
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1911"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1911"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("eIG6O", function(module, exports) {

$parcel$export(module.exports, "defineCustomElements", () => defineCustomElements);

var $696Z8 = parcelRequire("696Z8");
let localTransformTagName;
// Allows access to the transformTagName function at runtime to transform nested children.
// Stencil does not currently expose this.
function getNamespacedTagFor(tagName) {
    return new Proxy((tag)=>tag, {
        apply (target, thisArg, args) {
            return Reflect.apply(localTransformTagName !== null && localTransformTagName !== void 0 ? localTransformTagName : target, thisArg, args);
        }
    })(tagName);
}
const setTransformTagName = (transform)=>{
    localTransformTagName = transform;
};
const marketAccessoryCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:flex;justify-content:center;align-items:center}:host([size='icon']){width:var(--accessory-icon-variant-size);height:var(--accessory-icon-variant-size)}:host([size='image']){width:var(--accessory-image-variant-size);height:var(--accessory-image-variant-size)}:host ::slotted(.market-icon){}:host ::slotted(img){-o-object-fit:cover;object-fit:cover;width:100%;height:100%}:host([size='icon']) ::slotted(img){border-radius:var(--accessory-icon-variant-border-radius)}:host([size='image']) ::slotted(img){border-radius:var(--accessory-image-variant-border-radius)}";
const MarketAccessory$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.size = undefined;
    }
    /* TODO: add optional height/width props for custom sizing of slotted image */ render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-accessory",
            size: this.size
        }, (0, $696Z8.h)("slot", null));
    }
    static get style() {
        return marketAccessoryCss;
    }
};
const marketAccordionItemCss = "button{all:unset;display:flex;justify-content:space-between;align-items:center;width:100%;color:var(--accordion-normal-state-content-color);cursor:pointer}button:focus-visible{outline:var(--core-focus-ring-border-size) solid var(--core-focus-ring-color)}button:hover{color:var(--accordion-hover-state-content-color)}button:active{color:var(--accordion-pressed-state-content-color)}:host([disabled]) button{color:var(--accordion-disabled-state-content-color);cursor:not-allowed;pointer-events:none}svg{transition-duration:300ms}:host([expanded]) svg{transform:rotate(-180deg)}h2{margin:0;font-weight:var(--accordion-heading-30-variant-text-weight);font-size:var(--accordion-heading-30-variant-text-size);font-family:var(--accordion-heading-30-variant-text-font-family)}h2 button{padding:var(--accordion-heading-30-variant-vertical-padding)\n      var(--accordion-heading-30-variant-horizontal-padding);box-shadow:inset\n      0\n      calc(var(--accordion-heading-30-variant-separator-size) * -1)\n      0\n      var(--accordion-heading-30-variant-separator-color)}h3{margin:0;font-weight:var(--accordion-heading-20-variant-text-weight);font-size:var(--accordion-heading-20-variant-text-size);font-family:var(--accordion-heading-20-variant-text-font-family)}h3 button{padding:var(--accordion-heading-20-variant-vertical-padding)\n      var(--accordion-heading-20-variant-horizontal-padding);box-shadow:inset\n      0\n      calc(var(--accordion-heading-20-variant-separator-size) * -1)\n      0\n      var(--accordion-heading-20-variant-separator-color)}h4{margin:0;font-weight:var(--accordion-heading-10-variant-text-weight);font-size:var(--accordion-heading-10-variant-text-size);font-family:var(--accordion-heading-10-variant-text-font-family)}h4 button{padding:var(--accordion-heading-10-variant-vertical-padding)\n      var(--accordion-heading-10-variant-horizontal-padding);box-shadow:inset\n      0\n      calc(var(--accordion-heading-10-variant-separator-size) * -1)\n      0\n      var(--accordion-heading-10-variant-separator-color)}:host([size='medium']) svg{width:20px;height:20px}:host([size='small']) svg{width:16px;height:16px}";
const sizeToHeadingType = {
    large: '2',
    medium: '3',
    small: '4'
};
const MarketAccordionItem$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketAccordionItemExpandedChange = (0, $696Z8.createEvent)(this, "marketAccordionItemExpandedChange", 7);
        this.name = undefined;
        this.expanded = false;
        this.disabled = false;
        this.size = 'medium';
        this.customTrigger = undefined;
    }
    marketAccordionToggleHandler(e) {
        e.stopPropagation();
        this.setExpanded(!this.expanded);
    }
    /**
   * Used to set the "open" state of the accordion.
   */ setExpanded(newExpanded) {
        const oldExpanded = this.expanded;
        if (newExpanded !== oldExpanded) {
            const { defaultPrevented } = this.marketAccordionItemExpandedChange.emit({
                expanded: newExpanded
            });
            if (!defaultPrevented) {
                this.expanded = newExpanded;
                if (this.customTrigger) this.customTrigger.expanded = newExpanded;
            }
        }
        return Promise.resolve();
    }
    /**
   * Sets `disabled` state. Allows external elements to programmatically trigger disabled styling.
   */ setDisabled(value) {
        this.disabled = value;
        return Promise.resolve();
    }
    componentWillLoad() {
        this.customTrigger = this.el.querySelector('[slot="custom-trigger"]');
        if (this.customTrigger) this.customTrigger.expanded = this.expanded;
    }
    render() {
        const Heading = `h${sizeToHeadingType[this.size]}`;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-accordion-item"
        }, this.customTrigger ? (0, $696Z8.h)("slot", {
            name: "custom-trigger"
        }) : (0, $696Z8.h)(Heading, null, (0, $696Z8.h)("button", {
            id: `${this.name}__button`,
            type: "button",
            "aria-expanded": this.expanded,
            "aria-controls": `${this.name}__content`,
            "aria-disabled": this.disabled,
            disabled: this.disabled,
            onClick: ()=>this.setExpanded(!this.expanded)
        }, (0, $696Z8.h)("slot", {
            name: "label"
        }), (0, $696Z8.h)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, $696Z8.h)("path", {
            fill: "currentColor",
            d: "M13.06 17.56a1.5 1.5 0 0 1-2.12 0l-9-9 2.12-2.12L12 14.378l7.94-7.94 2.12 2.122-9 9Z"
        })))), this.expanded && (0, $696Z8.h)("div", {
            id: `${this.name}__content`,
            role: "region",
            "aria-labelledby": `${this.name}__button`
        }, (0, $696Z8.h)("slot", null)));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketAccordionItemCss;
    }
};
const marketActionCardCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:relative;outline:none;display:block;padding:var(--action-card-padding-vertical-size) var(--action-card-padding-horizontal-size);border-radius:var(--action-card-border-radius);background-color:var(--action-card-background-color);box-shadow:inset\n    0\n    0\n    0\n    var(--action-card-normal-state-unselected-value-border-width)\n    var(--action-card-normal-state-unselected-value-border-color);opacity:var(--action-card-normal-state-content-opacity);cursor:pointer}:host(:hover){box-shadow:inset\n      0\n      0\n      0\n      var(--action-card-hover-state-unselected-value-border-width)\n      var(--action-card-hover-state-unselected-value-border-color)}:host(:active){box-shadow:inset\n      0\n      0\n      0\n      var(--action-card-active-state-unselected-value-border-width)\n      var(--action-card-active-state-unselected-value-border-color)}:host([disabled]){box-shadow:inset\n      0\n      0\n      0\n      var(--action-card-disabled-state-unselected-value-border-width)\n      var(--action-card-disabled-state-unselected-value-border-color);opacity:var(--action-card-disabled-state-content-opacity)}:host([selected]){box-shadow:inset\n      0\n      0\n      0\n      var(--action-card-normal-state-selected-value-border-width)\n      var(--action-card-normal-state-selected-value-border-color)}:host([selected]:hover){box-shadow:inset\n      0\n      0\n      0\n      var(--action-card-hover-state-selected-value-border-width)\n      var(--action-card-hover-state-selected-value-border-color)}:host([selected]:active){box-shadow:inset\n      0\n      0\n      0\n      var(--action-card-active-state-selected-value-border-width)\n      var(--action-card-active-state-selected-value-border-color)}:host([selected][disabled]){box-shadow:inset\n      0\n      0\n      0\n      var(--action-card-disabled-state-selected-value-border-width)\n      var(--action-card-disabled-state-selected-value-border-color)}:host(.has-slotted-row){padding:0 var(--row-background-horizontal-outset-padding)}:host(.has-slotted-row) ::slotted(.market-row){background-color:transparent}:host::after{--focus-ring-position:calc(-1 * (var(--action-card-focus-ring-border-size) + var(--action-card-focus-ring-buffer-size) + var(--action-card-focus-ring-border-size)));content:'';position:absolute;top:var(--focus-ring-position);right:var(--focus-ring-position);bottom:var(--focus-ring-position);left:var(--focus-ring-position);display:block;border:var(--action-card-focus-ring-border-size) solid var(--action-card-focus-ring-color);border-radius:calc(var(--action-card-border-radius) + var(--action-card-focus-ring-buffer-size) * 2);opacity:0;pointer-events:none;transition:opacity 0.2s;content:'';position:absolute;display:block}:host(:focus-visible)::after{opacity:0.5}";
const MarketActionCard$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketCardSelected = (0, $696Z8.createEvent)(this, "marketCardSelected", 7);
        this.marketCardDeselected = (0, $696Z8.createEvent)(this, "marketCardDeselected", 7);
        this.selected = false;
        this.disabled = false;
        this.value = undefined;
        this.transient = false;
        this.row = null;
    }
    /**
   * When rows are slotted into cards, we want to catch their selection events
   * and emit our own, so that the containing `market-list` only gets one set
   * of selection events.
   */ handleRowSelection(e) {
        this.select();
        // Prevent `marketRowSelected` from bubbling up to containing lists, since we expect
        // them to listen to our card selection events instead.
        e.stopPropagation();
    }
    /**
   * When rows are slotted into cards, we want to catch their selection events
   * and emit our own, so that the containing `market-list` only gets one set
   * of selection events.
   */ handleRowDeselection(e) {
        this.deselect();
        // Prevent `marketRowSelected` from bubbling up to containing lists, since we expect
        // them to listen to our card selection events instead.
        e.stopPropagation();
    }
    /**
   * Used for setting the selection state to true without emitting events.
   * Useful for scenarios where another component (ex. `<market-list>`) needs
   * to sync state with slotted `<market-action-card>`s.
   */ silentlySelect() {
        this.selected = true;
        if (this.row) this.row.silentlySelect();
        return Promise.resolve();
    }
    /**
   * Set `selected` to `true` and emit `marketCardSelected`. Generally speaking,
   * it is preferable to avoid using this method from outside this component
   * and allow `market-action-card` to manage its own selection state based on user
   * interaction. It should only be used for parent components that need to
   * manage a group of rows, such as `market-list`.
   */ select() {
        this.selected = true;
        if (this.row) this.row.silentlySelect();
        this.marketCardSelected.emit(this.buildEventDetail());
        return Promise.resolve();
    }
    /**
   * Set `selected` to `false` and emit `marketCardDeselected`. Generally speaking,
   * it is preferable to avoid using this method from outside this component
   * and allow `market-action-card` to manage its own selection state based on user
   * interaction. It should only be used for parent components that need to
   * manage a group of rows, such as `market-list`.
   */ deselect() {
        this.selected = false;
        if (this.row) this.row.silentlyDeselect();
        this.marketCardDeselected.emit(this.buildEventDetail());
        return Promise.resolve();
    }
    /**
   * Set `selected` to `false`. Generally speaking,
   * it is preferable to avoid using this method from outside this component
   * and allow `market-action-card` to manage its own selection state based on user
   * interaction. It should only be used for parent components that need to
   * manage a group of rows, such as `market-list`.
   */ silentlyDeselect() {
        this.selected = false;
        if (this.row) this.row.silentlyDeselect();
        return Promise.resolve();
    }
    buildEventDetail() {
        return {
            value: this.value
        };
    }
    handleClick() {
        // Rows handle selected state when slotted. The only way you can click directly on
        // the card is by clicking the border, and we want to just ignore that edge case.
        if (this.disabled || this.transient || this.row) return;
        if (!this.selected) this.select();
        else this.deselect();
    }
    handleKeydown(e) {
        if (e.key === 'Enter') {
            if (this.row) // if slotted row is present, click it
            this.row.click();
            else this.handleClick();
        }
    }
    componentWillRender() {
        const row = this.el.querySelector(getNamespacedTagFor('market-row'));
        if (row) {
            this.row = row;
            if (!row.interactive) // Action cards are interactive, so rows slotted into them should be as well
            row.interactive = true;
            this.el.classList.add('has-slotted-row');
            if (this.selected) this.row.silentlySelect();
        }
    }
    componentDidRender() {
        // slotted rows inside action cards should not be able to receive focus because
        // they are controlled by interaction w/ the action card
        if (this.row) this.row.setAttribute('tabIndex', null);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-action-card",
            tabindex: this.disabled ? null : '0',
            role: "option",
            "aria-selected": this.selected,
            onClick: ()=>this.handleClick(),
            onKeydown: (e)=>this.handleKeydown(e)
        }, (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketActionCardCss;
    }
};
const marketActivityIndicatorCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}svg{position:static;flex:none;fill:currentColor;animation:rotation 1s infinite linear}@keyframes rotation{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}";
const MarketActivityIndicator$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.size = 'large';
    }
    render() {
        let height, width;
        switch(this.size){
            case 'large':
                width = 48;
                height = 48;
                break;
            case 'small':
                width = 24;
                height = 24;
                break;
            default:
                width = this.size;
                height = this.size;
        }
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-activity-indicator"
        }, (0, $696Z8.h)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M42.6667 24C42.6667 13.6907 34.3093 5.33333 24 5.33333V0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24H5.33333C5.33333 34.3093 13.6907 42.6667 24 42.6667C34.3093 42.6667 42.6667 34.3093 42.6667 24Z",
            "fill-opacity": "0.9"
        })));
    }
    static get style() {
        return marketActivityIndicatorCss;
    }
};
const marketActivityIndicatorBarCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--activity-indicator-bar-height:4px;--activity-indicator-bar-border-radius:6px;--activity-indicator-bar-bar-color:var(--core-fill-40-color);--activity-indicator-bar-value-color:var(--core-emphasis-fill-color);display:block;height:var(--activity-indicator-bar-height)}progress{display:block;width:100%;height:100%;border:none;border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-bar-color);-webkit-appearance:none;-moz-appearance:none;appearance:none}progress[value]::-webkit-progress-value{border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-value-color)}progress[value]::-webkit-progress-bar,progress:not([value])::-webkit-progress-bar{border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-bar-color)}progress[value]::-moz-progress-bar{border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-value-color)}progress:not([value])::-moz-progress-bar{visibility:hidden}.progress-bar{width:100%;height:100%;border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-bar-color)}.progress-bar>span{display:block;height:100%;border-radius:var(--activity-indicator-bar-border-radius);background-color:var(--activity-indicator-bar-value-color);text-indent:-9999px}";
const MarketActivityIndicatorBar$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.value = 0;
        this.max = 1;
    }
    render() {
        const max = this.max > 0 ? this.max : 1;
        const value = this.value > 0 ? Math.min(this.value, this.max) : 0;
        const percentComplete = value / max * 100;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-activity-indicator-bar",
            role: "progressbar",
            "aria-valuenow": value,
            "aria-valuemin": "0",
            "aria-valuemax": max,
            "aria-valuetext": `${percentComplete}%`
        }, (0, $696Z8.h)("progress", {
            value: value,
            max: max
        }, (0, $696Z8.h)("div", {
            class: "progress-bar"
        }, (0, $696Z8.h)("span", {
            style: {
                width: `${percentComplete}%`
            }
        }))));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketActivityIndicatorBarCss;
    }
};
/**
 * Utility for joining class names
 *
 * This function accepts any number of arguments which can be a string or an object.
 * With object parameters, class names that have a truthy value are applied.
 *
 * Based on https://github.com/JedWatson/classnames
 *
 * @param {TClassNamesArgs} args class names
 */ function classNames(...args) {
    return args.reduce((result, arg)=>{
        if (typeof arg === 'string') result.push(arg);
        else if (typeof arg === 'object') {
            for (const cn of Object.keys(arg))if (arg[cn]) result.push(cn);
        }
        return result;
    }, []).join(' ');
}
const marketBannerCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:flex;align-items:flex-start;width:100%;padding:var(--banner-vertical-padding) var(--banner-horizontal-padding);border-width:calc(var(--banner-border-width) * 1px);border-style:solid;border-radius:calc(var(--banner-border-radius) * 1px);font-weight:var(--banner-text-weight);font-size:var(--banner-text-size);line-height:var(--banner-text-leading);letter-spacing:var(--banner-text-tracking);text-transform:var(--banner-text-case);-moz-column-gap:var(--banner-icon-spacing);column-gap:var(--banner-icon-spacing)}.icon-container,.dismiss-container{display:flex;flex-shrink:0;align-items:center}.dismiss-container button{display:flex;justify-content:center;align-items:center;margin:0;padding:0;border:none;background-color:transparent;cursor:pointer;transition:opacity 0.2s;-webkit-appearance:none;-moz-appearance:none;appearance:none}.dismiss-container button svg{fill:var(--banner-dismiss-button-normal-state-color)}.dismiss-container button:active svg{fill:var(--banner-dismiss-button-pressed-state-color)}.main{display:flex;flex-grow:1;flex-wrap:wrap;row-gap:var(--banner-multiline-spacing);-moz-column-gap:var(--banner-content-spacing);column-gap:var(--banner-content-spacing)}.main.has-title{flex-direction:column}.main.has-title .actions{justify-content:unset}::slotted([slot='title']){margin:0;font-weight:var(--banner-title-weight);font-size:var(--banner-title-size);font-family:inherit;line-height:var(--banner-title-leading);letter-spacing:var(--banner-title-tracking);text-transform:var(--banner-title-case)}section{flex-grow:1}nav{display:flex;flex-wrap:wrap;justify-content:flex-end}nav.hidden{display:none}::slotted(a),::slotted(button){margin:0;padding:0;border:none;background-color:transparent;font-weight:var(--banner-button-text-weight);font-size:var(--banner-button-text-size);font-family:inherit;line-height:var(--banner-button-text-leading);letter-spacing:var(--banner-button-text-tracking);text-decoration:none;text-transform:var(--banner-button-text-case);cursor:pointer;transition:opacity 0.2s}::slotted(a:hover),::slotted(button:hover){opacity:var(--text-link-hover-state-opacity)}::slotted(a:active),::slotted(button:active){opacity:var(--text-link-pressed-state-opacity)}::slotted([slot='action']){display:flex;justify-content:center;align-items:center}::slotted([slot='action']:not(:last-child)){margin-right:calc(var(--banner-button-spacing) * 2 + var(--banner-button-separator-width))}::slotted([slot='action']:not(:last-child))::after{content:'';display:inline-block;width:var(--banner-button-separator-width);height:var(--banner-button-separator-height);margin-right:calc(-1 * var(--banner-button-spacing) - var(--banner-button-separator-width));margin-left:var(--banner-button-spacing);background-color:var(--banner-button-separator-color);opacity:var(--banner-button-separator-opacity);pointer-events:none}:host([variant=\"info\"]){border-color:var(--banner-info-variant-border-color);background-color:var(--banner-info-variant-background-color);color:var(--banner-info-variant-text-color)}:host([variant=\"info\"]) .icon-container svg,:host([variant=\"info\"]) ::slotted([slot=\"icon\"]){fill:var(--banner-info-variant-icon-color)}:host([variant=\"info\"]) ::slotted(a){color:var(--banner-info-variant-text-link-text-color)}:host([variant=\"info\"]) ::slotted(button){color:var(--banner-info-variant-button-text-color)}:host([variant=\"success\"]){border-color:var(--banner-success-variant-border-color);background-color:var(--banner-success-variant-background-color);color:var(--banner-success-variant-text-color)}:host([variant=\"success\"]) .icon-container svg,:host([variant=\"success\"]) ::slotted([slot=\"icon\"]){fill:var(--banner-success-variant-icon-color)}:host([variant=\"success\"]) ::slotted(a){color:var(--banner-success-variant-text-link-text-color)}:host([variant=\"success\"]) ::slotted(button){color:var(--banner-success-variant-button-text-color)}:host([variant=\"warning\"]){border-color:var(--banner-warning-variant-border-color);background-color:var(--banner-warning-variant-background-color);color:var(--banner-warning-variant-text-color)}:host([variant=\"warning\"]) .icon-container svg,:host([variant=\"warning\"]) ::slotted([slot=\"icon\"]){fill:var(--banner-warning-variant-icon-color)}:host([variant=\"warning\"]) ::slotted(a){color:var(--banner-warning-variant-text-link-text-color)}:host([variant=\"warning\"]) ::slotted(button){color:var(--banner-warning-variant-button-text-color)}:host([variant=\"critical\"]){border-color:var(--banner-critical-variant-border-color);background-color:var(--banner-critical-variant-background-color);color:var(--banner-critical-variant-text-color)}:host([variant=\"critical\"]) .icon-container svg,:host([variant=\"critical\"]) ::slotted([slot=\"icon\"]){fill:var(--banner-critical-variant-icon-color)}:host([variant=\"critical\"]) ::slotted(a){color:var(--banner-critical-variant-text-color)}:host([variant=\"critical\"]) ::slotted(button){color:var(--banner-critical-variant-button-text-color)}:host([variant=\"insight\"]){border-color:var(--banner-insight-variant-border-color);background-color:var(--banner-insight-variant-background-color);color:var(--banner-insight-variant-text-color)}:host([variant=\"insight\"]) .icon-container svg,:host([variant=\"insight\"]) ::slotted([slot=\"icon\"]){fill:var(--banner-insight-variant-icon-color)}:host([variant=\"insight\"]) ::slotted(a){color:var(--banner-insight-variant-text-link-text-color)}:host([variant=\"insight\"]) ::slotted(button){color:var(--banner-insight-variant-button-text-color)}";
const MarketBanner$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketBannerDismissed = (0, $696Z8.createEvent)(this, "marketBannerDismissed", 7);
        this.variant = 'info';
        this.dismissable = false;
        this.dismissButtonAriaLabel = 'Dismiss';
        this.hasTitle = false;
        this.hasAction = false;
    }
    renderIcon() {
        if (this.variant === 'success') return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12ZM5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5C8.14 5 5 8.14 5 12ZM8.71005 10.8L11 13.09L15.3101 8.80005L16.72 10.21L11.72 15.21C11.52 15.4 11.27 15.5 11.01 15.5C10.75 15.5 10.5 15.41 10.3 15.21L7.30005 12.21L8.71005 10.8Z"
        }));
        else if (this.variant === 'info') return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3ZM12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19ZM11 10.5V17H13V10.5H11ZM13.25 8.25C13.25 8.94036 12.6904 9.5 12 9.5C11.3096 9.5 10.75 8.94036 10.75 8.25C10.75 7.55964 11.3096 7 12 7C12.6904 7 13.25 7.55964 13.25 8.25Z"
        }));
        else if (this.variant === 'insight') return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M11 23.1701V15.0001H3.07996L13 0.830078V9.00008H20.92L11 23.1701ZM6.91996 13.0001H13V16.8301L17.08 11.0001H11V7.17008L6.91996 13.0001Z"
        }));
        else if (this.variant === 'warning') return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M11 9.00005H13V14.5H11V9.00005Z"
        }), (0, $696Z8.h)("path", {
            d: "M12 18C12.6904 18 13.25 17.4404 13.25 16.75C13.25 16.0596 12.6904 15.5 12 15.5C11.3096 15.5 10.75 16.0596 10.75 16.75C10.75 17.4404 11.3096 18 12 18Z"
        }), (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.866 2.17944C12.6874 1.87004 12.3573 1.67944 12 1.67944C11.6427 1.67944 11.3126 1.87004 11.134 2.17944L1.13397 19.5C0.955342 19.8094 0.955342 20.1905 1.13397 20.5C1.31261 20.8094 1.64273 21 2 21H22C22.3573 21 22.6874 20.8094 22.866 20.5C23.0447 20.1905 23.0447 19.8094 22.866 19.5L12.866 2.17944ZM12 4.67944L20.268 19H3.73205L12 4.67944Z"
        }));
        else return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21ZM12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5ZM12 17C12.6904 17 13.25 16.4404 13.25 15.75C13.25 15.0596 12.6904 14.5 12 14.5C11.3096 14.5 10.75 15.0596 10.75 15.75C10.75 16.4404 11.3096 17 12 17ZM11 7H13V13.5H11V7Z"
        }));
    }
    handleTitleSlotChange() {
        this.hasTitle = Boolean(this.el.querySelector('[slot="title"]'));
    }
    handleActionSlotChange() {
        this.hasAction = Boolean(this.el.querySelector('[slot="action"]'));
    }
    componentWillLoad() {
        this.handleTitleSlotChange();
        this.handleActionSlotChange();
    }
    dismiss() {
        const { defaultPrevented } = this.marketBannerDismissed.emit();
        if (defaultPrevented) return;
        this.el.remove();
    }
    render() {
        const MarketAccessoryTag = getNamespacedTagFor('market-accessory');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-banner"
        }, (0, $696Z8.h)("span", {
            class: "icon-container"
        }, (0, $696Z8.h)("slot", {
            name: "icon"
        }, (0, $696Z8.h)(MarketAccessoryTag, null, this.renderIcon()))), (0, $696Z8.h)("div", {
            class: classNames('main', {
                'has-title': this.hasTitle
            })
        }, (0, $696Z8.h)("section", null, (0, $696Z8.h)("header", {
            class: "title"
        }, (0, $696Z8.h)("slot", {
            name: "title",
            onSlotchange: ()=>this.handleTitleSlotChange()
        })), (0, $696Z8.h)("slot", null)), (0, $696Z8.h)("nav", {
            class: classNames('actions', {
                hidden: !this.hasAction
            })
        }, (0, $696Z8.h)("slot", {
            name: "action",
            onSlotchange: ()=>this.handleActionSlotChange()
        }))), this.dismissable && (0, $696Z8.h)("nav", {
            class: "dismiss-container"
        }, (0, $696Z8.h)("button", {
            type: "button",
            "aria-label": this.dismissButtonAriaLabel,
            onClick: ()=>this.dismiss()
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M6.71004 18.71L12 13.41L17.29 18.71L18.71 17.29L13.41 12L18.71 6.71004L17.29 5.29004L12 10.59L6.71004 5.29004L5.29004 6.71004L10.59 12L5.29004 17.29L6.71004 18.71Z"
        })))));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketBannerCss;
    }
};
// This file is automatically generated. Do not edit.
var cjs = {
    "ACCESSORY_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ACCESSORY_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ACCESSORY_BACKGROUND_RADIUS": 6,
    "ACCESSORY_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ACCESSORY_MEDIUM_SIZE_HEIGHT": 40,
    "ACCESSORY_MEDIUM_SIZE_WIDTH": 40,
    "ACCESSORY_LARGE_SIZE_HEIGHT": 64,
    "ACCESSORY_LARGE_SIZE_WIDTH": 64,
    "ACCESSORY_ICON_VARIANT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ACCESSORY_ICON_VARIANT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ACCESSORY_ICON_VARIANT_SIZE": 24,
    "ACCESSORY_ICON_VARIANT_BORDER_RADIUS": 3,
    "ACCESSORY_ICON_VARIANT_MEDIUM_SIZE_HEIGHT": 24,
    "ACCESSORY_ICON_VARIANT_MEDIUM_SIZE_WIDTH": 24,
    "ACCESSORY_ICON_VARIANT_LARGE_SIZE_HEIGHT": 40,
    "ACCESSORY_ICON_VARIANT_LARGE_SIZE_WIDTH": 40,
    "ACCESSORY_ICON_VARIANT_COLOR": "rgba(0, 0, 0, 0.9)",
    "ACCESSORY_IMAGE_VARIANT_SIZE": 40,
    "ACCESSORY_IMAGE_VARIANT_BORDER_RADIUS": 5,
    "ACCESSORY_INITIALS_VARIANT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ACCESSORY_INITIALS_VARIANT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_SIZE": 16,
    "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_LEADING": 24,
    "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_TRACKING": 0,
    "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_WEIGHT": 600,
    "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_CASE": "regular",
    "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_NUMBER_SPACING": "default",
    "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_SCALE": "paragraph-30",
    "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_SIZE": 32,
    "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_LEADING": 40,
    "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_TRACKING": 0,
    "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_WEIGHT": 700,
    "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_CASE": "regular",
    "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_NUMBER_SPACING": "default",
    "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_SCALE": "heading-30",
    "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_FONT_FAMILY": "Square Sans Display",
    "ACCESSORY_INITIALS_VARIANT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ACCORDION_DISABLED_STATE_CONTENT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ACCORDION_DISABLED_STATE_CONTENT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ACCORDION_DISABLED_STATE_CONTENT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ACCORDION_DISABLED_STATE_ACCESSORY_OPACITY": 0.5,
    "ACCORDION_DISABLED_STATE_SIDE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ACCORDION_DISABLED_STATE_SIDE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ACCORDION_DISABLED_STATE_SIDE_TEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ACCORDION_FOCUS_STATE_CONTENT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ACCORDION_FOCUS_STATE_CONTENT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ACCORDION_FOCUS_STATE_CONTENT_COLOR": "rgb(0, 90, 217)",
    "ACCORDION_FOCUS_STATE_ACCESSORY_OPACITY": 1,
    "ACCORDION_FOCUS_STATE_SIDE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ACCORDION_FOCUS_STATE_SIDE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ACCORDION_FOCUS_STATE_SIDE_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ACCORDION_HOVER_STATE_CONTENT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ACCORDION_HOVER_STATE_CONTENT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ACCORDION_HOVER_STATE_CONTENT_COLOR": "rgb(0, 90, 217)",
    "ACCORDION_HOVER_STATE_ACCESSORY_OPACITY": 1,
    "ACCORDION_HOVER_STATE_SIDE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ACCORDION_HOVER_STATE_SIDE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ACCORDION_HOVER_STATE_SIDE_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ACCORDION_NORMAL_STATE_CONTENT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ACCORDION_NORMAL_STATE_CONTENT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ACCORDION_NORMAL_STATE_CONTENT_COLOR": "rgba(0, 0, 0, 0.9)",
    "ACCORDION_NORMAL_STATE_ACCESSORY_OPACITY": 1,
    "ACCORDION_NORMAL_STATE_SIDE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ACCORDION_NORMAL_STATE_SIDE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ACCORDION_NORMAL_STATE_SIDE_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ACCORDION_PRESSED_STATE_CONTENT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ACCORDION_PRESSED_STATE_CONTENT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ACCORDION_PRESSED_STATE_CONTENT_COLOR": "rgb(0, 90, 217)",
    "ACCORDION_PRESSED_STATE_ACCESSORY_OPACITY": 1,
    "ACCORDION_PRESSED_STATE_SIDE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ACCORDION_PRESSED_STATE_SIDE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ACCORDION_PRESSED_STATE_SIDE_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ACCORDION_HEADING_10_VARIANT_CONTENT_SPACING": 16,
    "ACCORDION_HEADING_10_VARIANT_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ACCORDION_HEADING_10_VARIANT_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ACCORDION_HEADING_10_VARIANT_SEPARATOR_SIZE": 1,
    "ACCORDION_HEADING_10_VARIANT_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.05)",
    "ACCORDION_HEADING_10_VARIANT_HORIZONTAL_PADDING": 0,
    "ACCORDION_HEADING_10_VARIANT_TEXT_SIZE": 14,
    "ACCORDION_HEADING_10_VARIANT_TEXT_LEADING": 22,
    "ACCORDION_HEADING_10_VARIANT_TEXT_TRACKING": 0,
    "ACCORDION_HEADING_10_VARIANT_TEXT_WEIGHT": 700,
    "ACCORDION_HEADING_10_VARIANT_TEXT_CASE": "regular",
    "ACCORDION_HEADING_10_VARIANT_TEXT_NUMBER_SPACING": "default",
    "ACCORDION_HEADING_10_VARIANT_TEXT_SCALE": "heading-10",
    "ACCORDION_HEADING_10_VARIANT_TEXT_FONT_FAMILY": "Square Sans Text",
    "ACCORDION_HEADING_10_VARIANT_TEXT_IS_HEADER": true,
    "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_SIZE": 16,
    "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_LEADING": 24,
    "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_TRACKING": 0,
    "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_WEIGHT": 400,
    "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_CASE": "regular",
    "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_NUMBER_SPACING": "default",
    "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_SCALE": "paragraph-30",
    "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_FONT_FAMILY": "Square Sans Text",
    "ACCORDION_HEADING_10_VARIANT_VERTICAL_PADDING": 13,
    "ACCORDION_HEADING_10_VARIANT_EXPANDED_PHASE_ICON_ASSET": "chevron-down",
    "ACCORDION_HEADING_10_VARIANT_EXPANDED_PHASE_ICON_WIDTH": 16,
    "ACCORDION_HEADING_10_VARIANT_EXPANDED_PHASE_ICON_HEIGHT": 16,
    "ACCORDION_HEADING_10_VARIANT_EXPANDED_PHASE_ICON_TINTABLE": true,
    "ACCORDION_HEADING_10_VARIANT_COLLAPSED_PHASE_ICON_ASSET": "chevron-up",
    "ACCORDION_HEADING_10_VARIANT_COLLAPSED_PHASE_ICON_WIDTH": 16,
    "ACCORDION_HEADING_10_VARIANT_COLLAPSED_PHASE_ICON_HEIGHT": 16,
    "ACCORDION_HEADING_10_VARIANT_COLLAPSED_PHASE_ICON_TINTABLE": true,
    "ACCORDION_HEADING_20_VARIANT_CONTENT_SPACING": 16,
    "ACCORDION_HEADING_20_VARIANT_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ACCORDION_HEADING_20_VARIANT_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ACCORDION_HEADING_20_VARIANT_SEPARATOR_SIZE": 1,
    "ACCORDION_HEADING_20_VARIANT_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.05)",
    "ACCORDION_HEADING_20_VARIANT_HORIZONTAL_PADDING": 0,
    "ACCORDION_HEADING_20_VARIANT_TEXT_SIZE": 19,
    "ACCORDION_HEADING_20_VARIANT_TEXT_LEADING": 26,
    "ACCORDION_HEADING_20_VARIANT_TEXT_TRACKING": 0,
    "ACCORDION_HEADING_20_VARIANT_TEXT_WEIGHT": 700,
    "ACCORDION_HEADING_20_VARIANT_TEXT_CASE": "regular",
    "ACCORDION_HEADING_20_VARIANT_TEXT_NUMBER_SPACING": "default",
    "ACCORDION_HEADING_20_VARIANT_TEXT_SCALE": "heading-20",
    "ACCORDION_HEADING_20_VARIANT_TEXT_FONT_FAMILY": "Square Sans Display",
    "ACCORDION_HEADING_20_VARIANT_TEXT_IS_HEADER": true,
    "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_SIZE": 14,
    "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_LEADING": 22,
    "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_TRACKING": 0,
    "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_WEIGHT": 400,
    "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_CASE": "regular",
    "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_NUMBER_SPACING": "default",
    "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_SCALE": "paragraph-20",
    "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_FONT_FAMILY": "Square Sans Text",
    "ACCORDION_HEADING_20_VARIANT_VERTICAL_PADDING": 19,
    "ACCORDION_HEADING_20_VARIANT_EXPANDED_PHASE_ICON_ASSET": "chevron-down",
    "ACCORDION_HEADING_20_VARIANT_EXPANDED_PHASE_ICON_WIDTH": 16,
    "ACCORDION_HEADING_20_VARIANT_EXPANDED_PHASE_ICON_HEIGHT": 16,
    "ACCORDION_HEADING_20_VARIANT_EXPANDED_PHASE_ICON_TINTABLE": true,
    "ACCORDION_HEADING_20_VARIANT_COLLAPSED_PHASE_ICON_ASSET": "chevron-up",
    "ACCORDION_HEADING_20_VARIANT_COLLAPSED_PHASE_ICON_WIDTH": 16,
    "ACCORDION_HEADING_20_VARIANT_COLLAPSED_PHASE_ICON_HEIGHT": 16,
    "ACCORDION_HEADING_20_VARIANT_COLLAPSED_PHASE_ICON_TINTABLE": true,
    "ACCORDION_HEADING_30_VARIANT_CONTENT_SPACING": 16,
    "ACCORDION_HEADING_30_VARIANT_HORIZONTAL_PADDING": 0,
    "ACCORDION_HEADING_30_VARIANT_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ACCORDION_HEADING_30_VARIANT_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ACCORDION_HEADING_30_VARIANT_SEPARATOR_SIZE": 1,
    "ACCORDION_HEADING_30_VARIANT_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.05)",
    "ACCORDION_HEADING_30_VARIANT_TEXT_SIZE": 25,
    "ACCORDION_HEADING_30_VARIANT_TEXT_LEADING": 32,
    "ACCORDION_HEADING_30_VARIANT_TEXT_TRACKING": 0,
    "ACCORDION_HEADING_30_VARIANT_TEXT_WEIGHT": 700,
    "ACCORDION_HEADING_30_VARIANT_TEXT_CASE": "regular",
    "ACCORDION_HEADING_30_VARIANT_TEXT_NUMBER_SPACING": "default",
    "ACCORDION_HEADING_30_VARIANT_TEXT_SCALE": "heading-30",
    "ACCORDION_HEADING_30_VARIANT_TEXT_FONT_FAMILY": "Square Sans Display",
    "ACCORDION_HEADING_30_VARIANT_TEXT_IS_HEADER": true,
    "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_SIZE": 12,
    "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_LEADING": 18,
    "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_TRACKING": 0,
    "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_WEIGHT": 400,
    "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_CASE": "regular",
    "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_NUMBER_SPACING": "default",
    "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_SCALE": "paragraph-10",
    "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_FONT_FAMILY": "Square Sans Text",
    "ACCORDION_HEADING_30_VARIANT_VERTICAL_PADDING": 24,
    "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_16_FIDELITY_ASSET": "chevron-down",
    "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_16_FIDELITY_WIDTH": 16,
    "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_16_FIDELITY_HEIGHT": 16,
    "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_16_FIDELITY_TINTABLE": true,
    "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_ASSET": "chevron-down",
    "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_WIDTH": 16,
    "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_HEIGHT": 16,
    "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_TINTABLE": true,
    "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_16_FIDELITY_ASSET": "chevron-up",
    "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_16_FIDELITY_WIDTH": 16,
    "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_16_FIDELITY_HEIGHT": 16,
    "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_16_FIDELITY_TINTABLE": true,
    "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_ASSET": "chevron-up",
    "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_WIDTH": 16,
    "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_HEIGHT": 16,
    "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_TINTABLE": true,
    "ACTION_CARD_BORDER_RADIUS": 6,
    "ACTION_CARD_BORDER_HOVER_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ACTION_CARD_BORDER_HOVER_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ACTION_CARD_BORDER_HOVER_STATE_WIDTH": 1,
    "ACTION_CARD_BORDER_HOVER_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ACTION_CARD_BORDER_SELECTED_STATE_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_BORDER_SELECTED_STATE_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_BORDER_SELECTED_STATE_WIDTH": 2,
    "ACTION_CARD_BORDER_SELECTED_STATE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_BORDER_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "ACTION_CARD_BORDER_DISABLED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "ACTION_CARD_BORDER_DISABLED_STATE_WIDTH": 1,
    "ACTION_CARD_BORDER_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0.15)",
    "ACTION_CARD_NORMAL_STATE_CONTENT_OPACITY": 1,
    "ACTION_CARD_NORMAL_STATE_UNSELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "ACTION_CARD_NORMAL_STATE_UNSELECTED_VALUE_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "ACTION_CARD_NORMAL_STATE_UNSELECTED_VALUE_BORDER_WIDTH": 1,
    "ACTION_CARD_NORMAL_STATE_UNSELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.15)",
    "ACTION_CARD_NORMAL_STATE_SELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_NORMAL_STATE_SELECTED_VALUE_BORDER_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_NORMAL_STATE_SELECTED_VALUE_BORDER_WIDTH": 2,
    "ACTION_CARD_NORMAL_STATE_SELECTED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_HOVER_STATE_CONTENT_OPACITY": 1,
    "ACTION_CARD_HOVER_STATE_UNSELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ACTION_CARD_HOVER_STATE_UNSELECTED_VALUE_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ACTION_CARD_HOVER_STATE_UNSELECTED_VALUE_BORDER_WIDTH": 1,
    "ACTION_CARD_HOVER_STATE_UNSELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.9)",
    "ACTION_CARD_HOVER_STATE_SELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_HOVER_STATE_SELECTED_VALUE_BORDER_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_HOVER_STATE_SELECTED_VALUE_BORDER_WIDTH": 2,
    "ACTION_CARD_HOVER_STATE_SELECTED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_ACTIVE_STATE_CONTENT_OPACITY": 1,
    "ACTION_CARD_ACTIVE_STATE_UNSELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_ACTIVE_STATE_UNSELECTED_VALUE_BORDER_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_ACTIVE_STATE_UNSELECTED_VALUE_BORDER_WIDTH": 1,
    "ACTION_CARD_ACTIVE_STATE_UNSELECTED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_ACTIVE_STATE_SELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ACTION_CARD_ACTIVE_STATE_SELECTED_VALUE_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ACTION_CARD_ACTIVE_STATE_SELECTED_VALUE_BORDER_WIDTH": 2,
    "ACTION_CARD_ACTIVE_STATE_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.9)",
    "ACTION_CARD_DISABLED_STATE_CONTENT_OPACITY": 0.4,
    "ACTION_CARD_DISABLED_STATE_UNSELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "ACTION_CARD_DISABLED_STATE_UNSELECTED_VALUE_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "ACTION_CARD_DISABLED_STATE_UNSELECTED_VALUE_BORDER_WIDTH": 1,
    "ACTION_CARD_DISABLED_STATE_UNSELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.15)",
    "ACTION_CARD_DISABLED_STATE_SELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_DISABLED_STATE_SELECTED_VALUE_BORDER_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_DISABLED_STATE_SELECTED_VALUE_BORDER_WIDTH": 2,
    "ACTION_CARD_DISABLED_STATE_SELECTED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "ACTION_CARD_BACKGROUND_DARK_MODE_COLOR": "rgb(20, 20, 20)",
    "ACTION_CARD_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "ACTION_CARD_PADDING_HORIZONTAL_SIZE": 16,
    "ACTION_CARD_PADDING_VERTICAL_SIZE": 16,
    "ACTION_CARD_SPACING": 16,
    "ACTION_CARD_FOCUS_RING_BUFFER_SIZE": 2,
    "ACTION_CARD_FOCUS_RING_BORDER_SIZE": 2,
    "ACTION_CARD_FOCUS_RING_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_FOCUS_RING_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "ACTION_CARD_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "BANNER_BORDER_RADIUS": 6,
    "BANNER_BORDER_WIDTH": 1,
    "BANNER_DISMISS_BUTTON_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_DISMISS_BUTTON_NORMAL_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "BANNER_DISMISS_BUTTON_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_DISMISS_BUTTON_PRESSED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "BANNER_DISMISS_BUTTON_PRESSED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "BANNER_DISMISS_BUTTON_PRESSED_STATE_COLOR": "rgba(0, 0, 0, 0.55)",
    "BANNER_DISMISS_BUTTON_ICON_ASSET": "x",
    "BANNER_DISMISS_BUTTON_ICON_WIDTH": 24,
    "BANNER_DISMISS_BUTTON_ICON_HEIGHT": 24,
    "BANNER_DISMISS_BUTTON_ICON_TINTABLE": true,
    "BANNER_BUTTON_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_BUTTON_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "BANNER_BUTTON_SEPARATOR_HEIGHT": 8,
    "BANNER_BUTTON_SEPARATOR_OPACITY": 0.3,
    "BANNER_BUTTON_SEPARATOR_WIDTH": 1,
    "BANNER_BUTTON_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_BUTTON_SPACING": 12,
    "BANNER_BUTTON_TEXT_SIZE": 16,
    "BANNER_BUTTON_TEXT_LEADING": 24,
    "BANNER_BUTTON_TEXT_TRACKING": 0,
    "BANNER_BUTTON_TEXT_WEIGHT": 600,
    "BANNER_BUTTON_TEXT_CASE": "regular",
    "BANNER_BUTTON_TEXT_NUMBER_SPACING": "default",
    "BANNER_BUTTON_TEXT_SCALE": "paragraph-30",
    "BANNER_BUTTON_TEXT_FONT_FAMILY": "Square Sans Text",
    "BANNER_CONTENT_SPACING": 12,
    "BANNER_HORIZONTAL_PADDING": 16,
    "BANNER_ICON_SPACING": 12,
    "BANNER_MULTILINE_SPACING": 12,
    "BANNER_VERTICAL_PADDING": 16,
    "BANNER_TITLE_SIZE": 16,
    "BANNER_TITLE_LEADING": 24,
    "BANNER_TITLE_TRACKING": 0,
    "BANNER_TITLE_WEIGHT": 600,
    "BANNER_TITLE_CASE": "regular",
    "BANNER_TITLE_NUMBER_SPACING": "default",
    "BANNER_TITLE_SCALE": "paragraph-30",
    "BANNER_TITLE_FONT_FAMILY": "Square Sans Text",
    "BANNER_TEXT_SIZE": 16,
    "BANNER_TEXT_LEADING": 24,
    "BANNER_TEXT_TRACKING": 0,
    "BANNER_TEXT_WEIGHT": 400,
    "BANNER_TEXT_CASE": "regular",
    "BANNER_TEXT_NUMBER_SPACING": "default",
    "BANNER_TEXT_SCALE": "paragraph-30",
    "BANNER_TEXT_FONT_FAMILY": "Square Sans Text",
    "BANNER_INFO_VARIANT_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "BANNER_INFO_VARIANT_LIGHT_MODE_BORDER_COLOR": "rgb(204, 225, 255)",
    "BANNER_INFO_VARIANT_LIGHT_MODE_ICON_COLOR": "rgb(0, 106, 255)",
    "BANNER_INFO_VARIANT_LIGHT_MODE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_INFO_VARIANT_LIGHT_MODE_BUTTON_TEXT_COLOR": "rgb(0, 90, 217)",
    "BANNER_INFO_VARIANT_LIGHT_MODE_TEXT_LINK_TEXT_COLOR": "rgb(0, 90, 217)",
    "BANNER_INFO_VARIANT_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "BANNER_INFO_VARIANT_DARK_MODE_BORDER_COLOR": "rgb(0, 37, 89)",
    "BANNER_INFO_VARIANT_DARK_MODE_ICON_COLOR": "rgb(0, 106, 255)",
    "BANNER_INFO_VARIANT_DARK_MODE_TEXT_COLOR": "rgba(255, 255, 255, 0.95)",
    "BANNER_INFO_VARIANT_DARK_MODE_BUTTON_TEXT_COLOR": "rgb(74, 149, 255)",
    "BANNER_INFO_VARIANT_DARK_MODE_TEXT_LINK_TEXT_COLOR": "rgb(74, 149, 255)",
    "BANNER_INFO_VARIANT_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "BANNER_INFO_VARIANT_BORDER_COLOR": "rgb(204, 225, 255)",
    "BANNER_INFO_VARIANT_ICON_COLOR": "rgb(0, 106, 255)",
    "BANNER_INFO_VARIANT_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_INFO_VARIANT_BUTTON_TEXT_COLOR": "rgb(0, 90, 217)",
    "BANNER_INFO_VARIANT_TEXT_LINK_TEXT_COLOR": "rgb(0, 90, 217)",
    "BANNER_SUCCESS_VARIANT_LIGHT_MODE_BACKGROUND_COLOR": "rgb(229, 255, 238)",
    "BANNER_SUCCESS_VARIANT_LIGHT_MODE_BORDER_COLOR": "rgb(204, 255, 221)",
    "BANNER_SUCCESS_VARIANT_LIGHT_MODE_ICON_COLOR": "rgb(0, 178, 59)",
    "BANNER_SUCCESS_VARIANT_LIGHT_MODE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_SUCCESS_VARIANT_LIGHT_MODE_BUTTON_TEXT_COLOR": "rgb(0, 125, 42)",
    "BANNER_SUCCESS_VARIANT_LIGHT_MODE_TEXT_LINK_TEXT_COLOR": "rgb(0, 125, 42)",
    "BANNER_SUCCESS_VARIANT_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 51, 17)",
    "BANNER_SUCCESS_VARIANT_DARK_MODE_BORDER_COLOR": "rgb(0, 89, 30)",
    "BANNER_SUCCESS_VARIANT_DARK_MODE_ICON_COLOR": "rgb(0, 179, 59)",
    "BANNER_SUCCESS_VARIANT_DARK_MODE_TEXT_COLOR": "rgba(255, 255, 255, 0.95)",
    "BANNER_SUCCESS_VARIANT_DARK_MODE_BUTTON_TEXT_COLOR": "rgb(22, 217, 86)",
    "BANNER_SUCCESS_VARIANT_DARK_MODE_TEXT_LINK_TEXT_COLOR": "rgb(22, 217, 86)",
    "BANNER_SUCCESS_VARIANT_BACKGROUND_COLOR": "rgb(229, 255, 238)",
    "BANNER_SUCCESS_VARIANT_BORDER_COLOR": "rgb(204, 255, 221)",
    "BANNER_SUCCESS_VARIANT_ICON_COLOR": "rgb(0, 178, 59)",
    "BANNER_SUCCESS_VARIANT_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_SUCCESS_VARIANT_BUTTON_TEXT_COLOR": "rgb(0, 125, 42)",
    "BANNER_SUCCESS_VARIANT_TEXT_LINK_TEXT_COLOR": "rgb(0, 125, 42)",
    "BANNER_WARNING_VARIANT_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 242, 230)",
    "BANNER_WARNING_VARIANT_LIGHT_MODE_BORDER_COLOR": "rgb(255, 230, 204)",
    "BANNER_WARNING_VARIANT_LIGHT_MODE_ICON_COLOR": "rgb(255, 159, 64)",
    "BANNER_WARNING_VARIANT_LIGHT_MODE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_WARNING_VARIANT_LIGHT_MODE_BUTTON_TEXT_COLOR": "rgb(148, 92, 37)",
    "BANNER_WARNING_VARIANT_LIGHT_MODE_TEXT_LINK_TEXT_COLOR": "rgb(148, 92, 37)",
    "BANNER_WARNING_VARIANT_DARK_MODE_BACKGROUND_COLOR": "rgb(51, 26, 0)",
    "BANNER_WARNING_VARIANT_DARK_MODE_BORDER_COLOR": "rgb(89, 45, 0)",
    "BANNER_WARNING_VARIANT_DARK_MODE_ICON_COLOR": "rgb(255, 159, 64)",
    "BANNER_WARNING_VARIANT_DARK_MODE_TEXT_COLOR": "rgba(255, 255, 255, 0.95)",
    "BANNER_WARNING_VARIANT_DARK_MODE_BUTTON_TEXT_COLOR": "rgb(255, 159, 64)",
    "BANNER_WARNING_VARIANT_DARK_MODE_TEXT_LINK_TEXT_COLOR": "rgb(255, 159, 64)",
    "BANNER_WARNING_VARIANT_BACKGROUND_COLOR": "rgb(255, 242, 230)",
    "BANNER_WARNING_VARIANT_BORDER_COLOR": "rgb(255, 230, 204)",
    "BANNER_WARNING_VARIANT_ICON_COLOR": "rgb(255, 159, 64)",
    "BANNER_WARNING_VARIANT_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_WARNING_VARIANT_BUTTON_TEXT_COLOR": "rgb(148, 92, 37)",
    "BANNER_WARNING_VARIANT_TEXT_LINK_TEXT_COLOR": "rgb(148, 92, 37)",
    "BANNER_CRITICAL_VARIANT_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "BANNER_CRITICAL_VARIANT_LIGHT_MODE_BORDER_COLOR": "rgb(255, 204, 213)",
    "BANNER_CRITICAL_VARIANT_LIGHT_MODE_ICON_COLOR": "rgb(204, 0, 35)",
    "BANNER_CRITICAL_VARIANT_LIGHT_MODE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_CRITICAL_VARIANT_LIGHT_MODE_BUTTON_TEXT_COLOR": "rgb(191, 0, 32)",
    "BANNER_CRITICAL_VARIANT_LIGHT_MODE_TEXT_LINK_TEXT_COLOR": "rgb(191, 0, 32)",
    "BANNER_CRITICAL_VARIANT_DARK_MODE_BACKGROUND_COLOR": "rgb(51, 0, 9)",
    "BANNER_CRITICAL_VARIANT_DARK_MODE_BORDER_COLOR": "rgb(89, 0, 15)",
    "BANNER_CRITICAL_VARIANT_DARK_MODE_ICON_COLOR": "rgb(204, 0, 35)",
    "BANNER_CRITICAL_VARIANT_DARK_MODE_TEXT_COLOR": "rgba(255, 255, 255, 0.95)",
    "BANNER_CRITICAL_VARIANT_DARK_MODE_BUTTON_TEXT_COLOR": "rgb(255, 90, 118)",
    "BANNER_CRITICAL_VARIANT_DARK_MODE_TEXT_LINK_TEXT_COLOR": "rgb(255, 90, 118)",
    "BANNER_CRITICAL_VARIANT_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "BANNER_CRITICAL_VARIANT_BORDER_COLOR": "rgb(255, 204, 213)",
    "BANNER_CRITICAL_VARIANT_ICON_COLOR": "rgb(204, 0, 35)",
    "BANNER_CRITICAL_VARIANT_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_CRITICAL_VARIANT_BUTTON_TEXT_COLOR": "rgb(191, 0, 32)",
    "BANNER_CRITICAL_VARIANT_TEXT_LINK_TEXT_COLOR": "rgb(191, 0, 32)",
    "BANNER_INSIGHT_VARIANT_LIGHT_MODE_BACKGROUND_COLOR": "rgb(244, 230, 255)",
    "BANNER_INSIGHT_VARIANT_LIGHT_MODE_BORDER_COLOR": "rgb(234, 204, 255)",
    "BANNER_INSIGHT_VARIANT_LIGHT_MODE_ICON_COLOR": "rgb(135, 22, 217)",
    "BANNER_INSIGHT_VARIANT_LIGHT_MODE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_INSIGHT_VARIANT_LIGHT_MODE_BUTTON_TEXT_COLOR": "rgb(135, 22, 217)",
    "BANNER_INSIGHT_VARIANT_LIGHT_MODE_TEXT_LINK_TEXT_COLOR": "rgb(135, 22, 217)",
    "BANNER_INSIGHT_VARIANT_DARK_MODE_BACKGROUND_COLOR": "rgb(30, 0, 51)",
    "BANNER_INSIGHT_VARIANT_DARK_MODE_BORDER_COLOR": "rgb(52, 0, 89)",
    "BANNER_INSIGHT_VARIANT_DARK_MODE_ICON_COLOR": "rgb(135, 22, 217)",
    "BANNER_INSIGHT_VARIANT_DARK_MODE_TEXT_COLOR": "rgba(255, 255, 255, 0.95)",
    "BANNER_INSIGHT_VARIANT_DARK_MODE_BUTTON_TEXT_COLOR": "rgb(194, 110, 255)",
    "BANNER_INSIGHT_VARIANT_DARK_MODE_TEXT_LINK_TEXT_COLOR": "rgb(194, 110, 255)",
    "BANNER_INSIGHT_VARIANT_BACKGROUND_COLOR": "rgb(244, 230, 255)",
    "BANNER_INSIGHT_VARIANT_BORDER_COLOR": "rgb(234, 204, 255)",
    "BANNER_INSIGHT_VARIANT_ICON_COLOR": "rgb(135, 22, 217)",
    "BANNER_INSIGHT_VARIANT_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "BANNER_INSIGHT_VARIANT_BUTTON_TEXT_COLOR": "rgb(135, 22, 217)",
    "BANNER_INSIGHT_VARIANT_TEXT_LINK_TEXT_COLOR": "rgb(135, 22, 217)",
    "BUTTON_GROUP_SPACING": 16,
    "BUTTON_GROUP_OVERFLOW_BUTTON_MINIMUM_HEIGHT": 48,
    "BUTTON_GROUP_OVERFLOW_BUTTON_ICON_ASSET": "ellipsis",
    "BUTTON_GROUP_OVERFLOW_BUTTON_ICON_WIDTH": 24,
    "BUTTON_GROUP_OVERFLOW_BUTTON_ICON_HEIGHT": 24,
    "BUTTON_GROUP_OVERFLOW_BUTTON_ICON_TINTABLE": true,
    "BUTTON_GROUP_OVERFLOW_BUTTON_WIDTH": 48,
    "BUTTON_GROUP_OVERFLOW_BUTTON_SIZE_MULTIPLIER": 1,
    "BUTTON_COMPACT_HORIZONTAL_SIZE_CLASS_SAMPLE_TOKEN": 100,
    "BUTTON_REGULAR_HORIZONTAL_SIZE_CLASS_SAMPLE_TOKEN": 200,
    "BUTTON_WIDE_HORIZONTAL_SIZE_CLASS_SAMPLE_TOKEN": 300,
    "BUTTON_COMPACT_VERTICAL_SIZE_CLASS_SAMPLE_TOKEN_2": 10,
    "BUTTON_REGULAR_VERTICAL_SIZE_CLASS_SAMPLE_TOKEN_2": 20,
    "BUTTON_TALL_VERTICAL_SIZE_CLASS_SAMPLE_TOKEN_2": 30,
    "BUTTON_SMALL_SIZE_MINIMUM_HEIGHT": 40,
    "BUTTON_SMALL_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
    "BUTTON_SMALL_SIZE_TEXT_SIZE": 14,
    "BUTTON_SMALL_SIZE_TEXT_LEADING": 22,
    "BUTTON_SMALL_SIZE_TEXT_TRACKING": 0,
    "BUTTON_SMALL_SIZE_TEXT_WEIGHT": 600,
    "BUTTON_SMALL_SIZE_TEXT_CASE": "regular",
    "BUTTON_SMALL_SIZE_TEXT_NUMBER_SPACING": "default",
    "BUTTON_SMALL_SIZE_TEXT_SCALE": "paragraph-20",
    "BUTTON_SMALL_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "BUTTON_SMALL_SIZE_CONTENT_SPACING": 8,
    "BUTTON_SMALL_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 12,
    "BUTTON_SMALL_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 9,
    "BUTTON_SMALL_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 12,
    "BUTTON_SMALL_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 9,
    "BUTTON_SMALL_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
    "BUTTON_SMALL_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 9,
    "BUTTON_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
    "BUTTON_MEDIUM_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
    "BUTTON_MEDIUM_SIZE_TEXT_SIZE": 16,
    "BUTTON_MEDIUM_SIZE_TEXT_LEADING": 24,
    "BUTTON_MEDIUM_SIZE_TEXT_TRACKING": 0,
    "BUTTON_MEDIUM_SIZE_TEXT_WEIGHT": 600,
    "BUTTON_MEDIUM_SIZE_TEXT_CASE": "regular",
    "BUTTON_MEDIUM_SIZE_TEXT_NUMBER_SPACING": "default",
    "BUTTON_MEDIUM_SIZE_TEXT_SCALE": "paragraph-30",
    "BUTTON_MEDIUM_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "BUTTON_MEDIUM_SIZE_CONTENT_SPACING": 8,
    "BUTTON_MEDIUM_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 16,
    "BUTTON_MEDIUM_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 12,
    "BUTTON_MEDIUM_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 16,
    "BUTTON_MEDIUM_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 12,
    "BUTTON_MEDIUM_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
    "BUTTON_MEDIUM_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 12,
    "BUTTON_LARGE_SIZE_MINIMUM_HEIGHT": 64,
    "BUTTON_LARGE_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
    "BUTTON_LARGE_SIZE_TEXT_SIZE": 16,
    "BUTTON_LARGE_SIZE_TEXT_LEADING": 24,
    "BUTTON_LARGE_SIZE_TEXT_TRACKING": 0,
    "BUTTON_LARGE_SIZE_TEXT_WEIGHT": 600,
    "BUTTON_LARGE_SIZE_TEXT_CASE": "regular",
    "BUTTON_LARGE_SIZE_TEXT_NUMBER_SPACING": "default",
    "BUTTON_LARGE_SIZE_TEXT_SCALE": "paragraph-30",
    "BUTTON_LARGE_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "BUTTON_LARGE_SIZE_CONTENT_SPACING": 8,
    "BUTTON_LARGE_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 20,
    "BUTTON_LARGE_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 20,
    "BUTTON_LARGE_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 20,
    "BUTTON_LARGE_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 20,
    "BUTTON_LARGE_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
    "BUTTON_LARGE_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 20,
    "BUTTON_BORDER_RADIUS": 6,
    "BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
    "BUTTON_FOCUS_RING_BORDER_SIZE": 2,
    "BUTTON_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "BUTTON_LIGHT_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "BUTTON_DARK_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 90, 118)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(51, 0, 9)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 90, 118)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 204, 213)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(89, 0, 15)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 90, 118)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(255, 204, 213)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(51, 0, 9)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 90, 118)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 90, 118)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(51, 0, 9)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 90, 118)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 204, 213)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(89, 0, 15)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 90, 118)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(255, 204, 213)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 90, 118)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_LABEL_COLOR": "rgb(191, 0, 32)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "BUTTON_LOADING_ICON_ASSET": "radial-spinner",
    "BUTTON_LOADING_ICON_WIDTH": 24,
    "BUTTON_LOADING_ICON_HEIGHT": 24,
    "BUTTON_LOADING_ICON_TINTABLE": true,
    "CHECKBOX_WIDTH": 20,
    "CHECKBOX_HEIGHT": 20,
    "CHECKBOX_BORDER_RADIUS": 4,
    "CHECKBOX_BORDER_SIZE": 2,
    "CHECKBOX_LIGHT_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_DARK_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_RING_BUFFER_SIZE": 2,
    "CHECKBOX_FOCUS_RING_BORDER_SIZE": 2,
    "CHECKBOX_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(255, 255, 255, 0.3)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_ASSET": "checkmark",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_WIDTH": 20,
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_HEIGHT": 20,
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_TINTABLE": true,
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "rgba(255, 255, 255, 0.3)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_ASSET": "indeterminate-mark",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_WIDTH": 20,
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_HEIGHT": 20,
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_TINTABLE": true,
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "rgb(204, 0, 35)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "rgb(0, 85, 204)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "rgb(153, 0, 26)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "rgb(0, 106, 255)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "rgb(178, 0, 30)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.03)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0.03)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.05)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(255, 255, 255, 0.05)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.03)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.03)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.3)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.03)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0.03)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.15)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.05)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "rgba(255, 255, 255, 0.05)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.15)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.03)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.03)",
    "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "rgba(0, 0, 0, 0.15)",
    "CHOICE_BUTTON_MINIMUM_WIDTH_MULTIPLER": 1.5,
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_SIZE": 14,
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_LEADING": 22,
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_TRACKING": 0,
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_WEIGHT": 600,
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_CASE": "regular",
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_NUMBER_SPACING": "default",
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_SCALE": "paragraph-20",
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_FONT_FAMILY": "Square Sans Text",
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_SIZE": 14,
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_LEADING": 22,
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_TRACKING": 0,
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_WEIGHT": 400,
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_CASE": "regular",
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_NUMBER_SPACING": "default",
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_SCALE": "paragraph-20",
    "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_FONT_FAMILY": "Square Sans Text",
    "CHOICE_BUTTON_SMALL_SIZE_CONTENT_SPACING": 8,
    "CHOICE_BUTTON_SMALL_SIZE_HORIZONTAL_PADDING": 12,
    "CHOICE_BUTTON_SMALL_SIZE_VERTICAL_PADDING": 9,
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_SIZE": 16,
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_LEADING": 24,
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_TRACKING": 0,
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_WEIGHT": 600,
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_CASE": "regular",
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_NUMBER_SPACING": "default",
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_SCALE": "paragraph-30",
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_FONT_FAMILY": "Square Sans Text",
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_SIZE": 16,
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_LEADING": 24,
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_TRACKING": 0,
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_WEIGHT": 400,
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_CASE": "regular",
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_NUMBER_SPACING": "default",
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_SCALE": "paragraph-30",
    "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_FONT_FAMILY": "Square Sans Text",
    "CHOICE_BUTTON_MEDIUM_SIZE_CONTENT_SPACING": 8,
    "CHOICE_BUTTON_MEDIUM_SIZE_HORIZONTAL_PADDING": 16,
    "CHOICE_BUTTON_MEDIUM_SIZE_VERTICAL_PADDING": 12,
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_SIZE": 16,
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_LEADING": 24,
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_TRACKING": 0,
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_WEIGHT": 600,
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_CASE": "regular",
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_NUMBER_SPACING": "default",
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_SCALE": "paragraph-30",
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_FONT_FAMILY": "Square Sans Text",
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_SIZE": 16,
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_LEADING": 24,
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_TRACKING": 0,
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_WEIGHT": 400,
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_CASE": "regular",
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_NUMBER_SPACING": "default",
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_SCALE": "paragraph-30",
    "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_FONT_FAMILY": "Square Sans Text",
    "CHOICE_BUTTON_LARGE_SIZE_CONTENT_SPACING": 8,
    "CHOICE_BUTTON_LARGE_SIZE_HORIZONTAL_PADDING": 20,
    "CHOICE_BUTTON_LARGE_SIZE_VERTICAL_PADDING": 20,
    "CHOICE_BUTTON_BORDER_RADIUS": 6,
    "CHOICE_BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
    "CHOICE_BUTTON_FOCUS_RING_BORDER_SIZE": 2,
    "CHOICE_BUTTON_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "CHOICE_BUTTON_LIGHT_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "CHOICE_BUTTON_DARK_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.3)",
    "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.15)",
    "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.15)",
    "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.15)",
    "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_MINIMUM_WIDTH_MULTIPLER": 1,
    "CHOICE_ICON_BUTTON_SMALL_SIZE_HORIZONTAL_PADDING": 8,
    "CHOICE_ICON_BUTTON_SMALL_SIZE_VERTICAL_PADDING": 8,
    "CHOICE_ICON_BUTTON_MEDIUM_SIZE_HORIZONTAL_PADDING": 12,
    "CHOICE_ICON_BUTTON_MEDIUM_SIZE_VERTICAL_PADDING": 12,
    "CHOICE_ICON_BUTTON_LARGE_SIZE_HORIZONTAL_PADDING": 16,
    "CHOICE_ICON_BUTTON_LARGE_SIZE_VERTICAL_PADDING": 16,
    "CHOICE_ICON_BUTTON_BORDER_RADIUS": 6,
    "CHOICE_ICON_BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
    "CHOICE_ICON_BUTTON_FOCUS_RING_BORDER_SIZE": 2,
    "CHOICE_ICON_BUTTON_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "CHOICE_ICON_BUTTON_LIGHT_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "CHOICE_ICON_BUTTON_DARK_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.3)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.3)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.15)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.15)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.15)",
    "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "COLOR_PICKER_VERTICAL_SPACING": 16,
    "COLOR_PICKER_DOTS_SIZE": 40,
    "COLOR_PICKER_DOTS_HORIZONTAL_SPACING": 14,
    "COLOR_PICKER_DOTS_VERTICAL_SPACING": 16,
    "COLOR_PICKER_DOTS_ICON_ASSET": "check",
    "COLOR_PICKER_DOTS_ICON_WIDTH": 24,
    "COLOR_PICKER_DOTS_ICON_HEIGHT": 24,
    "COLOR_PICKER_DOTS_ICON_TINTABLE": true,
    "COLOR_PICKER_ADJUSTMENTS_HUE_RADIUS": 6,
    "COLOR_PICKER_ADJUSTMENTS_HUE_MIN_HEIGHT": 40,
    "COLOR_PICKER_ADJUSTMENTS_SATURATION_BRIGHTNESS_RADIUS": 12,
    "COLOR_PICKER_ADJUSTMENTS_SATURATION_BRIGHTNESS_MIN_HEIGHT": 200,
    "COLOR_PICKER_ADJUSTMENTS_SCRUBBER_SIZE": 16,
    "COLOR_PICKER_ADJUSTMENTS_SCRUBBER_WIDTH": 2,
    "COLOR_PICKER_ADJUSTMENTS_SCRUBBER_PADDING": 4,
    "COLOR_PICKER_ADJUSTMENTS_SCRUBBER_MULTIPLIER": 1.25,
    "CONTENT_CARD_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "CONTENT_CARD_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "CONTENT_CARD_BORDER_WIDTH": 1,
    "CONTENT_CARD_BORDER_RADIUS": 6,
    "CONTENT_CARD_BORDER_COLOR": "rgba(0, 0, 0, 0.15)",
    "CONTENT_CARD_PADDING_HORIZONTAL_SIZE": 16,
    "CONTENT_CARD_PADDING_VERTICAL_SIZE": 16,
    "CONTENT_CARD_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "CONTENT_CARD_BACKGROUND_DARK_MODE_COLOR": "rgb(20, 20, 20)",
    "CONTENT_CARD_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "DATE_PICKER_MINIMUM_WIDTH": 280,
    "DATE_PICKER_HEADER_FONT_SIZE": 25,
    "DATE_PICKER_HEADER_FONT_LEADING": 32,
    "DATE_PICKER_HEADER_FONT_TRACKING": 0,
    "DATE_PICKER_HEADER_FONT_WEIGHT": 700,
    "DATE_PICKER_HEADER_FONT_CASE": "regular",
    "DATE_PICKER_HEADER_FONT_NUMBER_SPACING": "default",
    "DATE_PICKER_HEADER_FONT_SCALE": "heading-30",
    "DATE_PICKER_HEADER_FONT_FONT_FAMILY": "Square Sans Display",
    "DATE_PICKER_HEADER_FONT_IS_HEADER": true,
    "DATE_PICKER_HEADER_COLOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_HEADER_COLOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_HEADER_COLOR_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_HEADER_MINIMUM_HEIGHT": 40,
    "DATE_PICKER_HEADER_VERTICAL_SPACING": 16,
    "DATE_PICKER_HEADER_BUTTON_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_HEADER_BUTTON_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_HEADER_BUTTON_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "DATE_PICKER_HEADER_BUTTON_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "DATE_PICKER_HEADER_BUTTON_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DATE_PICKER_HEADER_BUTTON_BORDER_RADIUS": 6,
    "DATE_PICKER_HEADER_BUTTON_PREVIOUS_YEAR_ICON_ASSET": "arrow-left",
    "DATE_PICKER_HEADER_BUTTON_PREVIOUS_YEAR_ICON_WIDTH": 24,
    "DATE_PICKER_HEADER_BUTTON_PREVIOUS_YEAR_ICON_HEIGHT": 24,
    "DATE_PICKER_HEADER_BUTTON_PREVIOUS_YEAR_ICON_TINTABLE": true,
    "DATE_PICKER_HEADER_BUTTON_NEXT_YEAR_ICON_ASSET": "arrow-right",
    "DATE_PICKER_HEADER_BUTTON_NEXT_YEAR_ICON_WIDTH": 24,
    "DATE_PICKER_HEADER_BUTTON_NEXT_YEAR_ICON_HEIGHT": 24,
    "DATE_PICKER_HEADER_BUTTON_NEXT_YEAR_ICON_TINTABLE": true,
    "DATE_PICKER_HEADER_BUTTON_PADDING": 8,
    "DATE_PICKER_HEADER_BUTTON_HORIZONTAL_SPACING": 16,
    "DATE_PICKER_HEADER_BUTTON_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_GRID_ITEM_WIDTH": 40,
    "DATE_PICKER_GRID_ITEM_HEIGHT": 40,
    "DATE_PICKER_GRID_ITEM_VERTICAL_PADDING": 8,
    "DATE_PICKER_GRID_ITEM_HORIZONTAL_PADDING": 0,
    "DATE_PICKER_WEEKDAYS_FONT_SIZE": 16,
    "DATE_PICKER_WEEKDAYS_FONT_LEADING": 24,
    "DATE_PICKER_WEEKDAYS_FONT_TRACKING": 0,
    "DATE_PICKER_WEEKDAYS_FONT_WEIGHT": 400,
    "DATE_PICKER_WEEKDAYS_FONT_CASE": "regular",
    "DATE_PICKER_WEEKDAYS_FONT_NUMBER_SPACING": "default",
    "DATE_PICKER_WEEKDAYS_FONT_SCALE": "paragraph-30",
    "DATE_PICKER_WEEKDAYS_FONT_FONT_FAMILY": "Square Sans Text",
    "DATE_PICKER_WEEKDAYS_COLOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "DATE_PICKER_WEEKDAYS_COLOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "DATE_PICKER_WEEKDAYS_COLOR_COLOR": "rgba(0, 0, 0, 0.55)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "rgb(8, 8, 8)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_NORMAL_STATE_COLOR": "rgb(255, 255, 255)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "rgb(8, 8, 8)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_DISABLED_STATE_COLOR": "rgb(255, 255, 255)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_HOVER_STATE_COLOR": "rgb(230, 240, 255)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_PRESSED_STATE_COLOR": "rgb(204, 225, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_HOVER_STATE_COLOR": "rgb(230, 240, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_PRESSED_STATE_COLOR": "rgb(204, 225, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0.05)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_HOVER_STATE_COLOR": "rgb(230, 240, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_PRESSED_STATE_COLOR": "rgb(204, 225, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_HOVER_STATE_COLOR": "rgb(230, 240, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_PRESSED_STATE_COLOR": "rgb(204, 225, 255)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_HOVER_STATE_COLOR": "rgb(230, 240, 255)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_PRESSED_STATE_COLOR": "rgb(204, 225, 255)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0.3)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_HOVER_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_PRESSED_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_NORMAL_STATE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_DISABLED_STATE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_HOVER_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_PRESSED_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0.3)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_HOVER_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_PRESSED_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_NORMAL_STATE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_DISABLED_STATE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_HOVER_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_PRESSED_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_NORMAL_STATE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_DISABLED_STATE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_HOVER_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_PRESSED_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_DATE_BORDER_RADIUS": 6,
    "DATE_PICKER_DATE_BORDER_NORMAL_STATE_BORDER": 2,
    "DATE_PICKER_DATE_BORDER_NORMAL_STATE_COLOR_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "DATE_PICKER_DATE_BORDER_NORMAL_STATE_COLOR_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "DATE_PICKER_DATE_BORDER_NORMAL_STATE_COLOR_COLOR": "rgb(0, 106, 255)",
    "DATE_PICKER_DATE_BORDER_NORMAL_STATE_OPACITY": 0,
    "DATE_PICKER_DATE_BORDER_FOCUSED_STATE_BORDER": 2,
    "DATE_PICKER_DATE_BORDER_FOCUSED_STATE_COLOR_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "DATE_PICKER_DATE_BORDER_FOCUSED_STATE_COLOR_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "DATE_PICKER_DATE_BORDER_FOCUSED_STATE_COLOR_COLOR": "rgb(0, 106, 255)",
    "DATE_PICKER_DATE_BORDER_FOCUSED_STATE_OPACITY": 1,
    "DATE_PICKER_DATE_BORDER_DISABLED_STATE_COLOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_DATE_BORDER_DISABLED_STATE_COLOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "DATE_PICKER_DATE_BORDER_DISABLED_STATE_COLOR_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_TODAY_BORDER_WIDTH": 1,
    "DATE_PICKER_TODAY_BORDER_COLOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_TODAY_BORDER_COLOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "DATE_PICKER_TODAY_BORDER_COLOR_COLOR": "rgba(0, 0, 0, 0.9)",
    "DATE_PICKER_TODAY_FONT_SIZE": 16,
    "DATE_PICKER_TODAY_FONT_LEADING": 24,
    "DATE_PICKER_TODAY_FONT_TRACKING": 0,
    "DATE_PICKER_TODAY_FONT_WEIGHT": 600,
    "DATE_PICKER_TODAY_FONT_CASE": "regular",
    "DATE_PICKER_TODAY_FONT_NUMBER_SPACING": "default",
    "DATE_PICKER_TODAY_FONT_SCALE": "paragraph-30",
    "DATE_PICKER_TODAY_FONT_FONT_FAMILY": "Square Sans Text",
    "DATE_PICKER_TODAY_LABEL_DISABLED_STATE_COLOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_TODAY_LABEL_DISABLED_STATE_COLOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "DATE_PICKER_TODAY_LABEL_DISABLED_STATE_COLOR_COLOR": "rgba(0, 0, 0, 0.15)",
    "DATE_PICKER_MENU_TEXT_SIZE": 16,
    "DATE_PICKER_MENU_TEXT_LEADING": 24,
    "DATE_PICKER_MENU_TEXT_TRACKING": 0,
    "DATE_PICKER_MENU_TEXT_WEIGHT": 600,
    "DATE_PICKER_MENU_TEXT_CASE": "regular",
    "DATE_PICKER_MENU_TEXT_NUMBER_SPACING": "default",
    "DATE_PICKER_MENU_TEXT_SCALE": "paragraph-30",
    "DATE_PICKER_MENU_TEXT_FONT_FAMILY": "Square Sans Text",
    "DATE_PICKER_MENU_ROW_LABEL_SELECTED_STATE_TEXT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "DATE_PICKER_MENU_ROW_LABEL_SELECTED_STATE_TEXT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "DATE_PICKER_MENU_ROW_LABEL_SELECTED_STATE_TEXT_COLOR": "rgb(0, 90, 217)",
    "DATE_PICKER_MENU_ROW_HEIGHT": 48,
    "DATE_PICKER_MENU_ROW_WIDTH": 111,
    "DATE_PICKER_MENU_HORIZONTAL_SPACING": 32,
    "DATE_PICKER_MENU_VERTICAL_SPACING": 24,
    "DIVIDER_FILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "DIVIDER_FILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "DIVIDER_FILL_COLOR": "rgba(0, 0, 0, 0.05)",
    "DIVIDER_HEIGHT": 8,
    "DIVIDER_RADIUS": 2,
    "DIVIDER_EXTRA_SMALL_VARIANT_VERTICAL_PADDING": 0,
    "DIVIDER_SMALL_VARIANT_VERTICAL_PADDING": 8,
    "DIVIDER_MEDIUM_VARIANT_VERTICAL_PADDING": 16,
    "DIVIDER_LARGE_VARIANT_VERTICAL_PADDING": 32,
    "DROPDOWN_BUTTON_SMALL_SIZE_MINIMUM_HEIGHT": 40,
    "DROPDOWN_BUTTON_SMALL_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
    "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_SIZE": 14,
    "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_LEADING": 22,
    "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_TRACKING": 0,
    "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_WEIGHT": 600,
    "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_CASE": "regular",
    "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_NUMBER_SPACING": "default",
    "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_SCALE": "paragraph-20",
    "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "DROPDOWN_BUTTON_SMALL_SIZE_CONTENT_SPACING": 8,
    "DROPDOWN_BUTTON_SMALL_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 12,
    "DROPDOWN_BUTTON_SMALL_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 9,
    "DROPDOWN_BUTTON_SMALL_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 12,
    "DROPDOWN_BUTTON_SMALL_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 9,
    "DROPDOWN_BUTTON_SMALL_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
    "DROPDOWN_BUTTON_SMALL_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 9,
    "DROPDOWN_BUTTON_SMALL_SIZE_CARET_ICON_ASSET": "chevron-down",
    "DROPDOWN_BUTTON_SMALL_SIZE_CARET_ICON_WIDTH": 16,
    "DROPDOWN_BUTTON_SMALL_SIZE_CARET_ICON_HEIGHT": 16,
    "DROPDOWN_BUTTON_SMALL_SIZE_CARET_ICON_TINTABLE": true,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_SIZE": 16,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_LEADING": 24,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_TRACKING": 0,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_WEIGHT": 600,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_CASE": "regular",
    "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_NUMBER_SPACING": "default",
    "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_SCALE": "paragraph-30",
    "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "DROPDOWN_BUTTON_MEDIUM_SIZE_CONTENT_SPACING": 8,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 16,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 12,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 16,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 12,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 12,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_CARET_ICON_ASSET": "chevron-down",
    "DROPDOWN_BUTTON_MEDIUM_SIZE_CARET_ICON_WIDTH": 16,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_CARET_ICON_HEIGHT": 16,
    "DROPDOWN_BUTTON_MEDIUM_SIZE_CARET_ICON_TINTABLE": true,
    "DROPDOWN_BUTTON_LARGE_SIZE_MINIMUM_HEIGHT": 64,
    "DROPDOWN_BUTTON_LARGE_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
    "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_SIZE": 16,
    "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_LEADING": 24,
    "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_TRACKING": 0,
    "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_WEIGHT": 600,
    "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_CASE": "regular",
    "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_NUMBER_SPACING": "default",
    "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_SCALE": "paragraph-30",
    "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "DROPDOWN_BUTTON_LARGE_SIZE_CONTENT_SPACING": 8,
    "DROPDOWN_BUTTON_LARGE_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 20,
    "DROPDOWN_BUTTON_LARGE_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 20,
    "DROPDOWN_BUTTON_LARGE_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 20,
    "DROPDOWN_BUTTON_LARGE_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 20,
    "DROPDOWN_BUTTON_LARGE_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
    "DROPDOWN_BUTTON_LARGE_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 20,
    "DROPDOWN_BUTTON_LARGE_SIZE_CARET_ICON_ASSET": "chevron-down",
    "DROPDOWN_BUTTON_LARGE_SIZE_CARET_ICON_WIDTH": 16,
    "DROPDOWN_BUTTON_LARGE_SIZE_CARET_ICON_HEIGHT": 16,
    "DROPDOWN_BUTTON_LARGE_SIZE_CARET_ICON_TINTABLE": true,
    "DROPDOWN_BUTTON_BORDER_RADIUS": 6,
    "DROPDOWN_BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
    "DROPDOWN_BUTTON_FOCUS_RING_BORDER_SIZE": 2,
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LABEL_COLOR": "rgb(255, 255, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "rgb(74, 149, 255)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LABEL_COLOR": "rgb(0, 90, 217)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "DROPDOWN_ICON_BUTTON_SMALL_SIZE_MINIMUM_HEIGHT": 40,
    "DROPDOWN_ICON_BUTTON_SMALL_SIZE_WIDTH_MULTIPLIER": 1,
    "DROPDOWN_ICON_BUTTON_SMALL_SIZE_PADDING_SIZE": 8,
    "DROPDOWN_ICON_BUTTON_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
    "DROPDOWN_ICON_BUTTON_MEDIUM_SIZE_WIDTH_MULTIPLIER": 1,
    "DROPDOWN_ICON_BUTTON_MEDIUM_SIZE_PADDING_SIZE": 12,
    "DROPDOWN_ICON_BUTTON_LARGE_SIZE_MINIMUM_HEIGHT": 64,
    "DROPDOWN_ICON_BUTTON_LARGE_SIZE_WIDTH_MULTIPLIER": 1,
    "DROPDOWN_ICON_BUTTON_LARGE_SIZE_PADDING_SIZE": 20,
    "DROPDOWN_ICON_BUTTON_BORDER_RADIUS": 6,
    "DROPDOWN_ICON_BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
    "DROPDOWN_ICON_BUTTON_FOCUS_RING_BORDER_SIZE": 2,
    "DROPDOWN_ICON_BUTTON_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DROPDOWN_ICON_BUTTON_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "DROPDOWN_ICON_BUTTON_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "DROPDOWN_ICON_BUTTON_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "DROPDOWN_ICON_BUTTON_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DROPDOWN_ICON_BUTTON_NORMAL_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "DROPDOWN_ICON_BUTTON_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "DROPDOWN_ICON_BUTTON_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "DROPDOWN_ICON_BUTTON_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "DROPDOWN_ICON_BUTTON_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "DROPDOWN_ICON_BUTTON_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "DROPDOWN_ICON_BUTTON_HOVER_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "DROPDOWN_ICON_BUTTON_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "DROPDOWN_ICON_BUTTON_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "DROPDOWN_ICON_BUTTON_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "DROPDOWN_ICON_BUTTON_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "DROPDOWN_ICON_BUTTON_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "DROPDOWN_ICON_BUTTON_PRESSED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "DROPDOWN_ICON_BUTTON_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "DROPDOWN_ICON_BUTTON_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "DROPDOWN_ICON_BUTTON_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "DROPDOWN_ICON_BUTTON_FOCUS_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "DROPDOWN_ICON_BUTTON_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "DROPDOWN_ICON_BUTTON_FOCUS_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "DROPDOWN_ICON_BUTTON_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DROPDOWN_ICON_BUTTON_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "DROPDOWN_ICON_BUTTON_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "DROPDOWN_ICON_BUTTON_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "DROPDOWN_ICON_BUTTON_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "DROPDOWN_ICON_BUTTON_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "EMPTY_STATE_HEADING_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "EMPTY_STATE_HEADING_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "EMPTY_STATE_HEADING_TEXT_SIZE": 19,
    "EMPTY_STATE_HEADING_TEXT_LEADING": 26,
    "EMPTY_STATE_HEADING_TEXT_TRACKING": 0,
    "EMPTY_STATE_HEADING_TEXT_WEIGHT": 700,
    "EMPTY_STATE_HEADING_TEXT_CASE": "regular",
    "EMPTY_STATE_HEADING_TEXT_NUMBER_SPACING": "default",
    "EMPTY_STATE_HEADING_TEXT_SCALE": "heading-20",
    "EMPTY_STATE_HEADING_TEXT_FONT_FAMILY": "Square Sans Display",
    "EMPTY_STATE_HEADING_TEXT_IS_HEADER": true,
    "EMPTY_STATE_HEADING_COLOR": "rgba(0, 0, 0, 0.9)",
    "EMPTY_STATE_PARAGRAPH_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "EMPTY_STATE_PARAGRAPH_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "EMPTY_STATE_PARAGRAPH_TEXT_SIZE": 16,
    "EMPTY_STATE_PARAGRAPH_TEXT_LEADING": 24,
    "EMPTY_STATE_PARAGRAPH_TEXT_TRACKING": 0,
    "EMPTY_STATE_PARAGRAPH_TEXT_WEIGHT": 400,
    "EMPTY_STATE_PARAGRAPH_TEXT_CASE": "regular",
    "EMPTY_STATE_PARAGRAPH_TEXT_NUMBER_SPACING": "default",
    "EMPTY_STATE_PARAGRAPH_TEXT_SCALE": "paragraph-30",
    "EMPTY_STATE_PARAGRAPH_TEXT_FONT_FAMILY": "Square Sans Text",
    "EMPTY_STATE_PARAGRAPH_VERTICAL_SPACING": 8,
    "EMPTY_STATE_PARAGRAPH_COLOR": "rgba(0, 0, 0, 0.9)",
    "EMPTY_STATE_BUTTON_GROUP_VERTICAL_SPACING": 32,
    "EMPTY_STATE_HORIZONTAL_PADDING": 32,
    "EMPTY_STATE_VERTICAL_PADDING": 32,
    "EMPTY_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "EMPTY_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(20, 20, 20)",
    "EMPTY_STATE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "EMPTY_STATE_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "EMPTY_STATE_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "EMPTY_STATE_BORDER_RADIUS": 6,
    "EMPTY_STATE_BORDER_WIDTH": 1,
    "EMPTY_STATE_BORDER_COLOR": "rgba(0, 0, 0, 0.15)",
    "FIELD_BORDER_RADIUS": 6,
    "FIELD_BORDER_SIZE": 1,
    "FIELD_ACTION_TEXT_SIZE": 14,
    "FIELD_ACTION_TEXT_LEADING": 22,
    "FIELD_ACTION_TEXT_TRACKING": 0,
    "FIELD_ACTION_TEXT_WEIGHT": 600,
    "FIELD_ACTION_TEXT_CASE": "regular",
    "FIELD_ACTION_TEXT_NUMBER_SPACING": "default",
    "FIELD_ACTION_TEXT_SCALE": "paragraph-20",
    "FIELD_ACTION_TEXT_FONT_FAMILY": "Square Sans Text",
    "FIELD_ACTION_TEXT_COLOR": "rgb(0, 106, 255)",
    "FIELD_ACTION_VERTICAL_PADDING_SIZE": 8,
    "FIELD_ERROR_MESSAGE_ICON_ASSET": "exclamation-circle",
    "FIELD_ERROR_MESSAGE_ICON_WIDTH": 24,
    "FIELD_ERROR_MESSAGE_ICON_HEIGHT": 24,
    "FIELD_ERROR_MESSAGE_ICON_TINTABLE": true,
    "FIELD_ERROR_MESSAGE_TEXT_SIZE": 14,
    "FIELD_ERROR_MESSAGE_TEXT_LEADING": 22,
    "FIELD_ERROR_MESSAGE_TEXT_TRACKING": 0,
    "FIELD_ERROR_MESSAGE_TEXT_WEIGHT": 400,
    "FIELD_ERROR_MESSAGE_TEXT_CASE": "regular",
    "FIELD_ERROR_MESSAGE_TEXT_NUMBER_SPACING": "default",
    "FIELD_ERROR_MESSAGE_TEXT_SCALE": "paragraph-20",
    "FIELD_ERROR_MESSAGE_TEXT_FONT_FAMILY": "Square Sans Text",
    "FIELD_ERROR_MESSAGE_TEXT_VERTICAL_SPACING": 8,
    "FIELD_ERROR_MESSAGE_TEXT_COLOR": "rgb(191, 0, 32)",
    "FIELD_HELPER_TEXT_SIZE": 14,
    "FIELD_HELPER_TEXT_LEADING": 22,
    "FIELD_HELPER_TEXT_TRACKING": 0,
    "FIELD_HELPER_TEXT_WEIGHT": 400,
    "FIELD_HELPER_TEXT_CASE": "regular",
    "FIELD_HELPER_TEXT_NUMBER_SPACING": "default",
    "FIELD_HELPER_TEXT_SCALE": "paragraph-20",
    "FIELD_HELPER_TEXT_FONT_FAMILY": "Square Sans Text",
    "FIELD_HELPER_TEXT_HORIZONTAL_SPACING": 0,
    "FIELD_HELPER_TEXT_VERTICAL_SPACING": 8,
    "FIELD_HELPER_TEXT_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "FIELD_ICON_ASSET": "i-circle",
    "FIELD_ICON_WIDTH": 24,
    "FIELD_ICON_HEIGHT": 24,
    "FIELD_ICON_TINTABLE": true,
    "FIELD_IMAGE_ACCESSORY_SPACING_LEFT_SIZE": 12,
    "FIELD_INPUT_SIZE": 16,
    "FIELD_INPUT_LEADING": 24,
    "FIELD_INPUT_TRACKING": 0,
    "FIELD_INPUT_WEIGHT": 400,
    "FIELD_INPUT_CASE": "regular",
    "FIELD_INPUT_NUMBER_SPACING": "default",
    "FIELD_INPUT_SCALE": "paragraph-30",
    "FIELD_INPUT_FONT_FAMILY": "Square Sans Text",
    "FIELD_TRAILING_ACCESSORY_BUFFER_SIZE": 16,
    "FIELD_TRAILING_ACCESSORY_HEIGHT": 48,
    "FIELD_TRAILING_ACCESSORY_WIDTH": 48,
    "FIELD_TRAILING_ACCESSORY_POSITION_BOTTOM_SIZE": 8,
    "FIELD_TRAILING_ACCESSORY_POSITION_RIGHT_SIZE": 0,
    "FIELD_LIGHT_MODE_ACTION_TEXT_COLOR": "rgb(0, 106, 255)",
    "FIELD_LIGHT_MODE_ERROR_MESSAGE_TEXT_COLOR": "rgb(191, 0, 32)",
    "FIELD_LIGHT_MODE_HELPER_TEXT_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "FIELD_LIGHT_MODE_PLACEHOLDER_TEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "FIELD_DARK_MODE_ACTION_TEXT_COLOR": "rgb(0, 106, 255)",
    "FIELD_DARK_MODE_ERROR_MESSAGE_TEXT_COLOR": "rgb(255, 90, 118)",
    "FIELD_DARK_MODE_HELPER_TEXT_TEXT_COLOR": "rgba(255, 255, 255, 0.55)",
    "FIELD_DARK_MODE_PLACEHOLDER_TEXT_COLOR": "rgba(255, 255, 255, 0.3)",
    "FIELD_EMPTY_PHASE_LABEL_TEXT_SIZE": 16,
    "FIELD_EMPTY_PHASE_LABEL_TEXT_LEADING": 24,
    "FIELD_EMPTY_PHASE_LABEL_TEXT_TRACKING": 0,
    "FIELD_EMPTY_PHASE_LABEL_TEXT_WEIGHT": 400,
    "FIELD_EMPTY_PHASE_LABEL_TEXT_CASE": "regular",
    "FIELD_EMPTY_PHASE_LABEL_TEXT_NUMBER_SPACING": "default",
    "FIELD_EMPTY_PHASE_LABEL_TEXT_SCALE": "paragraph-30",
    "FIELD_EMPTY_PHASE_LABEL_TEXT_FONT_FAMILY": "Square Sans Text",
    "FIELD_EMPTY_PHASE_HORIZONTAL_PADDING_SIZE": 16,
    "FIELD_EMPTY_PHASE_VERTICAL_PADDING_SIZE": 20,
    "FIELD_FLOAT_PHASE_LABEL_TEXT_SIZE": 14,
    "FIELD_FLOAT_PHASE_LABEL_TEXT_LEADING": 22,
    "FIELD_FLOAT_PHASE_LABEL_TEXT_TRACKING": 0,
    "FIELD_FLOAT_PHASE_LABEL_TEXT_WEIGHT": 500,
    "FIELD_FLOAT_PHASE_LABEL_TEXT_CASE": "regular",
    "FIELD_FLOAT_PHASE_LABEL_TEXT_NUMBER_SPACING": "default",
    "FIELD_FLOAT_PHASE_LABEL_TEXT_SCALE": "paragraph-20",
    "FIELD_FLOAT_PHASE_LABEL_TEXT_FONT_FAMILY": "Square Sans Text",
    "FIELD_FLOAT_PHASE_LABEL_MARGIN_TOP_SIZE": 8,
    "FIELD_FLOAT_PHASE_LABEL_MARGIN_BOTTOM_SIZE": 2,
    "FIELD_FLOAT_PHASE_HORIZONTAL_PADDING_SIZE": 16,
    "FIELD_FLOAT_PHASE_VERTICAL_PADDING_SIZE": 8,
    "FIELD_NORMAL_STATE_EMPTY_PHASE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.55)",
    "FIELD_NORMAL_STATE_EMPTY_PHASE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.55)",
    "FIELD_NORMAL_STATE_EMPTY_PHASE_LABEL_COLOR": "rgba(0, 0, 0, 0.55)",
    "FIELD_NORMAL_STATE_FLOAT_PHASE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_NORMAL_STATE_FLOAT_PHASE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "FIELD_NORMAL_STATE_FLOAT_PHASE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_NORMAL_STATE_NORMAL_VALIDITY_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0.15)",
    "FIELD_NORMAL_STATE_NORMAL_VALIDITY_DARK_MODE_BORDER_COLOR": "rgba(255, 255, 255, 0.15)",
    "FIELD_NORMAL_STATE_NORMAL_VALIDITY_BORDER_COLOR": "rgba(0, 0, 0, 0.15)",
    "FIELD_NORMAL_STATE_INVALID_VALIDITY_LIGHT_MODE_BORDER_COLOR": "rgb(204, 0, 35)",
    "FIELD_NORMAL_STATE_INVALID_VALIDITY_DARK_MODE_BORDER_COLOR": "rgb(204, 0, 35)",
    "FIELD_NORMAL_STATE_INVALID_VALIDITY_BORDER_COLOR": "rgb(204, 0, 35)",
    "FIELD_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "FIELD_NORMAL_STATE_LIGHT_MODE_INPUT_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(8, 8, 8)",
    "FIELD_NORMAL_STATE_DARK_MODE_INPUT_COLOR": "rgba(255, 255, 255, 0.95)",
    "FIELD_NORMAL_STATE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "FIELD_NORMAL_STATE_INPUT_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_HOVER_STATE_EMPTY_PHASE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.55)",
    "FIELD_HOVER_STATE_EMPTY_PHASE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.55)",
    "FIELD_HOVER_STATE_EMPTY_PHASE_LABEL_COLOR": "rgba(0, 0, 0, 0.55)",
    "FIELD_HOVER_STATE_FLOAT_PHASE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_HOVER_STATE_FLOAT_PHASE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "FIELD_HOVER_STATE_FLOAT_PHASE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_HOVER_STATE_NORMAL_VALIDITY_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_HOVER_STATE_NORMAL_VALIDITY_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_HOVER_STATE_NORMAL_VALIDITY_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_HOVER_STATE_INVALID_VALIDITY_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_HOVER_STATE_INVALID_VALIDITY_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_HOVER_STATE_INVALID_VALIDITY_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "FIELD_HOVER_STATE_LIGHT_MODE_INPUT_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(8, 8, 8)",
    "FIELD_HOVER_STATE_DARK_MODE_INPUT_COLOR": "rgba(255, 255, 255, 0.95)",
    "FIELD_HOVER_STATE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "FIELD_HOVER_STATE_INPUT_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_FOCUS_STATE_BORDER_SIZE": 2,
    "FIELD_FOCUS_STATE_FLOAT_PHASE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_FOCUS_STATE_FLOAT_PHASE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "FIELD_FOCUS_STATE_FLOAT_PHASE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_FOCUS_STATE_NORMAL_VALIDITY_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_FOCUS_STATE_NORMAL_VALIDITY_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_FOCUS_STATE_NORMAL_VALIDITY_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_FOCUS_STATE_INVALID_VALIDITY_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_FOCUS_STATE_INVALID_VALIDITY_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_FOCUS_STATE_INVALID_VALIDITY_BORDER_COLOR": "rgb(0, 106, 255)",
    "FIELD_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "FIELD_FOCUS_STATE_LIGHT_MODE_INPUT_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(8, 8, 8)",
    "FIELD_FOCUS_STATE_DARK_MODE_INPUT_COLOR": "rgba(255, 255, 255, 0.95)",
    "FIELD_FOCUS_STATE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "FIELD_FOCUS_STATE_INPUT_COLOR": "rgba(0, 0, 0, 0.9)",
    "FIELD_DISABLED_STATE_EMPTY_PHASE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "FIELD_DISABLED_STATE_EMPTY_PHASE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "FIELD_DISABLED_STATE_EMPTY_PHASE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "FIELD_DISABLED_STATE_FLOAT_PHASE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "FIELD_DISABLED_STATE_FLOAT_PHASE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "FIELD_DISABLED_STATE_FLOAT_PHASE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "FIELD_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "FIELD_DISABLED_STATE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0.05)",
    "FIELD_DISABLED_STATE_LIGHT_MODE_INPUT_COLOR": "rgba(0, 0, 0, 0.3)",
    "FIELD_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "FIELD_DISABLED_STATE_DARK_MODE_BORDER_COLOR": "rgba(255, 255, 255, 0.08)",
    "FIELD_DISABLED_STATE_DARK_MODE_INPUT_COLOR": "rgba(255, 255, 255, 0.3)",
    "FIELD_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "FIELD_DISABLED_STATE_BORDER_COLOR": "rgba(0, 0, 0, 0.05)",
    "FIELD_DISABLED_STATE_INPUT_COLOR": "rgba(0, 0, 0, 0.3)",
    "FIELD_PLACEHOLDER_TEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "FILTER_BUTTON_BORDER_RADIUS": 6,
    "FILTER_BUTTON_BORDER_SIZE": 1,
    "FILTER_BUTTON_FEEDBACK_MAXIMUM": 99,
    "FILTER_BUTTON_LABEL_CONTENT_SPACING": 8,
    "FILTER_BUTTON_ICON_FEEDBACK_TRAILING_PADDING": 2,
    "FILTER_BUTTON_ICON_CONTENT_SPACING": 4,
    "FILTER_BUTTON_SMALL_SIZE_MINIMUM_HEIGHT": 40,
    "FILTER_BUTTON_SMALL_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1,
    "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_SIZE": 14,
    "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_LEADING": 22,
    "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_TRACKING": 0,
    "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_WEIGHT": 400,
    "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_CASE": "regular",
    "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_NUMBER_SPACING": "default",
    "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_SCALE": "paragraph-20",
    "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_FONT_FAMILY": "Square Sans Text",
    "FILTER_BUTTON_SMALL_SIZE_LABEL_HORIZONTAL_PADDING": 12,
    "FILTER_BUTTON_SMALL_SIZE_LABEL_VERTICAL_PADDING": 9,
    "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_SIZE": 14,
    "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_LEADING": 22,
    "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_TRACKING": 0,
    "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_WEIGHT": 600,
    "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_CASE": "regular",
    "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_NUMBER_SPACING": "default",
    "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_SCALE": "paragraph-20",
    "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_FONT_FAMILY": "Square Sans Text",
    "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_SIZE": 16,
    "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_LEADING": 24,
    "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_TRACKING": 0,
    "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_WEIGHT": 600,
    "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_CASE": "regular",
    "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_NUMBER_SPACING": "default",
    "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_SCALE": "paragraph-30",
    "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_FONT_FAMILY": "Square Sans Text",
    "FILTER_BUTTON_SMALL_SIZE_ICON_HORIZONTAL_PADDING": 8,
    "FILTER_BUTTON_SMALL_SIZE_ICON_VERTICAL_PADDING": 8,
    "FILTER_BUTTON_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
    "FILTER_BUTTON_MEDIUM_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1,
    "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_SIZE": 16,
    "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_LEADING": 24,
    "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_TRACKING": 0,
    "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_WEIGHT": 400,
    "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_CASE": "regular",
    "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_NUMBER_SPACING": "default",
    "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_SCALE": "paragraph-30",
    "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_FONT_FAMILY": "Square Sans Text",
    "FILTER_BUTTON_MEDIUM_SIZE_LABEL_HORIZONTAL_PADDING": 16,
    "FILTER_BUTTON_MEDIUM_SIZE_LABEL_VERTICAL_PADDING": 12,
    "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_SIZE": 16,
    "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_LEADING": 24,
    "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_TRACKING": 0,
    "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_WEIGHT": 600,
    "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_CASE": "regular",
    "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_NUMBER_SPACING": "default",
    "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_SCALE": "paragraph-30",
    "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_FONT_FAMILY": "Square Sans Text",
    "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_SIZE": 16,
    "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_LEADING": 24,
    "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_TRACKING": 0,
    "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_WEIGHT": 600,
    "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_CASE": "regular",
    "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_NUMBER_SPACING": "default",
    "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_SCALE": "paragraph-30",
    "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_FONT_FAMILY": "Square Sans Text",
    "FILTER_BUTTON_MEDIUM_SIZE_ICON_HORIZONTAL_PADDING": 12,
    "FILTER_BUTTON_MEDIUM_SIZE_ICON_VERTICAL_PADDING": 12,
    "FILTER_BUTTON_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "FILTER_BUTTON_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "FILTER_BUTTON_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "FILTER_BUTTON_NORMAL_STATE_LABEL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "FILTER_BUTTON_NORMAL_STATE_LABEL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "FILTER_BUTTON_NORMAL_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.55)",
    "FILTER_BUTTON_NORMAL_STATE_FEEDBACK_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "FILTER_BUTTON_NORMAL_STATE_FEEDBACK_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "FILTER_BUTTON_NORMAL_STATE_FEEDBACK_COLOR": "rgba(0, 0, 0, 0.9)",
    "FILTER_BUTTON_NORMAL_STATE_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "FILTER_BUTTON_NORMAL_STATE_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "FILTER_BUTTON_NORMAL_STATE_BORDER_COLOR": "rgba(0, 0, 0, 0.15)",
    "FILTER_BUTTON_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "FILTER_BUTTON_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "FILTER_BUTTON_HOVER_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "FILTER_BUTTON_HOVER_STATE_LABEL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "FILTER_BUTTON_HOVER_STATE_LABEL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "FILTER_BUTTON_HOVER_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.55)",
    "FILTER_BUTTON_HOVER_STATE_FEEDBACK_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "FILTER_BUTTON_HOVER_STATE_FEEDBACK_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "FILTER_BUTTON_HOVER_STATE_FEEDBACK_COLOR": "rgba(0, 0, 0, 0.9)",
    "FILTER_BUTTON_HOVER_STATE_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "FILTER_BUTTON_HOVER_STATE_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "FILTER_BUTTON_HOVER_STATE_BORDER_COLOR": "rgba(0, 0, 0, 0.15)",
    "FILTER_BUTTON_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "FILTER_BUTTON_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "FILTER_BUTTON_PRESSED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "FILTER_BUTTON_PRESSED_STATE_LABEL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "FILTER_BUTTON_PRESSED_STATE_LABEL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "FILTER_BUTTON_PRESSED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.55)",
    "FILTER_BUTTON_PRESSED_STATE_FEEDBACK_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "FILTER_BUTTON_PRESSED_STATE_FEEDBACK_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "FILTER_BUTTON_PRESSED_STATE_FEEDBACK_COLOR": "rgba(0, 0, 0, 0.9)",
    "FILTER_BUTTON_PRESSED_STATE_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "FILTER_BUTTON_PRESSED_STATE_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "FILTER_BUTTON_PRESSED_STATE_BORDER_COLOR": "rgba(0, 0, 0, 0.9)",
    "FILTER_BUTTON_DISABLED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "FILTER_BUTTON_DISABLED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "FILTER_BUTTON_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "FILTER_BUTTON_DISABLED_STATE_LABEL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "FILTER_BUTTON_DISABLED_STATE_LABEL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "FILTER_BUTTON_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "FILTER_BUTTON_DISABLED_STATE_FEEDBACK_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "FILTER_BUTTON_DISABLED_STATE_FEEDBACK_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "FILTER_BUTTON_DISABLED_STATE_FEEDBACK_COLOR": "rgba(0, 0, 0, 0.3)",
    "FILTER_BUTTON_DISABLED_STATE_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "FILTER_BUTTON_DISABLED_STATE_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "FILTER_BUTTON_DISABLED_STATE_BORDER_COLOR": "rgba(0, 0, 0, 0.15)",
    "FOOTER_VERTICAL_PADDING_SIZE": 16,
    "HEADER_TOP_PADDING_COMPACT_SIZE_CLASS_SIZE": 16,
    "HEADER_TOP_PADDING_NORMAL_SIZE_CLASS_SIZE": 24,
    "HEADER_TOP_PADDING_WIDE_SIZE_CLASS_SIZE": 24,
    "HEADER_TOP_PADDING_SIZE": 24,
    "HEADER_BOTTOM_PADDING_COMPACT_SIZE_CLASS_SIZE": 16,
    "HEADER_BOTTOM_PADDING_NORMAL_SIZE_CLASS_SIZE": 16,
    "HEADER_BOTTOM_PADDING_WIDE_SIZE_CLASS_SIZE": 16,
    "HEADER_BOTTOM_PADDING_SIZE": 16,
    "HEADER_HORIZONTAL_PADDING_COMPACT_SIZE_CLASS_SIZE": 16,
    "HEADER_HORIZONTAL_PADDING_NORMAL_SIZE_CLASS_SIZE": 24,
    "HEADER_HORIZONTAL_PADDING_WIDE_SIZE_CLASS_SIZE": 24,
    "HEADER_HORIZONTAL_PADDING_SIZE": 16,
    "HEADER_NAV_ICON_BUTTON_SPACING_BUTTOM_SIZE": 24,
    "HEADER_NAV_ICON_BUTTON_SPACING_BOTTOM_SIZE": 24,
    "HEADER_CLOSE_BUTTON_ICON_ASSET": "x",
    "HEADER_CLOSE_BUTTON_ICON_WIDTH": 24,
    "HEADER_CLOSE_BUTTON_ICON_HEIGHT": 24,
    "HEADER_CLOSE_BUTTON_ICON_TINTABLE": true,
    "HEADER_MAIN_TEXT_HORIZONTAL_SPACING": 16,
    "HEADER_MAIN_TEXT_MINIMUM_WIDTH": 64,
    "HEADER_MAIN_TEXT_TRANSITION_DURATION": 160,
    "HEADER_MAIN_TEXT_NORMAL_PHASE_SPACING_TOP_SIZE": 8,
    "HEADER_MAIN_TEXT_LIGHT_MODE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "HEADER_MAIN_TEXT_DARK_MODE_TEXT_COLOR": "rgba(255, 255, 255, 0.95)",
    "HEADER_MAIN_TEXT_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "HEADER_SUB_TEXT_SPACING_BOTTOM_SIZE": 8,
    "HEADER_SUB_TEXT_LIGHT_MODE_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "HEADER_SUB_TEXT_DARK_MODE_TEXT_COLOR": "rgba(255, 255, 255, 0.55)",
    "HEADER_SUB_TEXT_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "HEADER_DIVIDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "HEADER_DIVIDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "HEADER_DIVIDER_SIZE": 1,
    "HEADER_DIVIDER_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_SMALL_SIZE_MINIMUM_HEIGHT": 40,
    "ICON_BUTTON_SMALL_SIZE_WIDTH_MULTIPLIER": 1,
    "ICON_BUTTON_SMALL_SIZE_PADDING_SIZE": 8,
    "ICON_BUTTON_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
    "ICON_BUTTON_MEDIUM_SIZE_WIDTH_MULTIPLIER": 1,
    "ICON_BUTTON_MEDIUM_SIZE_PADDING_SIZE": 12,
    "ICON_BUTTON_LARGE_SIZE_MINIMUM_HEIGHT": 64,
    "ICON_BUTTON_LARGE_SIZE_WIDTH_MULTIPLIER": 1,
    "ICON_BUTTON_LARGE_SIZE_PADDING_SIZE": 20,
    "ICON_BUTTON_NORMAL_SIZE_MINIMUM_WIDTH": 48,
    "ICON_BUTTON_NORMAL_SIZE_MINIMUM_HEIGHT": 48,
    "ICON_BUTTON_NORMAL_SIZE_PADDING_SIZE": 16,
    "ICON_BUTTON_COMPACT_SIZE_MINIMUM_WIDTH": 40,
    "ICON_BUTTON_COMPACT_SIZE_MINIMUM_HEIGHT": 40,
    "ICON_BUTTON_COMPACT_SIZE_MINIMUM_PADDING_SIZE": 12,
    "ICON_BUTTON_COMPACT_SIZE_PADDING_SIZE": 12,
    "ICON_BUTTON_MINIMUM_WIDTH": 48,
    "ICON_BUTTON_MINIMUM_HEIGHT": 48,
    "ICON_BUTTON_PADDING_SIZE": 16,
    "ICON_BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
    "ICON_BUTTON_FOCUS_RING_BORDER_SIZE": 2,
    "ICON_BUTTON_BORDER_RADIUS": 6,
    "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ICON_BUTTON_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ICON_BUTTON_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_TERTIARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ICON_BUTTON_TERTIARY_RANK_NORMAL_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_TERTIARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "ICON_BUTTON_TERTIARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_TERTIARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_TERTIARY_RANK_HOVER_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "ICON_BUTTON_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "ICON_BUTTON_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_TERTIARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "ICON_BUTTON_TERTIARY_RANK_PRESSED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "ICON_BUTTON_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_TERTIARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_TERTIARY_RANK_FOCUS_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ICON_BUTTON_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ICON_BUTTON_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "ICON_BUTTON_TERTIARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ICON_BUTTON_TERTIARY_RANK_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_NORMAL_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "ICON_BUTTON_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_HOVER_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "ICON_BUTTON_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "ICON_BUTTON_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "ICON_BUTTON_PRESSED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "ICON_BUTTON_FOCUS_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_FOCUS_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "ICON_BUTTON_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_ICON_COLOR": "rgb(255, 255, 255)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 90, 118)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(51, 0, 9)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 90, 118)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 204, 213)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(89, 0, 15)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 90, 118)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(255, 204, 213)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 90, 118)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(51, 0, 9)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 90, 118)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 204, 213)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(89, 0, 15)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgb(255, 90, 118)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "rgb(255, 204, 213)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_ICON_COLOR": "rgb(191, 0, 32)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ICON_BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "INLINE_SECTION_HEADER_10_HEADING_SIZE": 14,
    "INLINE_SECTION_HEADER_10_HEADING_LEADING": 22,
    "INLINE_SECTION_HEADER_10_HEADING_TRACKING": 0,
    "INLINE_SECTION_HEADER_10_HEADING_WEIGHT": 700,
    "INLINE_SECTION_HEADER_10_HEADING_CASE": "regular",
    "INLINE_SECTION_HEADER_10_HEADING_NUMBER_SPACING": "default",
    "INLINE_SECTION_HEADER_10_HEADING_SCALE": "heading-10",
    "INLINE_SECTION_HEADER_10_HEADING_FONT_FAMILY": "Square Sans Text",
    "INLINE_SECTION_HEADER_10_HEADING_IS_HEADER": true,
    "INLINE_SECTION_HEADER_10_HEADING_VERTICAL_PADDING": 9,
    "INLINE_SECTION_HEADER_10_PARAGRAPH_SIZE": 16,
    "INLINE_SECTION_HEADER_10_PARAGRAPH_LEADING": 24,
    "INLINE_SECTION_HEADER_10_PARAGRAPH_TRACKING": 0,
    "INLINE_SECTION_HEADER_10_PARAGRAPH_WEIGHT": 400,
    "INLINE_SECTION_HEADER_10_PARAGRAPH_CASE": "regular",
    "INLINE_SECTION_HEADER_10_PARAGRAPH_NUMBER_SPACING": "default",
    "INLINE_SECTION_HEADER_10_PARAGRAPH_SCALE": "paragraph-30",
    "INLINE_SECTION_HEADER_10_PARAGRAPH_FONT_FAMILY": "Square Sans Text",
    "INLINE_SECTION_HEADER_10_PARAGRAPH_TOP_PADDING": 0,
    "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_SIZE": 14,
    "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_LEADING": 22,
    "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_TRACKING": 0,
    "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_WEIGHT": 600,
    "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_CASE": "regular",
    "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_NUMBER_SPACING": "default",
    "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_SCALE": "paragraph-20",
    "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_FONT_FAMILY": "Square Sans Text",
    "INLINE_SECTION_HEADER_10_TEXT_LINK_VERTICAL_PADDING": 0,
    "INLINE_SECTION_HEADER_20_HEADING_SIZE": 19,
    "INLINE_SECTION_HEADER_20_HEADING_LEADING": 26,
    "INLINE_SECTION_HEADER_20_HEADING_TRACKING": 0,
    "INLINE_SECTION_HEADER_20_HEADING_WEIGHT": 700,
    "INLINE_SECTION_HEADER_20_HEADING_CASE": "regular",
    "INLINE_SECTION_HEADER_20_HEADING_NUMBER_SPACING": "default",
    "INLINE_SECTION_HEADER_20_HEADING_SCALE": "heading-20",
    "INLINE_SECTION_HEADER_20_HEADING_FONT_FAMILY": "Square Sans Display",
    "INLINE_SECTION_HEADER_20_HEADING_IS_HEADER": true,
    "INLINE_SECTION_HEADER_20_HEADING_VERTICAL_PADDING": 7,
    "INLINE_SECTION_HEADER_20_PARAGRAPH_SIZE": 16,
    "INLINE_SECTION_HEADER_20_PARAGRAPH_LEADING": 24,
    "INLINE_SECTION_HEADER_20_PARAGRAPH_TRACKING": 0,
    "INLINE_SECTION_HEADER_20_PARAGRAPH_WEIGHT": 400,
    "INLINE_SECTION_HEADER_20_PARAGRAPH_CASE": "regular",
    "INLINE_SECTION_HEADER_20_PARAGRAPH_NUMBER_SPACING": "default",
    "INLINE_SECTION_HEADER_20_PARAGRAPH_SCALE": "paragraph-30",
    "INLINE_SECTION_HEADER_20_PARAGRAPH_FONT_FAMILY": "Square Sans Text",
    "INLINE_SECTION_HEADER_20_PARAGRAPH_TOP_PADDING": 5,
    "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_SIZE": 16,
    "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_LEADING": 24,
    "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_TRACKING": 0,
    "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_WEIGHT": 600,
    "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_CASE": "regular",
    "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_NUMBER_SPACING": "default",
    "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_SCALE": "paragraph-30",
    "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_FONT_FAMILY": "Square Sans Text",
    "INLINE_SECTION_HEADER_20_TEXT_LINK_VERTICAL_PADDING": 0,
    "INLINE_SECTION_HEADER_30_HEADING_SIZE": 25,
    "INLINE_SECTION_HEADER_30_HEADING_LEADING": 32,
    "INLINE_SECTION_HEADER_30_HEADING_TRACKING": 0,
    "INLINE_SECTION_HEADER_30_HEADING_WEIGHT": 700,
    "INLINE_SECTION_HEADER_30_HEADING_CASE": "regular",
    "INLINE_SECTION_HEADER_30_HEADING_NUMBER_SPACING": "default",
    "INLINE_SECTION_HEADER_30_HEADING_SCALE": "heading-30",
    "INLINE_SECTION_HEADER_30_HEADING_FONT_FAMILY": "Square Sans Display",
    "INLINE_SECTION_HEADER_30_HEADING_IS_HEADER": true,
    "INLINE_SECTION_HEADER_30_HEADING_VERTICAL_PADDING": 4,
    "INLINE_SECTION_HEADER_30_PARAGRAPH_SIZE": 16,
    "INLINE_SECTION_HEADER_30_PARAGRAPH_LEADING": 24,
    "INLINE_SECTION_HEADER_30_PARAGRAPH_TRACKING": 0,
    "INLINE_SECTION_HEADER_30_PARAGRAPH_WEIGHT": 400,
    "INLINE_SECTION_HEADER_30_PARAGRAPH_CASE": "regular",
    "INLINE_SECTION_HEADER_30_PARAGRAPH_NUMBER_SPACING": "default",
    "INLINE_SECTION_HEADER_30_PARAGRAPH_SCALE": "paragraph-30",
    "INLINE_SECTION_HEADER_30_PARAGRAPH_FONT_FAMILY": "Square Sans Text",
    "INLINE_SECTION_HEADER_30_PARAGRAPH_TOP_PADDING": 12,
    "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_SIZE": 16,
    "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_LEADING": 24,
    "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_TRACKING": 0,
    "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_WEIGHT": 600,
    "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_CASE": "regular",
    "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_NUMBER_SPACING": "default",
    "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_SCALE": "paragraph-30",
    "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_FONT_FAMILY": "Square Sans Text",
    "INLINE_SECTION_HEADER_30_TEXT_LINK_VERTICAL_PADDING": 0,
    "INLINE_SECTION_HEADER_HEADING_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "INLINE_SECTION_HEADER_HEADING_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "INLINE_SECTION_HEADER_HEADING_COLOR": "rgba(0, 0, 0, 0.9)",
    "INLINE_SECTION_HEADER_PARAGRAPH_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "INLINE_SECTION_HEADER_PARAGRAPH_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "INLINE_SECTION_HEADER_PARAGRAPH_COLOR": "rgba(0, 0, 0, 0.9)",
    "INLINE_SECTION_HEADER_TEXT_LINK_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "INLINE_SECTION_HEADER_TEXT_LINK_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "INLINE_SECTION_HEADER_TEXT_LINK_NORMAL_STATE_OPACITY": 1,
    "INLINE_SECTION_HEADER_TEXT_LINK_HOVER_STATE_OPACITY": 0.6,
    "INLINE_SECTION_HEADER_TEXT_LINK_PRESSED_STATE_OPACITY": 0.6,
    "INLINE_SECTION_HEADER_TEXT_LINK_DISABLED_STATE_OPACITY": 0.3,
    "INLINE_SECTION_HEADER_TEXT_LINK_COLOR": "rgb(0, 90, 217)",
    "INLINE_SECTION_HEADER_HORIZONTAL_SPACING": 8,
    "MODAL_BLADE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "MODAL_BLADE_BACKGROUND_DARK_MODE_COLOR": "rgb(28, 28, 28)",
    "MODAL_BLADE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "MODAL_BLADE_WIDE_VIEWPORT_PADDING_LEFT_SIZE": 32,
    "MODAL_BLADE_WIDE_VIEWPORT_PADDING_TOP_SIZE": 32,
    "MODAL_BLADE_WIDE_VIEWPORT_PADDING_RIGHT_SIZE": 32,
    "MODAL_BLADE_WIDE_VIEWPORT_PADDING_BOTTOM_SIZE": 0,
    "MODAL_BLADE_WIDE_VIEWPORT_MAX_HEIGHT_SIZE": 500,
    "MODAL_BLADE_WIDE_VIEWPORT_CONTENT_WIDTH_SIZE": 400,
    "MODAL_BLADE_WIDE_VIEWPORT_WIDTH_SIZE": 464,
    "MODAL_BLADE_COMPACT_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 32,
    "MODAL_BLADE_REGULAR_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 32,
    "MODAL_BLADE_WIDE_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 32,
    "MODAL_BLADE_COMPACT_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 24,
    "MODAL_BLADE_REGULAR_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 24,
    "MODAL_BLADE_MAXIMUM_WIDTH_SIZE": 464,
    "MODAL_DIALOG_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "MODAL_DIALOG_DARK_MODE_BACKGROUND_COLOR": "rgb(28, 28, 28)",
    "MODAL_DIALOG_BORDER_RADIUS": 12,
    "MODAL_DIALOG_ANIMATION_ENTER_TRANSITION_DURATION": 240,
    "MODAL_DIALOG_ANIMATION_ENTER_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
    "MODAL_DIALOG_ANIMATION_EXIT_TRANSITION_DURATION": 160,
    "MODAL_DIALOG_ANIMATION_EXIT_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
    "MODAL_DIALOG_ANIMATION_DURATION": 500,
    "MODAL_DIALOG_NARROW_VIEWPORT_HORIZONTAL_PADDING_SIZE": 24,
    "MODAL_DIALOG_NARROW_VIEWPORT_VERTICAL_PADDING_SIZE": 24,
    "MODAL_DIALOG_MEDIUM_VIEWPORT_WIDTH": 480,
    "MODAL_DIALOG_MEDIUM_VIEWPORT_HORIZONTAL_PADDING_SIZE": 40,
    "MODAL_DIALOG_MEDIUM_VIEWPORT_VERTICAL_PADDING_SIZE": 24,
    "MODAL_DIALOG_WIDE_VIEWPORT_WIDTH": 480,
    "MODAL_DIALOG_WIDE_VIEWPORT_HORIZONTAL_PADDING_SIZE": 32,
    "MODAL_DIALOG_WIDE_VIEWPORT_VERTICAL_PADDING_SIZE": 24,
    "MODAL_DIALOG_COMPACT_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 32,
    "MODAL_DIALOG_REGULAR_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 32,
    "MODAL_DIALOG_WIDE_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 32,
    "MODAL_DIALOG_COMPACT_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 32,
    "MODAL_DIALOG_REGULAR_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 32,
    "MODAL_DIALOG_MAXIMUM_WIDTH_SIZE": 480,
    "MODAL_DIALOG_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "MODAL_FULL_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "MODAL_FULL_DARK_MODE_BACKGROUND_COLOR": "rgb(8, 8, 8)",
    "MODAL_FULL_ANIMATION_ENTER_TRANSITION_DURATION": 240,
    "MODAL_FULL_ANIMATION_ENTER_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
    "MODAL_FULL_ANIMATION_EXIT_TRANSITION_DURATION": 160,
    "MODAL_FULL_ANIMATION_EXIT_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
    "MODAL_FULL_FIXED_LAYOUT_WIDTH": 600,
    "MODAL_FULL_NARROW_VIEWPORT_ANIMATION_DURATION": 500,
    "MODAL_FULL_NARROW_VIEWPORT_HORIZONTAL_PADDING_SIZE": 16,
    "MODAL_FULL_NARROW_VIEWPORT_VERTICAL_PADDING_SIZE": 16,
    "MODAL_FULL_MEDIUM_VIEWPORT_ANIMATION_DURATION": 500,
    "MODAL_FULL_MEDIUM_VIEWPORT_HORIZONTAL_PADDING_SIZE": 24,
    "MODAL_FULL_MEDIUM_VIEWPORT_VERTICAL_PADDING_SIZE": 24,
    "MODAL_FULL_WIDE_VIEWPORT_ANIMATION_DURATION": 500,
    "MODAL_FULL_WIDE_VIEWPORT_HORIZONTAL_PADDING_SIZE": 32,
    "MODAL_FULL_WIDE_VIEWPORT_VERTICAL_PADDING_SIZE": 16,
    "MODAL_FULL_COMPACT_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 16,
    "MODAL_FULL_REGULAR_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 24,
    "MODAL_FULL_WIDE_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 24,
    "MODAL_FULL_COMPACT_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 12,
    "MODAL_FULL_REGULAR_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 16,
    "MODAL_FULL_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "MODAL_PARTIAL_LIGHT_MODE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "MODAL_PARTIAL_DARK_MODE_BACKGROUND_COLOR": "rgb(28, 28, 28)",
    "MODAL_PARTIAL_BORDER_RADIUS": 12,
    "MODAL_PARTIAL_ANIMATION_ENTER_TRANSITION_DURATION": 240,
    "MODAL_PARTIAL_ANIMATION_ENTER_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
    "MODAL_PARTIAL_ANIMATION_EXIT_TRANSITION_DURATION": 160,
    "MODAL_PARTIAL_ANIMATION_EXIT_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
    "MODAL_PARTIAL_NARROW_VIEWPORT_ANIMATION_DURATION": 500,
    "MODAL_PARTIAL_NARROW_VIEWPORT_HORIZONTAL_PADDING_SIZE": 16,
    "MODAL_PARTIAL_NARROW_VIEWPORT_HORIZONTAL_SCREEN_BUFFER_SIZE": 0,
    "MODAL_PARTIAL_NARROW_VIEWPORT_VERTICAL_PADDING_SIZE": 16,
    "MODAL_PARTIAL_NARROW_VIEWPORT_VERTICAL_SCREEN_BUFFER_SIZE": 0,
    "MODAL_PARTIAL_MEDIUM_VIEWPORT_ANIMATION_DURATION": 500,
    "MODAL_PARTIAL_MEDIUM_VIEWPORT_WIDTH": 664,
    "MODAL_PARTIAL_MEDIUM_VIEWPORT_HORIZONTAL_PADDING_SIZE": 32,
    "MODAL_PARTIAL_MEDIUM_VIEWPORT_HORIZONTAL_SCREEN_BUFFER_SIZE": 24,
    "MODAL_PARTIAL_MEDIUM_VIEWPORT_VERTICAL_PADDING_SIZE": 32,
    "MODAL_PARTIAL_MEDIUM_VIEWPORT_VERTICAL_SCREEN_BUFFER_SIZE": 24,
    "MODAL_PARTIAL_WIDE_VIEWPORT_ANIMATION_DURATION": 500,
    "MODAL_PARTIAL_WIDE_VIEWPORT_WIDTH": 664,
    "MODAL_PARTIAL_WIDE_VIEWPORT_HORIZONTAL_PADDING_SIZE": 32,
    "MODAL_PARTIAL_WIDE_VIEWPORT_HORIZONTAL_SCREEN_BUFFER_SIZE": 24,
    "MODAL_PARTIAL_WIDE_VIEWPORT_VERTICAL_PADDING_SIZE": 32,
    "MODAL_PARTIAL_WIDE_VIEWPORT_VERTICAL_SCREEN_BUFFER_SIZE": 24,
    "MODAL_PARTIAL_COMPACT_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 32,
    "MODAL_PARTIAL_REGULAR_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 32,
    "MODAL_PARTIAL_WIDE_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 32,
    "MODAL_PARTIAL_COMPACT_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 24,
    "MODAL_PARTIAL_REGULAR_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 24,
    "MODAL_PARTIAL_MAXIMUM_WIDTH_SIZE": 664,
    "MODAL_PARTIAL_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "MODAL_POPOVER_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "MODAL_POPOVER_BACKGROUND_DARK_MODE_COLOR": "rgb(45, 45, 45)",
    "MODAL_POPOVER_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "MODAL_POPOVER_BORDER_RADIUS": 6,
    "MODAL_POPOVER_APPEAR_ANIMATION_PERCENTAGE": 70,
    "MODAL_POPOVER_WIDE_VIEWPORT_PADDING_LEFT_SIZE": 24,
    "MODAL_POPOVER_WIDE_VIEWPORT_PADDING_TOP_SIZE": 8,
    "MODAL_POPOVER_WIDE_VIEWPORT_PADDING_RIGHT_SIZE": 24,
    "MODAL_POPOVER_WIDE_VIEWPORT_PADDING_BOTTOM_SIZE": 8,
    "MODAL_POPOVER_WIDE_VIEWPORT_MAX_HEIGHT_SIZE": 500,
    "MODAL_POPOVER_WIDE_VIEWPORT_MIN_WIDTH_SIZE": 200,
    "MODAL_POPOVER_COMPACT_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 16,
    "MODAL_POPOVER_REGULAR_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 16,
    "MODAL_POPOVER_WIDE_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 16,
    "MODAL_POPOVER_COMPACT_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 16,
    "MODAL_POPOVER_REGULAR_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 16,
    "MODAL_SHEET_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "MODAL_SHEET_BACKGROUND_DARK_MODE_COLOR": "rgb(28, 28, 28)",
    "MODAL_SHEET_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "MODAL_SHEET_BORDER_RADIUS": 12,
    "MODAL_SHEET_NARROW_VIEWPORT_PADDING_LEFT_SIZE": 16,
    "MODAL_SHEET_NARROW_VIEWPORT_PADDING_TOP_SIZE": 16,
    "MODAL_SHEET_NARROW_VIEWPORT_PADDING_RIGHT_SIZE": 16,
    "MODAL_SHEET_NARROW_VIEWPORT_PADDING_BOTTOM_SIZE": 16,
    "MODAL_SHEET_WIDE_VIEWPORT_PADDING_LEFT_SIZE": 32,
    "MODAL_SHEET_WIDE_VIEWPORT_PADDING_TOP_SIZE": 32,
    "MODAL_SHEET_WIDE_VIEWPORT_PADDING_RIGHT_SIZE": 32,
    "MODAL_SHEET_WIDE_VIEWPORT_PADDING_BOTTOM_SIZE": 32,
    "MODAL_SHEET_HANDLE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "MODAL_SHEET_HANDLE_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "MODAL_SHEET_HANDLE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.15)",
    "MODAL_SHEET_HANDLE_TOP_BUFFER_SIZE": 10,
    "MODAL_SHEET_HANDLE_WIDTH": 40,
    "MODAL_SHEET_HANDLE_HEIGHT": 4,
    "MODAL_SHEET_HANDLE_BORDER_RADIUS": 2,
    "MODAL_SHEET_COMPACT_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 16,
    "MODAL_SHEET_REGULAR_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 24,
    "MODAL_SHEET_WIDE_HORIZONTAL_SIZE_CLASS_HORIZONTAL_PADDING": 24,
    "MODAL_SHEET_COMPACT_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 16,
    "MODAL_SHEET_REGULAR_VERTICAL_SIZE_CLASS_VERTICAL_PADDING": 24,
    "PAGE_INDICATOR_DOT_SIZE": 6,
    "PAGE_INDICATOR_DOT_COLOR": "rgba(0, 0, 0, 0.55)",
    "PAGE_INDICATOR_SELECTED_SIZE": 8,
    "PAGE_INDICATOR_SELECTED_COLOR": "rgb(0, 106, 255)",
    "PAGE_INDICATOR_SPACING_SIZE": 6,
    "PAGE_INDICATOR_LIGHT_MODE_DOT_COLOR": "rgba(0, 0, 0, 0.55)",
    "PAGE_INDICATOR_LIGHT_MODE_SELECTED_COLOR": "rgb(0, 106, 255)",
    "PAGE_INDICATOR_DARK_MODE_DOT_COLOR": "rgba(255, 255, 255, 0.55)",
    "PAGE_INDICATOR_DARK_MODE_SELECTED_COLOR": "rgb(0, 106, 255)",
    "PAGINATION_NAV_VERTICAL_MARGIN": 16,
    "PAGINATION_NAV_HORIZONTAL_MARGIN": 8,
    "PAGINATION_NAV_CONTENT_SPACING": 8,
    "PILL_NORMAL_SIZE_TEXT_SIZE": 14,
    "PILL_NORMAL_SIZE_TEXT_LEADING": 22,
    "PILL_NORMAL_SIZE_TEXT_TRACKING": 0,
    "PILL_NORMAL_SIZE_TEXT_WEIGHT": 600,
    "PILL_NORMAL_SIZE_TEXT_CASE": "regular",
    "PILL_NORMAL_SIZE_TEXT_NUMBER_SPACING": "default",
    "PILL_NORMAL_SIZE_TEXT_SCALE": "paragraph-20",
    "PILL_NORMAL_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "PILL_NORMAL_SIZE_PADDING_HORIZONTAL_SIZE": 12,
    "PILL_NORMAL_SIZE_PADDING_VERTICAL_SIZE": 5,
    "PILL_NORMAL_SIZE_ICON_LEFT_PADDING": 8,
    "PILL_NORMAL_SIZE_TEXT_EDGE_PADDING": 12,
    "PILL_NORMAL_SIZE_CORNER_RADIUS": 100,
    "PILL_NORMAL_SIZE_ICON_DOT_RADIUS": 5,
    "PILL_NORMAL_SIZE_ICON_SIZE": 16,
    "PILL_NORMAL_SIZE_SPACING_HORIZONTAL": 8,
    "PILL_NORMAL_SIZE_ICON_TO_TEXT_SPACING": 4,
    "PILL_COMPACT_SIZE_TEXT_SIZE": 12,
    "PILL_COMPACT_SIZE_TEXT_LEADING": 18,
    "PILL_COMPACT_SIZE_TEXT_TRACKING": 0,
    "PILL_COMPACT_SIZE_TEXT_WEIGHT": 600,
    "PILL_COMPACT_SIZE_TEXT_CASE": "regular",
    "PILL_COMPACT_SIZE_TEXT_NUMBER_SPACING": "default",
    "PILL_COMPACT_SIZE_TEXT_SCALE": "paragraph-10",
    "PILL_COMPACT_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "PILL_COMPACT_SIZE_PADDING_HORIZONTAL_SIZE": 8,
    "PILL_COMPACT_SIZE_PADDING_VERTICAL_SIZE": 3,
    "PILL_COMPACT_SIZE_ICON_LEFT_PADDING": 4,
    "PILL_COMPACT_SIZE_TEXT_EDGE_PADDING": 8,
    "PILL_COMPACT_SIZE_ICON_DOT_RADIUS": 4,
    "PILL_COMPACT_SIZE_ICON_SIZE": 16,
    "PILL_COMPACT_SIZE_SPACING_HORIZONTAL": 6,
    "PILL_COMPACT_SIZE_ICON_TO_TEXT_SPACING": 3,
    "PILL_NORMAL_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "PILL_NORMAL_VARIANT_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "PILL_NORMAL_VARIANT_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "PILL_NORMAL_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "PILL_NORMAL_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "PILL_NORMAL_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "PILL_NORMAL_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "PILL_NORMAL_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "PILL_NORMAL_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.15)",
    "PILL_NORMAL_VARIANT_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "PILL_NORMAL_VARIANT_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "PILL_NORMAL_VARIANT_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "PILL_NORMAL_VARIANT_ICON_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "PILL_NORMAL_VARIANT_ICON_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "PILL_NORMAL_VARIANT_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "PILL_EMPHASIS_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "PILL_EMPHASIS_VARIANT_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "PILL_EMPHASIS_VARIANT_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "PILL_EMPHASIS_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "PILL_EMPHASIS_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "PILL_EMPHASIS_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "PILL_EMPHASIS_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "PILL_EMPHASIS_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "PILL_EMPHASIS_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "PILL_EMPHASIS_VARIANT_TEXT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "PILL_EMPHASIS_VARIANT_TEXT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "PILL_EMPHASIS_VARIANT_TEXT_COLOR": "rgb(0, 90, 217)",
    "PILL_EMPHASIS_VARIANT_ICON_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "PILL_EMPHASIS_VARIANT_ICON_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "PILL_EMPHASIS_VARIANT_ICON_COLOR": "rgb(0, 106, 255)",
    "PILL_SUCCESS_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "rgb(229, 255, 238)",
    "PILL_SUCCESS_VARIANT_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 51, 17)",
    "PILL_SUCCESS_VARIANT_BACKGROUND_COLOR": "rgb(229, 255, 238)",
    "PILL_SUCCESS_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(229, 255, 238)",
    "PILL_SUCCESS_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 51, 17)",
    "PILL_SUCCESS_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "rgb(229, 255, 238)",
    "PILL_SUCCESS_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(204, 255, 221)",
    "PILL_SUCCESS_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 89, 30)",
    "PILL_SUCCESS_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 255, 221)",
    "PILL_SUCCESS_VARIANT_TEXT_LIGHT_MODE_COLOR": "rgb(0, 125, 42)",
    "PILL_SUCCESS_VARIANT_TEXT_DARK_MODE_COLOR": "rgb(22, 217, 86)",
    "PILL_SUCCESS_VARIANT_TEXT_COLOR": "rgb(0, 125, 42)",
    "PILL_SUCCESS_VARIANT_ICON_LIGHT_MODE_COLOR": "rgb(0, 178, 59)",
    "PILL_SUCCESS_VARIANT_ICON_DARK_MODE_COLOR": "rgb(0, 179, 59)",
    "PILL_SUCCESS_VARIANT_ICON_COLOR": "rgb(0, 178, 59)",
    "PILL_WARNING_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 242, 230)",
    "PILL_WARNING_VARIANT_BACKGROUND_DARK_MODE_COLOR": "rgb(51, 26, 0)",
    "PILL_WARNING_VARIANT_BACKGROUND_COLOR": "rgb(255, 242, 230)",
    "PILL_WARNING_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 242, 230)",
    "PILL_WARNING_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(51, 26, 0)",
    "PILL_WARNING_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "rgb(255, 242, 230)",
    "PILL_WARNING_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 230, 204)",
    "PILL_WARNING_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(89, 45, 0)",
    "PILL_WARNING_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "rgb(255, 230, 204)",
    "PILL_WARNING_VARIANT_TEXT_LIGHT_MODE_COLOR": "rgb(148, 92, 37)",
    "PILL_WARNING_VARIANT_TEXT_DARK_MODE_COLOR": "rgb(255, 159, 64)",
    "PILL_WARNING_VARIANT_TEXT_COLOR": "rgb(148, 92, 37)",
    "PILL_WARNING_VARIANT_ICON_LIGHT_MODE_COLOR": "rgb(255, 159, 64)",
    "PILL_WARNING_VARIANT_ICON_DARK_MODE_COLOR": "rgb(255, 159, 64)",
    "PILL_WARNING_VARIANT_ICON_COLOR": "rgb(255, 159, 64)",
    "PILL_CRITICAL_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 229, 234)",
    "PILL_CRITICAL_VARIANT_BACKGROUND_DARK_MODE_COLOR": "rgb(51, 0, 9)",
    "PILL_CRITICAL_VARIANT_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "PILL_CRITICAL_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 229, 234)",
    "PILL_CRITICAL_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(51, 0, 9)",
    "PILL_CRITICAL_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "PILL_CRITICAL_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 204, 213)",
    "PILL_CRITICAL_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(89, 0, 15)",
    "PILL_CRITICAL_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "rgb(255, 204, 213)",
    "PILL_CRITICAL_VARIANT_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "PILL_CRITICAL_VARIANT_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "PILL_CRITICAL_VARIANT_TEXT_COLOR": "rgb(191, 0, 32)",
    "PILL_CRITICAL_VARIANT_ICON_LIGHT_MODE_COLOR": "rgb(204, 0, 35)",
    "PILL_CRITICAL_VARIANT_ICON_DARK_MODE_COLOR": "rgb(204, 0, 35)",
    "PILL_CRITICAL_VARIANT_ICON_COLOR": "rgb(204, 0, 35)",
    "PILL_INSIGHT_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "rgb(244, 230, 255)",
    "PILL_INSIGHT_VARIANT_BACKGROUND_DARK_MODE_COLOR": "rgb(30, 0, 51)",
    "PILL_INSIGHT_VARIANT_BACKGROUND_COLOR": "rgb(244, 230, 255)",
    "PILL_INSIGHT_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(244, 230, 255)",
    "PILL_INSIGHT_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(30, 0, 51)",
    "PILL_INSIGHT_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "rgb(244, 230, 255)",
    "PILL_INSIGHT_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(234, 204, 255)",
    "PILL_INSIGHT_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(52, 0, 89)",
    "PILL_INSIGHT_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "rgb(234, 204, 255)",
    "PILL_INSIGHT_VARIANT_TEXT_LIGHT_MODE_COLOR": "rgb(135, 22, 217)",
    "PILL_INSIGHT_VARIANT_TEXT_DARK_MODE_COLOR": "rgb(194, 110, 255)",
    "PILL_INSIGHT_VARIANT_TEXT_COLOR": "rgb(135, 22, 217)",
    "PILL_INSIGHT_VARIANT_ICON_LIGHT_MODE_COLOR": "rgb(135, 22, 217)",
    "PILL_INSIGHT_VARIANT_ICON_DARK_MODE_COLOR": "rgb(135, 22, 217)",
    "PILL_INSIGHT_VARIANT_ICON_COLOR": "rgb(135, 22, 217)",
    "PILL_ALPHA_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 230, 249)",
    "PILL_ALPHA_VARIANT_BACKGROUND_DARK_MODE_COLOR": "rgb(51, 0, 38)",
    "PILL_ALPHA_VARIANT_BACKGROUND_COLOR": "rgb(255, 230, 249)",
    "PILL_ALPHA_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 230, 249)",
    "PILL_ALPHA_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(51, 0, 38)",
    "PILL_ALPHA_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "rgb(255, 230, 249)",
    "PILL_ALPHA_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 204, 242)",
    "PILL_ALPHA_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(89, 0, 67)",
    "PILL_ALPHA_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "rgb(255, 204, 242)",
    "PILL_ALPHA_VARIANT_TEXT_LIGHT_MODE_COLOR": "rgb(168, 42, 136)",
    "PILL_ALPHA_VARIANT_TEXT_DARK_MODE_COLOR": "rgb(255, 67, 208)",
    "PILL_ALPHA_VARIANT_TEXT_COLOR": "rgb(168, 42, 136)",
    "PILL_ALPHA_VARIANT_ICON_LIGHT_MODE_COLOR": "rgb(217, 54, 176)",
    "PILL_ALPHA_VARIANT_ICON_DARK_MODE_COLOR": "rgb(217, 54, 176)",
    "PILL_ALPHA_VARIANT_ICON_COLOR": "rgb(217, 54, 176)",
    "PILL_BETA_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 255, 249)",
    "PILL_BETA_VARIANT_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 51, 38)",
    "PILL_BETA_VARIANT_BACKGROUND_COLOR": "rgb(230, 255, 249)",
    "PILL_BETA_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 255, 249)",
    "PILL_BETA_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 51, 38)",
    "PILL_BETA_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "rgb(230, 255, 249)",
    "PILL_BETA_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(204, 255, 242)",
    "PILL_BETA_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 89, 67)",
    "PILL_BETA_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 255, 242)",
    "PILL_BETA_VARIANT_TEXT_LIGHT_MODE_COLOR": "rgb(12, 120, 93)",
    "PILL_BETA_VARIANT_TEXT_DARK_MODE_COLOR": "rgb(22, 216, 167)",
    "PILL_BETA_VARIANT_TEXT_COLOR": "rgb(12, 120, 93)",
    "PILL_BETA_VARIANT_ICON_LIGHT_MODE_COLOR": "rgb(18, 191, 148)",
    "PILL_BETA_VARIANT_ICON_DARK_MODE_COLOR": "rgb(18, 191, 148)",
    "PILL_BETA_VARIANT_ICON_COLOR": "rgb(18, 191, 148)",
    "QRCODE_NORMAL_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "QRCODE_NORMAL_VARIANT_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "QRCODE_NORMAL_VARIANT_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "QRCODE_NORMAL_VARIANT_FOREGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "QRCODE_NORMAL_VARIANT_FOREGROUND_DARK_MODE_COLOR": "rgb(255, 255, 255)",
    "QRCODE_NORMAL_VARIANT_FOREGROUND_COLOR": "rgba(0, 0, 0, 0.9)",
    "QRCODE_NORMAL_VARIANT_ICON_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "QRCODE_NORMAL_VARIANT_ICON_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "QRCODE_NORMAL_VARIANT_ICON_COLOR": "rgb(0, 106, 255)",
    "QRCODE_MONOCHROME_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "QRCODE_MONOCHROME_VARIANT_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "QRCODE_MONOCHROME_VARIANT_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "QRCODE_MONOCHROME_VARIANT_FOREGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "QRCODE_MONOCHROME_VARIANT_FOREGROUND_DARK_MODE_COLOR": "rgb(255, 255, 255)",
    "QRCODE_MONOCHROME_VARIANT_FOREGROUND_COLOR": "rgba(0, 0, 0, 0.9)",
    "QRCODE_MONOCHROME_VARIANT_ICON_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "QRCODE_MONOCHROME_VARIANT_ICON_DARK_MODE_COLOR": "rgb(255, 255, 255)",
    "QRCODE_MONOCHROME_VARIANT_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_SIZE": 48,
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_LEADING": 56,
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_TRACKING": 0,
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_WEIGHT": 500,
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_CASE": "regular",
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_NUMBER_SPACING": "monospaced",
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_SCALE": "heading-30",
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_FONT_FAMILY": "Square Sans Display",
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_COLOR": "rgba(0, 0, 0, 0.3)",
    "QUANTITY_INPUT_FIELD_VALUE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "RADIO_WIDTH": 20,
    "RADIO_HEIGHT": 20,
    "RADIO_BORDER_RADIUS": 100,
    "RADIO_BORDER_SIZE": 2,
    "RADIO_SVG_RADIUS": 3,
    "RADIO_LIGHT_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "RADIO_DARK_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "RADIO_FOCUS_RING_BUFFER_SIZE": 2,
    "RADIO_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0.3)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(255, 255, 255, 0.3)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.3)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "rgb(0, 106, 255)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(204, 0, 35)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(204, 0, 35)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "rgb(204, 0, 35)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "rgb(204, 0, 35)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "rgb(178, 0, 30)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 85, 204)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 85, 204)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "rgb(0, 85, 204)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "rgb(0, 85, 204)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(153, 0, 26)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(153, 0, 26)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "rgb(153, 0, 26)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "rgb(153, 0, 26)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "rgb(0, 95, 229)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(178, 0, 30)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "rgb(178, 0, 30)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "rgb(178, 0, 30)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.03)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0.03)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.05)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(255, 255, 255, 0.05)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.03)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.03)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.3)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.3)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "rgb(255, 255, 255)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.3)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_ICON_COLOR": "rgb(255, 255, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_MINIMUM_HEIGHT": 32,
    "RICH_TEXT_TOOLBAR_BUTTON_WIDTH_MULTIPLIER": 1,
    "RICH_TEXT_TOOLBAR_BUTTON_PADDING_SIZE": 4,
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_ICON_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_ICON_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_HOVER_STATE_ICON_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_HOVER_STATE_ICON_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_HOVER_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_ICON_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_ICON_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_ICON_COLOR": "rgb(0, 90, 217)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_FOCUS_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_FOCUS_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_FOCUS_STATE_ICON_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_FOCUS_STATE_ICON_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_FOCUS_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_ICON_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_ICON_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "RICH_TEXT_TOOLBAR_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_NORMAL_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_NORMAL_STATE_ICON_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_NORMAL_STATE_ICON_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_NORMAL_STATE_ICON_COLOR": "rgb(0, 90, 217)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_HOVER_STATE_ICON_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_HOVER_STATE_ICON_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_HOVER_STATE_ICON_COLOR": "rgb(0, 90, 217)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_PRESSED_STATE_ICON_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_PRESSED_STATE_ICON_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_PRESSED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_FOCUS_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_FOCUS_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_FOCUS_STATE_ICON_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_FOCUS_STATE_ICON_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_FOCUS_STATE_ICON_COLOR": "rgb(0, 90, 217)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_DISABLED_STATE_ICON_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_DISABLED_STATE_ICON_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "RICH_TEXT_TOOLBAR_BUTTON_SELECTED_VALUE_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "RICH_TEXT_TOOLBAR_DIVIDER_VERTICAL_PADDING": 0,
    "RICH_TEXT_TOOLBAR_SPACING_HORIZONTAL": 12,
    "RICH_TEXT_TOOLBAR_PADDING_VERTICAL": 4,
    "RICH_TEXT_TOOLBAR_PADDING_HORIZONTAL": 4,
    "RICH_TEXT_TOOLBAR_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.03)",
    "RICH_TEXT_TOOLBAR_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.05)",
    "RICH_TEXT_TOOLBAR_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.03)",
    "RICH_TEXT_LINK_EDIT_POPOVER_SPACING_VERTICAL": 16,
    "ROW_LIGHT_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "ROW_DARK_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "ROW_BACKGROUND_RADIUS": 6,
    "ROW_BACKGROUND_HORIZONTAL_OUTSET_PADDING": 12,
    "ROW_BACKGROUND_VERTICAL_OUTSET_PADDING": 0,
    "ROW_SEPARATOR_HEIGHT": 1,
    "ROW_NORMAL_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_NORMAL_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_NORMAL_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_NORMAL_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ROW_NORMAL_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_HOVER_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_HOVER_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_HOVER_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_HOVER_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_HOVER_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_HOVER_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_HOVER_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_HOVER_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_HOVER_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_HOVER_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_HOVER_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_HOVER_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_HOVER_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_HOVER_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_HOVER_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_HOVER_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_HOVER_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_HOVER_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_HOVER_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_HOVER_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_HOVER_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "ROW_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "ROW_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ROW_PRESSED_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_PRESSED_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_PRESSED_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_PRESSED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_PRESSED_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_PRESSED_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_PRESSED_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_PRESSED_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_PRESSED_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_PRESSED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_PRESSED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_PRESSED_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_PRESSED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_PRESSED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_PRESSED_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_PRESSED_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_PRESSED_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_PRESSED_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_PRESSED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_PRESSED_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_PRESSED_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "ROW_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "ROW_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "ROW_SELECTED_STATE_TEXT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ROW_SELECTED_STATE_TEXT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ROW_SELECTED_STATE_TEXT_COLOR": "rgb(0, 90, 217)",
    "ROW_SELECTED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ROW_SELECTED_STATE_SUBTEXT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ROW_SELECTED_STATE_SUBTEXT_COLOR": "rgb(0, 90, 217)",
    "ROW_SELECTED_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ROW_SELECTED_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ROW_SELECTED_STATE_TERTIARY_TEXT_COLOR": "rgb(0, 90, 217)",
    "ROW_SELECTED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ROW_SELECTED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ROW_SELECTED_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgb(0, 90, 217)",
    "ROW_SELECTED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ROW_SELECTED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ROW_SELECTED_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgb(0, 90, 217)",
    "ROW_SELECTED_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_SELECTED_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_SELECTED_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_SELECTED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_SELECTED_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_SELECTED_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_SELECTED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "ROW_SELECTED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "ROW_SELECTED_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ROW_FOCUS_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_FOCUS_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_FOCUS_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_FOCUS_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_FOCUS_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_FOCUS_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_FOCUS_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_FOCUS_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_FOCUS_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_FOCUS_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_FOCUS_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_FOCUS_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_FOCUS_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_FOCUS_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_FOCUS_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_FOCUS_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_FOCUS_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_FOCUS_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_FOCUS_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_FOCUS_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_FOCUS_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_FOCUS_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "ROW_FOCUS_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "ROW_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ROW_DISABLED_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DISABLED_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_DISABLED_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DISABLED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DISABLED_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_DISABLED_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DISABLED_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DISABLED_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_DISABLED_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DISABLED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DISABLED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_DISABLED_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DISABLED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DISABLED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_DISABLED_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DISABLED_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "ROW_DISABLED_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "ROW_DISABLED_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.15)",
    "ROW_DISABLED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_DISABLED_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ROW_DISABLED_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_DISABLED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DISABLED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DISABLED_STATE_IMAGE_OPACITY": 0.4,
    "ROW_DISABLED_STATE_LEADING_ACCESSORY_OPACITY": 0.4,
    "ROW_HORIZONTAL_SPACING": 12,
    "ROW_TEXT_ACCESSORY_SPACING": 8,
    "ROW_MEDIUM_SIZE_TEXT_SIZE": 16,
    "ROW_MEDIUM_SIZE_TEXT_LEADING": 24,
    "ROW_MEDIUM_SIZE_TEXT_TRACKING": 0,
    "ROW_MEDIUM_SIZE_TEXT_WEIGHT": 500,
    "ROW_MEDIUM_SIZE_TEXT_CASE": "regular",
    "ROW_MEDIUM_SIZE_TEXT_NUMBER_SPACING": "default",
    "ROW_MEDIUM_SIZE_TEXT_SCALE": "paragraph-30",
    "ROW_MEDIUM_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "ROW_MEDIUM_SIZE_TEXT_VERTICAL_SPACING": 2,
    "ROW_MEDIUM_SIZE_SUBTEXT_SIZE": 14,
    "ROW_MEDIUM_SIZE_SUBTEXT_LEADING": 22,
    "ROW_MEDIUM_SIZE_SUBTEXT_TRACKING": 0,
    "ROW_MEDIUM_SIZE_SUBTEXT_WEIGHT": 400,
    "ROW_MEDIUM_SIZE_SUBTEXT_CASE": "regular",
    "ROW_MEDIUM_SIZE_SUBTEXT_NUMBER_SPACING": "default",
    "ROW_MEDIUM_SIZE_SUBTEXT_SCALE": "paragraph-20",
    "ROW_MEDIUM_SIZE_SUBTEXT_FONT_FAMILY": "Square Sans Text",
    "ROW_MEDIUM_SIZE_TERTIARY_TEXT_SIZE": 14,
    "ROW_MEDIUM_SIZE_TERTIARY_TEXT_LEADING": 22,
    "ROW_MEDIUM_SIZE_TERTIARY_TEXT_TRACKING": 0,
    "ROW_MEDIUM_SIZE_TERTIARY_TEXT_WEIGHT": 400,
    "ROW_MEDIUM_SIZE_TERTIARY_TEXT_CASE": "regular",
    "ROW_MEDIUM_SIZE_TERTIARY_TEXT_NUMBER_SPACING": "default",
    "ROW_MEDIUM_SIZE_TERTIARY_TEXT_SCALE": "paragraph-20",
    "ROW_MEDIUM_SIZE_TERTIARY_TEXT_FONT_FAMILY": "Square Sans Text",
    "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_SIZE": 16,
    "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_LEADING": 24,
    "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_TRACKING": 0,
    "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_WEIGHT": 400,
    "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_CASE": "regular",
    "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_NUMBER_SPACING": "default",
    "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_SCALE": "paragraph-30",
    "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_FONT_FAMILY": "Square Sans Text",
    "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_SIZE": 14,
    "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_LEADING": 22,
    "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_TRACKING": 0,
    "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_WEIGHT": 400,
    "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_CASE": "regular",
    "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_NUMBER_SPACING": "default",
    "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_SCALE": "paragraph-20",
    "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_FONT_FAMILY": "Square Sans Text",
    "ROW_MEDIUM_SIZE_VERTICAL_PADDING": 16,
    "ROW_MEDIUM_SIZE_CARET_ICON_ASSET": "chevron-right",
    "ROW_MEDIUM_SIZE_CARET_ICON_WIDTH": 16,
    "ROW_MEDIUM_SIZE_CARET_ICON_HEIGHT": 16,
    "ROW_MEDIUM_SIZE_CARET_ICON_TINTABLE": true,
    "ROW_SMALL_SIZE_TEXT_SIZE": 14,
    "ROW_SMALL_SIZE_TEXT_LEADING": 22,
    "ROW_SMALL_SIZE_TEXT_TRACKING": 0,
    "ROW_SMALL_SIZE_TEXT_WEIGHT": 600,
    "ROW_SMALL_SIZE_TEXT_CASE": "regular",
    "ROW_SMALL_SIZE_TEXT_NUMBER_SPACING": "default",
    "ROW_SMALL_SIZE_TEXT_SCALE": "paragraph-20",
    "ROW_SMALL_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "ROW_SMALL_SIZE_TEXT_VERTICAL_SPACING": 2,
    "ROW_SMALL_SIZE_SUBTEXT_SIZE": 12,
    "ROW_SMALL_SIZE_SUBTEXT_LEADING": 18,
    "ROW_SMALL_SIZE_SUBTEXT_TRACKING": 0,
    "ROW_SMALL_SIZE_SUBTEXT_WEIGHT": 400,
    "ROW_SMALL_SIZE_SUBTEXT_CASE": "regular",
    "ROW_SMALL_SIZE_SUBTEXT_NUMBER_SPACING": "default",
    "ROW_SMALL_SIZE_SUBTEXT_SCALE": "paragraph-10",
    "ROW_SMALL_SIZE_SUBTEXT_FONT_FAMILY": "Square Sans Text",
    "ROW_SMALL_SIZE_TERTIARY_TEXT_SIZE": 12,
    "ROW_SMALL_SIZE_TERTIARY_TEXT_LEADING": 18,
    "ROW_SMALL_SIZE_TERTIARY_TEXT_TRACKING": 0,
    "ROW_SMALL_SIZE_TERTIARY_TEXT_WEIGHT": 400,
    "ROW_SMALL_SIZE_TERTIARY_TEXT_CASE": "regular",
    "ROW_SMALL_SIZE_TERTIARY_TEXT_NUMBER_SPACING": "default",
    "ROW_SMALL_SIZE_TERTIARY_TEXT_SCALE": "paragraph-10",
    "ROW_SMALL_SIZE_TERTIARY_TEXT_FONT_FAMILY": "Square Sans Text",
    "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_SIZE": 14,
    "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_LEADING": 22,
    "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_TRACKING": 0,
    "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_WEIGHT": 400,
    "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_CASE": "regular",
    "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_NUMBER_SPACING": "default",
    "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_SCALE": "paragraph-20",
    "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_FONT_FAMILY": "Square Sans Text",
    "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_SIZE": 12,
    "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_LEADING": 18,
    "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_TRACKING": 0,
    "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_WEIGHT": 400,
    "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_CASE": "regular",
    "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_NUMBER_SPACING": "default",
    "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_SCALE": "paragraph-10",
    "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_FONT_FAMILY": "Square Sans Text",
    "ROW_SMALL_SIZE_VERTICAL_PADDING": 9,
    "ROW_SMALL_SIZE_CARET_ICON_ASSET": "chevron-right",
    "ROW_SMALL_SIZE_CARET_ICON_WIDTH": 16,
    "ROW_SMALL_SIZE_CARET_ICON_HEIGHT": 16,
    "ROW_SMALL_SIZE_CARET_ICON_TINTABLE": true,
    "ROW_FOCUS_RING_BUFFER_SIZE": 2,
    "ROW_FOCUS_RING_BORDER_SIZE": 2,
    "ROW_FOCUS_RING_RADIUS": 6,
    "ROW_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "ROW_DESTRUCTIVE_VARIANT_LIGHT_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "ROW_DESTRUCTIVE_VARIANT_DARK_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "ROW_DESTRUCTIVE_VARIANT_BACKGROUND_RADIUS": 6,
    "ROW_DESTRUCTIVE_VARIANT_BACKGROUND_HORIZONTAL_OUTSET_PADDING": 12,
    "ROW_DESTRUCTIVE_VARIANT_BACKGROUND_VERTICAL_OUTSET_PADDING": 0,
    "ROW_DESTRUCTIVE_VARIANT_SEPARATOR_HEIGHT": 1,
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_TEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SUBTEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SUBTEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_TERTIARY_TEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_DRILL_LIGHT_MODE_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_DRILL_DARK_MODE_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_DRILL_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_TEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SUBTEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SUBTEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_TERTIARY_TEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_DRILL_LIGHT_MODE_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_DRILL_DARK_MODE_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_DRILL_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 229, 234)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(51, 0, 9)",
    "ROW_DESTRUCTIVE_VARIANT_HOVER_STATE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_TEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SUBTEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SUBTEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_TERTIARY_TEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_DRILL_LIGHT_MODE_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_DRILL_DARK_MODE_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_DRILL_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 204, 213)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(89, 0, 15)",
    "ROW_DESTRUCTIVE_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "rgb(255, 204, 213)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_TEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SUBTEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SUBTEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_TERTIARY_TEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_DRILL_LIGHT_MODE_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_DRILL_DARK_MODE_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_DRILL_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 229, 234)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(51, 0, 9)",
    "ROW_DESTRUCTIVE_VARIANT_SELECTED_STATE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_TEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SUBTEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SUBTEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_TERTIARY_TEXT_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgb(191, 0, 32)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_DRILL_LIGHT_MODE_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_DRILL_DARK_MODE_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_DRILL_COLOR": "rgb(178, 0, 30)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 229, 234)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(51, 0, 9)",
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_STATE_BACKGROUND_COLOR": "rgb(255, 229, 234)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.15)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_IMAGE_OPACITY": 0.4,
    "ROW_DESTRUCTIVE_VARIANT_DISABLED_STATE_LEADING_ACCESSORY_OPACITY": 0.4,
    "ROW_DESTRUCTIVE_VARIANT_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "ROW_NORMAL_VARIANT_LIGHT_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "ROW_NORMAL_VARIANT_DARK_MODE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "ROW_NORMAL_VARIANT_BACKGROUND_RADIUS": 6,
    "ROW_NORMAL_VARIANT_BACKGROUND_HORIZONTAL_OUTSET_PADDING": 12,
    "ROW_NORMAL_VARIANT_BACKGROUND_VERTICAL_OUTSET_PADDING": 0,
    "ROW_NORMAL_VARIANT_SEPARATOR_HEIGHT": 1,
    "ROW_NORMAL_VARIANT_NORMAL_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "ROW_NORMAL_VARIANT_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "ROW_NORMAL_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_TEXT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_TEXT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_TEXT_COLOR": "rgb(0, 90, 217)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SUBTEXT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SUBTEXT_COLOR": "rgb(0, 90, 217)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_TERTIARY_TEXT_COLOR": "rgb(0, 90, 217)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgb(0, 90, 217)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgb(0, 90, 217)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "ROW_NORMAL_VARIANT_SELECTED_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.9)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.55)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "ROW_NORMAL_VARIANT_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SUBTEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SUBTEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_TERTIARY_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_TERTIARY_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_TERTIARY_TEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SIDE_TEXT_PRIMARY_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SIDE_TEXT_SECONDARY_COLOR": "rgba(0, 0, 0, 0.3)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_DRILL_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_DRILL_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_DRILL_COLOR": "rgba(0, 0, 0, 0.15)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.05)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0)",
    "ROW_NORMAL_VARIANT_DISABLED_STATE_IMAGE_OPACITY": 0.4,
    "ROW_NORMAL_VARIANT_DISABLED_STATE_LEADING_ACCESSORY_OPACITY": 0.4,
    "ROW_NORMAL_VARIANT_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "SEGMENTED_CONTROL_BACKGROUND_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "SEGMENTED_CONTROL_BACKGROUND_NORMAL_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "SEGMENTED_CONTROL_BACKGROUND_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0.05)",
    "SEGMENTED_CONTROL_BACKGROUND_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "SEGMENTED_CONTROL_BACKGROUND_DISABLED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "SEGMENTED_CONTROL_BACKGROUND_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0.05)",
    "SEGMENTED_CONTROL_BACKGROUND_RADIUS": 6,
    "SEGMENTED_CONTROL_PADDING_HORIZONTAL": 4,
    "SEGMENTED_CONTROL_PADDING_VERTICAL": 4,
    "SEGMENTED_CONTROL_ANIMATION_DURATION": 330,
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_NORMAL_STATE_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_SELECTED_STATE_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_SELECTED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_SELECTED_STATE_COLOR": "rgb(255, 255, 255)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_HOVER_STATE_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_HOVER_STATE_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_HOVER_STATE_COLOR": "rgb(230, 240, 255)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_PRESSED_STATE_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_PRESSED_STATE_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_PRESSED_STATE_COLOR": "rgb(204, 225, 255)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_DISABLED_STATE_DARK_MODE_COLOR": "rgba(0, 0, 0, 0)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0)",
    "SEGMENTED_CONTROL_OPTION_BACKGROUND_RADIUS": 4,
    "SEGMENTED_CONTROL_OPTION_PADDING_HORIZONTAL": 8,
    "SEGMENTED_CONTROL_OPTION_PADDING_VERTICAL": 8,
    "SEGMENTED_CONTROL_OPTION_LABEL_SIZE": 16,
    "SEGMENTED_CONTROL_OPTION_LABEL_LEADING": 24,
    "SEGMENTED_CONTROL_OPTION_LABEL_TRACKING": 0,
    "SEGMENTED_CONTROL_OPTION_LABEL_WEIGHT": 600,
    "SEGMENTED_CONTROL_OPTION_LABEL_CASE": "regular",
    "SEGMENTED_CONTROL_OPTION_LABEL_NUMBER_SPACING": "default",
    "SEGMENTED_CONTROL_OPTION_LABEL_SCALE": "paragraph-30",
    "SEGMENTED_CONTROL_OPTION_LABEL_FONT_FAMILY": "Square Sans Text",
    "SEGMENTED_CONTROL_OPTION_LABEL_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "SEGMENTED_CONTROL_OPTION_LABEL_NORMAL_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "SEGMENTED_CONTROL_OPTION_LABEL_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "SEGMENTED_CONTROL_OPTION_LABEL_SELECTED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "SEGMENTED_CONTROL_OPTION_LABEL_SELECTED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "SEGMENTED_CONTROL_OPTION_LABEL_SELECTED_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "SEGMENTED_CONTROL_OPTION_LABEL_HOVER_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "SEGMENTED_CONTROL_OPTION_LABEL_HOVER_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "SEGMENTED_CONTROL_OPTION_LABEL_HOVER_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "SEGMENTED_CONTROL_OPTION_LABEL_PRESSED_STATE_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "SEGMENTED_CONTROL_OPTION_LABEL_PRESSED_STATE_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "SEGMENTED_CONTROL_OPTION_LABEL_PRESSED_STATE_COLOR": "rgb(0, 90, 217)",
    "SEGMENTED_CONTROL_OPTION_LABEL_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "SEGMENTED_CONTROL_OPTION_LABEL_DISABLED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "SEGMENTED_CONTROL_OPTION_LABEL_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0.3)",
    "SELECT_CARET_ICON_ASSET": "chevron-down",
    "SELECT_CARET_ICON_WIDTH": 16,
    "SELECT_CARET_ICON_HEIGHT": 16,
    "SELECT_CARET_ICON_TINTABLE": true,
    "SELECT_CARET_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "SELECT_CARET_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "SELECT_CARET_COLOR": "rgba(0, 0, 0, 0.3)",
    "STEPPER_BORDER_RADIUS": 6,
    "STEPPER_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "STEPPER_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(8, 8, 8)",
    "STEPPER_NORMAL_STATE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "STEPPER_NORMAL_STATE_BORDER_SIZE": 1,
    "STEPPER_NORMAL_STATE_NORMAL_VALIDITY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "STEPPER_NORMAL_STATE_NORMAL_VALIDITY_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "STEPPER_NORMAL_STATE_NORMAL_VALIDITY_COLOR": "rgba(0, 0, 0, 0.15)",
    "STEPPER_NORMAL_STATE_INVALID_VALIDITY_LIGHT_MODE_COLOR": "rgb(204, 0, 35)",
    "STEPPER_NORMAL_STATE_INVALID_VALIDITY_DARK_MODE_COLOR": "rgb(204, 0, 35)",
    "STEPPER_NORMAL_STATE_INVALID_VALIDITY_COLOR": "rgb(204, 0, 35)",
    "STEPPER_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "STEPPER_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(8, 8, 8)",
    "STEPPER_HOVER_STATE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "STEPPER_HOVER_STATE_BORDER_SIZE": 1,
    "STEPPER_HOVER_STATE_NORMAL_VALIDITY_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "STEPPER_HOVER_STATE_NORMAL_VALIDITY_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "STEPPER_HOVER_STATE_NORMAL_VALIDITY_COLOR": "rgb(0, 106, 255)",
    "STEPPER_HOVER_STATE_INVALID_VALIDITY_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "STEPPER_HOVER_STATE_INVALID_VALIDITY_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "STEPPER_HOVER_STATE_INVALID_VALIDITY_COLOR": "rgb(0, 106, 255)",
    "STEPPER_FOCUS_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "STEPPER_FOCUS_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(8, 8, 8)",
    "STEPPER_FOCUS_STATE_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "STEPPER_FOCUS_STATE_BORDER_SIZE": 2,
    "STEPPER_FOCUS_STATE_NORMAL_VALIDITY_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "STEPPER_FOCUS_STATE_NORMAL_VALIDITY_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "STEPPER_FOCUS_STATE_NORMAL_VALIDITY_COLOR": "rgb(0, 106, 255)",
    "STEPPER_FOCUS_STATE_INVALID_VALIDITY_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "STEPPER_FOCUS_STATE_INVALID_VALIDITY_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "STEPPER_FOCUS_STATE_INVALID_VALIDITY_COLOR": "rgb(0, 106, 255)",
    "STEPPER_DISABLED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "STEPPER_DISABLED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "STEPPER_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "STEPPER_DISABLED_STATE_BORDER_SIZE": 1,
    "STEPPER_DISABLED_STATE_BORDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "STEPPER_DISABLED_STATE_BORDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "STEPPER_DISABLED_STATE_BORDER_COLOR": "rgba(0, 0, 0, 0.05)",
    "STEPPER_PADDING_SIZE": 12,
    "STEPPER_HORIZONTAL_SPACING": 12,
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_SIZE": 16,
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_LEADING": 24,
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_TRACKING": 0,
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_WEIGHT": 400,
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_CASE": "regular",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_NUMBER_SPACING": "monospaced",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_SCALE": "paragraph-30",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_FONT_FAMILY": "Square Sans Text",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_NORMAL_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_NORMAL_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_NORMAL_STATE_COLOR": "rgba(0, 0, 0, 0.9)",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_DISABLED_STATE_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_DISABLED_STATE_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_DISABLED_STATE_COLOR": "rgba(0, 0, 0, 0.55)",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_COLOR": "rgba(0, 0, 0, 0.3)",
    "STEPPER_QUANTITY_INPUT_FIELD_MINIMUM_WIDTH_MULTIPLIER": 1.66,
    "STEPPER_BUTTON_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "STEPPER_BUTTON_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "STEPPER_BUTTON_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "STEPPER_BUTTON_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "STEPPER_BUTTON_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "STEPPER_BUTTON_NORMAL_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "STEPPER_BUTTON_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "STEPPER_BUTTON_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "STEPPER_BUTTON_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "STEPPER_BUTTON_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "STEPPER_BUTTON_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "STEPPER_BUTTON_HOVER_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "STEPPER_BUTTON_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "STEPPER_BUTTON_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "STEPPER_BUTTON_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "STEPPER_BUTTON_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "STEPPER_BUTTON_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "STEPPER_BUTTON_PRESSED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "STEPPER_BUTTON_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "STEPPER_BUTTON_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "STEPPER_BUTTON_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "STEPPER_BUTTON_FOCUS_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "STEPPER_BUTTON_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "STEPPER_BUTTON_FOCUS_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "STEPPER_BUTTON_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "STEPPER_BUTTON_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "STEPPER_BUTTON_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "STEPPER_BUTTON_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.3)",
    "STEPPER_BUTTON_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "STEPPER_BUTTON_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.3)",
    "STEPPER_BUTTON_BORDER_RADIUS": 4,
    "STEPPER_BUTTON_PADDING_SIZE": 4,
    "STEPPER_BUTTON_WIDTH_MULTIPLIER": 1,
    "STEPPER_BUTTON_MINIMUM_HEIGHT": 24,
    "STEPPER_BUTTON_INCREMENT_ICON_ASSET": "plus",
    "STEPPER_BUTTON_INCREMENT_ICON_WIDTH": 24,
    "STEPPER_BUTTON_INCREMENT_ICON_HEIGHT": 24,
    "STEPPER_BUTTON_INCREMENT_ICON_TINTABLE": true,
    "STEPPER_BUTTON_INCREMENT_WIDTH": 16,
    "STEPPER_BUTTON_INCREMENT_HEIGHT": 16,
    "STEPPER_BUTTON_INCREMENT_SCALE": "paragraph-20",
    "STEPPER_BUTTON_DECREMENT_ICON_ASSET": "minus",
    "STEPPER_BUTTON_DECREMENT_ICON_WIDTH": 24,
    "STEPPER_BUTTON_DECREMENT_ICON_HEIGHT": 24,
    "STEPPER_BUTTON_DECREMENT_ICON_TINTABLE": true,
    "STEPPER_BUTTON_DECREMENT_WIDTH": 16,
    "STEPPER_BUTTON_DECREMENT_HEIGHT": 16,
    "STEPPER_BUTTON_DECREMENT_SCALE": "paragraph-20",
    "STICKY_SECTION_HEADER_TEXT_SIZE": 14,
    "STICKY_SECTION_HEADER_TEXT_LEADING": 22,
    "STICKY_SECTION_HEADER_TEXT_TRACKING": 0,
    "STICKY_SECTION_HEADER_TEXT_WEIGHT": 700,
    "STICKY_SECTION_HEADER_TEXT_CASE": "regular",
    "STICKY_SECTION_HEADER_TEXT_NUMBER_SPACING": "default",
    "STICKY_SECTION_HEADER_TEXT_SCALE": "heading-10",
    "STICKY_SECTION_HEADER_TEXT_FONT_FAMILY": "Square Sans Text",
    "STICKY_SECTION_HEADER_TEXT_IS_HEADER": true,
    "STICKY_SECTION_HEADER_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "STICKY_SECTION_HEADER_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "STICKY_SECTION_HEADER_TEXT_COLOR": "rgba(0, 0, 0, 0.9)",
    "STICKY_SECTION_HEADER_TEXT_LINK_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "STICKY_SECTION_HEADER_TEXT_LINK_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "STICKY_SECTION_HEADER_TEXT_LINK_TEXT_SIZE": 14,
    "STICKY_SECTION_HEADER_TEXT_LINK_TEXT_LEADING": 22,
    "STICKY_SECTION_HEADER_TEXT_LINK_TEXT_TRACKING": 0,
    "STICKY_SECTION_HEADER_TEXT_LINK_TEXT_WEIGHT": 600,
    "STICKY_SECTION_HEADER_TEXT_LINK_TEXT_CASE": "regular",
    "STICKY_SECTION_HEADER_TEXT_LINK_TEXT_NUMBER_SPACING": "default",
    "STICKY_SECTION_HEADER_TEXT_LINK_TEXT_SCALE": "paragraph-20",
    "STICKY_SECTION_HEADER_TEXT_LINK_TEXT_FONT_FAMILY": "Square Sans Text",
    "STICKY_SECTION_HEADER_TEXT_LINK_VERTICAL_PADDING": 0,
    "STICKY_SECTION_HEADER_TEXT_LINK_NORMAL_STATE_OPACITY": 1,
    "STICKY_SECTION_HEADER_TEXT_LINK_HOVER_STATE_OPACITY": 0.6,
    "STICKY_SECTION_HEADER_TEXT_LINK_PRESSED_STATE_OPACITY": 0.6,
    "STICKY_SECTION_HEADER_TEXT_LINK_DISABLED_STATE_OPACITY": 0.3,
    "STICKY_SECTION_HEADER_TEXT_LINK_COLOR": "rgb(0, 90, 217)",
    "STICKY_SECTION_HEADER_VERTICAL_PADDING": 9,
    "STICKY_SECTION_HEADER_HORIZONTAL_SPACING": 8,
    "STICKY_SECTION_HEADER_BACKGROUND_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "STICKY_SECTION_HEADER_BACKGROUND_DARK_MODE_COLOR": "rgb(8, 8, 8)",
    "STICKY_SECTION_HEADER_BACKGROUND_COLOR": "rgb(255, 255, 255)",
    "STICKY_SECTION_HEADER_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "STICKY_SECTION_HEADER_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "STICKY_SECTION_HEADER_SEPARATOR_HEIGHT": 1,
    "STICKY_SECTION_HEADER_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.3)",
    "TABLE_CELL_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.03)",
    "TABLE_CELL_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.05)",
    "TABLE_CELL_HOVER_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.03)",
    "TABLE_CELL_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "TABLE_CELL_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "TABLE_CELL_PRESSED_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "TABLE_CELL_FOCUS_STATE_BACKGROUND_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.03)",
    "TABLE_CELL_FOCUS_STATE_BACKGROUND_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.05)",
    "TABLE_CELL_FOCUS_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.03)",
    "TABLE_CELL_DISABLED_STATE_TEXT_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "TABLE_CELL_DISABLED_STATE_TEXT_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "TABLE_CELL_DISABLED_STATE_TEXT_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_HORIZONTAL_SPACING": 4,
    "TAG_MINIMUM_WIDTH_MULTIPLIER": 1.5,
    "TAG_REMOVE_INDICATOR_ICON_ASSET": "x",
    "TAG_REMOVE_INDICATOR_ICON_WIDTH": 24,
    "TAG_REMOVE_INDICATOR_ICON_HEIGHT": 24,
    "TAG_REMOVE_INDICATOR_ICON_TINTABLE": true,
    "TAG_REMOVE_INDICATOR_WIDTH": 16,
    "TAG_REMOVE_INDICATOR_HEIGHT": 16,
    "TAG_REMOVE_INDICATOR_SCALE": "paragraph-10",
    "TAG_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "TAG_DISABLED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "TAG_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.3)",
    "TAG_DISABLED_STATE_DARK_MODE_REMOVE_INDICATOR_COLOR": "rgba(255, 255, 255, 0.15)",
    "TAG_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "TAG_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_DISABLED_STATE_LIGHT_MODE_REMOVE_INDICATOR_COLOR": "rgba(0, 0, 0, 0.15)",
    "TAG_DISABLED_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "TAG_DISABLED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_DISABLED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_DISABLED_STATE_REMOVE_INDICATOR_COLOR": "rgba(0, 0, 0, 0.15)",
    "TAG_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "TAG_FOCUS_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "TAG_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "TAG_FOCUS_STATE_DARK_MODE_REMOVE_INDICATOR_COLOR": "rgba(255, 255, 255, 0.3)",
    "TAG_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "TAG_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_FOCUS_STATE_LIGHT_MODE_REMOVE_INDICATOR_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_FOCUS_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "TAG_FOCUS_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_FOCUS_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_FOCUS_STATE_REMOVE_INDICATOR_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 21, 51)",
    "TAG_HOVER_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "TAG_HOVER_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "TAG_HOVER_STATE_DARK_MODE_REMOVE_INDICATOR_COLOR": "rgba(255, 255, 255, 0.3)",
    "TAG_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "TAG_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_HOVER_STATE_LIGHT_MODE_REMOVE_INDICATOR_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_HOVER_STATE_BACKGROUND_COLOR": "rgb(230, 240, 255)",
    "TAG_HOVER_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_HOVER_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_HOVER_STATE_REMOVE_INDICATOR_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "rgba(255, 255, 255, 0.08)",
    "TAG_NORMAL_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "TAG_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "TAG_NORMAL_STATE_DARK_MODE_REMOVE_INDICATOR_COLOR": "rgba(255, 255, 255, 0.3)",
    "TAG_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "TAG_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_NORMAL_STATE_LIGHT_MODE_REMOVE_INDICATOR_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_NORMAL_STATE_BACKGROUND_COLOR": "rgba(0, 0, 0, 0.05)",
    "TAG_NORMAL_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_NORMAL_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_NORMAL_STATE_REMOVE_INDICATOR_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "rgb(0, 37, 89)",
    "TAG_PRESSED_STATE_DARK_MODE_ICON_COLOR": "rgba(255, 255, 255, 0.95)",
    "TAG_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "rgba(255, 255, 255, 0.95)",
    "TAG_PRESSED_STATE_DARK_MODE_REMOVE_INDICATOR_COLOR": "rgba(255, 255, 255, 0.3)",
    "TAG_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "TAG_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_PRESSED_STATE_LIGHT_MODE_REMOVE_INDICATOR_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_PRESSED_STATE_BACKGROUND_COLOR": "rgb(204, 225, 255)",
    "TAG_PRESSED_STATE_ICON_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_PRESSED_STATE_LABEL_COLOR": "rgba(0, 0, 0, 0.9)",
    "TAG_PRESSED_STATE_REMOVE_INDICATOR_COLOR": "rgba(0, 0, 0, 0.3)",
    "TAG_TEXT_SIZE": 12,
    "TAG_TEXT_LEADING": 18,
    "TAG_TEXT_TRACKING": 0,
    "TAG_TEXT_WEIGHT": 400,
    "TAG_TEXT_CASE": "regular",
    "TAG_TEXT_NUMBER_SPACING": "default",
    "TAG_TEXT_SCALE": "paragraph-10",
    "TAG_TEXT_FONT_FAMILY": "Square Sans Text",
    "TAG_BASIC_FORMAT_LEFT_PADDING": 12,
    "TAG_BASIC_FORMAT_TOP_PADDING": 8,
    "TAG_BASIC_FORMAT_RIGHT_PADDING": 8,
    "TAG_BASIC_FORMAT_BOTTOM_PADDING": 8,
    "TAG_WITH_ICON_FORMAT_LEFT_PADDING": 8,
    "TAG_WITH_ICON_FORMAT_TOP_PADDING": 8,
    "TAG_WITH_ICON_FORMAT_RIGHT_PADDING": 8,
    "TAG_WITH_ICON_FORMAT_BOTTOM_PADDING": 8,
    "TEXT_LINK_GROUP_SEPARATOR_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "TEXT_LINK_GROUP_SEPARATOR_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "TEXT_LINK_GROUP_SEPARATOR_OPACITY": 0.3,
    "TEXT_LINK_GROUP_SEPARATOR_HEIGHT": 8,
    "TEXT_LINK_GROUP_SEPARATOR_WIDTH": 1,
    "TEXT_LINK_GROUP_SEPARATOR_COLOR": "rgba(0, 0, 0, 0.9)",
    "TEXT_LINK_GROUP_HORIZONTAL_SPACING": 12,
    "TEXT_LINK_GROUP_VERTICAL_SPACING": 0,
    "TEXT_LINK_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "TEXT_LINK_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "TEXT_LINK_SMALL_SIZE_TEXT_SIZE": 14,
    "TEXT_LINK_SMALL_SIZE_TEXT_LEADING": 22,
    "TEXT_LINK_SMALL_SIZE_TEXT_TRACKING": 0,
    "TEXT_LINK_SMALL_SIZE_TEXT_WEIGHT": 600,
    "TEXT_LINK_SMALL_SIZE_TEXT_CASE": "regular",
    "TEXT_LINK_SMALL_SIZE_TEXT_NUMBER_SPACING": "default",
    "TEXT_LINK_SMALL_SIZE_TEXT_SCALE": "paragraph-20",
    "TEXT_LINK_SMALL_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "TEXT_LINK_SMALL_SIZE_VERTICAL_PADDING": 9,
    "TEXT_LINK_MEDIUM_SIZE_TEXT_SIZE": 16,
    "TEXT_LINK_MEDIUM_SIZE_TEXT_LEADING": 24,
    "TEXT_LINK_MEDIUM_SIZE_TEXT_TRACKING": 0,
    "TEXT_LINK_MEDIUM_SIZE_TEXT_WEIGHT": 600,
    "TEXT_LINK_MEDIUM_SIZE_TEXT_CASE": "regular",
    "TEXT_LINK_MEDIUM_SIZE_TEXT_NUMBER_SPACING": "default",
    "TEXT_LINK_MEDIUM_SIZE_TEXT_SCALE": "paragraph-30",
    "TEXT_LINK_MEDIUM_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
    "TEXT_LINK_MEDIUM_SIZE_VERTICAL_PADDING": 12,
    "TEXT_LINK_NORMAL_STATE_OPACITY": 1,
    "TEXT_LINK_HOVER_STATE_OPACITY": 0.6,
    "TEXT_LINK_PRESSED_STATE_OPACITY": 0.6,
    "TEXT_LINK_DISABLED_STATE_OPACITY": 0.3,
    "TEXT_LINK_NORMAL_VARIANT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "TEXT_LINK_NORMAL_VARIANT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "TEXT_LINK_NORMAL_VARIANT_COLOR": "rgb(0, 90, 217)",
    "TEXT_LINK_DESTRUCTIVE_VARIANT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "TEXT_LINK_DESTRUCTIVE_VARIANT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "TEXT_LINK_DESTRUCTIVE_VARIANT_COLOR": "rgb(191, 0, 32)",
    "TEXT_LINK_COLOR": "rgb(0, 90, 217)",
    "TEXTAREA_FONT_SIZE": 16,
    "TEXTAREA_FONT_LEADING": 24,
    "TEXTAREA_FONT_TRACKING": 0,
    "TEXTAREA_FONT_WEIGHT": 400,
    "TEXTAREA_FONT_CASE": "regular",
    "TEXTAREA_FONT_NUMBER_SPACING": "default",
    "TEXTAREA_FONT_SCALE": "paragraph-30",
    "TEXTAREA_FONT_FONT_FAMILY": "Square Sans Text",
    "TEXTAREA_HEIGHT": 112,
    "TEXTAREA_MIN_HEIGHT": 112,
    "TEXTAREA_MINIMUM_HEIGHT": 112,
    "TEXTAREA_MAXIMUM_HEIGHT": 320,
    "TEXTAREA_PLACEHOLDER_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "TEXTAREA_PLACEHOLDER_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "TEXTAREA_PLACEHOLDER_COLOR": "rgba(0, 0, 0, 0.15)",
    "TOGGLE_WIDTH": 40,
    "TOGGLE_HEIGHT": 24,
    "TOGGLE_BORDER_RADIUS": 100,
    "TOGGLE_BORDER_SIZE": 2,
    "TOGGLE_PADDING_VERTICAL": 5,
    "TOGGLE_PADDING_HORIZONTAL": 5,
    "TOGGLE_FOCUS_RING_BUFFER_SIZE": 0,
    "TOGGLE_FOCUS_RING_BORDER_SIZE": 2,
    "TOGGLE_FOCUS_RING_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_FOCUS_RING_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0.3)",
    "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "rgba(0, 0, 0, 0.3)",
    "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(255, 255, 255, 0.3)",
    "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_DARK_MODE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_DARK_MODE_THUMB_COLOR": "rgba(255, 255, 255, 0.3)",
    "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.3)",
    "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_THUMB_COLOR": "rgba(0, 0, 0, 0.3)",
    "TOGGLE_NORMAL_STATE_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_NORMAL_STATE_SELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_NORMAL_STATE_SELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_NORMAL_STATE_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_NORMAL_STATE_SELECTED_VALUE_DARK_MODE_TRACK_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_NORMAL_STATE_SELECTED_VALUE_DARK_MODE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_NORMAL_STATE_SELECTED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_NORMAL_STATE_SELECTED_VALUE_TRACK_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_NORMAL_STATE_SELECTED_VALUE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_DARK_MODE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_DARK_MODE_THUMB_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_THUMB_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_HOVER_STATE_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_HOVER_STATE_SELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_HOVER_STATE_SELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_HOVER_STATE_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_HOVER_STATE_SELECTED_VALUE_DARK_MODE_TRACK_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_HOVER_STATE_SELECTED_VALUE_DARK_MODE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_HOVER_STATE_SELECTED_VALUE_BORDER_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_HOVER_STATE_SELECTED_VALUE_TRACK_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_HOVER_STATE_SELECTED_VALUE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_DARK_MODE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_DARK_MODE_THUMB_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_BORDER_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_THUMB_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_SELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_SELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_PRESSED_STATE_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_SELECTED_VALUE_DARK_MODE_TRACK_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_SELECTED_VALUE_DARK_MODE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_PRESSED_STATE_SELECTED_VALUE_BORDER_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_SELECTED_VALUE_TRACK_COLOR": "rgb(0, 85, 204)",
    "TOGGLE_PRESSED_STATE_SELECTED_VALUE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_DARK_MODE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_DARK_MODE_THUMB_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_BORDER_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_TRACK_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_THUMB_COLOR": "rgb(0, 106, 255)",
    "TOGGLE_FOCUS_STATE_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_FOCUS_STATE_SELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_FOCUS_STATE_SELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_FOCUS_STATE_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_FOCUS_STATE_SELECTED_VALUE_DARK_MODE_TRACK_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_FOCUS_STATE_SELECTED_VALUE_DARK_MODE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_FOCUS_STATE_SELECTED_VALUE_BORDER_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_FOCUS_STATE_SELECTED_VALUE_TRACK_COLOR": "rgb(0, 95, 229)",
    "TOGGLE_FOCUS_STATE_SELECTED_VALUE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0.03)",
    "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "rgba(0, 0, 0, 0.03)",
    "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "rgba(0, 0, 0, 0.15)",
    "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(255, 255, 255, 0.05)",
    "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_DARK_MODE_TRACK_COLOR": "rgba(255, 255, 255, 0.05)",
    "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_DARK_MODE_THUMB_COLOR": "rgba(255, 255, 255, 0.15)",
    "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0.03)",
    "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_TRACK_COLOR": "rgba(0, 0, 0, 0.03)",
    "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_THUMB_COLOR": "rgba(0, 0, 0, 0.15)",
    "TOGGLE_DISABLED_STATE_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_DISABLED_STATE_SELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "rgba(0, 0, 0, 0.3)",
    "TOGGLE_DISABLED_STATE_SELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_DISABLED_STATE_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_DISABLED_STATE_SELECTED_VALUE_DARK_MODE_TRACK_COLOR": "rgba(255, 255, 255, 0.3)",
    "TOGGLE_DISABLED_STATE_SELECTED_VALUE_DARK_MODE_THUMB_COLOR": "rgb(255, 255, 255)",
    "TOGGLE_DISABLED_STATE_SELECTED_VALUE_BORDER_COLOR": "rgba(0, 0, 0, 0)",
    "TOGGLE_DISABLED_STATE_SELECTED_VALUE_TRACK_COLOR": "rgba(0, 0, 0, 0.3)",
    "TOGGLE_DISABLED_STATE_SELECTED_VALUE_THUMB_COLOR": "rgb(255, 255, 255)",
    "CORE_ANIMATION_ENTER_TRANSITION_EASING": "cubic-bezier(0.26, 0.10, 0.48, 1.0)",
    "CORE_ANIMATION_ENTER_TRANSITION_FAST_SPEED_DURATION": 100,
    "CORE_ANIMATION_ENTER_TRANSITION_MODERATE_SPEED_DURATION": 240,
    "CORE_ANIMATION_ENTER_TRANSITION_SLOW_SPEED_DURATION": 400,
    "CORE_ANIMATION_EXIT_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
    "CORE_ANIMATION_EXIT_TRANSITION_FAST_SPEED_DURATION": 100,
    "CORE_ANIMATION_EXIT_TRANSITION_MODERATE_SPEED_DURATION": 160,
    "CORE_ANIMATION_EXIT_TRANSITION_SLOW_SPEED_DURATION": 300,
    "CORE_ANIMATION_MOVE_TRANSITION_EASING": "cubic-bezier(0.76, 0.0, 0.24, 1.0)",
    "CORE_ANIMATION_MOVE_TRANSITION_FAST_SPEED_DURATION": 100,
    "CORE_ANIMATION_MOVE_TRANSITION_MODERATE_SPEED_DURATION": 240,
    "CORE_ANIMATION_MOVE_TRANSITION_SLOW_SPEED_DURATION": 400,
    "CORE_BORDER_10": 1,
    "CORE_BREAKPOINT_EXTRA_WIDE_MIN_WIDTH": 1024,
    "CORE_BREAKPOINT_WIDE_MIN_WIDTH": 800,
    "CORE_BREAKPOINT_WIDE_MIN_MAX_WIDTH": 1023,
    "CORE_BREAKPOINT_MEDIUM_MIN_WIDTH": 600,
    "CORE_BREAKPOINT_MEDIUM_MAX_WIDTH": 839,
    "CORE_BREAKPOINT_NARROW_MIN_WIDTH": 0,
    "CORE_BREAKPOINT_NARROW_MAX_WIDTH": 599,
    "CORE_TEXT_10_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_TEXT_10_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "CORE_TEXT_10_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_TEXT_20_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.55)",
    "CORE_TEXT_20_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.55)",
    "CORE_TEXT_20_COLOR": "rgba(0, 0, 0, 0.55)",
    "CORE_TEXT_30_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "CORE_TEXT_30_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "CORE_TEXT_30_COLOR": "rgba(0, 0, 0, 0.3)",
    "CORE_TEXT_INVERSE_LIGHT_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "CORE_TEXT_INVERSE_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_TEXT_INVERSE_COLOR": "rgba(255, 255, 255, 0.95)",
    "CORE_TEXT_BLACK_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_TEXT_BLACK_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_TEXT_BLACK_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_TEXT_WHITE_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "CORE_TEXT_WHITE_DARK_MODE_COLOR": "rgb(255, 255, 255)",
    "CORE_TEXT_WHITE_COLOR": "rgb(255, 255, 255)",
    "CORE_FILL_10_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_FILL_10_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "CORE_FILL_10_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_FILL_20_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "CORE_FILL_20_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "CORE_FILL_20_COLOR": "rgba(0, 0, 0, 0.3)",
    "CORE_FILL_30_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.15)",
    "CORE_FILL_30_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.15)",
    "CORE_FILL_30_COLOR": "rgba(0, 0, 0, 0.15)",
    "CORE_FILL_40_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "CORE_FILL_40_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "CORE_FILL_40_COLOR": "rgba(0, 0, 0, 0.05)",
    "CORE_FILL_50_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.03)",
    "CORE_FILL_50_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.05)",
    "CORE_FILL_50_COLOR": "rgba(0, 0, 0, 0.03)",
    "CORE_FILL_INVERSE_LIGHT_MODE_COLOR": "rgba(255, 255, 255, 0.95)",
    "CORE_FILL_INVERSE_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_FILL_INVERSE_COLOR": "rgba(255, 255, 255, 0.95)",
    "CORE_FILL_BLACK_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_FILL_BLACK_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_FILL_BLACK_COLOR": "rgba(0, 0, 0, 0.9)",
    "CORE_FILL_WHITE_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "CORE_FILL_WHITE_DARK_MODE_COLOR": "rgb(255, 255, 255)",
    "CORE_FILL_WHITE_COLOR": "rgb(255, 255, 255)",
    "CORE_DIVIDER_10_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.3)",
    "CORE_DIVIDER_10_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.3)",
    "CORE_DIVIDER_10_COLOR": "rgba(0, 0, 0, 0.3)",
    "CORE_DIVIDER_20_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.05)",
    "CORE_DIVIDER_20_DARK_MODE_COLOR": "rgba(255, 255, 255, 0.08)",
    "CORE_DIVIDER_20_COLOR": "rgba(0, 0, 0, 0.05)",
    "CORE_SURFACE_5_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "CORE_SURFACE_5_DARK_MODE_COLOR": "rgb(8, 8, 8)",
    "CORE_SURFACE_5_COLOR": "rgb(255, 255, 255)",
    "CORE_SURFACE_10_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "CORE_SURFACE_10_DARK_MODE_COLOR": "rgb(20, 20, 20)",
    "CORE_SURFACE_10_COLOR": "rgb(255, 255, 255)",
    "CORE_SURFACE_20_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "CORE_SURFACE_20_DARK_MODE_COLOR": "rgb(28, 28, 28)",
    "CORE_SURFACE_20_COLOR": "rgb(255, 255, 255)",
    "CORE_SURFACE_30_LIGHT_MODE_COLOR": "rgb(255, 255, 255)",
    "CORE_SURFACE_30_DARK_MODE_COLOR": "rgb(45, 45, 45)",
    "CORE_SURFACE_30_COLOR": "rgb(255, 255, 255)",
    "CORE_SURFACE_INVERSE_LIGHT_MODE_COLOR": "rgb(26, 26, 26)",
    "CORE_SURFACE_INVERSE_DARK_MODE_COLOR": "rgb(255, 255, 255)",
    "CORE_SURFACE_INVERSE_COLOR": "rgb(26, 26, 26)",
    "CORE_SURFACE_OVERLAY_LIGHT_MODE_COLOR": "rgba(0, 0, 0, 0.8)",
    "CORE_SURFACE_OVERLAY_DARK_MODE_COLOR": "rgba(0, 0, 0, 0.8)",
    "CORE_SURFACE_OVERLAY_COLOR": "rgba(0, 0, 0, 0.8)",
    "CORE_EMPHASIS_FILL_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "CORE_EMPHASIS_FILL_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "CORE_EMPHASIS_FILL_COLOR": "rgb(0, 106, 255)",
    "CORE_EMPHASIS_TEXT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "CORE_EMPHASIS_TEXT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "CORE_EMPHASIS_TEXT_COLOR": "rgb(0, 90, 217)",
    "CORE_EMPHASIS_10_LIGHT_MODE_COLOR": "rgb(0, 85, 204)",
    "CORE_EMPHASIS_10_DARK_MODE_COLOR": "rgb(0, 85, 204)",
    "CORE_EMPHASIS_10_COLOR": "rgb(0, 85, 204)",
    "CORE_EMPHASIS_20_LIGHT_MODE_COLOR": "rgb(0, 95, 229)",
    "CORE_EMPHASIS_20_DARK_MODE_COLOR": "rgb(0, 95, 229)",
    "CORE_EMPHASIS_20_COLOR": "rgb(0, 95, 229)",
    "CORE_EMPHASIS_30_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "CORE_EMPHASIS_30_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "CORE_EMPHASIS_30_COLOR": "rgb(204, 225, 255)",
    "CORE_EMPHASIS_40_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "CORE_EMPHASIS_40_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "CORE_EMPHASIS_40_COLOR": "rgb(230, 240, 255)",
    "CORE_SUCCESS_FILL_LIGHT_MODE_COLOR": "rgb(0, 178, 59)",
    "CORE_SUCCESS_FILL_DARK_MODE_COLOR": "rgb(0, 179, 59)",
    "CORE_SUCCESS_FILL_COLOR": "rgb(0, 178, 59)",
    "CORE_SUCCESS_TEXT_LIGHT_MODE_COLOR": "rgb(0, 125, 42)",
    "CORE_SUCCESS_TEXT_DARK_MODE_COLOR": "rgb(22, 217, 86)",
    "CORE_SUCCESS_TEXT_COLOR": "rgb(0, 125, 42)",
    "CORE_SUCCESS_10_LIGHT_MODE_COLOR": "rgb(0, 128, 42)",
    "CORE_SUCCESS_10_DARK_MODE_COLOR": "rgb(0, 128, 42)",
    "CORE_SUCCESS_10_COLOR": "rgb(0, 128, 42)",
    "CORE_SUCCESS_20_LIGHT_MODE_COLOR": "rgb(0, 153, 51)",
    "CORE_SUCCESS_20_DARK_MODE_COLOR": "rgb(0, 153, 51)",
    "CORE_SUCCESS_20_COLOR": "rgb(0, 153, 51)",
    "CORE_SUCCESS_30_LIGHT_MODE_COLOR": "rgb(204, 255, 221)",
    "CORE_SUCCESS_30_DARK_MODE_COLOR": "rgb(0, 89, 30)",
    "CORE_SUCCESS_30_COLOR": "rgb(204, 255, 221)",
    "CORE_SUCCESS_40_LIGHT_MODE_COLOR": "rgb(229, 255, 238)",
    "CORE_SUCCESS_40_DARK_MODE_COLOR": "rgb(0, 51, 17)",
    "CORE_SUCCESS_40_COLOR": "rgb(229, 255, 238)",
    "CORE_WARNING_FILL_LIGHT_MODE_COLOR": "rgb(255, 159, 64)",
    "CORE_WARNING_FILL_DARK_MODE_COLOR": "rgb(255, 159, 64)",
    "CORE_WARNING_FILL_COLOR": "rgb(255, 159, 64)",
    "CORE_WARNING_TEXT_LIGHT_MODE_COLOR": "rgb(148, 92, 37)",
    "CORE_WARNING_TEXT_DARK_MODE_COLOR": "rgb(255, 159, 64)",
    "CORE_WARNING_TEXT_COLOR": "rgb(148, 92, 37)",
    "CORE_WARNING_10_LIGHT_MODE_COLOR": "rgb(204, 128, 51)",
    "CORE_WARNING_10_DARK_MODE_COLOR": "rgb(204, 128, 51)",
    "CORE_WARNING_10_COLOR": "rgb(204, 128, 51)",
    "CORE_WARNING_20_LIGHT_MODE_COLOR": "rgb(230, 143, 57)",
    "CORE_WARNING_20_DARK_MODE_COLOR": "rgb(230, 143, 57)",
    "CORE_WARNING_20_COLOR": "rgb(230, 143, 57)",
    "CORE_WARNING_30_LIGHT_MODE_COLOR": "rgb(255, 230, 204)",
    "CORE_WARNING_30_DARK_MODE_COLOR": "rgb(89, 45, 0)",
    "CORE_WARNING_30_COLOR": "rgb(255, 230, 204)",
    "CORE_WARNING_40_LIGHT_MODE_COLOR": "rgb(255, 242, 230)",
    "CORE_WARNING_40_DARK_MODE_COLOR": "rgb(51, 26, 0)",
    "CORE_WARNING_40_COLOR": "rgb(255, 242, 230)",
    "CORE_CRITICAL_FILL_LIGHT_MODE_COLOR": "rgb(204, 0, 35)",
    "CORE_CRITICAL_FILL_DARK_MODE_COLOR": "rgb(204, 0, 35)",
    "CORE_CRITICAL_FILL_COLOR": "rgb(204, 0, 35)",
    "CORE_CRITICAL_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "CORE_CRITICAL_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "CORE_CRITICAL_TEXT_COLOR": "rgb(191, 0, 32)",
    "CORE_CRITICAL_10_LIGHT_MODE_COLOR": "rgb(153, 0, 26)",
    "CORE_CRITICAL_10_DARK_MODE_COLOR": "rgb(153, 0, 26)",
    "CORE_CRITICAL_10_COLOR": "rgb(153, 0, 26)",
    "CORE_CRITICAL_20_LIGHT_MODE_COLOR": "rgb(178, 0, 30)",
    "CORE_CRITICAL_20_DARK_MODE_COLOR": "rgb(178, 0, 30)",
    "CORE_CRITICAL_20_COLOR": "rgb(178, 0, 30)",
    "CORE_CRITICAL_30_LIGHT_MODE_COLOR": "rgb(255, 204, 213)",
    "CORE_CRITICAL_30_DARK_MODE_COLOR": "rgb(89, 0, 15)",
    "CORE_CRITICAL_30_COLOR": "rgb(255, 204, 213)",
    "CORE_CRITICAL_40_LIGHT_MODE_COLOR": "rgb(255, 229, 234)",
    "CORE_CRITICAL_40_DARK_MODE_COLOR": "rgb(51, 0, 9)",
    "CORE_CRITICAL_40_COLOR": "rgb(255, 229, 234)",
    "CORE_FOCUS_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "CORE_FOCUS_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "CORE_FOCUS_COLOR": "rgb(0, 106, 255)",
    "CORE_GREEN_FILL_LIGHT_MODE_COLOR": "rgb(0, 178, 59)",
    "CORE_GREEN_FILL_DARK_MODE_COLOR": "rgb(0, 179, 59)",
    "CORE_GREEN_FILL_COLOR": "rgb(0, 178, 59)",
    "CORE_GREEN_TEXT_LIGHT_MODE_COLOR": "rgb(0, 125, 42)",
    "CORE_GREEN_TEXT_DARK_MODE_COLOR": "rgb(22, 217, 86)",
    "CORE_GREEN_TEXT_COLOR": "rgb(0, 125, 42)",
    "CORE_GREEN_10_LIGHT_MODE_COLOR": "rgb(0, 128, 42)",
    "CORE_GREEN_10_DARK_MODE_COLOR": "rgb(0, 128, 42)",
    "CORE_GREEN_10_COLOR": "rgb(0, 128, 42)",
    "CORE_GREEN_20_LIGHT_MODE_COLOR": "rgb(0, 153, 51)",
    "CORE_GREEN_20_DARK_MODE_COLOR": "rgb(0, 153, 51)",
    "CORE_GREEN_20_COLOR": "rgb(0, 153, 51)",
    "CORE_GREEN_30_LIGHT_MODE_COLOR": "rgb(204, 255, 221)",
    "CORE_GREEN_30_DARK_MODE_COLOR": "rgb(0, 89, 30)",
    "CORE_GREEN_30_COLOR": "rgb(204, 255, 221)",
    "CORE_GREEN_40_LIGHT_MODE_COLOR": "rgb(229, 255, 238)",
    "CORE_GREEN_40_DARK_MODE_COLOR": "rgb(0, 51, 17)",
    "CORE_GREEN_40_COLOR": "rgb(229, 255, 238)",
    "CORE_FOREST_FILL_LIGHT_MODE_COLOR": "rgb(25, 128, 42)",
    "CORE_FOREST_FILL_DARK_MODE_COLOR": "rgb(25, 128, 42)",
    "CORE_FOREST_FILL_COLOR": "rgb(25, 128, 42)",
    "CORE_FOREST_TEXT_LIGHT_MODE_COLOR": "rgb(0, 125, 42)",
    "CORE_FOREST_TEXT_DARK_MODE_COLOR": "rgb(22, 217, 86)",
    "CORE_FOREST_TEXT_COLOR": "rgb(0, 125, 42)",
    "CORE_FOREST_10_LIGHT_MODE_COLOR": "rgb(15, 77, 25)",
    "CORE_FOREST_10_DARK_MODE_COLOR": "rgb(15, 77, 25)",
    "CORE_FOREST_10_COLOR": "rgb(15, 77, 25)",
    "CORE_FOREST_20_LIGHT_MODE_COLOR": "rgb(20, 102, 34)",
    "CORE_FOREST_20_DARK_MODE_COLOR": "rgb(20, 102, 34)",
    "CORE_FOREST_20_COLOR": "rgb(20, 102, 34)",
    "CORE_FOREST_30_LIGHT_MODE_COLOR": "rgb(204, 255, 213)",
    "CORE_FOREST_30_DARK_MODE_COLOR": "rgb(0, 89, 15)",
    "CORE_FOREST_30_COLOR": "rgb(204, 255, 213)",
    "CORE_FOREST_40_LIGHT_MODE_COLOR": "rgb(230, 255, 234)",
    "CORE_FOREST_40_DARK_MODE_COLOR": "rgb(0, 51, 8)",
    "CORE_FOREST_40_COLOR": "rgb(230, 255, 234)",
    "CORE_TEAL_FILL_LIGHT_MODE_COLOR": "rgb(18, 191, 148)",
    "CORE_TEAL_FILL_DARK_MODE_COLOR": "rgb(18, 191, 148)",
    "CORE_TEAL_FILL_COLOR": "rgb(18, 191, 148)",
    "CORE_TEAL_TEXT_LIGHT_MODE_COLOR": "rgb(12, 120, 93)",
    "CORE_TEAL_TEXT_DARK_MODE_COLOR": "rgb(22, 216, 167)",
    "CORE_TEAL_TEXT_COLOR": "rgb(12, 120, 93)",
    "CORE_TEAL_10_LIGHT_MODE_COLOR": "rgb(13, 140, 109)",
    "CORE_TEAL_10_DARK_MODE_COLOR": "rgb(13, 140, 109)",
    "CORE_TEAL_10_COLOR": "rgb(13, 140, 109)",
    "CORE_TEAL_20_LIGHT_MODE_COLOR": "rgb(16, 166, 128)",
    "CORE_TEAL_20_DARK_MODE_COLOR": "rgb(16, 166, 128)",
    "CORE_TEAL_20_COLOR": "rgb(16, 166, 128)",
    "CORE_TEAL_30_LIGHT_MODE_COLOR": "rgb(204, 255, 242)",
    "CORE_TEAL_30_DARK_MODE_COLOR": "rgb(0, 89, 67)",
    "CORE_TEAL_30_COLOR": "rgb(204, 255, 242)",
    "CORE_TEAL_40_LIGHT_MODE_COLOR": "rgb(230, 255, 249)",
    "CORE_TEAL_40_DARK_MODE_COLOR": "rgb(0, 51, 38)",
    "CORE_TEAL_40_COLOR": "rgb(230, 255, 249)",
    "CORE_BLUE_FILL_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "CORE_BLUE_FILL_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "CORE_BLUE_FILL_COLOR": "rgb(0, 106, 255)",
    "CORE_BLUE_TEXT_LIGHT_MODE_COLOR": "rgb(0, 90, 217)",
    "CORE_BLUE_TEXT_DARK_MODE_COLOR": "rgb(74, 149, 255)",
    "CORE_BLUE_TEXT_COLOR": "rgb(0, 90, 217)",
    "CORE_BLUE_10_LIGHT_MODE_COLOR": "rgb(0, 85, 204)",
    "CORE_BLUE_10_DARK_MODE_COLOR": "rgb(0, 85, 204)",
    "CORE_BLUE_10_COLOR": "rgb(0, 85, 204)",
    "CORE_BLUE_20_LIGHT_MODE_COLOR": "rgb(0, 95, 229)",
    "CORE_BLUE_20_DARK_MODE_COLOR": "rgb(0, 95, 229)",
    "CORE_BLUE_20_COLOR": "rgb(0, 95, 229)",
    "CORE_BLUE_30_LIGHT_MODE_COLOR": "rgb(204, 225, 255)",
    "CORE_BLUE_30_DARK_MODE_COLOR": "rgb(0, 37, 89)",
    "CORE_BLUE_30_COLOR": "rgb(204, 225, 255)",
    "CORE_BLUE_40_LIGHT_MODE_COLOR": "rgb(230, 240, 255)",
    "CORE_BLUE_40_DARK_MODE_COLOR": "rgb(0, 21, 51)",
    "CORE_BLUE_40_COLOR": "rgb(230, 240, 255)",
    "CORE_SKY_FILL_LIGHT_MODE_COLOR": "rgb(38, 147, 255)",
    "CORE_SKY_FILL_DARK_MODE_COLOR": "rgb(38, 147, 255)",
    "CORE_SKY_FILL_COLOR": "rgb(38, 147, 255)",
    "CORE_SKY_TEXT_LIGHT_MODE_COLOR": "rgb(15, 101, 186)",
    "CORE_SKY_TEXT_DARK_MODE_COLOR": "rgb(46, 151, 255)",
    "CORE_SKY_TEXT_COLOR": "rgb(15, 101, 186)",
    "CORE_SKY_10_LIGHT_MODE_COLOR": "rgb(31, 117, 204)",
    "CORE_SKY_10_DARK_MODE_COLOR": "rgb(31, 117, 204)",
    "CORE_SKY_10_COLOR": "rgb(31, 117, 204)",
    "CORE_SKY_20_LIGHT_MODE_COLOR": "rgb(34, 132, 230)",
    "CORE_SKY_20_DARK_MODE_COLOR": "rgb(34, 132, 230)",
    "CORE_SKY_20_COLOR": "rgb(34, 132, 230)",
    "CORE_SKY_30_LIGHT_MODE_COLOR": "rgb(204, 230, 255)",
    "CORE_SKY_30_DARK_MODE_COLOR": "rgb(0, 45, 89)",
    "CORE_SKY_30_COLOR": "rgb(204, 230, 255)",
    "CORE_SKY_40_LIGHT_MODE_COLOR": "rgb(230, 242, 255)",
    "CORE_SKY_40_DARK_MODE_COLOR": "rgb(0, 26, 51)",
    "CORE_SKY_40_COLOR": "rgb(230, 242, 255)",
    "CORE_PURPLE_FILL_LIGHT_MODE_COLOR": "rgb(135, 22, 217)",
    "CORE_PURPLE_FILL_DARK_MODE_COLOR": "rgb(135, 22, 217)",
    "CORE_PURPLE_FILL_COLOR": "rgb(135, 22, 217)",
    "CORE_PURPLE_TEXT_LIGHT_MODE_COLOR": "rgb(135, 22, 217)",
    "CORE_PURPLE_TEXT_DARK_MODE_COLOR": "rgb(194, 110, 255)",
    "CORE_PURPLE_TEXT_COLOR": "rgb(135, 22, 217)",
    "CORE_PURPLE_10_LIGHT_MODE_COLOR": "rgb(104, 17, 166)",
    "CORE_PURPLE_10_DARK_MODE_COLOR": "rgb(104, 17, 166)",
    "CORE_PURPLE_10_COLOR": "rgb(104, 17, 166)",
    "CORE_PURPLE_20_LIGHT_MODE_COLOR": "rgb(120, 19, 191)",
    "CORE_PURPLE_20_DARK_MODE_COLOR": "rgb(120, 19, 191)",
    "CORE_PURPLE_20_COLOR": "rgb(120, 19, 191)",
    "CORE_PURPLE_30_LIGHT_MODE_COLOR": "rgb(234, 204, 255)",
    "CORE_PURPLE_30_DARK_MODE_COLOR": "rgb(52, 0, 89)",
    "CORE_PURPLE_30_COLOR": "rgb(234, 204, 255)",
    "CORE_PURPLE_40_LIGHT_MODE_COLOR": "rgb(244, 230, 255)",
    "CORE_PURPLE_40_DARK_MODE_COLOR": "rgb(30, 0, 51)",
    "CORE_PURPLE_40_COLOR": "rgb(244, 230, 255)",
    "CORE_PINK_FILL_LIGHT_MODE_COLOR": "rgb(217, 54, 176)",
    "CORE_PINK_FILL_DARK_MODE_COLOR": "rgb(217, 54, 176)",
    "CORE_PINK_FILL_COLOR": "rgb(217, 54, 176)",
    "CORE_PINK_TEXT_LIGHT_MODE_COLOR": "rgb(168, 42, 136)",
    "CORE_PINK_TEXT_DARK_MODE_COLOR": "rgb(255, 67, 208)",
    "CORE_PINK_TEXT_COLOR": "rgb(168, 42, 136)",
    "CORE_PINK_10_LIGHT_MODE_COLOR": "rgb(166, 41, 135)",
    "CORE_PINK_10_DARK_MODE_COLOR": "rgb(166, 41, 135)",
    "CORE_PINK_10_COLOR": "rgb(166, 41, 135)",
    "CORE_PINK_20_LIGHT_MODE_COLOR": "rgb(191, 48, 155)",
    "CORE_PINK_20_DARK_MODE_COLOR": "rgb(191, 48, 155)",
    "CORE_PINK_20_COLOR": "rgb(191, 48, 155)",
    "CORE_PINK_30_LIGHT_MODE_COLOR": "rgb(255, 204, 242)",
    "CORE_PINK_30_DARK_MODE_COLOR": "rgb(89, 0, 67)",
    "CORE_PINK_30_COLOR": "rgb(255, 204, 242)",
    "CORE_PINK_40_LIGHT_MODE_COLOR": "rgb(255, 230, 249)",
    "CORE_PINK_40_DARK_MODE_COLOR": "rgb(51, 0, 38)",
    "CORE_PINK_40_COLOR": "rgb(255, 230, 249)",
    "CORE_BURGUNDY_FILL_LIGHT_MODE_COLOR": "rgb(153, 8, 56)",
    "CORE_BURGUNDY_FILL_DARK_MODE_COLOR": "rgb(153, 8, 56)",
    "CORE_BURGUNDY_FILL_COLOR": "rgb(153, 8, 56)",
    "CORE_BURGUNDY_TEXT_LIGHT_MODE_COLOR": "rgb(153, 8, 56)",
    "CORE_BURGUNDY_TEXT_DARK_MODE_COLOR": "rgb(255, 86, 142)",
    "CORE_BURGUNDY_TEXT_COLOR": "rgb(153, 8, 56)",
    "CORE_BURGUNDY_10_LIGHT_MODE_COLOR": "rgb(102, 5, 37)",
    "CORE_BURGUNDY_10_DARK_MODE_COLOR": "rgb(102, 5, 37)",
    "CORE_BURGUNDY_10_COLOR": "rgb(102, 5, 37)",
    "CORE_BURGUNDY_20_LIGHT_MODE_COLOR": "rgb(128, 6, 47)",
    "CORE_BURGUNDY_20_DARK_MODE_COLOR": "rgb(128, 6, 47)",
    "CORE_BURGUNDY_20_COLOR": "rgb(128, 6, 47)",
    "CORE_BURGUNDY_30_LIGHT_MODE_COLOR": "rgb(255, 204, 221)",
    "CORE_BURGUNDY_30_DARK_MODE_COLOR": "rgb(89, 0, 30)",
    "CORE_BURGUNDY_30_COLOR": "rgb(255, 204, 221)",
    "CORE_BURGUNDY_40_LIGHT_MODE_COLOR": "rgb(255, 230, 238)",
    "CORE_BURGUNDY_40_DARK_MODE_COLOR": "rgb(51, 0, 17)",
    "CORE_BURGUNDY_40_COLOR": "rgb(255, 230, 238)",
    "CORE_RED_FILL_LIGHT_MODE_COLOR": "rgb(204, 0, 35)",
    "CORE_RED_FILL_DARK_MODE_COLOR": "rgb(204, 0, 35)",
    "CORE_RED_FILL_COLOR": "rgb(204, 0, 35)",
    "CORE_RED_TEXT_LIGHT_MODE_COLOR": "rgb(191, 0, 32)",
    "CORE_RED_TEXT_DARK_MODE_COLOR": "rgb(255, 90, 118)",
    "CORE_RED_TEXT_COLOR": "rgb(191, 0, 32)",
    "CORE_RED_10_LIGHT_MODE_COLOR": "rgb(153, 0, 26)",
    "CORE_RED_10_DARK_MODE_COLOR": "rgb(153, 0, 26)",
    "CORE_RED_10_COLOR": "rgb(153, 0, 26)",
    "CORE_RED_20_LIGHT_MODE_COLOR": "rgb(178, 0, 30)",
    "CORE_RED_20_DARK_MODE_COLOR": "rgb(178, 0, 30)",
    "CORE_RED_20_COLOR": "rgb(178, 0, 30)",
    "CORE_RED_30_LIGHT_MODE_COLOR": "rgb(255, 204, 213)",
    "CORE_RED_30_DARK_MODE_COLOR": "rgb(89, 0, 15)",
    "CORE_RED_30_COLOR": "rgb(255, 204, 213)",
    "CORE_RED_40_LIGHT_MODE_COLOR": "rgb(255, 229, 234)",
    "CORE_RED_40_DARK_MODE_COLOR": "rgb(51, 0, 9)",
    "CORE_RED_40_COLOR": "rgb(255, 229, 234)",
    "CORE_ORANGE_FILL_LIGHT_MODE_COLOR": "rgb(242, 91, 61)",
    "CORE_ORANGE_FILL_DARK_MODE_COLOR": "rgb(242, 91, 61)",
    "CORE_ORANGE_FILL_COLOR": "rgb(242, 91, 61)",
    "CORE_ORANGE_TEXT_LIGHT_MODE_COLOR": "rgb(168, 63, 42)",
    "CORE_ORANGE_TEXT_DARK_MODE_COLOR": "rgb(255, 95, 63)",
    "CORE_ORANGE_TEXT_COLOR": "rgb(168, 63, 42)",
    "CORE_ORANGE_10_LIGHT_MODE_COLOR": "rgb(191, 72, 48)",
    "CORE_ORANGE_10_DARK_MODE_COLOR": "rgb(191, 72, 48)",
    "CORE_ORANGE_10_COLOR": "rgb(191, 72, 48)",
    "CORE_ORANGE_20_LIGHT_MODE_COLOR": "rgb(219, 82, 55)",
    "CORE_ORANGE_20_DARK_MODE_COLOR": "rgb(219, 82, 55)",
    "CORE_ORANGE_20_COLOR": "rgb(219, 82, 55)",
    "CORE_ORANGE_30_LIGHT_MODE_COLOR": "rgb(255, 213, 204)",
    "CORE_ORANGE_30_DARK_MODE_COLOR": "rgb(89, 15, 0)",
    "CORE_ORANGE_30_COLOR": "rgb(255, 213, 204)",
    "CORE_ORANGE_40_LIGHT_MODE_COLOR": "rgb(255, 234, 230)",
    "CORE_ORANGE_40_DARK_MODE_COLOR": "rgb(51, 8, 0)",
    "CORE_ORANGE_40_COLOR": "rgb(255, 234, 230)",
    "CORE_GOLD_FILL_LIGHT_MODE_COLOR": "rgb(255, 159, 64)",
    "CORE_GOLD_FILL_DARK_MODE_COLOR": "rgb(255, 159, 64)",
    "CORE_GOLD_FILL_COLOR": "rgb(255, 159, 64)",
    "CORE_GOLD_TEXT_LIGHT_MODE_COLOR": "rgb(148, 92, 37)",
    "CORE_GOLD_TEXT_DARK_MODE_COLOR": "rgb(255, 159, 64)",
    "CORE_GOLD_TEXT_COLOR": "rgb(148, 92, 37)",
    "CORE_GOLD_10_LIGHT_MODE_COLOR": "rgb(204, 128, 51)",
    "CORE_GOLD_10_DARK_MODE_COLOR": "rgb(204, 128, 51)",
    "CORE_GOLD_10_COLOR": "rgb(204, 128, 51)",
    "CORE_GOLD_20_LIGHT_MODE_COLOR": "rgb(230, 143, 57)",
    "CORE_GOLD_20_DARK_MODE_COLOR": "rgb(230, 143, 57)",
    "CORE_GOLD_20_COLOR": "rgb(230, 143, 57)",
    "CORE_GOLD_30_LIGHT_MODE_COLOR": "rgb(255, 230, 204)",
    "CORE_GOLD_30_DARK_MODE_COLOR": "rgb(89, 45, 0)",
    "CORE_GOLD_30_COLOR": "rgb(255, 230, 204)",
    "CORE_GOLD_40_LIGHT_MODE_COLOR": "rgb(255, 242, 230)",
    "CORE_GOLD_40_DARK_MODE_COLOR": "rgb(51, 26, 0)",
    "CORE_GOLD_40_COLOR": "rgb(255, 242, 230)",
    "CORE_YELLOW_FILL_LIGHT_MODE_COLOR": "rgb(255, 191, 0)",
    "CORE_YELLOW_FILL_DARK_MODE_COLOR": "rgb(255, 191, 0)",
    "CORE_YELLOW_FILL_COLOR": "rgb(255, 191, 0)",
    "CORE_YELLOW_TEXT_LIGHT_MODE_COLOR": "rgb(135, 101, 0)",
    "CORE_YELLOW_TEXT_DARK_MODE_COLOR": "rgb(255, 191, 0)",
    "CORE_YELLOW_TEXT_COLOR": "rgb(135, 101, 0)",
    "CORE_YELLOW_10_LIGHT_MODE_COLOR": "rgb(204, 153, 0)",
    "CORE_YELLOW_10_DARK_MODE_COLOR": "rgb(204, 153, 0)",
    "CORE_YELLOW_10_COLOR": "rgb(204, 153, 0)",
    "CORE_YELLOW_20_LIGHT_MODE_COLOR": "rgb(229, 172, 0)",
    "CORE_YELLOW_20_DARK_MODE_COLOR": "rgb(229, 172, 0)",
    "CORE_YELLOW_20_COLOR": "rgb(229, 172, 0)",
    "CORE_YELLOW_30_LIGHT_MODE_COLOR": "rgb(255, 242, 204)",
    "CORE_YELLOW_30_DARK_MODE_COLOR": "rgb(89, 67, 0)",
    "CORE_YELLOW_30_COLOR": "rgb(255, 242, 204)",
    "CORE_YELLOW_40_LIGHT_MODE_COLOR": "rgb(255, 249, 229)",
    "CORE_YELLOW_40_DARK_MODE_COLOR": "rgb(51, 38, 0)",
    "CORE_YELLOW_40_COLOR": "rgb(255, 249, 229)",
    "CORE_TAUPE_FILL_LIGHT_MODE_COLOR": "rgb(166, 124, 83)",
    "CORE_TAUPE_FILL_DARK_MODE_COLOR": "rgb(166, 124, 83)",
    "CORE_TAUPE_FILL_COLOR": "rgb(166, 124, 83)",
    "CORE_TAUPE_TEXT_LIGHT_MODE_COLOR": "rgb(130, 97, 65)",
    "CORE_TAUPE_TEXT_DARK_MODE_COLOR": "rgb(201, 152, 102)",
    "CORE_TAUPE_TEXT_COLOR": "rgb(130, 97, 65)",
    "CORE_TAUPE_10_LIGHT_MODE_COLOR": "rgb(115, 86, 57)",
    "CORE_TAUPE_10_DARK_MODE_COLOR": "rgb(115, 86, 57)",
    "CORE_TAUPE_10_COLOR": "rgb(115, 86, 57)",
    "CORE_TAUPE_20_LIGHT_MODE_COLOR": "rgb(140, 105, 70)",
    "CORE_TAUPE_20_DARK_MODE_COLOR": "rgb(140, 105, 70)",
    "CORE_TAUPE_20_COLOR": "rgb(140, 105, 70)",
    "CORE_TAUPE_30_LIGHT_MODE_COLOR": "rgb(255, 230, 204)",
    "CORE_TAUPE_30_DARK_MODE_COLOR": "rgb(89, 45, 0)",
    "CORE_TAUPE_30_COLOR": "rgb(255, 230, 204)",
    "CORE_TAUPE_40_LIGHT_MODE_COLOR": "rgb(255, 242, 230)",
    "CORE_TAUPE_40_DARK_MODE_COLOR": "rgb(51, 26, 0)",
    "CORE_TAUPE_40_COLOR": "rgb(255, 242, 230)",
    "CORE_BROWN_FILL_LIGHT_MODE_COLOR": "rgb(102, 74, 46)",
    "CORE_BROWN_FILL_DARK_MODE_COLOR": "rgb(102, 77, 51)",
    "CORE_BROWN_FILL_COLOR": "rgb(102, 74, 46)",
    "CORE_BROWN_TEXT_LIGHT_MODE_COLOR": "rgb(102, 74, 46)",
    "CORE_BROWN_TEXT_DARK_MODE_COLOR": "rgb(201, 152, 102)",
    "CORE_BROWN_TEXT_COLOR": "rgb(102, 74, 46)",
    "CORE_BROWN_10_LIGHT_MODE_COLOR": "rgb(51, 37, 23)",
    "CORE_BROWN_10_DARK_MODE_COLOR": "rgb(51, 38, 26)",
    "CORE_BROWN_10_COLOR": "rgb(51, 37, 23)",
    "CORE_BROWN_20_LIGHT_MODE_COLOR": "rgb(77, 55, 34)",
    "CORE_BROWN_20_DARK_MODE_COLOR": "rgb(77, 57, 38)",
    "CORE_BROWN_20_COLOR": "rgb(77, 55, 34)",
    "CORE_BROWN_30_LIGHT_MODE_COLOR": "rgb(255, 230, 204)",
    "CORE_BROWN_30_DARK_MODE_COLOR": "rgb(89, 45, 0)",
    "CORE_BROWN_30_COLOR": "rgb(255, 230, 204)",
    "CORE_BROWN_40_LIGHT_MODE_COLOR": "rgb(255, 242, 230)",
    "CORE_BROWN_40_DARK_MODE_COLOR": "rgb(51, 25, 0)",
    "CORE_BROWN_40_COLOR": "rgb(255, 242, 230)",
    "CORE_EXTRA_WIDE_VIEWPORT_GRID_COLUMN_COUNT": 4,
    "CORE_EXTRA_WIDE_VIEWPORT_GRID_HORIZONTAL_SPACING": 16,
    "CORE_EXTRA_WIDE_VIEWPORT_GRID_VERTICAL_SPACING": 16,
    "CORE_EXTRA_WIDE_VIEWPORT_GRID_ITEM_SMALL_SIZE_COLUMN_SPAN": 1,
    "CORE_EXTRA_WIDE_VIEWPORT_GRID_ITEM_MEDIUM_SIZE_COLUMN_SPAN": 2,
    "CORE_EXTRA_WIDE_VIEWPORT_GRID_ITEM_LARGE_SIZE_COLUMN_SPAN": 3,
    "CORE_EXTRA_WIDE_VIEWPORT_GRID_ITEM_FULL_SIZE_COLUMN_SPAN": 4,
    "CORE_WIDE_VIEWPORT_GRID_COLUMN_COUNT": 4,
    "CORE_WIDE_VIEWPORT_GRID_HORIZONTAL_SPACING": 16,
    "CORE_WIDE_VIEWPORT_GRID_VERTICAL_SPACING": 16,
    "CORE_WIDE_VIEWPORT_GRID_ITEM_SMALL_SIZE_COLUMN_SPAN": 1,
    "CORE_WIDE_VIEWPORT_GRID_ITEM_MEDIUM_SIZE_COLUMN_SPAN": 2,
    "CORE_WIDE_VIEWPORT_GRID_ITEM_LARGE_SIZE_COLUMN_SPAN": 3,
    "CORE_WIDE_VIEWPORT_GRID_ITEM_FULL_SIZE_COLUMN_SPAN": 4,
    "CORE_MEDIUM_VIEWPORT_GRID_COLUMN_COUNT": 2,
    "CORE_MEDIUM_VIEWPORT_GRID_HORIZONTAL_SPACING": 16,
    "CORE_MEDIUM_VIEWPORT_GRID_VERTICAL_SPACING": 16,
    "CORE_MEDIUM_VIEWPORT_GRID_ITEM_SMALL_SIZE_COLUMN_SPAN": 1,
    "CORE_MEDIUM_VIEWPORT_GRID_ITEM_MEDIUM_SIZE_COLUMN_SPAN": 1,
    "CORE_MEDIUM_VIEWPORT_GRID_ITEM_LARGE_SIZE_COLUMN_SPAN": 1,
    "CORE_MEDIUM_VIEWPORT_GRID_ITEM_FULL_SIZE_COLUMN_SPAN": 2,
    "CORE_NARROW_VIEWPORT_GRID_COLUMN_COUNT": 1,
    "CORE_NARROW_VIEWPORT_GRID_HORIZONTAL_SPACING": 16,
    "CORE_NARROW_VIEWPORT_GRID_VERTICAL_SPACING": 16,
    "CORE_NARROW_VIEWPORT_GRID_ITEM_SMALL_SIZE_COLUMN_SPAN": 1,
    "CORE_NARROW_VIEWPORT_GRID_ITEM_MEDIUM_SIZE_COLUMN_SPAN": 1,
    "CORE_NARROW_VIEWPORT_GRID_ITEM_LARGE_SIZE_COLUMN_SPAN": 1,
    "CORE_NARROW_VIEWPORT_GRID_ITEM_FULL_SIZE_COLUMN_SPAN": 1,
    "CORE_ICON_EXPAND_16_FIDELITY_ASSET": "chevron-down",
    "CORE_ICON_EXPAND_16_FIDELITY_WIDTH": 16,
    "CORE_ICON_EXPAND_16_FIDELITY_HEIGHT": 16,
    "CORE_ICON_EXPAND_16_FIDELITY_TINTABLE": true,
    "CORE_ICON_COLLAPSE_16_FIDELITY_ASSET": "chevron-up",
    "CORE_ICON_COLLAPSE_16_FIDELITY_WIDTH": 16,
    "CORE_ICON_COLLAPSE_16_FIDELITY_HEIGHT": 16,
    "CORE_ICON_COLLAPSE_16_FIDELITY_TINTABLE": true,
    "CORE_ICON_CONTINUE_16_FIDELITY_ASSET": "chevron-right",
    "CORE_ICON_CONTINUE_16_FIDELITY_WIDTH": 16,
    "CORE_ICON_CONTINUE_16_FIDELITY_HEIGHT": 16,
    "CORE_ICON_CONTINUE_16_FIDELITY_TINTABLE": true,
    "CORE_ICON_RETURN_16_FIDELITY_ASSET": "chevron-left",
    "CORE_ICON_RETURN_16_FIDELITY_WIDTH": 16,
    "CORE_ICON_RETURN_16_FIDELITY_HEIGHT": 16,
    "CORE_ICON_RETURN_16_FIDELITY_TINTABLE": true,
    "CORE_ICON_CLEAR_24_FIDELITY_ASSET": "x",
    "CORE_ICON_CLEAR_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_CLEAR_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_CLEAR_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_CLOSE_24_FIDELITY_ASSET": "x",
    "CORE_ICON_CLOSE_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_CLOSE_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_CLOSE_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_ADD_24_FIDELITY_ASSET": "plus",
    "CORE_ICON_ADD_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_ADD_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_ADD_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_REMOVE_24_FIDELITY_ASSET": "minus",
    "CORE_ICON_REMOVE_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_REMOVE_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_REMOVE_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_BACK_24_FIDELITY_ASSET": "arrow-left",
    "CORE_ICON_BACK_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_BACK_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_BACK_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_PREVIOUS_24_FIDELITY_ASSET": "arrow-left",
    "CORE_ICON_PREVIOUS_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_PREVIOUS_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_PREVIOUS_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_FORWARD_24_FIDELITY_ASSET": "arrow-right",
    "CORE_ICON_FORWARD_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_FORWARD_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_FORWARD_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_NEXT_24_FIDELITY_ASSET": "arrow-right",
    "CORE_ICON_NEXT_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_NEXT_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_NEXT_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_ASCEND_24_FIDELITY_ASSET": "arrow-up",
    "CORE_ICON_ASCEND_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_ASCEND_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_ASCEND_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_DESCEND_24_FIDELITY_ASSET": "arrow-down",
    "CORE_ICON_DESCEND_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_DESCEND_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_DESCEND_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_MORE_24_FIDELITY_ASSET": "ellipsis",
    "CORE_ICON_MORE_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_MORE_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_MORE_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_MENU_24_FIDELITY_ASSET": "hamburger-lines",
    "CORE_ICON_MENU_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_MENU_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_MENU_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_LOADING_24_FIDELITY_ASSET": "radial-spinner",
    "CORE_ICON_LOADING_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_LOADING_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_LOADING_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_SEARCH_24_FIDELITY_ASSET": "magnifying-glass",
    "CORE_ICON_SEARCH_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_SEARCH_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_SEARCH_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_DRAG_24_FIDELITY_ASSET": "grip-dots-vertical",
    "CORE_ICON_DRAG_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_DRAG_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_DRAG_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_WARN_24_FIDELITY_ASSET": "exclamation-circle",
    "CORE_ICON_WARN_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_WARN_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_WARN_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_WARNING_24_FIDELITY_ASSET": "exclamation-circle",
    "CORE_ICON_WARNING_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_WARNING_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_WARNING_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_SUCCEED_24_FIDELITY_ASSET": "checkmark-circle",
    "CORE_ICON_SUCCEED_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_SUCCEED_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_SUCCEED_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_SUCCESS_24_FIDELITY_ASSET": "checkmark-circle",
    "CORE_ICON_SUCCESS_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_SUCCESS_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_SUCCESS_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_INFORM_24_FIDELITY_ASSET": "i-circle",
    "CORE_ICON_INFORM_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_INFORM_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_INFORM_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_INFO_24_FIDELITY_ASSET": "i-circle",
    "CORE_ICON_INFO_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_INFO_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_INFO_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_DENY_24_FIDELITY_ASSET": "no-entry-circle",
    "CORE_ICON_DENY_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_DENY_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_DENY_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_DENIED_24_FIDELITY_ASSET": "no-entry-circle",
    "CORE_ICON_DENIED_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_DENIED_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_DENIED_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_CANCEL_24_FIDELITY_ASSET": "x-circle",
    "CORE_ICON_CANCEL_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_CANCEL_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_CANCEL_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_CANCELLED_24_FIDELITY_ASSET": "x-circle",
    "CORE_ICON_CANCELLED_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_CANCELLED_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_CANCELLED_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_RECOMMEND_24_FIDELITY_ASSET": "lightning-bolt",
    "CORE_ICON_RECOMMEND_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_RECOMMEND_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_RECOMMEND_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_RECOMMENDATION_24_FIDELITY_ASSET": "lightning-bolt",
    "CORE_ICON_RECOMMENDATION_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_RECOMMENDATION_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_RECOMMENDATION_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_REFRESH_24_FIDELITY_ASSET": "dual-rotating-arrows",
    "CORE_ICON_REFRESH_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_REFRESH_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_REFRESH_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_CYCLE_24_FIDELITY_ASSET": "dual-rotating-arrows",
    "CORE_ICON_CYCLE_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_CYCLE_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_CYCLE_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_DELETE_24_FIDELITY_ASSET": "trashcan",
    "CORE_ICON_DELETE_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_DELETE_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_DELETE_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_CHECKMARK_24_FIDELITY_ASSET": "check",
    "CORE_ICON_CHECKMARK_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_CHECKMARK_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_CHECKMARK_24_FIDELITY_TINTABLE": true,
    "CORE_ICON_HELP_24_FIDELITY_ASSET": "question-mark-circle",
    "CORE_ICON_HELP_24_FIDELITY_WIDTH": 24,
    "CORE_ICON_HELP_24_FIDELITY_HEIGHT": 24,
    "CORE_ICON_HELP_24_FIDELITY_TINTABLE": true,
    "CORE_BASE_SIZE": 8,
    "CORE_TEXT_SIZE": 16,
    "CORE_SPACE_10_SIZE": 8,
    "CORE_METRICS_SPACING_25": 2,
    "CORE_METRICS_SPACING_50": 4,
    "CORE_METRICS_SPACING_100": 8,
    "CORE_METRICS_SPACING_150": 12,
    "CORE_METRICS_SPACING_200": 16,
    "CORE_METRICS_SPACING_300": 24,
    "CORE_METRICS_SPACING_400": 32,
    "CORE_METRICS_SPACING_500": 40,
    "CORE_METRICS_SPACING_600": 48,
    "CORE_METRICS_SPACING_800": 64,
    "CORE_METRICS_SPACING_1000": 80,
    "CORE_METRICS_SPACING_1500": 120,
    "CORE_METRICS_SPACING_2000": 160,
    "CORE_RADIUS_10": 6,
    "CORE_RADIUS_20": 12,
    "CORE_HORIZONTAL_SIZE_CLASS_REGULAR_THRESHOLD": 600,
    "CORE_HORIZONTAL_SIZE_CLASS_WIDE_THRESHOLD": 1200,
    "CORE_VERTICAL_SIZE_CLASS_REGULAR_THRESHOLD": 600,
    "CORE_VERTICAL_SIZE_CLASS_TALL_THRESHOLD": 864,
    "CORE_SMALL_SIZE_MINIMUM_HEIGHT": 40,
    "CORE_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
    "CORE_LARGE_SIZE_MINIMUM_HEIGHT": 64,
    "CORE_FOCUS_RING_BUFFER_SIZE": 2,
    "CORE_FOCUS_RING_BORDER_SIZE": 2,
    "CORE_FOCUS_RING_LIGHT_MODE_COLOR": "rgb(0, 106, 255)",
    "CORE_FOCUS_RING_DARK_MODE_COLOR": "rgb(0, 106, 255)",
    "CORE_FOCUS_RING_COLOR": "rgb(0, 106, 255)",
    "CORE_TYPE_DISPLAY_10_SIZE": 32,
    "CORE_TYPE_DISPLAY_10_LEADING": 40,
    "CORE_TYPE_DISPLAY_10_TRACKING": 0,
    "CORE_TYPE_DISPLAY_10_WEIGHT": 700,
    "CORE_TYPE_DISPLAY_10_CASE": "regular",
    "CORE_TYPE_DISPLAY_10_NUMBER_SPACING": "default",
    "CORE_TYPE_DISPLAY_10_SCALE": "heading-30",
    "CORE_TYPE_DISPLAY_10_FONT_FAMILY": "Square Sans Display",
    "CORE_TYPE_DISPLAY_20_SIZE": 48,
    "CORE_TYPE_DISPLAY_20_LEADING": 56,
    "CORE_TYPE_DISPLAY_20_TRACKING": 0,
    "CORE_TYPE_DISPLAY_20_WEIGHT": 500,
    "CORE_TYPE_DISPLAY_20_CASE": "regular",
    "CORE_TYPE_DISPLAY_20_NUMBER_SPACING": "default",
    "CORE_TYPE_DISPLAY_20_SCALE": "heading-30",
    "CORE_TYPE_DISPLAY_20_FONT_FAMILY": "Square Sans Display",
    "CORE_TYPE_DISPLAY_FONT_FAMILY": "Square Sans Display",
    "CORE_TYPE_HEADING_5_SIZE": 12,
    "CORE_TYPE_HEADING_5_LEADING": 20,
    "CORE_TYPE_HEADING_5_TRACKING": 0.05,
    "CORE_TYPE_HEADING_5_WEIGHT": 500,
    "CORE_TYPE_HEADING_5_CASE": "uppercase",
    "CORE_TYPE_HEADING_5_NUMBER_SPACING": "default",
    "CORE_TYPE_HEADING_5_SCALE": "heading-5",
    "CORE_TYPE_HEADING_5_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_HEADING_5_IS_HEADER": true,
    "CORE_TYPE_HEADING_10_SIZE": 14,
    "CORE_TYPE_HEADING_10_LEADING": 22,
    "CORE_TYPE_HEADING_10_TRACKING": 0,
    "CORE_TYPE_HEADING_10_WEIGHT": 700,
    "CORE_TYPE_HEADING_10_CASE": "regular",
    "CORE_TYPE_HEADING_10_NUMBER_SPACING": "default",
    "CORE_TYPE_HEADING_10_SCALE": "heading-10",
    "CORE_TYPE_HEADING_10_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_HEADING_10_IS_HEADER": true,
    "CORE_TYPE_HEADING_20_SIZE": 19,
    "CORE_TYPE_HEADING_20_LEADING": 26,
    "CORE_TYPE_HEADING_20_TRACKING": 0,
    "CORE_TYPE_HEADING_20_WEIGHT": 700,
    "CORE_TYPE_HEADING_20_CASE": "regular",
    "CORE_TYPE_HEADING_20_NUMBER_SPACING": "default",
    "CORE_TYPE_HEADING_20_SCALE": "heading-20",
    "CORE_TYPE_HEADING_20_FONT_FAMILY": "Square Sans Display",
    "CORE_TYPE_HEADING_20_IS_HEADER": true,
    "CORE_TYPE_HEADING_30_SIZE": 25,
    "CORE_TYPE_HEADING_30_LEADING": 32,
    "CORE_TYPE_HEADING_30_TRACKING": 0,
    "CORE_TYPE_HEADING_30_WEIGHT": 700,
    "CORE_TYPE_HEADING_30_CASE": "regular",
    "CORE_TYPE_HEADING_30_NUMBER_SPACING": "default",
    "CORE_TYPE_HEADING_30_SCALE": "heading-30",
    "CORE_TYPE_HEADING_30_FONT_FAMILY": "Square Sans Display",
    "CORE_TYPE_HEADING_30_IS_HEADER": true,
    "CORE_TYPE_PARAGRAPH_10_SIZE": 12,
    "CORE_TYPE_PARAGRAPH_10_LEADING": 18,
    "CORE_TYPE_PARAGRAPH_10_TRACKING": 0,
    "CORE_TYPE_PARAGRAPH_10_WEIGHT": 400,
    "CORE_TYPE_PARAGRAPH_10_CASE": "regular",
    "CORE_TYPE_PARAGRAPH_10_NUMBER_SPACING": "default",
    "CORE_TYPE_PARAGRAPH_10_SCALE": "paragraph-10",
    "CORE_TYPE_PARAGRAPH_10_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_PARAGRAPH_20_SIZE": 14,
    "CORE_TYPE_PARAGRAPH_20_LEADING": 22,
    "CORE_TYPE_PARAGRAPH_20_TRACKING": 0,
    "CORE_TYPE_PARAGRAPH_20_WEIGHT": 400,
    "CORE_TYPE_PARAGRAPH_20_CASE": "regular",
    "CORE_TYPE_PARAGRAPH_20_NUMBER_SPACING": "default",
    "CORE_TYPE_PARAGRAPH_20_SCALE": "paragraph-20",
    "CORE_TYPE_PARAGRAPH_20_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_PARAGRAPH_30_SIZE": 16,
    "CORE_TYPE_PARAGRAPH_30_LEADING": 24,
    "CORE_TYPE_PARAGRAPH_30_TRACKING": 0,
    "CORE_TYPE_PARAGRAPH_30_WEIGHT": 400,
    "CORE_TYPE_PARAGRAPH_30_CASE": "regular",
    "CORE_TYPE_PARAGRAPH_30_NUMBER_SPACING": "default",
    "CORE_TYPE_PARAGRAPH_30_SCALE": "paragraph-30",
    "CORE_TYPE_PARAGRAPH_30_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_MEDIUM_10_SIZE": 12,
    "CORE_TYPE_MEDIUM_10_LEADING": 18,
    "CORE_TYPE_MEDIUM_10_TRACKING": 0,
    "CORE_TYPE_MEDIUM_10_WEIGHT": 500,
    "CORE_TYPE_MEDIUM_10_CASE": "regular",
    "CORE_TYPE_MEDIUM_10_NUMBER_SPACING": "default",
    "CORE_TYPE_MEDIUM_10_SCALE": "paragraph-10",
    "CORE_TYPE_MEDIUM_10_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_MEDIUM_20_SIZE": 14,
    "CORE_TYPE_MEDIUM_20_LEADING": 22,
    "CORE_TYPE_MEDIUM_20_TRACKING": 0,
    "CORE_TYPE_MEDIUM_20_WEIGHT": 500,
    "CORE_TYPE_MEDIUM_20_CASE": "regular",
    "CORE_TYPE_MEDIUM_20_NUMBER_SPACING": "default",
    "CORE_TYPE_MEDIUM_20_SCALE": "paragraph-20",
    "CORE_TYPE_MEDIUM_20_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_MEDIUM_30_SIZE": 16,
    "CORE_TYPE_MEDIUM_30_LEADING": 24,
    "CORE_TYPE_MEDIUM_30_TRACKING": 0,
    "CORE_TYPE_MEDIUM_30_WEIGHT": 500,
    "CORE_TYPE_MEDIUM_30_CASE": "regular",
    "CORE_TYPE_MEDIUM_30_NUMBER_SPACING": "default",
    "CORE_TYPE_MEDIUM_30_SCALE": "paragraph-30",
    "CORE_TYPE_MEDIUM_30_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_MEDIUM_WEIGHT": 500,
    "CORE_TYPE_SEMIBOLD_10_SIZE": 12,
    "CORE_TYPE_SEMIBOLD_10_LEADING": 18,
    "CORE_TYPE_SEMIBOLD_10_TRACKING": 0,
    "CORE_TYPE_SEMIBOLD_10_WEIGHT": 600,
    "CORE_TYPE_SEMIBOLD_10_CASE": "regular",
    "CORE_TYPE_SEMIBOLD_10_NUMBER_SPACING": "default",
    "CORE_TYPE_SEMIBOLD_10_SCALE": "paragraph-10",
    "CORE_TYPE_SEMIBOLD_10_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_SEMIBOLD_20_SIZE": 14,
    "CORE_TYPE_SEMIBOLD_20_LEADING": 22,
    "CORE_TYPE_SEMIBOLD_20_TRACKING": 0,
    "CORE_TYPE_SEMIBOLD_20_WEIGHT": 600,
    "CORE_TYPE_SEMIBOLD_20_CASE": "regular",
    "CORE_TYPE_SEMIBOLD_20_NUMBER_SPACING": "default",
    "CORE_TYPE_SEMIBOLD_20_SCALE": "paragraph-20",
    "CORE_TYPE_SEMIBOLD_20_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_SEMIBOLD_30_SIZE": 16,
    "CORE_TYPE_SEMIBOLD_30_LEADING": 24,
    "CORE_TYPE_SEMIBOLD_30_TRACKING": 0,
    "CORE_TYPE_SEMIBOLD_30_WEIGHT": 600,
    "CORE_TYPE_SEMIBOLD_30_CASE": "regular",
    "CORE_TYPE_SEMIBOLD_30_NUMBER_SPACING": "default",
    "CORE_TYPE_SEMIBOLD_30_SCALE": "paragraph-30",
    "CORE_TYPE_SEMIBOLD_30_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_SEMIBOLD_WEIGHT": 600,
    "CORE_TYPE_REGULAR_WEIGHT": 400,
    "CORE_TYPE_BOLD_WEIGHT": 700,
    "CORE_TYPE_FONT_FAMILY": "Square Sans Text",
    "CORE_TYPE_MONO_FONT_FAMILY": "Square Sans Mono"
};
/**
 * [PR 29510](https://github.com/Microsoft/TypeScript/pull/29510), available in
 * TypeScript 3.4+, enables us to define the literal string union type
 * `DialogType` based on a readonly array of all possible values (`as const`
 * makes `ALL_DIALOG_TYPES` readonly). This is required to support refactoring
 * from enum to union type while also allowing us to enumerate all possible
 * values (see references of `ALL_DIALOG_TYPES` for use cases).
 *
 * Motivation for the refactor from enum to union type can be found in the
 * description for [PR 1554](https://github.com/squareup/market/pull/1554).
 */ const ALL_DIALOG_TYPES = [
    'modal-full',
    'modal-partial',
    'blade',
    'dialog'
];
const DIALOGS_META = {
    'modal-full': {
        veil: true
    },
    'modal-partial': {
        veil: true
    },
    blade: {
        veil: false
    },
    dialog: {
        veil: true
    }
};
const getDialogSelector = ()=>ALL_DIALOG_TYPES.map((type)=>{
        return getNamespacedTagFor(`market-${type}`);
    }).join(',');
function setupDialogCompactHandler(modal) {
    const main = modal.querySelector('main');
    const header = modal.querySelector(getNamespacedTagFor('market-header'));
    // Manage compact header on scroll unless it's already explicitly set
    if (main && header && !header.compact) main.addEventListener('scroll', ()=>{
        if (main.scrollTop > 0) {
            if (!header.compact) {
                const headingDiv = header.shadowRoot.querySelector('.heading');
                const headingDivStyles = getComputedStyle(headingDiv);
                const paddingTop = Number.parseInt(headingDivStyles.height, 10) + Number.parseInt(headingDivStyles.marginTop, 10);
                main.style.paddingTop = `${paddingTop}px`;
                header.compact = true;
            }
        } else if (header.compact) {
            main.style.paddingTop = '';
            header.compact = false;
        }
    });
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var candidateSelector = /* #__PURE__ */ candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if (isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var getTabIndex = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = getTabIndex(node);
    if (tabIndex < 0 && isScope && !hasTabIndex(node)) return 0;
    return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio(node) {
    return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if (isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    isInert(node) || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */ candidateSelectors.concat('iframe').join(',');
var isFocusable = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};
/*!
* focus-trap 7.5.3
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap.pause();
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0) trapStack[trapStack.length - 1].unpause();
    }
};
var isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Escape' || (e === null || e === void 0 ? void 0 : e.key) === 'Esc' || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Tab' || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var isKeyForward = function isKeyForward(e) {
    return isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var isKeyBackward = function isKeyBackward(e) {
    return isTabEvent(e) && e.shiftKey;
};
var delay = function delay(fn) {
    return setTimeout(fn, 0);
};
// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var findIndex$1 = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var internalTrapStack = [];
var createFocusTrap = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || internalTrapStack;
    var config = _objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: isKeyForward,
        isKeyBackward: isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === 'function' ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === 'function') {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === 'string') {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption('initialFocus');
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || !isFocusable(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption('fallbackFocus');
            }
        }
        if (!node) throw new Error('Your focus-trap needs to have at least one focusable element');
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = tabbable(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = focusable(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return isTabbable(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return isTabbable(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return getTabIndex(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return isTabbable(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return isTabbable(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
        ) throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption('setReturnFocus', previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref2) {
        var target = _ref2.target, event = _ref2.event, _ref2$isBackward = _ref2.isBackward, isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
        target = target || getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = findIndex$1(state.tabbableGroups, function(_ref3) {
                    var firstTabbableNode = _ref3.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = getTabIndex(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = findIndex$1(state.tabbableGroups, function(_ref4) {
                    var lastTabbableNode = _ref4.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = getTabIndex(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption('fallbackFocus');
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if (valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if (getTabIndex(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return getTabIndex(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) tryFocus(nextNode);
            else tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if (isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(event) {
        if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
            return;
        }
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    var checkClick = function checkClick(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener('focusin', checkFocusIn, true);
        doc.addEventListener('mousedown', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('touchstart', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('click', checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener('focusin', checkFocusIn, true);
        doc.removeEventListener('mousedown', checkPointerDown, true);
        doc.removeEventListener('touchstart', checkPointerDown, true);
        doc.removeEventListener('click', checkClick, true);
        doc.removeEventListener('keydown', checkKey, true);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, 'onActivate');
            var onPostActivate = getOption(activateOptions, 'onPostActivate');
            var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = _objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, 'onDeactivate');
            var onPostDeactivate = getOption(options, 'onPostDeactivate');
            var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
            var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (state.paused || !state.active) return this;
            var onPause = getOption(pauseOptions, 'onPause');
            var onPostPause = getOption(pauseOptions, 'onPostPause');
            state.paused = true;
            onPause === null || onPause === void 0 || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === void 0 || onPostPause();
            return this;
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.paused || !state.active) return this;
            var onUnpause = getOption(unpauseOptions, 'onUnpause');
            var onPostUnpause = getOption(unpauseOptions, 'onPostUnpause');
            state.paused = false;
            onUnpause === null || onUnpause === void 0 || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === 'string' ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};
const createAndActivateFocusTrap = (el, focusTrapOptions, focusTrapActivateOptions)=>{
    // Prevent runtime errors when attempting to activate focus trap
    try {
        return createFocusTrap(el, Object.assign(Object.assign({
            allowOutsideClick: true,
            document: document,
            escapeDeactivates: false
        }, focusTrapOptions), {
            tabbableOptions: Object.assign({
                getShadowRoot: true
            }, focusTrapOptions === null || focusTrapOptions === void 0 ? void 0 : focusTrapOptions.tabbableOptions)
        })).activate(focusTrapActivateOptions);
    } catch (e) {
        console.warn(e); // eslint-disable-line no-console
    }
    return undefined;
};
/**
 * Use this util within a MutationObserver callback.
 * This waits for all `addedNodes[].componentOnReady` to be called.
 * @returns {Promise} Promise when the elements are ready
 */ const waitForAddedNodesToBeReady = (mutationList)=>{
    const addedNodes = mutationList.reduce((nodes, record)=>{
        for (const node of record.addedNodes)if (typeof node.componentOnReady === 'function') nodes.push(node);
        return nodes;
    }, []);
    return Promise.all(addedNodes.map(async (node)=>{
        await node.componentOnReady();
        return Promise.resolve();
    }));
};
const marketBladeCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{display:flex;flex-direction:column;justify-content:stretch;overflow:hidden}:host ::slotted(main){flex:0 1 100%;overflow-y:auto;height:100%}:host ::slotted(.market-header){margin-bottom:var(--core-metrics-spacing-300);padding-top:0}:host ::slotted(.market-footer){padding-bottom:0}:host{position:fixed;top:0;right:0;width:100%;max-width:calc(var(--modal-blade-width, 400px) + var(--core-metrics-spacing-400) + var(--core-metrics-spacing-400));height:100vh;padding-top:var(--core-metrics-spacing-400);padding-bottom:var(--core-metrics-spacing-400);background-color:var(--modal-full-background-color);box-shadow:0 2px 16px rgb(0 0 0 / 0.08), 0 4px 8px rgb(0 0 0 / 0.08);animation-name:market-slide-left-enter;animation-duration:var(\n      --blade-animation-enter-transition-duration,\n      var(--core-animation-enter-transition-moderate-speed-duration)\n    );animation-timing-function:var(\n      --blade-animation-enter-transition-easing,\n      var(--core-animation-enter-transition-easing)\n    );animation-fill-mode:forwards}:host ::slotted(*){padding-right:var(--core-metrics-spacing-400);padding-left:var(--core-metrics-spacing-400)}:host([hidden]){animation-name:market-slide-left-exit;animation-duration:var(\n        --blade-animation-exit-transition-duration,\n        var(--core-animation-exit-transition-moderate-speed-duration)\n      );animation-timing-function:var(\n        --blade-animation-exit-transition-easing,\n        var(--core-animation-exit-transition-easing)\n      )}:host([hidden].skip-animation){transform:translateX(100%);animation:none}";
const MarketBlade$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketDialogLoaded = (0, $696Z8.createEvent)(this, "marketDialogLoaded", 7);
        this.marketDialogDismissed = (0, $696Z8.createEvent)(this, "marketDialogDismissed", 7);
        this.marketDialogDidDismiss = (0, $696Z8.createEvent)(this, "marketDialogDidDismiss", 7);
        this.type = 'blade';
        this.observers = {};
        /* Used to skip the exit animation for <market-blade hidden> on load */ this.skipAnimation = false;
        this.hidden = false;
        this.dialogID = undefined;
        this.index = undefined;
        this.animationDuration = cjs.CORE_ANIMATION_ENTER_TRANSITION_MODERATE_SPEED_DURATION;
        this.animationEnterDuration = cjs.CORE_ANIMATION_ENTER_TRANSITION_MODERATE_SPEED_DURATION;
        this.animationExitDuration = cjs.CORE_ANIMATION_EXIT_TRANSITION_MODERATE_SPEED_DURATION;
        this.trapFocus = false;
    }
    reenableAnimation() {
        this.skipAnimation = false;
    }
    /* Listen to the marketHeaderNavigate event emitted by a market-header child component
  so we can emit a close event if needed */ headerNavigateEventHandler(event) {
        const { detail, target } = event;
        // TODO: 'close' should probably come from an enum of some sort
        if (detail.action === 'close') // only dismiss if this is the first ancestor dialog
        {
            if (target.closest(getDialogSelector()) === this.el) this.dismiss();
        }
    }
    /**
   * Emits the dismiss event
   * The parent context will handle actually removing elements from the DOM,
   * All the blade needs to do it emit an event so actually closing it can be
   * some other elements problem
   */ dismiss(options) {
        const { defaultPrevented } = this.marketDialogDismissed.emit({
            dialog: this.el,
            type: this.type,
            origin: (options === null || options === void 0 ? void 0 : options.origin) || this.el
        });
        if (!defaultPrevented) {
            this.hidden = true;
            /**
       * Emit a marketDialogDidDismiss event when modal gets fully dismissed (after animation).
       */ setTimeout(()=>{
                this.marketDialogDidDismiss.emit({
                    dialog: this.el,
                    type: this.type,
                    origin: this.el
                });
            }, this.animationExitDuration);
        }
        return Promise.resolve();
    }
    onTrapFocusChanged(newValue, oldValue) {
        if (newValue !== oldValue) {
            if (newValue) this.activateFocusTrap();
            else this.deactivateFocusTrap();
        }
    }
    /**
   * Activates the focus trap
   * @param {Object} [options] [focus-trap `.createFocusTrap` options](https://github.com/focus-trap/focus-trap#createoptions)
   * @param {Object} [activateOptions] [focus-trap `.activate` options](https://github.com/focus-trap/focus-trap#trapactivate)
   */ activateFocusTrap(options, activateOptions) {
        if (this.focusTrap) {
            this.focusTrap.activate(activateOptions);
            if (!this.trapFocus) this.trapFocus = true;
        } else this.focusTrap = createAndActivateFocusTrap(this.el, options, activateOptions);
        this.focusTrapActivateOptions = activateOptions;
        return Promise.resolve();
    }
    /**
   * Deactivates the focus trap
   * @param {Object} [deactivateOptions] [focus-trap `.deactivate` options](https://github.com/focus-trap/focus-trap#trapdeactivate)
   */ deactivateFocusTrap(deactivateOptions) {
        if (this.focusTrap) {
            this.focusTrap.deactivate(deactivateOptions);
            this.focusTrap = undefined;
        }
        return Promise.resolve();
    }
    initContentObserver() {
        if (!this.observers.content) {
            this.observers.content = new MutationObserver(async (mutations)=>{
                if (this.trapFocus && this.focusTrap) {
                    this.focusTrap.deactivate();
                    await waitForAddedNodesToBeReady(mutations);
                    this.focusTrap.activate(this.focusTrapActivateOptions);
                }
            });
            this.observers.content.observe(this.el, {
                childList: true,
                subtree: true
            });
        }
    }
    connectedCallback() {
        /**
     * Emit a dialogLoaded event when the component connects. Need this so
     * the context manager isn't rummaging around it's DOM to try and find the
     * dialog that was just appended
     */ setTimeout(()=>{
            this.marketDialogLoaded.emit({
                dialog: this.el,
                type: this.type
            });
            if (this.trapFocus) this.activateFocusTrap();
        }, this.animationEnterDuration);
    }
    componentWillLoad() {
        const header = this.el.querySelector(getNamespacedTagFor('market-header'));
        if (header) // We want to force the header to be navigable when slotted into blade
        header.showNavigation = true;
        if (this.hidden) this.skipAnimation = true;
        setupDialogCompactHandler(this.el);
    }
    componentDidLoad() {
        this.initContentObserver();
    }
    disconnectedCallback() {
        this.deactivateFocusTrap();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            role: "dialog",
            class: classNames('market-blade', {
                'skip-animation': this.skipAnimation
            })
        }, (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "hidden": [
                "reenableAnimation"
            ],
            "trapFocus": [
                "onTrapFocusChanged"
            ]
        };
    }
    static get style() {
        return marketBladeCss;
    }
};
const getAriaAttributes = (el)=>{
    // create an object with all aria-* attributes on host element
    return el.getAttributeNames().filter((attr)=>attr.startsWith('aria-')).reduce((acc, attr)=>{
        const value = el.getAttribute(attr);
        if (value !== null) acc[attr] = value;
        return acc;
    }, {});
};
/**
 * Watch for aria attribute changes on host element.
 */ const observeAriaAttributes = (el, onMutationObserved)=>{
    const mutationObserver = new MutationObserver(()=>{
        const ariaAttributes = getAriaAttributes(el);
        return onMutationObserved(ariaAttributes);
    });
    mutationObserver.observe(el, {
        attributes: true
    });
    return mutationObserver;
};
/**
 * ARIA LABELS
 *
 * It's currently not possible to make label/input associations across the
 * shadow DOM boundary. These helpers are intended to act as a lightweight a11y
 * solution by allowing our input and control components to set their own
 * aria-label attributes based on what is being used to label them.
 *
 * https://developer.salesforce.com/blogs/2020/01/accessibility-for-web-components.html
 * https://nolanlawson.com/2022/11/28/shadow-dom-and-accessibility-the-trouble-with-aria
 * https://github.com/whatwg/html/issues/3219
 */ /**
 * Returns the the aria-label attribute to set on text input components:
 *   <market-input-text>
 *   <market-select>
 *   <market-textarea>
 *   <market-input-password> (via its internal market-input-text)
 *
 * These components expect a <label> element in the default slot to use as the
 * floating input label. Falls back to the component's `name` attribute if no
 * label can be found.
 *
 * @param inputEl The input element that needs an aria-label
 */ const getTextInputAriaLabel = (inputEl)=>{
    var _a;
    const slottedLabel = // label slotted directly into input component
    inputEl.querySelector('label:not([slot])') || (// label slotted into a higher-level component (market-input-password)
    (_a = inputEl.getRootNode().host) === null || _a === void 0 ? void 0 : _a.querySelector('label:not([slot])'));
    return (slottedLabel === null || slottedLabel === void 0 ? void 0 : slottedLabel.innerHTML) || inputEl.getAttribute('name') || undefined;
};
/**
 * Returns the aria-label attribute to set on control components:
 *   <market-checkbox>
 *   <market-radio>
 *   <market-toggle>
 *
 * When used as a slotted control in <market-row>, the row handles setting the
 * aria-label of the control to match its own slotted label element. Otherwise,
 * if a consumer sets the aria-labelledby or aria-label attribute on the Market
 * component, the correct label text will be reflected in the shadow DOM.
 *
 * Adapted from Ionic Framework's getAriaLabel() helper:
 * https://github.com/ionic-team/ionic-framework/blob/main/core/src/utils/helpers.ts#L275-L332
 *
 * @param controlEl The control element that needs an aria-label
 */ const getControlInputAriaLabel = (controlEl)=>{
    var _a;
    const attrIsValid = (attr)=>attr !== null && attr.trim() !== '';
    let controlAriaLabel;
    // aria-labelledby takes precedence
    const ariaLabelledBy = controlEl.getAttribute('aria-labelledby');
    if (attrIsValid(ariaLabelledBy)) {
        const labelledByText = (_a = document.getElementById(ariaLabelledBy)) === null || _a === void 0 ? void 0 : _a.textContent;
        controlAriaLabel = controlAriaLabel || labelledByText;
    }
    // aria-label
    const ariaLabel = controlEl.getAttribute('aria-label');
    if (attrIsValid(ariaLabel)) controlAriaLabel = controlAriaLabel || ariaLabel;
    return controlAriaLabel || controlEl.getAttribute('name') || undefined;
};
const marketButtonCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--transition-duration:0.2s;position:relative;display:inline-block;border-radius:var(--button-border-radius);transition:background-color color var(--transition-duration)}.inner-tag{display:inline-flex;justify-content:center;align-items:center;width:100%;border:none;border-radius:var(--button-border-radius);background-color:transparent;color:inherit;outline:none;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;text-align:center;text-decoration:none;cursor:pointer}.inner-tag .focus-ring{--focus-ring-position:calc(-1 * (0px + var(--button-focus-ring-buffer-size) + var(--button-focus-ring-border-size)));content:'';position:absolute;top:var(--focus-ring-position);right:var(--focus-ring-position);bottom:var(--focus-ring-position);left:var(--focus-ring-position);display:block;border:var(--button-focus-ring-border-size) solid var(--button-focus-ring-color);border-radius:calc(var(--button-border-radius) + var(--button-focus-ring-buffer-size) * 2);opacity:0;pointer-events:none;transition:opacity 0.2s;}.inner-tag:focus-visible .focus-ring{opacity:0.5}svg,::slotted([slot=\"icon\"]){position:relative;display:flex;color:inherit;fill:currentColor;stroke:inherit}:host([icon-only]) svg,:host([icon-only]) ::slotted([slot=\"icon\"]){fill:inherit}.market-activity-indicator{position:absolute;top:50%;left:50%;line-height:0;opacity:0;transform:translate(-50%, -50%)}:host([is-loading]){pointer-events:none}:host([is-loading]) .inner-tag{opacity:0}:host([is-loading]) .market-activity-indicator{opacity:1}:host([size=\"small\"]){--button-small-size-minimum-width:var(--button-small-size-minimum-height);font-weight:var(--button-small-size-text-weight);font-size:var(--button-small-size-text-size);line-height:var(--button-small-size-text-leading);letter-spacing:var(--button-small-size-text-tracking)}:host([size=\"small\"]) .inner-tag{min-width:var(--button-small-size-minimum-width);min-height:var(--button-small-size-minimum-height);-moz-column-gap:var(--button-small-size-content-spacing);column-gap:var(--button-small-size-content-spacing)}:host([size=\"small\"][rank=\"primary\"]) .inner-tag{padding:var(--button-small-size-primary-rank-vertical-padding)\n      var(--button-small-size-primary-rank-horizontal-padding)}:host([size=\"small\"][rank=\"primary\"]) svg,:host([size=\"small\"][rank=\"primary\"]) ::slotted([slot=\"icon\"]){margin:calc(\n        (var(--button-small-size-minimum-height) - var(--accessory-icon-variant-size)) / 2\n        - var(--button-small-size-primary-rank-vertical-padding)\n      ) 0}:host([size=\"small\"][rank=\"secondary\"]) .inner-tag{padding:var(--button-small-size-secondary-rank-vertical-padding)\n      var(--button-small-size-secondary-rank-horizontal-padding)}:host([size=\"small\"][rank=\"secondary\"]) svg,:host([size=\"small\"][rank=\"secondary\"]) ::slotted([slot=\"icon\"]){margin:calc(\n        (var(--button-small-size-minimum-height) - var(--accessory-icon-variant-size)) / 2\n        - var(--button-small-size-secondary-rank-vertical-padding)\n      ) 0}:host([size=\"small\"][rank=\"tertiary\"]) .inner-tag{padding:var(--button-small-size-tertiary-rank-vertical-padding)\n      var(--button-small-size-tertiary-rank-horizontal-padding)}:host([size=\"small\"][rank=\"tertiary\"]) svg,:host([size=\"small\"][rank=\"tertiary\"]) ::slotted([slot=\"icon\"]){margin:calc(\n        (var(--button-small-size-minimum-height) - var(--accessory-icon-variant-size)) / 2\n        - var(--button-small-size-tertiary-rank-vertical-padding)\n      ) 0}:host([size=\"small\"][icon-only]) .inner-tag{padding:var(--icon-button-small-size-padding-size)}:host([size=\"medium\"]){--button-medium-size-minimum-width:var(--button-medium-size-minimum-height);font-weight:var(--button-medium-size-text-weight);font-size:var(--button-medium-size-text-size);line-height:var(--button-medium-size-text-leading);letter-spacing:var(--button-medium-size-text-tracking)}:host([size=\"medium\"]) .inner-tag{min-width:var(--button-medium-size-minimum-width);min-height:var(--button-medium-size-minimum-height);-moz-column-gap:var(--button-medium-size-content-spacing);column-gap:var(--button-medium-size-content-spacing)}:host([size=\"medium\"][rank=\"primary\"]) .inner-tag{padding:var(--button-medium-size-primary-rank-vertical-padding)\n      var(--button-medium-size-primary-rank-horizontal-padding)}:host([size=\"medium\"][rank=\"secondary\"]) .inner-tag{padding:var(--button-medium-size-secondary-rank-vertical-padding)\n      var(--button-medium-size-secondary-rank-horizontal-padding)}:host([size=\"medium\"][rank=\"tertiary\"]) .inner-tag{padding:var(--button-medium-size-tertiary-rank-vertical-padding)\n      var(--button-medium-size-tertiary-rank-horizontal-padding)}:host([size=\"medium\"][icon-only]) .inner-tag{padding:var(--icon-button-medium-size-padding-size)}:host([size=\"large\"]){--button-large-size-minimum-width:var(--button-large-size-minimum-height);font-weight:var(--button-large-size-text-weight);font-size:var(--button-large-size-text-size);line-height:var(--button-large-size-text-leading);letter-spacing:var(--button-large-size-text-tracking)}:host([size=\"large\"]) .inner-tag{min-width:var(--button-large-size-minimum-width);min-height:var(--button-large-size-minimum-height);-moz-column-gap:var(--button-large-size-content-spacing);column-gap:var(--button-large-size-content-spacing)}:host([size=\"large\"][rank=\"primary\"]) .inner-tag{padding:var(--button-large-size-primary-rank-vertical-padding)\n      var(--button-large-size-primary-rank-horizontal-padding)}:host([size=\"large\"][rank=\"secondary\"]) .inner-tag{padding:var(--button-large-size-secondary-rank-vertical-padding)\n      var(--button-large-size-secondary-rank-horizontal-padding)}:host([size=\"large\"][rank=\"tertiary\"]) .inner-tag{padding:var(--button-large-size-tertiary-rank-vertical-padding)\n      var(--button-large-size-tertiary-rank-horizontal-padding)}:host([size=\"large\"][icon-only]) .inner-tag{padding:var(--icon-button-large-size-padding-size)}:host([rank=\"primary\"]){background-color:var(--button-normal-variant-primary-rank-normal-state-background-color);color:var(--button-normal-variant-primary-rank-normal-state-label-color)}:host([rank=\"primary\"][icon-only]){fill:var(--icon-button-primary-rank-normal-state-icon-color)}@media (hover: hover){:host([rank=\"primary\"]:hover){background-color:var(--button-normal-variant-primary-rank-hover-state-background-color);color:var(--button-normal-variant-primary-rank-hover-state-label-color)}:host([rank=\"primary\"][icon-only]:hover){fill:var(--icon-button-primary-rank-hover-state-icon-color)}}:host([rank=\"primary\"][focused]){background-color:var(--button-normal-variant-primary-rank-focus-state-background-color);color:var(--button-normal-variant-primary-rank-focus-state-label-color)}:host([rank=\"primary\"][icon-only][focused]){fill:var(--icon-button-primary-rank-focus-state-icon-color)}:host([rank=\"primary\"]:active){background-color:var(--button-normal-variant-primary-rank-pressed-state-background-color);color:var(--button-normal-variant-primary-rank-pressed-state-label-color)}:host([rank=\"primary\"][icon-only]:active){fill:var(--icon-button-primary-rank-pressed-state-icon-color)}:host([rank=\"primary\"][disabled]){background-color:var(--button-normal-variant-primary-rank-disabled-state-background-color);color:var(--button-normal-variant-primary-rank-disabled-state-label-color)}:host([rank=\"primary\"][icon-only][disabled]){fill:var(--icon-button-primary-rank-disabled-state-icon-color)}:host([rank=\"secondary\"]){background-color:var(--button-normal-variant-secondary-rank-normal-state-background-color);color:var(--button-normal-variant-secondary-rank-normal-state-label-color)}:host([rank=\"secondary\"][icon-only]){fill:var(--icon-button-secondary-rank-normal-state-icon-color)}@media (hover: hover){:host([rank=\"secondary\"]:hover){background-color:var(--button-normal-variant-secondary-rank-hover-state-background-color);color:var(--button-normal-variant-secondary-rank-hover-state-label-color)}:host([rank=\"secondary\"][icon-only]:hover){fill:var(--icon-button-secondary-rank-hover-state-icon-color)}}:host([rank=\"secondary\"][focused]){background-color:var(--button-normal-variant-secondary-rank-focus-state-background-color);color:var(--button-normal-variant-secondary-rank-focus-state-label-color)}:host([rank=\"secondary\"][icon-only][focused]){fill:var(--icon-button-secondary-rank-focus-state-icon-color)}:host([rank=\"secondary\"]:active){background-color:var(--button-normal-variant-secondary-rank-pressed-state-background-color);color:var(--button-normal-variant-secondary-rank-pressed-state-label-color)}:host([rank=\"secondary\"][icon-only]:active){fill:var(--icon-button-secondary-rank-pressed-state-icon-color)}:host([rank=\"secondary\"][disabled]){background-color:var(--button-normal-variant-secondary-rank-disabled-state-background-color);color:var(--button-normal-variant-secondary-rank-disabled-state-label-color)}:host([rank=\"secondary\"][icon-only][disabled]){fill:var(--icon-button-secondary-rank-disabled-state-icon-color)}:host([rank=\"tertiary\"]){background-color:var(--button-normal-variant-tertiary-rank-normal-state-background-color);color:var(--button-normal-variant-tertiary-rank-normal-state-label-color)}:host([rank=\"tertiary\"][icon-only]){fill:var(--icon-button-tertiary-rank-normal-state-icon-color)}@media (hover: hover){:host([rank=\"tertiary\"]:hover){background-color:var(--button-normal-variant-tertiary-rank-hover-state-background-color);color:var(--button-normal-variant-tertiary-rank-hover-state-label-color)}:host([rank=\"tertiary\"][icon-only]:hover){fill:var(--icon-button-tertiary-rank-hover-state-icon-color)}}:host([rank=\"tertiary\"][focused]){background-color:var(--button-normal-variant-tertiary-rank-focus-state-background-color);color:var(--button-normal-variant-tertiary-rank-focus-state-label-color)}:host([rank=\"tertiary\"][icon-only][focused]){fill:var(--icon-button-tertiary-rank-focus-state-icon-color)}:host([rank=\"tertiary\"]:active){background-color:var(--button-normal-variant-tertiary-rank-pressed-state-background-color);color:var(--button-normal-variant-tertiary-rank-pressed-state-label-color)}:host([rank=\"tertiary\"][icon-only]:active){fill:var(--icon-button-tertiary-rank-pressed-state-icon-color)}:host([rank=\"tertiary\"][disabled]){background-color:var(--button-normal-variant-tertiary-rank-disabled-state-background-color);color:var(--button-normal-variant-tertiary-rank-disabled-state-label-color)}:host([rank=\"tertiary\"][icon-only][disabled]){fill:var(--icon-button-tertiary-rank-disabled-state-icon-color)}:host([variant=\"destructive\"][rank=\"primary\"]){background-color:var(--button-destructive-variant-primary-rank-normal-state-background-color);color:var(--button-destructive-variant-primary-rank-normal-state-label-color)}@media (hover: hover){:host([variant=\"destructive\"][rank=\"primary\"]:hover){background-color:var(--button-destructive-variant-primary-rank-hover-state-background-color);color:var(--button-destructive-variant-primary-rank-hover-state-label-color)}}:host([variant=\"destructive\"][rank=\"primary\"][focused]){background-color:var(--button-destructive-variant-primary-rank-focus-state-background-color);color:var(--button-destructive-variant-primary-rank-focus-state-label-color)}:host([variant=\"destructive\"][rank=\"primary\"]:active){background-color:var(--button-destructive-variant-primary-rank-pressed-state-background-color);color:var(--button-destructive-variant-primary-rank-pressed-state-label-color)}:host([variant=\"destructive\"][rank=\"primary\"][disabled]){background-color:var(--button-destructive-variant-primary-rank-disabled-state-background-color);color:var(--button-destructive-variant-primary-rank-disabled-state-label-color)}:host([variant=\"destructive\"][rank=\"secondary\"]){background-color:var(--button-destructive-variant-secondary-rank-normal-state-background-color);color:var(--button-destructive-variant-secondary-rank-normal-state-label-color)}@media (hover: hover){:host([variant=\"destructive\"][rank=\"secondary\"]:hover){background-color:var(--button-destructive-variant-secondary-rank-hover-state-background-color);color:var(--button-destructive-variant-secondary-rank-hover-state-label-color)}}:host([variant=\"destructive\"][rank=\"secondary\"][focused]){background-color:var(--button-destructive-variant-secondary-rank-focus-state-background-color);color:var(--button-destructive-variant-secondary-rank-focus-state-label-color)}:host([variant=\"destructive\"][rank=\"secondary\"]:active){background-color:var(--button-destructive-variant-secondary-rank-pressed-state-background-color);color:var(--button-destructive-variant-secondary-rank-pressed-state-label-color)}:host([variant=\"destructive\"][rank=\"secondary\"][disabled]){background-color:var(--button-destructive-variant-secondary-rank-disabled-state-background-color);color:var(--button-destructive-variant-secondary-rank-disabled-state-label-color)}:host([variant=\"destructive\"][rank=\"tertiary\"]){background-color:var(--button-destructive-variant-tertiary-rank-normal-state-background-color);color:var(--button-destructive-variant-tertiary-rank-normal-state-label-color)}@media (hover: hover){:host([variant=\"destructive\"][rank=\"tertiary\"]:hover){background-color:var(--button-destructive-variant-tertiary-rank-hover-state-background-color);color:var(--button-destructive-variant-tertiary-rank-hover-state-label-color)}}:host([variant=\"destructive\"][rank=\"tertiary\"][focused]){background-color:var(--button-destructive-variant-tertiary-rank-focus-state-background-color);color:var(--button-destructive-variant-tertiary-rank-focus-state-label-color)}:host([variant=\"destructive\"][rank=\"tertiary\"]:active){background-color:var(--button-destructive-variant-tertiary-rank-pressed-state-background-color);color:var(--button-destructive-variant-tertiary-rank-pressed-state-label-color)}:host([variant=\"destructive\"][rank=\"tertiary\"][disabled]){background-color:var(--button-destructive-variant-tertiary-rank-disabled-state-background-color);color:var(--button-destructive-variant-tertiary-rank-disabled-state-label-color)}";
const MarketButton$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        // Implicit submission is when an interaction within a form fires a click event on the form's first submit button in tree order.
        // Because the inner <button> of <market-button> is in the shadow dom and not in tree order, we lose this functionality.
        // To ensure we have the exact behavior that a plain button would have had in this situation,
        // we add a hidden button to the form and click it for the implicit submission.
        // https://www.hjorthhansen.dev/shadow-dom-and-forms/
        // note: this is attached in the host element's onclick instead of with the @Listen decorator
        // to ensure the following fire in the correct order:
        // 1) handleClick
        // 2) the event passed to market-button
        // 3) implicit submission
        // In Ember, the @Listen would fire before the event passed to the button, which could result in the event not happening.
        this.handleImplicitSubmission = ()=>{
            if (this.type === 'submit') {
                const form = this.el.closest('form');
                if (form) {
                    const fakeButton = document.createElement('button');
                    fakeButton.type = this.type;
                    fakeButton.style.display = 'none';
                    form.appendChild(fakeButton);
                    fakeButton.click();
                    fakeButton.remove();
                }
            }
        };
        this.onMutationObserved = (ariaAttributes)=>{
            this.ariaAttributes = ariaAttributes;
        };
        this.caret = 'none';
        this.disabled = false;
        this.download = undefined;
        this.focused = false;
        this.href = undefined;
        this.iconOnly = false;
        this.innerTabindex = undefined;
        this.isLoading = false;
        this.rank = 'secondary';
        this.rel = undefined;
        this.size = 'medium';
        this.target = undefined;
        this.type = 'button';
        this.variant = 'regular';
        this.ariaAttributes = undefined;
    }
    focusedChangeHandler(newValue) {
        if (!this.innerTag) return;
        if (newValue) this.innerTag.focus();
        else this.innerTag.blur();
    }
    /* Listening for click events here allows us to stop bubbling when
  disabled. Attaching listeners to Host (as the Stencil linter prefers),
  seems to also work in Stencil tests, but fails in Ember for some reason.
  We listen in the "capture" phase to ensure we're hit before any external
  click handlers. See here for details:
  https://www.sitepoint.com/event-bubbling-javascript/ */ handleClick(event) {
        if (this.disabled || this.isLoading) // Calling `stopImmediatePropagation` instead of `stopPropagation`
        // allows us to block current and future "sibling" event listeners
        // that have also been attached to this element, as opposed to just
        // those higher in the DOM tree.
        event.stopImmediatePropagation();
    }
    /**
   * Sets `focused` state, except when disabled. Allows external consumers to programmatically
   * trigger focused styling.
   */ setFocus(value = true) {
        if (this.disabled) return Promise.resolve();
        this.focused = value;
        return Promise.resolve();
    }
    handleSlotChange() {
        const iconSlot = this.el.querySelector('[slot="icon"]');
        const hasIcon = Boolean(iconSlot);
        const buttonText = this.el.textContent.trim();
        let hasLabelText;
        if (hasIcon) {
            // Check for text in the icon itself, such as icon badge text. This text is considered part of the icon and not a label.
            // Since buttonText contains all text in the element including the svg, only set hasLabelText to true if text exists outside of the icon.
            const iconText = iconSlot.textContent.trim();
            hasLabelText = buttonText.length > iconText.length;
        } else hasLabelText = buttonText.length > 0;
        this.iconOnly = hasIcon && !hasLabelText;
    }
    componentWillLoad() {
        this.mutationObserver = observeAriaAttributes(this.el, this.onMutationObserved);
        this.handleSlotChange();
    }
    render() {
        const { // props
        caret, disabled, href, innerTabindex, isLoading, target, type, rel, download, // state
        ariaAttributes, // methods
        handleImplicitSubmission } = this;
        const TagType = href === undefined ? 'button' : 'a';
        const ariaRole = TagType === 'button' ? 'button' : 'link';
        const TagTypeAttrs = TagType === 'button' ? {
            type: type,
            disabled: disabled
        } : {
            href: href,
            target: target,
            rel: rel,
            download: download
        };
        const MarketActivityIndicatorTagName = getNamespacedTagFor('market-activity-indicator');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-button",
            role: ariaRole,
            "aria-disabled": disabled,
            onClick: handleImplicitSubmission
        }, (0, $696Z8.h)(TagType, Object.assign({
            class: "inner-tag"
        }, TagTypeAttrs, ariaAttributes, {
            tabindex: disabled ? -1 : innerTabindex,
            onFocus: ()=>{
                this.focused = true;
            },
            onBlur: ()=>{
                this.focused = false;
            },
            ref: (el)=>this.innerTag = el
        }), (0, $696Z8.h)("span", {
            class: "focus-ring"
        }), (0, $696Z8.h)("slot", {
            name: "icon",
            onSlotchange: ()=>this.handleSlotChange()
        }), (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.handleSlotChange()
        }), caret === 'down' && (0, $696Z8.h)("svg", {
            width: "14",
            height: "8",
            viewBox: "0 0 14 8",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292895 1.70711L1.70711 0.292892L7 5.58579L12.2929 0.292893L13.7071 1.70711L7.70711 7.70711Z"
        })), caret === 'up' && (0, $696Z8.h)("svg", {
            width: "14",
            height: "8",
            viewBox: "0 0 14 8",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6.29291 0.292893C6.68343 -0.0976311 7.3166 -0.0976311 7.70712 0.292893L13.7071 6.29289L12.2929 7.70711L7.00001 2.41421L1.70712 7.70711L0.292908 6.29289L6.29291 0.292893Z"
        }))), isLoading && (0, $696Z8.h)(MarketActivityIndicatorTagName, {
            size: "small"
        }));
    }
    disconnectedCallback() {
        var _a;
        (_a = this.mutationObserver) === null || _a === void 0 || _a.disconnect();
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "focused": [
                "focusedChangeHandler"
            ]
        };
    }
    static get style() {
        return marketButtonCss;
    }
};
const supportedDropdownTriggers = Object.freeze([
    getNamespacedTagFor('market-button'),
    getNamespacedTagFor('market-link'),
    getNamespacedTagFor('market-filter-button')
]);
const marketButtonDropdownCss = ":host{display:inline-block}svg{fill:transparent}";
/**
 * Type guard to check if the supported trigger element is a `market-button`
 */ function isMarketButton(el) {
    return el.tagName.toLowerCase() === getNamespacedTagFor('market-button');
}
const MarketButtonDropdown$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketButtonDropdownOpened = (0, $696Z8.createEvent)(this, "marketButtonDropdownOpened", 7);
        this.marketButtonDropdownClosed = (0, $696Z8.createEvent)(this, "marketButtonDropdownClosed", 7);
        this.interaction = 'click';
        this.disabled = false;
        this.noCaret = false;
        this.popoverPlacement = 'bottom-end';
        this.persistListSelections = false;
        this.dropdownIsActive = false;
    }
    dropdownOpenedEventHandler() {
        this.dropdownIsActive = true;
        this.setCaret();
        this.marketButtonDropdownOpened.emit();
    }
    dropdownClosedEventHandler() {
        this.dropdownIsActive = false;
        this.setCaret();
        this.marketButtonDropdownClosed.emit();
    }
    syncTriggerDisabledState() {
        if (this.slottedButton) this.slottedButton.disabled = this.disabled;
    }
    setCaret() {
        if (this.noCaret || !isMarketButton(this.slottedButton)) return;
        if (this.dropdownIsActive) this.slottedButton.caret = 'up';
        else this.slottedButton.caret = 'down';
    }
    registerTrigger() {
        this.slottedButton = this.el.querySelector(supportedDropdownTriggers.join(','));
        this.syncTriggerDisabledState();
        this.setCaret();
    }
    componentWillRender() {
        const markeListTagName = getNamespacedTagFor('market-list');
        const list = this.el.querySelector(markeListTagName);
        if (list) {
            // We set this here even though market-popover also sets it,
            // because the slotted market-list's componentWillLoad hook
            // will fire before market-popover's, and we need it to be set
            // before the row processing that happens in that hook.
            list.interactive = true;
            list.transient = !this.persistListSelections;
        }
    }
    render() {
        const MarketDropdownTagName = getNamespacedTagFor('market-dropdown');
        const MarketPopoverTagName = getNamespacedTagFor('market-popover');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-button-dropdown",
            "aria-expanded": this.dropdownIsActive
        }, (0, $696Z8.h)(MarketDropdownTagName, {
            interaction: this.interaction,
            "popover-placement": this.popoverPlacement,
            disabled: this.disabled
        }, (0, $696Z8.h)("slot", {
            name: "trigger",
            slot: "trigger",
            onSlotchange: ()=>this.registerTrigger()
        }), (0, $696Z8.h)(MarketPopoverTagName, {
            slot: "popover",
            part: "popover"
        }, (0, $696Z8.h)("slot", {
            name: "content"
        }))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "disabled": [
                "syncTriggerDisabledState"
            ]
        };
    }
    static get style() {
        return marketButtonDropdownCss;
    }
};
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Built-in value references. */ var Symbol$1 = root.Symbol;
/** Used for built-in method references. */ var objectProto$b = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$8 = objectProto$b.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString$1 = objectProto$b.toString;
/** Built-in value references. */ var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty$8.call(value, symToStringTag$1), tag = value[symToStringTag$1];
    try {
        value[symToStringTag$1] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString$1.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag$1] = tag;
        else delete value[symToStringTag$1];
    }
    return result;
}
/** Used for built-in method references. */ var objectProto$a = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto$a.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/** `Object#toString` result references. */ var symbolTag$1 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$1;
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length1 = array == null ? 0 : array.length, result = Array(length1);
    while(++index < length1)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/** Used as references for various `Number` constants. */ var INFINITY$2 = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined, symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag$1 = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/** Used for built-in method references. */ var funcProto$1 = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString$1 = funcProto$1.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString$1.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto$9 = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length1 = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length1){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length1 = array.length;
    while(++index < length1){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length1 = array == null ? 0 : array.length;
    return !!length1 && baseIndexOf(array, value, 0) > -1;
}
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER$1 = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length1) {
    var type = typeof value;
    length1 = length1 == null ? MAX_SAFE_INTEGER$1 : length1;
    return !!length1 && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length1;
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/** Used for built-in method references. */ var objectProto$8 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$8;
    return value === proto;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/** `Object#toString` result references. */ var argsTag$2 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}
/** Used for built-in method references. */ var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty$6.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
/** Detect free variable `exports`. */ var freeExports$1 = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule$1 = freeExports$1 && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
/** Built-in value references. */ var Buffer = moduleExports$1 ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/** `Object#toString` result references. */ var argsTag$1 = '[object Arguments]', arrayTag$1 = '[object Array]', boolTag$1 = '[object Boolean]', dateTag$1 = '[object Date]', errorTag$1 = '[object Error]', funcTag = '[object Function]', mapTag$2 = '[object Map]', numberTag$1 = '[object Number]', objectTag$2 = '[object Object]', regexpTag$1 = '[object RegExp]', setTag$2 = '[object Set]', stringTag$1 = '[object String]', weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]', dataViewTag$2 = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/** Used for built-in method references. */ var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length1 = result.length;
    for(var key in value)if ((inherited || hasOwnProperty$5.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length1)))) result.push(key);
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/** Used for built-in method references. */ var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty$4.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED$2 ? undefined : result;
    }
    return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}
/** Used for built-in method references. */ var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty$2.call(data, key);
}
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
    return this;
}
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length1 = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length1){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length1 = array.length;
    while(length1--){
        if (eq(array[length1][0], key)) return length1;
    }
    return -1;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length1 = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length1){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/* Built-in method references that are verified to be native. */ var Map$1 = getNative(root, 'Map');
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map$1 || ListCache),
        'string': new Hash
    };
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length1 = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length1){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/** Error message constants. */ var FUNC_ERROR_TEXT$2 = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT$2);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
/** Used as references for various `Number` constants. */ var INFINITY$1 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length1 = path.length;
    while(object != null && index < length1)object = object[toKey(path[index++])];
    return index && index == length1 ? object : undefined;
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length1 = values.length, offset = array.length;
    while(++index < length1)array[offset + index] = values[index];
    return array;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE$1 = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length1 = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length1){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/** Used for built-in method references. */ var objectProto$2 = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
/* Built-in method references that are verified to be native. */ var Promise$1 = getNative(root, 'Promise');
/* Built-in method references that are verified to be native. */ var Set$1 = getNative(root, 'Set');
/** `Object#toString` result references. */ var mapTag$1 = '[object Map]', objectTag$1 = '[object Object]', promiseTag = '[object Promise]', setTag$1 = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag$1 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$1 || Map$1 && getTag(new Map$1) != mapTag$1 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1) != setTag$1 || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag$1;
        case mapCtorString:
            return mapTag$1;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag$1;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
const getTag$1 = getTag;
/** Built-in value references. */ var Uint8Array$1 = root.Uint8Array;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length1 = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length1)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length1 = array == null ? 0 : array.length;
    while(++index < length1){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG$2;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$3 = 1;
/** Used for built-in method references. */ var objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$2 = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag$1(object), othTag = othIsArr ? arrayTag : getTag$1(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length1 = index, noCustomizer = !customizer;
    if (object == null) return !length1;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length1){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length1 = result.length;
    while(length1--){
        var key = result[length1], value = object[key];
        result[length1] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length1 = path.length, result = false;
    while(++index < length1){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length1) return result;
    length1 = object == null ? 0 : object.length;
    return !!length1 && isLength(length1) && isIndex(key, length1) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
/** Error message constants. */ var FUNC_ERROR_TEXT$1 = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce$2(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT$1);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length1 = array == null ? 0 : array.length;
    while(++index < length1){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return debounce$2(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set$1 && 1 / setToArray(new Set$1([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set$1(values);
};
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length1 = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length1 >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length1){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee)) : [];
}
/**
 * Promisified `window.requestAnimationFrame`
 */ function asyncRequestAnimationFrame() {
    return new Promise((resolve)=>{
        var _a;
        ((_a = window === null || window === void 0 ? void 0 : window.requestAnimationFrame) === null || _a === void 0 ? void 0 : _a.call(window, ()=>resolve())) || resolve();
    });
}
const marketButtonGroupCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:flex}.content{display:flex;flex:1;flex-direction:row;flex-wrap:nowrap;gap:var(--button-group-spacing)}:host([alignment='right']) .content{flex-direction:row-reverse}:host([alignment='left']) .content{justify-content:flex-start}:host([alignment='split']) .content{flex-direction:row-reverse;justify-content:flex-end}:host([alignment='split']) .content ::slotted(.market-button:first-of-type){margin-left:auto}:host([alignment='fill']) .content{flex-direction:row-reverse}:host([alignment='fill']) .content ::slotted(.market-button){flex:1}:host([alignment='stack']) .content{flex-direction:column}[slot=\"content\"]{display:flex;flex-direction:column;gap:var(--button-group-spacing)}::slotted([slot=\"overflow-buttons\"]){width:100%}";
const MAX_VISIBLE_BUTTONS = 2;
const DROPDOWN_MENU_BUTTON_WIDTH = 48;
const RESIZE_DEBOUNCE_DURATION$2 = 16; // 60fps
const MarketButtonGroup$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
     * References to the button elements
     */ this._buttonEls = [];
        /**
     * Observers
     */ this._observers = {};
        this.throttledHandleResize = throttle(this.handleResize.bind(this), RESIZE_DEBOUNCE_DURATION$2);
        this.alignment = 'right';
        this._sortedButtonEls = {
            overflow: [],
            visible: []
        };
    }
    getComputedWidth(el) {
        return Number.parseFloat(window.getComputedStyle(el).width);
    }
    /**
   * Find out where the cutoff will happen.
   * Main chunk of the overflow logic happens here
   */ async findButtonCutoffIndex() {
        if (this.alignment === 'stack') // buttons are full width so no overflow necessary
        return this._buttonEls.length;
        const buttonGroupWidth = this.getComputedWidth(this.el);
        /**
     * Temporary container where we can measure button widths
     * https://dev.to/sstraatemans/calculate-html-element-width-before-render-4ii7
     */ const tempEl = document.createElement('div');
        tempEl.style.width = 'auto';
        tempEl.style.position = 'absolute';
        tempEl.style.visibility = 'hidden';
        this.el.shadowRoot.appendChild(tempEl);
        let index = 0;
        let buttonWidths = 0;
        for (const buttonEl of this._buttonEls){
            if (index === MAX_VISIBLE_BUTTONS) break;
            /**
       * Presuming that all the remaining buttons (**excluding** the current one, i.e. `buttonEl`)
       * will be overflowed, calculate the potential dropdown menu button width.
       * If this is the last button, it will not be followed by a `market-button-dropdown-menu`.
       */ const dropdownMenuButtonWidth = index + 1 === this._buttonEls.length // is this the last one?
             ? 0 : cjs.BUTTON_GROUP_SPACING + DROPDOWN_MENU_BUTTON_WIDTH;
            // measure the button's width in the temporary container
            const clonedButtonEl = buttonEl.cloneNode(true);
            clonedButtonEl.style.display = 'block';
            tempEl.appendChild(clonedButtonEl);
            // let the shadow DOM render within the temp container first before measuring its width
            await asyncRequestAnimationFrame();
            const buttonElWidth = this.getComputedWidth(tempEl);
            tempEl.removeChild(clonedButtonEl);
            // width of all the buttons so far; gap is only added for buttons after the first
            buttonWidths += (index > 0 ? cjs.BUTTON_GROUP_SPACING : 0) + buttonElWidth;
            // check if button can fit
            const potentialWidth = buttonWidths + dropdownMenuButtonWidth;
            if (potentialWidth >= buttonGroupWidth) break;
            ++index;
        }
        // cleanup
        this.el.shadowRoot.removeChild(tempEl);
        tempEl.remove();
        return index;
    }
    /**
   * Sort buttons:
   * - split by `this._buttonCutoffIndex`
   * - visible buttons: remove attr `[slot="overflow-buttons"]`; remove `display: none;`
   * - overflow buttons: set attr `[slot="overflow-buttons"]`; add `display: none;`
   */ sortVisibleAndOverflowButtons() {
        this._sortedButtonEls = {
            visible: this._buttonEls.slice(0, this._buttonCutoffIndex),
            overflow: this._buttonEls.slice(this._buttonCutoffIndex)
        };
        this._sortedButtonEls.visible.forEach((buttonEl)=>{
            // if (buttonEl.style.display) {
            //   buttonEl.style.removeProperty('display');
            // }
            if (buttonEl.getAttribute('slot') === 'overflow-buttons') buttonEl.removeAttribute('slot');
        });
        this._sortedButtonEls.overflow.forEach((buttonEl)=>{
            // if (buttonEl.style.display !== 'none') {
            //   buttonEl.style.display = 'none';
            // }
            if (buttonEl.getAttribute('slot') !== 'overflow-buttons') buttonEl.setAttribute('slot', 'overflow-buttons');
        });
    }
    /**
   * Handle screen / component resize
   */ async handleResize() {
        if (!this.getComputedWidth(this.el)) // element isn't fully rendered yet
        return;
        const index = await this.findButtonCutoffIndex();
        const isButtonCutoffUpdated = index !== this._buttonCutoffIndex;
        if (isButtonCutoffUpdated) {
            this._buttonCutoffIndex = index;
            await asyncRequestAnimationFrame();
            this.sortVisibleAndOverflowButtons();
        }
        this.el.style.visibility = '';
    }
    registerSlottedButtons() {
        const MarketButtonTagName = getNamespacedTagFor('market-button');
        this._buttonEls = [
            ...this.el.querySelectorAll(MarketButtonTagName)
        ];
    }
    observeContent(el) {
        if (!this._observers.content) {
            this._observers.content = new ResizeObserver(this.throttledHandleResize);
            this._observers.content.observe(el);
        }
    }
    connectedCallback() {
        if (!this._observers.host) {
            this._observers.host = new ResizeObserver(this.throttledHandleResize);
            this._observers.host.observe(this.el);
        }
    }
    componentWillLoad() {
        // hide component until handleResize()
        this.el.style.visibility = 'hidden';
        this.registerSlottedButtons();
        this.handleResize();
    }
    disconnectedCallback() {
        Object.entries(this._observers).forEach(([key, observer])=>{
            if (observer) {
                observer.disconnect();
                this._observers[key] = undefined;
            }
        });
    }
    render() {
        const MarketButtonDropdownTagName = getNamespacedTagFor('market-button-dropdown');
        const MarketButtonTagName = getNamespacedTagFor('market-button');
        const MarketAccessoryTagName = getNamespacedTagFor('market-accessory');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-button-group"
        }, (0, $696Z8.h)("div", {
            class: "content",
            ref: (el)=>this.observeContent(el)
        }, (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.registerSlottedButtons()
        }), this._sortedButtonEls.overflow.length > 0 && (0, $696Z8.h)(MarketButtonDropdownTagName, {
            "no-caret": true
        }, (0, $696Z8.h)(MarketButtonTagName, {
            slot: "trigger"
        }, (0, $696Z8.h)(MarketAccessoryTagName, {
            slot: "icon"
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12C16 13.1046 16.8954 14 18 14Z"
        })))), (0, $696Z8.h)("div", {
            slot: "content"
        }, (0, $696Z8.h)("slot", {
            name: "overflow-buttons",
            slot: "overflow-buttons"
        })))));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketButtonGroupCss;
    }
};
const marketCheckboxCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--checkbox-offset:calc(-1 * var(--checkbox-border-size));position:relative;outline:none;display:inline-block;width:var(--checkbox-width);height:var(--checkbox-height);border:var(--checkbox-border-size) solid var(--checkbox-normal-state-normal-validity-unchecked-value-border-color);border-radius:var(--checkbox-border-radius);background-color:var(--checkbox-normal-state-normal-validity-unchecked-value-background-color)}input{position:absolute;top:var(--checkbox-offset);left:var(--checkbox-offset);width:var(--checkbox-width);height:var(--checkbox-height);margin:0;outline:none;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}.focus-ring{--focus-ring-position:calc(-1 * (var(--checkbox-border-size) + var(--checkbox-focus-ring-buffer-size) + var(--checkbox-focus-ring-border-size)));content:'';position:absolute;top:var(--focus-ring-position);right:var(--focus-ring-position);bottom:var(--focus-ring-position);left:var(--focus-ring-position);display:block;border:var(--checkbox-focus-ring-border-size) solid var(--checkbox-focus-ring-color);border-radius:calc(var(--checkbox-border-radius) + var(--checkbox-focus-ring-buffer-size) * 2);opacity:0;pointer-events:none;transition:opacity 0.2s}input:focus-visible+.focus-ring{opacity:0.5}svg{position:absolute;top:var(--checkbox-offset);left:var(--checkbox-offset);pointer-events:none}:host(:hover),:host([hovered]){border-color:var(--checkbox-hover-state-normal-validity-unchecked-value-border-color);background-color:var(--checkbox-hover-state-normal-validity-unchecked-value-background-color)}:host([focused]){border-color:var(--checkbox-focus-state-normal-validity-unchecked-value-border-color);background-color:var(--checkbox-focus-state-normal-validity-unchecked-value-background-color)}:host(:active),:host([active]){border-color:var(--checkbox-pressed-state-normal-validity-unchecked-value-border-color);background-color:var(--checkbox-pressed-state-normal-validity-unchecked-value-background-color)}:host([checked]){border-color:var(--checkbox-normal-state-normal-validity-checked-value-border-color);background-color:var(--checkbox-normal-state-normal-validity-checked-value-background-color)}:host([checked]) path{stroke:var(--checkbox-normal-state-normal-validity-checked-value-icon-color)}:host([checked]:hover),:host([checked][hovered]){border-color:var(--checkbox-hover-state-normal-validity-checked-value-border-color);background-color:var(--checkbox-hover-state-normal-validity-checked-value-background-color)}:host([checked]:hover) path,:host([checked][hovered]) path{stroke:var(--checkbox-hover-state-normal-validity-checked-value-icon-color)}:host([checked][focused]){border-color:var(--checkbox-focus-state-normal-validity-checked-value-border-color);background-color:var(--checkbox-focus-state-normal-validity-checked-value-background-color)}:host([checked][focused]) path{stroke:var(--checkbox-focus-state-normal-validity-checked-value-icon-color)}:host([checked]:active),:host([checked][active]){border-color:var(--checkbox-pressed-state-normal-validity-checked-value-border-color);background-color:var(--checkbox-pressed-state-normal-validity-checked-value-background-color)}:host([checked]:active) path,:host([checked][active]) path{stroke:var(--checkbox-pressed-state-normal-validity-checked-value-icon-color)}:host([indeterminate]){border-color:var(--checkbox-normal-state-normal-validity-indeterminate-value-border-color);background-color:var(--checkbox-normal-state-normal-validity-indeterminate-value-background-color)}:host([indeterminate]) path{stroke:var(--checkbox-normal-state-normal-validity-indeterminate-value-icon-color)}:host([indeterminate]:hover),:host([indeterminate][hovered]){border-color:var(--checkbox-hover-state-normal-validity-indeterminate-value-border-color);background-color:var(--checkbox-hover-state-normal-validity-indeterminate-value-background-color)}:host([indeterminate]:hover) path,:host([indeterminate][hovered]) path{stroke:var(--checkbox-hover-state-normal-validity-indeterminate-value-icon-color)}:host([indeterminate][focused]){border-color:var(--checkbox-focus-state-normal-validity-indeterminate-value-border-color);background-color:var(--checkbox-focus-state-normal-validity-indeterminate-value-background-color)}:host([indeterminate][focused]) path{stroke:var(--checkbox-focus-state-normal-validity-indeterminate-value-icon-color)}:host([indeterminate]:active),:host([indeterminate][active]){border-color:var(--checkbox-pressed-state-normal-validity-indeterminate-value-border-color);background-color:var(--checkbox-pressed-state-normal-validity-indeterminate-value-background-color)}:host([indeterminate]:active) path,:host([indeterminate][active]) path{stroke:var(--checkbox-pressed-state-normal-validity-indeterminate-value-icon-color)}:host([invalid]){border-color:var(--checkbox-normal-state-invalid-validity-unchecked-value-border-color);background-color:var(--checkbox-normal-state-invalid-validity-unchecked-value-background-color)}:host([invalid]:hover){border-color:var(--checkbox-hover-state-invalid-validity-unchecked-value-border-color);background-color:var(--checkbox-hover-state-invalid-validity-unchecked-value-background-color)}:host([invalid][focused]){border-color:var(--checkbox-focus-state-invalid-validity-unchecked-value-border-color);background-color:var(--checkbox-focus-state-invalid-validity-unchecked-value-background-color)}:host([invalid]:active){border-color:var(--checkbox-pressed-state-invalid-validity-unchecked-value-border-color);background-color:var(--checkbox-pressed-state-invalid-validity-unchecked-value-background-color)}:host([invalid][checked]){border-color:var(--checkbox-normal-state-invalid-validity-checked-value-border-color);background-color:var(--checkbox-normal-state-invalid-validity-checked-value-background-color)}:host([invalid][checked]) path{stroke:var(--checkbox-normal-state-invalid-validity-checked-value-icon-color)}:host([invalid][checked]:hover){border-color:var(--checkbox-hover-state-invalid-validity-checked-value-border-color);background-color:var(--checkbox-hover-state-invalid-validity-checked-value-background-color)}:host([invalid][checked]:hover) path{stroke:var(--checkbox-hover-state-invalid-validity-checked-value-icon-color)}:host([invalid][checked][focused]){border-color:var(--checkbox-focus-state-invalid-validity-checked-value-border-color);background-color:var(--checkbox-focus-state-invalid-validity-checked-value-background-color)}:host([invalid][checked][focused]) path{stroke:var(--checkbox-focus-state-invalid-validity-checked-value-icon-color)}:host([invalid][checked]:active){border-color:var(--checkbox-pressed-state-invalid-validity-checked-value-border-color);background-color:var(--checkbox-pressed-state-invalid-validity-checked-value-background-color)}:host([invalid][checked]:active) path{stroke:var(--checkbox-pressed-state-invalid-validity-checked-value-icon-color)}:host([invalid][indeterminate]){border-color:var(--checkbox-normal-state-invalid-validity-indeterminate-value-border-color);background-color:var(--checkbox-normal-state-invalid-validity-indeterminate-value-background-color)}:host([invalid][indeterminate]) path{stroke:var(--checkbox-normal-state-invalid-validity-indeterminate-value-icon-color)}:host([invalid][indeterminate]:hover){border-color:var(--checkbox-hover-state-invalid-validity-indeterminate-value-border-color);background-color:var(--checkbox-hover-state-invalid-validity-indeterminate-value-background-color)}:host([invalid][indeterminate]:hover) path{stroke:var(--checkbox-hover-state-invalid-validity-indeterminate-value-icon-color)}:host([invalid][indeterminate][focused]){border-color:var(--checkbox-focus-state-invalid-validity-indeterminate-value-border-color);background-color:var(--checkbox-focus-state-invalid-validity-indeterminate-value-background-color)}:host([invalid][indeterminate]:active){border-color:var(--checkbox-pressed-state-invalid-validity-indeterminate-value-border-color);background-color:var(--checkbox-pressed-state-invalid-validity-indeterminate-value-background-color)}:host([invalid][indeterminate]:active) path{stroke:var(--checkbox-pressed-state-invalid-validity-indeterminate-value-icon-color)}:host([disabled]){border-color:var(--checkbox-disabled-state-normal-validity-unchecked-value-border-color);background-color:var(--checkbox-disabled-state-normal-validity-unchecked-value-background-color);cursor:not-allowed}:host([disabled]) input{cursor:not-allowed}:host([checked][disabled]){border-color:var(--checkbox-disabled-state-normal-validity-checked-value-border-color);background-color:var(--checkbox-disabled-state-normal-validity-checked-value-background-color)}:host([checked][disabled]) path{stroke:var(--checkbox-disabled-state-normal-validity-checked-value-icon-color)}:host([indeterminate][disabled]){border-color:var(--checkbox-disabled-state-normal-validity-indeterminate-value-border-color);background-color:var(--checkbox-disabled-state-normal-validity-indeterminate-value-background-color)}:host([indeterminate][disabled]) path{stroke:var(--checkbox-disabled-state-normal-validity-indeterminate-value-icon-color)}";
var ARIA_VALUE$2;
(function(ARIA_VALUE) {
    ARIA_VALUE["TRUE"] = "true";
    ARIA_VALUE["FALSE"] = "false";
    ARIA_VALUE["MIXED"] = "mixed";
})(ARIA_VALUE$2 || (ARIA_VALUE$2 = {}));
const MarketCheckbox$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketCheckboxValueChange = (0, $696Z8.createEvent)(this, "marketCheckboxValueChange", 7);
        this.checked = false;
        this.disabled = false;
        this.indeterminate = false;
        this.invalid = false;
        this.focused = false;
        this.hovered = false;
        this.active = false;
    }
    /**
   * Toggles `checked` prop, and emits a change event accordingly.
   * Used by `market-row` to sync its selected state w/ slotted checkboxes.
   */ setSelection(newValue) {
        if (typeof newValue !== 'boolean') return Promise.resolve();
        const prevValue = this.checked;
        if (prevValue !== newValue) {
            const { defaultPrevented } = this.marketCheckboxValueChange.emit({
                current: newValue,
                previous: prevValue
            });
            if (!defaultPrevented) this.checked = newValue;
        }
        this.indeterminate = false;
        return Promise.resolve();
    }
    /**
   * Toggles `indeterminate` prop. Operates independently of the `checked` property but if `true`,
   * indeterminate visual appearance takes precedence over checked/unchecked.
   */ setIndeterminate(newValue) {
        this.indeterminate = newValue;
        return Promise.resolve();
    }
    /**
   * DEPRECATED (3.x): Toggles `selected` state (unrelated to the HTML attribute `value`).
   */ setValue(newValue) {
        /* eslint-disable-next-line no-console */ console.warn("market-checkbox's setValue() method has been deprecated. Use setSelection() instead.", this.el);
        this.setSelection(newValue);
        return Promise.resolve();
    }
    /**
   * Sets `active` state. Allows external elements to programmatically
   * trigger active styling, ex. when slotted as a control into `market-row`.
   */ setActive(value) {
        this.active = value;
        return Promise.resolve();
    }
    /**
   * Sets `hovered` state. Allows external elements to programmatically
   * trigger hover styling, ex. when slotted as a control into `market-row`.
   */ setHover(value) {
        this.hovered = value;
        return Promise.resolve();
    }
    /**
   * Sets `disabled` state. Allows external elements to programmatically
   * trigger disabled styling, ex. when slotted as a control into `market-row`.
   */ setDisabled(value) {
        this.disabled = value;
        return Promise.resolve();
    }
    /**
   * Sets `focused` state, except when disabled.
   * Allows external consumers to programmatically
   * trigger focused styling.
   */ setFocus(value = true) {
        if (this.disabled) return Promise.resolve();
        this.focused = value;
        return Promise.resolve();
    }
    handleClick() {
        if (this.disabled) return;
        this.setFocus();
        this.setSelection(!this.checked);
    }
    getCheckedState() {
        return this.indeterminate ? 'indeterminate' : this.checked;
    }
    getAriaCheckedValue() {
        switch(this.getCheckedState()){
            case 'indeterminate':
                return ARIA_VALUE$2.MIXED;
            case true:
                return ARIA_VALUE$2.TRUE;
            default:
                return ARIA_VALUE$2.FALSE;
        }
    }
    componentDidRender() {
        if (!this.innerInput) this.innerInput = this.el.shadowRoot.querySelector('input');
        if (this.checked || this.indeterminate) {
            this.innerInput.checked = this.checked;
            this.innerInput.indeterminate = this.indeterminate;
        }
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-checkbox",
            role: "checkbox",
            "aria-checked": this.getAriaCheckedValue(),
            onBlur: ()=>{
                this.setFocus(false);
            },
            onClick: ()=>{
                this.handleClick();
            },
            onFocus: ()=>{
                this.setFocus();
            }
        }, (0, $696Z8.h)("input", {
            type: "checkbox",
            "aria-checked": this.getAriaCheckedValue(),
            "aria-label": getControlInputAriaLabel(this.el),
            checked: this.checked,
            indeterminate: this.indeterminate,
            disabled: this.disabled
        }), (0, $696Z8.h)("span", {
            class: "focus-ring"
        }), this.checked && !this.indeterminate && (0, $696Z8.h)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "check"
        }, (0, $696Z8.h)("path", {
            d: "M6 10L8.85714 13L14 7",
            stroke: "white",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })), this.indeterminate && (0, $696Z8.h)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "indeterminate"
        }, (0, $696Z8.h)("path", {
            d: "M6 10H14",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketCheckboxCss;
    }
};
const marketChoiceButtonCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--transition-duration:0.2s;position:relative;display:inline-block;border-radius:var(--choice-button-border-radius);background-color:var(--choice-button-unselected-value-normal-state-background-color);color:var(--choice-button-unselected-value-normal-state-label-color);cursor:pointer;transition:background-color color var(--transition-duration)}button{display:inline-flex;justify-content:center;align-items:center;box-sizing:border-box;width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;outline:none;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;text-align:center;cursor:inherit}button::after{--focus-ring-position:calc(-1 * (0px + var(--choice-button-focus-ring-buffer-size) + var(--choice-button-focus-ring-border-size)));content:'';position:absolute;top:var(--focus-ring-position);right:var(--focus-ring-position);bottom:var(--focus-ring-position);left:var(--focus-ring-position);display:block;border:var(--choice-button-focus-ring-border-size) solid var(--choice-button-focus-ring-color);border-radius:calc(var(--choice-button-border-radius) + var(--choice-button-focus-ring-buffer-size) * 2);opacity:0;pointer-events:none;transition:opacity 0.2s;}button:focus-visible::after{opacity:0.5}::slotted([slot='secondary-text']){cursor:inherit}:host([size=\"medium\"]) button{padding:var(--choice-button-medium-size-vertical-padding) var(--choice-button-medium-size-horizontal-padding);font-weight:var(--choice-button-medium-size-text-primary-weight);font-size:var(--choice-button-medium-size-text-primary-size);line-height:var(--choice-button-medium-size-text-primary-leading);letter-spacing:var(--choice-button-medium-size-text-primary-tracking);text-transform:var(--choice-button-medium-size-text-primary-case);-moz-column-gap:var(--choice-button-medium-size-content-spacing);column-gap:var(--choice-button-medium-size-content-spacing)}:host([size=\"medium\"]) ::slotted([slot='secondary-text']){font-weight:var(--choice-button-medium-size-text-secondary-weight);font-size:var(--choice-button-medium-size-text-secondary-size);line-height:var(--choice-button-medium-size-text-secondary-leading);letter-spacing:var(--choice-button-medium-size-text-secondary-tracking);text-transform:var(--choice-button-medium-size-text-secondary-case)}:host([size=\"small\"]) button{padding:var(--choice-button-small-size-vertical-padding) var(--choice-button-small-size-horizontal-padding);font-weight:var(--choice-button-small-size-text-primary-weight);font-size:var(--choice-button-small-size-text-primary-size);line-height:var(--choice-button-small-size-text-primary-leading);letter-spacing:var(--choice-button-small-size-text-primary-tracking);text-transform:var(--choice-button-small-size-text-primary-case);-moz-column-gap:var(--choice-button-small-size-content-spacing);column-gap:var(--choice-button-small-size-content-spacing)}:host([size=\"small\"]) ::slotted([slot='secondary-text']){font-weight:var(--choice-button-small-size-text-secondary-weight);font-size:var(--choice-button-small-size-text-secondary-size);line-height:var(--choice-button-small-size-text-secondary-leading);letter-spacing:var(--choice-button-small-size-text-secondary-tracking);text-transform:var(--choice-button-small-size-text-secondary-case)}:host([size=\"large\"]) button{padding:var(--choice-button-large-size-vertical-padding) var(--choice-button-large-size-horizontal-padding);font-weight:var(--choice-button-large-size-text-primary-weight);font-size:var(--choice-button-large-size-text-primary-size);line-height:var(--choice-button-large-size-text-primary-leading);letter-spacing:var(--choice-button-large-size-text-primary-tracking);text-transform:var(--choice-button-large-size-text-primary-case);-moz-column-gap:var(--choice-button-large-size-content-spacing);column-gap:var(--choice-button-large-size-content-spacing)}:host([size=\"large\"]) ::slotted([slot='secondary-text']){font-weight:var(--choice-button-large-size-text-secondary-weight);font-size:var(--choice-button-large-size-text-secondary-size);line-height:var(--choice-button-large-size-text-secondary-leading);letter-spacing:var(--choice-button-large-size-text-secondary-tracking);text-transform:var(--choice-button-large-size-text-secondary-case)}@media (hover: hover){:host(:hover){background-color:var(--choice-button-unselected-value-hover-state-background-color);color:var(--choice-button-unselected-value-hover-state-label-color)}}:host(:active){background-color:var(--choice-button-unselected-value-pressed-state-background-color);color:var(--choice-button-unselected-value-pressed-state-label-color)}:host([disabled]){background-color:var(--choice-button-unselected-value-disabled-state-background-color);color:var(--choice-button-unselected-value-disabled-state-label-color)}:host([selected]){background-color:var(--choice-button-selected-value-normal-state-background-color);color:var(--choice-button-selected-value-normal-state-label-color)}@media (hover: hover){:host([selected]:hover){background-color:var(--choice-button-selected-value-hover-state-background-color);color:var(--choice-button-selected-value-hover-state-label-color)}}:host([selected]:active){background-color:var(--choice-button-selected-value-pressed-state-background-color);color:var(--choice-button-selected-value-pressed-state-label-color)}:host([selected][disabled]){background-color:var(--choice-button-selected-value-disabled-state-background-color);color:var(--choice-button-selected-value-disabled-state-label-color)}";
const MarketChoiceButton$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketChoiceButtonSelected = (0, $696Z8.createEvent)(this, "marketChoiceButtonSelected", 7);
        this.marketChoiceButtonDeselected = (0, $696Z8.createEvent)(this, "marketChoiceButtonDeselected", 7);
        this.disabled = false;
        this.selected = false;
        this.size = 'medium';
    }
    onClick(e) {
        if (this.disabled) {
            e.stopImmediatePropagation();
            return;
        }
        if (this.selected) {
            this.selected = false;
            this.marketChoiceButtonDeselected.emit();
        } else {
            this.selected = true;
            this.marketChoiceButtonSelected.emit();
        }
    }
    render() {
        const { disabled } = this;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-choice-button",
            "aria-disabled": disabled,
            role: "button",
            tabindex: disabled ? -1 : undefined,
            onClick: (e)=>{
                this.onClick(e);
            }
        }, (0, $696Z8.h)("button", null, (0, $696Z8.h)("slot", null), (0, $696Z8.h)("slot", {
            name: "secondary-text"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketChoiceButtonCss;
    }
};
const marketCodeDisplayCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:flex;justify-content:space-between;align-items:center;width:-moz-min-content;width:min-content;min-width:var(--code-display-width, 320px);min-height:var(--code-display-height, 48px);margin:var(--code-display-margin, 12px);padding:var(--code-display-padding-vertical, 12px)\n    var(--code-display-padding-right, 16px)\n    var(--code-display-padding-vertical, 12px)\n    var(--code-display-zero-value, 0);border-radius:var(--code-display-border-radius, 6px);background-color:var(--code-display-background-color, var(--core-fill-40-color));font-weight:var(--code-display-code-font-weight, var(--core-type-bold-weight));font-size:var(--code-display-code-font-size, var(--core-type-heading-20-size));font-family:var(--code-display-font-family, var(--core-type-font-family));font-feature-settings:'tnum'}:host(:not([disabled])) button:hover,:host ::slotted(button:hover),:host ::slotted(a:hover){opacity:var(--code-display-action-interaction-opacity, 0.6)}:host(:not([disabled])) button:active,:host ::slotted(button:active),:host ::slotted(a:active){opacity:var(--code-display-action-interaction-opacity, 0.6)}:host([disabled]){color:var(--code-display-disabled-text-color, var(--core-text-30-color));}:host([disabled]) ::slotted(button),:host ::slotted(a){color:var(--code-display-disabled-text-color, var(--core-text-30-color));}:host .code-container{display:flex;flex-grow:2;justify-content:space-between;min-width:var(--code-display-code-container-min-width, 269px)}:host .code-char{flex-basis:100%;text-align:center}:host .actions-container{display:flex;justify-content:center;align-items:center}:host .actions-container ::slotted([slot='actions']:not(:last-child)){margin-right:var(--code-display-extra-actions-margin-right, 25px)}:host .actions-container ::slotted([slot='actions']:not(:last-child))::after{content:'';display:inline-block;width:var(--code-display-button-separator-width, 1px);height:var(--code-display-button-separator-height, 8px);margin-right:var(--code-display-separator-margin-right, -13px);margin-left:var(--code-display-button-content-spacing, 12px);background-color:var(--code-display-button-separator-color, var(--core-fill-10-color));opacity:var(--code-display-button-separator-opacity, 0.3);pointer-events:none}:host button,:host ::slotted(button),:host ::slotted(a){margin:var(--code-display-zero-value, 0);padding:var(--code-display-zero-value, 0);border:none;background-color:transparent;color:var(--code-display-button-font-color, var(--core-blue-text-color));font-weight:var(--code-display-button-font-weight, var(--core-type-semibold-weight));font-size:var(--code-display-button-font-size, var(--core-type-paragraph-20-size));font-family:inherit;line-height:var(--code-display-button-line-height, var(--core-type-paragraph-20-leading));text-decoration:none;cursor:pointer}@media only screen and (max-width: 320px){:host{flex-wrap:wrap;width:100%;min-width:var(--code-display-zero-value, 0)}:host .code-container{min-width:var(--code-display-zero-value, 0)}}";
/**
 * When code is split up, represents how many characters are in each group.
 */ const CODE_GROUP_LEN = 4;
const MarketCodeDisplay$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketCodeCopied = (0, $696Z8.createEvent)(this, "marketCodeCopied", 7);
        /**
     * A string holding the code inputted by the user through a slot.
     */ this.code = '';
        /**
     * An array holding spans containing each character in the code, with some blanks.
     * Used for styling and spacing.
     */ this.codeChars = [];
        this.disabled = false;
        this.focused = false;
    }
    /**
   * Component Lifecycle Event:
   * Grab the code and its len from inputted code slot.
   * Set relevant props and insert the Copy button programmatically so that it appears in the light DOM.
   */ componentWillLoad() {
        // Set code and codeGroups
        const slottedCodeTag = this.el.querySelector('[slot=code]');
        const code = slottedCodeTag.textContent;
        // Remove whitespace from slotted code
        this.code = code.replace(/\s/g, '');
        this.initCodeChars(this.code);
        // Programmatically insert default Copy button into light DOM
        this.copyButton = document.createElement('button');
        Object.assign(this.copyButton, {
            slot: 'actions',
            type: 'button',
            tabIndex: this.disabled ? -1 : 0,
            onclick: ()=>this.copyToClipboard()
        });
        // NOTE: The following code is brittle! Relies on the fact that the consumer
        //       slotted in elements in order of 'code' -> 'copy-text' -> 'actions'
        // If consumer slotted in alt copy-text, place copyButton after code & copy-text
        if (this.el.querySelector('[slot=copy-text]')) {
            // Set text of the Copy button to slotted copy-text
            const slottedCopyText = this.el.querySelector('[slot=copy-text]');
            const copyText = slottedCopyText.textContent;
            this.copyButton.innerHTML = copyText;
            slottedCopyText.insertAdjacentElement('afterend', this.copyButton);
        } else {
            this.copyButton.innerHTML = `Copy`;
            slottedCodeTag.insertAdjacentElement('afterend', this.copyButton);
        }
    }
    /**
   * Inits this.codeChars to an array of <span> tags containing each character in the code string.
   * Additionally contains empty strings at certain indices based on codeLen.
   * By default, blanks are only placed at the front & back of the array.
   *    ['', 'x', 'x', 'x', 'x', '']
   * If codeLen is divisible by 4, put blanks every 4 spots too.
   *    ['', 'x', 'x', 'x', 'x', '', 'x', 'x', 'x', 'x', '']
   * The exception to this is if codeLen===4, in which case we use the default.
   * This codeChars arr is used in render() to space and style characters appropriately.
   * Called only once on componentWillLoad() as to not cause re-renders
   */ initCodeChars(code) {
        const codeLen = code.length;
        const BLANK_CODE_SPAN = (0, $696Z8.h)("span", {
            class: "code-char"
        });
        // Place blanks every 4 chars
        if (codeLen !== CODE_GROUP_LEN && codeLen % CODE_GROUP_LEN === 0) for(let i = 0; i < codeLen; i++){
            if (i % CODE_GROUP_LEN === 0) this.codeChars.push(BLANK_CODE_SPAN);
            this.codeChars.push((0, $696Z8.h)("span", {
                class: "code-char"
            }, code[i]));
        }
        else {
            this.codeChars.push(BLANK_CODE_SPAN);
            for(let i = 0; i < codeLen; i++)this.codeChars.push((0, $696Z8.h)("span", {
                class: "code-char"
            }, code[i]));
        }
        this.codeChars.push(BLANK_CODE_SPAN);
    }
    /**
   * When user presses the 'Copy' button, copy code to clipboard & emit an event.
   */ copyToClipboard() {
        navigator.clipboard.writeText(this.code);
        this.marketCodeCopied.emit();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-code-display",
            tabIndex: this.disabled ? null : 0,
            "aria-label": this.code
        }, (0, $696Z8.h)("span", {
            class: "code-container"
        }, this.codeChars), (0, $696Z8.h)("span", {
            class: "actions-container"
        }, (0, $696Z8.h)("slot", {
            name: "actions"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketCodeDisplayCss;
    }
};
const marketCodeInputCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:relative;outline:none;font-weight:var(--field-input-weight);font-size:var(--field-input-size);line-height:var(--field-input-leading);cursor:text}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;cursor:inherit}:host ::slotted(label){cursor:inherit}:host input:focus,:host ::slotted(input:focus),:host textarea:focus,:host ::slotted(textarea:focus){outline:none}:host input::-moz-placeholder,:host textarea::-moz-placeholder{color:var(--field-placeholder-text-color)}:host input::placeholder,:host textarea::placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::-moz-placeholder,:host ::slotted(textarea)::-moz-placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::placeholder,:host ::slotted(textarea)::placeholder{color:var(--field-placeholder-text-color)}:host([size='small']){font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}:host{border-radius:var(--field-border-radius);background-color:var(--field-normal-state-background-color);color:var(--field-normal-state-input-color)}:host::after{content:'';position:absolute;inset:0;border-radius:var(--field-border-radius);box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color);pointer-events:none}:host([invalid])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-invalid-validity-border-color)}:host(:hover){background-color:var(--field-hover-state-background-color);color:var(--field-hover-state-input-color)}:host(:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-normal-validity-border-color)}:host([invalid]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-invalid-validity-border-color)}:host([focused]){color:var(--field-focus-state-input-color)}:host([focused])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size)\n        var(--field-focus-state-normal-validity-border-color)}:host([focused][invalid])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size) var(--field-focus-state-invalid-validity-border-color)}:host([disabled]){background-color:var(--field-disabled-state-background-color) !important;color:var(--field-disabled-state-input-color) !important;cursor:not-allowed !important;}:host([disabled])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-disabled-state-border-color) !important}:host([value=\"\"]) ::slotted(label){color:var(--field-normal-state-empty-phase-label-color)}:host(:not([value=\"\"])) ::slotted(label),:host([value=\"\"][autofilled]) ::slotted(label){color:var(--field-normal-state-float-phase-label-color)}:host(:hover) ::slotted(label){color:var(--field-hover-state-empty-phase-label-color)}:host(:not([value=\"\"]):hover) ::slotted(label),:host([value=\"\"][autofilled]:hover) ::slotted(label){color:var(--field-hover-state-float-phase-label-color)}:host([focused]) ::slotted(label){color:var(--field-focus-state-float-phase-label-color)}:host([value=\"\"][disabled]) ::slotted(label){color:var(--field-disabled-state-empty-phase-label-color)}:host(:not([value=\"\"])[disabled]) ::slotted(label),:host([value=\"\"][autofilled][disabled]) ::slotted(label){color:var(--field-disabled-state-float-phase-label-color)}:host{display:flex;align-items:center;height:var(--input-code-height, 64px)}:host input{font-weight:var(--input-code-font-weight, var(--core-type-bold-weight));text-align:center}:host input:-webkit-autofill,:host input:-webkit-autofill:hover,:host input:-webkit-autofill:focus{-webkit-box-shadow:0 0 0 calc(var(--input-code-height, 64px) / 2) var(--field-normal-state-background-color) inset}.code-input-container{display:flex;justify-content:center;width:100%;height:100%}.code-input-container::before,.code-input-container::after{content:'';flex-basis:100%;pointer-events:none}::slotted([slot='trailing-accessory']){margin-right:var(--input-code-trailing-accessory-spacing, 12px)}input::-moz-placeholder{color:var(--input-code-placeholder-color, var(--core-fill-30-color));font-size:var(--input-code-placeholder-font-size, 24px)}input::placeholder{color:var(--input-code-placeholder-color, var(--core-fill-30-color));font-size:var(--input-code-placeholder-font-size, 24px)}";
const MarketCodeInput$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketCodeInputValueChange = (0, $696Z8.createEvent)(this, "marketCodeInputValueChange", 7);
        this.type = 'number';
        this.name = undefined;
        this.length = 4;
        this.focused = false;
        this.value = '';
        this.readonly = false;
        this.invalid = false;
        this.disabled = false;
        this._code = undefined;
    }
    valueChangeHandler(value) {
        const sanitized = this.sanitizeValue(value);
        if (this.value !== sanitized) this.value = sanitized;
        this.setInputsFromValue(this.value);
    }
    /**
   * Trigger focus styling on `<market-input-text>`
   * and focus the cursor on the first empty `<input />`.
   */ setFocus(value = true) {
        var _a;
        this.focused = value;
        if (value) this.focusFirstEmptyInput();
        else (_a = this.el.shadowRoot.activeElement) === null || _a === void 0 || _a.blur();
        return Promise.resolve();
    }
    isNumber(value) {
        return /^\d+$/.test(value);
    }
    isValidChar(char) {
        // no whitespace
        if (/\s/.test(char)) return false;
        // number check
        return this.type === 'text' || this.isNumber(char);
    }
    focusFirstEmptyInput() {
        const inputs = this.el.shadowRoot.querySelectorAll('input');
        let input;
        inputs.forEach((i)=>{
            if (!i.value && !input) input = i;
        });
        if (!input) input = inputs[this.length - 1];
        input.focus();
    }
    /**
   * Inits this._code to the passed-in `value` prop or to an
   * empty array representation of the code input i.e ['', '', '', '']
   * Called only once on componentWillLoad() as to not cause re-renders
   */ initCode(value) {
        if (value) {
            this._code = value.split('');
            // ensure that this._code is always of size this.length
            if (this._code.length < this.length) {
                const padding = Array.from({
                    length: this.length - this._code.length
                }).fill('');
                this._code = [
                    ...this._code,
                    ...padding
                ];
            } else if (this._code.length > this.length) this._code = this._code.slice(0, this.length);
        } else this._code = Array.from({
            length: this.length
        }).fill('');
    }
    sanitizeValue(value) {
        return value.split('').filter((char)=>this.isValidChar(char)).join('').slice(0, this.length);
    }
    getValueFromInputs() {
        let value = '';
        this.el.shadowRoot.querySelectorAll('input').forEach((input)=>{
            value += input.value;
        });
        return value;
    }
    setInputsFromValue(value) {
        const inputs = this.el.shadowRoot.querySelectorAll('input');
        inputs.forEach((input, i)=>{
            const char = value[i];
            const prevChar = value[i - 1];
            // set the input value
            input.value = char || '';
            // set the input tabindex
            if (i === 0 || prevChar) input.removeAttribute('tabindex');
            else input.tabIndex = -1;
        });
    }
    spreadChars(e) {
        const { target, data } = e;
        const chars = data || target.value;
        if (!chars) return;
        const sanitized = this.sanitizeValue(chars);
        if (sanitized) this.insertChars(target, sanitized.split(''));
        else target.value = '';
    }
    insertChars(input, chars) {
        const { nextElementSibling } = input;
        const [first, ...rest] = chars;
        input.value = first;
        nextElementSibling === null || nextElementSibling === void 0 || nextElementSibling.focus();
        if (nextElementSibling && rest.length > 0) this.insertChars(nextElementSibling, rest);
    }
    updateValue() {
        const previousValue = this.value;
        const newValue = this.sanitizeValue(this.getValueFromInputs());
        if (previousValue !== newValue) {
            const { defaultPrevented } = this.marketCodeInputValueChange.emit({
                code: newValue
            });
            if (defaultPrevented) this.setInputsFromValue(previousValue);
            else this.value = newValue;
        }
    }
    onInput(e) {
        // Handle paste or autocomplete of multiple chars
        this.spreadChars(e);
        this.updateValue();
    }
    onFocus(e) {
        const { target } = e;
        this.focused = true;
        if (target.value) target.select();
        else this.focusFirstEmptyInput();
    }
    onBlur() {
        this.focused = false;
    }
    onKeyDown(e) {
        const { target, key } = e;
        const { value, previousElementSibling, nextElementSibling } = target;
        switch(key){
            case 'ArrowLeft':
                e.preventDefault();
                previousElementSibling === null || previousElementSibling === void 0 || previousElementSibling.select();
                break;
            case 'ArrowRight':
                e.preventDefault();
                nextElementSibling === null || nextElementSibling === void 0 || nextElementSibling.select();
                break;
            case 'Backspace':
                if (!value) previousElementSibling === null || previousElementSibling === void 0 || previousElementSibling.select();
                break;
        }
    }
    onKeyUp(e) {
        const { target } = e;
        const { value } = target;
        if (value.length > 1) this.spreadChars(e);
        else if (!this.isValidChar(value)) {
            target.value = '';
            target.focus();
        }
    }
    onHostClick() {
        // if a child input does not already have focus
        if (!this.el.shadowRoot.activeElement) this.setFocus();
    }
    componentWillLoad() {
        this.valueChangeHandler(this.value);
        this.initCode(this.value);
    }
    render() {
        const inputs = [];
        this._code.forEach((char, index)=>{
            const tabindex = this._code[index - 1] || index === 0 ? null : -1;
            inputs.push((0, $696Z8.h)("input", {
                required: true,
                type: "text",
                inputmode: this.type === 'number' ? 'numeric' : null,
                autocomplete: index === 0 ? 'one-time-code' : null,
                value: char,
                maxlength: index === this.length - 1 ? '1' : null,
                readOnly: this.readonly,
                disabled: this.disabled,
                placeholder: "\u25CF",
                tabindex: tabindex,
                onFocus: (e)=>this.onFocus(e),
                onBlur: ()=>this.onBlur(),
                onInput: (e)=>this.onInput(e),
                onKeyDown: (e)=>this.onKeyDown(e),
                onKeyUp: (e)=>this.onKeyUp(e)
            }));
        });
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-code-input",
            name: this.name,
            onClick: ()=>this.onHostClick()
        }, (0, $696Z8.h)("span", {
            class: "code-input-container"
        }, inputs), (0, $696Z8.h)("slot", {
            name: "trailing-accessory"
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "value": [
                "valueChangeHandler"
            ]
        };
    }
    static get style() {
        return marketCodeInputCss;
    }
};
const marketContentCardCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:block;padding:var(--content-card-padding-vertical-size) var(--content-card-padding-horizontal-size);border:var(--content-card-border-width) solid var(--content-card-border-color);border-radius:var(--content-card-border-radius);background-color:var(--content-card-background-color)}";
const MarketContentCard$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-content-card"
        }, (0, $696Z8.h)("slot", null));
    }
    static get style() {
        return marketContentCardCss;
    }
};
const marketContextCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:absolute;display:grid;justify-items:center;width:100vw;height:100%;animation:var(--core-animation-enter-transition-moderate-speed-duration)\n    market-fade-in\n    forwards\n    var(--core-animation-enter-transition-easing)}:host([hidden]){opacity:0;animation-name:market-fade-out;animation-duration:var(--core-animation-exit-transition-moderate-speed-duration);animation-timing-function:var(--core-animation-exit-transition-easing)}:host>*{pointer-events:auto}:host(:not(.no-veil)){background-color:var(--core-surface-overlay-color);opacity:1;pointer-events:auto}:host(.no-veil){pointer-events:none}@media screen and (min-width: 800px){::slotted(.market-modal-partial){align-self:center;margin:var(--modal-partial-vertical-screen-buffer-size) var(--modal-partial-horizontal-screen-buffer-size)}}::slotted(.market-dialog){align-self:center;width:calc(100% - (2 * var(--modal-dialog-horizontal-screen-buffer-size, 16px)))}";
const MarketContext$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketContextContentsChanged = (0, $696Z8.createEvent)(this, "marketContextContentsChanged", 7);
        this.marketContextEmptied = (0, $696Z8.createEvent)(this, "marketContextEmptied", 7);
        this.currentDialog = undefined;
        this.noVeil = false;
        this.hidden = false;
        this.animationEnterDuration = cjs.CORE_ANIMATION_ENTER_TRANSITION_MODERATE_SPEED_DURATION;
        this.animationExitDuration = cjs.CORE_ANIMATION_EXIT_TRANSITION_MODERATE_SPEED_DURATION;
        this.stack = [];
        this.totalCount = 0;
        this.dialogMeta = {};
    }
    currentDialogWatcher(newDialog) {
        this.stack.push(newDialog);
        this.stack = [
            ...this.stack
        ]; // Spread syntax ensures triggering the watcher
    }
    stackWatcher(newValue) {
        newValue.forEach((dialog)=>{
            // increase the count of the type of dialog in the meta
            this.dialogMeta[dialog.type].count += 1;
            // Increase the total count of dialogs
            this.totalCount += 1;
        });
        // If there are no more dialogs opened, then emit an event indicating so
        if (newValue.length === 0) {
            this.hidden = true;
            setTimeout(()=>{
                this.marketContextEmptied.emit();
            }, this.animationExitDuration);
        }
        this.setContextVeil();
    }
    doesStackContainDialogThatRequiresVeil(dialog) {
        const veiledDialogTagnames = Object.entries(DIALOGS_META).filter(([, config])=>config.veil).map(([type])=>getNamespacedTagFor(`market-${type}`));
        return veiledDialogTagnames.includes(dialog.tagName.toLowerCase());
    }
    setContextVeil() {
        // consumer use of noVeil prop overrides default behavior
        // veil shouldn't reset when stack is emptied
        if (this.el.hasAttribute('no-veil') || this.stack.length === 0) return;
        // context will turn off veil if no context in its stack requires one
        this.noVeil = !this.stack.some((dialog)=>this.doesStackContainDialogThatRequiresVeil(dialog.el));
    }
    stackHasDialog(dialogEl) {
        return this.stack.some((dialog)=>dialog.el === dialogEl);
    }
    modalLoadedEventHandler(e) {
        const dialog = e.detail.dialog;
        const type = e.detail.type;
        if (dialog.parentElement !== this.el) // Ignore marketDialogLoaded events from dialogs which are not children of this
        // context.
        return;
        else if (this.stackHasDialog(dialog)) // Ignore marketDialogLoaded events from dialogs already contained in this
        // context's stack.
        return;
        // Generate a new dialogID (ex. "modal-partial-2")
        const generatedDialogID = this.generateDialogID(type);
        // Set the dialogID for the dialog element (note: this maps to data-dialog-id
        // and not the native id attribute)
        dialog.dialogID = generatedDialogID;
        // Set the id prop if one does not exist
        // (we don't use this prop anymore, but since we were setting it to
        // generatedDialogID before, removing it would be a breaking change)
        dialog.id = dialog.id || generatedDialogID;
        // Build a new Dialog object and set the currentDialog
        this.currentDialog = {
            el: dialog,
            type: type,
            dialogID: dialog.dialogID,
            id: dialog.id,
            index: this.stack.length,
            indexOfType: this.dialogMeta[type].count + 1
        };
        // Emit a nice marketContextContentsChanged event
        this.marketContextContentsChanged.emit({
            action: 'marketNewDialogOpened',
            currentDialog: this.currentDialog,
            stack: this.stack
        });
    }
    // This event is emitted from market dialog components (Modal, Sheet, Blade, etc.)
    dialogDismissedEventHandler(event) {
        if (event.defaultPrevented) return;
        // only close direct children of this context
        if (event.target.parentElement === this.el) this.close(event.detail.dialog.dialogID);
    }
    generateDialogID(type) {
        // ex. "sheet-2"
        return `${type}-${this.dialogMeta[type].count + 1}`;
    }
    getDialogByID(dialogID) {
        return this.stack.find((dialog)=>dialog.dialogID === dialogID);
    }
    /**
   * Adds the passed dialogTemplate to the stack and inserts it into the DOM
   */ open(dialogTemplate) {
        if (this.stack.length === 0) this.noVeil = !this.doesStackContainDialogThatRequiresVeil(dialogTemplate);
        this.el.appendChild(dialogTemplate);
        return Promise.resolve();
    }
    /**
   * **Recommended for internal use only**
   * Removes the topmost dialog from the stack or the dialog matching the passed `dialogID`
   * Note that using this will not trigger the dialog to emit a marketDialogDismissed event.
   *
   * The recommended path for closing a dialog is to call its dismiss() method.
   */ // TODO (breaking): consider renaming this method to `removeDialogElement`
    close(dialogID) {
        let dialog;
        const d = this.stack.indexOf(dialog);
        // If we want to close a specific dialog, then find that dialog in the stack
        if (dialogID) {
            dialog = this.stack.find((dialog)=>dialog.dialogID === dialogID);
            // If there is no dialog with the passed id, log a helpful warning
            /* eslint-disable-next-line no-console */ !dialog && console.warn(`Tried to close dialog with data-dialog-id "${dialogID}" but none were found`);
        // Otherwise we will close the current/most recently opened dialog
        } else dialog = this.currentDialog;
        // currently, "persistent" is only implemented for market-dialog, bc it's
        // the only dialog type that doesn't programmatically insert a close button
        // when used w/ market-header
        if (dialog.type === 'dialog' && dialog.el.persistent) return Promise.resolve();
        // Remove the dialog node from the DOM
        setTimeout(()=>{
            dialog.el.remove();
            // Remove the dialog from the stack. Reassign to trigger the watcher
            this.stack.splice(d, 1);
            this.stack = [
                ...this.stack
            ];
            // Emit a nice event
            this.marketContextContentsChanged.emit({
                action: 'marketDialogClosed',
                currentDialog: dialog,
                stack: this.stack
            });
        }, dialog.el.animationExitDuration);
        return Promise.resolve();
    }
    /**
   * **Recommended for internal use only**
   * Removes the topmost dialog from the stack (just an alias for default .close() behavior)
   * Note that using this will not trigger the dialog to emit a marketDialogDismissed event.
   *
   * The recommended path for closing a dialog is to call its dismiss() method.
   */ // TODO (breaking): consider removing this method in favor of encouraging consumers to close dialogs via dialog.dismiss();
    closeCurrent() {
        this.close();
        return Promise.resolve();
    }
    connectedCallback() {
        ALL_DIALOG_TYPES.forEach((dialogType)=>{
            this.dialogMeta[dialogType] = {
                count: 0
            };
        });
        const scrollElement = document.scrollingElement;
        this.initialScrollingElementOverflowState = scrollElement.style.overflow;
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: `market-context ${this.noVeil ? 'no-veil' : ''}`
        }, (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "currentDialog": [
                "currentDialogWatcher"
            ],
            "stack": [
                "stackWatcher"
            ]
        };
    }
    static get style() {
        return marketContextCss;
    }
};
const marketContextManagerCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:fixed;top:0;left:0;z-index:-1000;display:block;overflow:hidden;width:100vw;height:100%;opacity:0}:host([active]){z-index:2;opacity:1;pointer-events:none}";
const MarketContextManager$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketContextManagerActivated = (0, $696Z8.createEvent)(this, "marketContextManagerActivated", 7);
        this.marketContextManagerDeactivated = (0, $696Z8.createEvent)(this, "marketContextManagerDeactivated", 7);
        this.active = false;
        this.currentContext = undefined;
        this.stack = [];
    }
    initChildListObserver() {
        if (this.childListObserver) return;
        const updateChildList = ()=>{
            this.stack = [
                ...this.el.children
            ];
            this.currentContext = this.stack.length > 0 ? this.stack[this.stack.length - 1] : null;
        };
        updateChildList();
        this.childListObserver = new MutationObserver(updateChildList);
        this.childListObserver.observe(this.el, {
            childList: true
        });
    }
    async getCurrentContext() {
        while(!this.currentContext)await asyncRequestAnimationFrame();
        return this.currentContext;
    }
    contextEmptiedEventHandler({ target: emptiedContext }) {
        // Remove the emptied context from the DOM
        emptiedContext.remove();
        // Remove the emptied context from the stack
        this.stack.splice(this.stack.indexOf(emptiedContext), 1);
        // Set the currentContext to the next highest context or null if this was the
        // only context in the stack
        if (this.stack.length === 0) this.deactivate();
    }
    windowKeydown(e) {
        var _a;
        if (e.key === 'Escape' || e.key === 'Esc') (_a = this.currentContext) === null || _a === void 0 || _a.currentDialog.el.dismiss({
            origin: this.el
        });
    }
    /**
   * Adds the passed dialogEl to the DOM and creates a new context if necessary or according to
   * `shouldCreateNewContext` if it is passed
   */ async open(dialogEl, shouldCreateNewContext) {
        let createNewContext = shouldCreateNewContext;
        if (!this.currentContext || dialogEl) createNewContext = true;
        // If we don't currently have a context, or we're opening certain types of
        // dialogs, then we should create a new context
        if (createNewContext) this.createNewContext();
        await this.currentContext.open(dialogEl);
    }
    /**
   * Closes the dialog with matching ID
   */ close(dialogID) {
        this.currentContext.close(dialogID);
        return Promise.resolve();
    }
    /**
   * Adds a new market-context to the stack in the DOM and activates it
   */ createNewContext() {
        this.activate();
        this.el.appendChild(document.createElement(getNamespacedTagFor('market-context')));
        this.currentContext = this.el.lastElementChild;
        return Promise.resolve();
    }
    /**
   * Hides the entire context manager
   */ deactivate() {
        this.active = false;
        this.marketContextManagerDeactivated.emit();
        return Promise.resolve();
    }
    /**
   * Shows the context manager
   */ activate() {
        if (!this.active) {
            this.active = true;
            this.marketContextManagerActivated.emit();
        }
        return Promise.resolve();
    }
    handleMouseEvents(e) {
        // checking to make sure the click started and ended on a market-context
        // with a veil before dismissing the current dialog
        // (clicks pass through contexts w/o veil, currently only used w/ market-blade)
        if (e.type === 'mousedown') this.mouseDownEl = e.target.tagName;
        else if (e.type === 'mouseup') {
            const mouseUpEl = e.target.tagName;
            if (this.mouseDownEl === mouseUpEl && e.target.tagName.toLowerCase() === getNamespacedTagFor('market-context') && !e.target.classList.contains('no-veil')) this.currentContext.currentDialog.el.dismiss({
                origin: this.el
            });
        }
    }
    componentDidLoad() {
        this.initChildListObserver();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-context-manager",
            onMouseDown: (e)=>this.handleMouseEvents(e),
            onMouseUp: (e)=>this.handleMouseEvents(e)
        }, (0, $696Z8.h)("slot", null));
    }
    disconnectedCallback() {
        var _a;
        (_a = this.childListObserver) === null || _a === void 0 || _a.disconnect();
    }
    get el() {
        return this;
    }
    static get style() {
        return marketContextManagerCss;
    }
};
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function toDate(argument) {
    requiredArgs(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function addDays(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var amount = toInteger(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */ function addMonths(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var amount = toInteger(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function addMilliseconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var timestamp = toDate(dirtyDate).getTime();
    var amount = toInteger(dirtyAmount);
    return new Date(timestamp + amount);
}
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(1, arguments);
    var defaultOptions = getDefaultOptions();
    var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = toDate(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function startOfDay(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function addWeeks(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    var days = amount * 7;
    return addDays(dirtyDate, days);
}
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function addYears(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMonths(dirtyDate, amount * 12);
}
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ /**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */ var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */ var millisecondsInHour = 3600000;
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function isSameDay(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
    var dateRightStartOfDay = startOfDay(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function isDate(value) {
    requiredArgs(1, arguments);
    return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function isValid(dirtyDate) {
    requiredArgs(1, arguments);
    if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = toDate(dirtyDate);
    return !isNaN(Number(date));
}
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function startOfMonth(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function startOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var cleanDate = toDate(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}
/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(1, arguments);
    var defaultOptions = getDefaultOptions();
    var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = toDate(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function subMilliseconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var weekStartsOn = 1;
    var date = toDate(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
function getUTCISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
function startOfUTCISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var year = getUTCISOWeekYear(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = startOfUTCISOWeek(fourthOfJanuary);
    return date;
}
var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(1, arguments);
    var defaultOptions = getDefaultOptions();
    var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = toDate(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = getDefaultOptions();
    var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(1, arguments);
    var defaultOptions = getDefaultOptions();
    var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = getUTCWeekYear(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = startOfUTCWeek(firstWeek, options);
    return date;
}
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters$1 = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return addLeadingZeros(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return addLeadingZeros(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return addLeadingZeros(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return addLeadingZeros(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return addLeadingZeros(fractionalSeconds, token.length);
    }
};
var dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return formatters$1.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = getUTCWeekYear(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return addLeadingZeros(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return addLeadingZeros(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = getUTCISOWeekYear(date);
        // Padding
        return addLeadingZeros(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return addLeadingZeros(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return addLeadingZeros(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return addLeadingZeros(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return formatters$1.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return addLeadingZeros(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = getUTCWeek(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return addLeadingZeros(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = getUTCISOWeek(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return addLeadingZeros(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return formatters$1.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = getUTCDayOfYear(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return addLeadingZeros(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return addLeadingZeros(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return addLeadingZeros(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return addLeadingZeros(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return formatters$1.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return formatters$1.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return addLeadingZeros(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return addLeadingZeros(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return formatters$1.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return formatters$1.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return formatters$1.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return addLeadingZeros(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return addLeadingZeros(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = addLeadingZeros(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
var protectedDayOfYearTokens = [
    'D',
    'DD'
];
var protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: buildFormatLongFn({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: buildFormatLongFn({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: buildFormatLongFn({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
var eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: buildLocalizeFn({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: buildLocalizeFn({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: buildLocalizeFn({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: buildLocalizeFn({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: buildLocalizeFn({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: buildMatchFn({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: buildMatchFn({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: buildMatchFn({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'en-US',
    formatDistance: formatDistance,
    formatLong: formatLong,
    formatRelative: formatRelative,
    localize: localize,
    match: match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    requiredArgs(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = getDefaultOptions();
    var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : locale;
    var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale$1.localize) throw new RangeError('locale must contain localize property');
    if (!locale$1.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = toDate(dirtyDate);
    if (!isValid(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
    var utcDate = subMilliseconds(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale$1,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = longFormatters[firstCharacter];
            return longFormatter(substring, locale$1.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = formatters[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale$1.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}
/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function lastDayOfMonth(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function isAfter(dirtyDate, dirtyDateToCompare) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var dateToCompare = toDate(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function isBefore(dirtyDate, dirtyDateToCompare) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var dateToCompare = toDate(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}
/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function lastDayOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function parseISO(argument, options) {
    var _options$additionalDi;
    requiredArgs(1, arguments);
    var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
/**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ function startOfYesterday() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function subMonths(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMonths(dirtyDate, -amount);
}
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function subWeeks(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addWeeks(dirtyDate, -amount);
}
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function subYears(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addYears(dirtyDate, -amount);
}
/**
 *  Enums for market-date-picker-menu slot names used to determine which row was selected
 */ var MENU_SLOT_NAMES;
(function(MENU_SLOT_NAMES) {
    MENU_SLOT_NAMES["TODAY"] = "today";
    MENU_SLOT_NAMES["YESTERDAY"] = "yesterday";
    MENU_SLOT_NAMES["THIS_WEEK"] = "this-week";
    MENU_SLOT_NAMES["LAST_WEEK"] = "last-week";
    MENU_SLOT_NAMES["THIS_MONTH"] = "this-month";
    MENU_SLOT_NAMES["LAST_MONTH"] = "last-month";
    MENU_SLOT_NAMES["THIS_YEAR"] = "this-year";
    MENU_SLOT_NAMES["LAST_YEAR"] = "last-year";
    MENU_SLOT_NAMES["CUSTOM"] = "custom";
})(MENU_SLOT_NAMES || (MENU_SLOT_NAMES = {}));
const marketDatePickerCss = ":host{display:flex}@media only screen and (max-width: 800px){:host([mobile-menu-position='top']){flex-direction:column}:host([mobile-menu-position='top']) list-view{margin-bottom:var(--date-picker-menu-vertical-spacing)}:host([mobile-menu-position='bottom']){flex-direction:column-reverse}:host([mobile-menu-position='bottom']) list-view{margin-top:var(--date-picker-menu-vertical-spacing)}}.left-nav{margin-right:var(--date-picker-header-button-horizontal-spacing)}header{display:flex;justify-content:space-between;align-items:center;height:var(--date-picker-header-minimum-height);margin-bottom:var(--date-picker-header-vertical-spacing)}nav{display:flex}group-view{display:grid;grid-template-rows:repeat(auto-fill, 1fr);grid-template-columns:repeat(7, 1fr);gap:var(--date-picker-grid-item-vertical-padding) var(--date-picker-grid-item-horizontal-padding);box-sizing:border-box}";
/**
 * Object class to hold necessary date information when building out each market-date-picker-date for the calendar
 */ class Day {
    constructor(){
        this.date = '';
        this.month = null;
        this.year = null;
        // For market-date-picker-date props
        this.selected = false;
        this.selection = 'none';
        this.today = false;
        this.disabled = false;
    }
}
const MarketDatePicker$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketDateRangeChanged = (0, $696Z8.createEvent)(this, "marketDateRangeChanged", 7);
        this.marketMenuSelectionChanged = (0, $696Z8.createEvent)(this, "marketMenuSelectionChanged", 7);
        this.selectionType = 'single';
        this.selectedStartDate = undefined;
        this.selectedEndDate = undefined;
        this.presetMenuOption = undefined;
        this.displayMenu = false;
        this.mobileMenuPosition = 'top';
        this.excludeMenuItems = '';
        this.timeframe = 'present';
        this.isDateDisabled = undefined;
        this.locale = navigator.language || 'en-US';
        this.displayedDate = undefined;
        this.withInputs = '';
        this.invalid = false;
        this.displayedMonth = undefined;
        this.displayedWeekdays = [];
        this.hoveredDate = undefined;
    }
    /**
   * Build out the weekday headers based on locale for the calendar view.
   */ buildWeekdays() {
        this.displayedWeekdays = [];
        // Grab start of the week
        const weekday = startOfWeek(new Date());
        let weekdayText;
        for(let d = 0; d < 7; d++){
            weekdayText = weekday.toLocaleDateString(this.locale, {
                weekday: 'short'
            });
            // Shorten English based weekday headers by one
            if (this.locale.startsWith('en-')) weekdayText = weekdayText.slice(0, -1);
            this.displayedWeekdays.push(weekdayText);
            weekday.setDate(weekday.getDate() + 1);
        }
    }
    /**
   * Compares current hovered date to selected dates to determine correct styling for selection.
   */ addHoveredDateRangeStyling(currentDate, datePickerDay) {
        if (!this.hoveredDate) return;
        const currentStartDate = new Date(this.selectedStartDate);
        // Set the day to be in the middle of a range when there is a start date and no end date,
        // and the day in question is between the start date and hovered date.
        if (this.selectedStartDate && !this.selectedEndDate && isBefore(currentDate, this.hoveredDate) && isAfter(currentDate, currentStartDate)) datePickerDay.selection = 'range-middle';
        if (!isSameDay(this.hoveredDate, currentDate)) return;
        // If there's no start date, or a date range is selected, or the hovered date is before or the same as the start date,
        // the hovered button should be the start of a new range.
        if (!this.selectedStartDate || this.selectedStartDate && this.selectedEndDate || !isAfter(this.hoveredDate, currentStartDate)) datePickerDay.selection = 'range-first';
        else datePickerDay.selection = 'range-last';
    }
    /**
   * Helper function to add selection metadata to the date object being processed in buildCalendar.
   */ addDateSelectionAttributes(day, calendarDate, currentStartDate, currentEndDate) {
        // Checks for start date comparison (for both single/range types)
        if (currentStartDate && isSameDay(calendarDate, currentStartDate)) {
            day.selected = true;
            day.selection = this.selectionType === 'single' ? 'single' : 'range-first';
        }
        // For range types only, check for dates within a selected range, or ends in a range
        if (this.selectionType === 'range') {
            this.addHoveredDateRangeStyling(calendarDate, day);
            if (currentStartDate && currentEndDate && isAfter(calendarDate, currentStartDate) && isBefore(calendarDate, currentEndDate)) {
                day.selected = true;
                day.selection = 'range-middle';
            }
            if (currentEndDate && isSameDay(calendarDate, currentEndDate)) {
                day.selected = true;
                day.selection = 'range-last';
            }
        }
    }
    /**
   * The main chunk of this component is building out the calendar view.
   * Ensures correct styling and formatting is placed on each date component.
   * Adapted from: https://ionicframework.com/blog/building-with-stencil-calendar-component/
   */ buildCalendar() {
        const today = new Date();
        const currentDisplayedDate = new Date(this.displayedDate);
        // Calendar used in iteration
        const calendar = new Date(currentDisplayedDate.getFullYear(), currentDisplayedDate.getMonth(), 1);
        // First day of month may not be first day of week
        // Roll back until first day of week
        calendar.setDate(calendar.getDate() - calendar.getDay());
        // Clear days to be rendered
        this.days = [];
        // Create date objects from selected dates if they exist
        const currentStartDate = this.selectedStartDate && new Date(this.selectedStartDate);
        const currentEndDate = this.selectedEndDate && new Date(this.selectedEndDate);
        for(let d = 0; d < 42; d++){
            // Day to be rendered
            // Seed with current date in iteration
            const day = new Day();
            day.year = calendar.getFullYear();
            day.month = calendar.getMonth();
            // Populate day in month
            // Undefined date properties are not rendered
            if (calendar.getFullYear() === currentDisplayedDate.getFullYear() && calendar.getMonth() === currentDisplayedDate.getMonth()) day.date = calendar.getDate().toString();
            // Check for today
            if (isSameDay(calendar, today)) day.today = true;
            // Check for selection types
            this.addDateSelectionAttributes(day, calendar, currentStartDate, currentEndDate);
            // Check for disabled dates
            if (day.date && this.isDateDisabled) day.disabled = this.isDateDisabled(calendar);
            if (this.timeframe === 'future' && isBefore(calendar, today) && !isSameDay(calendar, today)) day.disabled = true;
            if (this.timeframe === 'past' && isAfter(calendar, today) && !isSameDay(calendar, today)) day.disabled = true;
            // Add to days to be rendered
            this.days.push(day);
            // Move to next date
            calendar.setDate(calendar.getDate() + 1);
            // Do not render the last week
            // Depending on calendar layout
            // Some months require five weeks
            // Others six weeks (see May 2021)
            if (calendar.getDay() === 0 && calendar.getMonth() !== currentDisplayedDate.getMonth()) break;
        }
    }
    /**
   * Helper function to clear date selections.
   */ clearDateSelections() {
        this.selectedStartDate = null;
        this.selectedEndDate = null;
    }
    /**
   * Used for the navigation arrows in the market-date-picker header, moves the calendar forward/backward by increment.
   * Currently only used for +1/-1 month.
   */ navigateMonth(increment) {
        const currentDisplayedDate = new Date(this.displayedDate);
        this.displayedDate = new Date(currentDisplayedDate.getFullYear(), currentDisplayedDate.getMonth() + increment, 1).toISOString();
    }
    /**
   *  When ever an event changes the selected date, this updates the calendar view.
   *  The event receives a date string in the yyyy-mm-dd or yyy-mm-ddThh:mm format.
   *  this then checks what parts of the date have changed and only sends the changed parts to the
   * _selectDate function that receives (day, month, year)
   */ dateInputDateSet({ detail: { date, input } }) {
        const [newDate, time] = date.split('T');
        const [newYear, newMonth, newDay] = newDate.split('-').map(Number);
        this.displayedDate = new Date(newYear, newMonth - 1, 1).toString();
        // fallback to undefined, to prevent overwriting if time was initialized but withTime is disabled.
        const [hour, minute] = this.withInputs === 'date-and-time' ? time.split(':').map(Number) : [];
        this._selectDate(newDay, newMonth - 1, newYear, hour, minute, input);
    }
    /**
   * Whenever a market-date-picker-date is selected, this updates the selected date props, which then updates the calendar view.
   */ selectDate({ detail: { date: dateElement } }) {
        this._selectDate(dateElement.day);
    }
    /**
   * Whenever a market-date-picker-date is moused over or hovered, this updates the hovered date to update the calendar view.
   */ hoverDate({ detail: { date: dateElement } }) {
        const currentDisplayedDate = new Date(this.displayedDate);
        this.hoveredDate = new Date(currentDisplayedDate.getFullYear(), currentDisplayedDate.getMonth(), dateElement.day);
    }
    /**
   * Whenever a market-date-picker-date is moused out, clear any hovering styling in the calendar view.
   */ mousedOutDate() {
        this.hoveredDate = null;
    }
    /**
   * Whenever a market-row within market-date-picker-menu is selected, this ensures we move the current selected dates
   * to whichever option the user has selected.
   */ selectMenuRow(e) {
        const menuOption = e.detail.menuSelection;
        if (!menuOption) return;
        this.marketMenuSelectionChanged.emit({
            menuSelection: menuOption
        });
        const prevStartDate = this.selectedStartDate;
        const prevEndDate = this.selectedEndDate;
        this._setMenuRowOption(menuOption);
        if (menuOption !== MENU_SLOT_NAMES.CUSTOM) this.marketDateRangeChanged.emit({
            prevStartDate: prevStartDate,
            prevEndDate: prevEndDate,
            startDate: this.selectedStartDate,
            endDate: this.selectedEndDate,
            menuSelection: menuOption
        });
    }
    /**
   * Updates invalid state of date picker based on date input selections
   */ setInvalidState({ detail: { invalid } }) {
        this.invalid = invalid;
    }
    _setMenuRowOption(menuOption) {
        const today = new Date();
        switch(menuOption){
            case MENU_SLOT_NAMES.TODAY:
                this.clearDateSelections();
                this.selectedStartDate = today.toISOString();
                break;
            case MENU_SLOT_NAMES.YESTERDAY:
                this.clearDateSelections();
                this.selectedStartDate = startOfYesterday().toISOString();
                break;
            case MENU_SLOT_NAMES.THIS_WEEK:
                this.selectedStartDate = startOfWeek(today).toISOString();
                if (this.selectionType === 'range') this.selectedEndDate = endOfWeek(today).toISOString();
                break;
            case MENU_SLOT_NAMES.LAST_WEEK:
                {
                    const lastWeekDate = subWeeks(today, 1);
                    this.selectedStartDate = startOfWeek(lastWeekDate).toISOString();
                    if (this.selectionType === 'range') this.selectedEndDate = endOfWeek(lastWeekDate).toISOString();
                    break;
                }
            case MENU_SLOT_NAMES.THIS_MONTH:
                this.selectedStartDate = startOfMonth(today).toISOString();
                if (this.selectionType === 'range') this.selectedEndDate = lastDayOfMonth(today).toISOString();
                break;
            case MENU_SLOT_NAMES.LAST_MONTH:
                {
                    const lastMonthDate = subMonths(today, 1);
                    this.selectedStartDate = startOfMonth(lastMonthDate).toISOString();
                    if (this.selectionType === 'range') this.selectedEndDate = lastDayOfMonth(lastMonthDate).toISOString();
                    break;
                }
            case MENU_SLOT_NAMES.THIS_YEAR:
                this.selectedStartDate = startOfYear(today).toISOString();
                if (this.selectionType === 'range') this.selectedEndDate = lastDayOfYear(today).toISOString();
                break;
            case MENU_SLOT_NAMES.LAST_YEAR:
                {
                    const lastYearDate = subYears(today, 1);
                    this.selectedStartDate = startOfYear(lastYearDate).toISOString();
                    if (this.selectionType === 'range') this.selectedEndDate = lastDayOfYear(lastYearDate).toISOString();
                    break;
                }
        }
        // Update displayed date to selected date
        if (menuOption !== MENU_SLOT_NAMES.CUSTOM) this.displayedDate = this.selectedStartDate;
    }
    componentWillLoad() {
        if (this.presetMenuOption) this._setMenuRowOption(this.presetMenuOption);
    }
    _selectDate(daySelected, selectedMonth, selectedYear, selectedHour, selectedMinute, input) {
        const prevStartDate = this.selectedStartDate;
        const prevEndDate = this.selectedEndDate;
        const currentDisplayedDate = new Date(this.displayedDate);
        const day = new Date(selectedYear || currentDisplayedDate.getFullYear(), selectedMonth || currentDisplayedDate.getMonth(), daySelected || currentDisplayedDate.getDate(), selectedHour || currentDisplayedDate.getHours(), selectedMinute || currentDisplayedDate.getMinutes()).toISOString();
        if (this.displayMenu && !isSameDay(new Date(this.selectedStartDate), new Date(day))) {
            // Select custom menu row if it exists when calendar is updated
            const menu = this.el.shadowRoot.querySelector(getNamespacedTagFor('market-date-picker-menu'));
            menu._selectCustomRow();
        }
        if (this.selectionType === 'single') {
            this.clearDateSelections();
            this.selectedStartDate = day;
        } else {
            // Date range logic
            if (this.selectedStartDate && !this.selectedEndDate && day > this.selectedStartDate) // if new day is after selected start date, and end date isn't set, update end date.
            this.selectedEndDate = day;
            else if (input) {
                if (input === 'start') this.selectedStartDate = day;
                if (input === 'end') this.selectedEndDate = day;
            } else {
                this.clearDateSelections();
                this.selectedStartDate = day;
            }
        }
        this.marketDateRangeChanged.emit({
            prevStartDate: prevStartDate,
            prevEndDate: prevEndDate,
            startDate: this.selectedStartDate,
            endDate: this.selectedEndDate,
            menuSelection: MENU_SLOT_NAMES.CUSTOM
        });
    }
    /**
   * Core function called whenever props or states are changed to update the calendar view.
   */ componentWillRender() {
        // Handles invalid dates passed in to displayed date
        if (new Date(this.displayedDate).toString() === 'Invalid Date') this.displayedDate = new Date().toISOString();
        this.displayedMonth = new Date(this.displayedDate).toLocaleString(this.locale, {
            month: 'short',
            year: 'numeric'
        });
        this.buildWeekdays();
        this.buildCalendar();
    }
    render() {
        const MarketDatePickerMenuTagName = getNamespacedTagFor('market-date-picker-menu');
        const MarketDatePickerDateTagName = getNamespacedTagFor('market-date-picker-date');
        const MarketDatePickerInputDateTagName = getNamespacedTagFor('market-date-picker-input-date');
        const MarketButtonTagName = getNamespacedTagFor('market-button');
        const MarketAccessoryTagName = getNamespacedTagFor('market-accessory');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-date-picker"
        }, this.displayMenu && (0, $696Z8.h)("list-view", null, (0, $696Z8.h)(MarketDatePickerMenuTagName, {
            timeframe: this.timeframe,
            excludeMenuItems: this.excludeMenuItems,
            presetMenuOption: this.presetMenuOption
        }, (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.TODAY,
            slot: MENU_SLOT_NAMES.TODAY
        }, "Today"), (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.YESTERDAY,
            slot: MENU_SLOT_NAMES.YESTERDAY
        }, "Yesterday"), (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.THIS_WEEK,
            slot: MENU_SLOT_NAMES.THIS_WEEK
        }, "This week"), (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.LAST_WEEK,
            slot: MENU_SLOT_NAMES.LAST_WEEK
        }, "Last week"), (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.THIS_MONTH,
            slot: MENU_SLOT_NAMES.THIS_MONTH
        }, "This month"), (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.LAST_MONTH,
            slot: MENU_SLOT_NAMES.LAST_MONTH
        }, "Last month"), (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.THIS_YEAR,
            slot: MENU_SLOT_NAMES.THIS_YEAR
        }, "This year"), (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.LAST_YEAR,
            slot: MENU_SLOT_NAMES.LAST_YEAR
        }, "Last year"), (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.CUSTOM,
            slot: MENU_SLOT_NAMES.CUSTOM
        }, "Custom"))), (0, $696Z8.h)("calendar", null, (0, $696Z8.h)("header", null, (0, $696Z8.h)("h2", {
            id: "date-picker-label"
        }, this.displayedMonth), (0, $696Z8.h)("nav", null, (0, $696Z8.h)(MarketButtonTagName, {
            class: "left-nav",
            size: "small",
            "aria-label": "Previous month",
            onClick: ()=>this.navigateMonth(-1)
        }, (0, $696Z8.h)(MarketAccessoryTagName, {
            slot: "icon"
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M4.29289 11.293C3.90237 11.6835 3.90237 12.3167 4.29289 12.7072L11.2929 19.7072L12.7071 18.293L7.41421 13.0001L19 13.0001V11.0001L7.41421 11.0001L12.7071 5.70718L11.2929 4.29297L4.29289 11.293Z"
        })))), (0, $696Z8.h)(MarketButtonTagName, {
            size: "small",
            "aria-label": "Next month",
            onClick: ()=>this.navigateMonth(1)
        }, (0, $696Z8.h)(MarketAccessoryTagName, {
            slot: "icon"
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M19.7071 11.293C20.0976 11.6835 20.0976 12.3167 19.7071 12.7072L12.7071 19.7072L11.2929 18.293L16.5858 13.0001L5 13.0001L5 11.0001L16.5858 11.0001L11.2929 5.70718L12.7071 4.29297L19.7071 11.293Z",
            fill: "black",
            "fill-opacity": "0.9"
        })))))), (0, $696Z8.h)("group-view", {
            role: "grid",
            "aria-labelledby": "date-picker-label"
        }, // Set the weekdays header for the date picker calendar
        this.displayedWeekdays.map((text)=>(0, $696Z8.h)(MarketDatePickerDateTagName, {
                class: 'weekday-header',
                disabled: true,
                day: text
            })), // Set the available dates
        this.days.map((day)=>(0, $696Z8.h)(MarketDatePickerDateTagName, {
                disabled: day.disabled,
                selection: day.selection,
                today: day.today,
                selected: day.selected,
                day: day.date || null
            }))), this.withInputs && (0, $696Z8.h)(MarketDatePickerInputDateTagName, {
            class: "date-input-top-margin",
            range: this.selectionType === 'range',
            isDateDisabled: this.isDateDisabled,
            selectedStartDate: this.selectedStartDate,
            selectedEndDate: this.selectedEndDate,
            withTime: this.withInputs === 'date-and-time',
            timeframe: this.timeframe
        }, (0, $696Z8.h)("slot", {
            name: "start-date",
            slot: "start-date"
        }, this.selectionType === 'range' ? 'Start ' : '', "Date"), (0, $696Z8.h)("slot", {
            name: "end-date",
            slot: "end-date"
        }, "End Date"), (0, $696Z8.h)("slot", {
            name: "start-time",
            slot: "start-time"
        }, this.selectionType === 'range' ? 'Start ' : '', "Time"), (0, $696Z8.h)("slot", {
            name: "end-time",
            slot: "end-time"
        }, "End Time"))));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketDatePickerCss;
    }
};
const marketDatePickerDateCss = ":host(:not([day])){border-width:0 !important;border-radius:0 !important;background-color:rgb(0 0 0 / 0) !important;color:rgb(0 0 0 / 0) !important;pointer-events:none !important;}:host{display:inline-flex;flex-direction:row;justify-content:center;align-items:center;width:100%;min-width:var(--date-picker-grid-item-width);height:var(--date-picker-grid-item-height);padding:0;font-size:var(--date-picker-weekdays-font-size);line-height:var(--date-picker-weekdays-font-leading);text-align:center}:host([disabled]){color:var(--date-picker-date-text-unselected-selection-disabled-state-color);cursor:not-allowed}:host(.weekday-header){color:var(--date-picker-weekdays-color-color);cursor:auto}:host(:not([selection='range-middle']:not([today]))){border-radius:var(--date-picker-date-border-radius)}:host([selection='none']:not([disabled])){color:var(--date-picker-date-text-unselected-selection-normal-state-color)}:host([selection='single'][selected]),:host([selection='range-first'][selected]),:host([selection='range-last'][selected]){background-color:var(--date-picker-date-background-single-selection-normal-state-color);color:var(--date-picker-date-text-single-selection-disabled-state-color)}:host([selection='single'][disabled][selected]),:host([selection='range-first'][disabled][selected]),:host([selection='range-last'][disabled][selected]){background-color:var(--date-picker-date-background-single-selection-disabled-state-color);color:var(--date-picker-date-text-single-selection-disabled-state-color)}:host(:hover[selection='range-first']:not([selected]):not([today])),:host(:active[selection='range-first']:not([selected]):not([today])){--date-picker-date-range-first-selection-border-radius-top-left:var(--date-picker-date-border-radius);--date-picker-date-range-first-selection-border-radius-top-right:0;--date-picker-date-range-first-selection-border-radius-bottom-right:0;--date-picker-date-range-first-selection-border-radius-bottom-left:var(--date-picker-date-border-radius);border-radius:var(--date-picker-date-range-first-selection-border-radius-top-left)\n      var(--date-picker-date-range-first-selection-border-radius-top-right)\n      var(--date-picker-date-range-first-selection-border-radius-bottom-right)\n      var(--date-picker-date-range-first-selection-border-radius-bottom-left)}:host([selection='range-middle']:not([disabled])){background-color:var(--date-picker-date-background-range-middle-selection-hover-state-color);color:var(--date-picker-date-text-range-middle-selection-hover-state-color)}:host([selection='range-middle'][selected]){background-color:var(--date-picker-date-background-range-middle-selection-normal-state-color)}:host([selection='range-middle'][disabled][today]){border-color:var(--date-picker-date-border-disabled-state-color-color)}:host(:hover[selection='range-last']:not([selected]):not([today])),:host(:active[selection='range-last']:not([selected]):not([today])){--date-picker-date-range-last-selection-border-radius-top-left:0;--date-picker-date-range-last-selection-border-radius-top-right:var(--date-picker-date-border-radius);--date-picker-date-range-last-selection-border-radius-bottom-right:var(--date-picker-date-border-radius);--date-picker-date-range-last-selection-border-radius-bottom-left:0;border-radius:var(--date-picker-date-range-last-selection-border-radius-top-left)\n      var(--date-picker-date-range-last-selection-border-radius-top-right)\n      var(--date-picker-date-range-last-selection-border-radius-bottom-right)\n      var(--date-picker-date-range-last-selection-border-radius-bottom-left)}:host([today]){box-sizing:border-box;border-width:calc(var(--date-picker-today-border-width) * 1px);border-style:solid;border-radius:var(--date-picker-date-border-radius);font-weight:var(--date-picker-today-font-weight)}:host([today]:not([disabled])){border-color:var(--date-picker-today-border-color-color)}:host([today][disabled]){color:var(--date-picker-today-label-disabled-state-color-color)}:host(:hover:not([disabled])){cursor:pointer}:host(:hover:not([disabled]):not([selected])){background-color:var(--date-picker-date-background-unselected-selection-hover-state-color);color:var(--date-picker-date-text-unselected-selection-hover-state-color)}:host(:active:not([disabled]):not([selected])){background-color:var(--date-picker-date-background-unselected-selection-pressed-state-color);color:var(--date-picker-date-text-unselected-selection-pressed-state-color)}";
const MarketDatePickerDate$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketDatePickerDateSelected = (0, $696Z8.createEvent)(this, "marketDatePickerDateSelected", 7);
        this.marketDatePickerDateMousedOver = (0, $696Z8.createEvent)(this, "marketDatePickerDateMousedOver", 7);
        this.marketDatePickerDateMousedOut = (0, $696Z8.createEvent)(this, "marketDatePickerDateMousedOut", 7);
        this.disabled = false;
        this.selection = 'none';
        this.today = false;
        this.selected = false;
        this.day = undefined;
    }
    /**
   * Interaction handler that passes events back to the market-date-picker component
   */ handleInteraction(e) {
        if (this.disabled || this.day.length === 0) {
            e.stopImmediatePropagation();
            return;
        }
        if (e.type === 'click') this.marketDatePickerDateSelected.emit({
            date: this.el
        });
        if (e.type === 'mouseover') this.marketDatePickerDateMousedOver.emit({
            date: this.el
        });
        if (e.type === 'mouseout') this.marketDatePickerDateMousedOut.emit();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-date-picker-date",
            "aria-disabled": this.disabled,
            onClick: (e)=>{
                this.handleInteraction(e);
            },
            onmouseover: (e)=>{
                this.handleInteraction(e);
            },
            onmouseout: (e)=>{
                this.handleInteraction(e);
            }
        }, this.day);
    }
    get el() {
        return this;
    }
    static get style() {
        return marketDatePickerDateCss;
    }
};
const marketDatePickerInputDateCss = ".input-row{display:flex;justify-content:space-around;margin-top:8px}.input-wrapper{display:flex;flex:1;flex-direction:column;align-items:flex-start}.start-input:not(:last-child){margin-right:16px}.time-input,.date-input{box-sizing:border-box;width:100%;margin-top:16px}.market-banner{margin-top:16px}";
const MarketDateInputDate = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketDatePickerInputDateSet = (0, $696Z8.createEvent)(this, "marketDatePickerInputDateSet", 7);
        this.marketDatePickerInputDateInvalidStateChanged = (0, $696Z8.createEvent)(this, "marketDatePickerInputDateInvalidStateChanged", 7);
        this.withTime = false;
        this.selectedStartDate = undefined;
        this.selectedEndDate = undefined;
        this.isDateDisabled = undefined;
        this.timeframe = 'present';
        this.range = false;
        this.isRangeInvalid = false;
    }
    emitInvalidStateEvent() {
        this.marketDatePickerInputDateInvalidStateChanged.emit({
            invalid: this.isRangeInvalid
        });
    }
    formatDate(date, isTime = false) {
        if (!date) return '';
        const dateObj = new Date(date);
        if (!isValid(dateObj)) return '';
        const formatStr = isTime ? 'HH:mm' : 'yyyy-MM-dd';
        return format(dateObj, formatStr);
    }
    isInvalidDateForTimeframe(dateObj, today = new Date()) {
        const isFutureDate = this.timeframe === 'future' && isBefore(dateObj, today) && !isSameDay(dateObj, today);
        const isPastDate = this.timeframe === 'past' && isAfter(dateObj, today) && !isSameDay(dateObj, today);
        return isFutureDate || isPastDate;
    }
    updateInvalidState(start = this.selectedStartDate, end = this.selectedEndDate) {
        if (this.isDateInvalid(start) || this.isDateInvalid(end)) {
            this.isRangeInvalid = true;
            return;
        }
        // If end date is set, check if start date is after end date
        if (end) {
            this.isRangeInvalid = isAfter(new Date(start), new Date(end));
            return;
        }
        this.isRangeInvalid = false;
    }
    isDateInvalid(date) {
        if (!date) return false;
        const dateObj = parseISO(date);
        if (dateObj.toString() === 'Invalid Date') return true;
        if (this.isDateDisabled && this.isDateDisabled(dateObj)) return true;
        if (this.timeframe && this.isInvalidDateForTimeframe(dateObj)) return true;
        return false;
    }
    emitDateSetStart(ev) {
        this.emitDateSet(ev, 'start');
    }
    emitDateSetEnd(ev) {
        this.emitDateSet(ev, 'end');
    }
    emitDateSetStartTime(ev) {
        this.emitDateSet(ev, 'start', true);
    }
    emitDateSetEndTime(ev) {
        this.emitDateSet(ev, 'end', true);
    }
    emitDateSet(ev, input, timeInput = false) {
        ev.preventDefault();
        ev.stopPropagation();
        const { value } = ev.target;
        let valueToSubmit = value;
        // If time is set, add the time to the date
        if (this.withTime) {
            if (timeInput) {
                const date = this.formatDate(input === 'start' ? this.selectedStartDate : this.selectedEndDate);
                const time = value.slice(0, 5);
                valueToSubmit = `${date}T${time}`;
            } else {
                const time = this.formatDate(input === 'start' ? this.selectedStartDate : this.selectedEndDate, true);
                valueToSubmit = `${value}T${time}`;
            }
        }
        // Remove leading zeros
        const realLength = valueToSubmit.replace(/^0+/, '').length;
        // Only emit if length is (yyyy-mm-dd) or (yyyy-mm-ddThh:mm) and is valid
        if (realLength === 10 || realLength === 16) this.marketDatePickerInputDateSet.emit({
            date: valueToSubmit,
            input: input
        });
    }
    componentWillRender() {
        this.updateInvalidState();
    }
    render() {
        const MarketInputTextTagName = getNamespacedTagFor('market-input-text');
        const MarketBannerTagName = getNamespacedTagFor('market-banner');
        const inputWrapper = (type)=>(0, $696Z8.h)("div", {
                class: `input-wrapper ${type === 'start' ? 'start-input' : ''}`
            }, type === 'start' && dateInput('start'), type === 'start' && this.withTime && timeInput('start'), type === 'end' && dateInput('end'), type === 'end' && this.withTime && timeInput('end'));
        const dateInput = (type)=>(0, $696Z8.h)(MarketInputTextTagName, {
                type: "date",
                class: `date-input`,
                name: `date-picker-date-${type}`,
                invalid: this.isRangeInvalid,
                value: this.formatDate(type === 'start' ? this.selectedStartDate : this.selectedEndDate),
                onInput: type === 'start' ? this.emitDateSetStart.bind(this) : this.emitDateSetEnd.bind(this)
            }, (0, $696Z8.h)("label", {
                htmlFor: `date-picker-${type}`
            }, (0, $696Z8.h)("slot", {
                name: `${type}-date`
            }, this.range && (type === 'start' ? 'Start' : 'End'), " Date")));
        const timeInput = (type)=>(0, $696Z8.h)(MarketInputTextTagName, {
                type: "time",
                class: `time-input`,
                name: `date-picker-time-${type}`,
                invalid: this.isRangeInvalid,
                value: this.formatDate(type === 'start' ? this.selectedStartDate : this.selectedEndDate, true),
                onInput: type === 'start' ? this.emitDateSetStartTime.bind(this) : this.emitDateSetEndTime.bind(this)
            }, (0, $696Z8.h)("label", {
                htmlFor: `date-picker-time-${type}`
            }, (0, $696Z8.h)("slot", {
                name: `${type}-time`
            }, this.range && (type === 'start' ? 'Start' : 'End'), " Time")));
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-date-picker-input-date"
        }, this.range ? (0, $696Z8.h)("div", {
            class: "input-row"
        }, inputWrapper('start'), inputWrapper('end')) : (0, $696Z8.h)("div", null, inputWrapper('start')), this.isRangeInvalid && (0, $696Z8.h)(MarketBannerTagName, {
            variant: "critical"
        }, "Enter a valid date range"));
    }
    static get watchers() {
        return {
            "isRangeInvalid": [
                "emitInvalidStateEvent"
            ]
        };
    }
    static get style() {
        return marketDatePickerInputDateCss;
    }
};
const marketDatePickerMenuCss = ":host{display:block;margin-right:var(--date-picker-menu-horizontal-spacing);font-weight:var(--date-picker-menu-text-weight);font-size:var(--date-picker-menu-text-size);line-height:var(--date-picker-menu-text-leading)}:host>.market-list>.market-row{min-height:var(--date-picker-menu-row-height);padding:0 12px}:host>.market-list>.market-row::before{content:none}:host>.market-list>.market-row::part(container){padding-right:0;padding-left:0}:host>.market-list>.market-row[selected]{color:var(--date-picker-menu-row-label-selected-state-text-color)}@media only screen and (max-width: 800px){:host{margin-right:0}:host>.market-list>.market-row{width:inherit}}";
const MarketDatePickerMenu$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketDatePickerMenuSelectionChanged = (0, $696Z8.createEvent)(this, "marketDatePickerMenuSelectionChanged", 7);
        this.timeframe = 'present';
        this.excludeMenuItems = '';
        this.presetMenuOption = undefined;
    }
    handleMarketListSelectionsDidChange(e) {
        e.stopPropagation();
        this.marketDatePickerMenuSelectionChanged.emit({
            menuSelection: e.detail.newSelectionValue
        });
    }
    /**
   * Method to visually select Custom row for use by the date picker component
   * (internal use only)
   */ _selectCustomRow() {
        const MarketRowTagName = getNamespacedTagFor('market-row');
        this.el.shadowRoot.querySelectorAll(MarketRowTagName).forEach((row)=>{
            if (row.querySelector('slot').name === MENU_SLOT_NAMES.CUSTOM) row.click();
        });
        return Promise.resolve();
    }
    render() {
        const MarketListTagName = getNamespacedTagFor('market-list');
        const MarketRowTagName = getNamespacedTagFor('market-row');
        const excludedItems = this.excludeMenuItems.split(',');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-date-picker-menu"
        }, (0, $696Z8.h)(MarketListTagName, {
            interactive: true
        }, this.timeframe !== 'past' && !excludedItems.includes(MENU_SLOT_NAMES.TODAY) && (0, $696Z8.h)(MarketRowTagName, {
            value: MENU_SLOT_NAMES.TODAY,
            selected: this.presetMenuOption === MENU_SLOT_NAMES.TODAY
        }, (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.TODAY
        }, "Today")), this.timeframe !== 'future' && !excludedItems.includes(MENU_SLOT_NAMES.YESTERDAY) && (0, $696Z8.h)(MarketRowTagName, {
            value: MENU_SLOT_NAMES.YESTERDAY,
            selected: this.presetMenuOption === MENU_SLOT_NAMES.YESTERDAY
        }, (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.YESTERDAY
        }, "Yesterday")), this.timeframe !== 'past' && !excludedItems.includes(MENU_SLOT_NAMES.THIS_WEEK) && (0, $696Z8.h)(MarketRowTagName, {
            value: MENU_SLOT_NAMES.THIS_WEEK,
            selected: this.presetMenuOption === MENU_SLOT_NAMES.THIS_WEEK
        }, (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.THIS_WEEK
        }, "This week")), this.timeframe !== 'future' && !excludedItems.includes(MENU_SLOT_NAMES.LAST_WEEK) && (0, $696Z8.h)(MarketRowTagName, {
            value: MENU_SLOT_NAMES.LAST_WEEK,
            selected: this.presetMenuOption === MENU_SLOT_NAMES.LAST_WEEK
        }, (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.LAST_WEEK
        }, "Last week")), this.timeframe !== 'past' && !excludedItems.includes(MENU_SLOT_NAMES.THIS_MONTH) && (0, $696Z8.h)(MarketRowTagName, {
            value: MENU_SLOT_NAMES.THIS_MONTH,
            selected: this.presetMenuOption === MENU_SLOT_NAMES.THIS_MONTH
        }, (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.THIS_MONTH
        }, "This month")), this.timeframe !== 'future' && !excludedItems.includes(MENU_SLOT_NAMES.LAST_MONTH) && (0, $696Z8.h)(MarketRowTagName, {
            value: MENU_SLOT_NAMES.LAST_MONTH,
            selected: this.presetMenuOption === MENU_SLOT_NAMES.LAST_MONTH
        }, (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.LAST_MONTH
        }, "Last month")), this.timeframe !== 'past' && !excludedItems.includes(MENU_SLOT_NAMES.THIS_YEAR) && (0, $696Z8.h)(MarketRowTagName, {
            value: MENU_SLOT_NAMES.THIS_YEAR,
            selected: this.presetMenuOption === MENU_SLOT_NAMES.THIS_YEAR
        }, (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.THIS_YEAR
        }, "This year")), this.timeframe !== 'future' && !excludedItems.includes(MENU_SLOT_NAMES.LAST_YEAR) && (0, $696Z8.h)(MarketRowTagName, {
            value: MENU_SLOT_NAMES.LAST_YEAR,
            selected: this.presetMenuOption === MENU_SLOT_NAMES.LAST_YEAR
        }, (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.LAST_YEAR
        }, "Last year")), !excludedItems.includes(MENU_SLOT_NAMES.CUSTOM) && (0, $696Z8.h)(MarketRowTagName, {
            value: MENU_SLOT_NAMES.CUSTOM,
            selected: this.presetMenuOption === MENU_SLOT_NAMES.CUSTOM
        }, (0, $696Z8.h)("slot", {
            name: MENU_SLOT_NAMES.CUSTOM
        }, "Custom"))));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketDatePickerMenuCss;
    }
};
const marketDialogCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{display:flex;flex-direction:column;justify-content:stretch;overflow:hidden}:host ::slotted(main){flex:0 1 100%;overflow-y:auto;height:100%}:host ::slotted(.market-header){margin-bottom:var(--core-metrics-spacing-300);padding-top:0}:host ::slotted(.market-footer){padding-bottom:0}:host{width:100%;max-width:var(--modal-dialog-width, 100%);height:auto;padding:var(--modal-dialog-regular-vertical-size-class-vertical-padding)\n    var(--modal-dialog-regular-horizontal-size-class-horizontal-padding);border-radius:var(--modal-dialog-border-radius);background-color:var(--modal-dialog-background-color);animation:var(--modal-dialog-animation-enter-transition-duration)\n    market-popup\n    forwards\n    var(--modal-dialog-animation-enter-transition-easing)}:host([hidden]){animation-name:market-popdown;animation-duration:var(--modal-dialog-animation-exit-transition-duration);animation-timing-function:var(--modal-dialog-animation-exit-transition-easing)}:host([value='loadingMode']){display:flex;flex-direction:column}.market-activity-indicator{position:static;top:24px;left:40px;flex:none;color:var(--core-emphasis-fill-color)}";
const MarketDialog$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketDialogLoaded = (0, $696Z8.createEvent)(this, "marketDialogLoaded", 7);
        this.marketDialogDismissed = (0, $696Z8.createEvent)(this, "marketDialogDismissed", 7);
        this.marketDialogDidDismiss = (0, $696Z8.createEvent)(this, "marketDialogDidDismiss", 7);
        this.type = 'dialog';
        this.hidden = false;
        this.dialogID = undefined;
        this.index = undefined;
        this.isLoading = false;
        this.persistent = false;
        this.trapFocus = false;
        this.animationEnterDuration = cjs.MODAL_DIALOG_ANIMATION_ENTER_TRANSITION_DURATION;
        this.animationExitDuration = cjs.MODAL_DIALOG_ANIMATION_EXIT_TRANSITION_DURATION;
    }
    /**
   * Emits the dismiss event
   * The parent context will handle actually removing elements from the DOM,
   * All the dialog needs to do it emit an event so actually closing it can be
   * some other elements problem
   */ dismiss(options) {
        if (!this.persistent) {
            const { defaultPrevented } = this.marketDialogDismissed.emit({
                dialog: this.el,
                type: this.type,
                origin: (options === null || options === void 0 ? void 0 : options.origin) || this.el
            });
            if (!defaultPrevented) {
                this.hidden = true;
                /**
         * Emit a marketDialogDidDismiss event when modal gets fully dismissed (after animation).
         */ setTimeout(()=>{
                    this.marketDialogDidDismiss.emit({
                        dialog: this.el,
                        type: this.type,
                        origin: this.el
                    });
                }, this.animationExitDuration);
            }
        }
        return Promise.resolve();
    }
    onTrapFocusChanged(newValue, oldValue) {
        if (newValue !== oldValue) {
            if (newValue) this.activateFocusTrap();
            else this.deactivateFocusTrap();
        }
    }
    /**
   * Activates the focus trap
   * @param {Object} [options] [focus-trap `.createFocusTrap` options](https://github.com/focus-trap/focus-trap#createoptions)
   * @param {Object} [activateOptions] [focus-trap `.activate` options](https://github.com/focus-trap/focus-trap#trapactivate)
   */ activateFocusTrap(options, activateOptions) {
        if (this.focusTrap) {
            this.focusTrap.activate(activateOptions);
            if (!this.trapFocus) this.trapFocus = true;
        } else this.focusTrap = createAndActivateFocusTrap(this.el, options, activateOptions);
        return Promise.resolve();
    }
    /**
   * Deactivates the focus trap
   * @param {Object} [deactivateOptions] [focus-trap `.deactivate` options](https://github.com/focus-trap/focus-trap#trapdeactivate)
   */ deactivateFocusTrap(deactivateOptions) {
        if (this.focusTrap) {
            this.focusTrap.deactivate(deactivateOptions);
            this.focusTrap = undefined;
        }
        return Promise.resolve();
    }
    connectedCallback() {
        this.connectedCallbackTimeout = setTimeout(()=>{
            /**
       * Emit a marketDialogLoaded event when the component connects. Need this so
       * the context manager isn't rummaging around it's DOM to try and find the
       * dialog that was just appended
       */ this.marketDialogLoaded.emit({
                dialog: this.el,
                type: this.type
            });
            if (this.trapFocus) this.activateFocusTrap();
        }, this.animationEnterDuration);
    }
    disconnectedCallback() {
        this.deactivateFocusTrap();
        /**
     * Prevents error caused by race conditions during rapid mounting and
     * unmounting of component by clearing the setTimeout from connectedCallback
     * if it gets called after disconnectedCallback.
     */ clearTimeout(this.connectedCallbackTimeout);
    }
    render() {
        const MarketActivityIndicatorTagName = getNamespacedTagFor('market-activity-indicator');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-dialog",
            role: "dialog"
        }, this.isLoading && (0, $696Z8.h)(MarketActivityIndicatorTagName, null), (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "trapFocus": [
                "onTrapFocusChanged"
            ]
        };
    }
    static get style() {
        return marketDialogCss;
    }
};
const marketDividerCss = ":host{display:block;height:var(--divider-height);border-radius:var(--divider-radius);background-color:var(--divider-fill-color)}:host([margin=\"large\"]){margin:var(--divider-large-variant-vertical-padding) 0}:host([margin=\"medium\"]){margin:var(--divider-medium-variant-vertical-padding) 0}:host([margin=\"small\"]){margin:var(--divider-small-variant-vertical-padding) 0}";
const MarketDivider$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.margin = 'medium';
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-divider"
        });
    }
    static get style() {
        return marketDividerCss;
    }
};
/**
 * Check if the event is a TouchEvent
 * @param {TMouseOrTouchEvent} event
 */ function isTouchEvent(event) {
    return Boolean(event === null || event === void 0 ? void 0 : event.changedTouches);
}
const marketDragHandleCss = ":host{margin:calc(var(--core-metrics-spacing-200) * -1);padding:var(--core-metrics-spacing-200);cursor:grab}:host(:active){cursor:grabbing}svg{display:block;fill:var(--drag-handle-normal-state-color, var(--core-fill-20-color))}:host(:hover) svg{fill:var(--drag-handle-hover-state-color, var(--core-fill-10-color))}";
const MarketDragHandle$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketDragHandleDragStart = (0, $696Z8.createEvent)(this, "marketDragHandleDragStart", 7);
        this.marketDragHandleDragMove = (0, $696Z8.createEvent)(this, "marketDragHandleDragMove", 7);
        this.marketDragHandleDragEnd = (0, $696Z8.createEvent)(this, "marketDragHandleDragEnd", 7);
        // These bound func refs are so we can remove them later
        this.boundOnDragMove = this.onDragMove.bind(this);
        this.boundOnDragEnd = this.onDragEnd.bind(this);
    }
    onDragStart(e) {
        e.preventDefault();
        // only start drag on touch events or left mouse clicks
        if (!isTouchEvent(e) && e.button !== 0) return;
        const { marketDragHandleDragStart, boundOnDragMove, boundOnDragEnd } = this;
        const coords = this.getCoordsFromEvent(e);
        const { defaultPrevented } = marketDragHandleDragStart.emit(coords);
        if (defaultPrevented) return;
        document.addEventListener('mousemove', boundOnDragMove);
        document.addEventListener('mouseup', boundOnDragEnd);
        // don't use passive touch event listeners so we can call preventDefault()
        document.addEventListener('touchmove', boundOnDragMove, {
            passive: false
        });
        document.addEventListener('touchend', boundOnDragEnd, {
            passive: false
        });
    }
    onDragMove(e) {
        e.preventDefault();
        const { marketDragHandleDragMove, boundOnDragMove, boundOnDragEnd } = this;
        const coords = this.getCoordsFromEvent(e);
        const { defaultPrevented } = marketDragHandleDragMove.emit(coords);
        if (defaultPrevented) {
            // cancel the drag
            document.removeEventListener('mousemove', boundOnDragMove);
            document.removeEventListener('mouseup', boundOnDragEnd);
            document.removeEventListener('touchmove', boundOnDragMove);
            document.removeEventListener('touchend', boundOnDragEnd);
        }
    }
    onDragEnd(e) {
        e.preventDefault();
        const { marketDragHandleDragEnd, boundOnDragMove, boundOnDragEnd } = this;
        const coords = this.getCoordsFromEvent(e);
        const { defaultPrevented } = marketDragHandleDragEnd.emit(coords);
        if (defaultPrevented) return;
        document.removeEventListener('mousemove', boundOnDragMove);
        document.removeEventListener('mouseup', boundOnDragEnd);
        document.removeEventListener('touchmove', boundOnDragMove);
        document.removeEventListener('touchend', boundOnDragEnd);
    }
    // gets coords depending on touch vs mouse event
    getCoordsFromEvent(e) {
        const x = isTouchEvent(e) ? e.changedTouches[0].clientX : e.clientX;
        const y = isTouchEvent(e) ? e.changedTouches[0].clientY : e.clientY;
        return {
            x: x,
            y: y
        };
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-drag-handle",
            onMouseDown: (e)=>this.onDragStart(e),
            onTouchStart: (e)=>this.onDragStart(e)
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M15 8C16.1046 8 17 7.10457 17 6C17 4.89543 16.1046 4 15 4C13.8954 4 13 4.89543 13 6C13 7.10457 13.8954 8 15 8ZM15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14ZM11 18C11 19.1046 10.1046 20 9 20C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16C10.1046 16 11 16.8954 11 18ZM17 18C17 19.1046 16.1046 20 15 20C13.8954 20 13 19.1046 13 18C13 16.8954 13.8954 16 15 16C16.1046 16 17 16.8954 17 18ZM11 12C11 13.1046 10.1046 14 9 14C7.89543 14 7 13.1046 7 12C7 10.8954 7.89543 10 9 10C10.1046 10 11 10.8954 11 12ZM11 6C11 7.10457 10.1046 8 9 8C7.89543 8 7 7.10457 7 6C7 4.89543 7.89543 4 9 4C10.1046 4 11 4.89543 11 6Z"
        })));
    }
    static get style() {
        return marketDragHandleCss;
    }
};
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements$1 = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];
function getNodeName$1(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}
function getWindow$1(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}
function isElement$1(node) {
    var OwnElement = getWindow$1(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement$1(node) {
    var OwnElement = getWindow$1(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot$1(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = getWindow$1(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!isHTMLElement$1(element) || !getNodeName$1(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function effect$2(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!isHTMLElement$1(element) || !getNodeName$1(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
const applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect$2,
    requires: [
        'computeStyles'
    ]
};
function getBasePlacement(placement) {
    return placement.split('-')[0];
}
var max$1 = Math.max;
var min$1 = Math.min;
var round$1 = Math.round;
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect$1(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && isHTMLElement$1(element)) {
        scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = isElement$1(element) ? getWindow$1(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}
// means it doesn't take into account transforms.
function getLayoutRect(element) {
    var clientRect = getBoundingClientRect$1(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && isShadowRoot$1(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}
function getComputedStyle$2(element) {
    return getWindow$1(element).getComputedStyle(element);
}
function isTableElement$1(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf(getNodeName$1(element)) >= 0;
}
function getDocumentElement$1(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return ((isElement$1(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode$1(element) {
    if (getNodeName$1(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || (isShadowRoot$1(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement$1(element) // fallback
    );
}
function getTrueOffsetParent$1(element) {
    if (!isHTMLElement$1(element) || // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle$2(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock$1(element) {
    var isFirefox = /firefox/i.test(getUAString());
    var isIE = /Trident/i.test(getUAString());
    if (isIE && isHTMLElement$1(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = getComputedStyle$2(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = getParentNode$1(element);
    if (isShadowRoot$1(currentNode)) currentNode = currentNode.host;
    while(isHTMLElement$1(currentNode) && [
        'html',
        'body'
    ].indexOf(getNodeName$1(currentNode)) < 0){
        var css = getComputedStyle$2(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent$1(element) {
    var window1 = getWindow$1(element);
    var offsetParent = getTrueOffsetParent$1(element);
    while(offsetParent && isTableElement$1(offsetParent) && getComputedStyle$2(offsetParent).position === 'static')offsetParent = getTrueOffsetParent$1(offsetParent);
    if (offsetParent && (getNodeName$1(offsetParent) === 'html' || getNodeName$1(offsetParent) === 'body' && getComputedStyle$2(offsetParent).position === 'static')) return window1;
    return offsetParent || getContainingBlock$1(element) || window1;
}
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}
function within(min, value, max) {
    return max$1(min, min$1(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}
function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [
        left,
        right
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === 'y' ? top : left;
    var maxProp = axis === 'y' ? bottom : right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent$1(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = within(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect$1(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!contains(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
const arrow$1 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect$1,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};
function getVariation(placement) {
    return placement.split('-')[1];
}
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: round$1(x * dpr) / dpr || 0,
        y: round$1(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = left;
    var sideY = top;
    var win = window;
    if (adaptive) {
        var offsetParent = getOffsetParent$1(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === getWindow$1(popper)) {
            offsetParent = getDocumentElement$1(popper);
            if (getComputedStyle$2(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === top || (placement === left || placement === right) && variation === end) {
            sideY = bottom;
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === left || (placement === top || placement === bottom) && variation === end) {
            sideX = right;
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, getWindow$1(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: getBasePlacement(state.placement),
        variation: getVariation(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
const computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window1 = getWindow$1(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window1.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window1.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
const eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};
var hash$1 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement$1(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash$1[matched];
    });
}
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}
function getWindowScroll(node) {
    var win = getWindow$1(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}
function getWindowScrollBarX$1(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return getBoundingClientRect$1(getDocumentElement$1(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect$1(element, strategy) {
    var win = getWindow$1(element);
    var html = getDocumentElement$1(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = isLayoutViewport();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + getWindowScrollBarX$1(element),
        y: y
    };
}
// of the `<html>` and `<body>` rect bounds if horizontally scrollable
function getDocumentRect$1(element) {
    var _element$ownerDocumen;
    var html = getDocumentElement$1(element);
    var winScroll = getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = max$1(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = max$1(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX$1(element);
    var y = -winScroll.scrollTop;
    if (getComputedStyle$2(body || html).direction === 'rtl') x += max$1(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = getComputedStyle$2(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf(getNodeName$1(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if (isHTMLElement$1(node) && isScrollParent(node)) return node;
    return getScrollParent(getParentNode$1(node));
}
/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/ function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = getScrollParent(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = getWindow$1(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode$1(target)));
}
function rectToClientRect$1(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}
function getInnerBoundingClientRect$1(element, strategy) {
    var rect = getBoundingClientRect$1(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === viewport ? rectToClientRect$1(getViewportRect$1(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect$1(clippingParent, strategy) : rectToClientRect$1(getDocumentRect$1(getDocumentElement$1(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = listScrollParents(getParentNode$1(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf(getComputedStyle$2(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent$1(element) : element;
    if (!isElement$1(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName$1(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents
function getClippingRect$1(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = max$1(rect.top, accRect.top);
        accRect.right = min$1(rect.right, accRect.right);
        accRect.bottom = min$1(rect.bottom, accRect.bottom);
        accRect.left = max$1(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
        }
    }
    return offsets;
}
function detectOverflow$1(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect$1(isElement$1(element) ? element : element.contextElement || getDocumentElement$1(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = getBoundingClientRect$1(state.elements.reference);
    var popperOffsets = computeOffsets({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = rectToClientRect$1(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === popper && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                right,
                bottom
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                top,
                bottom
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements$1 : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement) {
        return getVariation(placement) === variation;
    }) : basePlacements;
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = detectOverflow$1(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[getBasePlacement(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}
function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement(placement) === auto) return [];
    var oppositePlacement = getOppositePlacement$1(placement);
    return [
        getOppositeVariationPlacement(placement),
        oppositePlacement,
        getOppositeVariationPlacement(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        getOppositePlacement$1(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = getBasePlacement(placement);
        var isStartVariation = getVariation(placement) === start;
        var isVertical = [
            top,
            bottom
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = detectOverflow$1(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
        if (referenceRect[len] > popperRect[len]) mainVariationSide = getOppositePlacement$1(mainVariationSide);
        var altVariationSide = getOppositePlacement$1(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
const flip$1 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        top,
        right,
        bottom,
        left
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow$1(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = detectOverflow$1(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
const hide$1 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = getBasePlacement(placement);
    var invertDistance = [
        left,
        top
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        left,
        right
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset$1(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = placements$1.reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
const offset$2 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset$1
};
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = computeOffsets({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
const popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow$1(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = getBasePlacement(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? top : left;
        var altSide = mainAxis === 'y' ? bottom : right;
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === start ? referenceRect[len] : popperRect[len];
        var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = within(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && getOffsetParent$1(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = within(tether ? min$1(min, tetherMin) : min, offset, tether ? max$1(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? top : left;
        var _altSide = mainAxis === 'x' ? bottom : right;
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            top,
            left
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
const preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}
function getNodeScroll$1(node) {
    if (node === getWindow$1(node) || !isHTMLElement$1(node)) return getWindowScroll(node);
    else return getHTMLElementScroll(node);
}
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = round$1(rect.width) / element.offsetWidth || 1;
    var scaleY = round$1(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
    var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
    var documentElement = getDocumentElement$1(offsetParent);
    var rect = getBoundingClientRect$1(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if (getNodeName$1(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        isScrollParent(documentElement)) scroll = getNodeScroll$1(offsetParent);
        if (isHTMLElement$1(offsetParent)) {
            offsets = getBoundingClientRect$1(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = getWindowScrollBarX$1(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return modifierPhases.reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}
function debounce$1(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
                    popper: listScrollParents(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: getCompositeRect(reference, getOffsetParent$1(popper), state.options.strategy === 'fixed'),
                    popper: getLayoutRect(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: debounce$1(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var defaultModifiers = [
    eventListeners,
    popperOffsets$1,
    computeStyles$1,
    applyStyles$1,
    offset$2,
    flip$1,
    preventOverflow$1,
    arrow$1,
    hide$1
];
var createPopper = /*#__PURE__*/ popperGenerator({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules
const marketDropdownCss = ":host{display:inline-block}:host ::slotted([slot='trigger']){cursor:pointer !important;}:host ::slotted([slot='popover']){z-index:99999;opacity:0;visibility:hidden;pointer-events:none}:host([aria-expanded]) ::slotted([slot='popover']){opacity:1;visibility:visible;pointer-events:auto}:host([aria-expanded]) .\uD83D\uDE43{visibility:hidden}@media (min-width: 600px){:host ::slotted(.market-popover){max-width:400px}}";
const MarketDropdown$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketDropdownOpened = (0, $696Z8.createEvent)(this, "marketDropdownOpened", 7);
        this.marketDropdownClosed = (0, $696Z8.createEvent)(this, "marketDropdownClosed", 7);
        /**
     * Popper instance
     */ this.popperInstance = null;
        this.interaction = 'click';
        this.disabled = false;
        this.expanded = false;
        this.popoverPlacement = 'bottom';
        this.popoverStrategy = 'absolute';
        this.popoverSkidding = undefined;
        this.popoverDistance = 8;
    }
    /**
   * Clicks outside of the dropdown component will close the popover. This means
   * that only one dropdown can be open on screen at a time.
   */ windowClick(e) {
        // https://lamplightdev.com/blog/2021/04/10/how-to-detect-clicks-outside-of-a-web-component
        if (this.expanded && !e.composedPath().includes(this.el)) this.closeDropdown();
    }
    /**
   * Toggles the dropdown
   */ onExpandedChange(newValue, oldValue) {
        if (newValue === oldValue) return;
        if (this.expanded) this.openDropdown();
        else this.closeDropdown();
    }
    syncDisabledState() {
        // this only covers elements slotted directly into market-dropdown, aka in the light DOM
        const slottedTriggerElements = this.el.querySelectorAll(supportedDropdownTriggers.map((elName)=>getNamespacedTagFor(elName)).join(','));
        slottedTriggerElements.forEach((element)=>{
            element.disabled = this.disabled;
        });
    }
    /**
   * Toggles the dropdown opened or closed
   */ toggleDropdown() {
        if (this.expanded) return this.closeDropdown();
        else return this.openDropdown();
    }
    /**
   * Opens the dropdown
   */ openDropdown() {
        if (this.expanded) return Promise.resolve();
        const { defaultPrevented } = this.marketDropdownOpened.emit();
        if (!defaultPrevented && !this.expanded) this.expanded = true;
        return Promise.resolve();
    }
    /**
   * Closes the dropdown
   */ closeDropdown() {
        if (!this.expanded) return Promise.resolve();
        const { defaultPrevented } = this.marketDropdownClosed.emit();
        if (!defaultPrevented && this.expanded) this.expanded = false;
        return Promise.resolve();
    }
    /**
   * Updates the popper's tooltip location
   * https://popper.js.org/docs/v2/lifecycle/#manual-update
   */ async updateDropdownPosition() {
        var _a;
        await ((_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.update());
        return Promise.resolve();
    }
    async handleInteraction(e) {
        if (this.disabled) return;
        // default behavior (interaction = 'click') is that the popover toggles
        // open/closed when any part of the element is clicked (trigger or popover)
        if (this.interaction === 'click' && e.type === 'click') this.toggleDropdown();
        // when interaction = 'hover', mousing over the trigger opens the popover
        // and mousing out of the trigger OR popover closes the popover
        if (this.interaction === 'hover' && e.type === 'mouseover') this.openDropdown();
        if (this.interaction === 'hover' && e.type === 'mouseout') this.closeDropdown();
        // when interaction = 'persistent', the popover can only be toggled
        // open/closed with clicks to the trigger element
        const trigger = this.el.querySelector('[slot="trigger"]');
        if (this.interaction === 'persistent' && e.type === 'click' && e.composedPath().includes(trigger)) this.toggleDropdown();
        // since slotted content is not visible until this.expanded is true,
        // we need to tell popper.js to more accurately calculate its position once
        // it becomes visible
        if (this.popperInstance) await this.popperInstance.update();
    }
    initializePopper() {
        if (this.popperInstance !== null) return;
        const { el, popoverPlacement: placement, popoverStrategy: strategy, popoverSkidding: skidding, popoverDistance: distance } = this;
        const trigger = el;
        const popover = el.querySelector('[slot="popover"]');
        if (popover === null) return;
        this.popperInstance = createPopper(trigger, popover, {
            placement: // https://popper.js.org/docs/v2/constructors/#options
            placement,
            strategy: strategy,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            skidding,
                            distance
                        ]
                    }
                }
            ]
        });
    }
    updatePopoverConfig() {
        const { popperInstance, popoverSkidding: skidding, popoverDistance: distance } = this;
        popperInstance.setOptions({
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            skidding,
                            distance
                        ]
                    }
                }
            ]
        });
    }
    connectedCallback() {
        // It's possible for connectedCallback to fire when the element is not connected ¯\_(ツ)_/¯
        // https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements#using_the_lifecycle_callbacks
        if (!this.el.isConnected) return;
        // If this is the initial connection, the popover slot may not exist yet. In that case we'll initialize Popper via
        // the slotchange event handler. If this is a reconnect, we need to reinitialize Popper since it will have been
        // destroyed by disconnectedCallback.
        this.initializePopper();
    }
    disconnectedCallback() {
        // It's possible for disconnectedCallback to fire when the element is still connected ¯\_(ツ)_/¯
        // https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements#using_the_lifecycle_callbacks
        if (this.el.isConnected) return;
        if (this.popperInstance) {
            // Destroying Popper on disconnect prevents memory leaks
            this.popperInstance.destroy();
            this.popperInstance = null;
        }
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-dropdown",
            "aria-expanded": this.expanded,
            onClick: (e)=>{
                this.handleInteraction(e);
            },
            onmouseover: (e)=>{
                this.handleInteraction(e);
            },
            onmouseout: (e)=>{
                this.handleInteraction(e);
            }
        }, (0, $696Z8.h)("slot", {
            name: "trigger",
            onSlotchange: ()=>this.syncDisabledState()
        }), (0, $696Z8.h)("slot", {
            name: "popover",
            onSlotchange: ()=>this.initializePopper()
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "expanded": [
                "onExpandedChange"
            ],
            "disabled": [
                "syncDisabledState"
            ],
            "popoverSkidding": [
                "updatePopoverConfig"
            ],
            "popoverDistance": [
                "updatePopoverConfig"
            ]
        };
    }
    static get style() {
        return marketDropdownCss;
    }
};
const marketEmptyStateCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:flex;flex-direction:column;gap:var(--empty-state-button-group-vertical-spacing);justify-content:center;align-items:center;width:100%;padding:var(--empty-state-vertical-padding) var(--empty-state-horizontal-padding);border-width:calc(var(--empty-state-border-width) * 1px);border-style:solid;border-color:var(--core-fill-40-color);border-radius:calc(var(--empty-state-border-radius) * 1px);background-color:var(--empty-state-background-color)}.text{display:flex;flex-direction:column;gap:var(--empty-state-paragraph-vertical-spacing);width:100%;max-width:var(--empty-state-text-maximum-width, 600px);margin:0 auto;text-align:center}.text ::slotted([slot=\"primary-text\"]),.text ::slotted([slot=\"secondary-text\"]){margin:0;font-family:inherit}.text ::slotted([slot=\"primary-text\"]){color:var(--empty-state-heading-color);font-weight:var(--empty-state-heading-text-weight);font-size:var(--empty-state-heading-text-size);line-height:var(--empty-state-heading-text-leading)}.text ::slotted([slot=\"secondary-text\"]){color:var(--empty-state-paragraph-color);font-weight:var(--empty-state-paragraph-text-weight);font-size:var(--empty-state-paragraph-text-size);line-height:var(--empty-state-paragraph-text-leading)}.actions{display:flex;flex-direction:row;gap:var(--empty-state-actions-spacing, var(--core-metrics-spacing-200));}";
const MarketEmptyState$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
     * Whether or not `.actions` will be displayed (if `actions` slot is provided)
     */ this.showActions = false;
    }
    handleSlottedContent() {
        this.showActions = Boolean(this.el.querySelector('[slot="actions"]'));
    }
    componentWillRender() {
        this.handleSlottedContent();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-empty-state"
        }, (0, $696Z8.h)("slot", null), (0, $696Z8.h)("slot", {
            name: "media"
        }), (0, $696Z8.h)("div", {
            class: "text"
        }, (0, $696Z8.h)("slot", {
            name: "primary-text"
        }), (0, $696Z8.h)("slot", {
            name: "secondary-text"
        })), this.showActions && (0, $696Z8.h)("div", {
            class: "actions"
        }, (0, $696Z8.h)("slot", {
            name: "actions"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketEmptyStateCss;
    }
};
const marketFieldCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--slot-margin-top:4px;--error-icon-height:16px;--error-icon-width:16px;--error-icon-offset:calc(calc(var(--field-error-message-text-leading) - var(--error-icon-height)) / 2);display:block;text-align:start}::slotted([slot]){margin-top:var(--slot-margin-top) !important;}::slotted([slot='error']){display:block;color:var(--field-error-message-text-color) !important;font-weight:var(--field-error-message-text-weight) !important;font-size:var(--field-error-message-text-size) !important;line-height:var(--field-error-message-text-leading) !important;letter-spacing:var(--field-error-message-text-tracking) !important}::slotted([slot='error'])::before{content:'';display:inline-block;vertical-align:calc(-1 * var(--error-icon-offset));width:var(--error-icon-width);height:var(--error-icon-height);margin-right:calc(\n        var(--field-error-message-icon-padding, 2px) +\n        var(--field-error-message-icon-margin-right, 4px)\n      );margin-left:var(--field-error-message-icon-padding, 2px);background-color:var(--field-error-message-text-color);-webkit-mask:url(\"data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M8 15.5C12.1333 15.5 15.5 12.1333 15.5 8C15.5 3.86667 12.1333 0.5 8 0.5C3.86667 0.5 0.5 3.86667 0.5 8C0.5 12.1333 3.86667 15.5 8 15.5ZM8 2.16667C11.2167 2.16667 13.8333 4.78333 13.8333 8C13.8333 11.2167 11.2167 13.8333 8 13.8333C4.78333 13.8333 2.16667 11.2167 2.16667 8C2.16667 4.78333 4.78333 2.16667 8 2.16667ZM8 12.1667C8.5753 12.1667 9.04167 11.7003 9.04167 11.125C9.04167 10.5497 8.5753 10.0833 8 10.0833C7.4247 10.0833 6.95833 10.5497 6.95833 11.125C6.95833 11.7003 7.4247 12.1667 8 12.1667ZM7.16667 3.83333H8.83333V9.25H7.16667V3.83333Z'/></svg>\");mask:url(\"data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M8 15.5C12.1333 15.5 15.5 12.1333 15.5 8C15.5 3.86667 12.1333 0.5 8 0.5C3.86667 0.5 0.5 3.86667 0.5 8C0.5 12.1333 3.86667 15.5 8 15.5ZM8 2.16667C11.2167 2.16667 13.8333 4.78333 13.8333 8C13.8333 11.2167 11.2167 13.8333 8 13.8333C4.78333 13.8333 2.16667 11.2167 2.16667 8C2.16667 4.78333 4.78333 2.16667 8 2.16667ZM8 12.1667C8.5753 12.1667 9.04167 11.7003 9.04167 11.125C9.04167 10.5497 8.5753 10.0833 8 10.0833C7.4247 10.0833 6.95833 10.5497 6.95833 11.125C6.95833 11.7003 7.4247 12.1667 8 12.1667ZM7.16667 3.83333H8.83333V9.25H7.16667V3.83333Z'/></svg>\");-webkit-mask-size:cover;mask-size:cover}::slotted([slot='bottom-accessory']){display:block;margin:var(--field-helper-text-vertical-spacing) var(--field-helper-text-horizontal-spacing);color:var(--field-helper-text-text-color);font-weight:var(--field-helper-text-weight);font-size:var(--field-helper-text-size);line-height:var(--field-helper-text-leading);letter-spacing:var(--field-helper-text-tracking)}::slotted([slot='action']){display:block;padding:var(--field-action-vertical-padding-size) 0;color:var(--field-action-text-color) !important;font-weight:var(--field-action-text-weight);font-size:var(--field-action-text-size);line-height:var(--field-action-text-leading);letter-spacing:var(--field-action-text-tracking);text-decoration:none;cursor:pointer}::slotted(button[slot='action']){padding:0;border:none;background-color:transparent;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}";
const MarketField$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.name = undefined;
        this.readonly = false;
        this.disabled = false;
        this.invalid = false;
    }
    getSlottedInputs() {
        const supportedInputTags = [
            getNamespacedTagFor('market-input-text'),
            getNamespacedTagFor('market-input-password'),
            getNamespacedTagFor('market-select'),
            getNamespacedTagFor('market-textarea'),
            getNamespacedTagFor('market-code-input')
        ];
        // create flattened array of slotted supported input elements based on tag name
        const slottedInputElements = supportedInputTags.flatMap((tag)=>{
            return [
                ...this.el.getElementsByTagName(tag)
            ];
        });
        return slottedInputElements;
    }
    handleErrorAriaRole() {
        const errorSlotEl = this.el.querySelector('[slot="error"]');
        if (errorSlotEl) errorSlotEl.setAttribute('role', 'alert');
    }
    render() {
        // check for slotted supported market inputs and pass properties down
        this.getSlottedInputs().forEach((input)=>{
            input.name = this.name;
            input.disabled = this.disabled;
            input.invalid = this.invalid;
            input.readonly = this.readonly;
        });
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-field"
        }, (0, $696Z8.h)("slot", null), this.invalid && !this.disabled && // slot relocation broke in @stencil/core@1.13.0
        // wrapping a slot in a shadowless div as a workaround
        // this should be fixed in 2.1.1
        (0, $696Z8.h)("div", null, (0, $696Z8.h)("slot", {
            name: "error",
            onSlotchange: ()=>this.handleErrorAriaRole()
        })), (0, $696Z8.h)("slot", {
            name: "bottom-accessory"
        }), (0, $696Z8.h)("slot", {
            name: "action"
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketFieldCss;
    }
};
const marketFileUploadCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}button,.market-button,::slotted(button),::slotted(.market-button),::slotted(.market-link){font-weight:var(--core-type-semibold-30-weight);font-size:var(--core-type-semibold-30-size);font-family:var(--core-type-semibold-30-font-family);line-height:var(--core-type-semibold-30-leading);letter-spacing:var(--core-type-semibold-30-tracking);text-transform:var(--core-type-semibold-30-case)}:host([invalid]) .label-container{border-color:var(--field-normal-state-invalid-validity-border-color)}:host([disabled]) .label-container{border-color:var(--field-disabled-state-border-color);background-color:var(--field-disabled-state-background-color);color:var(--field-disabled-state-empty-phase-label-color)}:host([disabled]) button,:host([disabled]) .market-accessory,:host([disabled]) ::slotted(button),:host([disabled]) ::slotted(.market-button),:host([disabled]) ::slotted(.market-link),:host([disabled]) svg{opacity:0.3}.label-container{border:var(--file-upload-border-width, 1px)\n    dashed\n    var(--file-upload-normal-state-border-color, var(--core-fill-30-color));border-style:dashed;border-radius:var(--file-upload-border-radius, 6px)}.label-container>label,.label-container>market-row{padding:var(--file-upload-vertical-padding, 28px)\n      var(--file-upload-button-horizontal-padding, var(--core-metrics-spacing-200))}.label-container>label{display:flex;justify-content:center;align-items:center;cursor:pointer}.label-container>label svg{margin-right:20px;fill:var(--file-upload-label-fill-color, var(--core-fill-10-color))}.label-container>market-row{margin:0}.is-dragging-over{border:var(--file-upload-border-width, 1px)\n    solid\n    var(--file-upload-dragging-state-border-color, var(--core-blue-fill-color));background-color:var(--file-upload-dragging-state-background-color, var(--core-emphasis-40-color))}.has-file-selected{border:var(--file-upload-border-width, 1px)\n    solid\n    var(--file-upload-file-selected-state-border-color, var(--core-fill-30-color))}button,.market-button,::slotted(button),::slotted(.market-button),::slotted(.market-link){padding:var(--file-upload-button-padding, 0);border:none;background-color:inherit;color:var(--file-upload-button-label-color, var(--button-normal-variant-tertiary-rank-normal-state-label-color));font-family:inherit;text-align:right;cursor:pointer}::slotted([slot='bottom-accessory']){color:var(--file-upload-helper-text-color, var(--core-text-20-color))}.market-accessory{cursor:pointer}.market-accessory svg{fill:var(--file-upload-delete-fill-color, var(--core-fill-20-color))}";
const MarketFileUpload$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketFileUploadValueChange = (0, $696Z8.createEvent)(this, "marketFileUploadValueChange", 7);
        this.accept = '';
        this.value = [];
        this.disabled = false;
        this.invalid = false;
        this.multiple = false;
        this.deleteButtonAriaLabel = 'Delete';
        this.isDraggingOver = false;
        this.files = undefined;
    }
    watchValueHandler(newValue) {
        this.files = [
            ...newValue
        ];
    }
    /**
   * We want to disable certain functions if multiple is false and a file has been selected
   */ get hasSingleFileSelected() {
        return !this.multiple && this.files.length === 1;
    }
    draggingOver(e) {
        if (this.disabled || this.hasSingleFileSelected) return;
        this.isDraggingOver = true;
        e.preventDefault();
    }
    endDrag(e) {
        e.preventDefault();
        if (this.disabled || this.hasSingleFileSelected) return;
        this.isDraggingOver = false;
        if (e.type === 'drop' && e.dataTransfer) this.addFiles(e.dataTransfer.files);
    }
    handleButtonClick() {
        this.fileInputElement.click();
    }
    handleDeleteKeydown(e, index) {
        if (e.key === 'Enter' && !this.disabled) this.removeFile(index);
    }
    removeFile(index) {
        this.files.splice(index, 1);
        this.files = [
            ...this.files
        ];
        this.emitFileChange();
    }
    labelContainerClassNames() {
        const classNames = [];
        if (this.isDraggingOver) classNames.push('is-dragging-over');
        if (this.hasSingleFileSelected) classNames.push('has-file-selected');
        return classNames;
    }
    onInputChange(e) {
        this.addFiles(e.target.files);
        // unset the file input value so that we can re-add files
        // if they are removed by the user
        this.fileInputElement.value = '';
    }
    addFiles(files) {
        if (files) {
            if (!this.multiple) this.files = [
                files[0]
            ];
            else this.files = [
                ...files,
                ...this.files
            ];
        }
        this.emitFileChange();
    }
    emitFileChange() {
        this.marketFileUploadValueChange.emit({
            value: this.files
        });
    }
    componentWillLoad() {
        this.files = [];
    }
    render() {
        const MarketRowTagName = getNamespacedTagFor('market-row');
        const MarketListTagName = getNamespacedTagFor('market-list');
        const MarketAccessoryTagName = getNamespacedTagFor('market-accessory');
        const MarketFieldTagName = getNamespacedTagFor('market-field');
        const fileMarketRows = this.files.map((file, index)=>{
            return (0, $696Z8.h)(MarketRowTagName, {
                disabled: this.disabled,
                interactive: true,
                transient: true,
                "data-index": index
            }, (0, $696Z8.h)("label", {
                slot: "label"
            }, file.name), (0, $696Z8.h)(MarketAccessoryTagName, {
                slot: "trailing-accessory",
                size: "icon",
                tabindex: this.disabled ? -1 : 0,
                role: "button",
                "aria-label": this.deleteButtonAriaLabel,
                onKeyDown: (e)=>this.handleDeleteKeydown(e, index),
                onClick: ()=>this.removeFile(index)
            }, (0, $696Z8.h)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, (0, $696Z8.h)("path", {
                d: "M21 5H19H17H15C15 3.35 13.65 2 12 2C10.35 2 9 3.35 9 5H7H5H3V7H5V18.75C5 20.54 6.66 22 8.7 22H15.3C17.34 22 19 20.54 19 18.75V7H21V5ZM12 4C12.55 4 13 4.45 13 5H11C11 4.45 11.45 4 12 4ZM17 18.75C17 19.43 16.22 20 15.3 20H8.7C7.78 20 7 19.43 7 18.75V7H17V18.75ZM15 9H13V18H15V9ZM9 9H11V18H9V9Z"
            }))));
        });
        const showUploadLabel = this.multiple || fileMarketRows.length === 0;
        const showList = this.multiple && fileMarketRows.length > 0;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-file-upload",
            ondragenter: (e)=>this.draggingOver(e),
            ondragover: (e)=>this.draggingOver(e),
            ondragleave: (e)=>this.endDrag(e),
            ondrop: (e)=>this.endDrag(e)
        }, (0, $696Z8.h)(MarketFieldTagName, {
            disabled: this.disabled,
            invalid: this.invalid
        }, (0, $696Z8.h)("div", {
            class: `label-container ${this.labelContainerClassNames()}`
        }, !showUploadLabel && fileMarketRows[0], showUploadLabel && (0, $696Z8.h)("label", null, (0, $696Z8.h)("svg", {
            width: "14",
            height: "20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M8 0H3C1.34 0 0 1.34 0 3v14c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V6L8 0Zm3.17 6H8V2.83L11.17 6ZM12 17c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h3v6h6v9Z"
        })), (0, $696Z8.h)("span", null, (0, $696Z8.h)("slot", null, "Drag and drop here or ", (0, $696Z8.h)("button", {
            onClick: ()=>this.handleButtonClick()
        }, "browse file"))), (0, $696Z8.h)("input", {
            ref: (el)=>this.fileInputElement = el,
            onChange: (e)=>this.onInputChange(e),
            type: "file",
            name: "files[]",
            multiple: this.multiple,
            accept: this.accept,
            hidden: true
        }))), (0, $696Z8.h)("slot", {
            name: "bottom-accessory"
        }, (0, $696Z8.h)("small", {
            slot: "bottom-accessory"
        })), (0, $696Z8.h)("slot", {
            name: "error"
        }, (0, $696Z8.h)("small", {
            slot: "error"
        }))), showList && (0, $696Z8.h)(MarketListTagName, {
            interactive: true,
            transient: true
        }, fileMarketRows));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "value": [
                "watchValueHandler"
            ]
        };
    }
    static get style() {
        return marketFileUploadCss;
    }
};
const marketFilterCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:inline-block}.dropdown,.dropdown>.filter-button{width:100%}.date-popover{max-width:unset;max-height:unset}";
const MarketFilter$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketFilterClosed = (0, $696Z8.createEvent)(this, "marketFilterClosed", 7);
        this.marketFilterOpened = (0, $696Z8.createEvent)(this, "marketFilterOpened", 7);
        this.marketFilterExpandedChanged = (0, $696Z8.createEvent)(this, "marketFilterExpandedChanged", 7);
        this.marketFilterValueDidChange = (0, $696Z8.createEvent)(this, "marketFilterValueDidChange", 7);
        this.name = undefined;
        this.disabled = undefined;
        this.focused = false;
        this.size = 'medium';
        this.expanded = false;
        this.dropdownInteraction = undefined;
        this.popoverPlacement = 'bottom-start';
        this.selectedDisplayValue = undefined;
    }
    /**
   * **INTERNAL [do not use directly]**
   *
   * Get the filter type
   */ async getFilterType() {
        return Promise.resolve(this.filterType);
    }
    /**
   * Toggle focus on the filter button
   * @param {boolean} [value=true] whether or not focus will be applied or removed
   * @returns {Promise<boolean>} whether or not the filter was focused or blurred
   */ async setFocus(value = true) {
        this.focused = await this.filterButtonEl.setFocus(value);
        return Promise.resolve(this.focused);
    }
    /**
   * Handle `marketListSelectionsDidChange` emitted by `<market-list>`
   */ handleListSelectionChange({ detail }) {
        var _a;
        this.setDisplayValueFromListEvent(detail);
        const prevValue = detail.prevSelectionValues.length > 1 ? detail.prevSelectionValues : detail.prevSelectionValues[0];
        const value = (()=>{
            if (detail.currentSelectionValues.length === 0) return null;
            else if (detail.currentSelectionValues.length === 1) return detail.currentSelectionValues[0];
            return detail.currentSelectionValues;
        })();
        this.rawValue = value;
        this.marketFilterValueDidChange.emit({
            name: this.name,
            prevValue: prevValue || null,
            value: value
        });
        /**
     * If the `<market-list>` is mutliselect, prevent the dropdown from collapsing after a selection.
     * Also prevent from closing when `dropdownInteraction` is provided.
     */ if (!((_a = this.listEl) === null || _a === void 0 ? void 0 : _a.multiselect) && !this.dropdownInteraction) this.expanded = false;
    }
    /**
   * Handle `marketDateRangeChanged` emitted by `<market-date-picker>`
   */ handleDateRangeChange(e) {
        const { startDate, endDate, prevStartDate, prevEndDate } = e.detail;
        this.setDisplayValueFromDateEvent(e);
        this.marketFilterValueDidChange.emit({
            name: this.name,
            prevValue: {
                startDate: prevStartDate,
                endDate: prevEndDate
            },
            value: {
                startDate: startDate,
                endDate: endDate
            }
        });
    }
    /**
   * Handle `marketDropdownOpened` emitted by `<market-dropdown>`
   */ handleDropdownOpened(e) {
        const { defaultPrevented } = this.marketFilterExpandedChanged.emit(true);
        if (defaultPrevented) {
            e.preventDefault();
            return;
        }
        // temporary handler for deprecated event
        if (this.marketFilterOpened.emit().defaultPrevented) {
            e.preventDefault();
            return;
        }
        if (!this.dropdownInteraction) this.expanded = true;
    }
    /**
   * Handle `marketDropdownClosed` emitted by `<market-dropdown>`
   */ handleDropdownClosed(e) {
        const { defaultPrevented } = this.marketFilterExpandedChanged.emit(false);
        if (defaultPrevented) {
            e.preventDefault();
            return;
        }
        // temporary handler for deprecated event
        if (this.marketFilterClosed.emit().defaultPrevented) {
            e.preventDefault();
            return;
        }
        if (!this.dropdownInteraction) this.expanded = false;
    }
    /**
   * Handle change events on the `display-value` slot
   */ handleDisplayValueSlotChange() {
        this.hasDisplayValue = Boolean(this.el.querySelector('[slot="display-value"]'));
    }
    /**
   * Handle default slot changes
   */ handleDefaultSlotChange() {
        this.datePickerEl = this.el.querySelector(getNamespacedTagFor('market-date-picker'));
        this.listEl = this.el.querySelector(getNamespacedTagFor('market-list'));
        if (this.datePickerEl) {
            this.filterType = 'date';
            this.setDisplayValueFromSlottedElement();
        } else if (this.listEl) {
            // make sure that the list is interactive
            if (!this.listEl.interactive) this.listEl.interactive = true;
            this.filterType = 'list';
            this.setDisplayValueFromSlottedElement();
        }
    }
    /**
   * Listens to changes in row content to ensure that if the selected row's content
   * is dynamically updated, those changes will be reflected to `selectedDisplayValue`.
   */ initRowObservers() {
        /**
     * Since onSlotchange only fires on changes to the slotted node itself,
     * we need to use mutation observers to listen to changes to market-list's
     * slotted market-rows: https://github.com/ionic-team/stencil/issues/232#issuecomment-397871813
     */ const syncRowContent = (row)=>{
            if (typeof this.rawValue === 'string' && row.value === this.rawValue) this.selectedDisplayValue = this.getTextContentOfRowWithValue(row.value);
        };
        const rows = this.el.querySelectorAll(`${getNamespacedTagFor('market-list')} ${getNamespacedTagFor('market-row')}`);
        rows.forEach((row)=>{
            const observer = new MutationObserver(()=>syncRowContent(row));
            observer.observe(row, {
                characterData: true,
                subtree: true
            });
        });
    }
    /**
   * Gets the `.textContent` of the `<market-row>` with the provided `value`.
   * This is only used for list types.
   */ getTextContentOfRowWithValue(value) {
        const marketRowTag = getNamespacedTagFor('market-row');
        const labelEl = this.listEl.querySelector(`${marketRowTag}[value="${value}"] [slot="label"]`);
        return labelEl === null || labelEl === void 0 ? void 0 : labelEl.textContent;
    }
    /**
   * Infers the value from the <market-list> or <market-date-picker>
   */ setDisplayValueFromSlottedElement() {
        if (this.hasDisplayValue) {
            this.selectedDisplayValue = undefined;
            return;
        }
        if (this.listEl) {
            if (!this.listEl.value) {
                this.selectedDisplayValue = undefined;
                return;
            }
            this.rawValue = this.listEl.value;
            if (this.listEl.multiselect) {
                // if there's more than 1 value selected, get the count of selected values
                const valueCount = (()=>{
                    if (typeof this.listEl.value === 'string') return this.listEl.value.split(',').length;
                    else if (Array.isArray(this.listEl.value)) return this.listEl.value.length;
                    return undefined; // this will skip the check below and print the raw `value` instead
                })();
                if (valueCount > 1) {
                    this.selectedDisplayValue = `${valueCount}`;
                    return;
                }
            }
            // get the selected row's label textContent and set that as the display value
            this.selectedDisplayValue = this.getTextContentOfRowWithValue(this.listEl.value);
        } else if (this.datePickerEl) this.selectedDisplayValue = this.formatDate({
            startDate: this.datePickerEl.selectedStartDate,
            endDate: this.datePickerEl.selectedEndDate
        });
    }
    formatDate({ startDate, endDate }) {
        var _a, _b;
        const start = startDate ? new Date(startDate) : undefined;
        const end = endDate ? new Date(endDate) : undefined;
        if (!start && !end) return '';
        const locale = this.datePickerEl.locale;
        // If both dates exists and have the same year, show the year only on the end of the range.
        const startAndEndInTheSameYear = Boolean(start && end && start.getFullYear() === end.getFullYear());
        const startDateString = (_a = start === null || start === void 0 ? void 0 : start.toLocaleDateString(locale, startAndEndInTheSameYear && end ? {
            day: 'numeric',
            month: 'numeric'
        } : {
            dateStyle: 'short'
        })) !== null && _a !== void 0 ? _a : '';
        const endDateString = (_b = end === null || end === void 0 ? void 0 : end.toLocaleDateString(locale, {
            dateStyle: 'short'
        })) !== null && _b !== void 0 ? _b : '';
        return `${startDateString}${endDateString ? `\u{2013}${endDateString}` : ''}`;
    }
    /**
   * Calculate the display value from the `marketDateRangeChanged` event of `<market-list>`
   * Formatting is based on design guidelines:
   * https://www.notion.so/marketdesignsystem/Filters-78885543b16446f49d5cfa98c6a56648#bb6aac7e29e04f98890ba32042ddae05
   */ setDisplayValueFromDateEvent(e) {
        var _a, _b, _c, _d;
        const { menuSelection } = e.detail;
        if (menuSelection === MENU_SLOT_NAMES.CUSTOM) this.selectedDisplayValue = this.formatDate(e.detail);
        else if (menuSelection) {
            // get the textContent of the menu item
            const presetMenuTextContent = (_d = (_c = (_b = (_a = this.datePickerEl) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(`${getNamespacedTagFor('market-date-picker-menu')} slot[name="${menuSelection}"]`)) === null || _c === void 0 ? void 0 : _c.textContent) === null || _d === void 0 ? void 0 : _d.trim();
            this.selectedDisplayValue = presetMenuTextContent;
        }
    }
    /**
   * Calculate the display value from the `marketListSelectionsDidChange` event of `<market-list>`
   */ setDisplayValueFromListEvent({ currentSelectionValues, currentSelections }) {
        if (this.hasDisplayValue) {
            // display-value slot is provided; no need to calculate for this
            this.selectedDisplayValue = undefined;
            return;
        }
        if (!(currentSelectionValues === null || currentSelectionValues === void 0 ? void 0 : currentSelectionValues.length)) // no selection
        this.selectedDisplayValue = undefined;
        else if (currentSelectionValues.length > 1) // multiple selections: display the count
        this.selectedDisplayValue = `${currentSelectionValues.length}`;
        else {
            // single selection: display the selected row's label contents
            const labelEl = currentSelections[0].querySelector('[slot="label"]');
            this.selectedDisplayValue = labelEl.textContent;
        }
    }
    connectedCallback() {
        this.initRowObservers();
        this.handleDisplayValueSlotChange();
        this.handleDefaultSlotChange();
    }
    render() {
        var _a;
        const { datePickerEl, disabled, dropdownInteraction, expanded, handleDefaultSlotChange, handleDisplayValueSlotChange, hasDisplayValue, listEl, popoverPlacement, selectedDisplayValue, size } = this;
        const hasFeedback = hasDisplayValue || Boolean(selectedDisplayValue);
        /**
     * Dropdown interaction will be set as 'persistent' by default if:
     * - `dropdownInteraction` is not defined; or
     * - `<market-list>` is provided and is `multiselect`; or
     * - `<market-date-picker>` is provided
     */ const isMultiselectList = (_a = listEl === null || listEl === void 0 ? void 0 : listEl.multiselect) !== null && _a !== void 0 ? _a : false;
        const hasDatePicker = Boolean(datePickerEl);
        const interaction = dropdownInteraction !== null && dropdownInteraction !== void 0 ? dropdownInteraction : hasDatePicker || isMultiselectList ? 'persistent' : undefined;
        const MarketDropdownTagName = getNamespacedTagFor('market-dropdown');
        const MarketPopoverTagName = getNamespacedTagFor('market-popover');
        const MarketFilterButtonTagName = getNamespacedTagFor('market-filter-button');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-filter"
        }, (0, $696Z8.h)(MarketDropdownTagName, {
            class: "dropdown",
            disabled: disabled,
            expanded: expanded,
            interaction: interaction,
            popoverPlacement: popoverPlacement
        }, (0, $696Z8.h)(MarketFilterButtonTagName, {
            active: expanded,
            class: "filter-button",
            disabled: disabled,
            ref: (el)=>this.filterButtonEl = el,
            slot: "trigger",
            size: size
        }, (0, $696Z8.h)("slot", {
            name: "label"
        }), hasFeedback && (0, $696Z8.h)("span", {
            slot: "feedback",
            "data-test-id": "filter-feedback"
        }, (0, $696Z8.h)("slot", {
            name: "display-value",
            onSlotchange: handleDisplayValueSlotChange.bind(this)
        }, selectedDisplayValue))), (0, $696Z8.h)(MarketPopoverTagName, {
            class: classNames({
                'date-popover': hasDatePicker
            }),
            slot: "popover"
        }, (0, $696Z8.h)("slot", {
            onSlotchange: handleDefaultSlotChange.bind(this)
        }), (0, $696Z8.h)("slot", {
            name: "list",
            onSlotchange: handleDefaultSlotChange.bind(this)
        }))));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketFilterCss;
    }
};
const marketFilterButtonCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--filter-button-normal-state-icon-color:var(--filter-button-normal-state-label-color);--filter-button-hover-state-icon-color:var(--filter-button-hover-state-label-color);--filter-button-pressed-state-icon-color:var(--filter-button-pressed-state-label-color);--filter-button-disabled-state-icon-color:var(--filter-button-disabled-state-label-color);display:inline-block;white-space:nowrap}button{display:inline-flex;gap:var(--filter-button-label-content-spacing);justify-content:center;align-items:center;width:100%;border:none;border-radius:var(--filter-button-border-radius);background-color:var(--filter-button-normal-state-background-color);color:var(--filter-button-normal-state-label-color);box-shadow:var(--filter-button-normal-state-border-color) 0 0 0 var(--filter-button-border-size) inset;font-family:inherit;white-space:nowrap;cursor:pointer}button:focus{outline:none}button ::slotted([slot]){cursor:inherit}button ::slotted([slot='feedback']){color:var(--filter-button-normal-state-feedback-color, var(--core-text-10-color));white-space:nowrap}button svg{display:none;fill:var(--filter-button-normal-state-icon-color)}:host([icon-only]) .label{display:none}:host([icon-only]) svg{display:block}:host([size='medium']) button{min-height:var(--filter-button-medium-size-minimum-height);padding:var(--filter-button-medium-size-label-vertical-padding)\n      var(--filter-button-medium-size-label-horizontal-padding);font-weight:var(--filter-button-medium-size-label-text-weight);font-size:var(--filter-button-medium-size-label-text-size);line-height:var(--filter-button-medium-size-label-text-leading);letter-spacing:var(--filter-button-medium-size-label-text-tracking);text-transform:var(--filter-button-medium-size-label-text-case)}:host([size='medium']) ::slotted([slot='feedback']){font-weight:var(--filter-button-medium-size-feedback-text-weight);font-size:var(--filter-button-medium-size-feedback-text-size);line-height:var(--filter-button-medium-size-feedback-text-leading);letter-spacing:var(--filter-button-medium-size-feedback-text-tracking);text-transform:var(--filter-button-medium-size-feedback-text-case)}:host([size='small']) button{min-height:var(--filter-button-small-size-minimum-height);padding:var(--filter-button-small-size-label-vertical-padding)\n      var(--filter-button-small-size-label-horizontal-padding);font-weight:var(--filter-button-small-size-label-text-weight);font-size:var(--filter-button-small-size-label-text-size);line-height:var(--filter-button-small-size-label-text-leading);letter-spacing:var(--filter-button-small-size-label-text-tracking);text-transform:var(--filter-button-small-size-label-text-case)}:host([size='small']) ::slotted([slot='feedback']){font-weight:var(--filter-button-small-size-feedback-text-weight);font-size:var(--filter-button-small-size-feedback-text-size);line-height:var(--filter-button-small-size-feedback-text-leading);letter-spacing:var(--filter-button-small-size-feedback-text-tracking);text-transform:var(--filter-button-small-size-feedback-text-case)}:host(:hover) button,:host(:focus) button{background-color:var(--filter-button-hover-state-background-color);color:var(--filter-button-hover-state-label-color);box-shadow:var(--filter-button-hover-state-border-color) 0 0 0 var(--filter-button-border-size) inset}:host(:hover) ::slotted([slot='feedback']),:host(:focus) ::slotted([slot='feedback']){color:var(--filter-button-hover-state-feedback-color)}:host(:hover) svg,:host(:focus) svg{fill:var(--filter-button-hover-state-icon-color)}:host([active]) button,:host(:active) button{background-color:var(--filter-button-pressed-state-background-color);color:var(--filter-button-pressed-state-label-color);box-shadow:var(--filter-button-pressed-state-border-color) 0 0 0 var(--filter-button-border-size) inset}:host([active]) ::slotted([slot='feedback']),:host(:active) ::slotted([slot='feedback']){color:var(--filter-button-pressed-state-feedback-color)}:host([active]) svg,:host(:active) svg{fill:var(--filter-button-pressed-state-icon-color)}:host([disabled]) button{background-color:var(--filter-button-disabled-state-background-color);color:var(--filter-button-disabled-state-label-color);box-shadow:var(--filter-button-disabled-state-border-color) 0 0 0 var(--filter-button-border-size) inset}:host([disabled]) ::slotted([slot='feedback']){color:var(--filter-button-disabled-state-feedback-color)}:host([disabled]) svg{fill:var(--filter-button-disabled-state-icon-color)}";
const MarketFilterButton$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.size = 'medium';
        this.disabled = false;
        this.focused = false;
        this.iconOnly = false;
        this.active = false;
    }
    handleClick(event) {
        if (this.disabled) event.stopImmediatePropagation();
    }
    handleDisabledChange(newValue) {
        if (newValue && this.focused) this.focused = false;
    }
    /**
   * Toggle focus on the filter button
   * @param {boolean} [value=true] whether or not focus will be applied or removed
   * @returns {Promise<boolean>} whether or not the button was focused or blurred
   */ async setFocus(value = true) {
        if (this.disabled) return Promise.resolve(false);
        this.focused = value;
        if (this.focused) this.buttonEl.focus();
        else this.buttonEl.blur();
        return Promise.resolve(this.focused);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-filter-button"
        }, (0, $696Z8.h)("button", {
            "aria-disabled": this.disabled,
            disabled: this.disabled,
            ref: (el)=>this.buttonEl = el,
            type: "button"
        }, (0, $696Z8.h)("svg", {
            width: "18",
            height: "12",
            viewBox: "0 0 18 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M0 0H18V2H0V0ZM15 5H3V7H15V5ZM12 10H6V12H12V10Z"
        })), (0, $696Z8.h)("span", {
            class: "label"
        }, (0, $696Z8.h)("slot", null)), (0, $696Z8.h)("slot", {
            name: "feedback"
        })));
    }
    static get watchers() {
        return {
            "disabled": [
                "handleDisabledChange"
            ]
        };
    }
    static get style() {
        return marketFilterButtonCss;
    }
};
const marketFilterDropdownMenuCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}::slotted([slot='filter-title']){font-weight:var(--core-type-heading-20-weight);font-size:var(--core-type-heading-20-size);font-family:var(--core-type-heading-20-font-family);line-height:var(--core-type-heading-20-leading);letter-spacing:var(--core-type-heading-20-tracking);text-transform:var(--core-type-heading-20-case)}.overflow-filters{overflow:hidden;height:0}.popover{display:flex;flex-direction:column}.selection-header::part(heading){--filter-overflow-heading-margin-top-size:var(--core-metrics-spacing-200);margin-top:var(--filter-overflow-heading-margin-top-size)}.filter-options-container{--filter-overflow-filter-options-container-margin-top-size:var(--core-metrics-spacing-100);display:flex;flex:1;overflow-y:auto;width:calc(\n      100% +\n      var(--modal-popover-wide-viewport-padding-left-size) +\n      var(--modal-popover-wide-viewport-padding-right-size)\n    );margin:var(--filter-overflow-filter-options-container-margin-top-size)\n    calc(var(--modal-popover-wide-viewport-padding-right-size) * -1)\n    calc(var(--modal-popover-wide-viewport-padding-bottom-size) * -1)\n    calc(var(--modal-popover-wide-viewport-padding-left-size) * -1);padding-left:var(--modal-popover-wide-viewport-padding-left-size)}.filter-options-container ::slotted(.market-list[slot='filter-options']){width:calc(100% - var(--modal-popover-wide-viewport-padding-right-size))}.filter-options-container ::slotted(.market-list[slot='filter-options'])::after{content:'';display:block;width:100%;height:var(--core-metrics-spacing-100)}.filter-options-container ::slotted(.market-date-picker[slot='filter-options']){width:auto;min-width:var(--date-picker-minimum-width);padding-right:var(--modal-popover-wide-viewport-padding-right-size)}.filter-options-container ::slotted(.market-date-picker[slot='filter-options'])::after{content:'';display:block;width:100%;height:var(--core-metrics-spacing-300)}.filter-options-container ::slotted(.market-date-picker[slot='filter-options'][display-menu]){height:calc(100%)}";
const MarketFilterDropdownMenu$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.size = 'medium';
        this.filtersWithSelectedValue = undefined;
        this.hasSelectedFilter = undefined;
        this.isDropdownActive = undefined;
    }
    /**
   * Handle `marketDropdownOpened` emitted by `<market-dropdown>`
   */ handleDropdownOpened() {
        this.deselectFilter();
        this.isDropdownActive = true;
    }
    /**
   * Handle `marketDropdownClosed` emitted by `<market-dropdown>`
   */ handleDropdownClosed() {
        this.isDropdownActive = false;
    }
    /**
   * Handle `marketHeaderNavigate` emitted by `<market-button>` when clicking the back button
   */ handleHeaderNavigate() {
        this.deselectFilter();
    }
    /**
   * Deselect filter
   */ deselectFilter() {
        this.hasSelectedFilter = false;
    }
    /**
   * Handle overflow-filters slot change
   */ handleOverflowFiltersSlotChange() {
        this.filterEls = this.el.querySelector('[slot="overflow-filters"]').assignedNodes();
        // create <market-row>s; and calculate how many filters have set `values`
        this.createRowsFromFilters();
        this.calculateFiltersWithSelectedValue();
    }
    /**
   * Create rows from filter slots
   */ createRowsFromFilters() {
        var _a, _b, _c, _d;
        // no more filters, remove rows if they exist
        if (!((_a = this.filterEls) === null || _a === void 0 ? void 0 : _a.length)) {
            (_b = this.filterRowEls) === null || _b === void 0 || _b.forEach((filterRowEl)=>{
                filterRowEl.remove();
            });
            return;
        }
        const filterRowElsByValue = ((_c = this.filterRowEls) !== null && _c !== void 0 ? _c : []).reduce((result, rowEl)=>{
            result[rowEl.value] = rowEl;
            return result;
        }, {});
        const filterNames = new Set();
        const rowsByName = {};
        this.filterEls.forEach((filterEl)=>{
            var _a;
            const name = filterEl.name;
            filterNames.add(name);
            const currentRowEl = filterRowElsByValue[name];
            if (currentRowEl) // recycle filter row with the same name if it exists
            rowsByName[name] = currentRowEl;
            else {
                // create new row element
                const newRowEl = document.createElement(getNamespacedTagFor('market-row'));
                newRowEl.variant = 'drill';
                newRowEl.interactive = true;
                newRowEl.transient = true;
                newRowEl.value = name;
                newRowEl.size = this.size;
                newRowEl.addEventListener('click', async ()=>{
                    await this.handleFilterSelection(newRowEl);
                });
                rowsByName[name] = newRowEl;
            }
            // create the row label
            const label = (_a = rowsByName[name]) === null || _a === void 0 ? void 0 : _a.querySelector('label');
            label === null || label === void 0 || label.remove();
            const filterLabelEl = filterEl.querySelector('label');
            if (filterLabelEl) rowsByName[name].appendChild(filterLabelEl.cloneNode(true));
            // disable the row if the filter is disabled
            if (filterEl.disabled) rowsByName[name].disabled = true;
            // assign the slot
            rowsByName[name].setAttribute('slot', 'filter-row');
        });
        // remove rows that should not exist anymore
        (_d = this.filterRowEls) === null || _d === void 0 || _d.forEach((filterRowEl)=>{
            if (!filterNames.has(filterRowEl.value)) filterRowEl.remove();
        });
        // add the new rows to the DOM
        this.filterRowEls = [
            ...this.filterEls
        ].map(({ name })=>rowsByName[name]);
        this.filterRowEls.forEach((filterRowEl)=>{
            filterRowEl.setAttribute('slot', 'filter-rows');
            this.el.appendChild(filterRowEl);
        });
    }
    /**
   * When a filter is selected, the popover content will show
   * the selected filter's title and list selection
   */ async handleFilterSelection(rowEl) {
        var _a, _b, _c;
        const value = rowEl.value;
        this.hasSelectedFilter = true;
        const filterEl = this.filterEls.find((filterEl)=>filterEl.name === value);
        // clone the label
        const labelEl = filterEl.querySelector('label');
        const clonedLabelEl = labelEl.cloneNode(true);
        clonedLabelEl.setAttribute('slot', 'filter-title');
        (_a = this.el.querySelector('[slot="filter-title"]')) === null || _a === void 0 || _a.remove();
        this.el.appendChild(clonedLabelEl);
        switch(await filterEl.getFilterType()){
            case 'date':
                {
                    // clone the date picker
                    const datePickerEl = filterEl.querySelector(getNamespacedTagFor('market-date-picker'));
                    const clonedDatePickerEl = datePickerEl.cloneNode(true);
                    clonedDatePickerEl.setAttribute('slot', 'filter-options');
                    clonedDatePickerEl.addEventListener('marketDateRangeChanged', (e)=>{
                        this.handleDatePickerFilterSelection(e, filterEl);
                    });
                    (_b = this.el.querySelector('[slot="filter-options"]')) === null || _b === void 0 || _b.remove();
                    this.el.appendChild(clonedDatePickerEl);
                    break;
                }
            case 'list':
                {
                    // clone the list
                    const listEl = filterEl.querySelector(getNamespacedTagFor('market-list'));
                    const isMultiselect = listEl.multiselect;
                    const clonedListEl = listEl.cloneNode(true);
                    clonedListEl.setAttribute('slot', 'filter-options');
                    clonedListEl.addEventListener('marketListSelectionsDidChange', (e)=>{
                        this.handleListFilterSelection(e, filterEl, isMultiselect);
                    });
                    clonedListEl.setAttribute('interactive', '');
                    listEl.multiselect && clonedLabelEl.setAttribute('multiselect', '');
                    (_c = this.el.querySelector('[slot="filter-options"]')) === null || _c === void 0 || _c.remove();
                    this.el.appendChild(clonedListEl);
                    break;
                }
        }
    }
    handleDatePickerFilterSelection(e, filterEl) {
        const { startDate, endDate } = e.detail;
        const datePickerEl = filterEl.querySelector(getNamespacedTagFor('market-date-picker'));
        datePickerEl.selectedStartDate = startDate;
        datePickerEl.selectedEndDate = endDate;
        // after selecting, recalculate what we display as feedback
        this.calculateFiltersWithSelectedValue();
    }
    handleListFilterSelection(e, filterEl, isMultiselect) {
        // set the filter value, then automatically deselect if the list is not multiselect
        const { currentSelectionValues } = e.detail;
        const listEl = filterEl.querySelector(getNamespacedTagFor('market-list'));
        listEl.value = currentSelectionValues.join(',');
        if (!isMultiselect) this.deselectFilter();
        // after selecting, recalculate what we display as feedback
        this.calculateFiltersWithSelectedValue();
    }
    /**
   * Count how many filters with selected value
   * and that count is displayed as feedback.
   */ calculateFiltersWithSelectedValue() {
        this.filtersWithSelectedValue = [
            ...this.filterEls || []
        ].reduce((count, filterEl)=>{
            const list = filterEl.querySelector(getNamespacedTagFor('market-list'));
            if (list === null || list === void 0 ? void 0 : list.value) return count + 1;
            const datePicker = filterEl.querySelector(getNamespacedTagFor('market-date-picker'));
            if (datePicker === null || datePicker === void 0 ? void 0 : datePicker.selectedStartDate) return count + 1;
            return count;
        }, 0);
    }
    componentDidLoad() {
        this.handleOverflowFiltersSlotChange();
    }
    render() {
        const { filtersWithSelectedValue, handleOverflowFiltersSlotChange, hasSelectedFilter, isDropdownActive, size } = this;
        const MarketButtonTagName = getNamespacedTagFor('market-button');
        const MarketDropdownTagName = getNamespacedTagFor('market-dropdown');
        const MarketFilterButtonTagName = getNamespacedTagFor('market-filter-button');
        const MarketHeaderTagName = getNamespacedTagFor('market-header');
        const MarketListTagName = getNamespacedTagFor('market-list');
        const MarketPopoverTagName = getNamespacedTagFor('market-popover');
        const MarketAccessoryTagName = getNamespacedTagFor('market-accessory');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: classNames('market-filter-dropdown-menu', {
                'show-options': hasSelectedFilter
            })
        }, (0, $696Z8.h)(MarketDropdownTagName, {
            interaction: "persistent",
            popoverPlacement: "bottom-end"
        }, (0, $696Z8.h)(MarketFilterButtonTagName, {
            active: isDropdownActive,
            iconOnly: true,
            size: size,
            slot: "trigger"
        }, filtersWithSelectedValue && (0, $696Z8.h)("span", {
            slot: "feedback"
        }, filtersWithSelectedValue)), (0, $696Z8.h)(MarketPopoverTagName, {
            class: "popover",
            slot: "popover"
        }, !hasSelectedFilter ? (0, $696Z8.h)(MarketListTagName, {
            class: "filter-list",
            interactive: true
        }, (0, $696Z8.h)("slot", {
            name: "filter-rows"
        })) : (0, $696Z8.h)((0, $696Z8.Fragment), null, (0, $696Z8.h)(MarketHeaderTagName, {
            class: "selection-header"
        }, (0, $696Z8.h)(MarketButtonTagName, {
            rank: "secondary",
            size: "small",
            slot: "navigation"
        }, (0, $696Z8.h)(MarketAccessoryTagName, {
            slot: "icon"
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M4.29289 11.293C3.90237 11.6835 3.90237 12.3167 4.29289 12.7072L11.2929 19.7072L12.7071 18.293L7.41421 13.0001L19 13.0001V11.0001L7.41421 11.0001L12.7071 5.70718L11.2929 4.29297L4.29289 11.293Z"
        })))), (0, $696Z8.h)("slot", {
            name: "filter-title"
        })), (0, $696Z8.h)("div", {
            class: "filter-options-container"
        }, (0, $696Z8.h)("slot", {
            name: "filter-options"
        }))))), (0, $696Z8.h)("div", {
            class: "overflow-filters"
        }, (0, $696Z8.h)("slot", {
            name: "overflow-filters",
            onSlotchange: handleOverflowFiltersSlotChange.bind(this)
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketFilterDropdownMenuCss;
    }
};
const marketFilterGroupCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--filter-group-margin:var(--core-metrics-spacing-200);--filter-group-search-width:280px;display:flex;margin:var(--filter-group-margin)}.content{--filter-group-button-spacing:var(--core-metrics-spacing-100);display:flex;flex:1;flex-direction:row;flex-wrap:nowrap;gap:var(--filter-group-button-spacing, var(--core-metrics-spacing-100))}::slotted([slot=\"search\"]){max-width:var(--filter-group-search-width)}::slotted([slot=\"search\"]:not([compact])){min-width:var(--filter-group-search-width)}::slotted([slot=\"search\"][focused]){flex:1 1 var(--filter-group-search-width)}@media (max-width: 599px){.content{justify-content:space-between}::slotted([slot=\"search\"]){max-width:unset}::slotted([slot=\"search\"][focused]){flex:1}::slotted([slot=\"filters\"]){display:inline-flex;flex:1}}";
const MAX_VISIBLE_FILTERS = 3;
const FILTER_GROUP_GAP = 8;
const FILTER_BUTTON_WIDTH = 50;
const FILTER_BUTTON_FEEDBACK_GAP = 8;
const RESIZE_DEBOUNCE_DURATION$1 = 16; // 60fps
const MarketFilterGroup$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
     * Used to hide filters when on compact mode
     */ this._isSearchActive = false;
        /**
     * Used to focus on the first filter when 'Tab' is pressed on the input search
     */ this._willFocusOnFirstFilter = false;
        /**
     * Used to delay the overflow dropdown menu from opening
     */ this._willDelayDropdownOpen = false;
        /**
     * Observers
     */ this._observers = {};
        this.throttledHandleResize = throttle(this.handleResize.bind(this), RESIZE_DEBOUNCE_DURATION$1);
        this.maxVisibleFilters = 3;
        this._sortedFilterEls = {
            overflow: [],
            visible: []
        };
    }
    maxVisibleFiltersWatcher() {
        this.handleResize();
    }
    /**
   * Search is active when it's focused
   */ marketInputSearchFocusHandler({ detail }) {
        this._isSearchActive = detail;
    }
    /**
   * For every search animation event, we either show or hide filters
   */ async marketInternalInputSearchCompactAnimationHandler(e) {
        e.stopPropagation();
        await this.handleResize();
        await asyncRequestAnimationFrame();
        /**
     * 'animationstart' means that search is expanded from its compact state.
     * So when the dropdown menu is clicked, we defer the popover from opening
     * right away to prevent jittery animations while elements are getting settled.
     * (See `marketDropdownOpenedHandler` for the delay logic)
     */ this._willDelayDropdownOpen = e.detail === 'animationstart';
    }
    /**
   * Handle dropdown menu's `marketDropdownOpened` event
   */ marketDropdownOpenedHandler(e) {
        if (!this._willDelayDropdownOpen) return;
        this._willDelayDropdownOpen = false;
        e.preventDefault();
        /**
     * Delay `marketDropdownOpened` and manually open the dropdown later.
     * A little extra time (1.25x) has to be added in case the browser rendering
     * is a bit slow. FAST x 1.25 looks like the sweet spot for now.
     */ setTimeout(async ()=>{
            var _a, _b, _c, _d, _e, _f;
            await asyncRequestAnimationFrame();
            await ((_c = (_b = (_a = this._dropdownMenuEl) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(getNamespacedTagFor('market-dropdown'))) === null || _c === void 0 ? void 0 : _c.updateDropdownPosition());
            (_f = (_e = (_d = this._dropdownMenuEl) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector(getNamespacedTagFor('market-dropdown'))) === null || _f === void 0 || _f.openDropdown();
        }, cjs.CORE_ANIMATION_EXIT_TRANSITION_FAST_SPEED_DURATION * 1.25);
    }
    /**
   * The overflow feedback's text length is based on filters that have value.
   * Basically, the button's structure is: `[ <icon> <gap> <feedback> ]`
   */ calculateOverflowButtonWidth(filterEls) {
        // if there are no filters, the overflow button will be hidden
        if (!(filterEls === null || filterEls === void 0 ? void 0 : filterEls.length)) return 0;
        const hasValueCount = filterEls.reduce((result, filterEl)=>{
            const listEl = filterEl.querySelector(getNamespacedTagFor('market-list'));
            if (listEl === null || listEl === void 0 ? void 0 : listEl.value) return result + 1;
            const datePickerEl = filterEl.querySelector(getNamespacedTagFor('market-date-picker'));
            if (datePickerEl === null || datePickerEl === void 0 ? void 0 : datePickerEl.selectedStartDate) return result + 1;
            return result;
        }, 0);
        // feedback omitted when there's no selection
        if (hasValueCount === 0) return FILTER_BUTTON_WIDTH;
        // render the text in some canvas and calculate its width
        const canvasEl = document.createElement('canvas');
        const context = canvasEl.getContext('2d');
        // assume that the first filter's size is the same size as the rest
        if (filterEls[0].size === 'small') context.font = `${cjs.CORE_TYPE_PARAGRAPH_20_SIZE}px ${cjs.CORE_TYPE_PARAGRAPH_20_FONT_FAMILY}`;
        else context.font = `${cjs.CORE_TYPE_PARAGRAPH_30_SIZE}px ${cjs.CORE_TYPE_PARAGRAPH_30_FONT_FAMILY}`;
        const feedbackTextWidth = context.measureText(`${hasValueCount}`).width;
        canvasEl.remove(); // cleanup
        return FILTER_BUTTON_WIDTH + FILTER_BUTTON_FEEDBACK_GAP + feedbackTextWidth;
    }
    getComputedWidth(el) {
        return Number.parseFloat(window.getComputedStyle(el).width);
    }
    /**
   * Find out where the cutoff will happen.
   * Main chunk of the overflow logic happens here
   */ async findFilterCutoffIndex() {
        var _a, _b;
        if (((_a = this.maxVisibleFilters) !== null && _a !== void 0 ? _a : MAX_VISIBLE_FILTERS) <= 0) return 0;
        const isNarrowBreakpoint = (window === null || window === void 0 ? void 0 : window.innerWidth) <= cjs.CORE_BREAKPOINT_NARROW_MAX_WIDTH;
        if (isNarrowBreakpoint) return 1; // show 1 filter max on narrow breakpoints
        else if (this._isSearchActive) return 0; // search is active so no filters should be shown
        /**
     * Get the widths of all the other components (group, search)
     * where `FILTER_GROUP_GAP` is the gap between elements
     */ const filterGroupWidth = this.getComputedWidth(this.el);
        const searchWidth = this._slottedInputSearchEl ? this.getComputedWidth(this._slottedInputSearchEl) + FILTER_GROUP_GAP : 0;
        /**
     * Temporary container where we can measure filter widths
     * https://dev.to/sstraatemans/calculate-html-element-width-before-render-4ii7
     */ const tempEl = document.createElement('div');
        tempEl.style.width = 'auto';
        tempEl.style.position = 'absolute';
        tempEl.style.visibility = 'hidden';
        this.el.shadowRoot.appendChild(tempEl);
        let index = 0;
        let filterWidths = 0;
        for (const filterEl of this._filterEls){
            if (index === ((_b = this.maxVisibleFilters) !== null && _b !== void 0 ? _b : MAX_VISIBLE_FILTERS)) break;
            /**
       * Presuming that all the remaining filters (**excluding** the current one, i.e. `filterEl`)
       * will be overflowed, calculate the potential dropdown menu button width.
       * If this is the last filter, it will not be followed by a `market-filter-dropdown-menu`.
       */ const dropdownMenuButtonWidth = index + 1 === this._filterEls.length // is this the last one?
             ? 0 : FILTER_GROUP_GAP + this.calculateOverflowButtonWidth(this._filterEls.slice(index));
            // measure the filter's width in the temporary container
            const clonedFilterEl = filterEl.cloneNode(true);
            clonedFilterEl.style.display = 'block';
            tempEl.appendChild(clonedFilterEl);
            // let the shadow DOM render within the temp container first before measuring its width
            await asyncRequestAnimationFrame();
            const filterElWidth = this.getComputedWidth(tempEl);
            tempEl.removeChild(clonedFilterEl);
            // width of all the filters so far; gap is only added for filters after the first
            filterWidths += (index > 0 ? FILTER_GROUP_GAP : 0) + filterElWidth;
            // check if filter can fit
            const potentialWidth = searchWidth + filterWidths + dropdownMenuButtonWidth;
            if (potentialWidth >= filterGroupWidth) break;
            ++index;
        }
        // cleanup
        this.el.shadowRoot.removeChild(tempEl);
        tempEl.remove();
        return index;
    }
    /**
   * Sort filters:
   * - split by `this._filterCutoffIndex`
   * - visible filters: set attr `[slot="filters"]`; remove `display: none;`
   * - overflow filters: set attr `[slot="overflow-filters"]`; add `display: none;`
   */ sortVisibleAndOverflowFilters() {
        this._sortedFilterEls = {
            visible: this._filterEls.slice(0, this._filterCutoffIndex),
            overflow: this._filterEls.slice(this._filterCutoffIndex)
        };
        this._sortedFilterEls.visible.forEach((filterEl)=>{
            if (filterEl.style.display) filterEl.style.removeProperty('display');
            if (filterEl.getAttribute('slot') !== 'filters') filterEl.setAttribute('slot', 'filters');
        });
        this._sortedFilterEls.overflow.forEach((filterEl)=>{
            if (filterEl.style.display !== 'none') filterEl.style.display = 'none';
            if (filterEl.getAttribute('slot') !== 'overflow-filters') filterEl.setAttribute('slot', 'overflow-filters');
        });
    }
    /**
   * Handle screen / component resize
   */ async handleResize() {
        if (!this.getComputedWidth(this.el)) // element isn't fully rendered yet
        return;
        const index = await this.findFilterCutoffIndex();
        const isFilterCutoffUpdated = index !== this._filterCutoffIndex;
        if (isFilterCutoffUpdated) {
            this._filterCutoffIndex = index;
            await asyncRequestAnimationFrame();
            this.sortVisibleAndOverflowFilters();
            // collapse dropdown if it's expanded
            if (this._dropdownMenuEl) {
                const dropdownEl = this._dropdownMenuEl.querySelector(getNamespacedTagFor('market-dropdown'));
                if (dropdownEl === null || dropdownEl === void 0 ? void 0 : dropdownEl.expanded) dropdownEl === null || dropdownEl === void 0 || dropdownEl.closeDropdown();
            }
        }
        this.checkIfSearchShouldBeCompact();
    }
    /**
   * Toggle search's compact mode, if present and not focused
   */ async checkIfSearchShouldBeCompact() {
        var _a, _b;
        if (!this._slottedInputSearchEl || this._slottedInputSearchEl.hasAttribute('focused')) return;
        const isNarrowBreakpoint = (window === null || window === void 0 ? void 0 : window.innerWidth) <= cjs.CORE_BREAKPOINT_NARROW_MAX_WIDTH;
        const hasFilters = Boolean((_a = this._filterEls) === null || _a === void 0 ? void 0 : _a.length);
        const hasMoreThanMaxFilters = this._filterEls.length > ((_b = this.maxVisibleFilters) !== null && _b !== void 0 ? _b : MAX_VISIBLE_FILTERS);
        const searchShouldBeCompact = hasFilters && (isNarrowBreakpoint || hasMoreThanMaxFilters);
        // only toggle `compact` when value is new
        if (searchShouldBeCompact !== this._slottedInputSearchEl.hasAttribute('compact')) {
            if (this._slottedInputSearchEl.getAttribute('focused')) await this._slottedInputSearchEl.setFocus(false);
            if (searchShouldBeCompact) this._slottedInputSearchEl.setAttribute('compact', '');
            else this._slottedInputSearchEl.removeAttribute('compact');
        }
    }
    /**
   * When tabbing from the search input and into the first filter,
   */ handleInputSearchTabKeydown(e) {
        var _a;
        if (e.key === 'Tab' && !e.shiftKey && ((_a = this._filterEls) === null || _a === void 0 ? void 0 : _a.length)) {
            e.preventDefault();
            this._slottedInputSearchEl.blur();
            this._willFocusOnFirstFilter = true;
        }
    }
    /**
   * When input search is focused, make sure that dropdown menu is closed
   */ handleInputSearchFocus() {
        var _a, _b;
        const dropdownEl = (_b = (_a = this._dropdownMenuEl) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(getNamespacedTagFor('market-dropdown'));
        if (dropdownEl === null || dropdownEl === void 0 ? void 0 : dropdownEl.hasAttribute('expanded')) dropdownEl.closeDropdown();
    }
    registerSlottedInputSearch() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (_b = (_a = this._slottedInputSearchEl) === null || _a === void 0 ? void 0 : _a.removeEventListener) === null || _b === void 0 || _b.call(_a, 'keydown', this.handleInputSearchTabKeydown);
        (_d = (_c = this._slottedInputSearchEl) === null || _c === void 0 ? void 0 : _c.removeEventListener) === null || _d === void 0 || _d.call(_c, 'focus', this.handleInputSearchFocus);
        this._slottedInputSearchEl = this.el.querySelector('[slot="search"]');
        (_f = (_e = this._slottedInputSearchEl) === null || _e === void 0 ? void 0 : _e.addEventListener) === null || _f === void 0 || _f.call(_e, 'keydown', this.handleInputSearchTabKeydown.bind(this));
        (_h = (_g = this._slottedInputSearchEl) === null || _g === void 0 ? void 0 : _g.addEventListener) === null || _h === void 0 || _h.call(_g, 'focus', this.handleInputSearchFocus.bind(this));
        this.checkIfSearchShouldBeCompact();
    }
    registerSlottedFilters() {
        this._filterEls = [
            ...this.el.querySelectorAll('market-filter')
        ];
    }
    observeContent(el) {
        if (!this._observers.content) {
            this._observers.content = new ResizeObserver(this.throttledHandleResize);
            this._observers.content.observe(el);
        }
    }
    connectedCallback() {
        if (!this._observers.host) {
            this._observers.host = new ResizeObserver(this.throttledHandleResize);
            this._observers.host.observe(this.el);
        }
    }
    componentWillLoad() {
        this.registerSlottedFilters();
        this.registerSlottedInputSearch();
        this.handleResize();
    }
    componentWillRender() {
        var _a, _b, _c;
        // if 'Tab' was pressed (see `handleInputSearchTabKeydown`), attempt to focus on the first filter
        if (this._willFocusOnFirstFilter) {
            (_c = (_b = (_a = this._filterEls) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.setFocus) === null || _c === void 0 || _c.call(_b);
            this._willFocusOnFirstFilter = false;
        }
    }
    disconnectedCallback() {
        Object.entries(this._observers).forEach(([key, observer])=>{
            if (observer) {
                observer.disconnect();
                this._observers[key] = undefined;
            }
        });
    }
    render() {
        var _a, _b;
        /**
     * The dropdown menu button will follow the size of the first filter;
     * basically assuming that the rest of the filters follow the same size.
     */ const dropdownMenuButtonSize = (_b = (_a = this._filterEls) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.size;
        const MarketFilterDropdownMenuTagName = getNamespacedTagFor('market-filter-dropdown-menu');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-filter-group"
        }, (0, $696Z8.h)("div", {
            class: "content",
            ref: (el)=>this.observeContent(el)
        }, (0, $696Z8.h)("slot", {
            name: "search",
            onSlotchange: ()=>this.registerSlottedInputSearch()
        }), (0, $696Z8.h)("slot", {
            name: "filters",
            onSlotchange: ()=>this.registerSlottedFilters()
        }), this._sortedFilterEls.overflow.length > 0 && (0, $696Z8.h)(MarketFilterDropdownMenuTagName, {
            class: "dropdown-menu",
            size: dropdownMenuButtonSize,
            ref: (el)=>this._dropdownMenuEl = el
        }, (0, $696Z8.h)("slot", {
            name: "overflow-filters",
            slot: "overflow-filters"
        }))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "maxVisibleFilters": [
                "maxVisibleFiltersWatcher"
            ]
        };
    }
    static get style() {
        return marketFilterGroupCss;
    }
};
const marketFooterCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:flex;flex-wrap:wrap;justify-content:space-between;width:100%;padding:var(--footer-vertical-padding-size) 0}:host ::slotted(.market-button-group){width:100%}";
const MarketFooter$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-footer"
        }, (0, $696Z8.h)("slot", null));
    }
    static get style() {
        return marketFooterCss;
    }
};
const marketHeaderCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}::slotted(.wayfinding),::slotted([slot='wayfinding']){font-weight:var(--core-type-paragraph-20-weight);font-size:var(--core-type-paragraph-20-size);font-family:var(--core-type-paragraph-20-font-family);line-height:var(--core-type-paragraph-20-leading);letter-spacing:var(--core-type-paragraph-20-tracking);text-transform:var(--core-type-paragraph-20-case)}::slotted(.wayfinding) b,::slotted(.wayfinding) strong,::slotted([slot='wayfinding']) b,::slotted([slot='wayfinding']) strong{font-weight:var(--core-type-semibold-20-weight)}:host{--header-animation-duration:0.2s;display:block}::slotted(*){margin:0}::slotted(.wayfinding),::slotted([slot='wayfinding']){display:block;color:var(--core-text-20-color)}::slotted([slot='wayfinding']){margin-bottom:8px}:host([show-navigation]) ::slotted([slot='compact']:not(.wayfinding)){font-weight:var(--core-type-heading-20-weight) !important;font-size:var(--core-type-heading-20-size) !important;font-family:var(--core-type-heading-20-font-family) !important;line-height:var(--core-type-heading-20-leading) !important;letter-spacing:var(--core-type-heading-20-tracking) !important;text-transform:var(--core-type-heading-20-case) !important;}nav{padding-right:var(--header-main-text-horizontal-spacing)}menu{display:none;grid-auto-flow:column;align-items:start;margin:0;padding-left:var(--header-main-text-horizontal-spacing);-moz-column-gap:var(--button-group-spacing);column-gap:var(--button-group-spacing)}:host([show-actions]) menu{display:grid}.grid{display:none}:host([show-actions]) .grid{display:grid;grid-template-columns:auto minmax(max-content, 1fr)}:host([show-navigation]) .grid{display:grid;grid-template-columns:minmax(max-content, 1fr) auto minmax(max-content, 1fr)}.navigation{display:none}:host([show-navigation]) .navigation{display:flex}.actions{display:flex;place-content:flex-end}.compact{display:flex;flex-direction:column;place-content:center}::slotted(p){margin-top:var(--header-bottom-padding-size)}::slotted(p[slot='compact']){display:none}:host([show-navigation]) .compact{overflow:hidden;text-align:center;opacity:0;visibility:hidden;transition:opacity var(--header-animation-duration) ease-in-out,\n    visibility 0s linear var(--header-animation-duration)}:host([show-navigation]) .compact ::slotted([slot='compact']){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.heading{display:block;transition:opacity var(--header-animation-duration) ease-in-out, visibility 0s}:host([show-navigation]) .heading{margin-top:var(--header-nav-icon-button-spacing-buttom-size)}:host([show-actions]:not([show-navigation])) .heading{display:none}:host([show-navigation][compact]) .compact{opacity:1;visibility:visible;transition:opacity var(--header-animation-duration) ease-in-out, visibility 0s}:host([show-navigation][compact]) .heading{opacity:0;visibility:hidden;transition:opacity var(--header-animation-duration) ease-in-out,\n      visibility 0s linear var(--header-animation-duration)}:host(.regular) .heading{width:var(--modal-full-fixed-layout-width);margin-right:auto;margin-left:auto}:host(.wide) .heading{width:1200px;margin-right:auto;margin-left:auto}";
const MarketHeader$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketHeaderNavigate = (0, $696Z8.createEvent)(this, "marketHeaderNavigate", 7);
        this.showNavigation = null;
        this.closeButtonAriaLabel = 'Close';
        this.disableCloseButton = false;
        this.compact = false;
        this.showActions = false;
    }
    handleCompact() {
        if (this.compact) {
            const compact = this.el.shadowRoot.querySelector('.grid .compact');
            const minHeight = Number.parseInt(getComputedStyle(compact).height, 10);
            this.el.style.height = minHeight !== undefined ? `${minHeight}px` : '';
        } else this.el.style.height = '';
    }
    handleSlottedNavigation() {
        // If there is custom navigation passed in, we need to
        // attach event handlers to the slotted elements manually
        const customNavEl = this.el.querySelector('[slot="navigation"]');
        if (customNavEl) {
            this.showNavigation = true;
            customNavEl.addEventListener('click', this.handleSlottedNavClick.bind(this));
        }
    }
    handleSlottedActions() {
        const actions = this.el.querySelector('[slot="actions"]');
        this.showActions = actions ? true : false;
    }
    handleCloseButtonClick(event) {
        this.marketHeaderNavigate.emit({
            event: event,
            action: 'close'
        });
    }
    handleSlottedNavClick(event) {
        this.marketHeaderNavigate.emit({
            event: event,
            action: 'custom'
        });
    }
    componentWillLoad() {
        this.checkForNavigation();
        this.cloneDefaultHeadingToCompactHeading();
        // watch for changes in slotted children content
        const observer = new MutationObserver(this.handleMutation.bind(this));
        observer.observe(this.el, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }
    componentDidRender() {
        // this function requires layout computation,
        // so we need to wait until render to call.
        this.handleCompact();
    }
    handleMutation(mutationList) {
        // We don't want to re-clone the default slot content if
        // the mutation was already the result of the cloning
        // because then we would get into an infinite loop!
        // So we have to look at the mutation data to check if a
        // compact slotted element was added to prevent re-cloning.
        let shouldClone = true;
        mutationList.forEach((mutation)=>{
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) mutation.addedNodes.forEach((node)=>{
                if (node.slot === 'compact') shouldClone = false;
            });
        });
        if (shouldClone) this.cloneDefaultHeadingToCompactHeading();
    }
    checkForNavigation() {
        // We want to force the header to be navigable when slotted in modals
        const hasModalParent = this.el.closest(`
      ${getNamespacedTagFor('market-modal-full')},
      ${getNamespacedTagFor('market-modal-partial')}
    `);
        // The same if custom navigation is slotted in
        const hasCustomNavigation = this.el.querySelector('[slot="navigation"]');
        // Only set this if the prop hasn't been passed in manually
        if (this.showNavigation === null) this.showNavigation = hasModalParent || hasCustomNavigation ? true : false;
    }
    cloneDefaultHeadingToCompactHeading() {
        // clear existing compact slotted content
        const compactSlottedContent = this.el.querySelectorAll('[slot="compact"]');
        for (const node of compactSlottedContent)this.el.removeChild(node);
        // clone the wayfinding slot into compact slot
        const wayfindingEl = this.el.querySelector('[slot="wayfinding"]');
        if (wayfindingEl) {
            const clone = wayfindingEl.cloneNode(true);
            clone.slot = 'compact';
            clone.classList.add('wayfinding');
            this.el.appendChild(clone);
        }
        // clone the rest of the default slot content into compact slot
        const defaultSlotContent = [
            ...this.el.children
        ].filter((el)=>!el.getAttribute('slot'));
        for (const node of defaultSlotContent){
            const clone = node.cloneNode(true);
            clone.slot = 'compact';
            this.el.appendChild(clone);
        }
    }
    renderDefaultNavigation() {
        const MarketButtonTagName = getNamespacedTagFor('market-button');
        const MarketAccessoryTagName = getNamespacedTagFor('market-accessory');
        return (0, $696Z8.h)(MarketButtonTagName, {
            rank: "secondary",
            slot: "navigation",
            "aria-label": this.closeButtonAriaLabel,
            disabled: this.disableCloseButton,
            onClick: (event)=>this.handleCloseButtonClick(event)
        }, (0, $696Z8.h)(MarketAccessoryTagName, {
            slot: "icon"
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M6.71004 18.71L12 13.41L17.29 18.71L18.71 17.29L13.41 12L18.71 6.71004L17.29 5.29004L12 10.59L6.71004 5.29004L5.29004 6.71004L10.59 12L5.29004 17.29L6.71004 18.71Z"
        }))));
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-header",
            "show-actions": this.showActions
        }, (0, $696Z8.h)("div", {
            class: "grid"
        }, (0, $696Z8.h)("div", {
            class: "navigation"
        }, (0, $696Z8.h)("nav", null, (0, $696Z8.h)("slot", {
            name: "navigation",
            onSlotchange: ()=>this.handleSlottedNavigation()
        }, this.renderDefaultNavigation()))), (0, $696Z8.h)("div", {
            class: "compact"
        }, (0, $696Z8.h)("slot", {
            name: "compact"
        })), (0, $696Z8.h)("div", {
            class: "actions"
        }, (0, $696Z8.h)("menu", null, (0, $696Z8.h)("slot", {
            name: "actions",
            onSlotchange: ()=>this.handleSlottedActions()
        })))), (0, $696Z8.h)("div", {
            class: "heading",
            part: "heading"
        }, (0, $696Z8.h)("slot", {
            name: "wayfinding"
        }), (0, $696Z8.h)("slot", null)));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "compact": [
                "handleCompact"
            ]
        };
    }
    static get style() {
        return marketHeaderCss;
    }
};
function submitFormImplicitly(trigger) {
    const form = trigger.closest('form');
    if (form) {
        const submitButton = form.querySelector('[type="submit"]:not(disabled)');
        if (submitButton) submitButton.click();
    }
}
const marketInputPasswordCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:block}.toggle{cursor:pointer}";
const MarketInputPassword$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inputId = undefined;
        this.name = undefined;
        this.value = undefined;
        this.placeholder = undefined;
        this.maxlength = undefined;
        this.minlength = undefined;
        this.size = 'large';
        this.readonly = undefined;
        this.disabled = undefined;
        this.focused = undefined;
        this.invalid = undefined;
        this.autocomplete = undefined;
        this.inputmode = undefined;
        this.type = 'password';
    }
    /**
   * Sets focus styling on `<market-input-password>`. Toggles focus on the inner `<input>` if true, and blurs focus if false.
   */ async setFocus(value = true) {
        if (this.disabled || this.readonly) return;
        this.focused = value;
        await this.marketInputText.setFocus(value);
    }
    registerSlottedInput() {
        // We need to pass in the slotted input here since it's inside market-input-password's
        // light DOM, and market-input-text is unable to find it.
        this.slottedInput = this.el.querySelector('input[slot=input]');
        if (this.slottedInput) this.marketInputText.registerSlottedInput(this.slottedInput);
    }
    togglePasswordVisibility(e) {
        this.type = this.type === 'password' ? 'text' : 'password';
        e.stopPropagation();
    }
    handleKeyDown(e) {
        if (e.key === 'Enter') submitFormImplicitly(this.el);
    }
    render() {
        const MarketInputTextTagName = getNamespacedTagFor('market-input-text');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-input-password",
            onBlur: ()=>{
                this.marketInputText.focused = false;
            },
            onClick: ()=>{
                this.marketInputText.setFocus();
            },
            onFocus: ()=>{
                this.marketInputText.setFocus();
            },
            onKeyDown: (e)=>{
                this.handleKeyDown(e);
            }
        }, (0, $696Z8.h)(MarketInputTextTagName, {
            type: this.type,
            ref: (el)=>this.marketInputText = el,
            onBlur: ()=>{},
            onClick: ()=>{},
            onFocus: ()=>{},
            inputId: this.inputId,
            name: this.name,
            placeholder: this.placeholder,
            maxlength: this.maxlength,
            minlength: this.minlength,
            size: this.size,
            value: this.value,
            readonly: this.readonly,
            disabled: this.disabled,
            invalid: this.invalid,
            autocomplete: this.autocomplete,
            inputmode: this.inputmode
        }, (0, $696Z8.h)("slot", null), (0, $696Z8.h)("slot", {
            name: "input",
            onSlotchange: ()=>this.registerSlottedInput(),
            // if there is a slotted input, assign it to market-input-text's "input" slot
            slot: this.slottedInput ? 'input' : ''
        }), (0, $696Z8.h)("svg", {
            class: "toggle",
            slot: "trailing-accessory",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: (e)=>{
                this.togglePasswordVisibility(e);
            }
        }, this.type === 'password' && (0, $696Z8.h)("g", {
            "clip-path": "url(#clip0)"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M1.70711 0.292878C1.31658 -0.0976463 0.683418 -0.0976463 0.292893 0.292878C-0.0976311 0.683402 -0.0976311 1.31657 0.292893 1.70709L2.55013 3.96433C1.38429 4.94208 0.502299 6.23046 0.0449702 7.70347C-0.0149901 7.8966 -0.0149901 8.10337 0.0449702 8.29649C1.07604 11.6175 4.26567 14 8 14C9.33924 14 10.6084 13.6936 11.7331 13.1473L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13.4499 12.0356C14.6157 11.0579 15.4977 9.76951 15.955 8.29649C16.015 8.10337 16.015 7.8966 15.955 7.70347C14.924 4.38251 11.7343 1.99998 8 1.99998C6.66076 1.99998 5.39158 2.30641 4.26689 2.85266L1.70711 0.292878ZM2.05607 7.99998C2.43683 6.97522 3.10489 6.07286 3.9716 5.3858L6.0677 7.4819C6.0235 7.64714 5.99994 7.82082 5.99994 8C5.99994 9.10457 6.89537 10 7.99994 10C8.17912 10 8.3528 9.97644 8.51804 9.93224L10.2077 11.6219C9.52221 11.866 8.77873 12 8 12C5.23524 12 2.91488 10.3113 2.05607 7.99998ZM9.93221 8.51798L12.0284 10.6142C12.8951 9.92711 13.5632 9.02475 13.9439 7.99998C13.0851 5.68863 10.7648 3.99998 8 3.99998C7.22127 3.99998 6.47779 4.13395 5.7923 4.37807L7.48196 6.06773C7.64716 6.02355 7.8208 6 7.99994 6C9.10451 6 9.99994 6.89543 9.99994 8C9.99994 8.17914 9.97639 8.35277 9.93221 8.51798Z",
            fill: "black",
            "fill-opacity": "0.3"
        })), this.type === 'text' && (0, $696Z8.h)("g", {
            "clip-path": "url(#clip0)"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8.00006 12C5.2353 12 2.91494 10.3114 2.05613 8C2.91494 5.68865 5.2353 4 8.00006 4C10.7648 4 13.0852 5.68865 13.944 8C13.0852 10.3114 10.7648 12 8.00006 12ZM8.00006 2C4.26573 2 1.0761 4.38252 0.0450312 7.70349C-0.014929 7.89662 -0.014929 8.10338 0.0450312 8.29651C1.0761 11.6175 4.26573 14 8.00006 14C11.7344 14 14.924 11.6175 15.9551 8.29651C16.0151 8.10338 16.0151 7.89662 15.9551 7.70349C14.924 4.38252 11.7344 2 8.00006 2ZM8.00006 10C9.10463 10 10.0001 9.10457 10.0001 8C10.0001 6.89543 9.10463 6 8.00006 6C6.89549 6 6.00006 6.89543 6.00006 8C6.00006 9.10457 6.89549 10 8.00006 10Z",
            fill: "black",
            "fill-opacity": "0.3"
        })), (0, $696Z8.h)("defs", null, (0, $696Z8.h)("clipPath", {
            id: "clip0"
        }, (0, $696Z8.h)("rect", {
            width: "16",
            height: "16",
            fill: "white"
        }))))));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketInputPasswordCss;
    }
};
/**
 * We need to account for several possible values for autocomplete.
 * many people make the assumption that autocomplete is a boolean value,
 * but it is actually a string, so we're going to account for people's
 * incorrect assumptions and accept a boolean as well as accepting the
 * spec values
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
 */ var AUTOCOMPLETE;
(function(AUTOCOMPLETE) {
    AUTOCOMPLETE["TRUE"] = "true";
    AUTOCOMPLETE["FALSE"] = "false";
    AUTOCOMPLETE["ON"] = "on";
    AUTOCOMPLETE["OFF"] = "off";
})(AUTOCOMPLETE || (AUTOCOMPLETE = {}));
function autocompleteWatcher(newValue) {
    switch(newValue){
        case '':
        case true:
        case AUTOCOMPLETE.ON:
        case AUTOCOMPLETE.TRUE:
            /**
       * First, we check for known "truthy" values which will just set
       * the autocomplete attribute to "on" and tell the browser, yes please
       * autocomplete this field, but you have to fend for yourself to figure
       * out what to fill it with.
       */ return AUTOCOMPLETE.ON;
        case false:
        case AUTOCOMPLETE.OFF:
        case AUTOCOMPLETE.FALSE:
            /**
       * The way the W3 spec says to turn autocomplete off is to just
       * set autocomplete="off". But Chrome is notorious for
       * purposefully not implementing this and attempting to always
       * force autocomplete on for inputs. So instead of being
       * straightfoward, we have to trick Chrome by passing it a value
       * that it doesn't understand, hence the emoji.
       *
       * https://stackoverflow.com/questions/15738259/disabling-chrome-autofill
       */ return "\uD83D\uDE0E"; // Deal with it, Chrome
        default:
            /**
       * Otherwise we can assume that a non-empty string is passed
       * that doesn't map to a specific enum value. Despite assumptions
       * otherwise, the autocomplete attribute is not a boolean. You can
       * pass strings to it and browsers will use that to infer what kind
       * of data should be autofilled to this field (address, name)
       * https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
       */ return newValue;
    }
}
const marketInputSearchCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{--input-search-accessory-height:48px;--input-search-accessory-width:48px;--input-search-animation-enter-transition-duration:var(--core-animation-enter-transition-moderate-speed-duration);--input-search-animation-enter-transition-easing:var(--core-animation-enter-transition-easing);--input-search-animation-exit-transition-duration:var(--core-animation-exit-transition-fast-speed-duration);--input-search-animation-exit-transition-easing:var(--core-animation-exit-transition-easing);--input-search-background-color:var(--core-surface-5-color);--input-search-border-radius:6px;--input-search-border-size:1px;--input-search-clear-button-fill:var(--core-fill-20-color);--input-search-clear-button-hover-state-fill:var(--core-fill-10-color);--input-search-compact-state-hover-state-background-color:var(--core-fill-40-color);--input-search-compact-state-hover-state-border-color:var(--core-fill-30-color);--input-search-compact-state-max-width:40px;--input-search-disabled-state-border-color:var(--core-fill-40-color);--input-search-disabled-state-text-color:var(--core-text-20-color);--input-search-focused-state-border-color:var(--core-fill-10-color);--input-search-height:48px;--input-search-hover-state-border-color:var(--core-fill-20-color);--input-search-icon-color:var(--core-text-10-color);--input-search-normal-state-border-color:var(--core-fill-30-color);--input-search-small-size-accessory-height:40px;--input-search-small-size-accessory-width:40px;--input-search-small-size-compact-state-max-width:40px;--input-search-small-size-height:40px;--input-search-small-size-text-size:14px;--input-search-text-color:var(--core-text-10-color);--input-search-text-font-family:var(--square-sans-text);--input-search-text-leading:24px;--input-search-text-placeholder-color:var(--core-text-30-color);--input-search-text-size:16px;--input-search-text-weight:var(--core-type-regular-weight);display:flex;flex:1;flex-direction:row;align-items:center;border:var(--input-search-border-size) solid var(--input-search-normal-state-border-color);border-radius:var(--input-search-border-radius);background-color:var(--input-search-background-color);color:var(--input-search-text-color);font-weight:var(--input-search-text-weight);font-family:var(--input-search-text-font-family);line-height:var(--input-search-text-leading);cursor:text;transition:flex\n    var(--input-search-animation-enter-transition-duration)\n    var(--input-search-animation-enter-transition-easing)}:host(.preload){transition:none !important;}:host(:hover){border-color:var(--input-search-hover-state-border-color)}:host([focused]){border-color:var(--input-search-focused-state-border-color)}:host([disabled]){border-color:var(--input-search-disabled-state-border-color);color:var(--input-search-disabled-state-text-color);cursor:not-allowed}:host([disabled]) svg{fill:var(--input-search-secondary-button-disabled-state-color)}:host([variant=\"medium\" i]),:host([size=\"medium\" i]){height:var(--input-search-height);font-size:var(--input-search-text-size)}:host([variant=\"medium\" i]) .leading-accessory,:host([variant=\"medium\" i]) .leading-accessory .market-accessory,:host([variant=\"medium\" i]) ::slotted([slot='trailing-accessory']),:host([variant=\"medium\" i]) .clear-button,:host([size=\"medium\" i]) .leading-accessory,:host([size=\"medium\" i]) .leading-accessory .market-accessory,:host([size=\"medium\" i]) ::slotted([slot='trailing-accessory']),:host([size=\"medium\" i]) .clear-button{width:calc(var(--input-search-accessory-width) - var(--input-search-border-size) * 2);height:calc(var(--input-search-accessory-height) - var(--input-search-border-size) * 2)}:host([variant=\"medium\" i][compact]:not([focused])),:host([size=\"medium\" i][compact]:not([focused])){flex-basis:var(--input-search-compact-state-max-width)}:host([variant=\"small\" i]),:host([size=\"small\" i]){height:var(--input-search-small-size-height);font-size:var(--input-search-small-size-text-size)}:host([variant=\"small\" i]) .leading-accessory,:host([variant=\"small\" i]) .leading-accessory .market-accessory,:host([variant=\"small\" i]) ::slotted([slot='trailing-accessory']),:host([variant=\"small\" i]) .clear-button,:host([size=\"small\" i]) .leading-accessory,:host([size=\"small\" i]) .leading-accessory .market-accessory,:host([size=\"small\" i]) ::slotted([slot='trailing-accessory']),:host([size=\"small\" i]) .clear-button{width:calc(var(--input-search-small-size-accessory-width) - var(--input-search-border-size) * 2);height:calc(var(--input-search-small-size-accessory-height) - var(--input-search-border-size) * 2)}:host([variant=\"small\" i][compact]:not([focused])),:host([size=\"small\" i][compact]:not([focused])){flex-basis:var(--input-search-small-size-compact-state-max-width)}:host([compact]:not([focused])){flex:0;cursor:pointer;transition:flex\n    var(--input-search-animation-exit-transition-duration)\n    var(--input-search-animation-exit-transition-easing);animation-name:market-input-search-compact-exit;animation-duration:var(--input-search-animation-exit-transition-duration)}:host([compact]:not([focused])) .leading-accessory{margin-right:0;pointer-events:none}:host([compact]:not([focused])) ::slotted([slot='trailing-accessory']),:host([compact]:not([focused])) .clear-button{display:none}:host([compact]:not([focused]):hover){border-color:var(--input-search-compact-state-hover-state-border-color);background-color:var(--input-search-compact-state-hover-state-background-color)}:host([compact][focused]){animation-name:market-input-search-compact-enter;animation-duration:var(--input-search-animation-enter-transition-duration)}input::-moz-placeholder,::slotted(input::-moz-placeholder){color:var(--input-search-text-placeholder-color)}input::placeholder,::slotted(input::placeholder),:host([value=\"\"]) input,:host([value=\"\"]) ::slotted(input){color:var(--input-search-text-placeholder-color)}.leading-accessory,::slotted([slot='trailing-accessory']),.clear-button{display:flex;justify-content:center;align-items:center;padding:0;border:0;background:transparent}.leading-accessory.is-back-icon,.clear-button{cursor:pointer}.clear-button svg{fill:var(--input-search-clear-button-fill)}.clear-button:hover svg{fill:var(--input-search-clear-button-hover-state-fill)}.clear-button.hidden{display:none}svg{fill:var(--input-search-icon-color)}.input-container{flex:1}input,::slotted(input){width:100%;height:var(--input-search-text-leading);padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit}input:focus,::slotted(input:focus){outline:none}input[disabled],::slotted(input[disabled]){color:var(--input-search-disabled-state-text-color)}:host(:not([value=\"\"])) ::slotted([slot='trailing-accessory']){display:none}input:-webkit-autofill,::slotted(input:-webkit-autofill){box-shadow:0 0 0 var(--input-search-text-leading) var(--input-search-background-color) inset !important;-webkit-text-fill-color:var(--input-search-text-color) !important;caret-color:var(--input-search-text-color)}:host input:-webkit-autofill,:host ::slotted(input:-webkit-autofill){animation-name:market-input-autofill-start}:host input:not(:-webkit-autofill),:host ::slotted(input:not(:-webkit-autofill)){animation-name:market-input-autofill-cancel}";
const InputText$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketInputSearchCleared = (0, $696Z8.createEvent)(this, "marketInputSearchCleared", 7);
        this.marketInputSearchValueChange = (0, $696Z8.createEvent)(this, "marketInputSearchValueChange", 7);
        this.marketInputSearchFocus = (0, $696Z8.createEvent)(this, "marketInputSearchFocus", 7);
        this.marketInternalInputSearchCompactAnimation = (0, $696Z8.createEvent)(this, "marketInternalInputSearchCompactAnimation", 7);
        this.marketInputSearchDidLoad = (0, $696Z8.createEvent)(this, "marketInputSearchDidLoad", 7);
        this.value = '';
        this.placeholder = '';
        this.maxlength = undefined;
        this.size = 'medium';
        this.variant = 'medium';
        this.disabled = false;
        this.focused = false;
        this.autofocus = false;
        this.autocomplete = true;
        this.name = undefined;
        this.inputAriaLabel = 'Search';
        this.clearButtonAriaLabel = 'Clear';
        this.searchIconButtonAriaLabel = 'Search icon';
        this.compact = false;
    }
    /**
   * This toggles focus on the inner `<input>`.
   * When input is about to receive focus, force a `tabindex="-1"` on the `<Host>`.
   * Since the focus is already on the inner `<input>`, tabbing into `<Host>` is redundant.
   * When the input loses is focus, the previous `tabindex` value,
   * presumably assigned by the consumer, is assigned back.
   */ focusedWatcher(newValue, oldValue) {
        if (newValue === oldValue) return;
        if (newValue) this.nativeInputEl.focus();
        else this.nativeInputEl.blur();
    }
    disabledWatcher(newValue) {
        // if this component is disabled but focused, make sure to remove focus
        if (newValue && this.focused) this.setFocus(false);
    }
    autocompleteWatcher(newValue) {
        this._autocomplete = autocompleteWatcher(newValue);
    }
    /**
   * Sets focus styling on `<market-input-search>`;
   * toggles focus on the native `<input>` depending on the value passed
   * @param value new `focused` value
   */ setFocus(value = true) {
        // don't do anything when: disabled; or it's already focused/blurred
        if (this.disabled && value || this.focused === value) return Promise.resolve();
        const { defaultPrevented } = this.marketInputSearchFocus.emit(value);
        if (!defaultPrevented) // this will cause the `focusedChangeHandler` to be triggered
        this.focused = value;
        return Promise.resolve();
    }
    /**
   * Clears the current input value.
   */ clearInput() {
        const clearedEvent = this.marketInputSearchCleared.emit();
        if (clearedEvent.defaultPrevented || this.value === '') // if the value is already '', no need to emit the value change event below
        return Promise.resolve();
        const valueChangeEvent = this.marketInputSearchValueChange.emit({
            current: '',
            prevValue: this.value,
            originalEvent: null,
            value: ''
        });
        if (!valueChangeEvent.defaultPrevented) this.value = '';
        return Promise.resolve();
    }
    /**
   * When the clear (X) button is clicked
   */ async handleClearButtonClicked() {
        await this.clearInput();
        this.clearButtonClicked = true;
    }
    /**
   * Handle value change from an <input> event
   */ handleValueChange(e) {
        const target = e.target;
        if (!target) return;
        const { defaultPrevented } = this.marketInputSearchValueChange.emit({
            current: target.value,
            prevValue: this.value,
            originalEvent: e,
            value: target.value
        });
        if (defaultPrevented) {
            e.preventDefault();
            return;
        }
        this.value = target.value;
    }
    /**
   * Handles `.input-container` animation changes
   */ handleAnimation(e) {
        if (!this.compact) return;
        if (e.animationName === 'market-input-search-compact-enter' && e.type === 'animationstart' && this.focused) {
            this.marketInternalInputSearchCompactAnimation.emit(e.type);
            // re-focus because `this.focused` prop change happens first before this animation even trigger
            window.requestAnimationFrame(()=>{
                var _a;
                (_a = this.nativeInputEl) === null || _a === void 0 || _a.focus();
            });
        } else if (e.animationName === 'market-input-search-compact-exit' && e.type === 'animationend') this.marketInternalInputSearchCompactAnimation.emit(e.type);
    }
    handleAccessoryClicked(e, isBackIcon) {
        if (isBackIcon) {
            e.stopPropagation();
            // back button should be displayed, so unfocus
            this.setFocus(false);
        }
    }
    /**
   * Allows passing an alternative light DOM input.
   */ registerSlottedInput(slottedInput) {
        var _a;
        this.slottedInputEl = slottedInput || // input slotted into market-input-search
        this.el.querySelector('input[slot=input]') || (// input slotted into a higher-level component that uses market-input-search
        // (e.g. market-input-password)
        (_a = this.el.getRootNode().host) === null || _a === void 0 ? void 0 : _a.querySelector('input[slot=input]'));
        if (this.slottedInputEl) {
            this.slottedInputEl.addEventListener('input', (e)=>this.handleValueChange(e));
            this.slottedInputEl.addEventListener('focus', ()=>this.setFocus());
            this.slottedInputEl.addEventListener('blur', ()=>this.setFocus(false));
            this.nativeInputEl = this.slottedInputEl;
        }
    }
    /**
   * TODO: This should be a common util. -antonn
   */ updateSharedInputProps() {
        const prevSharedProps = Object.assign({}, this.sharedProps);
        // used by the default shadow DOM native input and to copy component properties to slotted inputs
        // conditionally adding key/value pairs based on whether we want to set them on the <input>
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#individual_attributes
        this.sharedProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this._autocomplete && {
            autocomplete: this._autocomplete
        }), this.autofocus && {
            autofocus: this.autofocus
        }), this.disabled && {
            disabled: this.disabled
        }), this.maxlength >= 0 && {
            maxlength: this.maxlength
        }), this.name && {
            name: this.name
        }), this.placeholder && {
            placeholder: this.placeholder
        }), this.value !== undefined && {
            value: this.value
        });
        // sync component props to slotted input, if one exists
        if (this.slottedInputEl) {
            const modifiedPropKeys = [
                ...new Set([
                    ...Object.keys(prevSharedProps),
                    ...Object.keys(this.sharedProps)
                ])
            ];
            modifiedPropKeys.forEach((key)=>{
                if (!(key in this.sharedProps)) // remove properties that have been unset
                this.slottedInputEl.removeAttribute(key);
                else {
                    /**
           * Boolean attributes can be set using empty strings
           * https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute#javascript
           *
           * But for setting properties like `value` (currently the only known one), directly modify the value instead
           * https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute#gecko_notes
           */ const attributeValue = this.sharedProps[key] !== true ? this.sharedProps[key] : '';
                    if (key === 'value') this.slottedInputEl.value = attributeValue;
                    else if (attributeValue === false) this.slottedInputEl.removeAttribute(key);
                    else this.slottedInputEl.setAttribute(key, attributeValue);
                }
            });
        }
    }
    componentWillLoad() {
        this.el.classList.add('preload'); // disables transitions on page load
        this.autocompleteWatcher(this.autocomplete);
        this.registerSlottedInput();
        this.updateSharedInputProps();
    }
    componentWillUpdate() {
        this.updateSharedInputProps();
    }
    componentDidLoad() {
        this.el.classList.remove('preload');
        this.marketInputSearchDidLoad.emit();
    }
    render() {
        const isBackIcon = this.compact && this.focused;
        // remove tabindex from host if inner <input> is already focused
        const tabindex = this.el.querySelector('input:focus') ? -1 : undefined;
        const MarketAccessoryTagName = getNamespacedTagFor('market-accessory');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-input-search",
            onAnimationEnd: (e)=>this.handleAnimation(e),
            onAnimationStart: (e)=>this.handleAnimation(e),
            onBlur: ()=>{
                var _a;
                if (this.clearButtonClicked) {
                    (_a = this.nativeInputEl) === null || _a === void 0 || _a.focus();
                    this.clearButtonClicked = false;
                } else this.setFocus(false);
            },
            onClick: (e)=>{
                e.stopPropagation();
                this.setFocus();
            },
            onFocus: ()=>this.setFocus(),
            tabindex: tabindex
        }, (0, $696Z8.h)("button", {
            class: classNames('leading-accessory', {
                'is-back-icon': isBackIcon
            }),
            "aria-label": this.searchIconButtonAriaLabel,
            onClick: (e)=>this.handleAccessoryClicked(e, isBackIcon),
            tabindex: "-1"
        }, (0, $696Z8.h)("slot", {
            name: "leading-accessory"
        }, (0, $696Z8.h)(MarketAccessoryTagName, {
            size: "icon",
            tabindex: "-1"
        }, isBackIcon ? // back icon
        (0, $696Z8.h)("svg", {
            width: "15",
            height: "16",
            viewBox: "0 0 15 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M0.292894 7.29285C-0.0976308 7.68337 -0.0976307 8.31654 0.292894 8.70706L7.29289 15.7071L8.70711 14.2928L3.41421 8.99995L15 8.99995L15 6.99995L3.41421 6.99995L8.70711 1.70706L7.29289 0.292846L0.292894 7.29285Z"
        })) : // search icon
        (0, $696Z8.h)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M7.49999 14.4998C9.06999 14.4998 10.52 13.9698 11.68 13.0998L15.79 17.2098L17.2 15.7998L13.09 11.6898C13.97 10.5198 14.49 9.07983 14.49 7.50983C14.49 3.64983 11.35 0.509827 7.48999 0.509827C3.62999 0.509827 0.48999 3.64983 0.48999 7.50983C0.48999 11.3698 3.63999 14.4998 7.49999 14.4998ZM7.49999 2.49983C10.26 2.49983 12.5 4.73983 12.5 7.49983C12.5 10.2598 10.26 12.4998 7.49999 12.4998C4.73999 12.4998 2.49999 10.2598 2.49999 7.49983C2.49999 4.73983 4.73999 2.49983 7.49999 2.49983Z"
        }))))), (0, $696Z8.h)("div", {
            class: "input-container"
        }, (0, $696Z8.h)("slot", {
            name: "input",
            onSlotchange: ()=>this.registerSlottedInput()
        }, !this.slottedInputEl && (0, $696Z8.h)("input", Object.assign({
            "aria-label": this.inputAriaLabel,
            onInput: (e)=>this.handleValueChange(e),
            part: "native-input",
            ref: (input)=>this.nativeInputEl = input,
            type: "text"
        }, this.sharedProps)))), (0, $696Z8.h)("slot", {
            name: "trailing-accessory"
        }), (0, $696Z8.h)("button", {
            "aria-label": this.clearButtonAriaLabel,
            class: classNames('clear-button', {
                hidden: !this.value || this.disabled
            }),
            onClick: this.handleClearButtonClicked.bind(this),
            tabindex: "-1"
        }, (0, $696Z8.h)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M1.71004 13.71L7.00004 8.41004L12.29 13.71L13.71 12.29L8.41004 7.00004L13.71 1.71004L12.29 0.290039L7.00004 5.59004L1.71004 0.290039L0.290039 1.71004L5.59004 7.00004L0.290039 12.29L1.71004 13.71Z"
        }))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "focused": [
                "focusedWatcher"
            ],
            "disabled": [
                "disabledWatcher"
            ],
            "autocomplete": [
                "autocompleteWatcher"
            ]
        };
    }
    static get style() {
        return marketInputSearchCss;
    }
};
const marketInputTextCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:relative;outline:none;font-weight:var(--field-input-weight);font-size:var(--field-input-size);line-height:var(--field-input-leading);cursor:text}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;cursor:inherit}:host ::slotted(label){cursor:inherit}:host input:focus,:host ::slotted(input:focus),:host textarea:focus,:host ::slotted(textarea:focus){outline:none}:host input::-moz-placeholder,:host textarea::-moz-placeholder{color:var(--field-placeholder-text-color)}:host input::placeholder,:host textarea::placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::-moz-placeholder,:host ::slotted(textarea)::-moz-placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::placeholder,:host ::slotted(textarea)::placeholder{color:var(--field-placeholder-text-color)}:host([size='small']){font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}:host{border-radius:var(--field-border-radius);background-color:var(--field-normal-state-background-color);color:var(--field-normal-state-input-color)}:host::after{content:'';position:absolute;inset:0;border-radius:var(--field-border-radius);box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color);pointer-events:none}:host([invalid])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-invalid-validity-border-color)}:host(:hover){background-color:var(--field-hover-state-background-color);color:var(--field-hover-state-input-color)}:host(:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-normal-validity-border-color)}:host([invalid]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-invalid-validity-border-color)}:host([focused]){color:var(--field-focus-state-input-color)}:host([focused])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size)\n        var(--field-focus-state-normal-validity-border-color)}:host([focused][invalid])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size) var(--field-focus-state-invalid-validity-border-color)}:host([disabled]){background-color:var(--field-disabled-state-background-color) !important;color:var(--field-disabled-state-input-color) !important;cursor:not-allowed !important;}:host([disabled])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-disabled-state-border-color) !important}:host([value=\"\"]) ::slotted(label){color:var(--field-normal-state-empty-phase-label-color)}:host(:not([value=\"\"])) ::slotted(label),:host([value=\"\"][autofilled]) ::slotted(label){color:var(--field-normal-state-float-phase-label-color)}:host(:hover) ::slotted(label){color:var(--field-hover-state-empty-phase-label-color)}:host(:not([value=\"\"]):hover) ::slotted(label),:host([value=\"\"][autofilled]:hover) ::slotted(label){color:var(--field-hover-state-float-phase-label-color)}:host([focused]) ::slotted(label){color:var(--field-focus-state-float-phase-label-color)}:host([value=\"\"][disabled]) ::slotted(label){color:var(--field-disabled-state-empty-phase-label-color)}:host(:not([value=\"\"])[disabled]) ::slotted(label),:host([value=\"\"][autofilled][disabled]) ::slotted(label){color:var(--field-disabled-state-float-phase-label-color)}:host{--field-accessory-horizontal-spacing-size:16px;--field-size-small-accessory-horizontal-spacing-size:12px;--field-size-large-image-accessory-outer-spacing-size:12px;--field-size-medium-image-accessory-outer-spacing-size:4px;--field-size-large-button-accessory-outer-spacing-size:12px;--field-size-medium-button-accessory-outer-spacing-size:4px;--field-size-large-tooltip-accessory-horizontal-spacing-size:5px;--field-size-large-tooltip-accessory-vertical-spacing-size:-1px;--field-size-small-tooltip-accessory-horizontal-spacing-size:1px}:host ::slotted([slot='leading-accessory']){flex-shrink:0;margin-right:var(--field-accessory-horizontal-spacing-size);margin-left:var(--field-accessory-horizontal-spacing-size)}:host ::slotted(.market-accessory[slot='leading-accessory'][size='image']){margin-left:var(--field-size-large-image-accessory-outer-spacing-size)}:host ::slotted(.market-tooltip[slot='leading-accessory']){margin:var(--field-size-large-tooltip-accessory-vertical-spacing-size)\n      var(--field-size-large-tooltip-accessory-horizontal-spacing-size)}:host ::slotted(.market-button[slot='leading-accessory'][size='small']){margin-left:var(--field-size-large-button-accessory-outer-spacing-size)}:host ::slotted([slot='trailing-accessory']){flex-shrink:0;margin-right:var(--field-accessory-horizontal-spacing-size);margin-left:var(--field-accessory-horizontal-spacing-size)}:host ::slotted(.market-accessory[slot='trailing-accessory'][size='image']){margin-right:var(--field-size-large-image-accessory-outer-spacing-size)}:host ::slotted(.market-tooltip[slot='trailing-accessory']){margin:var(--field-size-large-tooltip-accessory-vertical-spacing-size)\n      var(--field-size-large-tooltip-accessory-horizontal-spacing-size)}:host ::slotted(.market-button[slot='trailing-accessory'][size='small']){margin-right:var(--field-size-large-button-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-accessory[slot='leading-accessory'][size='image']){margin-left:var(--field-size-medium-image-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-button[slot='leading-accessory'][size='small']){margin-left:var(--field-size-medium-button-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-accessory[slot='trailing-accessory'][size='image']){margin-right:var(--field-size-medium-image-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-button[slot='trailing-accessory'][size='small']){margin-right:var(--field-size-medium-button-accessory-outer-spacing-size)}:host([size='small']) ::slotted([slot='leading-accessory']),:host([size='small']) ::slotted([slot='trailing-accessory']){margin-right:var(--field-size-small-accessory-horizontal-spacing-size);margin-left:var(--field-size-small-accessory-horizontal-spacing-size)}:host([size='small']) ::slotted(.market-tooltip[slot='leading-accessory']),:host([size='small']) ::slotted(.market-tooltip[slot='trailing-accessory']){margin-right:var(--field-size-small-tooltip-accessory-horizontal-spacing-size);margin-left:var(--field-size-small-tooltip-accessory-horizontal-spacing-size)}:host .label-input-container.has-leading-accessory{padding-left:0 !important;}:host .label-input-container.has-trailing-accessory{padding-right:0 !important;}:host{--field-input-animation-speed:0.2s;--field-input-label-translate:12px;--field-empty-phase-label-text-size-unitless:16;--field-float-phase-label-text-size-unitless:14;--field-size-medium-float-phase-vertical-padding-size:12px;--field-size-medium-float-phase-horizontal-padding-size:16px;--field-size-small-float-phase-vertical-padding-size:9px;--field-size-small-float-phase-horizontal-padding-size:12px;display:flex;align-items:center}:host .label-input-container,:host([value='']:not([focused]):not([autofilled])) .label-input-container{flex-grow:1;padding:var(--field-float-phase-vertical-padding-size) var(--field-float-phase-horizontal-padding-size)}:host([size='medium']) .label-input-container,:host([size='medium'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-medium-float-phase-vertical-padding-size)\n      var(--field-size-medium-float-phase-horizontal-padding-size)}:host([size='small']) .label-input-container,:host([size='small'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-small-float-phase-vertical-padding-size)\n      var(--field-size-small-float-phase-horizontal-padding-size)}:host ::slotted(label){display:block;min-height:var(--field-empty-phase-label-text-leading);font-weight:var(--field-empty-phase-label-text-weight);font-size:var(--field-empty-phase-label-text-size);line-height:var(--field-empty-phase-label-text-leading);letter-spacing:var(--field-empty-phase-label-text-tracking);transition:all var(--field-input-animation-speed);transform:translateY(var(--field-input-label-translate));transform-origin:0 0}:host(:not([value=\"\"])) ::slotted(label),:host([value=\"\"]:not([focused])[autofilled]) ::slotted(label),:host([focused]) ::slotted(label){font-weight:var(--field-float-phase-label-text-weight);transform:scale(\n        calc(var(--field-float-phase-label-text-size-unitless) / var(--field-empty-phase-label-text-size-unitless))\n      )}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){opacity:0}:host([focused]) input,:host([focused]) ::slotted(input),:host([focused]) textarea,:host([focused]) ::slotted(textarea),:host(:not([value=''])) input,:host(:not([value=''])) ::slotted(input),:host(:not([value=''])) textarea,:host(:not([value=''])) ::slotted(textarea){opacity:1}:host([size='small']) ::slotted(label),:host([size='medium']) ::slotted(label){position:absolute;overflow:hidden;clip:rect(0 0 0 0);width:1px;height:1px;white-space:nowrap;clip-path:inset(50%)}:host([size='small']) input,:host([size='small']) ::slotted(input),:host([size='small']) textarea,:host([size='small']) ::slotted(textarea),:host([size='medium']) input,:host([size='medium']) ::slotted(input),:host([size='medium']) textarea,:host([size='medium']) ::slotted(textarea){opacity:1}:host input::-webkit-outer-spin-button,:host input::-webkit-inner-spin-button{margin:0;-webkit-appearance:none;appearance:none}:host input[type='number']{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}input[type=\"time\"]::-webkit-inner-spin-button,input[type=\"time\"]::-webkit-outer-spin-button,input[type=\"time\"]::-webkit-clear-button,input[type=\"time\"]::-webkit-calendar-picker-indicator{display:none}input[type=\"date\"]::-webkit-calendar-picker-indicator,input[type=\"time\"]::-webkit-calendar-picker-indicator{display:none}input[type=\"date\"]::-webkit-inner-spin-button,input[type=\"time\"]::-webkit-inner-spin-button,input[type=\"date\"]::-webkit-clear-button,input[type=\"time\"]::-webkit-clear-button{display:none;margin:0;-webkit-appearance:none}:host([value='']) input,:host([value='']) ::slotted(input){color:var(--field-placeholder-text-color)}:host input:-webkit-autofill,:host ::slotted(input:-webkit-autofill){animation-name:market-input-autofill-start;animation-duration:0.1ms}:host input:not(:-webkit-autofill),:host ::slotted(input:not(:-webkit-autofill)){animation-name:market-input-autofill-cancel;animation-duration:0.1ms}";
const InputText = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketInputValueChange = (0, $696Z8.createEvent)(this, "marketInputValueChange", 7);
        this.marketInputDidLoad = (0, $696Z8.createEvent)(this, "marketInputDidLoad", 7);
        this.hasLeadingAccessory = false;
        this.hasTrailingAccessory = false;
        this.onMutationObserved = (ariaAttributes)=>{
            this.ariaAttributes = ariaAttributes;
        };
        this.type = 'text';
        this.inputId = undefined;
        this.name = undefined;
        this.value = '';
        this.placeholder = undefined;
        this.maxlength = undefined;
        this.minlength = undefined;
        this.size = 'large';
        this.step = undefined;
        this.min = undefined;
        this.max = undefined;
        this.pattern = undefined;
        this.required = undefined;
        this.readonly = false;
        this.disabled = false;
        this.focused = false;
        this.invalid = false;
        this.inputmode = undefined;
        this.autofocus = false;
        this.autocomplete = true;
        this.autovalidate = false;
        this.autofilled = false;
        this.ariaAttributes = undefined;
    }
    focusedChangeHandler(newValue) {
        if (!this.nativeInput) return;
        if (newValue) this.nativeInput.focus();
        else this.nativeInput.blur();
    }
    autocompleteWatcher(newValue) {
        this._autocomplete = autocompleteWatcher(newValue);
    }
    handleMarketDialogLoaded() {
        if (this.autofocus) this.setFocus();
    }
    valueDidChange(e) {
        const result = this.marketInputValueChange.emit({
            value: e.target.value,
            originalEvent: e
        });
        if (result.defaultPrevented) {
            e.target.value = this.value;
            e.preventDefault();
        } else {
            this.value = e.target.value;
            if (this.autovalidate) this.invalid = !this.nativeInput.checkValidity();
        }
        // Once the merchant has entered text, the content is no longer populated
        // via autofill, and should be styled as usual.
        this.autofilled = false;
    }
    handleAutofill(e) {
        // This a hack to detect browser autofill, since there's no event emitted for it.
        // See here for details: https://stackoverflow.com/a/41530164
        if (e.animationName === 'market-input-autofill-start') this.autofilled = true;
        else if (e.animationName === 'market-input-autofill-cancel' && !this.value) this.autofilled = false;
    }
    handleKeyDown(e) {
        if (e.key === 'Enter') submitFormImplicitly(this.el);
    }
    /**
   * Sets focus styling on `<market-input-text>`. Toggles focus on the inner `<input>` if true, and blurs focus if false.
   */ setFocus(value = true) {
        if (this.readonly || this.disabled) return Promise.resolve();
        /**
     * This will cause the `focusChangedHandler` to be triggered which will focus/blur the native <input /> depending on the value passed.
     */ this.focused = value;
        return Promise.resolve();
    }
    /**
   * Returns the native `<input>` element used under the hood.
   */ getInputElement() {
        return Promise.resolve(this.nativeInput);
    }
    /**
   * Allows passing an alternative light DOM input.
   */ registerSlottedInput(slottedInput) {
        var _a;
        this.slottedInput = slottedInput || // input slotted into market-input-text
        this.el.querySelector('input[slot=input]') || (// input slotted into a higher-level component that uses market-input-text
        // (e.g. market-input-password)
        (_a = this.el.getRootNode().host) === null || _a === void 0 ? void 0 : _a.querySelector('input[slot=input]'));
        if (this.slottedInput) {
            this.slottedInput.addEventListener('input', (e)=>this.valueDidChange(e));
            this.slottedInput.addEventListener('focus', ()=>this.setFocus());
            this.slottedInput.addEventListener('blur', ()=>this.focused = false);
            this.slottedInput.addEventListener('animationstart', (e)=>this.handleAutofill(e));
            this.nativeInput = this.slottedInput;
        }
        return Promise.resolve();
    }
    updateSharedInputProps() {
        const prevSharedProps = Object.assign({}, this.sharedProps);
        // used by the default shadow DOM native input and to copy component properties to slotted inputs
        // conditionally adding key/value pairs based on whether we want to set them on the <input>
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#individual_attributes
        this.sharedProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this.inputId && {
            id: this.inputId
        }), this.name && {
            name: this.name
        }), this.type && {
            type: this.type
        }), this.placeholder && {
            placeholder: this.placeholder
        }), this.maxlength >= 0 && {
            maxlength: this.maxlength
        }), this.minlength >= 0 && {
            minlength: this.minlength
        }), this.step && {
            step: this.step
        }), this.min && {
            min: this.min
        }), this.max && {
            max: this.max
        }), this.required && {
            required: this.required
        }), this.pattern && {
            pattern: this.pattern
        }), this.value !== undefined && {
            value: this.value
        }), this.readonly && {
            readonly: this.readonly
        }), this.disabled && {
            disabled: this.disabled
        }), this.autofocus && {
            autofocus: this.autofocus
        }), this.inputmode && {
            inputmode: this.inputmode
        }), this._autocomplete && {
            autocomplete: this._autocomplete
        }), this.ariaAttributes), {
            'aria-label': getTextInputAriaLabel(this.el)
        });
        // sync component props to slotted input, if one exists
        if (this.slottedInput) {
            const modifiedPropKeys = [
                ...new Set([
                    ...Object.keys(prevSharedProps),
                    ...Object.keys(this.sharedProps)
                ])
            ];
            modifiedPropKeys.forEach((key)=>{
                if (!(key in this.sharedProps)) // remove properties that have been unset
                this.slottedInput.removeAttribute(key);
                else {
                    // boolean attributes can be set using empty strings
                    // https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute#javascript
                    const attributeValue = this.sharedProps[key] !== true ? this.sharedProps[key] : '';
                    this.slottedInput.setAttribute(key, attributeValue);
                }
            });
        }
    }
    componentWillLoad() {
        this.hasLeadingAccessory = Boolean(this.el.querySelector('[slot="leading-accessory"]'));
        this.hasTrailingAccessory = Boolean(this.el.querySelector('[slot="trailing-accessory"]'));
        this.mutationObserver = observeAriaAttributes(this.el, this.onMutationObserved);
        this.registerSlottedInput();
        this.autocompleteWatcher(this.autocomplete);
        this.updateSharedInputProps();
    }
    componentDidLoad() {
        this.marketInputDidLoad.emit({
            input: this.nativeInput
        });
    }
    componentWillUpdate() {
        this.updateSharedInputProps();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-input-text",
            onBlur: ()=>{
                this.focused = false;
            },
            onClick: ()=>{
                this.setFocus();
            },
            onFocus: ()=>{
                this.setFocus();
            },
            onKeyDown: (e)=>{
                this.handleKeyDown(e);
            }
        }, (0, $696Z8.h)("slot", {
            name: "leading-accessory"
        }), (0, $696Z8.h)("div", {
            class: classNames('label-input-container', {
                'has-leading-accessory': this.hasLeadingAccessory,
                'has-trailing-accessory': this.hasTrailingAccessory
            })
        }, (0, $696Z8.h)("slot", null), (0, $696Z8.h)("slot", {
            name: "input",
            onSlotchange: ()=>this.registerSlottedInput()
        }, !this.slottedInput && (0, $696Z8.h)("input", Object.assign({
            part: "native-input",
            ref: (input)=>this.nativeInput = input,
            onInput: (e)=>this.valueDidChange(e),
            onAnimationStart: (e)=>this.handleAutofill(e)
        }, this.sharedProps)))), (0, $696Z8.h)("slot", {
            name: "trailing-accessory"
        }));
    }
    disconnectedCallback() {
        var _a;
        (_a = this.mutationObserver) === null || _a === void 0 || _a.disconnect();
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "focused": [
                "focusedChangeHandler"
            ],
            "autocomplete": [
                "autocompleteWatcher"
            ]
        };
    }
    static get style() {
        return marketInputTextCss;
    }
};
const marketLinkCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--transition-duration:0.2s;font-weight:var(--text-link-medium-size-text-weight);font-size:inherit;line-height:inherit;letter-spacing:var(--text-link-medium-size-text-tracking);cursor:pointer}:host a,:host a:link,:host a:visited,:host a:hover,:host a:active,:host button{color:var(--text-link-normal-variant-color);font-family:inherit;text-decoration:none;transition:opacity var(--transition-duration)}:host a,:host a:link,:host a:visited,:host button{opacity:var(--text-link-normal-state-opacity)}:host a:hover,:host button:hover{opacity:var(--text-link-hover-state-opacity)}:host a:active,:host button:active{opacity:var(--text-link-pressed-state-opacity)}:host([aria-disabled]) a,:host([aria-disabled]) button{opacity:var(--text-link-disabled-state-opacity)}:host([destructive]) a,:host([destructive]) a:link,:host([destructive]) a:visited,:host([destructive]) a:hover,:host([destructive]) a:active,:host([destructive]) button{color:var(--text-link-destructive-variant-color)}:host button{padding:0;border:none;background:none;outline:inherit;font:inherit;cursor:pointer}";
const MarketLink$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.onMutationObserved = (ariaAttributes)=>{
            this.ariaAttributes = ariaAttributes;
        };
        this.href = undefined;
        this.target = undefined;
        this.rel = undefined;
        this.destructive = false;
        this.disabled = false;
        this.ariaAttributes = undefined;
    }
    componentWillLoad() {
        this.mutationObserver = observeAriaAttributes(this.el, this.onMutationObserved);
    }
    handleClick(e) {
        if (this.disabled) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    render() {
        const { disabled, handleClick, href, target, ariaAttributes, rel } = this;
        const TagType = href !== undefined ? 'a' : 'button';
        const TagTypeAttrs = TagType === 'a' ? {
            href: href,
            target: target,
            rel: rel
        } : {
            disabled: disabled
        };
        const ariaRole = TagType === 'a' ? 'link' : 'button';
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-link",
            role: ariaRole,
            "aria-disabled": disabled ? 'true' : null,
            tabindex: disabled ? '-1' : null,
            onClick: handleClick,
            onKeyDown: handleClick
        }, (0, $696Z8.h)(TagType, Object.assign({}, TagTypeAttrs, ariaAttributes, {
            "aria-disabled": disabled ? 'true' : null
        }), (0, $696Z8.h)("slot", null)));
    }
    disconnectedCallback() {
        var _a;
        (_a = this.mutationObserver) === null || _a === void 0 || _a.disconnect();
    }
    get el() {
        return this;
    }
    static get style() {
        return marketLinkCss;
    }
};
// adapted from https://bobbyhadz.com/blog/javascript-find-highest-z-index-on-page
function getMaxZIndex(container) {
    return Math.max(...[
        ...container.querySelectorAll('*')
    ].map((el)=>Number.parseFloat(window.getComputedStyle(el).zIndex)).filter((zIndex)=>!Number.isNaN(zIndex)), 0);
}
// adapted from https://gist.github.com/davej/44e3bbec414ed4665220
async function transitionToPromise(el, property, value) {
    return new Promise((resolve)=>{
        // ensure there is a transition on this property
        const { transitionProperty } = getComputedStyle(el);
        const properties = transitionProperty.split(', ');
        // if no transition on this property, set it and resolve
        if (!properties.includes(property)) {
            el.style[property] = value;
            resolve();
            return;
        }
        // otherwise, set up a listener for transitionend
        const transitionEnded = (e)=>{
            if (e.propertyName !== property) return;
            el.removeEventListener('transitionend', transitionEnded);
            resolve();
        };
        el.addEventListener('transitionend', transitionEnded);
        el.style[property] = value;
    });
}
function isDraggable(value) {
    return Boolean(value && value.dragEnabled !== undefined);
}
/*
  This util class abstracts & encapsulates drag & drop functionality for a component.

  When wired up to a component, it does the following:
  - adds a .market-drag-placeholder class to the original dragged element
  - clones the dragged element with a class of .market-drag-clone
  - visually tracks the drag move with the cloned element via CSS transform
  - fires marketDragStart & marketDragEnd custom events on the dragged element
  - fires marketDragEnter, marketDragMove, marketDragLeave, & marketDragDrop custom events on drag targets
  - adds a .market-drag-released class to transition the clone back to the placeholder

  Intended to be wired up via events fired by <market-drag-handle> like so:
  
  ```html
  <Host
    onMarketDragHandleDragStart={(e: CustomEvent<TMarketDragCoords>) => this.onDragStart(e)}
    onMarketDragHandleDragMove={(e: CustomEvent<TMarketDragCoords>) => this.onDragMove(e)}
    onMarketDragHandleDragEnd={(e: CustomEvent<TMarketDragCoords> => this.onDragEnd(e)}
  >
    <market-drag-handle></market-drag-handle>
  </Host>
  ```

  ```js
  onDragStart(e: CustomEvent<TMarketDragCoords>) {
    const coords: TMarketDragCoords = e.detail;
    this.drag = new Draggable(this.el);
    await this.drag.start(coords);
  }
  onDragMove(e: CustomEvent<TMarketDragCoords>) {
    const coords: TMarketDragCoords = e.detail;
    await this.drag.move(coords);
  }
  onDragEnd(e: CustomEvent<TMarketDragCoords>) {
    const coords: TMarketDragCoords = e.detail;
    await this.drag.end(coords);
    this.drag.destroy();
  }
  ```

  ```css
  // the original element gets this class while being dragged
  :host(.market-drag-placeholder) { ... }

  // the cloned element gets this class while being dragged
  :host(.market-drag-clone) { ... }
  
  // the cloned element gets this class when released
  // use it to transition clone back to the placeholder
  :host(.market-drag-released) {
    transition: transform 100ms ease;
  }
  ```
*/ class Draggable {
    // Init the class with the element to be dragged
    constructor(el){
        this.el = el;
    }
    // Start a drag movement on the element:
    // - adds a .market-drag-placeholder class to the dragged element
    // - clones the dragged element with a class of .market-drag-clone
    // - fires marketDragStart custom event on the dragged element
    start(coords) {
        this.canceled = false;
        this.startCoords = coords;
        const { el } = this;
        // fire start event
        const defaultPrevented = !el.dispatchEvent(new CustomEvent('marketDragStart', {
            bubbles: true,
            cancelable: true,
            detail: Object.assign(Object.assign({}, coords), {
                draggedEl: el,
                dragTarget: null
            })
        }));
        if (defaultPrevented) {
            this.canceled = true;
            return;
        }
        // measure the dragged element
        const { width } = getComputedStyle(el);
        const { top, left } = el.getBoundingClientRect();
        // clone & append a dummy el to visually track the drag move
        const clone = el.cloneNode(true);
        clone.classList.add('market-drag-clone');
        Object.assign(clone.style, {
            width: width,
            position: 'fixed',
            top: `${top}px`,
            left: `${left}px`,
            zIndex: `${getMaxZIndex(document.body) + 1}`
        });
        document.body.append(clone);
        this.clone = clone;
        // class to style placeholder while drag is in progress
        el.classList.add('market-drag-placeholder');
    }
    // Continues a drag movement on the element:
    // - visually tracks the drag move with the cloned element via CSS transform
    // - fires marketDragEnter, marketDragMove, & marketDragLeave custom events on drag targets
    move(coords) {
        if (this.canceled) return;
        const { el, clone, target, startCoords } = this;
        const { x, y } = coords;
        // get the first drag target that is not the clone
        const newTarget = [
            ...document.elementsFromPoint(x, y)
        ].find((target)=>target !== clone);
        // if drag target is new
        if (newTarget !== target) {
            // fire leave on current target
            if (target) target.dispatchEvent(new CustomEvent('marketDragLeave', {
                bubbles: true,
                detail: {
                    x: x,
                    y: y,
                    draggedEl: el,
                    dragTarget: target
                }
            }));
            // fire enter on new target
            newTarget.dispatchEvent(new CustomEvent('marketDragEnter', {
                bubbles: true,
                detail: {
                    x: x,
                    y: y,
                    draggedEl: el,
                    dragTarget: newTarget
                }
            }));
            // update current drag target
            this.target = newTarget;
        }
        // fire drag move on new target
        newTarget.dispatchEvent(new CustomEvent('marketDragMove', {
            bubbles: true,
            detail: {
                x: x,
                y: y,
                draggedEl: el,
                dragTarget: newTarget
            }
        }));
        // move the cloned el with the drag move
        const deltaX = x - startCoords.x;
        const deltaY = y - startCoords.y;
        Object.assign(clone.style, {
            transform: `translate(${deltaX}px, ${deltaY}px)`
        });
    }
    // Ends a drag movement on the element:
    // - fires marketDragEnd custom event on the dragged element
    // - fires marketDragDrop custom event on drag target
    // - removes the cloned element after transitioning it back to the placeholder
    // - removes the .market-drag-placeholder class from the dragged element
    async end(coords) {
        if (this.canceled) return;
        const { el, clone } = this;
        const { x, y } = coords;
        // get the first drag target that is not the clone
        const dragTarget = [
            ...document.elementsFromPoint(x, y)
        ].find((target)=>target !== clone);
        // fire end event on dragged element
        const defaultPrevented = !el.dispatchEvent(new CustomEvent('marketDragEnd', {
            bubbles: true,
            cancelable: true,
            detail: {
                x: x,
                y: y,
                draggedEl: el,
                dragTarget: dragTarget
            }
        }));
        // fire drop event on target
        if (!defaultPrevented) dragTarget === null || dragTarget === void 0 || dragTarget.dispatchEvent(new CustomEvent('marketDragDrop', {
            bubbles: true,
            detail: {
                x: x,
                y: y,
                draggedEl: el,
                dragTarget: dragTarget
            }
        }));
        // measure the elements once again
        await asyncRequestAnimationFrame();
        const { width } = getComputedStyle(el);
        const elRect = el.getBoundingClientRect();
        const cloneRect = clone.getBoundingClientRect();
        const deltaX = cloneRect.left - elRect.left;
        const deltaY = cloneRect.top - elRect.top;
        // update the clone position so that its top & left origin
        // is the same as the dragged element (which may have been moved!)
        // delta transform will result in the clone appearing in the same spot
        Object.assign(clone.style, {
            width: width,
            top: `${elRect.top}px`,
            left: `${elRect.left}px`,
            transform: `translate(${deltaX}px, ${deltaY}px)`
        });
        // remove the transform to transition clone back to the placeholder.
        if (deltaX || deltaY) {
            await asyncRequestAnimationFrame();
            clone.classList.add('market-drag-released');
            await transitionToPromise(clone, 'transform', 'translate(0, 0)');
        }
        // cleanup
        el.classList.remove('market-drag-placeholder');
        clone.remove();
    }
    // clean up var refs
    destroy() {
        this.el = null;
        this.clone = null;
        this.target = null;
        this.startCoords = null;
        this.canceled = null;
    }
}
function isReorderable(value) {
    return Boolean(value && value.reorderable !== undefined);
}
/*
  This util class abstracts & encapsulates reorderable functionality for a component.

  In the constructor:
  - `el` is the component element to apply reordering functionality to
  - `accepts` is an array of CSS selectors that are valid draggable elements
  - `event` is the stencil EventEmitter to fire when a reorder event occurs

  Intended to be wired up via drag events fired by a dragged object like so:
  
  ```html
  <Host
    onMarketDragMove={(e: CustomEvent<TMarketDragEventDetail>) => this.onDragMove(e)}
    onMarketDragLeave={() => this.onDragLeave()}
    onMarketDragEnd={(e: CustomEvent<TMarketDragEventDetail>) => this.onDragEnd(e)}
    onMarketDragDrop={(e: CustomEvent<TMarketDragEventDetail>) => this.onDragDrop(e)}
  >
    ...
  </Host>
  ```

  ```js
  this.reorder = new Reorderable({
    el: this.el,
    accepts: ['market-row'],
    event: marketListItemsReordered,
  });
  onDragMove(e: CustomEvent<TMarketDragEventDetail>) {
    this.reorder.dragMove(e);
  }
  onDragLeave() {
    this.reorder.dragLeave();
  }
  onDragEnd(e: CustomEvent<TMarketDragEventDetail>) {
    this.reorder.dragEnd(e);
  }
  onDragDrop(e: CustomEvent<TMarketDragEventDetail>) {
    this.reorder.dragDrop(e);
  }
  ```

  ```css
  // the drag cursor inserted to show current drop location
  ::slotted(.market-drag-cursor) { ... }
  ```
*/ class Reorderable {
    constructor({ el, accepts, event }){
        this.el = el;
        this.accepts = accepts;
        this.event = event;
        this.cursor = document.createElement('div');
        this.cursor.classList.add('market-drag-cursor');
    }
    isValidDrag(dragged, target) {
        const { el, accepts } = this;
        const dragSource = dragged.closest(el.tagName);
        const dragTarget = target.closest(el.tagName);
        // begin with type checks...
        if (!isDraggable(dragged)) return false;
        if (!isReorderable(dragSource)) return false;
        if (!isReorderable(dragTarget)) return false;
        // is this an accepted draggable item?
        if (dragged.closest(accepts.join(',')) !== dragged) return false;
        // is this element either the source or target?
        if (el !== dragSource && el !== dragTarget) return false;
        // are the source and target elements reorderable?
        if (dragSource.reorderable === 'off' || dragTarget.reorderable === 'off') return false;
        // if target & source elements are different, are they both externally reorderable?
        if (dragSource !== dragTarget && (dragSource.reorderable !== 'external' || dragTarget.reorderable !== 'external')) return false;
        // looks like we're good!
        return true;
    }
    getItems() {
        const { el, accepts } = this;
        const items = [];
        const scopedSelectors = accepts.map((selector)=>`:scope > ${selector}`);
        el.querySelectorAll(scopedSelectors.join(',')).forEach((item)=>{
            if (isDraggable(item)) items.push(item);
        });
        return items;
    }
    /**
   * Fired on a target element when an item is dragged over the target.
   */ dragMove(e) {
        const { el, accepts, cursor } = this;
        const { draggedEl, dragTarget, y } = e.detail;
        if (!this.isValidDrag(draggedEl, dragTarget)) return;
        // if this el is the drag target (not another child)
        if (dragTarget === el) {
            el.append(cursor);
            return;
        }
        // otherwise, find the nearest child item target
        const targetSibling = dragTarget.closest(accepts.join(','));
        if (!targetSibling) return;
        // determine whether to append or prepend cursor based on mouse position
        const { top, bottom } = targetSibling.getBoundingClientRect();
        const halfway = (top + bottom) / 2;
        if (y < halfway) targetSibling.before(cursor);
        else targetSibling.after(cursor);
    }
    /**
   * Fired on a target element when a dragged item leaves the target
   */ dragLeave() {
        var _a;
        (_a = this.cursor) === null || _a === void 0 || _a.remove();
    }
    /**
   * Fired on a dragged item when it is released.
   * Useful to determine if an item was dropped externally.
   */ dragEnd(e) {
        const { el, event } = this;
        const { draggedEl, dragTarget } = e.detail;
        const items = this.getItems();
        if (!this.isValidDrag(draggedEl, dragTarget)) return;
        // do nothing if the drag target is still inside this el
        if (dragTarget.closest(el.tagName) === el) return;
        // note: dragging externally means new index = -1
        const oldIndex = items.indexOf(draggedEl);
        const newIndex = -1;
        // emit the reorder event and check for prevent default
        const { defaultPrevented } = event.emit({
            item: draggedEl,
            oldIndex: oldIndex,
            newIndex: newIndex
        });
        // if reorder event was prevented, prevent the drop event
        if (defaultPrevented) e.preventDefault();
    }
    /**
   * Fired on a target element when a dragged item is released over the target.
   */ dragDrop(e) {
        const { event, cursor } = this;
        const { draggedEl, dragTarget } = e.detail;
        const items = this.getItems();
        if (!this.isValidDrag(draggedEl, dragTarget)) return;
        // note: if item is external, then old index is -1
        const oldIndex = items.indexOf(draggedEl);
        // find new index
        const itemsWithoutDraggedEl = [
            ...items
        ];
        if (oldIndex >= 0) itemsWithoutDraggedEl.splice(oldIndex, 1);
        const newIndex = itemsWithoutDraggedEl.indexOf(cursor.previousElementSibling) + 1;
        // same index means no reorder event
        if (newIndex === oldIndex) {
            cursor === null || cursor === void 0 || cursor.remove();
            return;
        }
        // emit the reorder event and check for prevent default
        const { defaultPrevented } = event.emit({
            item: draggedEl,
            oldIndex: oldIndex,
            newIndex: newIndex
        });
        // if default prevented, remove the drag cursor
        if (defaultPrevented) {
            cursor === null || cursor === void 0 || cursor.remove();
            return;
        }
        // otherwise, insert the item
        cursor.replaceWith(draggedEl);
    }
    // clean up var refs
    destroy() {
        var _a;
        (_a = this.cursor) === null || _a === void 0 || _a.remove();
        this.el = null;
        this.accepts = null;
        this.event = null;
        this.cursor = null;
    }
}
/**
 * Check if the value is considered empty
 * @param {unknown} value
 */ function isValueEmpty$1(value) {
    return value === '' || value === null || value === undefined;
}
/**
 * Check if the slotted control in <market-row slot="control-row> is a valid control row input
 * @param {unknown} control
 */ function isValidControl(control) {
    var _a;
    if (!control) return false;
    const tagName = (_a = control.tagName) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
    const validControlTags = [
        getNamespacedTagFor('market-checkbox').toLocaleLowerCase(),
        getNamespacedTagFor('market-radio').toLocaleLowerCase(),
        getNamespacedTagFor('market-toggle').toLocaleLowerCase()
    ];
    return validControlTags.includes(tagName);
}
const marketListCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}::slotted(.market-action-card){margin-bottom:var(--action-card-spacing)}::slotted(.market-input-search){margin-bottom:var(--core-metrics-spacing-100)}.hidden,::slotted(.hidden){display:none}::slotted(.market-row.hide-bottom-border)::before{display:none}.market-empty-state,::slotted(.market-empty-state){padding-right:0;padding-left:0;border:0}::slotted(.market-drag-cursor){--drag-cursor-height:4px;display:block;height:var(--drag-cursor-height);margin:calc(var(--drag-cursor-height) / 2 * -1) 0;background:var(--core-emphasis-fill-color);pointer-events:none}";
const MarketList$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketListSelectionsDidChange = (0, $696Z8.createEvent)(this, "marketListSelectionsDidChange", 7);
        this.marketListSlotChange = (0, $696Z8.createEvent)(this, "marketListSlotChange", 7);
        this.marketListItemsReordered = (0, $696Z8.createEvent)(this, "marketListItemsReordered", 7);
        this.marketListItemsFiltered = (0, $696Z8.createEvent)(this, "marketListItemsFiltered", 7);
        this.value = '';
        this.interactive = false;
        this.transient = false;
        this.multiselect = false;
        this.name = undefined;
        this.filterStrategy = 'textcontent';
        this.reorderable = 'off';
        this.hasSearch = false;
        this.items = undefined;
        this.selections = new Set();
        this.filteredItems = undefined;
    }
    reorderableWatcher() {
        this.setReorderable();
    }
    valueWatcher() {
        this.setSelectionsFromValue();
    }
    /* Listen for the marketRowSelected event which is emitted by slotted market-row elements
  when they are clicked */ rowSelectedEventHandler(e) {
        this.handleItemSelectedEvent(e.target);
    }
    /* Listen for the marketRowDeselected event which is emitted by slotted market-row elements
  when they are clicked */ rowDeselectedEventHandler(e) {
        this.handleItemDeselectedEvent(e.target);
    }
    /* Listen for the marketCardSelected event which is emitted by slotted market-action-card elements
  when they are clicked */ cardSelectedEventHandler(e) {
        this.handleItemSelectedEvent(e.target);
    }
    /* Listen for the marketCardDeselected event which is emitted by slotted market-action-card elements
  when they are clicked */ cardDeselectedEventHandler(e) {
        this.handleItemDeselectedEvent(e.target);
    }
    /**
   * Listen for `marketInputSearchValueChange` which is emitted by the slotted `market-input-search`
   */ marketInputSearchValueChangeEventHander({ detail }) {
        this.filterItems(detail.value);
    }
    getEventSelectionDetails() {
        const prevSelectionValues = (()=>{
            if (typeof this.value === 'string') return this.value ? this.value.split(',').filter((value)=>!isValueEmpty$1(value)) : [];
            else if (Array.isArray(this.value)) return this.value.filter((value)=>!isValueEmpty$1(value));
            return this.value;
        })();
        const currentSelections = uniqBy([
            ...this.selections
        ].filter((item)=>item !== this.controlRow), (item)=>item.value);
        const currentSelectionValues = currentSelections.reduce((items, item)=>{
            if (!isValueEmpty$1(item.value)) items.push(item.value);
            return items;
        }, []);
        return {
            currentSelections: currentSelections,
            currentSelectionValues: currentSelectionValues,
            prevSelectionValues: prevSelectionValues
        };
    }
    handleItemSelectedEvent(selectedItem) {
        if (selectedItem === this.controlRow) this.selectAllItems();
        else this.selectItem(selectedItem);
        const { currentSelections, currentSelectionValues, prevSelectionValues } = this.getEventSelectionDetails();
        this.value = currentSelectionValues.join(','); // reflect to DOM
        this.marketListSelectionsDidChange.emit({
            newSelection: selectedItem,
            newSelectionValue: selectedItem.value,
            newDeselection: null,
            newDeselectionValue: null,
            currentSelections: currentSelections,
            currentSelectionValues: currentSelectionValues,
            prevSelectionValues: prevSelectionValues
        });
    }
    handleItemDeselectedEvent(deselectedItem) {
        // We check to see if the element is in our selections, since we may have
        // already manually deselected it due to another element being clicked.
        // We only want the code in the block to fire when `marketRowDeselected` is being
        // emitted due to a merchant actually clicking to deselect an element.
        if (!this.selections.has(deselectedItem)) return;
        if (deselectedItem === this.controlRow) this.deselectAllItems();
        else this.deselectItem(deselectedItem);
        const { currentSelections, currentSelectionValues, prevSelectionValues } = this.getEventSelectionDetails();
        this.value = currentSelectionValues.join(','); // reflect to DOM
        this.marketListSelectionsDidChange.emit({
            newSelection: null,
            newSelectionValue: null,
            newDeselection: deselectedItem,
            newDeselectionValue: deselectedItem.value,
            currentSelections: currentSelections,
            currentSelectionValues: currentSelectionValues,
            prevSelectionValues: prevSelectionValues
        });
    }
    /**
   * Selects a given option from the list. Also handles deselecting
   * all other elements when not in multiselect mode.
   */ selectItem(selectedItem) {
        /* Only if this list is interactive and *doesn't* allow multiple selections,
    deselect all the options except the one that was just selected */ if (this.interactive) {
            if (!this.multiselect) {
                this.deselectItems([
                    selectedItem
                ]);
                this.selections = new Set([
                    selectedItem
                ]);
            } else this.selections.add(selectedItem);
        }
    }
    /**
   * Selects all multiselect list options.
   */ selectAllItems() {
        var _a;
        if (!this.items || !this.interactive || !this.multiselect) return;
        // if items are being filtered, "Select all" only applies to visible items
        const items = ((_a = this.filteredItems) === null || _a === void 0 ? void 0 : _a.visible) || this.items;
        this.selections = new Set(items);
    }
    /**
   * Deselects a given option from the list.
   */ deselectItem(deselectedItem) {
        this.selections.delete(deselectedItem);
    }
    /**
   * Deselects all other items other than the ones that were just selected.
   */ deselectItems(selectedItems) {
        if (!this.items) return;
        this.items.forEach((item)=>{
            /* Check to make sure the item isn't in the list of
        selected items (likely only the one that was just
        selected and triggered the callback) */ if (!selectedItems.includes(item) && item.selected) item.deselect();
        });
    }
    /**
   * Deselects all list options.
   */ deselectAllItems() {
        if (!this.selections || !this.interactive) return;
        // if items are being filtered, only deselect all visible filters
        if (this.filteredItems.visible) this.filteredItems.visible.forEach((item)=>{
            this.selections.delete(item);
        });
        else this.selections.clear();
    }
    /**
   * If passed or updates interactive, ensure list itself is set to interactive mode.
   */ syncListInteractiveWithItems() {
        if (this.items.length > 0 && (this.items[0].tagName === getNamespacedTagFor('market-action-card').toUpperCase() || this.items[0].tagName === getNamespacedTagFor('market-row').toUpperCase() && this.items[0].interactive === true) && !this.interactive) // force list to be interactive if items are interactive rows
        // (i.e. when they contain slotted controls), or
        // items are action cards (which are always interactive)
        this.interactive = true;
    }
    /**
   * Processes interactive, transient, and multiselect props and propagates these props
   * to children components whenever these props are updated.
   */ processItems() {
        this.items.forEach((item)=>{
            if (item.tagName === getNamespacedTagFor('market-action-card').toUpperCase()) {
                item.transient = this.transient;
                const cardRow = item.querySelector(getNamespacedTagFor('market-row'));
                if (cardRow) this.setRowProperties(cardRow);
            } else this.setRowProperties(item);
        });
    }
    getCurrentSelectionValues() {
        if (Array.isArray(this.value)) return new Set(this.value);
        return new Set(this.multiselect ? this.value.split(',') : [
            this.value
        ]);
    }
    setRowProperties(row) {
        row.interactive = this.interactive;
        row.transient = this.transient;
        // We don't want subsequent clicks to deselect rows for single select lists
        row.togglable = this.multiselect;
    }
    /**
   * Select item that corresponds to passed value, or clear all values if value is empty string.
   */ setSelectionsFromValue() {
        var _a;
        if (this.value || this.value === '') {
            const values = this.getCurrentSelectionValues();
            (_a = this.items) === null || _a === void 0 || _a.forEach((item)=>{
                if (item === this.controlRow) // control row selection happens in syncControlRowWithSelections
                return;
                if (!isValueEmpty$1(this.value) && values.has(item.value)) {
                    item.silentlySelect();
                    this.selectItem(item);
                } else {
                    // value is '', so deselect all items
                    item.silentlyDeselect();
                    this.deselectItem(item);
                }
            });
        }
    }
    /**
   * Find any list items with the `selected` property and add to `selections`.
   */ setSelectionsFromRowAttributes() {
        const initialSelections = new Set();
        this.items.forEach((item)=>{
            if (item.selected) /* TODO: Maybe figure out how to handle the case where the
         * list is not multiselect, but more than one market-row has the
         * [selected] attribute */ initialSelections.add(item);
        });
        this.selections = initialSelections;
    }
    /**
   * Sets the initial state of the list by updating and propagating props and setting
   * default value.
   */ setInternalState() {
        this.items = [
            ...this.el.querySelectorAll(`:scope > ${getNamespacedTagFor('market-row')}, :scope > ${getNamespacedTagFor('market-action-card')}`)
        ];
        this.syncListInteractiveWithItems();
        this.processItems();
        if (this.items.length > 0) {
            if (this.value) this.setSelectionsFromValue();
            else this.setSelectionsFromRowAttributes();
        }
    }
    /**
   * Syncs the state of the slotted control row with list selections (e.g. all selected, none
   * selected, some selected).
   */ async syncControlRowWithSelections() {
        var _a, _b, _c, _d, _e, _f;
        if (!this.controlRow) return;
        const slottedControl = this.controlRow.querySelector('[slot="control"]');
        const isCheckbox = slottedControl.tagName.toLowerCase() === getNamespacedTagFor('market-checkbox');
        const selectableItems = (_c = (_b = (_a = this.filteredItems) === null || _a === void 0 ? void 0 : _a.visible) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : this.items.length - 1; // -1 excludes control row
        const visibleSelectedItems = (_f = (_e = (_d = this.filteredItems) === null || _d === void 0 ? void 0 : _d.visibleSelected) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : this.selections.size;
        switch(visibleSelectedItems){
            case 0:
                // no options selected, deselect control row
                this.deselectItem(this.controlRow);
                await this.controlRow.silentlyDeselect();
                await asyncRequestAnimationFrame(); // prevents flash where it goes from indeterminate -> checked -> unchecked
                slottedControl.removeAttribute('indeterminate');
                break;
            case selectableItems:
                // all options selected, select control row
                await this.controlRow.silentlySelect();
                this.selectItem(this.controlRow);
                slottedControl.removeAttribute('indeterminate');
                break;
            default:
                // some options selected
                if (isCheckbox) {
                    // control row gets selected, checkbox set to indeterminate
                    await this.controlRow.silentlySelect();
                    this.selectItem(this.controlRow);
                    await asyncRequestAnimationFrame(); // prevents bug where checkbox becomes checked but not indeterminate
                    slottedControl.setAttribute('indeterminate', '');
                } else {
                    // control row gets deselected
                    await this.controlRow.silentlyDeselect();
                    this.deselectItem(this.controlRow);
                }
                break;
        }
        this.injectCountOnControlRow();
    }
    /**
   * Injects an accessory to the control row that displays the number of items;
   * or edit that accessory's text content if the element already exists
   */ injectCountOnControlRow() {
        if (!this.controlRow) return;
        const countAccessoryEl = this.controlRow.querySelector('.count[slot="trailing-accessory"]');
        const count = this.filteredItems.visible.length;
        if (countAccessoryEl) countAccessoryEl.textContent = `${count}`;
        else {
            const newEl = document.createElement('span');
            newEl.classList.add('count');
            newEl.setAttribute('slot', 'trailing-accessory');
            newEl.textContent = `${count}`;
            this.controlRow.appendChild(newEl);
        }
    }
    /**
   * Filters items based on search query inputted in slotted `market-input-search`
   */ filterItems(query) {
        var _a;
        const filteredItems = this.items.reduce((filteredItems, item)=>{
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (item.getAttribute('slot') === 'control-row') // filteredItems will not contain the control row as it isn't needed for logic purposes
            return filteredItems;
            else if (!query) {
                // if there's no search query, all items are visible
                filteredItems.visible.push(item);
                return filteredItems;
            } else if (typeof this.filterStrategy === 'function') {
                // attempts to call the provided function
                const callbackResult = this.filterStrategy({
                    item: item,
                    label: (_a = item.querySelector('[slot="label"]')) === null || _a === void 0 ? void 0 : _a.textContent,
                    query: query,
                    textContent: item.textContent,
                    value: item.value
                });
                if (callbackResult) {
                    filteredItems.visible.push(item);
                    return filteredItems;
                }
            } else if (((_c = (_b = this.filterStrategy) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b)) === 'textcontent') {
                // search through the entire item's textContent
                const isFound = ((_d = item === null || item === void 0 ? void 0 : item.textContent) === null || _d === void 0 ? void 0 : _d.search(new RegExp(query, 'i'))) >= 0;
                if (isFound) {
                    filteredItems.visible.push(item);
                    return filteredItems;
                }
            } else if (((_f = (_e = this.filterStrategy) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase) === null || _f === void 0 ? void 0 : _f.call(_e)) === 'label') {
                // only works if there's a slotted label
                const labelEl = item.querySelector('[slot="label"]');
                const isFound = ((_g = labelEl === null || labelEl === void 0 ? void 0 : labelEl.textContent) === null || _g === void 0 ? void 0 : _g.search(new RegExp(query, 'i'))) >= 0;
                if (isFound) {
                    filteredItems.visible.push(item);
                    return filteredItems;
                }
            } else if (((_j = (_h = this.filterStrategy) === null || _h === void 0 ? void 0 : _h.toLocaleLowerCase) === null || _j === void 0 ? void 0 : _j.call(_h)) === 'value') {
                // if the item's value isn't a string, it may not work well UX-wise
                const value = String(item.value);
                const isFound = value.search(new RegExp(query)) >= 0;
                if (isFound) {
                    filteredItems.visible.push(item);
                    return filteredItems;
                }
            }
            // item didn't pass any of the conditions / filter strategies above
            filteredItems.hidden.push(item);
            return filteredItems;
        }, {
            visible: [],
            hidden: [],
            visibleSelected: [],
            selected: []
        });
        // DOM manipulation
        requestAnimationFrame(()=>{
            var _a;
            // make sure that visible items are visible, hidden items are hidden
            filteredItems.visible.forEach((item)=>item.classList.remove('hidden'));
            filteredItems.hidden.forEach((item)=>item.classList.add('hidden'));
            // hide last visible item's bottom border
            this.items.forEach((item)=>item.classList.remove('hide-bottom-border'));
            if (filteredItems.visible.length > 0) {
                const lastVisibleItem = filteredItems.visible[filteredItems.visible.length - 1];
                lastVisibleItem.classList.add('hide-bottom-border');
            }
            // hide control row if there are no search results
            (_a = this.controlRow) === null || _a === void 0 || _a.classList.toggle('hidden', filteredItems.visible.length === 0);
        });
        // will not emit when the list is initially rendered without a search query
        if (this.filteredItems || !this.filteredItems && query) this.marketListItemsFiltered.emit({
            items: filteredItems.visible,
            prevItems: (_a = this.filteredItems) === null || _a === void 0 ? void 0 : _a.visible
        });
        // this triggers a re-render since `this.filteredItems` is a `@State`
        this.filteredItems = filteredItems;
        this.updateSelectedItemsInFilteredItems();
    }
    updateSelectedItemsInFilteredItems() {
        if (!this.filteredItems) return;
        this.filteredItems.selected = this.items.filter((item)=>item.getAttribute('slot') !== 'control-row' && item.selected);
        this.filteredItems.visibleSelected = this.filteredItems.visible.filter((item)=>item.getAttribute('slot') !== 'control-row' && item.selected);
    }
    /* SLOTCHANGE HANDLERS */ handleSearchSlotchange() {
        var _a;
        this.inputSearchEl = this.el.querySelector('[slot="search"]');
        this.hasSearch = Boolean(this.inputSearchEl);
        this.filterItems((_a = this.inputSearchEl) === null || _a === void 0 ? void 0 : _a.value);
    }
    defaultSlotchangeHandler() {
        var _a;
        this.setInternalState();
        this.filterItems((_a = this.inputSearchEl) === null || _a === void 0 ? void 0 : _a.value);
        this.setReorderable();
        this.marketListSlotChange.emit();
    }
    /**
   * Rows slotted into the "control-row" slot only function as such if the list is interactive and
   * multiselect and the row contains a valid slotted control (checkbox or toggle).
   */ controlRowSlotchangeHandler() {
        if (!this.interactive || !this.multiselect) return;
        const slottedRow = this.el.querySelector('[slot="control-row"]');
        const slottedControl = slottedRow === null || slottedRow === void 0 ? void 0 : slottedRow.querySelector('[slot="control"]');
        this.controlRow = isValidControl(slottedControl) ? slottedRow : undefined;
    }
    /**
   * Show empty state if:
   * - list isn't empty, but
   * - there is a search query, and
   * - there are no search results
   */ setEmptyStateVisibility() {
        var _a, _b;
        const emptyStateEl = this.el.querySelector('[slot="empty-state"]') || this.el.shadowRoot.querySelector(getNamespacedTagFor('market-empty-state'));
        const willShowEmptyState = ((_a = this.inputSearchEl) === null || _a === void 0 ? void 0 : _a.value) && !((_b = this.filteredItems) === null || _b === void 0 ? void 0 : _b.visible.length);
        emptyStateEl === null || emptyStateEl === void 0 || emptyStateEl.classList.toggle('hidden', !willShowEmptyState);
    }
    /* LIFECYCLE EVENTS */ componentWillLoad() {
        var _a;
        this.setInternalState();
        this.filterItems((_a = this.inputSearchEl) === null || _a === void 0 ? void 0 : _a.value);
        this.setReorderable();
    }
    componentWillRender() {
        this.syncListInteractiveWithItems();
        this.processItems();
        this.updateSelectedItemsInFilteredItems();
        this.controlRowSlotchangeHandler();
        this.syncControlRowWithSelections();
        this.setEmptyStateVisibility();
    }
    /*
    KEYBOARD ACCESSIBILITY

    tabbing goes through rows (and slotted controls, if any) once before moving
    on to rest of page content

    once list has focus, up/down arrows can move focus up/down, stopping at end
    of list rather than cycling through (similar to native html <select>)
    - https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select

    if slotted row contents have focus, up/down arrows do nothing
  */ handleKeydown(e) {
        switch(e.key){
            case 'ArrowDown':
                this.handleArrowDown(e);
                break;
            case 'ArrowUp':
                this.handleArrowUp(e);
                break;
        }
    }
    handleArrowDown(e) {
        const focused = document.querySelector(':focus');
        const prevFocusedRowIndex = [
            ...this.items
        ].indexOf(focused);
        // return if no rows are focused
        if (prevFocusedRowIndex === -1) return;
        // focus next enabled row
        for(let i = prevFocusedRowIndex + 1; i < this.items.length; i++)if (!this.items[i].disabled) {
            this.items[i].focus();
            break;
        }
        e.preventDefault(); // down arrow should not scroll page
    }
    handleArrowUp(e) {
        const focused = document.querySelector(':focus');
        const prevFocusedRowIndex = [
            ...this.items
        ].indexOf(focused);
        // return if no rows are focused
        if (prevFocusedRowIndex === -1) return;
        // focus last enabled row
        for(let i = prevFocusedRowIndex - 1; i >= 0; i--)if (!this.items[i].disabled) {
            this.items[i].focus();
            break;
        }
        e.preventDefault(); // up arrow should not scroll page
    }
    setReorderable() {
        const { el, items, controlRow, reorderable, reorder, marketListItemsReordered } = this;
        if (reorderable === 'off') {
            reorder === null || reorder === void 0 || reorder.destroy();
            this.reorder = null;
        } else if (!reorder) this.reorder = new Reorderable({
            el: el,
            accepts: [
                `${getNamespacedTagFor('market-row')}:not([slot="control"])`
            ],
            event: marketListItemsReordered
        });
        items === null || items === void 0 || items.forEach((item)=>{
            if (!isDraggable(item)) return;
            if (item === controlRow) return; // control row is not reorderable
            item.dragEnabled = reorderable !== 'off';
        });
    }
    onDragMove(e) {
        this.reorder.dragMove(e);
    }
    onDragLeave() {
        this.reorder.dragLeave();
    }
    onDragEnd(e) {
        this.reorder.dragEnd(e);
    }
    onDragDrop(e) {
        this.reorder.dragDrop(e);
    }
    render() {
        var _a;
        const MarketEmptyState = getNamespacedTagFor('market-empty-state');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-list",
            role: this.interactive ? 'listbox' : 'list',
            "aria-labelledby": this.name,
            "aria-multiselectable": this.multiselect,
            "has-search": this.hasSearch,
            onKeydown: (e)=>this.handleKeydown(e),
            onMarketDragMove: (e)=>this.onDragMove(e),
            onMarketDragLeave: ()=>this.onDragLeave(),
            onMarketDragEnd: (e)=>this.onDragEnd(e),
            onMarketDragDrop: (e)=>this.onDragDrop(e)
        }, (0, $696Z8.h)("slot", {
            name: "search",
            onSlotchange: ()=>this.handleSearchSlotchange()
        }), (0, $696Z8.h)("slot", {
            name: "control-row",
            onSlotchange: ()=>this.controlRowSlotchangeHandler()
        }), (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.defaultSlotchangeHandler()
        }), (0, $696Z8.h)("slot", {
            name: "empty-state"
        }, (0, $696Z8.h)(MarketEmptyState, {
            class: "hidden"
        }, (0, $696Z8.h)("svg", {
            height: "40",
            slot: "media",
            viewBox: "0 0 40 40",
            width: "40",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M34.4667 17.2L28.1 10.8333H26.6667C26.6667 9.45 25.55 8.33333 24.1667 8.33333C22.7834 8.33333 21.6667 9.45 21.6667 10.8333H18.3334C18.3334 9.45 17.2167 8.33333 15.8334 8.33333C14.45 8.33333 13.3334 9.45 13.3334 10.8333H11.9L5.53337 17.2C4.11671 18.6167 3.33337 20.5 3.33337 22.5C3.33337 26.6333 6.70004 30 10.8334 30C14.8 30 18.0167 26.9 18.2834 23.0167C18.8167 23.2167 19.4 23.3333 20 23.3333C20.6 23.3333 21.1834 23.2167 21.7167 23.0167C21.9834 26.9 25.2 30 29.1667 30C33.3 30 36.6667 26.6333 36.6667 22.5C36.6667 20.5 35.8834 18.6167 34.4667 17.2ZM10.8334 26.6667C8.53337 26.6667 6.66671 24.8 6.66671 22.5C6.66671 21.3833 7.10004 20.3333 7.88337 19.55C8.66671 18.7667 9.71671 18.3333 10.8334 18.3333C13.1334 18.3333 15 20.2 15 22.5C15 24.8 13.1334 26.6667 10.8334 26.6667ZM15.35 16.55C14.4667 15.8833 13.4334 15.3833 12.3 15.15L13.2667 14.1667H17.2334C16.3834 14.7333 15.7167 15.5667 15.35 16.55ZM20 20C19.0834 20 18.3334 19.25 18.3334 18.3333C18.3334 17.4167 19.0834 16.6667 20 16.6667C20.9167 16.6667 21.6667 17.4167 21.6667 18.3333C21.6667 19.25 20.9167 20 20 20ZM22.75 14.1667H26.7167L27.7 15.15C26.5667 15.3833 25.5334 15.8833 24.65 16.55C24.2834 15.5667 23.6167 14.7333 22.75 14.1667ZM29.1667 26.6667C26.8667 26.6667 25 24.8 25 22.5C25 20.2 26.8667 18.3333 29.1667 18.3333C30.2834 18.3333 31.3334 18.7667 32.1167 19.55C32.9 20.3333 33.3334 21.3833 33.3334 22.5C33.3334 24.8 31.4667 26.6667 29.1667 26.6667Z",
            fill: "var(--core-text-10-color)",
            "fill-opacity": "0.9"
        })), (0, $696Z8.h)("h3", {
            slot: "primary-text"
        }, (0, $696Z8.h)("slot", {
            name: "empty-state-primary-text"
        }, "No search results for \u201C", (_a = this.inputSearchEl) === null || _a === void 0 ? void 0 : _a.value, "\u201D")), (0, $696Z8.h)("p", {
            slot: "secondary-text"
        }, (0, $696Z8.h)("slot", {
            name: "empty-state-secondary-text"
        }, "Try a different search.")))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "reorderable": [
                "reorderableWatcher"
            ],
            "value": [
                "valueWatcher"
            ]
        };
    }
    static get style() {
        return marketListCss;
    }
};
const marketModalFullCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{display:flex;flex-direction:column;justify-content:stretch;overflow:hidden}:host ::slotted(main){flex:0 1 100%;overflow-y:auto;height:100%}:host ::slotted(.market-header){margin-bottom:var(--core-metrics-spacing-300);padding-top:0}:host ::slotted(.market-footer){padding-bottom:0}:host{position:absolute;top:0;left:0;width:100%;height:100%;padding-top:var(--modal-full-vertical-padding-size);padding-bottom:var(--modal-full-vertical-padding-size);background-color:var(--modal-full-background-color);animation:var(--modal-full-animation-enter-transition-duration)\n    market-slideup\n    forwards\n    var(--modal-full-animation-enter-transition-easing)}:host ::slotted(*){padding-right:var(--modal-full-horizontal-padding-size);padding-left:var(--modal-full-horizontal-padding-size)}:host([hidden]){animation-name:market-slidedown;animation-duration:var(--modal-full-animation-exit-transition-duration);animation-timing-function:var(--modal-full-animation-exit-transition-easing)}:host{--modal-full-wide-layout-width:1200px;--regular-modal-main-horizontal-padding:calc((100vw - var(--modal-full-fixed-layout-width)) / 2);--wide-modal-main-horizontal-padding:calc((100vw - var(--modal-full-wide-layout-width)) / 2)}@media (min-width: 648px){:host([layout='regular'])>:not(.market-header,.market-footer),:host([layout='regular']) ::slotted(main){padding:0 var(--regular-modal-main-horizontal-padding)}}@media (min-width: 1280px){:host([layout='wide'])>:not(.market-header,.market-footer),:host([layout='wide']) ::slotted(main){padding:0 var(--wide-modal-main-horizontal-padding)}}";
const MarketModalFull$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketDialogLoaded = (0, $696Z8.createEvent)(this, "marketDialogLoaded", 7);
        this.marketDialogDismissed = (0, $696Z8.createEvent)(this, "marketDialogDismissed", 7);
        this.marketDialogDidDismiss = (0, $696Z8.createEvent)(this, "marketDialogDidDismiss", 7);
        this.type = 'modal-full';
        this.observers = {};
        this.hidden = false;
        this.dialogID = undefined;
        this.index = undefined;
        this.layout = 'regular';
        this.trapFocus = false;
        this.animationEnterDuration = cjs.MODAL_FULL_ANIMATION_ENTER_TRANSITION_DURATION;
        this.animationExitDuration = cjs.MODAL_FULL_ANIMATION_EXIT_TRANSITION_DURATION;
    }
    layoutWatcher() {
        this.repositionHeader();
    }
    /* Listen to the headerNavigate event emitted by a market-header child component
  so we can emit a close event if needed */ headerNavigateEventHandler(event) {
        const { detail, target } = event;
        // TODO: 'close' should probably come from an enum of some sort
        if (detail.action === 'close') // only dismiss if this is the first ancestor dialog
        {
            if (target.closest(getDialogSelector()) === this.el) this.dismiss();
        }
    }
    /* The parent context will handle actually removing elements from the DOM,
  All the modal needs to do it emit an event so actually closing it can be
  some other elements problem */ /**
   * Repositions header inside of market-header to align with modal content
   */ repositionHeader() {
        // since it isn't possible to style slotted child elements, we need to add
        // classes to the slotted header to apply needed styles to its shadow DOM.
        const slottedHeader = this.el.querySelector(getNamespacedTagFor('market-header'));
        if (slottedHeader) {
            slottedHeader.classList.remove('regular', 'wide');
            switch(this.layout){
                case 'regular':
                    slottedHeader.classList.add('regular');
                    break;
                case 'wide':
                    slottedHeader.classList.add('wide');
                    break;
            }
        }
    }
    /**
   * Fires the dismiss event
   */ dismiss(options) {
        const { defaultPrevented } = this.marketDialogDismissed.emit({
            dialog: this.el,
            type: this.type,
            origin: (options === null || options === void 0 ? void 0 : options.origin) || this.el
        });
        if (!defaultPrevented) {
            this.hidden = true;
            /**
       * Emit a marketDialogDidDismiss event when modal gets fully dismissed (after animation).
       */ setTimeout(()=>{
                this.marketDialogDidDismiss.emit({
                    dialog: this.el,
                    type: this.type,
                    origin: this.el
                });
            }, this.animationExitDuration);
        }
        return Promise.resolve();
    }
    onTrapFocusChanged(newValue, oldValue) {
        // only activate/deactivate when the `trapFocus` prop value changes
        if (newValue !== oldValue) {
            if (newValue) this.activateFocusTrap();
            else this.deactivateFocusTrap();
        }
    }
    /**
   * Activates the focus trap
   * @param {Object} [options] [focus-trap `.createFocusTrap` options](https://github.com/focus-trap/focus-trap#createoptions)
   * @param {Object} [activateOptions] [focus-trap `.activate` options](https://github.com/focus-trap/focus-trap#trapactivate)
   */ activateFocusTrap(options, activateOptions) {
        if (this.focusTrap) {
            this.focusTrap.activate(activateOptions);
            if (!this.trapFocus) this.trapFocus = true;
        } else this.focusTrap = createAndActivateFocusTrap(this.el, options, activateOptions);
        this.focusTrapActivateOptions = activateOptions;
        return Promise.resolve();
    }
    /**
   * Deactivates the focus trap
   * @param {Object} [deactivateOptions] [focus-trap `.deactivate` options](https://github.com/focus-trap/focus-trap#trapdeactivate)
   */ deactivateFocusTrap(deactivateOptions) {
        if (this.focusTrap) {
            this.focusTrap.deactivate(deactivateOptions);
            this.focusTrap = undefined;
        }
        return Promise.resolve();
    }
    handleDefaultSlotChange() {
        this.repositionHeader();
    }
    initContentObserver() {
        if (!this.observers.content) {
            this.observers.content = new MutationObserver(async (mutations)=>{
                if (this.trapFocus && this.focusTrap) {
                    this.focusTrap.deactivate();
                    await waitForAddedNodesToBeReady(mutations);
                    this.focusTrap.activate(this.focusTrapActivateOptions);
                }
            });
            this.observers.content.observe(this.el, {
                childList: true,
                subtree: true
            });
        }
    }
    connectedCallback() {
        this.connectedCallbackTimeout = setTimeout(()=>{
            /**
       * Emit a dialogLoaded event when the component connects. Need this so
       * the context manager isn't rummaging around it's DOM to try and find the
       * dialog that was just appended
       */ this.marketDialogLoaded.emit({
                dialog: this.el,
                type: this.type
            });
            if (this.trapFocus) this.activateFocusTrap();
        }, this.animationEnterDuration);
    }
    componentWillLoad() {
        setupDialogCompactHandler(this.el);
    }
    componentDidLoad() {
        this.initContentObserver();
    }
    disconnectedCallback() {
        this.deactivateFocusTrap();
        /**
     * Prevents error caused by race conditions during rapid mounting and
     * unmounting of component by clearing the setTimeout from connectedCallback
     * if it gets called after disconnectedCallback.
     */ clearTimeout(this.connectedCallbackTimeout);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-modal-full",
            role: "dialog"
        }, (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.handleDefaultSlotChange()
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "layout": [
                "layoutWatcher"
            ],
            "trapFocus": [
                "onTrapFocusChanged"
            ]
        };
    }
    static get style() {
        return marketModalFullCss;
    }
};
const marketModalPartialCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}@keyframes market-popup{from{opacity:0;transform:scale(0.9, 0.9)}to{opacity:1;transform:scale(1, 1)}}@keyframes market-popdown{from{opacity:1;transform:scale(1, 1)}to{opacity:0;transform:scale(0.9, 0.9)}}@keyframes market-slideup{from{opacity:0;transform:translateY(80vh)}to{opacity:1;transform:translateY(0)}}@keyframes market-slidedown{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(80vh)}}@keyframes market-slide-left-enter{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes market-slide-left-exit{from{transform:translateX(0)}to{transform:translateX(100%)}}@keyframes market-fade-in{from{opacity:0}to{opacity:1}}@keyframes market-fade-out{from{opacity:1}to{opacity:0}}@keyframes market-input-autofill-start{from{}to{}}@keyframes market-input-autofill-cancel{from{}to{}}@keyframes market-input-search-compact-enter{from{}to{}}@keyframes market-input-search-compact-exit{from{}to{}}:host{display:flex;flex-direction:column;justify-content:stretch;overflow:hidden}:host ::slotted(main){flex:0 1 100%;overflow-y:auto;height:100%}:host ::slotted(.market-header){margin-bottom:var(--core-metrics-spacing-300);padding-top:0}:host ::slotted(.market-footer){padding-bottom:0}:host{position:absolute;top:0;left:0;width:100%;height:100%;padding-top:var(--modal-full-vertical-padding-size);padding-bottom:var(--modal-full-vertical-padding-size);background-color:var(--modal-full-background-color);animation:var(--modal-full-animation-enter-transition-duration)\n    market-slideup\n    forwards\n    var(--modal-full-animation-enter-transition-easing)}:host ::slotted(*){padding-right:var(--modal-full-horizontal-padding-size);padding-left:var(--modal-full-horizontal-padding-size)}:host([hidden]){animation-name:market-slidedown;animation-duration:var(--modal-full-animation-exit-transition-duration);animation-timing-function:var(--modal-full-animation-exit-transition-easing)}@media (min-width: 800px){:host{top:0;left:auto;width:var(--modal-partial-width);height:auto;max-height:calc(100vh - var(--modal-partial-vertical-screen-buffer-size) * 2);padding-top:var(--modal-partial-vertical-padding-size);padding-bottom:var(--modal-partial-vertical-padding-size);border-radius:var(--modal-partial-border-radius);animation:var(--modal-partial-animation-enter-transition-duration)\n      market-popup\n      forwards\n      var(--modal-partial-animation-enter-transition-easing)}:host ::slotted(*){padding-right:var(--modal-partial-horizontal-padding-size);padding-left:var(--modal-partial-horizontal-padding-size)}:host([hidden]){animation-name:market-popdown;animation-duration:var(--modal-partial-animation-exit-transition-duration);animation-timing-function:var(--modal-partial-animation-exit-transition-easing)}}";
const MarketModalPartial$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketDialogLoaded = (0, $696Z8.createEvent)(this, "marketDialogLoaded", 7);
        this.marketDialogDismissed = (0, $696Z8.createEvent)(this, "marketDialogDismissed", 7);
        this.marketDialogDidDismiss = (0, $696Z8.createEvent)(this, "marketDialogDidDismiss", 7);
        this.type = 'modal-partial';
        this.observers = {};
        this.hidden = false;
        this.dialogID = undefined;
        this.index = undefined;
        this.trapFocus = false;
        this.animationEnterDuration = cjs.MODAL_PARTIAL_ANIMATION_ENTER_TRANSITION_DURATION;
        this.animationExitDuration = cjs.MODAL_PARTIAL_ANIMATION_EXIT_TRANSITION_DURATION;
    }
    /* Listen to the headerNavigate event emitted by a market-header child component
  so we can emit a close event if needed */ headerNavigateEventHandler(event) {
        const { detail, target } = event;
        // TODO: 'close' should probably come from an enum of some sort
        if (detail.action === 'close') // only dismiss if this is the first ancestor dialog
        {
            if (target.closest(getDialogSelector()) === this.el) this.dismiss();
        }
    }
    /* The parent context will handle actually removing elements from the DOM,
  All the modal needs to do it emit an event so actually closing it can be
  some other elements problem */ /**
   * Fires the dismiss event
   */ dismiss(options) {
        const { defaultPrevented } = this.marketDialogDismissed.emit({
            dialog: this.el,
            type: this.type,
            origin: (options === null || options === void 0 ? void 0 : options.origin) || this.el
        });
        if (!defaultPrevented) {
            this.hidden = true;
            /**
       * Emit a marketDialogDidDismiss event when modal gets fully dismissed (after animation).
       */ setTimeout(()=>{
                this.marketDialogDidDismiss.emit({
                    dialog: this.el,
                    type: this.type,
                    origin: this.el
                });
            }, this.animationExitDuration);
        }
        return Promise.resolve();
    }
    onTrapFocusChanged(newValue, oldValue) {
        if (newValue !== oldValue) {
            if (newValue) this.activateFocusTrap();
            else this.deactivateFocusTrap();
        }
    }
    /**
   * Activates the focus trap
   * @param {Object} [options] [focus-trap `.createFocusTrap` options](https://github.com/focus-trap/focus-trap#createoptions)
   * @param {Object} [activateOptions] [focus-trap `.activate` options](https://github.com/focus-trap/focus-trap#trapactivate)
   */ activateFocusTrap(options, activateOptions) {
        if (this.focusTrap) {
            this.focusTrap.activate(activateOptions);
            if (!this.trapFocus) this.trapFocus = true;
        } else this.focusTrap = createAndActivateFocusTrap(this.el, options, activateOptions);
        this.focusTrapActivateOptions = activateOptions;
        return Promise.resolve();
    }
    /**
   * Deactivates the focus trap
   * @param {Object} [deactivateOptions] [focus-trap `.deactivate` options](https://github.com/focus-trap/focus-trap#trapdeactivate)
   */ deactivateFocusTrap(deactivateOptions) {
        if (this.focusTrap) {
            this.focusTrap.deactivate(deactivateOptions);
            this.focusTrap = undefined;
        }
        return Promise.resolve();
    }
    initContentObserver() {
        if (!this.observers.content) {
            this.observers.content = new MutationObserver(async (mutations)=>{
                if (this.trapFocus && this.focusTrap) {
                    this.focusTrap.deactivate();
                    await waitForAddedNodesToBeReady(mutations);
                    this.focusTrap.activate(this.focusTrapActivateOptions);
                }
            });
            this.observers.content.observe(this.el, {
                childList: true,
                subtree: true
            });
        }
    }
    connectedCallback() {
        this.connectedCallbackTimeout = setTimeout(()=>{
            /**
       * Emit a dialogLoaded event when the component connects. Need this so
       * the context manager isn't rummaging around it's DOM to try and find the
       * dialog that was just appended
       */ this.marketDialogLoaded.emit({
                dialog: this.el,
                type: this.type
            });
            if (this.trapFocus) this.activateFocusTrap();
        }, this.animationEnterDuration);
    }
    componentWillLoad() {
        setupDialogCompactHandler(this.el);
    }
    componentDidLoad() {
        this.initContentObserver();
    }
    disconnectedCallback() {
        this.deactivateFocusTrap();
        /**
     * Prevents error caused by race conditions during rapid mounting and
     * unmounting of component by clearing the setTimeout from connectedCallback
     * if it gets called after disconnectedCallback.
     */ clearTimeout(this.connectedCallbackTimeout);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-modal-partial",
            role: "dialog"
        }, (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "trapFocus": [
                "onTrapFocusChanged"
            ]
        };
    }
    static get style() {
        return marketModalPartialCss;
    }
};
const marketPaginationCss = ":host{display:flex;flex-direction:column;align-items:stretch}.market-button-dropdown{display:flex;flex-direction:column;align-items:stretch}.market-button-dropdown market-filter-button{display:block}.market-pagination-page-size+.market-pagination-nav{margin-top:var(--pagination-nav-vertical-margin, var(--core-metrics-spacing-200))}@media only screen and (min-width: 600px){.market-pagination-page-size+.market-pagination-nav{margin-top:0;margin-left:var(--pagination-nav-horizontal-margin, var(--core-metrics-spacing-100))}}.market-pagination-nav nav{display:flex;justify-content:space-between;-moz-column-gap:var(--pagination-nav-content-spacing, var(--core-metrics-spacing-100));column-gap:var(--pagination-nav-content-spacing, var(--core-metrics-spacing-100))}.market-pagination-nav nav market-button-dropdown{flex-grow:1}@media only screen and (min-width: 600px){:host{flex-direction:row;justify-content:space-between}.market-pagination-nav:only-child{margin-left:auto}}";
const MarketPagination$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketPaginationPageSizeChange = (0, $696Z8.createEvent)(this, "marketPaginationPageSizeChange", 7);
        this.marketPaginationNavigation = (0, $696Z8.createEvent)(this, "marketPaginationNavigation", 7);
        this.currentPage = undefined;
        this.totalPages = undefined;
        this.hasNextPage = undefined;
        this.hasPreviousPage = undefined;
        this.pageSize = undefined;
        this.pageSizeOptions = undefined;
    }
    /**
   * Rebroadcast up events from market-pagination-page-size.
   */ changePageSize(e) {
        e.stopPropagation();
        const { detail } = e;
        this.marketPaginationPageSizeChange.emit(detail);
    }
    /**
   * Rebroadcast up events from market-pagination-nav.
   */ navigatePage(e) {
        e.stopPropagation();
        const { detail } = e;
        this.marketPaginationNavigation.emit(detail);
    }
    render() {
        const MarketPaginationPageSizeTagName = getNamespacedTagFor('market-pagination-page-size');
        const MarketPaginationNavTagName = getNamespacedTagFor('market-pagination-nav');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-pagination"
        }, this.pageSizeOptions && (0, $696Z8.h)(MarketPaginationPageSizeTagName, {
            value: this.pageSize,
            pageSizeOptions: this.pageSizeOptions
        }, (0, $696Z8.h)("slot", {
            name: "page-size-label",
            slot: "page-size-label"
        }, "Results per page"), (0, $696Z8.h)("slot", {
            name: "page-size-feedback",
            slot: "page-size-feedback"
        }, this.pageSize)), (0, $696Z8.h)(MarketPaginationNavTagName, {
            currentPage: this.currentPage,
            totalPages: this.totalPages,
            pageSize: this.pageSize,
            hasNextPage: this.hasNextPage,
            hasPreviousPage: this.hasPreviousPage
        }, (0, $696Z8.h)("slot", {
            name: "nav-label",
            slot: "nav-label"
        }, "Page"), (0, $696Z8.h)("slot", {
            name: "nav-feedback",
            slot: "nav-feedback"
        }, this.currentPage, " of ", this.totalPages)));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketPaginationCss;
    }
};
const MarketPaginationNav$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.marketInternalPaginationNavigation = (0, $696Z8.createEvent)(this, "marketInternalPaginationNavigation", 7);
        this.currentPage = undefined;
        this.totalPages = undefined;
        this.hasNextPage = undefined;
        this.hasPreviousPage = undefined;
        this.pageSize = undefined;
    }
    listSelectionEventHandler(e) {
        const { newSelectionValue } = e.detail;
        this.marketInternalPaginationNavigation.emit({
            page: newSelectionValue,
            prevPage: `${this.currentPage}`,
            pageSize: this.pageSize
        });
    }
    handlePrev() {
        if (this.hasPreviousPage === false || this.currentPage === 1) return;
        const prevPage = this.currentPage - 1;
        this.marketInternalPaginationNavigation.emit({
            page: `${prevPage}`,
            prevPage: `${this.currentPage}`,
            pageSize: this.pageSize
        });
    }
    handleNext() {
        if (this.hasNextPage === false || Boolean(this.totalPages) && this.currentPage === this.totalPages) return;
        const nextPage = this.currentPage + 1;
        this.marketInternalPaginationNavigation.emit({
            page: `${nextPage}`,
            prevPage: `${this.currentPage}`,
            pageSize: this.pageSize
        });
    }
    render() {
        // Don't render page info when totalPages is missing or set to 0
        const renderPageInfo = Boolean(this.totalPages);
        const hasPreviousPage = this.currentPage > 1 || this.hasPreviousPage;
        const hasNextPage = this.currentPage < this.totalPages || this.hasNextPage;
        // Dropdown navigates by every 10 pages if there are more than 20 pages
        const isLargeDataset = this.totalPages > 20;
        const largeDatasetSteps = 10;
        // pageList for a large dataset = [10, 20, 30, 40, 50...]
        // pageList for a small dataset = [1, 2, 3, 5, 6, 7...]
        const pageList = isLargeDataset ? Array.from({
            length: Math.floor(this.totalPages / largeDatasetSteps)
        }).map((_, i)=>(i + 1) * largeDatasetSteps) : Array.from({
            length: this.totalPages
        }).map((_, i)=>i + 1);
        const MarketButtonTagName = getNamespacedTagFor('market-button');
        const MarketButtonDropdownTagName = getNamespacedTagFor('market-button-dropdown');
        const MarketFilterButtonTagName = getNamespacedTagFor('market-filter-button');
        const MarketListTagName = getNamespacedTagFor('market-list');
        const MarketRowTagName = getNamespacedTagFor('market-row');
        const MarketAccessoryTagName = getNamespacedTagFor('market-accessory');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-pagination-nav"
        }, (0, $696Z8.h)("nav", null, (0, $696Z8.h)(MarketButtonTagName, {
            size: "small",
            disabled: !hasPreviousPage,
            onClick: ()=>this.handlePrev()
        }, (0, $696Z8.h)(MarketAccessoryTagName, {
            slot: "icon"
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M4.29289 11.293C3.90237 11.6835 3.90237 12.3167 4.29289 12.7072L11.2929 19.7072L12.7071 18.293L7.41421 13.0001L19 13.0001V11.0001L7.41421 11.0001L12.7071 5.70718L11.2929 4.29297L4.29289 11.293Z"
        })))), renderPageInfo && (0, $696Z8.h)(MarketButtonDropdownTagName, {
            "no-caret": true,
            "popover-placement": "bottom-end",
            "persist-list": true
        }, (0, $696Z8.h)(MarketFilterButtonTagName, {
            size: "small",
            slot: "trigger"
        }, (0, $696Z8.h)("span", null, (0, $696Z8.h)("slot", {
            name: "nav-label"
        }, "Page")), (0, $696Z8.h)("span", {
            slot: "feedback"
        }, (0, $696Z8.h)("slot", {
            name: "nav-feedback"
        }, this.currentPage, " of ", this.totalPages))), (0, $696Z8.h)(MarketListTagName, {
            value: `${this.currentPage}`,
            slot: "content"
        }, pageList.map((pageNum)=>(0, $696Z8.h)(MarketRowTagName, {
                key: `pageNav_${pageNum}`,
                value: `${pageNum}`
            }, pageNum)))), (0, $696Z8.h)(MarketButtonTagName, {
            size: "small",
            disabled: !hasNextPage,
            onClick: ()=>this.handleNext()
        }, (0, $696Z8.h)(MarketAccessoryTagName, {
            slot: "icon"
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M19.7071 11.293C20.0976 11.6835 20.0976 12.3167 19.7071 12.7072L12.7071 19.7072L11.2929 18.293L16.5858 13.0001L5 13.0001L5 11.0001L16.5858 11.0001L11.2929 5.70718L12.7071 4.29297L19.7071 11.293Z"
        }))))));
    }
    get el() {
        return this;
    }
};
const MarketPaginationPageSize$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.marketInternalPaginationPageSizeChange = (0, $696Z8.createEvent)(this, "marketInternalPaginationPageSizeChange", 7);
        this.value = undefined;
        this.pageSizeOptions = undefined;
    }
    listSelectionEventHander(e) {
        const { newSelectionValue } = e.detail;
        this.marketInternalPaginationPageSizeChange.emit({
            value: newSelectionValue
        });
    }
    render() {
        const MarketButtonDropdownTagName = getNamespacedTagFor('market-button-dropdown');
        const MarketFilterButtonTagName = getNamespacedTagFor('market-filter-button');
        const MarketListTagName = getNamespacedTagFor('market-list');
        const MarketRowTagName = getNamespacedTagFor('market-row');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-pagination-page-size"
        }, (0, $696Z8.h)(MarketButtonDropdownTagName, {
            "no-caret": true,
            "popover-placement": "bottom-start",
            "persist-list": true
        }, (0, $696Z8.h)(MarketFilterButtonTagName, {
            size: "small",
            slot: "trigger"
        }, (0, $696Z8.h)("span", null, (0, $696Z8.h)("slot", {
            name: "page-size-label"
        }, "Results per page")), (0, $696Z8.h)("span", {
            slot: "feedback"
        }, (0, $696Z8.h)("slot", {
            name: "page-size-feedback"
        }, this.value))), (0, $696Z8.h)(MarketListTagName, {
            value: this.value,
            slot: "content"
        }, this.pageSizeOptions.split(',').map((v)=>(0, $696Z8.h)(MarketRowTagName, {
                key: `pageSize_${v}`,
                value: v
            }, v)))));
    }
    get el() {
        return this;
    }
};
const marketPillCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:inline-flex;justify-content:center;align-items:center;border-radius:var(--pill-normal-size-corner-radius);white-space:nowrap}:host svg,:host ::slotted([slot='icon']){color:inherit;fill:currentColor;stroke:inherit}:host([interactive]){cursor:pointer}:host([size=\"medium\"]){gap:var(--pill-normal-size-spacing-horizontal);padding:var(--pill-normal-size-padding-vertical-size) var(--pill-normal-size-padding-horizontal-size);font-weight:var(--pill-normal-size-text-weight);font-size:var(--pill-normal-size-text-size);line-height:var(--pill-normal-size-text-leading);letter-spacing:var(--pill-normal-size-text-tracking)}:host([size=\"small\"]){gap:var(--pill-compact-size-spacing-horizontal);padding:var(--pill-compact-size-padding-vertical-size) var(--pill-compact-size-padding-horizontal-size);font-weight:var(--pill-compact-size-text-weight);font-size:var(--pill-compact-size-text-size);line-height:var(--pill-compact-size-text-leading);letter-spacing:var(--pill-compact-size-text-tracking)}:host([variant=\"normal\"]){background-color:var(--pill-normal-variant-background-color);color:var(--pill-normal-variant-text-color)}:host([variant=\"emphasis\"]){background-color:var(--pill-emphasis-variant-background-color);color:var(--pill-emphasis-variant-text-color)}:host([variant=\"success\"]){background-color:var(--pill-success-variant-background-color);color:var(--pill-success-variant-text-color)}:host([variant=\"warning\"]){background-color:var(--pill-warning-variant-background-color);color:var(--pill-warning-variant-text-color)}:host([variant=\"critical\"]){background-color:var(--pill-critical-variant-background-color);color:var(--pill-critical-variant-text-color)}:host([variant=\"insight\"]){background-color:var(--pill-insight-variant-background-color);color:var(--pill-insight-variant-text-color)}:host([variant=\"alpha\"]){background-color:var(--pill-alpha-variant-background-color);color:var(--pill-alpha-variant-text-color)}:host([variant=\"beta\"]){background-color:var(--pill-beta-variant-background-color);color:var(--pill-beta-variant-text-color)}@media (hover: hover){:host([variant='normal'][interactive]:hover){background-color:var(--pill-normal-variant-pressed-state-background-color)}:host([variant='emphasis'][interactive]:hover){background-color:var(--pill-emphasis-variant-pressed-state-background-color)}:host([variant=\"success\"][interactive]:hover){background-color:var(--pill-success-variant-pressed-state-background-color)}:host([variant=\"warning\"][interactive]:hover){background-color:var(--pill-warning-variant-pressed-state-background-color)}:host([variant=\"critical\"][interactive]:hover){background-color:var(--pill-critical-variant-pressed-state-background-color)}:host([variant=\"insight\"][interactive]:hover){background-color:var(--pill-insight-variant-pressed-state-background-color)}:host([variant=\"alpha\"][interactive]:hover){background-color:var(--pill-alpha-variant-pressed-state-background-color)}:host([variant=\"beta\"][interactive]:hover){background-color:var(--pill-beta-variant-pressed-state-background-color)}}:host([variant='normal'][interactive]:active){background-color:var(--pill-normal-variant-pressed-state-background-color)}:host([variant='emphasis'][interactive]:active){background-color:var(--pill-emphasis-variant-pressed-state-background-color)}:host([variant=\"success\"][interactive]:active){background-color:var(--pill-success-variant-pressed-state-background-color)}:host([variant=\"warning\"][interactive]:active){background-color:var(--pill-warning-variant-pressed-state-background-color)}:host([variant=\"critical\"][interactive]:active){background-color:var(--pill-critical-variant-pressed-state-background-color)}:host([variant=\"insight\"][interactive]:active){background-color:var(--pill-insight-variant-pressed-state-background-color)}:host([variant=\"alpha\"][interactive]:active){background-color:var(--pill-alpha-variant-pressed-state-background-color)}:host([variant=\"beta\"][interactive]:active){background-color:var(--pill-beta-variant-pressed-state-background-color)}";
const MarketPill$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.variant = 'normal';
        this.size = 'medium';
        this.indicator = false;
        this.interactive = false;
        this.role = undefined;
    }
    renderIndicator() {
        const MarketAccessoryTag = getNamespacedTagFor('market-accessory');
        return this.size === 'medium' ? (0, $696Z8.h)(MarketAccessoryTag, null, (0, $696Z8.h)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("circle", {
            cx: "8",
            cy: "8",
            r: "5"
        }))) : (0, $696Z8.h)(MarketAccessoryTag, null, (0, $696Z8.h)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("circle", {
            cx: "8",
            cy: "8",
            r: "4"
        })));
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-pill"
        }, (0, $696Z8.h)("slot", {
            name: "icon"
        }, this.indicator && this.renderIndicator()), (0, $696Z8.h)("slot", null));
    }
    static get style() {
        return marketPillCss;
    }
};
const marketPopoverCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:inline-block;overflow-y:auto;min-width:var(--popover-min-width, 200px);max-height:var(--popover-max-height, 464px);padding:var(--modal-popover-wide-viewport-padding-right-size)\n    var(--modal-popover-wide-viewport-padding-right-size)\n    var(--modal-popover-wide-viewport-padding-right-size)\n    var(--modal-popover-wide-viewport-padding-left-size);border-radius:var(--modal-popover-border-radius);background-color:var(--modal-popover-background-color);box-shadow:0 2px 16px rgb(0 0 0 / 0.08), 0 4px 8px rgb(0 0 0 / 0.08)}@media (min-width: 600px){:host{width:auto}}::slotted(.market-list){display:block;width:100%;height:100%;margin-bottom:calc(var(--popover-content-vertical-padding, 8px) - var(--popover-padding, 24px))}::slotted(.market-list:not([has-search])){margin:calc(var(--popover-content-vertical-padding, 8px) - var(--popover-padding, 24px)) 0}";
const Popover = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    /* Don't want to force consumers to have to remember to put 'interactive' attribute
    on a <market-list> slotted into this options list, so just set the property on the child
    element here because lists should always be interactive when inside this component */ initInteractiveList() {
        /* We could just do el.querySelectorAll('market-list') here, but to handle elements that may be multi-slotted
    such as when using this popover inside of a select/filterable element and forwarding the slotted contents into
    the popover, we need to use this assignedElements() method */ const slot = this.el.querySelector('slot');
        let lists;
        if (slot) lists = slot.assignedElements().filter((el)=>el.localName === getNamespacedTagFor('market-list'));
        else /* .querySelectorAll() returns a NodeList and not an array so we need to convert it
       in order to use .map() below */ lists = [].slice.call(this.el.querySelectorAll(getNamespacedTagFor('market-list')));
        if (lists) lists.forEach((list)=>{
            list.interactive = true;
        });
    }
    render() {
        this.initInteractiveList();
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-popover"
        }, (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketPopoverCss;
    }
};
const marketProgressTrackerCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:contents}:host>ol{display:flex;flex-direction:column;margin:0;padding:0;list-style:none}";
const MarketProgressTracker$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.currentStepIndex = undefined;
        this.completedSteps = undefined;
        this.size = undefined;
        this.variant = undefined;
        this.indicator = undefined;
        this.reversed = false;
        this.barless = false;
    }
    setStepProps() {
        var _a, _b;
        const { barless, completedSteps, currentStepIndex, el, indicator, size, reversed, variant } = this;
        const stepEls = [
            ...el.querySelectorAll(getNamespacedTagFor('market-progress-tracker-step'))
        ];
        if (!(stepEls === null || stepEls === void 0 ? void 0 : stepEls.length)) return;
        const currentIndex = (_a = currentStepIndex !== null && currentStepIndex !== void 0 ? currentStepIndex : completedSteps) !== null && _a !== void 0 ? _a : -1;
        (_b = reversed ? [
            ...stepEls
        ].reverse() : stepEls) === null || _b === void 0 || _b.forEach((stepEl, index)=>{
            stepEl.size = size !== null && size !== void 0 ? size : stepEl.size;
            if (variant !== null && variant !== void 0 ? variant : indicator) stepEl.indicator = variant !== null && variant !== void 0 ? variant : indicator;
            const isCompleted = index < currentIndex;
            const isActive = index === currentIndex;
            stepEl.completed = isCompleted;
            stepEl.active = isActive;
            if (isCompleted || isActive && reversed) stepEl.bar = 'active';
            else stepEl.bar = 'inactive';
        });
        // remove bar if barless or last step
        stepEls.forEach((stepEl, index)=>{
            if (barless || index + 1 === stepEls.length) stepEl.bar = 'hidden';
        });
    }
    handleDefaultSlotChange() {
        this.setStepProps();
    }
    connectedCallback() {
        this.handleDefaultSlotChange();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-progress-tracker"
        }, (0, $696Z8.h)("ol", null, (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.handleDefaultSlotChange()
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketProgressTrackerCss;
    }
};
const checkedIcon = ()=>(0, $696Z8.h)("svg", {
        part: "icon",
        class: "default-icon checked-icon",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $696Z8.h)("path", {
        d: "M5.88683 7.62327L5.71005 7.4465L5.53327 7.62327L4.12327 9.03327L3.9465 9.21005L4.12327 9.38683L7.12327 12.3868C7.37411 12.6377 7.68955 12.75 8.01005 12.75C8.33627 12.75 8.64735 12.6239 8.89224 12.3913L8.89229 12.3914L8.89683 12.3868L13.8968 7.38683L14.0736 7.21005L13.8968 7.03327L12.4868 5.62327L12.3105 5.44691L12.1337 5.62286L8.00046 9.73691L5.88683 7.62327ZM0.25 9C0.25 4.16807 4.16807 0.25 9 0.25C13.8319 0.25 17.75 4.16807 17.75 9C17.75 13.8319 13.8319 17.75 9 17.75C4.16807 17.75 0.25 13.8319 0.25 9Z"
    }));
const uncheckedIcon = ()=>(0, $696Z8.h)("svg", {
        part: "icon",
        class: "default-icon unchecked-icon",
        width: "18",
        height: "18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $696Z8.h)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
    }));
const currentCircleIcon = ()=>(0, $696Z8.h)("svg", {
        part: "icon",
        class: "default-icon current-circle-icon",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $696Z8.h)("circle", {
        cx: "9",
        cy: "9",
        r: "7",
        "stroke-width": "4"
    }));
const nonCurrentCircleIcon = ()=>(0, $696Z8.h)("svg", {
        part: "icon",
        class: "default-icon non-current-circle-icon",
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $696Z8.h)("path", {
        d: "M0 4a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }));
const marketProgressTrackerStepCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}::slotted([slot=\"label\"]){font-weight:var(--core-type-heading-20-weight);font-size:var(--core-type-heading-20-size);font-family:var(--core-type-heading-20-font-family);line-height:var(--core-type-heading-20-leading);letter-spacing:var(--core-type-heading-20-tracking);text-transform:var(--core-type-heading-20-case)}::slotted([slot=\"error\"]){font-weight:var(--core-type-paragraph-20-weight);font-size:var(--core-type-paragraph-20-size);font-family:var(--core-type-paragraph-20-font-family);line-height:var(--core-type-paragraph-20-leading);letter-spacing:var(--core-type-paragraph-20-tracking);text-transform:var(--core-type-paragraph-20-case)}::slotted([slot=\"error\"]) b,::slotted([slot=\"error\"]) strong{font-weight:var(--core-type-semibold-20-weight)}::slotted([slot=\"subtext\"]){font-weight:var(--core-type-paragraph-10-weight);font-size:var(--core-type-paragraph-10-size);font-family:var(--core-type-paragraph-10-font-family);line-height:var(--core-type-paragraph-10-leading);letter-spacing:var(--core-type-paragraph-10-tracking);text-transform:var(--core-type-paragraph-10-case)}::slotted([slot=\"subtext\"]) b,::slotted([slot=\"subtext\"]) strong{font-weight:var(--core-type-semibold-10-weight)}:host([size=\"small\"]) ::slotted([slot=\"label\"]){font-weight:var(--core-type-medium-20-weight);font-size:var(--core-type-medium-20-size);font-family:var(--core-type-medium-20-font-family);line-height:var(--core-type-medium-20-leading);letter-spacing:var(--core-type-medium-20-tracking);text-transform:var(--core-type-medium-20-case)}:host([size=\"medium\"]) ::slotted([slot=\"label\"]){font-weight:var(--core-type-semibold-30-weight);font-size:var(--core-type-semibold-30-size);font-family:var(--core-type-semibold-30-font-family);line-height:var(--core-type-semibold-30-leading);letter-spacing:var(--core-type-semibold-30-tracking);text-transform:var(--core-type-semibold-30-case)}:host{display:contents}:host>li{display:flex;gap:var(--core-metrics-spacing-200)}.indicator{display:flex;flex-direction:column;align-items:center}.indicator [part=\"icon\"]{margin:var(--core-metrics-spacing-25) 0}.indicator ::slotted([slot=\"icon\"]){fill:inherit;stroke:inherit}.indicator:not(.completed):not(.active){fill:var(--progress-tracker-bar-incomplete-value-color, var(--core-fill-20-color))}.indicator:not(.completed):not(.active) .default-icon.checked-icon,.indicator:not(.completed):not(.active) .default-icon.unchecked-icon,.indicator:not(.completed):not(.active) .default-icon.non-current-circle-icon{fill:var(--progress-tracker-bar-incomplete-value-color, var(--core-fill-20-color));stroke:none}.indicator:not(.completed):not(.active) .default-icon.current-circle-icon{fill:none;stroke:var(--progress-tracker-bar-incomplete-value-color, var(--core-fill-20-color))}.indicator.active{fill:var(--progress-tracker-step-active-icon-color, var(--core-blue-fill-color))}.indicator.active .default-icon.checked-icon,.indicator.active .default-icon.unchecked-icon,.indicator.active .default-icon.non-current-circle-icon{fill:var(--progress-tracker-bar-active-value-color, var(--core-blue-fill-color));stroke:none}.indicator.active .default-icon.current-circle-icon{fill:none;stroke:var(--progress-tracker-bar-active-value-color, var(--core-blue-fill-color))}.indicator.completed{fill:var(--progress-tracker-step-completed-icon-color, var(--core-blue-fill-color))}.indicator.completed .default-icon.checked-icon,.indicator.completed .default-icon.unchecked-icon,.indicator.completed .default-icon.non-current-circle-icon{fill:var(--progress-tracker-bar-completed-value-color, var(--core-blue-fill-color));stroke:none}.indicator.completed .default-icon.current-circle-icon{fill:none;stroke:var(--progress-tracker-bar-completed-value-color, var(--core-blue-fill-color))}.indicator [part=\"bar\"]{display:none;flex:1;width:var(--progress-tracker-step-bar-size, 2px)}.indicator [part=\"bar\"].hidden{display:none}.indicator [part=\"bar\"].inactive{display:unset;background-color:var(--progress-tracker-step-bar-color, var(--core-fill-20-color))}.indicator [part=\"bar\"].active{display:unset;background-color:var(--progress-tracker-step-completed-bar-color, var(--core-blue-fill-color))}[part=\"content\"]{display:flex;flex-direction:column;gap:var(--core-metrics-spacing-25);align-items:flex-start;padding-top:var(--core-metrics-spacing-25);padding-bottom:var(--progress-tracker-step-padding-bottom-size, var(--core-metrics-spacing-200))}[part=\"content\"] ::slotted(p:first-of-type){margin-top:0}[part=\"content\"] ::slotted(p:last-of-type){margin-bottom:0}:host([size=\"large\"]) [part=\"content\"]{padding-top:unset}:host([size=\"small\"]) ::slotted([slot=\"label\"]),:host([size=\"medium\"]) ::slotted([slot=\"label\"]),:host([size=\"large\"]) ::slotted([slot=\"label\"]){color:var(--core-text-10-color)}:host([size=\"small\"]) ::slotted([slot=\"subtext\"]),:host([size=\"medium\"]) ::slotted([slot=\"subtext\"]),:host([size=\"large\"]) ::slotted([slot=\"subtext\"]){color:var(--core-text-20-color)}:host([size=\"small\"]) ::slotted([slot=\"label\"]),:host([size=\"small\"]) ::slotted([slot=\"subtext\"]),:host([size=\"medium\"]) ::slotted([slot=\"label\"]),:host([size=\"medium\"]) ::slotted([slot=\"subtext\"]),:host([size=\"large\"]) ::slotted([slot=\"label\"]),:host([size=\"large\"]) ::slotted([slot=\"subtext\"]){margin:0}:host([size=\"small\"]) ::slotted([slot=\"error\"]),:host([size=\"medium\"]) ::slotted([slot=\"error\"]),:host([size=\"large\"]) ::slotted([slot=\"error\"]){color:var(--core-critical-text-color)}";
const MarketProgressTrackerStep$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.size = 'medium';
        this.variant = undefined;
        this.indicator = 'circle';
        this.completed = false;
        this.active = false;
        this.bar = 'hidden';
    }
    render() {
        const { active, bar, completed, el, indicator: _indicator, variant } = this;
        const MarketAccessoryTagName = getNamespacedTagFor('market-accessory');
        const indicator = variant !== null && variant !== void 0 ? variant : _indicator;
        const hasError = el.querySelector('[slot="error"]');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-progress-tracker-step",
            "has-error": hasError ? true : null
        }, (0, $696Z8.h)("li", null, (0, $696Z8.h)("div", {
            class: classNames('indicator', {
                active: active,
                completed: completed
            })
        }, (0, $696Z8.h)(MarketAccessoryTagName, {
            size: "icon",
            part: "icon"
        }, (0, $696Z8.h)("slot", {
            name: "icon"
        }, completed && indicator === 'check' && checkedIcon(), !completed && indicator === 'check' && uncheckedIcon(), active && indicator === 'circle' && currentCircleIcon(), !active && indicator === 'circle' && nonCurrentCircleIcon())), (0, $696Z8.h)("div", {
            class: bar,
            part: "bar"
        })), (0, $696Z8.h)("div", {
            part: "content"
        }, (0, $696Z8.h)("slot", {
            name: "label"
        }), (0, $696Z8.h)("slot", {
            name: "subtext"
        }), (0, $696Z8.h)("slot", {
            name: "error"
        }), (0, $696Z8.h)("slot", null))));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketProgressTrackerStepCss;
    }
};
const ALIGNMENT_PATTERN_LOCATIONS = Object.freeze([
    [],
    [
        4,
        16
    ],
    [
        4,
        20
    ],
    [
        4,
        24
    ],
    [
        4,
        28
    ],
    [
        4,
        32
    ],
    [
        4,
        20,
        36
    ],
    [
        4,
        22,
        40
    ],
    [
        4,
        24,
        44
    ],
    [
        4,
        26,
        48
    ],
    [
        4,
        28,
        52
    ],
    [
        4,
        30,
        56
    ],
    [
        4,
        32,
        60
    ],
    [
        4,
        24,
        44,
        64
    ],
    [
        4,
        24,
        46,
        68
    ],
    [
        4,
        24,
        48,
        72
    ],
    [
        4,
        28,
        52,
        76
    ],
    [
        4,
        28,
        54,
        80
    ],
    [
        4,
        28,
        56,
        84
    ],
    [
        4,
        32,
        60,
        88
    ],
    [
        4,
        26,
        48,
        70,
        92
    ],
    [
        4,
        24,
        48,
        72,
        96
    ],
    [
        4,
        28,
        52,
        76,
        100
    ],
    [
        4,
        26,
        52,
        78,
        104
    ],
    [
        4,
        30,
        56,
        82,
        108
    ],
    [
        4,
        28,
        56,
        84,
        112
    ],
    [
        4,
        32,
        60,
        88,
        116
    ],
    [
        4,
        24,
        48,
        72,
        96,
        120
    ],
    [
        4,
        28,
        52,
        76,
        100,
        124
    ],
    [
        4,
        24,
        50,
        76,
        102,
        128
    ],
    [
        4,
        28,
        54,
        80,
        106,
        132
    ],
    [
        4,
        32,
        58,
        84,
        110,
        136
    ],
    [
        4,
        28,
        56,
        84,
        112,
        140
    ],
    [
        4,
        32,
        60,
        88,
        116,
        144
    ],
    [
        4,
        28,
        52,
        76,
        100,
        124,
        148
    ],
    [
        4,
        22,
        48,
        74,
        100,
        126,
        152
    ],
    [
        4,
        26,
        52,
        78,
        104,
        130,
        156
    ],
    [
        4,
        30,
        56,
        82,
        108,
        134,
        160
    ],
    [
        4,
        24,
        52,
        80,
        108,
        136,
        164
    ],
    [
        4,
        28,
        56,
        84,
        112,
        140,
        168
    ]
]);
const DATA_CAPACITY = Object.freeze({
    LOW: [
        19,
        34,
        55,
        80,
        108,
        136,
        156,
        194,
        232,
        274,
        324,
        370,
        428,
        461,
        523,
        589,
        647,
        721,
        795,
        861,
        932,
        1006,
        1094,
        1174,
        1276,
        1370,
        1468,
        1531,
        1631,
        1735,
        1843,
        1955,
        2071,
        2191,
        2306,
        2434,
        2566,
        2702,
        2812,
        2956
    ],
    MEDIUM: [
        16,
        28,
        44,
        64,
        86,
        108,
        124,
        154,
        182,
        216,
        254,
        290,
        334,
        365,
        415,
        453,
        507,
        563,
        627,
        669,
        714,
        782,
        860,
        914,
        1000,
        1062,
        1128,
        1193,
        1267,
        1373,
        1455,
        1541,
        1631,
        1725,
        1812,
        1914,
        1992,
        2102,
        2216,
        2334
    ],
    QUARTER: [
        13,
        22,
        34,
        48,
        62,
        76,
        88,
        110,
        132,
        154,
        180,
        206,
        244,
        261,
        295,
        325,
        367,
        397,
        445,
        485,
        512,
        568,
        614,
        664,
        718,
        754,
        808,
        871,
        911,
        985,
        1033,
        1115,
        1171,
        1231,
        1286,
        1354,
        1426,
        1502,
        1582,
        1666
    ],
    HIGH: [
        9,
        16,
        26,
        36,
        46,
        60,
        66,
        86,
        100,
        122,
        140,
        158,
        180,
        197,
        223,
        253,
        283,
        313,
        341,
        385,
        406,
        442,
        464,
        514,
        538,
        596,
        628,
        661,
        701,
        745,
        793,
        845,
        901,
        961,
        986,
        1054,
        1096,
        1142,
        1222,
        1276
    ]
});
const ENCODING = Object.freeze({
    NUMERIC: 'NUMERIC',
    ALPHANUMERIC: 'ALPHANUMERIC',
    KANJI: 'KANJI',
    BYTE: 'BYTE'
});
const ERROR_CORRECTION = Object.freeze({
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    QUARTER: 'QUARTER',
    HIGH: 'HIGH'
});
/**
 * CLASS BitWriter
 * A internal class for writing bits to an Uint8Array for QRCode encoding.
 */ class BitWriter {
    constructor(length1){
        this.length = length1;
        this.content = new Uint8Array(length1);
        this.byte = 0;
        this.bit = 0;
    }
    get bitsLeft() {
        return (this.length - this.byte) * 8 - this.bit;
    }
    get bytesLeft() {
        return this.bit === 0 ? this.length - this.byte : this.length - this.byte - 1;
    }
    codeForAlphaNUMERICal(char) {
        const lookIn = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:';
        for(let index = 0; index < lookIn.length; index++){
            if (lookIn[index] === char) return index;
        }
    }
    completeByte() {
        if (this.bit === 0) return;
        this.bit = 0;
        this.byte++;
    }
    nextPutAlphaNUMERIC(string) {
        // Two ALPHANUMERICal characters at a time.
        for(let last = 1; last < string.length; last += 2)this.nextPutBits(this.codeForAlphaNUMERICal(string[last - 1]) * 45 + this.codeForAlphaNUMERICal(string[last]), 11);
        if (string.length % 2 === 1) this.nextPutBits(this.codeForAlphaNUMERICal(string[string.length - 1]), 6);
    }
    nextPutBits(int, bits) {
        if (bits === 0) return;
        let amount = this.bit + bits;
        if (amount < 8) {
            this.content[this.byte] = this.content[this.byte] | int << 8 - amount;
            this.bit += bits;
        } else if (amount === 8) {
            this.content[this.byte] = this.content[this.byte] | int;
            this.byte++;
            this.bit = 0;
        } else {
            amount -= 8;
            let shift = int >> amount;
            this.content[this.byte] = this.content[this.byte] | shift;
            shift = int - (shift << amount);
            this.byte++;
            this.bit = 0;
            this.nextPutBits(shift, amount);
        }
    }
    nextPutByte(byteArray) {
        byteArray.forEach((byte)=>{
            this.nextPutBits(byte, 8);
        });
    }
    nextPutCompleteByte(byte) {
        this.completeByte();
        this.content[this.byte] = byte;
        this.byte++;
    }
    nextPutKanji(string) {
        for(let index = 0; index < string.length; index++){
            let charCode = string.charCodeAt(index);
            if (charCode <= 0x9ffc) // in the range 0x8140 to 0x9FFC
            charCode -= 0x8140;
            else // in the range 0xE040 to 0xEBBF
            charCode -= 0xc140;
            let lByte = charCode % 256;
            let bByte = (charCode - lByte) / 256;
            this.nextPutBits(bByte * 0xc0 + lByte, 13);
        }
    }
    nextPutNumeric(string) {
        const asNumbers = [];
        for(let index = 0; index < string.length; index++)asNumbers.push(string.charCodeAt(index) - 48);
        // Three NUMERICal characters at a time.
        for(let last = 2; last < string.length; last += 3)this.nextPutBits(asNumbers[last - 2] * 100 + asNumbers[last - 1] * 10 + asNumbers[last], 10);
        switch(string.length % 3){
            case 0:
                break;
            case 1:
                this.nextPutBits(asNumbers[string.length - 1], 4);
                break;
            case 2:
                this.nextPutBits(asNumbers[string.length - 2] * 10 + asNumbers[string.length - 1], 7);
                break;
        }
    }
}
/**
 * CLASS Matrix
 * A class for manipulating a 2D array.
 */ class Matrix$1 {
    static withAll(width, height, fill) {
        const content = [];
        if (fill === undefined) for(let row = 0; row < height; row++)content.push(new Array(width));
        else for(let row = 0; row < height; row++)content.push(new Array(width).fill(fill));
        return new this(content);
    }
    constructor(content){
        this.content = content;
    }
    at(x, y) {
        return this.content[y][x];
    }
    copy() {
        return new this.constructor(this.content.map((row)=>row.slice()));
    }
    fill(x, y, width, height, value) {
        for(let top = y; top < y + height; top++){
            let row = this.content[top];
            for(let col = x; col < x + width; col++)row[col] = value;
        }
    }
    get height() {
        return this.content.length;
    }
    put(x, y, value) {
        return this.content[y][x] = value;
    }
    get width() {
        return this.content[0].length;
    }
}
/**
 * CLASS BooleanMatrix
 * A class for keeping and manipulating 2D boolean data.
 */ class BooleanMatrix extends Matrix$1 {
    static forIntegerArray(width, height, array) {
        const content = [];
        for(let y = 0; y < height; y++){
            let rowInteger = array[y];
            const row = [];
            for(let x = width - 1; x >= 0; x--){
                if (rowInteger % 2 === 1) {
                    row.unshift(true);
                    rowInteger--;
                } else row.unshift(false);
                rowInteger = rowInteger / 2;
            }
            content.push(row);
        }
        return new this(content);
    }
    asIntegerArray() {
        return this.content.map((row)=>{
            let integer = 0;
            row.forEach((bool)=>{
                integer *= 2;
                if (bool === true) integer++;
            });
            return integer;
        });
    }
    bitAt(x, y) {
        return this.at(x, y) ? 1 : 0;
    }
    fillAlignmentPatternAt(x, y) {
        for(let size = 0; size < 4; size++){
            this.content[y][x + size] = true;
            this.content[y + 4][x + size + 1] = true;
            this.content[y + 1 + size][x] = true;
            this.content[y + size][x + 4] = true;
        }
        this.content[y + 2][x + 2] = true;
    }
    fillFinderPatternAt(x, y) {
        for(let size = 0; size < 6; size++){
            this.content[y][x + size] = true;
            this.content[y + 6][x + size + 1] = true;
            this.content[y + 1 + size][x] = true;
            this.content[y + size][x + 6] = true;
        }
        this.fill(x + 2, y + 2, 3, 3, true);
    }
}
/**
 * CLASS QRCodeMap
 * An instance holds the mapping for a QR code at a version and level of error correction.
 * The instances are cached so they can be reused. The map has the responsibility for adding
 * error correction to the codewords, positioning those codewords as data into a boolean
 * matrix, and masking that matrix. Instances are cached so this can be used as a service.
 */ class QRCodeMap extends Matrix$1 {
    // CHUNKING
    static chunkingAt(errorCorrection, version) {
        return ({
            LOW: [
                [
                    [
                        1,
                        26,
                        19
                    ]
                ],
                [
                    [
                        1,
                        44,
                        34
                    ]
                ],
                [
                    [
                        1,
                        70,
                        55
                    ]
                ],
                [
                    [
                        1,
                        100,
                        80
                    ]
                ],
                [
                    [
                        1,
                        134,
                        108
                    ]
                ],
                [
                    [
                        2,
                        86,
                        68
                    ]
                ],
                [
                    [
                        2,
                        98,
                        78
                    ]
                ],
                [
                    [
                        2,
                        121,
                        97
                    ]
                ],
                [
                    [
                        2,
                        146,
                        116
                    ]
                ],
                [
                    [
                        2,
                        86,
                        68
                    ],
                    [
                        2,
                        87,
                        69
                    ]
                ],
                [
                    [
                        4,
                        101,
                        81
                    ]
                ],
                [
                    [
                        2,
                        116,
                        92
                    ],
                    [
                        2,
                        117,
                        93
                    ]
                ],
                [
                    [
                        4,
                        133,
                        107
                    ]
                ],
                [
                    [
                        3,
                        145,
                        115
                    ],
                    [
                        1,
                        146,
                        116
                    ]
                ],
                [
                    [
                        5,
                        109,
                        87
                    ],
                    [
                        1,
                        110,
                        88
                    ]
                ],
                [
                    [
                        5,
                        122,
                        98
                    ],
                    [
                        1,
                        123,
                        99
                    ]
                ],
                [
                    [
                        1,
                        135,
                        107
                    ],
                    [
                        5,
                        136,
                        108
                    ]
                ],
                [
                    [
                        5,
                        150,
                        120
                    ],
                    [
                        1,
                        151,
                        121
                    ]
                ],
                [
                    [
                        3,
                        141,
                        113
                    ],
                    [
                        4,
                        142,
                        114
                    ]
                ],
                [
                    [
                        3,
                        135,
                        107
                    ],
                    [
                        5,
                        136,
                        108
                    ]
                ],
                [
                    [
                        4,
                        144,
                        116
                    ],
                    [
                        4,
                        145,
                        117
                    ]
                ],
                [
                    [
                        2,
                        139,
                        111
                    ],
                    [
                        7,
                        140,
                        112
                    ]
                ],
                [
                    [
                        4,
                        151,
                        121
                    ],
                    [
                        5,
                        152,
                        122
                    ]
                ],
                [
                    [
                        6,
                        147,
                        117
                    ],
                    [
                        4,
                        148,
                        118
                    ]
                ],
                [
                    [
                        8,
                        132,
                        106
                    ],
                    [
                        4,
                        133,
                        107
                    ]
                ],
                [
                    [
                        10,
                        142,
                        114
                    ],
                    [
                        2,
                        143,
                        115
                    ]
                ],
                [
                    [
                        8,
                        152,
                        122
                    ],
                    [
                        4,
                        153,
                        123
                    ]
                ],
                [
                    [
                        3,
                        147,
                        117
                    ],
                    [
                        10,
                        148,
                        118
                    ]
                ],
                [
                    [
                        7,
                        146,
                        116
                    ],
                    [
                        7,
                        147,
                        117
                    ]
                ],
                [
                    [
                        5,
                        145,
                        115
                    ],
                    [
                        10,
                        146,
                        116
                    ]
                ],
                [
                    [
                        13,
                        145,
                        115
                    ],
                    [
                        3,
                        146,
                        116
                    ]
                ],
                [
                    [
                        17,
                        145,
                        115
                    ]
                ],
                [
                    [
                        17,
                        145,
                        115
                    ],
                    [
                        1,
                        146,
                        116
                    ]
                ],
                [
                    [
                        13,
                        145,
                        115
                    ],
                    [
                        6,
                        146,
                        116
                    ]
                ],
                [
                    [
                        12,
                        151,
                        121
                    ],
                    [
                        7,
                        152,
                        122
                    ]
                ],
                [
                    [
                        6,
                        151,
                        121
                    ],
                    [
                        14,
                        152,
                        122
                    ]
                ],
                [
                    [
                        17,
                        152,
                        122
                    ],
                    [
                        4,
                        153,
                        123
                    ]
                ],
                [
                    [
                        4,
                        152,
                        122
                    ],
                    [
                        18,
                        153,
                        123
                    ]
                ],
                [
                    [
                        20,
                        147,
                        117
                    ],
                    [
                        4,
                        148,
                        118
                    ]
                ],
                [
                    [
                        19,
                        148,
                        118
                    ],
                    [
                        6,
                        149,
                        119
                    ]
                ]
            ],
            HIGH: [
                [
                    [
                        1,
                        26,
                        9
                    ]
                ],
                [
                    [
                        1,
                        44,
                        16
                    ]
                ],
                [
                    [
                        2,
                        35,
                        13
                    ]
                ],
                [
                    [
                        4,
                        25,
                        9
                    ]
                ],
                [
                    [
                        2,
                        33,
                        11
                    ],
                    [
                        2,
                        34,
                        12
                    ]
                ],
                [
                    [
                        4,
                        43,
                        15
                    ]
                ],
                [
                    [
                        4,
                        39,
                        13
                    ],
                    [
                        1,
                        40,
                        14
                    ]
                ],
                [
                    [
                        4,
                        40,
                        14
                    ],
                    [
                        2,
                        41,
                        15
                    ]
                ],
                [
                    [
                        4,
                        36,
                        12
                    ],
                    [
                        4,
                        37,
                        13
                    ]
                ],
                [
                    [
                        6,
                        43,
                        15
                    ],
                    [
                        2,
                        44,
                        16
                    ]
                ],
                [
                    [
                        3,
                        36,
                        12
                    ],
                    [
                        8,
                        37,
                        13
                    ]
                ],
                [
                    [
                        7,
                        42,
                        14
                    ],
                    [
                        4,
                        43,
                        15
                    ]
                ],
                [
                    [
                        12,
                        33,
                        11
                    ],
                    [
                        4,
                        34,
                        12
                    ]
                ],
                [
                    [
                        11,
                        36,
                        12
                    ],
                    [
                        5,
                        37,
                        13
                    ]
                ],
                [
                    [
                        11,
                        36,
                        12
                    ],
                    [
                        7,
                        37,
                        13
                    ]
                ],
                [
                    [
                        3,
                        45,
                        15
                    ],
                    [
                        13,
                        46,
                        16
                    ]
                ],
                [
                    [
                        2,
                        42,
                        14
                    ],
                    [
                        17,
                        43,
                        15
                    ]
                ],
                [
                    [
                        2,
                        42,
                        14
                    ],
                    [
                        19,
                        43,
                        15
                    ]
                ],
                [
                    [
                        9,
                        39,
                        13
                    ],
                    [
                        16,
                        40,
                        14
                    ]
                ],
                [
                    [
                        15,
                        43,
                        15
                    ],
                    [
                        10,
                        44,
                        16
                    ]
                ],
                [
                    [
                        19,
                        46,
                        16
                    ],
                    [
                        6,
                        47,
                        17
                    ]
                ],
                [
                    [
                        34,
                        37,
                        13
                    ]
                ],
                [
                    [
                        16,
                        45,
                        15
                    ],
                    [
                        14,
                        46,
                        16
                    ]
                ],
                [
                    [
                        30,
                        46,
                        16
                    ],
                    [
                        2,
                        47,
                        17
                    ]
                ],
                [
                    [
                        22,
                        45,
                        15
                    ],
                    [
                        13,
                        46,
                        16
                    ]
                ],
                [
                    [
                        33,
                        46,
                        16
                    ],
                    [
                        4,
                        47,
                        17
                    ]
                ],
                [
                    [
                        12,
                        45,
                        15
                    ],
                    [
                        28,
                        46,
                        16
                    ]
                ],
                [
                    [
                        11,
                        45,
                        15
                    ],
                    [
                        31,
                        46,
                        16
                    ]
                ],
                [
                    [
                        19,
                        45,
                        15
                    ],
                    [
                        26,
                        46,
                        16
                    ]
                ],
                [
                    [
                        23,
                        45,
                        15
                    ],
                    [
                        25,
                        46,
                        16
                    ]
                ],
                [
                    [
                        23,
                        45,
                        15
                    ],
                    [
                        28,
                        46,
                        16
                    ]
                ],
                [
                    [
                        19,
                        45,
                        15
                    ],
                    [
                        35,
                        46,
                        16
                    ]
                ],
                [
                    [
                        11,
                        45,
                        15
                    ],
                    [
                        46,
                        46,
                        16
                    ]
                ],
                [
                    [
                        59,
                        46,
                        16
                    ],
                    [
                        1,
                        47,
                        17
                    ]
                ],
                [
                    [
                        22,
                        45,
                        15
                    ],
                    [
                        41,
                        46,
                        16
                    ]
                ],
                [
                    [
                        2,
                        45,
                        15
                    ],
                    [
                        64,
                        46,
                        16
                    ]
                ],
                [
                    [
                        24,
                        45,
                        15
                    ],
                    [
                        46,
                        46,
                        16
                    ]
                ],
                [
                    [
                        42,
                        45,
                        15
                    ],
                    [
                        32,
                        46,
                        16
                    ]
                ],
                [
                    [
                        10,
                        45,
                        15
                    ],
                    [
                        67,
                        46,
                        16
                    ]
                ],
                [
                    [
                        20,
                        45,
                        15
                    ],
                    [
                        61,
                        46,
                        16
                    ]
                ]
            ],
            MEDIUM: [
                [
                    [
                        1,
                        26,
                        16
                    ]
                ],
                [
                    [
                        1,
                        44,
                        28
                    ]
                ],
                [
                    [
                        1,
                        70,
                        44
                    ]
                ],
                [
                    [
                        2,
                        50,
                        32
                    ]
                ],
                [
                    [
                        2,
                        67,
                        43
                    ]
                ],
                [
                    [
                        4,
                        43,
                        27
                    ]
                ],
                [
                    [
                        4,
                        49,
                        31
                    ]
                ],
                [
                    [
                        2,
                        60,
                        38
                    ],
                    [
                        2,
                        61,
                        39
                    ]
                ],
                [
                    [
                        3,
                        58,
                        36
                    ],
                    [
                        2,
                        59,
                        37
                    ]
                ],
                [
                    [
                        4,
                        69,
                        43
                    ],
                    [
                        1,
                        70,
                        44
                    ]
                ],
                [
                    [
                        1,
                        80,
                        50
                    ],
                    [
                        4,
                        81,
                        51
                    ]
                ],
                [
                    [
                        6,
                        58,
                        36
                    ],
                    [
                        2,
                        59,
                        37
                    ]
                ],
                [
                    [
                        8,
                        59,
                        37
                    ],
                    [
                        1,
                        60,
                        38
                    ]
                ],
                [
                    [
                        4,
                        64,
                        40
                    ],
                    [
                        5,
                        65,
                        41
                    ]
                ],
                [
                    [
                        5,
                        65,
                        41
                    ],
                    [
                        5,
                        66,
                        42
                    ]
                ],
                [
                    [
                        7,
                        73,
                        45
                    ],
                    [
                        3,
                        74,
                        46
                    ]
                ],
                [
                    [
                        10,
                        74,
                        46
                    ],
                    [
                        1,
                        75,
                        47
                    ]
                ],
                [
                    [
                        9,
                        69,
                        43
                    ],
                    [
                        4,
                        70,
                        44
                    ]
                ],
                [
                    [
                        3,
                        70,
                        44
                    ],
                    [
                        11,
                        71,
                        45
                    ]
                ],
                [
                    [
                        3,
                        67,
                        41
                    ],
                    [
                        13,
                        68,
                        42
                    ]
                ],
                [
                    [
                        17,
                        68,
                        42
                    ]
                ],
                [
                    [
                        17,
                        74,
                        46
                    ]
                ],
                [
                    [
                        4,
                        75,
                        47
                    ],
                    [
                        14,
                        76,
                        48
                    ]
                ],
                [
                    [
                        6,
                        73,
                        45
                    ],
                    [
                        14,
                        74,
                        46
                    ]
                ],
                [
                    [
                        8,
                        75,
                        47
                    ],
                    [
                        13,
                        76,
                        48
                    ]
                ],
                [
                    [
                        19,
                        74,
                        46
                    ],
                    [
                        4,
                        75,
                        47
                    ]
                ],
                [
                    [
                        22,
                        73,
                        45
                    ],
                    [
                        3,
                        74,
                        46
                    ]
                ],
                [
                    [
                        3,
                        73,
                        45
                    ],
                    [
                        23,
                        74,
                        46
                    ]
                ],
                [
                    [
                        21,
                        73,
                        45
                    ],
                    [
                        7,
                        74,
                        46
                    ]
                ],
                [
                    [
                        19,
                        75,
                        47
                    ],
                    [
                        10,
                        76,
                        48
                    ]
                ],
                [
                    [
                        2,
                        74,
                        46
                    ],
                    [
                        29,
                        75,
                        47
                    ]
                ],
                [
                    [
                        10,
                        74,
                        46
                    ],
                    [
                        23,
                        75,
                        47
                    ]
                ],
                [
                    [
                        14,
                        74,
                        46
                    ],
                    [
                        21,
                        75,
                        47
                    ]
                ],
                [
                    [
                        14,
                        74,
                        46
                    ],
                    [
                        23,
                        75,
                        47
                    ]
                ],
                [
                    [
                        12,
                        75,
                        47
                    ],
                    [
                        26,
                        76,
                        48
                    ]
                ],
                [
                    [
                        6,
                        75,
                        47
                    ],
                    [
                        34,
                        76,
                        48
                    ]
                ],
                [
                    [
                        29,
                        74,
                        46
                    ],
                    [
                        14,
                        75,
                        47
                    ]
                ],
                [
                    [
                        13,
                        74,
                        46
                    ],
                    [
                        32,
                        75,
                        47
                    ]
                ],
                [
                    [
                        40,
                        75,
                        47
                    ],
                    [
                        7,
                        76,
                        48
                    ]
                ],
                [
                    [
                        18,
                        75,
                        47
                    ],
                    [
                        31,
                        76,
                        48
                    ]
                ]
            ],
            QUARTER: [
                [
                    [
                        1,
                        26,
                        13
                    ]
                ],
                [
                    [
                        1,
                        44,
                        22
                    ]
                ],
                [
                    [
                        2,
                        35,
                        17
                    ]
                ],
                [
                    [
                        2,
                        50,
                        24
                    ]
                ],
                [
                    [
                        2,
                        33,
                        15
                    ],
                    [
                        2,
                        34,
                        16
                    ]
                ],
                [
                    [
                        4,
                        43,
                        19
                    ]
                ],
                [
                    [
                        2,
                        32,
                        14
                    ],
                    [
                        4,
                        33,
                        15
                    ]
                ],
                [
                    [
                        4,
                        40,
                        18
                    ],
                    [
                        2,
                        41,
                        19
                    ]
                ],
                [
                    [
                        4,
                        36,
                        16
                    ],
                    [
                        4,
                        37,
                        17
                    ]
                ],
                [
                    [
                        6,
                        43,
                        19
                    ],
                    [
                        2,
                        44,
                        20
                    ]
                ],
                [
                    [
                        4,
                        50,
                        22
                    ],
                    [
                        4,
                        51,
                        23
                    ]
                ],
                [
                    [
                        4,
                        46,
                        20
                    ],
                    [
                        6,
                        47,
                        21
                    ]
                ],
                [
                    [
                        8,
                        44,
                        20
                    ],
                    [
                        4,
                        45,
                        21
                    ]
                ],
                [
                    [
                        11,
                        36,
                        16
                    ],
                    [
                        5,
                        37,
                        17
                    ]
                ],
                [
                    [
                        5,
                        54,
                        24
                    ],
                    [
                        7,
                        55,
                        25
                    ]
                ],
                [
                    [
                        15,
                        43,
                        19
                    ],
                    [
                        2,
                        44,
                        20
                    ]
                ],
                [
                    [
                        1,
                        50,
                        22
                    ],
                    [
                        15,
                        51,
                        23
                    ]
                ],
                [
                    [
                        17,
                        50,
                        22
                    ],
                    [
                        1,
                        51,
                        23
                    ]
                ],
                [
                    [
                        17,
                        47,
                        21
                    ],
                    [
                        4,
                        48,
                        22
                    ]
                ],
                [
                    [
                        15,
                        54,
                        24
                    ],
                    [
                        5,
                        55,
                        25
                    ]
                ],
                [
                    [
                        17,
                        50,
                        22
                    ],
                    [
                        6,
                        51,
                        23
                    ]
                ],
                [
                    [
                        7,
                        54,
                        24
                    ],
                    [
                        16,
                        55,
                        25
                    ]
                ],
                [
                    [
                        11,
                        54,
                        24
                    ],
                    [
                        14,
                        55,
                        25
                    ]
                ],
                [
                    [
                        11,
                        54,
                        24
                    ],
                    [
                        16,
                        55,
                        25
                    ]
                ],
                [
                    [
                        7,
                        54,
                        24
                    ],
                    [
                        22,
                        55,
                        25
                    ]
                ],
                [
                    [
                        28,
                        50,
                        22
                    ],
                    [
                        6,
                        51,
                        23
                    ]
                ],
                [
                    [
                        8,
                        53,
                        23
                    ],
                    [
                        26,
                        54,
                        24
                    ]
                ],
                [
                    [
                        4,
                        54,
                        24
                    ],
                    [
                        31,
                        55,
                        25
                    ]
                ],
                [
                    [
                        1,
                        53,
                        23
                    ],
                    [
                        37,
                        54,
                        24
                    ]
                ],
                [
                    [
                        15,
                        54,
                        24
                    ],
                    [
                        25,
                        55,
                        25
                    ]
                ],
                [
                    [
                        42,
                        54,
                        24
                    ],
                    [
                        1,
                        55,
                        25
                    ]
                ],
                [
                    [
                        10,
                        54,
                        24
                    ],
                    [
                        35,
                        55,
                        25
                    ]
                ],
                [
                    [
                        29,
                        54,
                        24
                    ],
                    [
                        19,
                        55,
                        25
                    ]
                ],
                [
                    [
                        44,
                        54,
                        24
                    ],
                    [
                        7,
                        55,
                        25
                    ]
                ],
                [
                    [
                        39,
                        54,
                        24
                    ],
                    [
                        14,
                        55,
                        25
                    ]
                ],
                [
                    [
                        46,
                        54,
                        24
                    ],
                    [
                        10,
                        55,
                        25
                    ]
                ],
                [
                    [
                        49,
                        54,
                        24
                    ],
                    [
                        10,
                        55,
                        25
                    ]
                ],
                [
                    [
                        48,
                        54,
                        24
                    ],
                    [
                        14,
                        55,
                        25
                    ]
                ],
                [
                    [
                        43,
                        54,
                        24
                    ],
                    [
                        22,
                        55,
                        25
                    ]
                ],
                [
                    [
                        34,
                        54,
                        24
                    ],
                    [
                        34,
                        55,
                        25
                    ]
                ]
            ]
        })[errorCorrection][version - 1];
    }
    // GALOIS FIELD POLYNOMIALS
    static fromGF256Alpha(index) {
        return [
            1,
            2,
            4,
            8,
            16,
            32,
            64,
            128,
            29,
            58,
            116,
            232,
            205,
            135,
            19,
            38,
            76,
            152,
            45,
            90,
            180,
            117,
            234,
            201,
            143,
            3,
            6,
            12,
            24,
            48,
            96,
            192,
            157,
            39,
            78,
            156,
            37,
            74,
            148,
            53,
            106,
            212,
            181,
            119,
            238,
            193,
            159,
            35,
            70,
            140,
            5,
            10,
            20,
            40,
            80,
            160,
            93,
            186,
            105,
            210,
            185,
            111,
            222,
            161,
            95,
            190,
            97,
            194,
            153,
            47,
            94,
            188,
            101,
            202,
            137,
            15,
            30,
            60,
            120,
            240,
            253,
            231,
            211,
            187,
            107,
            214,
            177,
            127,
            254,
            225,
            223,
            163,
            91,
            182,
            113,
            226,
            217,
            175,
            67,
            134,
            17,
            34,
            68,
            136,
            13,
            26,
            52,
            104,
            208,
            189,
            103,
            206,
            129,
            31,
            62,
            124,
            248,
            237,
            199,
            147,
            59,
            118,
            236,
            197,
            151,
            51,
            102,
            204,
            133,
            23,
            46,
            92,
            184,
            109,
            218,
            169,
            79,
            158,
            33,
            66,
            132,
            21,
            42,
            84,
            168,
            77,
            154,
            41,
            82,
            164,
            85,
            170,
            73,
            146,
            57,
            114,
            228,
            213,
            183,
            115,
            230,
            209,
            191,
            99,
            198,
            145,
            63,
            126,
            252,
            229,
            215,
            179,
            123,
            246,
            241,
            255,
            227,
            219,
            171,
            75,
            150,
            49,
            98,
            196,
            149,
            55,
            110,
            220,
            165,
            87,
            174,
            65,
            130,
            25,
            50,
            100,
            200,
            141,
            7,
            14,
            28,
            56,
            112,
            224,
            221,
            167,
            83,
            166,
            81,
            162,
            89,
            178,
            121,
            242,
            249,
            239,
            195,
            155,
            43,
            86,
            172,
            69,
            138,
            9,
            18,
            36,
            72,
            144,
            61,
            122,
            244,
            245,
            247,
            243,
            251,
            235,
            203,
            139,
            11,
            22,
            44,
            88,
            176,
            125,
            250,
            233,
            207,
            131,
            27,
            54,
            108,
            216,
            173,
            71,
            142
        ][index];
    }
    static polynomial(size) {
        // cache the polynomials
        if (this.polynomials.length >= size) return this.polynomials[size - 1];
        let polynomial = this.polynomials[this.polynomials.length - 1];
        for(let multiplier = this.polynomials.length; multiplier < size; multiplier++){
            let factor = new Uint8Array(2);
            factor[1] = multiplier;
            polynomial = this.product(polynomial, factor);
            this.polynomials.push(polynomial);
        }
        return polynomial;
    }
    static product(first, second) {
        let product = new Uint8Array(first.length + second.length - 1);
        first.forEach((firstValue, firstIndex)=>{
            second.forEach((secondValue, secondIndex)=>{
                let productIndex = firstIndex + secondIndex;
                product[productIndex] = this.fromGF256Alpha((firstValue + secondValue) % 255) ^ product[productIndex];
            });
        });
        return product.map((entry)=>this.toGF256Alpha(entry));
    }
    static quotient(dividend, divisor) {
        let quotient = new Uint8Array(dividend.length + divisor.length - 1);
        for(let index = 0; index < dividend.length; index++)quotient[index] = dividend[index];
        for(let dividendIndex = 0; dividendIndex < dividend.length; dividendIndex++){
            let startEntry = quotient[dividendIndex];
            if (startEntry !== 0) {
                startEntry = this.toGF256Alpha(startEntry);
                divisor.forEach((alpha, divisorIndex)=>{
                    let quotientIndex = dividendIndex + divisorIndex;
                    quotient[quotientIndex] = this.fromGF256Alpha((startEntry + alpha) % 255) ^ quotient[quotientIndex];
                });
            }
        }
        return quotient.slice(quotient.length - divisor.length + 1);
    }
    static toGF256Alpha(index) {
        return [
            0,
            0,
            1,
            25,
            2,
            50,
            26,
            198,
            3,
            223,
            51,
            238,
            27,
            104,
            199,
            75,
            4,
            100,
            224,
            14,
            52,
            141,
            239,
            129,
            28,
            193,
            105,
            248,
            200,
            8,
            76,
            113,
            5,
            138,
            101,
            47,
            225,
            36,
            15,
            33,
            53,
            147,
            142,
            218,
            240,
            18,
            130,
            69,
            29,
            181,
            194,
            125,
            106,
            39,
            249,
            185,
            201,
            154,
            9,
            120,
            77,
            228,
            114,
            166,
            6,
            191,
            139,
            98,
            102,
            221,
            48,
            253,
            226,
            152,
            37,
            179,
            16,
            145,
            34,
            136,
            54,
            208,
            148,
            206,
            143,
            150,
            219,
            189,
            241,
            210,
            19,
            92,
            131,
            56,
            70,
            64,
            30,
            66,
            182,
            163,
            195,
            72,
            126,
            110,
            107,
            58,
            40,
            84,
            250,
            133,
            186,
            61,
            202,
            94,
            155,
            159,
            10,
            21,
            121,
            43,
            78,
            212,
            229,
            172,
            115,
            243,
            167,
            87,
            7,
            112,
            192,
            247,
            140,
            128,
            99,
            13,
            103,
            74,
            222,
            237,
            49,
            197,
            254,
            24,
            227,
            165,
            153,
            119,
            38,
            184,
            180,
            124,
            17,
            68,
            146,
            217,
            35,
            32,
            137,
            46,
            55,
            63,
            209,
            91,
            149,
            188,
            207,
            205,
            144,
            135,
            151,
            178,
            220,
            252,
            190,
            97,
            242,
            86,
            211,
            171,
            20,
            42,
            93,
            158,
            132,
            60,
            57,
            83,
            71,
            109,
            65,
            162,
            31,
            45,
            67,
            216,
            183,
            123,
            164,
            118,
            196,
            23,
            73,
            236,
            127,
            12,
            111,
            246,
            108,
            161,
            59,
            82,
            41,
            157,
            85,
            170,
            251,
            96,
            134,
            177,
            187,
            204,
            62,
            90,
            203,
            89,
            95,
            176,
            156,
            169,
            160,
            81,
            11,
            245,
            22,
            235,
            122,
            117,
            44,
            215,
            79,
            174,
            213,
            233,
            230,
            231,
            173,
            232,
            116,
            214,
            244,
            234,
            168,
            80,
            88,
            175
        ][index];
    }
    // MASKS
    static get masks() {
        if (this.maskArray.length === 0) [
            (x, y)=>(x + y) % 2 === 0,
            (x, y)=>y % 2 === 0,
            (x)=>x % 3 === 0,
            (x, y)=>(x + y) % 3 === 0,
            (x, y)=>((y - y % 2) / 2 + (x - x % 3) / 3) % 2 === 0,
            (x, y)=>x * y % 2 + x * y % 3 === 0,
            (x, y)=>(x * y + x * y % 3) % 2 === 0,
            (x, y)=>(x * y % 3 + x + y) % 2 === 0
        ].forEach((generator)=>{
            const content = [];
            for(let y = 0; y < 12; y++){
                const row = [];
                for(let x = 0; x < 12; x++)row.push(generator(x, y));
                content.push(row);
            }
            this.maskArray.push(new BooleanMatrix(content));
        });
        return this.maskArray;
    }
    // INSTANCE CREATION
    static for(errorCorrection, version) {
        // cache the instances
        let instance = this.instances[errorCorrection + version];
        if (instance === undefined) {
            const dimension = version * 4 + 17;
            const content = [];
            for(let row = 0; row < dimension; row++)content.push(new Array(dimension).fill(this.AVAILABLE));
            instance = new this(content, errorCorrection, version);
            this.instances[errorCorrection + version] = instance;
        }
        return instance;
    }
    // INSTANCE
    // chunking
    // chunkingOffsets          where each chunk can be found in the data
    // errorCorrection
    // errorCorrectionCapacity  the number of codewords that can be messed up
    //                          (1x for erasure, 2x for miscoding) per chunk
    // version
    constructor(content, errorCorrection, version){
        super(content);
        this.errorCorrection = errorCorrection;
        this.version = version;
        this.initialize();
    }
    initialize() {
        // calculate misdecodeProtectionCodewords
        let misdecodeProtectionCodewords = 0;
        if (this.errorCorrection === ERROR_CORRECTION.LOW) {
            if (this.version === 1) misdecodeProtectionCodewords = 3;
            else if (this.version === 2) misdecodeProtectionCodewords = 2;
            else if (this.version === 3) misdecodeProtectionCodewords = 1;
        } else if (this.version === 1) {
            if (this.errorCorrection === ERROR_CORRECTION.MEDIUM) misdecodeProtectionCodewords = 2;
            else misdecodeProtectionCodewords = 1;
        }
        // get data and errorCorrection
        this.chunking = this.constructor.chunkingAt(this.errorCorrection, this.version);
        const data = [];
        const errorCorrection = [];
        let dataWidth = 0;
        let errorCorrectionWidth = 0;
        const errorCorrectionCapacity = [];
        const chunkingOffsets = [];
        let chunkingOffset = 0;
        let chunk = 0;
        this.chunking.forEach((arr)=>{
            for(let i = 0; i < arr[0]; i++){
                let byte = 0;
                chunkingOffsets.push(chunkingOffset * 8);
                chunkingOffset += arr[1];
                const dataI = [];
                const numberOfDataCodewords = arr[2];
                for(let j = 0; j < numberOfDataCodewords; j++){
                    dataI.push({
                        chunk: chunk,
                        byte: byte
                    });
                    byte++;
                }
                data.push(dataI);
                dataWidth = Math.max(dataWidth, dataI.length);
                const errorCorrectionI = [];
                const numberOfErrorCorrectionCodewords = arr[1] - numberOfDataCodewords;
                for(let j = 0; j < numberOfErrorCorrectionCodewords; j++){
                    errorCorrectionI.push({
                        chunk: chunk,
                        byte: byte
                    });
                    byte++;
                }
                errorCorrection.push(errorCorrectionI);
                errorCorrectionWidth = Math.max(errorCorrectionWidth, errorCorrectionI.length);
                errorCorrectionCapacity.push(numberOfErrorCorrectionCodewords - misdecodeProtectionCodewords);
                chunk++;
            }
        });
        this.chunkingOffsets = chunkingOffsets;
        this.errorCorrectionCapacity = errorCorrectionCapacity;
        // combine the data and errorCorrection
        const combined = [];
        for(let column = 0; column < dataWidth; column++)data.forEach((row)=>{
            if (row.length > column) combined.push(row[column]);
        });
        for(let column = 0; column < errorCorrectionWidth; column++)errorCorrection.forEach((row)=>{
            if (row.length > column) combined.push(row[column]);
        });
        // create the pixels
        const pixels = [];
        combined.forEach((byteAndChunk)=>{
            const byte = byteAndChunk.byte;
            const chunk = byteAndChunk.chunk;
            for(let bit = 0; bit < 8; bit++)pixels.push({
                chunk: chunk,
                byte: byte,
                bit: bit
            });
        });
        // finder patterns & format information
        const dimension = this.width;
        this.fill(0, 0, 9, 9, this.constructor.AVOID);
        this.fill(dimension - 8, 0, 8, 9, this.constructor.AVOID);
        this.fill(0, dimension - 8, 9, 8, this.constructor.AVOID);
        // version information
        if (this.version > 6) {
            this.fill(dimension - 11, 0, 3, 6, this.constructor.AVOID);
            this.fill(0, dimension - 11, 6, 3, this.constructor.AVOID);
        }
        // timing patterns
        this.fill(9, 6, dimension - 17, 1, this.constructor.AVOID);
        this.fill(6, 9, 1, dimension - 17, this.constructor.AVOID);
        // alignment patterns
        for (const position of QRCode$1.alignmentPatternPositions(this.version))this.fill(position.x, position.y, 5, 5, this.constructor.AVOID);
        // fill the pixels
        let x = dimension - 2;
        let y = dimension;
        pixels.forEach((pixel)=>{
            // get next position
            do {
                let shift;
                let halfOdd = (x - x % 2) / 2 % 2 === 1;
                if (x === 6) {
                    shift = false;
                    x = 5;
                } else if (x < 6) shift = x % 2 === 1;
                else shift = x % 2 === 0;
                if (shift) x--;
                else if (halfOdd) {
                    if (y === 0) x--;
                    else {
                        x++;
                        y--;
                    }
                } else if (y + 1 === dimension) x--;
                else {
                    x++;
                    y++;
                }
            }while (this.at(x, y) === this.constructor.AVOID && x > -1);
            // place the bit
            this.put(x, y, pixel);
        });
    }
    codewordsFor(codewords) {
        let bytePosition = 0;
        const withErrorCorrection = [];
        this.chunking.forEach((arr)=>{
            for(let i = 0; i < arr[0]; i++){
                const data = codewords.slice(bytePosition, bytePosition + arr[2]);
                bytePosition += arr[2];
                const errorCorrection = this.constructor.quotient(data, this.constructor.polynomial(arr[1] - arr[2]));
                withErrorCorrection.push(...data);
                withErrorCorrection.push(...errorCorrection);
            }
        });
        return withErrorCorrection;
    }
    dataFor(codewords) {
        // convert to bits
        const bits = [];
        codewords.forEach((byte)=>{
            let remainder = byte;
            [
                128,
                64,
                32,
                16,
                8,
                4,
                2,
                1
            ].forEach((subtract)=>{
                if (remainder >= subtract) {
                    bits.push(true);
                    remainder -= subtract;
                } else bits.push(false);
            });
        });
        this.bits = bits;
        // place bits in matrix
        const dimension = this.content.length;
        const encodedData = BooleanMatrix.withAll(dimension, dimension, false);
        for(let y = 0; y < dimension; y++)for(let x = 0; x < dimension; x++){
            const pixel = this.at(x, y);
            if (this.isDataPixel(pixel)) encodedData.put(x, y, bits[this.chunkingOffsets[pixel.chunk] + pixel.byte * 8 + pixel.bit]);
        }
        return encodedData;
    }
    isDataPixel(pixel) {
        return pixel !== this.constructor.AVOID && pixel !== this.constructor.AVAILABLE;
    }
    maskedDataFor(data) {
        const dimension = data.height;
        return this.constructor.masks.map((mask)=>{
            const masked = BooleanMatrix.withAll(dimension, dimension);
            for(let x = 0; x < dimension; x++)for(let y = 0; y < dimension; y++){
                let value = data.at(x, y);
                if (this.at(x, y) !== QRCodeMap.AVOID) {
                    if (mask.at(x % 12, y % 12)) value = !value;
                }
                masked.put(x, y, value);
            }
            return masked;
        });
    }
    // TESTING
    asIntegerArray() {
        return this.content.map((row)=>{
            let integer = 0;
            row.forEach((pixel)=>{
                integer *= 2;
                if (this.isDataPixel(pixel)) integer++;
            });
            return integer;
        });
    }
}
// static variables
QRCodeMap.AVAILABLE = 'available';
QRCodeMap.AVOID = 'avoid';
QRCodeMap.GENERATOR_FUNCTIONS = [
    (x, y)=>(x + y) % 2 === 0,
    (x, y)=>y % 2 === 0,
    (x)=>x % 3 === 0,
    (x, y)=>(x + y) % 3 === 0,
    (x, y)=>((y - y % 2) / 2 + (x - x % 3) / 3) % 2 === 0,
    (x, y)=>x * y % 2 + x * y % 3 === 0,
    (x, y)=>(x * y + x * y % 3) % 2 === 0,
    (x, y)=>(x * y % 3 + x + y) % 2 === 0
];
QRCodeMap.instances = {};
QRCodeMap.maskArray = [];
QRCodeMap.polynomials = [
    new Uint8Array(2)
];
/**
 * CLASS QRCode
 * This represents an encoded QRCode based on the following:
 *   content         the string to encode
 *   options         an object with the options, such as the ECI integer and errorCorrection
 * An encoder generates the following:
 *   data            the BooleanMatrix of mapped data, along with the format and version information
 *   eci             (see above)
 *   encoding        'NUMERIC' | 'ALPHANUMERIC' | 'KANJI' | BYTE
 *   errorCorrection (see above)
 *   version         the QRCode version from 1 to 40.
 * It also provides pattern positions and derivative information.
 */ class QRCode$1 {
    static alignmentPatternPositions(version) {
        let locations = ALIGNMENT_PATTERN_LOCATIONS[version - 1];
        if (locations.length === 0) return [];
        const positions = [];
        // top and left
        const first = locations[0];
        locations.slice(1, locations.length - 1).forEach((location)=>{
            positions.push({
                x: first,
                y: location
            });
            positions.push({
                x: location,
                y: first
            });
        });
        // others
        locations = locations.slice(1);
        locations.forEach((y)=>{
            locations.forEach((x)=>{
                positions.push({
                    x: x,
                    y: y
                });
            });
        });
        return positions;
    }
    static finderPatternPositions(version) {
        const far = 4 * version + 10;
        return [
            {
                x: 0,
                y: 0
            },
            {
                x: 0,
                y: far
            },
            {
                x: far,
                y: 0
            }
        ];
    }
    static timingPatternPositions(version) {
        const positions = [];
        const far = 4 * version + 9;
        for(let position = 8; position < far; position += 2){
            positions.push({
                x: position,
                y: 6
            });
            positions.push({
                x: 6,
                y: position
            });
        }
        return positions;
    }
    constructor(content, options){
        if (content === undefined || content.length === 0) throw 'no content to encode';
        this.content = content;
        this.options = options || {};
        if ('eci' in this.options) this.eci = this.options.eci;
        if ('errorCorrection' in this.options) this.errorCorrection = this.options.errorCorrection;
    }
    get alignmentPatternPositions() {
        return this.constructor.alignmentPatternPositions(this.version);
    }
    get dimension() {
        return this.version * 4 + 17;
    }
    get encoding() {
        return this._encoding;
    }
    set encoding(string) {
        this._encoding = string;
    }
    get finderPatternPositions() {
        return this.constructor.finderPatternPositions(this.version);
    }
    get hasEci() {
        return this.eci !== undefined && this.eci !== 3;
    }
    get hasAlignmentPattern() {
        return this.version > 1;
    }
    get timingPatternPositions() {
        return this.constructor.timingPatternPositions(this.version);
    }
}
// static variables
QRCode$1.MAX_VERSION = 40;
/**
 * CLASS QRCodeEncoder
 * This class does the encoding work for the QRCode class, hiding the algorithmic details and
 * intermediate step data. It populates the QRCode with encoding, version, errorCorrection, and data.
 * It is only exported to be used in tests.
 */ class QRCodeEncoder$1 {
    constructor(contents, options){
        this.code = new QRCode$1(contents, options);
        this.encode();
    }
    encode() {
        this.initializeEncoding();
        this.initializeVersion();
        this.initializeCodewords();
        this.initializeMapping();
        this.initializeMasking();
    }
    initializeCodewords() {
        const writer = new BitWriter(DATA_CAPACITY[this.code.errorCorrection][this.code.version - 1]);
        switch(this.code.encoding){
            case ENCODING.NUMERIC:
                // mode
                writer.nextPutBits(1, 4);
                // number of bits
                if (this.code.version < 10) writer.nextPutBits(this.length, 10);
                else if (this.code.version < 27) writer.nextPutBits(this.length, 12);
                else writer.nextPutBits(this.length, 14);
                // content
                writer.nextPutNumeric(this.code.content);
                break;
            case ENCODING.ALPHANUMERIC:
                // mode
                writer.nextPutBits(2, 4);
                // number of bits
                if (this.code.version < 10) writer.nextPutBits(this.length, 9);
                else if (this.code.version < 27) writer.nextPutBits(this.length, 11);
                else writer.nextPutBits(this.length, 13);
                // content
                writer.nextPutAlphaNUMERIC(this.code.content);
                break;
            case ENCODING.KANJI:
                // mode
                writer.nextPutBits(8, 8);
                // number of bits
                if (this.code.version < 10) writer.nextPutBits(this.length, 8);
                else if (this.code.version < 27) writer.nextPutBits(this.length, 10);
                else writer.nextPutBits(this.length, 12);
                // content
                writer.nextPutKanji(this.code.content);
                break;
            case ENCODING.BYTE:
                if (this.code.hasEci) {
                    // specife ECI mode
                    writer.nextPutBits(7, 4);
                    // Add the ECI assignment number
                    if (this.code.eci < 128) {
                        writer.nextPutBits(0, 1);
                        writer.nextPutBits(this.code.eci, 7);
                    } else if (this.code.eci < 16384) {
                        writer.nextPutBits(2, 2);
                        writer.nextPutBits(this.code.eci, 14);
                    } else {
                        writer.nextPutBits(6, 3);
                        writer.nextPutBits(this.code.eci, 21);
                    }
                }
                // mode
                writer.nextPutBits(4, 4);
                // number of bits
                if (this.code.version < 10) writer.nextPutBits(this.length, 8);
                else writer.nextPutBits(this.length, 16);
                // content
                writer.nextPutByte(this.bytes);
                break;
        }
        // Terminate the sequence / Skip to next byte for error correction
        if (writer.bitsLeft > 3) writer.nextPutBits(0, 4);
        // Add error correction sequence, alternating between 11101100 and 00010001
        const bytesLeft = writer.bytesLeft;
        for(let index = 0; index < bytesLeft; index++)writer.nextPutCompleteByte(index % 2 === 0 ? 236 : 17);
        this.codewords = writer.content;
    }
    initializeEncoding() {
        if (this.code.hasEci) {
            this.code.encoding = ENCODING.BYTE;
            if (this.code.eci === 3) {
                // jis
                this.length = this.code.content.length;
                this.bytes = [];
                for(let i = 0; i < length; i++)this.bytes.push(this.code.content.charCodeAt(i) % 128);
            } else if (this.code.eci === 25) {
                // utf-16be
                this.bytes = this.toUtf16Bytes(this.code.content);
                this.length = this.bytes.length;
            } else if (this.code.eci === 26) {
                // utf-8
                this.bytes = this.toUtf8Bytes(this.code.content);
                this.length = this.bytes.length;
            } else {
                this.length = this.code.content.length;
                this.bytes = [];
                for(let i = 0; i < length; i++)this.bytes.push(this.code.content.charCodeAt(i) % 256);
            }
        } else if (/^\d*$/.test(this.code.content)) {
            this.code.encoding = ENCODING.NUMERIC;
            this.length = this.code.content.length;
        } else if (/^[A-Z\d\dA-Z $%*+-./:]+$/.test(this.code.content)) {
            this.code.encoding = ENCODING.ALPHANUMERIC;
            this.length = this.code.content.length;
        } else if (/^[\u8140-\u9ffc\ue040-\uebbf]+$/.test(this.code.content)) {
            this.code.encoding = ENCODING.KANJI;
            this.length = this.code.content.length;
        } else {
            this.code.encoding = ENCODING.BYTE;
            this.bytes = this.toUtf8Bytes(this.code.content);
            this.length = this.bytes.length;
            // use utf-8 encoding if it is needed, jis if that is sufficient
            this.code.eci = this.length === this.code.content.length ? 3 : 26;
        }
    }
    initializeMapping() {
        this.map = QRCodeMap.for(this.code.errorCorrection, this.code.version);
        this.mapCodewords = this.map.codewordsFor(this.codewords);
        this.mapData = this.map.dataFor(this.mapCodewords);
    }
    initializeMasking() {
        // Get the masked choices
        const choices = this.map.maskedDataFor(this.mapData);
        // Find the one with the lowest penalty
        let data;
        let dataIndex;
        let lowestPenalty = 1000000;
        choices.forEach((matrix, index)=>{
            const penalty = this.penaltyForMatrix(matrix);
            if (penalty < lowestPenalty) {
                lowestPenalty = penalty;
                data = matrix;
                dataIndex = index;
            }
        });
        this.lowestPenalty = lowestPenalty;
        // Generate the format information
        let format = [
            1,
            0,
            3,
            2
        ][this.errorCorrections.indexOf(this.code.errorCorrection)];
        format = (8 * format + dataIndex) * 1024;
        let errorCorrection = format;
        for(let i = 14; i >= 10; i--)if (errorCorrection >= Math.pow(2, i)) errorCorrection = Math.pow(2, i - 10) * 1335 ^ errorCorrection;
        format = format + errorCorrection ^ 21522;
        // Place the format information
        const dimension = this.code.dimension;
        [
            [
                8,
                0,
                dimension - 1,
                8
            ],
            [
                8,
                1,
                dimension - 2,
                8
            ],
            [
                8,
                2,
                dimension - 3,
                8
            ],
            [
                8,
                3,
                dimension - 4,
                8
            ],
            [
                8,
                4,
                dimension - 5,
                8
            ],
            [
                8,
                5,
                dimension - 6,
                8
            ],
            [
                8,
                7,
                dimension - 7,
                8
            ],
            [
                8,
                8,
                dimension - 8,
                8
            ],
            [
                7,
                8,
                8,
                dimension - 7
            ],
            [
                5,
                8,
                8,
                dimension - 6
            ],
            [
                4,
                8,
                8,
                dimension - 5
            ],
            [
                3,
                8,
                8,
                dimension - 4
            ],
            [
                2,
                8,
                8,
                dimension - 3
            ],
            [
                1,
                8,
                8,
                dimension - 2
            ],
            [
                0,
                8,
                8,
                dimension - 1
            ]
        ].forEach((arr, index)=>{
            if ((Math.pow(2, index) & format) > 0) {
                data.put(arr[0], arr[1], true);
                data.put(arr[2], arr[3], true);
            }
        });
        // Add dark module
        data.put(8, dimension - 8, true);
        // Version information
        if (this.code.version > 6) {
            // Generate the bitVersion information
            let bitVersion = this.code.version * 4096;
            errorCorrection = bitVersion;
            for(let i = 17; i >= 12; i--)if (errorCorrection >= Math.pow(2, i)) errorCorrection = Math.pow(2, i - 12) * 7973 ^ errorCorrection;
            bitVersion += errorCorrection;
            // Place the bitVersion information
            let count = 0;
            for(let x = 0; x < 6; x++)for(let y = dimension - 11; y <= dimension - 9; y++){
                if ((Math.pow(2, count) & bitVersion) > 0) {
                    data.put(x, y, true);
                    data.put(y, x, true);
                }
                count++;
            }
        }
        // finalize loading of QRCode
        this.code.data = data;
    }
    initializeVersion() {
        if (this.errorCorrections.includes(this.code.errorCorrection)) {
            // Error correction has already been specified
            let version = this.versionForLength(this.length, this.code.errorCorrection);
            if (version > QRCode$1.MAX_VERSION) throw 'This content is too long to be encoded for the specified error correction.';
            this.code.version = version;
        } else {
            // Choose the error correction that gets the smallest size but the highest error correction
            let versions = this.errorCorrections.map((errorCorrection)=>this.versionForLength(this.length, errorCorrection));
            let version = versions[0];
            if (version > QRCode$1.MAX_VERSION) throw 'This string is too long to be encoded.';
            this.code.version = version;
            for(let index = 3; index >= 0; index--)if (versions[index] === version) {
                this.code.errorCorrection = this.errorCorrections[index];
                return;
            }
        }
    }
    capacity(encoding, errorCorrection) {
        return ({
            NUMERIC: {
                LOW: [
                    41,
                    77,
                    127,
                    187,
                    255,
                    322,
                    370,
                    461,
                    552,
                    652,
                    772,
                    883,
                    1022,
                    1101,
                    1250,
                    1408,
                    1548,
                    1725,
                    1903,
                    2061,
                    2232,
                    2409,
                    2620,
                    2812,
                    3057,
                    3283,
                    3517,
                    3669,
                    3909,
                    4158,
                    4417,
                    4686,
                    4965,
                    5253,
                    5529,
                    5836,
                    6153,
                    6479,
                    6743,
                    7089
                ],
                MEDIUM: [
                    34,
                    63,
                    101,
                    149,
                    202,
                    255,
                    293,
                    365,
                    432,
                    513,
                    604,
                    691,
                    796,
                    871,
                    991,
                    1082,
                    1212,
                    1346,
                    1500,
                    1600,
                    1708,
                    1872,
                    2059,
                    2188,
                    2395,
                    2544,
                    2701,
                    2857,
                    3035,
                    3289,
                    3486,
                    3693,
                    3909,
                    4134,
                    4343,
                    4588,
                    4775,
                    5039,
                    5313,
                    5596
                ],
                QUARTER: [
                    27,
                    48,
                    77,
                    111,
                    144,
                    178,
                    207,
                    259,
                    312,
                    364,
                    427,
                    489,
                    580,
                    621,
                    703,
                    775,
                    876,
                    948,
                    1063,
                    1159,
                    1224,
                    1358,
                    1468,
                    1588,
                    1718,
                    1804,
                    1933,
                    2085,
                    2181,
                    2358,
                    2473,
                    2670,
                    2805,
                    2949,
                    3081,
                    3244,
                    3417,
                    3599,
                    3791,
                    3993
                ],
                HIGH: [
                    17,
                    34,
                    58,
                    82,
                    106,
                    139,
                    154,
                    202,
                    235,
                    288,
                    331,
                    374,
                    427,
                    468,
                    530,
                    602,
                    674,
                    746,
                    813,
                    919,
                    969,
                    1056,
                    1108,
                    1228,
                    1286,
                    1425,
                    1501,
                    1581,
                    1677,
                    1782,
                    1897,
                    2022,
                    2157,
                    2301,
                    2361,
                    2524,
                    2625,
                    2735,
                    2927,
                    3057
                ]
            },
            ALPHANUMERIC: {
                LOW: [
                    25,
                    47,
                    77,
                    114,
                    154,
                    195,
                    224,
                    279,
                    335,
                    395,
                    468,
                    535,
                    619,
                    667,
                    758,
                    854,
                    938,
                    1046,
                    1153,
                    1249,
                    1352,
                    1460,
                    1588,
                    1704,
                    1853,
                    1990,
                    2132,
                    2223,
                    2369,
                    2520,
                    2677,
                    2840,
                    3009,
                    3183,
                    3351,
                    3537,
                    3729,
                    3927,
                    4087,
                    4296
                ],
                MEDIUM: [
                    20,
                    38,
                    61,
                    90,
                    122,
                    154,
                    178,
                    221,
                    262,
                    311,
                    366,
                    419,
                    483,
                    528,
                    600,
                    656,
                    734,
                    816,
                    909,
                    970,
                    1035,
                    1134,
                    1248,
                    1326,
                    1451,
                    1542,
                    1637,
                    1732,
                    1839,
                    1994,
                    2113,
                    2238,
                    2369,
                    2506,
                    2632,
                    2780,
                    2894,
                    3054,
                    3220,
                    3391
                ],
                QUARTER: [
                    16,
                    29,
                    47,
                    67,
                    87,
                    108,
                    125,
                    157,
                    189,
                    221,
                    259,
                    296,
                    352,
                    376,
                    426,
                    470,
                    531,
                    574,
                    644,
                    702,
                    742,
                    823,
                    890,
                    963,
                    1041,
                    1094,
                    1172,
                    1263,
                    1322,
                    1429,
                    1499,
                    1618,
                    1700,
                    1787,
                    1867,
                    1966,
                    2071,
                    2181,
                    2298,
                    2420
                ],
                HIGH: [
                    10,
                    20,
                    35,
                    50,
                    64,
                    84,
                    93,
                    122,
                    143,
                    174,
                    200,
                    227,
                    259,
                    283,
                    321,
                    365,
                    408,
                    452,
                    493,
                    557,
                    587,
                    640,
                    672,
                    744,
                    779,
                    864,
                    910,
                    958,
                    1016,
                    1080,
                    1150,
                    1226,
                    1307,
                    1394,
                    1431,
                    1530,
                    1591,
                    1658,
                    1774,
                    1852
                ]
            },
            KANJI: {
                LOW: [
                    10,
                    20,
                    32,
                    48,
                    65,
                    82,
                    95,
                    118,
                    141,
                    167,
                    198,
                    226,
                    262,
                    282,
                    320,
                    361,
                    397,
                    442,
                    488,
                    528,
                    572,
                    618,
                    672,
                    721,
                    784,
                    842,
                    902,
                    940,
                    1002,
                    1066,
                    1132,
                    1201,
                    1273,
                    1347,
                    1417,
                    1496,
                    1577,
                    1661,
                    1729,
                    1817
                ],
                MEDIUM: [
                    8,
                    16,
                    26,
                    38,
                    52,
                    65,
                    75,
                    93,
                    111,
                    131,
                    155,
                    177,
                    204,
                    223,
                    254,
                    277,
                    310,
                    345,
                    384,
                    410,
                    438,
                    480,
                    528,
                    561,
                    614,
                    652,
                    692,
                    732,
                    778,
                    843,
                    894,
                    947,
                    1002,
                    1060,
                    1113,
                    1176,
                    1224,
                    1292,
                    1362,
                    1435
                ],
                QUARTER: [
                    7,
                    12,
                    20,
                    28,
                    37,
                    45,
                    53,
                    66,
                    80,
                    93,
                    109,
                    125,
                    149,
                    159,
                    180,
                    198,
                    224,
                    243,
                    272,
                    297,
                    314,
                    348,
                    376,
                    407,
                    440,
                    462,
                    496,
                    534,
                    559,
                    604,
                    634,
                    684,
                    719,
                    756,
                    790,
                    832,
                    876,
                    923,
                    972,
                    1024
                ],
                HIGH: [
                    4,
                    8,
                    15,
                    21,
                    27,
                    36,
                    39,
                    52,
                    60,
                    74,
                    85,
                    96,
                    109,
                    120,
                    136,
                    154,
                    173,
                    191,
                    208,
                    235,
                    248,
                    270,
                    284,
                    315,
                    330,
                    365,
                    385,
                    405,
                    430,
                    457,
                    486,
                    518,
                    553,
                    590,
                    605,
                    647,
                    673,
                    701,
                    750,
                    784
                ]
            },
            BYTE: {
                LOW: [
                    17,
                    32,
                    53,
                    78,
                    106,
                    134,
                    154,
                    192,
                    230,
                    271,
                    321,
                    367,
                    425,
                    458,
                    520,
                    586,
                    644,
                    718,
                    792,
                    858,
                    929,
                    1003,
                    1091,
                    1171,
                    1273,
                    1367,
                    1465,
                    1528,
                    1628,
                    1732,
                    1840,
                    1952,
                    2068,
                    2188,
                    2303,
                    2431,
                    2563,
                    2699,
                    2809,
                    2953
                ],
                MEDIUM: [
                    14,
                    26,
                    42,
                    62,
                    84,
                    106,
                    122,
                    152,
                    180,
                    213,
                    251,
                    287,
                    331,
                    362,
                    412,
                    450,
                    504,
                    560,
                    624,
                    666,
                    711,
                    779,
                    857,
                    911,
                    997,
                    1059,
                    1125,
                    1190,
                    1264,
                    1370,
                    1452,
                    1538,
                    1628,
                    1722,
                    1809,
                    1911,
                    1989,
                    2099,
                    2213,
                    2331
                ],
                QUARTER: [
                    11,
                    20,
                    32,
                    46,
                    60,
                    74,
                    86,
                    108,
                    130,
                    151,
                    177,
                    203,
                    241,
                    258,
                    292,
                    322,
                    364,
                    394,
                    442,
                    482,
                    509,
                    565,
                    611,
                    661,
                    715,
                    751,
                    805,
                    868,
                    908,
                    982,
                    1030,
                    1112,
                    1168,
                    1228,
                    1283,
                    1351,
                    1423,
                    1499,
                    1579,
                    1663
                ],
                HIGH: [
                    7,
                    14,
                    24,
                    34,
                    44,
                    58,
                    64,
                    84,
                    98,
                    119,
                    137,
                    155,
                    177,
                    194,
                    220,
                    250,
                    280,
                    310,
                    338,
                    382,
                    403,
                    439,
                    461,
                    511,
                    535,
                    593,
                    625,
                    658,
                    698,
                    742,
                    790,
                    842,
                    898,
                    958,
                    983,
                    1051,
                    1093,
                    1139,
                    1219,
                    1273
                ]
            }
        })[encoding][errorCorrection];
    }
    get errorCorrections() {
        return [
            ERROR_CORRECTION.LOW,
            ERROR_CORRECTION.MEDIUM,
            ERROR_CORRECTION.QUARTER,
            ERROR_CORRECTION.HIGH
        ];
    }
    penaltyForMatrix(matrix) {
        /*
      Return the penalty score for the symbol, according to the following criteria:
      Penalty 1: A penalty (n-2) for each group of five or more same-colored modules in a row (or column)
      Penalty 2: A penalty (3) for each 2x2 area of same-colored modules
      Penalty 3: A penalty (40) if there are patterns that look similar to the finder patterns
      Penalty 4: A penalty based on the percentage of tiles that are black / white
    */ let penalty = 0;
        const dimension = matrix.content.length;
        let current, last, run, runTest, finderPattern;
        for(let y = 0; y < dimension - 1; y++){
            current = matrix.bitAt(0, y);
            last = current;
            run = 1;
            runTest = current;
            finderPattern = current;
            for(let x = 1; x < 10; x++){
                current = matrix.bitAt(x, y);
                if (last === current) {
                    if (matrix.bitAt(x, y + 1) === last && matrix.bitAt(x - 1, y + 1) === last) penalty += 3;
                } else last = current;
                if (runTest === current) run++;
                else {
                    if (run > 4) penalty += run - 2;
                    run = 1;
                    runTest = current;
                }
                finderPattern = finderPattern * 2 + current;
            }
            for(let x = 10; x < dimension; x++){
                current = matrix.bitAt(x, y);
                if (last === current) {
                    if (matrix.bitAt(x, y + 1) === last && matrix.bitAt(x - 1, y + 1) === last) penalty += 3;
                } else last = current;
                if (runTest === current) run++;
                else {
                    if (run > 4) penalty += run - 2;
                    run = 1;
                    runTest = current;
                }
                finderPattern = (finderPattern * 2 + current) % 2048;
                if (finderPattern === 1488 || finderPattern === 93) penalty += 40;
            }
            if (run > 4) penalty += run - 2;
        }
        // Process the last row without Penalty 2
        let lastY = dimension - 1;
        current = matrix.bitAt(0, lastY);
        run = 1;
        runTest = current;
        finderPattern = current;
        for(let x = 1; x < 10; x++){
            current = matrix.bitAt(x, lastY);
            if (runTest === current) run++;
            else {
                if (run > 4) penalty += run - 2;
                run = 1;
                runTest = current;
            }
            finderPattern = finderPattern * 2 + current;
        }
        for(let x = 10; x < dimension; x++){
            current = matrix.bitAt(x, lastY);
            if (runTest === current) run++;
            else {
                if (run > 4) penalty += run - 2;
                run = 1;
                runTest = current;
            }
            finderPattern = (finderPattern * 2 + current) % 2048;
            if (finderPattern === 1488 || finderPattern === 93) penalty += 40;
        }
        if (run > 4) penalty += run - 2;
        // Penalty 4
        let count = 0;
        for(let x = 0; x < dimension; x++){
            current = matrix.bitAt(x, 0);
            count += current;
            run = 1;
            runTest = current;
            finderPattern = current;
            for(let y = 1; y < 10; y++){
                current = matrix.bitAt(x, y);
                count += current;
                if (runTest === current) run++;
                else {
                    if (run > 4) penalty += run - 2;
                    run = 1;
                    runTest = current;
                }
                finderPattern = finderPattern * 2 + current;
            }
            for(let y = 10; y < dimension; y++){
                current = matrix.bitAt(x, y);
                count += current;
                if (runTest === current) run++;
                else {
                    if (run > 4) penalty += run - 2;
                    run = 1;
                    runTest = current;
                }
                finderPattern = (finderPattern * 2 + current) % 2048;
                if (finderPattern === 1488 || finderPattern === 93) penalty += 40;
            }
            if (run > 4) penalty += run - 2;
        }
        penalty += Math.floor(Math.abs(count / (dimension * dimension) - 0.5) * 10);
        return penalty;
    }
    toUtf16Bytes(string) {
        const bytes = [];
        for(let i = 0; i < string.length; i++){
            let code = string.charCodeAt(i);
            let remainder = code % 256;
            let quotient = (code - remainder) / 256;
            bytes.push(quotient);
            bytes.push(remainder);
        }
        return bytes;
    }
    toUtf8Bytes(string) {
        const bytes = [];
        let position = 0;
        for(let i = 0; i < string.length; i++){
            let code = string.charCodeAt(i);
            if (code < 128) bytes[position++] = code;
            else if (code < 2048) {
                bytes[position++] = code >> 6 | 192;
                bytes[position++] = code & 63 | 128;
            } else if ((code & 0xfc00) == 0xd800 && i + 1 < string.length && (string.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
                // Surrogate Pair
                code = 0x10000 + ((code & 0x03ff) << 10) + (string.charCodeAt(++i) & 0x03ff);
                bytes[position++] = code >> 18 | 240;
                bytes[position++] = code >> 12 & 63 | 128;
                bytes[position++] = code >> 6 & 63 | 128;
                bytes[position++] = code & 63 | 128;
            } else {
                bytes[position++] = code >> 12 | 224;
                bytes[position++] = code >> 6 & 63 | 128;
                bytes[position++] = code & 63 | 128;
            }
        }
        return bytes;
    }
    versionForLength(length1, errorCorrection) {
        let capacity;
        if (this.code.hasEci) capacity = DATA_CAPACITY[errorCorrection];
        else capacity = this.capacity(this.code.encoding, errorCorrection);
        let index = capacity.findIndex((allows)=>allows >= length1);
        if (index === -1) return 100;
        return index + 1;
    }
}
var qrcode = {
    ENCODING: ENCODING,
    ERROR_CORRECTION: ERROR_CORRECTION,
    BitWriter: BitWriter,
    Matrix: Matrix$1,
    BooleanMatrix: BooleanMatrix,
    QRCodeMap: QRCodeMap,
    QRCode: QRCode$1,
    QRCodeEncoder: QRCodeEncoder$1
};
const { QRCode, QRCodeEncoder } = qrcode;
/**
 * CLASS SquareQRCodeEncoder
 * While it can render an SVG, it mainly provides a base encoder for MarketQRCodeEncoder and EmbedQRCodeEncoder.
 * It adds these features to QRCodeEncoder:
 *   - svg rendering using the Turtle to edge trace data
 *   - hooks for adjusting the data for turtle rendering
 *   - using lowestPenalty calculation to make sure the code can be read
 *   - some base methods for SVG rendering
 * The following options can be specified:
 *   border          boolean (default false) whether to add a 4-pixel quiet zone
 *   invert          boolean (default false) light data on dark background when on
 *   styleBackground string to override style inserted in SVG background rectangle
 *   styleForeground string to override style inserted in SVG foreground data and patterns
 */ class SquareQRCodeEncoder$1 extends QRCodeEncoder {
    encode() {
        this.initializeEncoding();
        for (const errorCorrection of this.errorCorrections){
            this.code.errorCorrection = errorCorrection;
            this.initializeVersion();
            if (this.code.version < this.minimumVersion) continue;
            this.initializeCodewords();
            this.initializeMapping();
            this.initializeMasking();
            if (this.lowestPenalty < this.constructor.PENALTY_FOR_NEGATIVE_CAPACITY) {
                this.initializeTurtleData();
                this.initializeSvg();
                return;
            }
        }
        // go up in version, keep H errorCorrection
        const start = Math.max(this.minimumVersion, this.code.version + 1);
        for(let version = start; version <= QRCode.MAX_VERSION; version++){
            this.code.version = version;
            this.initializeCodewords();
            this.initializeMapping();
            this.initializeMasking();
            if (this.lowestPenalty < this.constructor.PENALTY_FOR_NEGATIVE_CAPACITY) {
                this.initializeTurtleData();
                this.initializeSvg();
                return;
            }
        }
    }
    initializeSvg() {
        const offset = this.svgOffset;
        const dimension = this.svgDimension;
        const foregroundStyle = this.svgForegroundStyle;
        const backgroundStyle = this.svgBackgroundStyle;
        const source = [];
        source.push(this.svgTag(dimension));
        source.push('<defs>');
        source.push(this.svgFinderPattern(foregroundStyle));
        source.push('</defs>');
        source.push(this.svgBackground(backgroundStyle, dimension, offset === 0 ? undefined : offset / 2));
        this.svgFinderPatterns(source, offset);
        this.svgTurtle(source, foregroundStyle, offset);
        source.push('</svg>');
        this.svg = source.join('');
    }
    initializeTurtleData() {
        // add timing and alignment patterns as data
        const data = this.code.data.copy();
        for (const point of this.code.timingPatternPositions)data.put(point.x, point.y, true);
        for (const point of this.code.alignmentPatternPositions)data.fillAlignmentPatternAt(point.x, point.y);
        this.turtleData = data;
    }
    get inverted() {
        const inverted = this.code.options.invert;
        if (inverted === undefined) return false;
        return inverted;
    }
    get hasBorder() {
        const hasBorder = this.code.options.border;
        if (hasBorder === undefined) return false;
        return hasBorder;
    }
    get minimumVersion() {
        return 1;
    }
    async png() {
        if (this._png !== undefined) return this._png;
        if (this.svg === undefined) throw 'no SVG to convert to PNG';
        const image = new Image();
        const imageBlob = new Blob([
            this.svg
        ], {
            type: 'image/svg+xml;charset=utf-8'
        });
        image.src = URL.createObjectURL(imageBlob);
        await image.decode();
        const dimension = this.svgDimension;
        const canvas = document.createElement('canvas');
        canvas.width = dimension;
        canvas.height = dimension;
        canvas.getContext('2d').drawImage(image, 0, 0, dimension, dimension);
        this._png = canvas.toDataURL();
        return this._png;
    }
    svgBackground(style, dimension, cornerRadius) {
        if (style === '') return '';
        return cornerRadius === undefined ? `<rect ${style} x="0" y="0" width="${dimension}" height="${dimension}" />` : `<rect ${style} x="0" y="0" width="${dimension}" height="${dimension}" rx="${cornerRadius}" ry="${cornerRadius}" />`;
    }
    get svgBackgroundStyle() {
        const fromOptions = this.code.options.styleBackground;
        if (fromOptions !== undefined) return fromOptions;
        return this.inverted ? 'fill="black"' : 'fill="white"';
    }
    get svgDimension() {
        return 2 * this.svgOffset + 8 * this.code.dimension;
    }
    svgFinderPattern(style) {
        return `<path id="f" ${style} fill-rule="evenodd" d="M 0 10 a10,10 0 0 1 10,-10 h36 a10,10 0 0 1 10,10 v36 a10,10 0 0 1 -10,10 h-36 a10,10 0 0 1 -10,-10 Z M 8 10 a2,2 0 0 1 2,-2 h36 a2,2 0 0 1 2,2 v36 a2,2 0 0 1 -2,2 h-36 a2,2 0 0 1 -2,-2 Z M 16 18 a2,2 0 0 1 2,-2 h20 a2,2 0 0 1 2,2 v20 a2,2 0 0 1 -2,2 h-20 a2,2 0 0 1 -2,-2 Z" />`;
    }
    svgFinderPatterns(source, offset) {
        for (const point of this.code.finderPatternPositions)source.push(`<use xlink:href="#f" x="${point.x * 8 + offset}" y="${point.y * 8 + offset}" />`);
    }
    get svgForegroundStyle() {
        const fromOptions = this.code.options.styleForeground;
        if (fromOptions !== undefined) return fromOptions;
        return this.inverted ? 'fill="white"' : 'fill="black"';
    }
    get svgOffset() {
        return this.hasBorder ? 32 : 0;
    }
    svgTag(dimension) {
        return `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${dimension}" height="${dimension}" viewBox="0 0 ${dimension} ${dimension}">`;
    }
    svgTurtle(source, style, offset) {
        const dimension = this.code.dimension;
        for(let y = 0; y < dimension; y++){
            for(let x = 0; x < dimension; x++)if (this.turtleData.at(x, y)) source.push(new Turtle(this.turtleData, style, offset, x, y).element);
        }
    }
}
// static variables
SquareQRCodeEncoder$1.PENALTY_FOR_LEFTOVER_CAPACITY = [
    32,
    16,
    8,
    4,
    2,
    1
];
SquareQRCodeEncoder$1.PENALTY_FOR_NEGATIVE_CAPACITY = 10000;
/**
 * CLASS Turtle
 * This is used to draw a path at a point, drawing both the outline and any cutouts.
 *   data            the BooleanMatrix of encoded data, along with the format and version information
 *   style           injected into the SVG element
 *   offset          how many SVG pixels to offset the topleft corner
 *   x               the x coordinate of the pixel to start from
 *   y               the y coordinate of the pixel to start from
 * It is only exported to be used in tests.
 */ class Turtle {
    constructor(data, style, offset, x, y){
        this.data = data;
        this.dimension = data.width;
        this.style = style || '';
        this.offset = offset || 0;
        this.start = {
            x: x,
            y: y
        };
        this.visitedLocations = new Set();
        this.generateElement();
        this.clearVisited();
    }
    clearVisited() {
        this.visitedLocations.forEach((location)=>{
            const point = this.fromLocation(location);
            this.data.put(point.x, point.y, false);
        });
    }
    get element() {
        return this._element;
    }
    fromLocation(location) {
        const x = location % this.dimension;
        const y = (location - x) / this.dimension;
        return {
            x: x,
            y: y
        };
    }
    generateElement() {
        // build outside edges
        const startX = this.start.x;
        const startY = this.start.y;
        const startEdge = 'left';
        let x = startX;
        let y = startY;
        const outsideEdges = [];
        outsideEdges.push(startEdge);
        let edge = 'top';
        const tops = new Set();
        const rights = new Set();
        const bottoms = new Set();
        const lefts = new Set();
        lefts.add(this.toLocation(x, y));
        while(!(x === startX && y === startY && edge === startEdge)){
            outsideEdges.push(edge);
            const location = this.toLocation(x, y);
            this.visitLocation(location);
            switch(edge){
                case 'top':
                    tops.add(location);
                    if (!this.hasPixelAtCoordinate(x + 1, y)) edge = 'right';
                    else if (this.hasPixelAtCoordinate(x + 1, y - 1)) {
                        x += 1;
                        y -= 1;
                        edge = 'left';
                    } else x += 1;
                    break;
                case 'right':
                    rights.add(location);
                    if (!this.hasPixelAtCoordinate(x, y + 1)) edge = 'bottom';
                    else if (this.hasPixelAtCoordinate(x + 1, y + 1)) {
                        x += 1;
                        y += 1;
                        edge = 'top';
                    } else y += 1;
                    break;
                case 'bottom':
                    bottoms.add(location);
                    if (!this.hasPixelAtCoordinate(x - 1, y)) edge = 'left';
                    else if (this.hasPixelAtCoordinate(x - 1, y + 1)) {
                        x -= 1;
                        y += 1;
                        edge = 'right';
                    } else x -= 1;
                    break;
                case 'left':
                    lefts.add(location);
                    if (!this.hasPixelAtCoordinate(x, y - 1)) edge = 'top';
                    else if (this.hasPixelAtCoordinate(x - 1, y - 1)) {
                        x -= 1;
                        y -= 1;
                        edge = 'bottom';
                    } else y -= 1;
                    break;
            }
        }
        // render outside edges
        if (outsideEdges.length === 4) {
            // if it only a single pixel, just make it a rectangle
            this._element = `<rect ${this.style} x="${startX * 8 + this.offset}" y="${startY * 8 + this.offset}" width="8" height="8" rx="2" ry="2" />`;
            return;
        }
        let d = [];
        d.push(`M${startX * 8 + this.offset + 1} ${startY * 8 + this.offset + 4}`);
        let next = outsideEdges[0];
        outsideEdges.push(next);
        let now;
        let length1 = 0;
        for(let i = 1; i < outsideEdges.length; i++){
            now = next;
            next = outsideEdges[i];
            if (now === next) length1 += 8;
            else if (now === 'top' && next === 'right') {
                if (length1 !== 0) {
                    d.push(`h${length1}`);
                    length1 = 0;
                }
                d.push('a3,3 0 0 1 3,3');
            } else if (now === 'right' && next === 'bottom') {
                if (length1 !== 0) {
                    d.push(`v${length1}`);
                    length1 = 0;
                }
                d.push('a3,3 0 0 1 -3,3');
            } else if (now === 'bottom' && next === 'left') {
                if (length1 !== 0) {
                    d.push(`h-${length1}`);
                    length1 = 0;
                }
                d.push('a3,3 0 0 1 -3,-3');
            } else if (now === 'left' && next === 'top') {
                if (length1 !== 0) {
                    d.push(`v-${length1}`);
                    length1 = 0;
                }
                d.push('a3,3 0 0 1 3,-3');
            } else if (now === 'top' && next === 'left') {
                d.push(`h${length1 + 5}`);
                length1 = 5;
            } else if (now === 'right' && next === 'top') {
                d.push(`v${length1 + 5}`);
                length1 = 5;
            } else if (now === 'bottom' && next === 'right') {
                d.push(`h-${length1 + 5}`);
                length1 = 5;
            } else if (now === 'left' && next === 'bottom') {
                d.push(`v-${length1 + 5}`);
                length1 = 5;
            }
        }
        if (length1 > 0) d.push(`v-${length1}`);
        d.push('z');
        // determine the interior pixels
        let interior = new Set();
        let process = new Set();
        this.visitedLocations.forEach((location)=>{
            if (!tops.has(location)) process.add(location - this.dimension);
            if (!lefts.has(location)) process.add(location - 1);
            if (!bottoms.has(location)) process.add(location + this.dimension);
            if (!rights.has(location)) process.add(location + 1);
        });
        process = [
            ...process
        ].filter((location)=>!this.hasVisitedLocation(location));
        while(process.length > 0){
            let fanOutFrom = [];
            process.forEach((location)=>{
                if (this.hasPixelAtLocation(location)) {
                    this.visitLocation(location);
                    fanOutFrom.push(location);
                } else interior.add(location);
            });
            process = new Set();
            fanOutFrom.forEach((location)=>{
                process.add(location - this.dimension);
                process.add(location + this.dimension);
                process.add(location + 1);
                process.add(location - 1);
            });
            process = [
                ...process
            ].filter((location)=>!this.hasVisitedLocation(location));
        }
        while(interior.size > 0){
            // determine and move to the top right
            let topRight, topRightX, topRightY;
            interior.forEach((location)=>{
                x = location % this.dimension;
                y = (location - x) / this.dimension;
                if (topRight === undefined || y < topRightY || y === topRightY && x > topRightX) {
                    topRight = location;
                    topRightX = x;
                    topRightY = y;
                }
            });
            d.push(`M${topRightX * 8 + this.offset + 9} ${topRightY * 8 + this.offset - 1}`);
            // move counterclockwise to remove interior
            x = topRightX;
            y = topRightY;
            edge = 'top';
            let distance = 5;
            while(!(x === topRightX && y === topRightY && edge === 'right')){
                const location = this.toLocation(x, y);
                interior.delete(location);
                switch(edge){
                    case 'top':
                        if (!this.hasPixelAtCoordinate(x - 1, y - 1)) {
                            if (distance > 0) d.push(`h-${distance}`);
                            d.push('a3,3 0 0 1 -3,-3');
                            distance = 0;
                            edge = 'right';
                            x--;
                            y--;
                        } else if (!this.hasPixelAtCoordinate(x - 1, y)) {
                            distance += 8;
                            x--;
                        } else {
                            d.push(`h-${distance + 5}`);
                            distance = 5;
                            edge = 'left';
                        }
                        break;
                    case 'left':
                        if (!this.hasPixelAtCoordinate(x - 1, y + 1)) {
                            if (distance > 0) d.push(`v${distance}`);
                            d.push('a3,3 0 0 1 -3,3');
                            distance = 0;
                            edge = 'top';
                            x--;
                            y++;
                        } else if (!this.hasPixelAtCoordinate(x, y + 1)) {
                            distance += 8;
                            y++;
                        } else {
                            d.push(`v${distance + 5}`);
                            distance = 5;
                            edge = 'bottom';
                        }
                        break;
                    case 'bottom':
                        if (!this.hasPixelAtCoordinate(x + 1, y + 1)) {
                            if (distance > 0) d.push(`h${distance}`);
                            d.push('a3,3 0 0 1 3,3');
                            distance = 0;
                            edge = 'left';
                            x++;
                            y++;
                        } else if (!this.hasPixelAtCoordinate(x + 1, y)) {
                            distance += 8;
                            x++;
                        } else {
                            d.push(`h${distance + 5}`);
                            distance = 5;
                            edge = 'right';
                        }
                        break;
                    case 'right':
                        if (!this.hasPixelAtCoordinate(x + 1, y - 1)) {
                            if (distance > 0) d.push(`v-${distance}`);
                            d.push('a3,3 0 0 1 3,-3');
                            distance = 0;
                            edge = 'bottom';
                            x++;
                            y--;
                        } else if (!this.hasPixelAtCoordinate(x, y - 1)) {
                            distance += 8;
                            y--;
                        } else {
                            d.push(`v-${distance + 5}`);
                            distance = 5;
                            edge = 'top';
                        }
                        break;
                }
            }
            d.push(`v-${distance + 5}`);
            d.push('z');
        }
        this._element = `<path ${this.style} d="${d.join('')}" />`;
    }
    hasPixelAtCoordinate(x, y) {
        if (x >= this.dimension || x < 0 || y >= this.dimension || y < 0) return false;
        return this.data.at(x, y);
    }
    hasPixelAtLocation(location) {
        const x = location % this.dimension;
        const y = (location - x) / this.dimension;
        return this.data.at(x, y);
    }
    hasVisitedCoordinate(x, y) {
        return this.hasVisitedLocation(this.toLocation(x, y));
    }
    hasVisitedLocation(location) {
        return this.visitedLocations.has(location);
    }
    toLocation(x, y) {
        return this.dimension * y + x;
    }
    visitCoordinate(x, y) {
        this.visitLocation(this.toLocation(x, y));
    }
    visitLocation(location) {
        this.visitedLocations.add(location);
    }
}
var squareQrcode = {
    SquareQRCodeEncoder: SquareQRCodeEncoder$1,
    Turtle: Turtle
};
const { Matrix } = qrcode;
const { SquareQRCodeEncoder } = squareQrcode;
const JEWEL_VALUE = Object.freeze({
    AVAILABLE: 'AVAILABLE',
    FALSE: 'FALSE',
    TRUE: 'TRUE',
    UNDECIDED: 'UNDECIDED'
});
/**
 * CLASS MarketQRCodeEncoder
 * This is used to generate an SVG for a QR code with a Square logo embedded in the center.
 * Contact #qrcode-design for design specifics
 * The following options can be specified:
 *   border          boolean (default false) whether to add a 6-pixel quiet zone
 *   invert          boolean (default false) light data on dark background when on
 *   monochrome      boolean (default false) whether to make it all black and white
 *                   This is useful for things like thermal printers that only print black
 *   styleBackground string to override style inserted in SVG background rectangle
 *   styleForeground string to override style inserted in SVG foreground data and patterns
 *   styleLogo       string to override style inserted in SVG for Square jewel
 */ class MarketQRCodeEncoder extends SquareQRCodeEncoder {
    static getJewel() {
        if (this.jewel !== undefined) return this.jewel;
        const jewel = Matrix.withAll(9, 9, JEWEL_VALUE.UNDECIDED);
        // corners are available
        jewel.put(0, 0, JEWEL_VALUE.AVAILABLE);
        jewel.put(0, 8, JEWEL_VALUE.AVAILABLE);
        jewel.put(8, 0, JEWEL_VALUE.AVAILABLE);
        jewel.put(8, 8, JEWEL_VALUE.AVAILABLE);
        // forced false
        for(let offset = 0; offset < 7; offset++){
            jewel.put(offset + 1, 0, JEWEL_VALUE.FALSE);
            jewel.put(offset + 1, 8, JEWEL_VALUE.FALSE);
            jewel.put(0, offset + 1, JEWEL_VALUE.FALSE);
            jewel.put(8, offset + 1, JEWEL_VALUE.FALSE);
        }
        jewel.put(3, 3, JEWEL_VALUE.FALSE);
        jewel.put(3, 5, JEWEL_VALUE.FALSE);
        jewel.put(5, 3, JEWEL_VALUE.FALSE);
        jewel.put(5, 5, JEWEL_VALUE.FALSE);
        // forced true
        for(let offset = 0; offset < 6; offset++){
            jewel.put(1 + offset, 1, JEWEL_VALUE.TRUE);
            jewel.put(2 + offset, 7, JEWEL_VALUE.TRUE);
            jewel.put(7, 1 + offset, JEWEL_VALUE.TRUE);
            jewel.put(1, 2 + offset, JEWEL_VALUE.TRUE);
        }
        jewel.put(4, 4, JEWEL_VALUE.TRUE);
        this.jewel = jewel;
        return jewel;
    }
    initializeSvg() {
        // generate the SVG
        const offset = this.svgOffset;
        const dimension = this.svgDimension;
        const foregroundStyle = this.svgForegroundStyle;
        const logoStyle = this.svgLogoStyle;
        const source = [];
        source.push(this.svgTag(dimension));
        source.push('<defs>');
        source.push(this.svgFinderPattern(foregroundStyle));
        source.push(this.svgLogo(logoStyle));
        source.push('</defs>');
        source.push(this.svgBackground(this.svgBackgroundStyle, dimension, offset === 0 ? undefined : 16));
        this.svgFinderPatterns(source, offset);
        this.svgTurtle(source, foregroundStyle, offset);
        // Square logo
        const logoPosition = (this.code.dimension - 7) * 4 + offset;
        source.push(`<use xlink:href="#s" x="${logoPosition}" y="${logoPosition}" />`);
        // finish
        source.push('</svg>');
        this.svg = source.join('');
    }
    initializeTurtleData() {
        super.initializeTurtleData();
        // clear out middle for Square logo
        const start = (this.code.dimension - 9) / 2;
        this.turtleData.fill(start, start + 1, 9, 7, false);
        this.turtleData.fill(start + 1, start, 7, 1, false);
        this.turtleData.fill(start + 1, start + 8, 7, 1, false);
    }
    get isMonochrome() {
        const isMonochrome = this.code.options.monochrome;
        if (isMonochrome === undefined) return false;
        return isMonochrome;
    }
    get minimumVersion() {
        // if the code version is 1, then the jewel would cut out the timing patterns
        return 2;
    }
    penaltyForMatrix(matrix) {
        const errorCorrectionCapacity = this.map.errorCorrectionCapacity;
        const messedUpBytes = errorCorrectionCapacity.map(()=>new Set());
        // figure out the messed up bytes based on putting the jewel in the center
        const jewel = this.constructor.getJewel();
        const start = (matrix.content.length - 9) / 2;
        for(let y = 0; y < 9; y++){
            const yData = y + start;
            for(let x = 0; x < 9; x++){
                const xData = x + start;
                const pixel = this.map.at(xData, yData);
                if (this.map.isDataPixel(pixel)) switch(jewel.at(x, y)){
                    case JEWEL_VALUE.FALSE:
                        if (matrix.at(xData, yData) !== false) messedUpBytes[pixel.chunk].add(pixel.byte);
                        break;
                    case JEWEL_VALUE.TRUE:
                        if (matrix.at(xData, yData) !== true) messedUpBytes[pixel.chunk].add(pixel.byte);
                        break;
                    case JEWEL_VALUE.UNDECIDED:
                        messedUpBytes[pixel.chunk].add(pixel.byte);
                        break;
                }
            }
        }
        // calculate penalty based on how many messed up bytes
        let penalty = 0;
        errorCorrectionCapacity.forEach((capacity, index)=>{
            const leftoverCapacity = capacity - messedUpBytes[index].size * 2;
            if (leftoverCapacity < 0) penalty += this.constructor.PENALTY_FOR_NEGATIVE_CAPACITY;
            else if (leftoverCapacity < this.constructor.PENALTY_FOR_LEFTOVER_CAPACITY.length) penalty += this.constructor.PENALTY_FOR_LEFTOVER_CAPACITY[leftoverCapacity];
        });
        // add additional penalties on trying to have the corners be filled
        if (!matrix.at(start, start)) penalty++;
        if (!matrix.at(start, start + 8)) penalty++;
        if (!matrix.at(start + 8, start)) penalty++;
        if (!matrix.at(start + 8, start + 8)) penalty++;
        return penalty;
    }
    get svgForegroundStyle() {
        const fromOptions = this.code.options.styleForeground;
        if (fromOptions !== undefined) return fromOptions;
        if (this.inverted) return this.isMonochrome ? 'fill="white"' : 'fill="white" fill-opacity="0.95"';
        else return this.isMonochrome ? 'fill="black"' : 'fill="black" fill-opacity="0.9"';
    }
    get svgLogoStyle() {
        if (this.isMonochrome) return this.svgForegroundStyle;
        const fromOptions = this.code.options.styleLogo;
        if (fromOptions !== undefined) return fromOptions;
        return 'fill="#006AFF"';
    }
    svgLogo(style) {
        return `<path id="s" ${style} fill-rule="evenodd" d="M 0 9.8 C 0 3.92 3.92 0 9.8 0 L 46.2 0 C 52.08 0 56 3.92 56 9.8 L 56 46.2 C 56 52.08 52.08 56 46.2 56 L 9.8 56 C 3.92 56 0 52.08 0 46.2 Z M 11.2 14 C 11.2 12.32 12.32 11.2 14 11.2 L 42 11.2 C 43.68 11.2 44.8 12.32 44.8 14 L 44.8 42 C 44.8 43.68 43.68 44.8 42 44.8 L 14 44.8 C 12.32 44.8 11.2 43.68 11.2 42 Z M 21 22.4 C 21 21.7 21.7 21 22.4 21 L 33.6 21 C 34.3 21 35 21.7 35 22.4 L 35 33.6 C 35 34.3 34.3 35 33.6 35 L 22.4 35 C 21.7 35 21 34.3 21 33.6 Z" />`;
    }
    get svgOffset() {
        return this.hasBorder ? 48 : 0;
    }
}
var marketQrcode = {
    MarketQRCodeEncoder: MarketQRCodeEncoder,
    JEWEL_VALUE: JEWEL_VALUE
};
var qrcodeEncoder = {
    ...marketQrcode,
    ...qrcode,
    ...squareQrcode
};
const marketQrcodeCss = ":host{display:block}:host svg .foreground{fill:var(--qrcode-normal-variant-foreground-color)}:host svg .background{fill:var(--qrcode-normal-variant-background-color)}:host svg .logo{fill:var(--qrcode-normal-variant-icon-color)}:host([monochrome]) .foreground{fill:var(--qrcode-monochrome-variant-foreground-color)}:host([monochrome]) .background{fill:var(--qrcode-monochrome-variant-background-color)}:host([monochrome]) .logo{fill:var(--qrcode-monochrome-variant-icon-color)}:host([size]) svg{width:100%;height:100%}";
const MarketQrcode$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.content = '';
        this.size = undefined;
        this.border = false;
        this.monochrome = false;
    }
    render() {
        const encoder = this.content ? new qrcodeEncoder.MarketQRCodeEncoder(this.content, {
            border: this.border,
            styleBackground: this.border ? 'class="background"' : '',
            styleForeground: 'class="foreground"',
            styleLogo: 'class="logo"'
        }) : null;
        const containerStyle = this.size !== undefined ? {
            height: `${this.size}px`,
            width: `${this.size}px`
        } : null;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-qrcode",
            "aria-hidden": "true"
        }, (0, $696Z8.h)("div", {
            innerHTML: encoder ? encoder.svg : '',
            style: containerStyle
        }));
    }
    static get style() {
        return marketQrcodeCss;
    }
};
const marketRadioCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--transition-duration:0.2s;--radio-offset:calc(-1 * var(--radio-border-size));position:relative;outline:none;position:relative;display:inline-block;width:var(--radio-width);height:var(--radio-height);border:var(--radio-border-size) solid var(--radio-normal-state-normal-validity-unselected-value-border-color);border-radius:var(--radio-border-radius);background-color:var(--radio-normal-state-normal-validity-unselected-value-background-color)}input{position:absolute;top:var(--radio-offset);left:var(--radio-offset);width:var(--radio-width);height:var(--radio-height);margin:0;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.focus-ring{--focus-ring-position:calc(-1 * (var(--radio-border-size) + var(--radio-focus-ring-buffer-size) + var(--radio-focus-ring-border-size, 2px)));content:'';position:absolute;top:var(--focus-ring-position);right:var(--focus-ring-position);bottom:var(--focus-ring-position);left:var(--focus-ring-position);display:block;border:var(--radio-focus-ring-border-size, 2px) solid var(--radio-focus-ring-color);border-radius:calc(var(--radio-border-radius) + var(--radio-focus-ring-buffer-size) * 2);opacity:0;pointer-events:none;transition:opacity 0.2s}input:focus-visible+.focus-ring{opacity:0.5}svg{position:absolute;top:calc(50% - var(--radio-svg-radius));left:calc(50% - var(--radio-svg-radius));align-items:center;pointer-events:none}@media (hover: hover){:host(:hover),:host([hovered]){border-color:var(--radio-hover-state-normal-validity-unselected-value-border-color);background-color:var(--radio-hover-state-normal-validity-unselected-value-background-color)}}:host(:focus),:host([focused]){border-color:var(--radio-focus-state-normal-validity-unselected-value-border-color);background-color:var(--radio-focus-state-normal-validity-unselected-value-background-color)}:host(:active),:host([active]){border-color:var(--radio-pressed-state-normal-validity-unselected-value-border-color);background-color:var(--radio-pressed-state-normal-validity-unselected-value-background-color)}:host([invalid]){border-color:var(--radio-normal-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-normal-state-invalid-validity-unselected-value-background-color)}@media (hover: hover){:host([invalid]:hover),:host([invalid][hovered]){border-color:var(--radio-hover-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-hover-state-invalid-validity-unselected-value-background-color)}}:host([invalid]:focus),:host([invalid][focused]){border-color:var(--radio-focus-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-focus-state-invalid-validity-unselected-value-background-color)}:host([invalid]:active),:host([invalid][active]){border-color:var(--radio-pressed-state-invalid-validity-unselected-value-border-color);background-color:var(--radio-pressed-state-invalid-validity-unselected-value-background-color)}:host([disabled]),:host([invalid][disabled]){border-color:var(--radio-disabled-state-normal-validity-unselected-value-border-color);background-color:var(--radio-disabled-state-normal-validity-unselected-value-background-color)}:host([selected]){border-color:var(--radio-normal-state-normal-validity-selected-value-border-color);background-color:var(--radio-normal-state-normal-validity-selected-value-background-color)}:host([selected]) svg{fill:var(--radio-normal-state-normal-validity-selected-value-icon-color)}@media (hover: hover){:host([selected]:hover),:host([selected][hovered]){border-color:var(--radio-hover-state-normal-validity-selected-value-border-color);background-color:var(--radio-hover-state-normal-validity-selected-value-background-color)}:host([selected]:hover) svg,:host([selected][hovered]) svg{fill:var(--radio-normal-state-normal-validity-selected-value-icon-color)}}:host([selected]:focus),:host([selected][focused]){border-color:var(--radio-focus-state-normal-validity-selected-value-border-color);background-color:var(--radio-focus-state-normal-validity-selected-value-background-color)}:host([selected]:focus) svg,:host([selected][focused]) svg{fill:var(--radio-focus-state-normal-validity-selected-value-icon-color)}:host([selected]:active),:host([selected][active]){border-color:var(--radio-pressed-state-normal-validity-selected-value-border-color);background-color:var(--radio-pressed-state-normal-validity-selected-value-background-color)}:host([selected]:active) svg,:host([selected][active]) svg{fill:var(--radio-pressed-state-normal-validity-selected-value-icon-color)}:host([invalid][selected]){border-color:var(--radio-normal-state-invalid-validity-selected-value-border-color);background-color:var(--radio-normal-state-invalid-validity-selected-value-background-color)}:host([invalid][selected]) svg{fill:var(--radio-normal-state-invalid-validity-selected-value-icon-color)}@media (hover: hover){:host([invalid][selected]:hover),:host([invalid][selected][hovered]){border-color:var(--radio-hover-state-invalid-validity-selected-value-border-color);background-color:var(--radio-hover-state-invalid-validity-selected-value-background-color)}:host([invalid][selected]:hover) svg,:host([invalid][selected][hovered]) svg{fill:var(--radio-hover-state-invalid-validity-selected-value-icon-color)}}:host([invalid][selected]:focus),:host([invalid][selected][focused]){border-color:var(--radio-focus-state-invalid-validity-selected-value-border-color);background-color:var(--radio-focus-state-invalid-validity-selected-value-background-color)}:host([invalid][selected]:focus) svg,:host([invalid][selected][focused]) svg{fill:var(--radio-focus-state-invalid-validity-selected-value-icon-color)}:host([invalid][selected]:active),:host([invalid][selected][active]){border-color:var(--radio-pressed-state-invalid-validity-selected-value-border-color);background-color:var(--radio-pressed-state-invalid-validity-selected-value-background-color)}:host([invalid][selected]:active) svg,:host([invalid][selected][active]) svg{fill:var(--radio-pressed-state-invalid-validity-selected-value-icon-color)}:host([selected][disabled]),:host([selected][disabled][invalid]){border-color:var(--radio-disabled-state-normal-validity-selected-value-border-color);background-color:var(--radio-disabled-state-normal-validity-selected-value-background-color)}:host([selected][disabled]) svg,:host([selected][disabled][invalid]) svg{fill:var(--radio-disabled-state-normal-validity-selected-value-icon-color)}";
var ARIA_VALUE$1;
(function(ARIA_VALUE) {
    ARIA_VALUE["TRUE"] = "true";
    ARIA_VALUE["FALSE"] = "false";
})(ARIA_VALUE$1 || (ARIA_VALUE$1 = {}));
const MarketRadio$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketRadioValueChange = (0, $696Z8.createEvent)(this, "marketRadioValueChange", 7);
        this.selected = false;
        this.disabled = false;
        this.invalid = false;
        this.focused = false;
        this.hovered = false;
        this.active = false;
    }
    /**
   * Toggles `selected` prop, and emits a change event accordingly.
   * Used by `market-row` to sync its selected state w/ slotted radio buttons.
   */ setSelection(newValue) {
        if (typeof newValue !== 'boolean') return Promise.resolve();
        const prevValue = this.selected;
        if (prevValue !== newValue) {
            const { defaultPrevented } = this.marketRadioValueChange.emit({
                current: newValue,
                previous: prevValue
            });
            if (!defaultPrevented) this.selected = newValue;
        }
        return Promise.resolve();
    }
    /**
   * DEPRECATED (3.x): Toggles `selected` state (unrelated to the HTML attribute `value`).
   */ setValue(newValue) {
        /* eslint-disable-next-line no-console */ console.warn("market-radio's setValue() method has been deprecated. Use setSelection() instead.", this.el);
        this.setSelection(newValue);
        return Promise.resolve();
    }
    /**
   * Sets `active` state. Allows external elements to programmatically
   * trigger active styling, ex. when slotted as a control into `market-row`.
   */ setActive(value) {
        this.active = value;
        return Promise.resolve();
    }
    /**
   * Sets `hovered` state. Allows external elements to programmatically
   * trigger hover styling, ex. when slotted as a control into `market-row`.
   */ setHover(value) {
        this.hovered = value;
        return Promise.resolve();
    }
    /**
   * Sets `disabled` state. Allows external elements to programmatically
   * trigger disabled styling, ex. when slotted as a control into `market-row`.
   */ setDisabled(value) {
        this.disabled = value;
        return Promise.resolve();
    }
    /**
   * Sets `focused` state, except when disabled.
   * Allows external consumers to programmatically
   * trigger focused styling.
   */ setFocus(value = true) {
        if (this.disabled) return Promise.resolve();
        this.focused = value;
        return Promise.resolve();
    }
    componentDidRender() {
        if (!this.innerInput) this.innerInput = this.el.shadowRoot.querySelector('input');
        if (this.selected) this.innerInput.checked = this.selected;
    }
    onFocus() {
        if (this.disabled) return;
        this.focused = true;
        this.el.shadowRoot.querySelector('input').focus();
    }
    handleClick() {
        if (this.disabled) return;
        // once a radio is selected, it shouldn't be togglable/deselectable on click
        if (!this.selected) {
            this.setFocus();
            this.setSelection(true);
        }
    }
    render() {
        const ariaChecked = this.selected ? ARIA_VALUE$1.TRUE : ARIA_VALUE$1.FALSE;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-radio",
            role: "radio",
            "aria-checked": ariaChecked,
            onBlur: ()=>{
                this.setFocus(false);
            },
            onClick: ()=>{
                this.handleClick();
            },
            onFocus: ()=>{
                this.setFocus();
            }
        }, (0, $696Z8.h)("input", {
            type: "radio",
            "aria-checked": ariaChecked,
            "aria-label": getControlInputAriaLabel(this.el),
            checked: this.selected,
            disabled: this.disabled
        }), (0, $696Z8.h)("span", {
            class: "focus-ring"
        }), this.selected && (0, $696Z8.h)("svg", {
            width: "6",
            height: "6",
            viewBox: "0 0 6 6",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("circle", {
            cx: "3",
            cy: "3",
            r: "3"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketRadioCss;
    }
};
const marketRowCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--transition-duration:0.2s;--row-horizontal-spacing:16px;position:relative;display:block;margin:0 calc(-1 * var(--row-normal-variant-background-horizontal-outset-padding));background-color:var(--row-normal-variant-normal-state-background-color);transition:background-color var(--transition-duration)}:host::before{content:'';position:absolute;right:var(--row-normal-variant-background-horizontal-outset-padding);bottom:0;left:var(--row-normal-variant-background-horizontal-outset-padding);display:block;height:var(--row-normal-variant-separator-height);background-color:var(--row-normal-variant-normal-state-separator-color)}:host(:last-of-type)::before{content:none}.container{display:flex;justify-content:space-between;align-items:center;padding-right:var(--row-normal-variant-background-horizontal-outset-padding);padding-left:var(--row-normal-variant-background-horizontal-outset-padding);outline:none;text-decoration:none;-moz-column-gap:var(--row-horizontal-spacing);column-gap:var(--row-horizontal-spacing)}.main{display:flex;flex-grow:2;flex-direction:column;min-width:0}.side{display:flex;flex-direction:column;text-align:right}.drill-icon{flex-shrink:0;fill:var(--row-normal-variant-normal-state-drill-color)}.hidden{display:none;}::slotted(*){cursor:inherit}::slotted([slot='label']){display:block;margin:0;color:var(--row-normal-variant-normal-state-text-color)}::slotted([slot='subtext']){display:block;margin:0;color:var(--row-normal-variant-normal-state-subtext-color)}::slotted([slot='side-label']){display:block;margin:0;color:var(--row-normal-variant-normal-state-side-text-primary-color)}::slotted([slot='side-subtext']){display:block;margin:0;color:var(--row-normal-variant-normal-state-side-text-secondary-color)}::slotted([slot='control']),::slotted([slot='leading-accessory']),::slotted([slot='trailing-accessory']){flex-shrink:0}:host(.market-drag-placeholder)::before{content:'' !important;top:0;bottom:0;display:block !important;height:auto;background-color:var(--core-fill-50-color)}:host(.market-drag-placeholder) *,:host(.market-drag-placeholder) ::slotted(*){opacity:0}:host(.market-drag-clone){margin:0;border-radius:calc(var(--core-radius-10) * 1px);background-color:var(--core-surface-20-color);box-shadow:0 4px 8px rgba(0, 0, 0, 0.1);opacity:0.9;cursor:grabbing;transition:none}:host(.market-drag-clone)::before{display:none}:host(.market-drag-clone) .market-drag-handle{cursor:grabbing}:host(.market-drag-released){transition:transform 100ms ease}:host([size='small']){min-height:var(--row-small-size-min-height, 40px);font-size:var(--row-small-size-text-size);line-height:var(--row-small-size-text-leading);letter-spacing:var(--row-small-size-text-tracking);text-transform:var(--row-small-size-text-case);}:host([size='small']) .container{padding-top:var(--row-small-size-vertical-padding);padding-bottom:var(--row-small-size-vertical-padding)}:host([size='small']) .main{gap:var(--row-small-size-text-vertical-spacing)}:host([size='small']) .side{gap:var(--row-small-size-text-vertical-spacing)}:host([size='small']) ::slotted([slot='label']){font-weight:var(--row-small-size-text-weight) !important;font-size:var(--row-small-size-text-size) !important;line-height:var(--row-small-size-text-leading) !important;letter-spacing:var(--row-small-size-text-tracking) !important;text-transform:var(--row-small-size-text-case) !important}:host([size='small']) ::slotted([slot='subtext']){font-weight:var(--row-small-size-subtext-weight) !important;font-size:var(--row-small-size-subtext-size) !important;line-height:var(--row-small-size-subtext-leading) !important;letter-spacing:var(--row-small-size-subtext-tracking) !important;text-transform:var(--row-small-size-subtext-case) !important}:host([size='small']) ::slotted([slot='side-label']){font-weight:var(--row-small-size-side-text-primary-weight) !important;font-size:var(--row-small-size-side-text-primary-size) !important;line-height:var(--row-small-size-side-text-primary-leading) !important;letter-spacing:var(--row-small-size-side-text-primary-tracking) !important;text-transform:var(--row-small-size-side-text-primary-case) !important}:host([size='small']) ::slotted([slot='side-subtext']){font-weight:var(--row-small-size-side-text-secondary-weight) !important;font-size:var(--row-small-size-side-text-secondary-size) !important;line-height:var(--row-small-size-side-text-secondary-leading) !important;letter-spacing:var(--row-small-size-side-text-secondary-tracking) !important;text-transform:var(--row-small-size-side-text-secondary-case) !important}:host([size='medium']){min-height:var(--row-medium-size-min-height, 56px);font-size:var(--row-medium-size-text-size);line-height:var(--row-medium-size-text-leading);letter-spacing:var(--row-medium-size-text-tracking);text-transform:var(--row-medium-size-text-case);}:host([size='medium']) .container{padding-top:var(--row-medium-size-vertical-padding);padding-bottom:var(--row-medium-size-vertical-padding)}:host([size='medium']) .main{gap:var(--row-medium-size-text-vertical-spacing)}:host([size='medium']) .side{gap:var(--row-medium-size-text-vertical-spacing)}:host([size='medium']) ::slotted([slot='label']){font-weight:var(--row-medium-size-text-weight) !important;font-size:var(--row-medium-size-text-size) !important;line-height:var(--row-medium-size-text-leading) !important;letter-spacing:var(--row-medium-size-text-tracking) !important;text-transform:var(--row-medium-size-text-case) !important}:host([size='medium']) ::slotted([slot='subtext']){font-weight:var(--row-medium-size-subtext-weight) !important;font-size:var(--row-medium-size-subtext-size) !important;line-height:var(--row-medium-size-subtext-leading) !important;letter-spacing:var(--row-medium-size-subtext-tracking) !important;text-transform:var(--row-medium-size-subtext-case) !important}:host([size='medium']) ::slotted([slot='side-label']){font-weight:var(--row-medium-size-side-text-primary-weight) !important;font-size:var(--row-medium-size-side-text-primary-size) !important;line-height:var(--row-medium-size-side-text-primary-leading) !important;letter-spacing:var(--row-medium-size-side-text-primary-tracking) !important;text-transform:var(--row-medium-size-side-text-primary-case) !important}:host([size='medium']) ::slotted([slot='side-subtext']){font-weight:var(--row-medium-size-side-text-secondary-weight) !important;font-size:var(--row-medium-size-side-text-secondary-size) !important;line-height:var(--row-medium-size-side-text-secondary-leading) !important;letter-spacing:var(--row-medium-size-side-text-secondary-tracking) !important;text-transform:var(--row-medium-size-side-text-secondary-case) !important}:host{position:relative;outline:none}.container::after{--focus-ring-position:calc(-1 * (var(--row-focus-ring-border-size) + var(--row-focus-ring-buffer-size) + var(--row-focus-ring-border-size)));content:'';position:absolute;top:var(--focus-ring-position);right:var(--focus-ring-position);bottom:var(--focus-ring-position);left:var(--focus-ring-position);display:block;border:var(--row-focus-ring-border-size) solid var(--row-normal-variant-focus-ring-color);border-radius:calc(var(--row-focus-ring-radius) + var(--row-focus-ring-buffer-size) * 2);opacity:0;pointer-events:none;transition:opacity 0.2s;inset:0}.container:focus-visible::after,:host(:focus-visible) .container::after{opacity:0.5}:host(.preload) ::slotted([slot='control']){--row-slotted-control-transition:none}:host([role=\"option\"]){border-radius:calc(var(--row-normal-variant-background-radius) * 1px);outline:none;cursor:pointer}@media (hover: hover){:host([role=\"option\"]:hover){background-color:var(--row-normal-variant-hover-state-background-color)}:host([role=\"option\"]:hover)::before{background-color:var(--row-normal-variant-hover-state-separator-color)}:host([role=\"option\"]:hover) .drill-icon{fill:var(--row-normal-variant-hover-state-drill-color)}:host([role=\"option\"]:hover) ::slotted([slot='label']){color:var(--row-normal-variant-hover-state-text-color)}:host([role=\"option\"]:hover) ::slotted([slot='subtext']){color:var(--row-normal-variant-hover-state-subtext-color)}:host([role=\"option\"]:hover) ::slotted([slot='side-label']){color:var(--row-normal-variant-hover-state-side-text-primary-color)}:host([role=\"option\"]:hover) ::slotted([slot='side-subtext']){color:var(--row-normal-variant-hover-state-side-text-secondary-color)}}:host([role=\"option\"]:focus){background-color:var(--row-normal-variant-focus-state-background-color)}:host([role=\"option\"]:focus)::before{background-color:var(--row-normal-variant-focus-state-separator-color)}:host([role=\"option\"]:focus) .drill-icon{fill:var(--row-normal-variant-focus-state-drill-color)}:host([role=\"option\"]:focus) ::slotted([slot='label']){color:var(--row-normal-variant-focus-state-text-color)}:host([role=\"option\"]:focus) ::slotted([slot='subtext']){color:var(--row-normal-variant-focus-state-subtext-color)}:host([role=\"option\"]:focus) ::slotted([slot='side-label']){color:var(--row-normal-variant-focus-state-side-text-primary-color)}:host([role=\"option\"]:focus) ::slotted([slot='side-subtext']){color:var(--row-normal-variant-focus-state-side-text-secondary-color)}:host([role=\"option\"][selected]:not(.has-slotted-control)){background-color:var(--row-normal-variant-selected-state-background-color)}:host([role=\"option\"][selected]:not(.has-slotted-control))::before{background-color:var(--row-normal-variant-selected-state-separator-color)}:host([role=\"option\"][selected]:not(.has-slotted-control)) .drill-icon{fill:var(--row-normal-variant-selected-state-drill-color)}:host([role=\"option\"][selected]:not(.has-slotted-control)) ::slotted([slot='label']){color:var(--row-normal-variant-selected-state-text-color)}:host([role=\"option\"][selected]:not(.has-slotted-control)) ::slotted([slot='subtext']){color:var(--row-normal-variant-selected-state-subtext-color)}:host([role=\"option\"][selected]:not(.has-slotted-control)) ::slotted([slot='side-label']){color:var(--row-normal-variant-selected-state-side-text-primary-color)}:host([role=\"option\"][selected]:not(.has-slotted-control)) ::slotted([slot='side-subtext']){color:var(--row-normal-variant-selected-state-side-text-secondary-color)}:host([role=\"option\"]:active){background-color:var(--row-normal-variant-pressed-state-background-color)}:host([role=\"option\"]:active)::before{background-color:var(--row-normal-variant-pressed-state-separator-color)}:host([role=\"option\"]:active) .drill-icon{fill:var(--row-normal-variant-pressed-state-drill-color)}:host([role=\"option\"]:active) ::slotted([slot='label']){color:var(--row-normal-variant-pressed-state-text-color)}:host([role=\"option\"]:active) ::slotted([slot='subtext']){color:var(--row-normal-variant-pressed-state-subtext-color)}:host([role=\"option\"]:active) ::slotted([slot='side-label']){color:var(--row-normal-variant-pressed-state-side-text-primary-color)}:host([role=\"option\"]:active) ::slotted([slot='side-subtext']){color:var(--row-normal-variant-pressed-state-side-text-secondary-color)}:host([role=\"option\"][disabled]){background-color:var(--row-normal-variant-disabled-state-background-color);color:var(--row-normal-variant-disabled-state-text-color);pointer-events:none}:host([role=\"option\"][disabled])::before{background-color:var(--row-normal-variant-disabled-state-separator-color)}:host([role=\"option\"][disabled]) .drill-icon{fill:var(--row-normal-variant-disabled-state-drill-color)}:host([role=\"option\"][disabled]) ::slotted([slot='label']){color:var(--row-normal-variant-disabled-state-text-color)}:host([role=\"option\"][disabled]) ::slotted([slot='subtext']){color:var(--row-normal-variant-disabled-state-subtext-color)}:host([role=\"option\"][disabled]) ::slotted([slot='side-label']){color:var(--row-normal-variant-disabled-state-side-text-primary-color)}:host([role=\"option\"][disabled]) ::slotted([slot='side-subtext']){color:var(--row-normal-variant-disabled-state-side-text-secondary-color)}:host([role=\"option\"][disabled]) ::slotted(.market-accessory),:host([role=\"option\"][disabled]) ::slotted(img[slot*=\"accessory\"]),:host([role=\"option\"][disabled]) ::slotted(svg[slot*=\"accessory\"]),:host([role=\"option\"][disabled]) ::slotted(div[slot*=\"accessory\"]){opacity:var(--row-disabled-state-leading-accessory-opacity)}:host([role=\"option\"][disabled]) ::slotted(.market-tooltip){pointer-events:auto !important;}:host([slot='displayed-selection']){pointer-events:none}:host([slot='displayed-selection']) .container{padding:0}:host([slot='displayed-selection']) .main{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host([slot='displayed-selection']) ::slotted([slot='label']){overflow:hidden;font-weight:var(--field-input-weight);font-size:inherit;line-height:inherit;text-overflow:ellipsis;white-space:nowrap}:host([slot='displayed-selection']) .side{display:none}:host([slot='displayed-selection']) ::slotted([slot='subtext']),:host([slot='displayed-selection']) ::slotted([slot='side-label']),:host([slot='displayed-selection']) ::slotted([slot='side-subtext']),:host([slot='displayed-selection']) ::slotted([slot='leading-accessory']),:host([slot='displayed-selection']) ::slotted([slot='trailing-accessory']),:host([slot='displayed-selection']) ::slotted([slot='control']){display:none}:host([destructive]) ::slotted([slot='label']){color:var(--row-destructive-variant-normal-state-text-color)}:host([destructive]) ::slotted([slot='subtext']){color:var(--row-destructive-variant-normal-state-subtext-color)}:host([destructive]) ::slotted([slot='side-label']){color:var(--row-destructive-variant-normal-state-side-text-primary-color)}:host([destructive]) ::slotted([slot='side-subtext']){color:var(--row-destructive-variant-normal-state-side-text-secondary-color)}:host([destructive][role=\"option\"]){border-radius:calc(var(--row-destructive-variant-background-radius) * 1px)}@media (hover: hover){:host([destructive][role=\"option\"]:hover){background-color:var(--row-destructive-variant-hover-state-background-color)}:host([destructive][role=\"option\"]:hover)::before{background-color:var(--row-destructive-variant-hover-state-separator-color)}:host([destructive][role=\"option\"]:hover) .drill-icon{fill:var(--row-destructive-variant-hover-state-drill-color)}:host([destructive][role=\"option\"]:hover) ::slotted([slot='label']){color:var(--row-destructive-variant-hover-state-text-color)}:host([destructive][role=\"option\"]:hover) ::slotted([slot='subtext']){color:var(--row-destructive-variant-hover-state-subtext-color)}:host([destructive][role=\"option\"]:hover) ::slotted([slot='side-label']){color:var(--row-destructive-variant-hover-state-side-text-primary-color)}:host([destructive][role=\"option\"]:hover) ::slotted([slot='side-subtext']){color:var(--row-destructive-variant-hover-state-side-text-secondary-color)}}:host([destructive][role=\"option\"]:focus){background-color:var(--row-destructive-variant-focus-state-background-color)}:host([destructive][role=\"option\"]:focus)::before{background-color:var(--row-destructive-variant-focus-state-separator-color)}:host([destructive][role=\"option\"]:focus) .drill-icon{fill:var(--row-destructive-variant-focus-state-drill-color)}:host([destructive][role=\"option\"]:focus) ::slotted([slot='label']){color:var(--row-destructive-variant-focus-state-text-color)}:host([destructive][role=\"option\"]:focus) ::slotted([slot='subtext']){color:var(--row-destructive-variant-focus-state-subtext-color)}:host([destructive][role=\"option\"]:focus) ::slotted([slot='side-label']){color:var(--row-destructive-variant-focus-state-side-text-primary-color)}:host([destructive][role=\"option\"]:focus) ::slotted([slot='side-subtext']){color:var(--row-destructive-variant-focus-state-side-text-secondary-color)}:host([destructive][role=\"option\"][selected]:not(.has-slotted-control)){background-color:var(--row-destructive-variant-selected-state-background-color)}:host([destructive][role=\"option\"][selected]:not(.has-slotted-control))::before{background-color:var(--row-destructive-variant-selected-state-separator-color)}:host([destructive][role=\"option\"][selected]:not(.has-slotted-control)) .drill-icon{fill:var(--row-destructive-variant-selected-state-drill-color)}:host([destructive][role=\"option\"][selected]:not(.has-slotted-control)) ::slotted([slot='label']){color:var(--row-destructive-variant-selected-state-text-color)}:host([destructive][role=\"option\"][selected]:not(.has-slotted-control)) ::slotted([slot='subtext']){color:var(--row-destructive-variant-selected-state-subtext-color)}:host([destructive][role=\"option\"][selected]:not(.has-slotted-control)) ::slotted([slot='side-label']){color:var(--row-destructive-variant-selected-state-side-text-primary-color)}:host([destructive][role=\"option\"][selected]:not(.has-slotted-control)) ::slotted([slot='side-subtext']){color:var(--row-destructive-variant-selected-state-side-text-secondary-color)}:host([destructive][role=\"option\"]:active){background-color:var(--row-destructive-variant-pressed-state-background-color)}:host([destructive][role=\"option\"]:active)::before{background-color:var(--row-destructive-variant-pressed-state-separator-color)}:host([destructive][role=\"option\"]:active) .drill-icon{fill:var(--row-destructive-variant-pressed-state-drill-color)}:host([destructive][role=\"option\"]:active) ::slotted([slot='label']){color:var(--row-destructive-variant-pressed-state-text-color)}:host([destructive][role=\"option\"]:active) ::slotted([slot='subtext']){color:var(--row-destructive-variant-pressed-state-subtext-color)}:host([destructive][role=\"option\"]:active) ::slotted([slot='side-label']){color:var(--row-destructive-variant-pressed-state-side-text-primary-color)}:host([destructive][role=\"option\"]:active) ::slotted([slot='side-subtext']){color:var(--row-destructive-variant-pressed-state-side-text-secondary-color)}:host([destructive][role=\"option\"][disabled]){background-color:var(--row-destructive-variant-disabled-state-background-color);color:var(--row-destructive-variant-disabled-state-text-color);pointer-events:none}:host([destructive][role=\"option\"][disabled])::before{background-color:var(--row-destructive-variant-disabled-state-separator-color)}:host([destructive][role=\"option\"][disabled]) .drill-icon{fill:var(--row-destructive-variant-disabled-state-drill-color)}:host([destructive][role=\"option\"][disabled]) ::slotted([slot='label']){color:var(--row-destructive-variant-disabled-state-text-color)}:host([destructive][role=\"option\"][disabled]) ::slotted([slot='subtext']){color:var(--row-destructive-variant-disabled-state-subtext-color)}:host([destructive][role=\"option\"][disabled]) ::slotted([slot='side-label']){color:var(--row-destructive-variant-disabled-state-side-text-primary-color)}:host([destructive][role=\"option\"][disabled]) ::slotted([slot='side-subtext']){color:var(--row-destructive-variant-disabled-state-side-text-secondary-color)}";
const MarketRow$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketRowSelected = (0, $696Z8.createEvent)(this, "marketRowSelected", 7);
        this.marketRowDeselected = (0, $696Z8.createEvent)(this, "marketRowDeselected", 7);
        this.selected = false;
        this.value = undefined;
        this.disabled = false;
        this.size = 'medium';
        this.interactive = false;
        this.transient = false;
        this.togglable = true;
        this.variant = 'regular';
        this.destructive = false;
        this.controlPosition = 'trailing';
        this.href = undefined;
        this.target = undefined;
        this.dragEnabled = false;
        this.dragHandlePosition = 'trailing';
        this.slottedControl = undefined;
        this.hasSideText = false;
    }
    /**
   * If a control gets slotted in, set the value to match that of the row
   */ selectedChangeHandler() {
        if (this.slottedControl) this.slottedControl.setSelection(this.selected);
    }
    /**
   * If a control gets slotted in, set the value to match that of the row
   */ disabledChangeHandler() {
        if (this.slottedControl) this.slottedControl.setDisabled(this.disabled);
    }
    /**
   * Used for setting the selection state to true without emiting the `marketRowSelected` event.
   */ silentlySelect() {
        this.selected = true;
        return Promise.resolve();
    }
    /**
   * Used for setting the selection state to false without emiting the `marketRowDeselected` event.
   */ silentlyDeselect() {
        this.selected = false;
        return Promise.resolve();
    }
    /**
   * Used for manually setting `selected` to false. Generally speaking, it
   * is preferable to avoid using this method and allow `market-row` to
   * manage its own selection state based on user interaction. It should only
   * be used for parent components that need to manage a group of rows, such as
   * `market-list`.
   */ deselect() {
        const currentRow = {
            value: this.value
        };
        this.selected = false;
        this.marketRowDeselected.emit(currentRow);
        return Promise.resolve();
    }
    /**
   * Used for toggling the row's selected state.
   */ toggle() {
        this.selected = !this.selected;
        return Promise.resolve();
    }
    registerSlottedControl() {
        var _a;
        this.slottedControl = this.el.querySelector([
            getNamespacedTagFor('market-checkbox'),
            getNamespacedTagFor('market-radio'),
            getNamespacedTagFor('market-toggle')
        ].join(','));
        if (this.slottedControl) {
            this.interactive = true;
            this.selectedChangeHandler();
            this.disabledChangeHandler();
            const slottedControlLabel = (_a = this.el.querySelector('[slot="label"]')) === null || _a === void 0 ? void 0 : _a.textContent;
            this.slottedControl.setAttribute('aria-label', slottedControlLabel);
        }
    }
    connectedCallback() {
        // drill variant rows should be interactive
        if (this.variant === 'drill') this.interactive = true;
        // link rows should not be selectable
        if (this.href) this.transient = true;
    }
    setControlActive(value) {
        if (this.slottedControl) this.slottedControl.setActive(value);
    }
    setControlHover(value) {
        if (this.slottedControl) this.slottedControl.setHover(value);
    }
    handleClick(e) {
        // clicks on links inside row content shouldn't select the row itself
        if (this.disabled || e.target.tagName === 'A' || e.target.tagName === getNamespacedTagFor('market-link').toUpperCase()) return;
        // We only persist selections on interactive rows that don't have the
        // `transient` property.
        if (this.interactive && !this.transient) {
            const currentRow = {
                value: this.value
            };
            if (this.togglable) {
                this.toggle();
                if (this.selected) this.marketRowSelected.emit(currentRow);
                else this.marketRowDeselected.emit(currentRow);
            } else if (!this.selected) {
                this.selected = true;
                this.marketRowSelected.emit(currentRow);
            }
        }
    }
    handleKeydown(e) {
        // don't intercept keydown of descendant elements
        // e.g. when typing into nested input fields (gross)
        if (e.target !== this.el) return;
        switch(e.key){
            case 'Enter':
                this.handleClick(e);
                break;
            case ' ':
                this.handleClick(e);
                e.preventDefault(); // spacebar should not scroll page
                break;
        }
    }
    onDragStart(e) {
        const coords = e.detail;
        this.drag = new Draggable(this.el);
        this.drag.start(coords);
    }
    onDragMove(e) {
        const coords = e.detail;
        this.drag.move(coords);
    }
    async onDragEnd(e) {
        const coords = e.detail;
        await this.drag.end(coords);
        this.drag.destroy();
    }
    checkIfSideTextIsPresent() {
        const sideText = this.el.querySelector('[slot="side-label"], [slot="side-subtext"]');
        this.hasSideText = sideText ? true : false;
    }
    componentWillLoad() {
        this.checkIfSideTextIsPresent();
    }
    async componentDidUpdate() {
        // remove preload class (used to manage slotted control transitions)
        if (this.el.classList.contains('preload')) {
            await asyncRequestAnimationFrame();
            this.el.classList.remove('preload');
        }
    }
    render() {
        const { controlPosition, disabled, href, interactive, selected, slottedControl, target, variant, hasSideText, dragEnabled, dragHandlePosition } = this;
        // we include `href` here because we want to tab directly the rendered `a` tag
        // in that case, skipping the `market-row`.
        const tabindex = interactive && !disabled && !href ? '0' : null;
        const ContainerTag = href === undefined ? 'div' : 'a';
        const ContainerTagAttrs = ContainerTag === 'a' ? {
            href: href,
            target: target
        } : {};
        const leadingControl = controlPosition === 'leading';
        const MarketDragHandleTagName = getNamespacedTagFor('market-drag-handle');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            role: interactive ? 'option' : 'listitem',
            tabindex: tabindex,
            "aria-selected": interactive ? Boolean(selected).toString() : null,
            class: classNames('market-row', 'preload', {
                'has-slotted-control': typeof slottedControl !== 'undefined',
                'has-leading-control': leadingControl
            }),
            onMouseDown: ()=>this.setControlActive(true),
            onMouseUp: ()=>this.setControlActive(false),
            onMouseEnter: ()=>this.setControlHover(true),
            onMouseLeave: ()=>this.setControlHover(false),
            onClick: (e)=>this.handleClick(e),
            onKeydown: (e)=>this.handleKeydown(e),
            onMarketDragHandleDragStart: (e)=>this.onDragStart(e),
            onMarketDragHandleDragMove: (e)=>this.onDragMove(e),
            onMarketDragHandleDragEnd: (e)=>this.onDragEnd(e)
        }, (0, $696Z8.h)(ContainerTag, Object.assign({
            part: "container",
            class: "container"
        }, ContainerTagAttrs), dragEnabled && dragHandlePosition === 'leading' && (0, $696Z8.h)(MarketDragHandleTagName, null), leadingControl && (0, $696Z8.h)("slot", {
            name: "control",
            onSlotchange: ()=>this.registerSlottedControl()
        }), (0, $696Z8.h)("slot", {
            name: "leading-accessory"
        }), (0, $696Z8.h)("div", {
            class: "main",
            part: "main"
        }, (0, $696Z8.h)("slot", {
            name: "label"
        }), (0, $696Z8.h)("slot", {
            name: "subtext"
        }), (0, $696Z8.h)("slot", null)), (0, $696Z8.h)("div", {
            part: "side",
            class: classNames('side', {
                hidden: !hasSideText
            })
        }, (0, $696Z8.h)("slot", {
            name: "side-label",
            onSlotchange: ()=>this.checkIfSideTextIsPresent()
        }), (0, $696Z8.h)("slot", {
            name: "side-subtext",
            onSlotchange: ()=>this.checkIfSideTextIsPresent()
        })), (0, $696Z8.h)("slot", {
            name: "trailing-accessory"
        }), variant === 'regular' ? !leadingControl && (0, $696Z8.h)("slot", {
            name: "control",
            onSlotchange: ()=>this.registerSlottedControl()
        }) : (0, $696Z8.h)("svg", {
            class: "drill-icon",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M11.7071 7.29297C12.0976 7.68349 12.0976 8.31666 11.7071 8.70718L5.70711 14.7072L4.29289 13.293L9.58579 8.00008L4.29289 2.70718L5.70711 1.29297L11.7071 7.29297Z"
        })), dragEnabled && dragHandlePosition === 'trailing' && (0, $696Z8.h)(MarketDragHandleTagName, null)));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "selected": [
                "selectedChangeHandler"
            ],
            "disabled": [
                "disabledChangeHandler"
            ]
        };
    }
    static get style() {
        return marketRowCss;
    }
};
const marketSegmentCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--segmented-control-option-min-width:var(--core-small-size-minimum-height);display:flex;flex-direction:row;justify-content:center;align-items:center;min-width:var(--segmented-control-option-min-width);padding:var(--segmented-control-option-padding-vertical) var(--segmented-control-option-padding-horizontal);border-radius:var(--segmented-control-option-background-radius);color:var(--segmented-control-option-label-normal-state);font-weight:var(--segmented-control-option-label-weight);font-size:var(--segmented-control-option-label-size);line-height:var(--segmented-control-option-label-leading);letter-spacing:var(--segmented-control-option-label-tracking);text-align:center;cursor:pointer;transition:color var(--segmented-control-animation-duration)}:host([selected]){color:var(--segmented-control-option-label-selected-state);box-shadow:none !important;}:host([disabled]){background:var(--segmented-control-option-background-disabled-state-color);color:var(--segmented-control-option-label-disabled-state-color);cursor:not-allowed}:host(:hover:not([selected]):not([disabled])){--segmented-control-option-label-hover-state-color:var(--core-emphasis-text-color);color:var(--segmented-control-option-label-hover-state-color)}:host(:active:not([disabled])){color:var(--segmented-control-option-label-pressed-state-color)}";
const MarketSegment$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketSegmentSelectedChanged = (0, $696Z8.createEvent)(this, "marketSegmentSelectedChanged", 7);
        this.disabled = false;
        this.value = undefined;
        this.selected = false;
    }
    setSelectedState(state) {
        this.selected = state;
        return Promise.resolve();
    }
    selectSegment() {
        if (this.selected || this.disabled) return Promise.resolve();
        this.marketSegmentSelectedChanged.emit();
        return Promise.resolve();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            selected: this.selected,
            class: "market-segment",
            onClick: ()=>this.selectSegment()
        }, (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketSegmentCss;
    }
};
const marketSegmentedControlCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:relative;display:inline-flex;flex-direction:row;gap:calc(var(--segmented-control-padding-horizontal) * 2);align-items:center;min-width:100%;padding:var(--segmented-control-padding-vertical) var(--segmented-control-padding-horizontal);border-radius:var(--segmented-control-background-radius);background:var(--segmented-control-background-normal-state-color)}:host([disabled]){background:var(--segmented-control-background-disabled-state-color);color:var(--segmented-control-option-label-disabled-state-color)}::slotted(.market-segment){z-index:2;width:100%;height:100%}:host::before{content:'';position:absolute;left:var(--selected-slider-left);z-index:1;width:var(--selected-slider-width);height:calc(100% - var(--segmented-control-padding-vertical) * 2);border-radius:var(--segmented-control-option-background-radius);background:var(--segmented-control-option-background-selected-state-color);box-shadow:0 1px 2px rgba(0, 0, 0, 0.1), 0 0 4px rgba(0, 0, 0, 0.1);transition:left var(--segmented-control-animation-duration)}";
function isValueEmpty(value) {
    return value === '' || value === ' ' || value === null || value === undefined;
}
const MarketSegmentedControl$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketSegmentedSelectionDidChange = (0, $696Z8.createEvent)(this, "marketSegmentedSelectionDidChange", 7);
        this.items = undefined;
        this.value = '';
        this.disabled = false;
    }
    valueWatcher() {
        this.setSelectionsFromValue();
    }
    /**
   * If a segment gets slotted in, set the value to match that of the row
   */ disabledChangeHandler() {
        var _a;
        (_a = this.items) === null || _a === void 0 || _a.forEach((item)=>item.disabled = this.disabled);
    }
    /**
   * Select item that corresponds to passed value, or clear all values if value is empty string.
   */ setSelectionsFromValue() {
        var _a;
        (_a = this.items) === null || _a === void 0 || _a.forEach((item)=>{
            if (this.value === item.value) {
                item.setSelectedState(true);
                this.setSliderPosition(item);
            } else item.setSelectedState(false);
        });
    }
    /**
   * Sets the initial state of the segmented-control by updating and propagating props and setting
   * default value.
   */ setInternalState() {
        this.items = this.el.querySelectorAll(`${getNamespacedTagFor('market-segment')}`);
        this.selectedSlider = this.el.shadowRoot.getElementById('selected-slider');
        if (this.items.length > 0) {
            if (isValueEmpty(this.value)) this.value = this.items[0].value;
            this.setSelectionsFromValue();
        }
    }
    /**
   * Sets slider size to be the size of a segment
   */ setSliderSize() {
        var _a;
        this.el.style.setProperty('--selected-slider-width', `calc(${100 / ((_a = this.items) === null || _a === void 0 ? void 0 : _a.length)}% - ${cjs.SEGMENTED_CONTROL_PADDING_HORIZONTAL * 2}px)`);
    }
    /**
   * Sets slider position (left offset) based on the currently selected item
   */ setSliderPosition(selectedItem) {
        if (!selectedItem) {
            this.el.style.setProperty('--selected-slider-left', `${cjs.SEGMENTED_CONTROL_PADDING_HORIZONTAL}px`);
            return;
        }
        const newSelectionIndex = [
            ...this.items
        ].indexOf(selectedItem);
        this.el.style.setProperty('--selected-slider-left', `calc(${newSelectionIndex / this.items.length * 100}% + ${cjs.SEGMENTED_CONTROL_PADDING_HORIZONTAL}px)`);
    }
    /**
   * Sets the initial state of the segmented-control by updating and propagating props and setting
   * default value.
   */ defaultSlotchangeHandler() {
        this.setInternalState();
        this.setSliderSize();
    }
    marketSegmentSelectedEventHandler(e) {
        const newSelection = e.target;
        const prevSelection = this.el.querySelector(`${getNamespacedTagFor('market-segment')}[selected]`);
        prevSelection === null || prevSelection === void 0 || prevSelection.setSelectedState(false);
        newSelection.setSelectedState(true);
        this.setSliderPosition(newSelection);
        this.marketSegmentedSelectionDidChange.emit({
            selectedSegment: newSelection,
            selectedSegmentValue: newSelection.value,
            deselectedSegment: prevSelection,
            deselectedSegmentValue: prevSelection === null || prevSelection === void 0 ? void 0 : prevSelection.value
        });
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-segmented-control"
        }, (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.defaultSlotchangeHandler()
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "value": [
                "valueWatcher"
            ],
            "disabled": [
                "disabledChangeHandler"
            ]
        };
    }
    static get style() {
        return marketSegmentedControlCss;
    }
};
const sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const alignments = [
    'start',
    'end'
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
    return [
        'top',
        'bottom'
    ].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length1 = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length1] > rects.floating[length1]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>oppositeAlignmentMap[alignment]);
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = getSideAxis(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const alignLength = getAxisLength(alignmentAxis);
    const side = getSide(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch(getAlignment(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition$1 = async (reference, floating, config)=>{
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name, fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data, reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = 'clippingAncestors', rootBoundary = 'viewport', elementContext = 'floating', altBoundary = false, padding = 0 } = evaluate(options, state);
    const paddingObject = getPaddingObject(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = rectToClientRect(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement)=>getAlignment(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>getSide(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = placements, autoAlignment = true, ...detectOverflowOptions } = evaluate(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[getSide(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = getAlignment(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                getAlignment(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = getSide(placement);
    const alignment = getAlignment(placement);
    const isVertical = getSideAxis(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = evaluate(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            const { x, y } = state;
            const diffCoords = await convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x, y, placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = evaluate(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const crossAxis = getSideAxis(getSide(placement));
            const mainAxis = getOppositeAxis(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = clamp(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = clamp(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = evaluate(options, state);
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const side = getSide(placement);
            const alignment = getAlignment(placement);
            const isYAxis = getSideAxis(placement) === 'y';
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = max(overflow.left, 0);
                const xMax = max(overflow.right, 0);
                const yMin = max(overflow.top, 0);
                const yMax = max(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle$1(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].includes(getNodeName(element));
}
function isContainingBlock(element) {
    const webkit = isWebKit();
    const css = getComputedStyle$1(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getCssDimensions(element) {
    const css = getComputedStyle$1(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!isHTMLElement(domElement)) return createCoords(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? round(rect.width) : rect.width) / width;
    let y = ($ ? round(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const noOffsets = /*#__PURE__*/ createCoords(0);
function getVisualOffsets(element) {
    const win = getWindow(element);
    if (!isWebKit() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = createCoords(1);
    if (includeScale) {
        if (offsetParent) {
            if (isElement(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = getWindow(domElement);
        const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = getComputedStyle$1(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = getWindow(currentIFrame).frameElement;
        }
    }
    return rectToClientRect({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect, offsetParent, strategy } = _ref;
    const isOffsetParentAnElement = isHTMLElement(offsetParent);
    const documentElement = getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = createCoords(1);
    const offsets = createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
        if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
        if (isHTMLElement(offsetParent)) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = getDocumentElement(element);
    const scroll = getNodeScroll(element);
    const body = element.ownerDocument.body;
    const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if (getComputedStyle$1(body).direction === 'rtl') x += max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function getViewportRect(element, strategy) {
    const win = getWindow(element);
    const html = getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = isWebKit();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = getDocumentRect(getDocumentElement(element));
    else if (isElement(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = getParentNode(element);
    if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) return false;
    return getComputedStyle$1(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = getOverflowAncestors(element, [], false).filter((el)=>isElement(el) && getNodeName(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = getComputedStyle$1(element).position === 'fixed';
    let currentNode = elementIsFixed ? getParentNode(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while(isElement(currentNode) && !isLastTraversableNode(currentNode)){
        const computedStyle = getComputedStyle$1(currentNode);
        const currentNodeIsContaining = isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = max(rect.top, accRect.top);
        accRect.right = min(rect.right, accRect.right);
        accRect.bottom = min(rect.bottom, accRect.bottom);
        accRect.left = max(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    return getCssDimensions(element);
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = isHTMLElement(offsetParent);
    const documentElement = getDocumentElement(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function getTrueOffsetParent(element, polyfill) {
    if (!isHTMLElement(element) || getComputedStyle$1(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const window1 = getWindow(element);
    if (!isHTMLElement(element)) return window1;
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) return window1;
    return offsetParent || getContainingBlock(element) || window1;
}
const getElementRects = async function(_ref) {
    let { reference, floating, strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function isRTL(element) {
    return getComputedStyle$1(element).direction === 'rtl';
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: getDocumentElement,
    getClippingRect: getClippingRect,
    getOffsetParent: getOffsetParent,
    getElementRects: getElementRects,
    getClientRects: getClientRects,
    getDimensions: getDimensions,
    getScale: getScale,
    isElement: isElement,
    isRTL: isRTL
};
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = getDocumentElement(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left, top, width, height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = floor(top);
        const insetRight = floor(root.clientWidth - (left + width));
        const insetBottom = floor(root.clientHeight - (top + height));
        const insetLeft = floor(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: max(0, min(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === 'function', layoutShift = typeof IntersectionObserver === 'function', animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? getOverflowAncestors(referenceEl) : [],
        ...getOverflowAncestors(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return computePosition$1(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate(uuid) {
    return typeof uuid === 'string' && REGEX.test(uuid);
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!validate(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return stringify(rnds);
}
/**
 * helper functions for managing callback timing (ex. delay, throttle, debounce)
 *
 * these will probably be most useful in situations where we wish to respond to
 * user input events (particularly ones that happen in "streams" like scrolling,
 * window resizing, or typing) in a performant way.
 *
 * if this file ends up larger than a few functions, we should consider bringing
 * in lodash as a dependency instead: https://lodash.com/docs
 *
 * recommended pattern for using these functions in your stencil components:
 * myEventHandler = debounce(() => {
 *   // your code
 * }, timeout)
 */ /**
 * returns a function that will not be triggered until it stops being called for
 * N milliseconds, adapted from https://davidwalsh.name/javascript-debounce-function
 *
 * @param callback - callback to be executed after the wait
 * @param {number} wait - wait in milliseconds
 */ const debounce = (callback, wait)=>{
    let timeout;
    return (...args)=>{
        const later = ()=>{
            timeout = null;
            callback.apply(undefined, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};
const marketSelectCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:relative;outline:none;font-weight:var(--field-input-weight);font-size:var(--field-input-size);line-height:var(--field-input-leading);cursor:text}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;cursor:inherit}:host ::slotted(label){cursor:inherit}:host input:focus,:host ::slotted(input:focus),:host textarea:focus,:host ::slotted(textarea:focus){outline:none}:host input::-moz-placeholder,:host textarea::-moz-placeholder{color:var(--field-placeholder-text-color)}:host input::placeholder,:host textarea::placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::-moz-placeholder,:host ::slotted(textarea)::-moz-placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::placeholder,:host ::slotted(textarea)::placeholder{color:var(--field-placeholder-text-color)}:host([size='small']){font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}:host{border-radius:var(--field-border-radius);background-color:var(--field-normal-state-background-color);color:var(--field-normal-state-input-color)}:host::after{content:'';position:absolute;inset:0;border-radius:var(--field-border-radius);box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color);pointer-events:none}:host([invalid])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-invalid-validity-border-color)}:host(:hover){background-color:var(--field-hover-state-background-color);color:var(--field-hover-state-input-color)}:host(:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-normal-validity-border-color)}:host([invalid]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-invalid-validity-border-color)}:host([focused]){color:var(--field-focus-state-input-color)}:host([focused])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size)\n        var(--field-focus-state-normal-validity-border-color)}:host([focused][invalid])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size) var(--field-focus-state-invalid-validity-border-color)}:host([disabled]){background-color:var(--field-disabled-state-background-color) !important;color:var(--field-disabled-state-input-color) !important;cursor:not-allowed !important;}:host([disabled])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-disabled-state-border-color) !important}:host([value=\"\"]) ::slotted(label){color:var(--field-normal-state-empty-phase-label-color)}:host(:not([value=\"\"])) ::slotted(label),:host([value=\"\"][autofilled]) ::slotted(label){color:var(--field-normal-state-float-phase-label-color)}:host(:hover) ::slotted(label){color:var(--field-hover-state-empty-phase-label-color)}:host(:not([value=\"\"]):hover) ::slotted(label),:host([value=\"\"][autofilled]:hover) ::slotted(label){color:var(--field-hover-state-float-phase-label-color)}:host([focused]) ::slotted(label){color:var(--field-focus-state-float-phase-label-color)}:host([value=\"\"][disabled]) ::slotted(label){color:var(--field-disabled-state-empty-phase-label-color)}:host(:not([value=\"\"])[disabled]) ::slotted(label),:host([value=\"\"][autofilled][disabled]) ::slotted(label){color:var(--field-disabled-state-float-phase-label-color)}:host{--field-accessory-horizontal-spacing-size:16px;--field-size-small-accessory-horizontal-spacing-size:12px;--field-size-large-image-accessory-outer-spacing-size:12px;--field-size-medium-image-accessory-outer-spacing-size:4px;--field-size-large-button-accessory-outer-spacing-size:12px;--field-size-medium-button-accessory-outer-spacing-size:4px;--field-size-large-tooltip-accessory-horizontal-spacing-size:5px;--field-size-large-tooltip-accessory-vertical-spacing-size:-1px;--field-size-small-tooltip-accessory-horizontal-spacing-size:1px}:host ::slotted([slot='leading-accessory']){flex-shrink:0;margin-right:var(--field-accessory-horizontal-spacing-size);margin-left:var(--field-accessory-horizontal-spacing-size)}:host ::slotted(.market-accessory[slot='leading-accessory'][size='image']){margin-left:var(--field-size-large-image-accessory-outer-spacing-size)}:host ::slotted(.market-tooltip[slot='leading-accessory']){margin:var(--field-size-large-tooltip-accessory-vertical-spacing-size)\n      var(--field-size-large-tooltip-accessory-horizontal-spacing-size)}:host ::slotted(.market-button[slot='leading-accessory'][size='small']){margin-left:var(--field-size-large-button-accessory-outer-spacing-size)}:host ::slotted([slot='trailing-accessory']){flex-shrink:0;margin-right:var(--field-accessory-horizontal-spacing-size);margin-left:var(--field-accessory-horizontal-spacing-size)}:host ::slotted(.market-accessory[slot='trailing-accessory'][size='image']){margin-right:var(--field-size-large-image-accessory-outer-spacing-size)}:host ::slotted(.market-tooltip[slot='trailing-accessory']){margin:var(--field-size-large-tooltip-accessory-vertical-spacing-size)\n      var(--field-size-large-tooltip-accessory-horizontal-spacing-size)}:host ::slotted(.market-button[slot='trailing-accessory'][size='small']){margin-right:var(--field-size-large-button-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-accessory[slot='leading-accessory'][size='image']){margin-left:var(--field-size-medium-image-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-button[slot='leading-accessory'][size='small']){margin-left:var(--field-size-medium-button-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-accessory[slot='trailing-accessory'][size='image']){margin-right:var(--field-size-medium-image-accessory-outer-spacing-size)}:host([size='medium']) ::slotted(.market-button[slot='trailing-accessory'][size='small']){margin-right:var(--field-size-medium-button-accessory-outer-spacing-size)}:host([size='small']) ::slotted([slot='leading-accessory']),:host([size='small']) ::slotted([slot='trailing-accessory']){margin-right:var(--field-size-small-accessory-horizontal-spacing-size);margin-left:var(--field-size-small-accessory-horizontal-spacing-size)}:host([size='small']) ::slotted(.market-tooltip[slot='leading-accessory']),:host([size='small']) ::slotted(.market-tooltip[slot='trailing-accessory']){margin-right:var(--field-size-small-tooltip-accessory-horizontal-spacing-size);margin-left:var(--field-size-small-tooltip-accessory-horizontal-spacing-size)}:host .label-input-container.has-leading-accessory{padding-left:0 !important;}:host .label-input-container.has-trailing-accessory{padding-right:0 !important;}:host{--field-input-animation-speed:0.2s;--field-input-label-translate:12px;--field-empty-phase-label-text-size-unitless:16;--field-float-phase-label-text-size-unitless:14;--field-size-medium-float-phase-vertical-padding-size:12px;--field-size-medium-float-phase-horizontal-padding-size:16px;--field-size-small-float-phase-vertical-padding-size:9px;--field-size-small-float-phase-horizontal-padding-size:12px;display:flex;align-items:center}:host .label-input-container,:host([value='']:not([focused]):not([autofilled])) .label-input-container{flex-grow:1;padding:var(--field-float-phase-vertical-padding-size) var(--field-float-phase-horizontal-padding-size)}:host([size='medium']) .label-input-container,:host([size='medium'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-medium-float-phase-vertical-padding-size)\n      var(--field-size-medium-float-phase-horizontal-padding-size)}:host([size='small']) .label-input-container,:host([size='small'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-small-float-phase-vertical-padding-size)\n      var(--field-size-small-float-phase-horizontal-padding-size)}:host ::slotted(label){display:block;min-height:var(--field-empty-phase-label-text-leading);font-weight:var(--field-empty-phase-label-text-weight);font-size:var(--field-empty-phase-label-text-size);line-height:var(--field-empty-phase-label-text-leading);letter-spacing:var(--field-empty-phase-label-text-tracking);transition:all var(--field-input-animation-speed);transform:translateY(var(--field-input-label-translate));transform-origin:0 0}:host(:not([value=\"\"])) ::slotted(label),:host([value=\"\"]:not([focused])[autofilled]) ::slotted(label),:host([focused]) ::slotted(label){font-weight:var(--field-float-phase-label-text-weight);transform:scale(\n        calc(var(--field-float-phase-label-text-size-unitless) / var(--field-empty-phase-label-text-size-unitless))\n      )}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){opacity:0}:host([focused]) input,:host([focused]) ::slotted(input),:host([focused]) textarea,:host([focused]) ::slotted(textarea),:host(:not([value=''])) input,:host(:not([value=''])) ::slotted(input),:host(:not([value=''])) textarea,:host(:not([value=''])) ::slotted(textarea){opacity:1}:host([size='small']) ::slotted(label),:host([size='medium']) ::slotted(label){position:absolute;overflow:hidden;clip:rect(0 0 0 0);width:1px;height:1px;white-space:nowrap;clip-path:inset(50%)}:host([size='small']) input,:host([size='small']) ::slotted(input),:host([size='small']) textarea,:host([size='small']) ::slotted(textarea),:host([size='medium']) input,:host([size='medium']) ::slotted(input),:host([size='medium']) textarea,:host([size='medium']) ::slotted(textarea){opacity:1}:host{cursor:pointer}.label-input-container{overflow:hidden}.caret{flex-shrink:0;margin-right:var(--field-float-phase-horizontal-padding-size);pointer-events:none;transition:transform var(--field-input-animation-speed)}.caret path{fill:var(--select-caret-color)}:host([aria-expanded='true']) .caret{transform:rotate(180deg)}.placeholder{overflow:hidden;height:var(--field-input-leading);color:var(--field-placeholder-text-color);font-size:var(--field-input-size);line-height:var(--field-input-leading);text-overflow:ellipsis;white-space:nowrap;visibility:hidden}:host([focused]) .placeholder,:host([size='small']) .placeholder,:host([size='medium']) .placeholder{visibility:visible}:host([size='small']) .placeholder{height:var(--core-type-paragraph-20-leading);font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}::slotted(label){cursor:pointer}::slotted([slot='displayed-selection']){min-height:0;margin:0}::slotted([slot='displayed-selection'])::before,::slotted([slot='displayed-selection'])::after{display:none}::slotted([slot='list']){display:none}";
const MarketSelect$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketSelectValueDidChange = (0, $696Z8.createEvent)(this, "marketSelectValueDidChange", 7);
        this.marketSelectOpened = (0, $696Z8.createEvent)(this, "marketSelectOpened", 7);
        this.marketSelectClosed = (0, $696Z8.createEvent)(this, "marketSelectClosed", 7);
        /* TYPEAHEAD FUNCTIONALITY
    - https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
    - type a character: focus moves to the next item with a name that starts with
      the typed character
    - type multiple characters in rapid succession: focus moves to the next item
      with a name that starts with the string of characters typed
    - if no match is found, focus remains where it was
    - search wraps around end of list
    */ this.rowsInnerText = [];
        this.keypresses = [];
        this.debounceDelay = 250;
        this.setFocusOnMatch = debounce(()=>{
            const searchString = this.keypresses.join('');
            // array slicing is so we start the search from the currently focused row
            const nextMatch = [
                ...this.rowsInnerText.slice(this.focusedRowIndex + 1),
                ...this.rowsInnerText.slice(0, this.focusedRowIndex + 1)
            ].find((innerText)=>innerText.startsWith(searchString));
            const matchIndex = this.rowsInnerText.findIndex((innerText)=>{
                return innerText.startsWith(nextMatch);
            });
            const matchingRow = this.rows[matchIndex];
            // if matching row exists and is not disabled, focus it
            if (matchingRow && !matchingRow.disabled) {
                this.focusedRowIndex = matchIndex;
                matchingRow.focus();
                // if list is closed and single select, set the value
                if (!this.listIsActive && !this.multiselect) {
                    // row is not in the DOM, so matchingRow.click() doesn't bubble
                    // instead we manually set the value to the row's value
                    this.value = matchingRow.value;
                    // since we're bypassing marketListSelectionsDidChange event here,
                    // we also need to manually emit marketSelectValueDidChange event
                    this.marketSelectValueDidChange.emit({
                        value: this.value,
                        newSelectedOption: matchingRow,
                        newDeselectedOption: null,
                        currentSelectedOptions: [
                            matchingRow
                        ]
                    });
                }
            }
            this.keypresses = []; // reset keypress array
        }, this.debounceDelay);
        this.list = null;
        this.rows = null;
        this.popoverElement = null;
        this.name = undefined;
        this.value = '';
        this.size = 'large';
        this.placeholder = undefined;
        this.readonly = false;
        this.disabled = false;
        this.focused = false;
        this.invalid = false;
        this.multiselect = false;
        this.popoverContainer = undefined;
        this.listIsActive = false;
        this.focusedRowIndex = -1;
        this.hasLeadingAccessory = false;
        this.hasTrailingAccessory = false;
    }
    valueWatcher() {
        this.propagateValue();
    }
    multiselectWatcher() {
        this.list.multiselect = this.multiselect;
    }
    // Listener for the change event emitted by `market-list`
    handleListSelection({ detail: { currentSelectionValues, currentSelections, newDeselection, newSelection } }) {
        const value = currentSelectionValues.join(',');
        this.value = value;
        if (this.multiselect) this.setFocusedRow(newDeselection || newSelection);
        else this.setFocusedRow(newSelection);
        this.marketSelectValueDidChange.emit({
            value: value,
            newSelectedOption: newSelection,
            newDeselectedOption: newDeselection,
            currentSelectedOptions: currentSelections
        });
    }
    handleListItemsFiltered() {
        window.requestAnimationFrame(()=>{
            if (this.listIsActive) this.updatePopper();
        });
    }
    windowClick(e) {
        var _a;
        if (this.el.contains(e.target) || ((_a = this.popoverElement) === null || _a === void 0 ? void 0 : _a.contains(e.target))) return;
        this.focused = false;
        if (this.listIsActive) this.closeList();
    }
    getValues() {
        if (Array.isArray(this.value)) return new Set(this.value);
        return new Set(this.multiselect ? this.value.split(',') : [
            this.value
        ]);
    }
    getValuesCount() {
        return this.getValues().size;
    }
    /**
   * We search based on the `value` property rather than using querySelector and the `value`
   * attribute (i.e. `market-row[value=${this.value}]`) due to rendering issues we've seen
   * with Ember/Handlebars, where the property may be set before attribute is present.
   * See here for details: https://github.com/squareup/market/issues/2635
   */ getMatchingRows() {
        if (this.rows === null) return [];
        else {
            const values = this.getValues();
            return [
                ...this.rows
            ].filter((row)=>values.has(row.value));
        }
    }
    get hasMultipleSelections() {
        return this.multiselect && this.getValues().size > 1;
    }
    getMultiselectDisplayValue() {
        const values = this.getValues();
        return values.size > 1 ? `${values.size} selected` : '';
    }
    getDisplayedSelectionRow() {
        return this.el.querySelector(`${getNamespacedTagFor('market-row')}[slot="displayed-selection"]`);
    }
    /**
   * Ensure the passed `value` is reflected in the selected list item and the displayed selection row.
   */ propagateValue() {
        if (!this.list || !this.rows) return;
        const matchingRows = this.getMatchingRows();
        if (matchingRows.length === 0) {
            // there were no matching rows, so sanitize & reset the value
            this.list.value = this.value = '';
            this.focusedRowIndex = -1;
        } else {
            // set the list value so the correct list row will be selected
            this.list.value = this.value;
            this.setFocusedRow(matchingRows[0]);
        }
        this.displaySelection(matchingRows);
    }
    /**
   * Renders the passed row into the displayed selection slot, so it's visible
   * as the current selection in the main "input" area of the select.
   */ displaySelection(selectedRows = []) {
        var _a, _b, _c;
        // Remove existing selected row from the DOM
        (_b = (_a = this.getDisplayedSelectionRow()) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 || _b.call(_a);
        if (selectedRows.length === 1) {
            /**
       * For single select, we need to clone the row from the list so we can place a
       * duplicate into the field area. If we don't clone it, the row
       * will be removed from the list when we append it to the selection area
       */ const clonedRow = selectedRows[0].cloneNode(true);
            // Row was cloned from the list, so we need to remove its interactive attribute
            clonedRow.interactive = false;
            /**
       * Set slot='displayed-selection' so this shows up within the slotted area.
       * We use a slot instead of appending this directly into the shadowDOM
       * because we want to keep whatever styling cascaded from the Light DOM
       * on the row because market - row can accept any markup.
       */ clonedRow.setAttribute('slot', 'displayed-selection');
            // if the select size is small, the selected row needs to be small too
            clonedRow.size = this.size === 'small' ? 'small' : 'medium';
            // Append the cloned node after the first slot element (label).
            this.el.append(clonedRow);
        } else if (selectedRows.length > 1) {
            /**
       * For multiselect, we need to create a `market-row` element to display "n selected"
       * and possibly clone the "selected-translation" slot, if provided
       */ const multiselectDisplayRow = document.createElement(`${getNamespacedTagFor('market-row')}`);
            multiselectDisplayRow.setAttribute('slot', 'displayed-selection');
            multiselectDisplayRow.innerText = `${this.getValuesCount().toLocaleString()} `;
            // if the select size is small, the selected row needs to be small too
            multiselectDisplayRow.size = this.size === 'small' ? 'small' : 'medium';
            // Add slot for "selected"
            const selectedTranslationSlot = document.createElement('slot');
            selectedTranslationSlot.setAttribute('name', 'selected-translation');
            // Clone the contents of the "selected-translation"
            const selectedTranslation = this.el.querySelector('[slot="selected-translation"]');
            selectedTranslationSlot.innerHTML = (_c = selectedTranslation === null || selectedTranslation === void 0 ? void 0 : selectedTranslation.innerHTML) !== null && _c !== void 0 ? _c : 'selected';
            multiselectDisplayRow.appendChild(selectedTranslationSlot);
            // Observe for changes on the "selected-translation" slot
            if (selectedTranslation) {
                const observer = new MutationObserver(()=>{
                    selectedTranslationSlot.innerHTML = selectedTranslation === null || selectedTranslation === void 0 ? void 0 : selectedTranslation.innerHTML;
                });
                observer.observe(selectedTranslation, {
                    characterData: true,
                    subtree: true
                });
            }
            this.el.append(multiselectDisplayRow);
        }
    }
    /**
   * Listens to changes in list content to ensure that if the content is dynamically updated,
   * those changes will be copied to the popover and the displayed-selection row.
   */ initListObserver() {
        const observer = new MutationObserver(this.onListChange.bind(this));
        observer.observe(this.list, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }
    onListChange() {
        this.initRows();
        this.propagateValue();
        this.updatePopper();
    }
    /**
   * Record the index of the new selected row for keyboard navigation
   */ setFocusedRow(row) {
        this.focusedRowIndex = Array.prototype.indexOf.call(this.rows, row);
    }
    /**
   * Opens the select.
   */ async openList() {
        if (this.listIsActive || !this.popoverElement) return Promise.resolve();
        const container = this.el.closest(this.popoverContainer) || document.body;
        Object.assign(this.popoverElement.style, {
            zIndex: `${getMaxZIndex(container) + 1}`,
            visibility: 'hidden'
        });
        this.moveListToPopover();
        container.append(this.popoverElement);
        this.initPopperListeners();
        return new Promise((resolve)=>{
            // hack: ensure initial position is correctly set before visible
            setTimeout(()=>{
                this.updatePopper();
                this.popoverElement.style.visibility = 'visible';
                this.listIsActive = true;
                this.marketSelectOpened.emit();
                resolve();
            }, 50);
        });
    }
    /**
   * Closes the select.
   */ closeList() {
        if (!this.listIsActive) return Promise.resolve();
        this.popoverElement.remove();
        this.cleanupPopperListeners();
        this.moveListToSelect();
        this.listIsActive = false;
        this.marketSelectClosed.emit();
        return Promise.resolve();
    }
    /**
   * Toggles the select open and closed.
   */ async toggleList() {
        this.listIsActive ? await this.closeList() : await this.openList();
    }
    /* KEYBOARD ACCESSIBILITY */ // keyboard handler on the trigger (separate from the list)
    handleTriggerKeyDown(ev) {
        switch(ev.key){
            case 'ArrowDown':
                this.handleTriggerArrowDown(ev);
                break;
            case 'ArrowUp':
                this.handleTriggerArrowUp(ev);
                break;
            case ' ':
                this.handleTriggerSpacebar(ev);
                break;
            case 'Enter':
                this.handleTriggerEnter();
                break;
            case 'Escape':
                this.handleEscape();
                break;
            case 'Tab':
                this.handleTab(ev);
                break;
            default:
                this.typeaheadHandler(ev);
                break;
        }
        ev.stopPropagation();
    }
    /**
   * NOTE: market-list has it's own internal keyboard functionality,
   * so we only need to handle the trigger keypress here
   *
   * - if the list is open:
   *   - focus the next enabled row
   * - if the list is closed:
   *   - open the list
   *   - if there is a current selection, focus it
   */ async handleTriggerArrowDown(ev) {
        ev.preventDefault(); // do not scroll page while select has focus
        if (this.listIsActive) {
            for(let i = this.focusedRowIndex + 1; i < this.rows.length; i++)if (!this.rows[i].disabled) {
                this.focusedRowIndex = i;
                this.rows[i].focus();
                break;
            }
        } else {
            await this.openList();
            if (this.focusedRowIndex > -1) this.rows[this.focusedRowIndex].focus();
        }
    }
    /**
   * NOTE: market-list has it's own internal keyboard functionality,
   * so we only need to handle the trigger keypress here
   *
   * - if the list is open:
   *   - focus the last enabled row
   * - if the list is closed:
   *   - open the list
   *   - if there is a current selection, focus it
   */ async handleTriggerArrowUp(ev) {
        ev.preventDefault(); // do not scroll page while select has focus
        if (this.listIsActive) {
            for(let i = this.focusedRowIndex - 1; i > -1; i--)if (!this.rows[i].disabled) {
                this.focusedRowIndex = i;
                this.rows[i].focus();
                break;
            }
        } else {
            await this.openList();
            if (this.focusedRowIndex > -1) this.rows[this.focusedRowIndex].focus();
        }
    }
    /**
   * - if the list is open:
   *   - close it
   * - if the list is closed:
   *   - open the list
   *   - if there is a current selection, focus it
   */ async handleTriggerSpacebar(ev) {
        ev.preventDefault(); // do not scroll page while select has focus
        if (this.listIsActive) this.closeList();
        else {
            await this.openList();
            if (this.focusedRowIndex > -1) this.rows[this.focusedRowIndex].focus();
        }
    }
    /**
   * when the list is closed, invoke implicit submission
   */ handleTriggerEnter() {
        if (this.listIsActive) {
            this.closeList();
            this.el.focus();
        } else submitFormImplicitly(this.el);
    }
    /*
  - when the list is open, close it and focus the trigger
  */ handleEscape() {
        if (this.listIsActive) {
            this.closeList();
            this.el.focus();
        }
    }
    /*
  - when the list is open, suppress tab navigation
  - when the list is closed, allow tab navigation and remove focus
  */ handleTab(ev) {
        if (this.listIsActive) ev.preventDefault();
        else this.focused = false;
    }
    // keyboard handler on the list (separate from the trigger)
    handleListKeyDown(ev) {
        switch(ev.key){
            case 'Enter':
                this.handleListEnter();
                break;
            case 'Escape':
                this.handleEscape();
                break;
            case 'Tab':
                this.handleTab(ev);
                break;
            case ' ':
                this.handleListSpacebar(ev);
                break;
            default:
                this.typeaheadHandler(ev);
                break;
        }
        ev.stopPropagation();
    }
    /**
   * market-list handles selection functionality internally
   * just need to close the list if single select
   */ handleListSpacebar(ev) {
        // do nothing if list is multiselect or keydown event is emitted by typing into a slotted search input
        if (this.multiselect || ev.target.hasAttribute('slot', 'search')) return;
        ev.preventDefault(); // do not scroll page while select has focus
        this.closeList();
        this.el.focus();
    }
    /**
   * market-list handles selection functionality internally
   * just need to close the list if single select
   */ handleListEnter() {
        if (!this.multiselect) {
            this.closeList();
            this.el.focus();
        }
    }
    typeaheadHandler(ev) {
        var _a;
        // if list has a search, that will be used instead of a typeahead
        if ((_a = this.list) === null || _a === void 0 ? void 0 : _a.hasAttribute('has-search')) return;
        // because this is the default keydown event handler, we're ignoring
        // "special" keys, numbers, and punctuation for typeahead functionality
        // note that this check will also ignore characters from languages that have
        // no concept of upper/lowercase (ex. japanese)
        // TODO: revisit if localization requires it
        if (ev.key.length > 1 || ev.key.toUpperCase() === ev.key.toLowerCase()) return;
        this.storeKeypresses(ev);
        this.setFocusOnMatch();
    }
    storeKeypresses(ev) {
        this.keypresses = [
            ...this.keypresses,
            ev.key
        ];
    }
    /* EVENT HANDLING */ handleFocus() {
        if (this.readonly || this.disabled) return;
        this.focused = true;
    }
    handleTriggerClick(ev) {
        if (ev.target.tagName.toLowerCase() === getNamespacedTagFor('market-tooltip')) return;
        if (this.readonly || this.disabled) return;
        this.toggleList();
    }
    handleListClick() {
        if (!this.multiselect) {
            this.closeList();
            this.el.focus();
        }
    }
    initPopperListeners() {
        const { el, popoverElement, updatePopper } = this;
        this.cleanupPopperListeners = autoUpdate(el, popoverElement, updatePopper.bind(this), {
            elementResize: false
        });
    }
    updatePopper() {
        const { el, popoverElement } = this;
        // TODO: use design tokens
        const MARGIN_OFFSET = 8;
        const MAX_HEIGHT = 464;
        computePosition(el, popoverElement, {
            middleware: [
                offset(MARGIN_OFFSET),
                autoPlacement({
                    allowedPlacements: [
                        'top',
                        'bottom'
                    ]
                }),
                size({
                    apply ({ rects, availableHeight }) {
                        Object.assign(popoverElement.style, {
                            width: `${rects.reference.width}px`,
                            maxHeight: `${Math.min(availableHeight - MARGIN_OFFSET, MAX_HEIGHT)}px`
                        });
                    }
                }),
                shift({
                    padding: MARGIN_OFFSET
                })
            ]
        }).then(({ x, y })=>{
            Object.assign(popoverElement.style, {
                left: `${x}px`,
                top: `${y}px`
            });
        });
    }
    initPopover() {
        this.popoverElement = this.popoverElement || document.createElement(getNamespacedTagFor('market-popover'));
        this.popoverElement.id = this.popoverId;
        this.popoverElement.style.position = 'absolute';
    }
    initList() {
        this.list = this.el.querySelector('[slot="list"]');
        this.list.interactive = true;
        this.list.multiselect = this.multiselect;
        this.list.addEventListener('marketListSelectionsDidChange', this.handleListSelection.bind(this));
        this.list.addEventListener('marketListItemsFiltered', this.handleListItemsFiltered.bind(this));
        this.list.addEventListener('keydown', this.handleListKeyDown.bind(this));
        this.list.addEventListener('click', this.handleListClick.bind(this));
    }
    initRows() {
        this.rows = this.list.querySelectorAll(`${getNamespacedTagFor('market-row')}`);
        // used for typeahead functionality
        this.rowsInnerText = [
            ...this.rows
        ].filter((row)=>{
            /**
       * Addresses an issue in test environments where the innerText of
       * market-rows isn't set before componentWillLoad of the parent market-select (this file)
       * is executed.
       */ return row && row.innerText;
        }).map((row)=>row.innerText.trim().toLowerCase());
    }
    moveListToPopover() {
        this.list.removeAttribute('slot');
        this.popoverElement.append(this.list);
    }
    moveListToSelect() {
        this.list.setAttribute('slot', 'list');
        this.el.append(this.list);
    }
    /* COMPONENT LIFECYCLE EVENTS AND HELPERS */ registerSlottedAccessories() {
        const leadingAccessory = [
            ...this.el.children
        ].filter(function(child) {
            return child.matches('[slot="leading-accessory"]');
        });
        const trailingAccessory = [
            ...this.el.children
        ].filter(function(child) {
            return child.matches('[slot="trailing-accessory"]');
        });
        this.hasLeadingAccessory = leadingAccessory.length > 0;
        this.hasTrailingAccessory = trailingAccessory.length > 0;
    }
    componentWillLoad() {
        this.registerSlottedAccessories();
        this.popoverId = this.popoverId || `popover-${v4()}`;
    }
    componentDidLoad() {
        this.initList();
        this.initRows();
        this.initPopover();
        this.initListObserver();
        this.propagateValue();
    }
    componentWillRender() {
        const { listIsActive, list } = this;
        if (list && listIsActive) list.removeAttribute('slot');
    }
    disconnectedCallback() {
        this.closeList();
    }
    render() {
        const tabindex = this.disabled ? null : '0';
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-select",
            role: "combobox",
            "aria-label": getTextInputAriaLabel(this.el),
            "aria-expanded": this.listIsActive.toString(),
            "aria-controls": this.popoverId,
            "aria-haspopup": "listbox",
            tabindex: tabindex,
            onClick: (e)=>{
                this.handleTriggerClick(e);
            },
            onFocus: ()=>{
                this.handleFocus();
            },
            onKeyDown: (e)=>{
                this.handleTriggerKeyDown(e);
            }
        }, (0, $696Z8.h)("slot", {
            name: "leading-accessory",
            onSlotchange: ()=>this.registerSlottedAccessories()
        }), (0, $696Z8.h)("div", {
            class: classNames('label-input-container', {
                'has-leading-accessory': this.hasLeadingAccessory,
                'has-trailing-accessory': this.hasTrailingAccessory
            })
        }, (0, $696Z8.h)("slot", null), (0, $696Z8.h)("slot", {
            name: "displayed-selection"
        }, (0, $696Z8.h)("div", {
            class: "placeholder"
        }, this.placeholder))), (0, $696Z8.h)("slot", {
            name: "list"
        }), (0, $696Z8.h)("slot", {
            name: "trailing-accessory",
            onSlotchange: ()=>this.registerSlottedAccessories()
        }), (0, $696Z8.h)("svg", {
            class: "caret",
            width: "14",
            height: "8",
            viewBox: "0 0 14 8",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M7.70715 7.70711C7.31663 8.09763 6.68346 8.09763 6.29294 7.70711L0.29294 1.70711L1.70715 0.292892L7.00005 5.58579L12.2929 0.292893L13.7072 1.70711L7.70715 7.70711Z",
            fill: "black"
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "value": [
                "valueWatcher"
            ],
            "multiselect": [
                "multiselectWatcher"
            ]
        };
    }
    static get style() {
        return marketSelectCss;
    }
};
const marketStepperCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:relative;outline:none;font-weight:var(--field-input-weight);font-size:var(--field-input-size);line-height:var(--field-input-leading);cursor:text}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;cursor:inherit}:host ::slotted(label){cursor:inherit}:host input:focus,:host ::slotted(input:focus),:host textarea:focus,:host ::slotted(textarea:focus){outline:none}:host input::-moz-placeholder,:host textarea::-moz-placeholder{color:var(--field-placeholder-text-color)}:host input::placeholder,:host textarea::placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::-moz-placeholder,:host ::slotted(textarea)::-moz-placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::placeholder,:host ::slotted(textarea)::placeholder{color:var(--field-placeholder-text-color)}:host([size='small']){font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}:host{border-radius:var(--field-border-radius);background-color:var(--field-normal-state-background-color);color:var(--field-normal-state-input-color)}:host::after{content:'';position:absolute;inset:0;border-radius:var(--field-border-radius);box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color);pointer-events:none}:host([invalid])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-invalid-validity-border-color)}:host(:hover){background-color:var(--field-hover-state-background-color);color:var(--field-hover-state-input-color)}:host(:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-normal-validity-border-color)}:host([invalid]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-invalid-validity-border-color)}:host([focused]){color:var(--field-focus-state-input-color)}:host([focused])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size)\n        var(--field-focus-state-normal-validity-border-color)}:host([focused][invalid])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size) var(--field-focus-state-invalid-validity-border-color)}:host([disabled]){background-color:var(--field-disabled-state-background-color) !important;color:var(--field-disabled-state-input-color) !important;cursor:not-allowed !important;}:host([disabled])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-disabled-state-border-color) !important}:host([value=\"\"]) ::slotted(label){color:var(--field-normal-state-empty-phase-label-color)}:host(:not([value=\"\"])) ::slotted(label),:host([value=\"\"][autofilled]) ::slotted(label){color:var(--field-normal-state-float-phase-label-color)}:host(:hover) ::slotted(label){color:var(--field-hover-state-empty-phase-label-color)}:host(:not([value=\"\"]):hover) ::slotted(label),:host([value=\"\"][autofilled]:hover) ::slotted(label){color:var(--field-hover-state-float-phase-label-color)}:host([focused]) ::slotted(label){color:var(--field-focus-state-float-phase-label-color)}:host([value=\"\"][disabled]) ::slotted(label){color:var(--field-disabled-state-empty-phase-label-color)}:host(:not([value=\"\"])[disabled]) ::slotted(label),:host([value=\"\"][autofilled][disabled]) ::slotted(label){color:var(--field-disabled-state-float-phase-label-color)}:host input::-webkit-outer-spin-button,:host input::-webkit-inner-spin-button{margin:0;-webkit-appearance:none;appearance:none}:host input[type='number']{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}:host{display:flex;align-items:center}:host input{--stepper-quantity-input-field-height:calc(\n        var(--stepper-quantity-input-field-value-text-leading) + var(--stepper-padding-size) * 2\n      );position:relative;bottom:0;width:100%;height:var(--stepper-quantity-input-field-height);color:var(--stepper-quantity-input-field-value-text-normal-state-color);font-weight:var(--stepper-quantity-input-field-value-text-weight);font-size:var(--stepper-quantity-input-field-value-text-size);font-family:var(--stepper-quantity-input-field-value-text-font-family);line-height:var(--stepper-quantity-input-field-value-text-leading);letter-spacing:var(--stepper-quantity-input-field-value-text-tracking);text-align:center;text-transform:var(--stepper-quantity-input-field-value-text-case);cursor:text;font-feature-settings:'tnum'}:host input[disabled]{color:var(--stepper-quantity-input-field-value-text-disabled-state-color)}:host input::-moz-placeholder{color:var(--stepper-quantity-input-field-value-text-placeholder-color)}:host input::placeholder{color:var(--stepper-quantity-input-field-value-text-placeholder-color)}button{--transition-duration:0.2s;--stepper-button-size:var(--stepper-button-minimum-height);position:relative;display:inline-flex;flex-shrink:0;justify-content:center;align-items:center;box-sizing:content-box;width:var(--stepper-button-size);height:var(--stepper-button-size);padding:var(--stepper-padding-size);border:none;border-radius:var(--stepper-border-radius);background:none;cursor:pointer;transition:background-color color var(--transition-duration)}button::before{content:'';position:absolute;inset:0;display:block;margin:var(--stepper-padding-size);border-radius:var(--stepper-button-border-radius);background:var(--stepper-button-normal-state-background-color)}button svg{position:relative;pointer-events:none;fill:var(--stepper-button-normal-state-icon-color)}button:hover::before{background:var(--stepper-button-hover-state-background-color)}button:hover svg{fill:var(--stepper-button-hover-state-icon-color)}button:focus{outline:none}button:focus::before{background:var(--stepper-button-focus-state-background-color)}button:focus svg{fill:var(--stepper-button-focus-state-icon-color)}button:active::before{background:var(--stepper-button-pressed-state-background-color)}button:active svg{fill:var(--stepper-button-pressed-state-icon-color)}button[disabled]{cursor:not-allowed}button[disabled]::before{background:var(--stepper-button-disabled-state-background-color)}button[disabled] svg{fill:var(--stepper-button-disabled-state-icon-color)}";
const MarketStepper$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketStepperValueChange = (0, $696Z8.createEvent)(this, "marketStepperValueChange", 7);
        this.marketStepperInputFocus = (0, $696Z8.createEvent)(this, "marketStepperInputFocus", 7);
        this.value = undefined;
        this.inputId = undefined;
        this.name = undefined;
        this.placeholder = '0';
        this.max = undefined;
        this.min = undefined;
        this.step = 1;
        this.readonly = false;
        this.disabled = false;
        this.focused = false;
        this.invalid = false;
        this.inputAriaLabel = 'Number';
        this.decrementAriaLabel = 'Decrement';
        this.incrementAriaLabel = 'Increment';
        this.incrementDisabled = false;
        this.decrementDisabled = false;
    }
    valueChangeHandler() {
        // sanitize value in case it was set programmatically
        const sanitized = this.sanitizeValue(this.value);
        if (sanitized !== this.value) this.value = sanitized;
        this.updateButtonDisabledStates();
    }
    /**
   * Toggle focus styling on `<market-stepper>` and focus/blur the inner `<input />`.
   */ setFocus(value = true) {
        if (this.readonly || this.disabled) return Promise.resolve();
        this.focused = value;
        this.focused ? this.inputEl.focus() : this.inputEl.blur();
        return Promise.resolve();
    }
    onChange() {
        const previousValue = this.value;
        let nextValue = Number.parseFloat(this.inputEl.value);
        if (Number.isNaN(nextValue)) {
            // not a valid number, so reset it to null/empty
            nextValue = null;
            this.inputEl.value = '';
        } else {
            // a valid number, so sanitize it against min/max/step props
            nextValue = this.sanitizeValue(nextValue);
            this.inputEl.value = nextValue.toString();
        }
        // if value has changed, set it and emit event
        if (nextValue !== previousValue) {
            this.value = nextValue;
            this.emitChangeEvent(previousValue);
        }
    }
    onInputFocus() {
        this.emitInputFocusEvent();
    }
    onDecrementClick() {
        this.stepValue(-this.step);
    }
    onIncrementClick() {
        this.stepValue(this.step);
    }
    onKeyDown(e) {
        if (e.key === 'Enter') submitFormImplicitly(this.el);
    }
    stepValue(step) {
        const previousValue = this.value;
        const nextValue = (previousValue || 0) + step;
        const sanitizedValue = this.sanitizeValue(nextValue);
        if (sanitizedValue !== previousValue) {
            this.value = sanitizedValue;
            this.emitChangeEvent(previousValue);
        }
    }
    sanitizeValue(value) {
        var _a;
        const decimalPlaces = ((_a = this.step.toString().split('.')[1]) === null || _a === void 0 ? void 0 : _a.length) || 0;
        const hasMax = this.max !== null && this.max !== undefined;
        const hasMin = this.min !== null && this.min !== undefined;
        // round value to the nearest step
        let sanitized = Math.round(value / this.step) * this.step;
        // correct any floating point math errors
        sanitized = Number.parseFloat(sanitized.toFixed(decimalPlaces));
        // limit value to max
        sanitized = hasMax ? Math.min(sanitized, this.max) : sanitized;
        // limit value to min
        return hasMin ? Math.max(sanitized, this.min) : sanitized;
    }
    updateButtonDisabledStates() {
        const { value, max, min } = this;
        const hasValue = value !== null && value !== undefined;
        this.incrementDisabled = hasValue ? value === max : false;
        this.decrementDisabled = hasValue ? value === min : false;
    }
    emitChangeEvent(previousValue) {
        const { el, value, marketStepperValueChange } = this;
        marketStepperValueChange.emit({
            el: el,
            value: value,
            previousValue: previousValue
        });
    }
    emitInputFocusEvent() {
        const { marketStepperInputFocus } = this;
        marketStepperInputFocus.emit();
    }
    componentWillRender() {
        this.updateButtonDisabledStates();
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-stepper",
            onFocus: ()=>{
                this.focused = true;
            },
            onBlur: ()=>{
                this.focused = false;
            }
        }, (0, $696Z8.h)("button", {
            tabindex: this.disabled || this.decrementDisabled ? -1 : null,
            disabled: this.disabled || this.decrementDisabled,
            onClick: ()=>this.onDecrementClick(),
            "aria-label": this.decrementAriaLabel
        }, (0, $696Z8.h)("svg", {
            width: "10",
            height: "2",
            viewBox: "0 0 10 2",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M9.66667 0.333328H0.333336V1.66666H9.66667V0.333328Z"
        }))), (0, $696Z8.h)("input", {
            ref: (el)=>this.inputEl = el,
            type: "number",
            id: this.inputId,
            name: this.name,
            readonly: this.readonly,
            disabled: this.disabled,
            placeholder: this.placeholder,
            step: this.step,
            min: this.min,
            max: this.max,
            value: this.value,
            "aria-label": this.inputAriaLabel,
            onChange: ()=>this.onChange(),
            onFocus: ()=>this.onInputFocus(),
            onKeyDown: (e)=>this.onKeyDown(e),
            part: "native-input"
        }), (0, $696Z8.h)("button", {
            tabindex: this.disabled || this.incrementDisabled ? -1 : null,
            disabled: this.disabled || this.incrementDisabled,
            onClick: ()=>this.onIncrementClick(),
            "aria-label": this.incrementAriaLabel
        }, (0, $696Z8.h)("svg", {
            width: "10",
            height: "10",
            viewBox: "0 0 10 10",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M5.66665 9.66666V5.66666H9.66665V4.33333H5.66665V0.333328H4.33331V4.33333H0.333313V5.66666H4.33331V9.66666H5.66665Z"
        }))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "value": [
                "valueChangeHandler"
            ]
        };
    }
    static get style() {
        return marketStepperCss;
    }
};
const marketTabCss = ":host([size=\"large\"]){font-weight:var(--core-type-heading-30-weight);font-size:var(--core-type-heading-30-size);font-family:var(--core-type-heading-30-font-family);line-height:var(--core-type-heading-30-leading);letter-spacing:var(--core-type-heading-30-tracking);text-transform:var(--core-type-heading-30-case)}:host(:not([size])),:host([size=\"medium\"]){font-weight:var(--core-type-heading-20-weight);font-size:var(--core-type-heading-20-size);font-family:var(--core-type-heading-20-font-family);line-height:var(--core-type-heading-20-leading);letter-spacing:var(--core-type-heading-20-tracking);text-transform:var(--core-type-heading-20-case)}:host([size=\"small\"]){font-weight:var(--core-type-medium-20-weight);font-size:var(--core-type-medium-20-size);font-family:var(--core-type-medium-20-font-family);line-height:var(--core-type-medium-20-leading);letter-spacing:var(--core-type-medium-20-tracking);text-transform:var(--core-type-medium-20-case)}:host{color:var(--tabs-tab-text-color, var(--core-text-20-color))}:host [part=\"button\"]{position:relative;border:0;background:none;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;text-transform:inherit;cursor:pointer;transition:color\n    var(--core-animation-enter-transition-fast-speed-duration)\n    var(--core-animation-enter-transition-easing)}:host [part=\"button\"]::after{content:'';position:absolute;bottom:0;left:0;width:100%;height:0;border-radius:var(--tabs-tab-bottom-border-border-radius-top-left, var(--core-metrics-spacing-25))\n      var(--tabs-tab-bottom-border-border-radius-top-right, var(--core-metrics-spacing-25))\n      var(--tabs-tab-bottom-border-border-radius-bottom-right, 0)\n      var(--tabs-tab-bottom-border-border-radius-bottom-left, 0);background:var(--tabs-tab-bottom-border-background-color, var(--core-text-10-color));transition:height\n      var(--core-animation-enter-transition-fast-speed-duration)\n      var(--core-animation-enter-transition-easing),\n      background\n      var(--core-animation-enter-transition-fast-speed-duration)\n      var(--core-animation-enter-transition-easing)}:host(:hover),:host(:active){color:var(--tabs-tab-hover-state-text-color, var(--core-emphasis-text-color));transition:color\n    var(--core-animation-exit-transition-fast-speed-duration)\n    var(--core-animation-exit-transition-easing)}@media (-webkit-device-pixel-ratio: 1){:host [part=\"button\"]::after{border-radius:0}}:host([size=\"small\"]) [part=\"button\"]{padding:var(--tabs-tab-small-size-top-padding-size, 4px)\n      0\n      var(--tabs-tab-small-size-bottom-padding-size, 10px)}:host(:not([size])) [part=\"button\"],:host([size=\"medium\"]) [part=\"button\"]{padding:var(--tabs-tab-medium-size-top-padding-size, 4px)\n      0\n      var(--tabs-tab-medium-size-bottom-padding-size, 10px)}:host([size=\"large\"]) [part=\"button\"]{padding:var(--tabs-tab-large-size-top-padding-size, 4px)\n      0\n      var(--tabs-tab-large-size-bottom-padding-size, 12px)}:host([selected]){color:var(--tabs-tab-selected-text-color, var(--core-text-10-color))}:host([selected]) [part=\"button\"]::after{height:var(--tabs-tab-selected-bottom-border-height, var(--core-metrics-spacing-25))}:host([selected]):hover{color:var(--tabs-tab-hover-state-selected-text-color, var(--core-text-10-color))}:host([selected]):active{color:var(--tabs-tab-active-state-selected-text-color, var(--core-emphasis-text-color))}:host([selected]):active [part=\"button\"]::after{background:var(--tabs-tab-active-state-bottom-border-background-color, var(--core-emphasis-text-color))}:host([disabled]){color:var(--tabs-tab-disabled-state-text-color, var(--core-text-30-color))}:host([disabled]):hover{color:var(--tabs-tab-disabled-state-text-color, var(--core-text-30-color))}:host([disabled]) [part=\"button\"]{cursor:not-allowed}";
const MarketTab$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketTabSelectedChanged = (0, $696Z8.createEvent)(this, "marketTabSelectedChanged", 7);
        this.disabled = false;
        this.size = 'medium';
        this.selected = false;
    }
    /**
   * Select the tab and emits a `marketTabSelectedChanged` event
   */ select() {
        if (this.selected || this.disabled) return Promise.resolve();
        const { defaultPrevented } = this.marketTabSelectedChanged.emit({
            panelId: this.el.getAttribute('aria-controls'),
            prevValue: this.selected,
            tabId: this.el.id,
            value: true
        });
        if (!defaultPrevented) this.selected = true;
        return Promise.resolve();
    }
    /**
   * Deselects the tab and emits a `marketTabSelectedChanged` event
   */ deselect() {
        if (!this.selected) return Promise.resolve();
        const { defaultPrevented } = this.marketTabSelectedChanged.emit({
            panelId: this.el.getAttribute('aria-controls'),
            prevValue: this.selected,
            tabId: this.el.id,
            value: false
        });
        if (!defaultPrevented) this.selected = false;
        return Promise.resolve();
    }
    disabledWatcher() {
        this.selected = false;
    }
    handleClick() {
        this.select();
    }
    handleKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault(); // prevents scroll down when Space is pressed
            this.select();
        }
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            "aria-disabled": this.disabled.toString(),
            "aria-selected": this.selected.toString(),
            class: "market-tab",
            onClick: this.handleClick.bind(this),
            onKeydown: this.handleKeydown.bind(this),
            role: "tab",
            tabindex: "0"
        }, (0, $696Z8.h)("button", {
            disabled: this.disabled,
            part: "button",
            ref: (el)=>this.buttonEl = el,
            tabindex: "-1"
        }, (0, $696Z8.h)("slot", null)));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "disabled": [
                "disabledWatcher"
            ]
        };
    }
    static get style() {
        return marketTabCss;
    }
};
const marketTabListCss = ":host{position:relative;display:flex}:host::after{content:'';position:absolute;bottom:0;left:0;display:block;width:100%;height:var(--tabs-list-bottom-border-size, 1px);background-color:var(--tabs-list-bottom-border-color, var(--core-divider-20-color))}:host(:not([size])),:host([size=\"small\"]),:host([size=\"medium\"]){gap:var(--tabs-list-medium-size-horizontal-spacing, var(--core-metrics-spacing-200))}:host([size=\"large\"]){gap:var(--tabs-list-large-size-horizontal-spacing, var(--core-metrics-spacing-300))}";
const MarketTabList$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketTabListSelectedTabChanged = (0, $696Z8.createEvent)(this, "marketTabListSelectedTabChanged", 7);
        this.size = undefined;
        this.selectedTab = undefined;
        this.defaultTab = undefined;
    }
    marketTabSelectedChangedEventHandler(e) {
        var _a;
        const { tabId, value } = e.detail;
        if (!value) return;
        if (this.selectedTab !== tabId) {
            const { defaultPrevented } = this.marketTabListSelectedTabChanged.emit({
                prevValue: this.selectedTab,
                value: tabId
            });
            if (!defaultPrevented) this.selectedTab = tabId;
        }
        (_a = this.tabEls) === null || _a === void 0 || _a.forEach((tabEl)=>{
            if (tabEl.id !== tabId) {
                tabEl.deselect();
                tabEl.tabIndex = -1;
            } else tabEl.tabIndex = 0;
        });
    }
    tabWatcher(newTabId) {
        this.selectTab(newTabId);
    }
    sizeWatcher(newSize) {
        this.propagateSizeProp(newSize);
    }
    selectTab(tabId) {
        var _a, _b;
        const tabEl = ((_a = this.tabEls) === null || _a === void 0 ? void 0 : _a.find((el)=>tabId === el.id && !el.disabled)) || ((_b = this.tabEls) === null || _b === void 0 ? void 0 : _b.find((el)=>!el.disabled));
        tabEl === null || tabEl === void 0 || tabEl.select();
    }
    propagateSizeProp(size) {
        this.tabEls.forEach((el)=>{
            if (this.size && el.size !== this.size) el.size = size;
        });
    }
    focusOnTab(el) {
        var _a, _b;
        (_b = (_a = el === null || el === void 0 ? void 0 : el.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 || _b.focus();
    }
    handleKeyDown(e) {
        if (!this.tabEls || this.tabEls.every((el)=>el.disabled)) return;
        /**
     * These keyboard shortcut behaviours are from:
     * https://www.w3.org/WAI/ARIA/apg/patterns/tabs/examples/tabs-manual/#kbd_label
     *
     * Tab, Enter, and Space behaviours should already natively work.
     */ if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Home' || e.key === 'End') {
            e.preventDefault(); // prevent key press from triggering scroll events
            const currentTabIndex = this.tabEls.indexOf(e.target);
            if (currentTabIndex < 0) return;
            const left = this.tabEls.slice(0, currentTabIndex);
            const right = this.tabEls.slice(currentTabIndex + 1);
            switch(e.key){
                case 'ArrowRight':
                    {
                        const focusableTabEls = [
                            ...right,
                            ...left
                        ].find((el)=>!el.disabled);
                        this.focusOnTab(focusableTabEls);
                        break;
                    }
                case 'ArrowLeft':
                    {
                        const focusableTabEls = [
                            ...right,
                            ...left
                        ].reverse().find((el)=>!el.disabled);
                        this.focusOnTab(focusableTabEls);
                        break;
                    }
                case 'Home':
                    {
                        const focusableTabEls = this.tabEls.find((el)=>!el.disabled);
                        this.focusOnTab(focusableTabEls);
                        break;
                    }
                case 'End':
                    {
                        const focusableTabEls = this.tabEls.filter((el)=>!el.disabled);
                        this.focusOnTab(focusableTabEls[focusableTabEls.length - 1]);
                        break;
                    }
            }
        }
    }
    handleSlotChange() {
        this.tabEls = [
            ...this.el.querySelectorAll(getNamespacedTagFor('market-tab'))
        ];
        this.propagateSizeProp(this.size);
    }
    componentWillLoad() {
        this.handleSlotChange();
        this.selectTab(this.selectedTab || this.defaultTab);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-tab-list",
            onKeyDown: this.handleKeyDown.bind(this),
            role: "tablist"
        }, (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.handleSlotChange()
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "selectedTab": [
                "tabWatcher"
            ],
            "size": [
                "sizeWatcher"
            ]
        };
    }
    static get style() {
        return marketTabListCss;
    }
};
const marketTabPanelCss = ":host{display:block}:host([hidden]){display:none}";
const MarketTabPanel$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.hidden = false;
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            "aria-hidden": this.hidden.toString(),
            class: "market-tab-panel",
            role: "tabpanel",
            tabindex: "0"
        }, (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketTabPanelCss;
    }
};
/**
 * Parses a CSS grid-template-columns declaration and attempts to return an array with one entry for each column.
 *
 * @param {string} cssPropertyValue - Value of the `grid-template-columns` property.
 *
 * Example inputs and outputs:
 * '100px 80px 50px' --> ['100px', '80px', '50px']
 * '100px repeat(2, 80px)' --> ['100px', '80px', '80px']
 * '100px repeat(3, 50px, 75px)' --> ['100px', '50px', '75px', '50px']
 * 'repeat(2, 80px) repeat(3, 50px, 75px) 100px' --> ['80px', '80px', '50px', '75px', '50px', '100px']
 *
 * Why do we need this?
 * `market-table` has a `styleDeclaration` watcher which checks the CSS styles applied to the table. this gets used to
 * determine the grid template definition for the table (`this.gridColumnTemplate`), which in turn is used to set column
 * widths and update the grid layout. however, in situations where `grid-template-columns` is defined using the
 * `repeat()` function, we need to parse the value to ensure that we have a width explicitly specified for each column.
 * this ensures consistent column sizing and behavior when columns are being stuck/unstuck to the left/right.
 *
 * Cases where this will break:
 * 1. If user is using <auto-repeat> values ("auto-fill", "auto-fit") instead of explicit widths
 * 2. If user is using a CSS function other than `repeat()` (ex. `minmax()`, `fit-content()`)
 * https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-columns
 * https://developer.mozilla.org/en-US/docs/Web/CSS/repeat
 */ const parsedGridTemplateColumnValues = (cssPropertyValue)=>{
    const array = cssPropertyValue.split(' '); // ex. '100px repeat(2, 80px)' --> ['100px', 'repeat(2', '80px)']
    // error handling for unsupported cases
    const unsupportedValues = [
        'auto-fill',
        'auto-fit',
        'minmax',
        'fit-content'
    ];
    const matches = unsupportedValues.filter((value)=>cssPropertyValue.includes(value));
    const unsupportedValuesText = `${matches.length > 0 ? 'features' : 'feature'} ${matches.map((match)=>`\`${match}\``).join(', ')}`;
    if (matches.length > 0) {
        // eslint-disable-next-line no-console
        console.warn(`<market-table>'s grid layout is not built to support the use of the CSS ${unsupportedValuesText}.
To avoid potential column layout issues, try using explicitly defined \`grid-template-column\` widths using length, percentage, or flex units.`);
        // while this seems wonky (will return an array like ['repeat(auto-fill,', '250px)']), it means that table rows will
        // inherit the parent table's `grid-template-columns` declaration and will look as intended except for in situations
        // where columns are being stuck/unstuck.
        return array;
    }
    const output = [];
    let i = 0;
    let repeatedColCount = null;
    for(i = 0; i < array.length; i++){
        const item = array[i];
        // check to see if we are at the start of a `repeat` block
        if (item.includes('repeat(')) {
            // get number of repeats, ex. "repeat(4" --> 4)
            repeatedColCount = Number.parseInt(item.match(/\d+/).toString(), 10);
            // figure out what's being repeated
            // look ahead from current index to the next index containing ")" (the end of the repeat block)
            const endOfRepeatFunctionIndex = array.findIndex((item, index)=>index > i && item.includes(')'));
            // slice grid-template-columns values into their own array and strip parens/commas
            const repeatedValues = array.slice(i + 1, endOfRepeatFunctionIndex + 1).map((item)=>item.replace(/\W/, ''));
            // push as many values from the set of repeating column sizes as are needed
            for(let j = 0; j < repeatedColCount; j++)output.push(repeatedValues[j % repeatedValues.length].toString());
            // reset repeatedColCount bc we're done w/ the repeat block
            repeatedColCount = null;
            // increment for loop to skip all the items we just dealt with
            i += repeatedValues.length;
        } else if (!repeatedColCount) // if not in a `repeat()` block, save value as normal
        output.push(item);
    }
    return output;
};
const marketTableCss = ":host{position:relative;display:grid;grid-auto-columns:1fr;grid-auto-flow:rows;overflow-x:clip;height:auto}::slotted(.market-table-row:last-of-type:not([slot=\"header\"])),::slotted(.market-table-row.buffer-row){border-bottom:none !important;}";
const RESIZE_DEBOUNCE_DURATION = 16; // 60fps
const MarketTable$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.observers = {};
        this.throttledDetectStyleDeclaration = throttle(this.detectStyleDeclaration.bind(this), RESIZE_DEBOUNCE_DURATION);
        this.styleDeclaration = undefined;
        this.gridColumnTemplate = undefined;
        this.allColumns = [];
        this.visibleColumns = [];
        this.columnsStuckLeft = [];
        this.columnsStuckRight = [];
        this.columnsUnstuck = [];
        this.allRows = [];
        this.rowsStuckTop = [];
        this.rowsStuckBottom = [];
        this.rowsUnstuck = [];
        this.hasAccordionRows = false;
    }
    /* Everytime the computed CSS style for this element is updated, we want to
    mutate the grid template definition, and save whatever template they have set
    to our grid definition so we know what size the columns are */ styleDeclarationObserver(newValue, oldValue) {
        if (isEqual(newValue, oldValue)) return;
        /* unset this.gridColumnTemplate value when there is no explicit grid-template-columns style
      in this situation, the computed value of grid-template-columns === the width of the element
      https://developer.mozilla.org/en-US/docs/Web/CSS/computed_value */ if (newValue.getPropertyValue('grid-template-columns') === newValue.getPropertyValue('width')) {
            this.gridColumnTemplate = [];
            return;
        }
        /* when there is an explicit grid-template-columns style, update this.gridColumnTemplate */ const gridTemplateColumnsValue = parsedGridTemplateColumnValues(newValue.getPropertyValue('grid-template-columns'));
        if (!isEqual(gridTemplateColumnsValue, this.gridColumnTemplate)) this.gridColumnTemplate = gridTemplateColumnsValue;
    }
    /* When the grid template changes, forward it's value to the child sections.
  Use an observer instead of binding in the template to prevent polluting
  the DOM with unneeded attributes */ gridTemplateObserver(newValue, oldValue) {
        if (newValue !== oldValue) {
            this.setColumnWidths(newValue);
            this.updateGridLayout();
        }
    }
    /* If the columns change, forward their values to the child rows, and update
  the column count */ allColumnsObserver(columns, oldValue) {
        if (columns && (!oldValue || columns !== oldValue)) {
            this.setColumnWidths(this.gridColumnTemplate);
            this.forwardColumnPropertiesToCells(this.allColumns);
            this.updateGridLayout();
        }
    }
    allRowsObserver(rows, oldValue) {
        if (rows !== oldValue && rows) {
            this.updateGridLayout();
            this.forwardColumnPropertiesToCells(this.allColumns);
            this.updateStickyRows();
        }
    }
    stuckRowsObserver(newValue, oldValue) {
        if (newValue !== oldValue) {
            this.allRows.map((row)=>row.classList.remove('buffer-row'));
            if (this.rowsStuckTop.length > 0) this.rowsStuckTop[this.rowsStuckTop.length - 1].classList.add('buffer-row');
            if (this.rowsUnstuck.length > 0 && this.rowsStuckBottom.length > 0) this.rowsUnstuck[this.rowsUnstuck.length - 1].classList.add('buffer-row');
        }
    }
    marketTableHeaderLoadedEventHandler({ detail }) {
        this.allColumns = [
            ...detail.columns
        ];
        this.checkColumnVisibility();
    }
    marketTableRowStickEventHandler({ detail }) {
        switch(detail.position){
            case 'top':
                detail.row.el.slot = 'sticky-header';
                break;
            case 'bottom':
                detail.row.el.slot = 'sticky-footer';
                break;
            default:
                // eslint-disable-next-line no-console
                console.warn('could not stick row to an unknown position');
                break;
        }
        this.updateStickyRows();
    }
    marketTableRowUnstickEventHandler({ detail }) {
        /* If the row was originally in a named slot, we want to put the
    row back into that slot */ if (detail.row.originalSlot) detail.row.el.slot = detail.row.originalSlot;
        else detail.row.el.removeAttribute('slot');
        this.updateStickyRows();
    }
    async marketTableColumnStickEventHandler({ detail }) {
        // Stick each cell to the correct side in the row
        await Promise.all([
            ...this.allRows
        ].map(async (row)=>{
            await row._stickColumn(detail.column.name, detail.position);
        }));
        this.updateGridLayout();
    }
    async marketTableColumnUnstickEventHandler({ detail }) {
        await Promise.all([
            ...this.allRows
        ].map(async (row)=>{
            await row._unstickColumn(detail.column.name);
        }));
        this.updateGridLayout();
    }
    marketTableColumnVisibilityChangeHandler({ detail }) {
        this.checkColumnVisibility();
        this.allRows.forEach((row)=>row._syncColumnVisibilityWithCells(detail.columnName, detail.hidden));
        this.detectStyleDeclaration();
    }
    checkColumnVisibility() {
        this.visibleColumns = this.allColumns.filter((column)=>!column.hidden);
    }
    setColumnWidths(gridTemplate) {
        if (this.allColumns.length > 0) this.visibleColumns.forEach((column, i)=>{
            column.width = gridTemplate[i];
        });
    }
    forwardColumnPropertiesToCells(columns) {
        this.allRows.forEach((row)=>row.tableColumns = columns);
    }
    updateGridLayout() {
        if (this.allColumns.length > 0) {
            this.columnsUnstuck = this.visibleColumns.filter((column)=>!column.stickTo);
            this.columnsStuckLeft = this.visibleColumns.filter((column)=>column.stickTo === 'left');
            this.columnsStuckRight = this.visibleColumns.filter((column)=>column.stickTo === 'right');
            const mainGrid = this.columnsUnstuck.map((column)=>column.width);
            const leftGrid = this.columnsStuckLeft.map((column)=>column.width);
            const rightGrid = this.columnsStuckRight.map((column)=>column.width);
            if (this.allRows.length > 0) this.allRows.forEach((row)=>{
                row.gridTemplateMain = mainGrid;
                row.gridTemplateLeft = leftGrid;
                row.gridTemplateRight = rightGrid;
            });
        }
    }
    updateStickyRows() {
        this.rowsStuckTop = this.allRows.filter((row)=>row.sticky && row.header || row.stickTo === 'top');
        this.rowsStuckBottom = this.allRows.filter((row)=>row.sticky && row.footer || row.stickTo === 'bottom');
        this.rowsUnstuck = this.allRows.filter((row)=>!row.stickTo && !row.sticky);
    }
    /* If the slotted content of the table changes, we need to update
  our saved copy of the section and column children */ handleSlotChange() {
        // Get all the child rows
        this.allRows = [
            ...this.el.querySelectorAll(getNamespacedTagFor('market-table-row'))
        ];
        // Check for root accordion fields or default to passed in prop
        const hasAccordionElements = [
            ...this.el.children
        ].some((element)=>{
            return element.tagName.toLowerCase() === getNamespacedTagFor('market-accordion-item');
        }) || this.hasAccordionRows;
        /* Set an index for each row so we have some sort of id and can track it
    this will perhaps come in useful later when we need to add a row re-ordering
    drag & drop feature (although we probably need some conditional, or to set
    the index somewhere else than here) - jbiggs */ this.allRows.forEach((row)=>{
            row.index = Array.prototype.indexOf.call(this.allRows, row);
            row.nested = hasAccordionElements;
        });
    }
    /**
   * Gets current CSSStyleDeclaration object for this.el (see styleDeclarationObserver)
   */ detectStyleDeclaration() {
        this.styleDeclaration = window.getComputedStyle(this.el);
    }
    /**
   * Supports setting dynamic column sizes using CSS media queries by recalculating column width on table resize
   */ initResizeObserver() {
        if (!this.observers.resize) {
            this.observers.resize = new ResizeObserver(()=>{
                window.requestAnimationFrame(()=>{
                    this.throttledDetectStyleDeclaration();
                });
            });
            this.observers.resize.observe(this.el);
        }
    }
    /**
   * Supports setting dynamic column widths by updating inline styles
   */ initInlineStyleObserver() {
        if (!this.observers.inlineStyle) {
            this.observers.inlineStyle = new MutationObserver(()=>this.detectStyleDeclaration());
            this.observers.inlineStyle.observe(this.el, {
                attributes: true,
                attributeFilter: [
                    'style'
                ]
            });
        }
    }
    /**
   * since onSlotchange only fires on changes to the <Host> node itself (not changes to the child slots of the
   * <market-table-area>s), we're using a mutation observer to listen for added rows or changes in row content
   * https://github.com/ionic-team/stencil/issues/232#issuecomment-397871813
   */ initContentObserver() {
        if (!this.observers.content) {
            this.observers.content = new MutationObserver(()=>this.handleSlotChange());
            this.observers.content.observe(this.el, {
                childList: true,
                subtree: true,
                characterData: true
            });
        }
    }
    /* When the component loads, we need to check for a grid-template-columns
  CSS declaration on the table, and also read the column children
  Setting both of these will trigger watcher functions which forward these
  values to the row children */ componentWillLoad() {
        this.detectStyleDeclaration();
        this.handleSlotChange();
    }
    componentDidLoad() {
        this.initResizeObserver();
        this.initInlineStyleObserver();
        this.initContentObserver();
    }
    render() {
        const MarketTableAreaTagName = getNamespacedTagFor('market-table-area');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-table",
            role: "table",
            onSlotchange: ()=>this.handleSlotChange()
        }, (0, $696Z8.h)(MarketTableAreaTagName, {
            orientation: "horizontal",
            "stick-to": "top",
            active: this.rowsStuckTop.length > 0
        }, (0, $696Z8.h)("slot", {
            name: "sticky-header"
        })), (0, $696Z8.h)(MarketTableAreaTagName, {
            orientation: "horizontal",
            active: true
        }, (0, $696Z8.h)("slot", {
            name: "header"
        }), (0, $696Z8.h)("slot", null), (0, $696Z8.h)("slot", {
            name: "footer"
        })), (0, $696Z8.h)(MarketTableAreaTagName, {
            orientation: "horizontal",
            "stick-to": "bottom",
            active: this.rowsStuckBottom.length > 0
        }, (0, $696Z8.h)("slot", {
            name: "sticky-footer"
        })));
    }
    disconnectedCallback() {
        Object.values(this.observers).forEach((observer)=>{
            observer === null || observer === void 0 || observer.disconnect();
        });
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "styleDeclaration": [
                "styleDeclarationObserver"
            ],
            "gridColumnTemplate": [
                "gridTemplateObserver"
            ],
            "allColumns": [
                "allColumnsObserver"
            ],
            "visibleColumns": [
                "allColumnsObserver"
            ],
            "allRows": [
                "allRowsObserver"
            ],
            "rowsStuckTop": [
                "stuckRowsObserver"
            ],
            "rowsStuckBottom": [
                "stuckRowsObserver"
            ],
            "rowsUnstuck": [
                "stuckRowsObserver"
            ]
        };
    }
    static get style() {
        return marketTableCss;
    }
};
const marketTableAreaCss = ":host{position:relative;grid-column:1 / -1;background-color:var(--table-cell-state-normal-background-color, var(--core-surface-10-color))}:host(:not([active])){display:none !important;}:host([orientation=\"horizontal\"]){display:block}:host([orientation=\"vertical\"]){display:grid;grid-auto-columns:1fr;grid-auto-flow:column}:host([orientation=\"vertical\"]) ::slotted(.market-table-row){border-bottom:none}:host([stick-to]){position:sticky;z-index:1}:host([stick-to][orientation=\"horizontal\"]){z-index:2}:host([stick-to=\"top\"]){top:0;border-bottom:var(--table-border-width, 1px) solid var(--table-heading-border-color, var(--core-divider-10-color))}:host([stick-to=\"bottom\"]){bottom:0}:host([stick-to=\"bottom\"]:not(:empty)){border-top:var(--table-border-width, 1px) solid var(--table-heading-border-color, var(--core-divider-10-color))}:host([stick-to=\"left\"]){left:0;justify-content:end;border-right:var(--table-border-width, 1px) solid var(--table-heading-border-color, var(--core-divider-10-color))}:host([stick-to=\"right\"]){right:0;justify-content:start;border-left:var(--table-border-width, 1px) solid var(--table-heading-border-color, var(--core-divider-10-color))}";
const MarketTableArea$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.orientation = 'horizontal';
        this.stickTo = undefined;
        this.gridTemplate = undefined;
        this.active = false;
        this.placement = [
            1,
            -1
        ];
        this.elements = undefined;
    }
    /* When the gridTemplate changes, we need to parse it and update this elements's
  grid-template-columns property, which defines the number and widths of columns
  within this area */ assignGridTemplate(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
            if (newValue.length > 0 || oldValue === undefined // shows content for tables w/o header row
            ) {
                this.active = true;
                this.el.style.gridTemplateColumns = newValue.join(' ');
            } else {
                this.active = false;
                this.el.style.gridTemplateColumns = undefined;
            }
        }
    }
    /* When the placement changes, we need to parse it and update this element's
  grid-column property in order to correctly place it within the parent grid.
  Used to support sticky areas */ placementObserver(newValue, oldValue) {
        if (newValue !== oldValue) this.el.style.gridColumn = `${newValue[0]} / span ${newValue[1]}`;
    }
    componentWillLoad() {
        this.assignGridTemplate(this.gridTemplate);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-table-area"
        }, (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "gridTemplate": [
                "assignGridTemplate"
            ],
            "placement": [
                "placementObserver"
            ]
        };
    }
    static get style() {
        return marketTableAreaCss;
    }
};
const marketTableCellCss = ":host{position:relative;display:flex;justify-content:flex-start;align-items:center;overflow:hidden;padding:var(--table-cell-vertical-padding-size, 12px) var(--table-cell-horizontal-padding-size, 8px);background-color:var(--table-cell-state-normal-background-color, var(--core-surface-10-color));font-weight:var(--table-cell-primary-text-font-weight, var(--core-type-paragraph-20-weight));font-size:var(--table-cell-primary-text-font-size, var(--core-type-paragraph-20-size));line-height:var(--table-cell-primary-text-line-height, var(--core-type-paragraph-20-leading));text-overflow:ellipsis}:host([align=\"right\"]){justify-content:flex-end}:host([align=\"right\"]) .sorting-caret{order:-1;margin-right:var(--table-heading-sort-icon-space-size, 8px);margin-left:0}:host([stickTo=\"left\"]){position:sticky;grid-area:left;border-right:var(--table-fixed-column-border-width, 1px)\n      solid\n      var(--table-fixed-column-border-color, var(--core-divider-20-color))}:host([stickTo=\"right\"]){grid-area:right;border-left:var(--table-fixed-column-border-width, 1px)\n      solid\n      var(--table-fixed-column-border-color, var(--core-divider-20-color))}:host{--transition-duration:0.2s;transition:background-color var(--transition-duration)}@media (hover: hover){:host{}:host([interactive]:hover){background-color:var(--table-cell-hover-state-background-color, var(--core-fill-50-color))}}:host([interactive]){cursor:pointer}:host([interactive]:focus){outline:none;}:host([interactive]:not([disabled]):focus){background-color:var(--table-cell-focus-state-background-color, var(--core-fill-50-color))}:host([active]),:host([interactive]:not([disabled]):active){background-color:var(--table-cell-pressed-state-background-color, var(--core-emphasis-40-color))}:host([interactive][disabled]){pointer-events:none}:host([disabled]){background-color:transparent;color:var(--table-cell-disabled-state-text-color, var(--core-text-30-color));pointer-events:none}:host([hidden]){display:none}:host(:first-of-type){padding-left:var(--table-cell-padding, 8px)}:host(:first-of-type) ::slotted(button){all:unset;display:flex;justify-content:space-between;align-items:center;padding-right:var(--core-metrics-spacing-100);padding-left:calc(\n        var(--cell-indent-level) *\n        var(--table-row-indentation-padding, 40px) +\n        var(--core-metrics-spacing-100)\n      );color:var(--table-cell-normal-state-content-color, var(--core-fill-black-color));cursor:pointer}:host(:first-of-type) ::slotted(button):focus-visible{outline:none}:host(:first-of-type) ::slotted(button):focus{color:var(--table-accordion-focus-state-content-color, var(--core-fill-black-color))}:host(:first-of-type) ::slotted(button):hover{color:var(--table-accordion-hover-state-content-color, var(--core-fill-black-color))}:host(:first-of-type) ::slotted(button):active{color:var(--table-accordion-pressed-state-content-color, var(--core-fill-black-color))}:host(:first-of-type) ::slotted([slot='nested-row-indicator']){height:100%}::slotted([slot='leading-accessory'][size='image']){margin-right:16px;margin-left:12px}::slotted([slot='leading-accessory'][size='icon']){margin-right:16px;margin-left:16px}::slotted([slot='trailing-accessory'][size='image']){margin-right:12px;margin-left:16px}::slotted([slot='trailing-accessory'][size='icon']){margin-right:16px;margin-left:16px}::slotted([slot='nested-row-indicator']){color:var(--table-cell-normal-state-content-color, var(--core-fill-black-color))}::slotted([slot='nested-row-indicator']:focus-visible){outline:none}::slotted([slot='nested-row-indicator']:focus){color:var(--table-accordion-focus-state-content-color, var(--core-fill-black-color))}::slotted([slot='nested-row-indicator']:hover){color:var(--table-accordion-hover-state-content-color, var(--core-fill-black-color))}::slotted([slot='nested-row-indicator']:active){color:var(--table-accordion-pressed-state-content-color, var(--core-fill-black-color))}";
const MarketTableCell$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketTableCellClicked = (0, $696Z8.createEvent)(this, "marketTableCellClicked", 7);
        this.align = false;
        this.column = undefined;
        this.leadingIndentation = 0;
        this.active = false;
        this.interactive = false;
        this.disabled = false;
        this.originalSlot = undefined;
        this.hidden = false;
    }
    /**
   * **INTERNAL [do not use directly]**
   * Forwards appropriate properties from matching header market-table-column element to this cell.
   */ _updateColumnRelatedProperties(column) {
        if (!column) return Promise.resolve();
        this.column = column.name;
        this.align = column.align;
        this.hidden = column.hidden;
        if (column.stickTo) this._stickSelf(column.stickTo);
        return Promise.resolve();
    }
    /**
   * **INTERNAL [do not use directly]**
   * Sets properties specified in the row element. Leading and trailing
   * accessories are best set on the first or last cell to not mess
   * with the grid structure
   * @param rowEl
   */ _updateFirstCellProperties(rowEl) {
        this.leadingIndentation = rowEl.leadingIndentation || 0;
        // Sets leading accessory level of indentation on current row
        this.el.style.setProperty('--cell-indent-level', `${this.leadingIndentation}`);
        return Promise.resolve();
    }
    /**
   * **INTERNAL [do not use directly]**
   * Moves this column into a slot inside the market-table-area
   * which is fixed to the provided edge (position), allowing
   * for fixed columns
   */ _stickSelf(position) {
        if (position) this.el.slot = `sticky-${position}`;
        return Promise.resolve();
    }
    /**
   * **INTERNAL [do not use directly]**
   * Moves this column back into it's original slot from a slot
   * within a fixed market-table-area
   */ _unstickSelf() {
        if (!this.originalSlot) this.el.removeAttribute('slot');
        else this.el.slot = this.originalSlot;
        return Promise.resolve();
    }
    componentWillLoad() {
        this.originalSlot = this.el.getAttribute('slot');
    }
    handleClick() {
        if (this.interactive) this.marketTableCellClicked.emit();
    }
    handleKeydown(e) {
        // don't intercept keydown of descendant elements
        // e.g. when typing into nested input fields (gross)
        if (e.target !== this.el) return;
        switch(e.key){
            case 'Enter':
                this.handleClick();
                break;
            case ' ':
                this.handleClick();
                e.preventDefault(); // spacebar should not scroll page
                break;
        }
    }
    render() {
        const { disabled, interactive, align, hidden } = this;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-table-cell",
            role: "cell",
            align: align === 'right' && align,
            hidden: hidden,
            tabindex: interactive && !disabled ? '0' : null,
            onClick: ()=>this.handleClick(),
            onKeydown: (e)=>this.handleKeydown(e)
        }, (0, $696Z8.h)("slot", {
            name: "nested-row-indicator"
        }), (0, $696Z8.h)("slot", {
            name: "leading-accessory"
        }), (0, $696Z8.h)("slot", null), (0, $696Z8.h)("slot", {
            name: "trailing-accessory"
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketTableCellCss;
    }
};
const marketTableColumnCss = ":host{position:relative;display:flex;justify-content:flex-start;align-items:center;overflow:hidden;padding:var(--table-cell-vertical-padding-size, 12px) var(--table-cell-horizontal-padding-size, 8px);background-color:var(--table-cell-state-normal-background-color, var(--core-surface-10-color));font-weight:var(--table-cell-primary-text-font-weight, var(--core-type-paragraph-20-weight));font-size:var(--table-cell-primary-text-font-size, var(--core-type-paragraph-20-size));line-height:var(--table-cell-primary-text-line-height, var(--core-type-paragraph-20-leading));text-overflow:ellipsis}:host([align=\"right\"]){justify-content:flex-end}:host([align=\"right\"]) .sorting-caret{order:-1;margin-right:var(--table-heading-sort-icon-space-size, 8px);margin-left:0}:host([stickTo=\"left\"]){position:sticky;grid-area:left;border-right:var(--table-fixed-column-border-width, 1px)\n      solid\n      var(--table-fixed-column-border-color, var(--core-divider-20-color))}:host([stickTo=\"right\"]){grid-area:right;border-left:var(--table-fixed-column-border-width, 1px)\n      solid\n      var(--table-fixed-column-border-color, var(--core-divider-20-color))}:host{font-weight:var(--table-heading-primary-text-font-weight, 500);font-size:var(--table-heading-primary-text-font-size, var(--core-type-semibold-20-size));line-height:var(--table-heading-primary-text-line-height, var(--core-type-semibold-20-leading))}:host([sortable]){cursor:pointer;transition:background-color\n      var(--core-animation-enter-transition-fast-speed-duration)\n      var(--core-animation-enter-transition-fast-speed-duration-easing)}:host([sortable]:hover){background-color:var(--table-heading-hover-state-background-color, var(--core-fill-50-color))}:host([sortable]:active){background-color:var(--table-heading-active-state-background-color, var(--core-emphasis-40-color))}:host([sort-order]) .sorting-caret{fill:var(--table-heading-sortable-variant-active-state-caret-color, var(--core-text-10-color))}:host([sort-order=\"descending\"]) .sorting-caret{transform:rotate(0deg)}:host([hidden]){display:none}.sorting-caret{margin-left:var(--table-heading-sort-icon-space-size, 8px);fill:var(--table-heading-sortable-variant-normal-state-caret-color, var(--core-text-30-color));transition:color\n    var(--core-animation-enter-transition-fast-speed-duration)\n    var(--core-animation-enter-transition-fast-speed-duration-easing);transform:rotate(180deg)}::slotted([slot='leading-accessory'][size='image']){margin-right:16px;margin-left:12px}::slotted([slot='leading-accessory'][size='icon']){margin-right:16px;margin-left:16px}::slotted([slot='trailing-accessory'][size='image']){margin-right:12px;margin-left:16px}::slotted([slot='trailing-accessory'][size='icon']){margin-right:16px;margin-left:16px}";
const MarketTableColumn$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketTableColumnStick = (0, $696Z8.createEvent)(this, "marketTableColumnStick", 7);
        this.marketTableColumnUnstick = (0, $696Z8.createEvent)(this, "marketTableColumnUnstick", 7);
        this.marketTableColumnSort = (0, $696Z8.createEvent)(this, "marketTableColumnSort", 7);
        this.marketTableColumnVisibilityChange = (0, $696Z8.createEvent)(this, "marketTableColumnVisibilityChange", 7);
        this.name = undefined;
        this.align = false;
        this.stickTo = undefined;
        this.sortable = false;
        this.sortOrder = undefined;
        this.hidden = false;
        this.index = 0;
        this.width = undefined;
        this.originalSlot = undefined;
    }
    emitVisibilityChangeEvent(newValue, oldValue) {
        if (newValue !== oldValue) this.marketTableColumnVisibilityChange.emit({
            columnName: this.name,
            hidden: newValue
        });
    }
    async emitStickyEvents(newValue, oldValue) {
        if (newValue && newValue !== oldValue) await this.stick(newValue);
        else this.unstick(newValue);
    }
    /**
   * Fixes this column to the provided table edge (position)
   */ stick(position) {
        /* If our position is different than out current stickTo value,
    then we are probably calling stick() directly from javascript, rather
    than having it be triggered from the stickTo watcher, so we want to
    update that value, which will call this function again, the values will match
    and then the event will be emitted */ if (position !== this.stickTo) this.stickTo = position;
        else this.marketTableColumnStick.emit({
            column: this,
            position: position,
            index: this.index
        });
        return Promise.resolve();
    }
    /**
   * Un-fixes this column from any table edge
   */ unstick(position) {
        this.marketTableColumnUnstick.emit({
            column: this,
            position: position,
            index: this.index
        });
        return Promise.resolve();
    }
    /**
   * **INTERNAL [do not use directly]**
   * Moves this column into a slot inside the market-table-area
   * which is fixed to the provided edge (position), allowing
   * for fixed columns
   */ _stickSelf(position) {
        if (position) this.el.slot = `sticky-${position}`;
        this.stickTo = position;
        return Promise.resolve();
    }
    /**
   * **INTERNAL [do not use directly]**
   * Moves this column back into it's original slot from a slot
   * within a fixed market-table-area
   */ _unstickSelf() {
        if (!this.originalSlot) this.el.removeAttribute('slot');
        else this.el.slot = this.originalSlot;
        this.el.removeAttribute('stick-to');
        return Promise.resolve();
    }
    clickHandler() {
        if (this.sortable) this.marketTableColumnSort.emit({
            column: this.name,
            previousSortOrder: this.sortOrder
        });
    }
    componentWillLoad() {
        this.originalSlot = this.el.getAttribute('slot');
        if (!this.name) console.warn('Please set a name on <market-table-column>. Tables may not work correctly without this.'); // eslint-disable-line no-console
    }
    componentDidLoad() {
        // stickTo watcher does not fire on first component load
        if (this.stickTo) this.stick(this.stickTo);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-table-column",
            onClick: ()=>this.clickHandler(),
            align: this.align === 'right' && this.align
        }, (0, $696Z8.h)("slot", {
            name: "leading-accessory"
        }), (0, $696Z8.h)("slot", null), this.sortable && (0, $696Z8.h)("svg", {
            width: "16",
            height: "15",
            viewBox: "0 0 16 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            class: "sorting-caret"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8.70709 14.7071C8.31657 15.0976 7.6834 15.0976 7.29288 14.7071L0.292879 7.7071L1.70709 6.29289L6.99999 11.5858L6.99999 -7.612e-07L8.99999 -5.86354e-07L8.99999 11.5858L14.2929 6.29289L15.7071 7.70711L8.70709 14.7071Z"
        })), (0, $696Z8.h)("slot", {
            name: "trailing-accessory"
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "hidden": [
                "emitVisibilityChangeEvent"
            ],
            "stickTo": [
                "emitStickyEvents"
            ]
        };
    }
    static get style() {
        return marketTableColumnCss;
    }
};
const marketTableRowCss = ":host{--transition-duration:0.2s;position:relative;display:grid;grid-column:1 / -1;grid-auto-columns:1fr;grid-auto-flow:column;border-bottom:var(--table-border-width, 1px) solid var(--table-row-border-color, var(--core-divider-20-color));transition:background-color var(--transition-duration)}@media (hover: hover){:host{}:host([interactive]:hover) ::slotted(.market-table-cell){background-color:var(--table-cell-hover-state-background-color, var(--core-fill-50-color))}}:host([header]){border-bottom:var(--table-border-width, 1px) solid var(--table-heading-border-color, var(--core-divider-10-color))}:host([footer]) ::slotted(.market-table-cell){border-bottom:none;font-weight:var(--table-footing-primary-text-font-weight, 500);font-size:var(--table-footing-primary-text-font-size, var(--core-type-semibold-20-size));line-height:var(--table-footing-primary-text-line-height, var(--core-type-semibold-20-leading))}:host([interactive]) ::slotted(.market-table-cell){cursor:pointer}:host([active]) ::slotted(.market-table-cell),:host([interactive]:active) ::slotted(.market-table-cell){background-color:var(--table-cell-pressed-state-background-color, var(--core-emphasis-40-color))}:host([interactive]:focus){outline:none;}:host([interactive]:not([disabled]):focus) ::slotted(.market-table-cell){background-color:var(--table-cell-focus-state-background-color, var(--core-fill-50-color))}:host([interactive][disabled]){pointer-events:none}:host([disabled]) ::slotted(.market-table-cell){background-color:transparent;color:var(--table-cell-disabled-state-text-color, var(--core-text-30-color));pointer-events:none}:host([nested]) ::slotted(.market-table-cell:first-of-type){padding-left:calc(\n        (\n          var(--cell-indent-level) *\n          var(--table-row-indentation-padding, 40px)\n        ) +\n        var(--table-cell-padding, 8px) +\n        var(--table-accordion-content-width, 30px)\n      )}:host([slot='custom-trigger']) ::slotted(.market-table-cell:first-of-type),:host([slot='header']) ::slotted(.market-table-cell:first-of-type),:host([slot='footer']) ::slotted(.market-table-cell:first-of-type){padding-left:var(--table-cell-padding, 8px)}:host ::slotted(.market-table-cell:first-of-type){padding-left:calc(\n      var(--table-cell-padding, 8px) +\n      (var(--cell-indent-level) * var(--table-row-indentation-padding, 40px))\n    )}";
const MarketTableRow$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketTableHeaderLoaded = (0, $696Z8.createEvent)(this, "marketTableHeaderLoaded", 7);
        this.marketTableRowClicked = (0, $696Z8.createEvent)(this, "marketTableRowClicked", 7);
        this.marketTableRowStick = (0, $696Z8.createEvent)(this, "marketTableRowStick", 7);
        this.marketTableRowUnstick = (0, $696Z8.createEvent)(this, "marketTableRowUnstick", 7);
        this.marketAccordionToggled = (0, $696Z8.createEvent)(this, "marketAccordionToggled", 7);
        this.marketNestedRowToggled = (0, $696Z8.createEvent)(this, "marketNestedRowToggled", 7);
        // prevents unstick events from being fired on the slotchange before componentDidLoad
        this.componentLoaded = false;
        this.leadingIndentation = 0;
        this.stickTo = false;
        this.sticky = undefined;
        this.active = false;
        this.interactive = false;
        this.disabled = false;
        this.selected = false;
        this.header = false;
        this.footer = false;
        this.originalSlot = undefined;
        this.index = 0;
        this.tableColumns = undefined;
        this.cells = undefined;
        this.gridTemplateMain = [];
        this.gridTemplateLeft = [];
        this.gridTemplateRight = [];
        this.expanded = false;
        this.nested = false;
        this.styleDeclaration = undefined;
        this.gridTemplate = [];
        this.nestedRowToggleButton = undefined;
    }
    formNewGridTemplate() {
        this.gridTemplate = [
            ...this.gridTemplateLeft,
            ...this.gridTemplateMain,
            ...this.gridTemplateRight
        ];
        if (this.tableAreaLeft) this.tableAreaLeft.placement = [
            1,
            this.gridTemplateLeft.length
        ];
        if (this.tableAreaMain) this.tableAreaMain.placement = [
            this.gridTemplateLeft.length + 1,
            this.gridTemplateMain.length
        ];
        if (this.tableAreaRight) this.tableAreaRight.placement = [
            this.gridTemplateLeft.length + this.gridTemplateMain.length + 1,
            this.gridTemplateRight.length
        ];
    }
    gridTemplateObserver(newValue, oldValue) {
        if (newValue !== oldValue) this.el.style.gridTemplateColumns = newValue.join(' ');
    }
    stickyObserver(newValue, oldValue) {
        if (newValue !== oldValue) this.emitStickyEvents();
    }
    columnsObserver(columns) {
        this.setCellColumnProperties(columns);
    }
    updateCellProperties(oldCellList, newCellList) {
        if (oldCellList !== newCellList) this.setCellColumnProperties(this.tableColumns);
    }
    updateFirstCellProperties() {
        this._setFirstCellProperties();
    }
    updateNestedRowButton() {
        if (this.nestedRowToggleButton) {
            this.nestedRowToggleButton.ariaExpanded = `${this.expanded}`;
            // We cannot access the svg from the css files in the current state,
            // so we have to do it through JS. I figured this was the best place
            // to do it since the rotation depends on expansion for now. We should
            // find a better way to access this svg in the style sheets. -lindamr
            const svgElement = this.nestedRowToggleButton.querySelector('svg');
            if (svgElement) {
                if (this.expanded) svgElement.style.transform = 'rotate(-180deg)';
                else svgElement.style.transform = 'rotate(0deg)';
            }
        }
    }
    updateSlottedControlCheckedValue() {
        var _a;
        (_a = this.slottedControl) === null || _a === void 0 || _a.setSelection(this.selected);
    }
    updateSlottedControlDisabledValue() {
        var _a;
        (_a = this.slottedControl) === null || _a === void 0 || _a.setDisabled(this.disabled);
    }
    handleMarketCheckboxValueChange(event) {
        // Update selected value if event is triggered by slottedControl
        if (event.target !== this.slottedControl) return;
        this.selected = event.detail.current;
    }
    /**
   * Sticks this row to the provided edge (position) of the table
   */ stick(position) {
        if (position) this.stickTo = position;
        else if (this.header || this.footer) this.sticky = true;
        return Promise.resolve();
    }
    /**
   * Unsticks this row from any edge of the table
   */ unstick() {
        this.sticky = false;
        this.stickTo = false;
        return Promise.resolve();
    }
    /**
   * **INTERNAL [do not use directly]**
   * Used by the parent table to support fixing columns to either side of the table
   */ async _stickColumn(column, position) {
        const cell = this.el.querySelector(`[name="${column}"], [column="${column}"]`);
        if (cell) await cell._stickSelf(position);
        else console.warn('cannot stick cell to unknown position'); // eslint-disable-line no-console
    }
    /**
   * **INTERNAL [do not use directly]**
   * Used by the parent table to support fixing columns to either side of the table
   */ async _unstickColumn(column) {
        const cell = this.el.querySelector(`[name="${column}"], [column="${column}"]`);
        if (cell) await cell._unstickSelf();
        else console.warn('cannot unstick cell from unknown position'); // eslint-disable-line no-console
    }
    /**
   * **INTERNAL [do not use directly]**
   * Sets the hidden prop on market-table-cell. Used by market-table to allow market-table-column
   * to control the hidden/visible state of its associated table cells.
   */ _syncColumnVisibilityWithCells(columnName, hidden) {
        const cell = this.el.querySelector(`[name="${columnName}"], [column="${columnName}"]`);
        if (cell) cell.hidden = hidden;
        return Promise.resolve();
    }
    /**
   * **INTERNAL [do not use directly]**
   * Sets properties computed or specified on the row on the first
   * cell to keep the table rows from shifting
   */ _setFirstCellProperties() {
        var _a, _b, _c;
        // Setting indentation on the first cell of the row to not mess
        // with the table grid
        if (((_a = this.cells) === null || _a === void 0 ? void 0 : _a.length) && this.isStylableCell(this.cells[0])) (_c = (_b = this.cells[0])._updateFirstCellProperties) === null || _c === void 0 || _c.call(_b, this.el);
        return Promise.resolve();
    }
    /**
   * Sets the leadingIndentation
   * @param leadingIndentation
   */ setLeadingIndentation(leadingIndentation) {
        this.leadingIndentation = leadingIndentation;
        return Promise.resolve();
    }
    /**
   * Sets expanded property and emits nested row toggle event
   */ toggleNestedRow() {
        this.expanded = !this.expanded;
        this.marketAccordionToggled.emit({
            expanded: this.expanded
        });
        this.marketNestedRowToggled.emit({
            expanded: this.expanded
        });
        return Promise.resolve();
    }
    /**
   * Checks type of cell to make Typescript happy about using functions that are only on
   * HTMLMarketTableCellElement and not HTMLMarketTableColumnElement
   * @param cell
   * @returns
   */ isStylableCell(cell) {
        return cell._updateColumnRelatedProperties !== undefined && cell._updateFirstCellProperties !== undefined;
    }
    setCellColumnProperties(columns) {
        if (this.cells && columns && columns.length > 0) this.cells.forEach((cell, i)=>{
            if (this.isStylableCell(cell)) {
                const column = columns[i];
                cell._updateColumnRelatedProperties(column);
            }
        });
    }
    emitStickyEvents() {
        let position;
        if (this.stickTo) position = this.stickTo;
        else if (this.header) position = 'top';
        else if (this.footer) position = 'bottom';
        if (this.sticky || this.stickTo) // emit a stick event
        this.marketTableRowStick.emit({
            row: this,
            position: position,
            index: this.index
        });
        else if (this.componentLoaded) // Emit an unstick event
        this.marketTableRowUnstick.emit({
            row: this,
            position: position,
            index: this.index
        });
    }
    componentWillLoad() {
        // setting row properties based on whether row is using a named slot
        this.originalSlot = this.el.slot;
        this.header = this.originalSlot === 'header';
        this.footer = this.originalSlot === 'footer';
        // prettier wants (typeof this.cells)[0] but that change seems wrong
        // prettier-ignore
        this.cells = this.el.querySelectorAll(getNamespacedTagFor('market-table-cell'));
    }
    handleSlotChange() {
        this.cells = this.el.querySelectorAll(`${getNamespacedTagFor('market-table-cell')}, ${getNamespacedTagFor('market-table-column')}`);
        // If this is our header row, meaning we have column children, then emit an
        // event that sends the columns to the table parent
        if (this.header) this.marketTableHeaderLoaded.emit({
            columns: this.el.querySelectorAll(getNamespacedTagFor('market-table-column'))
        });
        this.emitStickyEvents();
    }
    _getMarketRowElement(element) {
        return element.querySelector(getNamespacedTagFor('market-table-row'));
    }
    _addCaretButtonToFirstCell() {
        if (this.cells && this.cells[0]) {
            this.nestedRowToggleButton = document.createElement('button');
            Object.assign(this.nestedRowToggleButton, {
                slot: 'nested-row-indicator',
                type: 'button',
                ariaExpanded: `${this.expanded}`,
                onclick: ()=>this.toggleNestedRow()
            });
            this.nestedRowToggleButton.innerHTML = `<svg class="caret" width="14" height="8" viewBox="0 0 14 8" fill="none" style="transition-duration:300ms;" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.70715 7.70711C7.31663 8.09763 6.68346 8.09763 6.29294 7.70711L0.29294 1.70711L1.70715 0.292892L7.00005 5.58579L12.2929 0.292893L13.7072 1.70711L7.70715 7.70711Z"
            fill="currentColor"
          />
        </svg>`;
            // Get the first table cell child element and append the this.nestedRowToggleButtonElement to it. Because it has the nested-row-indicator slot, it should appear in the correct place
            this.cells[0].append(this.nestedRowToggleButton);
        }
    }
    _registerSlottedControl() {
        this.slottedControl = this.el.querySelector([
            `[slot="control"] ${getNamespacedTagFor('market-checkbox')}`,
            `[slot="control"] ${getNamespacedTagFor('market-toggle')}`
        ].join(','));
        if (this.slottedControl) {
            this.slottedControl.setDisabled(this.disabled);
            this.slottedControl.setSelection(this.selected);
        }
    }
    componentDidRender() {
        var _a, _b;
        // Get accordion parent
        const accordionElement = this.el.closest(getNamespacedTagFor('market-accordion-item'));
        if (accordionElement) {
            let parentRow;
            if (this.el.slot === 'custom-trigger') {
                // If current row has nested row, we need to look a level above for
                // the correct indentation.
                const parentAccordionElement = (_a = accordionElement.parentElement) === null || _a === void 0 ? void 0 : _a.closest(getNamespacedTagFor('market-accordion-item'));
                // If there is a parent accordion element, find the trigger row
                // to get previous level indentation and set the current one.
                // Otherwise, the current row is at top level and indentaion will
                // remain as 0.
                if (parentAccordionElement) parentRow = [
                    ...parentAccordionElement.children
                ].find((child)=>child.slot === 'custom-trigger');
            } else // Find the the trigger row within same level to set indentation
            parentRow = [
                ...accordionElement.children
            ].find((child)=>child.slot === 'custom-trigger');
            // Set indentation
            this.leadingIndentation = parentRow ? ((_b = parentRow.leadingIndentation) !== null && _b !== void 0 ? _b : 0) + 1 : 0;
        }
        // Set indentation on the first cell of the row to not mess
        // with the table grid
        this._setFirstCellProperties();
    }
    componentDidLoad() {
        this.componentLoaded = true;
        if (this.el.slot === 'custom-trigger') {
            // Add caret button
            this._addCaretButtonToFirstCell();
            // If accordion is expanded when component is loaded, we have to
            // we have to make sure the caret is facing the correct way
            const svgElement = this.nestedRowToggleButton.querySelector('svg');
            if (svgElement && this.expanded) svgElement.style.transform = 'rotate(-180deg)';
        }
    }
    handleClick(e) {
        const ignoredElementTagNames = [
            getNamespacedTagFor('market-accessory'),
            getNamespacedTagFor('market-button'),
            getNamespacedTagFor('market-checkbox'),
            getNamespacedTagFor('market-link'),
            getNamespacedTagFor('market-toggle'),
            'button',
            'a'
        ];
        // If the element clicked was one of the ignoredElementTagNames or anything inside of them,
        // do not trigger marketTableRowClicked
        const shouldIgnoreClick = ignoredElementTagNames.some((tagname)=>e.target.closest(tagname));
        if (shouldIgnoreClick) return;
        if (this.interactive) this.marketTableRowClicked.emit();
    }
    handleKeydown(e) {
        // don't intercept keydown of descendant elements
        // e.g. when typing into nested input fields (gross)
        if (e.target !== this.el) return;
        switch(e.key){
            case 'Enter':
                this.handleClick(e);
                break;
            case ' ':
                this.handleClick(e);
                e.preventDefault(); // spacebar should not scroll page
                break;
        }
    }
    render() {
        const { disabled, footer, gridTemplateLeft, gridTemplateMain, gridTemplateRight, header, interactive, selected, slottedControl } = this;
        const MarketTableAreaTagName = getNamespacedTagFor('market-table-area');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            "aria-selected": slottedControl ? Boolean(selected).toString() : null,
            class: "market-table-row",
            role: "row",
            tabindex: interactive && !disabled ? '0' : null,
            header: header,
            footer: footer,
            onClick: (e)=>this.handleClick(e),
            onKeydown: (e)=>this.handleKeydown(e)
        }, (0, $696Z8.h)(MarketTableAreaTagName, {
            orientation: "vertical",
            "stick-to": "left",
            gridTemplate: gridTemplateLeft,
            ref: (el)=>this.tableAreaLeft = el
        }, (0, $696Z8.h)("slot", {
            name: "sticky-left"
        })), (0, $696Z8.h)(MarketTableAreaTagName, {
            orientation: "vertical",
            gridTemplate: gridTemplateMain,
            ref: (el)=>this.tableAreaMain = el,
            active: true
        }, (0, $696Z8.h)("slot", {
            name: "control",
            onSlotchange: ()=>this._registerSlottedControl()
        }), (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.handleSlotChange()
        })), (0, $696Z8.h)(MarketTableAreaTagName, {
            orientation: "vertical",
            "stick-to": "right",
            gridTemplate: gridTemplateRight,
            ref: (el)=>this.tableAreaRight = el
        }, (0, $696Z8.h)("slot", {
            name: "sticky-right"
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "gridTemplateMain": [
                "formNewGridTemplate"
            ],
            "gridTemplateLeft": [
                "formNewGridTemplate"
            ],
            "gridTemplateRight": [
                "formNewGridTemplate"
            ],
            "gridTemplate": [
                "gridTemplateObserver"
            ],
            "stickTo": [
                "stickyObserver"
            ],
            "sticky": [
                "stickyObserver"
            ],
            "tableColumns": [
                "columnsObserver"
            ],
            "cells": [
                "updateCellProperties"
            ],
            "leadingIndentation": [
                "updateFirstCellProperties"
            ],
            "expanded": [
                "updateNestedRowButton"
            ],
            "selected": [
                "updateSlottedControlCheckedValue"
            ],
            "disabled": [
                "updateSlottedControlDisabledValue"
            ]
        };
    }
    static get style() {
        return marketTableRowCss;
    }
};
const marketTableV2Css = ":host,*{box-sizing:border-box}:host{--table-cell-state-normal-background-color:var(--core-surface-10-color);--table-cell-text-font-weight:var(--core-type-paragraph-20-weight);--table-cell-text-font-size:var(--core-type-paragraph-20-size);--table-cell-text-line-height:var(--core-type-paragraph-20-leading);display:block;overflow:auto;width:100%;background-color:var(--table-cell-state-normal-background-color);font-weight:var(--table-cell-text-font-weight);font-size:var(--table-cell-text-font-size);line-height:var(--table-cell-text-line-height);font-feature-settings:'tnum'}:host [role=\"table\"]{display:table;vertical-align:middle;width:100%;border-spacing:0;border-collapse:separate;table-layout:auto;text-align:left}:host slot{vertical-align:inherit;text-align:inherit}:host([layout=\"fixed\"]) [role=\"table\"]{table-layout:fixed}:host([align=\"left\"]) [role=\"table\"]{text-align:left}:host([align=\"center\"]) [role=\"table\"]{text-align:center}:host([align=\"right\"]) [role=\"table\"]{text-align:right}:host([valign=\"top\"]) [role=\"table\"]{vertical-align:top}:host([valign=\"middle\"]) [role=\"table\"]{vertical-align:middle}:host([valign=\"bottom\"]) [role=\"table\"]{vertical-align:bottom}";
const MarketTableV2$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.align = undefined;
        this.layout = 'auto';
        this.valign = undefined;
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-table-v2"
        }, (0, $696Z8.h)("div", {
            role: "table",
            part: "table"
        }, (0, $696Z8.h)("slot", null)));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketTableV2Css;
    }
};
const marketTableV2CellCss = ":host,*{box-sizing:border-box}:host{--table-cell-vertical-padding-size:var(--core-metrics-spacing-150);--table-cell-horizontal-padding-size:var(--core-metrics-spacing-100);--table-cell-horizontal-spacing-size:var(--core-metrics-spacing-150);--table-cell-border-width:1px;--table-cell-heading-border-color:var(--core-divider-10-color);--table-cell-state-normal-background-color:var(--core-surface-10-color);--table-cell-hover-state-background-color:var(--core-fill-50-color);--table-cell-focus-state-background-color:var(--core-fill-50-color);--table-cell-pressed-state-background-color:var(--core-emphasis-40-color);--table-cell-disabled-state-text-color:var(--core-text-30-color);display:table-cell;vertical-align:inherit;width:auto;padding:var(--table-cell-vertical-padding-size) var(--table-cell-horizontal-padding-size);border-bottom:var(--table-cell-border-width) solid var(--table-cell-border-color);outline:none;text-align:inherit}:host .content{display:flex;gap:var(--table-cell-horizontal-spacing-size);align-items:center;width:100%}:host .default-slot{width:100%}:host([nowrap]) .default-slot{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host([align=\"left\"]){text-align:left}:host([align=\"center\"]){text-align:center}:host([align=\"right\"]){text-align:right}:host([valign=\"top\"]){vertical-align:top}:host([valign=\"middle\"]){vertical-align:middle}:host([valign=\"bottom\"]){vertical-align:bottom}:host([sticky]){position:sticky;z-index:2;background-color:var(--table-cell-state-normal-background-color)}:host([sticky=\"left\"]){left:0;border-right:var(--table-cell-border-width) solid var(--table-cell-heading-border-color)}:host([sticky=\"right\"]){right:0;border-left:var(--table-cell-border-width) solid var(--table-cell-heading-border-color)}::slotted([slot='leading-accessory']),::slotted([slot='trailing-accessory']){flex-shrink:0}:host([interactive]){cursor:pointer}@media (hover: hover){:host([interactive]:hover){background-color:var(--table-cell-hover-state-background-color)}}:host([interactive]:focus){background-color:var(--table-cell-focus-state-background-color)}:host([active]),:host([interactive]:active){background-color:var(--table-cell-pressed-state-background-color)}:host([disabled]){color:var(--table-cell-disabled-state-text-color);pointer-events:none}";
const MarketTableV2Cell$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.active = false;
        this.align = undefined;
        this.disabled = false;
        this.interactive = false;
        this.nowrap = false;
        this.sticky = undefined;
        this.valign = undefined;
    }
    render() {
        var _a;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            role: (_a = this.el.role) !== null && _a !== void 0 ? _a : 'cell',
            class: "market-table-v2-cell"
        }, (0, $696Z8.h)("div", {
            class: "content"
        }, (0, $696Z8.h)("slot", {
            name: "leading-accessory"
        }), (0, $696Z8.h)("div", {
            class: "default-slot"
        }, (0, $696Z8.h)("slot", null)), (0, $696Z8.h)("slot", {
            name: "trailing-accessory"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketTableV2CellCss;
    }
};
const marketTableV2RowCss = ":host,*{box-sizing:border-box}:host{--table-cell-border-width:1px;--table-cell-border-color:var(--core-divider-20-color);--table-cell-horizontal-spacing:var(--core-metrics-spacing-150);--table-cell-heading-border-color:var(--core-divider-10-color);--table-cell-heading-font-weight:var(--core-type-medium-weight);--table-cell-state-normal-background-color:var(--core-surface-10-color);display:table-row;vertical-align:inherit;width:100%;outline:none;text-align:inherit}:host slot{vertical-align:inherit;text-align:inherit}:host([align=\"left\"]){text-align:left}:host([align=\"center\"]){text-align:center}:host([align=\"right\"]){text-align:right}:host([valign=\"top\"]){vertical-align:top}:host([valign=\"middle\"]){vertical-align:middle}:host([valign=\"bottom\"]){vertical-align:bottom}:host([header]),:host([footer]){font-weight:var(--table-cell-heading-font-weight)}:host([header]) ::slotted(.market-table-v2-cell),:host([sticky=\"top\"]) ::slotted(.market-table-v2-cell){border-bottom:var(--table-cell-border-width) solid var(--table-cell-heading-border-color)}:host([footer]) ::slotted(.market-table-v2-cell),:host([sticky=\"bottom\"]) ::slotted(.market-table-v2-cell){border-top:var(--table-cell-border-width) solid var(--table-cell-heading-border-color);border-bottom:none}:host([sticky]){position:sticky;z-index:3;background-color:var(--table-cell-state-normal-background-color)}:host([sticky=\"top\"]){top:0}:host([sticky=\"bottom\"]){bottom:0}:host([interactive]){cursor:pointer}@media (hover: hover){:host([interactive]:hover){background-color:var(--table-cell-hover-state-background-color)}}:host([interactive]:focus){background-color:var(--table-cell-focus-state-background-color)}:host([active]),:host([interactive]:active){background-color:var(--table-cell-pressed-state-background-color)}:host([disabled]){color:var(--table-cell-disabled-state-text-color);pointer-events:none}";
const MarketTableV2Row$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.active = false;
        this.align = undefined;
        this.disabled = false;
        this.footer = false;
        this.header = false;
        this.interactive = false;
        this.sticky = undefined;
        this.valign = undefined;
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            role: "row",
            class: "market-table-v2-row"
        }, (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketTableV2RowCss;
    }
};
const marketTabsCss = ":host{display:block}";
const MarketTabs$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.selectedTab = undefined;
        this.defaultTab = undefined;
    }
    marketTabSelectedChangedEventHandler(e) {
        e.stopPropagation();
        const { panelId, tabId, value } = e.detail;
        if (!value) return;
        else if (this.selectedTab !== tabId) this.selectedTab = tabId;
        this.showPanelWithId(panelId);
    }
    tabWatcher(newTabId) {
        this.setTab(newTabId);
    }
    setTab(tabId) {
        if (this.tabListEl) this.tabListEl.selectedTab = tabId;
    }
    showPanelWithId(panelId) {
        var _a;
        (_a = this.panelEls) === null || _a === void 0 || _a.forEach((panelEl)=>{
            panelEl.hidden = panelEl.id !== panelId;
        });
    }
    handleSlotChange() {
        /**
     * `market-tab-panel`s aren't hidden by default,
     * but once they become a descendant of `<market-tabs>`, they will be hidden by default.
     * Later on, one will be shown depending on which tab gets selected by default.
     */ this.panelEls = [
            ...this.el.querySelectorAll(getNamespacedTagFor('market-tab-panel'))
        ].map((panelEl)=>{
            panelEl.hidden = true;
            return panelEl;
        });
        this.tabListEl = this.el.querySelector(getNamespacedTagFor('market-tab-list'));
    }
    componentWillLoad() {
        var _a;
        this.handleSlotChange();
        this.setTab((_a = this.selectedTab) !== null && _a !== void 0 ? _a : this.defaultTab);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-tabs"
        }, (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.handleSlotChange()
        }));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "selectedTab": [
                "tabWatcher"
            ]
        };
    }
    static get style() {
        return marketTabsCss;
    }
};
const marketTagCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--tag-small-size-minimum-height:var(--core-metrics-spacing-400);--tag-small-size-horizontal-spacing:var(--core-metrics-spacing-50);--tag-small-size-text-weight:var(--core-type-paragraph-10-weight);--tag-small-size-text-size:var(--core-type-paragraph-10-size);--tag-small-size-text-leading:var(--core-type-paragraph-10-leading);--tag-small-size-text-tracking:var(--core-type-paragraph-10-tracking);--tag-small-size-text-case:var(--core-type-paragraph-10-case);--tag-small-size-basic-format-top-padding:7px;--tag-small-size-basic-format-right-padding:8px;--tag-small-size-basic-format-bottom-padding:7px;--tag-small-size-basic-format-left-padding:12px;--tag-small-size-with-icon-format-top-padding:7px;--tag-small-size-with-icon-format-right-padding:8px;--tag-small-size-with-icon-format-bottom-padding:7px;--tag-small-size-with-icon-format-left-padding:8px;--tag-medium-size-minimum-height:var(--core-metrics-spacing-500);--tag-medium-size-horizontal-spacing:var(--core-metrics-spacing-50);--tag-medium-size-text-weight:var(--core-type-paragraph-20-weight);--tag-medium-size-text-size:var(--core-type-paragraph-20-size);--tag-medium-size-text-leading:var(--core-type-paragraph-20-leading);--tag-medium-size-text-tracking:var(--core-type-paragraph-20-tracking);--tag-medium-size-text-case:var(--core-type-paragraph-20-case);--tag-medium-size-basic-format-top-padding:9px;--tag-medium-size-basic-format-right-padding:8px;--tag-medium-size-basic-format-bottom-padding:9px;--tag-medium-size-basic-format-left-padding:12px;--tag-medium-size-with-icon-format-top-padding:9px;--tag-medium-size-with-icon-format-right-padding:8px;--tag-medium-size-with-icon-format-bottom-padding:9px;--tag-medium-size-with-icon-format-left-padding:8px;display:inline-flex;align-items:center;background-color:var(--tag-normal-state-background-color);color:var(--tag-normal-state-label-color);cursor:pointer}:host .icon{display:none}:host(.has-icon) .icon{display:inline-block}:host([size=\"small\"]){gap:var(--tag-small-size-horizontal-spacing);min-height:var(--tag-small-size-minimum-height);padding:var(--tag-small-size-basic-format-top-padding)\n      var(--tag-small-size-basic-format-right-padding)\n      var(--tag-small-size-basic-format-bottom-padding)\n      var(--tag-small-size-basic-format-left-padding);border-radius:calc(var(--tag-small-size-minimum-height) / 2);font-weight:var(--tag-small-size-text-weight);font-size:var(--tag-small-size-text-size);line-height:var(--tag-small-size-text-leading);letter-spacing:var(--tag-small-size-text-tracking);text-transform:var(--tag-small-size-text-case)}:host([size=\"small\"],.has-icon){padding:var(--tag-small-size-with-icon-format-top-padding)\n        var(--tag-small-size-with-icon-format-right-padding)\n        var(--tag-small-size-with-icon-format-bottom-padding)\n        var(--tag-small-size-with-icon-format-left-padding)}:host([size=\"medium\"]){gap:var(--tag-medium-size-horizontal-spacing);min-height:var(--tag-medium-size-minimum-height);padding:var(--tag-medium-size-basic-format-top-padding)\n      var(--tag-medium-size-basic-format-right-padding)\n      var(--tag-medium-size-basic-format-bottom-padding)\n      var(--tag-medium-size-basic-format-left-padding);border-radius:calc(var(--tag-medium-size-minimum-height) / 2);font-weight:var(--tag-medium-size-text-weight);font-size:var(--tag-medium-size-text-size);line-height:var(--tag-medium-size-text-leading);letter-spacing:var(--tag-medium-size-text-tracking);text-transform:var(--tag-medium-size-text-case)}:host([size=\"medium\"],.has-icon){padding:var(--tag-medium-size-with-icon-format-top-padding)\n        var(--tag-medium-size-with-icon-format-right-padding)\n        var(--tag-medium-size-with-icon-format-bottom-padding)\n        var(--tag-medium-size-with-icon-format-left-padding)}svg.remove-indicator,::slotted([slot='icon']){flex-shrink:0}::slotted([slot='icon']){fill:var(--tag-normal-state-icon-color)}svg.remove-indicator{fill:var(--tag-normal-state-remove-indicator-color)}@media (hover: hover){:host(:hover){background-color:var(--tag-hover-state-background-color);color:var(--tag-hover-state-label-color)}:host(:hover) ::slotted([slot='icon']){fill:var(--tag-hover-state-icon-color)}:host(:hover) svg.remove-indicator{fill:var(--tag-hover-state-remove-indicator-color)}}:host(:active){background-color:var(--tag-pressed-state-background-color);color:var(--tag-pressed-state-label-color)}:host(:active) ::slotted([slot='icon']){fill:var(--tag-pressed-state-icon-color)}:host(:active) svg.remove-indicator{fill:var(--tag-pressed-state-remove-indicator-color)}:host(:focus),:host([focused]){background-color:var(--tag-focus-state-background-color);color:var(--tag-focus-state-label-color)}:host(:focus) ::slotted([slot='icon']),:host([focused]) ::slotted([slot='icon']){fill:var(--tag-focus-state-icon-color)}:host(:focus) svg.remove-indicator,:host([focused]) svg.remove-indicator{fill:var(--tag-focus-state-remove-indicator-color)}:host([disabled]){background-color:var(--tag-disabled-state-background-color);color:var(--tag-disabled-state-label-color)}:host([disabled]) ::slotted([slot='icon']){fill:var(--tag-disabled-state-icon-color)}:host([disabled]) svg.remove-indicator{fill:var(--tag-disabled-state-remove-indicator-color)}";
const MarketTag$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketTagDismissed = (0, $696Z8.createEvent)(this, "marketTagDismissed", 7);
        this.disabled = false;
        this.focused = false;
        this.size = 'small';
        this.hasIcon = false;
    }
    /* handles click and unclick in tag */ onFocus() {
        if (this.disabled) return;
        if (!this.focused) this.focused = true;
        else this.focused = false;
    }
    handleDismissTagEvent(e) {
        this.marketTagDismissed.emit();
        e.stopPropagation();
        this.el.remove();
    }
    componentWillLoad() {
        this.hasIcon = Boolean(this.el.querySelector('[slot="icon"]'));
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: `market-tag ${this.hasIcon ? 'has-icon' : ''}`,
            onClick: ()=>{
                this.onFocus();
            },
            onFocus: ()=>{
                this.onFocus();
            },
            "aria-disabled": this.disabled
        }, (0, $696Z8.h)("span", {
            class: "icon"
        }, (0, $696Z8.h)("slot", {
            name: "icon"
        })), (0, $696Z8.h)("slot", null), (0, $696Z8.h)("svg", {
            class: "remove-indicator",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            onClick: (e)=>this.handleDismissTagEvent(e)
        }, (0, $696Z8.h)("path", {
            d: "M4.4734 12.4734L8.00007 8.94002L11.5267 12.4734L12.4734 11.5267L8.94007 8.00002L12.4734 4.47335L11.5267 3.52669L8.00007 7.06002L4.4734 3.52669L3.52673 4.47335L7.06007 8.00002L3.52673 11.5267L4.4734 12.4734Z"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketTagCss;
    }
};
const marketTextareaCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:relative;outline:none;font-weight:var(--field-input-weight);font-size:var(--field-input-size);line-height:var(--field-input-leading);cursor:text}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){width:100%;margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:inherit;font-size:inherit;font-family:inherit;line-height:inherit;letter-spacing:inherit;cursor:inherit}:host ::slotted(label){cursor:inherit}:host input:focus,:host ::slotted(input:focus),:host textarea:focus,:host ::slotted(textarea:focus){outline:none}:host input::-moz-placeholder,:host textarea::-moz-placeholder{color:var(--field-placeholder-text-color)}:host input::placeholder,:host textarea::placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::-moz-placeholder,:host ::slotted(textarea)::-moz-placeholder{color:var(--field-placeholder-text-color)}:host ::slotted(input)::placeholder,:host ::slotted(textarea)::placeholder{color:var(--field-placeholder-text-color)}:host([size='small']){font-size:var(--core-type-paragraph-20-size);line-height:var(--core-type-paragraph-20-leading)}:host{border-radius:var(--field-border-radius);background-color:var(--field-normal-state-background-color);color:var(--field-normal-state-input-color)}:host::after{content:'';position:absolute;inset:0;border-radius:var(--field-border-radius);box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-normal-validity-border-color);pointer-events:none}:host([invalid])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-normal-state-invalid-validity-border-color)}:host(:hover){background-color:var(--field-hover-state-background-color);color:var(--field-hover-state-input-color)}:host(:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-normal-validity-border-color)}:host([invalid]:hover)::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-hover-state-invalid-validity-border-color)}:host([focused]){color:var(--field-focus-state-input-color)}:host([focused])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size)\n        var(--field-focus-state-normal-validity-border-color)}:host([focused][invalid])::after{box-shadow:inset 0 0 0 var(--field-focus-state-border-size) var(--field-focus-state-invalid-validity-border-color)}:host([disabled]){background-color:var(--field-disabled-state-background-color) !important;color:var(--field-disabled-state-input-color) !important;cursor:not-allowed !important;}:host([disabled])::after{box-shadow:inset 0 0 0 var(--field-border-size) var(--field-disabled-state-border-color) !important}:host([value=\"\"]) ::slotted(label){color:var(--field-normal-state-empty-phase-label-color)}:host(:not([value=\"\"])) ::slotted(label),:host([value=\"\"][autofilled]) ::slotted(label){color:var(--field-normal-state-float-phase-label-color)}:host(:hover) ::slotted(label){color:var(--field-hover-state-empty-phase-label-color)}:host(:not([value=\"\"]):hover) ::slotted(label),:host([value=\"\"][autofilled]:hover) ::slotted(label){color:var(--field-hover-state-float-phase-label-color)}:host([focused]) ::slotted(label){color:var(--field-focus-state-float-phase-label-color)}:host([value=\"\"][disabled]) ::slotted(label){color:var(--field-disabled-state-empty-phase-label-color)}:host(:not([value=\"\"])[disabled]) ::slotted(label),:host([value=\"\"][autofilled][disabled]) ::slotted(label){color:var(--field-disabled-state-float-phase-label-color)}:host{--field-input-animation-speed:0.2s;--field-input-label-translate:12px;--field-empty-phase-label-text-size-unitless:16;--field-float-phase-label-text-size-unitless:14;--field-size-medium-float-phase-vertical-padding-size:12px;--field-size-medium-float-phase-horizontal-padding-size:16px;--field-size-small-float-phase-vertical-padding-size:9px;--field-size-small-float-phase-horizontal-padding-size:12px;display:flex;align-items:center}:host .label-input-container,:host([value='']:not([focused]):not([autofilled])) .label-input-container{flex-grow:1;padding:var(--field-float-phase-vertical-padding-size) var(--field-float-phase-horizontal-padding-size)}:host([size='medium']) .label-input-container,:host([size='medium'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-medium-float-phase-vertical-padding-size)\n      var(--field-size-medium-float-phase-horizontal-padding-size)}:host([size='small']) .label-input-container,:host([size='small'][value='']:not([focused]):not([autofilled])) .label-input-container{padding:var(--field-size-small-float-phase-vertical-padding-size)\n      var(--field-size-small-float-phase-horizontal-padding-size)}:host ::slotted(label){display:block;min-height:var(--field-empty-phase-label-text-leading);font-weight:var(--field-empty-phase-label-text-weight);font-size:var(--field-empty-phase-label-text-size);line-height:var(--field-empty-phase-label-text-leading);letter-spacing:var(--field-empty-phase-label-text-tracking);transition:all var(--field-input-animation-speed);transform:translateY(var(--field-input-label-translate));transform-origin:0 0}:host(:not([value=\"\"])) ::slotted(label),:host([value=\"\"]:not([focused])[autofilled]) ::slotted(label),:host([focused]) ::slotted(label){font-weight:var(--field-float-phase-label-text-weight);transform:scale(\n        calc(var(--field-float-phase-label-text-size-unitless) / var(--field-empty-phase-label-text-size-unitless))\n      )}:host input,:host ::slotted(input),:host textarea,:host ::slotted(textarea){opacity:0}:host([focused]) input,:host([focused]) ::slotted(input),:host([focused]) textarea,:host([focused]) ::slotted(textarea),:host(:not([value=''])) input,:host(:not([value=''])) ::slotted(input),:host(:not([value=''])) textarea,:host(:not([value=''])) ::slotted(textarea){opacity:1}:host([size='small']) ::slotted(label),:host([size='medium']) ::slotted(label){position:absolute;overflow:hidden;clip:rect(0 0 0 0);width:1px;height:1px;white-space:nowrap;clip-path:inset(50%)}:host([size='small']) input,:host([size='small']) ::slotted(input),:host([size='small']) textarea,:host([size='small']) ::slotted(textarea),:host([size='medium']) input,:host([size='medium']) ::slotted(input),:host([size='medium']) textarea,:host([size='medium']) ::slotted(textarea){opacity:1}:host{--textarea-height:120px;--textarea-minimum-height:120px;--textarea-label-bottom-padding:16px;flex-direction:column;overflow:hidden;min-height:var(--textarea-minimum-height);max-height:var(--textarea-maximum-height);resize:vertical}:host .label-input-container,:host([value='']:not([focused]):not([autofilled])) .label-input-container{display:flex;flex-direction:column;width:100%;padding-bottom:var(--textarea-label-bottom-padding);font-weight:var(--textarea-font-weight);font-size:var(--textarea-font-size);line-height:var(--textarea-font-leading);letter-spacing:var(--textarea-font-tracking)}textarea,::slotted(textarea){flex-grow:1;resize:none}";
const MarketTextarea$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketTextareaValueChange = (0, $696Z8.createEvent)(this, "marketTextareaValueChange", 7);
        this.onMutationObserved = (ariaAttributes)=>{
            this.ariaAttributes = ariaAttributes;
        };
        this.placeholder = undefined;
        this.name = undefined;
        this.value = '';
        this.maxlength = undefined;
        this.readonly = false;
        this.disabled = false;
        this.focused = false;
        this.invalid = false;
        this.maxHeight = `${cjs.TEXTAREA_MAXIMUM_HEIGHT}px`;
        this.autofocus = false;
        this.inputmode = undefined;
        this.ariaAttributes = undefined;
    }
    handleMarketDialogLoaded() {
        if (this.autofocus) this.setFocus();
    }
    /**
   * Allows passing an alternative light DOM textarea.
   * Sets the this.slottedTextarea value to undefined if there is no slotted element.
   */ registerSlottedTextarea(slottedTextarea) {
        var _a;
        this.slottedTextarea = slottedTextarea || // textarea slotted into market-textarea
        this.el.querySelector('textarea[slot=textarea]') || (// textarea slotted into a higher-level component that uses market-textarea
        (_a = this.el.getRootNode().host) === null || _a === void 0 ? void 0 : _a.querySelector('textarea[slot=textarea]'));
        if (this.slottedTextarea) {
            this.slottedTextarea.addEventListener('input', (e)=>this.textareaValueDidChange(e));
            this.slottedTextarea.addEventListener('focus', ()=>this.setFocus());
            this.slottedTextarea.addEventListener('blur', ()=>this.focused = false);
        }
        return Promise.resolve();
    }
    syncSharedPropsToSlottedTextarea(prevSharedProps) {
        // sync component props to slotted input, if one exists
        if (this.slottedTextarea) {
            const modifiedPropKeys = [
                ...new Set([
                    ...Object.keys(prevSharedProps),
                    ...Object.keys(this.sharedProps)
                ])
            ];
            modifiedPropKeys.forEach((key)=>{
                if (!(key in this.sharedProps)) // remove properties that have been unset
                this.slottedTextarea.removeAttribute(key);
                else {
                    // boolean attributes can be set using empty strings
                    // https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute#javascript
                    const attributeValue = this.sharedProps[key] !== true ? this.sharedProps[key] : '';
                    this.slottedTextarea.setAttribute(key, attributeValue);
                }
            });
        }
    }
    updateSharedPropsAndSyncSlottedTextarea() {
        const prevSharedProps = Object.assign({}, this.sharedProps);
        // used by the default shadow DOM native input and to copy component properties to slotted inputs
        // conditionally adding key/value pairs based on whether we want to set them on the <input>
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#individual_attributes
        this.sharedProps = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this.name && {
            name: this.name
        }), this.placeholder && {
            placeholder: this.placeholder
        }), this.maxlength !== undefined && Number.parseInt(this.maxlength, 10) >= 0 && {
            maxlength: this.maxlength
        }), this.value !== undefined && {
            value: this.value
        }), this.readonly && {
            readonly: this.readonly
        }), this.disabled && {
            disabled: this.disabled
        }), this.autofocus && {
            autofocus: this.autofocus
        }), this.inputmode && {
            inputmode: this.inputmode
        }), this.ariaAttributes), {
            'aria-label': getTextInputAriaLabel(this.el)
        });
        this.syncSharedPropsToSlottedTextarea(prevSharedProps);
    }
    componentWillLoad() {
        this.mutationObserver = observeAriaAttributes(this.el, this.onMutationObserved);
        this.registerSlottedTextarea();
        this.updateSharedPropsAndSyncSlottedTextarea();
    }
    componentDidLoad() {
        if (this.maxHeight) // Set the passed max height on the input container, since that's where
        // the drag handle will actually be visible.
        // This will be removed until `maxHeight` prop is fully deprecated.
        this.el.style.maxHeight = this.maxHeight;
    }
    componentWillUpdate() {
        this.updateSharedPropsAndSyncSlottedTextarea();
    }
    textareaValueDidChange(e) {
        // Need to update value for the label, which floats if this value exists.
        this.value = e.target.value;
        this.marketTextareaValueChange.emit({
            value: e.target.value,
            originalEvent: e
        });
    }
    setFocus(value = true) {
        var _a, _b, _c, _d, _e;
        if (this.readonly || this.disabled) return;
        const shouldSetElementFocus = value && !this.focused;
        this.focused = value;
        // Set focus on element if not already focused
        if (shouldSetElementFocus) this.slottedTextarea ? this.slottedTextarea.focus() : (_e = (_d = (_c = (_b = (_a = this.el) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector) === null || _c === void 0 ? void 0 : _c.call(_b, 'textarea')) === null || _d === void 0 ? void 0 : _d.focus) === null || _e === void 0 || _e.call(_d);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-textarea",
            onBlur: ()=>{
                this.focused = false;
            },
            onClick: ()=>{
                this.setFocus();
            },
            onFocus: ()=>{
                this.setFocus();
            },
            role: "textbox"
        }, (0, $696Z8.h)("div", {
            class: "label-input-container",
            part: "container"
        }, (0, $696Z8.h)("slot", null), (0, $696Z8.h)("slot", {
            name: "textarea",
            onSlotchange: ()=>this.registerSlottedTextarea()
        }, !this.slottedTextarea && (0, $696Z8.h)("textarea", Object.assign({}, this.ariaAttributes, {
            id: this.name,
            onInput: (e)=>this.textareaValueDidChange(e)
        }, this.sharedProps)))));
    }
    disconnectedCallback() {
        var _a;
        (_a = this.mutationObserver) === null || _a === void 0 || _a.disconnect();
    }
    get el() {
        return this;
    }
    static get style() {
        return marketTextareaCss;
    }
};
const marketTileCss = "::slotted([slot='hint']){font-weight:var(--core-type-display-10-weight);font-size:var(--core-type-display-10-size);font-family:var(--core-type-display-10-font-family);line-height:var(--core-type-display-10-leading);letter-spacing:var(--core-type-display-10-tracking);text-transform:var(--core-type-display-10-case)}::slotted([slot='subtext']){font-weight:var(--core-type-paragraph-10-weight);font-size:var(--core-type-paragraph-10-size);font-family:var(--core-type-paragraph-10-font-family);line-height:var(--core-type-paragraph-10-leading);letter-spacing:var(--core-type-paragraph-10-tracking);text-transform:var(--core-type-paragraph-10-case)}::slotted([slot='subtext']) b,::slotted([slot='subtext']) strong{font-weight:var(--core-type-semibold-10-weight)}::slotted([slot='label']){font-weight:var(--core-type-medium-30-weight);font-size:var(--core-type-medium-30-size);font-family:var(--core-type-medium-30-font-family);line-height:var(--core-type-medium-30-leading);letter-spacing:var(--core-type-medium-30-tracking);text-transform:var(--core-type-medium-30-case)}::slotted([slot='indicator']){font-weight:var(--core-type-semibold-10-weight);font-size:var(--core-type-semibold-10-size);font-family:var(--core-type-semibold-10-font-family);line-height:var(--core-type-semibold-10-leading);letter-spacing:var(--core-type-semibold-10-tracking);text-transform:var(--core-type-semibold-10-case)}:host{--item-tile-text-color:black;position:relative;outline:none;position:relative;z-index:1;display:grid;grid-template-areas:'leading-accessory _ trailing-accessory'\n    'content content content';grid-template-columns:minmax(0, max-content) 1fr auto;box-sizing:border-box;width:var(--item-tile-width, 200px);height:var(--item-tile-medium-height, 124px);padding:var(--item-tile-medium-padding, var(--core-metrics-spacing-150));border-radius:var(--item-tile-border-radius, 6px);background:var(--item-tile-fill-color, var(--core-fill-40-color));-webkit-user-select:none;-moz-user-select:none;user-select:none}:host([interactive]){cursor:pointer}:host([size=\"small\"]){grid-template-areas:'leading-accessory content trailing-accessory';grid-template-columns:max-content 1fr minmax(0, max-content);height:var(--item-tile-small-height, 56px);padding:var(--item-tile-small-padding-vertical, var(--core-metrics-spacing-50))\n      var(--item-tile-small-padding-horizontal, var(--core-metrics-spacing-150));-moz-column-gap:var(--core-metrics-spacing-100);column-gap:var(--core-metrics-spacing-100)}:host([size=\"small\"]) ::slotted([slot='leading-accessory']),:host([size=\"small\"]) .trailing-accessory-container{align-items:center}:host([size=\"small\"]) .content{justify-content:center;align-items:start}:host([size=\"small\"]) .remove-button{position:relative}:host([aria-disabled]){opacity:0.2;cursor:not-allowed}:host([aria-disabled]) .remove-button{cursor:not-allowed}:host([aria-disabled]) .remove-button:hover{background:var(--item-tile-remove-button-fill, #fff)}:host([aria-selected=\"true\"]){outline:var(--item-tile-selected-value-border-width, 2px) solid\n      var(--item-tile-selected-value-border-color, var(--core-blue-fill-light-mode-color));outline-offset:var(--item-tile-selected-value-border-offset, 1px)}:host::after{--focus-ring-position:calc(-1 * (var(--item-tile-border-size, var(--core-focus-ring-border-size)) + var(--item-tile-focus-ring-buffer-size, 1px) + var(--item-tile-focus-ring-border-size, var(--core-focus-ring-border-size))));content:'';position:absolute;top:var(--focus-ring-position);right:var(--focus-ring-position);bottom:var(--focus-ring-position);left:var(--focus-ring-position);display:block;border:var(--item-tile-focus-ring-border-size, var(--core-focus-ring-border-size)) solid var(--item-tile-focus-ring-color, var(--core-focus-ring-light-mode-color));border-radius:calc(var(--item-tile-border-radius, 6px) + var(--item-tile-focus-ring-buffer-size, 1px) * 2);opacity:0;pointer-events:none;transition:opacity 0.2s}:host(:focus-visible)::after{opacity:0.5}.background-image{display:none}.background-image.has-slotted-media,.background-image ::slotted([slot='media']){--item-tile-text-color:white;position:absolute;top:0;left:0;z-index:-1;display:block;-o-object-fit:cover;object-fit:cover;width:100%;height:100%;border-radius:var(--item-tile-border-radius, 6px)}.background-image.has-slotted-media::before,.background-image ::slotted([slot='media'])::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;border-radius:var(--item-tile-border-radius, 6px);background-image:var(\n        --item-tile-background-image-gradient,\n        linear-gradient(180.98deg, rgba(0, 0, 0, 0.04) 0.84%, rgba(0, 0, 0, 0.4) 99.16%)\n      )}::slotted([slot='leading-accessory']){z-index:2;display:flex;grid-area:leading-accessory;align-items:flex-start}.trailing-accessory-container{z-index:3;display:flex;grid-area:trailing-accessory;justify-content:flex-end}.trailing-accessory-container .remove-button{position:absolute;width:var(--item-tile-remove-button-width, 24px);height:var(--item-tile-remove-button-height, 24px);border:none;border-radius:100px;background:var(--item-tile-remove-button-fill, var(--core-surface-30-color));box-shadow:0 1px 2px rgba(0, 0, 0, 0.1), 0 0 4px rgba(0, 0, 0, 0.1);cursor:pointer}.trailing-accessory-container .remove-button:hover{background:var(--item-tile-remove-button-hover-state-background-color, #ffe5ea)}.trailing-accessory-container .remove-button:active{background:var(--item-time-remove-button-active-state-background-color, #ffccd5)}.trailing-accessory-container .remove-button svg{position:absolute;top:0;left:0;padding:var(--core-metrics-spacing-50)}.trailing-accessory-container ::slotted([slot='indicator']){height:var(--core-metrics-spacing-200);padding:0 var(--core-metrics-spacing-100);border-radius:100px;background:var(--core-fill-10-dark-mode-color);color:black;box-shadow:0 1px 2px rgba(0, 0, 0, 0.1), 0 0 4px rgba(0, 0, 0, 0.1)}.content{z-index:2;display:flex;flex-direction:column;grid-area:content;justify-content:flex-end;min-width:0}::slotted([slot='label']){display:-webkit-box;overflow-y:hidden;min-width:0;-webkit-line-clamp:var(--item-tile-label-line-clamp, 1);-webkit-box-orient:vertical}::slotted([slot='subtext']){display:-webkit-box;overflow-y:hidden;min-width:0;-webkit-line-clamp:1;-webkit-box-orient:vertical}";
const MarketTile$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketTileSelectedChanged = (0, $696Z8.createEvent)(this, "marketTileSelectedChanged", 7);
        this.marketTileRemoveClicked = (0, $696Z8.createEvent)(this, "marketTileRemoveClicked", 7);
        this.hasTrailingAccessorySlot = false;
        this.hasIndicatorTextSlot = false;
        this.disabled = false;
        this.interactive = false;
        this.showActions = false;
        this.size = 'medium';
        this.value = undefined;
        this.selected = false;
        this.hasSlottedMedia = false;
    }
    onSizeChange() {
        this.adjustSlottedLabels();
    }
    /**
   * Allows external elements to set selected value.
   */ setSelected(newValue) {
        if (typeof newValue !== 'boolean') return Promise.resolve();
        if (this.selected !== newValue) {
            const { defaultPrevented } = this.marketTileSelectedChanged.emit({
                selected: this.selected,
                value: this.value
            });
            if (!defaultPrevented) this.selected = newValue;
        }
        return Promise.resolve();
    }
    handleClick(event) {
        if (this.disabled || !this.interactive) return;
        this.selected = !this.selected;
        event.preventDefault();
        this.marketTileSelectedChanged.emit({
            selected: this.selected,
            value: this.value
        });
    }
    handleRemoveActionKeydown(event) {
        switch(event.key){
            case 'Enter':
            case ' ':
                this.handleRemoveActionClick(event);
                break;
        }
    }
    handleRemoveActionClick(event) {
        if (this.disabled || !this.interactive) return;
        event.stopPropagation();
        this.marketTileRemoveClicked.emit();
    }
    renderDefaultRemoveAction() {
        const { disabled, handleRemoveActionClick, handleRemoveActionKeydown } = this;
        return (0, $696Z8.h)("button", {
            class: "remove-button",
            disabled: disabled,
            onClick: handleRemoveActionClick.bind(this),
            onKeyUp: handleRemoveActionKeydown.bind(this)
        }, (0, $696Z8.h)("svg", {
            slot: "icon",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "var(--core-critical-text-color)",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M12.8318 7.3335V7.1685H12.6668H3.3335H3.1685V7.3335V8.66683V8.83183H3.3335H12.6668H12.8318V8.66683V7.3335Z",
            fill: "var(--core-critical-text-color)",
            stroke: "var(--core-critical-text-color)",
            "stroke-width": "0.33"
        })));
    }
    handleKeydown(event) {
        // don't intercept keydown of descendant elements
        // e.g. remove button
        if (event.target !== this.el) return;
        switch(event.key){
            case 'Enter':
            case ' ':
                this.handleClick(event);
                break;
        }
    }
    /**
   * This function determines the number of lines the `label` slot text should clamp to.
   * It should clamp to a single line if the hint slot exists or if the subtext slot exists
   * and the element `size` prop is set to "small".
   */ adjustSlottedLabels() {
        const { size, el } = this;
        const hint = el.querySelector('[slot="hint"]');
        const label = el.querySelector('[slot="label"]');
        const subtext = el.querySelector('[slot="subtext"]');
        if (!label) return;
        const labelLineClamp = hint || subtext && size === 'small' ? 1 : 2;
        el.style.setProperty('--item-tile-label-line-clamp', labelLineClamp.toString());
    }
    checkSlottedMedia() {
        this.hasSlottedMedia = Boolean(this.el.querySelector('[slot="media"]'));
    }
    componentWillLoad() {
        this.checkSlottedMedia();
        this.hasIndicatorTextSlot = Boolean(this.el.querySelector('[slot="indicator"]'));
    }
    render() {
        const { disabled, size, hasSlottedMedia, hasIndicatorTextSlot, interactive, showActions, selected } = this;
        const tabindex = interactive && !disabled ? '0' : null;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-tile",
            tabindex: tabindex,
            "aria-selected": selected.toString(),
            onClick: (e)=>this.handleClick(e),
            onKeydown: (e)=>this.handleKeydown(e)
        }, (0, $696Z8.h)("div", {
            class: classNames('background-image', {
                'has-slotted-media': hasSlottedMedia
            })
        }, (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.checkSlottedMedia(),
            name: "media"
        })), (0, $696Z8.h)("slot", {
            name: "leading-accessory"
        }), (0, $696Z8.h)("div", {
            class: "trailing-accessory-container"
        }, showActions && (0, $696Z8.h)("slot", {
            name: "actions"
        }, this.renderDefaultRemoveAction()), !showActions && hasIndicatorTextSlot && (0, $696Z8.h)("slot", {
            name: "indicator"
        })), (0, $696Z8.h)("div", {
            class: "content"
        }, size !== 'small' && (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.adjustSlottedLabels(),
            name: "hint"
        }), (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.adjustSlottedLabels(),
            name: "label"
        }), (0, $696Z8.h)("slot", {
            onSlotchange: ()=>this.adjustSlottedLabels(),
            name: "subtext"
        })));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "size": [
                "onSizeChange"
            ]
        };
    }
    static get style() {
        return marketTileCss;
    }
};
const marketToastCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{--toast-max-width:600px;--toast-vertical-padding:16px;--toast-horizontal-padding:16px;--toast-border-radius:var(--core-radius-10);--toast-icon-spacing:12px;--toast-content-spacing:12px;--toast-multiline-spacing:12px;--toast-button-spacing:12px;--toast-text-leading:var(--core-type-paragraph-30-leading);--toast-text-size:var(--core-type-paragraph-30-size);--toast-text-tracking:var(--core-type-paragraph-30-tracking);--toast-text-weight:var(--core-type-paragraph-30-weight);--toast-text-case:var(--core-type-paragraph-30-case);--toast-button-text-leading:var(--core-type-semibold-30-leading);--toast-button-text-weight:var(--core-type-semibold-weight);--toast-button-text-size:var(--core-type-semibold-30-size);--toast-button-text-tracking:var(--core-type-semibold-30-tracking);--toast-button-text-case:var(--core-type-semibold-30-case);--toast-button-separator-height:8px;--toast-button-separator-width:1px;--toast-button-separator-opacity:0.3;--toast-button-separator-color:currentColor;--toast-progress-bar-height:4px;display:flex;flex-direction:column;align-items:flex-start;overflow:hidden;width:100%;max-width:var(--toast-max-width);border-radius:calc(var(--toast-border-radius) * 1px);box-shadow:0 4px 32px 0 rgb(0 0 0 / 0.1), 0 8px 16px 0 rgb(0 0 0 / 0.1);font-weight:var(--toast-text-weight);font-size:var(--toast-text-size);line-height:var(--toast-text-leading);letter-spacing:var(--toast-text-tracking);text-transform:var(--toast-text-case)}.icon-container,.dismiss-container{display:flex;flex-shrink:0;align-items:center}.dismiss-container button{display:flex;justify-content:center;align-items:center;margin:0;padding:0;border:none;background-color:transparent;cursor:pointer;transition:opacity 0.2s;-webkit-appearance:none;-moz-appearance:none;appearance:none}.content{display:flex;align-items:flex-start;width:100%;padding:var(--toast-vertical-padding) var(--toast-horizontal-padding);-moz-column-gap:var(--toast-icon-spacing);column-gap:var(--toast-icon-spacing)}.main{display:flex;flex-grow:1;flex-wrap:wrap;row-gap:var(--toast-multiline-spacing);-moz-column-gap:var(--toast-content-spacing);column-gap:var(--toast-content-spacing)}section{flex-grow:1}nav{display:flex;flex-wrap:wrap;justify-content:flex-end}nav.hidden{display:none}::slotted(button),::slotted(a){margin:0;padding:0;border:none;background-color:transparent;color:inherit;font-weight:var(--toast-button-text-weight);font-size:var(--toast-button-text-size);font-family:inherit;line-height:var(--toast-button-text-leading);letter-spacing:var(--toast-button-text-tracking);text-decoration:none;text-transform:var(--toast-button-text-case);cursor:pointer;transition:opacity 0.2s}::slotted(button:hover),::slotted(a:hover){opacity:var(--text-link-hover-state-opacity)}::slotted(button:active),::slotted(a:active){opacity:var(--text-link-pressed-state-opacity)}::slotted([slot='action']){display:flex;justify-content:center;align-items:center}::slotted([slot='action']:not(:last-child)){margin-right:calc(var(--toast-button-spacing) * 2 + var(--toast-button-separator-width))}::slotted([slot='action']:not(:last-child))::after{content:'';display:inline-block;width:var(--toast-button-separator-width);height:var(--toast-button-separator-height);margin-right:calc(-1 * var(--toast-button-spacing) - var(--toast-button-separator-width));margin-left:var(--toast-button-spacing);background-color:var(--toast-button-separator-color);opacity:var(--toast-button-separator-opacity);pointer-events:none}progress-bar{height:var(--toast-progress-bar-height)}:host([variant=\"info\"]){--toast-info-variant-background-color:var(--core-surface-inverse-color);--toast-info-variant-text-color:var(--core-text-inverse-color);--toast-info-variant-icon-color:var(--core-emphasis-fill-color);--toast-info-variant-text-link-text-color:var(--core-text-inverse-color);--toast-info-variant-button-text-color:var(--core-text-inverse-color);--toast-info-variant-progress-bar-color:var(--core-emphasis-fill-color);--toast-info-variant-dismiss-button-color:var(--core-fill-white-color);background-color:var(--toast-info-variant-background-color);color:var(--toast-info-variant-text-color)}:host([variant=\"info\"]) .icon-container svg{fill:var(--toast-info-variant-icon-color)}:host([variant=\"info\"]) .dismiss-container svg{fill:var(--toast-info-variant-dismiss-button-color)}:host([variant=\"info\"]) progress-bar{background-color:var(--toast-info-variant-progress-bar-color)}:host([variant=\"info\"]) ::slotted(a){color:var(--toast-info-variant-text-link-text-color)}:host([variant=\"info\"]) ::slotted(button){color:var(--toast-info-variant-button-text-color)}:host([variant=\"success\"]){--toast-success-variant-background-color:var(--core-surface-inverse-color);--toast-success-variant-text-color:var(--core-text-inverse-color);--toast-success-variant-icon-color:var(--core-success-fill-color);--toast-success-variant-text-link-text-color:var(--core-text-inverse-color);--toast-success-variant-button-text-color:var(--core-text-inverse-color);--toast-success-variant-progress-bar-color:var(--core-success-fill-color);--toast-success-variant-dismiss-button-color:var(--core-fill-white-color);background-color:var(--toast-success-variant-background-color);color:var(--toast-success-variant-text-color)}:host([variant=\"success\"]) .icon-container svg{fill:var(--toast-success-variant-icon-color)}:host([variant=\"success\"]) .dismiss-container svg{fill:var(--toast-success-variant-dismiss-button-color)}:host([variant=\"success\"]) progress-bar{background-color:var(--toast-success-variant-progress-bar-color)}:host([variant=\"success\"]) ::slotted(a){color:var(--toast-success-variant-text-link-text-color)}:host([variant=\"success\"]) ::slotted(button){color:var(--toast-success-variant-button-text-color)}:host([variant=\"warning\"]){--toast-warning-variant-background-color:var(--core-surface-inverse-color);--toast-warning-variant-text-color:var(--core-text-inverse-color);--toast-warning-variant-icon-color:var(--core-warning-fill-color);--toast-warning-variant-text-link-text-color:var(--core-text-inverse-color);--toast-warning-variant-button-text-color:var(--core-text-inverse-color);--toast-warning-variant-progress-bar-color:var(--core-warning-fill-color);--toast-warning-variant-dismiss-button-color:var(--core-fill-white-color);background-color:var(--toast-warning-variant-background-color);color:var(--toast-warning-variant-text-color)}:host([variant=\"warning\"]) .icon-container svg{fill:var(--toast-warning-variant-icon-color)}:host([variant=\"warning\"]) .dismiss-container svg{fill:var(--toast-warning-variant-dismiss-button-color)}:host([variant=\"warning\"]) progress-bar{background-color:var(--toast-warning-variant-progress-bar-color)}:host([variant=\"warning\"]) ::slotted(a){color:var(--toast-warning-variant-text-link-text-color)}:host([variant=\"warning\"]) ::slotted(button){color:var(--toast-warning-variant-button-text-color)}:host([variant=\"critical\"]){--toast-critical-variant-background-color:var(--core-critical-fill-color);--toast-critical-variant-text-color:var(--core-fill-white-color);--toast-critical-variant-icon-color:var(--core-fill-white-color);--toast-critical-variant-text-link-text-color:var(--core-fill-white-color);--toast-critical-variant-button-text-color:var(--core-fill-white-color);--toast-critical-variant-progress-bar-color:var(--core-fill-10-color);--toast-critical-variant-dismiss-button-color:var(--core-fill-white-color);background-color:var(--toast-critical-variant-background-color);color:var(--toast-critical-variant-text-color)}:host([variant=\"critical\"]) .icon-container svg{fill:var(--toast-critical-variant-icon-color)}:host([variant=\"critical\"]) .dismiss-container svg{fill:var(--toast-critical-variant-dismiss-button-color)}:host([variant=\"critical\"]) progress-bar{background-color:var(--toast-critical-variant-progress-bar-color)}:host([variant=\"critical\"]) ::slotted(a){color:var(--toast-critical-variant-text-link-text-color)}:host([variant=\"critical\"]) ::slotted(button){color:var(--toast-critical-variant-button-text-color)}:host([variant=\"insight\"]){--toast-insight-variant-background-color:var(--core-surface-10-color);--toast-insight-variant-text-color:var(--core-text-10-color);--toast-insight-variant-icon-color:var(--core-purple-fill-color);--toast-insight-variant-text-link-text-color:var(--core-text-10-color);--toast-insight-variant-button-text-color:var(--core-text-10-color);--toast-insight-variant-progress-bar-color:var(--core-purple-fill-color);--toast-insight-variant-dismiss-button-color:var(--core-text-10-color);background-color:var(--toast-insight-variant-background-color);color:var(--toast-insight-variant-text-color)}:host([variant=\"insight\"]) .icon-container svg{fill:var(--toast-insight-variant-icon-color)}:host([variant=\"insight\"]) .dismiss-container svg{fill:var(--toast-insight-variant-dismiss-button-color)}:host([variant=\"insight\"]) progress-bar{background-color:var(--toast-insight-variant-progress-bar-color)}:host([variant=\"insight\"]) ::slotted(a){color:var(--toast-insight-variant-text-link-text-color)}:host([variant=\"insight\"]) ::slotted(button){color:var(--toast-insight-variant-button-text-color)}";
const MarketToast$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketToastAutoDismissed = (0, $696Z8.createEvent)(this, "marketToastAutoDismissed", 7);
        this.marketToastManuallyDismissed = (0, $696Z8.createEvent)(this, "marketToastManuallyDismissed", 7);
        this.variant = 'info';
        this.persistent = false;
        this.dismissButtonAriaLabel = 'Dismiss';
        this.progress = -1;
        this.durationTilAutoDismiss = 5000;
        this.showActionsNav = false;
    }
    /**
   * Set toast to disappear after the autodismiss timeout has passed
   */ startAutoDismissTimer() {
        if (!this.persistent) setTimeout(()=>{
            this.marketToastAutoDismissed.emit();
        }, this.durationTilAutoDismiss);
        return Promise.resolve();
    }
    handleManualDismiss() {
        this.marketToastManuallyDismissed.emit();
    }
    componentWillLoad() {
        this.checkIfActionsArePresent();
    }
    checkIfActionsArePresent() {
        const actions = this.el.querySelector('[slot="action"]');
        this.showActionsNav = actions ? true : false;
    }
    renderIcon() {
        if (this.variant === 'success') return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M3 12C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12ZM5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5C8.14 5 5 8.14 5 12ZM8.71005 10.8L11 13.09L15.3101 8.80005L16.72 10.21L11.72 15.21C11.52 15.4 11.27 15.5 11.01 15.5C10.75 15.5 10.5 15.41 10.3 15.21L7.30005 12.21L8.71005 10.8Z"
        }));
        else if (this.variant === 'info') return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3ZM12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19ZM11 10.5V17H13V10.5H11ZM13.25 8.25C13.25 8.94036 12.6904 9.5 12 9.5C11.3096 9.5 10.75 8.94036 10.75 8.25C10.75 7.55964 11.3096 7 12 7C12.6904 7 13.25 7.55964 13.25 8.25Z"
        }));
        else if (this.variant === 'warning') return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M11 9.00005H13V14.5H11V9.00005Z"
        }), (0, $696Z8.h)("path", {
            d: "M12 18C12.6904 18 13.25 17.4404 13.25 16.75C13.25 16.0596 12.6904 15.5 12 15.5C11.3096 15.5 10.75 16.0596 10.75 16.75C10.75 17.4404 11.3096 18 12 18Z"
        }), (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.866 2.17944C12.6874 1.87004 12.3573 1.67944 12 1.67944C11.6427 1.67944 11.3126 1.87004 11.134 2.17944L1.13397 19.5C0.955342 19.8094 0.955342 20.1905 1.13397 20.5C1.31261 20.8094 1.64273 21 2 21H22C22.3573 21 22.6874 20.8094 22.866 20.5C23.0447 20.1905 23.0447 19.8094 22.866 19.5L12.866 2.17944ZM12 4.67944L20.268 19H3.73205L12 4.67944Z"
        }));
        else if (this.variant === 'insight') return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M11 23.1701V15.0001H3.07996L13 0.830078V9.00008H20.92L11 23.1701ZM6.91996 13.0001H13V16.8301L17.08 11.0001H11V7.17008L6.91996 13.0001Z"
        }));
        else return (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21ZM12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5ZM12 17C12.6904 17 13.25 16.4404 13.25 15.75C13.25 15.0596 12.6904 14.5 12 14.5C11.3096 14.5 10.75 15.0596 10.75 15.75C10.75 16.4404 11.3096 17 12 17ZM11 7H13V13.5H11V7Z"
        }));
    }
    render() {
        const progress = Math.min(this.progress, 100);
        const progressStyle = {
            width: `${progress}%`
        };
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-toast",
            role: "alert"
        }, (0, $696Z8.h)("div", {
            class: "content"
        }, (0, $696Z8.h)("span", {
            class: "icon-container"
        }, this.renderIcon()), (0, $696Z8.h)("div", {
            class: "main"
        }, (0, $696Z8.h)("section", null, (0, $696Z8.h)("slot", null)), (0, $696Z8.h)("nav", {
            "aria-label": "toast-actions",
            class: this.showActionsNav ? '' : 'hidden'
        }, (0, $696Z8.h)("slot", {
            name: "action",
            onSlotchange: ()=>this.checkIfActionsArePresent()
        }))), (0, $696Z8.h)("nav", {
            "aria-label": "dismiss-container",
            class: "dismiss-container"
        }, (0, $696Z8.h)("button", {
            type: "button",
            "aria-label": this.dismissButtonAriaLabel,
            onClick: ()=>this.handleManualDismiss()
        }, (0, $696Z8.h)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            d: "M6.71004 18.71L12 13.41L17.29 18.71L18.71 17.29L13.41 12L18.71 6.71004L17.29 5.29004L12 10.59L6.71004 5.29004L5.29004 6.71004L10.59 12L5.29004 17.29L6.71004 18.71Z"
        }))))), this.progress >= 0 && (0, $696Z8.h)("progress-bar", {
            role: "progressbar",
            "aria-valuenow": progress,
            "aria-valuemin": "0",
            "aria-valuemax": "100",
            style: progressStyle
        }));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketToastCss;
    }
};
const marketToasterCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:fixed;right:0;bottom:0;left:0;z-index:3;padding:0 0 var(--toast-bottom-margin, 24px);pointer-events:none}:host ::slotted(.market-toast){width:calc(100% - var(--toast-horizontal-margin, 16px) * 2);margin:var(--toast-vertical-spacing, 16px) auto 0;pointer-events:auto}:host ::slotted(.use-transitions){position:absolute;top:100%;left:50%;margin:0;transition:transform var(--toast-animation-transition-duration, 200ms) ease-in-out;transform:translate(-50%, 0)}";
// TODO(UI-1153): add design tokens for these
const TOAST_VERTICAL_SPACING = 16;
const TOAST_BOTTOM_MARGIN = 24;
const TOAST_ANIMATION_TRANSITION_DURATION = 200;
const MarketToaster$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.toasts = [];
    }
    /**
   * Add the passed toastEl to market-toaster and make it visible
   **/ async show(toastEl) {
        this.toasts.unshift(toastEl);
        toastEl.classList.add('use-transitions');
        this.el.appendChild(toastEl);
        window.requestAnimationFrame(this.positionToasts.bind(this));
        await new Promise((resolve)=>setTimeout(resolve, TOAST_ANIMATION_TRANSITION_DURATION));
        toastEl.startAutoDismissTimer();
    }
    positionToasts() {
        let offset = TOAST_BOTTOM_MARGIN;
        this.toasts.forEach((toast)=>{
            toast.style.transform = `translate(-50%, calc(-100% - ${offset}px))`;
            offset += toast.offsetHeight + TOAST_VERTICAL_SPACING;
        });
    }
    /**
   * Remove the passed toastEl from market-toaster
   **/ async hide(toastEl) {
        const index = this.toasts.indexOf(toastEl);
        this.toasts.splice(index, 1);
        window.requestAnimationFrame(()=>{
            toastEl.style.transform = '';
            this.positionToasts();
        });
        await new Promise((resolve)=>setTimeout(resolve, TOAST_ANIMATION_TRANSITION_DURATION));
        toastEl.remove();
    }
    /**
   * Remove all market-toasts from market-toaster
   **/ removeAll() {
        const allActiveToasts = [
            ...this.toasts
        ];
        return Promise.all(allActiveToasts.map((toast)=>this.hide(toast)));
    }
    toastAutoDismissedEventHandler({ target: toast }) {
        this.hide(toast);
    }
    toastManuallyDismissedEventHandler({ target: toast }) {
        this.hide(toast);
    }
    render() {
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-toaster"
        }, (0, $696Z8.h)("slot", null));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketToasterCss;
    }
};
const marketToggleCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:relative;outline:none;display:inline-block;height:var(--toggle-height)}input{position:absolute;top:0;left:0;width:100%;height:100%;margin:0;outline:none;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}.focus-ring{--focus-ring-position:calc(-1 * (var(--toggle-border-size) + var(--toggle-focus-ring-buffer-size) + var(--toggle-focus-ring-border-size)));content:'';position:absolute;top:var(--focus-ring-position);right:var(--focus-ring-position);bottom:var(--focus-ring-position);left:var(--focus-ring-position);display:block;border:var(--toggle-focus-ring-border-size) solid var(--toggle-focus-ring-color);border-radius:calc(var(--toggle-border-radius) + var(--toggle-focus-ring-buffer-size) * 2);opacity:0;pointer-events:none;transition:opacity 0.2s}input:focus-visible+.focus-ring{opacity:0.5}circle,rect{transition:var(--row-slotted-control-transition, cx 0.3s)}circle{fill:var(--toggle-normal-state-unselected-value-thumb-color)}rect{fill:var(--toggle-normal-state-unselected-value-track-color);stroke:var(--toggle-normal-state-unselected-value-border-color)}:host([checked]) circle{fill:var(--toggle-normal-state-selected-value-thumb-color);cx:28px}:host([checked]) rect{fill:var(--toggle-normal-state-selected-value-track-color);stroke:var(--toggle-normal-state-selected-value-border-color)}:host(:hover) circle,:host([hovered]) circle{fill:var(--toggle-hover-state-unselected-value-thumb-color)}:host(:hover) rect,:host([hovered]) rect{fill:var(--toggle-hover-state-unselected-value-track-color);stroke:var(--toggle-hover-state-unselected-value-border-color)}:host([checked]:hover) circle,:host([checked][hovered]) circle{fill:var(--toggle-hover-state-selected-value-thumb-color)}:host([checked]:hover) rect,:host([checked][hovered]) rect{fill:var(--toggle-hover-state-selected-value-track-color);stroke:var(--toggle-hover-state-selected-value-border-color)}:host([focused]) circle{fill:var(--toggle-focus-state-unselected-value-thumb-color)}:host([focused]) rect{fill:var(--toggle-focus-state-unselected-value-track-color);stroke:var(--toggle-focus-state-unselected-value-border-color)}:host([checked][focused]) circle{fill:var(--toggle-focus-state-selected-value-thumb-color)}:host([checked][focused]) rect{fill:var(--toggle-focus-state-selected-value-track-color);stroke:var(--toggle-focus-state-selected-value-border-color)}:host(:active) circle,:host([active]) circle{fill:var(--toggle-pressed-state-unselected-value-thumb-color)}:host(:active) rect,:host([active]) rect{fill:var(--toggle-pressed-state-unselected-value-track-color);stroke:var(--toggle-pressed-state-unselected-value-border-color)}:host([checked]:active) circle,:host([checked][active]) circle{fill:var(--toggle-pressed-state-selected-value-thumb-color)}:host([checked]:active) rect,:host([checked][active]) rect{fill:var(--toggle-pressed-state-selected-value-track-color);stroke:var(--toggle-pressed-state-selected-value-border-color)}:host([disabled]) input{cursor:not-allowed}:host([disabled]) circle{fill:var(--toggle-disabled-state-unselected-value-thumb-color)}:host([disabled]) rect{fill:var(--toggle-disabled-state-unselected-value-track-color);stroke:var(--toggle-disabled-state-unselected-value-border-color)}:host([disabled][checked]) circle{fill:var(--toggle-disabled-state-selected-value-thumb-color)}:host([disabled][checked]) rect{fill:var(--toggle-disabled-state-selected-value-track-color);stroke:var(--toggle-disabled-state-selected-value-border-color)}";
var ARIA_VALUE;
(function(ARIA_VALUE) {
    ARIA_VALUE["TRUE"] = "true";
    ARIA_VALUE["FALSE"] = "false";
})(ARIA_VALUE || (ARIA_VALUE = {}));
const MarketToggle$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketToggleChange = (0, $696Z8.createEvent)(this, "marketToggleChange", 7);
        this.checked = false;
        this.disabled = false;
        this.focused = false;
        this.hovered = false;
        this.active = false;
    }
    /**
   * Toggles `checked` prop, and emits a change event accordingly.
   * Used by `market-row` to sync its selected state w/ slotted toggles.
   */ setSelection(newValue) {
        if (typeof newValue !== 'boolean') return Promise.resolve();
        const prevValue = this.checked;
        if (prevValue !== newValue) {
            const { defaultPrevented } = this.marketToggleChange.emit({
                current: newValue,
                previous: prevValue
            });
            if (!defaultPrevented) this.checked = newValue;
        }
        return Promise.resolve();
    }
    /**
   * DEPRECATED (3.x): Toggles `selected` state (unrelated to the HTML attribute `value`).
   */ setValue(newValue) {
        /* eslint-disable-next-line no-console */ console.warn("market-toggle's setValue() method has been deprecated. Use setSelection() instead.", this.el);
        this.setSelection(newValue);
        return Promise.resolve();
    }
    /**
   * Sets `active` state. Allows external elements to programmatically
   * trigger active styling, ex. when slotted as a control into `market-row`.
   */ setActive(value) {
        this.active = value;
        return Promise.resolve();
    }
    /**
   * Sets `hovered` state. Allows external elements to programmatically
   * trigger hover styling, ex. when slotted as a control into `market-row`.
   */ setHover(value) {
        this.hovered = value;
        return Promise.resolve();
    }
    /**
   * Sets `disabled` state. Allows external elements to programmatically
   * trigger disabled styling, ex. when slotted as a control into `market-row`.
   */ setDisabled(value) {
        this.disabled = value;
        return Promise.resolve();
    }
    /**
   * Sets `focused` state, except when disabled.
   * Allows external consumers to programmatically
   * trigger focused styling.
   */ setFocus(value = true) {
        if (this.disabled) return Promise.resolve();
        this.focused = value;
        return Promise.resolve();
    }
    handleClick() {
        if (this.disabled) return;
        this.setFocus();
        this.setSelection(!this.checked);
    }
    render() {
        const ariaChecked = this.checked ? ARIA_VALUE.TRUE : ARIA_VALUE.FALSE;
        return (0, $696Z8.h)((0, $696Z8.Host), {
            class: "market-toggle",
            role: "switch",
            "aria-checked": ariaChecked,
            onBlur: ()=>{
                this.setFocus(false);
            },
            onClick: ()=>{
                this.handleClick();
            },
            onFocus: ()=>{
                this.setFocus();
            }
        }, (0, $696Z8.h)("input", {
            type: "checkbox",
            role: "switch",
            "aria-checked": ariaChecked,
            "aria-label": getControlInputAriaLabel(this.el),
            checked: this.checked,
            disabled: this.disabled
        }), (0, $696Z8.h)("span", {
            class: "focus-ring"
        }), (0, $696Z8.h)("svg", {
            width: "40",
            height: "24",
            viewBox: "0 0 40 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("rect", {
            x: "1",
            y: "1",
            width: "38",
            height: "22",
            rx: "11",
            "stroke-width": "2"
        }), (0, $696Z8.h)("circle", {
            cx: "12",
            cy: "12",
            r: "7"
        })));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketToggleCss;
    }
};
const marketTooltipCss = ":host{display:inline-block;font-weight:var(--tooltip-text-weight, var(--core-type-paragraph-20-weight));font-size:var(--tooltip-text-size, var(--core-type-paragraph-20-size));line-height:var(--tooltip-text-leading, var(--core-type-paragraph-20-leading));letter-spacing:var(--tooltip-text-tracking, var(--core-type-paragraph-20-tracking));text-transform:var(--tooltip-text-case, var(--core-type-paragraph-20-case))}:host market-dropdown{padding-bottom:0}:host market-dropdown .trigger-tap-target{display:flex;justify-content:center;align-items:center;min-width:var(--tooltip-min-width, 40px);min-height:var(--tooltip-min-height, 40px)}:host svg,:host ::slotted(svg[slot='trigger']){fill:var(--tooltip-icon-normal-state-color, var(--core-fill-20-color));transition:fill 0.3s ease-out;}:host ::slotted([slot='trigger']:not(svg)){color:var(--tooltip-text-normal-state-color, var(--core-emphasis-text-color));transition:color border-bottom 0.3s ease-out;text-decoration-line:underline;text-decoration-style:dashed;text-decoration-color:var(--tooltip-text-normal-state-color, var(--core-emphasis-text-color));text-decoration-thickness:1px;text-underline-position:under;text-underline-offset:2px;}:host([aria-expanded]) svg,:host([aria-expanded]) ::slotted(svg[slot='trigger']){fill:var(--tooltip-icon-active-state-color, var(--core-fill-10-color))}:host([aria-expanded]) ::slotted([slot='trigger']:not(svg)){color:var(--tooltip-text-active-state-color, var(--core-text-10-color));text-decoration-color:var(--tooltip-text-active-state-color, var(--core-text-10-color))}:host([disabled]) svg,:host([disabled]) ::slotted(svg[slot='trigger']){fill:var(--tooltip-icon-disabled-state-color, var(--core-fill-30-color))}:host([disabled]) ::slotted([slot='trigger']:not(svg)){color:var(--tooltip-text-disabled-state-color, var(--core-text-30-color));text-decoration-color:var(--tooltip-text-disabled-state-color, var(--core-text-30-color))}:host aside{max-width:var(--tooltip-popover-max-width, 400px);padding:var(--tooltip-popover-padding-vertical-size, 8px) var(--tooltip-popover-padding-horizontal-size, 12px);border-radius:var(--tooltip-popover-border-radius, 6px);background-color:var(--tooltip-popover-background-color, var(--core-surface-inverse-color));color:var(--tooltip-popover-text-color, var(--core-text-inverse-color));box-shadow:0 8px 16px rgb(0 0 0 / 0.1),\n      0 4px 32px rgb(0 0 0 / 0.1);}";
const MarketTooltip$1 = class extends (0, $696Z8.HTMLElement) {
    constructor(){
        super();
        this.__registerHost();
        this.__attachShadow();
        this.marketTooltipOpened = (0, $696Z8.createEvent)(this, "marketTooltipOpened", 7);
        this.marketTooltipClosed = (0, $696Z8.createEvent)(this, "marketTooltipClosed", 7);
        this.interaction = 'hover';
        this.disabled = false;
        this.popoverPlacement = 'bottom';
        this.popoverStrategy = 'absolute';
        this.popoverSkidding = undefined;
        this.popoverDistance = undefined;
        this.dropdownIsActive = false;
    }
    dropdownOpenedEventHandler() {
        this.dropdownIsActive = true;
        this.marketTooltipOpened.emit();
    }
    dropdownClosedEventHandler() {
        this.dropdownIsActive = false;
        this.marketTooltipClosed.emit();
    }
    /**
   * Opens the tooltip
   */ openTooltip() {
        return this.innerDropdown.openDropdown();
    }
    /**
   * Closes the tooltip
   */ closeTooltip() {
        return this.innerDropdown.closeDropdown();
    }
    styleLinks() {
        // since it isn't possible to style slotted child elements, we need to add
        // inline styles to slotted links in order to style them correctly
        // https://github.com/WICG/webcomponents/issues/594
        // https://github.com/WICG/webcomponents/issues/331
        const slottedLinks = this.el.querySelectorAll('[slot="content"] a');
        [
            ...slottedLinks
        ].forEach((link)=>{
            // TODO: use tooltip design tokens when they exist
            link.style.color = cjs.CORE_TEXT_INVERSE_COLOR;
            link.style.fontWeight = cjs.CORE_TYPE_BOLD_WEIGHT;
            link.style.textDecoration = 'none';
        });
    }
    render() {
        const MarketDropdownTagName = getNamespacedTagFor('market-dropdown');
        return (0, $696Z8.h)((0, $696Z8.Host), {
            "aria-expanded": this.dropdownIsActive,
            class: "market-tooltip"
        }, (0, $696Z8.h)(MarketDropdownTagName, {
            interaction: this.interaction,
            "popover-placement": this.popoverPlacement,
            "popover-strategy": this.popoverStrategy,
            "popover-distance": this.popoverDistance,
            "popover-skidding": this.popoverSkidding,
            disabled: this.disabled,
            part: "dropdown",
            ref: (el)=>this.innerDropdown = el
        }, (0, $696Z8.h)("div", {
            slot: "trigger",
            part: "trigger",
            class: "trigger-tap-target"
        }, (0, $696Z8.h)("slot", {
            name: "trigger"
        }, (0, $696Z8.h)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $696Z8.h)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M9 0C4.04 0 0 4.04 0 9C0 13.96 4.04 18 9 18C13.96 18 18 13.96 18 9C18 4.04 13.96 0 9 0ZM9 16C5.14 16 2 12.86 2 9C2 5.14 5.14 2 9 2C12.86 2 16 5.14 16 9C16 12.86 12.86 16 9 16ZM8 7.5V14H10V7.5H8ZM10.25 5.25C10.25 5.94036 9.69036 6.5 9 6.5C8.30964 6.5 7.75 5.94036 7.75 5.25C7.75 4.55964 8.30964 4 9 4C9.69036 4 10.25 4.55964 10.25 5.25Z"
        })))), (0, $696Z8.h)("aside", {
            slot: "popover",
            part: "popover"
        }, (0, $696Z8.h)("slot", {
            name: "content",
            onSlotchange: ()=>this.styleLinks()
        }))));
    }
    get el() {
        return this;
    }
    static get style() {
        return marketTooltipCss;
    }
};
const MarketAccessory = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketAccessory$1, [
    1,
    "market-accessory",
    {
        "size": [
            1
        ]
    }
]);
const MarketAccordionItem = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketAccordionItem$1, [
    1,
    "market-accordion-item",
    {
        "name": [
            513
        ],
        "expanded": [
            1540
        ],
        "disabled": [
            1540
        ],
        "size": [
            513
        ],
        "customTrigger": [
            32
        ]
    },
    [
        [
            0,
            "marketAccordionToggled",
            "marketAccordionToggleHandler"
        ]
    ]
]);
const MarketActionCard = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketActionCard$1, [
    1,
    "market-action-card",
    {
        "selected": [
            1540
        ],
        "disabled": [
            516
        ],
        "value": [
            513
        ],
        "transient": [
            4
        ],
        "row": [
            32
        ]
    },
    [
        [
            0,
            "marketRowSelected",
            "handleRowSelection"
        ],
        [
            0,
            "marketRowDeselected",
            "handleRowDeselection"
        ]
    ]
]);
const MarketActivityIndicator = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketActivityIndicator$1, [
    1,
    "market-activity-indicator",
    {
        "size": [
            513
        ]
    }
]);
const MarketActivityIndicatorBar = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketActivityIndicatorBar$1, [
    1,
    "market-activity-indicator-bar",
    {
        "value": [
            2
        ],
        "max": [
            2
        ]
    }
]);
const MarketBanner = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketBanner$1, [
    1,
    "market-banner",
    {
        "variant": [
            513
        ],
        "dismissable": [
            516
        ],
        "dismissButtonAriaLabel": [
            513,
            "dismiss-button-aria-label"
        ],
        "hasTitle": [
            32
        ],
        "hasAction": [
            32
        ]
    }
]);
const MarketBlade = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketBlade$1, [
    1,
    "market-blade",
    {
        "hidden": [
            1540
        ],
        "dialogID": [
            513,
            "data-dialog-id"
        ],
        "index": [
            514,
            "data-dialog-index"
        ],
        "animationDuration": [
            2,
            "animation-duration"
        ],
        "animationEnterDuration": [
            2,
            "animation-enter-duration"
        ],
        "animationExitDuration": [
            2,
            "animation-exit-duration"
        ],
        "trapFocus": [
            1028,
            "trap-focus"
        ]
    },
    [
        [
            0,
            "marketHeaderNavigate",
            "headerNavigateEventHandler"
        ]
    ]
]);
const MarketButton = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketButton$1, [
    1,
    "market-button",
    {
        "caret": [
            1
        ],
        "disabled": [
            516
        ],
        "download": [
            1
        ],
        "focused": [
            1540
        ],
        "href": [
            1
        ],
        "iconOnly": [
            1540,
            "icon-only"
        ],
        "innerTabindex": [
            2,
            "inner-tabindex"
        ],
        "isLoading": [
            516,
            "is-loading"
        ],
        "rank": [
            513
        ],
        "rel": [
            1
        ],
        "size": [
            513
        ],
        "target": [
            1
        ],
        "type": [
            513
        ],
        "variant": [
            513
        ],
        "ariaAttributes": [
            32
        ]
    },
    [
        [
            2,
            "click",
            "handleClick"
        ]
    ]
]);
const MarketButtonDropdown = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketButtonDropdown$1, [
    1,
    "market-button-dropdown",
    {
        "interaction": [
            1
        ],
        "disabled": [
            516
        ],
        "noCaret": [
            4,
            "no-caret"
        ],
        "popoverPlacement": [
            1,
            "popover-placement"
        ],
        "persistListSelections": [
            4,
            "persist-list"
        ],
        "dropdownIsActive": [
            32
        ]
    },
    [
        [
            0,
            "marketDropdownOpened",
            "dropdownOpenedEventHandler"
        ],
        [
            0,
            "marketDropdownClosed",
            "dropdownClosedEventHandler"
        ]
    ]
]);
const MarketButtonGroup = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketButtonGroup$1, [
    1,
    "market-button-group",
    {
        "alignment": [
            513
        ],
        "_sortedButtonEls": [
            32
        ]
    }
]);
const MarketCheckbox = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketCheckbox$1, [
    1,
    "market-checkbox",
    {
        "checked": [
            1540
        ],
        "disabled": [
            1540
        ],
        "indeterminate": [
            1540
        ],
        "invalid": [
            516
        ],
        "focused": [
            1540
        ],
        "hovered": [
            1540
        ],
        "active": [
            1540
        ]
    }
]);
const MarketChoiceButton = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketChoiceButton$1, [
    1,
    "market-choice-button",
    {
        "disabled": [
            516
        ],
        "selected": [
            1540
        ],
        "size": [
            513
        ]
    }
]);
const MarketCodeDisplay = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketCodeDisplay$1, [
    1,
    "market-code-display",
    {
        "disabled": [
            1540
        ],
        "focused": [
            1540
        ]
    }
]);
const MarketCodeInput = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketCodeInput$1, [
    1,
    "market-code-input",
    {
        "type": [
            513
        ],
        "name": [
            1
        ],
        "length": [
            2
        ],
        "focused": [
            1540
        ],
        "value": [
            1537
        ],
        "readonly": [
            516
        ],
        "invalid": [
            516
        ],
        "disabled": [
            516
        ],
        "_code": [
            32
        ]
    }
]);
const MarketContentCard = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketContentCard$1, [
    1,
    "market-content-card"
]);
const MarketContext = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketContext$1, [
    1,
    "market-context",
    {
        "currentDialog": [
            1040
        ],
        "noVeil": [
            1040
        ],
        "hidden": [
            1540
        ],
        "animationEnterDuration": [
            2,
            "animation-enter-duration"
        ],
        "animationExitDuration": [
            2,
            "animation-exit-duration"
        ],
        "stack": [
            32
        ],
        "totalCount": [
            32
        ],
        "dialogMeta": [
            32
        ]
    },
    [
        [
            0,
            "marketDialogLoaded",
            "modalLoadedEventHandler"
        ],
        [
            0,
            "marketDialogDismissed",
            "dialogDismissedEventHandler"
        ]
    ]
]);
const MarketContextManager = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketContextManager$1, [
    1,
    "market-context-manager",
    {
        "active": [
            1540
        ],
        "currentContext": [
            32
        ],
        "stack": [
            32
        ]
    },
    [
        [
            0,
            "marketContextEmptied",
            "contextEmptiedEventHandler"
        ],
        [
            8,
            "keydown",
            "windowKeydown"
        ]
    ]
]);
const MarketDatePicker = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketDatePicker$1, [
    1,
    "market-date-picker",
    {
        "selectionType": [
            1,
            "selection-type"
        ],
        "selectedStartDate": [
            1537,
            "selected-start-date"
        ],
        "selectedEndDate": [
            1537,
            "selected-end-date"
        ],
        "presetMenuOption": [
            1,
            "preset-menu-option"
        ],
        "displayMenu": [
            4,
            "display-menu"
        ],
        "mobileMenuPosition": [
            513,
            "mobile-menu-position"
        ],
        "excludeMenuItems": [
            1,
            "exclude-menu-items"
        ],
        "timeframe": [
            1
        ],
        "isDateDisabled": [
            16
        ],
        "locale": [
            1
        ],
        "displayedDate": [
            1025,
            "displayed-date"
        ],
        "withInputs": [
            1537,
            "with-inputs"
        ],
        "invalid": [
            1540
        ],
        "displayedMonth": [
            32
        ],
        "displayedWeekdays": [
            32
        ],
        "hoveredDate": [
            32
        ]
    },
    [
        [
            0,
            "marketDatePickerInputDateSet",
            "dateInputDateSet"
        ],
        [
            0,
            "marketDatePickerDateSelected",
            "selectDate"
        ],
        [
            0,
            "marketDatePickerDateMousedOver",
            "hoverDate"
        ],
        [
            0,
            "marketDatePickerDateMousedOut",
            "mousedOutDate"
        ],
        [
            0,
            "marketDatePickerMenuSelectionChanged",
            "selectMenuRow"
        ],
        [
            0,
            "marketDatePickerInputDateInvalidStateChanged",
            "setInvalidState"
        ]
    ]
]);
const MarketDatePickerDate = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketDatePickerDate$1, [
    1,
    "market-date-picker-date",
    {
        "disabled": [
            516
        ],
        "selection": [
            513
        ],
        "today": [
            516
        ],
        "selected": [
            516
        ],
        "day": [
            513
        ]
    }
]);
const MarketDatePickerInputDate = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketDateInputDate, [
    1,
    "market-date-picker-input-date",
    {
        "withTime": [
            4,
            "with-time"
        ],
        "selectedStartDate": [
            1,
            "selected-start-date"
        ],
        "selectedEndDate": [
            1,
            "selected-end-date"
        ],
        "isDateDisabled": [
            16
        ],
        "timeframe": [
            1
        ],
        "range": [
            4
        ],
        "isRangeInvalid": [
            32
        ]
    }
]);
const MarketDatePickerMenu = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketDatePickerMenu$1, [
    1,
    "market-date-picker-menu",
    {
        "timeframe": [
            513
        ],
        "excludeMenuItems": [
            1,
            "exclude-menu-items"
        ],
        "presetMenuOption": [
            1,
            "preset-menu-option"
        ]
    },
    [
        [
            0,
            "marketListSelectionsDidChange",
            "handleMarketListSelectionsDidChange"
        ]
    ]
]);
const MarketDialog = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketDialog$1, [
    1,
    "market-dialog",
    {
        "hidden": [
            1540
        ],
        "dialogID": [
            513,
            "data-dialog-id"
        ],
        "index": [
            514,
            "data-dialog-index"
        ],
        "isLoading": [
            4,
            "is-loading"
        ],
        "persistent": [
            516
        ],
        "trapFocus": [
            1028,
            "trap-focus"
        ],
        "animationEnterDuration": [
            2,
            "animation-enter-duration"
        ],
        "animationExitDuration": [
            2,
            "animation-exit-duration"
        ]
    }
]);
const MarketDivider = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketDivider$1, [
    1,
    "market-divider",
    {
        "margin": [
            513
        ]
    }
]);
const MarketDragHandle = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketDragHandle$1, [
    1,
    "market-drag-handle"
]);
const MarketDropdown = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketDropdown$1, [
    1,
    "market-dropdown",
    {
        "interaction": [
            1
        ],
        "disabled": [
            516
        ],
        "expanded": [
            1540
        ],
        "popoverPlacement": [
            1,
            "popover-placement"
        ],
        "popoverStrategy": [
            1,
            "popover-strategy"
        ],
        "popoverSkidding": [
            2,
            "popover-skidding"
        ],
        "popoverDistance": [
            2,
            "popover-distance"
        ]
    },
    [
        [
            8,
            "click",
            "windowClick"
        ]
    ]
]);
const MarketEmptyState = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketEmptyState$1, [
    1,
    "market-empty-state"
]);
const MarketField = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketField$1, [
    1,
    "market-field",
    {
        "name": [
            513
        ],
        "readonly": [
            516
        ],
        "disabled": [
            516
        ],
        "invalid": [
            516
        ]
    }
]);
const MarketFileUpload = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketFileUpload$1, [
    1,
    "market-file-upload",
    {
        "accept": [
            1
        ],
        "value": [
            16
        ],
        "disabled": [
            516
        ],
        "invalid": [
            516
        ],
        "multiple": [
            516
        ],
        "deleteButtonAriaLabel": [
            513,
            "delete-button-aria-label"
        ],
        "isDraggingOver": [
            32
        ],
        "files": [
            32
        ]
    }
]);
const MarketFilter = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketFilter$1, [
    1,
    "market-filter",
    {
        "name": [
            1
        ],
        "disabled": [
            4
        ],
        "focused": [
            1540
        ],
        "size": [
            1
        ],
        "expanded": [
            1540
        ],
        "dropdownInteraction": [
            1,
            "dropdown-interaction"
        ],
        "popoverPlacement": [
            1,
            "popover-placement"
        ],
        "selectedDisplayValue": [
            32
        ]
    },
    [
        [
            0,
            "marketListSelectionsDidChange",
            "handleListSelectionChange"
        ],
        [
            0,
            "marketDateRangeChanged",
            "handleDateRangeChange"
        ],
        [
            0,
            "marketDropdownOpened",
            "handleDropdownOpened"
        ],
        [
            0,
            "marketDropdownClosed",
            "handleDropdownClosed"
        ]
    ]
]);
const MarketFilterButton = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketFilterButton$1, [
    1,
    "market-filter-button",
    {
        "size": [
            513
        ],
        "disabled": [
            516
        ],
        "focused": [
            1540
        ],
        "iconOnly": [
            516,
            "icon-only"
        ],
        "active": [
            516
        ]
    },
    [
        [
            2,
            "click",
            "handleClick"
        ]
    ]
]);
const MarketFilterDropdownMenu = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketFilterDropdownMenu$1, [
    1,
    "market-filter-dropdown-menu",
    {
        "size": [
            513
        ],
        "filtersWithSelectedValue": [
            32
        ],
        "hasSelectedFilter": [
            32
        ],
        "isDropdownActive": [
            32
        ]
    },
    [
        [
            0,
            "marketDropdownOpened",
            "handleDropdownOpened"
        ],
        [
            0,
            "marketDropdownClosed",
            "handleDropdownClosed"
        ],
        [
            0,
            "marketHeaderNavigate",
            "handleHeaderNavigate"
        ]
    ]
]);
const MarketFilterGroup = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketFilterGroup$1, [
    1,
    "market-filter-group",
    {
        "maxVisibleFilters": [
            2,
            "max-visible-filters"
        ],
        "_sortedFilterEls": [
            32
        ]
    },
    [
        [
            0,
            "marketInputSearchFocus",
            "marketInputSearchFocusHandler"
        ],
        [
            0,
            "marketInternalInputSearchCompactAnimation",
            "marketInternalInputSearchCompactAnimationHandler"
        ],
        [
            0,
            "marketDropdownOpened",
            "marketDropdownOpenedHandler"
        ]
    ]
]);
const MarketFooter = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketFooter$1, [
    1,
    "market-footer"
]);
const MarketHeader = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketHeader$1, [
    1,
    "market-header",
    {
        "showNavigation": [
            1540,
            "show-navigation"
        ],
        "closeButtonAriaLabel": [
            513,
            "close-button-aria-label"
        ],
        "disableCloseButton": [
            4,
            "disable-close-button"
        ],
        "compact": [
            516
        ],
        "showActions": [
            32
        ]
    }
]);
const MarketInputPassword = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketInputPassword$1, [
    1,
    "market-input-password",
    {
        "inputId": [
            1,
            "input-id"
        ],
        "name": [
            1
        ],
        "value": [
            1
        ],
        "placeholder": [
            1
        ],
        "maxlength": [
            2
        ],
        "minlength": [
            2
        ],
        "size": [
            513
        ],
        "readonly": [
            4
        ],
        "disabled": [
            4
        ],
        "focused": [
            1028
        ],
        "invalid": [
            4
        ],
        "autocomplete": [
            8
        ],
        "inputmode": [
            1
        ],
        "type": [
            32
        ]
    }
]);
const MarketInputSearch = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(InputText$1, [
    1,
    "market-input-search",
    {
        "value": [
            1537
        ],
        "placeholder": [
            1
        ],
        "maxlength": [
            2
        ],
        "size": [
            513
        ],
        "variant": [
            513
        ],
        "disabled": [
            516
        ],
        "focused": [
            1540
        ],
        "autofocus": [
            4
        ],
        "autocomplete": [
            8
        ],
        "name": [
            1
        ],
        "inputAriaLabel": [
            1,
            "input-aria-label"
        ],
        "clearButtonAriaLabel": [
            1,
            "clear-button-aria-label"
        ],
        "searchIconButtonAriaLabel": [
            1,
            "search-icon-button-aria-label"
        ],
        "compact": [
            4
        ]
    }
]);
const MarketInputText = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(InputText, [
    1,
    "market-input-text",
    {
        "type": [
            513
        ],
        "inputId": [
            1,
            "input-id"
        ],
        "name": [
            1
        ],
        "value": [
            1537
        ],
        "placeholder": [
            1
        ],
        "maxlength": [
            2
        ],
        "minlength": [
            2
        ],
        "size": [
            513
        ],
        "step": [
            1
        ],
        "min": [
            1
        ],
        "max": [
            1
        ],
        "pattern": [
            1
        ],
        "required": [
            4
        ],
        "readonly": [
            516
        ],
        "disabled": [
            516
        ],
        "focused": [
            1540
        ],
        "invalid": [
            1540
        ],
        "inputmode": [
            1
        ],
        "autofocus": [
            4
        ],
        "autocomplete": [
            8
        ],
        "autovalidate": [
            4
        ],
        "autofilled": [
            1540
        ],
        "ariaAttributes": [
            32
        ]
    },
    [
        [
            8,
            "marketDialogLoaded",
            "handleMarketDialogLoaded"
        ]
    ]
]);
const MarketLink = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketLink$1, [
    1,
    "market-link",
    {
        "href": [
            1
        ],
        "target": [
            1
        ],
        "rel": [
            1
        ],
        "destructive": [
            516
        ],
        "disabled": [
            516
        ],
        "ariaAttributes": [
            32
        ]
    }
]);
const MarketList = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketList$1, [
    1,
    "market-list",
    {
        "value": [
            1537
        ],
        "interactive": [
            1028
        ],
        "transient": [
            4
        ],
        "multiselect": [
            516
        ],
        "name": [
            1
        ],
        "filterStrategy": [
            1,
            "filter-strategy"
        ],
        "reorderable": [
            513
        ],
        "hasSearch": [
            32
        ],
        "items": [
            32
        ],
        "selections": [
            32
        ],
        "filteredItems": [
            32
        ]
    },
    [
        [
            0,
            "marketRowSelected",
            "rowSelectedEventHandler"
        ],
        [
            0,
            "marketRowDeselected",
            "rowDeselectedEventHandler"
        ],
        [
            0,
            "marketCardSelected",
            "cardSelectedEventHandler"
        ],
        [
            0,
            "marketCardDeselected",
            "cardDeselectedEventHandler"
        ],
        [
            0,
            "marketInputSearchValueChange",
            "marketInputSearchValueChangeEventHander"
        ]
    ]
]);
const MarketModalFull = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketModalFull$1, [
    1,
    "market-modal-full",
    {
        "hidden": [
            1540
        ],
        "dialogID": [
            513,
            "data-dialog-id"
        ],
        "index": [
            514,
            "data-dialog-index"
        ],
        "layout": [
            513
        ],
        "trapFocus": [
            1028,
            "trap-focus"
        ],
        "animationEnterDuration": [
            2,
            "animation-enter-duration"
        ],
        "animationExitDuration": [
            2,
            "animation-exit-duration"
        ]
    },
    [
        [
            0,
            "marketHeaderNavigate",
            "headerNavigateEventHandler"
        ]
    ]
]);
const MarketModalPartial = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketModalPartial$1, [
    1,
    "market-modal-partial",
    {
        "hidden": [
            1540
        ],
        "dialogID": [
            513,
            "data-dialog-id"
        ],
        "index": [
            514,
            "data-dialog-index"
        ],
        "trapFocus": [
            1028,
            "trap-focus"
        ],
        "animationEnterDuration": [
            2,
            "animation-enter-duration"
        ],
        "animationExitDuration": [
            2,
            "animation-exit-duration"
        ]
    },
    [
        [
            0,
            "marketHeaderNavigate",
            "headerNavigateEventHandler"
        ]
    ]
]);
const MarketPagination = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketPagination$1, [
    1,
    "market-pagination",
    {
        "currentPage": [
            2,
            "current-page"
        ],
        "totalPages": [
            2,
            "total-pages"
        ],
        "hasNextPage": [
            4,
            "has-next-page"
        ],
        "hasPreviousPage": [
            4,
            "has-previous-page"
        ],
        "pageSize": [
            1,
            "page-size"
        ],
        "pageSizeOptions": [
            1,
            "page-size-options"
        ]
    },
    [
        [
            0,
            "marketInternalPaginationPageSizeChange",
            "changePageSize"
        ],
        [
            0,
            "marketInternalPaginationNavigation",
            "navigatePage"
        ]
    ]
]);
const MarketPaginationNav = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketPaginationNav$1, [
    4,
    "market-pagination-nav",
    {
        "currentPage": [
            2,
            "current-page"
        ],
        "totalPages": [
            2,
            "total-pages"
        ],
        "hasNextPage": [
            4,
            "has-next-page"
        ],
        "hasPreviousPage": [
            4,
            "has-previous-page"
        ],
        "pageSize": [
            1,
            "page-size"
        ]
    },
    [
        [
            0,
            "marketListSelectionsDidChange",
            "listSelectionEventHandler"
        ]
    ]
]);
const MarketPaginationPageSize = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketPaginationPageSize$1, [
    4,
    "market-pagination-page-size",
    {
        "value": [
            1
        ],
        "pageSizeOptions": [
            1,
            "page-size-options"
        ]
    },
    [
        [
            0,
            "marketListSelectionsDidChange",
            "listSelectionEventHander"
        ]
    ]
]);
const MarketPill = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketPill$1, [
    1,
    "market-pill",
    {
        "variant": [
            513
        ],
        "size": [
            513
        ],
        "indicator": [
            516
        ],
        "interactive": [
            516
        ],
        "role": [
            513
        ]
    }
]);
const MarketPopover = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(Popover, [
    1,
    "market-popover"
]);
const MarketProgressTracker = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketProgressTracker$1, [
    1,
    "market-progress-tracker",
    {
        "currentStepIndex": [
            2,
            "current-step-index"
        ],
        "completedSteps": [
            2,
            "completed-steps"
        ],
        "size": [
            1
        ],
        "variant": [
            1
        ],
        "indicator": [
            1
        ],
        "reversed": [
            4
        ],
        "barless": [
            4
        ]
    }
]);
const MarketProgressTrackerStep = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketProgressTrackerStep$1, [
    1,
    "market-progress-tracker-step",
    {
        "size": [
            513
        ],
        "variant": [
            1
        ],
        "indicator": [
            1
        ],
        "completed": [
            516
        ],
        "active": [
            516
        ],
        "bar": [
            1
        ]
    }
]);
const MarketQrcode = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketQrcode$1, [
    1,
    "market-qrcode",
    {
        "content": [
            513
        ],
        "size": [
            514
        ],
        "border": [
            4
        ],
        "monochrome": [
            516
        ]
    }
]);
const MarketRadio = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketRadio$1, [
    1,
    "market-radio",
    {
        "selected": [
            1540
        ],
        "disabled": [
            1540
        ],
        "invalid": [
            516
        ],
        "focused": [
            1540
        ],
        "hovered": [
            1540
        ],
        "active": [
            1540
        ]
    }
]);
const MarketRow = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketRow$1, [
    1,
    "market-row",
    {
        "selected": [
            1540
        ],
        "value": [
            513
        ],
        "disabled": [
            516
        ],
        "size": [
            513
        ],
        "interactive": [
            1028
        ],
        "transient": [
            1028
        ],
        "togglable": [
            4
        ],
        "variant": [
            1
        ],
        "destructive": [
            516
        ],
        "controlPosition": [
            1,
            "control-position"
        ],
        "href": [
            1
        ],
        "target": [
            1
        ],
        "dragEnabled": [
            516,
            "drag-enabled"
        ],
        "dragHandlePosition": [
            513,
            "drag-handle-position"
        ],
        "slottedControl": [
            32
        ],
        "hasSideText": [
            32
        ]
    }
]);
const MarketSegment = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketSegment$1, [
    1,
    "market-segment",
    {
        "disabled": [
            1540
        ],
        "value": [
            1537
        ],
        "selected": [
            32
        ]
    }
]);
const MarketSegmentedControl = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketSegmentedControl$1, [
    1,
    "market-segmented-control",
    {
        "value": [
            1537
        ],
        "disabled": [
            516
        ],
        "items": [
            32
        ]
    },
    [
        [
            0,
            "marketSegmentSelectedChanged",
            "marketSegmentSelectedEventHandler"
        ]
    ]
]);
const MarketSelect = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketSelect$1, [
    1,
    "market-select",
    {
        "name": [
            1
        ],
        "value": [
            1537
        ],
        "size": [
            513
        ],
        "placeholder": [
            1
        ],
        "readonly": [
            516
        ],
        "disabled": [
            516
        ],
        "focused": [
            1540
        ],
        "invalid": [
            516
        ],
        "multiselect": [
            516
        ],
        "popoverContainer": [
            1,
            "popover-container"
        ],
        "listIsActive": [
            32
        ],
        "focusedRowIndex": [
            32
        ],
        "hasLeadingAccessory": [
            32
        ],
        "hasTrailingAccessory": [
            32
        ]
    },
    [
        [
            8,
            "click",
            "windowClick"
        ]
    ]
]);
const MarketStepper = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketStepper$1, [
    1,
    "market-stepper",
    {
        "value": [
            1538
        ],
        "inputId": [
            1,
            "input-id"
        ],
        "name": [
            1
        ],
        "placeholder": [
            1
        ],
        "max": [
            2
        ],
        "min": [
            2
        ],
        "step": [
            2
        ],
        "readonly": [
            516
        ],
        "disabled": [
            516
        ],
        "focused": [
            1540
        ],
        "invalid": [
            516
        ],
        "inputAriaLabel": [
            513,
            "input-aria-label"
        ],
        "decrementAriaLabel": [
            513,
            "decrement-aria-label"
        ],
        "incrementAriaLabel": [
            513,
            "increment-aria-label"
        ],
        "incrementDisabled": [
            32
        ],
        "decrementDisabled": [
            32
        ]
    }
]);
const MarketTab = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTab$1, [
    1,
    "market-tab",
    {
        "disabled": [
            516
        ],
        "size": [
            513
        ],
        "selected": [
            1540
        ]
    }
]);
const MarketTabList = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTabList$1, [
    1,
    "market-tab-list",
    {
        "size": [
            1
        ],
        "selectedTab": [
            1537,
            "selected-tab"
        ],
        "defaultTab": [
            1,
            "default-tab"
        ]
    },
    [
        [
            0,
            "marketTabSelectedChanged",
            "marketTabSelectedChangedEventHandler"
        ]
    ]
]);
const MarketTabPanel = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTabPanel$1, [
    1,
    "market-tab-panel",
    {
        "hidden": [
            516
        ]
    }
]);
const MarketTable = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTable$1, [
    1,
    "market-table",
    {
        "styleDeclaration": [
            32
        ],
        "gridColumnTemplate": [
            32
        ],
        "allColumns": [
            32
        ],
        "visibleColumns": [
            32
        ],
        "columnsStuckLeft": [
            32
        ],
        "columnsStuckRight": [
            32
        ],
        "columnsUnstuck": [
            32
        ],
        "allRows": [
            32
        ],
        "rowsStuckTop": [
            32
        ],
        "rowsStuckBottom": [
            32
        ],
        "rowsUnstuck": [
            32
        ],
        "hasAccordionRows": [
            32
        ]
    },
    [
        [
            0,
            "marketTableHeaderLoaded",
            "marketTableHeaderLoadedEventHandler"
        ],
        [
            0,
            "marketTableRowStick",
            "marketTableRowStickEventHandler"
        ],
        [
            0,
            "marketTableRowUnstick",
            "marketTableRowUnstickEventHandler"
        ],
        [
            0,
            "marketTableColumnStick",
            "marketTableColumnStickEventHandler"
        ],
        [
            0,
            "marketTableColumnUnstick",
            "marketTableColumnUnstickEventHandler"
        ],
        [
            0,
            "marketTableColumnVisibilityChange",
            "marketTableColumnVisibilityChangeHandler"
        ]
    ]
]);
const MarketTableArea = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTableArea$1, [
    1,
    "market-table-area",
    {
        "orientation": [
            513
        ],
        "stickTo": [
            513,
            "stick-to"
        ],
        "gridTemplate": [
            16
        ],
        "active": [
            1540
        ],
        "placement": [
            16
        ],
        "elements": [
            32
        ]
    }
]);
const MarketTableCell = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTableCell$1, [
    1,
    "market-table-cell",
    {
        "align": [
            1032
        ],
        "column": [
            1537
        ],
        "leadingIndentation": [
            1026,
            "leading-indentation"
        ],
        "active": [
            516
        ],
        "interactive": [
            516
        ],
        "disabled": [
            516
        ],
        "originalSlot": [
            32
        ],
        "hidden": [
            32
        ]
    }
]);
const MarketTableColumn = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTableColumn$1, [
    1,
    "market-table-column",
    {
        "name": [
            513
        ],
        "align": [
            8
        ],
        "stickTo": [
            1537,
            "stick-to"
        ],
        "sortable": [
            516
        ],
        "sortOrder": [
            513,
            "sort-order"
        ],
        "hidden": [
            516
        ],
        "index": [
            2
        ],
        "width": [
            1
        ],
        "originalSlot": [
            32
        ]
    }
]);
const MarketTableRow = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTableRow$1, [
    1,
    "market-table-row",
    {
        "leadingIndentation": [
            1538,
            "leading-indentation"
        ],
        "stickTo": [
            1544,
            "stick-to"
        ],
        "sticky": [
            1540
        ],
        "active": [
            516
        ],
        "interactive": [
            516
        ],
        "disabled": [
            516
        ],
        "selected": [
            1540
        ],
        "header": [
            1540
        ],
        "footer": [
            1540
        ],
        "originalSlot": [
            1025,
            "original-slot"
        ],
        "index": [
            2
        ],
        "tableColumns": [
            16
        ],
        "cells": [
            1040
        ],
        "gridTemplateMain": [
            16
        ],
        "gridTemplateLeft": [
            16
        ],
        "gridTemplateRight": [
            16
        ],
        "expanded": [
            1028
        ],
        "nested": [
            1540
        ],
        "styleDeclaration": [
            32
        ],
        "gridTemplate": [
            32
        ],
        "nestedRowToggleButton": [
            32
        ]
    },
    [
        [
            0,
            "marketCheckboxValueChange",
            "handleMarketCheckboxValueChange"
        ],
        [
            0,
            "marketToggleChange",
            "handleMarketCheckboxValueChange"
        ]
    ]
]);
const MarketTableV2 = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTableV2$1, [
    1,
    "market-table-v2",
    {
        "align": [
            513
        ],
        "layout": [
            513
        ],
        "valign": [
            513
        ]
    }
]);
const MarketTableV2Cell = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTableV2Cell$1, [
    1,
    "market-table-v2-cell",
    {
        "active": [
            516
        ],
        "align": [
            513
        ],
        "disabled": [
            516
        ],
        "interactive": [
            516
        ],
        "nowrap": [
            516
        ],
        "sticky": [
            513
        ],
        "valign": [
            513
        ]
    }
]);
const MarketTableV2Row = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTableV2Row$1, [
    1,
    "market-table-v2-row",
    {
        "active": [
            516
        ],
        "align": [
            513
        ],
        "disabled": [
            516
        ],
        "footer": [
            516
        ],
        "header": [
            516
        ],
        "interactive": [
            516
        ],
        "sticky": [
            513
        ],
        "valign": [
            513
        ]
    }
]);
const MarketTabs = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTabs$1, [
    1,
    "market-tabs",
    {
        "selectedTab": [
            1537,
            "selected-tab"
        ],
        "defaultTab": [
            1,
            "default-tab"
        ]
    },
    [
        [
            0,
            "marketTabSelectedChanged",
            "marketTabSelectedChangedEventHandler"
        ]
    ]
]);
const MarketTag = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTag$1, [
    1,
    "market-tag",
    {
        "disabled": [
            516
        ],
        "focused": [
            1540
        ],
        "size": [
            513
        ],
        "hasIcon": [
            32
        ]
    }
]);
const MarketTextarea = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTextarea$1, [
    1,
    "market-textarea",
    {
        "placeholder": [
            1
        ],
        "name": [
            1
        ],
        "value": [
            1537
        ],
        "maxlength": [
            1
        ],
        "readonly": [
            516
        ],
        "disabled": [
            516
        ],
        "focused": [
            1540
        ],
        "invalid": [
            516
        ],
        "maxHeight": [
            1,
            "max-height"
        ],
        "autofocus": [
            4
        ],
        "inputmode": [
            1
        ],
        "ariaAttributes": [
            32
        ]
    },
    [
        [
            8,
            "marketDialogLoaded",
            "handleMarketDialogLoaded"
        ]
    ]
]);
const MarketTile = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTile$1, [
    1,
    "market-tile",
    {
        "disabled": [
            516,
            "aria-disabled"
        ],
        "interactive": [
            4
        ],
        "showActions": [
            4,
            "show-actions"
        ],
        "size": [
            513
        ],
        "value": [
            513
        ],
        "selected": [
            1540
        ],
        "hasSlottedMedia": [
            32
        ]
    }
]);
const MarketToast = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketToast$1, [
    1,
    "market-toast",
    {
        "variant": [
            513
        ],
        "persistent": [
            4
        ],
        "dismissButtonAriaLabel": [
            513,
            "dismiss-button-aria-label"
        ],
        "progress": [
            514
        ],
        "durationTilAutoDismiss": [
            32
        ],
        "showActionsNav": [
            32
        ]
    }
]);
const MarketToaster = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketToaster$1, [
    1,
    "market-toaster",
    null,
    [
        [
            0,
            "marketToastAutoDismissed",
            "toastAutoDismissedEventHandler"
        ],
        [
            0,
            "marketToastManuallyDismissed",
            "toastManuallyDismissedEventHandler"
        ]
    ]
]);
const MarketToggle = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketToggle$1, [
    1,
    "market-toggle",
    {
        "checked": [
            1540
        ],
        "disabled": [
            1540
        ],
        "focused": [
            1540
        ],
        "hovered": [
            1540
        ],
        "active": [
            1540
        ]
    }
]);
const MarketTooltip = /*@__PURE__*/ (0, $696Z8.proxyCustomElement)(MarketTooltip$1, [
    1,
    "market-tooltip",
    {
        "interaction": [
            1
        ],
        "disabled": [
            516
        ],
        "popoverPlacement": [
            1,
            "popover-placement"
        ],
        "popoverStrategy": [
            1,
            "popover-strategy"
        ],
        "popoverSkidding": [
            2,
            "popover-skidding"
        ],
        "popoverDistance": [
            2,
            "popover-distance"
        ],
        "dropdownIsActive": [
            32
        ]
    },
    [
        [
            0,
            "marketDropdownOpened",
            "dropdownOpenedEventHandler"
        ],
        [
            0,
            "marketDropdownClosed",
            "dropdownClosedEventHandler"
        ]
    ]
]);
const defineCustomElements = (opts)=>{
    if (typeof customElements !== 'undefined') [
        MarketAccessory,
        MarketAccordionItem,
        MarketActionCard,
        MarketActivityIndicator,
        MarketActivityIndicatorBar,
        MarketBanner,
        MarketBlade,
        MarketButton,
        MarketButtonDropdown,
        MarketButtonGroup,
        MarketCheckbox,
        MarketChoiceButton,
        MarketCodeDisplay,
        MarketCodeInput,
        MarketContentCard,
        MarketContext,
        MarketContextManager,
        MarketDatePicker,
        MarketDatePickerDate,
        MarketDatePickerInputDate,
        MarketDatePickerMenu,
        MarketDialog,
        MarketDivider,
        MarketDragHandle,
        MarketDropdown,
        MarketEmptyState,
        MarketField,
        MarketFileUpload,
        MarketFilter,
        MarketFilterButton,
        MarketFilterDropdownMenu,
        MarketFilterGroup,
        MarketFooter,
        MarketHeader,
        MarketInputPassword,
        MarketInputSearch,
        MarketInputText,
        MarketLink,
        MarketList,
        MarketModalFull,
        MarketModalPartial,
        MarketPagination,
        MarketPaginationNav,
        MarketPaginationPageSize,
        MarketPill,
        MarketPopover,
        MarketProgressTracker,
        MarketProgressTrackerStep,
        MarketQrcode,
        MarketRadio,
        MarketRow,
        MarketSegment,
        MarketSegmentedControl,
        MarketSelect,
        MarketStepper,
        MarketTab,
        MarketTabList,
        MarketTabPanel,
        MarketTable,
        MarketTableArea,
        MarketTableCell,
        MarketTableColumn,
        MarketTableRow,
        MarketTableV2,
        MarketTableV2Cell,
        MarketTableV2Row,
        MarketTabs,
        MarketTag,
        MarketTextarea,
        MarketTile,
        MarketToast,
        MarketToaster,
        MarketToggle,
        MarketTooltip
    ].forEach((cmp)=>{
        if (!customElements.get(cmp.is)) customElements.define(cmp.is, cmp, opts);
    });
};

});
parcelRegister("696Z8", function(module, exports) {

$parcel$export(module.exports, "h", () => $47990066fdbc3144$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "Host", () => $47990066fdbc3144$export$5d2c872882e2b878);
$parcel$export(module.exports, "createEvent", () => $47990066fdbc3144$export$c30017717ce2168e);
$parcel$export(module.exports, "proxyCustomElement", () => $47990066fdbc3144$export$370caf1876b7c579);
$parcel$export(module.exports, "Fragment", () => $47990066fdbc3144$export$ffb0004e005737fa);
$parcel$export(module.exports, "HTMLElement", () => $47990066fdbc3144$export$7f8ddf7c7c20b3cd);
/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/snabbdom/snabbdom/blob/master/LICENSE
 *
 * Modified for Stencil's renderer and slot projection
 */ 
var $kxuSp = parcelRequire("kxuSp");
let $47990066fdbc3144$var$scopeId;
let $47990066fdbc3144$var$contentRef;
let $47990066fdbc3144$var$hostTagName;
let $47990066fdbc3144$var$customError;
let $47990066fdbc3144$var$i = 0;
let $47990066fdbc3144$var$useNativeShadowDom = false;
let $47990066fdbc3144$var$checkSlotFallbackVisibility = false;
let $47990066fdbc3144$var$checkSlotRelocate = false;
let $47990066fdbc3144$var$isSvgMode = false;
let $47990066fdbc3144$var$renderingRef = null;
let $47990066fdbc3144$var$queueCongestion = 0;
let $47990066fdbc3144$var$queuePending = false;
const $47990066fdbc3144$export$77b5f1d340d6466b = {
    isDev: (0, $kxuSp.BUILD).isDev ? true : false,
    isBrowser: true,
    isServer: false,
    isTesting: (0, $kxuSp.BUILD).isTesting ? true : false
};
const $47990066fdbc3144$export$841858b892ce1f4c = {};
const $47990066fdbc3144$export$7c3997b47f2311d9 = (path)=>{
    const assetUrl = new URL(path, $47990066fdbc3144$export$2e40610e9d23bca6.$resourcesUrl$);
    return assetUrl.origin !== $47990066fdbc3144$export$10a0f131c0eea21b.location.origin ? assetUrl.href : assetUrl.pathname;
};
const $47990066fdbc3144$export$4d21c79ffe6155ac = (path)=>$47990066fdbc3144$export$2e40610e9d23bca6.$resourcesUrl$ = path;
const $47990066fdbc3144$var$createTime = (fnName, tagName = '')=>{
    if ((0, $kxuSp.BUILD).profile && performance.mark) {
        const key = `st:${fnName}:${tagName}:${$47990066fdbc3144$var$i++}`;
        // Start
        performance.mark(key);
        // End
        return ()=>performance.measure(`[Stencil] ${fnName}() <${tagName}>`, key);
    } else return ()=>{
        return;
    };
};
const $47990066fdbc3144$var$uniqueTime = (key, measureText)=>{
    if ((0, $kxuSp.BUILD).profile && performance.mark) {
        if (performance.getEntriesByName(key, 'mark').length === 0) performance.mark(key);
        return ()=>{
            if (performance.getEntriesByName(measureText, 'measure').length === 0) performance.measure(measureText, key);
        };
    } else return ()=>{
        return;
    };
};
const $47990066fdbc3144$var$inspect = (ref)=>{
    const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(ref);
    if (!hostRef) return undefined;
    const flags = hostRef.$flags$;
    const hostElement = hostRef.$hostElement$;
    return {
        renderCount: hostRef.$renderCount$,
        flags: {
            hasRendered: !!(flags & 2 /* HOST_FLAGS.hasRendered */ ),
            hasConnected: !!(flags & 1 /* HOST_FLAGS.hasConnected */ ),
            isWaitingForChildren: !!(flags & 4 /* HOST_FLAGS.isWaitingForChildren */ ),
            isConstructingInstance: !!(flags & 8 /* HOST_FLAGS.isConstructingInstance */ ),
            isQueuedForUpdate: !!(flags & 16 /* HOST_FLAGS.isQueuedForUpdate */ ),
            hasInitializedComponent: !!(flags & 32 /* HOST_FLAGS.hasInitializedComponent */ ),
            hasLoadedComponent: !!(flags & 64 /* HOST_FLAGS.hasLoadedComponent */ ),
            isWatchReady: !!(flags & 128 /* HOST_FLAGS.isWatchReady */ ),
            isListenReady: !!(flags & 256 /* HOST_FLAGS.isListenReady */ ),
            needsRerender: !!(flags & 512 /* HOST_FLAGS.needsRerender */ )
        },
        instanceValues: hostRef.$instanceValues$,
        ancestorComponent: hostRef.$ancestorComponent$,
        hostElement: hostElement,
        lazyInstance: hostRef.$lazyInstance$,
        vnode: hostRef.$vnode$,
        modeName: hostRef.$modeName$,
        onReadyPromise: hostRef.$onReadyPromise$,
        onReadyResolve: hostRef.$onReadyResolve$,
        onInstancePromise: hostRef.$onInstancePromise$,
        onInstanceResolve: hostRef.$onInstanceResolve$,
        onRenderResolve: hostRef.$onRenderResolve$,
        queuedListeners: hostRef.$queuedListeners$,
        rmListeners: hostRef.$rmListeners$,
        ['s-id']: hostElement['s-id'],
        ['s-cr']: hostElement['s-cr'],
        ['s-lr']: hostElement['s-lr'],
        ['s-p']: hostElement['s-p'],
        ['s-rc']: hostElement['s-rc'],
        ['s-sc']: hostElement['s-sc']
    };
};
const $47990066fdbc3144$var$installDevTools = ()=>{
    if ((0, $kxuSp.BUILD).devTools) {
        const stencil = $47990066fdbc3144$export$10a0f131c0eea21b.stencil = $47990066fdbc3144$export$10a0f131c0eea21b.stencil || {};
        const originalInspect = stencil.inspect;
        stencil.inspect = (ref)=>{
            let result = $47990066fdbc3144$var$inspect(ref);
            if (!result && typeof originalInspect === 'function') result = originalInspect(ref);
            return result;
        };
    }
};
const $47990066fdbc3144$var$CONTENT_REF_ID = 'r';
const $47990066fdbc3144$var$ORG_LOCATION_ID = 'o';
const $47990066fdbc3144$var$SLOT_NODE_ID = 's';
const $47990066fdbc3144$var$TEXT_NODE_ID = 't';
const $47990066fdbc3144$var$HYDRATE_ID = 's-id';
const $47990066fdbc3144$var$HYDRATED_STYLE_ID = 'sty-id';
const $47990066fdbc3144$var$HYDRATE_CHILD_ID = 'c-id';
const $47990066fdbc3144$var$HYDRATED_CSS = '{visibility:hidden}.hydrated{visibility:inherit}';
const $47990066fdbc3144$var$XLINK_NS = 'http://www.w3.org/1999/xlink';
/**
 * Default style mode id
 */ /**
 * Reusable empty obj/array
 * Don't add values to these!!
 */ const $47990066fdbc3144$var$EMPTY_OBJ = {};
/**
 * Namespaces
 */ const $47990066fdbc3144$var$SVG_NS = 'http://www.w3.org/2000/svg';
const $47990066fdbc3144$var$HTML_NS = 'http://www.w3.org/1999/xhtml';
const $47990066fdbc3144$var$isDef = (v)=>v != null;
const $47990066fdbc3144$var$isComplexType = (o)=>{
    // https://jsperf.com/typeof-fn-object/5
    o = typeof o;
    return o === 'object' || o === 'function';
};
/**
 * Helper method for querying a `meta` tag that contains a nonce value
 * out of a DOM's head.
 *
 * @param doc The DOM containing the `head` to query against
 * @returns The content of the meta tag representing the nonce value, or `undefined` if no tag
 * exists or the tag has no content.
 */ function $47990066fdbc3144$var$queryNonceMetaTagContent(doc) {
    var _a, _b, _c;
    return (_c = (_b = (_a = doc.head) === null || _a === void 0 ? void 0 : _a.querySelector('meta[name="csp-nonce"]')) === null || _b === void 0 ? void 0 : _b.getAttribute('content')) !== null && _c !== void 0 ? _c : undefined;
}
/**
 * Production h() function based on Preact by
 * Jason Miller (@developit)
 * Licensed under the MIT License
 * https://github.com/developit/preact/blob/master/LICENSE
 *
 * Modified for Stencil's compiler and vdom
 */ // export function h(nodeName: string | d.FunctionalComponent, vnodeData: d.PropsType, child?: d.ChildType): d.VNode;
// export function h(nodeName: string | d.FunctionalComponent, vnodeData: d.PropsType, ...children: d.ChildType[]): d.VNode;
const $47990066fdbc3144$export$dda1d9f60106f0e9 = (nodeName, vnodeData, ...children)=>{
    let child = null;
    let key = null;
    let slotName = null;
    let simple = false;
    let lastSimple = false;
    const vNodeChildren = [];
    const walk = (c)=>{
        for(let i = 0; i < c.length; i++){
            child = c[i];
            if (Array.isArray(child)) walk(child);
            else if (child != null && typeof child !== 'boolean') {
                if (simple = typeof nodeName !== 'function' && !$47990066fdbc3144$var$isComplexType(child)) child = String(child);
                else if ((0, $kxuSp.BUILD).isDev && typeof nodeName !== 'function' && child.$flags$ === undefined) $47990066fdbc3144$export$47b52a6e53fbbc24(`vNode passed as children has unexpected type.
Make sure it's using the correct h() function.
Empty objects can also be the cause, look for JSX comments that became objects.`);
                if (simple && lastSimple) // If the previous child was simple (string), we merge both
                vNodeChildren[vNodeChildren.length - 1].$text$ += child;
                else // Append a new vNode, if it's text, we create a text vNode
                vNodeChildren.push(simple ? $47990066fdbc3144$var$newVNode(null, child) : child);
                lastSimple = simple;
            }
        }
    };
    walk(children);
    if (vnodeData) {
        if ((0, $kxuSp.BUILD).isDev && nodeName === 'input') $47990066fdbc3144$var$validateInputProperties(vnodeData);
        // normalize class / classname attributes
        if ((0, $kxuSp.BUILD).vdomKey && vnodeData.key) key = vnodeData.key;
        if ((0, $kxuSp.BUILD).slotRelocation && vnodeData.name) slotName = vnodeData.name;
        if ((0, $kxuSp.BUILD).vdomClass) {
            const classData = vnodeData.className || vnodeData.class;
            if (classData) vnodeData.class = typeof classData !== 'object' ? classData : Object.keys(classData).filter((k)=>classData[k]).join(' ');
        }
    }
    if ((0, $kxuSp.BUILD).isDev && vNodeChildren.some($47990066fdbc3144$var$isHost)) $47990066fdbc3144$export$47b52a6e53fbbc24(`The <Host> must be the single root component. Make sure:
- You are NOT using hostData() and <Host> in the same component.
- <Host> is used once, and it's the single root component of the render() function.`);
    if ((0, $kxuSp.BUILD).vdomFunctional && typeof nodeName === 'function') // nodeName is a functional component
    return nodeName(vnodeData === null ? {} : vnodeData, vNodeChildren, $47990066fdbc3144$var$vdomFnUtils);
    const vnode = $47990066fdbc3144$var$newVNode(nodeName, null);
    vnode.$attrs$ = vnodeData;
    if (vNodeChildren.length > 0) vnode.$children$ = vNodeChildren;
    if ((0, $kxuSp.BUILD).vdomKey) vnode.$key$ = key;
    if ((0, $kxuSp.BUILD).slotRelocation) vnode.$name$ = slotName;
    return vnode;
};
/**
 * A utility function for creating a virtual DOM node from a tag and some
 * possible text content.
 *
 * @param tag the tag for this element
 * @param text possible text content for the node
 * @returns a newly-minted virtual DOM node
 */ const $47990066fdbc3144$var$newVNode = (tag, text)=>{
    const vnode = {
        $flags$: 0,
        $tag$: tag,
        $text$: text,
        $elm$: null,
        $children$: null
    };
    if ((0, $kxuSp.BUILD).vdomAttribute) vnode.$attrs$ = null;
    if ((0, $kxuSp.BUILD).vdomKey) vnode.$key$ = null;
    if ((0, $kxuSp.BUILD).slotRelocation) vnode.$name$ = null;
    return vnode;
};
const $47990066fdbc3144$export$5d2c872882e2b878 = {};
/**
 * Check whether a given node is a Host node or not
 *
 * @param node the virtual DOM node to check
 * @returns whether it's a Host node or not
 */ const $47990066fdbc3144$var$isHost = (node)=>node && node.$tag$ === $47990066fdbc3144$export$5d2c872882e2b878;
/**
 * Implementation of {@link d.FunctionalUtilities} for Stencil's VDom.
 *
 * Note that these functions convert from {@link d.VNode} to
 * {@link d.ChildNode} to give functional component developers a friendly
 * interface.
 */ const $47990066fdbc3144$var$vdomFnUtils = {
    forEach: (children, cb)=>children.map($47990066fdbc3144$var$convertToPublic).forEach(cb),
    map: (children, cb)=>children.map($47990066fdbc3144$var$convertToPublic).map(cb).map($47990066fdbc3144$var$convertToPrivate)
};
/**
 * Convert a {@link d.VNode} to a {@link d.ChildNode} in order to present a
 * friendlier public interface (hence, 'convertToPublic').
 *
 * @param node the virtual DOM node to convert
 * @returns a converted child node
 */ const $47990066fdbc3144$var$convertToPublic = (node)=>({
        vattrs: node.$attrs$,
        vchildren: node.$children$,
        vkey: node.$key$,
        vname: node.$name$,
        vtag: node.$tag$,
        vtext: node.$text$
    });
/**
 * Convert a {@link d.ChildNode} back to an equivalent {@link d.VNode} in
 * order to use the resulting object in the virtual DOM. The initial object was
 * likely created as part of presenting a public API, so converting it back
 * involved making it 'private' again (hence, `convertToPrivate`).
 *
 * @param node the child node to convert
 * @returns a converted virtual DOM node
 */ const $47990066fdbc3144$var$convertToPrivate = (node)=>{
    if (typeof node.vtag === 'function') {
        const vnodeData = Object.assign({}, node.vattrs);
        if (node.vkey) vnodeData.key = node.vkey;
        if (node.vname) vnodeData.name = node.vname;
        return $47990066fdbc3144$export$dda1d9f60106f0e9(node.vtag, vnodeData, ...node.vchildren || []);
    }
    const vnode = $47990066fdbc3144$var$newVNode(node.vtag, node.vtext);
    vnode.$attrs$ = node.vattrs;
    vnode.$children$ = node.vchildren;
    vnode.$key$ = node.vkey;
    vnode.$name$ = node.vname;
    return vnode;
};
/**
 * Validates the ordering of attributes on an input element
 *
 * @param inputElm the element to validate
 */ const $47990066fdbc3144$var$validateInputProperties = (inputElm)=>{
    const props = Object.keys(inputElm);
    const value = props.indexOf('value');
    if (value === -1) return;
    const typeIndex = props.indexOf('type');
    const minIndex = props.indexOf('min');
    const maxIndex = props.indexOf('max');
    const stepIndex = props.indexOf('step');
    if (value < typeIndex || value < minIndex || value < maxIndex || value < stepIndex) $47990066fdbc3144$export$5d385f3b3df7e1b9(`The "value" prop of <input> should be set after "min", "max", "type" and "step"`);
};
const $47990066fdbc3144$var$initializeClientHydrate = (hostElm, tagName, hostId, hostRef)=>{
    const endHydrate = $47990066fdbc3144$var$createTime('hydrateClient', tagName);
    const shadowRoot = hostElm.shadowRoot;
    const childRenderNodes = [];
    const slotNodes = [];
    const shadowRootNodes = (0, $kxuSp.BUILD).shadowDom && shadowRoot ? [] : null;
    const vnode = hostRef.$vnode$ = $47990066fdbc3144$var$newVNode(tagName, null);
    if (!$47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$) $47990066fdbc3144$var$initializeDocumentHydrate($47990066fdbc3144$export$2a111da947c407d2.body, $47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$ = new Map());
    hostElm[$47990066fdbc3144$var$HYDRATE_ID] = hostId;
    hostElm.removeAttribute($47990066fdbc3144$var$HYDRATE_ID);
    $47990066fdbc3144$var$clientHydrate(vnode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, hostElm, hostId);
    childRenderNodes.map((c)=>{
        const orgLocationId = c.$hostId$ + '.' + c.$nodeId$;
        const orgLocationNode = $47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$.get(orgLocationId);
        const node = c.$elm$;
        if (orgLocationNode && $47990066fdbc3144$export$b4e7e6d61dbcd813 && orgLocationNode['s-en'] === '') orgLocationNode.parentNode.insertBefore(node, orgLocationNode.nextSibling);
        if (!shadowRoot) {
            node['s-hn'] = tagName;
            if (orgLocationNode) {
                node['s-ol'] = orgLocationNode;
                node['s-ol']['s-nr'] = node;
            }
        }
        $47990066fdbc3144$export$2e40610e9d23bca6.$orgLocNodes$.delete(orgLocationId);
    });
    if ((0, $kxuSp.BUILD).shadowDom && shadowRoot) shadowRootNodes.map((shadowRootNode)=>{
        if (shadowRootNode) shadowRoot.appendChild(shadowRootNode);
    });
    endHydrate();
};
const $47990066fdbc3144$var$clientHydrate = (parentVNode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, node, hostId)=>{
    let childNodeType;
    let childIdSplt;
    let childVNode;
    let i;
    if (node.nodeType === 1 /* NODE_TYPE.ElementNode */ ) {
        childNodeType = node.getAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID);
        if (childNodeType) {
            // got the node data from the element's attribute
            // `${hostId}.${nodeId}.${depth}.${index}`
            childIdSplt = childNodeType.split('.');
            if (childIdSplt[0] === hostId || childIdSplt[0] === '0') {
                childVNode = {
                    $flags$: 0,
                    $hostId$: childIdSplt[0],
                    $nodeId$: childIdSplt[1],
                    $depth$: childIdSplt[2],
                    $index$: childIdSplt[3],
                    $tag$: node.tagName.toLowerCase(),
                    $elm$: node,
                    $attrs$: null,
                    $children$: null,
                    $key$: null,
                    $name$: null,
                    $text$: null
                };
                childRenderNodes.push(childVNode);
                node.removeAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID);
                // this is a new child vnode
                // so ensure its parent vnode has the vchildren array
                if (!parentVNode.$children$) parentVNode.$children$ = [];
                // add our child vnode to a specific index of the vnode's children
                parentVNode.$children$[childVNode.$index$] = childVNode;
                // this is now the new parent vnode for all the next child checks
                parentVNode = childVNode;
                if (shadowRootNodes && childVNode.$depth$ === '0') shadowRootNodes[childVNode.$index$] = childVNode.$elm$;
            }
        }
        // recursively drill down, end to start so we can remove nodes
        for(i = node.childNodes.length - 1; i >= 0; i--)$47990066fdbc3144$var$clientHydrate(parentVNode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, node.childNodes[i], hostId);
        if (node.shadowRoot) // keep drilling down through the shadow root nodes
        for(i = node.shadowRoot.childNodes.length - 1; i >= 0; i--)$47990066fdbc3144$var$clientHydrate(parentVNode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, node.shadowRoot.childNodes[i], hostId);
    } else if (node.nodeType === 8 /* NODE_TYPE.CommentNode */ ) {
        // `${COMMENT_TYPE}.${hostId}.${nodeId}.${depth}.${index}`
        childIdSplt = node.nodeValue.split('.');
        if (childIdSplt[1] === hostId || childIdSplt[1] === '0') {
            // comment node for either the host id or a 0 host id
            childNodeType = childIdSplt[0];
            childVNode = {
                $flags$: 0,
                $hostId$: childIdSplt[1],
                $nodeId$: childIdSplt[2],
                $depth$: childIdSplt[3],
                $index$: childIdSplt[4],
                $elm$: node,
                $attrs$: null,
                $children$: null,
                $key$: null,
                $name$: null,
                $tag$: null,
                $text$: null
            };
            if (childNodeType === $47990066fdbc3144$var$TEXT_NODE_ID) {
                childVNode.$elm$ = node.nextSibling;
                if (childVNode.$elm$ && childVNode.$elm$.nodeType === 3 /* NODE_TYPE.TextNode */ ) {
                    childVNode.$text$ = childVNode.$elm$.textContent;
                    childRenderNodes.push(childVNode);
                    // remove the text comment since it's no longer needed
                    node.remove();
                    if (!parentVNode.$children$) parentVNode.$children$ = [];
                    parentVNode.$children$[childVNode.$index$] = childVNode;
                    if (shadowRootNodes && childVNode.$depth$ === '0') shadowRootNodes[childVNode.$index$] = childVNode.$elm$;
                }
            } else if (childVNode.$hostId$ === hostId) {
                // this comment node is specifcally for this host id
                if (childNodeType === $47990066fdbc3144$var$SLOT_NODE_ID) {
                    // `${SLOT_NODE_ID}.${hostId}.${nodeId}.${depth}.${index}.${slotName}`;
                    childVNode.$tag$ = 'slot';
                    if (childIdSplt[5]) node['s-sn'] = childVNode.$name$ = childIdSplt[5];
                    else node['s-sn'] = '';
                    node['s-sr'] = true;
                    if ((0, $kxuSp.BUILD).shadowDom && shadowRootNodes) {
                        // browser support shadowRoot and this is a shadow dom component
                        // create an actual slot element
                        childVNode.$elm$ = $47990066fdbc3144$export$2a111da947c407d2.createElement(childVNode.$tag$);
                        if (childVNode.$name$) // add the slot name attribute
                        childVNode.$elm$.setAttribute('name', childVNode.$name$);
                        // insert the new slot element before the slot comment
                        node.parentNode.insertBefore(childVNode.$elm$, node);
                        // remove the slot comment since it's not needed for shadow
                        node.remove();
                        if (childVNode.$depth$ === '0') shadowRootNodes[childVNode.$index$] = childVNode.$elm$;
                    }
                    slotNodes.push(childVNode);
                    if (!parentVNode.$children$) parentVNode.$children$ = [];
                    parentVNode.$children$[childVNode.$index$] = childVNode;
                } else if (childNodeType === $47990066fdbc3144$var$CONTENT_REF_ID) {
                    // `${CONTENT_REF_ID}.${hostId}`;
                    if ((0, $kxuSp.BUILD).shadowDom && shadowRootNodes) // remove the content ref comment since it's not needed for shadow
                    node.remove();
                    else if ((0, $kxuSp.BUILD).slotRelocation) {
                        hostElm['s-cr'] = node;
                        node['s-cn'] = true;
                    }
                }
            }
        }
    } else if (parentVNode && parentVNode.$tag$ === 'style') {
        const vnode = $47990066fdbc3144$var$newVNode(null, node.textContent);
        vnode.$elm$ = node;
        vnode.$index$ = '0';
        parentVNode.$children$ = [
            vnode
        ];
    }
};
const $47990066fdbc3144$var$initializeDocumentHydrate = (node, orgLocNodes)=>{
    if (node.nodeType === 1 /* NODE_TYPE.ElementNode */ ) {
        let i = 0;
        for(; i < node.childNodes.length; i++)$47990066fdbc3144$var$initializeDocumentHydrate(node.childNodes[i], orgLocNodes);
        if (node.shadowRoot) for(i = 0; i < node.shadowRoot.childNodes.length; i++)$47990066fdbc3144$var$initializeDocumentHydrate(node.shadowRoot.childNodes[i], orgLocNodes);
    } else if (node.nodeType === 8 /* NODE_TYPE.CommentNode */ ) {
        const childIdSplt = node.nodeValue.split('.');
        if (childIdSplt[0] === $47990066fdbc3144$var$ORG_LOCATION_ID) {
            orgLocNodes.set(childIdSplt[1] + '.' + childIdSplt[2], node);
            node.nodeValue = '';
            // useful to know if the original location is
            // the root light-dom of a shadow dom component
            node['s-en'] = childIdSplt[3];
        }
    }
};
// Private
const $47990066fdbc3144$var$computeMode = (elm)=>$47990066fdbc3144$export$31c64a1f6cd0f6.map((h)=>h(elm)).find((m)=>!!m);
// Public
const $47990066fdbc3144$export$d4f039427a1beff1 = (handler)=>$47990066fdbc3144$export$31c64a1f6cd0f6.push(handler);
const $47990066fdbc3144$export$1fc0f6205829e19c = (ref)=>$47990066fdbc3144$export$3f84770eccf215d2(ref).$modeName$;
/**
 * Parse a new property value for a given property type.
 *
 * While the prop value can reasonably be expected to be of `any` type as far as TypeScript's type checker is concerned,
 * it is not safe to assume that the string returned by evaluating `typeof propValue` matches:
 *   1. `any`, the type given to `propValue` in the function signature
 *   2. the type stored from `propType`.
 *
 * This function provides the capability to parse/coerce a property's value to potentially any other JavaScript type.
 *
 * Property values represented in TSX preserve their type information. In the example below, the number 0 is passed to
 * a component. This `propValue` will preserve its type information (`typeof propValue === 'number'`). Note that is
 * based on the type of the value being passed in, not the type declared of the class member decorated with `@Prop`.
 * ```tsx
 * <my-cmp prop-val={0}></my-cmp>
 * ```
 *
 * HTML prop values on the other hand, will always a string
 *
 * @param propValue the new value to coerce to some type
 * @param propType the type of the prop, expressed as a binary number
 * @returns the parsed/coerced value
 */ const $47990066fdbc3144$export$480b8c8d1e35b434 = (propValue, propType)=>{
    // ensure this value is of the correct prop type
    if (propValue != null && !$47990066fdbc3144$var$isComplexType(propValue)) {
        if ((0, $kxuSp.BUILD).propBoolean && propType & 4 /* MEMBER_FLAGS.Boolean */ ) // per the HTML spec, any string value means it is a boolean true value
        // but we'll cheat here and say that the string "false" is the boolean false
        return propValue === 'false' ? false : propValue === '' || !!propValue;
        if ((0, $kxuSp.BUILD).propNumber && propType & 2 /* MEMBER_FLAGS.Number */ ) // force it to be a number
        return parseFloat(propValue);
        if ((0, $kxuSp.BUILD).propString && propType & 1 /* MEMBER_FLAGS.String */ ) // could have been passed as a number or boolean
        // but we still want it as a string
        return String(propValue);
        // redundant return here for better minification
        return propValue;
    }
    // not sure exactly what type we want
    // so no need to change to a different type
    return propValue;
};
const $47990066fdbc3144$export$d16800b7e59a8051 = (ref)=>(0, $kxuSp.BUILD).lazyLoad ? $47990066fdbc3144$export$3f84770eccf215d2(ref).$hostElement$ : ref;
const $47990066fdbc3144$export$c30017717ce2168e = (ref, name, flags)=>{
    const elm = $47990066fdbc3144$export$d16800b7e59a8051(ref);
    return {
        emit: (detail)=>{
            if ((0, $kxuSp.BUILD).isDev && !elm.isConnected) $47990066fdbc3144$export$5d385f3b3df7e1b9(`The "${name}" event was emitted, but the dispatcher node is no longer connected to the dom.`);
            return $47990066fdbc3144$var$emitEvent(elm, name, {
                bubbles: !!(flags & 4 /* EVENT_FLAGS.Bubbles */ ),
                composed: !!(flags & 2 /* EVENT_FLAGS.Composed */ ),
                cancelable: !!(flags & 1 /* EVENT_FLAGS.Cancellable */ ),
                detail: detail
            });
        }
    };
};
/**
 * Helper function to create & dispatch a custom Event on a provided target
 * @param elm the target of the Event
 * @param name the name to give the custom Event
 * @param opts options for configuring a custom Event
 * @returns the custom Event
 */ const $47990066fdbc3144$var$emitEvent = (elm, name, opts)=>{
    const ev = $47990066fdbc3144$export$2e40610e9d23bca6.ce(name, opts);
    elm.dispatchEvent(ev);
    return ev;
};
const $47990066fdbc3144$var$rootAppliedStyles = /*@__PURE__*/ new WeakMap();
const $47990066fdbc3144$var$registerStyle = (scopeId, cssText, allowCS)=>{
    let style = $47990066fdbc3144$export$9dd6ff9ea0189349.get(scopeId);
    if ($47990066fdbc3144$export$27b311cd1cb97100 && allowCS) {
        style = style || new CSSStyleSheet();
        if (typeof style === 'string') style = cssText;
        else style.replaceSync(cssText);
    } else style = cssText;
    $47990066fdbc3144$export$9dd6ff9ea0189349.set(scopeId, style);
};
const $47990066fdbc3144$var$addStyle = (styleContainerNode, cmpMeta, mode, hostElm)=>{
    var _a;
    let scopeId = $47990066fdbc3144$var$getScopeId(cmpMeta, mode);
    const style = $47990066fdbc3144$export$9dd6ff9ea0189349.get(scopeId);
    if (!(0, $kxuSp.BUILD).attachStyles) return scopeId;
    // if an element is NOT connected then getRootNode() will return the wrong root node
    // so the fallback is to always use the document for the root node in those cases
    styleContainerNode = styleContainerNode.nodeType === 11 /* NODE_TYPE.DocumentFragment */  ? styleContainerNode : $47990066fdbc3144$export$2a111da947c407d2;
    if (style) {
        if (typeof style === 'string') {
            styleContainerNode = styleContainerNode.head || styleContainerNode;
            let appliedStyles = $47990066fdbc3144$var$rootAppliedStyles.get(styleContainerNode);
            let styleElm;
            if (!appliedStyles) $47990066fdbc3144$var$rootAppliedStyles.set(styleContainerNode, appliedStyles = new Set());
            if (!appliedStyles.has(scopeId)) {
                if ((0, $kxuSp.BUILD).hydrateClientSide && styleContainerNode.host && (styleElm = styleContainerNode.querySelector(`[${$47990066fdbc3144$var$HYDRATED_STYLE_ID}="${scopeId}"]`))) // This is only happening on native shadow-dom, do not needs CSS var shim
                styleElm.innerHTML = style;
                else {
                    if ((0, $kxuSp.BUILD).cssVarShim && $47990066fdbc3144$export$2e40610e9d23bca6.$cssShim$) {
                        styleElm = $47990066fdbc3144$export$2e40610e9d23bca6.$cssShim$.createHostStyle(hostElm, scopeId, style, !!(cmpMeta.$flags$ & 10 /* CMP_FLAGS.needsScopedEncapsulation */ ));
                        const newScopeId = styleElm['s-sc'];
                        if (newScopeId) {
                            scopeId = newScopeId;
                            // we don't want to add this styleID to the appliedStyles Set
                            // since the cssVarShim might need to apply several different
                            // stylesheets for the same component
                            appliedStyles = null;
                        }
                    } else {
                        styleElm = $47990066fdbc3144$export$2a111da947c407d2.createElement('style');
                        styleElm.innerHTML = style;
                    }
                    // Apply CSP nonce to the style tag if it exists
                    const nonce = (_a = $47990066fdbc3144$export$2e40610e9d23bca6.$nonce$) !== null && _a !== void 0 ? _a : $47990066fdbc3144$var$queryNonceMetaTagContent($47990066fdbc3144$export$2a111da947c407d2);
                    if (nonce != null) styleElm.setAttribute('nonce', nonce);
                    if ((0, $kxuSp.BUILD).hydrateServerSide || (0, $kxuSp.BUILD).hotModuleReplacement) styleElm.setAttribute($47990066fdbc3144$var$HYDRATED_STYLE_ID, scopeId);
                    styleContainerNode.insertBefore(styleElm, styleContainerNode.querySelector('link'));
                }
                if (appliedStyles) appliedStyles.add(scopeId);
            }
        } else if ((0, $kxuSp.BUILD).constructableCSS && !styleContainerNode.adoptedStyleSheets.includes(style)) styleContainerNode.adoptedStyleSheets = [
            ...styleContainerNode.adoptedStyleSheets,
            style
        ];
    }
    return scopeId;
};
const $47990066fdbc3144$var$attachStyles = (hostRef)=>{
    const cmpMeta = hostRef.$cmpMeta$;
    const elm = hostRef.$hostElement$;
    const flags = cmpMeta.$flags$;
    const endAttachStyles = $47990066fdbc3144$var$createTime('attachStyles', cmpMeta.$tagName$);
    const scopeId = $47990066fdbc3144$var$addStyle((0, $kxuSp.BUILD).shadowDom && $47990066fdbc3144$export$b4e7e6d61dbcd813 && elm.shadowRoot ? elm.shadowRoot : elm.getRootNode(), cmpMeta, hostRef.$modeName$, elm);
    if (((0, $kxuSp.BUILD).shadowDom || (0, $kxuSp.BUILD).scoped) && (0, $kxuSp.BUILD).cssAnnotations && flags & 10 /* CMP_FLAGS.needsScopedEncapsulation */ ) {
        // only required when we're NOT using native shadow dom (slot)
        // or this browser doesn't support native shadow dom
        // and this host element was NOT created with SSR
        // let's pick out the inner content for slot projection
        // create a node to represent where the original
        // content was first placed, which is useful later on
        // DOM WRITE!!
        elm['s-sc'] = scopeId;
        elm.classList.add(scopeId + '-h');
        if ((0, $kxuSp.BUILD).scoped && flags & 2 /* CMP_FLAGS.scopedCssEncapsulation */ ) elm.classList.add(scopeId + '-s');
    }
    endAttachStyles();
};
const $47990066fdbc3144$var$getScopeId = (cmp, mode)=>'sc-' + ((0, $kxuSp.BUILD).mode && mode && cmp.$flags$ & 32 /* CMP_FLAGS.hasMode */  ? cmp.$tagName$ + '-' + mode : cmp.$tagName$);
const $47990066fdbc3144$var$convertScopedToShadow = (css)=>css.replace(/\/\*!@([^\/]+)\*\/[^\{]+\{/g, '$1{');
/**
 * Production setAccessor() function based on Preact by
 * Jason Miller (@developit)
 * Licensed under the MIT License
 * https://github.com/developit/preact/blob/master/LICENSE
 *
 * Modified for Stencil's compiler and vdom
 */ const $47990066fdbc3144$var$setAccessor = (elm, memberName, oldValue, newValue, isSvg, flags)=>{
    if (oldValue !== newValue) {
        let isProp = $47990066fdbc3144$export$304efeaa4c96d4e9(elm, memberName);
        let ln = memberName.toLowerCase();
        if ((0, $kxuSp.BUILD).vdomClass && memberName === 'class') {
            const classList = elm.classList;
            const oldClasses = $47990066fdbc3144$var$parseClassList(oldValue);
            const newClasses = $47990066fdbc3144$var$parseClassList(newValue);
            classList.remove(...oldClasses.filter((c)=>c && !newClasses.includes(c)));
            classList.add(...newClasses.filter((c)=>c && !oldClasses.includes(c)));
        } else if ((0, $kxuSp.BUILD).vdomStyle && memberName === 'style') {
            // update style attribute, css properties and values
            if ((0, $kxuSp.BUILD).updatable) {
                for(const prop in oldValue)if (!newValue || newValue[prop] == null) {
                    if (!(0, $kxuSp.BUILD).hydrateServerSide && prop.includes('-')) elm.style.removeProperty(prop);
                    else elm.style[prop] = '';
                }
            }
            for(const prop in newValue)if (!oldValue || newValue[prop] !== oldValue[prop]) {
                if (!(0, $kxuSp.BUILD).hydrateServerSide && prop.includes('-')) elm.style.setProperty(prop, newValue[prop]);
                else elm.style[prop] = newValue[prop];
            }
        } else if ((0, $kxuSp.BUILD).vdomKey && memberName === 'key') ;
        else if ((0, $kxuSp.BUILD).vdomRef && memberName === 'ref') // minifier will clean this up
        {
            if (newValue) newValue(elm);
        } else if ((0, $kxuSp.BUILD).vdomListener && ((0, $kxuSp.BUILD).lazyLoad ? !isProp : !elm.__lookupSetter__(memberName)) && memberName[0] === 'o' && memberName[1] === 'n') {
            // Event Handlers
            // so if the member name starts with "on" and the 3rd characters is
            // a capital letter, and it's not already a member on the element,
            // then we're assuming it's an event listener
            if (memberName[2] === '-') // on- prefixed events
            // allows to be explicit about the dom event to listen without any magic
            // under the hood:
            // <my-cmp on-click> // listens for "click"
            // <my-cmp on-Click> // listens for "Click"
            // <my-cmp on-ionChange> // listens for "ionChange"
            // <my-cmp on-EVENTS> // listens for "EVENTS"
            memberName = memberName.slice(3);
            else if ($47990066fdbc3144$export$304efeaa4c96d4e9($47990066fdbc3144$export$10a0f131c0eea21b, ln)) // standard event
            // the JSX attribute could have been "onMouseOver" and the
            // member name "onmouseover" is on the window's prototype
            // so let's add the listener "mouseover", which is all lowercased
            memberName = ln.slice(2);
            else // custom event
            // the JSX attribute could have been "onMyCustomEvent"
            // so let's trim off the "on" prefix and lowercase the first character
            // and add the listener "myCustomEvent"
            // except for the first character, we keep the event name case
            memberName = ln[2] + memberName.slice(3);
            if (oldValue) $47990066fdbc3144$export$2e40610e9d23bca6.rel(elm, memberName, oldValue, false);
            if (newValue) $47990066fdbc3144$export$2e40610e9d23bca6.ael(elm, memberName, newValue, false);
        } else if ((0, $kxuSp.BUILD).vdomPropOrAttr) {
            // Set property if it exists and it's not a SVG
            const isComplex = $47990066fdbc3144$var$isComplexType(newValue);
            if ((isProp || isComplex && newValue !== null) && !isSvg) try {
                if (!elm.tagName.includes('-')) {
                    const n = newValue == null ? '' : newValue;
                    // Workaround for Safari, moving the <input> caret when re-assigning the same valued
                    if (memberName === 'list') isProp = false;
                    else if (oldValue == null || elm[memberName] != n) elm[memberName] = n;
                } else elm[memberName] = newValue;
            } catch (e) {}
            /**
             * Need to manually update attribute if:
             * - memberName is not an attribute
             * - if we are rendering the host element in order to reflect attribute
             * - if it's a SVG, since properties might not work in <svg>
             * - if the newValue is null/undefined or 'false'.
             */ let xlink = false;
            if ((0, $kxuSp.BUILD).vdomXlink) {
                if (ln !== (ln = ln.replace(/^xlink\:?/, ''))) {
                    memberName = ln;
                    xlink = true;
                }
            }
            if (newValue == null || newValue === false) {
                if (newValue !== false || elm.getAttribute(memberName) === '') {
                    if ((0, $kxuSp.BUILD).vdomXlink && xlink) elm.removeAttributeNS($47990066fdbc3144$var$XLINK_NS, memberName);
                    else elm.removeAttribute(memberName);
                }
            } else if ((!isProp || flags & 4 /* VNODE_FLAGS.isHost */  || isSvg) && !isComplex) {
                newValue = newValue === true ? '' : newValue;
                if ((0, $kxuSp.BUILD).vdomXlink && xlink) elm.setAttributeNS($47990066fdbc3144$var$XLINK_NS, memberName, newValue);
                else elm.setAttribute(memberName, newValue);
            }
        }
    }
};
const $47990066fdbc3144$var$parseClassListRegex = /\s/;
const $47990066fdbc3144$var$parseClassList = (value)=>!value ? [] : value.split($47990066fdbc3144$var$parseClassListRegex);
const $47990066fdbc3144$var$updateElement = (oldVnode, newVnode, isSvgMode, memberName)=>{
    // if the element passed in is a shadow root, which is a document fragment
    // then we want to be adding attrs/props to the shadow root's "host" element
    // if it's not a shadow root, then we add attrs/props to the same element
    const elm = newVnode.$elm$.nodeType === 11 /* NODE_TYPE.DocumentFragment */  && newVnode.$elm$.host ? newVnode.$elm$.host : newVnode.$elm$;
    const oldVnodeAttrs = oldVnode && oldVnode.$attrs$ || $47990066fdbc3144$var$EMPTY_OBJ;
    const newVnodeAttrs = newVnode.$attrs$ || $47990066fdbc3144$var$EMPTY_OBJ;
    if ((0, $kxuSp.BUILD).updatable) {
        // remove attributes no longer present on the vnode by setting them to undefined
        for(memberName in oldVnodeAttrs)if (!(memberName in newVnodeAttrs)) $47990066fdbc3144$var$setAccessor(elm, memberName, oldVnodeAttrs[memberName], undefined, isSvgMode, newVnode.$flags$);
    }
    // add new & update changed attributes
    for(memberName in newVnodeAttrs)$47990066fdbc3144$var$setAccessor(elm, memberName, oldVnodeAttrs[memberName], newVnodeAttrs[memberName], isSvgMode, newVnode.$flags$);
};
/**
 * Create a DOM Node corresponding to one of the children of a given VNode.
 *
 * @param oldParentVNode the parent VNode from the previous render
 * @param newParentVNode the parent VNode from the current render
 * @param childIndex the index of the VNode, in the _new_ parent node's
 * children, for which we will create a new DOM node
 * @param parentElm the parent DOM node which our new node will be a child of
 * @returns the newly created node
 */ const $47990066fdbc3144$var$createElm = (oldParentVNode, newParentVNode, childIndex, parentElm)=>{
    // tslint:disable-next-line: prefer-const
    const newVNode = newParentVNode.$children$[childIndex];
    let i = 0;
    let elm;
    let childNode;
    let oldVNode;
    if ((0, $kxuSp.BUILD).slotRelocation && !$47990066fdbc3144$var$useNativeShadowDom) {
        // remember for later we need to check to relocate nodes
        $47990066fdbc3144$var$checkSlotRelocate = true;
        if (newVNode.$tag$ === 'slot') {
            if ($47990066fdbc3144$var$scopeId) // scoped css needs to add its scoped id to the parent element
            parentElm.classList.add($47990066fdbc3144$var$scopeId + '-s');
            newVNode.$flags$ |= newVNode.$children$ ? 2 /* VNODE_FLAGS.isSlotFallback */  : 1 /* VNODE_FLAGS.isSlotReference */ ;
        }
    }
    if ((0, $kxuSp.BUILD).isDev && newVNode.$elm$) $47990066fdbc3144$export$47b52a6e53fbbc24(`The JSX ${newVNode.$text$ !== null ? `"${newVNode.$text$}" text` : `"${newVNode.$tag$}" element`} node should not be shared within the same renderer. The renderer caches element lookups in order to improve performance. However, a side effect from this is that the exact same JSX node should not be reused. For more information please see https://stenciljs.com/docs/templating-jsx#avoid-shared-jsx-nodes`);
    if ((0, $kxuSp.BUILD).vdomText && newVNode.$text$ !== null) // create text node
    elm = newVNode.$elm$ = $47990066fdbc3144$export$2a111da947c407d2.createTextNode(newVNode.$text$);
    else if ((0, $kxuSp.BUILD).slotRelocation && newVNode.$flags$ & 1 /* VNODE_FLAGS.isSlotReference */ ) // create a slot reference node
    elm = newVNode.$elm$ = (0, $kxuSp.BUILD).isDebug || (0, $kxuSp.BUILD).hydrateServerSide ? $47990066fdbc3144$var$slotReferenceDebugNode(newVNode) : $47990066fdbc3144$export$2a111da947c407d2.createTextNode('');
    else {
        if ((0, $kxuSp.BUILD).svg && !$47990066fdbc3144$var$isSvgMode) $47990066fdbc3144$var$isSvgMode = newVNode.$tag$ === 'svg';
        // create element
        elm = newVNode.$elm$ = (0, $kxuSp.BUILD).svg ? $47990066fdbc3144$export$2a111da947c407d2.createElementNS($47990066fdbc3144$var$isSvgMode ? $47990066fdbc3144$var$SVG_NS : $47990066fdbc3144$var$HTML_NS, (0, $kxuSp.BUILD).slotRelocation && newVNode.$flags$ & 2 /* VNODE_FLAGS.isSlotFallback */  ? 'slot-fb' : newVNode.$tag$) : $47990066fdbc3144$export$2a111da947c407d2.createElement((0, $kxuSp.BUILD).slotRelocation && newVNode.$flags$ & 2 /* VNODE_FLAGS.isSlotFallback */  ? 'slot-fb' : newVNode.$tag$);
        if ((0, $kxuSp.BUILD).svg && $47990066fdbc3144$var$isSvgMode && newVNode.$tag$ === 'foreignObject') $47990066fdbc3144$var$isSvgMode = false;
        // add css classes, attrs, props, listeners, etc.
        if ((0, $kxuSp.BUILD).vdomAttribute) $47990066fdbc3144$var$updateElement(null, newVNode, $47990066fdbc3144$var$isSvgMode);
        if (((0, $kxuSp.BUILD).shadowDom || (0, $kxuSp.BUILD).scoped) && $47990066fdbc3144$var$isDef($47990066fdbc3144$var$scopeId) && elm['s-si'] !== $47990066fdbc3144$var$scopeId) // if there is a scopeId and this is the initial render
        // then let's add the scopeId as a css class
        elm.classList.add(elm['s-si'] = $47990066fdbc3144$var$scopeId);
        if (newVNode.$children$) for(i = 0; i < newVNode.$children$.length; ++i){
            // create the node
            childNode = $47990066fdbc3144$var$createElm(oldParentVNode, newVNode, i, elm);
            // return node could have been null
            if (childNode) // append our new node
            elm.appendChild(childNode);
        }
        if ((0, $kxuSp.BUILD).svg) {
            if (newVNode.$tag$ === 'svg') // Only reset the SVG context when we're exiting <svg> element
            $47990066fdbc3144$var$isSvgMode = false;
            else if (elm.tagName === 'foreignObject') // Reenter SVG context when we're exiting <foreignObject> element
            $47990066fdbc3144$var$isSvgMode = true;
        }
    }
    if ((0, $kxuSp.BUILD).slotRelocation) {
        elm['s-hn'] = $47990066fdbc3144$var$hostTagName;
        if (newVNode.$flags$ & 3 /* VNODE_FLAGS.isSlotReference */ ) {
            // remember the content reference comment
            elm['s-sr'] = true;
            // remember the content reference comment
            elm['s-cr'] = $47990066fdbc3144$var$contentRef;
            // remember the slot name, or empty string for default slot
            elm['s-sn'] = newVNode.$name$ || '';
            // check if we've got an old vnode for this slot
            oldVNode = oldParentVNode && oldParentVNode.$children$ && oldParentVNode.$children$[childIndex];
            if (oldVNode && oldVNode.$tag$ === newVNode.$tag$ && oldParentVNode.$elm$) // we've got an old slot vnode and the wrapper is being replaced
            // so let's move the old slot content back to it's original location
            $47990066fdbc3144$var$putBackInOriginalLocation(oldParentVNode.$elm$, false);
        }
    }
    return elm;
};
const $47990066fdbc3144$var$putBackInOriginalLocation = (parentElm, recursive)=>{
    $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 1 /* PLATFORM_FLAGS.isTmpDisconnected */ ;
    const oldSlotChildNodes = parentElm.childNodes;
    for(let i = oldSlotChildNodes.length - 1; i >= 0; i--){
        const childNode = oldSlotChildNodes[i];
        if (childNode['s-hn'] !== $47990066fdbc3144$var$hostTagName && childNode['s-ol']) {
            // // this child node in the old element is from another component
            // // remove this node from the old slot's parent
            // childNode.remove();
            // and relocate it back to it's original location
            $47990066fdbc3144$var$parentReferenceNode(childNode).insertBefore(childNode, $47990066fdbc3144$var$referenceNode(childNode));
            // remove the old original location comment entirely
            // later on the patch function will know what to do
            // and move this to the correct spot in need be
            childNode['s-ol'].remove();
            childNode['s-ol'] = undefined;
            $47990066fdbc3144$var$checkSlotRelocate = true;
        }
        if (recursive) $47990066fdbc3144$var$putBackInOriginalLocation(childNode, recursive);
    }
    $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ &= -2 /* PLATFORM_FLAGS.isTmpDisconnected */ ;
};
/**
 * Create DOM nodes corresponding to a list of {@link d.Vnode} objects and
 * add them to the DOM in the appropriate place.
 *
 * @param parentElm the DOM node which should be used as a parent for the new
 * DOM nodes
 * @param before a child of the `parentElm` which the new children should be
 * inserted before (optional)
 * @param parentVNode the parent virtual DOM node
 * @param vnodes the new child virtual DOM nodes to produce DOM nodes for
 * @param startIdx the index in the child virtual DOM nodes at which to start
 * creating DOM nodes (inclusive)
 * @param endIdx the index in the child virtual DOM nodes at which to stop
 * creating DOM nodes (inclusive)
 */ const $47990066fdbc3144$var$addVnodes = (parentElm, before, parentVNode, vnodes, startIdx, endIdx)=>{
    let containerElm = (0, $kxuSp.BUILD).slotRelocation && parentElm['s-cr'] && parentElm['s-cr'].parentNode || parentElm;
    let childNode;
    if ((0, $kxuSp.BUILD).shadowDom && containerElm.shadowRoot && containerElm.tagName === $47990066fdbc3144$var$hostTagName) containerElm = containerElm.shadowRoot;
    for(; startIdx <= endIdx; ++startIdx)if (vnodes[startIdx]) {
        childNode = $47990066fdbc3144$var$createElm(null, parentVNode, startIdx, parentElm);
        if (childNode) {
            vnodes[startIdx].$elm$ = childNode;
            containerElm.insertBefore(childNode, (0, $kxuSp.BUILD).slotRelocation ? $47990066fdbc3144$var$referenceNode(before) : before);
        }
    }
};
/**
 * Remove the DOM elements corresponding to a list of {@link d.VNode} objects.
 * This can be used to, for instance, clean up after a list of children which
 * should no longer be shown.
 *
 * This function also handles some of Stencil's slot relocation logic.
 *
 * @param vnodes a list of virtual DOM nodes to remove
 * @param startIdx the index at which to start removing nodes (inclusive)
 * @param endIdx the index at which to stop removing nodes (inclusive)
 * @param vnode a VNode
 * @param elm an element
 */ const $47990066fdbc3144$var$removeVnodes = (vnodes, startIdx, endIdx, vnode, elm)=>{
    for(; startIdx <= endIdx; ++startIdx)if (vnode = vnodes[startIdx]) {
        elm = vnode.$elm$;
        $47990066fdbc3144$var$callNodeRefs(vnode);
        if ((0, $kxuSp.BUILD).slotRelocation) {
            // we're removing this element
            // so it's possible we need to show slot fallback content now
            $47990066fdbc3144$var$checkSlotFallbackVisibility = true;
            if (elm['s-ol']) // remove the original location comment
            elm['s-ol'].remove();
            else // it's possible that child nodes of the node
            // that's being removed are slot nodes
            $47990066fdbc3144$var$putBackInOriginalLocation(elm, true);
        }
        // remove the vnode's element from the dom
        elm.remove();
    }
};
/**
 * Reconcile the children of a new VNode with the children of an old VNode by
 * traversing the two collections of children, identifying nodes that are
 * conserved or changed, calling out to `patch` to make any necessary
 * updates to the DOM, and rearranging DOM nodes as needed.
 *
 * The algorithm for reconciling children works by analyzing two 'windows' onto
 * the two arrays of children (`oldCh` and `newCh`). We keep track of the
 * 'windows' by storing start and end indices and references to the
 * corresponding array entries. Initially the two 'windows' are basically equal
 * to the entire array, but we progressively narrow the windows until there are
 * no children left to update by doing the following:
 *
 * 1. Skip any `null` entries at the beginning or end of the two arrays, so
 *    that if we have an initial array like the following we'll end up dealing
 *    only with a window bounded by the highlighted elements:
 *
 *    [null, null, VNode1 , ... , VNode2, null, null]
 *                 ^^^^^^         ^^^^^^
 *
 * 2. Check to see if the elements at the head and tail positions are equal
 *    across the windows. This will basically detect elements which haven't
 *    been added, removed, or changed position, i.e. if you had the following
 *    VNode elements (represented as HTML):
 *
 *    oldVNode: `<div><p><span>HEY</span></p></div>`
 *    newVNode: `<div><p><span>THERE</span></p></div>`
 *
 *    Then when comparing the children of the `<div>` tag we check the equality
 *    of the VNodes corresponding to the `<p>` tags and, since they are the
 *    same tag in the same position, we'd be able to avoid completely
 *    re-rendering the subtree under them with a new DOM element and would just
 *    call out to `patch` to handle reconciling their children and so on.
 *
 * 3. Check, for both windows, to see if the element at the beginning of the
 *    window corresponds to the element at the end of the other window. This is
 *    a heuristic which will let us identify _some_ situations in which
 *    elements have changed position, for instance it _should_ detect that the
 *    children nodes themselves have not changed but merely moved in the
 *    following example:
 *
 *    oldVNode: `<div><element-one /><element-two /></div>`
 *    newVNode: `<div><element-two /><element-one /></div>`
 *
 *    If we find cases like this then we also need to move the concrete DOM
 *    elements corresponding to the moved children to write the re-order to the
 *    DOM.
 *
 * 4. Finally, if VNodes have the `key` attribute set on them we check for any
 *    nodes in the old children which have the same key as the first element in
 *    our window on the new children. If we find such a node we handle calling
 *    out to `patch`, moving relevant DOM nodes, and so on, in accordance with
 *    what we find.
 *
 * Finally, once we've narrowed our 'windows' to the point that either of them
 * collapse (i.e. they have length 0) we then handle any remaining VNode
 * insertion or deletion that needs to happen to get a DOM state that correctly
 * reflects the new child VNodes. If, for instance, after our window on the old
 * children has collapsed we still have more nodes on the new children that
 * we haven't dealt with yet then we need to add them, or if the new children
 * collapse but we still have unhandled _old_ children then we need to make
 * sure the corresponding DOM nodes are removed.
 *
 * @param parentElm the node into which the parent VNode is rendered
 * @param oldCh the old children of the parent node
 * @param newVNode the new VNode which will replace the parent
 * @param newCh the new children of the parent node
 */ const $47990066fdbc3144$var$updateChildren = (parentElm, oldCh, newVNode, newCh)=>{
    let oldStartIdx = 0;
    let newStartIdx = 0;
    let idxInOld = 0;
    let i = 0;
    let oldEndIdx = oldCh.length - 1;
    let oldStartVnode = oldCh[0];
    let oldEndVnode = oldCh[oldEndIdx];
    let newEndIdx = newCh.length - 1;
    let newStartVnode = newCh[0];
    let newEndVnode = newCh[newEndIdx];
    let node;
    let elmToMove;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) // VNode might have been moved left
        oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($47990066fdbc3144$var$isSameVnode(oldStartVnode, newStartVnode)) {
            // if the start nodes are the same then we should patch the new VNode
            // onto the old one, and increment our `newStartIdx` and `oldStartIdx`
            // indices to reflect that. We don't need to move any DOM Nodes around
            // since things are matched up in order.
            $47990066fdbc3144$var$patch(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($47990066fdbc3144$var$isSameVnode(oldEndVnode, newEndVnode)) {
            // likewise, if the end nodes are the same we patch new onto old and
            // decrement our end indices, and also likewise in this case we don't
            // need to move any DOM Nodes.
            $47990066fdbc3144$var$patch(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($47990066fdbc3144$var$isSameVnode(oldStartVnode, newEndVnode)) {
            // case: "Vnode moved right"
            //
            // We've found that the last node in our window on the new children is
            // the same VNode as the _first_ node in our window on the old children
            // we're dealing with now. Visually, this is the layout of these two
            // nodes:
            //
            // newCh: [..., newStartVnode , ... , newEndVnode , ...]
            //                                    ^^^^^^^^^^^
            // oldCh: [..., oldStartVnode , ... , oldEndVnode , ...]
            //              ^^^^^^^^^^^^^
            //
            // In this situation we need to patch `newEndVnode` onto `oldStartVnode`
            // and move the DOM element for `oldStartVnode`.
            if ((0, $kxuSp.BUILD).slotRelocation && (oldStartVnode.$tag$ === 'slot' || newEndVnode.$tag$ === 'slot')) $47990066fdbc3144$var$putBackInOriginalLocation(oldStartVnode.$elm$.parentNode, false);
            $47990066fdbc3144$var$patch(oldStartVnode, newEndVnode);
            // We need to move the element for `oldStartVnode` into a position which
            // will be appropriate for `newEndVnode`. For this we can use
            // `.insertBefore` and `oldEndVnode.$elm$.nextSibling`. If there is a
            // sibling for `oldEndVnode.$elm$` then we want to move the DOM node for
            // `oldStartVnode` between `oldEndVnode` and it's sibling, like so:
            //
            // <old-start-node />
            // <some-intervening-node />
            // <old-end-node />
            // <!-- ->              <-- `oldStartVnode.$elm$` should be inserted here
            // <next-sibling />
            //
            // If instead `oldEndVnode.$elm$` has no sibling then we just want to put
            // the node for `oldStartVnode` at the end of the children of
            // `parentElm`. Luckily, `Node.nextSibling` will return `null` if there
            // aren't any siblings, and passing `null` to `Node.insertBefore` will
            // append it to the children of the parent element.
            parentElm.insertBefore(oldStartVnode.$elm$, oldEndVnode.$elm$.nextSibling);
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($47990066fdbc3144$var$isSameVnode(oldEndVnode, newStartVnode)) {
            // case: "Vnode moved left"
            //
            // We've found that the first node in our window on the new children is
            // the same VNode as the _last_ node in our window on the old children.
            // Visually, this is the layout of these two nodes:
            //
            // newCh: [..., newStartVnode , ... , newEndVnode , ...]
            //              ^^^^^^^^^^^^^
            // oldCh: [..., oldStartVnode , ... , oldEndVnode , ...]
            //                                    ^^^^^^^^^^^
            //
            // In this situation we need to patch `newStartVnode` onto `oldEndVnode`
            // (which will handle updating any changed attributes, reconciling their
            // children etc) but we also need to move the DOM node to which
            // `oldEndVnode` corresponds.
            if ((0, $kxuSp.BUILD).slotRelocation && (oldStartVnode.$tag$ === 'slot' || newEndVnode.$tag$ === 'slot')) $47990066fdbc3144$var$putBackInOriginalLocation(oldEndVnode.$elm$.parentNode, false);
            $47990066fdbc3144$var$patch(oldEndVnode, newStartVnode);
            // We've already checked above if `oldStartVnode` and `newStartVnode` are
            // the same node, so since we're here we know that they are not. Thus we
            // can move the element for `oldEndVnode` _before_ the element for
            // `oldStartVnode`, leaving `oldStartVnode` to be reconciled in the
            // future.
            parentElm.insertBefore(oldEndVnode.$elm$, oldStartVnode.$elm$);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            // Here we do some checks to match up old and new nodes based on the
            // `$key$` attribute, which is set by putting a `key="my-key"` attribute
            // in the JSX for a DOM element in the implementation of a Stencil
            // component.
            //
            // First we check to see if there are any nodes in the array of old
            // children which have the same key as the first node in the new
            // children.
            idxInOld = -1;
            if ((0, $kxuSp.BUILD).vdomKey) {
                for(i = oldStartIdx; i <= oldEndIdx; ++i)if (oldCh[i] && oldCh[i].$key$ !== null && oldCh[i].$key$ === newStartVnode.$key$) {
                    idxInOld = i;
                    break;
                }
            }
            if ((0, $kxuSp.BUILD).vdomKey && idxInOld >= 0) {
                // We found a node in the old children which matches up with the first
                // node in the new children! So let's deal with that
                elmToMove = oldCh[idxInOld];
                if (elmToMove.$tag$ !== newStartVnode.$tag$) // the tag doesn't match so we'll need a new DOM element
                node = $47990066fdbc3144$var$createElm(oldCh && oldCh[newStartIdx], newVNode, idxInOld, parentElm);
                else {
                    $47990066fdbc3144$var$patch(elmToMove, newStartVnode);
                    // invalidate the matching old node so that we won't try to update it
                    // again later on
                    oldCh[idxInOld] = undefined;
                    node = elmToMove.$elm$;
                }
                newStartVnode = newCh[++newStartIdx];
            } else {
                // We either didn't find an element in the old children that matches
                // the key of the first new child OR the build is not using `key`
                // attributes at all. In either case we need to create a new element
                // for the new node.
                node = $47990066fdbc3144$var$createElm(oldCh && oldCh[newStartIdx], newVNode, newStartIdx, parentElm);
                newStartVnode = newCh[++newStartIdx];
            }
            if (node) {
                // if we created a new node then handle inserting it to the DOM
                if ((0, $kxuSp.BUILD).slotRelocation) $47990066fdbc3144$var$parentReferenceNode(oldStartVnode.$elm$).insertBefore(node, $47990066fdbc3144$var$referenceNode(oldStartVnode.$elm$));
                else oldStartVnode.$elm$.parentNode.insertBefore(node, oldStartVnode.$elm$);
            }
        }
    }
    if (oldStartIdx > oldEndIdx) // we have some more new nodes to add which don't match up with old nodes
    $47990066fdbc3144$var$addVnodes(parentElm, newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].$elm$, newVNode, newCh, newStartIdx, newEndIdx);
    else if ((0, $kxuSp.BUILD).updatable && newStartIdx > newEndIdx) // there are nodes in the `oldCh` array which no longer correspond to nodes
    // in the new array, so lets remove them (which entails cleaning up the
    // relevant DOM nodes)
    $47990066fdbc3144$var$removeVnodes(oldCh, oldStartIdx, oldEndIdx);
};
/**
 * Compare two VNodes to determine if they are the same
 *
 * **NB**: This function is an equality _heuristic_ based on the available
 * information set on the two VNodes and can be misleading under certain
 * circumstances. In particular, if the two nodes do not have `key` attrs
 * (available under `$key$` on VNodes) then the function falls back on merely
 * checking that they have the same tag.
 *
 * So, in other words, if `key` attrs are not set on VNodes which may be
 * changing order within a `children` array or something along those lines then
 * we could obtain a false negative and then have to do needless re-rendering
 * (i.e. we'd say two VNodes aren't equal when in fact they should be).
 *
 * @param leftVNode the first VNode to check
 * @param rightVNode the second VNode to check
 * @returns whether they're equal or not
 */ const $47990066fdbc3144$var$isSameVnode = (leftVNode, rightVNode)=>{
    // compare if two vnode to see if they're "technically" the same
    // need to have the same element tag, and same key to be the same
    if (leftVNode.$tag$ === rightVNode.$tag$) {
        if ((0, $kxuSp.BUILD).slotRelocation && leftVNode.$tag$ === 'slot') return leftVNode.$name$ === rightVNode.$name$;
        // this will be set if components in the build have `key` attrs set on them
        if ((0, $kxuSp.BUILD).vdomKey) return leftVNode.$key$ === rightVNode.$key$;
        return true;
    }
    return false;
};
const $47990066fdbc3144$var$referenceNode = (node)=>{
    // this node was relocated to a new location in the dom
    // because of some other component's slot
    // but we still have an html comment in place of where
    // it's original location was according to it's original vdom
    return node && node['s-ol'] || node;
};
const $47990066fdbc3144$var$parentReferenceNode = (node)=>(node['s-ol'] ? node['s-ol'] : node).parentNode;
/**
 * Handle reconciling an outdated VNode with a new one which corresponds to
 * it. This function handles flushing updates to the DOM and reconciling the
 * children of the two nodes (if any).
 *
 * @param oldVNode an old VNode whose DOM element and children we want to update
 * @param newVNode a new VNode representing an updated version of the old one
 */ const $47990066fdbc3144$var$patch = (oldVNode, newVNode)=>{
    const elm = newVNode.$elm$ = oldVNode.$elm$;
    const oldChildren = oldVNode.$children$;
    const newChildren = newVNode.$children$;
    const tag = newVNode.$tag$;
    const text = newVNode.$text$;
    let defaultHolder;
    if (!(0, $kxuSp.BUILD).vdomText || text === null) {
        if ((0, $kxuSp.BUILD).svg) // test if we're rendering an svg element, or still rendering nodes inside of one
        // only add this to the when the compiler sees we're using an svg somewhere
        $47990066fdbc3144$var$isSvgMode = tag === 'svg' ? true : tag === 'foreignObject' ? false : $47990066fdbc3144$var$isSvgMode;
        if ((0, $kxuSp.BUILD).vdomAttribute || (0, $kxuSp.BUILD).reflect) {
            if ((0, $kxuSp.BUILD).slot && tag === 'slot') ;
            else // either this is the first render of an element OR it's an update
            // AND we already know it's possible it could have changed
            // this updates the element's css classes, attrs, props, listeners, etc.
            $47990066fdbc3144$var$updateElement(oldVNode, newVNode, $47990066fdbc3144$var$isSvgMode);
        }
        if ((0, $kxuSp.BUILD).updatable && oldChildren !== null && newChildren !== null) // looks like there's child vnodes for both the old and new vnodes
        // so we need to call `updateChildren` to reconcile them
        $47990066fdbc3144$var$updateChildren(elm, oldChildren, newVNode, newChildren);
        else if (newChildren !== null) {
            // no old child vnodes, but there are new child vnodes to add
            if ((0, $kxuSp.BUILD).updatable && (0, $kxuSp.BUILD).vdomText && oldVNode.$text$ !== null) // the old vnode was text, so be sure to clear it out
            elm.textContent = '';
            // add the new vnode children
            $47990066fdbc3144$var$addVnodes(elm, null, newVNode, newChildren, 0, newChildren.length - 1);
        } else if ((0, $kxuSp.BUILD).updatable && oldChildren !== null) // no new child vnodes, but there are old child vnodes to remove
        $47990066fdbc3144$var$removeVnodes(oldChildren, 0, oldChildren.length - 1);
        if ((0, $kxuSp.BUILD).svg && $47990066fdbc3144$var$isSvgMode && tag === 'svg') $47990066fdbc3144$var$isSvgMode = false;
    } else if ((0, $kxuSp.BUILD).vdomText && (0, $kxuSp.BUILD).slotRelocation && (defaultHolder = elm['s-cr'])) // this element has slotted content
    defaultHolder.parentNode.textContent = text;
    else if ((0, $kxuSp.BUILD).vdomText && oldVNode.$text$ !== text) // update the text content for the text only vnode
    // and also only if the text is different than before
    elm.data = text;
};
const $47990066fdbc3144$var$updateFallbackSlotVisibility = (elm)=>{
    // tslint:disable-next-line: prefer-const
    const childNodes = elm.childNodes;
    let childNode;
    let i;
    let ilen;
    let j;
    let slotNameAttr;
    let nodeType;
    for(i = 0, ilen = childNodes.length; i < ilen; i++){
        childNode = childNodes[i];
        if (childNode.nodeType === 1 /* NODE_TYPE.ElementNode */ ) {
            if (childNode['s-sr']) {
                // this is a slot fallback node
                // get the slot name for this slot reference node
                slotNameAttr = childNode['s-sn'];
                // by default always show a fallback slot node
                // then hide it if there are other slots in the light dom
                childNode.hidden = false;
                for(j = 0; j < ilen; j++){
                    nodeType = childNodes[j].nodeType;
                    if (childNodes[j]['s-hn'] !== childNode['s-hn'] || slotNameAttr !== '') // this sibling node is from a different component OR is a named fallback slot node
                    {
                        if (nodeType === 1 /* NODE_TYPE.ElementNode */  && slotNameAttr === childNodes[j].getAttribute('slot')) {
                            childNode.hidden = true;
                            break;
                        }
                    } else // this is a default fallback slot node
                    // any element or text node (with content)
                    // should hide the default fallback slot node
                    if (nodeType === 1 /* NODE_TYPE.ElementNode */  || nodeType === 3 /* NODE_TYPE.TextNode */  && childNodes[j].textContent.trim() !== '') {
                        childNode.hidden = true;
                        break;
                    }
                }
            }
            // keep drilling down
            $47990066fdbc3144$var$updateFallbackSlotVisibility(childNode);
        }
    }
};
const $47990066fdbc3144$var$relocateNodes = [];
const $47990066fdbc3144$var$relocateSlotContent = (elm)=>{
    // tslint:disable-next-line: prefer-const
    let childNode;
    let node;
    let hostContentNodes;
    let slotNameAttr;
    let relocateNodeData;
    let j;
    let i = 0;
    const childNodes = elm.childNodes;
    const ilen = childNodes.length;
    for(; i < ilen; i++){
        childNode = childNodes[i];
        if (childNode['s-sr'] && (node = childNode['s-cr']) && node.parentNode) {
            // first got the content reference comment node
            // then we got it's parent, which is where all the host content is in now
            hostContentNodes = node.parentNode.childNodes;
            slotNameAttr = childNode['s-sn'];
            for(j = hostContentNodes.length - 1; j >= 0; j--){
                node = hostContentNodes[j];
                if (!node['s-cn'] && !node['s-nr'] && node['s-hn'] !== childNode['s-hn']) {
                    // let's do some relocating to its new home
                    // but never relocate a content reference node
                    // that is suppose to always represent the original content location
                    if ($47990066fdbc3144$var$isNodeLocatedInSlot(node, slotNameAttr)) {
                        // it's possible we've already decided to relocate this node
                        relocateNodeData = $47990066fdbc3144$var$relocateNodes.find((r)=>r.$nodeToRelocate$ === node);
                        // made some changes to slots
                        // let's make sure we also double check
                        // fallbacks are correctly hidden or shown
                        $47990066fdbc3144$var$checkSlotFallbackVisibility = true;
                        node['s-sn'] = node['s-sn'] || slotNameAttr;
                        if (relocateNodeData) // previously we never found a slot home for this node
                        // but turns out we did, so let's remember it now
                        relocateNodeData.$slotRefNode$ = childNode;
                        else // add to our list of nodes to relocate
                        $47990066fdbc3144$var$relocateNodes.push({
                            $slotRefNode$: childNode,
                            $nodeToRelocate$: node
                        });
                        if (node['s-sr']) $47990066fdbc3144$var$relocateNodes.map((relocateNode)=>{
                            if ($47990066fdbc3144$var$isNodeLocatedInSlot(relocateNode.$nodeToRelocate$, node['s-sn'])) {
                                relocateNodeData = $47990066fdbc3144$var$relocateNodes.find((r)=>r.$nodeToRelocate$ === node);
                                if (relocateNodeData && !relocateNode.$slotRefNode$) relocateNode.$slotRefNode$ = relocateNodeData.$slotRefNode$;
                            }
                        });
                    } else if (!$47990066fdbc3144$var$relocateNodes.some((r)=>r.$nodeToRelocate$ === node)) // so far this element does not have a slot home, not setting slotRefNode on purpose
                    // if we never find a home for this element then we'll need to hide it
                    $47990066fdbc3144$var$relocateNodes.push({
                        $nodeToRelocate$: node
                    });
                }
            }
        }
        if (childNode.nodeType === 1 /* NODE_TYPE.ElementNode */ ) $47990066fdbc3144$var$relocateSlotContent(childNode);
    }
};
const $47990066fdbc3144$var$isNodeLocatedInSlot = (nodeToRelocate, slotNameAttr)=>{
    if (nodeToRelocate.nodeType === 1 /* NODE_TYPE.ElementNode */ ) {
        if (nodeToRelocate.getAttribute('slot') === null && slotNameAttr === '') return true;
        if (nodeToRelocate.getAttribute('slot') === slotNameAttr) return true;
        return false;
    }
    if (nodeToRelocate['s-sn'] === slotNameAttr) return true;
    return slotNameAttr === '';
};
const $47990066fdbc3144$var$callNodeRefs = (vNode)=>{
    if ((0, $kxuSp.BUILD).vdomRef) {
        vNode.$attrs$ && vNode.$attrs$.ref && vNode.$attrs$.ref(null);
        vNode.$children$ && vNode.$children$.map($47990066fdbc3144$var$callNodeRefs);
    }
};
/**
 * The main entry point for Stencil's virtual DOM-based rendering engine
 *
 * Given a {@link d.HostRef} container and some virtual DOM nodes, this
 * function will handle creating a virtual DOM tree with a single root, patching
 * the current virtual DOM tree onto an old one (if any), dealing with slot
 * relocation, and reflecting attributes.
 *
 * @param hostRef data needed to root and render the virtual DOM tree, such as
 * the DOM node into which it should be rendered.
 * @param renderFnResults the virtual DOM nodes to be rendered
 */ const $47990066fdbc3144$export$52f8e388858754a = (hostRef, renderFnResults)=>{
    const hostElm = hostRef.$hostElement$;
    const cmpMeta = hostRef.$cmpMeta$;
    const oldVNode = hostRef.$vnode$ || $47990066fdbc3144$var$newVNode(null, null);
    const rootVnode = $47990066fdbc3144$var$isHost(renderFnResults) ? renderFnResults : $47990066fdbc3144$export$dda1d9f60106f0e9(null, null, renderFnResults);
    $47990066fdbc3144$var$hostTagName = hostElm.tagName;
    // <Host> runtime check
    if ((0, $kxuSp.BUILD).isDev && Array.isArray(renderFnResults) && renderFnResults.some($47990066fdbc3144$var$isHost)) throw new Error(`The <Host> must be the single root component.
Looks like the render() function of "${$47990066fdbc3144$var$hostTagName.toLowerCase()}" is returning an array that contains the <Host>.

The render() function should look like this instead:

render() {
  // Do not return an array
  return (
    <Host>{content}</Host>
  );
}
  `);
    if ((0, $kxuSp.BUILD).reflect && cmpMeta.$attrsToReflect$) {
        rootVnode.$attrs$ = rootVnode.$attrs$ || {};
        cmpMeta.$attrsToReflect$.map(([propName, attribute])=>rootVnode.$attrs$[attribute] = hostElm[propName]);
    }
    rootVnode.$tag$ = null;
    rootVnode.$flags$ |= 4 /* VNODE_FLAGS.isHost */ ;
    hostRef.$vnode$ = rootVnode;
    rootVnode.$elm$ = oldVNode.$elm$ = (0, $kxuSp.BUILD).shadowDom ? hostElm.shadowRoot || hostElm : hostElm;
    if ((0, $kxuSp.BUILD).scoped || (0, $kxuSp.BUILD).shadowDom) $47990066fdbc3144$var$scopeId = hostElm['s-sc'];
    if ((0, $kxuSp.BUILD).slotRelocation) {
        $47990066fdbc3144$var$contentRef = hostElm['s-cr'];
        $47990066fdbc3144$var$useNativeShadowDom = $47990066fdbc3144$export$b4e7e6d61dbcd813 && (cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) !== 0;
        // always reset
        $47990066fdbc3144$var$checkSlotFallbackVisibility = false;
    }
    // synchronous patch
    $47990066fdbc3144$var$patch(oldVNode, rootVnode);
    if ((0, $kxuSp.BUILD).slotRelocation) {
        // while we're moving nodes around existing nodes, temporarily disable
        // the disconnectCallback from working
        $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 1 /* PLATFORM_FLAGS.isTmpDisconnected */ ;
        if ($47990066fdbc3144$var$checkSlotRelocate) {
            $47990066fdbc3144$var$relocateSlotContent(rootVnode.$elm$);
            let relocateData;
            let nodeToRelocate;
            let orgLocationNode;
            let parentNodeRef;
            let insertBeforeNode;
            let refNode;
            let i = 0;
            for(; i < $47990066fdbc3144$var$relocateNodes.length; i++){
                relocateData = $47990066fdbc3144$var$relocateNodes[i];
                nodeToRelocate = relocateData.$nodeToRelocate$;
                if (!nodeToRelocate['s-ol']) {
                    // add a reference node marking this node's original location
                    // keep a reference to this node for later lookups
                    orgLocationNode = (0, $kxuSp.BUILD).isDebug || (0, $kxuSp.BUILD).hydrateServerSide ? $47990066fdbc3144$var$originalLocationDebugNode(nodeToRelocate) : $47990066fdbc3144$export$2a111da947c407d2.createTextNode('');
                    orgLocationNode['s-nr'] = nodeToRelocate;
                    nodeToRelocate.parentNode.insertBefore(nodeToRelocate['s-ol'] = orgLocationNode, nodeToRelocate);
                }
            }
            for(i = 0; i < $47990066fdbc3144$var$relocateNodes.length; i++){
                relocateData = $47990066fdbc3144$var$relocateNodes[i];
                nodeToRelocate = relocateData.$nodeToRelocate$;
                if (relocateData.$slotRefNode$) {
                    // by default we're just going to insert it directly
                    // after the slot reference node
                    parentNodeRef = relocateData.$slotRefNode$.parentNode;
                    insertBeforeNode = relocateData.$slotRefNode$.nextSibling;
                    orgLocationNode = nodeToRelocate['s-ol'];
                    while(orgLocationNode = orgLocationNode.previousSibling){
                        refNode = orgLocationNode['s-nr'];
                        if (refNode && refNode['s-sn'] === nodeToRelocate['s-sn'] && parentNodeRef === refNode.parentNode) {
                            refNode = refNode.nextSibling;
                            if (!refNode || !refNode['s-nr']) {
                                insertBeforeNode = refNode;
                                break;
                            }
                        }
                    }
                    if (!insertBeforeNode && parentNodeRef !== nodeToRelocate.parentNode || nodeToRelocate.nextSibling !== insertBeforeNode) // we've checked that it's worth while to relocate
                    // since that the node to relocate
                    // has a different next sibling or parent relocated
                    {
                        if (nodeToRelocate !== insertBeforeNode) {
                            if (!nodeToRelocate['s-hn'] && nodeToRelocate['s-ol']) // probably a component in the index.html that doesn't have it's hostname set
                            nodeToRelocate['s-hn'] = nodeToRelocate['s-ol'].parentNode.nodeName;
                            // add it back to the dom but in its new home
                            parentNodeRef.insertBefore(nodeToRelocate, insertBeforeNode);
                        }
                    }
                } else // this node doesn't have a slot home to go to, so let's hide it
                if (nodeToRelocate.nodeType === 1 /* NODE_TYPE.ElementNode */ ) nodeToRelocate.hidden = true;
            }
        }
        if ($47990066fdbc3144$var$checkSlotFallbackVisibility) $47990066fdbc3144$var$updateFallbackSlotVisibility(rootVnode.$elm$);
        // done moving nodes around
        // allow the disconnect callback to work again
        $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ &= -2 /* PLATFORM_FLAGS.isTmpDisconnected */ ;
        // always reset
        $47990066fdbc3144$var$relocateNodes.length = 0;
    }
};
// slot comment debug nodes only created with the `--debug` flag
// otherwise these nodes are text nodes w/out content
const $47990066fdbc3144$var$slotReferenceDebugNode = (slotVNode)=>$47990066fdbc3144$export$2a111da947c407d2.createComment(`<slot${slotVNode.$name$ ? ' name="' + slotVNode.$name$ + '"' : ''}> (host=${$47990066fdbc3144$var$hostTagName.toLowerCase()})`);
const $47990066fdbc3144$var$originalLocationDebugNode = (nodeToRelocate)=>$47990066fdbc3144$export$2a111da947c407d2.createComment(`org-location for ` + (nodeToRelocate.localName ? `<${nodeToRelocate.localName}> (host=${nodeToRelocate['s-hn']})` : `[${nodeToRelocate.textContent}]`));
const $47990066fdbc3144$var$attachToAncestor = (hostRef, ancestorComponent)=>{
    if ((0, $kxuSp.BUILD).asyncLoading && ancestorComponent && !hostRef.$onRenderResolve$ && ancestorComponent['s-p']) ancestorComponent['s-p'].push(new Promise((r)=>hostRef.$onRenderResolve$ = r));
};
const $47990066fdbc3144$var$scheduleUpdate = (hostRef, isInitialLoad)=>{
    if ((0, $kxuSp.BUILD).taskQueue && (0, $kxuSp.BUILD).updatable) hostRef.$flags$ |= 16 /* HOST_FLAGS.isQueuedForUpdate */ ;
    if ((0, $kxuSp.BUILD).asyncLoading && hostRef.$flags$ & 4 /* HOST_FLAGS.isWaitingForChildren */ ) {
        hostRef.$flags$ |= 512 /* HOST_FLAGS.needsRerender */ ;
        return;
    }
    $47990066fdbc3144$var$attachToAncestor(hostRef, hostRef.$ancestorComponent$);
    // there is no ancestor component or the ancestor component
    // has already fired off its lifecycle update then
    // fire off the initial update
    const dispatch = ()=>$47990066fdbc3144$var$dispatchHooks(hostRef, isInitialLoad);
    return (0, $kxuSp.BUILD).taskQueue ? $47990066fdbc3144$export$bbfc1321f142f72c(dispatch) : dispatch();
};
const $47990066fdbc3144$var$dispatchHooks = (hostRef, isInitialLoad)=>{
    const elm = hostRef.$hostElement$;
    const endSchedule = $47990066fdbc3144$var$createTime('scheduleUpdate', hostRef.$cmpMeta$.$tagName$);
    const instance = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$lazyInstance$ : elm;
    let promise;
    if (isInitialLoad) {
        if ((0, $kxuSp.BUILD).lazyLoad && (0, $kxuSp.BUILD).hostListener) {
            hostRef.$flags$ |= 256 /* HOST_FLAGS.isListenReady */ ;
            if (hostRef.$queuedListeners$) {
                hostRef.$queuedListeners$.map(([methodName, event])=>$47990066fdbc3144$var$safeCall(instance, methodName, event));
                hostRef.$queuedListeners$ = null;
            }
        }
        $47990066fdbc3144$var$emitLifecycleEvent(elm, 'componentWillLoad');
        if ((0, $kxuSp.BUILD).cmpWillLoad) promise = $47990066fdbc3144$var$safeCall(instance, 'componentWillLoad');
    } else {
        $47990066fdbc3144$var$emitLifecycleEvent(elm, 'componentWillUpdate');
        if ((0, $kxuSp.BUILD).cmpWillUpdate) promise = $47990066fdbc3144$var$safeCall(instance, 'componentWillUpdate');
    }
    $47990066fdbc3144$var$emitLifecycleEvent(elm, 'componentWillRender');
    if ((0, $kxuSp.BUILD).cmpWillRender) promise = $47990066fdbc3144$var$then(promise, ()=>$47990066fdbc3144$var$safeCall(instance, 'componentWillRender'));
    endSchedule();
    return $47990066fdbc3144$var$then(promise, ()=>$47990066fdbc3144$var$updateComponent(hostRef, instance, isInitialLoad));
};
const $47990066fdbc3144$var$updateComponent = async (hostRef, instance, isInitialLoad)=>{
    // updateComponent
    const elm = hostRef.$hostElement$;
    const endUpdate = $47990066fdbc3144$var$createTime('update', hostRef.$cmpMeta$.$tagName$);
    const rc = elm['s-rc'];
    if ((0, $kxuSp.BUILD).style && isInitialLoad) // DOM WRITE!
    $47990066fdbc3144$var$attachStyles(hostRef);
    const endRender = $47990066fdbc3144$var$createTime('render', hostRef.$cmpMeta$.$tagName$);
    if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ |= 1024 /* HOST_FLAGS.devOnRender */ ;
    if ((0, $kxuSp.BUILD).hydrateServerSide) await $47990066fdbc3144$var$callRender(hostRef, instance, elm);
    else $47990066fdbc3144$var$callRender(hostRef, instance, elm);
    if ((0, $kxuSp.BUILD).cssVarShim && $47990066fdbc3144$export$2e40610e9d23bca6.$cssShim$) $47990066fdbc3144$export$2e40610e9d23bca6.$cssShim$.updateHost(elm);
    if ((0, $kxuSp.BUILD).isDev) {
        hostRef.$renderCount$++;
        hostRef.$flags$ &= -1025 /* HOST_FLAGS.devOnRender */ ;
    }
    if ((0, $kxuSp.BUILD).hydrateServerSide) try {
        // manually connected child components during server-side hydrate
        $47990066fdbc3144$var$serverSideConnected(elm);
        if (isInitialLoad) {
            // using only during server-side hydrate
            if (hostRef.$cmpMeta$.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) elm['s-en'] = '';
            else if (hostRef.$cmpMeta$.$flags$ & 2 /* CMP_FLAGS.scopedCssEncapsulation */ ) elm['s-en'] = 'c';
        }
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e, elm);
    }
    if ((0, $kxuSp.BUILD).asyncLoading && rc) {
        // ok, so turns out there are some child host elements
        // waiting on this parent element to load
        // let's fire off all update callbacks waiting
        rc.map((cb)=>cb());
        elm['s-rc'] = undefined;
    }
    endRender();
    endUpdate();
    if ((0, $kxuSp.BUILD).asyncLoading) {
        const childrenPromises = elm['s-p'];
        const postUpdate = ()=>$47990066fdbc3144$export$a2fffedced549758(hostRef);
        if (childrenPromises.length === 0) postUpdate();
        else {
            Promise.all(childrenPromises).then(postUpdate);
            hostRef.$flags$ |= 4 /* HOST_FLAGS.isWaitingForChildren */ ;
            childrenPromises.length = 0;
        }
    } else $47990066fdbc3144$export$a2fffedced549758(hostRef);
};
const $47990066fdbc3144$var$callRender = (hostRef, instance, elm)=>{
    // in order for bundlers to correctly treeshake the BUILD object
    // we need to ensure BUILD is not deoptimized within a try/catch
    // https://rollupjs.org/guide/en/#treeshake tryCatchDeoptimization
    const allRenderFn = (0, $kxuSp.BUILD).allRenderFn ? true : false;
    const lazyLoad = (0, $kxuSp.BUILD).lazyLoad ? true : false;
    const taskQueue = (0, $kxuSp.BUILD).taskQueue ? true : false;
    const updatable = (0, $kxuSp.BUILD).updatable ? true : false;
    try {
        $47990066fdbc3144$var$renderingRef = instance;
        instance = allRenderFn ? instance.render() : instance.render && instance.render();
        if (updatable && taskQueue) hostRef.$flags$ &= -17 /* HOST_FLAGS.isQueuedForUpdate */ ;
        if (updatable || lazyLoad) hostRef.$flags$ |= 2 /* HOST_FLAGS.hasRendered */ ;
        if ((0, $kxuSp.BUILD).hasRenderFn || (0, $kxuSp.BUILD).reflect) {
            if ((0, $kxuSp.BUILD).vdomRender || (0, $kxuSp.BUILD).reflect) {
                // looks like we've got child nodes to render into this host element
                // or we need to update the css class/attrs on the host element
                // DOM WRITE!
                if ((0, $kxuSp.BUILD).hydrateServerSide) return Promise.resolve(instance).then((value)=>$47990066fdbc3144$export$52f8e388858754a(hostRef, value));
                else $47990066fdbc3144$export$52f8e388858754a(hostRef, instance);
            } else elm.textContent = instance;
        }
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e, hostRef.$hostElement$);
    }
    $47990066fdbc3144$var$renderingRef = null;
    return null;
};
const $47990066fdbc3144$export$40c3cc0861cb4611 = ()=>$47990066fdbc3144$var$renderingRef;
const $47990066fdbc3144$export$a2fffedced549758 = (hostRef)=>{
    const tagName = hostRef.$cmpMeta$.$tagName$;
    const elm = hostRef.$hostElement$;
    const endPostUpdate = $47990066fdbc3144$var$createTime('postUpdate', tagName);
    const instance = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$lazyInstance$ : elm;
    const ancestorComponent = hostRef.$ancestorComponent$;
    if ((0, $kxuSp.BUILD).cmpDidRender) {
        if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ |= 1024 /* HOST_FLAGS.devOnRender */ ;
        $47990066fdbc3144$var$safeCall(instance, 'componentDidRender');
        if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ &= -1025 /* HOST_FLAGS.devOnRender */ ;
    }
    $47990066fdbc3144$var$emitLifecycleEvent(elm, 'componentDidRender');
    if (!(hostRef.$flags$ & 64 /* HOST_FLAGS.hasLoadedComponent */ )) {
        hostRef.$flags$ |= 64 /* HOST_FLAGS.hasLoadedComponent */ ;
        if ((0, $kxuSp.BUILD).asyncLoading && (0, $kxuSp.BUILD).cssAnnotations) // DOM WRITE!
        $47990066fdbc3144$var$addHydratedFlag(elm);
        if ((0, $kxuSp.BUILD).cmpDidLoad) {
            if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ |= 2048 /* HOST_FLAGS.devOnDidLoad */ ;
            $47990066fdbc3144$var$safeCall(instance, 'componentDidLoad');
            if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ &= -2049 /* HOST_FLAGS.devOnDidLoad */ ;
        }
        $47990066fdbc3144$var$emitLifecycleEvent(elm, 'componentDidLoad');
        endPostUpdate();
        if ((0, $kxuSp.BUILD).asyncLoading) {
            hostRef.$onReadyResolve$(elm);
            if (!ancestorComponent) $47990066fdbc3144$var$appDidLoad(tagName);
        }
    } else {
        if ((0, $kxuSp.BUILD).cmpDidUpdate) {
            // we've already loaded this component
            // fire off the user's componentDidUpdate method (if one was provided)
            // componentDidUpdate runs AFTER render() has been called
            // and all child components have finished updating
            if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ |= 1024 /* HOST_FLAGS.devOnRender */ ;
            $47990066fdbc3144$var$safeCall(instance, 'componentDidUpdate');
            if ((0, $kxuSp.BUILD).isDev) hostRef.$flags$ &= -1025 /* HOST_FLAGS.devOnRender */ ;
        }
        $47990066fdbc3144$var$emitLifecycleEvent(elm, 'componentDidUpdate');
        endPostUpdate();
    }
    if ((0, $kxuSp.BUILD).hotModuleReplacement) elm['s-hmr-load'] && elm['s-hmr-load']();
    if ((0, $kxuSp.BUILD).method && (0, $kxuSp.BUILD).lazyLoad) hostRef.$onInstanceResolve$(elm);
    // load events fire from bottom to top
    // the deepest elements load first then bubbles up
    if ((0, $kxuSp.BUILD).asyncLoading) {
        if (hostRef.$onRenderResolve$) {
            hostRef.$onRenderResolve$();
            hostRef.$onRenderResolve$ = undefined;
        }
        if (hostRef.$flags$ & 512 /* HOST_FLAGS.needsRerender */ ) $47990066fdbc3144$export$bdd553fddd433dcb(()=>$47990066fdbc3144$var$scheduleUpdate(hostRef, false));
        hostRef.$flags$ &= -517;
    }
// ( •_•)
// ( •_•)>⌐■-■
// (⌐■_■)
};
const $47990066fdbc3144$export$98c7f8edae68c30f = (ref)=>{
    if ((0, $kxuSp.BUILD).updatable) {
        const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(ref);
        const isConnected = hostRef.$hostElement$.isConnected;
        if (isConnected && (hostRef.$flags$ & 18 /* HOST_FLAGS.isQueuedForUpdate */ ) === 2 /* HOST_FLAGS.hasRendered */ ) $47990066fdbc3144$var$scheduleUpdate(hostRef, false);
        // Returns "true" when the forced update was successfully scheduled
        return isConnected;
    }
    return false;
};
const $47990066fdbc3144$var$appDidLoad = (who)=>{
    // on appload
    // we have finish the first big initial render
    if ((0, $kxuSp.BUILD).cssAnnotations) $47990066fdbc3144$var$addHydratedFlag($47990066fdbc3144$export$2a111da947c407d2.documentElement);
    if ((0, $kxuSp.BUILD).asyncQueue) $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 2 /* PLATFORM_FLAGS.appLoaded */ ;
    $47990066fdbc3144$export$bdd553fddd433dcb(()=>$47990066fdbc3144$var$emitEvent($47990066fdbc3144$export$10a0f131c0eea21b, 'appload', {
            detail: {
                namespace: (0, $kxuSp.NAMESPACE)
            }
        }));
    if ((0, $kxuSp.BUILD).profile && performance.measure) performance.measure(`[Stencil] ${(0, $kxuSp.NAMESPACE)} initial load (by ${who})`, 'st:app:start');
};
const $47990066fdbc3144$var$safeCall = (instance, method, arg)=>{
    if (instance && instance[method]) try {
        return instance[method](arg);
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e);
    }
    return undefined;
};
const $47990066fdbc3144$var$then = (promise, thenFn)=>{
    return promise && promise.then ? promise.then(thenFn) : thenFn();
};
const $47990066fdbc3144$var$emitLifecycleEvent = (elm, lifecycleName)=>{
    if ((0, $kxuSp.BUILD).lifecycleDOMEvents) $47990066fdbc3144$var$emitEvent(elm, 'stencil_' + lifecycleName, {
        bubbles: true,
        composed: true,
        detail: {
            namespace: (0, $kxuSp.NAMESPACE)
        }
    });
};
const $47990066fdbc3144$var$addHydratedFlag = (elm)=>(0, $kxuSp.BUILD).hydratedClass ? elm.classList.add('hydrated') : (0, $kxuSp.BUILD).hydratedAttribute ? elm.setAttribute('hydrated', '') : undefined;
const $47990066fdbc3144$var$serverSideConnected = (elm)=>{
    const children = elm.children;
    if (children != null) for(let i = 0, ii = children.length; i < ii; i++){
        const childElm = children[i];
        if (typeof childElm.connectedCallback === 'function') childElm.connectedCallback();
        $47990066fdbc3144$var$serverSideConnected(childElm);
    }
};
const $47990066fdbc3144$export$bf7199a9ebcb84a9 = (ref, propName)=>$47990066fdbc3144$export$3f84770eccf215d2(ref).$instanceValues$.get(propName);
const $47990066fdbc3144$export$80746c6bc6142fc8 = (ref, propName, newVal, cmpMeta)=>{
    // check our new property value against our internal value
    const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(ref);
    const elm = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$hostElement$ : ref;
    const oldVal = hostRef.$instanceValues$.get(propName);
    const flags = hostRef.$flags$;
    const instance = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$lazyInstance$ : elm;
    newVal = $47990066fdbc3144$export$480b8c8d1e35b434(newVal, cmpMeta.$members$[propName][0]);
    // explicitly check for NaN on both sides, as `NaN === NaN` is always false
    const areBothNaN = Number.isNaN(oldVal) && Number.isNaN(newVal);
    const didValueChange = newVal !== oldVal && !areBothNaN;
    if ((!(0, $kxuSp.BUILD).lazyLoad || !(flags & 8 /* HOST_FLAGS.isConstructingInstance */ ) || oldVal === undefined) && didValueChange) {
        // gadzooks! the property's value has changed!!
        // set our new value!
        hostRef.$instanceValues$.set(propName, newVal);
        if ((0, $kxuSp.BUILD).isDev) {
            if (hostRef.$flags$ & 1024 /* HOST_FLAGS.devOnRender */ ) $47990066fdbc3144$export$5d385f3b3df7e1b9(`The state/prop "${propName}" changed during rendering. This can potentially lead to infinite-loops and other bugs.`, '\nElement', elm, '\nNew value', newVal, '\nOld value', oldVal);
            else if (hostRef.$flags$ & 2048 /* HOST_FLAGS.devOnDidLoad */ ) $47990066fdbc3144$export$5d385f3b3df7e1b9(`The state/prop "${propName}" changed during "componentDidLoad()", this triggers extra re-renders, try to setup on "componentWillLoad()"`, '\nElement', elm, '\nNew value', newVal, '\nOld value', oldVal);
        }
        if (!(0, $kxuSp.BUILD).lazyLoad || instance) {
            // get an array of method names of watch functions to call
            if ((0, $kxuSp.BUILD).watchCallback && cmpMeta.$watchers$ && flags & 128 /* HOST_FLAGS.isWatchReady */ ) {
                const watchMethods = cmpMeta.$watchers$[propName];
                if (watchMethods) // this instance is watching for when this property changed
                watchMethods.map((watchMethodName)=>{
                    try {
                        // fire off each of the watch methods that are watching this property
                        instance[watchMethodName](newVal, oldVal, propName);
                    } catch (e) {
                        $47990066fdbc3144$export$bf36f23bad3e1069(e, elm);
                    }
                });
            }
            if ((0, $kxuSp.BUILD).updatable && (flags & 18 /* HOST_FLAGS.isQueuedForUpdate */ ) === 2 /* HOST_FLAGS.hasRendered */ ) {
                if ((0, $kxuSp.BUILD).cmpShouldUpdate && instance.componentShouldUpdate) {
                    if (instance.componentShouldUpdate(newVal, oldVal, propName) === false) return;
                }
                // looks like this value actually changed, so we've got work to do!
                // but only if we've already rendered, otherwise just chill out
                // queue that we need to do an update, but don't worry about queuing
                // up millions cuz this function ensures it only runs once
                $47990066fdbc3144$var$scheduleUpdate(hostRef, false);
            }
        }
    }
};
/**
 * Attach a series of runtime constructs to a compiled Stencil component
 * constructor, including getters and setters for the `@Prop` and `@State`
 * decorators, callbacks for when attributes change, and so on.
 *
 * @param Cstr the constructor for a component that we need to process
 * @param cmpMeta metadata collected previously about the component
 * @param flags a number used to store a series of bit flags
 * @returns a reference to the same constructor passed in (but now mutated)
 */ const $47990066fdbc3144$export$982064ca8d9ad69 = (Cstr, cmpMeta, flags)=>{
    if ((0, $kxuSp.BUILD).member && cmpMeta.$members$) {
        if ((0, $kxuSp.BUILD).watchCallback && Cstr.watchers) cmpMeta.$watchers$ = Cstr.watchers;
        // It's better to have a const than two Object.entries()
        const members = Object.entries(cmpMeta.$members$);
        const prototype = Cstr.prototype;
        members.map(([memberName, [memberFlags]])=>{
            if (((0, $kxuSp.BUILD).prop || (0, $kxuSp.BUILD).state) && (memberFlags & 31 /* MEMBER_FLAGS.Prop */  || (!(0, $kxuSp.BUILD).lazyLoad || flags & 2 /* PROXY_FLAGS.proxyState */ ) && memberFlags & 32 /* MEMBER_FLAGS.State */ )) // proxyComponent - prop
            Object.defineProperty(prototype, memberName, {
                get () {
                    // proxyComponent, get value
                    return $47990066fdbc3144$export$bf7199a9ebcb84a9(this, memberName);
                },
                set (newValue) {
                    // only during dev time
                    if ((0, $kxuSp.BUILD).isDev) {
                        const ref = $47990066fdbc3144$export$3f84770eccf215d2(this);
                        if (// we are proxying the instance (not element)
                        (flags & 1 /* PROXY_FLAGS.isElementConstructor */ ) === 0 && // the element is not constructing
                        (ref.$flags$ & 8 /* HOST_FLAGS.isConstructingInstance */ ) === 0 && // the member is a prop
                        (memberFlags & 31 /* MEMBER_FLAGS.Prop */ ) !== 0 && // the member is not mutable
                        (memberFlags & 1024 /* MEMBER_FLAGS.Mutable */ ) === 0) $47990066fdbc3144$export$5d385f3b3df7e1b9(`@Prop() "${memberName}" on <${cmpMeta.$tagName$}> is immutable but was modified from within the component.\nMore information: https://stenciljs.com/docs/properties#prop-mutability`);
                    }
                    // proxyComponent, set value
                    $47990066fdbc3144$export$80746c6bc6142fc8(this, memberName, newValue, cmpMeta);
                },
                configurable: true,
                enumerable: true
            });
            else if ((0, $kxuSp.BUILD).lazyLoad && (0, $kxuSp.BUILD).method && flags & 1 /* PROXY_FLAGS.isElementConstructor */  && memberFlags & 64 /* MEMBER_FLAGS.Method */ ) // proxyComponent - method
            Object.defineProperty(prototype, memberName, {
                value (...args) {
                    const ref = $47990066fdbc3144$export$3f84770eccf215d2(this);
                    return ref.$onInstancePromise$.then(()=>ref.$lazyInstance$[memberName](...args));
                }
            });
        });
        if ((0, $kxuSp.BUILD).observeAttribute && (!(0, $kxuSp.BUILD).lazyLoad || flags & 1 /* PROXY_FLAGS.isElementConstructor */ )) {
            const attrNameToPropName = new Map();
            prototype.attributeChangedCallback = function(attrName, _oldValue, newValue) {
                $47990066fdbc3144$export$2e40610e9d23bca6.jmp(()=>{
                    const propName = attrNameToPropName.get(attrName);
                    //  In a web component lifecycle the attributeChangedCallback runs prior to connectedCallback
                    //  in the case where an attribute was set inline.
                    //  ```html
                    //    <my-component some-attribute="some-value"></my-component>
                    //  ```
                    //
                    //  There is an edge case where a developer sets the attribute inline on a custom element and then
                    //  programmatically changes it before it has been upgraded as shown below:
                    //
                    //  ```html
                    //    <!-- this component has _not_ been upgraded yet -->
                    //    <my-component id="test" some-attribute="some-value"></my-component>
                    //    <script>
                    //      // grab non-upgraded component
                    //      el = document.querySelector("#test");
                    //      el.someAttribute = "another-value";
                    //      // upgrade component
                    //      customElements.define('my-component', MyComponent);
                    //    </script>
                    //  ```
                    //  In this case if we do not unshadow here and use the value of the shadowing property, attributeChangedCallback
                    //  will be called with `newValue = "some-value"` and will set the shadowed property (this.someAttribute = "another-value")
                    //  to the value that was set inline i.e. "some-value" from above example. When
                    //  the connectedCallback attempts to unshadow it will use "some-value" as the initial value rather than "another-value"
                    //
                    //  The case where the attribute was NOT set inline but was not set programmatically shall be handled/unshadowed
                    //  by connectedCallback as this attributeChangedCallback will not fire.
                    //
                    //  https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
                    //
                    //  TODO(STENCIL-16) we should think about whether or not we actually want to be reflecting the attributes to
                    //  properties here given that this goes against best practices outlined here
                    //  https://developers.google.com/web/fundamentals/web-components/best-practices#avoid-reentrancy
                    if (this.hasOwnProperty(propName)) {
                        newValue = this[propName];
                        delete this[propName];
                    } else if (prototype.hasOwnProperty(propName) && typeof this[propName] === 'number' && this[propName] == newValue) // if the propName exists on the prototype of `Cstr`, this update may be a result of Stencil using native
                    // APIs to reflect props as attributes. Calls to `setAttribute(someElement, propName)` will result in
                    // `propName` to be converted to a `DOMString`, which may not be what we want for other primitive props.
                    return;
                    this[propName] = newValue === null && typeof this[propName] === 'boolean' ? false : newValue;
                });
            };
            // create an array of attributes to observe
            // and also create a map of html attribute name to js property name
            Cstr.observedAttributes = members.filter(([_, m])=>m[0] & 15 /* MEMBER_FLAGS.HasAttribute */ ) // filter to only keep props that should match attributes
            .map(([propName, m])=>{
                const attrName = m[1] || propName;
                attrNameToPropName.set(attrName, propName);
                if ((0, $kxuSp.BUILD).reflect && m[0] & 512 /* MEMBER_FLAGS.ReflectAttr */ ) cmpMeta.$attrsToReflect$.push([
                    propName,
                    attrName
                ]);
                return attrName;
            });
        }
    }
    return Cstr;
};

const $47990066fdbc3144$var$initializeComponent = async (elm, hostRef, cmpMeta, hmrVersionId, Cstr)=>{
    // initializeComponent
    if (((0, $kxuSp.BUILD).lazyLoad || (0, $kxuSp.BUILD).hydrateServerSide || (0, $kxuSp.BUILD).style) && (hostRef.$flags$ & 32 /* HOST_FLAGS.hasInitializedComponent */ ) === 0) {
        if ((0, $kxuSp.BUILD).lazyLoad || (0, $kxuSp.BUILD).hydrateClientSide) {
            // we haven't initialized this element yet
            hostRef.$flags$ |= 32 /* HOST_FLAGS.hasInitializedComponent */ ;
            // lazy loaded components
            // request the component's implementation to be
            // wired up with the host element
            Cstr = $47990066fdbc3144$export$ebb47fdc8f2dbc6f(cmpMeta, hostRef, hmrVersionId);
            if (Cstr.then) {
                // Await creates a micro-task avoid if possible
                const endLoad = $47990066fdbc3144$var$uniqueTime(`st:load:${cmpMeta.$tagName$}:${hostRef.$modeName$}`, `[Stencil] Load module for <${cmpMeta.$tagName$}>`);
                Cstr = await Cstr;
                endLoad();
            }
            if (((0, $kxuSp.BUILD).isDev || (0, $kxuSp.BUILD).isDebug) && !Cstr) throw new Error(`Constructor for "${cmpMeta.$tagName$}#${hostRef.$modeName$}" was not found`);
            if ((0, $kxuSp.BUILD).member && !Cstr.isProxied) {
                // we've never proxied this Constructor before
                // let's add the getters/setters to its prototype before
                // the first time we create an instance of the implementation
                if ((0, $kxuSp.BUILD).watchCallback) cmpMeta.$watchers$ = Cstr.watchers;
                $47990066fdbc3144$export$982064ca8d9ad69(Cstr, cmpMeta, 2 /* PROXY_FLAGS.proxyState */ );
                Cstr.isProxied = true;
            }
            const endNewInstance = $47990066fdbc3144$var$createTime('createInstance', cmpMeta.$tagName$);
            // ok, time to construct the instance
            // but let's keep track of when we start and stop
            // so that the getters/setters don't incorrectly step on data
            if ((0, $kxuSp.BUILD).member) hostRef.$flags$ |= 8 /* HOST_FLAGS.isConstructingInstance */ ;
            // construct the lazy-loaded component implementation
            // passing the hostRef is very important during
            // construction in order to directly wire together the
            // host element and the lazy-loaded instance
            try {
                new Cstr(hostRef);
            } catch (e) {
                $47990066fdbc3144$export$bf36f23bad3e1069(e);
            }
            if ((0, $kxuSp.BUILD).member) hostRef.$flags$ &= -9 /* HOST_FLAGS.isConstructingInstance */ ;
            if ((0, $kxuSp.BUILD).watchCallback) hostRef.$flags$ |= 128 /* HOST_FLAGS.isWatchReady */ ;
            endNewInstance();
            $47990066fdbc3144$var$fireConnectedCallback(hostRef.$lazyInstance$);
        } else {
            // sync constructor component
            Cstr = elm.constructor;
            hostRef.$flags$ |= 32 /* HOST_FLAGS.hasInitializedComponent */ ;
            // wait for the CustomElementRegistry to mark the component as ready before setting `isWatchReady`. Otherwise,
            // watchers may fire prematurely if `customElements.get()`/`customElements.whenDefined()` resolves _before_
            // Stencil has completed instantiating the component.
            customElements.whenDefined(cmpMeta.$tagName$).then(()=>hostRef.$flags$ |= 128 /* HOST_FLAGS.isWatchReady */ );
        }
        if ((0, $kxuSp.BUILD).style && Cstr.style) {
            // this component has styles but we haven't registered them yet
            let style = Cstr.style;
            if ((0, $kxuSp.BUILD).mode && typeof style !== 'string') {
                style = style[hostRef.$modeName$ = $47990066fdbc3144$var$computeMode(elm)];
                if ((0, $kxuSp.BUILD).hydrateServerSide && hostRef.$modeName$) elm.setAttribute('s-mode', hostRef.$modeName$);
            }
            const scopeId = $47990066fdbc3144$var$getScopeId(cmpMeta, hostRef.$modeName$);
            if (!$47990066fdbc3144$export$9dd6ff9ea0189349.has(scopeId)) {
                const endRegisterStyles = $47990066fdbc3144$var$createTime('registerStyles', cmpMeta.$tagName$);
                if (!(0, $kxuSp.BUILD).hydrateServerSide && (0, $kxuSp.BUILD).shadowDom && (0, $kxuSp.BUILD).shadowDomShim && cmpMeta.$flags$ & 8 /* CMP_FLAGS.needsShadowDomShim */ ) style = await (parcelRequire("fgFdQ")).then((m)=>m.scopeCss(style, scopeId, false));
                $47990066fdbc3144$var$registerStyle(scopeId, style, !!(cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ));
                endRegisterStyles();
            }
        }
    }
    // we've successfully created a lazy instance
    const ancestorComponent = hostRef.$ancestorComponent$;
    const schedule = ()=>$47990066fdbc3144$var$scheduleUpdate(hostRef, true);
    if ((0, $kxuSp.BUILD).asyncLoading && ancestorComponent && ancestorComponent['s-rc']) // this is the initial load and this component it has an ancestor component
    // but the ancestor component has NOT fired its will update lifecycle yet
    // so let's just cool our jets and wait for the ancestor to continue first
    // this will get fired off when the ancestor component
    // finally gets around to rendering its lazy self
    // fire off the initial update
    ancestorComponent['s-rc'].push(schedule);
    else schedule();
};
const $47990066fdbc3144$var$fireConnectedCallback = (instance)=>{
    if ((0, $kxuSp.BUILD).lazyLoad && (0, $kxuSp.BUILD).connectedCallback) $47990066fdbc3144$var$safeCall(instance, 'connectedCallback');
};
const $47990066fdbc3144$export$de367db4d6dadc9f = (elm)=>{
    if (($47990066fdbc3144$export$2e40610e9d23bca6.$flags$ & 1 /* PLATFORM_FLAGS.isTmpDisconnected */ ) === 0) {
        const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(elm);
        const cmpMeta = hostRef.$cmpMeta$;
        const endConnected = $47990066fdbc3144$var$createTime('connectedCallback', cmpMeta.$tagName$);
        if ((0, $kxuSp.BUILD).hostListenerTargetParent) // only run if we have listeners being attached to a parent
        $47990066fdbc3144$export$62df7fa1a32c483(elm, hostRef, cmpMeta.$listeners$, true);
        if (!(hostRef.$flags$ & 1 /* HOST_FLAGS.hasConnected */ )) {
            // first time this component has connected
            hostRef.$flags$ |= 1 /* HOST_FLAGS.hasConnected */ ;
            let hostId;
            if ((0, $kxuSp.BUILD).hydrateClientSide) {
                hostId = elm.getAttribute($47990066fdbc3144$var$HYDRATE_ID);
                if (hostId) {
                    if ((0, $kxuSp.BUILD).shadowDom && $47990066fdbc3144$export$b4e7e6d61dbcd813 && cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) {
                        const scopeId = (0, $kxuSp.BUILD).mode ? $47990066fdbc3144$var$addStyle(elm.shadowRoot, cmpMeta, elm.getAttribute('s-mode')) : $47990066fdbc3144$var$addStyle(elm.shadowRoot, cmpMeta);
                        elm.classList.remove(scopeId + '-h', scopeId + '-s');
                    }
                    $47990066fdbc3144$var$initializeClientHydrate(elm, cmpMeta.$tagName$, hostId, hostRef);
                }
            }
            if ((0, $kxuSp.BUILD).slotRelocation && !hostId) // initUpdate
            // if the slot polyfill is required we'll need to put some nodes
            // in here to act as original content anchors as we move nodes around
            // host element has been connected to the DOM
            {
                if ((0, $kxuSp.BUILD).hydrateServerSide || ((0, $kxuSp.BUILD).slot || (0, $kxuSp.BUILD).shadowDom) && cmpMeta.$flags$ & 12 /* CMP_FLAGS.needsShadowDomShim */ ) $47990066fdbc3144$var$setContentReference(elm);
            }
            if ((0, $kxuSp.BUILD).asyncLoading) {
                // find the first ancestor component (if there is one) and register
                // this component as one of the actively loading child components for its ancestor
                let ancestorComponent = elm;
                while(ancestorComponent = ancestorComponent.parentNode || ancestorComponent.host)// climb up the ancestors looking for the first
                // component that hasn't finished its lifecycle update yet
                if ((0, $kxuSp.BUILD).hydrateClientSide && ancestorComponent.nodeType === 1 /* NODE_TYPE.ElementNode */  && ancestorComponent.hasAttribute('s-id') && ancestorComponent['s-p'] || ancestorComponent['s-p']) {
                    // we found this components first ancestor component
                    // keep a reference to this component's ancestor component
                    $47990066fdbc3144$var$attachToAncestor(hostRef, hostRef.$ancestorComponent$ = ancestorComponent);
                    break;
                }
            }
            // Lazy properties
            // https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
            if ((0, $kxuSp.BUILD).prop && !(0, $kxuSp.BUILD).hydrateServerSide && cmpMeta.$members$) Object.entries(cmpMeta.$members$).map(([memberName, [memberFlags]])=>{
                if (memberFlags & 31 /* MEMBER_FLAGS.Prop */  && elm.hasOwnProperty(memberName)) {
                    const value = elm[memberName];
                    delete elm[memberName];
                    elm[memberName] = value;
                }
            });
            if ((0, $kxuSp.BUILD).initializeNextTick) // connectedCallback, taskQueue, initialLoad
            // angular sets attribute AFTER connectCallback
            // https://github.com/angular/angular/issues/18909
            // https://github.com/angular/angular/issues/19940
            $47990066fdbc3144$export$bdd553fddd433dcb(()=>$47990066fdbc3144$var$initializeComponent(elm, hostRef, cmpMeta));
            else $47990066fdbc3144$var$initializeComponent(elm, hostRef, cmpMeta);
        } else {
            // not the first time this has connected
            // reattach any event listeners to the host
            // since they would have been removed when disconnected
            $47990066fdbc3144$export$62df7fa1a32c483(elm, hostRef, cmpMeta.$listeners$, false);
            // fire off connectedCallback() on component instance
            $47990066fdbc3144$var$fireConnectedCallback(hostRef.$lazyInstance$);
        }
        endConnected();
    }
};
const $47990066fdbc3144$var$setContentReference = (elm)=>{
    // only required when we're NOT using native shadow dom (slot)
    // or this browser doesn't support native shadow dom
    // and this host element was NOT created with SSR
    // let's pick out the inner content for slot projection
    // create a node to represent where the original
    // content was first placed, which is useful later on
    const contentRefElm = elm['s-cr'] = $47990066fdbc3144$export$2a111da947c407d2.createComment((0, $kxuSp.BUILD).isDebug ? `content-ref (host=${elm.localName})` : '');
    contentRefElm['s-cn'] = true;
    elm.insertBefore(contentRefElm, elm.firstChild);
};
const $47990066fdbc3144$export$6cf1a3dd300e0a4f = (elm)=>{
    if (($47990066fdbc3144$export$2e40610e9d23bca6.$flags$ & 1 /* PLATFORM_FLAGS.isTmpDisconnected */ ) === 0) {
        const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(elm);
        const instance = (0, $kxuSp.BUILD).lazyLoad ? hostRef.$lazyInstance$ : elm;
        if ((0, $kxuSp.BUILD).hostListener) {
            if (hostRef.$rmListeners$) {
                hostRef.$rmListeners$.map((rmListener)=>rmListener());
                hostRef.$rmListeners$ = undefined;
            }
        }
        // clear CSS var-shim tracking
        if ((0, $kxuSp.BUILD).cssVarShim && $47990066fdbc3144$export$2e40610e9d23bca6.$cssShim$) $47990066fdbc3144$export$2e40610e9d23bca6.$cssShim$.removeHost(elm);
        if ((0, $kxuSp.BUILD).lazyLoad && (0, $kxuSp.BUILD).disconnectedCallback) $47990066fdbc3144$var$safeCall(instance, 'disconnectedCallback');
        if ((0, $kxuSp.BUILD).cmpDidUnload) $47990066fdbc3144$var$safeCall(instance, 'componentDidUnload');
    }
};
const $47990066fdbc3144$export$a00e2346eabbdbef = (Cstr, compactMeta)=>{
    customElements.define(compactMeta[1], $47990066fdbc3144$export$370caf1876b7c579(Cstr, compactMeta));
};
const $47990066fdbc3144$export$370caf1876b7c579 = (Cstr, compactMeta)=>{
    const cmpMeta = {
        $flags$: compactMeta[0],
        $tagName$: compactMeta[1]
    };
    if ((0, $kxuSp.BUILD).member) cmpMeta.$members$ = compactMeta[2];
    if ((0, $kxuSp.BUILD).hostListener) cmpMeta.$listeners$ = compactMeta[3];
    if ((0, $kxuSp.BUILD).watchCallback) cmpMeta.$watchers$ = Cstr.$watchers$;
    if ((0, $kxuSp.BUILD).reflect) cmpMeta.$attrsToReflect$ = [];
    if ((0, $kxuSp.BUILD).shadowDom && !$47990066fdbc3144$export$b4e7e6d61dbcd813 && cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) cmpMeta.$flags$ |= 8 /* CMP_FLAGS.needsShadowDomShim */ ;
    const originalConnectedCallback = Cstr.prototype.connectedCallback;
    const originalDisconnectedCallback = Cstr.prototype.disconnectedCallback;
    Object.assign(Cstr.prototype, {
        __registerHost () {
            $47990066fdbc3144$export$c20b986001efcf6c(this, cmpMeta);
        },
        connectedCallback () {
            $47990066fdbc3144$export$de367db4d6dadc9f(this);
            if ((0, $kxuSp.BUILD).connectedCallback && originalConnectedCallback) originalConnectedCallback.call(this);
        },
        disconnectedCallback () {
            $47990066fdbc3144$export$6cf1a3dd300e0a4f(this);
            if ((0, $kxuSp.BUILD).disconnectedCallback && originalDisconnectedCallback) originalDisconnectedCallback.call(this);
        },
        __attachShadow () {
            if ($47990066fdbc3144$export$b4e7e6d61dbcd813) {
                if ((0, $kxuSp.BUILD).shadowDelegatesFocus) this.attachShadow({
                    mode: 'open',
                    delegatesFocus: !!(cmpMeta.$flags$ & 16 /* CMP_FLAGS.shadowDelegatesFocus */ )
                });
                else this.attachShadow({
                    mode: 'open'
                });
            } else this.shadowRoot = this;
        }
    });
    Cstr.is = cmpMeta.$tagName$;
    return $47990066fdbc3144$export$982064ca8d9ad69(Cstr, cmpMeta, 3 /* PROXY_FLAGS.proxyState */ );
};
const $47990066fdbc3144$export$d156c3c6ac0fffa3 = (elm)=>{
    if ((0, $kxuSp.BUILD).style && (0, $kxuSp.BUILD).mode && !(0, $kxuSp.BUILD).lazyLoad) {
        const mode = $47990066fdbc3144$var$computeMode(elm);
        const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(elm);
        if (hostRef.$modeName$ !== mode) {
            const cmpMeta = hostRef.$cmpMeta$;
            const oldScopeId = elm['s-sc'];
            const scopeId = $47990066fdbc3144$var$getScopeId(cmpMeta, mode);
            const style = elm.constructor.style[mode];
            const flags = cmpMeta.$flags$;
            if (style) {
                if (!$47990066fdbc3144$export$9dd6ff9ea0189349.has(scopeId)) $47990066fdbc3144$var$registerStyle(scopeId, style, !!(flags & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ));
                hostRef.$modeName$ = mode;
                elm.classList.remove(oldScopeId + '-h', oldScopeId + '-s');
                $47990066fdbc3144$var$attachStyles(hostRef);
                $47990066fdbc3144$export$98c7f8edae68c30f(elm);
            }
        }
    }
};
const $47990066fdbc3144$var$patchCloneNode = (HostElementPrototype)=>{
    const orgCloneNode = HostElementPrototype.cloneNode;
    HostElementPrototype.cloneNode = function(deep) {
        const srcNode = this;
        const isShadowDom = (0, $kxuSp.BUILD).shadowDom ? srcNode.shadowRoot && $47990066fdbc3144$export$b4e7e6d61dbcd813 : false;
        const clonedNode = orgCloneNode.call(srcNode, isShadowDom ? deep : false);
        if ((0, $kxuSp.BUILD).slot && !isShadowDom && deep) {
            let i = 0;
            let slotted, nonStencilNode;
            const stencilPrivates = [
                's-id',
                's-cr',
                's-lr',
                's-rc',
                's-sc',
                's-p',
                's-cn',
                's-sr',
                's-sn',
                's-hn',
                's-ol',
                's-nr',
                's-si'
            ];
            for(; i < srcNode.childNodes.length; i++){
                slotted = srcNode.childNodes[i]['s-nr'];
                nonStencilNode = stencilPrivates.every((privateField)=>!srcNode.childNodes[i][privateField]);
                if (slotted) {
                    if ((0, $kxuSp.BUILD).appendChildSlotFix && clonedNode.__appendChild) clonedNode.__appendChild(slotted.cloneNode(true));
                    else clonedNode.appendChild(slotted.cloneNode(true));
                }
                if (nonStencilNode) clonedNode.appendChild(srcNode.childNodes[i].cloneNode(true));
            }
        }
        return clonedNode;
    };
};
const $47990066fdbc3144$var$patchSlotAppendChild = (HostElementPrototype)=>{
    HostElementPrototype.__appendChild = HostElementPrototype.appendChild;
    HostElementPrototype.appendChild = function(newChild) {
        const slotName = newChild['s-sn'] = $47990066fdbc3144$var$getSlotName(newChild);
        const slotNode = $47990066fdbc3144$var$getHostSlotNode(this.childNodes, slotName);
        if (slotNode) {
            const slotChildNodes = $47990066fdbc3144$var$getHostSlotChildNodes(slotNode, slotName);
            const appendAfter = slotChildNodes[slotChildNodes.length - 1];
            return appendAfter.parentNode.insertBefore(newChild, appendAfter.nextSibling);
        }
        return this.__appendChild(newChild);
    };
};
/**
 * Patches the text content of an unnamed slotted node inside a scoped component
 * @param hostElementPrototype the `Element` to be patched
 * @param cmpMeta component runtime metadata used to determine if the component should be patched or not
 */ const $47990066fdbc3144$var$patchTextContent = (hostElementPrototype, cmpMeta)=>{
    if ((0, $kxuSp.BUILD).scoped && cmpMeta.$flags$ & 2 /* CMP_FLAGS.scopedCssEncapsulation */ ) {
        const descriptor = Object.getOwnPropertyDescriptor(Node.prototype, 'textContent');
        Object.defineProperty(hostElementPrototype, '__textContent', descriptor);
        Object.defineProperty(hostElementPrototype, 'textContent', {
            get () {
                var _a;
                // get the 'default slot', which would be the first slot in a shadow tree (if we were using one), whose name is
                // the empty string
                const slotNode = $47990066fdbc3144$var$getHostSlotNode(this.childNodes, '');
                // when a slot node is found, the textContent _may_ be found in the next sibling (text) node, depending on how
                // nodes were reordered during the vdom render. first try to get the text content from the sibling.
                if (((_a = slotNode === null || slotNode === void 0 ? void 0 : slotNode.nextSibling) === null || _a === void 0 ? void 0 : _a.nodeType) === 3 /* NODE_TYPES.TEXT_NODE */ ) return slotNode.nextSibling.textContent;
                else if (slotNode) return slotNode.textContent;
                else // fallback to the original implementation
                return this.__textContent;
            },
            set (value) {
                var _a;
                // get the 'default slot', which would be the first slot in a shadow tree (if we were using one), whose name is
                // the empty string
                const slotNode = $47990066fdbc3144$var$getHostSlotNode(this.childNodes, '');
                // when a slot node is found, the textContent _may_ need to be placed in the next sibling (text) node,
                // depending on how nodes were reordered during the vdom render. first try to set the text content on the
                // sibling.
                if (((_a = slotNode === null || slotNode === void 0 ? void 0 : slotNode.nextSibling) === null || _a === void 0 ? void 0 : _a.nodeType) === 3 /* NODE_TYPES.TEXT_NODE */ ) slotNode.nextSibling.textContent = value;
                else if (slotNode) slotNode.textContent = value;
                else {
                    // we couldn't find a slot, but that doesn't mean that there isn't one. if this check ran before the DOM
                    // loaded, we could have missed it. check for a content reference element on the scoped component and insert
                    // it there
                    this.__textContent = value;
                    const contentRefElm = this['s-cr'];
                    if (contentRefElm) this.insertBefore(contentRefElm, this.firstChild);
                }
            }
        });
    }
};
const $47990066fdbc3144$var$patchChildSlotNodes = (elm, cmpMeta)=>{
    class FakeNodeList extends Array {
        item(n) {
            return this[n];
        }
    }
    if (cmpMeta.$flags$ & 8 /* CMP_FLAGS.needsShadowDomShim */ ) {
        const childNodesFn = elm.__lookupGetter__('childNodes');
        Object.defineProperty(elm, 'children', {
            get () {
                return this.childNodes.map((n)=>n.nodeType === 1);
            }
        });
        Object.defineProperty(elm, 'childElementCount', {
            get () {
                return elm.children.length;
            }
        });
        Object.defineProperty(elm, 'childNodes', {
            get () {
                const childNodes = childNodesFn.call(this);
                if (($47990066fdbc3144$export$2e40610e9d23bca6.$flags$ & 1 /* PLATFORM_FLAGS.isTmpDisconnected */ ) === 0 && $47990066fdbc3144$export$3f84770eccf215d2(this).$flags$ & 2 /* HOST_FLAGS.hasRendered */ ) {
                    const result = new FakeNodeList();
                    for(let i = 0; i < childNodes.length; i++){
                        const slot = childNodes[i]['s-nr'];
                        if (slot) result.push(slot);
                    }
                    return result;
                }
                return FakeNodeList.from(childNodes);
            }
        });
    }
};
const $47990066fdbc3144$var$getSlotName = (node)=>node['s-sn'] || node.nodeType === 1 && node.getAttribute('slot') || '';
/**
 * Recursively searches a series of child nodes for a slot with the provided name.
 * @param childNodes the nodes to search for a slot with a specific name.
 * @param slotName the name of the slot to match on.
 * @returns a reference to the slot node that matches the provided name, `null` otherwise
 */ const $47990066fdbc3144$var$getHostSlotNode = (childNodes, slotName)=>{
    let i = 0;
    let childNode;
    for(; i < childNodes.length; i++){
        childNode = childNodes[i];
        if (childNode['s-sr'] && childNode['s-sn'] === slotName) return childNode;
        childNode = $47990066fdbc3144$var$getHostSlotNode(childNode.childNodes, slotName);
        if (childNode) return childNode;
    }
    return null;
};
const $47990066fdbc3144$var$getHostSlotChildNodes = (n, slotName)=>{
    const childNodes = [
        n
    ];
    while((n = n.nextSibling) && n['s-sn'] === slotName)childNodes.push(n);
    return childNodes;
};
const $47990066fdbc3144$var$hmrStart = (elm, cmpMeta, hmrVersionId)=>{
    // ¯\_(ツ)_/¯
    const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(elm);
    // reset state flags to only have been connected
    hostRef.$flags$ = 1 /* HOST_FLAGS.hasConnected */ ;
    // TODO
    // detatch any event listeners that may have been added
    // because we're not passing an exact event name it'll
    // remove all of this element's event, which is good
    // create a callback for when this component finishes hmr
    elm['s-hmr-load'] = ()=>{
        // finished hmr for this element
        delete elm['s-hmr-load'];
    };
    // re-initialize the component
    $47990066fdbc3144$var$initializeComponent(elm, hostRef, cmpMeta, hmrVersionId);
};
const $47990066fdbc3144$export$12ca34fb6e539801 = (lazyBundles, options = {})=>{
    var _a;
    if ((0, $kxuSp.BUILD).profile && performance.mark) performance.mark('st:app:start');
    $47990066fdbc3144$var$installDevTools();
    const endBootstrap = $47990066fdbc3144$var$createTime('bootstrapLazy');
    const cmpTags = [];
    const exclude = options.exclude || [];
    const customElements1 = $47990066fdbc3144$export$10a0f131c0eea21b.customElements;
    const head = $47990066fdbc3144$export$2a111da947c407d2.head;
    const metaCharset = /*@__PURE__*/ head.querySelector('meta[charset]');
    const visibilityStyle = /*@__PURE__*/ $47990066fdbc3144$export$2a111da947c407d2.createElement('style');
    const deferredConnectedCallbacks = [];
    const styles = /*@__PURE__*/ $47990066fdbc3144$export$2a111da947c407d2.querySelectorAll(`[${$47990066fdbc3144$var$HYDRATED_STYLE_ID}]`);
    let appLoadFallback;
    let isBootstrapping = true;
    let i = 0;
    Object.assign($47990066fdbc3144$export$2e40610e9d23bca6, options);
    $47990066fdbc3144$export$2e40610e9d23bca6.$resourcesUrl$ = new URL(options.resourcesUrl || './', $47990066fdbc3144$export$2a111da947c407d2.baseURI).href;
    if ((0, $kxuSp.BUILD).asyncQueue) {
        if (options.syncQueue) $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 4 /* PLATFORM_FLAGS.queueSync */ ;
    }
    if ((0, $kxuSp.BUILD).hydrateClientSide) // If the app is already hydrated there is not point to disable the
    // async queue. This will improve the first input delay
    $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ |= 2 /* PLATFORM_FLAGS.appLoaded */ ;
    if ((0, $kxuSp.BUILD).hydrateClientSide && (0, $kxuSp.BUILD).shadowDom) for(; i < styles.length; i++)$47990066fdbc3144$var$registerStyle(styles[i].getAttribute($47990066fdbc3144$var$HYDRATED_STYLE_ID), $47990066fdbc3144$var$convertScopedToShadow(styles[i].innerHTML), true);
    lazyBundles.map((lazyBundle)=>{
        lazyBundle[1].map((compactMeta)=>{
            const cmpMeta = {
                $flags$: compactMeta[0],
                $tagName$: compactMeta[1],
                $members$: compactMeta[2],
                $listeners$: compactMeta[3]
            };
            if ((0, $kxuSp.BUILD).member) cmpMeta.$members$ = compactMeta[2];
            if ((0, $kxuSp.BUILD).hostListener) cmpMeta.$listeners$ = compactMeta[3];
            if ((0, $kxuSp.BUILD).reflect) cmpMeta.$attrsToReflect$ = [];
            if ((0, $kxuSp.BUILD).watchCallback) cmpMeta.$watchers$ = {};
            if ((0, $kxuSp.BUILD).shadowDom && !$47990066fdbc3144$export$b4e7e6d61dbcd813 && cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) cmpMeta.$flags$ |= 8 /* CMP_FLAGS.needsShadowDomShim */ ;
            const tagName = (0, $kxuSp.BUILD).transformTagName && options.transformTagName ? options.transformTagName(cmpMeta.$tagName$) : cmpMeta.$tagName$;
            const HostElement = class extends HTMLElement {
                // StencilLazyHost
                constructor(self){
                    // @ts-ignore
                    super(self);
                    self = this;
                    $47990066fdbc3144$export$c20b986001efcf6c(self, cmpMeta);
                    if ((0, $kxuSp.BUILD).shadowDom && cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) {
                        // this component is using shadow dom
                        // and this browser supports shadow dom
                        // add the read-only property "shadowRoot" to the host element
                        // adding the shadow root build conditionals to minimize runtime
                        if ($47990066fdbc3144$export$b4e7e6d61dbcd813) {
                            if ((0, $kxuSp.BUILD).shadowDelegatesFocus) self.attachShadow({
                                mode: 'open',
                                delegatesFocus: !!(cmpMeta.$flags$ & 16 /* CMP_FLAGS.shadowDelegatesFocus */ )
                            });
                            else self.attachShadow({
                                mode: 'open'
                            });
                        } else if (!(0, $kxuSp.BUILD).hydrateServerSide && !('shadowRoot' in self)) self.shadowRoot = self;
                    }
                    if ((0, $kxuSp.BUILD).slotChildNodesFix) $47990066fdbc3144$var$patchChildSlotNodes(self, cmpMeta);
                }
                connectedCallback() {
                    if (appLoadFallback) {
                        clearTimeout(appLoadFallback);
                        appLoadFallback = null;
                    }
                    if (isBootstrapping) // connectedCallback will be processed once all components have been registered
                    deferredConnectedCallbacks.push(this);
                    else $47990066fdbc3144$export$2e40610e9d23bca6.jmp(()=>$47990066fdbc3144$export$de367db4d6dadc9f(this));
                }
                disconnectedCallback() {
                    $47990066fdbc3144$export$2e40610e9d23bca6.jmp(()=>$47990066fdbc3144$export$6cf1a3dd300e0a4f(this));
                }
                componentOnReady() {
                    return $47990066fdbc3144$export$3f84770eccf215d2(this).$onReadyPromise$;
                }
            };
            if ((0, $kxuSp.BUILD).cloneNodeFix) $47990066fdbc3144$var$patchCloneNode(HostElement.prototype);
            if ((0, $kxuSp.BUILD).appendChildSlotFix) $47990066fdbc3144$var$patchSlotAppendChild(HostElement.prototype);
            if ((0, $kxuSp.BUILD).hotModuleReplacement) HostElement.prototype['s-hmr'] = function(hmrVersionId) {
                $47990066fdbc3144$var$hmrStart(this, cmpMeta, hmrVersionId);
            };
            if ((0, $kxuSp.BUILD).scopedSlotTextContentFix) $47990066fdbc3144$var$patchTextContent(HostElement.prototype, cmpMeta);
            cmpMeta.$lazyBundleId$ = lazyBundle[0];
            if (!exclude.includes(tagName) && !customElements1.get(tagName)) {
                cmpTags.push(tagName);
                customElements1.define(tagName, $47990066fdbc3144$export$982064ca8d9ad69(HostElement, cmpMeta, 1 /* PROXY_FLAGS.isElementConstructor */ ));
            }
        });
    });
    if ((0, $kxuSp.BUILD).invisiblePrehydration && ((0, $kxuSp.BUILD).hydratedClass || (0, $kxuSp.BUILD).hydratedAttribute)) {
        visibilityStyle.innerHTML = cmpTags + $47990066fdbc3144$var$HYDRATED_CSS;
        visibilityStyle.setAttribute('data-styles', '');
        // Apply CSP nonce to the style tag if it exists
        const nonce = (_a = $47990066fdbc3144$export$2e40610e9d23bca6.$nonce$) !== null && _a !== void 0 ? _a : $47990066fdbc3144$var$queryNonceMetaTagContent($47990066fdbc3144$export$2a111da947c407d2);
        if (nonce != null) visibilityStyle.setAttribute('nonce', nonce);
        head.insertBefore(visibilityStyle, metaCharset ? metaCharset.nextSibling : head.firstChild);
    }
    // Process deferred connectedCallbacks now all components have been registered
    isBootstrapping = false;
    if (deferredConnectedCallbacks.length) deferredConnectedCallbacks.map((host)=>host.connectedCallback());
    else if ((0, $kxuSp.BUILD).profile) $47990066fdbc3144$export$2e40610e9d23bca6.jmp(()=>appLoadFallback = setTimeout($47990066fdbc3144$var$appDidLoad, 30, 'timeout'));
    else $47990066fdbc3144$export$2e40610e9d23bca6.jmp(()=>appLoadFallback = setTimeout($47990066fdbc3144$var$appDidLoad, 30));
    // Fallback appLoad event
    endBootstrap();
};
const $47990066fdbc3144$export$3a4668f195d4bdaf = (_ref, tagName)=>{
    const componentOnReady = ()=>{
        let elm = $47990066fdbc3144$export$2a111da947c407d2.querySelector(tagName);
        if (!elm) {
            elm = $47990066fdbc3144$export$2a111da947c407d2.createElement(tagName);
            $47990066fdbc3144$export$2a111da947c407d2.body.appendChild(elm);
        }
        return typeof elm.componentOnReady === 'function' ? elm.componentOnReady() : Promise.resolve(elm);
    };
    const create = (...args)=>{
        return componentOnReady().then((el)=>el.create(...args));
    };
    return {
        create: create,
        componentOnReady: componentOnReady
    };
};
const $47990066fdbc3144$export$31553aaa555c1514 = (_elm, context)=>{
    if (context in $47990066fdbc3144$export$841858b892ce1f4c) return $47990066fdbc3144$export$841858b892ce1f4c[context];
    else if (context === 'window') return $47990066fdbc3144$export$10a0f131c0eea21b;
    else if (context === 'document') return $47990066fdbc3144$export$2a111da947c407d2;
    else if (context === 'isServer' || context === 'isPrerender') return (0, $kxuSp.BUILD).hydrateServerSide ? true : false;
    else if (context === 'isClient') return (0, $kxuSp.BUILD).hydrateServerSide ? false : true;
    else if (context === 'resourcesUrl' || context === 'publicPath') return $47990066fdbc3144$export$7c3997b47f2311d9('.');
    else if (context === 'queue') return {
        write: $47990066fdbc3144$export$bbfc1321f142f72c,
        read: $47990066fdbc3144$export$de6bea324e6d63f6,
        tick: {
            then (cb) {
                return $47990066fdbc3144$export$bdd553fddd433dcb(cb);
            }
        }
    };
    return undefined;
};
const $47990066fdbc3144$export$ffb0004e005737fa = (_, children)=>children;
const $47990066fdbc3144$export$62df7fa1a32c483 = (elm, hostRef, listeners, attachParentListeners)=>{
    if ((0, $kxuSp.BUILD).hostListener && listeners) {
        // this is called immediately within the element's constructor
        // initialize our event listeners on the host element
        // we do this now so that we can listen to events that may
        // have fired even before the instance is ready
        if ((0, $kxuSp.BUILD).hostListenerTargetParent) {
            // this component may have event listeners that should be attached to the parent
            if (attachParentListeners) // this is being ran from within the connectedCallback
            // which is important so that we know the host element actually has a parent element
            // filter out the listeners to only have the ones that ARE being attached to the parent
            listeners = listeners.filter(([flags])=>flags & 32 /* LISTENER_FLAGS.TargetParent */ );
            else // this is being ran from within the component constructor
            // everything BUT the parent element listeners should be attached at this time
            // filter out the listeners that are NOT being attached to the parent
            listeners = listeners.filter(([flags])=>!(flags & 32 /* LISTENER_FLAGS.TargetParent */ ));
        }
        listeners.map(([flags, name, method])=>{
            const target = (0, $kxuSp.BUILD).hostListenerTarget ? $47990066fdbc3144$var$getHostListenerTarget(elm, flags) : elm;
            const handler = $47990066fdbc3144$var$hostListenerProxy(hostRef, method);
            const opts = $47990066fdbc3144$var$hostListenerOpts(flags);
            $47990066fdbc3144$export$2e40610e9d23bca6.ael(target, name, handler, opts);
            (hostRef.$rmListeners$ = hostRef.$rmListeners$ || []).push(()=>$47990066fdbc3144$export$2e40610e9d23bca6.rel(target, name, handler, opts));
        });
    }
};
const $47990066fdbc3144$var$hostListenerProxy = (hostRef, methodName)=>(ev)=>{
        try {
            if ((0, $kxuSp.BUILD).lazyLoad) {
                if (hostRef.$flags$ & 256 /* HOST_FLAGS.isListenReady */ ) // instance is ready, let's call it's member method for this event
                hostRef.$lazyInstance$[methodName](ev);
                else (hostRef.$queuedListeners$ = hostRef.$queuedListeners$ || []).push([
                    methodName,
                    ev
                ]);
            } else hostRef.$hostElement$[methodName](ev);
        } catch (e) {
            $47990066fdbc3144$export$bf36f23bad3e1069(e);
        }
    };
const $47990066fdbc3144$var$getHostListenerTarget = (elm, flags)=>{
    if ((0, $kxuSp.BUILD).hostListenerTargetDocument && flags & 4 /* LISTENER_FLAGS.TargetDocument */ ) return $47990066fdbc3144$export$2a111da947c407d2;
    if ((0, $kxuSp.BUILD).hostListenerTargetWindow && flags & 8 /* LISTENER_FLAGS.TargetWindow */ ) return $47990066fdbc3144$export$10a0f131c0eea21b;
    if ((0, $kxuSp.BUILD).hostListenerTargetBody && flags & 16 /* LISTENER_FLAGS.TargetBody */ ) return $47990066fdbc3144$export$2a111da947c407d2.body;
    if ((0, $kxuSp.BUILD).hostListenerTargetParent && flags & 32 /* LISTENER_FLAGS.TargetParent */ ) return elm.parentElement;
    return elm;
};
// prettier-ignore
const $47990066fdbc3144$var$hostListenerOpts = (flags)=>$47990066fdbc3144$export$b4b667f9f62821eb ? {
        passive: (flags & 1 /* LISTENER_FLAGS.Passive */ ) !== 0,
        capture: (flags & 2 /* LISTENER_FLAGS.Capture */ ) !== 0
    } : (flags & 2 /* LISTENER_FLAGS.Capture */ ) !== 0;
/**
 * Assigns the given value to the nonce property on the runtime platform object.
 * During runtime, this value is used to set the nonce attribute on all dynamically created script and style tags.
 * @param nonce The value to be assigned to the platform nonce property.
 * @returns void
 */ const $47990066fdbc3144$export$c5f670b24c0ae95a = (nonce)=>$47990066fdbc3144$export$2e40610e9d23bca6.$nonce$ = nonce;
const $47990066fdbc3144$export$ac8bf6eebf15d3df = (opts)=>Object.assign($47990066fdbc3144$export$2e40610e9d23bca6, opts);
const $47990066fdbc3144$export$fd226bebc5efbbed = (doc, staticComponents)=>{
    if (doc != null) {
        const docData = {
            hostIds: 0,
            rootLevelIds: 0,
            staticComponents: new Set(staticComponents)
        };
        const orgLocationNodes = [];
        $47990066fdbc3144$var$parseVNodeAnnotations(doc, doc.body, docData, orgLocationNodes);
        orgLocationNodes.forEach((orgLocationNode)=>{
            if (orgLocationNode != null) {
                const nodeRef = orgLocationNode['s-nr'];
                let hostId = nodeRef['s-host-id'];
                let nodeId = nodeRef['s-node-id'];
                let childId = `${hostId}.${nodeId}`;
                if (hostId == null) {
                    hostId = 0;
                    docData.rootLevelIds++;
                    nodeId = docData.rootLevelIds;
                    childId = `${hostId}.${nodeId}`;
                    if (nodeRef.nodeType === 1 /* NODE_TYPE.ElementNode */ ) nodeRef.setAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID, childId);
                    else if (nodeRef.nodeType === 3 /* NODE_TYPE.TextNode */ ) {
                        if (hostId === 0) {
                            const textContent = nodeRef.nodeValue.trim();
                            if (textContent === '') {
                                // useless whitespace node at the document root
                                orgLocationNode.remove();
                                return;
                            }
                        }
                        const commentBeforeTextNode = doc.createComment(childId);
                        commentBeforeTextNode.nodeValue = `${$47990066fdbc3144$var$TEXT_NODE_ID}.${childId}`;
                        nodeRef.parentNode.insertBefore(commentBeforeTextNode, nodeRef);
                    }
                }
                let orgLocationNodeId = `${$47990066fdbc3144$var$ORG_LOCATION_ID}.${childId}`;
                const orgLocationParentNode = orgLocationNode.parentElement;
                if (orgLocationParentNode) {
                    if (orgLocationParentNode['s-en'] === '') // ending with a "." means that the parent element
                    // of this node's original location is a SHADOW dom element
                    // and this node is apart of the root level light dom
                    orgLocationNodeId += `.`;
                    else if (orgLocationParentNode['s-en'] === 'c') // ending with a ".c" means that the parent element
                    // of this node's original location is a SCOPED element
                    // and this node is apart of the root level light dom
                    orgLocationNodeId += `.c`;
                }
                orgLocationNode.nodeValue = orgLocationNodeId;
            }
        });
    }
};
const $47990066fdbc3144$var$parseVNodeAnnotations = (doc, node, docData, orgLocationNodes)=>{
    if (node == null) return;
    if (node['s-nr'] != null) orgLocationNodes.push(node);
    if (node.nodeType === 1 /* NODE_TYPE.ElementNode */ ) node.childNodes.forEach((childNode)=>{
        const hostRef = $47990066fdbc3144$export$3f84770eccf215d2(childNode);
        if (hostRef != null && !docData.staticComponents.has(childNode.nodeName.toLowerCase())) {
            const cmpData = {
                nodeIds: 0
            };
            $47990066fdbc3144$var$insertVNodeAnnotations(doc, childNode, hostRef.$vnode$, docData, cmpData);
        }
        $47990066fdbc3144$var$parseVNodeAnnotations(doc, childNode, docData, orgLocationNodes);
    });
};
const $47990066fdbc3144$var$insertVNodeAnnotations = (doc, hostElm, vnode, docData, cmpData)=>{
    if (vnode != null) {
        const hostId = ++docData.hostIds;
        hostElm.setAttribute($47990066fdbc3144$var$HYDRATE_ID, hostId);
        if (hostElm['s-cr'] != null) hostElm['s-cr'].nodeValue = `${$47990066fdbc3144$var$CONTENT_REF_ID}.${hostId}`;
        if (vnode.$children$ != null) {
            const depth = 0;
            vnode.$children$.forEach((vnodeChild, index)=>{
                $47990066fdbc3144$var$insertChildVNodeAnnotations(doc, vnodeChild, cmpData, hostId, depth, index);
            });
        }
        if (hostElm && vnode && vnode.$elm$ && !hostElm.hasAttribute('c-id')) {
            const parent = hostElm.parentElement;
            if (parent && parent.childNodes) {
                const parentChildNodes = Array.from(parent.childNodes);
                const comment = parentChildNodes.find((node)=>node.nodeType === 8 /* NODE_TYPE.CommentNode */  && node['s-sr']);
                if (comment) {
                    const index = parentChildNodes.indexOf(hostElm) - 1;
                    vnode.$elm$.setAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID, `${comment['s-host-id']}.${comment['s-node-id']}.0.${index}`);
                }
            }
        }
    }
};
const $47990066fdbc3144$var$insertChildVNodeAnnotations = (doc, vnodeChild, cmpData, hostId, depth, index)=>{
    const childElm = vnodeChild.$elm$;
    if (childElm == null) return;
    const nodeId = cmpData.nodeIds++;
    const childId = `${hostId}.${nodeId}.${depth}.${index}`;
    childElm['s-host-id'] = hostId;
    childElm['s-node-id'] = nodeId;
    if (childElm.nodeType === 1 /* NODE_TYPE.ElementNode */ ) childElm.setAttribute($47990066fdbc3144$var$HYDRATE_CHILD_ID, childId);
    else if (childElm.nodeType === 3 /* NODE_TYPE.TextNode */ ) {
        const parentNode = childElm.parentNode;
        const nodeName = parentNode.nodeName;
        if (nodeName !== 'STYLE' && nodeName !== 'SCRIPT') {
            const textNodeId = `${$47990066fdbc3144$var$TEXT_NODE_ID}.${childId}`;
            const commentBeforeTextNode = doc.createComment(textNodeId);
            parentNode.insertBefore(commentBeforeTextNode, childElm);
        }
    } else if (childElm.nodeType === 8 /* NODE_TYPE.CommentNode */ ) {
        if (childElm['s-sr']) {
            const slotName = childElm['s-sn'] || '';
            const slotNodeId = `${$47990066fdbc3144$var$SLOT_NODE_ID}.${childId}.${slotName}`;
            childElm.nodeValue = slotNodeId;
        }
    }
    if (vnodeChild.$children$ != null) {
        const childDepth = depth + 1;
        vnodeChild.$children$.forEach((vnode, index)=>{
            $47990066fdbc3144$var$insertChildVNodeAnnotations(doc, vnode, cmpData, hostId, childDepth, index);
        });
    }
};
const $47990066fdbc3144$var$hostRefs = /*@__PURE__*/ new WeakMap();
const $47990066fdbc3144$export$3f84770eccf215d2 = (ref)=>$47990066fdbc3144$var$hostRefs.get(ref);
const $47990066fdbc3144$export$ea4bcaef8454fd24 = (lazyInstance, hostRef)=>$47990066fdbc3144$var$hostRefs.set(hostRef.$lazyInstance$ = lazyInstance, hostRef);
const $47990066fdbc3144$export$c20b986001efcf6c = (elm, cmpMeta)=>{
    const hostRef = {
        $flags$: 0,
        $hostElement$: elm,
        $cmpMeta$: cmpMeta,
        $instanceValues$: new Map()
    };
    if ((0, $kxuSp.BUILD).isDev) hostRef.$renderCount$ = 0;
    if ((0, $kxuSp.BUILD).method && (0, $kxuSp.BUILD).lazyLoad) hostRef.$onInstancePromise$ = new Promise((r)=>hostRef.$onInstanceResolve$ = r);
    if ((0, $kxuSp.BUILD).asyncLoading) {
        hostRef.$onReadyPromise$ = new Promise((r)=>hostRef.$onReadyResolve$ = r);
        elm['s-p'] = [];
        elm['s-rc'] = [];
    }
    $47990066fdbc3144$export$62df7fa1a32c483(elm, hostRef, cmpMeta.$listeners$, false);
    return $47990066fdbc3144$var$hostRefs.set(elm, hostRef);
};
const $47990066fdbc3144$export$304efeaa4c96d4e9 = (elm, memberName)=>memberName in elm;
const $47990066fdbc3144$export$bf36f23bad3e1069 = (e, el)=>($47990066fdbc3144$var$customError || console.error)(e, el);
const $47990066fdbc3144$export$262a85bf225b2794 = (0, $kxuSp.BUILD).isTesting ? [
    'STENCIL:'
] // E2E testing
 : [
    '%cstencil',
    'color: white;background:#4c47ff;font-weight: bold; font-size:10px; padding:2px 6px; border-radius: 5px'
];
const $47990066fdbc3144$export$47b52a6e53fbbc24 = (...m)=>console.error(...$47990066fdbc3144$export$262a85bf225b2794, ...m);
const $47990066fdbc3144$export$5d385f3b3df7e1b9 = (...m)=>console.warn(...$47990066fdbc3144$export$262a85bf225b2794, ...m);
const $47990066fdbc3144$export$f71f4f192932e35e = (...m)=>console.info(...$47990066fdbc3144$export$262a85bf225b2794, ...m);
const $47990066fdbc3144$export$56c340fcfa13d1a2 = (handler)=>$47990066fdbc3144$var$customError = handler;
const $47990066fdbc3144$export$a8b3e6b062e6642a = /*@__PURE__*/ new Map();
const $47990066fdbc3144$export$ebb47fdc8f2dbc6f = (cmpMeta, hostRef, hmrVersionId)=>{
    // loadModuleImport
    const exportName = cmpMeta.$tagName$.replace(/-/g, '_');
    const bundleId = cmpMeta.$lazyBundleId$;
    if ((0, $kxuSp.BUILD).isDev && typeof bundleId !== 'string') {
        $47990066fdbc3144$export$47b52a6e53fbbc24(`Trying to lazily load component <${cmpMeta.$tagName$}> with style mode "${hostRef.$modeName$}", but it does not exist.`);
        return undefined;
    }
    const module = !(0, $kxuSp.BUILD).hotModuleReplacement ? $47990066fdbc3144$export$a8b3e6b062e6642a.get(bundleId) : false;
    if (module) return module[exportName];
    /*!__STENCIL_STATIC_IMPORT_SWITCH__*/ return import(/* @vite-ignore */ /* webpackInclude: /\.entry\.js$/ */ /* webpackExclude: /\.system\.entry\.js$/ */ /* webpackMode: "lazy" */ `./${bundleId}.entry.js${(0, $kxuSp.BUILD).hotModuleReplacement && hmrVersionId ? '?s-hmr=' + hmrVersionId : ''}`).then((importedModule)=>{
        if (!(0, $kxuSp.BUILD).hotModuleReplacement) $47990066fdbc3144$export$a8b3e6b062e6642a.set(bundleId, importedModule);
        return importedModule[exportName];
    }, $47990066fdbc3144$export$bf36f23bad3e1069);
};
const $47990066fdbc3144$export$9dd6ff9ea0189349 = /*@__PURE__*/ new Map();
const $47990066fdbc3144$export$31c64a1f6cd0f6 = [];
const $47990066fdbc3144$export$10a0f131c0eea21b = typeof window !== 'undefined' ? window : {};
const $47990066fdbc3144$export$c4ffa16951855e28 = (0, $kxuSp.BUILD).cssVarShim ? $47990066fdbc3144$export$10a0f131c0eea21b.CSS : null;
const $47990066fdbc3144$export$2a111da947c407d2 = $47990066fdbc3144$export$10a0f131c0eea21b.document || {
    head: {}
};
const $47990066fdbc3144$export$7f8ddf7c7c20b3cd = $47990066fdbc3144$export$10a0f131c0eea21b.HTMLElement || class {
};
const $47990066fdbc3144$export$2e40610e9d23bca6 = {
    $flags$: 0,
    $resourcesUrl$: '',
    jmp: (h)=>h(),
    raf: (h)=>requestAnimationFrame(h),
    ael: (el, eventName, listener, opts)=>el.addEventListener(eventName, listener, opts),
    rel: (el, eventName, listener, opts)=>el.removeEventListener(eventName, listener, opts),
    ce: (eventName, opts)=>new CustomEvent(eventName, opts)
};
const $47990066fdbc3144$export$a8ba718ef458346 = (helpers)=>{
    Object.assign($47990066fdbc3144$export$2e40610e9d23bca6, helpers);
};
const $47990066fdbc3144$export$b4e7e6d61dbcd813 = (0, $kxuSp.BUILD).shadowDomShim && (0, $kxuSp.BUILD).shadowDom ? /*@__PURE__*/ (()=>($47990066fdbc3144$export$2a111da947c407d2.head.attachShadow + '').indexOf('[native') > -1)() : true;
const $47990066fdbc3144$export$b4b667f9f62821eb = /*@__PURE__*/ (()=>{
    let supportsListenerOptions = false;
    try {
        $47990066fdbc3144$export$2a111da947c407d2.addEventListener('e', null, Object.defineProperty({}, 'passive', {
            get () {
                supportsListenerOptions = true;
            }
        }));
    } catch (e) {}
    return supportsListenerOptions;
})();
const $47990066fdbc3144$export$2578fbb2d34e3823 = (v)=>Promise.resolve(v);
const $47990066fdbc3144$export$27b311cd1cb97100 = (0, $kxuSp.BUILD).constructableCSS ? /*@__PURE__*/ (()=>{
    try {
        new CSSStyleSheet();
        return typeof new CSSStyleSheet().replaceSync === 'function';
    } catch (e) {}
    return false;
})() : false;
const $47990066fdbc3144$var$queueDomReads = [];
const $47990066fdbc3144$var$queueDomWrites = [];
const $47990066fdbc3144$var$queueDomWritesLow = [];
const $47990066fdbc3144$var$queueTask = (queue, write)=>(cb)=>{
        queue.push(cb);
        if (!$47990066fdbc3144$var$queuePending) {
            $47990066fdbc3144$var$queuePending = true;
            if (write && $47990066fdbc3144$export$2e40610e9d23bca6.$flags$ & 4 /* PLATFORM_FLAGS.queueSync */ ) $47990066fdbc3144$export$bdd553fddd433dcb($47990066fdbc3144$var$flush);
            else $47990066fdbc3144$export$2e40610e9d23bca6.raf($47990066fdbc3144$var$flush);
        }
    };
const $47990066fdbc3144$var$consume = (queue)=>{
    for(let i = 0; i < queue.length; i++)try {
        queue[i](performance.now());
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e);
    }
    queue.length = 0;
};
const $47990066fdbc3144$var$consumeTimeout = (queue, timeout)=>{
    let i = 0;
    let ts = 0;
    while(i < queue.length && (ts = performance.now()) < timeout)try {
        queue[i++](ts);
    } catch (e) {
        $47990066fdbc3144$export$bf36f23bad3e1069(e);
    }
    if (i === queue.length) queue.length = 0;
    else if (i !== 0) queue.splice(0, i);
};
const $47990066fdbc3144$var$flush = ()=>{
    if ((0, $kxuSp.BUILD).asyncQueue) $47990066fdbc3144$var$queueCongestion++;
    // always force a bunch of medium callbacks to run, but still have
    // a throttle on how many can run in a certain time
    // DOM READS!!!
    $47990066fdbc3144$var$consume($47990066fdbc3144$var$queueDomReads);
    // DOM WRITES!!!
    if ((0, $kxuSp.BUILD).asyncQueue) {
        const timeout = ($47990066fdbc3144$export$2e40610e9d23bca6.$flags$ & 6 /* PLATFORM_FLAGS.queueMask */ ) === 2 /* PLATFORM_FLAGS.appLoaded */  ? performance.now() + 14 * Math.ceil($47990066fdbc3144$var$queueCongestion * 0.1) : Infinity;
        $47990066fdbc3144$var$consumeTimeout($47990066fdbc3144$var$queueDomWrites, timeout);
        $47990066fdbc3144$var$consumeTimeout($47990066fdbc3144$var$queueDomWritesLow, timeout);
        if ($47990066fdbc3144$var$queueDomWrites.length > 0) {
            $47990066fdbc3144$var$queueDomWritesLow.push(...$47990066fdbc3144$var$queueDomWrites);
            $47990066fdbc3144$var$queueDomWrites.length = 0;
        }
        if ($47990066fdbc3144$var$queuePending = $47990066fdbc3144$var$queueDomReads.length + $47990066fdbc3144$var$queueDomWrites.length + $47990066fdbc3144$var$queueDomWritesLow.length > 0) // still more to do yet, but we've run out of time
        // let's let this thing cool off and try again in the next tick
        $47990066fdbc3144$export$2e40610e9d23bca6.raf($47990066fdbc3144$var$flush);
        else $47990066fdbc3144$var$queueCongestion = 0;
    } else {
        $47990066fdbc3144$var$consume($47990066fdbc3144$var$queueDomWrites);
        if ($47990066fdbc3144$var$queuePending = $47990066fdbc3144$var$queueDomReads.length > 0) // still more to do yet, but we've run out of time
        // let's let this thing cool off and try again in the next tick
        $47990066fdbc3144$export$2e40610e9d23bca6.raf($47990066fdbc3144$var$flush);
    }
};
const $47990066fdbc3144$export$bdd553fddd433dcb = /*@__PURE__*/ (cb)=>$47990066fdbc3144$export$2578fbb2d34e3823().then(cb);
const $47990066fdbc3144$export$de6bea324e6d63f6 = /*@__PURE__*/ $47990066fdbc3144$var$queueTask($47990066fdbc3144$var$queueDomReads, false);
const $47990066fdbc3144$export$bbfc1321f142f72c = /*@__PURE__*/ $47990066fdbc3144$var$queueTask($47990066fdbc3144$var$queueDomWrites, true);

});
parcelRegister("kxuSp", function(module, exports) {

$parcel$export(module.exports, "BUILD", () => $ef3ed721cea257a1$export$455dbfd86f20b704);
$parcel$export(module.exports, "NAMESPACE", () => $ef3ed721cea257a1$export$6aad947bda0f3f46);
const $ef3ed721cea257a1$export$455dbfd86f20b704 = {
    allRenderFn: false,
    cmpDidLoad: true,
    cmpDidUnload: false,
    cmpDidUpdate: true,
    cmpDidRender: true,
    cmpWillLoad: true,
    cmpWillUpdate: true,
    cmpWillRender: true,
    connectedCallback: true,
    disconnectedCallback: true,
    element: true,
    event: true,
    hasRenderFn: true,
    lifecycle: true,
    hostListener: true,
    hostListenerTargetWindow: true,
    hostListenerTargetDocument: true,
    hostListenerTargetBody: true,
    hostListenerTargetParent: false,
    hostListenerTarget: true,
    member: true,
    method: true,
    mode: true,
    observeAttribute: true,
    prop: true,
    propMutable: true,
    reflect: true,
    scoped: true,
    shadowDom: true,
    slot: true,
    cssAnnotations: true,
    state: true,
    style: true,
    svg: true,
    updatable: true,
    vdomAttribute: true,
    vdomXlink: true,
    vdomClass: true,
    vdomFunctional: true,
    vdomKey: true,
    vdomListener: true,
    vdomRef: true,
    vdomPropOrAttr: true,
    vdomRender: true,
    vdomStyle: true,
    vdomText: true,
    watchCallback: true,
    taskQueue: true,
    hotModuleReplacement: false,
    isDebug: false,
    isDev: false,
    isTesting: false,
    hydrateServerSide: false,
    hydrateClientSide: false,
    lifecycleDOMEvents: false,
    lazyLoad: false,
    profile: false,
    slotRelocation: true,
    appendChildSlotFix: false,
    cloneNodeFix: false,
    hydratedAttribute: false,
    hydratedClass: true,
    safari10: false,
    scriptDataOpts: false,
    scopedSlotTextContentFix: false,
    shadowDomShim: false,
    slotChildNodesFix: false,
    invisiblePrehydration: true,
    propBoolean: true,
    propNumber: true,
    propString: true,
    cssVarShim: false,
    constructableCSS: true,
    cmpShouldUpdate: true,
    devTools: false,
    dynamicImportShim: false,
    shadowDelegatesFocus: true,
    initializeNextTick: false,
    asyncLoading: false,
    asyncQueue: false,
    transformTagName: false,
    attachStyles: true
};
const $ef3ed721cea257a1$export$6c0517834721cef7 = {};
const $ef3ed721cea257a1$export$6aad947bda0f3f46 = /* default */ 'app';

});

parcelRegister("fgFdQ", function(module, exports) {
module.exports = $parcel$import("cLMc7").then(()=>parcelRequire('bYeMH'));

});



parcelRegister("lLiTM", function(module, exports) {
"use strict";

var $fd7ca5a843f03722$var$protobuf = module.exports = (parcelRequire("8MpkV"));
$fd7ca5a843f03722$var$protobuf.build = "light";
/**
 * A node-style callback as used by {@link load} and {@link Root#load}.
 * @typedef LoadCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Root} [root] Root, if there hasn't been an error
 * @returns {undefined}
 */ /**
 * Loads one or multiple .proto or preprocessed .json files into a common root namespace and calls the callback.
 * @param {string|string[]} filename One or multiple files to load
 * @param {Root} root Root namespace, defaults to create a new one if omitted.
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 * @see {@link Root#load}
 */ function $fd7ca5a843f03722$var$load(filename, root, callback) {
    if (typeof root === "function") {
        callback = root;
        root = new $fd7ca5a843f03722$var$protobuf.Root();
    } else if (!root) root = new $fd7ca5a843f03722$var$protobuf.Root();
    return root.load(filename, callback);
}
/**
 * Loads one or multiple .proto or preprocessed .json files into a common root namespace and calls the callback.
 * @name load
 * @function
 * @param {string|string[]} filename One or multiple files to load
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 * @see {@link Root#load}
 * @variation 2
 */ // function load(filename:string, callback:LoadCallback):undefined
/**
 * Loads one or multiple .proto or preprocessed .json files into a common root namespace and returns a promise.
 * @name load
 * @function
 * @param {string|string[]} filename One or multiple files to load
 * @param {Root} [root] Root namespace, defaults to create a new one if omitted.
 * @returns {Promise<Root>} Promise
 * @see {@link Root#load}
 * @variation 3
 */ // function load(filename:string, [root:Root]):Promise<Root>
$fd7ca5a843f03722$var$protobuf.load = $fd7ca5a843f03722$var$load;
/**
 * Synchronously loads one or multiple .proto or preprocessed .json files into a common root namespace (node only).
 * @param {string|string[]} filename One or multiple files to load
 * @param {Root} [root] Root namespace, defaults to create a new one if omitted.
 * @returns {Root} Root namespace
 * @throws {Error} If synchronous fetching is not supported (i.e. in browsers) or if a file's syntax is invalid
 * @see {@link Root#loadSync}
 */ function $fd7ca5a843f03722$var$loadSync(filename, root) {
    if (!root) root = new $fd7ca5a843f03722$var$protobuf.Root();
    return root.loadSync(filename);
}
$fd7ca5a843f03722$var$protobuf.loadSync = $fd7ca5a843f03722$var$loadSync;

// Serialization
$fd7ca5a843f03722$var$protobuf.encoder = (parcelRequire("ekUKG"));

$fd7ca5a843f03722$var$protobuf.decoder = (parcelRequire("8D1oN"));

$fd7ca5a843f03722$var$protobuf.verifier = (parcelRequire("kfNH8"));

$fd7ca5a843f03722$var$protobuf.converter = (parcelRequire("iaLh4"));

// Reflection
$fd7ca5a843f03722$var$protobuf.ReflectionObject = (parcelRequire("eqXqI"));

$fd7ca5a843f03722$var$protobuf.Namespace = (parcelRequire("3keUm"));

$fd7ca5a843f03722$var$protobuf.Root = (parcelRequire("hjrO2"));

$fd7ca5a843f03722$var$protobuf.Enum = (parcelRequire("teZIn"));

$fd7ca5a843f03722$var$protobuf.Type = (parcelRequire("kPRSk"));

$fd7ca5a843f03722$var$protobuf.Field = (parcelRequire("fMEB1"));

$fd7ca5a843f03722$var$protobuf.OneOf = (parcelRequire("8DQkR"));

$fd7ca5a843f03722$var$protobuf.MapField = (parcelRequire("80tkS"));

$fd7ca5a843f03722$var$protobuf.Service = (parcelRequire("hqJin"));

$fd7ca5a843f03722$var$protobuf.Method = (parcelRequire("3lwwS"));

// Runtime
$fd7ca5a843f03722$var$protobuf.Message = (parcelRequire("gLmvK"));

$fd7ca5a843f03722$var$protobuf.wrappers = (parcelRequire("9C7Ox"));

// Utility
$fd7ca5a843f03722$var$protobuf.types = (parcelRequire("keBMp"));

$fd7ca5a843f03722$var$protobuf.util = (parcelRequire("jshGU"));
// Set up possibly cyclic reflection dependencies
$fd7ca5a843f03722$var$protobuf.ReflectionObject._configure($fd7ca5a843f03722$var$protobuf.Root);
$fd7ca5a843f03722$var$protobuf.Namespace._configure($fd7ca5a843f03722$var$protobuf.Type, $fd7ca5a843f03722$var$protobuf.Service, $fd7ca5a843f03722$var$protobuf.Enum);
$fd7ca5a843f03722$var$protobuf.Root._configure($fd7ca5a843f03722$var$protobuf.Type);
$fd7ca5a843f03722$var$protobuf.Field._configure($fd7ca5a843f03722$var$protobuf.Type);

});
parcelRegister("8MpkV", function(module, exports) {
"use strict";
var $664675b82ee8df1a$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $664675b82ee8df1a$var$protobuf.build = "minimal";

// Serialization
$664675b82ee8df1a$var$protobuf.Writer = (parcelRequire("3KUVy"));

$664675b82ee8df1a$var$protobuf.BufferWriter = (parcelRequire("axYUT"));

$664675b82ee8df1a$var$protobuf.Reader = (parcelRequire("hP5zC"));

$664675b82ee8df1a$var$protobuf.BufferReader = (parcelRequire("hVbTm"));

// Utility
$664675b82ee8df1a$var$protobuf.util = (parcelRequire("hf2LF"));

$664675b82ee8df1a$var$protobuf.rpc = (parcelRequire("kPAIY"));

$664675b82ee8df1a$var$protobuf.roots = (parcelRequire("38hgC"));
$664675b82ee8df1a$var$protobuf.configure = $664675b82ee8df1a$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $664675b82ee8df1a$var$configure() {
    $664675b82ee8df1a$var$protobuf.util._configure();
    $664675b82ee8df1a$var$protobuf.Writer._configure($664675b82ee8df1a$var$protobuf.BufferWriter);
    $664675b82ee8df1a$var$protobuf.Reader._configure($664675b82ee8df1a$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$664675b82ee8df1a$var$configure();

});
parcelRegister("3KUVy", function(module, exports) {
"use strict";
module.exports = $2bc1d392757dc2c2$var$Writer;

var $hf2LF = parcelRequire("hf2LF");
var $2bc1d392757dc2c2$var$BufferWriter; // cyclic
var $2bc1d392757dc2c2$var$LongBits = $hf2LF.LongBits, $2bc1d392757dc2c2$var$base64 = $hf2LF.base64, $2bc1d392757dc2c2$var$utf8 = $hf2LF.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $2bc1d392757dc2c2$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $2bc1d392757dc2c2$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $2bc1d392757dc2c2$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $2bc1d392757dc2c2$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $2bc1d392757dc2c2$var$Op($2bc1d392757dc2c2$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $2bc1d392757dc2c2$var$create = function create() {
    return $hf2LF.Buffer ? function create_buffer_setup() {
        return ($2bc1d392757dc2c2$var$Writer.create = function create_buffer() {
            return new $2bc1d392757dc2c2$var$BufferWriter();
        })();
    } : function create_array() {
        return new $2bc1d392757dc2c2$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $2bc1d392757dc2c2$var$Writer.create = $2bc1d392757dc2c2$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $2bc1d392757dc2c2$var$Writer.alloc = function alloc(size) {
    return new $hf2LF.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($hf2LF.Array !== Array) $2bc1d392757dc2c2$var$Writer.alloc = $hf2LF.pool($2bc1d392757dc2c2$var$Writer.alloc, $hf2LF.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $2bc1d392757dc2c2$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $2bc1d392757dc2c2$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $2bc1d392757dc2c2$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $2bc1d392757dc2c2$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $2bc1d392757dc2c2$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$2bc1d392757dc2c2$var$VarintOp.prototype = Object.create($2bc1d392757dc2c2$var$Op.prototype);
$2bc1d392757dc2c2$var$VarintOp.prototype.fn = $2bc1d392757dc2c2$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $2bc1d392757dc2c2$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.int32 = function write_int32(value) {
    return (value |= 0) < 0 ? this._push($2bc1d392757dc2c2$var$writeVarint64, 10, $2bc1d392757dc2c2$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $2bc1d392757dc2c2$var$writeVarint64(val, buf, pos) {
    var lo = val.lo, hi = val.hi;
    while(hi){
        buf[pos++] = lo & 127 | 128;
        lo = (lo >>> 7 | hi << 25) >>> 0;
        hi >>>= 7;
    }
    while(lo > 127){
        buf[pos++] = lo & 127 | 128;
        lo = lo >>> 7;
    }
    buf[pos++] = lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $2bc1d392757dc2c2$var$LongBits.from(value);
    return this._push($2bc1d392757dc2c2$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.int64 = $2bc1d392757dc2c2$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $2bc1d392757dc2c2$var$LongBits.from(value).zzEncode();
    return this._push($2bc1d392757dc2c2$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($2bc1d392757dc2c2$var$writeByte, 1, value ? 1 : 0);
};
function $2bc1d392757dc2c2$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($2bc1d392757dc2c2$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.sfixed32 = $2bc1d392757dc2c2$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $2bc1d392757dc2c2$var$LongBits.from(value);
    return this._push($2bc1d392757dc2c2$var$writeFixed32, 4, bits.lo)._push($2bc1d392757dc2c2$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2bc1d392757dc2c2$var$Writer.prototype.sfixed64 = $2bc1d392757dc2c2$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.float = function write_float(value) {
    return this._push($hf2LF.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.double = function write_double(value) {
    return this._push($hf2LF.float.writeDoubleLE, 8, value);
};
var $2bc1d392757dc2c2$var$writeBytes = $hf2LF.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($2bc1d392757dc2c2$var$writeByte, 1, 0);
    if ($hf2LF.isString(value)) {
        var buf = $2bc1d392757dc2c2$var$Writer.alloc(len = $2bc1d392757dc2c2$var$base64.length(value));
        $2bc1d392757dc2c2$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($2bc1d392757dc2c2$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.string = function write_string(value) {
    var len = $2bc1d392757dc2c2$var$utf8.length(value);
    return len ? this.uint32(len)._push($2bc1d392757dc2c2$var$utf8.write, len, value) : this._push($2bc1d392757dc2c2$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.fork = function fork() {
    this.states = new $2bc1d392757dc2c2$var$State(this);
    this.head = this.tail = new $2bc1d392757dc2c2$var$Op($2bc1d392757dc2c2$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $2bc1d392757dc2c2$var$Op($2bc1d392757dc2c2$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $2bc1d392757dc2c2$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $2bc1d392757dc2c2$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$2bc1d392757dc2c2$var$Writer._configure = function(BufferWriter_) {
    $2bc1d392757dc2c2$var$BufferWriter = BufferWriter_;
    $2bc1d392757dc2c2$var$Writer.create = $2bc1d392757dc2c2$var$create();
    $2bc1d392757dc2c2$var$BufferWriter._configure();
};

});
parcelRegister("hf2LF", function(module, exports) {
"use strict";
var $c8d5fc00154f529a$var$util = module.exports;

// used to return a Promise where callback is omitted
$c8d5fc00154f529a$var$util.asPromise = (parcelRequire("6TUyK"));

// converts to / from base64 encoded strings
$c8d5fc00154f529a$var$util.base64 = (parcelRequire("ljrw7"));

// base class of rpc.Service
$c8d5fc00154f529a$var$util.EventEmitter = (parcelRequire("cTpsI"));

// float handling accross browsers
$c8d5fc00154f529a$var$util.float = (parcelRequire("b8LQB"));

// converts to / from utf8 encoded strings
$c8d5fc00154f529a$var$util.utf8 = (parcelRequire("1x6UU"));

// provides a node-like buffer pool in the browser
$c8d5fc00154f529a$var$util.pool = (parcelRequire("hU2wx"));

// utility to work with the low and high bits of a 64 bit value
$c8d5fc00154f529a$var$util.LongBits = (parcelRequire("5S9hy"));
/**
 * Tests if the specified key can affect object prototypes.
 * @memberof util
 * @param {string} key Key to test
 * @returns {boolean} `true` if the key is unsafe
 */ function $c8d5fc00154f529a$var$isUnsafeProperty(key) {
    return key === "__proto__" || key === "prototype" || key === "constructor";
}
$c8d5fc00154f529a$var$util.isUnsafeProperty = $c8d5fc00154f529a$var$isUnsafeProperty;
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $c8d5fc00154f529a$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $c8d5fc00154f529a$var$util.global = $c8d5fc00154f529a$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $c8d5fc00154f529a$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $c8d5fc00154f529a$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $c8d5fc00154f529a$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $c8d5fc00154f529a$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $c8d5fc00154f529a$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $c8d5fc00154f529a$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $c8d5fc00154f529a$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && Object.hasOwnProperty.call(obj, prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $c8d5fc00154f529a$var$util.Buffer = function() {
    try {
        var Buffer = $c8d5fc00154f529a$var$util.global.Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$c8d5fc00154f529a$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$c8d5fc00154f529a$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $c8d5fc00154f529a$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $c8d5fc00154f529a$var$util.Buffer ? $c8d5fc00154f529a$var$util._Buffer_allocUnsafe(sizeOrArray) : new $c8d5fc00154f529a$var$util.Array(sizeOrArray) : $c8d5fc00154f529a$var$util.Buffer ? $c8d5fc00154f529a$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $c8d5fc00154f529a$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;

/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $c8d5fc00154f529a$var$util.Long = /* istanbul ignore next */ $c8d5fc00154f529a$var$util.global.dcodeIO && /* istanbul ignore next */ $c8d5fc00154f529a$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $c8d5fc00154f529a$var$util.global.Long || function() {
    try {
        var Long = (parcelRequire("lkntF"));
        return Long && Long.isLong ? Long : null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $c8d5fc00154f529a$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $c8d5fc00154f529a$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $c8d5fc00154f529a$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $c8d5fc00154f529a$var$util.longToHash = function longToHash(value) {
    return value ? $c8d5fc00154f529a$var$util.LongBits.from(value).toHash() : $c8d5fc00154f529a$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $c8d5fc00154f529a$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $c8d5fc00154f529a$var$util.LongBits.fromHash(hash);
    if ($c8d5fc00154f529a$var$util.Long) return $c8d5fc00154f529a$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {...(Object.<string,*>|boolean)} src Source objects, optionally followed by an `ifNotSet` flag
 * @returns {Object.<string,*>} Destination object
 */ function $c8d5fc00154f529a$var$merge(dst) {
    var ifNotSet = typeof arguments[arguments.length - 1] === "boolean", limit = ifNotSet ? arguments.length - 1 : arguments.length;
    ifNotSet = ifNotSet && arguments[arguments.length - 1];
    for(var a = 1; a < limit; ++a){
        var src = arguments[a];
        if (!src) continue;
        for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (!$c8d5fc00154f529a$var$isUnsafeProperty(keys[i]) && (dst[keys[i]] === undefined || !ifNotSet)) dst[keys[i]] = src[keys[i]];
    }
    return dst;
}
$c8d5fc00154f529a$var$util.merge = $c8d5fc00154f529a$var$merge;
/**
 * Schema declaration nesting limit.
 * @memberof util
 * @type {number}
 */ $c8d5fc00154f529a$var$util.nestingLimit = 32; // protoc: MaxMessageDeclarationNestingDepth
/**
 * Recursion limit.
 * @memberof util
 * @type {number}
 */ $c8d5fc00154f529a$var$util.recursionLimit = 100; // protoc: CodedInputStream::default_recursion_limit_
/**
 * Makes a property safe for assignment as an own property.
 * @memberof util
 * @param {Object.<string,*>} obj Object
 * @param {string} key Property key
 * @returns {undefined}
 */ $c8d5fc00154f529a$var$util.makeProp = function makeProp(obj, key) {
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true
    });
};
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $c8d5fc00154f529a$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $c8d5fc00154f529a$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $c8d5fc00154f529a$var$merge(this, properties);
    }
    CustomError.prototype = Object.create(Error.prototype, {
        constructor: {
            value: CustomError,
            writable: true,
            enumerable: false,
            configurable: true
        },
        name: {
            get: function get() {
                return name;
            },
            set: undefined,
            enumerable: false,
            // configurable: false would accurately preserve the behavior of
            // the original, but I'm guessing that was not intentional.
            // For an actual error subclass, this property would
            // be configurable.
            configurable: true
        },
        toString: {
            value: function value() {
                return this.name + ": " + this.message;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    return CustomError;
}
$c8d5fc00154f529a$var$util.newError = $c8d5fc00154f529a$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $c8d5fc00154f529a$var$util.ProtocolError = $c8d5fc00154f529a$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $c8d5fc00154f529a$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $c8d5fc00154f529a$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $c8d5fc00154f529a$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$c8d5fc00154f529a$var$util._configure = function() {
    var Buffer = $c8d5fc00154f529a$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $c8d5fc00154f529a$var$util._Buffer_from = $c8d5fc00154f529a$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $c8d5fc00154f529a$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $c8d5fc00154f529a$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRegister("6TUyK", function(module, exports) {
"use strict";
module.exports = $5063c0aab3220c21$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $5063c0aab3220c21$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRegister("ljrw7", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $f840b7a2526f15a0$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $f840b7a2526f15a0$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $f840b7a2526f15a0$var$b64 = new Array(64);
// Base64 decoding table
var $f840b7a2526f15a0$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $f840b7a2526f15a0$var$i = 0; $f840b7a2526f15a0$var$i < 64;)$f840b7a2526f15a0$var$s64[$f840b7a2526f15a0$var$b64[$f840b7a2526f15a0$var$i] = $f840b7a2526f15a0$var$i < 26 ? $f840b7a2526f15a0$var$i + 65 : $f840b7a2526f15a0$var$i < 52 ? $f840b7a2526f15a0$var$i + 71 : $f840b7a2526f15a0$var$i < 62 ? $f840b7a2526f15a0$var$i - 4 : $f840b7a2526f15a0$var$i - 59 | 43] = $f840b7a2526f15a0$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $f840b7a2526f15a0$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $f840b7a2526f15a0$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $f840b7a2526f15a0$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $f840b7a2526f15a0$var$b64[t | b >> 6];
                chunk[i++] = $f840b7a2526f15a0$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $f840b7a2526f15a0$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $f840b7a2526f15a0$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $f840b7a2526f15a0$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $f840b7a2526f15a0$var$s64[c]) === undefined) throw Error($f840b7a2526f15a0$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($f840b7a2526f15a0$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $f840b7a2526f15a0$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRegister("cTpsI", function(module, exports) {
"use strict";
module.exports = $962e5f58319de5e6$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $962e5f58319de5e6$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = Object.create(null);
}
/**
 * Event listener as used by {@link util.EventEmitter}.
 * @typedef EventEmitterListener
 * @type {function}
 * @param {...*} args Arguments
 * @returns {undefined}
 */ /**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {EventEmitterListener} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {this} `this`
 */ $962e5f58319de5e6$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {EventEmitterListener} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {this} `this`
 */ $962e5f58319de5e6$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = Object.create(null);
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        if (!listeners) return this;
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {this} `this`
 */ $962e5f58319de5e6$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRegister("b8LQB", function(module, exports) {
"use strict";
module.exports = $81c58e96688a18b7$var$factory($81c58e96688a18b7$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $81c58e96688a18b7$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $81c58e96688a18b7$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $81c58e96688a18b7$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $81c58e96688a18b7$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $81c58e96688a18b7$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $81c58e96688a18b7$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $81c58e96688a18b7$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $81c58e96688a18b7$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $81c58e96688a18b7$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $81c58e96688a18b7$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $81c58e96688a18b7$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $81c58e96688a18b7$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $81c58e96688a18b7$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRegister("1x6UU", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $11de3d165fc704f0$var$utf8 = module.exports, $11de3d165fc704f0$var$replacementCharCode = 0xFFFD; // U+FFFD REPLACEMENT CHARACTER
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $11de3d165fc704f0$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $11de3d165fc704f0$var$utf8.read = function utf8_read(buffer, start, end) {
    if (end - start < 1) return "";
    // Batch code units and flush via String.fromCharCode.apply in 8192-unit
    // chunks to avoid the per-character ConsString buildup of `str += ...`.
    var parts = null, chunk = [], i = 0, t, t2, c2, c3;
    while(start < end){
        t = buffer[start++];
        if (t <= 0x7F) chunk[i++] = t;
        else if (t >= 0xC0 && t < 0xE0) {
            c2 = (t & 0x1F) << 6 | buffer[start++] & 0x3F;
            chunk[i++] = c2 >= 0x80 ? c2 : $11de3d165fc704f0$var$replacementCharCode;
        } else if (t >= 0xE0 && t < 0xF0) {
            c3 = (t & 0xF) << 12 | (buffer[start++] & 0x3F) << 6 | buffer[start++] & 0x3F;
            chunk[i++] = c3 >= 0x800 ? c3 : $11de3d165fc704f0$var$replacementCharCode;
        } else if (t >= 0xF0) {
            t2 = (t & 7) << 18 | (buffer[start++] & 0x3F) << 12 | (buffer[start++] & 0x3F) << 6 | buffer[start++] & 0x3F;
            if (t2 < 0x10000 || t2 > 0x10FFFF) chunk[i++] = $11de3d165fc704f0$var$replacementCharCode;
            else {
                t2 -= 0x10000;
                chunk[i++] = 0xD800 + (t2 >> 10);
                chunk[i++] = 0xDC00 + (t2 & 0x3FF);
            }
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk.slice(0, i)));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $11de3d165fc704f0$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRegister("hU2wx", function(module, exports) {
"use strict";
module.exports = $d0899fc8295f4c1e$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $d0899fc8295f4c1e$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRegister("5S9hy", function(module, exports) {
"use strict";
module.exports = $44693224ff456c0c$var$LongBits;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $44693224ff456c0c$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $44693224ff456c0c$var$zero = $44693224ff456c0c$var$LongBits.zero = new $44693224ff456c0c$var$LongBits(0, 0);
$44693224ff456c0c$var$zero.toNumber = function() {
    return 0;
};
$44693224ff456c0c$var$zero.zzEncode = $44693224ff456c0c$var$zero.zzDecode = function() {
    return this;
};
$44693224ff456c0c$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $44693224ff456c0c$var$zeroHash = $44693224ff456c0c$var$LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $44693224ff456c0c$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $44693224ff456c0c$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $44693224ff456c0c$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $44693224ff456c0c$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $44693224ff456c0c$var$LongBits.fromNumber(value);
    if ($hf2LF.isString(value)) {
        /* istanbul ignore else */ if ($hf2LF.Long) value = $hf2LF.Long.fromString(value);
        else return $44693224ff456c0c$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $44693224ff456c0c$var$LongBits(value.low >>> 0, value.high >>> 0) : $44693224ff456c0c$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $44693224ff456c0c$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $44693224ff456c0c$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $hf2LF.Long ? new $hf2LF.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $44693224ff456c0c$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $44693224ff456c0c$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $44693224ff456c0c$var$zeroHash) return $44693224ff456c0c$var$zero;
    return new $44693224ff456c0c$var$LongBits(($44693224ff456c0c$var$charCodeAt.call(hash, 0) | $44693224ff456c0c$var$charCodeAt.call(hash, 1) << 8 | $44693224ff456c0c$var$charCodeAt.call(hash, 2) << 16 | $44693224ff456c0c$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($44693224ff456c0c$var$charCodeAt.call(hash, 4) | $44693224ff456c0c$var$charCodeAt.call(hash, 5) << 8 | $44693224ff456c0c$var$charCodeAt.call(hash, 6) << 16 | $44693224ff456c0c$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $44693224ff456c0c$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $44693224ff456c0c$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $44693224ff456c0c$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $44693224ff456c0c$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});

parcelRegister("lkntF", function(module, exports) {
// GENERATED FILE. DO NOT EDIT.
(function(global, factory) {
    function preferDefault(exports1) {
        return exports1.default || exports1;
    }
    if (typeof define === "function" && define.amd) define([], function() {
        var exports1 = {};
        factory(exports1);
        return preferDefault(exports1);
    });
    else {
        factory(module.exports);
        module.exports = preferDefault(module.exports);
    }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : module.exports, function(_exports) {
    "use strict";
    Object.defineProperty(_exports, "__esModule", {
        value: true
    });
    _exports.default = void 0;
    /**
     * @license
     * Copyright 2009 The Closure Library Authors
     * Copyright 2020 Daniel Wirtz / The long.js Authors.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *     http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * SPDX-License-Identifier: Apache-2.0
     */ // WebAssembly optimizations to do native i64 multiplication and divide
    var wasm = null;
    try {
        wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
            // \0asm
            0,
            97,
            115,
            109,
            // version 1
            1,
            0,
            0,
            0,
            // section "type"
            1,
            13,
            2,
            // 0, () => i32
            96,
            0,
            1,
            127,
            // 1, (i32, i32, i32, i32) => i32
            96,
            4,
            127,
            127,
            127,
            127,
            1,
            127,
            // section "function"
            3,
            7,
            6,
            // 0, type 0
            0,
            // 1, type 1
            1,
            // 2, type 1
            1,
            // 3, type 1
            1,
            // 4, type 1
            1,
            // 5, type 1
            1,
            // section "global"
            6,
            6,
            1,
            // 0, "high", mutable i32
            127,
            1,
            65,
            0,
            11,
            // section "export"
            7,
            50,
            6,
            // 0, "mul"
            3,
            109,
            117,
            108,
            0,
            1,
            // 1, "div_s"
            5,
            100,
            105,
            118,
            95,
            115,
            0,
            2,
            // 2, "div_u"
            5,
            100,
            105,
            118,
            95,
            117,
            0,
            3,
            // 3, "rem_s"
            5,
            114,
            101,
            109,
            95,
            115,
            0,
            4,
            // 4, "rem_u"
            5,
            114,
            101,
            109,
            95,
            117,
            0,
            5,
            // 5, "get_high"
            8,
            103,
            101,
            116,
            95,
            104,
            105,
            103,
            104,
            0,
            0,
            // section "code"
            10,
            191,
            1,
            6,
            // 0, "get_high"
            4,
            0,
            35,
            0,
            11,
            // 1, "mul"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            126,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 2, "div_s"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            127,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 3, "div_u"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            128,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 4, "rem_s"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            129,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            // 5, "rem_u"
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            130,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11
        ])), {}).exports;
    } catch  {
    // no wasm support :(
    }
    /**
     * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
     *  See the from* functions below for more convenient ways of constructing Longs.
     * @exports Long
     * @class A Long class for representing a 64 bit two's-complement integer value.
     * @param {number} low The low (signed) 32 bits of the long
     * @param {number} high The high (signed) 32 bits of the long
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @constructor
     */ function Long(low, high, unsigned) {
        /**
       * The low 32 bits as a signed value.
       * @type {number}
       */ this.low = low | 0;
        /**
       * The high 32 bits as a signed value.
       * @type {number}
       */ this.high = high | 0;
        /**
       * Whether unsigned or not.
       * @type {boolean}
       */ this.unsigned = !!unsigned;
    }
    // The internal representation of a long is the two given signed, 32-bit values.
    // We use 32-bit pieces because these are the size of integers on which
    // Javascript performs bit-operations.  For operations like addition and
    // multiplication, we split each number into 16 bit pieces, which can easily be
    // multiplied within Javascript's floating-point representation without overflow
    // or change in sign.
    //
    // In the algorithms below, we frequently reduce the negative case to the
    // positive case by negating the input(s) and then post-processing the result.
    // Note that we must ALWAYS check specially whether those values are MIN_VALUE
    // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
    // a positive number, it overflows back into a negative).  Not handling this
    // case would often result in infinite recursion.
    //
    // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
    // methods on which they depend.
    /**
     * An indicator used to reliably determine if an object is a Long or not.
     * @type {boolean}
     * @const
     * @private
     */ Long.prototype.__isLong__;
    Object.defineProperty(Long.prototype, "__isLong__", {
        value: true
    });
    /**
     * @function
     * @param {*} obj Object
     * @returns {boolean}
     * @inner
     */ function isLong(obj) {
        return (obj && obj["__isLong__"]) === true;
    }
    /**
     * @function
     * @param {*} value number
     * @returns {number}
     * @inner
     */ function ctz32(value) {
        var c = Math.clz32(value & -value);
        return value ? 31 - c : c;
    }
    /**
     * Tests if the specified object is a Long.
     * @function
     * @param {*} obj Object
     * @returns {boolean}
     */ Long.isLong = isLong;
    /**
     * A cache of the Long representations of small integer values.
     * @type {!Object}
     * @inner
     */ var INT_CACHE = {};
    /**
     * A cache of the Long representations of small unsigned integer values.
     * @type {!Object}
     * @inner
     */ var UINT_CACHE = {};
    /**
     * @param {number} value
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromInt(value, unsigned) {
        var obj, cachedObj, cache;
        if (unsigned) {
            value >>>= 0;
            if (cache = 0 <= value && value < 256) {
                cachedObj = UINT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = fromBits(value, 0, true);
            if (cache) UINT_CACHE[value] = obj;
            return obj;
        } else {
            value |= 0;
            if (cache = -128 <= value && value < 128) {
                cachedObj = INT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = fromBits(value, value < 0 ? -1 : 0, false);
            if (cache) INT_CACHE[value] = obj;
            return obj;
        }
    }
    /**
     * Returns a Long representing the given 32 bit integer value.
     * @function
     * @param {number} value The 32 bit integer in question
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long} The corresponding Long value
     */ Long.fromInt = fromInt;
    /**
     * @param {number} value
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromNumber(value, unsigned) {
        if (isNaN(value)) return unsigned ? UZERO : ZERO;
        if (unsigned) {
            if (value < 0) return UZERO;
            if (value >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
        } else {
            if (value <= -TWO_PWR_63_DBL) return MIN_VALUE;
            if (value + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
        }
        if (value < 0) return fromNumber(-value, unsigned).neg();
        return fromBits(value % TWO_PWR_32_DBL | 0, value / TWO_PWR_32_DBL | 0, unsigned);
    }
    /**
     * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
     * @function
     * @param {number} value The number in question
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long} The corresponding Long value
     */ Long.fromNumber = fromNumber;
    /**
     * @param {number} lowBits
     * @param {number} highBits
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromBits(lowBits, highBits, unsigned) {
        return new Long(lowBits, highBits, unsigned);
    }
    /**
     * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
     *  assumed to use 32 bits.
     * @function
     * @param {number} lowBits The low 32 bits
     * @param {number} highBits The high 32 bits
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long} The corresponding Long value
     */ Long.fromBits = fromBits;
    /**
     * @function
     * @param {number} base
     * @param {number} exponent
     * @returns {number}
     * @inner
     */ var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
    /**
     * @param {string} str
     * @param {(boolean|number)=} unsigned
     * @param {number=} radix
     * @returns {!Long}
     * @inner
     */ function fromString(str, unsigned, radix) {
        if (str.length === 0) throw Error("empty string");
        if (typeof unsigned === "number") {
            // For goog.math.long compatibility
            radix = unsigned;
            unsigned = false;
        } else unsigned = !!unsigned;
        if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return unsigned ? UZERO : ZERO;
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError("radix");
        var p;
        if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
        else if (p === 0) return fromString(str.substring(1), unsigned, radix).neg();
        // Do several (8) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = fromNumber(pow_dbl(radix, 8));
        var result = ZERO;
        for(var i = 0; i < str.length; i += 8){
            var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
            if (size < 8) {
                var power = fromNumber(pow_dbl(radix, size));
                result = result.mul(power).add(fromNumber(value));
            } else {
                result = result.mul(radixToPower);
                result = result.add(fromNumber(value));
            }
        }
        result.unsigned = unsigned;
        return result;
    }
    /**
     * Returns a Long representation of the given string, written using the specified radix.
     * @function
     * @param {string} str The textual representation of the Long
     * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
     * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
     * @returns {!Long} The corresponding Long value
     */ Long.fromString = fromString;
    /**
     * @function
     * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
     * @param {boolean=} unsigned
     * @returns {!Long}
     * @inner
     */ function fromValue(val, unsigned) {
        if (typeof val === "number") return fromNumber(val, unsigned);
        if (typeof val === "string") return fromString(val, unsigned);
        // Throws for non-objects, converts non-instanceof Long:
        return fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
    }
    /**
     * Converts the specified value to a Long using the appropriate from* function for its type.
     * @function
     * @param {!Long|number|bigint|string|!{low: number, high: number, unsigned: boolean}} val Value
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {!Long}
     */ Long.fromValue = fromValue;
    // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
    // no runtime penalty for these.
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_16_DBL = 65536;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_24_DBL = 16777216;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
    /**
     * @type {number}
     * @const
     * @inner
     */ var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
    /**
     * @type {!Long}
     * @const
     * @inner
     */ var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
    /**
     * @type {!Long}
     * @inner
     */ var ZERO = fromInt(0);
    /**
     * Signed zero.
     * @type {!Long}
     */ Long.ZERO = ZERO;
    /**
     * @type {!Long}
     * @inner
     */ var UZERO = fromInt(0, true);
    /**
     * Unsigned zero.
     * @type {!Long}
     */ Long.UZERO = UZERO;
    /**
     * @type {!Long}
     * @inner
     */ var ONE = fromInt(1);
    /**
     * Signed one.
     * @type {!Long}
     */ Long.ONE = ONE;
    /**
     * @type {!Long}
     * @inner
     */ var UONE = fromInt(1, true);
    /**
     * Unsigned one.
     * @type {!Long}
     */ Long.UONE = UONE;
    /**
     * @type {!Long}
     * @inner
     */ var NEG_ONE = fromInt(-1);
    /**
     * Signed negative one.
     * @type {!Long}
     */ Long.NEG_ONE = NEG_ONE;
    /**
     * @type {!Long}
     * @inner
     */ var MAX_VALUE = fromBits(-1, 2147483647, false);
    /**
     * Maximum signed value.
     * @type {!Long}
     */ Long.MAX_VALUE = MAX_VALUE;
    /**
     * @type {!Long}
     * @inner
     */ var MAX_UNSIGNED_VALUE = fromBits(-1, -1, true);
    /**
     * Maximum unsigned value.
     * @type {!Long}
     */ Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
    /**
     * @type {!Long}
     * @inner
     */ var MIN_VALUE = fromBits(0, -2147483648, false);
    /**
     * Minimum signed value.
     * @type {!Long}
     */ Long.MIN_VALUE = MIN_VALUE;
    /**
     * @alias Long.prototype
     * @inner
     */ var LongPrototype = Long.prototype;
    /**
     * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
     * @this {!Long}
     * @returns {number}
     */ LongPrototype.toInt = function toInt() {
        return this.unsigned ? this.low >>> 0 : this.low;
    };
    /**
     * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
     * @this {!Long}
     * @returns {number}
     */ LongPrototype.toNumber = function toNumber() {
        if (this.unsigned) return (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0);
        return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
    };
    /**
     * Converts the Long to a string written in the specified radix.
     * @this {!Long}
     * @param {number=} radix Radix (2-36), defaults to 10
     * @returns {string}
     * @override
     * @throws {RangeError} If `radix` is out of range
     */ LongPrototype.toString = function toString(radix) {
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError("radix");
        if (this.isZero()) return "0";
        if (this.isNegative()) {
            // Unsigned Longs are never negative
            if (this.eq(MIN_VALUE)) {
                // We need to change the Long value before it can be negated, so we remove
                // the bottom-most digit in this base and then recurse to do the rest.
                var radixLong = fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
                return div.toString(radix) + rem1.toInt().toString(radix);
            } else return "-" + this.neg().toString(radix);
        }
        // Do several (6) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned), rem = this;
        var result = "";
        while(true){
            var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
            rem = remDiv;
            if (rem.isZero()) return digits + result;
            else {
                while(digits.length < 6)digits = "0" + digits;
                result = "" + digits + result;
            }
        }
    };
    /**
     * Gets the high 32 bits as a signed integer.
     * @this {!Long}
     * @returns {number} Signed high bits
     */ LongPrototype.getHighBits = function getHighBits() {
        return this.high;
    };
    /**
     * Gets the high 32 bits as an unsigned integer.
     * @this {!Long}
     * @returns {number} Unsigned high bits
     */ LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
        return this.high >>> 0;
    };
    /**
     * Gets the low 32 bits as a signed integer.
     * @this {!Long}
     * @returns {number} Signed low bits
     */ LongPrototype.getLowBits = function getLowBits() {
        return this.low;
    };
    /**
     * Gets the low 32 bits as an unsigned integer.
     * @this {!Long}
     * @returns {number} Unsigned low bits
     */ LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
        return this.low >>> 0;
    };
    /**
     * Gets the number of bits needed to represent the absolute value of this Long.
     * @this {!Long}
     * @returns {number}
     */ LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
        if (this.isNegative()) // Unsigned Longs are never negative
        return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
        var val = this.high != 0 ? this.high : this.low;
        for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
        return this.high != 0 ? bit + 33 : bit + 1;
    };
    /**
     * Tests if this Long can be safely represented as a JavaScript number.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isSafeInteger = function isSafeInteger() {
        // 2^53-1 is the maximum safe value
        var top11Bits = this.high >> 21;
        // [0, 2^53-1]
        if (!top11Bits) return true;
        // > 2^53-1
        if (this.unsigned) return false;
        // [-2^53, -1] except -2^53
        return top11Bits === -1 && !(this.low === 0 && this.high === -2097152);
    };
    /**
     * Tests if this Long's value equals zero.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isZero = function isZero() {
        return this.high === 0 && this.low === 0;
    };
    /**
     * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
     * @returns {boolean}
     */ LongPrototype.eqz = LongPrototype.isZero;
    /**
     * Tests if this Long's value is negative.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isNegative = function isNegative() {
        return !this.unsigned && this.high < 0;
    };
    /**
     * Tests if this Long's value is positive or zero.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isPositive = function isPositive() {
        return this.unsigned || this.high >= 0;
    };
    /**
     * Tests if this Long's value is odd.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isOdd = function isOdd() {
        return (this.low & 1) === 1;
    };
    /**
     * Tests if this Long's value is even.
     * @this {!Long}
     * @returns {boolean}
     */ LongPrototype.isEven = function isEven() {
        return (this.low & 1) === 0;
    };
    /**
     * Tests if this Long's value equals the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.equals = function equals(other) {
        if (!isLong(other)) other = fromValue(other);
        if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
        return this.high === other.high && this.low === other.low;
    };
    /**
     * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.eq = LongPrototype.equals;
    /**
     * Tests if this Long's value differs from the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.notEquals = function notEquals(other) {
        return !this.eq(/* validates */ other);
    };
    /**
     * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.neq = LongPrototype.notEquals;
    /**
     * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.ne = LongPrototype.notEquals;
    /**
     * Tests if this Long's value is less than the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lessThan = function lessThan(other) {
        return this.comp(/* validates */ other) < 0;
    };
    /**
     * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lt = LongPrototype.lessThan;
    /**
     * Tests if this Long's value is less than or equal the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
        return this.comp(/* validates */ other) <= 0;
    };
    /**
     * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.lte = LongPrototype.lessThanOrEqual;
    /**
     * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.le = LongPrototype.lessThanOrEqual;
    /**
     * Tests if this Long's value is greater than the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.greaterThan = function greaterThan(other) {
        return this.comp(/* validates */ other) > 0;
    };
    /**
     * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.gt = LongPrototype.greaterThan;
    /**
     * Tests if this Long's value is greater than or equal the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
        return this.comp(/* validates */ other) >= 0;
    };
    /**
     * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.gte = LongPrototype.greaterThanOrEqual;
    /**
     * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {boolean}
     */ LongPrototype.ge = LongPrototype.greaterThanOrEqual;
    /**
     * Compares this Long's value with the specified's.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other value
     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
     *  if the given one is greater
     */ LongPrototype.compare = function compare(other) {
        if (!isLong(other)) other = fromValue(other);
        if (this.eq(other)) return 0;
        var thisNeg = this.isNegative(), otherNeg = other.isNegative();
        if (thisNeg && !otherNeg) return -1;
        if (!thisNeg && otherNeg) return 1;
        // At this point the sign bits are the same
        if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
        // Both are positive if at least one is unsigned
        return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
    };
    /**
     * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
     * @function
     * @param {!Long|number|bigint|string} other Other value
     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
     *  if the given one is greater
     */ LongPrototype.comp = LongPrototype.compare;
    /**
     * Negates this Long's value.
     * @this {!Long}
     * @returns {!Long} Negated Long
     */ LongPrototype.negate = function negate() {
        if (!this.unsigned && this.eq(MIN_VALUE)) return MIN_VALUE;
        return this.not().add(ONE);
    };
    /**
     * Negates this Long's value. This is an alias of {@link Long#negate}.
     * @function
     * @returns {!Long} Negated Long
     */ LongPrototype.neg = LongPrototype.negate;
    /**
     * Returns the sum of this and the specified Long.
     * @this {!Long}
     * @param {!Long|number|bigint|string} addend Addend
     * @returns {!Long} Sum
     */ LongPrototype.add = function add(addend) {
        if (!isLong(addend)) addend = fromValue(addend);
        // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xffff;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xffff;
        var b48 = addend.high >>> 16;
        var b32 = addend.high & 0xffff;
        var b16 = addend.low >>> 16;
        var b00 = addend.low & 0xffff;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 + b00;
        c16 += c00 >>> 16;
        c00 &= 0xffff;
        c16 += a16 + b16;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c32 += a32 + b32;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c48 += a48 + b48;
        c48 &= 0xffff;
        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
     * Returns the difference of this and the specified Long.
     * @this {!Long}
     * @param {!Long|number|bigint|string} subtrahend Subtrahend
     * @returns {!Long} Difference
     */ LongPrototype.subtract = function subtract(subtrahend) {
        if (!isLong(subtrahend)) subtrahend = fromValue(subtrahend);
        return this.add(subtrahend.neg());
    };
    /**
     * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
     * @function
     * @param {!Long|number|bigint|string} subtrahend Subtrahend
     * @returns {!Long} Difference
     */ LongPrototype.sub = LongPrototype.subtract;
    /**
     * Returns the product of this and the specified Long.
     * @this {!Long}
     * @param {!Long|number|bigint|string} multiplier Multiplier
     * @returns {!Long} Product
     */ LongPrototype.multiply = function multiply(multiplier) {
        if (this.isZero()) return this;
        if (!isLong(multiplier)) multiplier = fromValue(multiplier);
        // use wasm support if present
        if (wasm) {
            var low = wasm["mul"](this.low, this.high, multiplier.low, multiplier.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        if (multiplier.isZero()) return this.unsigned ? UZERO : ZERO;
        if (this.eq(MIN_VALUE)) return multiplier.isOdd() ? MIN_VALUE : ZERO;
        if (multiplier.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
        if (this.isNegative()) {
            if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
            else return this.neg().mul(multiplier).neg();
        } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
        // If both longs are small, use float multiplication
        if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24)) return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
        // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
        // We can skip products that would overflow.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xffff;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xffff;
        var b48 = multiplier.high >>> 16;
        var b32 = multiplier.high & 0xffff;
        var b16 = multiplier.low >>> 16;
        var b00 = multiplier.low & 0xffff;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 * b00;
        c16 += c00 >>> 16;
        c00 &= 0xffff;
        c16 += a16 * b00;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c16 += a00 * b16;
        c32 += c16 >>> 16;
        c16 &= 0xffff;
        c32 += a32 * b00;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c32 += a16 * b16;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c32 += a00 * b32;
        c48 += c32 >>> 16;
        c32 &= 0xffff;
        c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
        c48 &= 0xffff;
        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
     * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
     * @function
     * @param {!Long|number|bigint|string} multiplier Multiplier
     * @returns {!Long} Product
     */ LongPrototype.mul = LongPrototype.multiply;
    /**
     * Returns this Long divided by the specified. The result is signed if this Long is signed or
     *  unsigned if this Long is unsigned.
     * @this {!Long}
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Quotient
     */ LongPrototype.divide = function divide(divisor) {
        if (!isLong(divisor)) divisor = fromValue(divisor);
        if (divisor.isZero()) throw Error("division by zero");
        // use wasm support if present
        if (wasm) {
            // guard against signed division overflow: the largest
            // negative number / -1 would be 1 larger than the largest
            // positive number, due to two's complement.
            if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
            return this;
            var low = (this.unsigned ? wasm["div_u"] : wasm["div_s"])(this.low, this.high, divisor.low, divisor.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        if (this.isZero()) return this.unsigned ? UZERO : ZERO;
        var approx, rem, res;
        if (!this.unsigned) {
            // This section is only relevant for signed longs and is derived from the
            // closure library as a whole.
            if (this.eq(MIN_VALUE)) {
                if (divisor.eq(ONE) || divisor.eq(NEG_ONE)) return MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
                else if (divisor.eq(MIN_VALUE)) return ONE;
                else {
                    // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                    var halfThis = this.shr(1);
                    approx = halfThis.div(divisor).shl(1);
                    if (approx.eq(ZERO)) return divisor.isNegative() ? ONE : NEG_ONE;
                    else {
                        rem = this.sub(divisor.mul(approx));
                        res = approx.add(rem.div(divisor));
                        return res;
                    }
                }
            } else if (divisor.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
            if (this.isNegative()) {
                if (divisor.isNegative()) return this.neg().div(divisor.neg());
                return this.neg().div(divisor).neg();
            } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
            res = ZERO;
        } else {
            // The algorithm below has not been made for unsigned longs. It's therefore
            // required to take special care of the MSB prior to running it.
            if (!divisor.unsigned) divisor = divisor.toUnsigned();
            if (divisor.gt(this)) return UZERO;
            if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
            return UONE;
            res = UZERO;
        }
        // Repeat the following until the remainder is less than other:  find a
        // floating-point that approximates remainder / other *from below*, add this
        // into the result, and subtract it from the remainder.  It is critical that
        // the approximate value is less than or equal to the real value so that the
        // remainder never becomes negative.
        rem = this;
        while(rem.gte(divisor)){
            // Approximate the result of division. This may be a little greater or
            // smaller than the actual value.
            approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
            // We will tweak the approximate result by changing it in the 48-th digit or
            // the smallest non-fractional digit, whichever is larger.
            var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
            // that if it is too large, the product overflows and is negative.
            approxRes = fromNumber(approx), approxRem = approxRes.mul(divisor);
            while(approxRem.isNegative() || approxRem.gt(rem)){
                approx -= delta;
                approxRes = fromNumber(approx, this.unsigned);
                approxRem = approxRes.mul(divisor);
            }
            // We know the answer can't be zero... and actually, zero would cause
            // infinite recursion since we would make no progress.
            if (approxRes.isZero()) approxRes = ONE;
            res = res.add(approxRes);
            rem = rem.sub(approxRem);
        }
        return res;
    };
    /**
     * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
     * @function
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Quotient
     */ LongPrototype.div = LongPrototype.divide;
    /**
     * Returns this Long modulo the specified.
     * @this {!Long}
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Remainder
     */ LongPrototype.modulo = function modulo(divisor) {
        if (!isLong(divisor)) divisor = fromValue(divisor);
        // use wasm support if present
        if (wasm) {
            var low = (this.unsigned ? wasm["rem_u"] : wasm["rem_s"])(this.low, this.high, divisor.low, divisor.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        return this.sub(this.div(divisor).mul(divisor));
    };
    /**
     * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
     * @function
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Remainder
     */ LongPrototype.mod = LongPrototype.modulo;
    /**
     * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
     * @function
     * @param {!Long|number|bigint|string} divisor Divisor
     * @returns {!Long} Remainder
     */ LongPrototype.rem = LongPrototype.modulo;
    /**
     * Returns the bitwise NOT of this Long.
     * @this {!Long}
     * @returns {!Long}
     */ LongPrototype.not = function not() {
        return fromBits(~this.low, ~this.high, this.unsigned);
    };
    /**
     * Returns count leading zeros of this Long.
     * @this {!Long}
     * @returns {!number}
     */ LongPrototype.countLeadingZeros = function countLeadingZeros() {
        return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
    };
    /**
     * Returns count leading zeros. This is an alias of {@link Long#countLeadingZeros}.
     * @function
     * @param {!Long}
     * @returns {!number}
     */ LongPrototype.clz = LongPrototype.countLeadingZeros;
    /**
     * Returns count trailing zeros of this Long.
     * @this {!Long}
     * @returns {!number}
     */ LongPrototype.countTrailingZeros = function countTrailingZeros() {
        return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
    };
    /**
     * Returns count trailing zeros. This is an alias of {@link Long#countTrailingZeros}.
     * @function
     * @param {!Long}
     * @returns {!number}
     */ LongPrototype.ctz = LongPrototype.countTrailingZeros;
    /**
     * Returns the bitwise AND of this Long and the specified.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other Long
     * @returns {!Long}
     */ LongPrototype.and = function and(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
    };
    /**
     * Returns the bitwise OR of this Long and the specified.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other Long
     * @returns {!Long}
     */ LongPrototype.or = function or(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
    };
    /**
     * Returns the bitwise XOR of this Long and the given one.
     * @this {!Long}
     * @param {!Long|number|bigint|string} other Other Long
     * @returns {!Long}
     */ LongPrototype.xor = function xor(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
    };
    /**
     * Returns this Long with bits shifted to the left by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shiftLeft = function shiftLeft(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
        else return fromBits(0, this.low << numBits - 32, this.unsigned);
    };
    /**
     * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shl = LongPrototype.shiftLeft;
    /**
     * Returns this Long with bits arithmetically shifted to the right by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shiftRight = function shiftRight(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
        else return fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
    };
    /**
     * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shr = LongPrototype.shiftRight;
    /**
     * Returns this Long with bits logically shifted to the right by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >>> numBits, this.unsigned);
        if (numBits === 32) return fromBits(this.high, 0, this.unsigned);
        return fromBits(this.high >>> numBits - 32, 0, this.unsigned);
    };
    /**
     * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shru = LongPrototype.shiftRightUnsigned;
    /**
     * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Shifted Long
     */ LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
    /**
     * Returns this Long with bits rotated to the left by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotateLeft = function rotateLeft(numBits) {
        var b;
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
        if (numBits < 32) {
            b = 32 - numBits;
            return fromBits(this.low << numBits | this.high >>> b, this.high << numBits | this.low >>> b, this.unsigned);
        }
        numBits -= 32;
        b = 32 - numBits;
        return fromBits(this.high << numBits | this.low >>> b, this.low << numBits | this.high >>> b, this.unsigned);
    };
    /**
     * Returns this Long with bits rotated to the left by the given amount. This is an alias of {@link Long#rotateLeft}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotl = LongPrototype.rotateLeft;
    /**
     * Returns this Long with bits rotated to the right by the given amount.
     * @this {!Long}
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotateRight = function rotateRight(numBits) {
        var b;
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
        if (numBits < 32) {
            b = 32 - numBits;
            return fromBits(this.high << b | this.low >>> numBits, this.low << b | this.high >>> numBits, this.unsigned);
        }
        numBits -= 32;
        b = 32 - numBits;
        return fromBits(this.low << b | this.high >>> numBits, this.high << b | this.low >>> numBits, this.unsigned);
    };
    /**
     * Returns this Long with bits rotated to the right by the given amount. This is an alias of {@link Long#rotateRight}.
     * @function
     * @param {number|!Long} numBits Number of bits
     * @returns {!Long} Rotated Long
     */ LongPrototype.rotr = LongPrototype.rotateRight;
    /**
     * Converts this Long to signed.
     * @this {!Long}
     * @returns {!Long} Signed long
     */ LongPrototype.toSigned = function toSigned() {
        if (!this.unsigned) return this;
        return fromBits(this.low, this.high, false);
    };
    /**
     * Converts this Long to unsigned.
     * @this {!Long}
     * @returns {!Long} Unsigned long
     */ LongPrototype.toUnsigned = function toUnsigned() {
        if (this.unsigned) return this;
        return fromBits(this.low, this.high, true);
    };
    /**
     * Converts this Long to its byte representation.
     * @param {boolean=} le Whether little or big endian, defaults to big endian
     * @this {!Long}
     * @returns {!Array.<number>} Byte representation
     */ LongPrototype.toBytes = function toBytes(le) {
        return le ? this.toBytesLE() : this.toBytesBE();
    };
    /**
     * Converts this Long to its little endian byte representation.
     * @this {!Long}
     * @returns {!Array.<number>} Little endian byte representation
     */ LongPrototype.toBytesLE = function toBytesLE() {
        var hi = this.high, lo = this.low;
        return [
            lo & 0xff,
            lo >>> 8 & 0xff,
            lo >>> 16 & 0xff,
            lo >>> 24,
            hi & 0xff,
            hi >>> 8 & 0xff,
            hi >>> 16 & 0xff,
            hi >>> 24
        ];
    };
    /**
     * Converts this Long to its big endian byte representation.
     * @this {!Long}
     * @returns {!Array.<number>} Big endian byte representation
     */ LongPrototype.toBytesBE = function toBytesBE() {
        var hi = this.high, lo = this.low;
        return [
            hi >>> 24,
            hi >>> 16 & 0xff,
            hi >>> 8 & 0xff,
            hi & 0xff,
            lo >>> 24,
            lo >>> 16 & 0xff,
            lo >>> 8 & 0xff,
            lo & 0xff
        ];
    };
    /**
     * Creates a Long from its byte representation.
     * @param {!Array.<number>} bytes Byte representation
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @param {boolean=} le Whether little or big endian, defaults to big endian
     * @returns {Long} The corresponding Long value
     */ Long.fromBytes = function fromBytes(bytes, unsigned, le) {
        return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
    };
    /**
     * Creates a Long from its little endian byte representation.
     * @param {!Array.<number>} bytes Little endian byte representation
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {Long} The corresponding Long value
     */ Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
        return new Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
    };
    /**
     * Creates a Long from its big endian byte representation.
     * @param {!Array.<number>} bytes Big endian byte representation
     * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
     * @returns {Long} The corresponding Long value
     */ Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
        return new Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
    };
    // Support conversion to/from BigInt where available
    if (typeof BigInt === "function") {
        /**
       * Returns a Long representing the given big integer.
       * @function
       * @param {number} value The big integer value
       * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
       * @returns {!Long} The corresponding Long value
       */ Long.fromBigInt = function fromBigInt(value, unsigned) {
            var lowBits = Number(BigInt.asIntN(32, value));
            var highBits = Number(BigInt.asIntN(32, value >> BigInt(32)));
            return fromBits(lowBits, highBits, unsigned);
        };
        // Override
        Long.fromValue = function fromValueWithBigInt(value, unsigned) {
            if (typeof value === "bigint") return Long.fromBigInt(value, unsigned);
            return fromValue(value, unsigned);
        };
        /**
       * Converts the Long to its big integer representation.
       * @this {!Long}
       * @returns {bigint}
       */ LongPrototype.toBigInt = function toBigInt() {
            var lowBigInt = BigInt(this.low >>> 0);
            var highBigInt = BigInt(this.unsigned ? this.high >>> 0 : this.high);
            return highBigInt << BigInt(32) | lowBigInt;
        };
    }
    var _default = _exports.default = Long;
});

});



parcelRegister("axYUT", function(module, exports) {
"use strict";
module.exports = $7adc3d3bb0285adb$var$BufferWriter;

var $3KUVy = parcelRequire("3KUVy");
($7adc3d3bb0285adb$var$BufferWriter.prototype = Object.create($3KUVy.prototype)).constructor = $7adc3d3bb0285adb$var$BufferWriter;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $7adc3d3bb0285adb$var$BufferWriter() {
    $3KUVy.call(this);
}
$7adc3d3bb0285adb$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $7adc3d3bb0285adb$var$BufferWriter.alloc = $hf2LF._Buffer_allocUnsafe;
    $7adc3d3bb0285adb$var$BufferWriter.writeBytesBuffer = $hf2LF.Buffer && $hf2LF.Buffer.prototype instanceof Uint8Array && $hf2LF.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $7adc3d3bb0285adb$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($hf2LF.isString(value)) value = $hf2LF._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($7adc3d3bb0285adb$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $7adc3d3bb0285adb$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $hf2LF.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $7adc3d3bb0285adb$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $hf2LF.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($7adc3d3bb0285adb$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $7adc3d3bb0285adb$var$BufferWriter._configure();

});

parcelRegister("hP5zC", function(module, exports) {
"use strict";
module.exports = $cf9b85d8c65bf523$var$Reader;

var $hf2LF = parcelRequire("hf2LF");
var $cf9b85d8c65bf523$var$BufferReader; // cyclic
var $cf9b85d8c65bf523$var$LongBits = $hf2LF.LongBits, $cf9b85d8c65bf523$var$utf8 = $hf2LF.utf8;
/* istanbul ignore next */ function $cf9b85d8c65bf523$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $cf9b85d8c65bf523$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $cf9b85d8c65bf523$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $cf9b85d8c65bf523$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $cf9b85d8c65bf523$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $cf9b85d8c65bf523$var$create = function create() {
    return $hf2LF.Buffer ? function create_buffer_setup(buffer) {
        return ($cf9b85d8c65bf523$var$Reader.create = function create_buffer(buffer) {
            return $hf2LF.Buffer.isBuffer(buffer) ? new $cf9b85d8c65bf523$var$BufferReader(buffer) : $cf9b85d8c65bf523$var$create_array(buffer);
        })(buffer);
    } : $cf9b85d8c65bf523$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $cf9b85d8c65bf523$var$Reader.create = $cf9b85d8c65bf523$var$create();
$cf9b85d8c65bf523$var$Reader.prototype._slice = $hf2LF.Array.prototype.subarray || /* istanbul ignore next */ $hf2LF.Array.prototype.slice;
function $cf9b85d8c65bf523$var$readVarint32NearEnd(reader) {
    // Safely read up to four bytes of a varint32 near the reader limit
    var value = 0;
    for(var i = 0; i < 4; ++i){
        if (reader.pos >= reader.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(reader);
        var b = reader.buf[reader.pos++];
        value = (value | (b & 127) << i * 7) >>> 0;
        if (b < 128) return value;
    }
    throw $cf9b85d8c65bf523$var$indexOutOfRange(reader);
}
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        if (this.len - this.pos < 5) {
            if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
            if (this.buf[this.pos] >= 128) return $cf9b85d8c65bf523$var$readVarint32NearEnd(this);
        }
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $cf9b85d8c65bf523$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $cf9b85d8c65bf523$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $cf9b85d8c65bf523$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    return $cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    return $cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $cf9b85d8c65bf523$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 8);
    return new $cf9b85d8c65bf523$var$LongBits($cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4), $cf9b85d8c65bf523$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    var value = $hf2LF.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, 4);
    var value = $hf2LF.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    if (start === end) {
        var nativeBuffer = $hf2LF.Buffer;
        return nativeBuffer ? nativeBuffer.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $cf9b85d8c65bf523$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $cf9b85d8c65bf523$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $cf9b85d8c65bf523$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $cf9b85d8c65bf523$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Recursion limit.
 * @type {number}
 */ $cf9b85d8c65bf523$var$Reader.recursionLimit = $hf2LF.recursionLimit;
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @param {number} [depth] Depth of recursion to control nested calls; 0 if omitted
 * @returns {Reader} `this`
 */ $cf9b85d8c65bf523$var$Reader.prototype.skipType = function(wireType, depth) {
    if (depth === undefined) depth = 0;
    if (depth > $cf9b85d8c65bf523$var$Reader.recursionLimit) throw Error("maximum nesting depth exceeded");
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType, depth + 1);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$cf9b85d8c65bf523$var$Reader._configure = function(BufferReader_) {
    $cf9b85d8c65bf523$var$BufferReader = BufferReader_;
    $cf9b85d8c65bf523$var$Reader.create = $cf9b85d8c65bf523$var$create();
    $cf9b85d8c65bf523$var$BufferReader._configure();
    var fn = $hf2LF.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $hf2LF.merge($cf9b85d8c65bf523$var$Reader.prototype, {
        int64: function read_int64() {
            return $cf9b85d8c65bf523$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $cf9b85d8c65bf523$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $cf9b85d8c65bf523$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $cf9b85d8c65bf523$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $cf9b85d8c65bf523$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRegister("hVbTm", function(module, exports) {
"use strict";
module.exports = $d0c0fc09890ced56$var$BufferReader;

var $hP5zC = parcelRequire("hP5zC");
($d0c0fc09890ced56$var$BufferReader.prototype = Object.create($hP5zC.prototype)).constructor = $d0c0fc09890ced56$var$BufferReader;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $d0c0fc09890ced56$var$BufferReader(buffer) {
    $hP5zC.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$d0c0fc09890ced56$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($hf2LF.Buffer) $d0c0fc09890ced56$var$BufferReader.prototype._slice = $hf2LF.Buffer.prototype.slice;
};
/**
 * @override
 */ $d0c0fc09890ced56$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $d0c0fc09890ced56$var$BufferReader._configure();

});

parcelRegister("kPAIY", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $f2a50ebf117c2427$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $f2a50ebf117c2427$var$rpc.Service = (parcelRequire("9qfRI"));

});
parcelRegister("9qfRI", function(module, exports) {
"use strict";
module.exports = $6dc2d94c097e90b5$var$Service;

var $hf2LF = parcelRequire("hf2LF");
// Extends EventEmitter
($6dc2d94c097e90b5$var$Service.prototype = Object.create($hf2LF.EventEmitter.prototype)).constructor = $6dc2d94c097e90b5$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $6dc2d94c097e90b5$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $hf2LF.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $6dc2d94c097e90b5$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $hf2LF.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $6dc2d94c097e90b5$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRegister("38hgC", function(module, exports) {
"use strict";
module.exports = Object.create(null); /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available across modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});


parcelRegister("ekUKG", function(module, exports) {
"use strict";
module.exports = $a6fef4afa6d495a9$var$encoder;

var $teZIn = parcelRequire("teZIn");

var $keBMp = parcelRequire("keBMp");

var $jshGU = parcelRequire("jshGU");
/**
 * Generates a partial message type encoder.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} ref Variable reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $a6fef4afa6d495a9$var$genTypePartial(gen, field, fieldIndex, ref) {
    return field.delimited ? gen("types[%i].encode(%s,w.uint32(%i),q+1).uint32(%i)", fieldIndex, ref, (field.id << 3 | 3) >>> 0, (field.id << 3 | 4) >>> 0) : gen("types[%i].encode(%s,w.uint32(%i).fork(),q+1).ldelim()", fieldIndex, ref, (field.id << 3 | 2) >>> 0);
}
/**
 * Generates an encoder specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ function $a6fef4afa6d495a9$var$encoder(mtype) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ var gen = $jshGU.codegen([
        "m",
        "w",
        "q"
    ], mtype.name + "$encode")("if(!w)")("w=Writer.create()")("if(q===undefined)q=0")("if(q>util.recursionLimit)")("throw Error(\"max depth exceeded\")");
    var i, ref;
    // "when a message is serialized its known fields should be written sequentially by field number"
    var fields = /* initializes */ mtype.fieldsArray.slice().sort($jshGU.compareFieldsById);
    for(var i = 0; i < fields.length; ++i){
        var field = fields[i].resolve(), index = mtype._fieldsArray.indexOf(field), type = field.resolvedType instanceof $teZIn ? "int32" : field.type, wireType = $keBMp.basic[type];
        ref = "m" + $jshGU.safeProp(field.name);
        // Map fields
        if (field.map) {
            gen("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", ref, field.name) // !== undefined && !== null
            ("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", ref)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (field.id << 3 | 2) >>> 0, 8 | $keBMp.mapKey[field.keyType], field.keyType);
            if (wireType === undefined) gen("types[%i].encode(%s[ks[i]],w.uint32(18).fork(),q+1).ldelim().ldelim()", index, ref); // can't be groups
            else gen(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | wireType, type, ref);
            gen("}")("}");
        // Repeated fields
        } else if (field.repeated) {
            gen("if(%s!=null&&%s.length){", ref, ref); // !== undefined && !== null
            // Packed repeated
            if (field.packed && $keBMp.packed[type] !== undefined) gen("w.uint32(%i).fork()", (field.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", ref)("w.%s(%s[i])", type, ref)("w.ldelim()");
            else {
                gen("for(var i=0;i<%s.length;++i)", ref);
                if (wireType === undefined) $a6fef4afa6d495a9$var$genTypePartial(gen, field, index, ref + "[i]");
                else gen("w.uint32(%i).%s(%s[i])", (field.id << 3 | wireType) >>> 0, type, ref);
            }
            gen("}");
        // Non-repeated
        } else {
            if (field.optional) gen("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", ref, field.name); // !== undefined && !== null
            if (wireType === undefined) $a6fef4afa6d495a9$var$genTypePartial(gen, field, index, ref);
            else gen("w.uint32(%i).%s(%s)", (field.id << 3 | wireType) >>> 0, type, ref);
        }
    }
    return gen("return w");
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ }

});
parcelRegister("teZIn", function(module, exports) {
"use strict";
module.exports = $057e571fb61d2aca$var$Enum;

var $eqXqI = parcelRequire("eqXqI");
(($057e571fb61d2aca$var$Enum.prototype = Object.create($eqXqI.prototype)).constructor = $057e571fb61d2aca$var$Enum).className = "Enum";

var $3keUm = parcelRequire("3keUm");

var $jshGU = parcelRequire("jshGU");
/**
 * Constructs a new enum instance.
 * @classdesc Reflected enum.
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {Object.<string,number>} [values] Enum values as an object, by name
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] The comment for this enum
 * @param {Object.<string,string>} [comments] The value comments for this enum
 * @param {Object.<string,Object<string,*>>|undefined} [valuesOptions] The value options for this enum
 */ function $057e571fb61d2aca$var$Enum(name, values, options, comment, comments, valuesOptions) {
    $eqXqI.call(this, name, options);
    if (values && typeof values !== "object") throw TypeError("values must be an object");
    /**
     * Enum values by id.
     * @type {Object.<number,string>}
     */ this.valuesById = {};
    /**
     * Enum values by name.
     * @type {Object.<string,number>}
     */ this.values = Object.create(this.valuesById); // toJSON, marker
    /**
     * Enum comment text.
     * @type {string|null}
     */ this.comment = comment;
    /**
     * Value comment texts, if any.
     * @type {Object.<string,string>}
     */ this.comments = comments || {};
    /**
     * Values options, if any
     * @type {Object<string, Object<string, *>>|undefined}
     */ this.valuesOptions = valuesOptions;
    /**
     * Resolved values features, if any
     * @type {Object<string, Object<string, *>>|undefined}
     */ this._valuesFeatures = {};
    /**
     * Reserved ranges, if any.
     * @type {Array.<number[]|string>}
     */ this.reserved = undefined; // toJSON
    // Note that values inherit valuesById on their prototype which makes them a TypeScript-
    // compatible enum. This is used by pbts to write actual enum definitions that work for
    // static and reflection code alike instead of emitting generic object definitions.
    if (values) {
        for(var keys = Object.keys(values), i = 0; i < keys.length; ++i)if (keys[i] !== "__proto__" && typeof values[keys[i]] === "number") this.valuesById[this.values[keys[i]] = values[keys[i]]] = keys[i];
    }
}
/**
 * @override
 */ $057e571fb61d2aca$var$Enum.prototype._resolveFeatures = function _resolveFeatures(edition) {
    edition = this._edition || edition;
    $eqXqI.prototype._resolveFeatures.call(this, edition);
    Object.keys(this.values).forEach((key)=>{
        var parentFeaturesCopy = $jshGU.merge({}, this._features);
        this._valuesFeatures[key] = $jshGU.merge(parentFeaturesCopy, this.valuesOptions && this.valuesOptions[key] && this.valuesOptions[key].features || {});
    });
    return this;
};
/**
 * Enum descriptor.
 * @interface IEnum
 * @property {Object.<string,number>} values Enum values
 * @property {Object.<string,*>} [options] Enum options
 */ /**
 * Constructs an enum from an enum descriptor.
 * @param {string} name Enum name
 * @param {IEnum} json Enum descriptor
 * @returns {Enum} Created enum
 * @throws {TypeError} If arguments are invalid
 */ $057e571fb61d2aca$var$Enum.fromJSON = function fromJSON(name, json) {
    var enm = new $057e571fb61d2aca$var$Enum(name, json.values, json.options, json.comment, json.comments);
    enm.reserved = json.reserved;
    if (json.edition) enm._edition = json.edition;
    enm._defaultEdition = "proto3"; // For backwards-compatibility.
    return enm;
};
/**
 * Converts this enum to an enum descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IEnum} Enum descriptor
 */ $057e571fb61d2aca$var$Enum.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "edition",
        this._editionToJSON(),
        "options",
        this.options,
        "valuesOptions",
        this.valuesOptions,
        "values",
        this.values,
        "reserved",
        this.reserved && this.reserved.length ? this.reserved : undefined,
        "comment",
        keepComments ? this.comment : undefined,
        "comments",
        keepComments ? this.comments : undefined
    ]);
};
/**
 * Adds a value to this enum.
 * @param {string} name Value name
 * @param {number} id Value id
 * @param {string} [comment] Comment, if any
 * @param {Object.<string, *>|undefined} [options] Options, if any
 * @returns {Enum} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If there is already a value with this name or id
 */ $057e571fb61d2aca$var$Enum.prototype.add = function add(name, id, comment, options) {
    // utilized by the parser but not by .fromJSON
    if (!$jshGU.isString(name)) throw TypeError("name must be a string");
    if (!$jshGU.isInteger(id)) throw TypeError("id must be an integer");
    if (name === "__proto__") return this;
    if (this.values[name] !== undefined) throw Error("duplicate name '" + name + "' in " + this);
    if (this.isReservedId(id)) throw Error("id " + id + " is reserved in " + this);
    if (this.isReservedName(name)) throw Error("name '" + name + "' is reserved in " + this);
    if (this.valuesById[id] !== undefined) {
        if (!(this.options && this.options.allow_alias)) throw Error("duplicate id " + id + " in " + this);
        this.values[name] = id;
    } else this.valuesById[this.values[name] = id] = name;
    if (options) {
        if (this.valuesOptions === undefined) this.valuesOptions = {};
        this.valuesOptions[name] = options || null;
    }
    this.comments[name] = comment || null;
    return this;
};
/**
 * Removes a value from this enum
 * @param {string} name Value name
 * @returns {Enum} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If `name` is not a name of this enum
 */ $057e571fb61d2aca$var$Enum.prototype.remove = function remove(name) {
    if (!$jshGU.isString(name)) throw TypeError("name must be a string");
    var val = this.values[name];
    if (val == null) throw Error("name '" + name + "' does not exist in " + this);
    delete this.valuesById[val];
    delete this.values[name];
    delete this.comments[name];
    if (this.valuesOptions) delete this.valuesOptions[name];
    return this;
};
/**
 * Tests if the specified id is reserved.
 * @param {number} id Id to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $057e571fb61d2aca$var$Enum.prototype.isReservedId = function isReservedId(id) {
    return $3keUm.isReservedId(this.reserved, id);
};
/**
 * Tests if the specified name is reserved.
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $057e571fb61d2aca$var$Enum.prototype.isReservedName = function isReservedName(name) {
    return $3keUm.isReservedName(this.reserved, name);
};

});
parcelRegister("eqXqI", function(module, exports) {
"use strict";
module.exports = $a82197f06aba8e75$var$ReflectionObject;
$a82197f06aba8e75$var$ReflectionObject.className = "ReflectionObject";

var $8DQkR = parcelRequire("8DQkR");

var $jshGU = parcelRequire("jshGU");
var $a82197f06aba8e75$var$Root; // cyclic
/* eslint-disable no-warning-comments */ // TODO: Replace with embedded proto.
var $a82197f06aba8e75$var$editions2023Defaults = {
    enum_type: "OPEN",
    field_presence: "EXPLICIT",
    json_format: "ALLOW",
    message_encoding: "LENGTH_PREFIXED",
    repeated_field_encoding: "PACKED",
    utf8_validation: "VERIFY"
};
var $a82197f06aba8e75$var$proto2Defaults = {
    enum_type: "CLOSED",
    field_presence: "EXPLICIT",
    json_format: "LEGACY_BEST_EFFORT",
    message_encoding: "LENGTH_PREFIXED",
    repeated_field_encoding: "EXPANDED",
    utf8_validation: "NONE"
};
var $a82197f06aba8e75$var$proto3Defaults = {
    enum_type: "OPEN",
    field_presence: "IMPLICIT",
    json_format: "ALLOW",
    message_encoding: "LENGTH_PREFIXED",
    repeated_field_encoding: "PACKED",
    utf8_validation: "VERIFY"
};
/**
 * Constructs a new reflection object instance.
 * @classdesc Base class of all reflection objects.
 * @constructor
 * @param {string} name Object name
 * @param {Object.<string,*>} [options] Declared options
 * @abstract
 */ function $a82197f06aba8e75$var$ReflectionObject(name, options) {
    if (!$jshGU.isString(name)) throw TypeError("name must be a string");
    if (options && !$jshGU.isObject(options)) throw TypeError("options must be an object");
    /**
     * Options.
     * @type {Object.<string,*>|undefined}
     */ this.options = options; // toJSON
    /**
     * Parsed Options.
     * @type {Array.<Object.<string,*>>|undefined}
     */ this.parsedOptions = null;
    /**
     * Unique name within its namespace.
     * @type {string}
     */ this.name = name;
    /**
     * The edition specified for this object.  Only relevant for top-level objects.
     * @type {string}
     * @private
     */ this._edition = null;
    /**
     * The default edition to use for this object if none is specified.  For legacy reasons,
     * this is proto2 except in the JSON parsing case where it was proto3.
     * @type {string}
     * @private
     */ this._defaultEdition = "proto2";
    /**
     * Resolved Features.
     * @type {object}
     * @private
     */ this._features = {};
    /**
     * Whether or not features have been resolved.
     * @type {boolean}
     * @private
     */ this._featuresResolved = false;
    /**
     * Parent namespace.
     * @type {Namespace|null}
     */ this.parent = null;
    /**
     * Whether already resolved or not.
     * @type {boolean}
     */ this.resolved = false;
    /**
     * Comment text, if any.
     * @type {string|null}
     */ this.comment = null;
    /**
     * Defining file name.
     * @type {string|null}
     */ this.filename = null;
}
Object.defineProperties($a82197f06aba8e75$var$ReflectionObject.prototype, {
    /**
     * Reference to the root namespace.
     * @name ReflectionObject#root
     * @type {Root}
     * @readonly
     */ root: {
        get: function() {
            var ptr = this;
            while(ptr.parent !== null)ptr = ptr.parent;
            return ptr;
        }
    },
    /**
     * Full name including leading dot.
     * @name ReflectionObject#fullName
     * @type {string}
     * @readonly
     */ fullName: {
        get: function() {
            var path = [
                this.name
            ], ptr = this.parent;
            while(ptr){
                path.unshift(ptr.name);
                ptr = ptr.parent;
            }
            return path.join(".");
        }
    }
});
/**
 * Converts this reflection object to its descriptor representation.
 * @returns {Object.<string,*>} Descriptor
 * @abstract
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.toJSON = /* istanbul ignore next */ function toJSON() {
    throw Error(); // not implemented, shouldn't happen
};
/**
 * Called when this object is added to a parent.
 * @param {ReflectionObject} parent Parent added to
 * @returns {undefined}
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.onAdd = function onAdd(parent) {
    if (this.parent && this.parent !== parent) this.parent.remove(this);
    this.parent = parent;
    this.resolved = false;
    var root = parent.root;
    if (root instanceof $a82197f06aba8e75$var$Root) root._handleAdd(this);
};
/**
 * Called when this object is removed from a parent.
 * @param {ReflectionObject} parent Parent removed from
 * @returns {undefined}
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.onRemove = function onRemove(parent) {
    var root = parent.root;
    if (root instanceof $a82197f06aba8e75$var$Root) root._handleRemove(this);
    this.parent = null;
    this.resolved = false;
};
/**
 * Resolves this objects type references.
 * @returns {ReflectionObject} `this`
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.resolve = function resolve() {
    if (this.resolved) return this;
    if (this.root instanceof $a82197f06aba8e75$var$Root) this.resolved = true; // only if part of a root
    return this;
};
/**
 * Resolves this objects editions features.
 * @param {string} edition The edition we're currently resolving for.
 * @returns {ReflectionObject} `this`
 */ $a82197f06aba8e75$var$ReflectionObject.prototype._resolveFeaturesRecursive = function _resolveFeaturesRecursive(edition) {
    return this._resolveFeatures(this._edition || edition);
};
/**
 * Resolves child features from parent features
 * @param {string} edition The edition we're currently resolving for.
 * @returns {undefined}
 */ $a82197f06aba8e75$var$ReflectionObject.prototype._resolveFeatures = function _resolveFeatures(edition) {
    if (this._featuresResolved) return;
    var defaults = {};
    /* istanbul ignore if */ if (!edition) throw new Error("Unknown edition for " + this.fullName);
    var protoFeatures = $jshGU.merge({}, this.options && this.options.features, this._inferLegacyProtoFeatures(edition));
    if (this._edition) {
        // For a namespace marked with a specific edition, reset defaults.
        /* istanbul ignore else */ if (edition === "proto2") defaults = Object.assign({}, $a82197f06aba8e75$var$proto2Defaults);
        else if (edition === "proto3") defaults = Object.assign({}, $a82197f06aba8e75$var$proto3Defaults);
        else if (edition === "2023") defaults = Object.assign({}, $a82197f06aba8e75$var$editions2023Defaults);
        else throw new Error("Unknown edition: " + edition);
        this._features = $jshGU.merge(defaults, protoFeatures);
        this._featuresResolved = true;
        return;
    }
    // fields in Oneofs aren't actually children of them, so we have to
    // special-case it
    /* istanbul ignore else */ if (this.partOf instanceof $8DQkR) {
        var lexicalParentFeaturesCopy = $jshGU.merge({}, this.partOf._features);
        this._features = $jshGU.merge(lexicalParentFeaturesCopy, protoFeatures);
    } else if (this.declaringField) ;
    else if (this.parent) {
        var parentFeaturesCopy = $jshGU.merge({}, this.parent._features);
        this._features = $jshGU.merge(parentFeaturesCopy, protoFeatures);
    } else throw new Error("Unable to find a parent for " + this.fullName);
    if (this.extensionField) // Sister fields should have the same features as their extensions.
    this.extensionField._features = this._features;
    this._featuresResolved = true;
};
/**
 * Infers features from legacy syntax that may have been specified differently.
 * in older editions.
 * @param {string|undefined} edition The edition this proto is on, or undefined if pre-editions
 * @returns {object} The feature values to override
 */ $a82197f06aba8e75$var$ReflectionObject.prototype._inferLegacyProtoFeatures = function _inferLegacyProtoFeatures() {
    return {};
};
/**
 * Gets an option value.
 * @param {string} name Option name
 * @returns {*} Option value or `undefined` if not set
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.getOption = function getOption(name) {
    if (this.options) return this.options[name];
    return undefined;
};
/**
 * Sets an option.
 * @param {string} name Option name
 * @param {*} value Option value
 * @param {boolean|undefined} [ifNotSet] Sets the option only if it isn't currently set
 * @returns {ReflectionObject} `this`
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.setOption = function setOption(name, value, ifNotSet) {
    if (name === "__proto__") return this;
    if (!this.options) this.options = {};
    if (/^features\./.test(name)) $jshGU.setProperty(this.options, name, value, ifNotSet);
    else if (!ifNotSet || this.options[name] === undefined) {
        if (this.getOption(name) !== value) this.resolved = false;
        this.options[name] = value;
    }
    return this;
};
/**
 * Sets a parsed option.
 * @param {string} name parsed Option name
 * @param {*} value Option value
 * @param {string} propName dot '.' delimited full path of property within the option to set. if undefined\empty, will add a new option with that value
 * @returns {ReflectionObject} `this`
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.setParsedOption = function setParsedOption(name, value, propName) {
    if (name === "__proto__") return this;
    if (!this.parsedOptions) this.parsedOptions = [];
    var parsedOptions = this.parsedOptions;
    if (propName) {
        // If setting a sub property of an option then try to merge it
        // with an existing option
        var opt = parsedOptions.find(function(opt) {
            return Object.prototype.hasOwnProperty.call(opt, name);
        });
        if (opt) {
            // If we found an existing option - just merge the property value
            // (If it's a feature, will just write over)
            var newValue = opt[name];
            $jshGU.setProperty(newValue, propName, value);
        } else {
            // otherwise, create a new option, set its property and add it to the list
            opt = {};
            opt[name] = $jshGU.setProperty({}, propName, value);
            parsedOptions.push(opt);
        }
    } else {
        // Always create a new option when setting the value of the option itself
        var newOpt = {};
        newOpt[name] = value;
        parsedOptions.push(newOpt);
    }
    return this;
};
/**
 * Sets multiple options.
 * @param {Object.<string,*>} options Options to set
 * @param {boolean} [ifNotSet] Sets an option only if it isn't currently set
 * @returns {ReflectionObject} `this`
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.setOptions = function setOptions(options, ifNotSet) {
    if (options) for(var keys = Object.keys(options), i = 0; i < keys.length; ++i)this.setOption(keys[i], options[keys[i]], ifNotSet);
    return this;
};
/**
 * Converts this instance to its string representation.
 * @returns {string} Class name[, space, full name]
 */ $a82197f06aba8e75$var$ReflectionObject.prototype.toString = function toString() {
    var className = this.constructor.className, fullName = this.fullName;
    if (fullName.length) return className + " " + fullName;
    return className;
};
/**
 * Converts the edition this object is pinned to for JSON format.
 * @returns {string|undefined} The edition string for JSON representation
 */ $a82197f06aba8e75$var$ReflectionObject.prototype._editionToJSON = function _editionToJSON() {
    if (!this._edition || this._edition === "proto3") // Avoid emitting proto3 since we need to default to it for backwards
    // compatibility anyway.
    return undefined;
    return this._edition;
};
// Sets up cyclic dependencies (called in index-light)
$a82197f06aba8e75$var$ReflectionObject._configure = function(Root_) {
    $a82197f06aba8e75$var$Root = Root_;
};

});
parcelRegister("8DQkR", function(module, exports) {
"use strict";
module.exports = $64aa8ffec14d52ef$var$OneOf;

var $eqXqI = parcelRequire("eqXqI");
(($64aa8ffec14d52ef$var$OneOf.prototype = Object.create($eqXqI.prototype)).constructor = $64aa8ffec14d52ef$var$OneOf).className = "OneOf";

var $fMEB1 = parcelRequire("fMEB1");

var $jshGU = parcelRequire("jshGU");
/**
 * Constructs a new oneof instance.
 * @classdesc Reflected oneof.
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Oneof name
 * @param {string[]|Object.<string,*>} [fieldNames] Field names
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] Comment associated with this field
 */ function $64aa8ffec14d52ef$var$OneOf(name, fieldNames, options, comment) {
    if (!Array.isArray(fieldNames)) {
        options = fieldNames;
        fieldNames = undefined;
    }
    $eqXqI.call(this, name, options);
    /* istanbul ignore if */ if (!(fieldNames === undefined || Array.isArray(fieldNames))) throw TypeError("fieldNames must be an Array");
    /**
     * Field names that belong to this oneof.
     * @type {string[]}
     */ this.oneof = fieldNames || []; // toJSON, marker
    /**
     * Fields that belong to this oneof as an array for iteration.
     * @type {Field[]}
     * @readonly
     */ this.fieldsArray = []; // declared readonly for conformance, possibly not yet added to parent
    /**
     * Comment for this field.
     * @type {string|null}
     */ this.comment = comment;
}
/**
 * Oneof descriptor.
 * @interface IOneOf
 * @property {Array.<string>} oneof Oneof field names
 * @property {Object.<string,*>} [options] Oneof options
 */ /**
 * Constructs a oneof from a oneof descriptor.
 * @param {string} name Oneof name
 * @param {IOneOf} json Oneof descriptor
 * @returns {OneOf} Created oneof
 * @throws {TypeError} If arguments are invalid
 */ $64aa8ffec14d52ef$var$OneOf.fromJSON = function fromJSON(name, json) {
    return new $64aa8ffec14d52ef$var$OneOf(name, json.oneof, json.options, json.comment);
};
/**
 * Converts this oneof to a oneof descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IOneOf} Oneof descriptor
 */ $64aa8ffec14d52ef$var$OneOf.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "options",
        this.options,
        "oneof",
        this.oneof,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * Adds the fields of the specified oneof to the parent if not already done so.
 * @param {OneOf} oneof The oneof
 * @returns {undefined}
 * @inner
 * @ignore
 */ function $64aa8ffec14d52ef$var$addFieldsToParent(oneof) {
    if (oneof.parent) {
        for(var i = 0; i < oneof.fieldsArray.length; ++i)if (!oneof.fieldsArray[i].parent) oneof.parent.add(oneof.fieldsArray[i]);
    }
}
/**
 * Adds a field to this oneof and removes it from its current parent, if any.
 * @param {Field} field Field to add
 * @returns {OneOf} `this`
 */ $64aa8ffec14d52ef$var$OneOf.prototype.add = function add(field) {
    /* istanbul ignore if */ if (!(field instanceof $fMEB1)) throw TypeError("field must be a Field");
    if (field.parent && field.parent !== this.parent) field.parent.remove(field);
    this.oneof.push(field.name);
    this.fieldsArray.push(field);
    field.partOf = this; // field.parent remains null
    $64aa8ffec14d52ef$var$addFieldsToParent(this);
    return this;
};
/**
 * Removes a field from this oneof and puts it back to the oneof's parent.
 * @param {Field} field Field to remove
 * @returns {OneOf} `this`
 */ $64aa8ffec14d52ef$var$OneOf.prototype.remove = function remove(field) {
    /* istanbul ignore if */ if (!(field instanceof $fMEB1)) throw TypeError("field must be a Field");
    var index = this.fieldsArray.indexOf(field);
    /* istanbul ignore if */ if (index < 0) throw Error(field + " is not a member of " + this);
    this.fieldsArray.splice(index, 1);
    index = this.oneof.indexOf(field.name);
    /* istanbul ignore else */ if (index > -1) this.oneof.splice(index, 1);
    field.partOf = null;
    return this;
};
/**
 * @override
 */ $64aa8ffec14d52ef$var$OneOf.prototype.onAdd = function onAdd(parent) {
    $eqXqI.prototype.onAdd.call(this, parent);
    var self = this;
    // Collect present fields
    for(var i = 0; i < this.oneof.length; ++i){
        var field = parent.get(this.oneof[i]);
        if (field && !field.partOf) {
            field.partOf = self;
            self.fieldsArray.push(field);
        }
    }
    // Add not yet present fields
    $64aa8ffec14d52ef$var$addFieldsToParent(this);
};
/**
 * @override
 */ $64aa8ffec14d52ef$var$OneOf.prototype.onRemove = function onRemove(parent) {
    for(var i = 0, field; i < this.fieldsArray.length; ++i)if ((field = this.fieldsArray[i]).parent) field.parent.remove(field);
    $eqXqI.prototype.onRemove.call(this, parent);
};
/**
 * Determines whether this field corresponds to a synthetic oneof created for
 * a proto3 optional field.  No behavioral logic should depend on this, but it
 * can be relevant for reflection.
 * @name OneOf#isProto3Optional
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($64aa8ffec14d52ef$var$OneOf.prototype, "isProto3Optional", {
    get: function() {
        if (this.fieldsArray == null || this.fieldsArray.length !== 1) return false;
        var field = this.fieldsArray[0];
        return field.options != null && field.options["proto3_optional"] === true;
    }
});
/**
 * Decorator function as returned by {@link OneOf.d} (TypeScript).
 * @typedef OneOfDecorator
 * @type {function}
 * @param {Object} prototype Target prototype
 * @param {string} oneofName OneOf name
 * @returns {undefined}
 */ /**
 * OneOf decorator (TypeScript).
 * @function
 * @param {...string} fieldNames Field names
 * @returns {OneOfDecorator} Decorator function
 * @template T extends string
 */ $64aa8ffec14d52ef$var$OneOf.d = function decorateOneOf() {
    var fieldNames = new Array(arguments.length), index = 0;
    while(index < arguments.length)fieldNames[index] = arguments[index++];
    return function oneOfDecorator(prototype, oneofName) {
        $jshGU.decorateType(prototype.constructor).add(new $64aa8ffec14d52ef$var$OneOf(oneofName, fieldNames));
        Object.defineProperty(prototype, oneofName, {
            get: $jshGU.oneOfGetter(fieldNames),
            set: $jshGU.oneOfSetter(fieldNames)
        });
    };
};

});
parcelRegister("fMEB1", function(module, exports) {
"use strict";
module.exports = $b7dad4439ac362ad$var$Field;

var $eqXqI = parcelRequire("eqXqI");
(($b7dad4439ac362ad$var$Field.prototype = Object.create($eqXqI.prototype)).constructor = $b7dad4439ac362ad$var$Field).className = "Field";

var $teZIn = parcelRequire("teZIn");

var $keBMp = parcelRequire("keBMp");

var $jshGU = parcelRequire("jshGU");
var $b7dad4439ac362ad$var$Type; // cyclic
var $b7dad4439ac362ad$var$ruleRe = /^required|optional|repeated$/;
/**
 * Constructs a new message field instance. Note that {@link MapField|map fields} have their own class.
 * @name Field
 * @classdesc Reflected message field.
 * @extends FieldBase
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {number} id Unique id within its namespace
 * @param {string} type Value type
 * @param {string|Object.<string,*>} [rule="optional"] Field rule
 * @param {string|Object.<string,*>} [extend] Extended type if different from parent
 * @param {Object.<string,*>} [options] Declared options
 */ /**
 * Constructs a field from a field descriptor.
 * @param {string} name Field name
 * @param {IField} json Field descriptor
 * @returns {Field} Created field
 * @throws {TypeError} If arguments are invalid
 */ $b7dad4439ac362ad$var$Field.fromJSON = function fromJSON(name, json) {
    var field = new $b7dad4439ac362ad$var$Field(name, json.id, json.type, json.rule, json.extend, json.options, json.comment);
    if (json.edition) field._edition = json.edition;
    field._defaultEdition = "proto3"; // For backwards-compatibility.
    return field;
};
/**
 * Not an actual constructor. Use {@link Field} instead.
 * @classdesc Base class of all reflected message fields. This is not an actual class but here for the sake of having consistent type definitions.
 * @exports FieldBase
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {number} id Unique id within its namespace
 * @param {string} type Value type
 * @param {string|Object.<string,*>} [rule="optional"] Field rule
 * @param {string|Object.<string,*>} [extend] Extended type if different from parent
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] Comment associated with this field
 */ function $b7dad4439ac362ad$var$Field(name, id, type, rule, extend, options, comment) {
    if ($jshGU.isObject(rule)) {
        comment = extend;
        options = rule;
        rule = extend = undefined;
    } else if ($jshGU.isObject(extend)) {
        comment = options;
        options = extend;
        extend = undefined;
    }
    $eqXqI.call(this, name, options);
    if (!$jshGU.isInteger(id) || id < 0) throw TypeError("id must be a non-negative integer");
    if (!$jshGU.isString(type)) throw TypeError("type must be a string");
    if (rule !== undefined && !$b7dad4439ac362ad$var$ruleRe.test(rule = rule.toString().toLowerCase())) throw TypeError("rule must be a string rule");
    if (extend !== undefined && !$jshGU.isString(extend)) throw TypeError("extend must be a string");
    /**
     * Field rule, if any.
     * @type {string|undefined}
     */ if (rule === "proto3_optional") rule = "optional";
    this.rule = rule && rule !== "optional" ? rule : undefined; // toJSON
    /**
     * Field type.
     * @type {string}
     */ this.type = type; // toJSON
    /**
     * Unique field id.
     * @type {number}
     */ this.id = id; // toJSON, marker
    /**
     * Extended type if different from parent.
     * @type {string|undefined}
     */ this.extend = extend || undefined; // toJSON
    /**
     * Whether this field is repeated.
     * @type {boolean}
     */ this.repeated = rule === "repeated";
    /**
     * Whether this field is a map or not.
     * @type {boolean}
     */ this.map = false;
    /**
     * Message this field belongs to.
     * @type {Type|null}
     */ this.message = null;
    /**
     * OneOf this field belongs to, if any,
     * @type {OneOf|null}
     */ this.partOf = null;
    /**
     * The field type's default value.
     * @type {*}
     */ this.typeDefault = null;
    /**
     * The field's default value on prototypes.
     * @type {*}
     */ this.defaultValue = null;
    /**
     * Whether this field's value should be treated as a long.
     * @type {boolean}
     */ this.long = $jshGU.Long ? $keBMp.long[type] !== undefined : /* istanbul ignore next */ false;
    /**
     * Whether this field's value is a buffer.
     * @type {boolean}
     */ this.bytes = type === "bytes";
    /**
     * Resolved type if not a basic type.
     * @type {Type|Enum|null}
     */ this.resolvedType = null;
    /**
     * Sister-field within the extended type if a declaring extension field.
     * @type {Field|null}
     */ this.extensionField = null;
    /**
     * Sister-field within the declaring namespace if an extended field.
     * @type {Field|null}
     */ this.declaringField = null;
    /**
     * Comment for this field.
     * @type {string|null}
     */ this.comment = comment;
}
/**
 * Determines whether this field is required.
 * @name Field#required
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($b7dad4439ac362ad$var$Field.prototype, "required", {
    get: function() {
        return this._features.field_presence === "LEGACY_REQUIRED";
    }
});
/**
 * Determines whether this field is not required.
 * @name Field#optional
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($b7dad4439ac362ad$var$Field.prototype, "optional", {
    get: function() {
        return !this.required;
    }
});
/**
 * Determines whether this field uses tag-delimited encoding.  In proto2 this
 * corresponded to group syntax.
 * @name Field#delimited
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($b7dad4439ac362ad$var$Field.prototype, "delimited", {
    get: function() {
        return this.resolvedType instanceof $b7dad4439ac362ad$var$Type && this._features.message_encoding === "DELIMITED";
    }
});
/**
 * Determines whether this field is packed. Only relevant when repeated.
 * @name Field#packed
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($b7dad4439ac362ad$var$Field.prototype, "packed", {
    get: function() {
        return this._features.repeated_field_encoding === "PACKED";
    }
});
/**
 * Determines whether this field tracks presence.
 * @name Field#hasPresence
 * @type {boolean}
 * @readonly
 */ Object.defineProperty($b7dad4439ac362ad$var$Field.prototype, "hasPresence", {
    get: function() {
        if (this.repeated || this.map) return false;
        return this.partOf || // oneofs
        this.declaringField || this.extensionField || // extensions
        this._features.field_presence !== "IMPLICIT";
    }
});
/**
 * @override
 */ $b7dad4439ac362ad$var$Field.prototype.setOption = function setOption(name, value, ifNotSet) {
    return $eqXqI.prototype.setOption.call(this, name, value, ifNotSet);
};
/**
 * Field descriptor.
 * @interface IField
 * @property {string} [rule="optional"] Field rule
 * @property {string} type Field type
 * @property {number} id Field id
 * @property {Object.<string,*>} [options] Field options
 */ /**
 * Extension field descriptor.
 * @interface IExtensionField
 * @extends IField
 * @property {string} extend Extended type
 */ /**
 * Converts this field to a field descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IField} Field descriptor
 */ $b7dad4439ac362ad$var$Field.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "edition",
        this._editionToJSON(),
        "rule",
        this.rule !== "optional" && this.rule || undefined,
        "type",
        this.type,
        "id",
        this.id,
        "extend",
        this.extend,
        "options",
        this.options,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * Resolves this field's type references.
 * @returns {Field} `this`
 * @throws {Error} If any reference cannot be resolved
 */ $b7dad4439ac362ad$var$Field.prototype.resolve = function resolve() {
    if (this.resolved) return this;
    if ((this.typeDefault = $keBMp.defaults[this.type]) === undefined) {
        this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type);
        if (this.resolvedType instanceof $b7dad4439ac362ad$var$Type) this.typeDefault = null;
        else this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]; // first defined
    } else if (this.options && this.options.proto3_optional) // proto3 scalar value marked optional; should default to null
    this.typeDefault = null;
    // use explicitly set default value if present
    if (this.options && this.options["default"] != null) {
        this.typeDefault = this.options["default"];
        if (this.resolvedType instanceof $teZIn && typeof this.typeDefault === "string") this.typeDefault = this.resolvedType.values[this.typeDefault];
    }
    // remove unnecessary options
    if (this.options) {
        if (this.options.packed !== undefined && this.resolvedType && !(this.resolvedType instanceof $teZIn)) delete this.options.packed;
        if (!Object.keys(this.options).length) this.options = undefined;
    }
    // convert to internal data type if necesssary
    if (this.long) {
        this.typeDefault = $jshGU.Long.fromNumber(this.typeDefault, this.type === "uint64" || this.type === "fixed64");
        /* istanbul ignore else */ if (Object.freeze) Object.freeze(this.typeDefault); // long instances are meant to be immutable anyway (i.e. use small int cache that even requires it)
    } else if (this.bytes && typeof this.typeDefault === "string") {
        var buf;
        if ($jshGU.base64.test(this.typeDefault)) $jshGU.base64.decode(this.typeDefault, buf = $jshGU.newBuffer($jshGU.base64.length(this.typeDefault)), 0);
        else $jshGU.utf8.write(this.typeDefault, buf = $jshGU.newBuffer($jshGU.utf8.length(this.typeDefault)), 0);
        this.typeDefault = buf;
    }
    // take special care of maps and repeated fields
    if (this.map) this.defaultValue = $jshGU.emptyObject;
    else if (this.repeated) this.defaultValue = $jshGU.emptyArray;
    else this.defaultValue = this.typeDefault;
    // ensure proper value on prototype
    if (this.parent instanceof $b7dad4439ac362ad$var$Type) this.parent.ctor.prototype[this.name] = this.defaultValue;
    return $eqXqI.prototype.resolve.call(this);
};
/**
 * Infers field features from legacy syntax that may have been specified differently.
 * in older editions.
 * @param {string|undefined} edition The edition this proto is on, or undefined if pre-editions
 * @returns {object} The feature values to override
 */ $b7dad4439ac362ad$var$Field.prototype._inferLegacyProtoFeatures = function _inferLegacyProtoFeatures(edition) {
    if (edition !== "proto2" && edition !== "proto3") return {};
    var features = {};
    if (this.rule === "required") features.field_presence = "LEGACY_REQUIRED";
    if (this.parent && $keBMp.defaults[this.type] === undefined) {
        // We can't use resolvedType because types may not have been resolved yet.  However,
        // legacy groups are always in the same scope as the field so we don't have to do a
        // full scan of the tree.
        var type = this.parent.get(this.type.split(".").pop());
        if (type && type instanceof $b7dad4439ac362ad$var$Type && type.group) features.message_encoding = "DELIMITED";
    }
    if (this.getOption("packed") === true) features.repeated_field_encoding = "PACKED";
    else if (this.getOption("packed") === false) features.repeated_field_encoding = "EXPANDED";
    return features;
};
/**
 * @override
 */ $b7dad4439ac362ad$var$Field.prototype._resolveFeatures = function _resolveFeatures(edition) {
    return $eqXqI.prototype._resolveFeatures.call(this, this._edition || edition);
};
/**
 * Decorator function as returned by {@link Field.d} and {@link MapField.d} (TypeScript).
 * @typedef FieldDecorator
 * @type {function}
 * @param {Object} prototype Target prototype
 * @param {string} fieldName Field name
 * @returns {undefined}
 */ /**
 * Field decorator (TypeScript).
 * @name Field.d
 * @function
 * @param {number} fieldId Field id
 * @param {"double"|"float"|"int32"|"uint32"|"sint32"|"fixed32"|"sfixed32"|"int64"|"uint64"|"sint64"|"fixed64"|"sfixed64"|"string"|"bool"|"bytes"|Object} fieldType Field type
 * @param {"optional"|"required"|"repeated"} [fieldRule="optional"] Field rule
 * @param {T} [defaultValue] Default value
 * @returns {FieldDecorator} Decorator function
 * @template T extends number | number[] | Long | Long[] | string | string[] | boolean | boolean[] | Uint8Array | Uint8Array[] | Buffer | Buffer[]
 */ $b7dad4439ac362ad$var$Field.d = function decorateField(fieldId, fieldType, fieldRule, defaultValue) {
    // submessage: decorate the submessage and use its name as the type
    if (typeof fieldType === "function") fieldType = $jshGU.decorateType(fieldType).name;
    else if (fieldType && typeof fieldType === "object") fieldType = $jshGU.decorateEnum(fieldType).name;
    return function fieldDecorator(prototype, fieldName) {
        $jshGU.decorateType(prototype.constructor).add(new $b7dad4439ac362ad$var$Field(fieldName, fieldId, fieldType, fieldRule, {
            "default": defaultValue
        }));
    };
};
/**
 * Field decorator (TypeScript).
 * @name Field.d
 * @function
 * @param {number} fieldId Field id
 * @param {Constructor<T>|string} fieldType Field type
 * @param {"optional"|"required"|"repeated"} [fieldRule="optional"] Field rule
 * @returns {FieldDecorator} Decorator function
 * @template T extends Message<T>
 * @variation 2
 */ // like Field.d but without a default value
// Sets up cyclic dependencies (called in index-light)
$b7dad4439ac362ad$var$Field._configure = function configure(Type_) {
    $b7dad4439ac362ad$var$Type = Type_;
};

});
parcelRegister("keBMp", function(module, exports) {
"use strict";
/**
 * Common type constants.
 * @namespace
 */ var $ebb26bbd31aa20d5$var$types = module.exports;

var $jshGU = parcelRequire("jshGU");
var $ebb26bbd31aa20d5$var$s = [
    "double",
    "float",
    "int32",
    "uint32",
    "sint32",
    "fixed32",
    "sfixed32",
    "int64",
    "uint64",
    "sint64",
    "fixed64",
    "sfixed64",
    "bool",
    "string",
    "bytes" // 14
];
function $ebb26bbd31aa20d5$var$bake(values, offset) {
    var i = 0, o = Object.create(null);
    offset |= 0;
    while(i < values.length)o[$ebb26bbd31aa20d5$var$s[i + offset]] = values[i++];
    return o;
}
/**
 * Basic type wire types.
 * @type {Object.<string,number>}
 * @const
 * @property {number} double=1 Fixed64 wire type
 * @property {number} float=5 Fixed32 wire type
 * @property {number} int32=0 Varint wire type
 * @property {number} uint32=0 Varint wire type
 * @property {number} sint32=0 Varint wire type
 * @property {number} fixed32=5 Fixed32 wire type
 * @property {number} sfixed32=5 Fixed32 wire type
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 * @property {number} bool=0 Varint wire type
 * @property {number} string=2 Ldelim wire type
 * @property {number} bytes=2 Ldelim wire type
 */ $ebb26bbd31aa20d5$var$types.basic = $ebb26bbd31aa20d5$var$bake([
    /* double   */ 1,
    /* float    */ 5,
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 5,
    /* sfixed32 */ 5,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1,
    /* bool     */ 0,
    /* string   */ 2,
    /* bytes    */ 2
]);
/**
 * Basic type defaults.
 * @type {Object.<string,*>}
 * @const
 * @property {number} double=0 Double default
 * @property {number} float=0 Float default
 * @property {number} int32=0 Int32 default
 * @property {number} uint32=0 Uint32 default
 * @property {number} sint32=0 Sint32 default
 * @property {number} fixed32=0 Fixed32 default
 * @property {number} sfixed32=0 Sfixed32 default
 * @property {number} int64=0 Int64 default
 * @property {number} uint64=0 Uint64 default
 * @property {number} sint64=0 Sint32 default
 * @property {number} fixed64=0 Fixed64 default
 * @property {number} sfixed64=0 Sfixed64 default
 * @property {boolean} bool=false Bool default
 * @property {string} string="" String default
 * @property {Array.<number>} bytes=Array(0) Bytes default
 * @property {null} message=null Message default
 */ $ebb26bbd31aa20d5$var$types.defaults = $ebb26bbd31aa20d5$var$bake([
    /* double   */ 0,
    /* float    */ 0,
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 0,
    /* sfixed32 */ 0,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 0,
    /* sfixed64 */ 0,
    /* bool     */ false,
    /* string   */ "",
    /* bytes    */ $jshGU.emptyArray,
    /* message  */ null
]);
/**
 * Basic long type wire types.
 * @type {Object.<string,number>}
 * @const
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 */ $ebb26bbd31aa20d5$var$types.long = $ebb26bbd31aa20d5$var$bake([
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1
], 7);
/**
 * Allowed types for map keys with their associated wire type.
 * @type {Object.<string,number>}
 * @const
 * @property {number} int32=0 Varint wire type
 * @property {number} uint32=0 Varint wire type
 * @property {number} sint32=0 Varint wire type
 * @property {number} fixed32=5 Fixed32 wire type
 * @property {number} sfixed32=5 Fixed32 wire type
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 * @property {number} bool=0 Varint wire type
 * @property {number} string=2 Ldelim wire type
 */ $ebb26bbd31aa20d5$var$types.mapKey = $ebb26bbd31aa20d5$var$bake([
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 5,
    /* sfixed32 */ 5,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1,
    /* bool     */ 0,
    /* string   */ 2
], 2);
/**
 * Allowed types for packed repeated fields with their associated wire type.
 * @type {Object.<string,number>}
 * @const
 * @property {number} double=1 Fixed64 wire type
 * @property {number} float=5 Fixed32 wire type
 * @property {number} int32=0 Varint wire type
 * @property {number} uint32=0 Varint wire type
 * @property {number} sint32=0 Varint wire type
 * @property {number} fixed32=5 Fixed32 wire type
 * @property {number} sfixed32=5 Fixed32 wire type
 * @property {number} int64=0 Varint wire type
 * @property {number} uint64=0 Varint wire type
 * @property {number} sint64=0 Varint wire type
 * @property {number} fixed64=1 Fixed64 wire type
 * @property {number} sfixed64=1 Fixed64 wire type
 * @property {number} bool=0 Varint wire type
 */ $ebb26bbd31aa20d5$var$types.packed = $ebb26bbd31aa20d5$var$bake([
    /* double   */ 1,
    /* float    */ 5,
    /* int32    */ 0,
    /* uint32   */ 0,
    /* sint32   */ 0,
    /* fixed32  */ 5,
    /* sfixed32 */ 5,
    /* int64    */ 0,
    /* uint64   */ 0,
    /* sint64   */ 0,
    /* fixed64  */ 1,
    /* sfixed64 */ 1,
    /* bool     */ 0
]);

});
parcelRegister("jshGU", function(module, exports) {
"use strict";

/**
 * Various utility functions.
 * @namespace
 */ var $e29e5af3c073127d$var$util = module.exports = (parcelRequire("hf2LF"));

var $38hgC = parcelRequire("38hgC");
var $e29e5af3c073127d$var$Type, $e29e5af3c073127d$var$Enum;

$e29e5af3c073127d$var$util.codegen = (parcelRequire("jvP0G"));

$e29e5af3c073127d$var$util.fetch = (parcelRequire("87at5"));

$e29e5af3c073127d$var$util.path = (parcelRequire("hcPZH"));

$e29e5af3c073127d$var$util.patterns = (parcelRequire("4SAE1"));
var $e29e5af3c073127d$var$reservedRe = $e29e5af3c073127d$var$util.patterns.reservedRe;

/**
 * Node's fs module if available.
 * @type {Object.<string,*>}
 */ $e29e5af3c073127d$var$util.fs = (parcelRequire("i2mO6"));
/**
 * Checks a recursion depth.
 * @param {number|undefined} depth Depth of recursion
 * @returns {number} Depth of recursion
 * @throws {Error} If depth exceeds util.recursionLimit
 */ $e29e5af3c073127d$var$util.checkDepth = function checkDepth(depth) {
    if (depth === undefined) depth = 0;
    if (depth > $e29e5af3c073127d$var$util.recursionLimit) throw Error("max depth exceeded");
    return depth;
};
/**
 * Converts an object's values to an array.
 * @param {Object.<string,*>} object Object to convert
 * @returns {Array.<*>} Converted array
 */ $e29e5af3c073127d$var$util.toArray = function toArray(object) {
    if (object) {
        var keys = Object.keys(object), array = new Array(keys.length), index = 0;
        while(index < keys.length)array[index] = object[keys[index++]];
        return array;
    }
    return [];
};
/**
 * Converts an array of keys immediately followed by their respective value to an object, omitting undefined values.
 * @param {Array.<*>} array Array to convert
 * @returns {Object.<string,*>} Converted object
 */ $e29e5af3c073127d$var$util.toObject = function toObject(array) {
    var object = {}, index = 0;
    while(index < array.length){
        var key = array[index++], val = array[index++];
        if (val !== undefined) object[key] = val;
    }
    return object;
};
/**
 * Tests whether the specified name is a reserved word in JS.
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $e29e5af3c073127d$var$util.isReserved = function isReserved(name) {
    return $e29e5af3c073127d$var$reservedRe.test(name);
};
/**
 * Returns a safe property accessor for the specified property name.
 * @param {string} prop Property name
 * @returns {string} Safe accessor
 */ $e29e5af3c073127d$var$util.safeProp = function safeProp(prop) {
    if (!/^[$\w_]+$/.test(prop) || $e29e5af3c073127d$var$reservedRe.test(prop)) return "[" + JSON.stringify(prop) + "]";
    return "." + prop;
};
/**
 * Converts the first character of a string to upper case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $e29e5af3c073127d$var$util.ucFirst = function ucFirst(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
};
var $e29e5af3c073127d$var$camelCaseRe = /_([a-z])/g;
/**
 * Converts a string to camel case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $e29e5af3c073127d$var$util.camelCase = function camelCase(str) {
    return str.substring(0, 1) + str.substring(1).replace($e29e5af3c073127d$var$camelCaseRe, function($0, $1) {
        return $1.toUpperCase();
    });
};
/**
 * Compares reflected fields by id.
 * @param {Field} a First field
 * @param {Field} b Second field
 * @returns {number} Comparison value
 */ $e29e5af3c073127d$var$util.compareFieldsById = function compareFieldsById(a, b) {
    return a.id - b.id;
};

/**
 * Decorator helper for types (TypeScript).
 * @param {Constructor<T>} ctor Constructor function
 * @param {string} [typeName] Type name, defaults to the constructor's name
 * @returns {Type} Reflected type
 * @template T extends Message<T>
 * @property {Root} root Decorators root
 */ $e29e5af3c073127d$var$util.decorateType = function decorateType(ctor, typeName) {
    /* istanbul ignore if */ if (ctor.$type) {
        if (typeName && ctor.$type.name !== typeName) {
            $e29e5af3c073127d$var$util.decorateRoot.remove(ctor.$type);
            ctor.$type.name = typeName;
            $e29e5af3c073127d$var$util.decorateRoot.add(ctor.$type);
        }
        return ctor.$type;
    }
    /* istanbul ignore next */ if (!$e29e5af3c073127d$var$Type) $e29e5af3c073127d$var$Type = (parcelRequire("kPRSk"));
    var type = new $e29e5af3c073127d$var$Type(typeName || ctor.name);
    $e29e5af3c073127d$var$util.decorateRoot.add(type);
    type.ctor = ctor; // sets up .encode, .decode etc.
    Object.defineProperty(ctor, "$type", {
        value: type,
        enumerable: false
    });
    Object.defineProperty(ctor.prototype, "$type", {
        value: type,
        enumerable: false
    });
    return type;
};
var $e29e5af3c073127d$var$decorateEnumIndex = 0;

/**
 * Decorator helper for enums (TypeScript).
 * @param {Object} object Enum object
 * @returns {Enum} Reflected enum
 */ $e29e5af3c073127d$var$util.decorateEnum = function decorateEnum(object) {
    /* istanbul ignore if */ if (object.$type) return object.$type;
    /* istanbul ignore next */ if (!$e29e5af3c073127d$var$Enum) $e29e5af3c073127d$var$Enum = (parcelRequire("teZIn"));
    var enm = new $e29e5af3c073127d$var$Enum("Enum" + $e29e5af3c073127d$var$decorateEnumIndex++, object);
    $e29e5af3c073127d$var$util.decorateRoot.add(enm);
    Object.defineProperty(object, "$type", {
        value: enm,
        enumerable: false
    });
    return enm;
};
/**
 * Sets the value of a property by property path. If a value already exists, it is turned to an array
 * @param {Object.<string,*>} dst Destination object
 * @param {string} path dot '.' delimited path of the property to set
 * @param {Object} value the value to set
 * @param {boolean|undefined} [ifNotSet] Sets the option only if it isn't currently set
 * @returns {Object.<string,*>} Destination object
 */ $e29e5af3c073127d$var$util.setProperty = function setProperty(dst, path, value, ifNotSet) {
    function setProp(dst, path, value) {
        var part = path.shift();
        if ($e29e5af3c073127d$var$util.isUnsafeProperty(part)) return dst;
        if (path.length > 0) dst[part] = setProp(dst[part] || {}, path, value);
        else {
            var prevValue = dst[part];
            if (prevValue && ifNotSet) return dst;
            if (prevValue) value = [].concat(prevValue).concat(value);
            dst[part] = value;
        }
        return dst;
    }
    if (typeof dst !== "object") throw TypeError("dst must be an object");
    if (!path) throw TypeError("path must be specified");
    path = path.split(".");
    if (path.length > $e29e5af3c073127d$var$util.recursionLimit) throw Error("max depth exceeded");
    return setProp(dst, path, value);
};

/**
 * Decorator root (TypeScript).
 * @name util.decorateRoot
 * @type {Root}
 * @readonly
 */ Object.defineProperty($e29e5af3c073127d$var$util, "decorateRoot", {
    get: function() {
        return $38hgC.decorated || ($38hgC["decorated"] = new (parcelRequire("hjrO2"))());
    }
});

});
parcelRegister("jvP0G", function(module, exports) {
"use strict";
module.exports = $e3487b1c341f7a9d$var$codegen;
var $e3487b1c341f7a9d$var$reservedRe = /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/;
/**
 * Begins generating a function.
 * @memberof util
 * @param {string[]} functionParams Function parameter names
 * @param {string} [functionName] Function name if not anonymous
 * @returns {Codegen} Appender that appends code to the function's body
 */ function $e3487b1c341f7a9d$var$codegen(functionParams, functionName) {
    /* istanbul ignore if */ if (typeof functionParams === "string") {
        functionName = functionParams;
        functionParams = undefined;
    }
    var body = [];
    /**
     * Appends code to the function's body or finishes generation.
     * @typedef Codegen
     * @type {function}
     * @param {string|Object.<string,*>} [formatStringOrScope] Format string or, to finish the function, an object of additional scope variables, if any
     * @param {...*} [formatParams] Format parameters
     * @returns {Codegen|Function} Itself or the generated function if finished
     * @throws {Error} If format parameter counts do not match
     */ function Codegen(formatStringOrScope) {
        // note that explicit array handling below makes this ~50% faster
        // finish the function
        if (typeof formatStringOrScope !== "string") {
            var source = toString();
            if ($e3487b1c341f7a9d$var$codegen.verbose) console.log("codegen: " + source); // eslint-disable-line no-console
            source = "return " + source;
            if (formatStringOrScope) {
                var scopeKeys = Object.keys(formatStringOrScope), scopeParams = new Array(scopeKeys.length + 1), scopeValues = new Array(scopeKeys.length), scopeOffset = 0;
                while(scopeOffset < scopeKeys.length){
                    scopeParams[scopeOffset] = scopeKeys[scopeOffset];
                    scopeValues[scopeOffset] = formatStringOrScope[scopeKeys[scopeOffset++]];
                }
                scopeParams[scopeOffset] = source;
                return Function.apply(null, scopeParams).apply(null, scopeValues); // eslint-disable-line no-new-func
            }
            return Function(source)(); // eslint-disable-line no-new-func
        }
        // otherwise append to body
        var formatParams = new Array(arguments.length - 1), formatOffset = 0;
        while(formatOffset < formatParams.length)formatParams[formatOffset] = arguments[++formatOffset];
        formatOffset = 0;
        formatStringOrScope = formatStringOrScope.replace(/%([%dfijs])/g, function replace($0, $1) {
            var value = formatParams[formatOffset++];
            switch($1){
                case "d":
                case "f":
                    return String(Number(value));
                case "i":
                    return String(Math.floor(value));
                case "j":
                    return JSON.stringify(value);
                case "s":
                    return String(value);
            }
            return "%";
        });
        if (formatOffset !== formatParams.length) throw Error("parameter count mismatch");
        body.push(formatStringOrScope);
        return Codegen;
    }
    function toString(functionNameOverride) {
        return "function " + $e3487b1c341f7a9d$var$safeFunctionName(functionNameOverride || functionName) + "(" + (functionParams && functionParams.join(",") || "") + "){\n  " + body.join("\n  ") + "\n}";
    }
    Codegen.toString = toString;
    return Codegen;
}
/**
 * Begins generating a function.
 * @memberof util
 * @function codegen
 * @param {string} [functionName] Function name if not anonymous
 * @returns {Codegen} Appender that appends code to the function's body
 * @variation 2
 */ /**
 * When set to `true`, codegen will log generated code to console. Useful for debugging.
 * @name util.codegen.verbose
 * @type {boolean}
 */ $e3487b1c341f7a9d$var$codegen.verbose = false;
function $e3487b1c341f7a9d$var$safeFunctionName(name) {
    if (!name) return "";
    name = String(name).replace(/[^\w$]/g, "");
    if (!name) return "";
    if (/^\d/.test(name)) name = "_" + name;
    return $e3487b1c341f7a9d$var$reservedRe.test(name) ? name + "_" : name;
}

});

parcelRegister("87at5", function(module, exports) {
"use strict";
module.exports = $5e8718e80f9d930c$var$fetch;

var $6TUyK = parcelRequire("6TUyK");

var $4wVtr = parcelRequire("4wVtr");
/**
 * Node-style callback as used by {@link util.fetch}.
 * @typedef FetchCallback
 * @type {function}
 * @param {?Error} error Error, if any, otherwise `null`
 * @param {string} [contents] File contents, if there hasn't been an error
 * @returns {undefined}
 */ /**
 * Options as used by {@link util.fetch}.
 * @interface IFetchOptions
 * @property {boolean} [binary=false] Whether expecting a binary response
 * @property {boolean} [xhr=false] If `true`, forces the use of XMLHttpRequest
 */ /**
 * Fetches the contents of a file.
 * @memberof util
 * @param {string} filename File path or url
 * @param {IFetchOptions} options Fetch options
 * @param {FetchCallback} callback Callback function
 * @returns {undefined}
 */ function $5e8718e80f9d930c$var$fetch(filename, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    } else if (!options) options = {};
    if (!callback) return $6TUyK($5e8718e80f9d930c$var$fetch, this, filename, options); // eslint-disable-line no-invalid-this
    // if a node-like filesystem is present, try it first but fall back to XHR if nothing is found.
    if (!options.xhr && $4wVtr && $4wVtr.readFile) return $4wVtr.readFile(filename, function fetchReadFileCallback(err, contents) {
        return err && typeof XMLHttpRequest !== "undefined" ? $5e8718e80f9d930c$var$fetch.xhr(filename, options, callback) : err ? callback(err) : callback(null, options.binary ? contents : contents.toString("utf8"));
    });
    // use the XHR version otherwise.
    return $5e8718e80f9d930c$var$fetch.xhr(filename, options, callback);
}
/**
 * Fetches the contents of a file.
 * @name util.fetch
 * @function
 * @param {string} path File path or url
 * @param {FetchCallback} callback Callback function
 * @returns {undefined}
 * @variation 2
 */ /**
 * Fetches the contents of a file.
 * @name util.fetch
 * @function
 * @param {string} path File path or url
 * @param {IFetchOptions} [options] Fetch options
 * @returns {Promise<string|Uint8Array>} Promise
 * @variation 3
 */ /**/ $5e8718e80f9d930c$var$fetch.xhr = function fetch_xhr(filename, options, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function fetchOnReadyStateChange() {
        if (xhr.readyState !== 4) return undefined;
        // local cors security errors return status 0 / empty string, too. afaik this cannot be
        // reliably distinguished from an actually empty file for security reasons. feel free
        // to send a pull request if you are aware of a solution.
        if (xhr.status !== 0 && xhr.status !== 200) return callback(Error("status " + xhr.status));
        // if binary data is expected, make sure that some sort of array is returned, even if
        // ArrayBuffers are not supported. the binary string fallback, however, is unsafe.
        if (options.binary) {
            var buffer = xhr.response;
            if (!buffer) {
                buffer = [];
                for(var i = 0; i < xhr.responseText.length; ++i)buffer.push(xhr.responseText.charCodeAt(i) & 255);
            }
            return callback(null, typeof Uint8Array !== "undefined" ? new Uint8Array(buffer) : buffer);
        }
        return callback(null, xhr.responseText);
    };
    if (options.binary) {
        // ref: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Sending_and_Receiving_Binary_Data#Receiving_binary_data_in_older_browsers
        if ("overrideMimeType" in xhr) xhr.overrideMimeType("text/plain; charset=x-user-defined");
        xhr.responseType = "arraybuffer";
    }
    xhr.open("GET", filename);
    xhr.send();
};

});
parcelRegister("4wVtr", function(module, exports) {
"use strict";
var $34c6bbb4acbadca3$var$fs = null;

try {
    $34c6bbb4acbadca3$var$fs = (parcelRequire("jMNYH"));
    if (!$34c6bbb4acbadca3$var$fs || !$34c6bbb4acbadca3$var$fs.readFile || !$34c6bbb4acbadca3$var$fs.readFileSync) $34c6bbb4acbadca3$var$fs = null;
} catch (e) {
// `fs` is unavailable in browsers and browser-like bundles.
}
module.exports = $34c6bbb4acbadca3$var$fs;

});
parcelRegister("jMNYH", function(module, exports) {
"use strict";

});



parcelRegister("hcPZH", function(module, exports) {
"use strict";
/**
 * A minimal path module to resolve Unix, Windows and URL paths alike.
 * @memberof util
 * @namespace
 */ var $c86be39b61cc2191$var$path = module.exports;
var $c86be39b61cc2191$var$isAbsolute = /**
 * Tests if the specified path is absolute.
 * @param {string} path Path to test
 * @returns {boolean} `true` if path is absolute
 */ $c86be39b61cc2191$var$path.isAbsolute = function isAbsolute(path) {
    return /^(?:\/|\w+:)/.test(path);
};
var $c86be39b61cc2191$var$normalize = /**
 * Normalizes the specified path.
 * @param {string} path Path to normalize
 * @returns {string} Normalized path
 */ $c86be39b61cc2191$var$path.normalize = function normalize(path) {
    path = path.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
    var parts = path.split("/"), absolute = $c86be39b61cc2191$var$isAbsolute(path), prefix = "";
    if (absolute) prefix = parts.shift() + "/";
    for(var i = 0; i < parts.length;){
        if (parts[i] === "..") {
            if (i > 0 && parts[i - 1] !== "..") parts.splice(--i, 2);
            else if (absolute) parts.splice(i, 1);
            else ++i;
        } else if (parts[i] === ".") parts.splice(i, 1);
        else ++i;
    }
    return prefix + parts.join("/");
};
/**
 * Resolves the specified include path against the specified origin path.
 * @param {string} originPath Path to the origin file
 * @param {string} includePath Include path relative to origin path
 * @param {boolean} [alreadyNormalized=false] `true` if both paths are already known to be normalized
 * @returns {string} Path to the include file
 */ $c86be39b61cc2191$var$path.resolve = function resolve(originPath, includePath, alreadyNormalized) {
    if (!alreadyNormalized) includePath = $c86be39b61cc2191$var$normalize(includePath);
    if ($c86be39b61cc2191$var$isAbsolute(includePath)) return includePath;
    if (!alreadyNormalized) originPath = $c86be39b61cc2191$var$normalize(originPath);
    return (originPath = originPath.replace(/(?:\/|^)[^/]+$/, "")).length ? $c86be39b61cc2191$var$normalize(originPath + "/" + includePath) : includePath;
};

});

parcelRegister("4SAE1", function(module, exports) {
"use strict";
var $38d8a168bfcc6412$var$patterns = module.exports;
$38d8a168bfcc6412$var$patterns.numberRe = /^(?![eE])[0-9]*(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?$/;
$38d8a168bfcc6412$var$patterns.typeRefRe = /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*$/;
$38d8a168bfcc6412$var$patterns.reservedRe = /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/;

});

parcelRegister("i2mO6", function(module, exports) {
"use strict";
var $d21a1aefaf9422fd$var$fs = null;

try {
    $d21a1aefaf9422fd$var$fs = (parcelRequire("jMNYH"));
    if (!$d21a1aefaf9422fd$var$fs || !$d21a1aefaf9422fd$var$fs.readFile || !$d21a1aefaf9422fd$var$fs.readFileSync) $d21a1aefaf9422fd$var$fs = null;
} catch (e) {
// `fs` is unavailable in browsers and browser-like bundles.
}
module.exports = $d21a1aefaf9422fd$var$fs;

});

parcelRegister("kPRSk", function(module, exports) {
"use strict";
module.exports = $f2b25c8c7de96169$var$Type;

var $3keUm = parcelRequire("3keUm");
(($f2b25c8c7de96169$var$Type.prototype = Object.create($3keUm.prototype)).constructor = $f2b25c8c7de96169$var$Type).className = "Type";

var $teZIn = parcelRequire("teZIn");

var $8DQkR = parcelRequire("8DQkR");

var $fMEB1 = parcelRequire("fMEB1");

var $80tkS = parcelRequire("80tkS");

var $hqJin = parcelRequire("hqJin");

var $gLmvK = parcelRequire("gLmvK");

var $hP5zC = parcelRequire("hP5zC");

var $3KUVy = parcelRequire("3KUVy");

var $jshGU = parcelRequire("jshGU");

var $ekUKG = parcelRequire("ekUKG");

var $8D1oN = parcelRequire("8D1oN");

var $kfNH8 = parcelRequire("kfNH8");

var $iaLh4 = parcelRequire("iaLh4");

var $9C7Ox = parcelRequire("9C7Ox");
/**
 * Constructs a new reflected message type instance.
 * @classdesc Reflected message type.
 * @extends NamespaceBase
 * @constructor
 * @param {string} name Message name
 * @param {Object.<string,*>} [options] Declared options
 */ function $f2b25c8c7de96169$var$Type(name, options) {
    name = name.replace(/\W/g, "");
    $3keUm.call(this, name, options);
    /**
     * Message fields.
     * @type {Object.<string,Field>}
     */ this.fields = {}; // toJSON, marker
    /**
     * Oneofs declared within this namespace, if any.
     * @type {Object.<string,OneOf>}
     */ this.oneofs = undefined; // toJSON
    /**
     * Extension ranges, if any.
     * @type {number[][]}
     */ this.extensions = undefined; // toJSON
    /**
     * Reserved ranges, if any.
     * @type {Array.<number[]|string>}
     */ this.reserved = undefined; // toJSON
    /*?
     * Whether this type is a legacy group.
     * @type {boolean|undefined}
     */ this.group = undefined; // toJSON
    /**
     * Cached fields by id.
     * @type {Object.<number,Field>|null}
     * @private
     */ this._fieldsById = null;
    /**
     * Cached fields as an array.
     * @type {Field[]|null}
     * @private
     */ this._fieldsArray = null;
    /**
     * Cached oneofs as an array.
     * @type {OneOf[]|null}
     * @private
     */ this._oneofsArray = null;
    /**
     * Cached constructor.
     * @type {Constructor<{}>}
     * @private
     */ this._ctor = null;
}
Object.defineProperties($f2b25c8c7de96169$var$Type.prototype, {
    /**
     * Message fields by id.
     * @name Type#fieldsById
     * @type {Object.<number,Field>}
     * @readonly
     */ fieldsById: {
        get: function() {
            /* istanbul ignore if */ if (this._fieldsById) return this._fieldsById;
            this._fieldsById = {};
            for(var names = Object.keys(this.fields), i = 0; i < names.length; ++i){
                var field = this.fields[names[i]], id = field.id;
                /* istanbul ignore if */ if (this._fieldsById[id]) throw Error("duplicate id " + id + " in " + this);
                this._fieldsById[id] = field;
            }
            return this._fieldsById;
        }
    },
    /**
     * Fields of this message as an array for iteration.
     * @name Type#fieldsArray
     * @type {Field[]}
     * @readonly
     */ fieldsArray: {
        get: function() {
            return this._fieldsArray || (this._fieldsArray = $jshGU.toArray(this.fields));
        }
    },
    /**
     * Oneofs of this message as an array for iteration.
     * @name Type#oneofsArray
     * @type {OneOf[]}
     * @readonly
     */ oneofsArray: {
        get: function() {
            return this._oneofsArray || (this._oneofsArray = $jshGU.toArray(this.oneofs));
        }
    },
    /**
     * The registered constructor, if any registered, otherwise a generic constructor.
     * Assigning a function replaces the internal constructor. If the function does not extend {@link Message} yet, its prototype will be setup accordingly and static methods will be populated. If it already extends {@link Message}, it will just replace the internal constructor.
     * @name Type#ctor
     * @type {Constructor<{}>}
     */ ctor: {
        get: function() {
            return this._ctor || (this.ctor = $f2b25c8c7de96169$var$Type.generateConstructor(this)());
        },
        set: function(ctor) {
            // Ensure proper prototype
            var prototype = ctor.prototype;
            if (!(prototype instanceof $gLmvK)) {
                (ctor.prototype = new $gLmvK()).constructor = ctor;
                $jshGU.merge(ctor.prototype, prototype);
            }
            // Classes and messages reference their reflected type
            ctor.$type = ctor.prototype.$type = this;
            // Mix in static methods
            $jshGU.merge(ctor, $gLmvK, true);
            this._ctor = ctor;
            // Messages have non-enumerable default values on their prototype
            var i = 0;
            for(; i < /* initializes */ this.fieldsArray.length; ++i)this._fieldsArray[i].resolve(); // ensures a proper value
            // Messages have non-enumerable getters and setters for each virtual oneof field
            var ctorProperties = {};
            for(i = 0; i < /* initializes */ this.oneofsArray.length; ++i)ctorProperties[this._oneofsArray[i].resolve().name] = {
                get: $jshGU.oneOfGetter(this._oneofsArray[i].oneof),
                set: $jshGU.oneOfSetter(this._oneofsArray[i].oneof)
            };
            if (i) Object.defineProperties(ctor.prototype, ctorProperties);
        }
    }
});
/**
 * Generates a constructor function for the specified type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ $f2b25c8c7de96169$var$Type.generateConstructor = function generateConstructor(mtype) {
    /* eslint-disable no-unexpected-multiline */ var gen = $jshGU.codegen([
        "p"
    ], mtype.name);
    // explicitly initialize mutable object/array fields so that these aren't just inherited from the prototype
    for(var i = 0, field; i < mtype.fieldsArray.length; ++i)if ((field = mtype._fieldsArray[i]).map) gen("this%s={}", $jshGU.safeProp(field.name));
    else if (field.repeated) gen("this%s=[]", $jshGU.safeProp(field.name));
    return gen("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null&&ks[i]!==\"__proto__\")") // omit undefined or null
    ("this[ks[i]]=p[ks[i]]");
/* eslint-enable no-unexpected-multiline */ };
function $f2b25c8c7de96169$var$clearCache(type) {
    type._fieldsById = type._fieldsArray = type._oneofsArray = null;
    delete type.encode;
    delete type.decode;
    delete type.verify;
    return type;
}
/**
 * Message type descriptor.
 * @interface IType
 * @extends INamespace
 * @property {Object.<string,IOneOf>} [oneofs] Oneof descriptors
 * @property {Object.<string,IField>} fields Field descriptors
 * @property {number[][]} [extensions] Extension ranges
 * @property {Array.<number[]|string>} [reserved] Reserved ranges
 * @property {boolean} [group=false] Whether a legacy group or not
 */ /**
 * Creates a message type from a message type descriptor.
 * @param {string} name Message name
 * @param {IType} json Message type descriptor
 * @param {number} [depth] Current nesting depth, defaults to `0`
 * @returns {Type} Created message type
 */ $f2b25c8c7de96169$var$Type.fromJSON = function fromJSON(name, json, depth) {
    if (depth === undefined) depth = 0;
    if (depth > $jshGU.nestingLimit) throw Error("max depth exceeded");
    var type = new $f2b25c8c7de96169$var$Type(name, json.options);
    type.extensions = json.extensions;
    type.reserved = json.reserved;
    var names = Object.keys(json.fields), i = 0;
    for(; i < names.length; ++i)type.add((typeof json.fields[names[i]].keyType !== "undefined" ? $80tkS.fromJSON : $fMEB1.fromJSON)(names[i], json.fields[names[i]]));
    if (json.oneofs) for(names = Object.keys(json.oneofs), i = 0; i < names.length; ++i)type.add($8DQkR.fromJSON(names[i], json.oneofs[names[i]]));
    if (json.nested) for(names = Object.keys(json.nested), i = 0; i < names.length; ++i){
        var nested = json.nested[names[i]];
        type.add((nested.id !== undefined ? $fMEB1.fromJSON : nested.fields !== undefined ? $f2b25c8c7de96169$var$Type.fromJSON : nested.values !== undefined ? $teZIn.fromJSON : nested.methods !== undefined ? $hqJin.fromJSON : $3keUm.fromJSON)(names[i], nested, depth + 1));
    }
    if (json.extensions && json.extensions.length) type.extensions = json.extensions;
    if (json.reserved && json.reserved.length) type.reserved = json.reserved;
    if (json.group) type.group = true;
    if (json.comment) type.comment = json.comment;
    if (json.edition) type._edition = json.edition;
    type._defaultEdition = "proto3"; // For backwards-compatibility.
    return type;
};
/**
 * Converts this message type to a message type descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IType} Message type descriptor
 */ $f2b25c8c7de96169$var$Type.prototype.toJSON = function toJSON(toJSONOptions) {
    var inherited = $3keUm.prototype.toJSON.call(this, toJSONOptions);
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "edition",
        this._editionToJSON(),
        "options",
        inherited && inherited.options || undefined,
        "oneofs",
        $3keUm.arrayToJSON(this.oneofsArray, toJSONOptions),
        "fields",
        $3keUm.arrayToJSON(this.fieldsArray.filter(function(obj) {
            return !obj.declaringField;
        }), toJSONOptions) || {},
        "extensions",
        this.extensions && this.extensions.length ? this.extensions : undefined,
        "reserved",
        this.reserved && this.reserved.length ? this.reserved : undefined,
        "group",
        this.group || undefined,
        "nested",
        inherited && inherited.nested || undefined,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * @override
 */ $f2b25c8c7de96169$var$Type.prototype.resolveAll = function resolveAll() {
    if (!this._needsRecursiveResolve) return this;
    $3keUm.prototype.resolveAll.call(this);
    var oneofs = this.oneofsArray;
    i = 0;
    while(i < oneofs.length)oneofs[i++].resolve();
    var fields = this.fieldsArray, i = 0;
    while(i < fields.length)fields[i++].resolve();
    return this;
};
/**
 * @override
 */ $f2b25c8c7de96169$var$Type.prototype._resolveFeaturesRecursive = function _resolveFeaturesRecursive(edition) {
    if (!this._needsRecursiveFeatureResolution) return this;
    edition = this._edition || edition;
    $3keUm.prototype._resolveFeaturesRecursive.call(this, edition);
    this.oneofsArray.forEach((oneof)=>{
        oneof._resolveFeatures(edition);
    });
    this.fieldsArray.forEach((field)=>{
        field._resolveFeatures(edition);
    });
    return this;
};
/**
 * @override
 */ $f2b25c8c7de96169$var$Type.prototype.get = function get(name) {
    if (Object.prototype.hasOwnProperty.call(this.fields, name)) return this.fields[name];
    if (this.oneofs && Object.prototype.hasOwnProperty.call(this.oneofs, name)) return this.oneofs[name];
    if (this.nested && Object.prototype.hasOwnProperty.call(this.nested, name)) return this.nested[name];
    return null;
};
/**
 * Adds a nested object to this type.
 * @param {ReflectionObject} object Nested object to add
 * @returns {Type} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If there is already a nested object with this name or, if a field, when there is already a field with this id
 */ $f2b25c8c7de96169$var$Type.prototype.add = function add(object) {
    if (this.get(object.name)) throw Error("duplicate name '" + object.name + "' in " + this);
    if (object instanceof $fMEB1 && object.extend === undefined) {
        // NOTE: Extension fields aren't actual fields on the declaring type, but nested objects.
        // The root object takes care of adding distinct sister-fields to the respective extended
        // type instead.
        // avoids calling the getter if not absolutely necessary because it's called quite frequently
        if (this._fieldsById ? /* istanbul ignore next */ this._fieldsById[object.id] : this.fieldsById[object.id]) throw Error("duplicate id " + object.id + " in " + this);
        if (this.isReservedId(object.id)) throw Error("id " + object.id + " is reserved in " + this);
        if (this.isReservedName(object.name) || object.name.charAt(0) === "$") throw Error("name '" + object.name + "' is reserved in " + this);
        if (object.name === "__proto__") return this;
        if (object.parent) object.parent.remove(object);
        this.fields[object.name] = object;
        object.message = this;
        object.onAdd(this);
        return $f2b25c8c7de96169$var$clearCache(this);
    }
    if (object instanceof $8DQkR) {
        if (object.name.charAt(0) === "$") throw Error("name '" + object.name + "' is reserved in " + this);
        if (object.name === "__proto__") return this;
        if (!this.oneofs) this.oneofs = {};
        this.oneofs[object.name] = object;
        object.onAdd(this);
        return $f2b25c8c7de96169$var$clearCache(this);
    }
    return $3keUm.prototype.add.call(this, object);
};
/**
 * Removes a nested object from this type.
 * @param {ReflectionObject} object Nested object to remove
 * @returns {Type} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If `object` is not a member of this type
 */ $f2b25c8c7de96169$var$Type.prototype.remove = function remove(object) {
    if (object instanceof $fMEB1 && object.extend === undefined) {
        // See Type#add for the reason why extension fields are excluded here.
        /* istanbul ignore if */ if (!this.fields || this.fields[object.name] !== object) throw Error(object + " is not a member of " + this);
        delete this.fields[object.name];
        object.parent = null;
        object.onRemove(this);
        return $f2b25c8c7de96169$var$clearCache(this);
    }
    if (object instanceof $8DQkR) {
        /* istanbul ignore if */ if (!this.oneofs || this.oneofs[object.name] !== object) throw Error(object + " is not a member of " + this);
        delete this.oneofs[object.name];
        object.parent = null;
        object.onRemove(this);
        return $f2b25c8c7de96169$var$clearCache(this);
    }
    return $3keUm.prototype.remove.call(this, object);
};
/**
 * Tests if the specified id is reserved.
 * @param {number} id Id to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $f2b25c8c7de96169$var$Type.prototype.isReservedId = function isReservedId(id) {
    return $3keUm.isReservedId(this.reserved, id);
};
/**
 * Tests if the specified name is reserved.
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $f2b25c8c7de96169$var$Type.prototype.isReservedName = function isReservedName(name) {
    return $3keUm.isReservedName(this.reserved, name);
};
/**
 * Creates a new message of this type using the specified properties.
 * @param {Object.<string,*>} [properties] Properties to set
 * @returns {Message<{}>} Message instance
 */ $f2b25c8c7de96169$var$Type.prototype.create = function create(properties) {
    return new this.ctor(properties);
};
/**
 * Sets up {@link Type#encode|encode}, {@link Type#decode|decode} and {@link Type#verify|verify}.
 * @returns {Type} `this`
 */ $f2b25c8c7de96169$var$Type.prototype.setup = function setup() {
    // Sets up everything at once so that the prototype chain does not have to be re-evaluated
    // multiple times (V8, soft-deopt prototype-check).
    var fullName = this.fullName, types = [];
    for(var i = 0; i < /* initializes */ this.fieldsArray.length; ++i)types.push(this._fieldsArray[i].resolve().resolvedType);
    // Replace setup methods with type-specific generated functions
    this.encode = $ekUKG(this)({
        Writer: $3KUVy,
        types: types,
        util: $jshGU
    });
    this.decode = $8D1oN(this)({
        Reader: $hP5zC,
        types: types,
        util: $jshGU
    });
    this.verify = $kfNH8(this)({
        types: types,
        util: $jshGU
    });
    this.fromObject = $iaLh4.fromObject(this)({
        types: types,
        util: $jshGU
    });
    this.toObject = $iaLh4.toObject(this)({
        types: types,
        util: $jshGU
    });
    // Inject custom wrappers for common types
    var wrapper = $9C7Ox[fullName];
    if (wrapper) {
        var originalThis = Object.create(this);
        // if (wrapper.fromObject) {
        originalThis.fromObject = this.fromObject;
        this.fromObject = wrapper.fromObject.bind(originalThis);
        // }
        // if (wrapper.toObject) {
        originalThis.toObject = this.toObject;
        this.toObject = wrapper.toObject.bind(originalThis);
    // }
    }
    return this;
};
/**
 * Encodes a message of this type. Does not implicitly {@link Type#verify|verify} messages.
 * @param {Message<{}>|Object.<string,*>} message Message instance or plain object
 * @param {Writer} [writer] Writer to encode to
 * @returns {Writer} writer
 */ $f2b25c8c7de96169$var$Type.prototype.encode = function encode_setup(message, writer) {
    return this.setup().encode.apply(this, arguments); // overrides this method
};
/**
 * Encodes a message of this type preceeded by its byte length as a varint. Does not implicitly {@link Type#verify|verify} messages.
 * @param {Message<{}>|Object.<string,*>} message Message instance or plain object
 * @param {Writer} [writer] Writer to encode to
 * @returns {Writer} writer
 */ $f2b25c8c7de96169$var$Type.prototype.encodeDelimited = function encodeDelimited(message, writer) {
    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
};
/**
 * Decodes a message of this type.
 * @param {Reader|Uint8Array} reader Reader or buffer to decode from
 * @param {number} [length] Length of the message, if known beforehand
 * @param {number} [end] Expected group end tag, if decoding a group
 * @param {number} [depth] Current nesting depth
 * @returns {Message<{}>} Decoded message
 * @throws {Error} If the payload is not a reader or valid buffer
 * @throws {util.ProtocolError<{}>} If required fields are missing
 */ $f2b25c8c7de96169$var$Type.prototype.decode = function decode_setup(reader, length, end, depth) {
    return this.setup().decode(reader, length, end, depth); // overrides this method
};
/**
 * Decodes a message of this type preceeded by its byte length as a varint.
 * @param {Reader|Uint8Array} reader Reader or buffer to decode from
 * @returns {Message<{}>} Decoded message
 * @throws {Error} If the payload is not a reader or valid buffer
 * @throws {util.ProtocolError} If required fields are missing
 */ $f2b25c8c7de96169$var$Type.prototype.decodeDelimited = function decodeDelimited(reader) {
    if (!(reader instanceof $hP5zC)) reader = $hP5zC.create(reader);
    return this.decode(reader, reader.uint32());
};
/**
 * Verifies that field values are valid and that required fields are present.
 * @param {Object.<string,*>} message Plain object to verify
 * @param {number} [depth] Current nesting depth
 * @returns {null|string} `null` if valid, otherwise the reason why it is not
 */ $f2b25c8c7de96169$var$Type.prototype.verify = function verify_setup(message, depth) {
    return this.setup().verify(message, depth); // overrides this method
};
/**
 * Creates a new message of this type from a plain object. Also converts values to their respective internal types.
 * @param {Object.<string,*>} object Plain object to convert
 * @param {number} [depth] Current nesting depth
 * @returns {Message<{}>} Message instance
 */ $f2b25c8c7de96169$var$Type.prototype.fromObject = function fromObject(object, depth) {
    return this.setup().fromObject(object, depth);
};
/**
 * Conversion options as used by {@link Type#toObject} and {@link Message.toObject}.
 * @interface IConversionOptions
 * @property {Function} [longs] Long conversion type.
 * Valid values are `BigInt`, `String` and `Number` (the global types).
 * Defaults to copy the present value, which is a possibly unsafe number without and a {@link Long} with a long library.
 * @property {Function} [enums] Enum value conversion type.
 * Only valid value is `String` (the global type).
 * Defaults to copy the present value, which is the numeric id.
 * @property {Function} [bytes] Bytes value conversion type.
 * Valid values are `Array` and (a base64 encoded) `String` (the global types).
 * Defaults to copy the present value, which usually is a Buffer under node and an Uint8Array in the browser.
 * @property {boolean} [defaults=false] Also sets default values on the resulting object
 * @property {boolean} [arrays=false] Sets empty arrays for missing repeated fields even if `defaults=false`
 * @property {boolean} [objects=false] Sets empty objects for missing map fields even if `defaults=false`
 * @property {boolean} [oneofs=false] Includes virtual oneof properties set to the present field's name, if any
 * @property {boolean} [json=false] Performs additional JSON compatibility conversions, i.e. NaN and Infinity to strings
 */ /**
 * Creates a plain object from a message of this type. Also converts values to other types if specified.
 * @param {Message<{}>} message Message instance
 * @param {IConversionOptions} [options] Conversion options
 * @returns {Object.<string,*>} Plain object
 */ $f2b25c8c7de96169$var$Type.prototype.toObject = function toObject(message, options) {
    return this.setup().toObject.apply(this, arguments);
};
/**
 * Decorator function as returned by {@link Type.d} (TypeScript).
 * @typedef TypeDecorator
 * @type {function}
 * @param {Constructor<T>} target Target constructor
 * @returns {undefined}
 * @template T extends Message<T>
 */ /**
 * Type decorator (TypeScript).
 * @param {string} [typeName] Type name, defaults to the constructor's name
 * @returns {TypeDecorator<T>} Decorator function
 * @template T extends Message<T>
 */ $f2b25c8c7de96169$var$Type.d = function decorateType(typeName) {
    return function typeDecorator(target) {
        $jshGU.decorateType(target, typeName);
    };
};

});
parcelRegister("3keUm", function(module, exports) {
"use strict";
module.exports = $26becdcd6379c642$var$Namespace;

var $eqXqI = parcelRequire("eqXqI");
(($26becdcd6379c642$var$Namespace.prototype = Object.create($eqXqI.prototype)).constructor = $26becdcd6379c642$var$Namespace).className = "Namespace";

var $fMEB1 = parcelRequire("fMEB1");

var $jshGU = parcelRequire("jshGU");

var $8DQkR = parcelRequire("8DQkR");
var $26becdcd6379c642$var$Type, $26becdcd6379c642$var$Service, $26becdcd6379c642$var$Enum;
/**
 * Constructs a new namespace instance.
 * @name Namespace
 * @classdesc Reflected namespace.
 * @extends NamespaceBase
 * @constructor
 * @param {string} name Namespace name
 * @param {Object.<string,*>} [options] Declared options
 */ /**
 * Constructs a namespace from JSON.
 * @memberof Namespace
 * @function
 * @param {string} name Namespace name
 * @param {Object.<string,*>} json JSON object
 * @param {number} [depth] Current nesting depth, defaults to `0`
 * @returns {Namespace} Created namespace
 * @throws {TypeError} If arguments are invalid
 */ $26becdcd6379c642$var$Namespace.fromJSON = function fromJSON(name, json, depth) {
    depth = $jshGU.checkDepth(depth);
    return new $26becdcd6379c642$var$Namespace(name, json.options).addJSON(json.nested, depth);
};
/**
 * Converts an array of reflection objects to JSON.
 * @memberof Namespace
 * @param {ReflectionObject[]} array Object array
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {Object.<string,*>|undefined} JSON object or `undefined` when array is empty
 */ function $26becdcd6379c642$var$arrayToJSON(array, toJSONOptions) {
    if (!(array && array.length)) return undefined;
    var obj = {};
    for(var i = 0; i < array.length; ++i)obj[array[i].name] = array[i].toJSON(toJSONOptions);
    return obj;
}
$26becdcd6379c642$var$Namespace.arrayToJSON = $26becdcd6379c642$var$arrayToJSON;
/**
 * Tests if the specified id is reserved.
 * @param {Array.<number[]|string>|undefined} reserved Array of reserved ranges and names
 * @param {number} id Id to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $26becdcd6379c642$var$Namespace.isReservedId = function isReservedId(reserved, id) {
    if (reserved) {
        for(var i = 0; i < reserved.length; ++i)if (typeof reserved[i] !== "string" && reserved[i][0] <= id && reserved[i][1] > id) return true;
    }
    return false;
};
/**
 * Tests if the specified name is reserved.
 * @param {Array.<number[]|string>|undefined} reserved Array of reserved ranges and names
 * @param {string} name Name to test
 * @returns {boolean} `true` if reserved, otherwise `false`
 */ $26becdcd6379c642$var$Namespace.isReservedName = function isReservedName(reserved, name) {
    if (reserved) {
        for(var i = 0; i < reserved.length; ++i)if (reserved[i] === name) return true;
    }
    return false;
};
/**
 * Not an actual constructor. Use {@link Namespace} instead.
 * @classdesc Base class of all reflection objects containing nested objects. This is not an actual class but here for the sake of having consistent type definitions.
 * @exports NamespaceBase
 * @extends ReflectionObject
 * @abstract
 * @constructor
 * @param {string} name Namespace name
 * @param {Object.<string,*>} [options] Declared options
 * @see {@link Namespace}
 */ function $26becdcd6379c642$var$Namespace(name, options) {
    $eqXqI.call(this, name, options);
    /**
     * Nested objects by name.
     * @type {Object.<string,ReflectionObject>|undefined}
     */ this.nested = undefined; // toJSON
    /**
     * Cached nested objects as an array.
     * @type {ReflectionObject[]|null}
     * @private
     */ this._nestedArray = null;
    /**
     * Cache lookup calls for any objects contains anywhere under this namespace.
     * This drastically speeds up resolve for large cross-linked protos where the same
     * types are looked up repeatedly.
     * @type {Object.<string,ReflectionObject|null>}
     * @private
     */ this._lookupCache = Object.create(null);
    /**
     * Whether or not objects contained in this namespace need feature resolution.
     * @type {boolean}
     * @protected
     */ this._needsRecursiveFeatureResolution = true;
    /**
     * Whether or not objects contained in this namespace need a resolve.
     * @type {boolean}
     * @protected
     */ this._needsRecursiveResolve = true;
}
function $26becdcd6379c642$var$clearCache(namespace) {
    namespace._nestedArray = null;
    namespace._lookupCache = Object.create(null);
    // Also clear parent caches, since they include nested lookups.
    var parent = namespace;
    while(parent = parent.parent)parent._lookupCache = Object.create(null);
    return namespace;
}
/**
 * Nested objects of this namespace as an array for iteration.
 * @name NamespaceBase#nestedArray
 * @type {ReflectionObject[]}
 * @readonly
 */ Object.defineProperty($26becdcd6379c642$var$Namespace.prototype, "nestedArray", {
    get: function() {
        return this._nestedArray || (this._nestedArray = $jshGU.toArray(this.nested));
    }
});
/**
 * Namespace descriptor.
 * @interface INamespace
 * @property {Object.<string,*>} [options] Namespace options
 * @property {Object.<string,AnyNestedObject>} [nested] Nested object descriptors
 */ /**
 * Any extension field descriptor.
 * @typedef AnyExtensionField
 * @type {IExtensionField|IExtensionMapField}
 */ /**
 * Any nested object descriptor.
 * @typedef AnyNestedObject
 * @type {IEnum|IType|IService|AnyExtensionField|INamespace|IOneOf}
 */ /**
 * Converts this namespace to a namespace descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {INamespace} Namespace descriptor
 */ $26becdcd6379c642$var$Namespace.prototype.toJSON = function toJSON(toJSONOptions) {
    return $jshGU.toObject([
        "options",
        this.options,
        "nested",
        $26becdcd6379c642$var$arrayToJSON(this.nestedArray, toJSONOptions)
    ]);
};
/**
 * Adds nested objects to this namespace from nested object descriptors.
 * @param {Object.<string,AnyNestedObject>} nestedJson Any nested object descriptors
 * @param {number} [depth] Current nesting depth, defaults to `0`
 * @returns {Namespace} `this`
 */ $26becdcd6379c642$var$Namespace.prototype.addJSON = function addJSON(nestedJson, depth) {
    depth = $jshGU.checkDepth(depth);
    var ns = this;
    /* istanbul ignore else */ if (nestedJson) for(var names = Object.keys(nestedJson), i = 0, nested; i < names.length; ++i){
        nested = nestedJson[names[i]];
        ns.add((nested.fields !== undefined ? $26becdcd6379c642$var$Type.fromJSON : nested.values !== undefined ? $26becdcd6379c642$var$Enum.fromJSON : nested.methods !== undefined ? $26becdcd6379c642$var$Service.fromJSON : nested.id !== undefined ? $fMEB1.fromJSON : $26becdcd6379c642$var$Namespace.fromJSON)(names[i], nested, depth + 1));
    }
    return this;
};
/**
 * Gets the nested object of the specified name.
 * @param {string} name Nested object name
 * @returns {ReflectionObject|null} The reflection object or `null` if it doesn't exist
 */ $26becdcd6379c642$var$Namespace.prototype.get = function get(name) {
    return this.nested && Object.prototype.hasOwnProperty.call(this.nested, name) ? this.nested[name] : null;
};
/**
 * Gets the values of the nested {@link Enum|enum} of the specified name.
 * This methods differs from {@link Namespace#get|get} in that it returns an enum's values directly and throws instead of returning `null`.
 * @param {string} name Nested enum name
 * @returns {Object.<string,number>} Enum values
 * @throws {Error} If there is no such enum
 */ $26becdcd6379c642$var$Namespace.prototype.getEnum = function getEnum(name) {
    if (this.nested && Object.prototype.hasOwnProperty.call(this.nested, name) && this.nested[name] instanceof $26becdcd6379c642$var$Enum) return this.nested[name].values;
    throw Error("no such enum: " + name);
};
/**
 * Adds a nested object to this namespace.
 * @param {ReflectionObject} object Nested object to add
 * @returns {Namespace} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If there is already a nested object with this name
 */ $26becdcd6379c642$var$Namespace.prototype.add = function add(object) {
    if (!(object instanceof $fMEB1 && object.extend !== undefined || object instanceof $26becdcd6379c642$var$Type || object instanceof $8DQkR || object instanceof $26becdcd6379c642$var$Enum || object instanceof $26becdcd6379c642$var$Service || object instanceof $26becdcd6379c642$var$Namespace)) throw TypeError("object must be a valid nested object");
    if (object.name === "__proto__") return this;
    if (!this.nested) this.nested = {};
    else {
        var prev = this.get(object.name);
        if (prev) {
            if (prev instanceof $26becdcd6379c642$var$Namespace && object instanceof $26becdcd6379c642$var$Namespace && !(prev instanceof $26becdcd6379c642$var$Type || prev instanceof $26becdcd6379c642$var$Service)) {
                // replace plain namespace but keep existing nested elements and options
                var nested = prev.nestedArray;
                for(var i = 0; i < nested.length; ++i)object.add(nested[i]);
                this.remove(prev);
                if (!this.nested) this.nested = {};
                object.setOptions(prev.options, true);
            } else throw Error("duplicate name '" + object.name + "' in " + this);
        }
    }
    this.nested[object.name] = object;
    if (!(this instanceof $26becdcd6379c642$var$Type || this instanceof $26becdcd6379c642$var$Service || this instanceof $26becdcd6379c642$var$Enum || this instanceof $fMEB1)) // This is a package or a root namespace.
    {
        if (!object._edition) // Make sure that some edition is set if it hasn't already been specified.
        object._edition = object._defaultEdition;
    }
    this._needsRecursiveFeatureResolution = true;
    this._needsRecursiveResolve = true;
    // Also clear parent caches, since they need to recurse down.
    var parent = this;
    while(parent = parent.parent){
        parent._needsRecursiveFeatureResolution = true;
        parent._needsRecursiveResolve = true;
    }
    object.onAdd(this);
    return $26becdcd6379c642$var$clearCache(this);
};
/**
 * Removes a nested object from this namespace.
 * @param {ReflectionObject} object Nested object to remove
 * @returns {Namespace} `this`
 * @throws {TypeError} If arguments are invalid
 * @throws {Error} If `object` is not a member of this namespace
 */ $26becdcd6379c642$var$Namespace.prototype.remove = function remove(object) {
    if (!(object instanceof $eqXqI)) throw TypeError("object must be a ReflectionObject");
    if (object.parent !== this) throw Error(object + " is not a member of " + this);
    delete this.nested[object.name];
    if (!Object.keys(this.nested).length) this.nested = undefined;
    object.onRemove(this);
    return $26becdcd6379c642$var$clearCache(this);
};
/**
 * Defines additial namespaces within this one if not yet existing.
 * @param {string|string[]} path Path to create
 * @param {*} [json] Nested types to create from JSON
 * @returns {Namespace} Pointer to the last namespace created or `this` if path is empty
 */ $26becdcd6379c642$var$Namespace.prototype.define = function define(path, json) {
    if ($jshGU.isString(path)) path = path.split(".");
    else if (!Array.isArray(path)) throw TypeError("illegal path");
    if (path && path.length && path[0] === "") throw Error("path must be relative");
    if (path.length > $jshGU.recursionLimit) throw Error("max depth exceeded");
    var ptr = this;
    while(path.length > 0){
        var part = path.shift();
        if (ptr.nested && ptr.nested[part]) {
            ptr = ptr.nested[part];
            if (!(ptr instanceof $26becdcd6379c642$var$Namespace)) throw Error("path conflicts with non-namespace objects");
        } else ptr.add(ptr = new $26becdcd6379c642$var$Namespace(part));
    }
    if (json) ptr.addJSON(json);
    return ptr;
};
/**
 * Resolves this namespace's and all its nested objects' type references. Useful to validate a reflection tree, but comes at a cost.
 * @returns {Namespace} `this`
 */ $26becdcd6379c642$var$Namespace.prototype.resolveAll = function resolveAll() {
    if (!this._needsRecursiveResolve) return this;
    this._resolveFeaturesRecursive(this._edition);
    var nested = this.nestedArray, i = 0;
    this.resolve();
    while(i < nested.length)if (nested[i] instanceof $26becdcd6379c642$var$Namespace) nested[i++].resolveAll();
    else nested[i++].resolve();
    this._needsRecursiveResolve = false;
    return this;
};
/**
 * @override
 */ $26becdcd6379c642$var$Namespace.prototype._resolveFeaturesRecursive = function _resolveFeaturesRecursive(edition) {
    if (!this._needsRecursiveFeatureResolution) return this;
    this._needsRecursiveFeatureResolution = false;
    edition = this._edition || edition;
    $eqXqI.prototype._resolveFeaturesRecursive.call(this, edition);
    this.nestedArray.forEach((nested)=>{
        nested._resolveFeaturesRecursive(edition);
    });
    return this;
};
/**
 * Recursively looks up the reflection object matching the specified path in the scope of this namespace.
 * @param {string|string[]} path Path to look up
 * @param {*|Array.<*>} filterTypes Filter types, any combination of the constructors of `protobuf.Type`, `protobuf.Enum`, `protobuf.Service` etc.
 * @param {boolean} [parentAlreadyChecked=false] If known, whether the parent has already been checked
 * @returns {ReflectionObject|null} Looked up object or `null` if none could be found
 */ $26becdcd6379c642$var$Namespace.prototype.lookup = function lookup(path, filterTypes, parentAlreadyChecked) {
    /* istanbul ignore next */ if (typeof filterTypes === "boolean") {
        parentAlreadyChecked = filterTypes;
        filterTypes = undefined;
    } else if (filterTypes && !Array.isArray(filterTypes)) filterTypes = [
        filterTypes
    ];
    if ($jshGU.isString(path) && path.length) {
        if (path === ".") return this.root;
        path = path.split(".");
    } else if (!path.length) return this;
    var flatPath = path.join(".");
    // Start at root if path is absolute
    if (path[0] === "") return this.root.lookup(path.slice(1), filterTypes);
    // Early bailout for objects with matching absolute paths
    var found = this.root._fullyQualifiedObjects && this.root._fullyQualifiedObjects["." + flatPath];
    if (found && (!filterTypes || filterTypes.indexOf(found.constructor) > -1)) return found;
    // Do a regular lookup at this namespace and below
    found = this._lookupImpl(path, flatPath);
    if (found && (!filterTypes || filterTypes.indexOf(found.constructor) > -1)) return found;
    if (parentAlreadyChecked) return null;
    // If there hasn't been a match, walk up the tree and look more broadly
    var current = this;
    while(current.parent){
        found = current.parent._lookupImpl(path, flatPath);
        if (found && (!filterTypes || filterTypes.indexOf(found.constructor) > -1)) return found;
        current = current.parent;
    }
    return null;
};
/**
 * Internal helper for lookup that handles searching just at this namespace and below along with caching.
 * @param {string[]} path Path to look up
 * @param {string} flatPath Flattened version of the path to use as a cache key
 * @returns {ReflectionObject|null} Looked up object or `null` if none could be found
 * @private
 */ $26becdcd6379c642$var$Namespace.prototype._lookupImpl = function lookup(path, flatPath) {
    if (Object.prototype.hasOwnProperty.call(this._lookupCache, flatPath)) return this._lookupCache[flatPath];
    // Test if the first part matches any nested object, and if so, traverse if path contains more
    var found = this.get(path[0]);
    var exact = null;
    if (found) {
        if (path.length === 1) exact = found;
        else if (found instanceof $26becdcd6379c642$var$Namespace) {
            path = path.slice(1);
            exact = found._lookupImpl(path, path.join("."));
        }
    // Otherwise try each nested namespace
    } else {
        for(var i = 0; i < this.nestedArray.length; ++i)if (this._nestedArray[i] instanceof $26becdcd6379c642$var$Namespace && (found = this._nestedArray[i]._lookupImpl(path, flatPath))) {
            exact = found;
            break;
        }
    }
    // Set this even when null, so that when we walk up the tree we can quickly bail on repeated checks back down.
    this._lookupCache[flatPath] = exact;
    return exact;
};
/**
 * Looks up the reflection object at the specified path, relative to this namespace.
 * @name NamespaceBase#lookup
 * @function
 * @param {string|string[]} path Path to look up
 * @param {boolean} [parentAlreadyChecked=false] Whether the parent has already been checked
 * @returns {ReflectionObject|null} Looked up object or `null` if none could be found
 * @variation 2
 */ // lookup(path: string, [parentAlreadyChecked: boolean])
/**
 * Looks up the {@link Type|type} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Type} Looked up type
 * @throws {Error} If `path` does not point to a type
 */ $26becdcd6379c642$var$Namespace.prototype.lookupType = function lookupType(path) {
    var found = this.lookup(path, [
        $26becdcd6379c642$var$Type
    ]);
    if (!found) throw Error("no such type: " + path);
    return found;
};
/**
 * Looks up the values of the {@link Enum|enum} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Enum} Looked up enum
 * @throws {Error} If `path` does not point to an enum
 */ $26becdcd6379c642$var$Namespace.prototype.lookupEnum = function lookupEnum(path) {
    var found = this.lookup(path, [
        $26becdcd6379c642$var$Enum
    ]);
    if (!found) throw Error("no such Enum '" + path + "' in " + this);
    return found;
};
/**
 * Looks up the {@link Type|type} or {@link Enum|enum} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Type} Looked up type or enum
 * @throws {Error} If `path` does not point to a type or enum
 */ $26becdcd6379c642$var$Namespace.prototype.lookupTypeOrEnum = function lookupTypeOrEnum(path) {
    var found = this.lookup(path, [
        $26becdcd6379c642$var$Type,
        $26becdcd6379c642$var$Enum
    ]);
    if (!found) throw Error("no such Type or Enum '" + path + "' in " + this);
    return found;
};
/**
 * Looks up the {@link Service|service} at the specified path, relative to this namespace.
 * Besides its signature, this methods differs from {@link Namespace#lookup|lookup} in that it throws instead of returning `null`.
 * @param {string|string[]} path Path to look up
 * @returns {Service} Looked up service
 * @throws {Error} If `path` does not point to a service
 */ $26becdcd6379c642$var$Namespace.prototype.lookupService = function lookupService(path) {
    var found = this.lookup(path, [
        $26becdcd6379c642$var$Service
    ]);
    if (!found) throw Error("no such Service '" + path + "' in " + this);
    return found;
};
// Sets up cyclic dependencies (called in index-light)
$26becdcd6379c642$var$Namespace._configure = function(Type_, Service_, Enum_) {
    $26becdcd6379c642$var$Type = Type_;
    $26becdcd6379c642$var$Service = Service_;
    $26becdcd6379c642$var$Enum = Enum_;
};

});

parcelRegister("80tkS", function(module, exports) {
"use strict";
module.exports = $5d45144450ee0279$var$MapField;

var $fMEB1 = parcelRequire("fMEB1");
(($5d45144450ee0279$var$MapField.prototype = Object.create($fMEB1.prototype)).constructor = $5d45144450ee0279$var$MapField).className = "MapField";

var $keBMp = parcelRequire("keBMp");

var $jshGU = parcelRequire("jshGU");
/**
 * Constructs a new map field instance.
 * @classdesc Reflected map field.
 * @extends FieldBase
 * @constructor
 * @param {string} name Unique name within its namespace
 * @param {number} id Unique id within its namespace
 * @param {string} keyType Key type
 * @param {string} type Value type
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] Comment associated with this field
 */ function $5d45144450ee0279$var$MapField(name, id, keyType, type, options, comment) {
    $fMEB1.call(this, name, id, type, undefined, undefined, options, comment);
    /* istanbul ignore if */ if (!$jshGU.isString(keyType)) throw TypeError("keyType must be a string");
    /**
     * Key type.
     * @type {string}
     */ this.keyType = keyType; // toJSON, marker
    /**
     * Resolved key type if not a basic type.
     * @type {ReflectionObject|null}
     */ this.resolvedKeyType = null;
    // Overrides Field#map
    this.map = true;
}
/**
 * Map field descriptor.
 * @interface IMapField
 * @extends {IField}
 * @property {string} keyType Key type
 */ /**
 * Extension map field descriptor.
 * @interface IExtensionMapField
 * @extends IMapField
 * @property {string} extend Extended type
 */ /**
 * Constructs a map field from a map field descriptor.
 * @param {string} name Field name
 * @param {IMapField} json Map field descriptor
 * @returns {MapField} Created map field
 * @throws {TypeError} If arguments are invalid
 */ $5d45144450ee0279$var$MapField.fromJSON = function fromJSON(name, json) {
    return new $5d45144450ee0279$var$MapField(name, json.id, json.keyType, json.type, json.options, json.comment);
};
/**
 * Converts this map field to a map field descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IMapField} Map field descriptor
 */ $5d45144450ee0279$var$MapField.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "keyType",
        this.keyType,
        "type",
        this.type,
        "id",
        this.id,
        "extend",
        this.extend,
        "options",
        this.options,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * @override
 */ $5d45144450ee0279$var$MapField.prototype.resolve = function resolve() {
    if (this.resolved) return this;
    // Besides a value type, map fields have a key type that may be "any scalar type except for floating point types and bytes"
    if ($keBMp.mapKey[this.keyType] === undefined) throw Error("invalid key type: " + this.keyType);
    return $fMEB1.prototype.resolve.call(this);
};
/**
 * Map field decorator (TypeScript).
 * @name MapField.d
 * @function
 * @param {number} fieldId Field id
 * @param {"int32"|"uint32"|"sint32"|"fixed32"|"sfixed32"|"int64"|"uint64"|"sint64"|"fixed64"|"sfixed64"|"bool"|"string"} fieldKeyType Field key type
 * @param {"double"|"float"|"int32"|"uint32"|"sint32"|"fixed32"|"sfixed32"|"int64"|"uint64"|"sint64"|"fixed64"|"sfixed64"|"bool"|"string"|"bytes"|Object|Constructor<{}>} fieldValueType Field value type
 * @returns {FieldDecorator} Decorator function
 * @template T extends { [key: string]: number | Long | string | boolean | Uint8Array | Buffer | number[] | Message<{}> }
 */ $5d45144450ee0279$var$MapField.d = function decorateMapField(fieldId, fieldKeyType, fieldValueType) {
    // submessage value: decorate the submessage and use its name as the type
    if (typeof fieldValueType === "function") fieldValueType = $jshGU.decorateType(fieldValueType).name;
    else if (fieldValueType && typeof fieldValueType === "object") fieldValueType = $jshGU.decorateEnum(fieldValueType).name;
    return function mapFieldDecorator(prototype, fieldName) {
        $jshGU.decorateType(prototype.constructor).add(new $5d45144450ee0279$var$MapField(fieldName, fieldId, fieldKeyType, fieldValueType));
    };
};

});

parcelRegister("hqJin", function(module, exports) {
"use strict";
module.exports = $cb080016f4e98073$var$Service;

var $3keUm = parcelRequire("3keUm");
(($cb080016f4e98073$var$Service.prototype = Object.create($3keUm.prototype)).constructor = $cb080016f4e98073$var$Service).className = "Service";

var $3lwwS = parcelRequire("3lwwS");

var $jshGU = parcelRequire("jshGU");

var $kPAIY = parcelRequire("kPAIY");
/**
 * Constructs a new service instance.
 * @classdesc Reflected service.
 * @extends NamespaceBase
 * @constructor
 * @param {string} name Service name
 * @param {Object.<string,*>} [options] Service options
 * @throws {TypeError} If arguments are invalid
 */ function $cb080016f4e98073$var$Service(name, options) {
    $3keUm.call(this, name, options);
    /**
     * Service methods.
     * @type {Object.<string,Method>}
     */ this.methods = {}; // toJSON, marker
    /**
     * Cached methods as an array.
     * @type {Method[]|null}
     * @private
     */ this._methodsArray = null;
}
/**
 * Service descriptor.
 * @interface IService
 * @extends INamespace
 * @property {Object.<string,IMethod>} methods Method descriptors
 */ /**
 * Constructs a service from a service descriptor.
 * @param {string} name Service name
 * @param {IService} json Service descriptor
 * @param {number} [depth] Current nesting depth, defaults to `0`
 * @returns {Service} Created service
 * @throws {TypeError} If arguments are invalid
 */ $cb080016f4e98073$var$Service.fromJSON = function fromJSON(name, json, depth) {
    depth = $jshGU.checkDepth(depth);
    var service = new $cb080016f4e98073$var$Service(name, json.options);
    /* istanbul ignore else */ if (json.methods) for(var names = Object.keys(json.methods), i = 0; i < names.length; ++i)service.add($3lwwS.fromJSON(names[i], json.methods[names[i]]));
    if (json.nested) service.addJSON(json.nested, depth);
    if (json.edition) service._edition = json.edition;
    service.comment = json.comment;
    service._defaultEdition = "proto3"; // For backwards-compatibility.
    return service;
};
/**
 * Converts this service to a service descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IService} Service descriptor
 */ $cb080016f4e98073$var$Service.prototype.toJSON = function toJSON(toJSONOptions) {
    var inherited = $3keUm.prototype.toJSON.call(this, toJSONOptions);
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "edition",
        this._editionToJSON(),
        "options",
        inherited && inherited.options || undefined,
        "methods",
        $3keUm.arrayToJSON(this.methodsArray, toJSONOptions) || /* istanbul ignore next */ {},
        "nested",
        inherited && inherited.nested || undefined,
        "comment",
        keepComments ? this.comment : undefined
    ]);
};
/**
 * Methods of this service as an array for iteration.
 * @name Service#methodsArray
 * @type {Method[]}
 * @readonly
 */ Object.defineProperty($cb080016f4e98073$var$Service.prototype, "methodsArray", {
    get: function() {
        return this._methodsArray || (this._methodsArray = $jshGU.toArray(this.methods));
    }
});
function $cb080016f4e98073$var$clearCache(service) {
    service._methodsArray = null;
    return service;
}
/**
 * @override
 */ $cb080016f4e98073$var$Service.prototype.get = function get(name) {
    return Object.prototype.hasOwnProperty.call(this.methods, name) ? this.methods[name] : $3keUm.prototype.get.call(this, name);
};
/**
 * @override
 */ $cb080016f4e98073$var$Service.prototype.resolveAll = function resolveAll() {
    if (!this._needsRecursiveResolve) return this;
    $3keUm.prototype.resolve.call(this);
    var methods = this.methodsArray;
    for(var i = 0; i < methods.length; ++i)methods[i].resolve();
    return this;
};
/**
 * @override
 */ $cb080016f4e98073$var$Service.prototype._resolveFeaturesRecursive = function _resolveFeaturesRecursive(edition) {
    if (!this._needsRecursiveFeatureResolution) return this;
    edition = this._edition || edition;
    $3keUm.prototype._resolveFeaturesRecursive.call(this, edition);
    this.methodsArray.forEach((method)=>{
        method._resolveFeaturesRecursive(edition);
    });
    return this;
};
/**
 * @override
 */ $cb080016f4e98073$var$Service.prototype.add = function add(object) {
    /* istanbul ignore if */ if (this.get(object.name)) throw Error("duplicate name '" + object.name + "' in " + this);
    if (object instanceof $3lwwS) {
        if (object.name === "__proto__") return this;
        this.methods[object.name] = object;
        object.parent = this;
        return $cb080016f4e98073$var$clearCache(this);
    }
    return $3keUm.prototype.add.call(this, object);
};
/**
 * @override
 */ $cb080016f4e98073$var$Service.prototype.remove = function remove(object) {
    if (object instanceof $3lwwS) {
        /* istanbul ignore if */ if (this.methods[object.name] !== object) throw Error(object + " is not a member of " + this);
        delete this.methods[object.name];
        object.parent = null;
        return $cb080016f4e98073$var$clearCache(this);
    }
    return $3keUm.prototype.remove.call(this, object);
};
/**
 * Creates a runtime service using the specified rpc implementation.
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 * @returns {rpc.Service} RPC service. Useful where requests and/or responses are streamed.
 */ $cb080016f4e98073$var$Service.prototype.create = function create(rpcImpl, requestDelimited, responseDelimited) {
    var rpcService = new $kPAIY.Service(rpcImpl, requestDelimited, responseDelimited);
    for(var i = 0, method; i < /* initializes */ this.methodsArray.length; ++i){
        var methodName = $jshGU.lcFirst((method = this._methodsArray[i]).resolve().name).replace(/[^$\w_]/g, "");
        rpcService[methodName] = function(method, requestType, responseType) {
            return function rpcMethod(request, callback) {
                return $kPAIY.Service.prototype.rpcCall.call(this, method, requestType, responseType, request, callback);
            };
        }(method, method.resolvedRequestType.ctor, method.resolvedResponseType.ctor);
    }
    return rpcService;
};

});
parcelRegister("3lwwS", function(module, exports) {
"use strict";
module.exports = $26fc90ea21b9b882$var$Method;

var $eqXqI = parcelRequire("eqXqI");
(($26fc90ea21b9b882$var$Method.prototype = Object.create($eqXqI.prototype)).constructor = $26fc90ea21b9b882$var$Method).className = "Method";

var $jshGU = parcelRequire("jshGU");
/**
 * Constructs a new service method instance.
 * @classdesc Reflected service method.
 * @extends ReflectionObject
 * @constructor
 * @param {string} name Method name
 * @param {string|undefined} type Method type, usually `"rpc"`
 * @param {string} requestType Request message type
 * @param {string} responseType Response message type
 * @param {boolean|Object.<string,*>} [requestStream] Whether the request is streamed
 * @param {boolean|Object.<string,*>} [responseStream] Whether the response is streamed
 * @param {Object.<string,*>} [options] Declared options
 * @param {string} [comment] The comment for this method
 * @param {Object.<string,*>} [parsedOptions] Declared options, properly parsed into an object
 */ function $26fc90ea21b9b882$var$Method(name, type, requestType, responseType, requestStream, responseStream, options, comment, parsedOptions) {
    /* istanbul ignore next */ if ($jshGU.isObject(requestStream)) {
        options = requestStream;
        requestStream = responseStream = undefined;
    } else if ($jshGU.isObject(responseStream)) {
        options = responseStream;
        responseStream = undefined;
    }
    /* istanbul ignore if */ if (!(type === undefined || $jshGU.isString(type))) throw TypeError("type must be a string");
    /* istanbul ignore if */ if (!$jshGU.isString(requestType)) throw TypeError("requestType must be a string");
    /* istanbul ignore if */ if (!$jshGU.isString(responseType)) throw TypeError("responseType must be a string");
    $eqXqI.call(this, name, options);
    /**
     * Method type.
     * @type {string}
     */ this.type = type || "rpc"; // toJSON
    /**
     * Request type.
     * @type {string}
     */ this.requestType = requestType; // toJSON, marker
    /**
     * Whether requests are streamed or not.
     * @type {boolean|undefined}
     */ this.requestStream = requestStream ? true : undefined; // toJSON
    /**
     * Response type.
     * @type {string}
     */ this.responseType = responseType; // toJSON
    /**
     * Whether responses are streamed or not.
     * @type {boolean|undefined}
     */ this.responseStream = responseStream ? true : undefined; // toJSON
    /**
     * Resolved request type.
     * @type {Type|null}
     */ this.resolvedRequestType = null;
    /**
     * Resolved response type.
     * @type {Type|null}
     */ this.resolvedResponseType = null;
    /**
     * Comment for this method
     * @type {string|null}
     */ this.comment = comment;
    /**
     * Options properly parsed into an object
     */ this.parsedOptions = parsedOptions;
}
/**
 * Method descriptor.
 * @interface IMethod
 * @property {string} [type="rpc"] Method type
 * @property {string} requestType Request type
 * @property {string} responseType Response type
 * @property {boolean} [requestStream=false] Whether requests are streamed
 * @property {boolean} [responseStream=false] Whether responses are streamed
 * @property {Object.<string,*>} [options] Method options
 * @property {string} comment Method comments
 * @property {Object.<string,*>} [parsedOptions] Method options properly parsed into an object
 */ /**
 * Constructs a method from a method descriptor.
 * @param {string} name Method name
 * @param {IMethod} json Method descriptor
 * @returns {Method} Created method
 * @throws {TypeError} If arguments are invalid
 */ $26fc90ea21b9b882$var$Method.fromJSON = function fromJSON(name, json) {
    return new $26fc90ea21b9b882$var$Method(name, json.type, json.requestType, json.responseType, json.requestStream, json.responseStream, json.options, json.comment, json.parsedOptions);
};
/**
 * Converts this method to a method descriptor.
 * @param {IToJSONOptions} [toJSONOptions] JSON conversion options
 * @returns {IMethod} Method descriptor
 */ $26fc90ea21b9b882$var$Method.prototype.toJSON = function toJSON(toJSONOptions) {
    var keepComments = toJSONOptions ? Boolean(toJSONOptions.keepComments) : false;
    return $jshGU.toObject([
        "type",
        this.type !== "rpc" && /* istanbul ignore next */ this.type || undefined,
        "requestType",
        this.requestType,
        "requestStream",
        this.requestStream,
        "responseType",
        this.responseType,
        "responseStream",
        this.responseStream,
        "options",
        this.options,
        "comment",
        keepComments ? this.comment : undefined,
        "parsedOptions",
        this.parsedOptions
    ]);
};
/**
 * @override
 */ $26fc90ea21b9b882$var$Method.prototype.resolve = function resolve() {
    /* istanbul ignore if */ if (this.resolved) return this;
    this.resolvedRequestType = this.parent.lookupType(this.requestType);
    this.resolvedResponseType = this.parent.lookupType(this.responseType);
    return $eqXqI.prototype.resolve.call(this);
};

});


parcelRegister("gLmvK", function(module, exports) {
"use strict";
module.exports = $c3427f5ddb23f4c4$var$Message;

var $hf2LF = parcelRequire("hf2LF");
/**
 * Constructs a new message instance.
 * @classdesc Abstract runtime message.
 * @constructor
 * @param {Properties<T>} [properties] Properties to set
 * @template T extends object = object
 */ function $c3427f5ddb23f4c4$var$Message(properties) {
    // not used internally
    if (properties) for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i){
        var key = keys[i];
        if (key === "__proto__") continue;
        this[key] = properties[key];
    }
}
/**
 * Reference to the reflected type.
 * @name Message.$type
 * @type {Type}
 * @readonly
 */ /**
 * Reference to the reflected type.
 * @name Message#$type
 * @type {Type}
 * @readonly
 */ /*eslint-disable valid-jsdoc*/ /**
 * Creates a new message of this type using the specified properties.
 * @param {Object.<string,*>} [properties] Properties to set
 * @returns {Message<T>} Message instance
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.create = function create(properties) {
    return this.$type.create(properties);
};
/**
 * Encodes a message of this type.
 * @param {T|Object.<string,*>} message Message to encode
 * @param {Writer} [writer] Writer to use
 * @returns {Writer} Writer
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.encode = function encode(message, writer) {
    return this.$type.encode(message, writer);
};
/**
 * Encodes a message of this type preceeded by its length as a varint.
 * @param {T|Object.<string,*>} message Message to encode
 * @param {Writer} [writer] Writer to use
 * @returns {Writer} Writer
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.encodeDelimited = function encodeDelimited(message, writer) {
    return this.$type.encodeDelimited(message, writer);
};
/**
 * Decodes a message of this type.
 * @name Message.decode
 * @function
 * @param {Reader|Uint8Array} reader Reader or buffer to decode
 * @returns {T} Decoded message
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.decode = function decode(reader) {
    return this.$type.decode(reader);
};
/**
 * Decodes a message of this type preceeded by its length as a varint.
 * @name Message.decodeDelimited
 * @function
 * @param {Reader|Uint8Array} reader Reader or buffer to decode
 * @returns {T} Decoded message
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.decodeDelimited = function decodeDelimited(reader) {
    return this.$type.decodeDelimited(reader);
};
/**
 * Verifies a message of this type.
 * @name Message.verify
 * @function
 * @param {Object.<string,*>} message Plain object to verify
 * @returns {string|null} `null` if valid, otherwise the reason why it is not
 */ $c3427f5ddb23f4c4$var$Message.verify = function verify(message) {
    return this.$type.verify(message);
};
/**
 * Creates a new message of this type from a plain object. Also converts values to their respective internal types.
 * @param {Object.<string,*>} object Plain object
 * @returns {T} Message instance
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.fromObject = function fromObject(object) {
    return this.$type.fromObject(object);
};
/**
 * Creates a plain object from a message of this type. Also converts values to other types if specified.
 * @param {T} message Message instance
 * @param {IConversionOptions} [options] Conversion options
 * @returns {Object.<string,*>} Plain object
 * @template T extends Message<T>
 * @this Constructor<T>
 */ $c3427f5ddb23f4c4$var$Message.toObject = function toObject(message, options) {
    return this.$type.toObject(message, options);
};
/**
 * Converts this message to JSON.
 * @returns {Object.<string,*>} JSON object
 */ $c3427f5ddb23f4c4$var$Message.prototype.toJSON = function toJSON() {
    return this.$type.toObject(this, $hf2LF.toJSONOptions);
}; /*eslint-enable valid-jsdoc*/ 

});

parcelRegister("8D1oN", function(module, exports) {
"use strict";
module.exports = $64830d0f853fe0da$var$decoder;

var $teZIn = parcelRequire("teZIn");

var $keBMp = parcelRequire("keBMp");

var $jshGU = parcelRequire("jshGU");
function $64830d0f853fe0da$var$missing(field) {
    return "missing required '" + field.name + "'";
}
/**
 * Generates a decoder specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ function $64830d0f853fe0da$var$decoder(mtype) {
    /* eslint-disable no-unexpected-multiline */ var gen = $jshGU.codegen([
        "r",
        "l",
        "e",
        "n"
    ], mtype.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("if(n===undefined)n=0")("if(n>Reader.recursionLimit)")("throw Error(\"maximum nesting depth exceeded\")")("var c,m" + (mtype.fieldsArray.filter(function(field) {
        return field.map;
    }).length ? ",k,value" : ""))("if(l===undefined)")("c=r.len")("else{")("c=r.pos+l")("if(c>r.len)")("throw RangeError(\"index out of range\")")("l=r.len")("r.len=c")("}")("m=new this.ctor")("while(r.pos<c){")("var t=r.uint32()")("if(t===e)")("break")("switch(t>>>3){");
    var i = 0;
    for(; i < /* initializes */ mtype.fieldsArray.length; ++i){
        var field = mtype._fieldsArray[i].resolve(), type = field.resolvedType instanceof $teZIn ? "int32" : field.type, ref = "m" + $jshGU.safeProp(field.name);
        gen("case %i: {", field.id);
        // Map fields
        if (field.map) {
            gen("if(%s===util.emptyObject)", ref)("%s={}", ref)("var c2=r.uint32()+r.pos")("if(c2>r.len)")("throw RangeError(\"index out of range\")")("r.len=c2");
            if ($keBMp.defaults[field.keyType] !== undefined) gen("k=%j", $keBMp.defaults[field.keyType]);
            else gen("k=null");
            if ($keBMp.defaults[type] !== undefined) gen("value=%j", $keBMp.defaults[type]);
            else gen("value=null");
            gen("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", field.keyType)("case 2:");
            if ($keBMp.basic[type] === undefined) gen("value=types[%i].decode(r,r.uint32(),undefined,n+1)", i); // can't be groups
            else gen("value=r.%s()", type);
            gen("break")("default:")("r.skipType(tag2&7,n)")("break")("}")("}")("if(r.pos!==c2)")("throw RangeError(\"index out of range\")")("r.len=c");
            if ($keBMp.long[field.keyType] !== undefined) gen("%s[typeof k===\"object\"?util.longToHash(k):k]=value", ref);
            else {
                if (field.keyType === "string") gen("if(k===\"__proto__\")")("util.makeProp(%s,k)", ref);
                gen("%s[k]=value", ref);
            }
        // Repeated fields
        } else if (field.repeated) {
            gen("if(!(%s&&%s.length))", ref, ref)("%s=[]", ref);
            // Packable (always check for forward and backward compatiblity)
            if ($keBMp.packed[type] !== undefined) gen("if((t&7)===2){")("var c2=r.uint32()+r.pos")("if(c2>r.len)")("throw RangeError(\"index out of range\")")("r.len=c2")("while(r.pos<c2)")("%s.push(r.%s())", ref, type)("if(r.pos!==c2)")("throw RangeError(\"index out of range\")")("r.len=c")("}else");
            // Non-packed
            if ($keBMp.basic[type] === undefined) gen(field.delimited ? "%s.push(types[%i].decode(r,undefined,((t&~7)|4),n+1))" : "%s.push(types[%i].decode(r,r.uint32(),undefined,n+1))", ref, i);
            else gen("%s.push(r.%s())", ref, type);
        // Non-repeated
        } else if ($keBMp.basic[type] === undefined) gen(field.delimited ? "%s=types[%i].decode(r,undefined,((t&~7)|4),n+1)" : "%s=types[%i].decode(r,r.uint32(),undefined,n+1)", ref, i);
        else gen("%s=r.%s()", ref, type);
        gen("break")("}");
    // Unknown fields
    }
    gen("default:")("r.skipType(t&7,n)")("break")("}")("}");
    gen("if(l!==undefined){")("if(r.pos!==c)")("throw RangeError(\"index out of range\")")("r.len=l")("}");
    // Field presence
    for(i = 0; i < mtype._fieldsArray.length; ++i){
        var rfield = mtype._fieldsArray[i];
        if (rfield.required) gen("if(!Object.hasOwnProperty.call(m,%j))", rfield.name)("throw util.ProtocolError(%j,{instance:m})", $64830d0f853fe0da$var$missing(rfield));
    }
    return gen("return m");
/* eslint-enable no-unexpected-multiline */ }

});

parcelRegister("kfNH8", function(module, exports) {
"use strict";
module.exports = $ebebc1b0dc90e532$var$verifier;

var $teZIn = parcelRequire("teZIn");

var $jshGU = parcelRequire("jshGU");
function $ebebc1b0dc90e532$var$invalid(field, expected) {
    return field.name + ": " + expected + (field.repeated && expected !== "array" ? "[]" : field.map && expected !== "object" ? "{k:" + field.keyType + "}" : "") + " expected";
}
/**
 * Generates a partial value verifier.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} ref Variable reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $ebebc1b0dc90e532$var$genVerifyValue(gen, field, fieldIndex, ref) {
    /* eslint-disable no-unexpected-multiline */ if (field.resolvedType) {
        if (field.resolvedType instanceof $teZIn) {
            gen("switch(%s){", ref)("default:")("return%j", $ebebc1b0dc90e532$var$invalid(field, "enum value"));
            for(var keys = Object.keys(field.resolvedType.values), j = 0; j < keys.length; ++j)gen("case %i:", field.resolvedType.values[keys[j]]);
            gen("break")("}");
        } else gen("{")("var e=types[%i].verify(%s,n+1);", fieldIndex, ref)("if(e)")("return%j+e", field.name + ".")("}");
    } else switch(field.type){
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
            gen("if(!util.isInteger(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "integer"));
            break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
            gen("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", ref, ref, ref, ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "integer|Long"));
            break;
        case "float":
        case "double":
            gen("if(typeof %s!==\"number\")", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "number"));
            break;
        case "bool":
            gen("if(typeof %s!==\"boolean\")", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "boolean"));
            break;
        case "string":
            gen("if(!util.isString(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "string"));
            break;
        case "bytes":
            gen("if(!(%s&&typeof %s.length===\"number\"||util.isString(%s)))", ref, ref, ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "buffer"));
            break;
    }
    return gen;
/* eslint-enable no-unexpected-multiline */ }
/**
 * Generates a partial key verifier.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {string} ref Variable reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $ebebc1b0dc90e532$var$genVerifyKey(gen, field, ref) {
    /* eslint-disable no-unexpected-multiline */ switch(field.keyType){
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
            gen("if(!util.key32Re.test(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "integer key"));
            break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
            gen("if(!util.key64Re.test(%s))", ref) // see comment above: x is ok, d is not
            ("return%j", $ebebc1b0dc90e532$var$invalid(field, "integer|Long key"));
            break;
        case "bool":
            gen("if(!util.key2Re.test(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "boolean key"));
            break;
    }
    return gen;
/* eslint-enable no-unexpected-multiline */ }
/**
 * Generates a verifier specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ function $ebebc1b0dc90e532$var$verifier(mtype) {
    /* eslint-disable no-unexpected-multiline */ var gen = $jshGU.codegen([
        "m",
        "n"
    ], mtype.name + "$verify")("if(typeof m!==\"object\"||m===null)")("return%j", "object expected")("if(n===undefined)n=0")("if(n>util.recursionLimit)")("return%j", "maximum nesting depth exceeded");
    var oneofs = mtype.oneofsArray, seenFirstField = {};
    if (oneofs.length) gen("var p={}");
    for(var i = 0; i < /* initializes */ mtype.fieldsArray.length; ++i){
        var field = mtype._fieldsArray[i].resolve(), ref = "m" + $jshGU.safeProp(field.name);
        if (field.optional) gen("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", ref, field.name); // !== undefined && !== null
        // map fields
        if (field.map) {
            gen("if(!util.isObject(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "object"))("var k=Object.keys(%s)", ref)("for(var i=0;i<k.length;++i){");
            $ebebc1b0dc90e532$var$genVerifyKey(gen, field, "k[i]");
            $ebebc1b0dc90e532$var$genVerifyValue(gen, field, i, ref + "[k[i]]")("}");
        // repeated fields
        } else if (field.repeated) {
            gen("if(!Array.isArray(%s))", ref)("return%j", $ebebc1b0dc90e532$var$invalid(field, "array"))("for(var i=0;i<%s.length;++i){", ref);
            $ebebc1b0dc90e532$var$genVerifyValue(gen, field, i, ref + "[i]")("}");
        // required or present fields
        } else {
            if (field.partOf) {
                var oneofProp = $jshGU.safeProp(field.partOf.name);
                if (seenFirstField[field.partOf.name] === 1) gen("if(p%s===1)", oneofProp)("return%j", field.partOf.name + ": multiple values");
                seenFirstField[field.partOf.name] = 1;
                gen("p%s=1", oneofProp);
            }
            $ebebc1b0dc90e532$var$genVerifyValue(gen, field, i, ref);
        }
        if (field.optional) gen("}");
    }
    return gen("return null");
/* eslint-enable no-unexpected-multiline */ }

});

parcelRegister("iaLh4", function(module, exports) {
"use strict";
/**
 * Runtime message from/to plain object converters.
 * @namespace
 */ var $d3add4dfd9202b09$var$converter = module.exports;

var $teZIn = parcelRequire("teZIn");

var $jshGU = parcelRequire("jshGU");
/**
 * Generates a partial value fromObject conveter.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} prop Property reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $d3add4dfd9202b09$var$genValuePartial_fromObject(gen, field, fieldIndex, prop) {
    var defaultAlreadyEmitted = false;
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ if (field.resolvedType) {
        if (field.resolvedType instanceof $teZIn) {
            gen("switch(d%s){", prop);
            for(var values = field.resolvedType.values, keys = Object.keys(values), i = 0; i < keys.length; ++i){
                // enum unknown values passthrough
                if (values[keys[i]] === field.typeDefault && !defaultAlreadyEmitted) {
                    gen("default:")("if(typeof(d%s)===\"number\"){m%s=d%s;break}", prop, prop, prop);
                    if (!field.repeated) gen // fallback to default value only for
                    ("break"); // for non-repeated fields, just ignore
                    defaultAlreadyEmitted = true;
                }
                gen("case%j:", keys[i])("case %i:", values[keys[i]])("m%s=%j", prop, values[keys[i]])("break");
            }
            gen("}");
        } else gen("if(!util.isObject(d%s))", prop)("throw TypeError(%j)", field.fullName + ": object expected")("m%s=types[%i].fromObject(d%s,n+1)", prop, fieldIndex, prop);
    } else {
        var isUnsigned = false;
        switch(field.type){
            case "double":
            case "float":
                gen("m%s=Number(d%s)", prop, prop); // also catches "NaN", "Infinity"
                break;
            case "uint32":
            case "fixed32":
                gen("m%s=d%s>>>0", prop, prop);
                break;
            case "int32":
            case "sint32":
            case "sfixed32":
                gen("m%s=d%s|0", prop, prop);
                break;
            case "uint64":
            case "fixed64":
                isUnsigned = true;
            // eslint-disable-next-line no-fallthrough
            case "int64":
            case "sint64":
            case "sfixed64":
                gen("if(util.Long)")("m%s=util.Long.fromValue(d%s,%j)", prop, prop, isUnsigned)("else if(typeof d%s===\"string\")", prop)("m%s=parseInt(d%s,10)", prop, prop)("else if(typeof d%s===\"number\")", prop)("m%s=d%s", prop, prop)("else if(typeof d%s===\"object\")", prop)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", prop, prop, prop, isUnsigned ? "true" : "");
                break;
            case "bytes":
                gen("if(typeof d%s===\"string\")", prop)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", prop, prop, prop)("else if(d%s.length >= 0)", prop)("m%s=d%s", prop, prop);
                break;
            case "string":
                gen("m%s=String(d%s)", prop, prop);
                break;
            case "bool":
                gen("m%s=Boolean(d%s)", prop, prop);
                break;
        }
    }
    return gen;
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ }
/**
 * Generates a plain object to runtime message converter specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ $d3add4dfd9202b09$var$converter.fromObject = function fromObject(mtype) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ var fields = mtype.fieldsArray;
    var gen = $jshGU.codegen([
        "d",
        "n"
    ], mtype.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
    if (!fields.length) return gen("return new this.ctor");
    gen("if(!util.isObject(d))")("throw TypeError(%j)", mtype.fullName + ": object expected")("if(n===undefined)n=0")("if(n>util.recursionLimit)")("throw Error(\"maximum nesting depth exceeded\")");
    gen("var m=new this.ctor");
    for(var i = 0; i < fields.length; ++i){
        var field = fields[i].resolve(), prop = $jshGU.safeProp(field.name);
        // Map fields
        if (field.map) {
            gen("if(d%s){", prop)("if(!util.isObject(d%s))", prop)("throw TypeError(%j)", field.fullName + ": object expected")("m%s={}", prop)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", prop);
            gen("if(ks[i]===\"__proto__\")")("util.makeProp(m%s,ks[i])", prop);
            $d3add4dfd9202b09$var$genValuePartial_fromObject(gen, field, /* not sorted */ i, prop + "[ks[i]]")("}")("}");
        // Repeated fields
        } else if (field.repeated) {
            gen("if(d%s){", prop)("if(!Array.isArray(d%s))", prop)("throw TypeError(%j)", field.fullName + ": array expected")("m%s=[]", prop)("for(var i=0;i<d%s.length;++i){", prop);
            $d3add4dfd9202b09$var$genValuePartial_fromObject(gen, field, /* not sorted */ i, prop + "[i]")("}")("}");
        // Non-repeated fields
        } else {
            if (!(field.resolvedType instanceof $teZIn)) gen // no need to test for null/undefined if an enum (uses switch)
            ("if(d%s!=null){", prop); // !== undefined && !== null
            $d3add4dfd9202b09$var$genValuePartial_fromObject(gen, field, /* not sorted */ i, prop);
            if (!(field.resolvedType instanceof $teZIn)) gen("}");
        }
    }
    return gen("return m");
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ };
/**
 * Generates a partial value toObject converter.
 * @param {Codegen} gen Codegen instance
 * @param {Field} field Reflected field
 * @param {number} fieldIndex Field index
 * @param {string} prop Property reference
 * @returns {Codegen} Codegen instance
 * @ignore
 */ function $d3add4dfd9202b09$var$genValuePartial_toObject(gen, field, fieldIndex, prop) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ if (field.resolvedType) {
        if (field.resolvedType instanceof $teZIn) gen("d%s=o.enums===String?(types[%i].values[m%s]===undefined?m%s:types[%i].values[m%s]):m%s", prop, fieldIndex, prop, prop, fieldIndex, prop, prop);
        else gen("d%s=types[%i].toObject(m%s,o,q+1)", prop, fieldIndex, prop);
    } else {
        var isUnsigned = false;
        switch(field.type){
            case "double":
            case "float":
                gen("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", prop, prop, prop, prop);
                break;
            case "uint64":
            case "fixed64":
                isUnsigned = true;
            // eslint-disable-next-line no-fallthrough
            case "int64":
            case "sint64":
            case "sfixed64":
                gen("if(typeof BigInt!==\"undefined\"&&o.longs===BigInt)")("d%s=typeof m%s===\"number\"?BigInt(m%s):util.Long.fromBits(m%s.low>>>0,m%s.high>>>0,%j).toBigInt()", prop, prop, prop, prop, prop, isUnsigned)("else if(typeof m%s===\"number\")", prop)("d%s=o.longs===String?String(m%s):m%s", prop, prop, prop)("else") // Long-like
                ("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", prop, prop, prop, prop, isUnsigned ? "true" : "", prop);
                break;
            case "bytes":
                gen("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", prop, prop, prop, prop, prop);
                break;
            default:
                gen("d%s=m%s", prop, prop);
                break;
        }
    }
    return gen;
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ }
/**
 * Generates a runtime message to plain object converter specific to the specified message type.
 * @param {Type} mtype Message type
 * @returns {Codegen} Codegen instance
 */ $d3add4dfd9202b09$var$converter.toObject = function toObject(mtype) {
    /* eslint-disable no-unexpected-multiline, block-scoped-var, no-redeclare */ var fields = mtype.fieldsArray.slice().sort($jshGU.compareFieldsById);
    if (!fields.length) return $jshGU.codegen()("return {}");
    var gen = $jshGU.codegen([
        "m",
        "o",
        "q"
    ], mtype.name + "$toObject")("if(!o)")("o={}")("if(q===undefined)q=0")("if(q>util.recursionLimit)")("throw Error(\"max depth exceeded\")")("var d={}");
    var repeatedFields = [], mapFields = [], normalFields = [], i = 0;
    for(; i < fields.length; ++i)if (!fields[i].partOf) (fields[i].resolve().repeated ? repeatedFields : fields[i].map ? mapFields : normalFields).push(fields[i]);
    if (repeatedFields.length) {
        gen("if(o.arrays||o.defaults){");
        for(i = 0; i < repeatedFields.length; ++i)gen("d%s=[]", $jshGU.safeProp(repeatedFields[i].name));
        gen("}");
    }
    if (mapFields.length) {
        gen("if(o.objects||o.defaults){");
        for(i = 0; i < mapFields.length; ++i)gen("d%s={}", $jshGU.safeProp(mapFields[i].name));
        gen("}");
    }
    if (normalFields.length) {
        gen("if(o.defaults){");
        for(i = 0; i < normalFields.length; ++i){
            var field = normalFields[i], prop = $jshGU.safeProp(field.name);
            if (field.resolvedType instanceof $teZIn) gen("d%s=o.enums===String?%j:%j", prop, field.resolvedType.valuesById[field.typeDefault], field.typeDefault);
            else if (field.long) gen("if(util.Long){")("var n=new util.Long(%i,%i,%j)", field.typeDefault.low, field.typeDefault.high, field.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():typeof BigInt!==\"undefined\"&&o.longs===BigInt?n.toBigInt():n", prop)("}else")("d%s=o.longs===String?%j:typeof BigInt!==\"undefined\"&&o.longs===BigInt?BigInt(%j):%i", prop, field.typeDefault.toString(), field.typeDefault.toString(), field.typeDefault.toNumber());
            else if (field.bytes) {
                var arrayDefault = Array.prototype.slice.call(field.typeDefault);
                gen("if(o.bytes===String)d%s=%j", prop, String.fromCharCode.apply(String, field.typeDefault))("else{")("d%s=%j", prop, arrayDefault)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", prop, prop)("}");
            } else gen("d%s=%j", prop, field.typeDefault); // also messages (=null)
        }
        gen("}");
    }
    var hasKs2 = false;
    for(i = 0; i < fields.length; ++i){
        var field = fields[i], index = mtype._fieldsArray.indexOf(field), prop = $jshGU.safeProp(field.name);
        if (field.map) {
            if (!hasKs2) {
                hasKs2 = true;
                gen("var ks2");
            }
            gen("if(m%s&&(ks2=Object.keys(m%s)).length){", prop, prop)("d%s={}", prop)("for(var j=0;j<ks2.length;++j){");
            gen("if(ks2[j]===\"__proto__\")")("util.makeProp(d%s,ks2[j])", prop);
            $d3add4dfd9202b09$var$genValuePartial_toObject(gen, field, /* sorted */ index, prop + "[ks2[j]]")("}");
        } else if (field.repeated) {
            gen("if(m%s&&m%s.length){", prop, prop)("d%s=[]", prop)("for(var j=0;j<m%s.length;++j){", prop);
            $d3add4dfd9202b09$var$genValuePartial_toObject(gen, field, /* sorted */ index, prop + "[j]")("}");
        } else {
            gen("if(m%s!=null&&Object.hasOwnProperty.call(m,%j)){", prop, field.name); // !== undefined && !== null
            $d3add4dfd9202b09$var$genValuePartial_toObject(gen, field, /* sorted */ index, prop);
            if (field.partOf) gen("if(o.oneofs)")("d%s=%j", $jshGU.safeProp(field.partOf.name), field.name);
        }
        gen("}");
    }
    return gen("return d");
/* eslint-enable no-unexpected-multiline, block-scoped-var, no-redeclare */ };

});

parcelRegister("9C7Ox", function(module, exports) {
"use strict";
/**
 * Wrappers for common types.
 * @type {Object.<string,IWrapper>}
 * @const
 */ var $6ffdb967c9213627$var$wrappers = module.exports;

var $gLmvK = parcelRequire("gLmvK");

var $hf2LF = parcelRequire("hf2LF");
/**
 * From object converter part of an {@link IWrapper}.
 * @typedef WrapperFromObjectConverter
 * @type {function}
 * @param {Object.<string,*>} object Plain object
 * @returns {Message<{}>} Message instance
 * @this Type
 */ /**
 * To object converter part of an {@link IWrapper}.
 * @typedef WrapperToObjectConverter
 * @type {function}
 * @param {Message<{}>} message Message instance
 * @param {IConversionOptions} [options] Conversion options
 * @returns {Object.<string,*>} Plain object
 * @this Type
 */ /**
 * Common type wrapper part of {@link wrappers}.
 * @interface IWrapper
 * @property {WrapperFromObjectConverter} [fromObject] From object converter
 * @property {WrapperToObjectConverter} [toObject] To object converter
 */ // Custom wrapper for Any
$6ffdb967c9213627$var$wrappers[".google.protobuf.Any"] = {
    fromObject: function(object, depth) {
        if (depth === undefined) depth = 0;
        if (depth > $hf2LF.recursionLimit) throw Error("max depth exceeded");
        // unwrap value type if mapped
        if (object && object["@type"]) {
            // Only use fully qualified type name after the last '/'
            var name = object["@type"].substring(object["@type"].lastIndexOf("/") + 1);
            var type = this.lookup(name);
            /* istanbul ignore else */ if (type) {
                // type_url does not accept leading "."
                var type_url = object["@type"].charAt(0) === "." ? object["@type"].slice(1) : object["@type"];
                // type_url prefix is optional, but path seperator is required
                if (type_url.indexOf("/") === -1) type_url = "/" + type_url;
                return this.create({
                    type_url: type_url,
                    value: type.encode(type.fromObject(object, depth + 1)).finish()
                });
            }
        }
        return this.fromObject(object, depth);
    },
    toObject: function(message, options, depth) {
        if (depth === undefined) depth = 0;
        if (depth > $hf2LF.recursionLimit) throw Error("max depth exceeded");
        // Default prefix
        var googleApi = "type.googleapis.com/";
        var prefix = "";
        var name = "";
        // decode value if requested and unmapped
        if (options && options.json && message.type_url && message.value) {
            // Only use fully qualified type name after the last '/'
            name = message.type_url.substring(message.type_url.lastIndexOf("/") + 1);
            // Separate the prefix used
            prefix = message.type_url.substring(0, message.type_url.lastIndexOf("/") + 1);
            var type = this.lookup(name);
            /* istanbul ignore else */ if (type) message = type.decode(message.value, undefined, undefined, depth + 1);
        }
        // wrap value if unmapped
        if (!(message instanceof this.ctor) && message instanceof $gLmvK) {
            var object = message.$type.toObject(message, options, depth + 1);
            var messageName = message.$type.fullName[0] === "." ? message.$type.fullName.slice(1) : message.$type.fullName;
            // Default to type.googleapis.com prefix if no prefix is used
            if (prefix === "") prefix = googleApi;
            name = prefix + messageName;
            object["@type"] = name;
            return object;
        }
        return this.toObject(message, options, depth);
    }
};

});


parcelRegister("hjrO2", function(module, exports) {
"use strict";
module.exports = $c9a9c7b8ab27cfd9$var$Root;

var $3keUm = parcelRequire("3keUm");
(($c9a9c7b8ab27cfd9$var$Root.prototype = Object.create($3keUm.prototype)).constructor = $c9a9c7b8ab27cfd9$var$Root).className = "Root";

var $fMEB1 = parcelRequire("fMEB1");

var $teZIn = parcelRequire("teZIn");

var $8DQkR = parcelRequire("8DQkR");

var $jshGU = parcelRequire("jshGU");
var $c9a9c7b8ab27cfd9$var$Type, $c9a9c7b8ab27cfd9$var$parse, $c9a9c7b8ab27cfd9$var$common; // "
/**
 * Constructs a new root namespace instance.
 * @classdesc Root namespace wrapping all types, enums, services, sub-namespaces etc. that belong together.
 * @extends NamespaceBase
 * @constructor
 * @param {Object.<string,*>} [options] Top level options
 */ function $c9a9c7b8ab27cfd9$var$Root(options) {
    $3keUm.call(this, "", options);
    /**
     * Deferred extension fields.
     * @type {Field[]}
     */ this.deferred = [];
    /**
     * Resolved file names of loaded files.
     * @type {string[]}
     */ this.files = [];
    /**
     * Edition, defaults to proto2 if unspecified.
     * @type {string}
     * @private
     */ this._edition = "proto2";
    /**
     * Global lookup cache of fully qualified names.
     * @type {Object.<string,ReflectionObject>}
     * @private
     */ this._fullyQualifiedObjects = {};
}
/**
 * Loads a namespace descriptor into a root namespace.
 * @param {INamespace} json Namespace descriptor
 * @param {Root} [root] Root namespace, defaults to create a new one if omitted
 * @param {number} [depth] Current nesting depth, defaults to `0`
 * @returns {Root} Root namespace
 */ $c9a9c7b8ab27cfd9$var$Root.fromJSON = function fromJSON(json, root, depth) {
    depth = $jshGU.checkDepth(depth);
    if (!root) root = new $c9a9c7b8ab27cfd9$var$Root();
    if (json.options) root.setOptions(json.options);
    return root.addJSON(json.nested, depth).resolveAll();
};
/**
 * Resolves the path of an imported file, relative to the importing origin.
 * This method exists so you can override it with your own logic in case your imports are scattered over multiple directories.
 * @function
 * @param {string} origin The file name of the importing file
 * @param {string} target The file name being imported
 * @returns {string|null} Resolved path to `target` or `null` to skip the file
 */ $c9a9c7b8ab27cfd9$var$Root.prototype.resolvePath = $jshGU.path.resolve;
/**
 * Fetch content from file path or url
 * This method exists so you can override it with your own logic.
 * @function
 * @param {string} path File path or url
 * @param {FetchCallback} callback Callback function
 * @returns {undefined}
 */ $c9a9c7b8ab27cfd9$var$Root.prototype.fetch = $jshGU.fetch;
// A symbol-like function to safely signal synchronous loading
/* istanbul ignore next */ function $c9a9c7b8ab27cfd9$var$SYNC() {} // eslint-disable-line no-empty-function
/**
 * Loads one or multiple .proto or preprocessed .json files into this root namespace and calls the callback.
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {IParseOptions} options Parse options
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 */ $c9a9c7b8ab27cfd9$var$Root.prototype.load = function load(filename, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = undefined;
    }
    var self = this;
    if (!callback) return $jshGU.asPromise(load, self, filename, options);
    var sync = callback === $c9a9c7b8ab27cfd9$var$SYNC; // undocumented
    // Finishes loading by calling the callback (exactly once)
    function finish(err, root) {
        /* istanbul ignore if */ if (!callback) return;
        if (sync) throw err;
        if (root) root.resolveAll();
        var cb = callback;
        callback = null;
        cb(err, root);
    }
    // Bundled definition existence checking
    function getBundledFileName(filename) {
        var idx = filename.lastIndexOf("google/protobuf/");
        if (idx > -1) {
            var altname = filename.substring(idx);
            if (altname in $c9a9c7b8ab27cfd9$var$common) return altname;
        }
        return null;
    }
    // Processes a single file
    function process(filename, source, depth) {
        if (depth === undefined) depth = 0;
        try {
            if (depth > $jshGU.recursionLimit) throw Error("max depth exceeded");
            if ($jshGU.isString(source) && source.charAt(0) === "{") source = JSON.parse(source);
            if (!$jshGU.isString(source)) self.setOptions(source.options).addJSON(source.nested);
            else {
                $c9a9c7b8ab27cfd9$var$parse.filename = filename;
                var parsed = $c9a9c7b8ab27cfd9$var$parse(source, self, options), resolved, i = 0;
                if (parsed.imports) {
                    for(; i < parsed.imports.length; ++i)if (resolved = getBundledFileName(parsed.imports[i]) || self.resolvePath(filename, parsed.imports[i])) fetch(resolved, false, depth + 1);
                }
                if (parsed.weakImports) {
                    for(i = 0; i < parsed.weakImports.length; ++i)if (resolved = getBundledFileName(parsed.weakImports[i]) || self.resolvePath(filename, parsed.weakImports[i])) fetch(resolved, true, depth + 1);
                }
            }
        } catch (err) {
            finish(err);
        }
        if (!sync && !queued) finish(null, self); // only once anyway
    }
    // Fetches a single file
    function fetch(filename, weak, depth) {
        if (depth === undefined) depth = 0;
        filename = getBundledFileName(filename) || filename;
        // Skip if already loaded / attempted
        if (self.files.indexOf(filename) > -1) return;
        self.files.push(filename);
        // Shortcut bundled definitions
        if (filename in $c9a9c7b8ab27cfd9$var$common) {
            if (sync) process(filename, $c9a9c7b8ab27cfd9$var$common[filename], depth);
            else {
                ++queued;
                setTimeout(function() {
                    --queued;
                    process(filename, $c9a9c7b8ab27cfd9$var$common[filename], depth);
                });
            }
            return;
        }
        // Otherwise fetch from disk or network
        if (sync) {
            var source;
            try {
                source = $jshGU.fs.readFileSync(filename).toString("utf8");
            } catch (err) {
                if (!weak) finish(err);
                return;
            }
            process(filename, source, depth);
        } else {
            ++queued;
            self.fetch(filename, function(err, source) {
                --queued;
                /* istanbul ignore if */ if (!callback) return; // terminated meanwhile
                if (err) {
                    /* istanbul ignore else */ if (!weak) finish(err);
                    else if (!queued) finish(null, self);
                    return;
                }
                process(filename, source, depth);
            });
        }
    }
    var queued = 0;
    // Assembling the root namespace doesn't require working type
    // references anymore, so we can load everything in parallel
    if ($jshGU.isString(filename)) filename = [
        filename
    ];
    for(var i = 0, resolved; i < filename.length; ++i)if (resolved = self.resolvePath("", filename[i])) fetch(resolved);
    if (sync) {
        self.resolveAll();
        return self;
    }
    if (!queued) finish(null, self);
    return self;
};
// function load(filename:string, options:IParseOptions, callback:LoadCallback):undefined
/**
 * Loads one or multiple .proto or preprocessed .json files into this root namespace and calls the callback.
 * @function Root#load
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {LoadCallback} callback Callback function
 * @returns {undefined}
 * @variation 2
 */ // function load(filename:string, callback:LoadCallback):undefined
/**
 * Loads one or multiple .proto or preprocessed .json files into this root namespace and returns a promise.
 * @function Root#load
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {IParseOptions} [options] Parse options. Defaults to {@link parse.defaults} when omitted.
 * @returns {Promise<Root>} Promise
 * @variation 3
 */ // function load(filename:string, [options:IParseOptions]):Promise<Root>
/**
 * Synchronously loads one or multiple .proto or preprocessed .json files into this root namespace (node only).
 * @function Root#loadSync
 * @param {string|string[]} filename Names of one or multiple files to load
 * @param {IParseOptions} [options] Parse options. Defaults to {@link parse.defaults} when omitted.
 * @returns {Root} Root namespace
 * @throws {Error} If synchronous fetching is not supported (i.e. in browsers) or if a file's syntax is invalid
 */ $c9a9c7b8ab27cfd9$var$Root.prototype.loadSync = function loadSync(filename, options) {
    if (!$jshGU.isNode) throw Error("not supported");
    return this.load(filename, options, $c9a9c7b8ab27cfd9$var$SYNC);
};
/**
 * @override
 */ $c9a9c7b8ab27cfd9$var$Root.prototype.resolveAll = function resolveAll() {
    if (!this._needsRecursiveResolve) return this;
    if (this.deferred.length) throw Error("unresolvable extensions: " + this.deferred.map(function(field) {
        return "'extend " + field.extend + "' in " + field.parent.fullName;
    }).join(", "));
    return $3keUm.prototype.resolveAll.call(this);
};
// only uppercased (and thus conflict-free) children are exposed, see below
var $c9a9c7b8ab27cfd9$var$exposeRe = /^[A-Z]/;
/**
 * Handles a deferred declaring extension field by creating a sister field to represent it within its extended type.
 * @param {Root} root Root instance
 * @param {Field} field Declaring extension field witin the declaring type
 * @returns {boolean} `true` if successfully added to the extended type, `false` otherwise
 * @inner
 * @ignore
 */ function $c9a9c7b8ab27cfd9$var$tryHandleExtension(root, field) {
    var extendedType = field.parent.lookup(field.extend);
    if (extendedType) {
        var sisterField = new $fMEB1(field.fullName, field.id, field.type, field.rule, undefined, field.options);
        //do not allow to extend same field twice to prevent the error
        if (extendedType.get(sisterField.name)) return true;
        sisterField.declaringField = field;
        field.extensionField = sisterField;
        extendedType.add(sisterField);
        return true;
    }
    return false;
}
/**
 * Called when any object is added to this root or its sub-namespaces.
 * @param {ReflectionObject} object Object added
 * @returns {undefined}
 * @private
 */ $c9a9c7b8ab27cfd9$var$Root.prototype._handleAdd = function _handleAdd(object) {
    if (object instanceof $fMEB1) {
        if (/* an extension field (implies not part of a oneof) */ object.extend !== undefined && /* not already handled */ !object.extensionField) {
            if (!$c9a9c7b8ab27cfd9$var$tryHandleExtension(this, object)) this.deferred.push(object);
        }
    } else if (object instanceof $teZIn) {
        if ($c9a9c7b8ab27cfd9$var$exposeRe.test(object.name)) object.parent[object.name] = object.values; // expose enum values as property of its parent
    } else if (!(object instanceof $8DQkR)) /* everything else is a namespace */ {
        if (object instanceof $c9a9c7b8ab27cfd9$var$Type) for(var i = 0; i < this.deferred.length;)if ($c9a9c7b8ab27cfd9$var$tryHandleExtension(this, this.deferred[i])) this.deferred.splice(i, 1);
        else ++i;
        for(var j = 0; j < /* initializes */ object.nestedArray.length; ++j)this._handleAdd(object._nestedArray[j]);
        if ($c9a9c7b8ab27cfd9$var$exposeRe.test(object.name)) object.parent[object.name] = object; // expose namespace as property of its parent
    }
    if (object instanceof $c9a9c7b8ab27cfd9$var$Type || object instanceof $teZIn || object instanceof $fMEB1) // Only store types and enums for quick lookup during resolve.
    this._fullyQualifiedObjects[object.fullName] = object;
// The above also adds uppercased (and thus conflict-free) nested types, services and enums as
// properties of namespaces just like static code does. This allows using a .d.ts generated for
// a static module with reflection-based solutions where the condition is met.
};
/**
 * Called when any object is removed from this root or its sub-namespaces.
 * @param {ReflectionObject} object Object removed
 * @returns {undefined}
 * @private
 */ $c9a9c7b8ab27cfd9$var$Root.prototype._handleRemove = function _handleRemove(object) {
    if (object instanceof $fMEB1) {
        if (/* an extension field */ object.extend !== undefined) {
            if (/* already handled */ object.extensionField) {
                object.extensionField.parent.remove(object.extensionField);
                object.extensionField = null;
            } else {
                var index = this.deferred.indexOf(object);
                /* istanbul ignore else */ if (index > -1) this.deferred.splice(index, 1);
            }
        }
    } else if (object instanceof $teZIn) {
        if ($c9a9c7b8ab27cfd9$var$exposeRe.test(object.name)) delete object.parent[object.name]; // unexpose enum values
    } else if (object instanceof $3keUm) {
        for(var i = 0; i < /* initializes */ object.nestedArray.length; ++i)this._handleRemove(object._nestedArray[i]);
        if ($c9a9c7b8ab27cfd9$var$exposeRe.test(object.name)) delete object.parent[object.name]; // unexpose namespaces
    }
    delete this._fullyQualifiedObjects[object.fullName];
};
// Sets up cyclic dependencies (called in index-light)
$c9a9c7b8ab27cfd9$var$Root._configure = function(Type_, parse_, common_) {
    $c9a9c7b8ab27cfd9$var$Type = Type_;
    $c9a9c7b8ab27cfd9$var$parse = parse_;
    $c9a9c7b8ab27cfd9$var$common = common_;
};

});









parcelRegister("3NuqQ", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", () => addExtensionMethods);

var $gu0hs = parcelRequire("gu0hs");
var $cmFjP = parcelRequire("cmFjP");

var $289ZW = parcelRequire("289ZW");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, $cmFjP.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, $289ZW.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, $289ZW.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mysql () {
            const integration = (0, $289ZW.dynamicRequire)(module, './node/integrations/mysql');
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, $289ZW.dynamicRequire)(module, './node/integrations/postgres');
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $289ZW.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, $gu0hs.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, $289ZW.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

});
parcelRegister("gu0hs", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", () => $bfffaa6649a6ba90$export$479dbd817e392a4f);
$parcel$export(module.exports, "addTracingExtensions", () => $bfffaa6649a6ba90$export$653d0ef2bad9cdf9);

var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $jfPQV = parcelRequire("jfPQV");

var $54O61 = parcelRequire("54O61");

var $2EZoq = parcelRequire("2EZoq");

var $kJ1jU = parcelRequire("kJ1jU");

var $6Tqu0 = parcelRequire("6Tqu0");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $bfffaa6649a6ba90$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, $jfPQV.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $bfffaa6649a6ba90$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $6Tqu0.Transaction)(transactionContext, this);
    transaction = (0, $kJ1jU.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $bfffaa6649a6ba90$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $2EZoq.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $kJ1jU.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $bfffaa6649a6ba90$export$653d0ef2bad9cdf9() {
    const carrier = (0, $cmFjP.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $bfffaa6649a6ba90$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $bfffaa6649a6ba90$var$traceHeaders;
    (0, $54O61.registerErrorInstrumentation)();
}

});
parcelRegister("4g0Ct", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $3199231328e69de5$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $3199231328e69de5$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $3199231328e69de5$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $3199231328e69de5$export$af88d00dbe7f521);

var $eKZKa = parcelRequire("eKZKa");

var $3bpJ1 = parcelRequire("3bpJ1");
/** Prefix for logging strings */ const $3199231328e69de5$var$PREFIX = 'Sentry Logger ';
const $3199231328e69de5$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $3199231328e69de5$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $3199231328e69de5$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $3bpJ1.GLOBAL_OBJ))) return callback();
    const console = (0, $3bpJ1.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($3199231328e69de5$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $3199231328e69de5$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $3199231328e69de5$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $eKZKa.DEBUG_BUILD) $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $3199231328e69de5$export$cda52e2a8927a2ca(()=>{
                (0, $3bpJ1.GLOBAL_OBJ).console[name](`${$3199231328e69de5$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $3199231328e69de5$export$af88d00dbe7f521 = $3199231328e69de5$var$makeLogger();

});
parcelRegister("eKZKa", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $abe5418a531ee1d6$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $abe5418a531ee1d6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("3bpJ1", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $25165aaf01761cfd$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $25165aaf01761cfd$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $25165aaf01761cfd$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $25165aaf01761cfd$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $25165aaf01761cfd$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $25165aaf01761cfd$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $25165aaf01761cfd$var$isGlobalObj(window) || typeof self == 'object' && $25165aaf01761cfd$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $25165aaf01761cfd$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $25165aaf01761cfd$export$256479dc0cea61c4() {
    return $25165aaf01761cfd$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $25165aaf01761cfd$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $25165aaf01761cfd$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("8IHa9", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $6593ea065203555e$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6593ea065203555e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("cmFjP", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $9007972943bbf579$export$19eade501500c6c1);
$parcel$export(module.exports, "getCurrentHub", () => $9007972943bbf579$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $9007972943bbf579$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $9007972943bbf579$export$70d775fb1f267027);

var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $3bpJ1 = parcelRequire("3bpJ1");
var $2zW56 = parcelRequire("2zW56");
var $b1E2c = parcelRequire("b1E2c");

var $kfXMR = parcelRequire("kfXMR");

var $8IHa9 = parcelRequire("8IHa9");

var $coQoV = parcelRequire("coQoV");

var $oyvka = parcelRequire("oyvka");

var $9OAWn = parcelRequire("9OAWn");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $9007972943bbf579$export$24a86ef7798177e4 = parseFloat((0, $9OAWn.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $9007972943bbf579$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $9007972943bbf579$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $9007972943bbf579$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $coQoV.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $coQoV.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $2zW56.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9007972943bbf579$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $cvSY8.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $4g0Ct.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $9007972943bbf579$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $9007972943bbf579$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $8IHa9.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $4g0Ct.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $4g0Ct.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $oyvka.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $kfXMR.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $3bpJ1.GLOBAL_OBJ).navigator || {};
        const session = (0, $oyvka.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $oyvka.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $9007972943bbf579$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9007972943bbf579$export$19eade501500c6c1() {
    (0, $3bpJ1.GLOBAL_OBJ).__SENTRY__ = (0, $3bpJ1.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $3bpJ1.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$4188a14ad302d1bc(hub) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    const oldHub = $9007972943bbf579$export$bfa8a924a84a76b7(registry);
    $9007972943bbf579$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $9007972943bbf579$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $9007972943bbf579$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $9007972943bbf579$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$var$getGlobalHub(registry = $9007972943bbf579$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$bfa8a924a84a76b7(registry).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$849f05434e95d2f2(registry, new $9007972943bbf579$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $9007972943bbf579$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$236689a79f5aa020(carrier, parent = $9007972943bbf579$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $9007972943bbf579$export$bfa8a924a84a76b7(carrier).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $9007972943bbf579$export$849f05434e95d2f2(carrier, new $9007972943bbf579$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $9007972943bbf579$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $9007972943bbf579$export$70d775fb1f267027(callback, options = {}) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $9007972943bbf579$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $3bpJ1.getGlobalSingleton)('hub', ()=>new $9007972943bbf579$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $9007972943bbf579$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("cvSY8", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => $91c304fc757d5e0f$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $91c304fc757d5e0f$export$ee52dced521e3e18);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => $91c304fc757d5e0f$export$baf075a948ffc0bf);

var $3bpJ1 = parcelRequire("3bpJ1");
const $91c304fc757d5e0f$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $91c304fc757d5e0f$export$7740643b9eeaf0c4() {
    return Date.now() / $91c304fc757d5e0f$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $91c304fc757d5e0f$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $3bpJ1.GLOBAL_OBJ);
    if (!performance || !performance.now) return $91c304fc757d5e0f$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $91c304fc757d5e0f$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $91c304fc757d5e0f$export$ee52dced521e3e18 = $91c304fc757d5e0f$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $91c304fc757d5e0f$export$c5907b5a8838db13 = $91c304fc757d5e0f$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $91c304fc757d5e0f$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $91c304fc757d5e0f$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $3bpJ1.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $91c304fc757d5e0f$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $91c304fc757d5e0f$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $91c304fc757d5e0f$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $91c304fc757d5e0f$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("2zW56", function(module, exports) {

$parcel$export(module.exports, "isError", () => $1e0be767ffa822d8$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $1e0be767ffa822d8$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $1e0be767ffa822d8$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $1e0be767ffa822d8$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $1e0be767ffa822d8$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $1e0be767ffa822d8$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $1e0be767ffa822d8$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $1e0be767ffa822d8$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $1e0be767ffa822d8$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $1e0be767ffa822d8$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $1e0be767ffa822d8$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $1e0be767ffa822d8$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $1e0be767ffa822d8$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $1e0be767ffa822d8$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $1e0be767ffa822d8$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $1e0be767ffa822d8$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $1e0be767ffa822d8$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$e6127cc7fe7395c3(wat) {
    switch($1e0be767ffa822d8$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $1e0be767ffa822d8$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$var$isBuiltin(wat, className) {
    return $1e0be767ffa822d8$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9f9636d330b71954(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$ef9e2056653f0c8e(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$12e869b2a583f783(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$844ec244b1367d54(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c3825b437cbdea5c(wat) {
    return wat === null || $1e0be767ffa822d8$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49841c62b9eff15(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $1e0be767ffa822d8$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$bc2894c7158efbac(wat) {
    return $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("b1E2c", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $806ed7b2edb8ea09$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $806ed7b2edb8ea09$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $806ed7b2edb8ea09$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $806ed7b2edb8ea09$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $806ed7b2edb8ea09$export$6de4ffac6a2f1098);
$parcel$export(module.exports, "arrayify", () => $806ed7b2edb8ea09$export$3131421a7d01b4fb);

var $jL8lq = parcelRequire("jL8lq");

var $91U3U = parcelRequire("91U3U");

var $3bpJ1 = parcelRequire("3bpJ1");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $806ed7b2edb8ea09$export$19f53698e68b2496() {
    const gbl = (0, $3bpJ1.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $806ed7b2edb8ea09$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $806ed7b2edb8ea09$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $806ed7b2edb8ea09$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $806ed7b2edb8ea09$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $806ed7b2edb8ea09$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $806ed7b2edb8ea09$export$d364f2020ab30578(input) {
    const match = input.match($806ed7b2edb8ea09$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $806ed7b2edb8ea09$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $91U3U.snipLine)(line, 0));
    frame.context_line = (0, $91U3U.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $91U3U.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $806ed7b2edb8ea09$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $jL8lq.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $806ed7b2edb8ea09$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("jL8lq", function(module, exports) {

$parcel$export(module.exports, "fill", () => $e628e125e878fd27$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $e628e125e878fd27$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $e628e125e878fd27$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $e628e125e878fd27$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $e628e125e878fd27$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $e628e125e878fd27$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $e628e125e878fd27$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $e628e125e878fd27$export$d25f2688db1bb433);

var $ibKgU = parcelRequire("ibKgU");

var $eKZKa = parcelRequire("eKZKa");

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");

var $91U3U = parcelRequire("91U3U");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $e628e125e878fd27$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $e628e125e878fd27$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $e628e125e878fd27$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $e628e125e878fd27$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $e628e125e878fd27$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $e628e125e878fd27$export$62ff257738bf57f5(value) {
    if ((0, $2zW56.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$e628e125e878fd27$var$getOwnProperties(value)
    };
    else if ((0, $2zW56.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $e628e125e878fd27$var$serializeEventTarget(value.target),
            currentTarget: $e628e125e878fd27$var$serializeEventTarget(value.currentTarget),
            ...$e628e125e878fd27$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $2zW56.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $e628e125e878fd27$var$serializeEventTarget(target) {
    try {
        return (0, $2zW56.isElement)(target) ? (0, $ibKgU.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $e628e125e878fd27$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $e628e125e878fd27$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($e628e125e878fd27$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $91U3U.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $91U3U.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $e628e125e878fd27$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($e628e125e878fd27$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $e628e125e878fd27$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($e628e125e878fd27$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $e628e125e878fd27$var$isPojo(input) {
    if (!(0, $2zW56.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $e628e125e878fd27$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $2zW56.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("ibKgU", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $d3dd25a69ce66c78$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $d3dd25a69ce66c78$export$1cfafeee2987818b);
$parcel$export(module.exports, "getDomElement", () => $d3dd25a69ce66c78$export$c660c1f3ab49225c);
$parcel$export(module.exports, "getComponentName", () => $d3dd25a69ce66c78$export$26727cfcc4d7e0fc);

var $2zW56 = parcelRequire("2zW56");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const $d3dd25a69ce66c78$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
const $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d3dd25a69ce66c78$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($d3dd25a69ce66c78$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $2zW56.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $d3dd25a69ce66c78$export$1cfafeee2987818b() {
    try {
        return $d3dd25a69ce66c78$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d3dd25a69ce66c78$export$c660c1f3ab49225c(selector) {
    if ($d3dd25a69ce66c78$var$WINDOW.document && $d3dd25a69ce66c78$var$WINDOW.document.querySelector) return $d3dd25a69ce66c78$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $d3dd25a69ce66c78$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$d3dd25a69ce66c78$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("91U3U", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $692fb1c9fae23fc3$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $692fb1c9fae23fc3$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $692fb1c9fae23fc3$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $692fb1c9fae23fc3$export$a7a5ec66062ea5d);

var $2zW56 = parcelRequire("2zW56");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $692fb1c9fae23fc3$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $2zW56.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $692fb1c9fae23fc3$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $2zW56.isString)(value)) return false;
    if ((0, $2zW56.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $2zW56.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $692fb1c9fae23fc3$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$692fb1c9fae23fc3$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("kfXMR", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $ebf395d8a45b5e48$export$849dbeeeda01ae98);
const $ebf395d8a45b5e48$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("coQoV", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $90705fab783f17f9$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $90705fab783f17f9$export$aa55d5ab8e05984f);

var $cvSY8 = parcelRequire("cvSY8");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $b1E2c = parcelRequire("b1E2c");

var $6T4Sa = parcelRequire("6T4Sa");

var $oyvka = parcelRequire("oyvka");

var $8ltoy = parcelRequire("8ltoy");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $90705fab783f17f9$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $90705fab783f17f9$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $90705fab783f17f9$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $90705fab783f17f9$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $90705fab783f17f9$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $oyvka.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $90705fab783f17f9$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $2zW56.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $90705fab783f17f9$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $cvSY8.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $8ltoy.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $6T4Sa.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $6T4Sa.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (!this._client) {
            (0, $4g0Ct.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (!this._client) {
            (0, $4g0Ct.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (!this._client) {
            (0, $4g0Ct.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $90705fab783f17f9$export$aa55d5ab8e05984f() {
    if (!$90705fab783f17f9$var$globalScope) $90705fab783f17f9$var$globalScope = new $90705fab783f17f9$export$775b6bb06e53a214();
    return $90705fab783f17f9$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $90705fab783f17f9$export$c83048efd17527d6(scope) {
    $90705fab783f17f9$var$globalScope = scope;
}
function $90705fab783f17f9$var$generatePropagationContext() {
    return {
        traceId: (0, $b1E2c.uuid4)(),
        spanId: (0, $b1E2c.uuid4)().substring(16)
    };
}

});
parcelRegister("6T4Sa", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", () => $503ba8c00efa1d46$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $503ba8c00efa1d46$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $503ba8c00efa1d46$export$bf2a096c3e883e79);

var $3bpJ1 = parcelRequire("3bpJ1");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $j3a3y = parcelRequire("j3a3y");

var $8IHa9 = parcelRequire("8IHa9");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $503ba8c00efa1d46$export$3c4238858b85e8ac() {
    return (0, $3bpJ1.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $503ba8c00efa1d46$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $503ba8c00efa1d46$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $503ba8c00efa1d46$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $8IHa9.DEBUG_BUILD) && processor.id && result === null && (0, $4g0Ct.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $2zW56.isThenable)(result)) result.then((final)=>$503ba8c00efa1d46$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $503ba8c00efa1d46$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("j3a3y", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $dde6191ffa17294f$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $dde6191ffa17294f$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $dde6191ffa17294f$export$78e43115b553f358);

var $2zW56 = parcelRequire("2zW56");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $dde6191ffa17294f$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($dde6191ffa17294f$var$States || ($dde6191ffa17294f$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $dde6191ffa17294f$export$1fda8aa4d135f8aa(value) {
    return new $dde6191ffa17294f$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $dde6191ffa17294f$export$78e43115b553f358(reason) {
    return new $dde6191ffa17294f$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $dde6191ffa17294f$export$6f292d4960313241 {
    constructor(executor){
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init2.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init3.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $dde6191ffa17294f$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($dde6191ffa17294f$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($dde6191ffa17294f$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $dde6191ffa17294f$var$States.PENDING) return;
            if ((0, $2zW56.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $dde6191ffa17294f$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $dde6191ffa17294f$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $dde6191ffa17294f$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("oyvka", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $049d01d3a3164ac2$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $049d01d3a3164ac2$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $049d01d3a3164ac2$export$56521d9ba90f62ee);

var $jL8lq = parcelRequire("jL8lq");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $049d01d3a3164ac2$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $cvSY8.timestampInSeconds)();
    const session = {
        sid: (0, $b1E2c.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$049d01d3a3164ac2$var$sessionToJSON(session)
    };
    if (context) $049d01d3a3164ac2$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $049d01d3a3164ac2$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $cvSY8.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $b1E2c.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $049d01d3a3164ac2$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $049d01d3a3164ac2$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $049d01d3a3164ac2$var$sessionToJSON(session) {
    return (0, $jL8lq.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("8ltoy", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", () => $613716288721a3ee$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $613716288721a3ee$export$25ac7e259a513db4);

var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");

var $bPHT6 = parcelRequire("bPHT6");

var $ga8Oo = parcelRequire("ga8Oo");

var $jfPQV = parcelRequire("jfPQV");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $613716288721a3ee$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $613716288721a3ee$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $613716288721a3ee$var$applySpanToEvent(event, span);
    $613716288721a3ee$var$applyFingerprintToEvent(event, fingerprint);
    $613716288721a3ee$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $613716288721a3ee$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $613716288721a3ee$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $613716288721a3ee$export$b1a120a2871faa46(data, 'extra', extra);
    $613716288721a3ee$export$b1a120a2871faa46(data, 'tags', tags);
    $613716288721a3ee$export$b1a120a2871faa46(data, 'user', user);
    $613716288721a3ee$export$b1a120a2871faa46(data, 'contexts', contexts);
    $613716288721a3ee$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $613716288721a3ee$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $613716288721a3ee$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $jL8lq.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $jL8lq.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $jL8lq.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $jL8lq.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $613716288721a3ee$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $613716288721a3ee$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $613716288721a3ee$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $jfPQV.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $ga8Oo.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $bPHT6.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $jfPQV.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $613716288721a3ee$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $b1E2c.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("bPHT6", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", () => $89d6805454b84092$export$366bad00d6815eed);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $89d6805454b84092$export$a117f995597e25df);

var $jL8lq = parcelRequire("jL8lq");

var $kfXMR = parcelRequire("kfXMR");

var $b8438 = parcelRequire("b8438");

var $ga8Oo = parcelRequire("ga8Oo");

var $jfPQV = parcelRequire("jfPQV");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $89d6805454b84092$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $jL8lq.dropUndefinedKeys)({
        environment: options.environment || (0, $kfXMR.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $89d6805454b84092$export$a117f995597e25df(span) {
    const client = (0, $b8438.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $89d6805454b84092$export$366bad00d6815eed((0, $jfPQV.spanToJSON)(span).trace_id || '', client, (0, $b8438.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $ga8Oo.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $jfPQV.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $jfPQV.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("b8438", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $81a395368bb6f380$export$f5282963edea4a68);
$parcel$export(module.exports, "captureEvent", () => $81a395368bb6f380$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "addBreadcrumb", () => $81a395368bb6f380$export$efda9a273d7a036d);
$parcel$export(module.exports, "withScope", () => $81a395368bb6f380$export$ec58d9285c204497);
$parcel$export(module.exports, "getCurrentScope", () => $81a395368bb6f380$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $81a395368bb6f380$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "startSession", () => $81a395368bb6f380$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $81a395368bb6f380$export$667e7b4d445d566b);

var $3bpJ1 = parcelRequire("3bpJ1");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");

var $kfXMR = parcelRequire("kfXMR");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $oyvka = parcelRequire("oyvka");

var $az0Em = parcelRequire("az0Em");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $81a395368bb6f380$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().captureException(exception, (0, $az0Em.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $81a395368bb6f380$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $81a395368bb6f380$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $81a395368bb6f380$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a395368bb6f380$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $cmFjP.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $81a395368bb6f380$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $cmFjP.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $81a395368bb6f380$export$9a4fed82c350c2bd(callback) {
    return (0, $cmFjP.runWithAsyncContext)(()=>{
        return callback((0, $cmFjP.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $81a395368bb6f380$export$e57ac09b143d92a2(span, callback) {
    return $81a395368bb6f380$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $81a395368bb6f380$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $81a395368bb6f380$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (!client) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $b1E2c.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $81a395368bb6f380$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $81a395368bb6f380$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $cvSY8.timestampInSeconds)();
    function finishCheckIn(status) {
        $81a395368bb6f380$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $cvSY8.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $2zW56.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $81a395368bb6f380$export$4909b86c8034bf73(timeout) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $81a395368bb6f380$export$8360e631d277ea4d(timeout) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $81a395368bb6f380$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $81a395368bb6f380$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $81a395368bb6f380$export$3f95c6f800b78024() {
    return !!$81a395368bb6f380$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $81a395368bb6f380$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $cmFjP.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $81a395368bb6f380$export$c0d84948cecf78d8(context) {
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $kfXMR.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $3bpJ1.GLOBAL_OBJ).navigator || {};
    const session = (0, $oyvka.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $oyvka.updateSession)(currentSession, {
        status: 'exited'
    });
    $81a395368bb6f380$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $81a395368bb6f380$export$17a5be43989a0bc1() {
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $oyvka.closeSession)(session);
    $81a395368bb6f380$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $81a395368bb6f380$var$_sendSessionUpdate() {
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    const currentScope = $81a395368bb6f380$export$c7be4b0125a10cba();
    const client = $81a395368bb6f380$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $81a395368bb6f380$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $81a395368bb6f380$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $81a395368bb6f380$var$_sendSessionUpdate();
}

});
parcelRegister("az0Em", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", () => $7b0dad5cf366cc16$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $7b0dad5cf366cc16$export$76b5f966996d1653);

var $b1E2c = parcelRequire("b1E2c");
var $cvSY8 = parcelRequire("cvSY8");
var $3bpJ1 = parcelRequire("3bpJ1");
var $drMc1 = parcelRequire("drMc1");
var $91U3U = parcelRequire("91U3U");

var $kfXMR = parcelRequire("kfXMR");

var $6T4Sa = parcelRequire("6T4Sa");

var $coQoV = parcelRequire("coQoV");

var $8ltoy = parcelRequire("8ltoy");

var $jfPQV = parcelRequire("jfPQV");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $7b0dad5cf366cc16$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $b1E2c.uuid4)(),
        timestamp: event.timestamp || (0, $cvSY8.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $7b0dad5cf366cc16$var$applyClientOptions(prepared, options);
    $7b0dad5cf366cc16$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $7b0dad5cf366cc16$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $7b0dad5cf366cc16$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $b1E2c.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $coQoV.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $8ltoy.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $8ltoy.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $8ltoy.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $6T4Sa.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $6T4Sa.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $7b0dad5cf366cc16$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $7b0dad5cf366cc16$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $7b0dad5cf366cc16$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $kfXMR.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $91U3U.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $91U3U.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $91U3U.truncate)(request.url, maxValueLength);
}
const $7b0dad5cf366cc16$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $7b0dad5cf366cc16$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $3bpJ1.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $7b0dad5cf366cc16$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $7b0dad5cf366cc16$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $7b0dad5cf366cc16$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $7b0dad5cf366cc16$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $7b0dad5cf366cc16$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $drMc1.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $drMc1.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $drMc1.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $drMc1.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $drMc1.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $jfPQV.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $drMc1.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $7b0dad5cf366cc16$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $coQoV.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $7b0dad5cf366cc16$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($7b0dad5cf366cc16$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($7b0dad5cf366cc16$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $7b0dad5cf366cc16$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $coQoV.Scope) || typeof hint === 'function';
}
const $7b0dad5cf366cc16$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $7b0dad5cf366cc16$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$7b0dad5cf366cc16$var$captureContextKeys.includes(key));
}

});
parcelRegister("drMc1", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $9ca32e18a091d955$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $9ca32e18a091d955$export$23fbbb20bed71033);

var $2zW56 = parcelRequire("2zW56");

var $3BHn6 = parcelRequire("3BHn6");

var $jL8lq = parcelRequire("jL8lq");

var $16dZf = parcelRequire("16dZf");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ca32e18a091d955$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $9ca32e18a091d955$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $9ca32e18a091d955$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $9ca32e18a091d955$export$a3295358bff77e(object, depth);
    if ($9ca32e18a091d955$var$jsonSize(normalized) > maxSize) return $9ca32e18a091d955$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $9ca32e18a091d955$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $3BHn6.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $2zW56.isNaN)(value)) return value;
    const stringified = $9ca32e18a091d955$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $9ca32e18a091d955$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $jL8lq.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $9ca32e18a091d955$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $9ca32e18a091d955$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $2zW56.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $2zW56.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $16dZf.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $9ca32e18a091d955$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $9ca32e18a091d955$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $9ca32e18a091d955$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9ca32e18a091d955$var$jsonSize(value) {
    return $9ca32e18a091d955$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $9ca32e18a091d955$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("3BHn6", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $2a06788518a26cc6$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $2a06788518a26cc6$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("16dZf", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $0cd1337813906a62$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $0cd1337813906a62$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $0cd1337813906a62$export$aad197c7121a6651);

var $cDXrx = parcelRequire("cDXrx");
const $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $0cd1337813906a62$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $0cd1337813906a62$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $0cd1337813906a62$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $0cd1337813906a62$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($0cd1337813906a62$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $0cd1337813906a62$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $0cd1337813906a62$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $0cd1337813906a62$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $0cd1337813906a62$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($0cd1337813906a62$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($0cd1337813906a62$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $0cd1337813906a62$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $0cd1337813906a62$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $0cd1337813906a62$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $0cd1337813906a62$var$defaultFunctionName;
        return fn.name || $0cd1337813906a62$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $0cd1337813906a62$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $0cd1337813906a62$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $cDXrx.node)(getModule)
    ];
}

});
parcelRegister("cDXrx", function(module, exports) {

$parcel$export(module.exports, "node", () => $93473cbc517fed7c$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $93473cbc517fed7c$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $93473cbc517fed7c$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $93473cbc517fed7c$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});



parcelRegister("jfPQV", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", () => $e047a3e652f57c75$export$208d5b368507fb8b);
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", () => $e047a3e652f57c75$export$eb571cd9b5d98de8);
$parcel$export(module.exports, "spanToTraceContext", () => $e047a3e652f57c75$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $e047a3e652f57c75$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceHeader", () => $e047a3e652f57c75$export$7e9f8ae9e4a328ab);
$parcel$export(module.exports, "spanIsSampled", () => $e047a3e652f57c75$export$5caecac1caaf3a71);
$parcel$export(module.exports, "spanTimeInputToSeconds", () => $e047a3e652f57c75$export$3f7581298f56c6d7);

var $jL8lq = parcelRequire("jL8lq");
var $65HJt = parcelRequire("65HJt");
var $cvSY8 = parcelRequire("cvSY8");
// These are aligned with OpenTelemetry trace flags
const $e047a3e652f57c75$export$208d5b368507fb8b = 0x0;
const $e047a3e652f57c75$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $e047a3e652f57c75$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $e047a3e652f57c75$export$92d8c23565496537(span);
    return (0, $jL8lq.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $e047a3e652f57c75$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $e047a3e652f57c75$export$5caecac1caaf3a71(span);
    return (0, $65HJt.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $e047a3e652f57c75$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $e047a3e652f57c75$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $e047a3e652f57c75$var$ensureTimestampInSeconds(input.getTime());
    return (0, $cvSY8.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $e047a3e652f57c75$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $e047a3e652f57c75$export$92d8c23565496537(span) {
    if ($e047a3e652f57c75$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $e047a3e652f57c75$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $e047a3e652f57c75$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $e047a3e652f57c75$export$eb571cd9b5d98de8);
}

});
parcelRegister("65HJt", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", () => $46f5220cb64aa700$export$394a210812ba3012);
$parcel$export(module.exports, "extractTraceparentData", () => $46f5220cb64aa700$export$8e9a29865c0a1226);
$parcel$export(module.exports, "tracingContextFromHeaders", () => $46f5220cb64aa700$export$ca5c066532785b6e);
$parcel$export(module.exports, "propagationContextFromHeaders", () => $46f5220cb64aa700$export$261f383d16a93e39);
$parcel$export(module.exports, "generateSentryTraceHeader", () => $46f5220cb64aa700$export$f35d907436da45cf);

var $dzA7g = parcelRequire("dzA7g");

var $b1E2c = parcelRequire("b1E2c");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $46f5220cb64aa700$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $46f5220cb64aa700$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($46f5220cb64aa700$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $46f5220cb64aa700$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $46f5220cb64aa700$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dzA7g.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $b1E2c.uuid4)(),
            spanId: (0, $b1E2c.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $b1E2c.uuid4)(),
            parentSpanId: parentSpanId || (0, $b1E2c.uuid4)().substring(16),
            spanId: (0, $b1E2c.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $46f5220cb64aa700$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $46f5220cb64aa700$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dzA7g.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $b1E2c.uuid4)(),
        spanId: (0, $b1E2c.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $b1E2c.uuid4)(),
        parentSpanId: parentSpanId || (0, $b1E2c.uuid4)().substring(16),
        spanId: (0, $b1E2c.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $46f5220cb64aa700$export$f35d907436da45cf(traceId = (0, $b1E2c.uuid4)(), spanId = (0, $b1E2c.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("dzA7g", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", () => $9e1a8f302f19c673$export$9ca9946bd449ac06);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $9e1a8f302f19c673$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $9e1a8f302f19c673$export$56766feef403f365);

var $eKZKa = parcelRequire("eKZKa");

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");
const $9e1a8f302f19c673$export$9ca9946bd449ac06 = 'baggage';
const $9e1a8f302f19c673$export$6e69537d67fa20f = 'sentry-';
const $9e1a8f302f19c673$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $9e1a8f302f19c673$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $9e1a8f302f19c673$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $2zW56.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $9e1a8f302f19c673$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $9e1a8f302f19c673$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($9e1a8f302f19c673$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($9e1a8f302f19c673$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $9e1a8f302f19c673$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$9e1a8f302f19c673$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $9e1a8f302f19c673$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $9e1a8f302f19c673$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $9e1a8f302f19c673$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $9e1a8f302f19c673$export$bdd844ddb2def819) {
            (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});





parcelRegister("ga8Oo", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", () => $bc446a546b963a28$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $bc446a546b963a28$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});




parcelRegister("9OAWn", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $725570364ca356d5$export$31499a9cd224b78c);
const $725570364ca356d5$export$31499a9cd224b78c = '7.120.4';

});


parcelRegister("54O61", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $3b242f8574a305e5$export$637857c1d87b640c);

var $isDtX = parcelRequire("isDtX");
var $e5Ga6 = parcelRequire("e5Ga6");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $5UTPE = parcelRequire("5UTPE");
let $3b242f8574a305e5$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $3b242f8574a305e5$export$637857c1d87b640c() {
    if ($3b242f8574a305e5$var$errorsInstrumented) return;
    $3b242f8574a305e5$var$errorsInstrumented = true;
    (0, $isDtX.addGlobalErrorInstrumentationHandler)($3b242f8574a305e5$var$errorCallback);
    (0, $e5Ga6.addGlobalUnhandledRejectionInstrumentationHandler)($3b242f8574a305e5$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $3b242f8574a305e5$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $5UTPE.getActiveTransaction)();
    if (activeTransaction) {
        const status = 'internal_error';
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$3b242f8574a305e5$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("isDtX", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $d70977d9b36915fd$export$55b5c3ba2194f0c6);

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
let $d70977d9b36915fd$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d70977d9b36915fd$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $d70977d9b36915fd$var$instrumentError);
}
function $d70977d9b36915fd$var$instrumentError() {
    $d70977d9b36915fd$var$_oldOnErrorHandler = (0, $3bpJ1.GLOBAL_OBJ).onerror;
    (0, $3bpJ1.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $dbwHv.triggerHandlers)('error', handlerData);
        if ($d70977d9b36915fd$var$_oldOnErrorHandler && !$d70977d9b36915fd$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $d70977d9b36915fd$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $3bpJ1.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("dbwHv", function(module, exports) {

$parcel$export(module.exports, "addHandler", () => $9995ab194a6bc98e$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $9995ab194a6bc98e$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $9995ab194a6bc98e$export$b18c893e424d3127);

var $eKZKa = parcelRequire("eKZKa");

var $4g0Ct = parcelRequire("4g0Ct");

var $16dZf = parcelRequire("16dZf");
// We keep the handlers globally
const $9995ab194a6bc98e$var$handlers = {};
const $9995ab194a6bc98e$var$instrumented = {};
/** Add a handler function. */ function $9995ab194a6bc98e$export$a4e09611e30da72e(type, handler) {
    $9995ab194a6bc98e$var$handlers[type] = $9995ab194a6bc98e$var$handlers[type] || [];
    $9995ab194a6bc98e$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $9995ab194a6bc98e$export$b17eab759a1cb5fe() {
    Object.keys($9995ab194a6bc98e$var$handlers).forEach((key)=>{
        $9995ab194a6bc98e$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $9995ab194a6bc98e$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$9995ab194a6bc98e$var$instrumented[type]) {
        instrumentFn();
        $9995ab194a6bc98e$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $9995ab194a6bc98e$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $9995ab194a6bc98e$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $16dZf.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("e5Ga6", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $a4223cccebdcb864$export$8bf4fc6858821a4e);

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
let $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a4223cccebdcb864$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $a4223cccebdcb864$var$instrumentUnhandledRejection);
}
function $a4223cccebdcb864$var$instrumentUnhandledRejection() {
    $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler = (0, $3bpJ1.GLOBAL_OBJ).onunhandledrejection;
    (0, $3bpJ1.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $dbwHv.triggerHandlers)('unhandledrejection', handlerData);
        if ($a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler && !$a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $a4223cccebdcb864$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $3bpJ1.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("5UTPE", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", () => $44ed7dd0e837ba6e$export$a7feb32fdd923295);
$parcel$export(module.exports, "extractTraceparentData", () => $44ed7dd0e837ba6e$export$8e9a29865c0a1226);

var $65HJt = parcelRequire("65HJt");

var $cmFjP = parcelRequire("cmFjP");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $44ed7dd0e837ba6e$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $cmFjP.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $44ed7dd0e837ba6e$export$8e9a29865c0a1226 = (0, $65HJt.extractTraceparentData);

});


parcelRegister("2EZoq", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", () => $1efef08b5fe9fa0b$export$809a2b7987fd5306);
$parcel$export(module.exports, "IdleTransaction", () => $1efef08b5fe9fa0b$export$b279e6bd7040371f);

var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");

var $8IHa9 = parcelRequire("8IHa9");

var $jfPQV = parcelRequire("jfPQV");

var $cKEJC = parcelRequire("cKEJC");

var $6Tqu0 = parcelRequire("6Tqu0");
const $1efef08b5fe9fa0b$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $1efef08b5fe9fa0b$var$FINISH_REASON_TAG = 'finishReason';
const $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $1efef08b5fe9fa0b$export$370d6113c18ba86c extends (0, $cKEJC.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $jfPQV.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $1efef08b5fe9fa0b$export$b279e6bd7040371f extends (0, $6Tqu0.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $1efef08b5fe9fa0b$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $1efef08b5fe9fa0b$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $1efef08b5fe9fa0b$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $jfPQV.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === 'ui.action.click') this.setAttribute($1efef08b5fe9fa0b$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $8IHa9.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, $4g0Ct.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $jfPQV.spanToJSON)(span).timestamp) {
                    span.setStatus('cancelled');
                    span.end(endTimestampInS);
                    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $jfPQV.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $8IHa9.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $4g0Ct.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $4g0Ct.logger).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log('[Tracing] flushing IdleTransaction');
        } else (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $1efef08b5fe9fa0b$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log('[Tracing] Received finish signal for idle transaction.');
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $cvSY8.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                this.setStatus('deadline_exceeded');
                this._finishReason = $1efef08b5fe9fa0b$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("cKEJC", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $948960fec1caf8ab$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $948960fec1caf8ab$export$5f1714a13ed34c01);

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");

var $8IHa9 = parcelRequire("8IHa9");

var $B23rB = parcelRequire("B23rB");

var $h5OHf = parcelRequire("h5OHf");

var $ga8Oo = parcelRequire("ga8Oo");

var $jfPQV = parcelRequire("jfPQV");

var $9pnio = parcelRequire("9pnio");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $948960fec1caf8ab$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $948960fec1caf8ab$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $b1E2c.uuid4)();
        this._spanId = spanContext.spanId || (0, $b1E2c.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $cvSY8.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        this.setAttributes({
            [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || 'manual',
            [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || '';
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $jfPQV.TRACE_FLAG_SAMPLED) : (0, $jfPQV.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $948960fec1caf8ab$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $ga8Oo.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $8IHa9.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = (0, $jfPQV.spanToJSON)(childSpan).description || '< unknown name >';
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $4g0Ct.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $9pnio.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === 'ok';
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $ga8Oo.getRootSpan)(this);
        if ((0, $8IHa9.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $4g0Ct.logger).log(logMessage.replace('Starting', 'Finishing'));
        }
        this._endTime = (0, $jfPQV.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $jfPQV.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $jfPQV.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $B23rB.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

});
parcelRegister("B23rB", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", () => $06f50cce9c869194$export$2e7205e45c58797d);

var $jL8lq = parcelRequire("jL8lq");




var $fJmes = parcelRequire("fJmes");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $06f50cce9c869194$var$SPAN_METRIC_SUMMARY;
function $06f50cce9c869194$var$getMetricStorageForSpan(span) {
    return $06f50cce9c869194$var$SPAN_METRIC_SUMMARY ? $06f50cce9c869194$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $06f50cce9c869194$export$2e7205e45c58797d(span) {
    const storage = $06f50cce9c869194$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $jL8lq.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $06f50cce9c869194$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $fJmes.getActiveSpan)();
    if (span) {
        const storage = $06f50cce9c869194$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$06f50cce9c869194$var$SPAN_METRIC_SUMMARY) $06f50cce9c869194$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $06f50cce9c869194$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("fJmes", function(module, exports) {

$parcel$export(module.exports, "startSpan", () => $b73c4ddb8b981968$export$a1bd95187356f372);
$parcel$export(module.exports, "startInactiveSpan", () => $b73c4ddb8b981968$export$63dbba021a6b4047);
$parcel$export(module.exports, "getActiveSpan", () => $b73c4ddb8b981968$export$1be426a8e585c83e);
$parcel$export(module.exports, "getCapturedScopesOnSpan", () => $b73c4ddb8b981968$export$c08fbc656a245d03);

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");
var $65HJt = parcelRequire("65HJt");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $jfPQV = parcelRequire("jfPQV");



var $bPHT6 = parcelRequire("bPHT6");

var $b8438 = parcelRequire("b8438");

var $b5vSa = parcelRequire("b5vSa");

var $duCnO = parcelRequire("duCnO");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $b73c4ddb8b981968$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $cmFjP.getCurrentHub)();
    const scope = (0, $b8438.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    const activeSpan = $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $b5vSa.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$a1bd95187356f372(context, callback) {
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    return (0, $cmFjP.runWithAsyncContext)(()=>{
        return (0, $b8438.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $cmFjP.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $b5vSa.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $jfPQV.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $b73c4ddb8b981968$export$cb9e396e6b90b703 = $b73c4ddb8b981968$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$c10292ad04b92aea(context, callback) {
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    return (0, $cmFjP.runWithAsyncContext)(()=>{
        return (0, $b8438.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $cmFjP.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $b5vSa.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $jfPQV.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $b73c4ddb8b981968$export$63dbba021a6b4047(context) {
    if (!(0, $duCnO.hasTracingEnabled)()) return undefined;
    const spanContext = $b73c4ddb8b981968$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $cmFjP.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : $b73c4ddb8b981968$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $b8438.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $b73c4ddb8b981968$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $b73c4ddb8b981968$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $b8438.getCurrentScope)().getSpan();
}
const $b73c4ddb8b981968$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $b8438.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $65HJt.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $8IHa9.DEBUG_BUILD) && traceparentData) (0, $4g0Ct.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $jL8lq.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $cmFjP.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function $b73c4ddb8b981968$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $duCnO.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $bPHT6.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $jfPQV.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $b73c4ddb8b981968$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $b73c4ddb8b981968$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $jfPQV.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $b73c4ddb8b981968$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $b73c4ddb8b981968$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function $b73c4ddb8b981968$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $jL8lq.addNonEnumerableProperty)(span, $b73c4ddb8b981968$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $jL8lq.addNonEnumerableProperty)(span, $b73c4ddb8b981968$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $b73c4ddb8b981968$export$c08fbc656a245d03(span) {
    return {
        scope: span[$b73c4ddb8b981968$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$b73c4ddb8b981968$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("b5vSa", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", () => $8128e29c1611c34e$export$18ce21a8b7efd7e9);

var $2zW56 = parcelRequire("2zW56");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $8128e29c1611c34e$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $8128e29c1611c34e$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $8128e29c1611c34e$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $2zW56.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("duCnO", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $9d2bd9c413e91a74$export$5008da00b1b6dee6);

var $b8438 = parcelRequire("b8438");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $9d2bd9c413e91a74$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $b8438.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}

});



parcelRegister("h5OHf", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $033619b8172dea69$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $033619b8172dea69$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $033619b8172dea69$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $033619b8172dea69$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $033619b8172dea69$export$1efec95406bbe327);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $033619b8172dea69$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $033619b8172dea69$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $033619b8172dea69$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $033619b8172dea69$export$cca8dd30f57f805e = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ const $033619b8172dea69$export$1efec95406bbe327 = 'profile_id';

});

parcelRegister("9pnio", function(module, exports) {

$parcel$export(module.exports, "SpanStatus", () => $6d9884e3956d809f$export$beb8e6a823e89c5d);
$parcel$export(module.exports, "spanStatusfromHttpCode", () => $6d9884e3956d809f$export$ac65c70d78fcdb55);
$parcel$export(module.exports, "setHttpStatus", () => $6d9884e3956d809f$export$2ad6630ec8164254);
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $6d9884e3956d809f$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($6d9884e3956d809f$export$beb8e6a823e89c5d || ($6d9884e3956d809f$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $6d9884e3956d809f$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $6d9884e3956d809f$export$ac65c70d78fcdb55 = $6d9884e3956d809f$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $6d9884e3956d809f$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    const spanStatus = $6d9884e3956d809f$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}

});


parcelRegister("6Tqu0", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $504c6c1458d8d0e9$export$febc5573c75cefb0);

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $cmFjP = parcelRequire("cmFjP");

var $B23rB = parcelRequire("B23rB");

var $h5OHf = parcelRequire("h5OHf");

var $jfPQV = parcelRequire("jfPQV");

var $bPHT6 = parcelRequire("bPHT6");

var $cKEJC = parcelRequire("cKEJC");

var $fJmes = parcelRequire("fJmes");
/** JSDoc */ class $504c6c1458d8d0e9$export$febc5573c75cefb0 extends (0, $cKEJC.Span) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $cmFjP.getCurrentHub)();
        this._name = transactionContext.name || '';
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: 'custom',
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = 'custom') {
        this._name = name;
        this.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $cKEJC.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $jfPQV.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $jL8lq.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $bPHT6.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $jfPQV.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $jfPQV.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $fJmes.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $jfPQV.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $jL8lq.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $bPHT6.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $B23rB.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

});


parcelRegister("kJ1jU", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", () => $f16908c3df50a491$export$b3258c3993bc9b71);
$parcel$export(module.exports, "isValidSampleRate", () => $f16908c3df50a491$export$2603c8d332a51c42);

var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $h5OHf = parcelRequire("h5OHf");

var $duCnO = parcelRequire("duCnO");

var $jfPQV = parcelRequire("jfPQV");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $f16908c3df50a491$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $duCnO.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$f16908c3df50a491$export$2603c8d332a51c42(sampleRate)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $8IHa9.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $4g0Ct.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $jfPQV.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $f16908c3df50a491$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $2zW56.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});


parcelRegister("289ZW", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire);
$parcel$export(module.exports, "loadModule", () => loadModule);

var $Wgg6o = parcelRequire("Wgg6o");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $Wgg6o.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("Wgg6o", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $0af207894032bdf2$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $0af207894032bdf2$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0af207894032bdf2$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0af207894032bdf2$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});



parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("f9rNA", function(module, exports) {
module.exports = $parcel$import("78EDp").then(()=>parcelRequire('R5nvG'));

});

parcelRegister("WS9F7", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRegister("3OBZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("jMNYH"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("dCBbD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("6gSsW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("33Dov", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("86Wyx", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.37', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HUAWEI = 'Huawei', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', OPERA = 'Opera', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI ' + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    '360 ' + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 ' + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    ' '
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i // Panasonic Viera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Lenovo'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    'Nokia'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OnePlus'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});

parcelRegister("hNQFu", function(module, exports) {

$parcel$export(module.exports, "makeContextSubject", () => makeContextSubject);
$parcel$export(module.exports, "entityMatch", () => entityMatch);
$parcel$export(module.exports, "getProp", () => getProp);

var $l73hA = parcelRequire("l73hA");

var $4ya6m = parcelRequire("4ya6m");
function makeContextSubject() {
    return {
        userToken: this.user.entityId,
        // cookie based token value
        anonymousToken: (0, $l73hA.getAndSetAvtSafe)(),
        // entity based token values check for matching entityType
        // before falling back user traits or message props
        employmentToken: this.entityMatch((0, $4ya6m.EntityTypes).employee) ? this.user.entityId : this.getProp('employmentToken'),
        merchantToken: this.entityMatch((0, $4ya6m.EntityTypes).merchant) ? this.user.entityId : this.getProp('merchantToken'),
        personToken: this.entityMatch((0, $4ya6m.EntityTypes).person) ? this.user.entityId : this.getProp('personToken'),
        unitToken: this.entityMatch((0, $4ya6m.EntityTypes).unit) ? this.user.entityId : this.getProp('unitToken'),
        /*
        these fields are only pulled from user traits or message props
        long term, it is best for these to be gotten via enrichment
        See discussion: https://docs.google.com/document/d/1OqpYJGFqU30leYRBjXtau4xV-03m5hZ-OonNrXvQqDA/edit?disco=AAAAkvBE_VY
    
        Note that we don't persist these values to localStorage in the
        the case that different users may share the same device.
        e.g. an employee with employmentCanAccessMobileRegister permission
        will log in and out of a device at the workplace. Then a different
        employee may log in and not have that permission
        */ legalEntityToken: this.getProp('legalEntityToken'),
        credentialToken: this.getProp('credentialToken'),
        deviceCredentialToken: this.getProp('deviceCredentialToken'),
        employmentCanAccessMobileRegister: this.getProp('employmentCanAccessMobileRegister'),
        employmentCanAccessSharedRegister: this.getProp('employmentCanAccessSharedRegister'),
        employmentIsOwner: this.getProp('employmentIsOwner'),
        accountCountryCode: this.getProp('accountCountryCode'),
        registeredCountryCode: this.getProp('registeredCountryCode')
    };
}
function entityMatch(entityTypeKey) {
    return this.user.entityType === entityTypeKey;
}
function getProp(propName) {
    return this.user.entityTraits[propName] || this.properties[propName] || null;
// TODO when we add group, user.traits and context.traits
// will not be the same so we need to check in both places
}

});
parcelRegister("l73hA", function(module, exports) {

$parcel$export(module.exports, "getAndSetAvtSafe", () => $03f76ea64b3c058d$export$bfecc853928377a4);
$parcel$export(module.exports, "entityIdAndTypeMatch", () => $03f76ea64b3c058d$export$84ad3bea9365c50b);

var $aEqFn = parcelRequire("aEqFn");
parcelRequire("5o0ob");
var $7tMaX = parcelRequire("7tMaX");
var $i34zz = parcelRequire("i34zz");
var $fvmH2 = parcelRequire("fvmH2");

var $4ya6m = parcelRequire("4ya6m");
function $03f76ea64b3c058d$export$bfecc853928377a4(passedId) {
    if ((0, $i34zz.isUUID)(passedId)) {
        // AVT can and should be overwritten by application logic
        $03f76ea64b3c058d$export$8583a1aa579ace2b(passedId);
        return passedId;
    } else {
        // if AVT is valid in cookies, return
        const avt = $03f76ea64b3c058d$export$4ad563027b36efdf();
        if (avt) return avt;
    }
    // create and set AVT if it doesn't exist
    const uuid = (0, $aEqFn.default)();
    $03f76ea64b3c058d$export$8583a1aa579ace2b(uuid);
    return uuid;
}
function $03f76ea64b3c058d$export$4ad563027b36efdf() {
    const avt = (0, $7tMaX.cookies).get((0, $4ya6m.CookieNames).avt);
    return (0, $i34zz.isUUID)(avt) ? avt : null;
}
function $03f76ea64b3c058d$export$8583a1aa579ace2b(id) {
    (0, $7tMaX.cookies).set((0, $4ya6m.CookieNames).avt, id);
    (0, $7tMaX.cookies).set((0, $4ya6m.LegacyStoreNames).anonId, id);
}
function $03f76ea64b3c058d$export$84ad3bea9365c50b(id, type) {
    if (!(0, $i34zz.isEntity)(type)) {
        (0, $fvmH2.warn)(`The second argument is not a valid entity type. Instead received "${type}". The identity will default to "${(0, $4ya6m.EntityTypes).anonVisitor}". Refer to https://go/cdpentities for a list of entity types.`);
        return false;
    }
    if (type === (0, $4ya6m.EntityTypes).merchant) {
        if ((0, $i34zz.isMerchantToken)(id)) return true;
        (0, $fvmH2.warn)(`The second argument entity type was specified as "${type}". The first argument should be a ${type} token. Instead received "${id}". The identity will default to "${(0, $4ya6m.EntityTypes).anonVisitor}".`);
        return false;
    }
    if (type === (0, $4ya6m.EntityTypes).anonVisitor) {
        if ((0, $i34zz.isUUID)(id)) return true;
        (0, $fvmH2.warn)(`The second argument entity type was specified as "${type}". The first argument should be a anonymous visitor token. Instead received "${id}". The user will be identified as an "${type}" but the entity id will be set to the AVT: "${$03f76ea64b3c058d$export$bfecc853928377a4()}".`);
        return false;
    }
    return true;
}

});
parcelRegister("aEqFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c12532ed9ea686c$export$2e2bcd8739ae039);

var $1sIEO = parcelRequire("1sIEO");

var $qz2KZ = parcelRequire("qz2KZ");

var $hIkO2 = parcelRequire("hIkO2");
function $7c12532ed9ea686c$var$v4(options, buf, offset) {
    if ((0, $1sIEO.default).randomUUID && !buf && !options) return (0, $1sIEO.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $qz2KZ.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $hIkO2.unsafeStringify)(rnds);
}
var $7c12532ed9ea686c$export$2e2bcd8739ae039 = $7c12532ed9ea686c$var$v4;

});
parcelRegister("1sIEO", function(module, exports) {

$parcel$export(module.exports, "default", () => $110b0bfc519c2451$export$2e2bcd8739ae039);
const $110b0bfc519c2451$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $110b0bfc519c2451$export$2e2bcd8739ae039 = {
    randomUUID: $110b0bfc519c2451$var$randomUUID
};

});

parcelRegister("qz2KZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $04fd9cb99c918a3b$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $04fd9cb99c918a3b$var$getRandomValues;
const $04fd9cb99c918a3b$var$rnds8 = new Uint8Array(16);
function $04fd9cb99c918a3b$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$04fd9cb99c918a3b$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $04fd9cb99c918a3b$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$04fd9cb99c918a3b$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $04fd9cb99c918a3b$var$getRandomValues($04fd9cb99c918a3b$var$rnds8);
}

});

parcelRegister("hIkO2", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $ce56af5fbb72a6f6$export$8fb373d660548968);

var $gbtAw = parcelRequire("gbtAw");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $ce56af5fbb72a6f6$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$ce56af5fbb72a6f6$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $ce56af5fbb72a6f6$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 0]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 1]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 2]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 3]] + '-' + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 4]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 5]] + '-' + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 6]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 7]] + '-' + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 8]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 9]] + '-' + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 10]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 11]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 12]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 13]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 14]] + $ce56af5fbb72a6f6$var$byteToHex[arr[offset + 15]];
}
function $ce56af5fbb72a6f6$var$stringify(arr, offset = 0) {
    const uuid = $ce56af5fbb72a6f6$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $gbtAw.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $ce56af5fbb72a6f6$export$2e2bcd8739ae039 = $ce56af5fbb72a6f6$var$stringify;

});
parcelRegister("gbtAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc84a0031a08350a$export$2e2bcd8739ae039);

var $hr82v = parcelRequire("hr82v");
function $bc84a0031a08350a$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $hr82v.default).test(uuid);
}
var $bc84a0031a08350a$export$2e2bcd8739ae039 = $bc84a0031a08350a$var$validate;

});
parcelRegister("hr82v", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb1b31bb7c47fc95$export$2e2bcd8739ae039);
var $cb1b31bb7c47fc95$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("5o0ob", function(module, exports) {
$parcel$export(module.exports, "ls", () => (parcelRequire("lll06")).ls);
$parcel$export(module.exports, "isArray", () => (parcelRequire("i34zz")).isArray);
$parcel$export(module.exports, "isEntity", () => (parcelRequire("i34zz")).isEntity);
$parcel$export(module.exports, "isEntityId", () => (parcelRequire("i34zz")).isEntityId);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("i34zz")).isFunction);
$parcel$export(module.exports, "isIdentify", () => (parcelRequire("i34zz")).isIdentify);
$parcel$export(module.exports, "isMerchantToken", () => (parcelRequire("i34zz")).isMerchantToken);
$parcel$export(module.exports, "isObject", () => (parcelRequire("i34zz")).isObject);
$parcel$export(module.exports, "isPage", () => (parcelRequire("i34zz")).isPage);
$parcel$export(module.exports, "isRecord", () => (parcelRequire("i34zz")).isRecord);
$parcel$export(module.exports, "isString", () => (parcelRequire("i34zz")).isString);
$parcel$export(module.exports, "isTrack", () => (parcelRequire("i34zz")).isTrack);
$parcel$export(module.exports, "isTraits", () => (parcelRequire("i34zz")).isTraits);
$parcel$export(module.exports, "isUUID", () => (parcelRequire("i34zz")).isUUID);
$parcel$export(module.exports, "cookies", () => (parcelRequire("7tMaX")).cookies);
$parcel$export(module.exports, "error", () => (parcelRequire("fvmH2")).error);
$parcel$export(module.exports, "logEvent", () => (parcelRequire("fvmH2")).logEvent);
$parcel$export(module.exports, "shouldLogEventsToConsole", () => (parcelRequire("fvmH2")).shouldLogEventsToConsole);
$parcel$export(module.exports, "throwError", () => (parcelRequire("fvmH2")).throwError);
$parcel$export(module.exports, "warn", () => (parcelRequire("fvmH2")).warn);
$parcel$export(module.exports, "warnAboutExcessiveColumns", () => (parcelRequire("3EKNW")).warnAboutExcessiveColumns);
$parcel$export(module.exports, "assignReadOnly", () => (parcelRequire("4BZ7p")).assignReadOnly);
$parcel$export(module.exports, "timeout", () => (parcelRequire("hLZet")).timeout);
$parcel$export(module.exports, "trackClickFeature", () => (parcelRequire("cCZXV")).trackClickFeature);
$parcel$export(module.exports, "trackClickLink", () => (parcelRequire("cCZXV")).trackClickLink);
$parcel$export(module.exports, "trackError", () => (parcelRequire("cCZXV")).trackError);
$parcel$export(module.exports, "trackViewFeature", () => (parcelRequire("cCZXV")).trackViewFeature);
parcelRequire("lll06");
parcelRequire("i34zz");
parcelRequire("7tMaX");
parcelRequire("fvmH2");
parcelRequire("3EKNW");
parcelRequire("4BZ7p");
parcelRequire("hLZet");
parcelRequire("cCZXV");

});
parcelRegister("lll06", function(module, exports) {

$parcel$export(module.exports, "ls", () => $f89bd96943f8d4ba$export$e0412d591d45e9b);

var $i34zz = parcelRequire("i34zz");
class $f89bd96943f8d4ba$export$24c55f0c9a7498db {
    set(key, value) {
        if ((0, $i34zz.isString)(value)) window.localStorage.setItem(key, value);
        else window.localStorage.setItem(key, JSON.stringify(value));
    }
    get(key) {
        const result = window.localStorage.getItem(key);
        try {
            if (result) return JSON.parse(result);
            return result;
        } catch (_a) {
            return result;
        }
    }
    remove(key) {
        window.localStorage.removeItem(key);
    }
}
const $f89bd96943f8d4ba$export$e0412d591d45e9b = new $f89bd96943f8d4ba$export$24c55f0c9a7498db();

});
parcelRegister("i34zz", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $d23c0dddc54d17ad$export$43bee75e5e14138e);
$parcel$export(module.exports, "isNull", () => $d23c0dddc54d17ad$export$630801d484da15df);
$parcel$export(module.exports, "isUndefined", () => $d23c0dddc54d17ad$export$fce6876652108ab);
$parcel$export(module.exports, "isObject", () => $d23c0dddc54d17ad$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isRecord", () => $d23c0dddc54d17ad$export$6ba840931da50680);
$parcel$export(module.exports, "isString", () => $d23c0dddc54d17ad$export$844ec244b1367d54);
$parcel$export(module.exports, "isFunction", () => $d23c0dddc54d17ad$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isEntity", () => $d23c0dddc54d17ad$export$b98f384b6711260c);
$parcel$export(module.exports, "isEntityId", () => $d23c0dddc54d17ad$export$d2e4f6b7ea45a200);
$parcel$export(module.exports, "isTraits", () => $d23c0dddc54d17ad$export$f91c32fb7ae270e8);
$parcel$export(module.exports, "isUUID", () => $d23c0dddc54d17ad$export$a1a1baf9c6597488);
$parcel$export(module.exports, "isMerchantToken", () => $d23c0dddc54d17ad$export$f4474880c6605184);
$parcel$export(module.exports, "isTrack", () => $d23c0dddc54d17ad$export$b36e5aedccf8be81);
$parcel$export(module.exports, "isPage", () => $d23c0dddc54d17ad$export$61d82a1ff85c609a);
$parcel$export(module.exports, "isIdentify", () => $d23c0dddc54d17ad$export$e5e98f9e52813f92);

var $jPIgV = parcelRequire("jPIgV");

var $4ya6m = parcelRequire("4ya6m");
function $d23c0dddc54d17ad$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $d23c0dddc54d17ad$export$630801d484da15df(arg) {
    return arg === null;
}
function $d23c0dddc54d17ad$export$fce6876652108ab(arg) {
    return arg === undefined;
}
function $d23c0dddc54d17ad$export$4967676db1b89293(arg) {
    return arg === null || arg === undefined;
}
function $d23c0dddc54d17ad$export$9a2e0569f350e442(arg) {
    return !$d23c0dddc54d17ad$export$4967676db1b89293(arg);
}
function $d23c0dddc54d17ad$export$a6cdc56e425d0d0a(arg) {
    if (typeof arg === 'object' && arg !== null) {
        const prototype = Object.getPrototypeOf(arg);
        return prototype === Object.prototype || prototype === null;
    }
    return false;
}
function $d23c0dddc54d17ad$export$6ba840931da50680(arg) {
    return $d23c0dddc54d17ad$export$a6cdc56e425d0d0a(arg);
}
function $d23c0dddc54d17ad$export$c66718ac105b3610(arg) {
    return $d23c0dddc54d17ad$export$a6cdc56e425d0d0a(arg) || $d23c0dddc54d17ad$export$43bee75e5e14138e(arg);
}
function $d23c0dddc54d17ad$export$844ec244b1367d54(arg) {
    return typeof arg === 'string';
}
function $d23c0dddc54d17ad$export$f6e2535fb5126e54(arg) {
    return typeof arg === 'function';
}
function $d23c0dddc54d17ad$export$b98f384b6711260c(entity) {
    if (!$d23c0dddc54d17ad$export$844ec244b1367d54(entity)) return false;
    return (0, $jPIgV.entities).includes(entity);
}
function $d23c0dddc54d17ad$export$d2e4f6b7ea45a200(entity) {
    return $d23c0dddc54d17ad$export$844ec244b1367d54(entity);
}
function $d23c0dddc54d17ad$export$f91c32fb7ae270e8(obj) {
    return $d23c0dddc54d17ad$export$a6cdc56e425d0d0a(obj);
}
function $d23c0dddc54d17ad$export$a1a1baf9c6597488(id) {
    if (!$d23c0dddc54d17ad$export$844ec244b1367d54(id)) return false;
    return (0, $4ya6m.Regex).uuid.test(id);
}
function $d23c0dddc54d17ad$export$f4474880c6605184(id) {
    if (!$d23c0dddc54d17ad$export$844ec244b1367d54(id)) return false;
    return (0, $4ya6m.Regex).merchantToken.test(id);
}
function $d23c0dddc54d17ad$export$b36e5aedccf8be81(msg) {
    return msg.apiMethod === 'track';
}
function $d23c0dddc54d17ad$export$61d82a1ff85c609a(msg) {
    return msg.apiMethod === 'page';
}
function $d23c0dddc54d17ad$export$e5e98f9e52813f92(msg) {
    return msg.apiMethod === 'identify';
}
function $d23c0dddc54d17ad$export$dae3322343de7d27(arg) {
    if (!$d23c0dddc54d17ad$export$a6cdc56e425d0d0a(arg)) return false;
    return 'integrations' in arg || 'page' in arg;
}

});
parcelRegister("jPIgV", function(module, exports) {

$parcel$export(module.exports, "LIBRARY_NAME", () => $e7051f36c76cee3d$export$450823d27eb9a43);
$parcel$export(module.exports, "LIBRARY_VERSION", () => $e7051f36c76cee3d$export$bb0adf1d8db61383);
$parcel$export(module.exports, "entities", () => $e7051f36c76cee3d$export$5345fd892b40e1f6);
$parcel$export(module.exports, "cookiePrefixMap", () => $e7051f36c76cee3d$export$94986e774361b474);
$parcel$export(module.exports, "gclidKeySet", () => $e7051f36c76cee3d$export$cedea2ee74d54d56);
/**
 * Library version is updated automatically during the
 * release process, do not update this manually.
 */ const $e7051f36c76cee3d$export$450823d27eb9a43 = '@squareup/cdp';
const $e7051f36c76cee3d$export$bb0adf1d8db61383 = '0.5.0';
const $e7051f36c76cee3d$export$5345fd892b40e1f6 = [
    'merchant',
    'employee',
    'anonymous_visitor',
    'capital_customer',
    'developer',
    'person',
    'unit',
    'weebly_user',
    'square_employee',
    'buyer'
];
const $e7051f36c76cee3d$export$10300b62880611fe = [
    '',
    null,
    undefined
];
const $e7051f36c76cee3d$export$94986e774361b474 = {
    aud: [
        'audience'
    ],
    c: [
        'campaignChannel'
    ],
    cmtp: [
        'campaigntype'
    ],
    cn: [
        'campaignname'
    ],
    crcopy: [
        'creativecopy'
    ],
    crcta: [
        'creativecta'
    ],
    crim: [
        'creativeimage'
    ],
    crtype: [
        'creativetype'
    ],
    d: [
        'detailChannel',
        'channel'
    ],
    dt: [
        'deviceChannel',
        'devicetype'
    ],
    exp: [
        'experiment'
    ],
    f: [
        'forecastChannel'
    ],
    l: [
        'locationChannel',
        'locationcountry'
    ],
    lang: [
        'language'
    ],
    meta1: [
        'meta1'
    ],
    meta2: [
        'meta2'
    ],
    o: [
        'offerChannel',
        'offer'
    ],
    p: [
        'partnerChannel',
        'partner'
    ],
    pr: [
        'productChannel',
        'initiative'
    ],
    route: [
        'destinationurl'
    ],
    sq: [
        'marinTag'
    ],
    subch: [
        'subchannel'
    ],
    subcmtp: [
        'subcampaigntype'
    ],
    subp: [
        'subpartner'
    ],
    tar: [
        'targetingtype'
    ],
    tarpr: [
        'targetproduct'
    ],
    u: [
        'urlChannel'
    ]
};
const $e7051f36c76cee3d$export$cedea2ee74d54d56 = new Set([
    'gclid',
    'pub',
    'kw',
    'kwid',
    'matchtype',
    'device'
]);

});

parcelRegister("4ya6m", function(module, exports) {

$parcel$export(module.exports, "EntityTypes", () => $35022c629f82799d$export$ede76e7dc512924d);
$parcel$export(module.exports, "StoreNames", () => $35022c629f82799d$export$bfe89b7256f355e8);
$parcel$export(module.exports, "CookieNames", () => $35022c629f82799d$export$ac4b353634732ef6);
$parcel$export(module.exports, "LSNames", () => $35022c629f82799d$export$8e09aad693641a41);
$parcel$export(module.exports, "LegacyStoreNames", () => $35022c629f82799d$export$75518b681ea4cbf5);
$parcel$export(module.exports, "LegacyLSNames", () => $35022c629f82799d$export$a56e4ff3628a33f0);
$parcel$export(module.exports, "Environments", () => $35022c629f82799d$export$56edef3a554a6277);
$parcel$export(module.exports, "LogEventsToConsole", () => $35022c629f82799d$export$bdbdfeafa5315b49);
$parcel$export(module.exports, "Regex", () => $35022c629f82799d$export$280b9474c61b36c7);
var $35022c629f82799d$export$ede76e7dc512924d;
(function(EntityTypes) {
    EntityTypes["merchant"] = "merchant";
    EntityTypes["employee"] = "employee";
    EntityTypes["anonVisitor"] = "anonymous_visitor";
    EntityTypes["capitalCustomer"] = "capital_customer";
    EntityTypes["developer"] = "developer";
    EntityTypes["person"] = "person";
    EntityTypes["unit"] = "unit";
    EntityTypes["weeblyUser"] = "weebly_user";
    EntityTypes["squareEmployee"] = "square_employee";
    EntityTypes["buyer"] = "buyer";
})($35022c629f82799d$export$ede76e7dc512924d || ($35022c629f82799d$export$ede76e7dc512924d = {}));
var $35022c629f82799d$export$bfe89b7256f355e8;
(function(StoreNames) {
    StoreNames["userEntityType"] = "cdpUserEntityType";
    StoreNames["userEntityId"] = "cdpUserEntityId";
})($35022c629f82799d$export$bfe89b7256f355e8 || ($35022c629f82799d$export$bfe89b7256f355e8 = {}));
var $35022c629f82799d$export$ac4b353634732ef6;
(function(CookieNames) {
    CookieNames["avt"] = "_savt";
    CookieNames["enabled"] = "cdpCookiesEnabled";
    CookieNames["trackCookie"] = "track_cookie";
})($35022c629f82799d$export$ac4b353634732ef6 || ($35022c629f82799d$export$ac4b353634732ef6 = {}));
var $35022c629f82799d$export$8e09aad693641a41;
(function(LSNames) {
    LSNames["userEntityTraits"] = "cdpUserEntityTraits";
    LSNames["groupProps"] = "cdpGroupProps";
/*
    user traits and group props are potentially
    massive amounts of data, even after encoding.
    We may hit the size limit of the cookie (4kb)
    */ })($35022c629f82799d$export$8e09aad693641a41 || ($35022c629f82799d$export$8e09aad693641a41 = {}));
var $35022c629f82799d$export$75518b681ea4cbf5;
(function(LegacyStoreNames) {
    LegacyStoreNames["userEntityId"] = "dajs_user_id";
    LegacyStoreNames["userEntityType"] = "da_js_user_type";
    LegacyStoreNames["anonId"] = "dajs_anonymous_id";
    LegacyStoreNames["groupId"] = "dajs_group_id";
})($35022c629f82799d$export$75518b681ea4cbf5 || ($35022c629f82799d$export$75518b681ea4cbf5 = {}));
var $35022c629f82799d$export$a56e4ff3628a33f0;
(function(LegacyLSNames) {
    LegacyLSNames["groupProps"] = "dajs_group_properties";
    LegacyLSNames["userEntityTraits"] = "dajs_user_traits";
})($35022c629f82799d$export$a56e4ff3628a33f0 || ($35022c629f82799d$export$a56e4ff3628a33f0 = {}));
var $35022c629f82799d$export$56edef3a554a6277;
(function(Environments) {
    Environments["production"] = "production";
    Environments["stage"] = "staging";
    Environments["development"] = "development";
    Environments["localDev"] = "localDev";
})($35022c629f82799d$export$56edef3a554a6277 || ($35022c629f82799d$export$56edef3a554a6277 = {}));
var $35022c629f82799d$export$bdbdfeafa5315b49;
(function(LogEventsToConsole) {
    LogEventsToConsole["on"] = "on";
    LogEventsToConsole["off"] = "off";
    LogEventsToConsole["default"] = "default";
})($35022c629f82799d$export$bdbdfeafa5315b49 || ($35022c629f82799d$export$bdbdfeafa5315b49 = {}));
class $35022c629f82799d$export$280b9474c61b36c7 {
}
$35022c629f82799d$export$280b9474c61b36c7.uuid = /^[\dA-Fa-f]{8}(?:\b-[\dA-Fa-f]{4}){3}\b-[\dA-Fa-f]{12}$/;
/* Seller Profile tokens: https://java-docs.square.com/roster/tokens
 * We have no guarantee these token formats will stay the same in the future, see link below
 * https://square.slack.com/archives/C03EH7224/p1670872738450729?thread_ts=1670861733.529879&cid=C03EH7224
 */ $35022c629f82799d$export$280b9474c61b36c7.merchantToken = /^(merchant:)?[\dA-Z]{13,14}$/;
$35022c629f82799d$export$280b9474c61b36c7.unitToken = /^(unit:)?[\dA-Z]{13,14}$/;
// setting min length of 5 as that seems good enough
$35022c629f82799d$export$280b9474c61b36c7.employmentToken = /^(employment:)?[\w-]{5,20}$/;

});



parcelRegister("7tMaX", function(module, exports) {

$parcel$export(module.exports, "cookies", () => $57209c843bc4ff85$export$97131b3b5327c27f);

var $hta8F = parcelRequire("hta8F");

var $4ya6m = parcelRequire("4ya6m");
function $57209c843bc4ff85$export$294ead44cbc289a5(host) {
    // https://github.com/squareup/public-web-styles/blob/master/app/assets/javascripts/public-web-styles/modules/tracking.js.es6#L97-L108
    const domain_match = /[^.]*\.([^.]*|..\...|...\...)$/.exec(host);
    const ip_match = /^[\d.]+$/.exec(host);
    if (!ip_match && domain_match) return `.${domain_match[0]}`;
    else return undefined;
}
const $57209c843bc4ff85$var$cookieOptions = {
    expires: 1095,
    path: '/'
};
function $57209c843bc4ff85$var$get(name) {
    if (name === undefined) return (0, $hta8F.default).get();
    let store = (0, $hta8F.default).get(name);
    if (Object.values((0, $4ya6m.LegacyStoreNames)).includes(name) && store) store = store.slice(1, -1);
    return store;
}
function $57209c843bc4ff85$var$set(name, value) {
    let store = value;
    if (Object.values((0, $4ya6m.LegacyStoreNames)).includes(name)) store = window.JSON.stringify(store);
    if (!$57209c843bc4ff85$var$cookieOptions.domain) $57209c843bc4ff85$var$cookieOptions.domain = $57209c843bc4ff85$export$294ead44cbc289a5(window.location.hostname);
    return (0, $hta8F.default).set(name, store, $57209c843bc4ff85$var$cookieOptions);
}
const $57209c843bc4ff85$export$97131b3b5327c27f = {
    remove: (0, $hta8F.default).remove,
    set: $57209c843bc4ff85$var$set,
    get: $57209c843bc4ff85$var$get
};

});
parcelRegister("hta8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb2bda4b905adee7$export$2e2bcd8739ae039);
/*! js-cookie v3.0.5 | MIT */ /* eslint-disable no-var */ function $fb2bda4b905adee7$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)target[key] = source[key];
    }
    return target;
}
/* eslint-enable no-var */ /* eslint-disable no-var */ var $fb2bda4b905adee7$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
/* eslint-enable no-var */ /* eslint-disable no-var */ function $fb2bda4b905adee7$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $fb2bda4b905adee7$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (e) {}
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $fb2bda4b905adee7$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $fb2bda4b905adee7$var$init(this.converter, $fb2bda4b905adee7$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $fb2bda4b905adee7$var$init($fb2bda4b905adee7$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $fb2bda4b905adee7$export$2e2bcd8739ae039 = $fb2bda4b905adee7$var$init($fb2bda4b905adee7$var$defaultConverter, {
    path: '/'
});

});


parcelRegister("fvmH2", function(module, exports) {

$parcel$export(module.exports, "warn", () => $b49b5aab683e55af$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "error", () => $b49b5aab683e55af$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "throwError", () => $b49b5aab683e55af$export$8bf7aba4a9e09055);
$parcel$export(module.exports, "shouldLogEventsToConsole", () => $b49b5aab683e55af$export$20de18a7a1a3a089);
$parcel$export(module.exports, "logEvent", () => $b49b5aab683e55af$export$5e9eec8001665ac5);

var $cCZXV = parcelRequire("cCZXV");

var $jPIgV = parcelRequire("jPIgV");

var $4ya6m = parcelRequire("4ya6m");
function $b49b5aab683e55af$export$c106dd0671a0fc2d(message) {
    console.warn(`${(0, $jPIgV.LIBRARY_NAME)}: ${message}`);
}
function $b49b5aab683e55af$export$a3bc9b8ed74fc(message) {
    console.error(`${(0, $jPIgV.LIBRARY_NAME)}: ${message}`);
}
function $b49b5aab683e55af$export$8bf7aba4a9e09055(message) {
    throw new Error(`${(0, $jPIgV.LIBRARY_NAME)}: ${message}`);
}
function $b49b5aab683e55af$export$20de18a7a1a3a089(value, environment) {
    switch(value){
        case 'on':
            return true;
        case 'off':
            return false;
        default:
            return environment !== (0, $4ya6m.Environments).production;
    }
}
const $b49b5aab683e55af$export$abaa3d2e8b1241a9 = new Map([
    [
        'identify',
        '#FF5722'
    ],
    [
        'page',
        '#4CAF50'
    ],
    [
        'track',
        '#2196F3'
    ],
    [
        'group',
        '#009688'
    ]
]);
function $b49b5aab683e55af$export$5e9eec8001665ac5(event) {
    const eventName = 'name' in event ? event.name : 'eventName' in event ? event.eventName : null;
    const { apiKey: apiKey, apiMethod: apiMethod, entityId: entityId, entityType: entityType, messageId: messageId, originalTimestamp: originalTimestamp, sentAt: sentAt, timestamp: timestamp, context: context } = event;
    const { groupCollapsed: groupCollapsed, log: log, groupEnd: groupEnd } = console;
    const featureName = (0, $cCZXV.getFeatureName)(eventName, // eslint-disable-next-line unicorn/consistent-destructuring
    'properties' in event ? event.properties : {});
    groupCollapsed(`%c${(0, $jPIgV.LIBRARY_NAME)}: ${apiMethod}${eventName ? ` - "${eventName}"` : ''}${featureName ? ` \u{2192} "${featureName}"` : ''}`, `color:${$b49b5aab683e55af$export$abaa3d2e8b1241a9.get(apiMethod)}`);
    log(Object.assign(Object.assign(Object.assign({
        apiKey: apiKey,
        messageId: messageId,
        entityId: entityId,
        entityType: entityType,
        sentAt: sentAt,
        originalTimestamp: originalTimestamp,
        timestamp: timestamp
    }, 'properties' in event ? {
        properties: event.properties
    } : {}), 'traits' in event ? {
        traits: event.traits
    } : {}), {
        context: context
    }));
    groupEnd();
}

});
parcelRegister("cCZXV", function(module, exports) {

$parcel$export(module.exports, "getFeatureName", () => $931919b949dbbc98$export$b6a8dc7b655c1abb);
$parcel$export(module.exports, "trackViewFeature", () => $931919b949dbbc98$export$598b8143605bca27);
$parcel$export(module.exports, "trackClickFeature", () => $931919b949dbbc98$export$a4fb76081b0beac6);
$parcel$export(module.exports, "trackClickLink", () => $931919b949dbbc98$export$8ef559bf595b302b);
$parcel$export(module.exports, "trackError", () => $931919b949dbbc98$export$5a6ec5e5079bbe35);
/**
 * These helpers provide a consistent contract for the
 * Dashboard Instrumentation Framework (see engineering guide):
 * @see {@link https://docs.google.com/document/d/1UKedwoC3F0g9vV4FejsmsYg1e8JWMtojTNaxUIoO7TY/edit?usp=sharing }
 */ 
var $i34zz = parcelRequire("i34zz");
const $931919b949dbbc98$export$8fd0db9ce085ddd7 = 'View Feature';
const $931919b949dbbc98$export$a4312940e23442bb = 'Click Feature';
const $931919b949dbbc98$export$3a1d98e18325910e = 'Click Link';
const $931919b949dbbc98$export$62ae3487abf7b22 = 'Error';
function $931919b949dbbc98$export$b6a8dc7b655c1abb(eventName, eventProps) {
    var _a;
    const validEvent = (0, $i34zz.isString)(eventName) && [
        $931919b949dbbc98$export$8fd0db9ce085ddd7,
        $931919b949dbbc98$export$a4312940e23442bb,
        $931919b949dbbc98$export$3a1d98e18325910e,
        $931919b949dbbc98$export$62ae3487abf7b22
    ].includes(eventName);
    const validProps = (0, $i34zz.isObject)(eventProps) && ('feature_id' in eventProps && 'feature_name' in eventProps || 'featureId' in eventProps && 'featureName' in eventProps);
    if (validEvent && validProps) return (_a = eventProps.feature_name) !== null && _a !== void 0 ? _a : eventProps.featureName;
    return '';
}
function $931919b949dbbc98$export$598b8143605bca27(instance, { featureName: featureName, featureId: featureId, featureParentId: featureParentId = null, featureFormat: featureFormat, eventDescription: eventDescription, isDefaultView: isDefaultView, featureLayout: featureLayout = null, additionalParameters: additionalParameters = null, isTaskCompleted: isTaskCompleted }) {
    /**
     * All properties that get passed to the data API should use snake case
     * to adhere to CDP's guidelines on data quality.
     *
     * @see {@link https://docs.google.com/document/d/1N8erIAE3CydeKuSLX0zMaLWskDy6PONSeAxErvvOEcU/edit#heading=h.jsuxzjdj57cr}
     */ const properties = {
        feature_name: featureName,
        feature_id: featureId,
        feature_parent_id: featureParentId,
        feature_format: featureFormat,
        event_description: eventDescription,
        is_default_view: isDefaultView,
        feature_layout: featureLayout,
        additional_parameters: additionalParameters,
        is_task_completed: isTaskCompleted
    };
    instance.trackV2({
        eventName: $931919b949dbbc98$export$8fd0db9ce085ddd7,
        eventProps: properties
    });
}
function $931919b949dbbc98$export$a4fb76081b0beac6(instance, { featureName: featureName, featureId: featureId, featureParentId: featureParentId = null, featureFormat: featureFormat, eventDescription: eventDescription, actionItem: actionItem, subActionItem: subActionItem = null, additionalParameters: additionalParameters = null, isTaskCompleted: isTaskCompleted }) {
    /**
     * All properties that get passed to the data API should use snake case
     * to adhere to CDP's guidelines on data quality.
     *
     * @see {@link https://docs.google.com/document/d/1N8erIAE3CydeKuSLX0zMaLWskDy6PONSeAxErvvOEcU/edit#heading=h.jsuxzjdj57cr}
     */ const properties = {
        feature_name: featureName,
        feature_id: featureId,
        feature_parent_id: featureParentId,
        feature_format: featureFormat,
        event_description: eventDescription,
        action_item: actionItem,
        sub_action_item: subActionItem,
        additional_parameters: additionalParameters,
        is_task_completed: isTaskCompleted
    };
    instance.trackV2({
        eventName: $931919b949dbbc98$export$a4312940e23442bb,
        eventProps: properties
    });
}
function $931919b949dbbc98$export$8ef559bf595b302b(instance, { featureName: featureName, featureId: featureId, featureParentId: featureParentId = null, featureFormat: featureFormat, linkText: linkText, linkTitle: linkTitle, linkUrl: linkUrl }) {
    /**
     * All properties that get passed to the data API should use snake case
     * to adhere to CDP's guidelines on data quality.
     *
     * @see {@link https://docs.google.com/document/d/1N8erIAE3CydeKuSLX0zMaLWskDy6PONSeAxErvvOEcU/edit#heading=h.jsuxzjdj57cr}
     */ const properties = {
        feature_name: featureName,
        feature_id: featureId,
        feature_parent_id: featureParentId,
        feature_format: featureFormat,
        link_text: linkText,
        link_title: linkTitle,
        link_url: linkUrl
    };
    instance.trackV2({
        eventName: $931919b949dbbc98$export$3a1d98e18325910e,
        eventProps: properties
    });
}
function $931919b949dbbc98$export$5a6ec5e5079bbe35(instance, { featureName: // Feature level
featureName, featureId: featureId, featureParentId: featureParentId = null, featureFormat: featureFormat, eventDescription: // Error level
eventDescription, eventCalled: eventCalled, errorType: errorType, errorMessage: errorMessage = null, additionalParameters: additionalParameters = null, isTaskCompleted: isTaskCompleted }) {
    /**
     * All properties that get passed to the data API should use snake case
     * to adhere to CDP's guidelines on data quality.
     *
     * @see {@link https://docs.google.com/document/d/1N8erIAE3CydeKuSLX0zMaLWskDy6PONSeAxErvvOEcU/edit#heading=h.jsuxzjdj57cr}
     */ const properties = {
        // Feature level
        feature_name: featureName,
        feature_id: featureId,
        feature_parent_id: featureParentId,
        feature_format: featureFormat,
        // Error level
        event_description: eventDescription,
        event_called: eventCalled,
        error_type: errorType,
        error_message: errorMessage,
        additional_parameters: additionalParameters,
        is_task_completed: isTaskCompleted
    };
    instance.trackV2({
        eventName: $931919b949dbbc98$export$62ae3487abf7b22,
        eventProps: properties
    });
}

});


parcelRegister("3EKNW", function(module, exports) {

$parcel$export(module.exports, "warnAboutExcessiveColumns", () => $2a9969f152be2058$export$736ab14d476c5318);

var $fvmH2 = parcelRequire("fvmH2");

var $i34zz = parcelRequire("i34zz");
const $2a9969f152be2058$export$482753196d6d7002 = 30;
function $2a9969f152be2058$export$733129a7d66ee0ba(eventProps) {
    let columns = 1;
    if ((0, $i34zz.isObject)(eventProps)) for (const value of Object.values(eventProps))columns += $2a9969f152be2058$export$733129a7d66ee0ba(value);
    return columns;
}
function $2a9969f152be2058$export$736ab14d476c5318(eventName, eventProps) {
    const columns = $2a9969f152be2058$export$733129a7d66ee0ba(eventProps) - 1;
    if (columns > $2a9969f152be2058$export$482753196d6d7002) (0, $fvmH2.warn)(`event "${eventName}" will create ${columns} columns in some upstream database tables`);
}

});

parcelRegister("4BZ7p", function(module, exports) {

$parcel$export(module.exports, "assignReadOnly", () => $35ba06fbc6c09960$export$a3a0906114eec376);
function $35ba06fbc6c09960$export$a3a0906114eec376(context, field, value) {
    Object.defineProperty(context, field, {
        value: value,
        writable: false,
        configurable: true
    });
}

});

parcelRegister("hLZet", function(module, exports) {

$parcel$export(module.exports, "timeout", () => $cf0652f57315af7b$export$83e74882c5df8fe1);

var $i34zz = parcelRequire("i34zz");
function $cf0652f57315af7b$export$83e74882c5df8fe1(fn) {
    if ((0, $i34zz.isFunction)(fn)) // 300 is default value in data-api.js
    setTimeout(fn, 300);
}

});




parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

var $5a449b2591d18a1b$exports = {};
$parcel$extendImportMap({
    "cLMc7": "shadow-css.bec2a672.js",
    "78EDp": "browser-ponyfill.02488d82.js"
});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $27bb0e5b34358db8$export$32180ef41b15b513;
$27bb0e5b34358db8$export$32180ef41b15b513 = `myMTMW_index_body`;


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $eIG6O = parcelRequire("eIG6O");
const $078609d239e2b7c3$export$640106f6dc7d2706 = window.location.hostname.split(".").slice(-2).join(".");
var $078609d239e2b7c3$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "ENVIRONMENT_DEVELOPMENT";
    Environment["Staging"] = "ENVIRONMENT_STAGING";
    Environment["Production"] = "ENVIRONMENT_PRODUCTION";
    return Environment;
}({});
const $078609d239e2b7c3$export$57570b1603cf6adb = ()=>{
    if ($078609d239e2b7c3$export$640106f6dc7d2706 === "squareupstaging.com") return "ENVIRONMENT_STAGING";
    if ($078609d239e2b7c3$export$640106f6dc7d2706 === "squareup.com") return "ENVIRONMENT_PRODUCTION";
    throw new Error("Cannot determine environment");
};
const $078609d239e2b7c3$export$987dd53eec1f61cf = ()=>$078609d239e2b7c3$export$57570b1603cf6adb() === "ENVIRONMENT_DEVELOPMENT";
const $078609d239e2b7c3$export$b3e1bb4c27c63f89 = ()=>$078609d239e2b7c3$export$57570b1603cf6adb() === "ENVIRONMENT_STAGING";
const $078609d239e2b7c3$export$9c0c5d1f8a7fb19a = ()=>$078609d239e2b7c3$export$57570b1603cf6adb() === "ENVIRONMENT_PRODUCTION";


function $e510731c6d5d7eb1$export$3988ae62b71be9a3(name) {
    if (document == null) return undefined;
    const cookies = document.cookie == null ? [] : document.cookie.split("; ");
    for(let i = 0; i < cookies.length; i++){
        const cookie = cookies[i];
        const parts = cookie.split("=");
        if (parts[0] === name) {
            const value = parts.slice(1).join("=");
            value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
            return value;
        }
    }
}


// "https://foo.bar.squareupstaging.com/baz" => "https://squareupstaging.com"
const $6a4edd14a7aeb8ed$var$BASE_URL = new URL(`${window.location.protocol}//${window.location.hostname.split(".").slice(-2).join(".")}`);
var $6a4edd14a7aeb8ed$export$2e2bcd8739ae039 = $6a4edd14a7aeb8ed$var$BASE_URL;


var // TODO(steckel): Use api subdomain and standardized path GRPC
// https://github.com/protobufjs/protobuf.js/#using-services
/* eslint-disable @typescript-eslint/ban-types */ $a8dda4170dc4b740$export$2e2bcd8739ae039 = (fetch)=>(method, requestData, callback)=>{
        /* eslint-enable @typescript-eslint/ban-types */ if (typeof method === "function") return method;
        const headers = new Headers();
        headers.append("Accept", "application/x-protobuf");
        headers.append("Content-Type", "application/x-protobuf");
        const csrfValue = (0, $e510731c6d5d7eb1$export$3988ae62b71be9a3)("_js_csrf");
        if (csrfValue != null) headers.append("X-CSRF-Token", csrfValue);
        const path = `/services/${$a8dda4170dc4b740$var$fullyQualifiedMethodName(method)}`;
        const grpcMethodUrl = new URL(path, (0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039));
        const request = new Request(grpcMethodUrl.toString(), {
            body: requestData,
            credentials: "include",
            headers: headers,
            method: "POST",
            mode: "cors"
        });
        fetch(request).then($a8dda4170dc4b740$var$fetchHandler(callback)).then((buffer)=>new Uint8Array(buffer)).then((message)=>callback(null, message)).catch((error)=>callback(error, null));
    };
const $a8dda4170dc4b740$var$fetchHandler = (callback)=>(response)=>{
        if (!response.ok) callback(new Error(`HTTP Response ${response.status}`), null);
        return response.arrayBuffer();
    };
// TODO(steckel): assert on parent being non-null
/* eslint-disable @typescript-eslint/no-non-null-assertion */ const $a8dda4170dc4b740$var$fullyQualifiedMethodName = (method)=>`${method.parent.fullName.slice(1)}/${method.name}`; /* eslint-enable @typescript-eslint/no-non-null-assertion */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ var $10433685c0be4487$exports = {};
// light library entry point.
"use strict";

$10433685c0be4487$exports = (parcelRequire("lLiTM"));



const $5fc7bb4dcf6d49e8$export$3f8fe6489e95757d = Symbol('build');
const $5fc7bb4dcf6d49e8$export$5baac73b42fdd539 = Symbol('validateAndBuild');
const $5fc7bb4dcf6d49e8$export$a22775fa5e2eebd9 = Symbol('validate');
const $5fc7bb4dcf6d49e8$export$423e32095c917e40 = Symbol('validated');


function $5b4e7aff5e6ce4a3$var$addInstanceof(Type) {
    // This lets `message instanceof Type` work
    Type[Symbol.hasInstance] = (instance)=>instance instanceof Type.ctor;
}
function $5b4e7aff5e6ce4a3$var$getChildren(field, value) {
    if (field.repeated) return value;
    else if (field.map) return [
        ...Object.values(value)
    ];
    else return [
        value
    ];
}
// Fixes create to make sure the Message has the correct types.
// It accepts the interfaces for the objects (regular objects potentially missing fields),
// but we then expect it to have the correct child Message objects.
function $5b4e7aff5e6ce4a3$var$fixCreate(Type) {
    const originalCreate = Type.create.bind(Type);
    Type.create = (...args)=>{
        const created = originalCreate(...args);
        for (const field of Object.values(Type.fields)){
            // This is not the type of field we need to convert
            if (!created[field.name] || !field.resolvedType || field.resolvedType instanceof (0, $10433685c0be4487$exports.Enum)) continue;
            if (field.repeated) created[field.name] = created[field.name].map((value)=>{
                if (value instanceof field.resolvedType) return value;
                else return field.resolvedType.create(value);
            });
            else if (field.map) created[field.name] = Object.fromEntries(Object.entries(created[field.name]).map(([key, value])=>{
                if (value instanceof field.resolvedType) return [
                    key,
                    value
                ];
                else return [
                    key,
                    field.resolvedType.create(value)
                ];
            }));
            else // This is already an instance of the type, so no need to convert it.
            if (!(created[field.name] instanceof field.resolvedType)) // We have a plain object (or the wrong type) but we want a Message.
            created[field.name] = field.resolvedType.create(created[field.name]);
        }
        return created;
    };
}
function $5b4e7aff5e6ce4a3$var$addValidations(Type, validationOptions = {}) {
    const existingDescriptor = Object.getOwnPropertyDescriptor(Type.__proto__, 'ctor');
    // no need to add validations if they have already been added
    // this function fires twice on fast refresh on frameworks such as NextJS
    if (Type.validateAndCreate) return;
    // This way the validation methods get added to any ctor added to this type, including
    // the default one that needs to be lazily created later.
    Object.defineProperty(Type, 'ctor', {
        ...existingDescriptor,
        get: function() {
            return existingDescriptor.get.call(Type);
        },
        set: function(ctor) {
            existingDescriptor.set.call(Type, ctor);
            ctor.prototype[0, $5fc7bb4dcf6d49e8$export$a22775fa5e2eebd9] = function() {
                for (const [propertyName, options] of Object.entries(validationOptions)){
                    for (const [validationType, validationValue] of Object.entries(options))switch(validationType){
                        case 'required':
                            if (!Object.prototype.hasOwnProperty.call(this, propertyName)) throw new TypeError(`Invalid ${propertyName}`);
                            break;
                        case 'notEmpty':
                            const value = this[propertyName];
                            const field = Type.fields[propertyName];
                            if (!$5b4e7aff5e6ce4a3$var$getChildren(field, value).every((v)=>v && v.length > 0)) throw new TypeError(`Invalid ${propertyName}`);
                            break;
                    }
                    for (const [propertyName, field] of Object.entries(Type.fields)){
                        const value = this[propertyName];
                        for (const childValue of $5b4e7aff5e6ce4a3$var$getChildren(field, value))childValue?.[0, $5fc7bb4dcf6d49e8$export$a22775fa5e2eebd9]?.();
                    }
                }
            };
            ctor.prototype[0, $5fc7bb4dcf6d49e8$export$423e32095c917e40] = function() {
                this[0, $5fc7bb4dcf6d49e8$export$a22775fa5e2eebd9]();
                return this;
            };
            if (!ctor.prototype.validate) ctor.prototype.validate = ctor.prototype[0, $5fc7bb4dcf6d49e8$export$a22775fa5e2eebd9];
            if (!ctor.prototype.validated) ctor.prototype.validated = ctor.prototype[0, $5fc7bb4dcf6d49e8$export$423e32095c917e40];
        }
    });
    Type.validateAndCreate = (...args)=>{
        return Type.create(...args)[0, $5fc7bb4dcf6d49e8$export$423e32095c917e40]();
    };
}
function $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb(Type, validationOptions) {
    $5b4e7aff5e6ce4a3$var$addInstanceof(Type);
    $5b4e7aff5e6ce4a3$var$fixCreate(Type);
    $5b4e7aff5e6ce4a3$var$addValidations(Type, validationOptions);
}



class $ae9a6665233e0895$export$2e2bcd8739ae039 {
    static createAndAttachToType(Type) {
        class MessageBuilder extends $ae9a6665233e0895$export$2e2bcd8739ae039 {
            static from(instance) {
                if (!(instance instanceof Type.ctor)) throw new Error(`cannot create ${Type.name}.Builder from object; types do not match`);
                const builder = new MessageBuilder();
                for(const key in Type.fields)if (Object.prototype.hasOwnProperty.call(instance, key)) {
                    const field = Type.fields[key];
                    builder[field.name](instance[field.name]);
                }
                return builder;
            }
        }
        for(const key in Type.fields){
            const field = Type.fields[key];
            MessageBuilder.prototype[field.name] = function(value) {
                this[`_${field.name}`] = value;
                return this;
            };
        }
        MessageBuilder.prototype[0, $5fc7bb4dcf6d49e8$export$3f8fe6489e95757d] = function() {
            const values = {};
            for(const key in Type.fields){
                const field = Type.fields[key];
                values[field.name] = this[`_${field.name}`];
            }
            return Type.create(values);
        };
        MessageBuilder.prototype[0, $5fc7bb4dcf6d49e8$export$5baac73b42fdd539] = function() {
            return this.build()[0, $5fc7bb4dcf6d49e8$export$423e32095c917e40]();
        };
        if (!MessageBuilder.prototype.build) MessageBuilder.prototype.build = MessageBuilder.prototype[0, $5fc7bb4dcf6d49e8$export$3f8fe6489e95757d];
        if (!MessageBuilder.prototype.validateAndBuild) MessageBuilder.prototype.validateAndBuild = MessageBuilder.prototype[0, $5fc7bb4dcf6d49e8$export$5baac73b42fdd539];
        Type.Builder = MessageBuilder; // eslint-disable-line no-param-reassign
        return MessageBuilder;
    }
}


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $63d33be972ac5a3a$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $63d33be972ac5a3a$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "time": {
                        "nested": {
                            "DateTime": {
                                "fields": {
                                    "instantUsec": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "timezoneOffsetMin": {
                                        "type": "sint32",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "posixTz": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "tzName": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "repeated"
                                    },
                                    "ordinal": {
                                        "type": "int64",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "DateTimeInterval": {
                                "fields": {
                                    "inclusiveStart": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "exclusiveEnd": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "YearMonth": {
                                "fields": {
                                    "year": {
                                        "type": "int32",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "monthOfYear": {
                                        "type": "int32",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "YearMonthDay": {
                                "fields": {
                                    "year": {
                                        "type": "int32",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "monthOfYear": {
                                        "type": "int32",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "dayOfMonth": {
                                        "type": "int32",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$63d33be972ac5a3a$var$$root.nested?.squareup?.nested?.common?.nested?.time?.nested?.DateTime && !$63d33be972ac5a3a$var$$root.nested?.squareup?.nested?.common?.nested?.time?.nested?.DateTimeInterval && !$63d33be972ac5a3a$var$$root.nested?.squareup?.nested?.common?.nested?.time?.nested?.YearMonth && !$63d33be972ac5a3a$var$$root.nested?.squareup?.nested?.common?.nested?.time?.nested?.YearMonthDay) $63d33be972ac5a3a$var$$root.addJSON($63d33be972ac5a3a$var$jsonData);
const $63d33be972ac5a3a$export$82f9ebd9adeba146 = $63d33be972ac5a3a$var$$root.lookupType('squareup.common.time.DateTime');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($63d33be972ac5a3a$export$82f9ebd9adeba146);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($63d33be972ac5a3a$export$82f9ebd9adeba146);
const $63d33be972ac5a3a$export$7ed523682b793870 = $63d33be972ac5a3a$var$$root.lookupType('squareup.common.time.DateTimeInterval');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($63d33be972ac5a3a$export$7ed523682b793870, {
    inclusiveStart: {
        required: true
    },
    exclusiveEnd: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($63d33be972ac5a3a$export$7ed523682b793870);
const $63d33be972ac5a3a$export$b707805e12671f51 = $63d33be972ac5a3a$var$$root.lookupType('squareup.common.time.YearMonth');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($63d33be972ac5a3a$export$b707805e12671f51);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($63d33be972ac5a3a$export$b707805e12671f51);
const $63d33be972ac5a3a$export$eedd050964d63dd = $63d33be972ac5a3a$var$$root.lookupType('squareup.common.time.YearMonthDay');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($63d33be972ac5a3a$export$eedd050964d63dd);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($63d33be972ac5a3a$export$eedd050964d63dd);


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $a8741251394c554f$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $a8741251394c554f$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "countries": {
                        "nested": {
                            "Country": {
                                "values": {
                                    "US": 840,
                                    "AD": 20,
                                    "AE": 784,
                                    "AF": 4,
                                    "AG": 28,
                                    "AI": 660,
                                    "AL": 8,
                                    "AM": 51,
                                    "AO": 24,
                                    "AQ": 10,
                                    "AR": 32,
                                    "AS": 16,
                                    "AT": 40,
                                    "AU": 36,
                                    "AW": 533,
                                    "AX": 248,
                                    "AZ": 31,
                                    "BA": 70,
                                    "BB": 52,
                                    "BD": 50,
                                    "BE": 56,
                                    "BF": 854,
                                    "BG": 100,
                                    "BH": 48,
                                    "BI": 108,
                                    "BJ": 204,
                                    "BL": 652,
                                    "BM": 60,
                                    "BN": 96,
                                    "BO": 68,
                                    "BQ": 535,
                                    "BR": 76,
                                    "BS": 44,
                                    "BT": 64,
                                    "BV": 74,
                                    "BW": 72,
                                    "BY": 112,
                                    "BZ": 84,
                                    "CA": 124,
                                    "CC": 166,
                                    "CD": 180,
                                    "CF": 140,
                                    "CG": 178,
                                    "CH": 756,
                                    "CI": 384,
                                    "CK": 184,
                                    "CL": 152,
                                    "CM": 120,
                                    "CN": 156,
                                    "CO": 170,
                                    "CR": 188,
                                    "CU": 192,
                                    "CV": 132,
                                    "CW": 531,
                                    "CX": 162,
                                    "CY": 196,
                                    "CZ": 203,
                                    "DE": 276,
                                    "DJ": 262,
                                    "DK": 208,
                                    "DM": 212,
                                    "DO": 214,
                                    "DZ": 12,
                                    "EC": 218,
                                    "EE": 233,
                                    "EG": 818,
                                    "EH": 732,
                                    "ER": 232,
                                    "ES": 724,
                                    "ET": 231,
                                    "FI": 246,
                                    "FJ": 242,
                                    "FK": 238,
                                    "FM": 583,
                                    "FO": 234,
                                    "FR": 250,
                                    "GA": 266,
                                    "GB": 826,
                                    "GD": 308,
                                    "GE": 268,
                                    "GF": 254,
                                    "GG": 831,
                                    "GH": 288,
                                    "GI": 292,
                                    "GL": 304,
                                    "GM": 270,
                                    "GN": 324,
                                    "GP": 312,
                                    "GQ": 226,
                                    "GR": 300,
                                    "GS": 239,
                                    "GT": 320,
                                    "GU": 316,
                                    "GW": 624,
                                    "GY": 328,
                                    "HK": 344,
                                    "HM": 334,
                                    "HN": 340,
                                    "HR": 191,
                                    "HT": 332,
                                    "HU": 348,
                                    "ID": 360,
                                    "IE": 372,
                                    "IL": 376,
                                    "IM": 833,
                                    "IN": 356,
                                    "IO": 86,
                                    "IQ": 368,
                                    "IR": 364,
                                    "IS": 352,
                                    "IT": 380,
                                    "JE": 832,
                                    "JM": 388,
                                    "JO": 400,
                                    "JP": 392,
                                    "KE": 404,
                                    "KG": 417,
                                    "KH": 116,
                                    "KI": 296,
                                    "KM": 174,
                                    "KN": 659,
                                    "KP": 408,
                                    "KR": 410,
                                    "KW": 414,
                                    "KY": 136,
                                    "KZ": 398,
                                    "LA": 418,
                                    "LB": 422,
                                    "LC": 662,
                                    "LI": 438,
                                    "LK": 144,
                                    "LR": 430,
                                    "LS": 426,
                                    "LT": 440,
                                    "LU": 442,
                                    "LV": 428,
                                    "LY": 434,
                                    "MA": 504,
                                    "MC": 492,
                                    "MD": 498,
                                    "ME": 499,
                                    "MF": 663,
                                    "MG": 450,
                                    "MH": 584,
                                    "MK": 807,
                                    "ML": 466,
                                    "MM": 104,
                                    "MN": 496,
                                    "MO": 446,
                                    "MP": 580,
                                    "MQ": 474,
                                    "MR": 478,
                                    "MS": 500,
                                    "MT": 470,
                                    "MU": 480,
                                    "MV": 462,
                                    "MW": 454,
                                    "MX": 484,
                                    "MY": 458,
                                    "MZ": 508,
                                    "NA": 516,
                                    "NC": 540,
                                    "NE": 562,
                                    "NF": 574,
                                    "NG": 566,
                                    "NI": 558,
                                    "NL": 528,
                                    "NO": 578,
                                    "NP": 524,
                                    "NR": 520,
                                    "NU": 570,
                                    "NZ": 554,
                                    "OM": 512,
                                    "PA": 591,
                                    "PE": 604,
                                    "PF": 258,
                                    "PG": 598,
                                    "PH": 608,
                                    "PK": 586,
                                    "PL": 616,
                                    "PM": 666,
                                    "PN": 612,
                                    "PR": 630,
                                    "PS": 275,
                                    "PT": 620,
                                    "PW": 585,
                                    "PY": 600,
                                    "QA": 634,
                                    "RE": 638,
                                    "RO": 642,
                                    "RS": 688,
                                    "RU": 643,
                                    "RW": 646,
                                    "SA": 682,
                                    "SB": 90,
                                    "SC": 690,
                                    "SD": 729,
                                    "SE": 752,
                                    "SG": 702,
                                    "SH": 654,
                                    "SI": 705,
                                    "SJ": 744,
                                    "SK": 703,
                                    "SL": 694,
                                    "SM": 674,
                                    "SN": 686,
                                    "SO": 706,
                                    "SR": 740,
                                    "SS": 728,
                                    "ST": 678,
                                    "SV": 222,
                                    "SX": 534,
                                    "SY": 760,
                                    "SZ": 748,
                                    "TC": 796,
                                    "TD": 148,
                                    "TF": 260,
                                    "TG": 768,
                                    "TH": 764,
                                    "TJ": 762,
                                    "TK": 772,
                                    "TL": 626,
                                    "TM": 795,
                                    "TN": 788,
                                    "TO": 776,
                                    "TR": 792,
                                    "TT": 780,
                                    "TV": 798,
                                    "TW": 158,
                                    "TZ": 834,
                                    "UA": 804,
                                    "UG": 800,
                                    "UM": 581,
                                    "UY": 858,
                                    "UZ": 860,
                                    "VA": 336,
                                    "VC": 670,
                                    "VE": 862,
                                    "VG": 92,
                                    "VI": 850,
                                    "VN": 704,
                                    "VU": 548,
                                    "WF": 876,
                                    "WS": 882,
                                    "XT": 963,
                                    "YE": 887,
                                    "YT": 175,
                                    "ZA": 710,
                                    "ZM": 894,
                                    "ZW": 716,
                                    "ZZ": 999
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$a8741251394c554f$var$$root.nested?.squareup?.nested?.common?.nested?.countries?.nested?.Country) $a8741251394c554f$var$$root.addJSON($a8741251394c554f$var$jsonData);
const $a8741251394c554f$export$5552a8f08b2b9f9e = $a8741251394c554f$var$$root.lookupEnum('squareup.common.countries.Country').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $fed2a7c6f34400dc$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $fed2a7c6f34400dc$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "script": {
                        "nested": {
                            "Script": {
                                "values": {
                                    "Zyyy": 998,
                                    "Hani": 500,
                                    "Hira": 410,
                                    "Jpan": 413,
                                    "Kana": 411,
                                    "Latn": 215
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$fed2a7c6f34400dc$var$$root.nested?.squareup?.nested?.common?.nested?.script?.nested?.Script) $fed2a7c6f34400dc$var$$root.addJSON($fed2a7c6f34400dc$var$jsonData);
const $fed2a7c6f34400dc$export$2f8b47a141e57afc = $fed2a7c6f34400dc$var$$root.lookupEnum('squareup.common.script.Script').values;


const $04e03da92c8def10$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $04e03da92c8def10$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "location": {
                        "nested": {
                            "Coordinates": {
                                "fields": {
                                    "latitude": {
                                        "type": "double",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "longitude": {
                                        "type": "double",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "altitude": {
                                        "type": "double",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "geographicAccuracy": {
                                        "type": "double",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "altitudinalAccuracy": {
                                        "type": "double",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "heading": {
                                        "type": "double",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "speed": {
                                        "type": "double",
                                        "id": 7,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GlobalAddress": {
                                "fields": {
                                    "addressLine1": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "addressLine2": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "addressLine3": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "locality": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "sublocality": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "administrativeDistrictLevel1": {
                                        "type": "string",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "postalCode": {
                                        "type": "string",
                                        "id": 16,
                                        "rule": "optional"
                                    },
                                    "countryCode": {
                                        "type": ".squareup.common.countries.Country",
                                        "id": 17,
                                        "rule": "optional"
                                    },
                                    "script": {
                                        "type": ".squareup.common.script.Script",
                                        "id": 20,
                                        "rule": "optional"
                                    },
                                    "alternateFormats": {
                                        "type": ".squareup.common.location.GlobalAddress.AlternateFormats",
                                        "id": 21,
                                        "rule": "optional"
                                    },
                                    "addressLine4": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "addressLine5": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "sublocality1": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "sublocality2": {
                                        "type": "string",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "sublocality3": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "sublocality4": {
                                        "type": "string",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "sublocality5": {
                                        "type": "string",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "administrativeDistrictLevel2": {
                                        "type": "string",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "administrativeDistrictLevel3": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "addressCoordinates": {
                                        "type": ".squareup.common.location.Coordinates",
                                        "id": 18,
                                        "rule": "optional"
                                    },
                                    "neighborhood": {
                                        "type": "string",
                                        "id": 19,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "AlternateFormats": {
                                        "fields": {
                                            "countrySubdivisionCode": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$04e03da92c8def10$var$$root.nested?.squareup?.nested?.common?.nested?.location?.nested?.Coordinates && !$04e03da92c8def10$var$$root.nested?.squareup?.nested?.common?.nested?.location?.nested?.GlobalAddress && !$04e03da92c8def10$var$$root.nested?.squareup?.nested?.common?.nested?.location?.nested?.GlobalAddress?.nested?.AlternateFormats) $04e03da92c8def10$var$$root.addJSON($04e03da92c8def10$var$jsonData);
const $04e03da92c8def10$export$d6e0f5996cc55599 = $04e03da92c8def10$var$$root.lookupType('squareup.common.location.Coordinates');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($04e03da92c8def10$export$d6e0f5996cc55599, {
    latitude: {
        required: true
    },
    longitude: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($04e03da92c8def10$export$d6e0f5996cc55599);
const $04e03da92c8def10$export$1d6b20d87bad724b = $04e03da92c8def10$var$$root.lookupType('squareup.common.location.GlobalAddress');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($04e03da92c8def10$export$1d6b20d87bad724b);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($04e03da92c8def10$export$1d6b20d87bad724b);
/**
 * SOURCE AlternateFormats @ squareup/common/location.proto at 121:3
 */ $04e03da92c8def10$export$1d6b20d87bad724b.AlternateFormats = $04e03da92c8def10$var$$root.lookupType('squareup.common.location.GlobalAddress.AlternateFormats');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($04e03da92c8def10$export$1d6b20d87bad724b.AlternateFormats);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($04e03da92c8def10$export$1d6b20d87bad724b.AlternateFormats);


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 




const $716cdaea1b5a62df$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $716cdaea1b5a62df$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "CardType": {
                                        "values": {
                                            "CARD_TYPE_DO_NOT_USE": 0,
                                            "PHYSICAL": 1,
                                            "VIRTUAL": 2,
                                            "PAIR": 3
                                        }
                                    },
                                    "CardStatus": {
                                        "values": {
                                            "CARD_STATUS_DO_NOT_USE": 0,
                                            "ORDERED": 1,
                                            "ISSUED": 2,
                                            "ISSUED_ACTIVATABLE": 3,
                                            "ACTIVE": 4,
                                            "DISABLED": 5,
                                            "SUSPENDED": 6,
                                            "TERMINATED": 7
                                        }
                                    },
                                    "CardFulfillment": {
                                        "fields": {
                                            "shipping": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Shipping",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "customization": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "Shipping": {
                                                "fields": {
                                                    "address": {
                                                        "type": ".squareup.common.location.GlobalAddress",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "status": {
                                                        "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Shipping.ShippingStatus",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    }
                                                },
                                                "nested": {
                                                    "ShippingStatus": {
                                                        "values": {
                                                            "SHIPPING_STATUS_DO_NOT_USE": 0,
                                                            "PROCESSING": 1,
                                                            "SHIPPED": 2,
                                                            "DELIVERED": 3,
                                                            "FAILURE": 4,
                                                            "CANCELED": 5
                                                        }
                                                    }
                                                }
                                            },
                                            "Customization": {
                                                "fields": {
                                                    "signature": {
                                                        "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.Signature",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "cardText": {
                                                        "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.CardText",
                                                        "id": 2,
                                                        "rule": "repeated"
                                                    }
                                                },
                                                "nested": {
                                                    "CardText": {
                                                        "fields": {
                                                            "text": {
                                                                "type": "string",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "type": {
                                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.CardText.Type",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            }
                                                        },
                                                        "nested": {
                                                            "Type": {
                                                                "values": {
                                                                    "CARD_TEXT_DO_NOT_USE": 0,
                                                                    "BUSINESS_NAME": 1,
                                                                    "CARD_HOLDER": 2
                                                                }
                                                            }
                                                        }
                                                    },
                                                    "Signature": {
                                                        "fields": {
                                                            "imageBytes": {
                                                                "type": "bytes",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "mimeType": {
                                                                "type": "string",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "Card": {
                                        "fields": {
                                            "id": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "status": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardStatus",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "type": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardType",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "fulfillment": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CardFulfillment",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "cardPairId": {
                                                "type": "string",
                                                "id": 6,
                                                "rule": "optional"
                                            },
                                            "panSuffix": {
                                                "type": "string",
                                                "id": 7,
                                                "rule": "optional"
                                            },
                                            "fullPan": {
                                                "type": "string",
                                                "id": 8,
                                                "rule": "optional"
                                            },
                                            "securityCode": {
                                                "type": "string",
                                                "id": 9,
                                                "rule": "optional"
                                            },
                                            "expiration": {
                                                "type": ".squareup.common.time.YearMonth",
                                                "id": 10,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardType && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardStatus && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Shipping && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Shipping?.nested?.ShippingStatus && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Customization && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Customization?.nested?.CardText && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Customization?.nested?.CardText?.nested?.Type && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CardFulfillment?.nested?.Customization?.nested?.Signature && !$716cdaea1b5a62df$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.Card) $716cdaea1b5a62df$var$$root.addJSON($716cdaea1b5a62df$var$jsonData);
const $716cdaea1b5a62df$export$f1a79bffad3377cd = $716cdaea1b5a62df$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.CardType').values;
const $716cdaea1b5a62df$export$490c7ce941281ba8 = $716cdaea1b5a62df$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.CardStatus').values;
const $716cdaea1b5a62df$export$b2a48b6a70d75edb = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CardFulfillment');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$b2a48b6a70d75edb);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$b2a48b6a70d75edb);
/**
 * SOURCE Shipping @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 62:3
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Shipping = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Shipping');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$b2a48b6a70d75edb.Shipping);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$b2a48b6a70d75edb.Shipping);
/**
 * SOURCE ShippingStatus @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 63:5
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Shipping.ShippingStatus = $716cdaea1b5a62df$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Shipping.ShippingStatus').values;
/**
 * SOURCE Customization @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 75:3
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization);
/**
 * SOURCE CardText @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 79:5
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.CardText = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.CardText');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.CardText);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.CardText);
/**
 * SOURCE Type @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 83:7
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.CardText.Type = $716cdaea1b5a62df$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.CardText.Type').values;
/**
 * SOURCE Signature @ squareup/bbfrontend/bankingweb/v1/card_model.proto at 90:5
 */ $716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.Signature = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CardFulfillment.Customization.Signature');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.Signature);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$b2a48b6a70d75edb.Customization.Signature);
const $716cdaea1b5a62df$export$60332b2344f7fe41 = $716cdaea1b5a62df$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.Card');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($716cdaea1b5a62df$export$60332b2344f7fe41);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($716cdaea1b5a62df$export$60332b2344f7fe41);


const $bc006730c79954a6$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $bc006730c79954a6$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "ActivateCardRequest": {
                                        "fields": {
                                            "cardToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "activation": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.ActivateCardRequest.ExpirationAndCVC",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "ExpirationAndCVC": {
                                                "fields": {
                                                    "expiration": {
                                                        "type": ".squareup.common.time.YearMonth",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "cvc": {
                                                        "type": "string",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "ActivateCardResponse": {
                                        "fields": {
                                            "error": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.ActivateCardResponse.ActivateCardError",
                                                "id": 1,
                                                "rule": "repeated"
                                            }
                                        },
                                        "nested": {
                                            "ActivateCardError": {
                                                "values": {
                                                    "ACTIVATE_CARD_ERROR_UNKNOWN": 0,
                                                    "ACTIVATE_CARD_ERROR_INVALID_EXPIRATION_CVC": 1,
                                                    "ACTIVATE_CARD_ERROR_UNAUTHORIZED": 2
                                                }
                                            }
                                        }
                                    },
                                    "CreateCardRequest": {
                                        "fields": {
                                            "idempotencyKey": {
                                                "type": "string",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "cardInvitationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "cardCustomizationToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "shippingAddress": {
                                                "type": ".squareup.common.location.GlobalAddress",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "CreateCardResponse": {
                                        "fields": {
                                            "cardToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "error": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.CreateCardResponse.IssueCardError",
                                                "id": 2,
                                                "rule": "repeated"
                                            }
                                        },
                                        "nested": {
                                            "IssueCardError": {
                                                "values": {
                                                    "ISSUE_CARD_ERROR_UNKNOWN": 0,
                                                    "ISSUE_CARD_ERROR_UNAUTHORIZED": 1,
                                                    "ISSUE_CARD_ERROR_OBLIGATION_REQUIRES_COMPLIANCE_VERIFICATION": 2
                                                }
                                            }
                                        }
                                    },
                                    "CreateCardCustomizationRequest": {
                                        "fields": {
                                            "idempotencyKey": {
                                                "type": "string",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "cardInvitationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "imageBytes": {
                                                "type": "bytes",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "mimeType": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "CreateCardCustomizationResponse": {
                                        "fields": {
                                            "cardCustomizationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "ListCardsRequest": {
                                        "fields": {}
                                    },
                                    "ListCardsResponse": {
                                        "fields": {
                                            "cards": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Card",
                                                "id": 1,
                                                "rule": "repeated"
                                            }
                                        }
                                    },
                                    "RetrieveCardRequest": {
                                        "fields": {
                                            "cardId": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "RetrieveCardResponse": {
                                        "fields": {
                                            "card": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Card",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "BankingWebCardService": {
                                        "methods": {
                                            "ActivateCard": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.ActivateCardRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.ActivateCardResponse"
                                            },
                                            "CreateCard": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.CreateCardRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.CreateCardResponse"
                                            },
                                            "CreateCardCustomization": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.CreateCardCustomizationRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.CreateCardCustomizationResponse"
                                            },
                                            "ListCards": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.ListCardsRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.ListCardsResponse"
                                            },
                                            "RetrieveCard": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.RetrieveCardRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.RetrieveCardResponse"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ActivateCardRequest && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ActivateCardRequest?.nested?.ExpirationAndCVC && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ActivateCardResponse && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ActivateCardResponse?.nested?.ActivateCardError && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CreateCardRequest && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CreateCardResponse && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CreateCardResponse?.nested?.IssueCardError && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CreateCardCustomizationRequest && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.CreateCardCustomizationResponse && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ListCardsRequest && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ListCardsResponse && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.RetrieveCardRequest && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.RetrieveCardResponse && !$bc006730c79954a6$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.BankingWebCardService) $bc006730c79954a6$var$$root.addJSON($bc006730c79954a6$var$jsonData);
const $bc006730c79954a6$export$7e4385b3b341704b = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ActivateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$7e4385b3b341704b);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$7e4385b3b341704b);
/**
 * SOURCE ExpirationAndCVC @ squareup/bbfrontend/bankingweb/v1/card_service.proto at 47:3
 */ $bc006730c79954a6$export$7e4385b3b341704b.ExpirationAndCVC = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ActivateCardRequest.ExpirationAndCVC');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$7e4385b3b341704b.ExpirationAndCVC);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$7e4385b3b341704b.ExpirationAndCVC);
const $bc006730c79954a6$export$7dde42e884f2d048 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ActivateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$7dde42e884f2d048);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$7dde42e884f2d048);
/**
 * SOURCE ActivateCardError @ squareup/bbfrontend/bankingweb/v1/card_service.proto at 56:3
 */ $bc006730c79954a6$export$7dde42e884f2d048.ActivateCardError = $bc006730c79954a6$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.ActivateCardResponse.ActivateCardError').values;
const $bc006730c79954a6$export$531aee450bc3dbd4 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CreateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$531aee450bc3dbd4, {
    idempotencyKey: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$531aee450bc3dbd4);
const $bc006730c79954a6$export$77c2e9a08149a1ad = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CreateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$77c2e9a08149a1ad);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$77c2e9a08149a1ad);
/**
 * SOURCE IssueCardError @ squareup/bbfrontend/bankingweb/v1/card_service.proto at 77:3
 */ $bc006730c79954a6$export$77c2e9a08149a1ad.IssueCardError = $bc006730c79954a6$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.CreateCardResponse.IssueCardError').values;
const $bc006730c79954a6$export$aed3bec368de6e1f = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CreateCardCustomizationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$aed3bec368de6e1f, {
    idempotencyKey: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$aed3bec368de6e1f);
const $bc006730c79954a6$export$ed2908e9380ce647 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.CreateCardCustomizationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$ed2908e9380ce647);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$ed2908e9380ce647);
const $bc006730c79954a6$export$1f9ff0d796a08011 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ListCardsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$1f9ff0d796a08011);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$1f9ff0d796a08011);
const $bc006730c79954a6$export$8a92910321c6ac49 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ListCardsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$8a92910321c6ac49);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$8a92910321c6ac49);
const $bc006730c79954a6$export$8f1da4e33ad24fb3 = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.RetrieveCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$8f1da4e33ad24fb3, {
    cardId: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$8f1da4e33ad24fb3);
const $bc006730c79954a6$export$763e5b98f5f24d5f = $bc006730c79954a6$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.RetrieveCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bc006730c79954a6$export$763e5b98f5f24d5f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bc006730c79954a6$export$763e5b98f5f24d5f);
const $bc006730c79954a6$export$3fcca2f60820bf28 = $bc006730c79954a6$var$$root.lookupService('squareup.bbfrontend.bankingweb.v1.BankingWebCardService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $e12f7d4943895009$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $e12f7d4943895009$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "OpenCardInvitation": {
                                        "fields": {
                                            "cardInvitationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "name": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "balanceId": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$e12f7d4943895009$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.OpenCardInvitation) $e12f7d4943895009$var$$root.addJSON($e12f7d4943895009$var$jsonData);
const $e12f7d4943895009$export$fab0e103913ff3a8 = $e12f7d4943895009$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.OpenCardInvitation');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e12f7d4943895009$export$fab0e103913ff3a8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e12f7d4943895009$export$fab0e103913ff3a8);


const $2a6a68ea1459b895$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $2a6a68ea1459b895$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "ListOpenCardInvitationsRequest": {
                                        "fields": {}
                                    },
                                    "ListOpenCardInvitationsResponse": {
                                        "fields": {
                                            "openCardInvitations": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.OpenCardInvitation",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "error": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsResponse.ListOpenCardInvitationsError",
                                                "id": 2,
                                                "rule": "repeated"
                                            }
                                        },
                                        "nested": {
                                            "ListOpenCardInvitationsError": {
                                                "values": {
                                                    "LIST_OPEN_CARD_INVITATIONS_ERROR_UNKNOWN": 0,
                                                    "LIST_OPEN_CARD_INVITATIONS_ERROR_UNAUTHORIZED": 1
                                                }
                                            }
                                        }
                                    },
                                    "BankingWebService": {
                                        "methods": {
                                            "ListOpenCardInvitations": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsResponse"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$2a6a68ea1459b895$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ListOpenCardInvitationsRequest && !$2a6a68ea1459b895$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ListOpenCardInvitationsResponse && !$2a6a68ea1459b895$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.ListOpenCardInvitationsResponse?.nested?.ListOpenCardInvitationsError && !$2a6a68ea1459b895$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.BankingWebService) $2a6a68ea1459b895$var$$root.addJSON($2a6a68ea1459b895$var$jsonData);
const $2a6a68ea1459b895$export$498c8f0ad968f111 = $2a6a68ea1459b895$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($2a6a68ea1459b895$export$498c8f0ad968f111);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($2a6a68ea1459b895$export$498c8f0ad968f111);
const $2a6a68ea1459b895$export$9ba45d39ce6d3f6e = $2a6a68ea1459b895$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($2a6a68ea1459b895$export$9ba45d39ce6d3f6e);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($2a6a68ea1459b895$export$9ba45d39ce6d3f6e);
/**
 * SOURCE ListOpenCardInvitationsError @ squareup/bbfrontend/bankingweb/v1/service.proto at 26:3
 */ $2a6a68ea1459b895$export$9ba45d39ce6d3f6e.ListOpenCardInvitationsError = $2a6a68ea1459b895$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.ListOpenCardInvitationsResponse.ListOpenCardInvitationsError').values;
const $2a6a68ea1459b895$export$65bc5f5b6b3789b3 = $2a6a68ea1459b895$var$$root.lookupService('squareup.bbfrontend.bankingweb.v1.BankingWebService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $3f95b099726a1553$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $3f95b099726a1553$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "Profile": {
                                        "fields": {
                                            "personToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "name": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Profile.Name",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "Name": {
                                                "fields": {
                                                    "firstName": {
                                                        "type": "string",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "lastName": {
                                                        "type": "string",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "GetPersonProfileRequest": {
                                        "fields": {}
                                    },
                                    "GetPersonProfileResponse": {
                                        "fields": {
                                            "personToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "profile": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Profile",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "UpdatePersonProfileRequest": {
                                        "fields": {
                                            "idempotenceKey": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "profile": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Profile",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "UpdatePersonProfileResponse": {
                                        "fields": {
                                            "profile": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.Profile",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "PersonProfileService": {
                                        "methods": {
                                            "GetPersonProfile": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.GetPersonProfileRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.GetPersonProfileResponse"
                                            },
                                            "UpdatePersonProfile": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.UpdatePersonProfileRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.UpdatePersonProfileResponse"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.Profile && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.Profile?.nested?.Name && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.GetPersonProfileRequest && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.GetPersonProfileResponse && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.UpdatePersonProfileRequest && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.UpdatePersonProfileResponse && !$3f95b099726a1553$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.PersonProfileService) $3f95b099726a1553$var$$root.addJSON($3f95b099726a1553$var$jsonData);
const $3f95b099726a1553$export$5120f2d0b8d4cab8 = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.Profile');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$5120f2d0b8d4cab8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$5120f2d0b8d4cab8);
/**
 * SOURCE Name @ squareup/bbfrontend/bankingweb/v1/person_profile_service.proto at 16:3
 */ $3f95b099726a1553$export$5120f2d0b8d4cab8.Name = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.Profile.Name');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$5120f2d0b8d4cab8.Name);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$5120f2d0b8d4cab8.Name);
const $3f95b099726a1553$export$2ad677b174787c25 = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.GetPersonProfileRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$2ad677b174787c25);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$2ad677b174787c25);
const $3f95b099726a1553$export$9ee66f3a232e9cb2 = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.GetPersonProfileResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$9ee66f3a232e9cb2);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$9ee66f3a232e9cb2);
const $3f95b099726a1553$export$2d30a2bab0b6db0 = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.UpdatePersonProfileRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$2d30a2bab0b6db0);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$2d30a2bab0b6db0);
const $3f95b099726a1553$export$3b61cfb87cf1bb3b = $3f95b099726a1553$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.UpdatePersonProfileResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f95b099726a1553$export$3b61cfb87cf1bb3b);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f95b099726a1553$export$3b61cfb87cf1bb3b);
const $3f95b099726a1553$export$f0d0e3d2fc028c = $3f95b099726a1553$var$$root.lookupService('squareup.bbfrontend.bankingweb.v1.PersonProfileService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 




/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $e77187f11e04d37d$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $e77187f11e04d37d$var$jsonData = {
    "squareup": {
        "nested": {
            "address": {
                "nested": {
                    "country_data": {
                        "nested": {
                            "CountryAddressData": {
                                "fields": {
                                    "name": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "format": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "requiredFields": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "upperCaseFields": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "createMethod": {
                                        "type": ".squareup.address.country_data.CountryAddressData.InputMethod",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "editMethod": {
                                        "type": ".squareup.address.country_data.CountryAddressData.InputMethod",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "admin1Label": {
                                        "type": ".squareup.address.country_data.CountryAddressData.Admin1Scope.Admin1Label",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "localityLabel": {
                                        "type": ".squareup.address.country_data.CountryAddressData.LocalityScope.LocalityLabel",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "sublocalityLabel": {
                                        "type": ".squareup.address.country_data.CountryAddressData.SublocalityScope.SublocalityLabel",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "postalCodeLabel": {
                                        "type": ".squareup.address.country_data.CountryAddressData.PostalCodeScope.PostalCodeLabel",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "defaultLinecount": {
                                        "type": "int32",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "examplePostalCodes": {
                                        "type": "string",
                                        "id": 12,
                                        "rule": "repeated"
                                    },
                                    "admin1Values": {
                                        "type": ".squareup.address.country_data.CountryAddressData.NameNode",
                                        "id": 13,
                                        "rule": "repeated"
                                    },
                                    "sortingCodeLabel": {
                                        "type": ".squareup.address.country_data.CountryAddressData.SortingCodeScope.SortingCodeLabel",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "countryCode": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "locale": {
                                        "type": "string",
                                        "id": 16,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "NameNode": {
                                        "fields": {
                                            "code": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "name": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "value": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "InputMethod": {
                                        "values": {
                                            "FORM": 0,
                                            "INVERTED_DROPDOWNS": 1,
                                            "CORRECT_AS_YOU_TYPE": 2
                                        }
                                    },
                                    "Admin1Scope": {
                                        "nested": {
                                            "Admin1Label": {
                                                "values": {
                                                    "PROVINCE": 0,
                                                    "AREA": 1,
                                                    "DEPARTMENT": 2,
                                                    "DISTRICT": 3,
                                                    "DO_SI": 4,
                                                    "EMIRATE": 5,
                                                    "ISLAND": 6,
                                                    "OBLAST": 7,
                                                    "PARISH": 8,
                                                    "PREFECTURE": 9,
                                                    "STATE": 10,
                                                    "COUNTY": 11
                                                }
                                            }
                                        }
                                    },
                                    "LocalityScope": {
                                        "nested": {
                                            "LocalityLabel": {
                                                "values": {
                                                    "CITY": 0,
                                                    "DISTRICT": 1,
                                                    "POST_TOWN": 2,
                                                    "SUBURB": 3,
                                                    "TOWN_CITY": 4
                                                }
                                            }
                                        }
                                    },
                                    "SublocalityScope": {
                                        "nested": {
                                            "SublocalityLabel": {
                                                "values": {
                                                    "SUBURB": 0,
                                                    "DISTRICT": 1,
                                                    "NEIGHBORHOOD": 2,
                                                    "TOWNLAND": 3,
                                                    "VILLAGE_TOWNSHIP": 4,
                                                    "TOWN": 5
                                                }
                                            }
                                        }
                                    },
                                    "PostalCodeScope": {
                                        "nested": {
                                            "PostalCodeLabel": {
                                                "values": {
                                                    "POSTAL": 0,
                                                    "EIRCODE": 1,
                                                    "PIN": 2,
                                                    "ZIP": 3
                                                }
                                            }
                                        }
                                    },
                                    "SortingCodeScope": {
                                        "nested": {
                                            "SortingCodeLabel": {
                                                "values": {
                                                    "CEDEX": 0
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.NameNode && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.InputMethod && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.Admin1Scope?.nested?.Admin1Label && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.LocalityScope?.nested?.LocalityLabel && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.SublocalityScope?.nested?.SublocalityLabel && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.PostalCodeScope?.nested?.PostalCodeLabel && !$e77187f11e04d37d$var$$root.nested?.squareup?.nested?.address?.nested?.country_data?.nested?.CountryAddressData?.nested?.SortingCodeScope?.nested?.SortingCodeLabel) $e77187f11e04d37d$var$$root.addJSON($e77187f11e04d37d$var$jsonData);
const $e77187f11e04d37d$export$a4125e32180777a7 = $e77187f11e04d37d$var$$root.lookupType('squareup.address.country_data.CountryAddressData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e77187f11e04d37d$export$a4125e32180777a7);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e77187f11e04d37d$export$a4125e32180777a7);
/**
 * SOURCE NameNode @ squareup/address/country_data.proto at 81:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.NameNode = $e77187f11e04d37d$var$$root.lookupType('squareup.address.country_data.CountryAddressData.NameNode');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e77187f11e04d37d$export$a4125e32180777a7.NameNode);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e77187f11e04d37d$export$a4125e32180777a7.NameNode);
/**
 * SOURCE InputMethod @ squareup/address/country_data.proto at 92:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.InputMethod = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.InputMethod').values;
/**
 * SOURCE Admin1Scope @ squareup/address/country_data.proto at 103:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.Admin1Scope = {};
/**
 * SOURCE Admin1Label @ squareup/address/country_data.proto at 104:5
 */ $e77187f11e04d37d$export$a4125e32180777a7.Admin1Scope.Admin1Label = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.Admin1Scope.Admin1Label').values;
/**
 * SOURCE LocalityScope @ squareup/address/country_data.proto at 122:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.LocalityScope = {};
/**
 * SOURCE LocalityLabel @ squareup/address/country_data.proto at 123:5
 */ $e77187f11e04d37d$export$a4125e32180777a7.LocalityScope.LocalityLabel = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.LocalityScope.LocalityLabel').values;
/**
 * SOURCE SublocalityScope @ squareup/address/country_data.proto at 132:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.SublocalityScope = {};
/**
 * SOURCE SublocalityLabel @ squareup/address/country_data.proto at 133:5
 */ $e77187f11e04d37d$export$a4125e32180777a7.SublocalityScope.SublocalityLabel = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.SublocalityScope.SublocalityLabel').values;
/**
 * SOURCE PostalCodeScope @ squareup/address/country_data.proto at 145:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.PostalCodeScope = {};
/**
 * SOURCE PostalCodeLabel @ squareup/address/country_data.proto at 146:5
 */ $e77187f11e04d37d$export$a4125e32180777a7.PostalCodeScope.PostalCodeLabel = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.PostalCodeScope.PostalCodeLabel').values;
/**
 * SOURCE SortingCodeScope @ squareup/address/country_data.proto at 156:3
 */ $e77187f11e04d37d$export$a4125e32180777a7.SortingCodeScope = {};
/**
 * SOURCE SortingCodeLabel @ squareup/address/country_data.proto at 157:5
 */ $e77187f11e04d37d$export$a4125e32180777a7.SortingCodeScope.SortingCodeLabel = $e77187f11e04d37d$var$$root.lookupEnum('squareup.address.country_data.CountryAddressData.SortingCodeScope.SortingCodeLabel').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



const $12e327d46afe7e5e$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $12e327d46afe7e5e$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "service": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "GetBillPayDataRequest": {
                                        "fields": {
                                            "authorizationCode": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "unitToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "GetBillPayDataResponse": {
                                        "fields": {
                                            "value": {
                                                "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData",
                                                "id": 1
                                            },
                                            "error": {
                                                "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.Error",
                                                "id": 2
                                            }
                                        },
                                        "nested": {
                                            "BillPayData": {
                                                "fields": {
                                                    "card": {
                                                        "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateCardData",
                                                        "id": 1,
                                                        "rule": "repeated"
                                                    },
                                                    "directDepositAccount": {
                                                        "type": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateDirectDepositAccountData",
                                                        "id": 2,
                                                        "rule": "repeated"
                                                    }
                                                },
                                                "nested": {
                                                    "PrivateCardData": {
                                                        "fields": {
                                                            "fullPan": {
                                                                "type": "string",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "cvc": {
                                                                "type": "string",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            },
                                                            "expiration": {
                                                                "type": ".squareup.common.time.YearMonth",
                                                                "id": 3,
                                                                "rule": "optional"
                                                            },
                                                            "nameOnCard": {
                                                                "type": "string",
                                                                "id": 4,
                                                                "rule": "optional"
                                                            }
                                                        }
                                                    },
                                                    "PrivateDirectDepositAccountData": {
                                                        "fields": {
                                                            "routingNumber": {
                                                                "type": "string",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "accountNumber": {
                                                                "type": "string",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "Error": {
                                                "values": {
                                                    "UNKNOWN": 0,
                                                    "UNAUTHORIZED": 1,
                                                    "AUTHORIZATION_FAILURE": 2
                                                }
                                            },
                                            "result": {
                                                "oneof": [
                                                    "value",
                                                    "error"
                                                ]
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataRequest && !$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse && !$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.BillPayData && !$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.BillPayData?.nested?.PrivateCardData && !$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.BillPayData?.nested?.PrivateDirectDepositAccountData && !$12e327d46afe7e5e$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetBillPayDataResponse?.nested?.Error) $12e327d46afe7e5e$var$$root.addJSON($12e327d46afe7e5e$var$jsonData);
const $12e327d46afe7e5e$export$65e14e19649f8e85 = $12e327d46afe7e5e$var$$root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($12e327d46afe7e5e$export$65e14e19649f8e85, {
    unitToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($12e327d46afe7e5e$export$65e14e19649f8e85);
const $12e327d46afe7e5e$export$3be84277be75e6b7 = $12e327d46afe7e5e$var$$root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($12e327d46afe7e5e$export$3be84277be75e6b7);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($12e327d46afe7e5e$export$3be84277be75e6b7);
/**
 * SOURCE BillPayData @ squareup/bbfrontend/v1/bill_pay.proto at 31:3
 */ $12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData = $12e327d46afe7e5e$var$$root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData);
/**
 * duplicated from squareup.bizbank.card_management.PrivateCardData
 *
 * SOURCE PrivateCardData @ squareup/bbfrontend/v1/bill_pay.proto at 36:5
 */ $12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateCardData = $12e327d46afe7e5e$var$$root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateCardData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateCardData);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateCardData);
/**
 * SOURCE PrivateDirectDepositAccountData @ squareup/bbfrontend/v1/bill_pay.proto at 43:5
 */ $12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateDirectDepositAccountData = $12e327d46afe7e5e$var$$root.lookupType('squareup.bbfrontend.service.v1.GetBillPayDataResponse.BillPayData.PrivateDirectDepositAccountData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateDirectDepositAccountData);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($12e327d46afe7e5e$export$3be84277be75e6b7.BillPayData.PrivateDirectDepositAccountData);
/**
 * SOURCE Error @ squareup/bbfrontend/v1/bill_pay.proto at 49:3
 */ $12e327d46afe7e5e$export$3be84277be75e6b7.Error = $12e327d46afe7e5e$var$$root.lookupEnum('squareup.bbfrontend.service.v1.GetBillPayDataResponse.Error').values;


const $fce501362cc81cfc$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $fce501362cc81cfc$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "service": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "BootstrapRequest": {
                                        "fields": {}
                                    },
                                    "BootstrapResponse": {
                                        "fields": {
                                            "authenticated": {
                                                "type": ".squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated",
                                                "id": 1
                                            },
                                            "unauthenticated": {
                                                "type": ".squareup.bbfrontend.service.v1.BootstrapResponse.Unauthenticated",
                                                "id": 2
                                            }
                                        },
                                        "nested": {
                                            "Authenticated": {
                                                "fields": {
                                                    "personProfile": {
                                                        "type": ".squareup.bbfrontend.bankingweb.v1.Profile",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "status": {
                                                        "type": ".squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Status",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    },
                                                    "authorized": {
                                                        "type": ".squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Authorized",
                                                        "id": 3
                                                    },
                                                    "unauthorized": {
                                                        "type": ".squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Unauthorized",
                                                        "id": 4
                                                    }
                                                },
                                                "nested": {
                                                    "Status": {
                                                        "values": {
                                                            "NEW_USER": 1,
                                                            "EXISTING_USER": 2
                                                        }
                                                    },
                                                    "Authorized": {
                                                        "fields": {}
                                                    },
                                                    "Unauthorized": {
                                                        "fields": {}
                                                    },
                                                    "authorization": {
                                                        "oneof": [
                                                            "authorized",
                                                            "unauthorized"
                                                        ]
                                                    }
                                                }
                                            },
                                            "Unauthenticated": {
                                                "fields": {}
                                            },
                                            "bootstrap": {
                                                "oneof": [
                                                    "authenticated",
                                                    "unauthenticated"
                                                ]
                                            }
                                        }
                                    },
                                    "GetCountryAddressDataRequest": {
                                        "fields": {
                                            "countryCode": {
                                                "type": ".squareup.common.countries.Country",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "GetCountryAddressDataResponse": {
                                        "fields": {
                                            "countryAddressData": {
                                                "type": ".squareup.address.country_data.CountryAddressData",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "WebService": {
                                        "methods": {
                                            "GetBillPayData": {
                                                "requestType": ".squareup.bbfrontend.service.v1.GetBillPayDataRequest",
                                                "responseType": ".squareup.bbfrontend.service.v1.GetBillPayDataResponse"
                                            },
                                            "GetBootstrap": {
                                                "requestType": ".squareup.bbfrontend.service.v1.BootstrapRequest",
                                                "responseType": ".squareup.bbfrontend.service.v1.BootstrapResponse"
                                            },
                                            "GetCountryAddressData": {
                                                "requestType": ".squareup.bbfrontend.service.v1.GetCountryAddressDataRequest",
                                                "responseType": ".squareup.bbfrontend.service.v1.GetCountryAddressDataResponse"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapRequest && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse?.nested?.Authenticated && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse?.nested?.Authenticated?.nested?.Status && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse?.nested?.Authenticated?.nested?.Authorized && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse?.nested?.Authenticated?.nested?.Unauthorized && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BootstrapResponse?.nested?.Unauthenticated && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetCountryAddressDataRequest && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.GetCountryAddressDataResponse && !$fce501362cc81cfc$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.WebService) $fce501362cc81cfc$var$$root.addJSON($fce501362cc81cfc$var$jsonData);
const $fce501362cc81cfc$export$fed1fc70f4110737 = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$fed1fc70f4110737);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$fed1fc70f4110737);
const $fce501362cc81cfc$export$21aaaaa317a5d23f = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$21aaaaa317a5d23f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$21aaaaa317a5d23f);
/**
 * SOURCE Authenticated @ squareup/bbfrontend/v1/web_service.proto at 27:3
 */ $fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated);
/**
 * SOURCE Status @ squareup/bbfrontend/v1/web_service.proto at 38:5
 */ $fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Status = $fce501362cc81cfc$var$$root.lookupEnum('squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Status').values;
/**
 * Denotes person is logged in/authenticated and authorized to use banking web
 *
 * SOURCE Authorized @ squareup/bbfrontend/v1/web_service.proto at 44:5
 */ $fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Authorized = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Authorized');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Authorized);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Authorized);
/**
 * Denotes person is not authorized to use banking web even though they are logged in
 * For example, a seller who has a square account but does not have any card invitations.
 *
 * SOURCE Unauthorized @ squareup/bbfrontend/v1/web_service.proto at 49:5
 */ $fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Unauthorized = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapResponse.Authenticated.Unauthorized');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Unauthorized);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$21aaaaa317a5d23f.Authenticated.Unauthorized);
/**
 * SOURCE Unauthenticated @ squareup/bbfrontend/v1/web_service.proto at 52:3
 */ $fce501362cc81cfc$export$21aaaaa317a5d23f.Unauthenticated = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.BootstrapResponse.Unauthenticated');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$21aaaaa317a5d23f.Unauthenticated);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$21aaaaa317a5d23f.Unauthenticated);
const $fce501362cc81cfc$export$be0c7e46b391ca72 = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.GetCountryAddressDataRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$be0c7e46b391ca72);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$be0c7e46b391ca72);
const $fce501362cc81cfc$export$cce565f709f0ad22 = $fce501362cc81cfc$var$$root.lookupType('squareup.bbfrontend.service.v1.GetCountryAddressDataResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($fce501362cc81cfc$export$cce565f709f0ad22);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($fce501362cc81cfc$export$cce565f709f0ad22);
const $fce501362cc81cfc$export$b944e8af96427ee6 = $fce501362cc81cfc$var$$root.lookupService('squareup.bbfrontend.service.v1.WebService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



const $81287a0f87730909$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $81287a0f87730909$var$jsonData = {
    "squareup": {
        "nested": {
            "bbfrontend": {
                "nested": {
                    "bankingweb": {
                        "nested": {
                            "v1": {
                                "nested": {
                                    "GetOrCreateComplianceVerificationRequest": {
                                        "fields": {
                                            "cardInvitationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "globalAddress": {
                                                "type": ".squareup.common.location.GlobalAddress",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "GetOrCreateComplianceVerificationResponse": {
                                        "fields": {
                                            "result": {
                                                "type": ".squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationResponse.ComplianceResult",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "ComplianceResult": {
                                                "values": {
                                                    "COMPLIANCE_RESULT_UNKNOWN": 0,
                                                    "COMPLIANCE_RESULT_PASSED": 1,
                                                    "COMPLIANCE_RESULT_FAILED": 2
                                                }
                                            }
                                        }
                                    },
                                    "BankingWebComplianceService": {
                                        "methods": {
                                            "GetOrCreateComplianceVerification": {
                                                "requestType": ".squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationRequest",
                                                "responseType": ".squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationResponse"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$81287a0f87730909$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.GetOrCreateComplianceVerificationRequest && !$81287a0f87730909$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.GetOrCreateComplianceVerificationResponse && !$81287a0f87730909$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.GetOrCreateComplianceVerificationResponse?.nested?.ComplianceResult && !$81287a0f87730909$var$$root.nested?.squareup?.nested?.bbfrontend?.nested?.bankingweb?.nested?.v1?.nested?.BankingWebComplianceService) $81287a0f87730909$var$$root.addJSON($81287a0f87730909$var$jsonData);
const $81287a0f87730909$export$32eac23879e45813 = $81287a0f87730909$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($81287a0f87730909$export$32eac23879e45813);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($81287a0f87730909$export$32eac23879e45813);
const $81287a0f87730909$export$5a81323f8347f22 = $81287a0f87730909$var$$root.lookupType('squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($81287a0f87730909$export$5a81323f8347f22);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($81287a0f87730909$export$5a81323f8347f22);
/**
 * SOURCE ComplianceResult @ squareup/bbfrontend/bankingweb/v1/compliance_service.proto at 27:3
 */ $81287a0f87730909$export$5a81323f8347f22.ComplianceResult = $81287a0f87730909$var$$root.lookupEnum('squareup.bbfrontend.bankingweb.v1.GetOrCreateComplianceVerificationResponse.ComplianceResult').values;
const $81287a0f87730909$export$58773615f38984aa = $81287a0f87730909$var$$root.lookupService('squareup.bbfrontend.bankingweb.v1.BankingWebComplianceService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $32d23a4e2afcf5bf$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $32d23a4e2afcf5bf$var$jsonData = {
    "google": {
        "nested": {
            "protobuf": {
                "nested": {
                    "FieldMask": {
                        "fields": {
                            "paths": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$32d23a4e2afcf5bf$var$$root.nested?.google?.nested?.protobuf?.nested?.FieldMask) $32d23a4e2afcf5bf$var$$root.addJSON($32d23a4e2afcf5bf$var$jsonData);
const $32d23a4e2afcf5bf$export$90f2e2c209b42f72 = $32d23a4e2afcf5bf$var$$root.lookupType('google.protobuf.FieldMask');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($32d23a4e2afcf5bf$export$90f2e2c209b42f72);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($32d23a4e2afcf5bf$export$90f2e2c209b42f72);



const $d272bac0a1712861$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $d272bac0a1712861$var$jsonData = {
    "squareup": {
        "nested": {
            "bbdebit": {
                "nested": {
                    "cardmanagement": {
                        "nested": {
                            "Error": {
                                "fields": {
                                    "category": {
                                        "type": ".squareup.bbdebit.cardmanagement.Error.Category",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "code": {
                                        "type": ".squareup.bbdebit.cardmanagement.Error.Code",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "detail": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "field": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Category": {
                                        "values": {
                                            "ERROR_CATEGORY_DO_NOT_USE": 0,
                                            "ERROR_CATEGORY_API_ERROR": 1,
                                            "ERROR_CATEGORY_AUTHENTICATION_ERROR": 2,
                                            "ERROR_CATEGORY_AUTHORIZATION_ERROR": 3,
                                            "ERROR_CATEGORY_INVALID_REQUEST_ERROR": 4
                                        }
                                    },
                                    "Code": {
                                        "values": {
                                            "ERROR_CODE_DO_NOT_USE": 0,
                                            "ERROR_CODE_INTERNAL_SERVER_ERROR": 1,
                                            "ERROR_CODE_UNAUTHENTICATED": 2,
                                            "ERROR_CODE_UNAUTHORIZED": 3,
                                            "ERROR_CODE_MISSING_REQUIRED_PARAMETER": 4,
                                            "ERROR_CODE_NOT_FOUND": 5
                                        }
                                    }
                                }
                            },
                            "Challenge": {
                                "fields": {}
                            },
                            "ActivateCardRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "expiration": {
                                        "type": ".squareup.common.time.YearMonth",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cvv": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ActivateCardResponse": {
                                "fields": {
                                    "error": {
                                        "type": ".squareup.bbdebit.cardmanagement.ActivateCardResponse.ActivateCardError",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "ActivateCardError": {
                                        "values": {
                                            "ACTIVATE_CARD_ERROR_DO_NOT_USE": 0,
                                            "ACTIVATE_CARD_ERROR_INVALID_CVV_OR_EXPIRATION": 1
                                        }
                                    }
                                }
                            },
                            "Card": {
                                "fields": {
                                    "id": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "status": {
                                        "type": ".squareup.bbdebit.cardmanagement.CardStatus",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardBrand": {
                                        "type": ".squareup.bbdebit.cardmanagement.CardBrand",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "fulfillment": {
                                        "type": ".squareup.bbdebit.cardmanagement.CardFulfillment",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "lastFour": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "fullPan": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "securityCode": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "expiration": {
                                        "type": ".squareup.common.time.YearMonth",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "canDigitalSpend": {
                                        "type": "bool",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "balanceId": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "relationship": {
                                        "type": ".squareup.bbdebit.cardmanagement.Relationship",
                                        "id": 11,
                                        "rule": "repeated"
                                    },
                                    "expirationData": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card.Expiration",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "previousCardId": {
                                        "type": "string",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "digitalWalletData": {
                                        "type": ".squareup.bbdebit.cardmanagement.DigitalWalletData",
                                        "id": 14,
                                        "rule": "repeated"
                                    },
                                    "pinIsSet": {
                                        "type": "bool",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "isEligibleForPhysicalCardPair": {
                                        "type": "bool",
                                        "id": 16,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Expiration": {
                                        "fields": {
                                            "expiration": {
                                                "type": ".squareup.common.time.YearMonth",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "status": {
                                                "type": ".squareup.bbdebit.cardmanagement.Card.Expiration.ExpirationStatus",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "replacementCard": {
                                                "type": ".squareup.bbdebit.cardmanagement.Card.Expiration.ReplacementCard",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "ReplacementCard": {
                                                "fields": {
                                                    "id": {
                                                        "type": "string",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "scheduledIssueDate": {
                                                        "type": ".squareup.common.time.YearMonthDay",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    }
                                                }
                                            },
                                            "ExpirationStatus": {
                                                "values": {
                                                    "EXPIRATION_STATUS_DO_NOT_USE": 0,
                                                    "EXPIRATION_STATUS_NOT_EXPIRED": 1,
                                                    "EXPIRATION_STATUS_EXPIRING": 2,
                                                    "EXPIRATION_STATUS_EXPIRED": 3
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "CardBrand": {
                                "values": {
                                    "CARD_BRAND_DO_NOT_USE": 0,
                                    "CARD_BRAND_MASTERCARD": 1
                                }
                            },
                            "CardStatus": {
                                "values": {
                                    "CARD_STATUS_DO_NOT_USE": 0,
                                    "CARD_STATUS_ORDERED": 1,
                                    "CARD_STATUS_ISSUED": 2,
                                    "CARD_STATUS_ACTIVATABLE": 3,
                                    "CARD_STATUS_ACTIVE": 4,
                                    "CARD_STATUS_LOCKED": 5,
                                    "CARD_STATUS_SUSPENDED": 6,
                                    "CARD_STATUS_TERMINATED": 7
                                }
                            },
                            "CardFulfillment": {
                                "fields": {
                                    "status": {
                                        "type": ".squareup.bbdebit.cardmanagement.CardFulfillment.FulfillmentStatus",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "customization": {
                                        "type": ".squareup.bbdebit.cardmanagement.Customization",
                                        "id": 2,
                                        "rule": "repeated"
                                    },
                                    "address": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "cardCustomization": {
                                        "type": ".squareup.bbdebit.cardmanagement.Customization",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "deliveryDate": {
                                        "type": ".squareup.common.time.YearMonthDay",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "FulfillmentStatus": {
                                        "values": {
                                            "FULFILLMENT_STATUS_DO_NOT_USE": 0,
                                            "FULFILLMENT_STATUS_PROCESSING": 1,
                                            "FULFILLMENT_STATUS_SHIPPED": 2,
                                            "FULFILLMENT_STATUS_DELIVERED": 3,
                                            "FULFILLMENT_STATUS_FAILURE": 4,
                                            "FULFILLMENT_STATUS_CANCELED": 5,
                                            "FULFILLMENT_STATUS_REJECTED": 6
                                        }
                                    }
                                }
                            },
                            "Customization": {
                                "fields": {
                                    "id": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardTexts": {
                                        "type": ".squareup.bbdebit.cardmanagement.Customization.CardText",
                                        "id": 2,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "CardText": {
                                        "fields": {
                                            "type": {
                                                "type": ".squareup.bbdebit.cardmanagement.Customization.CardText.Type",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "text": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "Type": {
                                                "values": {
                                                    "CARD_TEXT_TYPE_BUSINESS_NAME": 1,
                                                    "CARD_TEXT_TYPE_CARDHOLDER_NAME": 2
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "DigitalWalletData": {
                                "fields": {
                                    "digitalWalletToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "panReferenceId": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateCardRequest": {
                                "fields": {
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardCustomization": {
                                        "type": ".squareup.bbdebit.cardmanagement.Customization",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "shippingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "cardFulfillment": {
                                        "type": ".squareup.bbdebit.cardmanagement.CardFulfillment",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "cardIssuingType": {
                                        "type": ".squareup.bbdebit.cardmanagement.CreateCardRequest.CardIssuingType",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "existingCardIdInPair": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2
                                    },
                                    "balanceId": {
                                        "type": "string",
                                        "id": 3
                                    }
                                },
                                "nested": {
                                    "CardIssuingType": {
                                        "values": {
                                            "CARD_ISSUING_TYPE_DO_NOT_USE": 0,
                                            "CARD_ISSUING_TYPE_VIRTUAL": 1,
                                            "CARD_ISSUING_TYPE_PHYSICAL": 2,
                                            "CARD_ISSUING_TYPE_VIRTUAL_AND_PHYSICAL": 3
                                        }
                                    },
                                    "account_identifier": {
                                        "oneof": [
                                            "unitToken",
                                            "balanceId"
                                        ]
                                    }
                                }
                            },
                            "CreateCardResponse": {
                                "fields": {
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.CreateCardResponse.CreateCardError",
                                        "id": 2,
                                        "rule": "repeated"
                                    },
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 1
                                    },
                                    "challenge": {
                                        "type": ".squareup.bbdebit.cardmanagement.Challenge",
                                        "id": 3
                                    }
                                },
                                "nested": {
                                    "CreateCardError": {
                                        "values": {
                                            "CREATE_CARD_ERROR_DO_NOT_USE": 0,
                                            "CREATE_CARD_ERROR_AUTHORIZATION_CHALLENGED": 1
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "card",
                                            "challenge"
                                        ]
                                    }
                                }
                            },
                            "ListCardsRequest": {
                                "fields": {
                                    "sortOrder": {
                                        "type": ".squareup.bbdebit.cardmanagement.ListCardsRequest.SortOrder",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                            "default": "DESC"
                                        }
                                    },
                                    "cursor": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "limit": {
                                        "type": "int32",
                                        "id": 3,
                                        "rule": "optional",
                                        "options": {
                                            "default": 10
                                        }
                                    },
                                    "balanceId": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "relationship": {
                                        "type": ".squareup.bbdebit.cardmanagement.Relationship",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "personToken": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "includeTerminated": {
                                        "type": "bool",
                                        "id": 7,
                                        "rule": "optional",
                                        "options": {
                                            "default": false
                                        }
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 8,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "SortOrder": {
                                        "values": {
                                            "DESC": 0,
                                            "ASC": 1
                                        }
                                    }
                                }
                            },
                            "ListCardsResponse": {
                                "fields": {
                                    "cards": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "cursor": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "LockCardRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "LockCardResponse": {
                                "fields": {
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.Error",
                                        "id": 2,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "RetrieveCardRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "RetrieveCardResponse": {
                                "fields": {
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.RetrieveCardResponse.RetrieveCardError",
                                        "id": 2,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "RetrieveCardError": {
                                        "values": {
                                            "RETRIEVE_CARD_ERROR_DO_NOT_USE": 0,
                                            "RETRIEVE_CARD_ERROR_INVALID_CARD_TOKEN": 1
                                        }
                                    }
                                }
                            },
                            "RetrieveCardRelationshipsRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "RetrieveCardRelationshipsResponse": {
                                "fields": {
                                    "relationships": {
                                        "type": ".squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsResponse.Relationship",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "Relationship": {
                                        "values": {
                                            "RELATIONSHIP_DO_NOT_USE": 0,
                                            "RELATIONSHIP_ACCOUNT_HOLDER": 1,
                                            "RELATIONSHIP_CARD_HOLDER": 2
                                        }
                                    }
                                }
                            },
                            "Relationship": {
                                "values": {
                                    "RELATIONSHIP_DO_NOT_USE": 0,
                                    "RELATIONSHIP_CARDHOLDER": 1,
                                    "RELATIONSHIP_ACCOUNT_HOLDER": 2
                                }
                            },
                            "SetPinRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "pin": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetPinResponse": {
                                "fields": {
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.SetPinResponse.SetPinError",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "error": {
                                        "type": ".squareup.bbdebit.cardmanagement.SetPinResponse.SetPinError",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "SetPinError": {
                                        "values": {
                                            "SET_PIN_ERROR_DO_NOT_USE": 0,
                                            "SET_PIN_ERROR_INVALID_CARD_TOKEN": 1,
                                            "SET_PIN_ERROR_UNAUTHORIZED": 2,
                                            "SET_PIN_ERROR_WEAK_PIN": 3
                                        }
                                    }
                                }
                            },
                            "TerminateCardRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "reason": {
                                        "type": ".squareup.bbdebit.cardmanagement.TerminateCardRequest.TerminateCardReason",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "TerminateCardReason": {
                                        "values": {
                                            "TERMINATE_CARD_REASON_DO_NOT_USE": 0,
                                            "TERMINATE_CARD_REASON_LOST_OR_STOLEN": 1,
                                            "TERMINATE_CARD_REASON_DAMAGED": 2,
                                            "TERMINATE_CARD_REASON_CARD_NOT_RECEIVED": 3,
                                            "TERMINATE_CARD_REASON_CANCEL": 4,
                                            "TERMINATE_CARD_REASON_ACCOUNT_CLOSED": 5,
                                            "TERMINATE_CARD_REASON_FRAUD": 6,
                                            "TERMINATE_CARD_REASON_EXPIRED": 7,
                                            "TERMINATE_CARD_REASON_REISSUED": 8,
                                            "TERMINATE_CARD_REASON_OTHER": 9
                                        }
                                    }
                                }
                            },
                            "TerminateCardResponse": {
                                "fields": {
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.TerminateCardResponse.TerminateCardError",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "TerminateCardError": {
                                        "values": {
                                            "TERMINATE_CARD_ERROR_DO_NOT_USE": 0,
                                            "TERMINATE_CARD_ERROR_INVALID_CARD_TOKEN": 1,
                                            "TERMINATE_CARD_ERROR_CARD_ALREADY_TERMINATED": 2
                                        }
                                    }
                                }
                            },
                            "UnlockCardRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UnlockCardResponse": {
                                "fields": {
                                    "card": {
                                        "type": ".squareup.bbdebit.cardmanagement.Card",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errors": {
                                        "type": ".squareup.bbdebit.cardmanagement.Error",
                                        "id": 2,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "CardManagementService": {
                                "methods": {
                                    "ActivateCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.ActivateCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.ActivateCardResponse"
                                    },
                                    "CreateCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.CreateCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.CreateCardResponse"
                                    },
                                    "ListCards": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.ListCardsRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.ListCardsResponse"
                                    },
                                    "LockCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.LockCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.LockCardResponse"
                                    },
                                    "RetrieveCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.RetrieveCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.RetrieveCardResponse"
                                    },
                                    "RetrieveCardRelationships": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsResponse"
                                    },
                                    "SetPin": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.SetPinRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.SetPinResponse"
                                    },
                                    "TerminateCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.TerminateCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.TerminateCardResponse"
                                    },
                                    "UnlockCard": {
                                        "requestType": ".squareup.bbdebit.cardmanagement.UnlockCardRequest",
                                        "responseType": ".squareup.bbdebit.cardmanagement.UnlockCardResponse"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Error && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Error?.nested?.Category && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Error?.nested?.Code && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Challenge && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ActivateCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ActivateCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ActivateCardResponse?.nested?.ActivateCardError && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Card && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Card?.nested?.Expiration && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Card?.nested?.Expiration?.nested?.ReplacementCard && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Card?.nested?.Expiration?.nested?.ExpirationStatus && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CardBrand && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CardStatus && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CardFulfillment && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CardFulfillment?.nested?.FulfillmentStatus && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Customization && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Customization?.nested?.CardText && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Customization?.nested?.CardText?.nested?.Type && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.DigitalWalletData && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CreateCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CreateCardRequest?.nested?.CardIssuingType && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CreateCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CreateCardResponse?.nested?.CreateCardError && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ListCardsRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ListCardsRequest?.nested?.SortOrder && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.ListCardsResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.LockCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.LockCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardResponse?.nested?.RetrieveCardError && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardRelationshipsRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardRelationshipsResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.RetrieveCardRelationshipsResponse?.nested?.Relationship && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.Relationship && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.SetPinRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.SetPinResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.SetPinResponse?.nested?.SetPinError && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.TerminateCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.TerminateCardRequest?.nested?.TerminateCardReason && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.TerminateCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.TerminateCardResponse?.nested?.TerminateCardError && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.UnlockCardRequest && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.UnlockCardResponse && !$d272bac0a1712861$var$$root.nested?.squareup?.nested?.bbdebit?.nested?.cardmanagement?.nested?.CardManagementService) $d272bac0a1712861$var$$root.addJSON($d272bac0a1712861$var$jsonData);
const $d272bac0a1712861$export$edf27be85e5f6da0 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Error');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$edf27be85e5f6da0, {
    category: {
        required: true
    },
    code: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$edf27be85e5f6da0);
/**
 * SOURCE Category @ squareup/bbdebit/cardmanagement.proto at 18:3
 */ $d272bac0a1712861$export$edf27be85e5f6da0.Category = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.Error.Category').values;
/**
 * SOURCE Code @ squareup/bbdebit/cardmanagement.proto at 40:3
 */ $d272bac0a1712861$export$edf27be85e5f6da0.Code = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.Error.Code').values;
const $d272bac0a1712861$export$a50dcf13e7b62e9d = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Challenge');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$a50dcf13e7b62e9d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$a50dcf13e7b62e9d);
const $d272bac0a1712861$export$7e4385b3b341704b = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.ActivateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$7e4385b3b341704b, {
    cardToken: {
        notEmpty: true
    },
    expiration: {
        required: true
    },
    cvv: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$7e4385b3b341704b);
const $d272bac0a1712861$export$7dde42e884f2d048 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.ActivateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$7dde42e884f2d048);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$7dde42e884f2d048);
/**
 * SOURCE ActivateCardError @ squareup/bbdebit/cardmanagement.proto at 107:3
 */ $d272bac0a1712861$export$7dde42e884f2d048.ActivateCardError = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.ActivateCardResponse.ActivateCardError').values;
const $d272bac0a1712861$export$60332b2344f7fe41 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Card');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$60332b2344f7fe41, {
    id: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$60332b2344f7fe41);
/**
 * SOURCE Expiration @ squareup/bbdebit/cardmanagement.proto at 165:3
 */ $d272bac0a1712861$export$60332b2344f7fe41.Expiration = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Card.Expiration');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$60332b2344f7fe41.Expiration);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$60332b2344f7fe41.Expiration);
/**
 * SOURCE ReplacementCard @ squareup/bbdebit/cardmanagement.proto at 170:5
 */ $d272bac0a1712861$export$60332b2344f7fe41.Expiration.ReplacementCard = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Card.Expiration.ReplacementCard');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$60332b2344f7fe41.Expiration.ReplacementCard);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$60332b2344f7fe41.Expiration.ReplacementCard);
/**
 * Expiration status of the current card. The expiring status will start being populated two
 * months prior to card expiration
 *
 * SOURCE ExpirationStatus @ squareup/bbdebit/cardmanagement.proto at 187:5
 */ $d272bac0a1712861$export$60332b2344f7fe41.Expiration.ExpirationStatus = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.Card.Expiration.ExpirationStatus').values;
const $d272bac0a1712861$export$1e5507a06cab5709 = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.CardBrand').values;
const $d272bac0a1712861$export$490c7ce941281ba8 = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.CardStatus').values;
const $d272bac0a1712861$export$b2a48b6a70d75edb = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.CardFulfillment');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$b2a48b6a70d75edb);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$b2a48b6a70d75edb);
/**
 * SOURCE FulfillmentStatus @ squareup/bbdebit/cardmanagement.proto at 228:3
 */ $d272bac0a1712861$export$b2a48b6a70d75edb.FulfillmentStatus = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.CardFulfillment.FulfillmentStatus').values;
const $d272bac0a1712861$export$f27319a4138ec79f = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Customization');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$f27319a4138ec79f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$f27319a4138ec79f);
/**
 * SOURCE CardText @ squareup/bbdebit/cardmanagement.proto at 249:3
 */ $d272bac0a1712861$export$f27319a4138ec79f.CardText = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.Customization.CardText');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$f27319a4138ec79f.CardText, {
    type: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$f27319a4138ec79f.CardText);
/**
 * SOURCE Type @ squareup/bbdebit/cardmanagement.proto at 259:5
 */ $d272bac0a1712861$export$f27319a4138ec79f.CardText.Type = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.Customization.CardText.Type').values;
const $d272bac0a1712861$export$59597d2c7b41f3be = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.DigitalWalletData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$59597d2c7b41f3be);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$59597d2c7b41f3be);
const $d272bac0a1712861$export$531aee450bc3dbd4 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.CreateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$531aee450bc3dbd4, {
    idempotenceKey: {
        notEmpty: true
    },
    cardCustomization: {
        required: true
    },
    shippingAddress: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$531aee450bc3dbd4);
/**
 * CardIssuingType specifies the type of card issuing strategy
 *
 * SOURCE CardIssuingType @ squareup/bbdebit/cardmanagement.proto at 329:3
 */ $d272bac0a1712861$export$531aee450bc3dbd4.CardIssuingType = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.CreateCardRequest.CardIssuingType').values;
const $d272bac0a1712861$export$77c2e9a08149a1ad = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.CreateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$77c2e9a08149a1ad);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$77c2e9a08149a1ad);
/**
 * CreateCardError will be deprecated once clients switch over to using the Challenge object instead
 *
 * SOURCE CreateCardError @ squareup/bbdebit/cardmanagement.proto at 364:3
 */ $d272bac0a1712861$export$77c2e9a08149a1ad.CreateCardError = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.CreateCardResponse.CreateCardError').values;
const $d272bac0a1712861$export$1f9ff0d796a08011 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.ListCardsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$1f9ff0d796a08011);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$1f9ff0d796a08011);
/**
 * SOURCE SortOrder @ squareup/bbdebit/cardmanagement.proto at 371:3
 */ $d272bac0a1712861$export$1f9ff0d796a08011.SortOrder = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.ListCardsRequest.SortOrder').values;
const $d272bac0a1712861$export$8a92910321c6ac49 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.ListCardsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$8a92910321c6ac49);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$8a92910321c6ac49);
const $d272bac0a1712861$export$ea294dc182de2c2c = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.LockCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$ea294dc182de2c2c, {
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$ea294dc182de2c2c);
const $d272bac0a1712861$export$35137ddc8e41e17f = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.LockCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$35137ddc8e41e17f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$35137ddc8e41e17f);
const $d272bac0a1712861$export$8f1da4e33ad24fb3 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.RetrieveCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$8f1da4e33ad24fb3, {
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$8f1da4e33ad24fb3);
const $d272bac0a1712861$export$763e5b98f5f24d5f = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.RetrieveCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$763e5b98f5f24d5f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$763e5b98f5f24d5f);
/**
 * SOURCE RetrieveCardError @ squareup/bbdebit/cardmanagement.proto at 471:3
 */ $d272bac0a1712861$export$763e5b98f5f24d5f.RetrieveCardError = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.RetrieveCardResponse.RetrieveCardError').values;
const $d272bac0a1712861$export$94bbb7cf8da173b5 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$94bbb7cf8da173b5, {
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$94bbb7cf8da173b5);
const $d272bac0a1712861$export$a7a3cd26cb3a7a31 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$a7a3cd26cb3a7a31);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$a7a3cd26cb3a7a31);
/**
 * SOURCE Relationship @ squareup/bbdebit/cardmanagement.proto at 491:3
 */ $d272bac0a1712861$export$a7a3cd26cb3a7a31.Relationship = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.RetrieveCardRelationshipsResponse.Relationship').values;
const $d272bac0a1712861$export$69a0e7946cf616df = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.Relationship').values;
const $d272bac0a1712861$export$6129867d2a9d1edf = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.SetPinRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$6129867d2a9d1edf, {
    cardToken: {
        required: true
    },
    pin: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$6129867d2a9d1edf);
const $d272bac0a1712861$export$7aecf5bab678a854 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.SetPinResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$7aecf5bab678a854);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$7aecf5bab678a854);
/**
 * SOURCE SetPinError @ squareup/bbdebit/cardmanagement.proto at 519:3
 */ $d272bac0a1712861$export$7aecf5bab678a854.SetPinError = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.SetPinResponse.SetPinError').values;
const $d272bac0a1712861$export$6f80cf9974e4741 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.TerminateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$6f80cf9974e4741, {
    cardToken: {
        notEmpty: true
    },
    reason: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$6f80cf9974e4741);
/**
 * SOURCE TerminateCardReason @ squareup/bbdebit/cardmanagement.proto at 548:3
 */ $d272bac0a1712861$export$6f80cf9974e4741.TerminateCardReason = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.TerminateCardRequest.TerminateCardReason').values;
const $d272bac0a1712861$export$607876000fb9e10a = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.TerminateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$607876000fb9e10a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$607876000fb9e10a);
/**
 * SOURCE TerminateCardError @ squareup/bbdebit/cardmanagement.proto at 597:3
 */ $d272bac0a1712861$export$607876000fb9e10a.TerminateCardError = $d272bac0a1712861$var$$root.lookupEnum('squareup.bbdebit.cardmanagement.TerminateCardResponse.TerminateCardError').values;
const $d272bac0a1712861$export$708d55e385ca855d = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.UnlockCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$708d55e385ca855d, {
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$708d55e385ca855d);
const $d272bac0a1712861$export$9f3bbac088b762d6 = $d272bac0a1712861$var$$root.lookupType('squareup.bbdebit.cardmanagement.UnlockCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($d272bac0a1712861$export$9f3bbac088b762d6);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($d272bac0a1712861$export$9f3bbac088b762d6);
const $d272bac0a1712861$export$f40f1fb9063205d8 = $d272bac0a1712861$var$$root.lookupService('squareup.bbdebit.cardmanagement.CardManagementService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $239527144304fba6$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $239527144304fba6$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "Denominations": {
                        "fields": {
                            "banknoteCents": {
                                "type": "int32",
                                "id": 1,
                                "rule": "repeated"
                            },
                            "coinCents": {
                                "type": "int32",
                                "id": 2,
                                "rule": "repeated"
                            }
                        }
                    },
                    "CurrencyCode": {
                        "values": {
                            "AED": 784,
                            "AFN": 971,
                            "ALL": 8,
                            "AMD": 51,
                            "ANG": 532,
                            "AOA": 973,
                            "ARS": 32,
                            "AUD": 36,
                            "AWG": 533,
                            "AZN": 944,
                            "BAM": 977,
                            "BBD": 52,
                            "BDT": 50,
                            "BGN": 975,
                            "BHD": 48,
                            "BIF": 108,
                            "BMD": 60,
                            "BND": 96,
                            "BOB": 68,
                            "BOV": 984,
                            "BRL": 986,
                            "BSD": 44,
                            "BTN": 64,
                            "BWP": 72,
                            "BYR": 974,
                            "BZD": 84,
                            "CAD": 124,
                            "CDF": 976,
                            "CHE": 947,
                            "CHF": 756,
                            "CHW": 948,
                            "CLF": 990,
                            "CLP": 152,
                            "CNY": 156,
                            "COP": 170,
                            "COU": 970,
                            "CRC": 188,
                            "CUC": 931,
                            "CUP": 192,
                            "CVE": 132,
                            "CZK": 203,
                            "DJF": 262,
                            "DKK": 208,
                            "DOP": 214,
                            "DZD": 12,
                            "EGP": 818,
                            "ERN": 232,
                            "ETB": 230,
                            "EUR": 978,
                            "FJD": 242,
                            "FKP": 238,
                            "GBP": 826,
                            "GEL": 981,
                            "GHS": 936,
                            "GIP": 292,
                            "GMD": 270,
                            "GNF": 324,
                            "GTQ": 320,
                            "GYD": 328,
                            "HKD": 344,
                            "HNL": 340,
                            "HRK": 191,
                            "HTG": 332,
                            "HUF": 348,
                            "IDR": 360,
                            "ILS": 376,
                            "INR": 356,
                            "IQD": 368,
                            "IRR": 364,
                            "ISK": 352,
                            "JMD": 388,
                            "JOD": 400,
                            "JPY": 392,
                            "KES": 404,
                            "KGS": 417,
                            "KHR": 116,
                            "KMF": 174,
                            "KPW": 408,
                            "KRW": 410,
                            "KWD": 414,
                            "KYD": 136,
                            "KZT": 398,
                            "LAK": 418,
                            "LBP": 422,
                            "LKR": 144,
                            "LRD": 430,
                            "LSL": 426,
                            "LTL": 440,
                            "LVL": 428,
                            "LYD": 434,
                            "MAD": 504,
                            "MDL": 498,
                            "MGA": 969,
                            "MKD": 807,
                            "MMK": 104,
                            "MNT": 496,
                            "MOP": 446,
                            "MRO": 478,
                            "MUR": 480,
                            "MVR": 462,
                            "MWK": 454,
                            "MXN": 484,
                            "MXV": 979,
                            "MYR": 458,
                            "MZN": 943,
                            "NAD": 516,
                            "NGN": 566,
                            "NIO": 558,
                            "NOK": 578,
                            "NPR": 524,
                            "NZD": 554,
                            "OMR": 512,
                            "PAB": 590,
                            "PEN": 604,
                            "PGK": 598,
                            "PHP": 608,
                            "PKR": 586,
                            "PLN": 985,
                            "PYG": 600,
                            "QAR": 634,
                            "RON": 946,
                            "RSD": 941,
                            "RUB": 643,
                            "RWF": 646,
                            "SAR": 682,
                            "SBD": 90,
                            "SCR": 690,
                            "SDG": 938,
                            "SEK": 752,
                            "SGD": 702,
                            "SHP": 654,
                            "SLL": 694,
                            "SOS": 706,
                            "SRD": 968,
                            "SSP": 728,
                            "STD": 678,
                            "SVC": 222,
                            "SYP": 760,
                            "SZL": 748,
                            "THB": 764,
                            "TJS": 972,
                            "TMT": 934,
                            "TND": 788,
                            "TOP": 776,
                            "TRY": 949,
                            "TTD": 780,
                            "TWD": 901,
                            "TZS": 834,
                            "UAH": 980,
                            "UGX": 800,
                            "USD": 840,
                            "USN": 997,
                            "USS": 998,
                            "UYI": 940,
                            "UYU": 858,
                            "UZS": 860,
                            "VEF": 937,
                            "VND": 704,
                            "VUV": 548,
                            "WST": 882,
                            "XAF": 950,
                            "XAG": 961,
                            "XAU": 959,
                            "XBA": 955,
                            "XBB": 956,
                            "XBC": 957,
                            "XBD": 958,
                            "XCD": 951,
                            "XDR": 960,
                            "XOF": 952,
                            "XPD": 964,
                            "XPF": 953,
                            "XPT": 962,
                            "XTS": 963,
                            "XXX": 999,
                            "YER": 886,
                            "ZAR": 710,
                            "ZMK": 894,
                            "ZMW": 967,
                            "BTC": 1001,
                            "XUS": 1002,
                            "SLE": 925
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$239527144304fba6$var$$root.nested?.squareup?.nested?.common?.nested?.Denominations && !$239527144304fba6$var$$root.nested?.squareup?.nested?.common?.nested?.CurrencyCode) $239527144304fba6$var$$root.addJSON($239527144304fba6$var$jsonData);
const $239527144304fba6$export$c4145ae48aba6c75 = $239527144304fba6$var$$root.lookupType('squareup.common.Denominations');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($239527144304fba6$export$c4145ae48aba6c75);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($239527144304fba6$export$c4145ae48aba6c75);
const $239527144304fba6$export$6e3fca9a737174b = $239527144304fba6$var$$root.lookupEnum('squareup.common.CurrencyCode').values;


const $5404581afd6e3c7f$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $5404581afd6e3c7f$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "Money": {
                        "fields": {
                            "amount": {
                                "type": "int64",
                                "id": 2,
                                "rule": "optional"
                            },
                            "currencyCode": {
                                "type": ".squareup.common.CurrencyCode",
                                "id": 3,
                                "rule": "optional",
                                "options": {
                                    "default": "USD"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$5404581afd6e3c7f$var$$root.nested?.squareup?.nested?.common?.nested?.Money) $5404581afd6e3c7f$var$$root.addJSON($5404581afd6e3c7f$var$jsonData);
const $5404581afd6e3c7f$export$d26bcf891bc220f6 = $5404581afd6e3c7f$var$$root.lookupType('squareup.common.Money');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($5404581afd6e3c7f$export$d26bcf891bc220f6);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($5404581afd6e3c7f$export$d26bcf891bc220f6);



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $2b37713ec131f59e$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $2b37713ec131f59e$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "model": {
                        "nested": {
                            "BatchRequest": {
                                "fields": {
                                    "batchSize": {
                                        "type": "int32",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                            "default": 20
                                        }
                                    },
                                    "paginationToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$2b37713ec131f59e$var$$root.nested?.squareup?.nested?.bizbank?.nested?.model?.nested?.BatchRequest) $2b37713ec131f59e$var$$root.addJSON($2b37713ec131f59e$var$jsonData);
const $2b37713ec131f59e$export$fc03689ccf0157bb = $2b37713ec131f59e$var$$root.lookupType('squareup.bizbank.model.BatchRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($2b37713ec131f59e$export$fc03689ccf0157bb);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($2b37713ec131f59e$export$fc03689ccf0157bb);


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $17122ce9dd6f9602$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $17122ce9dd6f9602$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "external": {
                        "nested": {
                            "ExternalSystem": {
                                "values": {
                                    "SQUARE_CASH_PAYMENT": 1,
                                    "SQUARE_CASH_TRANSFER": 2,
                                    "BANKSY_TRANSFER": 3,
                                    "DASH_CARD": 4,
                                    "CORE_PRO_ACH": 5,
                                    "SHAZAM_CARD": 6,
                                    "MARQETA_CARD": 7,
                                    "SQUARE_CASH_CLAWBACK": 8,
                                    "GREEN_DOT_ACH": 9,
                                    "CARD_FULFILLMENT": 10,
                                    "CARD_MAILING": 11,
                                    "PITNEY_BOWES_CARD_MAILING": 12,
                                    "BITCOIN_BLOCKCHAIN": 13,
                                    "TRADEBLOCK": 14,
                                    "SQUARE_CASH_TRADING": 15,
                                    "THIRD_PARTY_TRADE": 16,
                                    "MARQETA_BUSINESS_CARD": 17,
                                    "DRIVEWEALTH": 18,
                                    "INVEST_CORE": 19,
                                    "MARQETA_ACH": 20,
                                    "LEDGER_INTERNAL": 21,
                                    "LOANSTAR": 22,
                                    "SQUARE_CASH_REFUND": 23,
                                    "SQUARE_CASH_ADMIN": 24,
                                    "MOBILE_CHECK_DEPOSIT": 25,
                                    "MITEK_CHECK_DEPOSIT": 26,
                                    "BTC_NETWORK": 27,
                                    "RISKARBITER_ACH": 28,
                                    "INVEST_CRYPTO": 29,
                                    "VDBS": 30,
                                    "PAY_WITH_CASH": 31,
                                    "INSTANT_PAY": 32,
                                    "MODERN_TREASURY_WIRE": 33,
                                    "VISA_CARD": 34,
                                    "RISKARBITER_WIRE": 35,
                                    "CRYPTO_SPARKY": 36,
                                    "VISA_DPS_CARD": 37,
                                    "NETWORK_OF_NETWORKS_GLOBAL_X": 38,
                                    "DISPUTRON": 39,
                                    "CASH_LIMITS": 40,
                                    "CASH_ME_OUTSIDE": 41,
                                    "CASH_BARB": 42,
                                    "ENSENTA_CHECK_DEPOSIT": 43,
                                    "SQUARE_BANKING_OPS": 44,
                                    "OVERDRAFT": 45,
                                    "CASH_DDA_ACH": 46,
                                    "WELLS_FARGO_WIRE": 47,
                                    "CASH_FOR_BUSINESS": 48,
                                    "PIGGYBANK": 49,
                                    "BILL_PAY_PAYMENTUS": 50,
                                    "CIVIL_PROCESSOR": 51,
                                    "ISTL": 52,
                                    "ORDERLY_AFTERPAY": 53,
                                    "BLOCK_STABLE": 54,
                                    "SALVAGER": 55,
                                    "TIMECARDS": 56
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$17122ce9dd6f9602$var$$root.nested?.squareup?.nested?.banklin?.nested?.external?.nested?.ExternalSystem) $17122ce9dd6f9602$var$$root.addJSON($17122ce9dd6f9602$var$jsonData);
const $17122ce9dd6f9602$export$be167ca5b681b6fa = $17122ce9dd6f9602$var$$root.lookupEnum('squareup.banklin.external.ExternalSystem').values;



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $74ad1a5cc9e66690$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $74ad1a5cc9e66690$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "octopus": {
                        "nested": {
                            "OctopusResult": {
                                "values": {
                                    "SUCCESS": 1,
                                    "GENERIC_FAILURE": 2,
                                    "TRANSPORT_ERROR": 3,
                                    "UNSUPPORTED_INSTRUMENT": 4,
                                    "INSUFFICIENT_FUNDS": 5,
                                    "INVALID_INSTRUMENT": 6,
                                    "INSTRUMENT_EXPIRED": 7,
                                    "CARD_LOST_OR_STOLEN": 8,
                                    "INVALID_CVV": 9,
                                    "DECLINED": 10,
                                    "FAILED_TO_REACH_ISSUER": 11,
                                    "LEASE_EXPIRED": 12,
                                    "INVALID_ROUTING_NUMBER": 13,
                                    "CONTACT_ACQUIRER": 14,
                                    "PICK_UP_CARD": 15,
                                    "SUSPECTED_FRAUD": 16,
                                    "DO_NOT_HONOR": 17,
                                    "REENTER_TRANSACTION": 18,
                                    "ACCOUNT_FROZEN": 19,
                                    "FAILED_BANKBOOK_VALIDATION": 23,
                                    "INVALID_BANKBOOK_ACCOUNT": 34,
                                    "BANKBOOK_CREDENTIALS_EXPIRED": 33,
                                    "POTENTIALLY_INSUFFICIENT_FUNDS": 20,
                                    "INSTRUMENT_DISABLED": 21,
                                    "UNSUPPORTED_CURRENCY": 22,
                                    "INVALID_AVS": 24,
                                    "UNACTIVATED_INSTRUMENT": 25,
                                    "INVALID_PIN": 26,
                                    "OVER_LIMIT": 27,
                                    "TOO_MANY_ACTIVATION_ATTEMPTS": 28,
                                    "MANUAL_REVIEW": 29,
                                    "UNSUPPORTED_COUNTRY": 30,
                                    "CHIP_ERROR": 31,
                                    "INVALID_AMOUNT": 32,
                                    "BLOCKED_BY_FRISKY": 35,
                                    "RESTRICTED_CARD": 36,
                                    "TRANSACTION_NOT_PERMITTED": 37,
                                    "AUTHENTICATION_REQUIRED": 38,
                                    "INVALID_MERCHANT": 40,
                                    "INVALID_EXPIRATION": 41,
                                    "SUSPECTED_STOLEN": 42,
                                    "DECLINED_CARD_LOCKED": 43,
                                    "UNSUPPORTED_MCC": 44,
                                    "ACCOUNT_DENYLISTED": 45,
                                    "ACCOUNT_EXTERNAL_SUSPENDED": 46,
                                    "CARD_TERMINATED": 47,
                                    "UNSUPPORTED_REASON_CODE": 48,
                                    "MOBILE_WALLET_ERROR": 49,
                                    "STOP_PAYMENT": 50,
                                    "REVOCATION_OF_AUTH": 51,
                                    "MERCHANT_BLOCKED_FOR_SPONSORED_CUSTOMER": 52,
                                    "MERCHANT_BLOCKED_BY_CUSTOMER": 53,
                                    "PIN_TRY_LIMIT_EXCEEDED": 54,
                                    "AUTO_REVERSAL": 55,
                                    "AUTO_REVERSAL_WITH_MANUAL_REVIEW": 56,
                                    "IN_APP_AUTHENTICATION_REQUIRED": 57,
                                    "DUPLICATE_TRANSACTION": 58,
                                    "AUTHENTICATION_FAILED": 59,
                                    "LINKED_ACCOUNT_LIMIT_EXCEEDED": 61,
                                    "STORED_VALUE_REQUIRED": 62,
                                    "DIDV_REQUIRED": 63,
                                    "BNF_NAME_REQUIRED": 64,
                                    "CREDIT_LIMIT_EXCEEDED": 65,
                                    "INVALID_USE_OF_CASH_CARD": 66,
                                    "INSTRUMENT_INCURS_ADDITIONAL_FEES": 67
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$74ad1a5cc9e66690$var$$root.nested?.squareup?.nested?.banklin?.nested?.octopus?.nested?.OctopusResult) $74ad1a5cc9e66690$var$$root.addJSON($74ad1a5cc9e66690$var$jsonData);
const $74ad1a5cc9e66690$export$90a1be0f1aee044f = $74ad1a5cc9e66690$var$$root.lookupEnum('squareup.banklin.octopus.OctopusResult').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $59b0e09277c0251d$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $59b0e09277c0251d$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "StoredValueBalance": {
                        "nested": {
                            "Type": {
                                "values": {
                                    "CURRENCY": 1,
                                    "EQUITY": 2,
                                    "SAVINGS": 3,
                                    "LOAN": 4,
                                    "INVEST_PAYMENT": 5,
                                    "GIFT_CARD": 6,
                                    "CCY_CLEARING": 7,
                                    "EXT_INSTRUMENT": 8,
                                    "OVERDRAFT": 9,
                                    "P2P": 10,
                                    "EXCHANGE": 11,
                                    "FUNDING_PROMISE": 12,
                                    "AFTERPAY_LOAN": 13,
                                    "MONEY_POOL": 14
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$59b0e09277c0251d$var$$root.nested?.squareup?.nested?.banklin?.nested?.StoredValueBalance?.nested?.Type) $59b0e09277c0251d$var$$root.addJSON($59b0e09277c0251d$var$jsonData);
const $59b0e09277c0251d$export$2b863153179ec9fa = {};
/**
 * SOURCE Type @ squareup/banklin/stored_value_balance.proto at 34:3
 */ $59b0e09277c0251d$export$2b863153179ec9fa.Type = $59b0e09277c0251d$var$$root.lookupEnum('squareup.banklin.StoredValueBalance.Type').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



const $792408278ae1508d$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $792408278ae1508d$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "rewards": {
                        "nested": {
                            "Reward": {
                                "fields": {
                                    "token": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "rewardProgramToken": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "flatReward": {
                                        "type": ".squareup.banklin.rewards.Reward.FlatRewardTerms",
                                        "id": 1
                                    },
                                    "percentageReward": {
                                        "type": ".squareup.banklin.rewards.Reward.PercentageRewardTerms",
                                        "id": 4
                                    }
                                },
                                "nested": {
                                    "FlatRewardTerms": {
                                        "fields": {
                                            "rewardAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "minimumSpendAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "PercentageRewardTerms": {
                                        "fields": {
                                            "rewardBasisPoints": {
                                                "type": "int64",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "terms": {
                                        "oneof": [
                                            "flatReward",
                                            "percentageReward"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$792408278ae1508d$var$$root.nested?.squareup?.nested?.banklin?.nested?.rewards?.nested?.Reward && !$792408278ae1508d$var$$root.nested?.squareup?.nested?.banklin?.nested?.rewards?.nested?.Reward?.nested?.FlatRewardTerms && !$792408278ae1508d$var$$root.nested?.squareup?.nested?.banklin?.nested?.rewards?.nested?.Reward?.nested?.PercentageRewardTerms) $792408278ae1508d$var$$root.addJSON($792408278ae1508d$var$jsonData);
const $792408278ae1508d$export$c6b5fd5be4b5d9d8 = $792408278ae1508d$var$$root.lookupType('squareup.banklin.rewards.Reward');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($792408278ae1508d$export$c6b5fd5be4b5d9d8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($792408278ae1508d$export$c6b5fd5be4b5d9d8);
/**
 * SOURCE FlatRewardTerms @ squareup/banklin/rewards.proto at 13:3
 */ $792408278ae1508d$export$c6b5fd5be4b5d9d8.FlatRewardTerms = $792408278ae1508d$var$$root.lookupType('squareup.banklin.rewards.Reward.FlatRewardTerms');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($792408278ae1508d$export$c6b5fd5be4b5d9d8.FlatRewardTerms);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($792408278ae1508d$export$c6b5fd5be4b5d9d8.FlatRewardTerms);
/**
 * SOURCE PercentageRewardTerms @ squareup/banklin/rewards.proto at 18:3
 */ $792408278ae1508d$export$c6b5fd5be4b5d9d8.PercentageRewardTerms = $792408278ae1508d$var$$root.lookupType('squareup.banklin.rewards.Reward.PercentageRewardTerms');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($792408278ae1508d$export$c6b5fd5be4b5d9d8.PercentageRewardTerms);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($792408278ae1508d$export$c6b5fd5be4b5d9d8.PercentageRewardTerms);



const $175b90705c9182e7$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $175b90705c9182e7$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "TransactionState": {
                        "values": {
                            "PENDING": 1,
                            "SETTLED": 2,
                            "VOIDED": 3,
                            "DECLINED": 4,
                            "REFUNDED": 5,
                            "REVERSED": 6,
                            "DISPUTED": 7,
                            "DISPUTE_REVERSED": 8,
                            "DISPUTE_WON": 9,
                            "IN_REVIEW": 10,
                            "IN_REVERSAL": 11,
                            "WAITING_ON_EXTERNAL": 12,
                            "SETTLED_EXTERNALLY": 13,
                            "REVERSED_EXTERNALLY": 14,
                            "IN_REVERSAL_EXTERNALLY": 15,
                            "DISPUTE_WRITTEN_OFF": 16
                        }
                    },
                    "TransactionReasonCode": {
                        "values": {
                            "ATM_WITHDRAWAL": 1,
                            "ATM_CHECK_DEPOSIT": 2,
                            "ATM_FEE": 3,
                            "CARD_PRESENT_PURCHASE": 4,
                            "CARD_NOT_PRESENT_PURCHASE": 5,
                            "ACCOUNT_MAINTENANCE_FEE": 6,
                            "BALANCE_ADJUSTMENT": 7,
                            "SQUARE_CASH_SELF": 8,
                            "SQUARE_CASH_P2P": 9,
                            "SQUARE_CASH_BUSINESS": 10,
                            "PINDEBIT": 11,
                            "PINCREDIT": 12,
                            "ACH": 13,
                            "UNLINKED_CREDIT": 14,
                            "GREENDOT_FEE": 15,
                            "NETWORK_FEE": 16,
                            "SQUARE_CASH_FEE": 17,
                            "CARD_MERCHANT_REFUND": 18,
                            "OVERDRAFT_FEE": 19,
                            "CARD_PRE_AUTHORIZATION": 20,
                            "MOBILE_CHECK_DEPOSIT": 21,
                            "CHECK_PAYMENT": 22,
                            "CARD_VALIDATION": 23,
                            "ONLINE_PURCHASE": 24,
                            "ATM_BALANCE_CHECK": 25,
                            "SQUARE_REGISTER_INSTANT_DEPOSIT": 26,
                            "SQUARE_CASH_REFERRAL": 27,
                            "APPLE_PAY_PURCHASE": 28,
                            "APPLE_PAY_ACTIVATION": 29,
                            "INTERNAL_CURRENCY_EXCHANGE": 30,
                            "BITCOIN_TRANSFER": 31,
                            "ANDROID_PAY_PURCHASE": 32,
                            "ANDROID_PAY_ACTIVATION": 33,
                            "PINDEBIT_CASHBACK": 34,
                            "PINDEBIT_QUASI_CASH": 35,
                            "CARD_ACTIVATION": 36,
                            "FUNDS_TRANSFER": 37,
                            "BILL_PAYMENT": 38,
                            "ATM_UNVERIFIED_DEPOSIT": 39,
                            "ATM_CASH_DEPOSIT": 40,
                            "SAMSUNG_PAY_PURCHASE": 41,
                            "SAMSUNG_PAY_ACTIVATION": 42,
                            "MICROSOFT_PAY_PURCHASE": 43,
                            "MICROSOFT_PAY_ACTIVATION": 44,
                            "VISA_CHECKOUT_PURCHASE": 45,
                            "VISA_CHECKOUT_ACTIVATION": 46,
                            "FACEBOOK_TOKEN_PURCHASE": 47,
                            "FACEBOOK_TOKEN_ACTIVATION": 48,
                            "NETFLIX_TOKEN_PURCHASE": 49,
                            "NETFLIX_TOKEN_ACTIVATION": 50,
                            "ATM_TRANSFER": 51,
                            "BITCOIN_TRADE_SETTLEMENT": 52,
                            "CAVIAR_SETTLEMENT": 53,
                            "DIGITAL_WALLET_PURCHASE": 54,
                            "SECURITIES_TRADE": 55,
                            "SECURITIES_DIVIDEND_PAYMENT": 56,
                            "SECURITIES_CORPORATE_ACTION": 57,
                            "ACCOUNT_FUNDING_TRANSACTION": 58,
                            "ORIGINAL_CREDIT_TRANSACTION": 59,
                            "CUSTOMER_MERGE": 60,
                            "LENDING_CASH_ADVANCE": 61,
                            "SECURITIES_TRADE_ERROR_CORRECTION": 62,
                            "ADMIN_BALANCE_ADJUSTMENT": 63,
                            "APPLE_PAY_NOT_PRESENT_PURCHASE": 64,
                            "ANDROID_PAY_NOT_PRESENT_PURCHASE": 65,
                            "BITCOIN_P2P": 66,
                            "MONEY_ORDER": 67,
                            "PAPER_MONEY_DEPOSIT": 68,
                            "PWC_PURCHASE": 69,
                            "INSTANT_PAY_ADVANCE": 70,
                            "INSTANT_PAY_PAYBACK": 71,
                            "SPONSORED_CARD_ACTIVATION": 72,
                            "WIRE": 73,
                            "LIGHTNING_TRANSFER": 74,
                            "LENDING_DRAWDOWN": 75,
                            "LENDING_PAYMENT": 76,
                            "LENDING_REFUND": 77,
                            "LENDING_LATE_FEE": 78,
                            "LENDING_INTEREST": 79,
                            "LENDING_ADJUSTMENT": 80,
                            "CRYPTO_PAYROLL_CONVERSION": 81,
                            "CRYPTO_CASH_CARD_ROUND_UP": 82,
                            "REMITTANCE_P2P_PAYMENT": 83,
                            "SAVINGS_TRANSFER": 84,
                            "OVERDRAFT_LIMIT_UPDATE": 85,
                            "OVERDRAFT_REPAYMENT": 86,
                            "OVERDRAFT_NON_REPAYMENT_UPDATE": 87,
                            "SQUARE_TAP_TO_PAY": 88,
                            "OVERDRAFT_RECOUP_REPAYMENT": 89,
                            "OVERDRAFT_MANUAL_REPAYMENT": 90,
                            "SAVINGS_INTEREST": 91,
                            "BITCOIN_WITHDRAWAL": 92,
                            "ONE_TIME_HOLD_TAX_LEVY": 93,
                            "CONTINUOUS_HOLD_TAX_LEVY": 94,
                            "CRYPTO_PURCHASE": 95,
                            "EQUITY_PURCHASE": 96,
                            "REMITTANCE": 97,
                            "RECEIVERSHIP": 98,
                            "INFORMATION_SUBPOENA": 99,
                            "USDC_BUY": 100,
                            "USDC_SELL": 101,
                            "MONEY_POOL_PAYMENT": 102,
                            "MONEY_POOL_TRANSFER": 103,
                            "SQUARE_TIP_PAYMENT": 104
                        }
                    },
                    "TransactionDeclineReason": {
                        "values": {
                            "UNKNOWN": 1,
                            "INSUFFICIENT_BALANCE": 2,
                            "POTENTIALLY_INSUFFICIENT_BALANCE": 3,
                            "BLOCKED_BY_RISK": 4,
                            "CARD_DISABLED": 5,
                            "INVALID_CURRENCY": 6,
                            "RISK_SYSTEMS_UNAVAILABLE": 7
                        }
                    },
                    "TransactionEvent": {
                        "fields": {
                            "token": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                            },
                            "transactionToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                            },
                            "type": {
                                "type": ".squareup.banklin.TransactionState",
                                "id": 3,
                                "rule": "optional"
                            },
                            "externalSystem": {
                                "type": ".squareup.banklin.external.ExternalSystem",
                                "id": 4,
                                "rule": "optional"
                            },
                            "externalSystemId": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                            },
                            "balanceToken": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                            },
                            "instrumentToken": {
                                "type": "string",
                                "id": 7,
                                "rule": "optional"
                            },
                            "occurredAt": {
                                "type": "int64",
                                "id": 8,
                                "rule": "optional"
                            },
                            "eventOrder": {
                                "type": "int64",
                                "id": 16,
                                "rule": "optional"
                            },
                            "amount": {
                                "type": ".squareup.common.Money",
                                "id": 9,
                                "rule": "optional"
                            },
                            "balanceSnapshotAmount": {
                                "type": ".squareup.common.Money",
                                "id": 10,
                                "rule": "optional"
                            },
                            "description": {
                                "type": "string",
                                "id": 11,
                                "rule": "optional"
                            },
                            "reference": {
                                "type": "string",
                                "id": 12,
                                "rule": "optional"
                            },
                            "declineReason": {
                                "type": ".squareup.banklin.TransactionDeclineReason",
                                "id": 13,
                                "rule": "optional"
                            },
                            "balanceSnapshotVersion": {
                                "type": "int64",
                                "id": 14,
                                "rule": "optional"
                            },
                            "octopusResult": {
                                "type": ".squareup.banklin.octopus.OctopusResult",
                                "id": 15,
                                "rule": "optional"
                            },
                            "reasonCode": {
                                "type": ".squareup.banklin.TransactionReasonCode",
                                "id": 18,
                                "rule": "optional"
                            },
                            "kind": {
                                "type": ".squareup.banklin.EventKind",
                                "id": 19,
                                "rule": "optional"
                            },
                            "amountType": {
                                "type": ".squareup.banklin.AmountType",
                                "id": 31,
                                "rule": "optional"
                            },
                            "merchantToken": {
                                "type": "string",
                                "id": 20,
                                "rule": "optional"
                            },
                            "expiresAt": {
                                "type": "int64",
                                "id": 21,
                                "rule": "optional"
                            },
                            "customerToken": {
                                "type": "string",
                                "id": 23,
                                "rule": "optional"
                            },
                            "precedingRelatedExternalSystemId": {
                                "type": "string",
                                "id": 25,
                                "rule": "optional"
                            },
                            "disputeFundsAvailability": {
                                "type": ".squareup.banklin.DisputeFundsAvailability",
                                "id": 26,
                                "rule": "optional"
                            },
                            "customerFeeSatoshis": {
                                "type": "uint64",
                                "id": 27,
                                "rule": "optional"
                            },
                            "targetWalletAddress": {
                                "type": "string",
                                "id": 28,
                                "rule": "optional"
                            },
                            "balanceType": {
                                "type": ".squareup.banklin.StoredValueBalance.Type",
                                "id": 29,
                                "rule": "optional"
                            },
                            "internationalFee": {
                                "type": ".squareup.common.Money",
                                "id": 30,
                                "rule": "optional"
                            },
                            "discount": {
                                "type": ".squareup.banklin.TransactionEvent.Discount",
                                "id": 22
                            }
                        },
                        "nested": {
                            "Discount": {
                                "fields": {
                                    "amount": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "discountAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "rewardDiscount": {
                                        "type": ".squareup.banklin.RewardDiscount",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "reward": {
                                        "type": ".squareup.banklin.rewards.Reward",
                                        "id": 1
                                    }
                                },
                                "nested": {
                                    "source": {
                                        "oneof": [
                                            "reward"
                                        ]
                                    }
                                }
                            },
                            "kind_specific_details": {
                                "oneof": [
                                    "discount"
                                ]
                            }
                        }
                    },
                    "DisputeFundsAvailability": {
                        "values": {
                            "RELEASE_TO_CUSTOMER": 1,
                            "WITHHOLD": 2,
                            "ISSUED": 3,
                            "NOT_ISSUED": 4
                        }
                    },
                    "AmountType": {
                        "values": {
                            "AMOUNT_TYPE_UNSPECIFIED": 0,
                            "AMOUNT_TYPE_PRINCIPAL": 1,
                            "AMOUNT_TYPE_ACQUIRER_FEE": 2,
                            "AMOUNT_TYPE_DISCOUNT": 3,
                            "AMOUNT_TYPE_CASH_APP_FEE": 4,
                            "AMOUNT_TYPE_CASH_BACK": 5,
                            "AMOUNT_TYPE_ACQUIRER_FEE_REIMBURSEMENT": 6,
                            "AMOUNT_TYPE_CASH_APP_FEE_REIMBURSEMENT": 7,
                            "AMOUNT_TYPE_GOVERNMENT_FEE": 8,
                            "AMOUNT_TYPE_TAX_WITHHOLDING": 9,
                            "AMOUNT_TYPE_LOAN_PRINCIPAL": 10,
                            "AMOUNT_TYPE_LOAN_INTEREST": 11,
                            "AMOUNT_TYPE_LOAN_SETUP_FEE": 12,
                            "AMOUNT_TYPE_LOAN_LATE_FEE": 13,
                            "AMOUNT_TYPE_CREDIT_CARD_FEE": 14,
                            "AMOUNT_TYPE_BUSINESS_FEE": 15,
                            "AMOUNT_TYPE_INSTANT_DEPOSIT_FEE": 16,
                            "AMOUNT_TYPE_INTERNATIONAL_FEE": 17,
                            "AMOUNT_TYPE_INTERNATIONAL_FEE_REIMBURSEMENT": 18,
                            "AMOUNT_TYPE_OUT_OF_NETWORK_FEE": 19
                        }
                    },
                    "EventKind": {
                        "values": {
                            "NO_AUTHORIZATION": 1,
                            "AUTHORIZATION": 2,
                            "PREAUTHORIZATION": 3,
                            "AFD_PREAUTHORIZATION": 4,
                            "AUTH_ADJUSTMENT": 5,
                            "ACQUIRER_FEE": 6,
                            "DISCOUNT": 7,
                            "SUBMITTED_TO_BITBANK": 8,
                            "SENT_TO_BLOCKCHAIN": 9,
                            "AUTH_OVERRIDE": 10,
                            "AUTH_INCREMENTAL": 11,
                            "MERCHANT_REVERSAL": 12,
                            "ISSUER_REVERSAL": 13,
                            "BOOKKEEPING": 14,
                            "CASH_APP_FEE": 15,
                            "PARTIAL_CAPTURE": 16,
                            "CASH_BACK": 17,
                            "RECEIVED_FROM_BLOCKCHAIN": 18,
                            "CASH_APP_FEE_REIMBURSEMENT": 19,
                            "ACQUIRER_FEE_REIMBURSEMENT": 20,
                            "SETTLED_INTERNALLY": 21,
                            "EARLY_DIRECT_DEPOSIT": 22,
                            "PROVISIONAL_CREDIT_ISSUED": 23,
                            "PROVISIONAL_CREDIT_WITHHELD": 24,
                            "PARTIAL_AUTH": 25,
                            "PAPER_CASH_DEPOSIT": 26,
                            "GOVERNMENT_FEE": 27,
                            "TAX_WITHHOLDING": 28,
                            "LOAN_PRINCIPAL": 29,
                            "LOAN_INTEREST": 30,
                            "LOAN_SETUP_FEE": 31,
                            "LOAN_LATE_FEE": 32,
                            "INTERNAL_REVERSAL": 33,
                            "RULE_BASED_AUTO_INTERNAL_REVERSAL": 34,
                            "AGENT_INTERNAL_REVERSAL": 35,
                            "INTERNATIONAL_FEE": 36,
                            "INTERNATIONAL_FEE_REIMBURSEMENT": 37,
                            "CREDIT_CARD_FEE": 38,
                            "INSTANT_DEPOSIT_FEE": 39,
                            "BUSINESS_FEE": 40,
                            "OUT_OF_NETWORK_FEE": 41
                        }
                    },
                    "RewardDiscount": {
                        "fields": {
                            "discountToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                            },
                            "missingRewardReportToken": {
                                "type": "string",
                                "id": 7,
                                "rule": "optional"
                            },
                            "missingRewardReportData": {
                                "type": ".squareup.banklin.RewardDiscount.MissingRewardReportData",
                                "id": 8,
                                "rule": "optional"
                            },
                            "crossCurrencyReward": {
                                "type": ".squareup.common.Money",
                                "id": 9,
                                "rule": "optional"
                            },
                            "crossCurrencyRewardExchangeRate": {
                                "type": ".squareup.common.Money",
                                "id": 10,
                                "rule": "optional"
                            },
                            "cardTransactionToken": {
                                "type": "string",
                                "id": 11,
                                "rule": "optional"
                            },
                            "rewardTransactionToken": {
                                "type": "string",
                                "id": 12,
                                "rule": "optional"
                            },
                            "crossCurrencyRewardInfo": {
                                "type": ".squareup.banklin.RewardDiscount.CrossCurrencyRewardInfo",
                                "id": 13,
                                "rule": "optional"
                            },
                            "rewardAmount": {
                                "type": ".squareup.common.Money",
                                "id": 5
                            },
                            "rewardBasisPoints": {
                                "type": "int64",
                                "id": 6
                            }
                        },
                        "nested": {
                            "MissingRewardReportData": {
                                "fields": {
                                    "missingRewardReportToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "approvedOnce": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "approvalReason": {
                                        "type": ".squareup.banklin.RewardDiscount.MissingRewardReportData.ApprovalReason",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "ApprovalReason": {
                                        "values": {
                                            "MERCHANT_DATA_UPDATED": 1,
                                            "ONE_TIME_APPROVAL_SILENT": 2,
                                            "ONE_TIME_APPROVAL": 3
                                        }
                                    }
                                }
                            },
                            "CrossCurrencyRewardInfo": {
                                "fields": {
                                    "rewardAmount": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "rewardCurrency": {
                                        "type": ".squareup.common.CurrencyCode",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "rewardValueSnapshot": {
                                        "type": ".squareup.common.Money",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "rewardExchangeRate": {
                                        "type": ".squareup.common.Money",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "rewardTransactionToken": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "cardTransactionToken": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "discount": {
                                "oneof": [
                                    "rewardAmount",
                                    "rewardBasisPoints"
                                ]
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.TransactionState && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.TransactionReasonCode && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.TransactionDeclineReason && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.TransactionEvent && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.TransactionEvent?.nested?.Discount && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.DisputeFundsAvailability && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.AmountType && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.EventKind && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount?.nested?.MissingRewardReportData && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount?.nested?.MissingRewardReportData?.nested?.ApprovalReason && !$175b90705c9182e7$var$$root.nested?.squareup?.nested?.banklin?.nested?.RewardDiscount?.nested?.CrossCurrencyRewardInfo) $175b90705c9182e7$var$$root.addJSON($175b90705c9182e7$var$jsonData);
const $175b90705c9182e7$export$52a28250c602ca8a = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.TransactionState').values;
const $175b90705c9182e7$export$7154d4c57f05541c = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.TransactionReasonCode').values;
const $175b90705c9182e7$export$af7292a86c4af22c = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.TransactionDeclineReason').values;
const $175b90705c9182e7$export$71730754b67b3035 = $175b90705c9182e7$var$$root.lookupType('squareup.banklin.TransactionEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($175b90705c9182e7$export$71730754b67b3035);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($175b90705c9182e7$export$71730754b67b3035);
/**
 * SOURCE Discount @ squareup/banklin/transaction.proto at 631:3
 */ $175b90705c9182e7$export$71730754b67b3035.Discount = $175b90705c9182e7$var$$root.lookupType('squareup.banklin.TransactionEvent.Discount');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($175b90705c9182e7$export$71730754b67b3035.Discount);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($175b90705c9182e7$export$71730754b67b3035.Discount);
const $175b90705c9182e7$export$d56a4336bd979175 = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.DisputeFundsAvailability').values;
const $175b90705c9182e7$export$4ced26ff9a1ce1ae = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.AmountType').values;
const $175b90705c9182e7$export$50508d7849040d51 = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.EventKind').values;
const $175b90705c9182e7$export$e33da8b6e7e2c746 = $175b90705c9182e7$var$$root.lookupType('squareup.banklin.RewardDiscount');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($175b90705c9182e7$export$e33da8b6e7e2c746);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($175b90705c9182e7$export$e33da8b6e7e2c746);
/**
 * SOURCE MissingRewardReportData @ squareup/banklin/transaction.proto at 969:3
 */ $175b90705c9182e7$export$e33da8b6e7e2c746.MissingRewardReportData = $175b90705c9182e7$var$$root.lookupType('squareup.banklin.RewardDiscount.MissingRewardReportData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($175b90705c9182e7$export$e33da8b6e7e2c746.MissingRewardReportData);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($175b90705c9182e7$export$e33da8b6e7e2c746.MissingRewardReportData);
/**
 * SOURCE ApprovalReason @ squareup/banklin/transaction.proto at 972:5
 */ $175b90705c9182e7$export$e33da8b6e7e2c746.MissingRewardReportData.ApprovalReason = $175b90705c9182e7$var$$root.lookupEnum('squareup.banklin.RewardDiscount.MissingRewardReportData.ApprovalReason').values;
/**
 * Populated only if this payment is a boost where the reward is a different currency than the
 * card transaction.  Gives us context related to the reward transaction for display on the card
 * transaction.
 *
 * SOURCE CrossCurrencyRewardInfo @ squareup/banklin/transaction.proto at 996:3
 */ $175b90705c9182e7$export$e33da8b6e7e2c746.CrossCurrencyRewardInfo = $175b90705c9182e7$var$$root.lookupType('squareup.banklin.RewardDiscount.CrossCurrencyRewardInfo');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($175b90705c9182e7$export$e33da8b6e7e2c746.CrossCurrencyRewardInfo);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($175b90705c9182e7$export$e33da8b6e7e2c746.CrossCurrencyRewardInfo);



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $82064d661c002629$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $82064d661c002629$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "DigitalWalletState": {
                        "values": {
                            "REQUESTED": 1,
                            "VERIFICATION_REQUESTED": 2,
                            "REJECTED": 3,
                            "SUSPENDED": 4,
                            "ACTIVE": 5,
                            "REJECTED_INTERNALLY": 6,
                            "FAILED": 7,
                            "TERMINATED": 8,
                            "REQUEST_DECLINED": 9
                        }
                    },
                    "DigitalWalletIssuer": {
                        "values": {
                            "APPLE_PAY": 1,
                            "ANDROID_PAY": 2,
                            "SAMSUNG_PAY": 3,
                            "MICROSOFT_PAY": 4,
                            "VISA_CHECKOUT": 5,
                            "FACEBOOK": 6,
                            "NETFLIX": 7,
                            "UNKNOWN_WALLET_ISSUER": 8,
                            "FITBIT_PAY": 9,
                            "GARMIN_PAY": 10,
                            "SPOTIFY": 11,
                            "ALIPAY": 12,
                            "STRIPE": 13,
                            "VIACOM_INTERNATIONAL": 14,
                            "AMAZON": 15,
                            "UBER": 16,
                            "SCENTBIRD": 17,
                            "SONY_PLAYSTATION": 18,
                            "ONE_PAY": 19,
                            "DOORDASH": 20,
                            "SHOPIFY": 21,
                            "MICROSOFT_NETWORK": 22,
                            "PAYPAL": 23,
                            "AUTOZONE": 24,
                            "WORLDPAY": 25,
                            "STARBUCKS": 26,
                            "TIDAL": 27,
                            "CLASSDOJO": 28,
                            "ANGIES_LIST": 29,
                            "ADOBE": 30,
                            "EBAY": 31
                        }
                    },
                    "DeviceType": {
                        "values": {
                            "MOBILE_PHONE": 1,
                            "WATCH": 2,
                            "TABLET": 3,
                            "LAPTOP": 4,
                            "PERSONAL_COMPUTER": 5,
                            "WEARABLE": 6,
                            "UNKNOWN_DEVICE_TYPE": 10
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$82064d661c002629$var$$root.nested?.squareup?.nested?.banklin?.nested?.DigitalWalletState && !$82064d661c002629$var$$root.nested?.squareup?.nested?.banklin?.nested?.DigitalWalletIssuer && !$82064d661c002629$var$$root.nested?.squareup?.nested?.banklin?.nested?.DeviceType) $82064d661c002629$var$$root.addJSON($82064d661c002629$var$jsonData);
const $82064d661c002629$export$a44a1ae835a585c3 = $82064d661c002629$var$$root.lookupEnum('squareup.banklin.DigitalWalletState').values;
const $82064d661c002629$export$fa3a1177a934b3f1 = $82064d661c002629$var$$root.lookupEnum('squareup.banklin.DigitalWalletIssuer').values;
const $82064d661c002629$export$ec1e04e4e5ef8233 = $82064d661c002629$var$$root.lookupEnum('squareup.banklin.DeviceType').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



const $caa20d27bc7281a1$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $caa20d27bc7281a1$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "invitations": {
                        "nested": {
                            "CardInvitationState": {
                                "values": {
                                    "CARD_INVITATION_STATE_DO_NOT_USE": 0,
                                    "OPEN": 1,
                                    "CLAIMED": 2,
                                    "CLOSED": 3
                                }
                            },
                            "CardInvitationClosedReason": {
                                "values": {
                                    "CLOSED_REASON_DO_NOT_USE": 0,
                                    "EXPIRED": 1,
                                    "REVOKED": 2
                                }
                            },
                            "CardInvitation": {
                                "fields": {
                                    "token": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "inviterPersonToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "inviteePersonToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "balanceId": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "state": {
                                        "type": ".squareup.bizbank.invitations.CardInvitationState",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "closedReason": {
                                        "type": ".squareup.bizbank.invitations.CardInvitationClosedReason",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "expiresAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "createdAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "updatedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$caa20d27bc7281a1$var$$root.nested?.squareup?.nested?.bizbank?.nested?.invitations?.nested?.CardInvitationState && !$caa20d27bc7281a1$var$$root.nested?.squareup?.nested?.bizbank?.nested?.invitations?.nested?.CardInvitationClosedReason && !$caa20d27bc7281a1$var$$root.nested?.squareup?.nested?.bizbank?.nested?.invitations?.nested?.CardInvitation) $caa20d27bc7281a1$var$$root.addJSON($caa20d27bc7281a1$var$jsonData);
const $caa20d27bc7281a1$export$ba2c43813aefeb59 = $caa20d27bc7281a1$var$$root.lookupEnum('squareup.bizbank.invitations.CardInvitationState').values;
const $caa20d27bc7281a1$export$bcc8c651ffea7e86 = $caa20d27bc7281a1$var$$root.lookupEnum('squareup.bizbank.invitations.CardInvitationClosedReason').values;
const $caa20d27bc7281a1$export$285d7a47fed7dbbc = $caa20d27bc7281a1$var$$root.lookupType('squareup.bizbank.invitations.CardInvitation');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($caa20d27bc7281a1$export$285d7a47fed7dbbc);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($caa20d27bc7281a1$export$285d7a47fed7dbbc);


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $3a95a6cf182aa66b$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $3a95a6cf182aa66b$var$jsonData = {
    "squareup": {
        "nested": {
            "banklin": {
                "nested": {
                    "IssuedCard": {
                        "nested": {
                            "CardState": {
                                "values": {
                                    "ACTIVE": 1,
                                    "DISABLED": 2,
                                    "TERMINATED": 3,
                                    "SUSPENDED": 4,
                                    "VERIFIED": 5,
                                    "ISSUED": 6,
                                    "UNDELIVERABLE": 7,
                                    "MONITORED": 12,
                                    "SHIPPED": 8,
                                    "CANCELLED": 9,
                                    "REJECTED": 10,
                                    "DESTROYED": 11
                                }
                            }
                        }
                    },
                    "CardEvent": {
                        "fields": {
                            "issuedCardToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                            },
                            "storedValueToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                            },
                            "issuer": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                            },
                            "type": {
                                "type": ".squareup.banklin.CardEvent.Type",
                                "id": 4,
                                "rule": "optional"
                            },
                            "result": {
                                "type": ".squareup.banklin.CardEvent.Result",
                                "id": 5,
                                "rule": "optional"
                            },
                            "message": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                            },
                            "occurredAt": {
                                "type": "int64",
                                "id": 7,
                                "rule": "optional"
                            },
                            "createdAt": {
                                "type": "int64",
                                "id": 8,
                                "rule": "optional"
                            },
                            "fideliusToken": {
                                "type": "string",
                                "id": 9,
                                "rule": "optional"
                            },
                            "cardState": {
                                "type": ".squareup.banklin.IssuedCard.CardState",
                                "id": 10,
                                "rule": "optional"
                            },
                            "cardType": {
                                "type": ".squareup.banklin.CardType",
                                "id": 11,
                                "rule": "optional"
                            },
                            "customerToken": {
                                "type": "string",
                                "id": 12,
                                "rule": "optional"
                            }
                        },
                        "nested": {
                            "Result": {
                                "values": {
                                    "SUCCESS": 1,
                                    "FAILED": 2,
                                    "ISSUER_EXCEPTION": 3,
                                    "SUSPECTED_FRAUD": 4
                                }
                            },
                            "Type": {
                                "values": {
                                    "ACTIVATED": 1,
                                    "DISABLED": 2,
                                    "ENABLED": 3,
                                    "SUSPENDED": 4,
                                    "REINSTATED": 5,
                                    "ISSUED": 6,
                                    "TERMINATED": 7,
                                    "VERIFIED": 8,
                                    "SHIPPED": 9,
                                    "CANCELLED": 10,
                                    "REJECTED": 11,
                                    "DESTROYED": 12,
                                    "SET_PIN": 13,
                                    "UNDELIVERABLE": 14,
                                    "REISSUED_LOST_OR_STOLEN": 15,
                                    "REISSUED_DAMAGED": 16,
                                    "UPDATED_IDV": 17,
                                    "UPDATED_ADDRESS": 18,
                                    "UPDATED_EMAIL": 19,
                                    "COURIER_FIRST_SCANNED": 20,
                                    "COURIER_IN_HOME_FORECAST": 21,
                                    "COURIER_UNDELIVERABLE": 22,
                                    "UPDATED_USER": 23,
                                    "DEACTIVATED_USER": 24,
                                    "ENABLED_ENHANCED_MONITORING": 25,
                                    "ACTIVATED_USER": 26,
                                    "SET_PRIMARY": 27,
                                    "UNSET_PRIMARY": 28,
                                    "UPDATED_BUSINESS": 29,
                                    "DISABLED_ENHANCED_MONITORING": 30,
                                    "ORDERED": 31,
                                    "ACTIVATION_ATTEMPT": 32,
                                    "ACTIVATION_RISK_EVALUATED": 33
                                }
                            }
                        }
                    },
                    "CardType": {
                        "values": {
                            "VIRTUAL": 1,
                            "PHYSICAL": 2
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$3a95a6cf182aa66b$var$$root.nested?.squareup?.nested?.banklin?.nested?.IssuedCard?.nested?.CardState && !$3a95a6cf182aa66b$var$$root.nested?.squareup?.nested?.banklin?.nested?.CardEvent && !$3a95a6cf182aa66b$var$$root.nested?.squareup?.nested?.banklin?.nested?.CardEvent?.nested?.Result && !$3a95a6cf182aa66b$var$$root.nested?.squareup?.nested?.banklin?.nested?.CardEvent?.nested?.Type && !$3a95a6cf182aa66b$var$$root.nested?.squareup?.nested?.banklin?.nested?.CardType) $3a95a6cf182aa66b$var$$root.addJSON($3a95a6cf182aa66b$var$jsonData);
const $3a95a6cf182aa66b$export$e4a7553722ed8603 = {};
/**
 * SOURCE CardState @ squareup/banklin/issued_card.proto at 80:3
 */ $3a95a6cf182aa66b$export$e4a7553722ed8603.CardState = $3a95a6cf182aa66b$var$$root.lookupEnum('squareup.banklin.IssuedCard.CardState').values;
const $3a95a6cf182aa66b$export$fd2b87ee9b86c6df = $3a95a6cf182aa66b$var$$root.lookupType('squareup.banklin.CardEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3a95a6cf182aa66b$export$fd2b87ee9b86c6df);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3a95a6cf182aa66b$export$fd2b87ee9b86c6df);
/**
 * SOURCE Result @ squareup/banklin/issued_card.proto at 187:3
 */ $3a95a6cf182aa66b$export$fd2b87ee9b86c6df.Result = $3a95a6cf182aa66b$var$$root.lookupEnum('squareup.banklin.CardEvent.Result').values;
/**
 * SOURCE Type @ squareup/banklin/issued_card.proto at 194:3
 */ $3a95a6cf182aa66b$export$fd2b87ee9b86c6df.Type = $3a95a6cf182aa66b$var$$root.lookupEnum('squareup.banklin.CardEvent.Type').values;
const $3a95a6cf182aa66b$export$f1a79bffad3377cd = $3a95a6cf182aa66b$var$$root.lookupEnum('squareup.banklin.CardType').values;



/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $65c896b44f717dd1$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $65c896b44f717dd1$var$jsonData = {
    "squareup": {
        "nested": {
            "common": {
                "nested": {
                    "instrument": {
                        "nested": {
                            "InstrumentType": {
                                "values": {
                                    "UNKNOWN": 1,
                                    "VISA": 2,
                                    "MASTER_CARD": 3,
                                    "AMERICAN_EXPRESS": 4,
                                    "DISCOVER": 5,
                                    "DISCOVER_DINERS": 6,
                                    "JCB": 7,
                                    "BALANCE": 8,
                                    "UNION_PAY": 9,
                                    "SQUARE_GIFT_CARD_V2": 10,
                                    "INTERAC": 11,
                                    "SQUARE_CAPITAL_CARD": 12,
                                    "EFTPOS": 13,
                                    "FELICA": 14,
                                    "ALIPAY": 15,
                                    "CASH_APP": 16,
                                    "EBT": 17,
                                    "PAYPAY": 18,
                                    "AFTERPAY": 19,
                                    "SQUARE_ACCOUNT_BALANCE": 20,
                                    "AU_PAY": 21,
                                    "MERPAY": 22,
                                    "RAKUTEN_PAY": 23,
                                    "D_BARAI": 24,
                                    "WECHAT_PAY": 25
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$65c896b44f717dd1$var$$root.nested?.squareup?.nested?.common?.nested?.instrument?.nested?.InstrumentType) $65c896b44f717dd1$var$$root.addJSON($65c896b44f717dd1$var$jsonData);
const $65c896b44f717dd1$export$8facc574da228694 = $65c896b44f717dd1$var$$root.lookupEnum('squareup.common.instrument.InstrumentType').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 


const $41eeb8c0a39de798$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $41eeb8c0a39de798$var$jsonData = {
    "squareup": {
        "nested": {
            "solidshop": {
                "nested": {
                    "VerifyShippingAddressResponse": {
                        "nested": {
                            "CorrectedField": {
                                "values": {
                                    "UNKNOWN_FIELD": 0,
                                    "POSTAL_CODE": 1,
                                    "LOCALITY": 2,
                                    "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                                    "ADDRESS_LINE_1": 4,
                                    "ADDRESS_LINE_2": 5
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$41eeb8c0a39de798$var$$root.nested?.squareup?.nested?.solidshop?.nested?.VerifyShippingAddressResponse?.nested?.CorrectedField) $41eeb8c0a39de798$var$$root.addJSON($41eeb8c0a39de798$var$jsonData);
const $41eeb8c0a39de798$export$d8fc9e0b7f205a8c = {};
/**
 * Which fields were corrected in the corrected address
 *
 * SOURCE CorrectedField @ squareup/solidshop/addressVerification/service.proto at 67:3
 */ $41eeb8c0a39de798$export$d8fc9e0b7f205a8c.CorrectedField = $41eeb8c0a39de798$var$$root.lookupEnum('squareup.solidshop.VerifyShippingAddressResponse.CorrectedField').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 






const $e57ed9311822f585$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $e57ed9311822f585$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "unified_activity": {
                        "nested": {
                            "UnifiedActivity": {
                                "fields": {
                                    "activityToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "latestEventAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "activityType": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityType",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "activityState": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityState",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "description": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "amount": {
                                        "type": ".squareup.common.Money",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "balance": {
                                        "type": ".squareup.common.Money",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "merchantImage": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "declineReason": {
                                        "type": "string",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "cardLastFour": {
                                        "type": "string",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "transactionReasonCode": {
                                        "type": ".squareup.banklin.TransactionReasonCode",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "merchantCanonicalCategory": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.MerchantCanonicalCategory",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "banklinCardToken": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "balanceToken": {
                                        "type": "string",
                                        "id": 16,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "ActivityType": {
                                        "values": {
                                            "UNKNOWN": 0,
                                            "CARD_PAYMENT": 1,
                                            "ATM_WITHDRAWAL": 2,
                                            "DEBIT_CARD_TRANSFER_IN": 3,
                                            "STANDARD_TRANSFER_OUT": 4,
                                            "INSTANT_TRANSFER_OUT": 5,
                                            "CARD_PROCESSING_SALES": 6,
                                            "CARD_PROCESSING_ADJUSTMENTS": 7,
                                            "PROMOTIONAL_REWARD": 8,
                                            "PAYROLL": 9,
                                            "PAYROLL_CANCELLATION": 10,
                                            "DIRECT_DEPOSIT_IN": 11,
                                            "DIRECT_DEPOSIT_OUT": 12,
                                            "CAPITAL_LOAN": 13,
                                            "CAPITAL_LOAN_CANCELLATION": 14,
                                            "CHECK_TRANSFER_IN": 15,
                                            "BALANCE_TRANSFER_SFS_AND_BANKLIN": 16,
                                            "BALANCE_TRANSFER_OTHER": 17,
                                            "BALANCE_TRANSFER_IN_SFS_TO_BANKLIN": 18,
                                            "BALANCE_TRANSFER_OUT_BANKLIN_TO_SFS": 19,
                                            "DEBIT_CARD_PAY_IN_CHARGEBACK": 20,
                                            "DIRECT_DEPOSIT_IN_CHARGEBACK": 21,
                                            "CHECK_TRANSFER_IN_CHARGEBACK": 22,
                                            "BILL_PAYMENT": 23
                                        }
                                    },
                                    "ActivityState": {
                                        "values": {
                                            "PENDING": 1,
                                            "SETTLED": 2,
                                            "VOIDED": 3,
                                            "DECLINED": 4,
                                            "REFUNDED": 5,
                                            "REVERSED": 6,
                                            "DISPUTED": 7,
                                            "DISPUTE_REVERSED": 8,
                                            "DISPUTE_WON": 9,
                                            "IN_REVIEW": 10,
                                            "IN_REVERSAL": 11,
                                            "WAITING_ON_EXTERNAL": 12,
                                            "INITIATED": 13
                                        }
                                    },
                                    "MerchantImage": {
                                        "fields": {
                                            "merchantImageUrl": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "colorCode": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "backgroundColorCode": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "isPrerendered": {
                                                "type": "bool",
                                                "id": 4,
                                                "rule": "optional",
                                                "options": {
                                                    "default": false
                                                }
                                            }
                                        }
                                    },
                                    "MerchantCanonicalCategory": {
                                        "fields": {
                                            "name": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "UnifiedActivityEvent": {
                                "fields": {
                                    "activityToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "occurredAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "activityType": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityType",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "activityState": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityState",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "description": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "amount": {
                                        "type": ".squareup.common.Money",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "balance": {
                                        "type": ".squareup.common.Money",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "merchantImage": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "eventToken": {
                                        "type": "string",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "declineReason": {
                                        "type": "string",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "cardLastFour": {
                                        "type": "string",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "modifierType": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier.ModifierType",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "bizbankCardToken": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "sourceApp": {
                                        "type": "string",
                                        "id": 16,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetUnifiedActivitiesRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "activityStateCategory": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.ActivityStateCategory",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "filters": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.Filters",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "batchRequest": {
                                        "type": ".squareup.bizbank.model.BatchRequest",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "currentTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "ActivityStateCategory": {
                                        "values": {
                                            "PENDING": 1,
                                            "COMPLETED": 2
                                        }
                                    },
                                    "Filters": {
                                        "fields": {
                                            "includeActivityTypes": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityType",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "minLatestEventAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "maxLatestEventAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "maxRetroactiveBalanceVersion": {
                                                "type": "int64",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "onlyIncludeBalanceActivities": {
                                                "type": "bool",
                                                "id": 5,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetUnifiedActivitiesResponse": {
                                "fields": {
                                    "response": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse.Response",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Response": {
                                        "fields": {
                                            "unifiedActivities": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "paginationToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "hasHiddenBalanceActivityTransactions": {
                                                "type": "bool",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "response",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "UnifiedActivityDetails": {
                                "fields": {
                                    "description": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "modifiers": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier",
                                        "id": 3,
                                        "rule": "repeated"
                                    },
                                    "grossAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "netAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "externalLink": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails.ExternalLink",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "attachments": {
                                        "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails.Attachment",
                                        "id": 7,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "Modifier": {
                                        "fields": {
                                            "modifierType": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier.ModifierType",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "modifierAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "modifierAmountDescription": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "ModifierType": {
                                                "values": {
                                                    "DO_NOT_USE": 0,
                                                    "COMMUNITY_REWARD": 1,
                                                    "ATM_WITHDRAWAL_FEE": 2,
                                                    "INSTANT_TRANSFER_FEE": 3,
                                                    "CASHBACK": 4,
                                                    "CARD_PAYMENT_FEE": 5,
                                                    "GENERIC_REWARD": 6
                                                }
                                            }
                                        }
                                    },
                                    "ExternalLink": {
                                        "fields": {
                                            "title": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "url": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "Attachment": {
                                        "fields": {
                                            "localizedLabel": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "imageData": {
                                                "type": "bytes",
                                                "id": 2
                                            }
                                        },
                                        "nested": {
                                            "content": {
                                                "oneof": [
                                                    "imageData"
                                                ]
                                            }
                                        }
                                    }
                                }
                            },
                            "GetUnifiedActivityDetailsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "activityToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "currentTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetUnifiedActivityDetailsResponse": {
                                "fields": {
                                    "response": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse.Response",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Response": {
                                        "fields": {
                                            "unifiedActivity": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "unifiedActivityDetails": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivityDetails",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "response",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "GetUnifiedActivityEventsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "filters": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventsRequest.Filters",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "batchRequest": {
                                        "type": ".squareup.bizbank.model.BatchRequest",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Filters": {
                                        "fields": {
                                            "minOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "maxOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "activityToken": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "transactionToken": {
                                                "type": "string",
                                                "id": 4,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetUnifiedActivityEventsResponse": {
                                "fields": {
                                    "response": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventsResponse.Response",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Response": {
                                        "fields": {
                                            "unifiedActivityEvents": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivityEvent",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "paginationToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "unitToken": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "response",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "GetUnifiedActivityEventDetailsRequest": {
                                "fields": {
                                    "eventToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetUnifiedActivityEventDetailsResponse": {
                                "fields": {
                                    "response": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsResponse.Response",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Response": {
                                        "fields": {
                                            "unifiedActivityEvent": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivityEvent",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "response",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "LineItem": {
                                "fields": {
                                    "type": {
                                        "type": ".squareup.bizbank.unified_activity.LineItem.LineItemType",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "total": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "LineItemType": {
                                        "values": {
                                            "UNKNOWN": 0,
                                            "PROCESSING_CARD_PAYMENTS": 1,
                                            "PROCESSING_CARD_REFUNDS": 2,
                                            "PROCESSING_CARD_TOTAL_COLLECTED": 3,
                                            "PROCESSING_CARD_FEES": 4,
                                            "PROCESSING_FREE_PROCESSING_CREDIT": 5,
                                            "PROCESSING_SQUARE_CAPITAL_REPAYMENT": 6,
                                            "PROCESSING_DISPUTES": 7,
                                            "PROCESSING_RESERVES_HELD": 8,
                                            "PROCESSING_RESERVES_RELEASED": 9,
                                            "PROCESSING_OTHER_ADJUSTMENTS": 10,
                                            "TRANSFERS_OUT": 11,
                                            "TRANSFERS_INSTANT_FEES": 12,
                                            "TRANSFERS_IN": 13,
                                            "TRANSFERS_BANK_ACCOUNT_DEBITS": 14,
                                            "PROCESSING_SAVINGS_TRANSFER": 15,
                                            "CARD_PAYMENT": 16,
                                            "ATM_WITHDRAWAL": 17,
                                            "PROMOTIONAL_REWARD": 18
                                        }
                                    }
                                }
                            },
                            "TopLevelLineItem": {
                                "fields": {
                                    "type": {
                                        "type": ".squareup.bizbank.unified_activity.TopLevelLineItem.TopLevelLineItemType",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "total": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "subLineItems": {
                                        "type": ".squareup.bizbank.unified_activity.LineItem",
                                        "id": 3,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "TopLevelLineItemType": {
                                        "values": {
                                            "UNKNOWN": 0,
                                            "PAYMENT_PROCESSING": 1,
                                            "SQUARE_CARD_SPEND": 2,
                                            "TRANSFERS": 3,
                                            "PAYROLL": 4,
                                            "LOANS": 5
                                        }
                                    }
                                }
                            },
                            "BalanceOverview": {
                                "fields": {
                                    "startingBalance": {
                                        "type": ".squareup.common.Money",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "endingBalance": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "lineItems": {
                                        "type": ".squareup.bizbank.unified_activity.TopLevelLineItem",
                                        "id": 3,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "GetBalanceOverviewRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "startTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "endTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "maxRetroactiveBalanceVersion": {
                                        "type": "int64",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetBalanceOverviewResponse": {
                                "fields": {
                                    "balanceOverview": {
                                        "type": ".squareup.bizbank.unified_activity.BalanceOverview",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "result": {
                                        "oneof": [
                                            "balanceOverview",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "PaymentProcessingDetails": {
                                "fields": {
                                    "lineItems": {
                                        "type": ".squareup.bizbank.unified_activity.LineItem",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "GetPaymentProcessingDetailsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "startTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "endTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetPaymentProcessingDetailsResponse": {
                                "fields": {
                                    "paymentProcessingDetails": {
                                        "type": ".squareup.bizbank.unified_activity.PaymentProcessingDetails",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "result": {
                                        "oneof": [
                                            "paymentProcessingDetails",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            },
                            "GetUnifiedActivityTransitionDataRequest": {
                                "fields": {
                                    "pendingActivitiesPaginationToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "recentEventsPaginationTokens": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataRequest.RecentEventsPaginationTokens",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1
                                    },
                                    "balanceToken": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "RecentEventsPaginationTokens": {
                                        "fields": {
                                            "bankcPaginationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "nonBankcPaginationToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "token": {
                                        "oneof": [
                                            "unitToken",
                                            "balanceToken"
                                        ]
                                    }
                                }
                            },
                            "GetUnifiedActivityTransitionDataResponse": {
                                "fields": {
                                    "transitionData": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData",
                                        "id": 1
                                    },
                                    "error": {
                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionDataError",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "AccountTokens": {
                                        "fields": {
                                            "unitToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "balanceToken": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "TransitionData": {
                                        "fields": {
                                            "accountsTokens": {
                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.AccountTokens",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "latestHistoricalBalance": {
                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.LatestRecord",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "latestRetroactiveBalance": {
                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.LatestRecord",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "pendingActivitiesAndEvents": {
                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.PendingActivitiesAndEvents",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "recentEvents": {
                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents",
                                                "id": 5,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "RecordTokens": {
                                                "fields": {
                                                    "eventToken": {
                                                        "type": "string",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "activityToken": {
                                                        "type": "string",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    },
                                                    "transactionToken": {
                                                        "type": "string",
                                                        "id": 3,
                                                        "rule": "optional"
                                                    }
                                                }
                                            },
                                            "LatestRecord": {
                                                "fields": {
                                                    "latestRecordTokens": {
                                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecordTokens",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "balanceAmount": {
                                                        "type": ".squareup.common.Money",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    },
                                                    "balanceVersion": {
                                                        "type": "int64",
                                                        "id": 3,
                                                        "rule": "optional"
                                                    },
                                                    "paginationToken": {
                                                        "type": "string",
                                                        "id": 4,
                                                        "rule": "optional"
                                                    },
                                                    "latestRecordTimestamp": {
                                                        "type": ".squareup.common.time.DateTime",
                                                        "id": 5,
                                                        "rule": "optional"
                                                    },
                                                    "subsequentSweepActivity": {
                                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.LatestRecord.SubsequentSweepActivity",
                                                        "id": 6,
                                                        "rule": "optional"
                                                    }
                                                },
                                                "nested": {
                                                    "SubsequentSweepActivity": {
                                                        "fields": {
                                                            "transactionToken": {
                                                                "type": "string",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "amount": {
                                                                "type": ".squareup.common.Money",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            },
                                                            "balanceAmount": {
                                                                "type": ".squareup.common.Money",
                                                                "id": 3,
                                                                "rule": "optional"
                                                            },
                                                            "balanceVersion": {
                                                                "type": "int64",
                                                                "id": 4,
                                                                "rule": "optional"
                                                            },
                                                            "updatedAt": {
                                                                "type": ".squareup.common.time.DateTime",
                                                                "id": 5,
                                                                "rule": "optional"
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "PendingActivitiesAndEvents": {
                                                "fields": {
                                                    "pendingActivitiesAndEvents": {
                                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.PendingActivitiesAndEvents.PendingActivityAndEvents",
                                                        "id": 1,
                                                        "rule": "repeated"
                                                    },
                                                    "pendingActivitiesPaginationToken": {
                                                        "type": "string",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    }
                                                },
                                                "nested": {
                                                    "PendingActivityAndEvents": {
                                                        "fields": {
                                                            "tokens": {
                                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecordTokens",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "activity": {
                                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            },
                                                            "events": {
                                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivityEvent",
                                                                "id": 3,
                                                                "rule": "repeated"
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "RecentEvents": {
                                                "fields": {
                                                    "recentBankcEvents": {
                                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents.RecentEvent",
                                                        "id": 1,
                                                        "rule": "repeated"
                                                    },
                                                    "recentOtherEvents": {
                                                        "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents.RecentEvent",
                                                        "id": 2,
                                                        "rule": "repeated"
                                                    },
                                                    "recentEventsPaginationTokenBankc": {
                                                        "type": "string",
                                                        "id": 3,
                                                        "rule": "optional"
                                                    },
                                                    "recentEventsPaginationTokenOther": {
                                                        "type": "string",
                                                        "id": 4,
                                                        "rule": "optional"
                                                    }
                                                },
                                                "nested": {
                                                    "RecentEvent": {
                                                        "fields": {
                                                            "tokens": {
                                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecordTokens",
                                                                "id": 1,
                                                                "rule": "optional"
                                                            },
                                                            "occurredAt": {
                                                                "type": ".squareup.common.time.DateTime",
                                                                "id": 2,
                                                                "rule": "optional"
                                                            },
                                                            "type": {
                                                                "type": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents.RecentEvent.Type",
                                                                "id": 3,
                                                                "rule": "optional"
                                                            },
                                                            "state": {
                                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity.ActivityState",
                                                                "id": 4,
                                                                "rule": "optional"
                                                            }
                                                        },
                                                        "nested": {
                                                            "Type": {
                                                                "values": {
                                                                    "UNKNOWN": 0,
                                                                    "BANKC": 1,
                                                                    "OTHER": 2
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "TransitionDataError": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "NOT_BIZBANK_USER": 1
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "transitionData",
                                            "error"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.ActivityType && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.ActivityState && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.MerchantImage && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.MerchantCanonicalCategory && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityEvent && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesRequest?.nested?.ActivityStateCategory && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesRequest?.nested?.Filters && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesResponse?.nested?.Response && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.Modifier && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.Modifier?.nested?.ModifierType && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.ExternalLink && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.Attachment && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityDetailsRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityDetailsResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityDetailsResponse?.nested?.Response && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventsRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventsRequest?.nested?.Filters && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventsResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventsResponse?.nested?.Response && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventDetailsRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventDetailsResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityEventDetailsResponse?.nested?.Response && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.LineItem && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.LineItem?.nested?.LineItemType && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.TopLevelLineItem && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.TopLevelLineItem?.nested?.TopLevelLineItemType && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.BalanceOverview && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetBalanceOverviewRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetBalanceOverviewResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.PaymentProcessingDetails && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetPaymentProcessingDetailsRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetPaymentProcessingDetailsResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataRequest && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataRequest?.nested?.RecentEventsPaginationTokens && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.AccountTokens && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.RecordTokens && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.LatestRecord && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.LatestRecord?.nested?.SubsequentSweepActivity && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.PendingActivitiesAndEvents && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.PendingActivitiesAndEvents?.nested?.PendingActivityAndEvents && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.RecentEvents && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.RecentEvents?.nested?.RecentEvent && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionData?.nested?.RecentEvents?.nested?.RecentEvent?.nested?.Type && !$e57ed9311822f585$var$$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityTransitionDataResponse?.nested?.TransitionDataError) $e57ed9311822f585$var$$root.addJSON($e57ed9311822f585$var$jsonData);
const $e57ed9311822f585$export$29bdc794142e11e = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivity');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$29bdc794142e11e, {
    activityToken: {
        required: true
    },
    latestEventAt: {
        required: true
    },
    activityType: {
        required: true
    },
    activityState: {
        required: true
    },
    description: {
        required: true
    },
    amount: {
        required: true
    },
    balanceToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$29bdc794142e11e);
/**
 * SOURCE ActivityType @ squareup/bizbank/unified_activity.proto at 22:3
 */ $e57ed9311822f585$export$29bdc794142e11e.ActivityType = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.UnifiedActivity.ActivityType').values;
/**
 * Currently maps to com.squareup.protos.banklin.data.TransactionState
 *
 * SOURCE ActivityState @ squareup/bizbank/unified_activity.proto at 73:3
 */ $e57ed9311822f585$export$29bdc794142e11e.ActivityState = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.UnifiedActivity.ActivityState').values;
/**
 * SOURCE MerchantImage @ squareup/bizbank/unified_activity.proto at 130:3
 */ $e57ed9311822f585$export$29bdc794142e11e.MerchantImage = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$29bdc794142e11e.MerchantImage, {
    merchantImageUrl: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$29bdc794142e11e.MerchantImage);
/**
 * SOURCE MerchantCanonicalCategory @ squareup/bizbank/unified_activity.proto at 140:3
 */ $e57ed9311822f585$export$29bdc794142e11e.MerchantCanonicalCategory = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivity.MerchantCanonicalCategory');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$29bdc794142e11e.MerchantCanonicalCategory, {
    name: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$29bdc794142e11e.MerchantCanonicalCategory);
const $e57ed9311822f585$export$f2c402645c2e7e61 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$f2c402645c2e7e61);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$f2c402645c2e7e61);
const $e57ed9311822f585$export$84c227598c17818e = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$84c227598c17818e, {
    activityStateCategory: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$84c227598c17818e);
/**
 * Category of UnifiedActivity.ActivityStates
 *
 * SOURCE ActivityStateCategory @ squareup/bizbank/unified_activity.proto at 221:3
 */ $e57ed9311822f585$export$84c227598c17818e.ActivityStateCategory = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.ActivityStateCategory').values;
/**
 * SOURCE Filters @ squareup/bizbank/unified_activity.proto at 227:3
 */ $e57ed9311822f585$export$84c227598c17818e.Filters = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.Filters');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$84c227598c17818e.Filters);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$84c227598c17818e.Filters);
const $e57ed9311822f585$export$244bc1d47f660674 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$244bc1d47f660674);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$244bc1d47f660674);
/**
 * SOURCE Response @ squareup/bizbank/unified_activity.proto at 255:3
 */ $e57ed9311822f585$export$244bc1d47f660674.Response = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse.Response');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$244bc1d47f660674.Response);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$244bc1d47f660674.Response);
const $e57ed9311822f585$export$d2f2207f59721d5f = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$d2f2207f59721d5f, {
    description: {
        required: true
    },
    grossAmount: {
        required: true
    },
    netAmount: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$d2f2207f59721d5f);
/**
 * SOURCE Modifier @ squareup/bizbank/unified_activity.proto at 274:3
 */ $e57ed9311822f585$export$d2f2207f59721d5f.Modifier = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$d2f2207f59721d5f.Modifier, {
    modifierType: {
        required: true
    },
    modifierAmount: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$d2f2207f59721d5f.Modifier);
/**
 * SOURCE ModifierType @ squareup/bizbank/unified_activity.proto at 275:5
 */ $e57ed9311822f585$export$d2f2207f59721d5f.Modifier.ModifierType = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier.ModifierType').values;
/**
 * Associated URL for an activity
 *
 * SOURCE ExternalLink @ squareup/bizbank/unified_activity.proto at 292:3
 */ $e57ed9311822f585$export$d2f2207f59721d5f.ExternalLink = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails.ExternalLink');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$d2f2207f59721d5f.ExternalLink);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$d2f2207f59721d5f.ExternalLink);
/**
 * SOURCE Attachment @ squareup/bizbank/unified_activity.proto at 298:3
 */ $e57ed9311822f585$export$d2f2207f59721d5f.Attachment = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails.Attachment');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$d2f2207f59721d5f.Attachment);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$d2f2207f59721d5f.Attachment);
const $e57ed9311822f585$export$24a11b384ef009b = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityDetailsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$24a11b384ef009b, {
    activityToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$24a11b384ef009b);
const $e57ed9311822f585$export$f5278f172d976bbe = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$f5278f172d976bbe);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$f5278f172d976bbe);
/**
 * SOURCE Response @ squareup/bizbank/unified_activity.proto at 333:3
 */ $e57ed9311822f585$export$f5278f172d976bbe.Response = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse.Response');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$f5278f172d976bbe.Response, {
    unifiedActivity: {
        required: true
    },
    unifiedActivityDetails: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$f5278f172d976bbe.Response);
const $e57ed9311822f585$export$c4965485f2174055 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$c4965485f2174055);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$c4965485f2174055);
/**
 * SOURCE Filters @ squareup/bizbank/unified_activity.proto at 346:3
 */ $e57ed9311822f585$export$c4965485f2174055.Filters = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventsRequest.Filters');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$c4965485f2174055.Filters, {
    activityToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$c4965485f2174055.Filters);
const $e57ed9311822f585$export$1b77dab9a79ca1b0 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$1b77dab9a79ca1b0);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$1b77dab9a79ca1b0);
/**
 * SOURCE Response @ squareup/bizbank/unified_activity.proto at 367:3
 */ $e57ed9311822f585$export$1b77dab9a79ca1b0.Response = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventsResponse.Response');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$1b77dab9a79ca1b0.Response);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$1b77dab9a79ca1b0.Response);
const $e57ed9311822f585$export$b959b00040c6f8ed = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$b959b00040c6f8ed);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$b959b00040c6f8ed);
const $e57ed9311822f585$export$85edbf2779642eb8 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$85edbf2779642eb8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$85edbf2779642eb8);
/**
 * SOURCE Response @ squareup/bizbank/unified_activity.proto at 387:3
 */ $e57ed9311822f585$export$85edbf2779642eb8.Response = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsResponse.Response');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$85edbf2779642eb8.Response);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$85edbf2779642eb8.Response);
const $e57ed9311822f585$export$63e502d15ed2c7b5 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.LineItem');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$63e502d15ed2c7b5);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$63e502d15ed2c7b5);
/**
 * SOURCE LineItemType @ squareup/bizbank/unified_activity.proto at 399:3
 */ $e57ed9311822f585$export$63e502d15ed2c7b5.LineItemType = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.LineItem.LineItemType').values;
const $e57ed9311822f585$export$d986f8c0e4fe0e52 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.TopLevelLineItem');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$d986f8c0e4fe0e52);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$d986f8c0e4fe0e52);
/**
 * SOURCE TopLevelLineItemType @ squareup/bizbank/unified_activity.proto at 445:3
 */ $e57ed9311822f585$export$d986f8c0e4fe0e52.TopLevelLineItemType = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.TopLevelLineItem.TopLevelLineItemType').values;
const $e57ed9311822f585$export$da41595dfa198660 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.BalanceOverview');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$da41595dfa198660);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$da41595dfa198660);
const $e57ed9311822f585$export$819cb40db0e653a6 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetBalanceOverviewRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$819cb40db0e653a6);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$819cb40db0e653a6);
const $e57ed9311822f585$export$79d14a84d6dd5cfe = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetBalanceOverviewResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$79d14a84d6dd5cfe);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$79d14a84d6dd5cfe);
const $e57ed9311822f585$export$28b8d7b4c3a0c8ad = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.PaymentProcessingDetails');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$28b8d7b4c3a0c8ad);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$28b8d7b4c3a0c8ad);
const $e57ed9311822f585$export$40a561b19f4fb80b = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetPaymentProcessingDetailsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$40a561b19f4fb80b);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$40a561b19f4fb80b);
const $e57ed9311822f585$export$b4bdcdf688c908f8 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetPaymentProcessingDetailsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$b4bdcdf688c908f8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$b4bdcdf688c908f8);
const $e57ed9311822f585$export$5dd38045b9f855b4 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$5dd38045b9f855b4);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$5dd38045b9f855b4);
/**
 * SOURCE RecentEventsPaginationTokens @ squareup/bizbank/unified_activity.proto at 507:3
 */ $e57ed9311822f585$export$5dd38045b9f855b4.RecentEventsPaginationTokens = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataRequest.RecentEventsPaginationTokens');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$5dd38045b9f855b4.RecentEventsPaginationTokens);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$5dd38045b9f855b4.RecentEventsPaginationTokens);
const $e57ed9311822f585$export$73f6915383d5e6b2 = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2);
/**
 * SOURCE AccountTokens @ squareup/bizbank/unified_activity.proto at 516:3
 */ $e57ed9311822f585$export$73f6915383d5e6b2.AccountTokens = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.AccountTokens');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.AccountTokens);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.AccountTokens);
/**
 * SOURCE TransitionData @ squareup/bizbank/unified_activity.proto at 521:3
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData);
/**
 * SOURCE RecordTokens @ squareup/bizbank/unified_activity.proto at 522:5
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecordTokens = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecordTokens');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecordTokens);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecordTokens);
/**
 * If subsequent_sweep_activity is populated, then the fields on `LatestRecord` refer to
 * the info on the activity prior to the sweep activity. If there's no prior activity,
 * the other fields will also refer to the same sweep activity.
 *
 * SOURCE LatestRecord @ squareup/bizbank/unified_activity.proto at 533:5
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.LatestRecord');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord);
/**
 * SOURCE SubsequentSweepActivity @ squareup/bizbank/unified_activity.proto at 534:7
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord.SubsequentSweepActivity = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.LatestRecord.SubsequentSweepActivity');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord.SubsequentSweepActivity);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.LatestRecord.SubsequentSweepActivity);
/**
 * SOURCE PendingActivitiesAndEvents @ squareup/bizbank/unified_activity.proto at 554:5
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.PendingActivitiesAndEvents');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents);
/**
 * SOURCE PendingActivityAndEvents @ squareup/bizbank/unified_activity.proto at 555:7
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents.PendingActivityAndEvents = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.PendingActivitiesAndEvents.PendingActivityAndEvents');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents.PendingActivityAndEvents);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.PendingActivitiesAndEvents.PendingActivityAndEvents);
/**
 * SOURCE RecentEvents @ squareup/bizbank/unified_activity.proto at 565:5
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents);
/**
 * SOURCE RecentEvent @ squareup/bizbank/unified_activity.proto at 566:7
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents.RecentEvent = $e57ed9311822f585$var$$root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents.RecentEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents.RecentEvent);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents.RecentEvent);
/**
 * SOURCE Type @ squareup/bizbank/unified_activity.proto at 567:9
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionData.RecentEvents.RecentEvent.Type = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionData.RecentEvents.RecentEvent.Type').values;
/**
 * SOURCE TransitionDataError @ squareup/bizbank/unified_activity.proto at 590:3
 */ $e57ed9311822f585$export$73f6915383d5e6b2.TransitionDataError = $e57ed9311822f585$var$$root.lookupEnum('squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse.TransitionDataError').values;


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 





const $e521b340cb47b525$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $e521b340cb47b525$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "transaction_dispute": {
                        "nested": {
                            "TransactionDispute": {
                                "fields": {
                                    "id": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "status": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "statusLastUpdatedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "marqetaCaseToken": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "transactionDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "disputeForm": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "sellerDisputedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "squareDisputedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "outreachUrl": {
                                        "type": "string",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "reasonCode": {
                                        "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditIssuedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditDebitedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 16,
                                        "rule": "optional"
                                    },
                                    "finalResolution": {
                                        "type": ".squareup.bizbank.transaction_dispute.FinalResolution",
                                        "id": 17,
                                        "rule": "optional"
                                    },
                                    "resolutionReason": {
                                        "type": ".squareup.bizbank.transaction_dispute.ResolutionReason",
                                        "id": 18,
                                        "rule": "optional"
                                    },
                                    "finalResolutionDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 19,
                                        "rule": "optional"
                                    },
                                    "finalFollowUpDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 20,
                                        "rule": "optional"
                                    },
                                    "createdAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 21,
                                        "rule": "optional"
                                    },
                                    "updatedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 22,
                                        "rule": "optional"
                                    },
                                    "marqetaDisputeFiledByLdap": {
                                        "type": "string",
                                        "id": 23,
                                        "rule": "optional"
                                    },
                                    "marqetaChargebackToken": {
                                        "type": "string",
                                        "id": 24,
                                        "rule": "optional"
                                    },
                                    "publicStatus": {
                                        "type": ".squareup.bizbank.transaction_dispute.PublicStatus",
                                        "id": 25,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ReasonCode": {
                                "values": {
                                    "UNKNOWN_REASON_CODE": 0,
                                    "FRAUD_OR_UNAUTHORIZED": 1,
                                    "NOT_RECEIVED": 2,
                                    "NOT_DESCRIBED": 3,
                                    "DUPLICATE_PROCESSING": 4,
                                    "TRANSACTION_AMOUNT_INCORRECT": 5,
                                    "CANCELED_OR_CREDIT_NOT_PROCESSED": 6
                                }
                            },
                            "DisputeStatus": {
                                "values": {
                                    "UNKNOWN_DISPUTE_STATUS": 0,
                                    "NEW": 1,
                                    "WAITING_ON_CARD_HOLDER": 2,
                                    "FILED": 3,
                                    "INITIATED": 4,
                                    "REPRESENTMENT": 5,
                                    "PREARBITRATION": 6,
                                    "ARBITRATION": 7,
                                    "NETWORK_REJECTED": 8,
                                    "WON": 9,
                                    "LOST": 10,
                                    "CLOSED": 11,
                                    "PENDING_AUTOMATED_REVIEW": 12,
                                    "PREARBITRATION_RESPONDED": 13
                                }
                            },
                            "PublicStatus": {
                                "values": {
                                    "UNKNOWN_PUBLIC_STATUS": 0,
                                    "PENDING_REVIEW": 1,
                                    "INFORMATION_NEEDED": 2,
                                    "IN_PROGRESS": 3,
                                    "SELLER_WON": 4,
                                    "SELLER_LOST": 5,
                                    "RESOLVED": 6
                                }
                            },
                            "FinalResolution": {
                                "values": {
                                    "UNKNOWN_FINAL_RESOLUTION": 0,
                                    "APPROVED": 1,
                                    "DENIED": 2,
                                    "CREDITED_FROM_SQUARE": 3,
                                    "VOIDED": 4,
                                    "REJECTED_BY_SQUARE": 5,
                                    "REFUNDED": 6,
                                    "REJECTED_BY_MARQETA": 7,
                                    "DENIED_WARNING": 8
                                }
                            },
                            "ResolutionReason": {
                                "values": {
                                    "UNKNOWN_RESOLUTION_REASON": 0,
                                    "ATO": 1,
                                    "BUSINESS_DECISION": 2,
                                    "CARDHOLDER_CANCELED_CLAIM": 3,
                                    "DISPUTE_LOST": 4,
                                    "DISPUTE_WON": 5,
                                    "DENIAL_GUIDELINES": 6,
                                    "LESS_THAN_25_DOLLARS": 7,
                                    "NO_REPLY": 8,
                                    "PAYMENT_WITH_CHIP_AND_PIN": 9,
                                    "REFUND": 10,
                                    "TRANSACTION_VOID": 11,
                                    "MULTIPLE_TRANSACTIONS": 12,
                                    "RESOLUTION_OVERTURNED": 13,
                                    "INACCURATE_OR_INCOMPLETE": 14,
                                    "AUTO_CHIP_OR_CONTACTLESS_WITH_CARD_IN_POSSESSION": 19,
                                    "AUTO_CARD_PIN_USED": 20,
                                    "AUTO_MOBILE_PAYMENT": 21,
                                    "AUTO_CONSENT_PROVIDED": 22
                                }
                            },
                            "DisputeForm": {
                                "fields": {
                                    "merchantName": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "transactionDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": "int64",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "usedWithMerchantBefore": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "provideCardOrInformation": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "cardInPossession": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "firstDateCardMissing": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "lastTransaction": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.LastTransaction",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "sharedPinWithAnyone": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.SharedPinWithAnyone",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "receivedExpectedProducts": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "didNotReceiveProductsDetails": {
                                        "type": "string",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "receivedProductsOnAgreedDate": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "receivedExpectedProductsDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "productsReceivedWereAsDescribed": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "productsReceivedWereNotAsDescribedDetails": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "chargedMultipleTimes": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 16,
                                        "rule": "optional"
                                    },
                                    "chargedMultipleTimesCorrectTransaction": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.ChargedMultipleTimes",
                                        "id": 17,
                                        "rule": "optional"
                                    },
                                    "amountIsCorrect": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 18,
                                        "rule": "optional"
                                    },
                                    "correctChargeAmount": {
                                        "type": "int64",
                                        "id": 27,
                                        "rule": "optional"
                                    },
                                    "purchaseWasCanceled": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 19,
                                        "rule": "optional"
                                    },
                                    "purchasedCanceledDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 20,
                                        "rule": "optional"
                                    },
                                    "merchandiseIsReturned": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 21,
                                        "rule": "optional"
                                    },
                                    "returnedMerchandise": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.ReturnedMerchandise",
                                        "id": 22,
                                        "rule": "optional"
                                    },
                                    "merchantAgreedToIssueCredit": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 23,
                                        "rule": "optional"
                                    },
                                    "merchantAgreedToIssueCreditDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 24,
                                        "rule": "optional"
                                    },
                                    "anythingElse": {
                                        "type": "string",
                                        "id": 25,
                                        "rule": "optional"
                                    },
                                    "pinWasWrittenDown": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                        "id": 26,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "DisputeFormAnswer": {
                                        "values": {
                                            "UNKNOWN_ANSWER": 0,
                                            "NO": 1,
                                            "YES": 2
                                        }
                                    },
                                    "LastTransaction": {
                                        "fields": {
                                            "lastTransactionDate": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "lastTransactionMerchant": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "SharedPinWithAnyone": {
                                        "fields": {
                                            "hasSharedPinWithAnyone": {
                                                "type": ".squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "sharedPinPerson": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "ChargedMultipleTimes": {
                                        "fields": {
                                            "correctChargeDate": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "correctChargeAmount": {
                                                "type": "int64",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "ReturnedMerchandise": {
                                        "fields": {
                                            "returnedMerchandiseDate": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "returnedMerchandiseProof": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetTransactionDisputeRequest": {
                                "fields": {
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetTransactionDisputeResponse": {
                                "fields": {
                                    "transactionDispute": {
                                        "type": ".squareup.bizbank.transaction_dispute.TransactionDispute",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetTransactionDisputeByTransactionTokenRequest": {
                                "fields": {
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetTransactionDisputeByTransactionTokenResponse": {
                                "fields": {
                                    "transactionDispute": {
                                        "type": ".squareup.bizbank.transaction_dispute.TransactionDispute",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetTransactionDisputeActivityRequest": {
                                "fields": {
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetTransactionDisputeActivityResponse": {
                                "fields": {
                                    "events": {
                                        "type": ".squareup.bizbank.transaction_dispute.Event",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "Event": {
                                "fields": {
                                    "eventAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "statusChangeEvent": {
                                        "type": ".squareup.bizbank.transaction_dispute.Event.StatusChangeEvent",
                                        "id": 2
                                    },
                                    "futureStatusChangeEvent": {
                                        "type": ".squareup.bizbank.transaction_dispute.Event.FutureStatusChangeEvent",
                                        "id": 3
                                    },
                                    "creditIssuedEvent": {
                                        "type": ".squareup.bizbank.transaction_dispute.Event.CreditIssuedEvent",
                                        "id": 4
                                    },
                                    "creditDebitedEvent": {
                                        "type": ".squareup.bizbank.transaction_dispute.Event.CreditDebitedEvent",
                                        "id": 5
                                    }
                                },
                                "nested": {
                                    "StatusChangeEvent": {
                                        "fields": {
                                            "publicStatus": {
                                                "type": ".squareup.bizbank.transaction_dispute.PublicStatus",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "FutureStatusChangeEvent": {
                                        "fields": {
                                            "publicStatus": {
                                                "type": ".squareup.bizbank.transaction_dispute.PublicStatus",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "CreditIssuedEvent": {
                                        "fields": {
                                            "amount": {
                                                "type": ".squareup.common.Money",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "CreditDebitedEvent": {
                                        "fields": {
                                            "amount": {
                                                "type": ".squareup.common.Money",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "event": {
                                        "oneof": [
                                            "statusChangeEvent",
                                            "futureStatusChangeEvent",
                                            "creditIssuedEvent",
                                            "creditDebitedEvent"
                                        ]
                                    }
                                }
                            },
                            "ListTransactionDisputesRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "beginTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "endTime": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "includeStatuses": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                                        "id": 4,
                                        "rule": "repeated"
                                    },
                                    "inProgressOnly": {
                                        "type": "bool",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "batchRequest": {
                                        "type": ".squareup.bizbank.model.BatchRequest",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "resolvedOnly": {
                                        "type": "bool",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListTransactionDisputesResponse": {
                                "fields": {
                                    "transactionDisputes": {
                                        "type": ".squareup.bizbank.transaction_dispute.TransactionDispute",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "paginationToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListTransactionDisputeStatusUpdatesRequest": {
                                "fields": {
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListTransactionDisputeStatusUpdatesResponse": {
                                "fields": {
                                    "statusUpdates": {
                                        "type": ".squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse.StatusUpdate",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "StatusUpdate": {
                                        "fields": {
                                            "transactionDisputesHistoryId": {
                                                "type": "int64",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "status": {
                                                "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "statusUpdatedDate": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "CreateTransactionDisputeRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "disputeForm": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeForm",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "reasonCode": {
                                        "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "sellerDisputedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "outreachUrl": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateTransactionDisputeResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateTransactionDisputeRequest": {
                                "fields": {
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "status": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "statusUpdatedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "outreachUrl": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "squareDisputedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditIssuedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditDebitedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "finalResolution": {
                                        "type": ".squareup.bizbank.transaction_dispute.FinalResolution",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "resolutionReason": {
                                        "type": ".squareup.bizbank.transaction_dispute.ResolutionReason",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "finalResolutionDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "finalFollowUpDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "reasonCode": {
                                        "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "marqetaDisputeFiledByLdap": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "marqetaChargebackToken": {
                                        "type": "string",
                                        "id": 16,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 17,
                                        "rule": "optional"
                                    },
                                    "marqetaCaseToken": {
                                        "type": "string",
                                        "id": 18,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateTransactionDisputeByTransactionTokenRequest": {
                                "fields": {
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "status": {
                                        "type": ".squareup.bizbank.transaction_dispute.DisputeStatus",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "statusUpdatedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "outreachUrl": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "squareDisputedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditIssuedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "provisionalCreditDebitedDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "finalResolution": {
                                        "type": ".squareup.bizbank.transaction_dispute.FinalResolution",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "resolutionReason": {
                                        "type": ".squareup.bizbank.transaction_dispute.ResolutionReason",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "finalResolutionDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "finalFollowUpDate": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "reasonCode": {
                                        "type": ".squareup.bizbank.transaction_dispute.ReasonCode",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "marqetaDisputeFiledByLdap": {
                                        "type": "string",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "marqetaChargebackToken": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 16,
                                        "rule": "optional"
                                    },
                                    "marqetaCaseToken": {
                                        "type": "string",
                                        "id": 17,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateTransactionDisputeResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "HandleDisputeStatusUpdateEventRequest": {
                                "fields": {
                                    "updateEventJson": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "HandleDisputeStatusUpdateEventResponse": {
                                "fields": {}
                            },
                            "MarqetaDisputeReason": {
                                "values": {
                                    "UNKNOWN_MQ_DISPUTE_REASON": 0,
                                    "WARNING_BULLETIN_FILE": 1,
                                    "AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM": 2,
                                    "ACCOUNT_NUMBER_NOT_ON_FILE": 3,
                                    "INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER": 4,
                                    "POINT_OF_INTERACTION_ERRORS": 5,
                                    "NOT_AUTHORIZED_CARD_PRESENT": 6,
                                    "NOT_AUTHORIZED_CARD_ABSENT": 7,
                                    "FRAUD_TRANSACTION": 8,
                                    "CANCELLED_RECURRING_TRANSACTION": 9,
                                    "LATE_PRESENTMENT": 10,
                                    "INCORRECT_CURRENCY": 11,
                                    "INCORRECT_TRANSACTION_CODE": 12,
                                    "INCORRECT_CURRENCY_OR_TRANSACTION_CODE": 13,
                                    "QUESTIONABLE_MERCHANT_ACTIVITY": 14,
                                    "INSTALLMENT_BILLING_DISPUTE": 15,
                                    "CARDHOLDER_DISPUTE_US_ONLY": 16,
                                    "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED": 17,
                                    "NO_SHOW_ADDENDUM_OR_ATM_DISPUTE": 18,
                                    "CREDIT_NOT_PROCESSED": 19,
                                    "TRANSACTION_NOT_RECOGNIZED": 20,
                                    "CHIP_LIABILITY_SHIFT": 21,
                                    "CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN": 22,
                                    "CHIP_READ_POS_LATE_PRESENTMENT": 23,
                                    "DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE": 24,
                                    "CARDHOLDER_DISPUTE": 25
                                }
                            },
                            "MarqetaDisputeDocumentCategory": {
                                "values": {
                                    "UNKNOWN_MQ_DISPUTE_DOCUMENT_CATEGORY": 0,
                                    "RECEIPT": 1,
                                    "CUSTOMER_SIGNATURE": 2,
                                    "CUSTOMER_DL": 3,
                                    "CUSTOMER_SSN": 4,
                                    "CUSTOMER_PASSPORT": 5,
                                    "UTILITY_BILL": 6,
                                    "CUSTOMER_COMMUNICATION": 7,
                                    "DISPUTE_FORM": 8,
                                    "BANK_STATEMENT": 9,
                                    "TAX_DOCUMENTS": 10,
                                    "INCORPORATION_CERTIFICATE": 11,
                                    "LEASE_AGREEMENT": 12,
                                    "OTHERS": 13
                                }
                            },
                            "CreateMarqetaDisputeRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "disputeAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "marqetaDisputeReason": {
                                        "type": ".squareup.bizbank.transaction_dispute.MarqetaDisputeReason",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "submittedBy": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "memo": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "document": {
                                        "type": ".squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest.Document",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 8,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Document": {
                                        "fields": {
                                            "fileBytes": {
                                                "type": "bytes",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "contentType": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "fileName": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "category": {
                                                "type": ".squareup.bizbank.transaction_dispute.MarqetaDisputeDocumentCategory",
                                                "id": 4,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "CreateMarqetaDisputeResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "LedgerDisputeLostRequest": {
                                "fields": {
                                    "transactionDisputeId": {
                                        "type": "int64",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "LedgerDisputeLostResponse": {
                                "fields": {}
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.TransactionDispute && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ReasonCode && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeStatus && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.PublicStatus && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.FinalResolution && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ResolutionReason && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.DisputeFormAnswer && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.LastTransaction && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.SharedPinWithAnyone && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.ChargedMultipleTimes && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.DisputeForm?.nested?.ReturnedMerchandise && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeByTransactionTokenRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeByTransactionTokenResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeActivityRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.GetTransactionDisputeActivityResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.StatusChangeEvent && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.FutureStatusChangeEvent && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.CreditIssuedEvent && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.Event?.nested?.CreditDebitedEvent && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputesRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputesResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputeStatusUpdatesRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputeStatusUpdatesResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.ListTransactionDisputeStatusUpdatesResponse?.nested?.StatusUpdate && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateTransactionDisputeRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateTransactionDisputeResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.UpdateTransactionDisputeRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.UpdateTransactionDisputeByTransactionTokenRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.UpdateTransactionDisputeResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.HandleDisputeStatusUpdateEventRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.HandleDisputeStatusUpdateEventResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.MarqetaDisputeReason && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.MarqetaDisputeDocumentCategory && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateMarqetaDisputeRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateMarqetaDisputeRequest?.nested?.Document && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.CreateMarqetaDisputeResponse && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.LedgerDisputeLostRequest && !$e521b340cb47b525$var$$root.nested?.squareup?.nested?.bizbank?.nested?.transaction_dispute?.nested?.LedgerDisputeLostResponse) $e521b340cb47b525$var$$root.addJSON($e521b340cb47b525$var$jsonData);
const $e521b340cb47b525$export$201f7a2811c12e8f = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.TransactionDispute');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$201f7a2811c12e8f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$201f7a2811c12e8f);
const $e521b340cb47b525$export$73bd2caeeaeda77b = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.ReasonCode').values;
const $e521b340cb47b525$export$ca69f21448a28201 = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.DisputeStatus').values;
const $e521b340cb47b525$export$4c81e80b8c38fc62 = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.PublicStatus').values;
const $e521b340cb47b525$export$6154cee52a5a8aa8 = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.FinalResolution').values;
const $e521b340cb47b525$export$385de46e976190af = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.ResolutionReason').values;
const $e521b340cb47b525$export$f9dbf923c40c0402 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f9dbf923c40c0402);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f9dbf923c40c0402);
/**
 * SOURCE DisputeFormAnswer @ squareup/bizbank/transaction_dispute.proto at 177:3
 */ $e521b340cb47b525$export$f9dbf923c40c0402.DisputeFormAnswer = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.DisputeForm.DisputeFormAnswer').values;
/**
 * What was the last transaction you made with your Square Card?
 *
 * SOURCE LastTransaction @ squareup/bizbank/transaction_dispute.proto at 205:3
 */ $e521b340cb47b525$export$f9dbf923c40c0402.LastTransaction = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.LastTransaction');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f9dbf923c40c0402.LastTransaction);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f9dbf923c40c0402.LastTransaction);
/**
 * SOURCE SharedPinWithAnyone @ squareup/bizbank/transaction_dispute.proto at 212:3
 */ $e521b340cb47b525$export$f9dbf923c40c0402.SharedPinWithAnyone = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.SharedPinWithAnyone');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f9dbf923c40c0402.SharedPinWithAnyone);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f9dbf923c40c0402.SharedPinWithAnyone);
/**
 * If you were charged multiple times for this payment, what was the date and amount of the correct transaction?
 *
 * SOURCE ChargedMultipleTimes @ squareup/bizbank/transaction_dispute.proto at 243:3
 */ $e521b340cb47b525$export$f9dbf923c40c0402.ChargedMultipleTimes = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.ChargedMultipleTimes');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f9dbf923c40c0402.ChargedMultipleTimes);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f9dbf923c40c0402.ChargedMultipleTimes);
/**
 * If you’ve returned the merchandise, please provide the return date and provide proof of return authorization (i.e tracking number, delivery confirmation, or return merchandise authorization)
 *
 * SOURCE ReturnedMerchandise @ squareup/bizbank/transaction_dispute.proto at 265:3
 */ $e521b340cb47b525$export$f9dbf923c40c0402.ReturnedMerchandise = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.DisputeForm.ReturnedMerchandise');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f9dbf923c40c0402.ReturnedMerchandise);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f9dbf923c40c0402.ReturnedMerchandise);
const $e521b340cb47b525$export$6ffc02cb2556bcd4 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$6ffc02cb2556bcd4, {
    transactionDisputeId: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$6ffc02cb2556bcd4);
const $e521b340cb47b525$export$875e74715c8af887 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$875e74715c8af887);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$875e74715c8af887);
const $e521b340cb47b525$export$58d6f643d9797046 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$58d6f643d9797046, {
    transactionToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$58d6f643d9797046);
const $e521b340cb47b525$export$5e20b7bac2c8538d = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$5e20b7bac2c8538d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$5e20b7bac2c8538d);
const $e521b340cb47b525$export$b358a6910d4d2055 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$b358a6910d4d2055, {
    transactionDisputeId: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$b358a6910d4d2055);
const $e521b340cb47b525$export$269f6f0781e5c7a9 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$269f6f0781e5c7a9);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$269f6f0781e5c7a9);
const $e521b340cb47b525$export$d61e24a684f9e51 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.Event');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$d61e24a684f9e51);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$d61e24a684f9e51);
/**
 * SOURCE StatusChangeEvent @ squareup/bizbank/transaction_dispute.proto at 319:3
 */ $e521b340cb47b525$export$d61e24a684f9e51.StatusChangeEvent = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.Event.StatusChangeEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$d61e24a684f9e51.StatusChangeEvent);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$d61e24a684f9e51.StatusChangeEvent);
/**
 * SOURCE FutureStatusChangeEvent @ squareup/bizbank/transaction_dispute.proto at 323:3
 */ $e521b340cb47b525$export$d61e24a684f9e51.FutureStatusChangeEvent = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.Event.FutureStatusChangeEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$d61e24a684f9e51.FutureStatusChangeEvent);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$d61e24a684f9e51.FutureStatusChangeEvent);
/**
 * SOURCE CreditIssuedEvent @ squareup/bizbank/transaction_dispute.proto at 327:3
 */ $e521b340cb47b525$export$d61e24a684f9e51.CreditIssuedEvent = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.Event.CreditIssuedEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$d61e24a684f9e51.CreditIssuedEvent);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$d61e24a684f9e51.CreditIssuedEvent);
/**
 * SOURCE CreditDebitedEvent @ squareup/bizbank/transaction_dispute.proto at 331:3
 */ $e521b340cb47b525$export$d61e24a684f9e51.CreditDebitedEvent = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.Event.CreditDebitedEvent');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$d61e24a684f9e51.CreditDebitedEvent);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$d61e24a684f9e51.CreditDebitedEvent);
const $e521b340cb47b525$export$f72a9e2991d87a1d = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputesRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f72a9e2991d87a1d, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f72a9e2991d87a1d);
const $e521b340cb47b525$export$5ff93e9cf3e843d4 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputesResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$5ff93e9cf3e843d4);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$5ff93e9cf3e843d4);
const $e521b340cb47b525$export$4cfed3e3362beeda = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$4cfed3e3362beeda, {
    transactionDisputeId: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$4cfed3e3362beeda);
const $e521b340cb47b525$export$8abc09afcd3b2abc = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$8abc09afcd3b2abc);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$8abc09afcd3b2abc);
/**
 * SOURCE StatusUpdate @ squareup/bizbank/transaction_dispute.proto at 359:3
 */ $e521b340cb47b525$export$8abc09afcd3b2abc.StatusUpdate = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse.StatusUpdate');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$8abc09afcd3b2abc.StatusUpdate);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$8abc09afcd3b2abc.StatusUpdate);
const $e521b340cb47b525$export$245c333457639690 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.CreateTransactionDisputeRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$245c333457639690, {
    unitToken: {
        notEmpty: true
    },
    disputeAmount: {
        required: true
    },
    reasonCode: {
        required: true
    },
    sellerDisputedDate: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$245c333457639690);
const $e521b340cb47b525$export$721540c0352c4f0d = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.CreateTransactionDisputeResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$721540c0352c4f0d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$721540c0352c4f0d);
const $e521b340cb47b525$export$8b1cd1b6bf235738 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.UpdateTransactionDisputeRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$8b1cd1b6bf235738, {
    transactionDisputeId: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$8b1cd1b6bf235738);
const $e521b340cb47b525$export$ec46f8e3efdec47d = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.UpdateTransactionDisputeByTransactionTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$ec46f8e3efdec47d, {
    transactionToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$ec46f8e3efdec47d);
const $e521b340cb47b525$export$679cc044a25585b0 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.UpdateTransactionDisputeResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$679cc044a25585b0);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$679cc044a25585b0);
const $e521b340cb47b525$export$fe944c5289c65dda = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$fe944c5289c65dda, {
    updateEventJson: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$fe944c5289c65dda);
const $e521b340cb47b525$export$9b65f99468247c8e = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$9b65f99468247c8e);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$9b65f99468247c8e);
const $e521b340cb47b525$export$df53fbf07eee81b6 = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.MarqetaDisputeReason').values;
const $e521b340cb47b525$export$1af9daa1f66a14cf = $e521b340cb47b525$var$$root.lookupEnum('squareup.bizbank.transaction_dispute.MarqetaDisputeDocumentCategory').values;
const $e521b340cb47b525$export$a2e166388e805d4 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$a2e166388e805d4, {
    unitToken: {
        notEmpty: true
    },
    disputeAmount: {
        required: true
    },
    transactionToken: {
        notEmpty: true
    },
    marqetaDisputeReason: {
        required: true
    },
    submittedBy: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$a2e166388e805d4);
/**
 * SOURCE Document @ squareup/bizbank/transaction_dispute.proto at 488:3
 */ $e521b340cb47b525$export$a2e166388e805d4.Document = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest.Document');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$a2e166388e805d4.Document, {
    contentType: {
        notEmpty: true
    },
    fileName: {
        notEmpty: true
    },
    category: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$a2e166388e805d4.Document);
const $e521b340cb47b525$export$f59816ef0ad5d634 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.CreateMarqetaDisputeResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$f59816ef0ad5d634, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$f59816ef0ad5d634);
const $e521b340cb47b525$export$7483d2465c90ff13 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.LedgerDisputeLostRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$7483d2465c90ff13, {
    transactionDisputeId: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$7483d2465c90ff13);
const $e521b340cb47b525$export$b1ef9545d73f06f8 = $e521b340cb47b525$var$$root.lookupType('squareup.bizbank.transaction_dispute.LedgerDisputeLostResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($e521b340cb47b525$export$b1ef9545d73f06f8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($e521b340cb47b525$export$b1ef9545d73f06f8);


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 



const $69670b9fb8fe807f$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $69670b9fb8fe807f$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "card_management": {
                        "nested": {
                            "CreateUserAuthorizationRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "authenticationToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateUserAuthorizationResponse": {
                                "fields": {
                                    "result": {
                                        "type": ".squareup.bizbank.card_management.CreateUserAuthorizationResponse.Result",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Result": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "SUCCESS": 1,
                                            "ERROR": 2,
                                            "INVALID_TOKEN": 3,
                                            "EXPIRED_TOKEN": 4
                                        }
                                    }
                                }
                            },
                            "GetPrivateCardDataRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "loggableSessionToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "PrivateCardData": {
                                "fields": {
                                    "fullPan": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cvc": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "expiration": {
                                        "type": ".squareup.common.time.YearMonth",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetPrivateCardDataResponse": {
                                "fields": {
                                    "privateCardInfo": {
                                        "type": ".squareup.bizbank.card_management.PrivateCardData",
                                        "id": 1
                                    },
                                    "error": {
                                        "type": ".squareup.bizbank.card_management.GetPrivateCardDataResponse.Error",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Error": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "ERROR": 1,
                                            "UNAUTHORIZED": 2
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "privateCardInfo",
                                            "error"
                                        ]
                                    }
                                }
                            },
                            "ExpireAllUserAuthorizationsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "bizbankCardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ExpireAllUserAuthorizationsResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "result": {
                                        "oneof": [
                                            "success",
                                            "errorMessage"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.CreateUserAuthorizationRequest && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.CreateUserAuthorizationResponse && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.CreateUserAuthorizationResponse?.nested?.Result && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.GetPrivateCardDataRequest && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.PrivateCardData && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.GetPrivateCardDataResponse && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.GetPrivateCardDataResponse?.nested?.Error && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.ExpireAllUserAuthorizationsRequest && !$69670b9fb8fe807f$var$$root.nested?.squareup?.nested?.bizbank?.nested?.card_management?.nested?.ExpireAllUserAuthorizationsResponse) $69670b9fb8fe807f$var$$root.addJSON($69670b9fb8fe807f$var$jsonData);
const $69670b9fb8fe807f$export$c1fff74db1cb380e = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.CreateUserAuthorizationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$c1fff74db1cb380e, {
    authenticationToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$c1fff74db1cb380e);
const $69670b9fb8fe807f$export$83ccf668fe6813a2 = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.CreateUserAuthorizationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$83ccf668fe6813a2, {
    result: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$83ccf668fe6813a2);
/**
 * Invalid token will be returned if two factor authentication code is invalid or expired
 *
 * SOURCE Result @ squareup/bizbank/card_management.proto at 24:3
 */ $69670b9fb8fe807f$export$83ccf668fe6813a2.Result = $69670b9fb8fe807f$var$$root.lookupEnum('squareup.bizbank.card_management.CreateUserAuthorizationResponse.Result').values;
const $69670b9fb8fe807f$export$acc45b72a9895637 = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.GetPrivateCardDataRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$acc45b72a9895637, {
    cardToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$acc45b72a9895637);
const $69670b9fb8fe807f$export$76ea8ebac544371a = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.PrivateCardData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$76ea8ebac544371a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$76ea8ebac544371a);
const $69670b9fb8fe807f$export$27437b8b654e9873 = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.GetPrivateCardDataResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$27437b8b654e9873);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$27437b8b654e9873);
/**
 * SOURCE Error @ squareup/bizbank/card_management.proto at 59:3
 */ $69670b9fb8fe807f$export$27437b8b654e9873.Error = $69670b9fb8fe807f$var$$root.lookupEnum('squareup.bizbank.card_management.GetPrivateCardDataResponse.Error').values;
const $69670b9fb8fe807f$export$e591fc412cabb5a2 = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.ExpireAllUserAuthorizationsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$e591fc412cabb5a2, {
    unitToken: {
        required: true
    },
    bizbankCardToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$e591fc412cabb5a2);
const $69670b9fb8fe807f$export$aba26c5151bca4a5 = $69670b9fb8fe807f$var$$root.lookupType('squareup.bizbank.card_management.ExpireAllUserAuthorizationsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($69670b9fb8fe807f$export$aba26c5151bca4a5);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($69670b9fb8fe807f$export$aba26c5151bca4a5);


const $3f73c216104868a6$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $3f73c216104868a6$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "service": {
                        "nested": {
                            "AddMobileNumberForSmsNotificationsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "mobileNumber": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "locale": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "AddMobileNumberForSmsNotificationsResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "localizedErrorTitle": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "localizedErrorDescription": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CheckIdentityVerificationStatusRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "pollToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CheckIdentityVerificationStatusResponse": {
                                "fields": {
                                    "pending": {
                                        "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Pending",
                                        "id": 1
                                    },
                                    "response": {
                                        "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Response",
                                        "id": 2
                                    },
                                    "error": {
                                        "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Error",
                                        "id": 3
                                    }
                                },
                                "nested": {
                                    "Response": {
                                        "fields": {
                                            "idvState": {
                                                "type": ".squareup.bizbank.service.IdvState",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "idvNeedsSsn": {
                                                "type": "bool",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "canRetryIdv": {
                                                "type": "bool",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "idvError": {
                                                "type": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse.IdvError",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "idvRetriesRemaining": {
                                                "type": "int32",
                                                "id": 5,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "Pending": {
                                        "fields": {
                                            "pollToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "IdvError": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "TOO_MANY_ATTEMPTS": 3,
                                            "UNDER_AGE_OF_MAJORITY": 4,
                                            "DOES_NOT_MATCH": 5
                                        }
                                    },
                                    "Error": {
                                        "fields": {
                                            "reason": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "pending",
                                            "response",
                                            "error"
                                        ]
                                    }
                                }
                            },
                            "ConfirmIssueCardRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardIssueToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "shippingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "customizationToken": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "shouldPauseDeposits": {
                                        "type": "bool",
                                        "id": 6,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ConfirmIssueCardResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "canImmediatelyAddToWallet": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "cardData": {
                                        "type": ".squareup.bizbank.service.CardData",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "IssueCardRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardholderPersonToken": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "createPhysicalCard": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "createVirtualCard": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "physicalCardDetails": {
                                        "type": ".squareup.bizbank.service.IssueCardRequest.PhysicalCardDetails",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "PhysicalCardDetails": {
                                        "fields": {
                                            "firstName": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "lastName": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "shippingAddress": {
                                                "type": ".squareup.common.location.GlobalAddress",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "customizationToken": {
                                                "type": "string",
                                                "id": 4,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "IssueCardResponse": {
                                "fields": {
                                    "physicalCardData": {
                                        "type": ".squareup.bizbank.service.CardData",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateCardCustomizationRequest": {
                                "fields": {
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "imageBytes": {
                                        "type": "bytes",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "mimeType": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "existingTrunkToken": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateCardCustomizationResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cutomizationToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "DeactivateCardRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "deactivationReason": {
                                        "type": ".squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "DeactivationReason": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "LOST": 1,
                                            "STOLEN": 2,
                                            "CARD_NOT_RECEIVED": 3,
                                            "CANCEL": 4,
                                            "FRAUD": 5,
                                            "TRANSFER_OF_ACCOUNT": 6,
                                            "RISK_ACCOUNT_DEACTIVATION": 7,
                                            "LOST_OR_STOLEN": 8,
                                            "DAMAGED": 9
                                        }
                                    }
                                }
                            },
                            "DeactivateCardResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "bizbankEnabled": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateDeactivationReasonRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "reason": {
                                        "type": ".squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateDeactivationReasonResponse": {
                                "fields": {
                                    "errors": {
                                        "type": ".squareup.bizbank.service.UpdateDeactivationReasonResponse.UpdateDeactivationReasonError",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "UpdateDeactivationReasonError": {
                                        "values": {
                                            "UPDATE_DEACTIVATION_REASON_ERROR_DO_NOT_USE": 0,
                                            "UPDATE_DEACTIVATION_REASON_ERROR_INVALID_CARD_TOKEN": 1
                                        }
                                    }
                                }
                            },
                            "FinishCardActivationRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "activationToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cvv": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "expirationMmyy": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "fideliusToken": {
                                        "type": "string",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "FinishCardActivationResponse": {
                                "fields": {
                                    "result": {
                                        "type": ".squareup.bizbank.service.FinishCardActivationResponse.Result",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "pinIsSet": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Result": {
                                        "values": {
                                            "SUCCESS": 1,
                                            "FAILED": 2,
                                            "ACTIVATION_TOKEN_INVALID": 3,
                                            "ACTIVATION_TOKEN_EXPIRED": 4,
                                            "INCORRECT_CVV": 5,
                                            "INCORRECT_EXPIRATION": 6,
                                            "INCORRECT_CARD_INFO": 7
                                        }
                                    }
                                }
                            },
                            "EnqueueSweepRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "EnqueueSweepResponse": {
                                "fields": {}
                            },
                            "GetBalanceRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetBalanceResponse": {
                                "fields": {
                                    "balance": {
                                        "type": ".squareup.common.Money",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "maxInstantDepositAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "pendingBalance": {
                                        "type": ".squareup.common.Money",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetBizbankAccountRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "includeIdvData": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional",
                                        "options": {
                                            "default": false
                                        }
                                    }
                                }
                            },
                            "GetBizbankAccountResponse": {
                                "fields": {
                                    "bizbankAccount": {
                                        "type": ".squareup.bizbank.service.GetBizbankAccountResponse.BizbankAccount",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "BizbankAccount": {
                                        "fields": {
                                            "unitToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "isBizbankEnabled": {
                                                "type": "bool",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "balance": {
                                                "type": ".squareup.common.Money",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "maxInstantDepositAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "cards": {
                                                "type": ".squareup.bizbank.service.CardData",
                                                "id": 5,
                                                "rule": "repeated"
                                            },
                                            "cardActivity": {
                                                "type": ".squareup.bizbank.service.CardActivity",
                                                "id": 6,
                                                "rule": "repeated"
                                            },
                                            "pendingBalance": {
                                                "type": ".squareup.common.Money",
                                                "id": 7,
                                                "rule": "optional"
                                            },
                                            "idvState": {
                                                "type": ".squareup.bizbank.service.IdvState",
                                                "id": 8,
                                                "rule": "optional"
                                            },
                                            "idvAttemptsRemaining": {
                                                "type": "int32",
                                                "id": 9,
                                                "rule": "optional"
                                            },
                                            "canToggleEnabled": {
                                                "type": "bool",
                                                "id": 10,
                                                "rule": "optional"
                                            },
                                            "canOrderCard": {
                                                "type": "bool",
                                                "id": 11,
                                                "rule": "optional"
                                            },
                                            "eligibilityReason": {
                                                "type": ".squareup.bizbank.service.UnitIneligibilityReason",
                                                "id": 12,
                                                "rule": "optional"
                                            },
                                            "storedValueToken": {
                                                "type": "string",
                                                "id": 13,
                                                "rule": "optional"
                                            },
                                            "countryCode": {
                                                "type": ".squareup.common.countries.Country",
                                                "id": 14,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "UnitIneligibilityReason": {
                                "values": {
                                    "UNKNOWN": 0,
                                    "SUSPENDED_BY_MARQETA": 1,
                                    "DEACTIVATED_BY_MARQETA": 2,
                                    "TOO_MANY_CLAIMS": 3,
                                    "NOT_ACTIVATED": 4,
                                    "NOT_FOUND": 5,
                                    "MCC_INELIGIBLE": 6,
                                    "DEACTIVATED_BY_RISK": 7,
                                    "INVALID_BUSINESS_NAME": 8,
                                    "EXHAUSTED_IDV_RETRIES": 9,
                                    "SUSPECTED_ATO": 10,
                                    "FAKE_ACCOUNT": 11,
                                    "SELLS_CANNABIS": 13,
                                    "PRODUCT_LEVEL_HARDBLOCKED_BY_COMPLIANCE": 14,
                                    "DECLINED_BY_RISK": 15
                                }
                            },
                            "GetCardOrderingEligibilityRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "skipRiskproxyEvaluation": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional",
                                        "options": {
                                            "default": true
                                        }
                                    }
                                }
                            },
                            "GetCardOrderingEligibilityResponse": {
                                "fields": {
                                    "canOrderCard": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "idvState": {
                                        "type": ".squareup.bizbank.service.IdvState",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "idvAttemptsRemaining": {
                                        "type": "int32",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "ineligibilityReasons": {
                                        "type": ".squareup.bizbank.service.UnitIneligibilityReason",
                                        "id": 6,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "GetCardActivityRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "batchRequest": {
                                        "type": ".squareup.bizbank.model.BatchRequest",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "filters": {
                                        "type": ".squareup.bizbank.service.GetCardActivityRequest.Filters",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Filters": {
                                        "fields": {
                                            "includeStates": {
                                                "type": ".squareup.banklin.TransactionState",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "excludeStates": {
                                                "type": ".squareup.banklin.TransactionState",
                                                "id": 2,
                                                "rule": "repeated"
                                            },
                                            "minOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "maxOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "excludeActivityTypes": {
                                                "type": ".squareup.bizbank.service.CardActivity.ActivityType",
                                                "id": 5,
                                                "rule": "repeated"
                                            },
                                            "includeActivityTypes": {
                                                "type": ".squareup.bizbank.service.CardActivity.ActivityType",
                                                "id": 6,
                                                "rule": "repeated"
                                            },
                                            "dateSource": {
                                                "type": ".squareup.bizbank.service.GetCardActivityRequest.Filters.DateSource",
                                                "id": 7,
                                                "rule": "optional",
                                                "options": {
                                                    "default": "OCCURRED_AT"
                                                }
                                            }
                                        },
                                        "nested": {
                                            "DateSource": {
                                                "values": {
                                                    "OCCURRED_AT": 1,
                                                    "UPDATED_AT": 2
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "GetCardActivityResponse": {
                                "fields": {
                                    "transactionEvents": {
                                        "type": ".squareup.banklin.TransactionEvent",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "cardActivity": {
                                        "type": ".squareup.bizbank.service.CardActivity",
                                        "id": 6,
                                        "rule": "repeated"
                                    },
                                    "batchResponse": {
                                        "type": ".squareup.bizbank.service.GetCardActivityResponse.BatchResponse",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "fetchedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "balance": {
                                        "type": ".squareup.common.Money",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "maxInstantDepositAmount": {
                                        "type": ".squareup.common.Money",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "BatchResponse": {
                                        "fields": {
                                            "nextPaginationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetCardCustomizationRequest": {
                                "fields": {
                                    "returnFullImage": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional",
                                        "options": {
                                            "default": false
                                        }
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1
                                    },
                                    "customizationToken": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "token": {
                                        "oneof": [
                                            "unitToken",
                                            "customizationToken"
                                        ]
                                    }
                                }
                            },
                            "CardCustomization": {
                                "fields": {
                                    "imageBytes": {
                                        "type": "bytes",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "mimeType": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetCardCustomizationResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "businessName": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardCustomization": {
                                        "type": ".squareup.bizbank.service.CardCustomization",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetEnabledRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "merchantToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetEnabledResponse": {
                                "fields": {
                                    "isEnabled": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "enabledAttributes": {
                                        "type": ".squareup.bizbank.service.GetEnabledResponse.EnabledAttribute",
                                        "id": 2,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "EnabledAttribute": {
                                        "fields": {
                                            "unitToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "isEnabled": {
                                                "type": "bool",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetEnabledHistoryRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetEnabledHistoryResponse": {
                                "fields": {
                                    "enabledIntervals": {
                                        "type": ".squareup.common.time.DateTimeInterval",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "enabledIntervalsByBanklinToken": {
                                        "type": ".squareup.bizbank.service.GetEnabledHistoryResponse.DateTimeIntervals",
                                        "id": 2,
                                        "keyType": "string"
                                    }
                                },
                                "nested": {
                                    "DateTimeIntervals": {
                                        "fields": {
                                            "intervals": {
                                                "type": ".squareup.common.time.DateTimeInterval",
                                                "id": 1,
                                                "rule": "repeated"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetCardBillingAddressRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetCardBillingAddressResponse": {
                                "fields": {
                                    "billingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "DigitalWalletToken": {
                                "fields": {
                                    "digitalWalletToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "issuerCardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "digitalWalletIssuer": {
                                        "type": ".squareup.banklin.DigitalWalletIssuer",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "digitalWalletState": {
                                        "type": ".squareup.banklin.DigitalWalletState",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "devicePhoneNumberLastFour": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "deviceType": {
                                        "type": ".squareup.banklin.DeviceType",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "bizbankCardToken": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "panReferenceId": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetDigitalWalletTokenRequest": {
                                "fields": {
                                    "digitalWalletToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetDigitalWalletTokenResponse": {
                                "fields": {
                                    "digitalWalletToken": {
                                        "type": ".squareup.bizbank.service.DigitalWalletToken",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetDigitalWalletTokensForUnitRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetDigitalWalletTokensForUnitResponse": {
                                "fields": {
                                    "digitalWalletTokens": {
                                        "type": ".squareup.bizbank.service.DigitalWalletToken",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "GetRolledUpActivityRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "repeated"
                                    },
                                    "batchRequest": {
                                        "type": ".squareup.bizbank.model.BatchRequest",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "filters": {
                                        "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.Filters",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "sortOrder": {
                                        "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.SortOrder",
                                        "id": 4,
                                        "rule": "optional",
                                        "options": {
                                            "default": "DESC"
                                        }
                                    }
                                },
                                "nested": {
                                    "SortOrder": {
                                        "values": {
                                            "ASC": 1,
                                            "DESC": 2
                                        }
                                    },
                                    "RolledUpActivityType": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "CARD_PAYMENT": 1,
                                            "DEPOSIT": 2,
                                            "INSTANT_DEPOSIT": 3,
                                            "ATM_WITHDRAWAL": 4
                                        }
                                    },
                                    "Filters": {
                                        "fields": {
                                            "includeTypes": {
                                                "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.RolledUpActivityType",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "excludeTypes": {
                                                "type": ".squareup.bizbank.service.GetRolledUpActivityRequest.RolledUpActivityType",
                                                "id": 2,
                                                "rule": "repeated"
                                            },
                                            "minOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "maxOccurredAt": {
                                                "type": ".squareup.common.time.DateTime",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "transactionToken": {
                                                "type": "string",
                                                "id": 5,
                                                "rule": "repeated"
                                            },
                                            "includeStates": {
                                                "type": ".squareup.banklin.TransactionState",
                                                "id": 6,
                                                "rule": "repeated"
                                            },
                                            "excludeStates": {
                                                "type": ".squareup.banklin.TransactionState",
                                                "id": 7,
                                                "rule": "repeated"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetRolledUpActivityResponse": {
                                "fields": {
                                    "cardActivity": {
                                        "type": ".squareup.bizbank.service.GetRolledUpActivityResponse.RolledUpCardActivity",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "Fee": {
                                        "fields": {
                                            "amount": {
                                                "type": ".squareup.common.Money",
                                                "id": 100,
                                                "rule": "optional"
                                            },
                                            "feeType": {
                                                "type": ".squareup.bizbank.service.GetRolledUpActivityResponse.Fee.FeeType",
                                                "id": 101,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "FeeType": {
                                                "values": {
                                                    "ATM": 1,
                                                    "INSTANT_DEPOSIT": 2
                                                }
                                            }
                                        }
                                    },
                                    "RolledUpCardActivity": {
                                        "fields": {
                                            "activity": {
                                                "type": ".squareup.bizbank.service.CardActivity",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "fee": {
                                                "type": ".squareup.bizbank.service.GetRolledUpActivityResponse.Fee",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "unitToken": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetSpendingLimitsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetSpendingLimitsResponse": {
                                "fields": {
                                    "spendSummaries": {
                                        "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "SpendSummary": {
                                        "fields": {
                                            "spendType": {
                                                "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendType",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "spendLimits": {
                                                "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit",
                                                "id": 2,
                                                "rule": "repeated"
                                            },
                                            "includesPurchases": {
                                                "type": "bool",
                                                "id": 3,
                                                "rule": "optional"
                                            },
                                            "includesWithdrawals": {
                                                "type": "bool",
                                                "id": 4,
                                                "rule": "optional"
                                            },
                                            "includesTransfers": {
                                                "type": "bool",
                                                "id": 5,
                                                "rule": "optional"
                                            },
                                            "includesCashback": {
                                                "type": "bool",
                                                "id": 6,
                                                "rule": "optional"
                                            },
                                            "includesCredits": {
                                                "type": "bool",
                                                "id": 7,
                                                "rule": "optional"
                                            },
                                            "includesP2p": {
                                                "type": "bool",
                                                "id": 9,
                                                "rule": "optional"
                                            },
                                            "controlName": {
                                                "type": "string",
                                                "id": 8,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "SpendType": {
                                                "values": {
                                                    "DO_NOT_USE": 0,
                                                    "MAX_SPEND": 1,
                                                    "CASH_ACCESS": 2,
                                                    "MAX_ATM": 3,
                                                    "MCC_CASH_DISBURSE": 4,
                                                    "CASHBACK": 5,
                                                    "CASHBACK_RESTRICTION": 6,
                                                    "CASHAPP_SEND": 7,
                                                    "P2P_CASHAPP": 8
                                                }
                                            },
                                            "SpendLimit": {
                                                "fields": {
                                                    "cadence": {
                                                        "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.Cadence",
                                                        "id": 1,
                                                        "rule": "optional"
                                                    },
                                                    "amountAvailableToSpend": {
                                                        "type": ".squareup.common.Money",
                                                        "id": 2,
                                                        "rule": "optional"
                                                    },
                                                    "limitAmount": {
                                                        "type": ".squareup.common.Money",
                                                        "id": 3,
                                                        "rule": "optional"
                                                    },
                                                    "daysLeftInCycle": {
                                                        "type": "int32",
                                                        "id": 4,
                                                        "rule": "optional"
                                                    },
                                                    "cardType": {
                                                        "type": ".squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.CardType",
                                                        "id": 5,
                                                        "rule": "optional"
                                                    }
                                                },
                                                "nested": {
                                                    "Cadence": {
                                                        "values": {
                                                            "DAILY": 1,
                                                            "WEEKLY": 2,
                                                            "MONTHLY": 3,
                                                            "SINGLE_TRANSACTION": 4
                                                        }
                                                    },
                                                    "CardType": {
                                                        "values": {
                                                            "PHYSICAL_CARD": 0,
                                                            "VIRTUAL_CARD": 1,
                                                            "PHYSICAL_AND_VIRTUAL_CARD": 2
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "GetAtmLimitsRequest": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetAtmLimitsResponse": {
                                "fields": {
                                    "limits": {
                                        "type": ".squareup.bizbank.service.GetAtmLimitsResponse.Limit",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "Limit": {
                                        "fields": {
                                            "cadence": {
                                                "type": ".squareup.bizbank.service.GetAtmLimitsResponse.Limit.Cadence",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "availableToSpendAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "limitAmount": {
                                                "type": ".squareup.common.Money",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        },
                                        "nested": {
                                            "Cadence": {
                                                "values": {
                                                    "DAILY": 1,
                                                    "WEEKLY": 2,
                                                    "MONTHLY": 3,
                                                    "PER_TRANSACTION": 4
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "CreateCardInvitationRequest": {
                                "fields": {
                                    "firstName": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "lastName": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "email": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "balanceId": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CreateCardInvitationResponse": {
                                "fields": {
                                    "cardInvitation": {
                                        "type": ".squareup.bizbank.invitations.CardInvitation",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SendNotificationRequest": {
                                "fields": {
                                    "idempotencyKey": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardInvitationEmail": {
                                        "type": ".squareup.bizbank.service.SendNotificationRequest.CardInvitationEmailPayload",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "CardInvitationEmailPayload": {
                                        "fields": {
                                            "cardInvitationToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "notification_payload": {
                                        "oneof": [
                                            "cardInvitationEmail"
                                        ]
                                    }
                                }
                            },
                            "SendNotificationResponse": {
                                "fields": {}
                            },
                            "CardAssignment": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "personToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardInvitationToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SearchCardAssignmentsRequest": {
                                "fields": {
                                    "query": {
                                        "type": ".squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsQuery",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "CardAssignmentsFilter": {
                                        "fields": {
                                            "cardTokens": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "repeated"
                                            }
                                        }
                                    },
                                    "CardAssignmentsQuery": {
                                        "fields": {
                                            "filter": {
                                                "type": ".squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsFilter",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "SearchCardAssignmentsResponse": {
                                "fields": {
                                    "assignments": {
                                        "type": ".squareup.bizbank.service.CardAssignment",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "ListCardsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "includeAdditionalDetails": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "filters": {
                                        "type": ".squareup.bizbank.service.ListCardsRequest.Filters",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "sortOrder": {
                                        "type": ".squareup.bizbank.service.ListCardsRequest.SortOrder",
                                        "id": 4,
                                        "rule": "optional",
                                        "options": {
                                            "default": "ASC"
                                        }
                                    }
                                },
                                "nested": {
                                    "SortOrder": {
                                        "values": {
                                            "ASC": 1,
                                            "DESC": 2
                                        }
                                    },
                                    "Filters": {
                                        "fields": {
                                            "includedCardTypes": {
                                                "type": ".squareup.bizbank.service.CardData.CardType",
                                                "id": 1,
                                                "rule": "repeated"
                                            }
                                        }
                                    }
                                }
                            },
                            "ListCardsResponse": {
                                "fields": {
                                    "cards": {
                                        "type": ".squareup.bizbank.service.CardData",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "CardBrand": {
                                "values": {
                                    "VISA": 1,
                                    "MASTERCARD": 2
                                }
                            },
                            "CardData": {
                                "fields": {
                                    "cardToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "banklinCardToken": {
                                        "type": "string",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "cardState": {
                                        "type": ".squareup.bizbank.service.CardData.CardState",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardBrand": {
                                        "type": ".squareup.bizbank.service.CardBrand",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "panLastFour": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "nameOnCard": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "active2faTokenTypes": {
                                        "type": ".squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                                        "id": 6,
                                        "rule": "repeated"
                                    },
                                    "shippingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "billingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "createdAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "cardType": {
                                        "type": ".squareup.bizbank.service.CardData.CardType",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "deactivationReason": {
                                        "type": ".squareup.bizbank.service.DeactivateCardRequest.DeactivationReason",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "cardEvents": {
                                        "type": ".squareup.banklin.CardEvent",
                                        "id": 12,
                                        "rule": "repeated"
                                    },
                                    "isActivatable": {
                                        "type": "bool",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "customizationToken": {
                                        "type": "string",
                                        "id": 15,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "CardState": {
                                        "values": {
                                            "ACTIVE": 1,
                                            "DISABLED": 2,
                                            "TERMINATED": 3,
                                            "SUSPENDED": 4,
                                            "VERIFIED": 5,
                                            "ISSUED": 6,
                                            "UNDELIVERABLE": 7,
                                            "SHIPPED": 8,
                                            "CANCELLED": 9,
                                            "REJECTED": 10,
                                            "DESTROYED": 11,
                                            "ACTIVE_PENDING_2FA": 12,
                                            "REVIEW_PENDING": 13,
                                            "CUSTOMIZATION_APPROVED": 14,
                                            "CUSTOMIZATION_DENIED": 15
                                        }
                                    },
                                    "CardType": {
                                        "values": {
                                            "PHYSICAL": 1,
                                            "VIRTUAL": 2
                                        }
                                    }
                                }
                            },
                            "CardActivity": {
                                "fields": {
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "amount": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "description": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "activityType": {
                                        "type": ".squareup.bizbank.service.CardActivity.ActivityType",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "transactionState": {
                                        "type": ".squareup.banklin.TransactionState",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "occurredAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "activityDisplayString": {
                                        "type": "string",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "paginationToken": {
                                        "type": "string",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "declineReason": {
                                        "type": ".squareup.banklin.octopus.OctopusResult",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "updatedAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 13,
                                        "rule": "optional"
                                    },
                                    "moneyTransferServerToken": {
                                        "type": "string",
                                        "id": 14,
                                        "rule": "optional"
                                    },
                                    "cardInfo": {
                                        "type": ".squareup.bizbank.service.CardActivity.DepositCardInfo",
                                        "id": 9
                                    },
                                    "bankInfo": {
                                        "type": ".squareup.bizbank.service.CardActivity.DepositBankInfo",
                                        "id": 10
                                    }
                                },
                                "nested": {
                                    "ActivityType": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "CARD_PAYMENT": 1,
                                            "DEPOSIT": 2,
                                            "INSTANT_DEPOSIT": 3,
                                            "INSTANT_DEPOSIT_FEE": 4,
                                            "ATM_WITHDRAWAL": 5,
                                            "ATM_WITHDRAWAL_FEE": 6,
                                            "CARD_PAYMENT_REWARD": 7
                                        }
                                    },
                                    "DepositCardInfo": {
                                        "fields": {
                                            "cardBrand": {
                                                "type": ".squareup.common.instrument.InstrumentType",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "panSuffix": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "cardToken": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "DepositBankInfo": {
                                        "fields": {
                                            "bankName": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "bankAccountSuffix": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "bankAccountToken": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "deposit_info": {
                                        "oneof": [
                                            "cardInfo",
                                            "bankInfo"
                                        ]
                                    }
                                }
                            },
                            "ProvideFeedbackRequest": {
                                "fields": {
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "feedbackText": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "feedbackSource": {
                                        "type": ".squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "FeedbackSource": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "CARD_DEACTIVATION": 1,
                                            "BALANCE_DEACTIVATION": 2,
                                            "ACCOUNT_DEACTIVATION_REGULATOR": 3,
                                            "TRANSFER_OF_ACCOUNT": 4,
                                            "ADMIN_CONSOLE": 5,
                                            "ACCOUNT_DEACTIVATION_BANK_PARTNER": 6,
                                            "ACCOUNT_DEACTIVATION_RISK_TEAM": 7
                                        }
                                    }
                                }
                            },
                            "ProvisionDigitalWalletTokenRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "provisioningAppVersion": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "deviceType": {
                                        "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.DeviceType",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "applePayRequest": {
                                        "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.ApplePayRequest",
                                        "id": 5
                                    },
                                    "googlePayRequest": {
                                        "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.GooglePayRequest",
                                        "id": 6
                                    }
                                },
                                "nested": {
                                    "DeviceType": {
                                        "values": {
                                            "UNKNOWN": 1,
                                            "MOBILE_PHONE": 2,
                                            "WATCH": 3
                                        }
                                    },
                                    "ApplePayRequest": {
                                        "fields": {
                                            "certificates": {
                                                "type": "bytes",
                                                "id": 1,
                                                "rule": "repeated"
                                            },
                                            "nonce": {
                                                "type": "bytes",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "nonceSignature": {
                                                "type": "bytes",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "GooglePayRequest": {
                                        "fields": {
                                            "walletAccountId": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "deviceId": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "Request": {
                                        "oneof": [
                                            "applePayRequest",
                                            "googlePayRequest"
                                        ]
                                    }
                                }
                            },
                            "ProvisionDigitalWalletTokenResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "applePayResponse": {
                                        "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.ApplePayResponse",
                                        "id": 2
                                    },
                                    "googlePayResponse": {
                                        "type": ".squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.GooglePayResponse",
                                        "id": 3
                                    }
                                },
                                "nested": {
                                    "ApplePayResponse": {
                                        "fields": {
                                            "encryptedPassData": {
                                                "type": "bytes",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "activationData": {
                                                "type": "bytes",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "ephemeralPublicKey": {
                                                "type": "bytes",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "GooglePayResponse": {
                                        "fields": {
                                            "opaquePaymentCard": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "Response": {
                                        "oneof": [
                                            "applePayResponse",
                                            "googlePayResponse"
                                        ]
                                    }
                                }
                            },
                            "ProvideFeedbackResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetCardBillingAddressRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "billingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetCardBillingAddressResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "billingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "failureReason": {
                                        "type": ".squareup.bizbank.service.SetCardBillingAddressResponse.FailureReason",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "FailureReason": {
                                        "values": {
                                            "NO_FAILURE": 0,
                                            "NO_BIZBANK_USER_FOUND": 1,
                                            "ADDRESS_IS_PO_BOX": 2,
                                            "ADDRESS_IS_INVALID": 3,
                                            "MARQETA_VERIFICATION_ERROR": 4
                                        }
                                    }
                                }
                            },
                            "SetEnabledRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "enabled": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetEnabledResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetPasscodeRequest": {
                                "fields": {
                                    "passcode": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "authenticationToken": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SetPasscodeResponse": {
                                "fields": {
                                    "result": {
                                        "type": ".squareup.bizbank.service.SetPasscodeResponse.Result",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Result": {
                                        "values": {
                                            "SUCCESS": 1,
                                            "FAILED": 2,
                                            "INVALID_CARD_TOKEN": 3,
                                            "FAILED_WEAK_PASSCODE": 4,
                                            "AUTHENTICATION_TOKEN_INVALID": 5,
                                            "AUTHENTICATION_TOKEN_EXPIRED": 6
                                        }
                                    }
                                }
                            },
                            "StartCardActivationRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartCardActivationResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartIdentityVerificationRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "ownerAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "ownerBirthDate": {
                                        "type": ".squareup.common.time.YearMonthDay",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "ownerSocialSecurityNumber": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartIdentityVerificationResponse": {
                                "fields": {
                                    "pollToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartIssueCardRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "shippingAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartIssueCardResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "cardIssueToken": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "normalizedAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "addressNormalizationResult": {
                                        "type": ".squareup.bizbank.service.StartIssueCardResponse.AddressNormalizationResult",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "correctedField": {
                                        "type": ".squareup.solidshop.VerifyShippingAddressResponse.CorrectedField",
                                        "id": 6,
                                        "rule": "repeated"
                                    },
                                    "challengeRequested": {
                                        "type": "bool",
                                        "id": 7,
                                        "rule": "optional",
                                        "options": {
                                            "default": false
                                        }
                                    }
                                },
                                "nested": {
                                    "AddressNormalizationResult": {
                                        "values": {
                                            "SUCCESS": 1,
                                            "VERIFICATION_NOT_AVAILABLE": 2,
                                            "VERIFICATION_FAILED": 3,
                                            "UNKNOWN_ERROR": 4
                                        }
                                    }
                                }
                            },
                            "TwoFactorAuthenticationRequestType": {
                                "values": {
                                    "DO_NOT_USE": 0,
                                    "CARD_ACTIVATION": 1,
                                    "RESET_PASSCODE": 2,
                                    "SHOW_PRIVATE_CARD_DATA": 3,
                                    "SHOW_DIRECT_DEPOSIT_ACCOUNT": 4
                                }
                            },
                            "StartTwoFactorAuthenticationRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "requestType": {
                                        "type": ".squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "StartTwoFactorAuthenticationResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ToggleCardRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "enableCard": {
                                        "type": "bool",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "sourceApplication": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ToggleCardResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "card": {
                                        "type": ".squareup.bizbank.service.CardData",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "VerifyCardActivationTokenRequest": {
                                "fields": {
                                    "activationToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "VerifyCardActivationTokenResponse": {
                                "fields": {
                                    "result": {
                                        "type": ".squareup.bizbank.service.VerifyCardActivationTokenResponse.Result",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Result": {
                                        "values": {
                                            "VERIFIED": 1,
                                            "INVALID_TOKEN": 2,
                                            "EXPIRED_TOKEN": 3,
                                            "USED": 4,
                                            "FAILED": 5
                                        }
                                    }
                                }
                            },
                            "VerifyTwoFactorAuthenticationTokenRequest": {
                                "fields": {
                                    "authenticationToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "requestType": {
                                        "type": ".squareup.bizbank.service.TwoFactorAuthenticationRequestType",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "VerifyTwoFactorAuthenticationTokenResponse": {
                                "fields": {
                                    "result": {
                                        "type": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse.Result",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "Result": {
                                        "values": {
                                            "VERIFIED": 1,
                                            "INVALID_TOKEN": 2,
                                            "EXPIRED_TOKEN": 3
                                        }
                                    }
                                }
                            },
                            "VoidAuthorizationRequest": {
                                "fields": {
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "VoidAuthorizationResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "IdvState": {
                                "values": {
                                    "IDV_DO_NOT_USE": 0,
                                    "APPROVED": 1,
                                    "INCOMPLETE": 2
                                }
                            },
                            "GetFundsHoldingAccountRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1
                                    },
                                    "balanceToken": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "customer_token": {
                                        "oneof": [
                                            "unitToken",
                                            "balanceToken"
                                        ]
                                    }
                                }
                            },
                            "GetFundsHoldingAccountResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "countryCode": {
                                        "type": ".squareup.common.countries.Country",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetIsUserAuthorizedRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "loggableSessionToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetIsUserAuthorizedResponse": {
                                "fields": {
                                    "isAuthorized": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetPromotionalRewardDescriptionRequest": {
                                "fields": {
                                    "transactionToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetPromotionalRewardDescriptionResponse": {
                                "fields": {
                                    "description": {
                                        "type": "string",
                                        "id": 1
                                    },
                                    "error": {
                                        "type": ".squareup.bizbank.service.GetPromotionalRewardDescriptionResponse.Error",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "Error": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "TRANSACTION_NOT_FOUND": 1,
                                            "INVALID_TRANSACTION_TOKEN": 2
                                        }
                                    },
                                    "result": {
                                        "oneof": [
                                            "description",
                                            "error"
                                        ]
                                    }
                                }
                            },
                            "LookupUnitRequest": {
                                "fields": {
                                    "panFideliusToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "LookupUnitResponse": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "balance": {
                                        "type": ".squareup.common.Money",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListDisputedTransactionTokensRequest": {
                                "fields": {
                                    "transactionTokens": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "ListDisputedTransactionTokensResponse": {
                                "fields": {
                                    "disputedTransactionTokens": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "ValidateAddressRequest": {
                                "fields": {
                                    "address": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ValidateAddressResponse": {
                                "fields": {
                                    "normalizedAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "addressNormalizationResult": {
                                        "type": ".squareup.bizbank.service.ValidateAddressResponse.AddressNormalizationResult",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "correctedFields": {
                                        "type": ".squareup.bizbank.service.ValidateAddressResponse.CorrectedField",
                                        "id": 3,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "CorrectedField": {
                                        "values": {
                                            "DO_NOT_USE_FIELD": 0,
                                            "ADDRESS_LINE_1": 1,
                                            "ADDRESS_LINE_2": 2,
                                            "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                                            "LOCALITY": 4,
                                            "POSTAL_CODE": 5
                                        }
                                    },
                                    "AddressNormalizationResult": {
                                        "values": {
                                            "DO_NOT_USE_RESULT": 0,
                                            "SUCCESS": 1,
                                            "VERIFICATION_NOT_AVAILABLE": 2,
                                            "VERIFICATION_FAILED": 3,
                                            "UNKNOWN_ERROR": 4
                                        }
                                    }
                                }
                            },
                            "UpdateCustomerDataRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1
                                    },
                                    "banklinToken": {
                                        "type": "string",
                                        "id": 2
                                    }
                                },
                                "nested": {
                                    "customer_token": {
                                        "oneof": [
                                            "unitToken",
                                            "banklinToken"
                                        ]
                                    }
                                }
                            },
                            "UpdateCustomerDataResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "errorMessage": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetCustomizationSettingsRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "userAgent": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetCustomizationSettingsResponse": {
                                "fields": {
                                    "success": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "ownerName": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "businessName": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "minInkCoverage": {
                                        "type": "float",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "maxInkCoverage": {
                                        "type": "float",
                                        "id": 5,
                                        "rule": "optional"
                                    },
                                    "idvState": {
                                        "type": ".squareup.bizbank.service.IdvState",
                                        "id": 6,
                                        "rule": "optional"
                                    },
                                    "canRetryIdv": {
                                        "type": "bool",
                                        "id": 7,
                                        "rule": "optional"
                                    },
                                    "ownerAddress": {
                                        "type": ".squareup.common.location.GlobalAddress",
                                        "id": 8,
                                        "rule": "optional"
                                    },
                                    "ownerBirthDate": {
                                        "type": ".squareup.common.time.YearMonthDay",
                                        "id": 9,
                                        "rule": "optional"
                                    },
                                    "idvNeedsSsn": {
                                        "type": "bool",
                                        "id": 10,
                                        "rule": "optional"
                                    },
                                    "idvRetriesRemaining": {
                                        "type": "int32",
                                        "id": 11,
                                        "rule": "optional"
                                    },
                                    "ineligibilityReason": {
                                        "type": ".squareup.bizbank.service.GetCustomizationSettingsResponse.IneligibilityReason",
                                        "id": 12,
                                        "rule": "optional"
                                    },
                                    "existingCustomization": {
                                        "type": ".squareup.bizbank.service.GetCustomizationSettingsResponse.ExistingCustomization",
                                        "id": 13,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "IneligibilityReason": {
                                        "values": {
                                            "DO_NOT_USE": 0,
                                            "NOT_ELIGIBLE": 1,
                                            "EXHAUSTED_IDV_RETRIES": 2,
                                            "NOT_ACTIVATED": 3
                                        }
                                    },
                                    "ExistingCustomization": {
                                        "fields": {
                                            "trunkToken": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "imageBytes": {
                                                "type": "bytes",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "mimeType": {
                                                "type": "string",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "GetAllStampsRequest": {
                                "fields": {}
                            },
                            "GetAllStampsResponse": {
                                "fields": {
                                    "stamps": {
                                        "type": ".squareup.bizbank.service.Stamp",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                }
                            },
                            "Stamp": {
                                "fields": {
                                    "name": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "accessibilityText": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "svg": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "minScale": {
                                        "type": "int32",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetFontsRequest": {
                                "fields": {}
                            },
                            "GetFontsResponse": {
                                "fields": {
                                    "fonts": {
                                        "type": ".squareup.bizbank.service.GetFontsResponse.Font",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "Font": {
                                        "fields": {
                                            "fontFamily": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "fontUrl": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "DeactivateAccountRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "deactivationReason": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "source": {
                                        "type": ".squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "idempotenceKey": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "DeactivateAccountResponse": {
                                "fields": {}
                            },
                            "MerchantBlockState": {
                                "values": {
                                    "UNKNOWN_MERCHANT_BLOCK_STATE": 0,
                                    "BLOCKED": 1,
                                    "UNBLOCKED": 2
                                }
                            },
                            "UpdateMerchantBlockRequest": {
                                "fields": {
                                    "merchanteinMerchantToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "merchantBlockState": {
                                        "type": ".squareup.bizbank.service.MerchantBlockState",
                                        "id": 3,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "UpdateMerchantBlockResponse": {
                                "fields": {
                                    "merchantBlockState": {
                                        "type": ".squareup.bizbank.service.MerchantBlockState",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetMerchantBlockRequest": {
                                "fields": {
                                    "merchanteinMerchantToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "unitToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetMerchantBlockResponse": {
                                "fields": {
                                    "merchantBlockState": {
                                        "type": ".squareup.bizbank.service.MerchantBlockState",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListMerchantBlocksRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ListMerchantBlocksResponse": {
                                "fields": {
                                    "blockedMerchanteinMerchants": {
                                        "type": ".squareup.bizbank.service.ListMerchantBlocksResponse.MerchanteinMerchant",
                                        "id": 1,
                                        "rule": "repeated"
                                    }
                                },
                                "nested": {
                                    "MerchanteinMerchant": {
                                        "fields": {
                                            "token": {
                                                "type": "string",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "name": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            },
                                            "merchantImage": {
                                                "type": ".squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage",
                                                "id": 3,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "BizbankService": {
                                "methods": {
                                    "AddMobileNumberForSmsNotifications": {
                                        "requestType": ".squareup.bizbank.service.AddMobileNumberForSmsNotificationsRequest",
                                        "responseType": ".squareup.bizbank.service.AddMobileNumberForSmsNotificationsResponse"
                                    },
                                    "ConfirmIssueCard": {
                                        "requestType": ".squareup.bizbank.service.ConfirmIssueCardRequest",
                                        "responseType": ".squareup.bizbank.service.ConfirmIssueCardResponse"
                                    },
                                    "CheckIdentityVerificationStatus": {
                                        "requestType": ".squareup.bizbank.service.CheckIdentityVerificationStatusRequest",
                                        "responseType": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse"
                                    },
                                    "LedgerDisputeLost": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.LedgerDisputeLostRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.LedgerDisputeLostResponse"
                                    },
                                    "CreateCardCustomization": {
                                        "requestType": ".squareup.bizbank.service.CreateCardCustomizationRequest",
                                        "responseType": ".squareup.bizbank.service.CreateCardCustomizationResponse"
                                    },
                                    "CreateMarqetaDispute": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.CreateMarqetaDisputeRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.CreateMarqetaDisputeResponse"
                                    },
                                    "CreateTransactionDispute": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.CreateTransactionDisputeRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.CreateTransactionDisputeResponse"
                                    },
                                    "CreateUserAuthorization": {
                                        "requestType": ".squareup.bizbank.card_management.CreateUserAuthorizationRequest",
                                        "responseType": ".squareup.bizbank.card_management.CreateUserAuthorizationResponse"
                                    },
                                    "DeactivateAccount": {
                                        "requestType": ".squareup.bizbank.service.DeactivateAccountRequest",
                                        "responseType": ".squareup.bizbank.service.DeactivateAccountResponse"
                                    },
                                    "DeactivateCard": {
                                        "requestType": ".squareup.bizbank.service.DeactivateCardRequest",
                                        "responseType": ".squareup.bizbank.service.DeactivateCardResponse"
                                    },
                                    "ExpireAllUserAuthorizations": {
                                        "requestType": ".squareup.bizbank.card_management.ExpireAllUserAuthorizationsRequest",
                                        "responseType": ".squareup.bizbank.card_management.ExpireAllUserAuthorizationsResponse"
                                    },
                                    "FinishCardActivation": {
                                        "requestType": ".squareup.bizbank.service.FinishCardActivationRequest",
                                        "responseType": ".squareup.bizbank.service.FinishCardActivationResponse"
                                    },
                                    "EnqueueSweep": {
                                        "requestType": ".squareup.bizbank.service.EnqueueSweepRequest",
                                        "responseType": ".squareup.bizbank.service.EnqueueSweepResponse"
                                    },
                                    "GetAtmLimits": {
                                        "requestType": ".squareup.bizbank.service.GetAtmLimitsRequest",
                                        "responseType": ".squareup.bizbank.service.GetAtmLimitsResponse"
                                    },
                                    "GetBalance": {
                                        "requestType": ".squareup.bizbank.service.GetBalanceRequest",
                                        "responseType": ".squareup.bizbank.service.GetBalanceResponse"
                                    },
                                    "GetBalanceOverview": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetBalanceOverviewRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetBalanceOverviewResponse"
                                    },
                                    "GetPaymentProcessingDetails": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsResponse"
                                    },
                                    "GetBizbankAccount": {
                                        "requestType": ".squareup.bizbank.service.GetBizbankAccountRequest",
                                        "responseType": ".squareup.bizbank.service.GetBizbankAccountResponse"
                                    },
                                    "GetCardActivity": {
                                        "requestType": ".squareup.bizbank.service.GetCardActivityRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardActivityResponse"
                                    },
                                    "GetCardCustomization": {
                                        "requestType": ".squareup.bizbank.service.GetCardCustomizationRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardCustomizationResponse"
                                    },
                                    "GetCardOrderingEligibility": {
                                        "requestType": ".squareup.bizbank.service.GetCardOrderingEligibilityRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardOrderingEligibilityResponse"
                                    },
                                    "GetDigitalWalletToken": {
                                        "requestType": ".squareup.bizbank.service.GetDigitalWalletTokenRequest",
                                        "responseType": ".squareup.bizbank.service.GetDigitalWalletTokenResponse"
                                    },
                                    "GetDigitalWalletTokensForUnit": {
                                        "requestType": ".squareup.bizbank.service.GetDigitalWalletTokensForUnitRequest",
                                        "responseType": ".squareup.bizbank.service.GetDigitalWalletTokensForUnitResponse"
                                    },
                                    "GetFundsHoldingAccount": {
                                        "requestType": ".squareup.bizbank.service.GetFundsHoldingAccountRequest",
                                        "responseType": ".squareup.bizbank.service.GetFundsHoldingAccountResponse"
                                    },
                                    "GetPrivateCardData": {
                                        "requestType": ".squareup.bizbank.card_management.GetPrivateCardDataRequest",
                                        "responseType": ".squareup.bizbank.card_management.GetPrivateCardDataResponse"
                                    },
                                    "GetEnabled": {
                                        "requestType": ".squareup.bizbank.service.GetEnabledRequest",
                                        "responseType": ".squareup.bizbank.service.GetEnabledResponse"
                                    },
                                    "GetEnabledHistory": {
                                        "requestType": ".squareup.bizbank.service.GetEnabledHistoryRequest",
                                        "responseType": ".squareup.bizbank.service.GetEnabledHistoryResponse"
                                    },
                                    "GetFonts": {
                                        "requestType": ".squareup.bizbank.service.GetFontsRequest",
                                        "responseType": ".squareup.bizbank.service.GetFontsResponse"
                                    },
                                    "GetCardBillingAddress": {
                                        "requestType": ".squareup.bizbank.service.GetCardBillingAddressRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardBillingAddressResponse"
                                    },
                                    "GetRolledUpActivity": {
                                        "requestType": ".squareup.bizbank.service.GetRolledUpActivityRequest",
                                        "responseType": ".squareup.bizbank.service.GetRolledUpActivityResponse"
                                    },
                                    "GetSpendingLimits": {
                                        "requestType": ".squareup.bizbank.service.GetSpendingLimitsRequest",
                                        "responseType": ".squareup.bizbank.service.GetSpendingLimitsResponse"
                                    },
                                    "GetUnifiedActivities": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse"
                                    },
                                    "GetUnifiedActivityDetails": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse"
                                    },
                                    "GetUnifiedActivityEvents": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventsResponse"
                                    },
                                    "GetUnifiedActivityEventDetails": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityEventDetailsResponse"
                                    },
                                    "GetUnifiedActivityTransitionData": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityTransitionDataResponse"
                                    },
                                    "GetIsUserAuthorized": {
                                        "requestType": ".squareup.bizbank.service.GetIsUserAuthorizedRequest",
                                        "responseType": ".squareup.bizbank.service.GetIsUserAuthorizedResponse"
                                    },
                                    "HandleDisputeStatusUpdateEvent": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.HandleDisputeStatusUpdateEventResponse"
                                    },
                                    "ListCards": {
                                        "requestType": ".squareup.bizbank.service.ListCardsRequest",
                                        "responseType": ".squareup.bizbank.service.ListCardsResponse"
                                    },
                                    "GetTransactionDispute": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeResponse"
                                    },
                                    "GetTransactionDisputeByTransactionToken": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeByTransactionTokenResponse"
                                    },
                                    "GetTransactionDisputeActivity": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityResponse"
                                    },
                                    "IssueCard": {
                                        "requestType": ".squareup.bizbank.service.IssueCardRequest",
                                        "responseType": ".squareup.bizbank.service.IssueCardResponse"
                                    },
                                    "CreateCardInvitation": {
                                        "requestType": ".squareup.bizbank.service.CreateCardInvitationRequest",
                                        "responseType": ".squareup.bizbank.service.CreateCardInvitationResponse"
                                    },
                                    "SendNotification": {
                                        "requestType": ".squareup.bizbank.service.SendNotificationRequest",
                                        "responseType": ".squareup.bizbank.service.SendNotificationResponse"
                                    },
                                    "SearchCardAssignments": {
                                        "requestType": ".squareup.bizbank.service.SearchCardAssignmentsRequest",
                                        "responseType": ".squareup.bizbank.service.SearchCardAssignmentsResponse"
                                    },
                                    "ListTransactionDisputes": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesResponse"
                                    },
                                    "ListDisputedTransactionTokens": {
                                        "requestType": ".squareup.bizbank.service.ListDisputedTransactionTokensRequest",
                                        "responseType": ".squareup.bizbank.service.ListDisputedTransactionTokensResponse"
                                    },
                                    "ListTransactionDisputeStatusUpdates": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputeStatusUpdatesResponse"
                                    },
                                    "LookupUnit": {
                                        "requestType": ".squareup.bizbank.service.LookupUnitRequest",
                                        "responseType": ".squareup.bizbank.service.LookupUnitResponse"
                                    },
                                    "ProvideFeedback": {
                                        "requestType": ".squareup.bizbank.service.ProvideFeedbackRequest",
                                        "responseType": ".squareup.bizbank.service.ProvideFeedbackResponse"
                                    },
                                    "ProvisionDigitalWalletToken": {
                                        "requestType": ".squareup.bizbank.service.ProvisionDigitalWalletTokenRequest",
                                        "responseType": ".squareup.bizbank.service.ProvisionDigitalWalletTokenResponse"
                                    },
                                    "SetCardBillingAddress": {
                                        "requestType": ".squareup.bizbank.service.SetCardBillingAddressRequest",
                                        "responseType": ".squareup.bizbank.service.SetCardBillingAddressResponse"
                                    },
                                    "SetEnabled": {
                                        "requestType": ".squareup.bizbank.service.SetEnabledRequest",
                                        "responseType": ".squareup.bizbank.service.SetEnabledResponse"
                                    },
                                    "SetPasscode": {
                                        "requestType": ".squareup.bizbank.service.SetPasscodeRequest",
                                        "responseType": ".squareup.bizbank.service.SetPasscodeResponse"
                                    },
                                    "StartCardActivation": {
                                        "requestType": ".squareup.bizbank.service.StartCardActivationRequest",
                                        "responseType": ".squareup.bizbank.service.StartCardActivationResponse"
                                    },
                                    "StartIdentityVerification": {
                                        "requestType": ".squareup.bizbank.service.StartIdentityVerificationRequest",
                                        "responseType": ".squareup.bizbank.service.StartIdentityVerificationResponse"
                                    },
                                    "StartIssueCard": {
                                        "requestType": ".squareup.bizbank.service.StartIssueCardRequest",
                                        "responseType": ".squareup.bizbank.service.StartIssueCardResponse"
                                    },
                                    "StartTwoFactorAuthentication": {
                                        "requestType": ".squareup.bizbank.service.StartTwoFactorAuthenticationRequest",
                                        "responseType": ".squareup.bizbank.service.StartTwoFactorAuthenticationResponse"
                                    },
                                    "ToggleCard": {
                                        "requestType": ".squareup.bizbank.service.ToggleCardRequest",
                                        "responseType": ".squareup.bizbank.service.ToggleCardResponse"
                                    },
                                    "UpdateCustomerData": {
                                        "requestType": ".squareup.bizbank.service.UpdateCustomerDataRequest",
                                        "responseType": ".squareup.bizbank.service.UpdateCustomerDataResponse"
                                    },
                                    "UpdateTransactionDispute": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeResponse"
                                    },
                                    "UpdateTransactionDisputeByTransactionToken": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeByTransactionTokenRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.UpdateTransactionDisputeResponse"
                                    },
                                    "UpdateDeactivationReason": {
                                        "requestType": ".squareup.bizbank.service.UpdateDeactivationReasonRequest",
                                        "responseType": ".squareup.bizbank.service.UpdateDeactivationReasonResponse"
                                    },
                                    "ValidateAddress": {
                                        "requestType": ".squareup.bizbank.service.ValidateAddressRequest",
                                        "responseType": ".squareup.bizbank.service.ValidateAddressResponse"
                                    },
                                    "VerifyCardActivationToken": {
                                        "requestType": ".squareup.bizbank.service.VerifyCardActivationTokenRequest",
                                        "responseType": ".squareup.bizbank.service.VerifyCardActivationTokenResponse"
                                    },
                                    "VerifyTwoFactorAuthenticationToken": {
                                        "requestType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenRequest",
                                        "responseType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse"
                                    },
                                    "VoidAuthorization": {
                                        "requestType": ".squareup.bizbank.service.VoidAuthorizationRequest",
                                        "responseType": ".squareup.bizbank.service.VoidAuthorizationResponse"
                                    },
                                    "GetPromotionalRewardDescription": {
                                        "requestType": ".squareup.bizbank.service.GetPromotionalRewardDescriptionRequest",
                                        "responseType": ".squareup.bizbank.service.GetPromotionalRewardDescriptionResponse"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.AddMobileNumberForSmsNotificationsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.AddMobileNumberForSmsNotificationsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Response && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Pending && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.IdvError && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CheckIdentityVerificationStatusResponse?.nested?.Error && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ConfirmIssueCardRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ConfirmIssueCardResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IssueCardRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IssueCardRequest?.nested?.PhysicalCardDetails && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IssueCardResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardCustomizationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardCustomizationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardRequest?.nested?.DeactivationReason && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateCardResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateDeactivationReasonRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateDeactivationReasonResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateDeactivationReasonResponse?.nested?.UpdateDeactivationReasonError && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.FinishCardActivationResponse?.nested?.Result && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.EnqueueSweepRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.EnqueueSweepResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBalanceRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBalanceResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBizbankAccountRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBizbankAccountResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetBizbankAccountResponse?.nested?.BizbankAccount && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UnitIneligibilityReason && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardOrderingEligibilityRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardOrderingEligibilityResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest?.nested?.Filters && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityRequest?.nested?.Filters?.nested?.DateSource && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardActivityResponse?.nested?.BatchResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardCustomizationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardCustomization && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardCustomizationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledResponse?.nested?.EnabledAttribute && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledHistoryRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledHistoryResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetEnabledHistoryResponse?.nested?.DateTimeIntervals && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardBillingAddressRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCardBillingAddressResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DigitalWalletToken && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokenRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokenResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokensForUnitRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetDigitalWalletTokensForUnitResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest?.nested?.SortOrder && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest?.nested?.RolledUpActivityType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityRequest?.nested?.Filters && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse?.nested?.Fee && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse?.nested?.Fee?.nested?.FeeType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetRolledUpActivityResponse?.nested?.RolledUpCardActivity && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendLimit && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendLimit?.nested?.Cadence && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetSpendingLimitsResponse?.nested?.SpendSummary?.nested?.SpendLimit?.nested?.CardType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsResponse?.nested?.Limit && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAtmLimitsResponse?.nested?.Limit?.nested?.Cadence && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardInvitationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CreateCardInvitationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SendNotificationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SendNotificationRequest?.nested?.CardInvitationEmailPayload && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SendNotificationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardAssignment && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsRequest?.nested?.CardAssignmentsFilter && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsRequest?.nested?.CardAssignmentsQuery && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SearchCardAssignmentsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest?.nested?.SortOrder && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsRequest?.nested?.Filters && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListCardsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardBrand && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData?.nested?.CardState && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardData?.nested?.CardType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.ActivityType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.DepositCardInfo && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.CardActivity?.nested?.DepositBankInfo && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackRequest?.nested?.FeedbackSource && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest?.nested?.DeviceType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest?.nested?.ApplePayRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenRequest?.nested?.GooglePayRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenResponse?.nested?.ApplePayResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvisionDigitalWalletTokenResponse?.nested?.GooglePayResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ProvideFeedbackResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetCardBillingAddressResponse?.nested?.FailureReason && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetEnabledRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetEnabledResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.SetPasscodeResponse?.nested?.Result && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartCardActivationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartCardActivationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIdentityVerificationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIdentityVerificationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartIssueCardResponse?.nested?.AddressNormalizationResult && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.TwoFactorAuthenticationRequestType && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartTwoFactorAuthenticationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.StartTwoFactorAuthenticationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ToggleCardRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ToggleCardResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyCardActivationTokenResponse?.nested?.Result && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VerifyTwoFactorAuthenticationTokenResponse?.nested?.Result && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VoidAuthorizationRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.VoidAuthorizationResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.IdvState && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFundsHoldingAccountRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFundsHoldingAccountResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetIsUserAuthorizedRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetIsUserAuthorizedResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetPromotionalRewardDescriptionRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetPromotionalRewardDescriptionResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetPromotionalRewardDescriptionResponse?.nested?.Error && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.LookupUnitRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.LookupUnitResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListDisputedTransactionTokensRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListDisputedTransactionTokensResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse?.nested?.CorrectedField && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ValidateAddressResponse?.nested?.AddressNormalizationResult && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateCustomerDataRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateCustomerDataResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse?.nested?.IneligibilityReason && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetCustomizationSettingsResponse?.nested?.ExistingCustomization && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAllStampsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetAllStampsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.Stamp && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFontsRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFontsResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetFontsResponse?.nested?.Font && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateAccountRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.DeactivateAccountResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.MerchantBlockState && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateMerchantBlockRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.UpdateMerchantBlockResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetMerchantBlockRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.GetMerchantBlockResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksRequest && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksResponse && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.ListMerchantBlocksResponse?.nested?.MerchanteinMerchant && !$3f73c216104868a6$var$$root.nested?.squareup?.nested?.bizbank?.nested?.service?.nested?.BizbankService) $3f73c216104868a6$var$$root.addJSON($3f73c216104868a6$var$jsonData);
const $3f73c216104868a6$export$253585ba1cdf0b3a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.AddMobileNumberForSmsNotificationsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$253585ba1cdf0b3a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$253585ba1cdf0b3a);
const $3f73c216104868a6$export$c158937f79cc6528 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.AddMobileNumberForSmsNotificationsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c158937f79cc6528);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c158937f79cc6528);
const $3f73c216104868a6$export$bde473bfd1f5e612 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$bde473bfd1f5e612, {
    unitToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$bde473bfd1f5e612);
const $3f73c216104868a6$export$23505a1850980175 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$23505a1850980175);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$23505a1850980175);
/**
 * SOURCE Response @ squareup/bizbank/service.proto at 71:3
 */ $3f73c216104868a6$export$23505a1850980175.Response = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Response');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$23505a1850980175.Response);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$23505a1850980175.Response);
/**
 * SOURCE Pending @ squareup/bizbank/service.proto at 82:3
 */ $3f73c216104868a6$export$23505a1850980175.Pending = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Pending');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$23505a1850980175.Pending);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$23505a1850980175.Pending);
/**
 * SOURCE IdvError @ squareup/bizbank/service.proto at 86:3
 */ $3f73c216104868a6$export$23505a1850980175.IdvError = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.IdvError').values;
/**
 * SOURCE Error @ squareup/bizbank/service.proto at 94:3
 */ $3f73c216104868a6$export$23505a1850980175.Error = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CheckIdentityVerificationStatusResponse.Error');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$23505a1850980175.Error);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$23505a1850980175.Error);
const $3f73c216104868a6$export$323ab8e57069a144 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ConfirmIssueCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$323ab8e57069a144, {
    unitToken: {
        notEmpty: true
    },
    cardIssueToken: {
        notEmpty: true
    },
    shippingAddress: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$323ab8e57069a144);
const $3f73c216104868a6$export$881590e4b6fda91d = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ConfirmIssueCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$881590e4b6fda91d, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$881590e4b6fda91d);
const $3f73c216104868a6$export$9f6faf5543ebcce8 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.IssueCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9f6faf5543ebcce8, {
    unitToken: {
        notEmpty: true
    },
    createPhysicalCard: {
        required: true
    },
    createVirtualCard: {
        required: true
    },
    idempotenceKey: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9f6faf5543ebcce8);
/**
 * SOURCE PhysicalCardDetails @ squareup/bizbank/service.proto at 129:3
 */ $3f73c216104868a6$export$9f6faf5543ebcce8.PhysicalCardDetails = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.IssueCardRequest.PhysicalCardDetails');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9f6faf5543ebcce8.PhysicalCardDetails, {
    firstName: {
        notEmpty: true
    },
    lastName: {
        notEmpty: true
    },
    shippingAddress: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9f6faf5543ebcce8.PhysicalCardDetails);
const $3f73c216104868a6$export$94d83c06da546ba7 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.IssueCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$94d83c06da546ba7);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$94d83c06da546ba7);
const $3f73c216104868a6$export$aed3bec368de6e1f = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CreateCardCustomizationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$aed3bec368de6e1f, {
    idempotenceKey: {
        notEmpty: true
    },
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$aed3bec368de6e1f);
const $3f73c216104868a6$export$ed2908e9380ce647 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CreateCardCustomizationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ed2908e9380ce647, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ed2908e9380ce647);
const $3f73c216104868a6$export$384405cd0a72593f = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.DeactivateCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$384405cd0a72593f, {
    unitToken: {
        notEmpty: true
    },
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$384405cd0a72593f);
/**
 * SOURCE DeactivationReason @ squareup/bizbank/service.proto at 171:3
 */ $3f73c216104868a6$export$384405cd0a72593f.DeactivationReason = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.DeactivateCardRequest.DeactivationReason').values;
const $3f73c216104868a6$export$9fa1b18da678fcb4 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.DeactivateCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9fa1b18da678fcb4, {
    success: {
        required: true
    },
    bizbankEnabled: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9fa1b18da678fcb4);
const $3f73c216104868a6$export$738d8d6ff2491de0 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateDeactivationReasonRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$738d8d6ff2491de0, {
    cardToken: {
        notEmpty: true
    },
    reason: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$738d8d6ff2491de0);
const $3f73c216104868a6$export$8027559510942413 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateDeactivationReasonResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8027559510942413);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8027559510942413);
/**
 * SOURCE UpdateDeactivationReasonError @ squareup/bizbank/service.proto at 204:3
 */ $3f73c216104868a6$export$8027559510942413.UpdateDeactivationReasonError = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.UpdateDeactivationReasonResponse.UpdateDeactivationReasonError').values;
const $3f73c216104868a6$export$fd7459a734464a1d = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.FinishCardActivationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$fd7459a734464a1d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$fd7459a734464a1d);
const $3f73c216104868a6$export$39d716a763ccfd83 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.FinishCardActivationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$39d716a763ccfd83, {
    result: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$39d716a763ccfd83);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 227:3
 */ $3f73c216104868a6$export$39d716a763ccfd83.Result = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.FinishCardActivationResponse.Result').values;
const $3f73c216104868a6$export$351538caa34ab18f = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.EnqueueSweepRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$351538caa34ab18f, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$351538caa34ab18f);
const $3f73c216104868a6$export$c293b32f4f7c2c = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.EnqueueSweepResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c293b32f4f7c2c);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c293b32f4f7c2c);
const $3f73c216104868a6$export$818864c64bfcb2bc = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetBalanceRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$818864c64bfcb2bc, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$818864c64bfcb2bc);
const $3f73c216104868a6$export$b98a487d2e723b1a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetBalanceResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$b98a487d2e723b1a, {
    balance: {
        required: true
    },
    maxInstantDepositAmount: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$b98a487d2e723b1a);
const $3f73c216104868a6$export$d338e911948e15fd = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetBizbankAccountRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d338e911948e15fd, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d338e911948e15fd);
const $3f73c216104868a6$export$7134c1000889519b = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetBizbankAccountResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$7134c1000889519b);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$7134c1000889519b);
/**
 * SOURCE BizbankAccount @ squareup/bizbank/service.proto at 260:3
 */ $3f73c216104868a6$export$7134c1000889519b.BizbankAccount = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetBizbankAccountResponse.BizbankAccount');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$7134c1000889519b.BizbankAccount);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$7134c1000889519b.BizbankAccount);
const $3f73c216104868a6$export$9754410f606dac06 = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.UnitIneligibilityReason').values;
const $3f73c216104868a6$export$77b589e9c6b7128d = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardOrderingEligibilityRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$77b589e9c6b7128d, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$77b589e9c6b7128d);
const $3f73c216104868a6$export$58dd883c48dff825 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardOrderingEligibilityResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$58dd883c48dff825);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$58dd883c48dff825);
const $3f73c216104868a6$export$74efe1ca0c13869 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardActivityRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$74efe1ca0c13869, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$74efe1ca0c13869);
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 325:3
 */ $3f73c216104868a6$export$74efe1ca0c13869.Filters = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardActivityRequest.Filters');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$74efe1ca0c13869.Filters);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$74efe1ca0c13869.Filters);
/**
 * SOURCE DateSource @ squareup/bizbank/service.proto at 326:5
 */ $3f73c216104868a6$export$74efe1ca0c13869.Filters.DateSource = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetCardActivityRequest.Filters.DateSource').values;
const $3f73c216104868a6$export$c40f4b8f45081c9a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardActivityResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c40f4b8f45081c9a, {
    batchResponse: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c40f4b8f45081c9a);
/**
 * SOURCE BatchResponse @ squareup/bizbank/service.proto at 357:3
 */ $3f73c216104868a6$export$c40f4b8f45081c9a.BatchResponse = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardActivityResponse.BatchResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c40f4b8f45081c9a.BatchResponse);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c40f4b8f45081c9a.BatchResponse);
const $3f73c216104868a6$export$1a963d2655841b69 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardCustomizationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$1a963d2655841b69);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$1a963d2655841b69);
const $3f73c216104868a6$export$4eecc657670f7f54 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardCustomization');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$4eecc657670f7f54);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$4eecc657670f7f54);
const $3f73c216104868a6$export$18f331a0de47a7a4 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardCustomizationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$18f331a0de47a7a4, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$18f331a0de47a7a4);
const $3f73c216104868a6$export$31465efa99f2f023 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$31465efa99f2f023);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$31465efa99f2f023);
const $3f73c216104868a6$export$d0fbfd319946e0e2 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d0fbfd319946e0e2);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d0fbfd319946e0e2);
/**
 * SOURCE EnabledAttribute @ squareup/bizbank/service.proto at 421:3
 */ $3f73c216104868a6$export$d0fbfd319946e0e2.EnabledAttribute = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledResponse.EnabledAttribute');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d0fbfd319946e0e2.EnabledAttribute, {
    unitToken: {
        notEmpty: true
    },
    isEnabled: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d0fbfd319946e0e2.EnabledAttribute);
const $3f73c216104868a6$export$e23273883df96fe1 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledHistoryRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e23273883df96fe1, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e23273883df96fe1);
const $3f73c216104868a6$export$e26f0f5b45a54589 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledHistoryResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e26f0f5b45a54589);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e26f0f5b45a54589);
/**
 * SOURCE DateTimeIntervals @ squareup/bizbank/service.proto at 437:3
 */ $3f73c216104868a6$export$e26f0f5b45a54589.DateTimeIntervals = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetEnabledHistoryResponse.DateTimeIntervals');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e26f0f5b45a54589.DateTimeIntervals);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e26f0f5b45a54589.DateTimeIntervals);
const $3f73c216104868a6$export$f87764fc5894590 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardBillingAddressRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f87764fc5894590, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f87764fc5894590);
const $3f73c216104868a6$export$f27b951ce73f58f3 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCardBillingAddressResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f27b951ce73f58f3);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f27b951ce73f58f3);
const $3f73c216104868a6$export$f0a8476e47a67d1f = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.DigitalWalletToken');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f0a8476e47a67d1f);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f0a8476e47a67d1f);
const $3f73c216104868a6$export$4514144d4614cd7e = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetDigitalWalletTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$4514144d4614cd7e, {
    digitalWalletToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$4514144d4614cd7e);
const $3f73c216104868a6$export$64fb0537c121896a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetDigitalWalletTokenResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$64fb0537c121896a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$64fb0537c121896a);
const $3f73c216104868a6$export$82d1991fb076a01e = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetDigitalWalletTokensForUnitRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$82d1991fb076a01e, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$82d1991fb076a01e);
const $3f73c216104868a6$export$573329aa8c61c8c5 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetDigitalWalletTokensForUnitResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$573329aa8c61c8c5);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$573329aa8c61c8c5);
const $3f73c216104868a6$export$8507afe130f824e2 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetRolledUpActivityRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8507afe130f824e2, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8507afe130f824e2);
/**
 * SOURCE SortOrder @ squareup/bizbank/service.proto at 490:3
 */ $3f73c216104868a6$export$8507afe130f824e2.SortOrder = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetRolledUpActivityRequest.SortOrder').values;
/**
 * SOURCE RolledUpActivityType @ squareup/bizbank/service.proto at 494:3
 */ $3f73c216104868a6$export$8507afe130f824e2.RolledUpActivityType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetRolledUpActivityRequest.RolledUpActivityType').values;
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 501:3
 */ $3f73c216104868a6$export$8507afe130f824e2.Filters = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetRolledUpActivityRequest.Filters');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8507afe130f824e2.Filters);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8507afe130f824e2.Filters);
const $3f73c216104868a6$export$5218d6d1b5b50253 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetRolledUpActivityResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$5218d6d1b5b50253);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$5218d6d1b5b50253);
/**
 * SOURCE Fee @ squareup/bizbank/service.proto at 531:3
 */ $3f73c216104868a6$export$5218d6d1b5b50253.Fee = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetRolledUpActivityResponse.Fee');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$5218d6d1b5b50253.Fee);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$5218d6d1b5b50253.Fee);
/**
 * SOURCE FeeType @ squareup/bizbank/service.proto at 532:5
 */ $3f73c216104868a6$export$5218d6d1b5b50253.Fee.FeeType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetRolledUpActivityResponse.Fee.FeeType').values;
/**
 * SOURCE RolledUpCardActivity @ squareup/bizbank/service.proto at 540:3
 */ $3f73c216104868a6$export$5218d6d1b5b50253.RolledUpCardActivity = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetRolledUpActivityResponse.RolledUpCardActivity');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$5218d6d1b5b50253.RolledUpCardActivity);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$5218d6d1b5b50253.RolledUpCardActivity);
const $3f73c216104868a6$export$8f898512f958f471 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetSpendingLimitsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8f898512f958f471, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8f898512f958f471);
const $3f73c216104868a6$export$204078808a8732ba = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetSpendingLimitsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$204078808a8732ba);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$204078808a8732ba);
/**
 * SOURCE SpendSummary @ squareup/bizbank/service.proto at 556:3
 */ $3f73c216104868a6$export$204078808a8732ba.SpendSummary = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$204078808a8732ba.SpendSummary);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$204078808a8732ba.SpendSummary);
/**
 * SOURCE SpendType @ squareup/bizbank/service.proto at 557:5
 */ $3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendType').values;
/**
 * SOURCE SpendLimit @ squareup/bizbank/service.proto at 569:5
 */ $3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendLimit = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendLimit);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendLimit);
/**
 * SOURCE Cadence @ squareup/bizbank/service.proto at 570:7
 */ $3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendLimit.Cadence = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.Cadence').values;
/**
 * SOURCE CardType @ squareup/bizbank/service.proto at 577:7
 */ $3f73c216104868a6$export$204078808a8732ba.SpendSummary.SpendLimit.CardType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetSpendingLimitsResponse.SpendSummary.SpendLimit.CardType').values;
const $3f73c216104868a6$export$b2bcae3e90f0c84 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetAtmLimitsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$b2bcae3e90f0c84, {
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$b2bcae3e90f0c84);
const $3f73c216104868a6$export$75d013afa1aa418d = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetAtmLimitsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$75d013afa1aa418d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$75d013afa1aa418d);
/**
 * SOURCE Limit @ squareup/bizbank/service.proto at 613:3
 */ $3f73c216104868a6$export$75d013afa1aa418d.Limit = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetAtmLimitsResponse.Limit');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$75d013afa1aa418d.Limit);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$75d013afa1aa418d.Limit);
/**
 * SOURCE Cadence @ squareup/bizbank/service.proto at 614:5
 */ $3f73c216104868a6$export$75d013afa1aa418d.Limit.Cadence = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetAtmLimitsResponse.Limit.Cadence').values;
const $3f73c216104868a6$export$ec11df8f80d70e0e = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CreateCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ec11df8f80d70e0e, {
    firstName: {
        notEmpty: true
    },
    lastName: {
        notEmpty: true
    },
    email: {
        notEmpty: true
    },
    balanceId: {
        notEmpty: true
    },
    idempotenceKey: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ec11df8f80d70e0e);
const $3f73c216104868a6$export$e83735994418891e = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CreateCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e83735994418891e);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e83735994418891e);
const $3f73c216104868a6$export$a2aa99ded42c8f67 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SendNotificationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$a2aa99ded42c8f67, {
    idempotencyKey: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$a2aa99ded42c8f67);
/**
 * SOURCE CardInvitationEmailPayload @ squareup/bizbank/service.proto at 670:3
 */ $3f73c216104868a6$export$a2aa99ded42c8f67.CardInvitationEmailPayload = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SendNotificationRequest.CardInvitationEmailPayload');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$a2aa99ded42c8f67.CardInvitationEmailPayload, {
    cardInvitationToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$a2aa99ded42c8f67.CardInvitationEmailPayload);
const $3f73c216104868a6$export$8cd5b864f9576eb = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SendNotificationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8cd5b864f9576eb);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8cd5b864f9576eb);
const $3f73c216104868a6$export$87f8ad33a2eb9c44 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardAssignment');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$87f8ad33a2eb9c44);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$87f8ad33a2eb9c44);
const $3f73c216104868a6$export$ca7406e507311134 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SearchCardAssignmentsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ca7406e507311134);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ca7406e507311134);
/**
 * SOURCE CardAssignmentsFilter @ squareup/bizbank/service.proto at 697:3
 */ $3f73c216104868a6$export$ca7406e507311134.CardAssignmentsFilter = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsFilter');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ca7406e507311134.CardAssignmentsFilter);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ca7406e507311134.CardAssignmentsFilter);
/**
 * SOURCE CardAssignmentsQuery @ squareup/bizbank/service.proto at 700:3
 */ $3f73c216104868a6$export$ca7406e507311134.CardAssignmentsQuery = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SearchCardAssignmentsRequest.CardAssignmentsQuery');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ca7406e507311134.CardAssignmentsQuery);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ca7406e507311134.CardAssignmentsQuery);
const $3f73c216104868a6$export$9e9599d7ce2899b2 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SearchCardAssignmentsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9e9599d7ce2899b2);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9e9599d7ce2899b2);
const $3f73c216104868a6$export$1f9ff0d796a08011 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListCardsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$1f9ff0d796a08011, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$1f9ff0d796a08011);
/**
 * SOURCE SortOrder @ squareup/bizbank/service.proto at 711:3
 */ $3f73c216104868a6$export$1f9ff0d796a08011.SortOrder = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.ListCardsRequest.SortOrder').values;
/**
 * SOURCE Filters @ squareup/bizbank/service.proto at 718:3
 */ $3f73c216104868a6$export$1f9ff0d796a08011.Filters = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListCardsRequest.Filters');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$1f9ff0d796a08011.Filters);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$1f9ff0d796a08011.Filters);
const $3f73c216104868a6$export$8a92910321c6ac49 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListCardsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8a92910321c6ac49);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8a92910321c6ac49);
const $3f73c216104868a6$export$1e5507a06cab5709 = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.CardBrand').values;
const $3f73c216104868a6$export$578a96ad364ed08b = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardData');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$578a96ad364ed08b, {
    cardState: {
        required: true
    },
    cardBrand: {
        required: true
    },
    cardType: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$578a96ad364ed08b);
/**
 * SOURCE CardState @ squareup/bizbank/service.proto at 772:3
 */ $3f73c216104868a6$export$578a96ad364ed08b.CardState = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.CardData.CardState').values;
/**
 * SOURCE CardType @ squareup/bizbank/service.proto at 792:3
 */ $3f73c216104868a6$export$578a96ad364ed08b.CardType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.CardData.CardType').values;
const $3f73c216104868a6$export$d0506934027d387d = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardActivity');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d0506934027d387d, {
    transactionToken: {
        required: true
    },
    amount: {
        required: true
    },
    description: {
        required: true
    },
    activityType: {
        required: true
    },
    transactionState: {
        required: true
    },
    occurredAt: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d0506934027d387d);
/**
 * SOURCE ActivityType @ squareup/bizbank/service.proto at 819:3
 */ $3f73c216104868a6$export$d0506934027d387d.ActivityType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.CardActivity.ActivityType').values;
/**
 * SOURCE DepositCardInfo @ squareup/bizbank/service.proto at 840:3
 */ $3f73c216104868a6$export$d0506934027d387d.DepositCardInfo = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardActivity.DepositCardInfo');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d0506934027d387d.DepositCardInfo);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d0506934027d387d.DepositCardInfo);
/**
 * SOURCE DepositBankInfo @ squareup/bizbank/service.proto at 847:3
 */ $3f73c216104868a6$export$d0506934027d387d.DepositBankInfo = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.CardActivity.DepositBankInfo');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$d0506934027d387d.DepositBankInfo);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$d0506934027d387d.DepositBankInfo);
const $3f73c216104868a6$export$c3ed00e569d17746 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvideFeedbackRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c3ed00e569d17746, {
    idempotenceKey: {
        notEmpty: true
    },
    unitToken: {
        notEmpty: true
    },
    feedbackText: {
        notEmpty: true
    },
    feedbackSource: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c3ed00e569d17746);
/**
 * SOURCE FeedbackSource @ squareup/bizbank/service.proto at 877:3
 */ $3f73c216104868a6$export$c3ed00e569d17746.FeedbackSource = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.ProvideFeedbackRequest.FeedbackSource').values;
const $3f73c216104868a6$export$7eeb177f30c2be7a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$7eeb177f30c2be7a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$7eeb177f30c2be7a);
/**
 * Maps to squareup.banklin.service.DeviceType
 *
 * SOURCE DeviceType @ squareup/bizbank/service.proto at 918:3
 */ $3f73c216104868a6$export$7eeb177f30c2be7a.DeviceType = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.DeviceType').values;
/**
 * SOURCE ApplePayRequest @ squareup/bizbank/service.proto at 924:3
 */ $3f73c216104868a6$export$7eeb177f30c2be7a.ApplePayRequest = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.ApplePayRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$7eeb177f30c2be7a.ApplePayRequest);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$7eeb177f30c2be7a.ApplePayRequest);
/**
 * SOURCE GooglePayRequest @ squareup/bizbank/service.proto at 939:3
 */ $3f73c216104868a6$export$7eeb177f30c2be7a.GooglePayRequest = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenRequest.GooglePayRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$7eeb177f30c2be7a.GooglePayRequest);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$7eeb177f30c2be7a.GooglePayRequest);
const $3f73c216104868a6$export$c94200d6ab793599 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c94200d6ab793599);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c94200d6ab793599);
/**
 * SOURCE ApplePayResponse @ squareup/bizbank/service.proto at 959:3
 */ $3f73c216104868a6$export$c94200d6ab793599.ApplePayResponse = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.ApplePayResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c94200d6ab793599.ApplePayResponse);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c94200d6ab793599.ApplePayResponse);
/**
 * SOURCE GooglePayResponse @ squareup/bizbank/service.proto at 974:3
 */ $3f73c216104868a6$export$c94200d6ab793599.GooglePayResponse = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvisionDigitalWalletTokenResponse.GooglePayResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c94200d6ab793599.GooglePayResponse);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c94200d6ab793599.GooglePayResponse);
const $3f73c216104868a6$export$9c8808f25c0c2a7a = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ProvideFeedbackResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9c8808f25c0c2a7a, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9c8808f25c0c2a7a);
const $3f73c216104868a6$export$5cad5c80d2995506 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetCardBillingAddressRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$5cad5c80d2995506, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$5cad5c80d2995506);
const $3f73c216104868a6$export$ab3effbfa8b072ee = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetCardBillingAddressResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ab3effbfa8b072ee);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ab3effbfa8b072ee);
/**
 * SOURCE FailureReason @ squareup/bizbank/service.proto at 996:3
 */ $3f73c216104868a6$export$ab3effbfa8b072ee.FailureReason = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.SetCardBillingAddressResponse.FailureReason').values;
const $3f73c216104868a6$export$190c7bbba8b2dd5b = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetEnabledRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$190c7bbba8b2dd5b, {
    unitToken: {
        notEmpty: true
    },
    enabled: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$190c7bbba8b2dd5b);
const $3f73c216104868a6$export$383b035df2f74cbc = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetEnabledResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$383b035df2f74cbc, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$383b035df2f74cbc);
const $3f73c216104868a6$export$11663ee714acba9c = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetPasscodeRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$11663ee714acba9c, {
    passcode: {
        notEmpty: true
    },
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$11663ee714acba9c);
const $3f73c216104868a6$export$640c45aee55c5a05 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.SetPasscodeResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$640c45aee55c5a05, {
    result: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$640c45aee55c5a05);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1026:3
 */ $3f73c216104868a6$export$640c45aee55c5a05.Result = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.SetPasscodeResponse.Result').values;
const $3f73c216104868a6$export$b04f9b9772683560 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartCardActivationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$b04f9b9772683560, {
    unitToken: {
        notEmpty: true
    },
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$b04f9b9772683560);
const $3f73c216104868a6$export$6b5a516299533ce2 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartCardActivationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$6b5a516299533ce2, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$6b5a516299533ce2);
const $3f73c216104868a6$export$3876c45275011242 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartIdentityVerificationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$3876c45275011242, {
    unitToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$3876c45275011242);
const $3f73c216104868a6$export$e5ba8a9283a704a1 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartIdentityVerificationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e5ba8a9283a704a1);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e5ba8a9283a704a1);
const $3f73c216104868a6$export$c1df98fe62718065 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartIssueCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c1df98fe62718065, {
    unitToken: {
        notEmpty: true
    },
    shippingAddress: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c1df98fe62718065);
const $3f73c216104868a6$export$5f2c1b223d9ce345 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartIssueCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$5f2c1b223d9ce345, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$5f2c1b223d9ce345);
/**
 * SOURCE AddressNormalizationResult @ squareup/bizbank/service.proto at 1076:3
 */ $3f73c216104868a6$export$5f2c1b223d9ce345.AddressNormalizationResult = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.StartIssueCardResponse.AddressNormalizationResult').values;
const $3f73c216104868a6$export$9366cce3f193cb83 = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.TwoFactorAuthenticationRequestType').values;
const $3f73c216104868a6$export$f1ed199d6959b70c = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartTwoFactorAuthenticationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f1ed199d6959b70c, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f1ed199d6959b70c);
const $3f73c216104868a6$export$a00902a84afe5fed = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.StartTwoFactorAuthenticationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$a00902a84afe5fed, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$a00902a84afe5fed);
const $3f73c216104868a6$export$874456b1e6c7ddf = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ToggleCardRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$874456b1e6c7ddf, {
    unitToken: {
        notEmpty: true
    },
    cardToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$874456b1e6c7ddf);
const $3f73c216104868a6$export$ea5572bcc3fede05 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ToggleCardResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ea5572bcc3fede05);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ea5572bcc3fede05);
const $3f73c216104868a6$export$6aabdc425eb3c113 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VerifyCardActivationTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$6aabdc425eb3c113, {
    activationToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$6aabdc425eb3c113);
const $3f73c216104868a6$export$adfc1e489f8313d5 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VerifyCardActivationTokenResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$adfc1e489f8313d5, {
    result: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$adfc1e489f8313d5);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1131:3
 */ $3f73c216104868a6$export$adfc1e489f8313d5.Result = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.VerifyCardActivationTokenResponse.Result').values;
const $3f73c216104868a6$export$cba70e0b29b94c67 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$cba70e0b29b94c67, {
    authenticationToken: {
        notEmpty: true
    },
    requestType: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$cba70e0b29b94c67);
const $3f73c216104868a6$export$87c54b251e79ee15 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$87c54b251e79ee15, {
    result: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$87c54b251e79ee15);
/**
 * SOURCE Result @ squareup/bizbank/service.proto at 1152:3
 */ $3f73c216104868a6$export$87c54b251e79ee15.Result = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse.Result').values;
const $3f73c216104868a6$export$256769e9e0c8eaed = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VoidAuthorizationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$256769e9e0c8eaed, {
    transactionToken: {
        required: true,
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$256769e9e0c8eaed);
const $3f73c216104868a6$export$82eabcdd4ffe7dca = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.VoidAuthorizationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$82eabcdd4ffe7dca);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$82eabcdd4ffe7dca);
const $3f73c216104868a6$export$e5cc96c060ae9851 = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.IdvState').values;
const $3f73c216104868a6$export$a9e165e810257348 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetFundsHoldingAccountRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$a9e165e810257348);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$a9e165e810257348);
const $3f73c216104868a6$export$f9cdbd229c36b373 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetFundsHoldingAccountResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f9cdbd229c36b373, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f9cdbd229c36b373);
const $3f73c216104868a6$export$273c5bcd8be2b812 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetIsUserAuthorizedRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$273c5bcd8be2b812, {
    unitToken: {
        notEmpty: true
    },
    loggableSessionToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$273c5bcd8be2b812);
const $3f73c216104868a6$export$f91f986de3bf155b = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetIsUserAuthorizedResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$f91f986de3bf155b, {
    isAuthorized: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$f91f986de3bf155b);
const $3f73c216104868a6$export$107f9a454ad5572c = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetPromotionalRewardDescriptionRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$107f9a454ad5572c, {
    transactionToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$107f9a454ad5572c);
const $3f73c216104868a6$export$9d5f43d3a6defc29 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetPromotionalRewardDescriptionResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$9d5f43d3a6defc29);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$9d5f43d3a6defc29);
/**
 * SOURCE Error @ squareup/bizbank/service.proto at 1243:3
 */ $3f73c216104868a6$export$9d5f43d3a6defc29.Error = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetPromotionalRewardDescriptionResponse.Error').values;
const $3f73c216104868a6$export$fb7e21f12e0f3909 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.LookupUnitRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$fb7e21f12e0f3909);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$fb7e21f12e0f3909);
const $3f73c216104868a6$export$14f6123428c42788 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.LookupUnitResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$14f6123428c42788, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$14f6123428c42788);
const $3f73c216104868a6$export$bb07015d694d04a8 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListDisputedTransactionTokensRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$bb07015d694d04a8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$bb07015d694d04a8);
const $3f73c216104868a6$export$ab0fbb702c2ed0ea = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListDisputedTransactionTokensResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ab0fbb702c2ed0ea);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ab0fbb702c2ed0ea);
const $3f73c216104868a6$export$b53f3420139a64e8 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ValidateAddressRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$b53f3420139a64e8, {
    address: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$b53f3420139a64e8);
const $3f73c216104868a6$export$fe9fdc7d6de9364e = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ValidateAddressResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$fe9fdc7d6de9364e);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$fe9fdc7d6de9364e);
/**
 * SOURCE CorrectedField @ squareup/bizbank/service.proto at 1293:3
 */ $3f73c216104868a6$export$fe9fdc7d6de9364e.CorrectedField = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.ValidateAddressResponse.CorrectedField').values;
/**
 * SOURCE AddressNormalizationResult @ squareup/bizbank/service.proto at 1302:3
 */ $3f73c216104868a6$export$fe9fdc7d6de9364e.AddressNormalizationResult = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.ValidateAddressResponse.AddressNormalizationResult').values;
const $3f73c216104868a6$export$106fc4beac01f7c8 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateCustomerDataRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$106fc4beac01f7c8);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$106fc4beac01f7c8);
const $3f73c216104868a6$export$58cc93ed2bdcabda = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateCustomerDataResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$58cc93ed2bdcabda, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$58cc93ed2bdcabda);
const $3f73c216104868a6$export$54bba2a1b23a3693 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCustomizationSettingsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$54bba2a1b23a3693, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$54bba2a1b23a3693);
const $3f73c216104868a6$export$99b3bcac9f2c8f3 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCustomizationSettingsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$99b3bcac9f2c8f3, {
    success: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$99b3bcac9f2c8f3);
/**
 * SOURCE IneligibilityReason @ squareup/bizbank/service.proto at 2074:3
 */ $3f73c216104868a6$export$99b3bcac9f2c8f3.IneligibilityReason = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.GetCustomizationSettingsResponse.IneligibilityReason').values;
/**
 * SOURCE ExistingCustomization @ squareup/bizbank/service.proto at 2083:3
 */ $3f73c216104868a6$export$99b3bcac9f2c8f3.ExistingCustomization = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetCustomizationSettingsResponse.ExistingCustomization');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$99b3bcac9f2c8f3.ExistingCustomization);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$99b3bcac9f2c8f3.ExistingCustomization);
const $3f73c216104868a6$export$c715bd10825208e5 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetAllStampsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$c715bd10825208e5);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$c715bd10825208e5);
const $3f73c216104868a6$export$8df4dee2d5069ed = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetAllStampsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8df4dee2d5069ed);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8df4dee2d5069ed);
const $3f73c216104868a6$export$8897676213252052 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.Stamp');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$8897676213252052);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$8897676213252052);
const $3f73c216104868a6$export$4b3247d5b313d0db = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetFontsRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$4b3247d5b313d0db);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$4b3247d5b313d0db);
const $3f73c216104868a6$export$30a59e598847ea22 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetFontsResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$30a59e598847ea22);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$30a59e598847ea22);
/**
 * SOURCE Font @ squareup/bizbank/service.proto at 2114:3
 */ $3f73c216104868a6$export$30a59e598847ea22.Font = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetFontsResponse.Font');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$30a59e598847ea22.Font, {
    fontFamily: {
        notEmpty: true
    },
    fontUrl: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$30a59e598847ea22.Font);
const $3f73c216104868a6$export$e8bb92aaff106560 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.DeactivateAccountRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$e8bb92aaff106560, {
    unitToken: {
        required: true
    },
    deactivationReason: {
        required: true
    },
    source: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$e8bb92aaff106560);
const $3f73c216104868a6$export$a9f0b0a3b546c5c = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.DeactivateAccountResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$a9f0b0a3b546c5c);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$a9f0b0a3b546c5c);
const $3f73c216104868a6$export$6e24e2f587b728e1 = $3f73c216104868a6$var$$root.lookupEnum('squareup.bizbank.service.MerchantBlockState').values;
const $3f73c216104868a6$export$ae98eb5b52fe16cb = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateMerchantBlockRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ae98eb5b52fe16cb, {
    merchanteinMerchantToken: {
        notEmpty: true
    },
    unitToken: {
        notEmpty: true
    },
    merchantBlockState: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ae98eb5b52fe16cb);
const $3f73c216104868a6$export$408740df96fac795 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.UpdateMerchantBlockResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$408740df96fac795, {
    merchantBlockState: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$408740df96fac795);
const $3f73c216104868a6$export$ace449f314897593 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetMerchantBlockRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$ace449f314897593, {
    merchanteinMerchantToken: {
        notEmpty: true
    },
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$ace449f314897593);
const $3f73c216104868a6$export$64f6977fb3775bfe = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.GetMerchantBlockResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$64f6977fb3775bfe, {
    merchantBlockState: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$64f6977fb3775bfe);
const $3f73c216104868a6$export$528ae0b88a2792f4 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListMerchantBlocksRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$528ae0b88a2792f4, {
    unitToken: {
        notEmpty: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$528ae0b88a2792f4);
const $3f73c216104868a6$export$737f5af1ddd15df4 = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListMerchantBlocksResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$737f5af1ddd15df4);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$737f5af1ddd15df4);
/**
 * SOURCE MerchanteinMerchant @ squareup/bizbank/service.proto at 2325:3
 */ $3f73c216104868a6$export$737f5af1ddd15df4.MerchanteinMerchant = $3f73c216104868a6$var$$root.lookupType('squareup.bizbank.service.ListMerchantBlocksResponse.MerchanteinMerchant');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3f73c216104868a6$export$737f5af1ddd15df4.MerchanteinMerchant, {
    token: {
        notEmpty: true
    },
    name: {
        notEmpty: true
    },
    merchantImage: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3f73c216104868a6$export$737f5af1ddd15df4.MerchanteinMerchant);
const $3f73c216104868a6$export$f0012387d4e9c920 = $3f73c216104868a6$var$$root.lookupService('squareup.bizbank.service.BizbankService');





const $3abdcd0949da282d$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $3abdcd0949da282d$var$jsonData = {
    "squareup": {
        "nested": {
            "bizbank": {
                "nested": {
                    "externalservice": {
                        "nested": {
                            "GetEnabledRequest": {
                                "fields": {
                                    "unitToken": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "GetEnabledResponse": {
                                "fields": {
                                    "isEnabled": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ExternalBizbankService": {
                                "methods": {
                                    "CheckIdentityVerificationStatus": {
                                        "requestType": ".squareup.bizbank.service.CheckIdentityVerificationStatusRequest",
                                        "responseType": ".squareup.bizbank.service.CheckIdentityVerificationStatusResponse"
                                    },
                                    "ConfirmIssueCard": {
                                        "requestType": ".squareup.bizbank.service.ConfirmIssueCardRequest",
                                        "responseType": ".squareup.bizbank.service.ConfirmIssueCardResponse"
                                    },
                                    "CreateCardCustomization": {
                                        "requestType": ".squareup.bizbank.service.CreateCardCustomizationRequest",
                                        "responseType": ".squareup.bizbank.service.CreateCardCustomizationResponse"
                                    },
                                    "CreateUserAuthorization": {
                                        "requestType": ".squareup.bizbank.card_management.CreateUserAuthorizationRequest",
                                        "responseType": ".squareup.bizbank.card_management.CreateUserAuthorizationResponse"
                                    },
                                    "DeactivateCard": {
                                        "requestType": ".squareup.bizbank.service.DeactivateCardRequest",
                                        "responseType": ".squareup.bizbank.service.DeactivateCardResponse"
                                    },
                                    "FinishCardActivation": {
                                        "requestType": ".squareup.bizbank.service.FinishCardActivationRequest",
                                        "responseType": ".squareup.bizbank.service.FinishCardActivationResponse"
                                    },
                                    "GetBalance": {
                                        "requestType": ".squareup.bizbank.service.GetBalanceRequest",
                                        "responseType": ".squareup.bizbank.service.GetBalanceResponse"
                                    },
                                    "GetBalanceOverview": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetBalanceOverviewRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetBalanceOverviewResponse"
                                    },
                                    "GetPaymentProcessingDetails": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetPaymentProcessingDetailsResponse"
                                    },
                                    "GetUnifiedActivities": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse"
                                    },
                                    "GetUnifiedActivityDetails": {
                                        "requestType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsRequest",
                                        "responseType": ".squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse"
                                    },
                                    "GetCardActivity": {
                                        "requestType": ".squareup.bizbank.service.GetCardActivityRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardActivityResponse"
                                    },
                                    "GetCardCustomization": {
                                        "requestType": ".squareup.bizbank.service.GetCardCustomizationRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardCustomizationResponse"
                                    },
                                    "GetCustomizationSettings": {
                                        "requestType": ".squareup.bizbank.service.GetCustomizationSettingsRequest",
                                        "responseType": ".squareup.bizbank.service.GetCustomizationSettingsResponse"
                                    },
                                    "GetAllStamps": {
                                        "requestType": ".squareup.bizbank.service.GetAllStampsRequest",
                                        "responseType": ".squareup.bizbank.service.GetAllStampsResponse"
                                    },
                                    "GetEnabled": {
                                        "requestType": ".squareup.bizbank.externalservice.GetEnabledRequest",
                                        "responseType": ".squareup.bizbank.externalservice.GetEnabledResponse"
                                    },
                                    "GetPrivateCardData": {
                                        "requestType": ".squareup.bizbank.card_management.GetPrivateCardDataRequest",
                                        "responseType": ".squareup.bizbank.card_management.GetPrivateCardDataResponse"
                                    },
                                    "GetTransactionDisputeActivity": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.GetTransactionDisputeActivityResponse"
                                    },
                                    "ListCards": {
                                        "requestType": ".squareup.bizbank.service.ListCardsRequest",
                                        "responseType": ".squareup.bizbank.service.ListCardsResponse"
                                    },
                                    "ListTransactionDisputes": {
                                        "requestType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesRequest",
                                        "responseType": ".squareup.bizbank.transaction_dispute.ListTransactionDisputesResponse"
                                    },
                                    "ProvideFeedback": {
                                        "requestType": ".squareup.bizbank.service.ProvideFeedbackRequest",
                                        "responseType": ".squareup.bizbank.service.ProvideFeedbackResponse"
                                    },
                                    "SetEnabled": {
                                        "requestType": ".squareup.bizbank.service.SetEnabledRequest",
                                        "responseType": ".squareup.bizbank.service.SetEnabledResponse"
                                    },
                                    "SetPasscode": {
                                        "requestType": ".squareup.bizbank.service.SetPasscodeRequest",
                                        "responseType": ".squareup.bizbank.service.SetPasscodeResponse"
                                    },
                                    "StartCardActivation": {
                                        "requestType": ".squareup.bizbank.service.StartCardActivationRequest",
                                        "responseType": ".squareup.bizbank.service.StartCardActivationResponse"
                                    },
                                    "StartIdentityVerification": {
                                        "requestType": ".squareup.bizbank.service.StartIdentityVerificationRequest",
                                        "responseType": ".squareup.bizbank.service.StartIdentityVerificationResponse"
                                    },
                                    "StartIssueCard": {
                                        "requestType": ".squareup.bizbank.service.StartIssueCardRequest",
                                        "responseType": ".squareup.bizbank.service.StartIssueCardResponse"
                                    },
                                    "StartTwoFactorAuthentication": {
                                        "requestType": ".squareup.bizbank.service.StartTwoFactorAuthenticationRequest",
                                        "responseType": ".squareup.bizbank.service.StartTwoFactorAuthenticationResponse"
                                    },
                                    "ToggleCard": {
                                        "requestType": ".squareup.bizbank.service.ToggleCardRequest",
                                        "responseType": ".squareup.bizbank.service.ToggleCardResponse"
                                    },
                                    "ValidateAddress": {
                                        "requestType": ".squareup.bizbank.service.ValidateAddressRequest",
                                        "responseType": ".squareup.bizbank.service.ValidateAddressResponse"
                                    },
                                    "VerifyCardActivationToken": {
                                        "requestType": ".squareup.bizbank.service.VerifyCardActivationTokenRequest",
                                        "responseType": ".squareup.bizbank.service.VerifyCardActivationTokenResponse"
                                    },
                                    "VerifyTwoFactorAuthenticationToken": {
                                        "requestType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenRequest",
                                        "responseType": ".squareup.bizbank.service.VerifyTwoFactorAuthenticationTokenResponse"
                                    },
                                    "GetCardBillingAddress": {
                                        "requestType": ".squareup.bizbank.service.GetCardBillingAddressRequest",
                                        "responseType": ".squareup.bizbank.service.GetCardBillingAddressResponse"
                                    },
                                    "SetCardBillingAddress": {
                                        "requestType": ".squareup.bizbank.service.SetCardBillingAddressRequest",
                                        "responseType": ".squareup.bizbank.service.SetCardBillingAddressResponse"
                                    },
                                    "UpdateMerchantBlock": {
                                        "requestType": ".squareup.bizbank.service.UpdateMerchantBlockRequest",
                                        "responseType": ".squareup.bizbank.service.UpdateMerchantBlockResponse"
                                    },
                                    "GetMerchantBlock": {
                                        "requestType": ".squareup.bizbank.service.GetMerchantBlockRequest",
                                        "responseType": ".squareup.bizbank.service.GetMerchantBlockResponse"
                                    },
                                    "ListMerchantBlocks": {
                                        "requestType": ".squareup.bizbank.service.ListMerchantBlocksRequest",
                                        "responseType": ".squareup.bizbank.service.ListMerchantBlocksResponse"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$3abdcd0949da282d$var$$root.nested?.squareup?.nested?.bizbank?.nested?.externalservice?.nested?.GetEnabledRequest && !$3abdcd0949da282d$var$$root.nested?.squareup?.nested?.bizbank?.nested?.externalservice?.nested?.GetEnabledResponse && !$3abdcd0949da282d$var$$root.nested?.squareup?.nested?.bizbank?.nested?.externalservice?.nested?.ExternalBizbankService) $3abdcd0949da282d$var$$root.addJSON($3abdcd0949da282d$var$jsonData);
const $3abdcd0949da282d$export$31465efa99f2f023 = $3abdcd0949da282d$var$$root.lookupType('squareup.bizbank.externalservice.GetEnabledRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3abdcd0949da282d$export$31465efa99f2f023, {
    unitToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3abdcd0949da282d$export$31465efa99f2f023);
const $3abdcd0949da282d$export$d0fbfd319946e0e2 = $3abdcd0949da282d$var$$root.lookupType('squareup.bizbank.externalservice.GetEnabledResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($3abdcd0949da282d$export$d0fbfd319946e0e2, {
    isEnabled: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($3abdcd0949da282d$export$d0fbfd319946e0e2);
const $3abdcd0949da282d$export$97e6853b0e6eaa06 = $3abdcd0949da282d$var$$root.lookupService('squareup.bizbank.externalservice.ExternalBizbankService');


/**
 * GENERATED CODE – DO NOT EDIT!
 */ /* eslint-disable */ 




const $bbc3574921766dd2$var$$root = $10433685c0be4487$exports.roots['default'] || ($10433685c0be4487$exports.roots['default'] = new $10433685c0be4487$exports.Root());
const $bbc3574921766dd2$var$jsonData = {
    "squareup": {
        "nested": {
            "banking": {
                "nested": {
                    "card_invitation": {
                        "nested": {
                            "Name": {
                                "fields": {
                                    "full": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "first": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "middle": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "last": {
                                        "type": "string",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "nickname": {
                                        "type": "string",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "CardInvitation": {
                                "fields": {
                                    "id": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "inviter": {
                                        "type": ".squareup.banking.card_invitation.CardInvitation.Inviter",
                                        "id": 2,
                                        "rule": "optional"
                                    },
                                    "invitee": {
                                        "type": ".squareup.banking.card_invitation.CardInvitation.Invitee",
                                        "id": 3,
                                        "rule": "optional"
                                    },
                                    "state": {
                                        "type": ".squareup.banking.card_invitation.CardInvitation.State",
                                        "id": 4,
                                        "rule": "optional"
                                    },
                                    "expiresAt": {
                                        "type": ".squareup.common.time.DateTime",
                                        "id": 5,
                                        "rule": "optional"
                                    }
                                },
                                "nested": {
                                    "State": {
                                        "values": {
                                            "STATE_NONE": 0,
                                            "STATE_OPEN": 1,
                                            "STATE_CLAIMED": 2,
                                            "STATE_EXPIRED": 3,
                                            "STATE_REVOKED": 4,
                                            "STATE_ARCHIVED": 5
                                        }
                                    },
                                    "Inviter": {
                                        "fields": {
                                            "name": {
                                                "type": ".squareup.banking.card_invitation.Name",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "businessName": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    },
                                    "Invitee": {
                                        "fields": {
                                            "name": {
                                                "type": ".squareup.banking.card_invitation.Name",
                                                "id": 1,
                                                "rule": "optional"
                                            },
                                            "emailAddress": {
                                                "type": "string",
                                                "id": 2,
                                                "rule": "optional"
                                            }
                                        }
                                    }
                                }
                            },
                            "OpenCardInvitationRequest": {
                                "fields": {
                                    "cardInvitationId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "OpenCardInvitationResponse": {
                                "fields": {}
                            },
                            "RetrieveCardInvitationRequest": {
                                "fields": {
                                    "cardInvitationId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "fieldMask": {
                                        "type": ".google.protobuf.FieldMask",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "RetrieveCardInvitationResponse": {
                                "fields": {
                                    "cardInvitation": {
                                        "type": ".squareup.banking.card_invitation.CardInvitation",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "RevokeCardInvitationRequest": {
                                "fields": {
                                    "cardInvitationId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "RevokeCardInvitationResponse": {
                                "fields": {}
                            },
                            "SendCardInvitationRequest": {
                                "fields": {
                                    "cardInvitationId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "idempotenceToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "SendCardInvitationResponse": {
                                "fields": {}
                            },
                            "ClaimCardInvitationRequest": {
                                "fields": {
                                    "cardInvitationId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                    },
                                    "cardToken": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                    }
                                }
                            },
                            "ClaimCardInvitationResponse": {
                                "fields": {}
                            },
                            "UserCardInvitationService": {
                                "methods": {
                                    "OpenCardInvitation": {
                                        "requestType": ".squareup.banking.card_invitation.OpenCardInvitationRequest",
                                        "responseType": ".squareup.banking.card_invitation.OpenCardInvitationResponse"
                                    },
                                    "RetrieveCardInvitation": {
                                        "requestType": ".squareup.banking.card_invitation.RetrieveCardInvitationRequest",
                                        "responseType": ".squareup.banking.card_invitation.RetrieveCardInvitationResponse"
                                    },
                                    "RevokeCardInvitation": {
                                        "requestType": ".squareup.banking.card_invitation.RevokeCardInvitationRequest",
                                        "responseType": ".squareup.banking.card_invitation.RevokeCardInvitationResponse"
                                    },
                                    "SendCardInvitation": {
                                        "requestType": ".squareup.banking.card_invitation.SendCardInvitationRequest",
                                        "responseType": ".squareup.banking.card_invitation.SendCardInvitationResponse"
                                    },
                                    "ClaimCardInvitation": {
                                        "requestType": ".squareup.banking.card_invitation.ClaimCardInvitationRequest",
                                        "responseType": ".squareup.banking.card_invitation.ClaimCardInvitationResponse"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
// Do not initialize these protos if they have already been defined
if (!$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.Name && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation?.nested?.State && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation?.nested?.Inviter && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.CardInvitation?.nested?.Invitee && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.OpenCardInvitationRequest && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.OpenCardInvitationResponse && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RetrieveCardInvitationRequest && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RetrieveCardInvitationResponse && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RevokeCardInvitationRequest && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.RevokeCardInvitationResponse && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.SendCardInvitationRequest && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.SendCardInvitationResponse && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.ClaimCardInvitationRequest && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.ClaimCardInvitationResponse && !$bbc3574921766dd2$var$$root.nested?.squareup?.nested?.banking?.nested?.card_invitation?.nested?.UserCardInvitationService) $bbc3574921766dd2$var$$root.addJSON($bbc3574921766dd2$var$jsonData);
const $bbc3574921766dd2$export$c7bd411105e2dec3 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.Name');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$c7bd411105e2dec3);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$c7bd411105e2dec3);
const $bbc3574921766dd2$export$285d7a47fed7dbbc = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.CardInvitation');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$285d7a47fed7dbbc);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$285d7a47fed7dbbc);
/**
 * SOURCE State @ squareup/banking/card_invitation.proto at 48:5
 */ $bbc3574921766dd2$export$285d7a47fed7dbbc.State = $bbc3574921766dd2$var$$root.lookupEnum('squareup.banking.card_invitation.CardInvitation.State').values;
/**
 * SOURCE Inviter @ squareup/banking/card_invitation.proto at 57:5
 */ $bbc3574921766dd2$export$285d7a47fed7dbbc.Inviter = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.CardInvitation.Inviter');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$285d7a47fed7dbbc.Inviter);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$285d7a47fed7dbbc.Inviter);
/**
 * SOURCE Invitee @ squareup/banking/card_invitation.proto at 66:5
 */ $bbc3574921766dd2$export$285d7a47fed7dbbc.Invitee = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.CardInvitation.Invitee');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$285d7a47fed7dbbc.Invitee);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$285d7a47fed7dbbc.Invitee);
const $bbc3574921766dd2$export$38e23c7fdcbf972d = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.OpenCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$38e23c7fdcbf972d);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$38e23c7fdcbf972d);
const $bbc3574921766dd2$export$ed2cae7159a68007 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.OpenCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$ed2cae7159a68007);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$ed2cae7159a68007);
const $bbc3574921766dd2$export$f3079ad0d113f9b7 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.RetrieveCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$f3079ad0d113f9b7);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$f3079ad0d113f9b7);
const $bbc3574921766dd2$export$73ffa9c14793433a = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.RetrieveCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$73ffa9c14793433a);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$73ffa9c14793433a);
const $bbc3574921766dd2$export$291ceb4f3c6dd653 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.RevokeCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$291ceb4f3c6dd653);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$291ceb4f3c6dd653);
const $bbc3574921766dd2$export$605b601da2e03762 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.RevokeCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$605b601da2e03762);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$605b601da2e03762);
const $bbc3574921766dd2$export$8774604bbf7dff83 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.SendCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$8774604bbf7dff83);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$8774604bbf7dff83);
const $bbc3574921766dd2$export$2de656cc4882b4f5 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.SendCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$2de656cc4882b4f5);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$2de656cc4882b4f5);
const $bbc3574921766dd2$export$818c5a2d30ed1bb0 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.ClaimCardInvitationRequest');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$818c5a2d30ed1bb0, {
    cardInvitationId: {
        required: true
    },
    cardToken: {
        required: true
    }
});
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$818c5a2d30ed1bb0);
const $bbc3574921766dd2$export$671ce799e042e3c0 = $bbc3574921766dd2$var$$root.lookupType('squareup.banking.card_invitation.ClaimCardInvitationResponse');
(0, $5b4e7aff5e6ce4a3$export$5ba30b2d08c27ebb)($bbc3574921766dd2$export$671ce799e042e3c0);
(0, $ae9a6665233e0895$export$2e2bcd8739ae039).createAndAttachToType($bbc3574921766dd2$export$671ce799e042e3c0);
const $bbc3574921766dd2$export$dede9ff322f0030a = $bbc3574921766dd2$var$$root.lookupService('squareup.banking.card_invitation.UserCardInvitationService');


var $701d006d22a68e04$export$9faacf97a1a86e9d = /*#__PURE__*/ function(APP_DEP) {
    APP_DEP["BANKING_WEB_CARD_SERVICE"] = "BANKING_WEB_CARD_SERVICE";
    APP_DEP["BANKING_WEB_COMPLIANCE_SERVICE"] = "BANKING_WEB_COMPLIANCE_SERVICE";
    APP_DEP["BANKING_WEB_SERVICE"] = "BANKING_WEB_SERVICE";
    APP_DEP["CARD_MANAGEMENT_SERVICE"] = "CARD_MANAGEMENT_SERVICE";
    APP_DEP["EXTERNAL_BIZBANK_SERVICE"] = "EXTERNAL_BIZBANK_SERVICE";
    APP_DEP["PERSON_PROFILE_SERVICE"] = "PERSON_PROFILE_SERVICE";
    APP_DEP["USER_CARD_INVITATION_SERVICE"] = "USER_CARD_INVITATION_SERVICE";
    APP_DEP["WEB_SERVICE"] = "WEB_SERVICE";
    return APP_DEP;
}({});
const $701d006d22a68e04$var$configureServices = async ()=>{
    const rpcImpl = (0, $a8dda4170dc4b740$export$2e2bcd8739ae039)(window.fetch);
    const bankingWebCardService = (0, $bc006730c79954a6$export$3fcca2f60820bf28).create(// eslint-disable-next-line
    rpcImpl);
    const bankingWebComplianceService = (0, $81287a0f87730909$export$58773615f38984aa).create(// eslint-disable-next-line
    rpcImpl);
    const bankingWebService = (0, $2a6a68ea1459b895$export$65bc5f5b6b3789b3).create(// eslint-disable-next-line
    rpcImpl);
    const cardManagementService = (0, $d272bac0a1712861$export$f40f1fb9063205d8).create(// eslint-disable-next-line
    rpcImpl);
    const externalBizbankService = (0, $3abdcd0949da282d$export$97e6853b0e6eaa06).create(// eslint-disable-next-line
    rpcImpl);
    const personProfileService = (0, $3f95b099726a1553$export$f0d0e3d2fc028c).create(// eslint-disable-next-line
    rpcImpl);
    const webService = (0, $fce501362cc81cfc$export$b944e8af96427ee6).create(// eslint-disable-next-line
    rpcImpl);
    const userCardInvitationService = (0, $bbc3574921766dd2$export$dede9ff322f0030a).create(// eslint-disable-next-line
    rpcImpl);
    return {
        ["BANKING_WEB_CARD_SERVICE"]: bankingWebCardService,
        ["BANKING_WEB_COMPLIANCE_SERVICE"]: bankingWebComplianceService,
        ["BANKING_WEB_SERVICE"]: bankingWebService,
        ["CARD_MANAGEMENT_SERVICE"]: cardManagementService,
        ["EXTERNAL_BIZBANK_SERVICE"]: externalBizbankService,
        ["PERSON_PROFILE_SERVICE"]: personProfileService,
        ["USER_CARD_INVITATION_SERVICE"]: userCardInvitationService,
        ["WEB_SERVICE"]: webService
    };
};
const $701d006d22a68e04$export$e9bcd07a423f60d8 = async ()=>{
    const servicesDependencies = await $701d006d22a68e04$var$configureServices();
    return {
        ...servicesDependencies
    };
};



var $b8438 = parcelRequire("b8438");
var $jL8lq = parcelRequire("jL8lq");

var $b8438 = parcelRequire("b8438");

var $b1E2c = parcelRequire("b1E2c");
var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $6T4Sa = parcelRequire("6T4Sa");

var $b8438 = parcelRequire("b8438");

var $cmFjP = parcelRequire("cmFjP");
const $51cfcbefde61ff20$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $51cfcbefde61ff20$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $51cfcbefde61ff20$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $b1E2c.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $51cfcbefde61ff20$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $51cfcbefde61ff20$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $51cfcbefde61ff20$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $51cfcbefde61ff20$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $51cfcbefde61ff20$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $51cfcbefde61ff20$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($51cfcbefde61ff20$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $6T4Sa.addGlobalEventProcessor), (0, $cmFjP.getCurrentHub));
        $51cfcbefde61ff20$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = (event, hint)=>callback(event, hint, client);
        processor.id = integration.name;
        client.addEventProcessor(processor);
    }
    (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $51cfcbefde61ff20$export$2d8f5188773bcddd(integration) {
    const client = (0, $b8438.getClient)();
    if (!client || !client.addIntegration) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $51cfcbefde61ff20$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $51cfcbefde61ff20$export$afa219bf23651160(name, fn) {
    const ConvertedIntegration = function ConvertedIntegration(...args) {
        return fn(...args);
    };
    ConvertedIntegration.id = name;
    return ConvertedIntegration;
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $51cfcbefde61ff20$export$2323046b9414659f(fn) {
    return fn;
}


let $ceb328f2f449885f$var$originalFunctionToString;
const $ceb328f2f449885f$var$INTEGRATION_NAME = 'FunctionToString';
const $ceb328f2f449885f$var$SETUP_CLIENTS = new WeakMap();
const $ceb328f2f449885f$var$_functionToStringIntegration = ()=>{
    return {
        name: $ceb328f2f449885f$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $ceb328f2f449885f$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $jL8lq.getOriginalFunction)(this);
                    const context = $ceb328f2f449885f$var$SETUP_CLIENTS.has((0, $b8438.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $ceb328f2f449885f$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $ceb328f2f449885f$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $ceb328f2f449885f$export$7918117e9202e4fb = (0, $51cfcbefde61ff20$export$2323046b9414659f)($ceb328f2f449885f$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ceb328f2f449885f$export$da4704525c20ae79 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($ceb328f2f449885f$var$INTEGRATION_NAME, $ceb328f2f449885f$export$7918117e9202e4fb);


var $cmFjP = parcelRequire("cmFjP");
var $eKZKa = parcelRequire("eKZKa");

var $4g0Ct = parcelRequire("4g0Ct");
/** Regular expression used to parse a Dsn. */ const $f7133678d936cd5e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f7133678d936cd5e$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $f7133678d936cd5e$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $f7133678d936cd5e$export$b892860177f70a30(str) {
    const match = $f7133678d936cd5e$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $4g0Ct.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f7133678d936cd5e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f7133678d936cd5e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $f7133678d936cd5e$var$validateDsn(dsn) {
    if (!(0, $eKZKa.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$f7133678d936cd5e$var$isValidProtocol(protocol)) {
        (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $4g0Ct.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $f7133678d936cd5e$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $f7133678d936cd5e$export$b892860177f70a30(from) : $f7133678d936cd5e$var$dsnFromComponents(from);
    if (!components || !$f7133678d936cd5e$var$validateDsn(components)) return undefined;
    return components;
}


var $jL8lq = parcelRequire("jL8lq");
const $d91612272370ed71$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $d91612272370ed71$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $d91612272370ed71$var$_getIngestEndpoint(dsn) {
    return `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $d91612272370ed71$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $jL8lq.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $d91612272370ed71$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $d91612272370ed71$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$d91612272370ed71$var$_getIngestEndpoint(dsn)}?${$d91612272370ed71$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $d91612272370ed71$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $f7133678d936cd5e$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


var $b1E2c = parcelRequire("b1E2c");
var $4g0Ct = parcelRequire("4g0Ct");
var $91U3U = parcelRequire("91U3U");

var $8IHa9 = parcelRequire("8IHa9");

// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $499a1b6c2e7bd9e9$var$INTEGRATION_NAME = 'InboundFilters';
const $499a1b6c2e7bd9e9$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $499a1b6c2e7bd9e9$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $499a1b6c2e7bd9e9$var$_mergeOptions(options, clientOptions);
            return $499a1b6c2e7bd9e9$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba = (0, $51cfcbefde61ff20$export$2323046b9414659f)($499a1b6c2e7bd9e9$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($499a1b6c2e7bd9e9$var$INTEGRATION_NAME, $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba);
function $499a1b6c2e7bd9e9$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $499a1b6c2e7bd9e9$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $499a1b6c2e7bd9e9$var$_isSentryError(event)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$499a1b6c2e7bd9e9$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event).some((message)=>(0, $91U3U.stringMatchesSomePattern)(message, ignoreErrors));
}
function $499a1b6c2e7bd9e9$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $91U3U.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $499a1b6c2e7bd9e9$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? false : (0, $91U3U.stringMatchesSomePattern)(url, denyUrls);
}
function $499a1b6c2e7bd9e9$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? true : (0, $91U3U.stringMatchesSomePattern)(url, allowUrls);
}
function $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $8IHa9.DEBUG_BUILD) && possibleMessages.length === 0) (0, $4g0Ct.logger).error(`Could not extract message for event ${(0, $b1E2c.getEventDescription)(event)}`);
    return possibleMessages;
}
function $499a1b6c2e7bd9e9$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error(`Cannot extract url for event ${(0, $b1E2c.getEventDescription)(event)}`);
        return null;
    }
}


var $4g0Ct = parcelRequire("4g0Ct");

var $8IHa9 = parcelRequire("8IHa9");

var $b8438 = parcelRequire("b8438");

var $cmFjP = parcelRequire("cmFjP");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $93002778f3923c52$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $8IHa9.DEBUG_BUILD) (0, $4g0Ct.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $4g0Ct.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $b8438.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $93002778f3923c52$export$ecb76f41d43c0e43(client);
    $93002778f3923c52$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $93002778f3923c52$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $cmFjP.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $93002778f3923c52$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}



var $jL8lq = parcelRequire("jL8lq");



var $3bpJ1 = parcelRequire("3bpJ1");

var $3bpJ1 = parcelRequire("3bpJ1");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $a7f24c22762d2906$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a7f24c22762d2906$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $a7f24c22762d2906$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $a7f24c22762d2906$var$WINDOW && !!$a7f24c22762d2906$var$WINDOW.history.pushState && !!$a7f24c22762d2906$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



var $dbwHv = parcelRequire("dbwHv");
const $2579aac1b9dfd189$var$WINDOW = (0, $3bpJ1.GLOBAL_OBJ);
let $2579aac1b9dfd189$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2579aac1b9dfd189$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $2579aac1b9dfd189$var$instrumentHistory);
}
function $2579aac1b9dfd189$var$instrumentHistory() {
    if (!(0, $a7f24c22762d2906$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $2579aac1b9dfd189$var$WINDOW.onpopstate;
    $2579aac1b9dfd189$var$WINDOW.onpopstate = function(...args) {
        const to = $2579aac1b9dfd189$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $2579aac1b9dfd189$var$lastHref;
        $2579aac1b9dfd189$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $dbwHv.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $2579aac1b9dfd189$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $2579aac1b9dfd189$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $dbwHv.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $jL8lq.fill)($2579aac1b9dfd189$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $jL8lq.fill)($2579aac1b9dfd189$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}


var $4g0Ct = parcelRequire("4g0Ct");
var $16dZf = parcelRequire("16dZf");
var $eKZKa = parcelRequire("eKZKa");

var $4g0Ct = parcelRequire("4g0Ct");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const $a87a94b8e4ff7f26$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $a87a94b8e4ff7f26$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a87a94b8e4ff7f26$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a87a94b8e4ff7f26$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a87a94b8e4ff7f26$export$18cf36ed71d733e7($a87a94b8e4ff7f26$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a87a94b8e4ff7f26$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a87a94b8e4ff7f26$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$531055a6c684a70a() {
    return 'ReportingObserver' in $a87a94b8e4ff7f26$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}



var $9OAWn = parcelRequire("9OAWn");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $cb951e05ebb58c43$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $9OAWn.SDK_VERSION)
            })),
        version: (0, $9OAWn.SDK_VERSION)
    };
    options._metadata = metadata;
}



var $drMc1 = parcelRequire("drMc1");

var $jL8lq = parcelRequire("jL8lq");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $2cae643f899492f0$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $2cae643f899492f0$export$604a45d95a155e2b(envelope, types) {
    return $2cae643f899492f0$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $2cae643f899492f0$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $2cae643f899492f0$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $2cae643f899492f0$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $2cae643f899492f0$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $drMc1.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $2cae643f899492f0$var$concatBuffers(parts);
}
function $2cae643f899492f0$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $2cae643f899492f0$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $2cae643f899492f0$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $2cae643f899492f0$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $jL8lq.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $2cae643f899492f0$export$b11169581eeaf237(type) {
    return $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $2cae643f899492f0$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $2cae643f899492f0$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $jL8lq.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}


var $b1E2c = parcelRequire("b1E2c");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $j3a3y = parcelRequire("j3a3y");/** An error emitted by Sentry SDKs and related utilities. */ class $890c53ca2f6b4a7a$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}




var $8IHa9 = parcelRequire("8IHa9");

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $9b6c4c62dbf66cae$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2cae643f899492f0$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $9b6c4c62dbf66cae$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2cae643f899492f0$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $2cae643f899492f0$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}



var $b8438 = parcelRequire("b8438");

var $cmFjP = parcelRequire("cmFjP");



var $jL8lq = parcelRequire("jL8lq");
/**
 * Generate bucket key from metric properties.
 */ function $2915496cd851a181$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $jL8lq.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $2915496cd851a181$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $2915496cd851a181$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $2915496cd851a181$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $2915496cd851a181$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $2915496cd851a181$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $2915496cd851a181$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        '\\u{7c}'
    ],
    [
        ',',
        '\\u{2c}'
    ]
];
function $2915496cd851a181$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $2915496cd851a181$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $2915496cd851a181$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $2915496cd851a181$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $2915496cd851a181$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $2915496cd851a181$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $2915496cd851a181$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $b86d5e61843389b9$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn);
    const item = $b86d5e61843389b9$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $b86d5e61843389b9$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $2915496cd851a181$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}



var $oyvka = parcelRequire("oyvka");

var $bPHT6 = parcelRequire("bPHT6");

var $az0Em = parcelRequire("az0Em");
const $5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $5d4a5f71b683f78e$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $f7133678d936cd5e$export$128827c3562ec0cb)(options.dsn);
        else (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $d91612272370ed71$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $b1E2c.checkOrSetAlreadyCaught)(exception)) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $2zW56.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $2zW56.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $b1E2c.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $oyvka.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $j3a3y.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $51cfcbefde61ff20$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $51cfcbefde61ff20$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $9b6c4c62dbf66cae$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $2cae643f899492f0$export$d650323442802f6f)(env, (0, $2cae643f899492f0$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $9b6c4c62dbf66cae$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $b86d5e61843389b9$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $51cfcbefde61ff20$export$51abed9797baa598)(this, integrations);
        (0, $51cfcbefde61ff20$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $oyvka.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $j3a3y.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $cmFjP.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $az0Em.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $bPHT6.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $8IHa9.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $4g0Ct.logger).log(sentryError.message);
                else (0, $4g0Ct.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $5d4a5f71b683f78e$var$isTransactionEvent(event);
        const isError = $5d4a5f71b683f78e$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $j3a3y.rejectedSyncPromise)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $5d4a5f71b683f78e$var$processBeforeSend(options, prepared, hint);
            return $5d4a5f71b683f78e$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error('Error while sending event:', reason);
        });
        else (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $5d4a5f71b683f78e$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $2zW56.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $2zW56.isPlainObject)(event) && event !== null) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $2zW56.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $5d4a5f71b683f78e$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($5d4a5f71b683f78e$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($5d4a5f71b683f78e$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $5d4a5f71b683f78e$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $5d4a5f71b683f78e$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $5d4a5f71b683f78e$export$9aac0b9f77928fbf(callback) {
    const client = (0, $b8438.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




var $cvSY8 = parcelRequire("cvSY8");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $d90c5d9ac5d72442$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $cvSY8.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $Wgg6o = parcelRequire("Wgg6o");
var $4g0Ct = parcelRequire("4g0Ct");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $817d897c5dc6d664$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



var $b8438 = parcelRequire("b8438");

var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $drMc1 = parcelRequire("drMc1");
var $j3a3y = parcelRequire("j3a3y");
/**
 * This function creates an exception from a JavaScript Error
 */ function $230372ac01587541$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $230372ac01587541$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $230372ac01587541$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $b8438.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $2zW56.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $230372ac01587541$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $drMc1.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $230372ac01587541$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $230372ac01587541$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $230372ac01587541$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $230372ac01587541$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($230372ac01587541$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $230372ac01587541$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $230372ac01587541$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b1E2c.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $j3a3y.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $230372ac01587541$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $j3a3y.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $2zW56.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $230372ac01587541$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $2zW56.isDOMError)(exception) || (0, $2zW56.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $2zW56.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $b1E2c.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $2zW56.isError)(exception)) // we have a real Error object, do nothing
    return $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $2zW56.isPlainObject)(exception) || (0, $2zW56.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $230372ac01587541$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $b1E2c.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b1E2c.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $b1E2c.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $2zW56.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $230372ac01587541$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $jL8lq.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $2zW56.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $2zW56.isEvent)(exception)) {
        const className = $230372ac01587541$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $230372ac01587541$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}




var $b8438 = parcelRequire("b8438");

var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");
var $3bpJ1 = parcelRequire("3bpJ1");
const $4e817323ced6d78c$export$56d8a8a25bd48b81 = (0, $3bpJ1.GLOBAL_OBJ);
let $4e817323ced6d78c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $4e817323ced6d78c$export$b79738ab10c590b2() {
    return $4e817323ced6d78c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $4e817323ced6d78c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $4e817323ced6d78c$var$ignoreOnError++;
    setTimeout(()=>{
        $4e817323ced6d78c$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $4e817323ced6d78c$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $jL8lq.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$4e817323ced6d78c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $4e817323ced6d78c$export$1265a142ff5ba165();
            (0, $b8438.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $b1E2c.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $b1E2c.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $b8438.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $jL8lq.markFunctionWrapped)(sentryWrapped, fn);
    (0, $jL8lq.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $b03dbb36f8019264$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $b03dbb36f8019264$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $b03dbb36f8019264$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $c55795097f9daeb0$export$1df9218a526d318d extends (0, $5d4a5f71b683f78e$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $Wgg6o.getSDKSource)();
        (0, $cb951e05ebb58c43$export$b9f95b027256052c)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $230372ac01587541$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $230372ac01587541$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $b03dbb36f8019264$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $d90c5d9ac5d72442$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $f7133678d936cd5e$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}





var $b8438 = parcelRequire("b8438");

var $b1E2c = parcelRequire("b1E2c");

var $jL8lq = parcelRequire("jL8lq");

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
const $6dad95eb90f2d36c$var$WINDOW = (0, $3bpJ1.GLOBAL_OBJ);
const $6dad95eb90f2d36c$var$DEBOUNCE_DURATION = 1000;
let $6dad95eb90f2d36c$var$debounceTimerID;
let $6dad95eb90f2d36c$var$lastCapturedEventType;
let $6dad95eb90f2d36c$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6dad95eb90f2d36c$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $6dad95eb90f2d36c$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $6dad95eb90f2d36c$export$3014bbf0af0e1d4a() {
    if (!$6dad95eb90f2d36c$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $dbwHv.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $6dad95eb90f2d36c$var$makeDOMEventHandler(triggerDOMHandler, true);
    $6dad95eb90f2d36c$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $6dad95eb90f2d36c$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $6dad95eb90f2d36c$var$WINDOW[target] && $6dad95eb90f2d36c$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $jL8lq.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $6dad95eb90f2d36c$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $jL8lq.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $6dad95eb90f2d36c$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $6dad95eb90f2d36c$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $6dad95eb90f2d36c$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $6dad95eb90f2d36c$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $6dad95eb90f2d36c$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $6dad95eb90f2d36c$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($6dad95eb90f2d36c$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $jL8lq.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $jL8lq.addNonEnumerableProperty)(target, '_sentryId', (0, $b1E2c.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$6dad95eb90f2d36c$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $6dad95eb90f2d36c$var$lastCapturedEventType = event.type;
            $6dad95eb90f2d36c$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($6dad95eb90f2d36c$var$debounceTimerID);
        $6dad95eb90f2d36c$var$debounceTimerID = $6dad95eb90f2d36c$var$WINDOW.setTimeout(()=>{
            $6dad95eb90f2d36c$var$lastCapturedEventTargetId = undefined;
            $6dad95eb90f2d36c$var$lastCapturedEventType = undefined;
        }, $6dad95eb90f2d36c$var$DEBOUNCE_DURATION);
    };
}
function $6dad95eb90f2d36c$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}


var $4g0Ct = parcelRequire("4g0Ct");

var $jL8lq = parcelRequire("jL8lq");

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d81ce3377b27def9$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $d81ce3377b27def9$var$instrumentConsole);
}
function $d81ce3377b27def9$var$instrumentConsole() {
    if (!('console' in (0, $3bpJ1.GLOBAL_OBJ))) return;
    (0, $4g0Ct.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $3bpJ1.GLOBAL_OBJ).console)) return;
        (0, $jL8lq.fill)((0, $3bpJ1.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $4g0Ct.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $dbwHv.triggerHandlers)('console', handlerData);
                const log = (0, $4g0Ct.originalConsoleMethods)[level];
                log && log.apply((0, $3bpJ1.GLOBAL_OBJ).console, args);
            };
        });
    });
}


var $jL8lq = parcelRequire("jL8lq");


var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $deebfb2c2f3e82fb$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $deebfb2c2f3e82fb$var$instrumentFetch);
}
function $deebfb2c2f3e82fb$var$instrumentFetch() {
    if (!(0, $a87a94b8e4ff7f26$export$c82d238e23c40b21)()) return;
    (0, $jL8lq.fill)((0, $3bpJ1.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $deebfb2c2f3e82fb$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $dbwHv.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $3bpJ1.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $dbwHv.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $dbwHv.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $deebfb2c2f3e82fb$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $deebfb2c2f3e82fb$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($deebfb2c2f3e82fb$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $deebfb2c2f3e82fb$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $deebfb2c2f3e82fb$var$getUrlFromResource(url),
            method: $deebfb2c2f3e82fb$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $deebfb2c2f3e82fb$var$getUrlFromResource(arg),
        method: $deebfb2c2f3e82fb$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}


var $2zW56 = parcelRequire("2zW56");

var $jL8lq = parcelRequire("jL8lq");

var $3bpJ1 = parcelRequire("3bpJ1");

var $dbwHv = parcelRequire("dbwHv");
const $ae6dc6125d1c3217$var$WINDOW = (0, $3bpJ1.GLOBAL_OBJ);
const $ae6dc6125d1c3217$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ae6dc6125d1c3217$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $dbwHv.addHandler)(type, handler);
    (0, $dbwHv.maybeInstrument)(type, $ae6dc6125d1c3217$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $ae6dc6125d1c3217$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$ae6dc6125d1c3217$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $jL8lq.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $2zW56.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $ae6dc6125d1c3217$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $dbwHv.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $jL8lq.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $jL8lq.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $2zW56.isString)(header) && (0, $2zW56.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $jL8lq.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $dbwHv.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $ae6dc6125d1c3217$var$parseUrl(url) {
    if ((0, $2zW56.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}


var $ibKgU = parcelRequire("ibKgU");
var $b1E2c = parcelRequire("b1E2c");
var $4g0Ct = parcelRequire("4g0Ct");/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $25257edadcf16f49$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $25257edadcf16f49$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $25257edadcf16f49$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $25257edadcf16f49$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


var $91U3U = parcelRequire("91U3U");// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $7f06244a5e0d22e8$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $7f06244a5e0d22e8$export$e01cef29b4327697(level) {
    return $7f06244a5e0d22e8$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $7f06244a5e0d22e8$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $7f06244a5e0d22e8$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $b50dad0732e7f682$var$INTEGRATION_NAME = 'Breadcrumbs';
const $b50dad0732e7f682$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $b50dad0732e7f682$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $d81ce3377b27def9$export$1d6e0d073f9e6723)($b50dad0732e7f682$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $6dad95eb90f2d36c$export$5aeffd3db2cf9df7)($b50dad0732e7f682$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $ae6dc6125d1c3217$export$26ace48dd54c9aea)($b50dad0732e7f682$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $deebfb2c2f3e82fb$export$f75d3c772c923df0)($b50dad0732e7f682$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $2579aac1b9dfd189$export$3f18c56c58114e75)($b50dad0732e7f682$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $b50dad0732e7f682$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $b50dad0732e7f682$export$c079d904b326663a = (0, $51cfcbefde61ff20$export$2323046b9414659f)($b50dad0732e7f682$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b50dad0732e7f682$export$2dc68d50d56fbbd = (0, $51cfcbefde61ff20$export$afa219bf23651160)($b50dad0732e7f682$var$INTEGRATION_NAME, $b50dad0732e7f682$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $b50dad0732e7f682$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $b8438.getClient)() !== client) return;
        (0, $b8438.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $b1E2c.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $b50dad0732e7f682$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $b8438.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $b50dad0732e7f682$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $b50dad0732e7f682$var$_isEvent(event) ? event.target : event;
            target = (0, $ibKgU.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $ibKgU.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $b8438.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $b50dad0732e7f682$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $b8438.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $7f06244a5e0d22e8$export$d771ef054122c30a)(handlerData.level),
            message: (0, $91U3U.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $91U3U.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $b8438.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $b50dad0732e7f682$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $b8438.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $b8438.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $b50dad0732e7f682$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $b8438.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $b8438.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $b8438.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $b50dad0732e7f682$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $b8438.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $25257edadcf16f49$export$7a5253c0f62e0150)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $25257edadcf16f49$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $25257edadcf16f49$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $b8438.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $b50dad0732e7f682$var$_isEvent(event) {
    return !!event && !!event.target;
}




var $4g0Ct = parcelRequire("4g0Ct");

const $893f0ce260470ef7$var$INTEGRATION_NAME = 'Dedupe';
const $893f0ce260470ef7$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $893f0ce260470ef7$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($893f0ce260470ef7$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $893f0ce260470ef7$export$6d39aa44cd0c7567 = (0, $51cfcbefde61ff20$export$2323046b9414659f)($893f0ce260470ef7$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $893f0ce260470ef7$export$688d98c249d31ad3 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($893f0ce260470ef7$var$INTEGRATION_NAME, $893f0ce260470ef7$export$6d39aa44cd0c7567);
function $893f0ce260470ef7$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $893f0ce260470ef7$var$_getExceptionFromEvent(previousEvent);
    const currentException = $893f0ce260470ef7$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $893f0ce260470ef7$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $893f0ce260470ef7$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $893f0ce260470ef7$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $893f0ce260470ef7$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



var $b8438 = parcelRequire("b8438");

var $isDtX = parcelRequire("isDtX");
var $e5Ga6 = parcelRequire("e5Ga6");
var $ibKgU = parcelRequire("ibKgU");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $9d72a78ef45a7c39$var$INTEGRATION_NAME = 'GlobalHandlers';
const $9d72a78ef45a7c39$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $9d72a78ef45a7c39$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler(client);
                $9d72a78ef45a7c39$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler(client);
                $9d72a78ef45a7c39$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $9d72a78ef45a7c39$export$66acc70e8cf2b71a = (0, $51cfcbefde61ff20$export$2323046b9414659f)($9d72a78ef45a7c39$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $9d72a78ef45a7c39$export$204155decbc90e5a = (0, $51cfcbefde61ff20$export$afa219bf23651160)($9d72a78ef45a7c39$var$INTEGRATION_NAME, $9d72a78ef45a7c39$export$66acc70e8cf2b71a);
function $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler(client) {
    (0, $isDtX.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9d72a78ef45a7c39$var$getOptions();
        if ((0, $b8438.getClient)() !== client || (0, $4e817323ced6d78c$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $2zW56.isString)(msg) ? $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) : $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame((0, $230372ac01587541$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $b8438.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $e5Ga6.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9d72a78ef45a7c39$var$getOptions();
        if ((0, $b8438.getClient)() !== client || (0, $4e817323ced6d78c$export$b79738ab10c590b2)()) return;
        const error = $9d72a78ef45a7c39$var$_getUnhandledRejectionError(e);
        const event = (0, $2zW56.isPrimitive)(error) ? $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(error) : (0, $230372ac01587541$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $b8438.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $9d72a78ef45a7c39$var$_getUnhandledRejectionError(error) {
    if ((0, $2zW56.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $2zW56.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $2zW56.isString)(url) && url.length > 0 ? url : (0, $ibKgU.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $9d72a78ef45a7c39$var$globalHandlerLog(type) {
    (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`Global Handler attached: ${type}`);
}
function $9d72a78ef45a7c39$var$getOptions() {
    const client = (0, $b8438.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $a609b75c449d57c1$var$INTEGRATION_NAME = 'HttpContext';
const $a609b75c449d57c1$var$_httpContextIntegration = ()=>{
    return {
        name: $a609b75c449d57c1$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).navigator && !(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location && !(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $a609b75c449d57c1$export$1378794447170364 = (0, $51cfcbefde61ff20$export$2323046b9414659f)($a609b75c449d57c1$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $a609b75c449d57c1$export$5d2ee9a544b09a94 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($a609b75c449d57c1$var$INTEGRATION_NAME, $a609b75c449d57c1$export$1378794447170364);




var $2zW56 = parcelRequire("2zW56");

var $91U3U = parcelRequire("91U3U");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $021240852b914991$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $2zW56.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $021240852b914991$var$truncateAggregateExceptions($021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $2zW56.isInstanceOf)(error[key], Error)) {
        $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $021240852b914991$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $2zW56.isInstanceOf)(childError, Error)) {
            $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $021240852b914991$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $021240852b914991$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $021240852b914991$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $021240852b914991$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $021240852b914991$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $91U3U.truncate)(exception.value, maxValueLength);
        return exception;
    });
}



const $732232d08e00e18c$var$DEFAULT_KEY = 'cause';
const $732232d08e00e18c$var$DEFAULT_LIMIT = 5;
const $732232d08e00e18c$var$INTEGRATION_NAME = 'LinkedErrors';
const $732232d08e00e18c$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $732232d08e00e18c$var$DEFAULT_LIMIT;
    const key = options.key || $732232d08e00e18c$var$DEFAULT_KEY;
    return {
        name: $732232d08e00e18c$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $021240852b914991$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $230372ac01587541$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $732232d08e00e18c$export$ebabb00eb7f3a395 = (0, $51cfcbefde61ff20$export$2323046b9414659f)($732232d08e00e18c$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $732232d08e00e18c$export$8d1e60aaf616fb4f = (0, $51cfcbefde61ff20$export$afa219bf23651160)($732232d08e00e18c$var$INTEGRATION_NAME, $732232d08e00e18c$export$ebabb00eb7f3a395);




var $jL8lq = parcelRequire("jL8lq");
var $16dZf = parcelRequire("16dZf");

const $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $f8ac3caec1ed9186$var$INTEGRATION_NAME = 'TryCatch';
const $f8ac3caec1ed9186$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $f8ac3caec1ed9186$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $jL8lq.fill)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), 'setTimeout', $f8ac3caec1ed9186$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $jL8lq.fill)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), 'setInterval', $f8ac3caec1ed9186$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $jL8lq.fill)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81), 'requestAnimationFrame', $f8ac3caec1ed9186$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $4e817323ced6d78c$export$56d8a8a25bd48b81)) (0, $jL8lq.fill)(XMLHttpRequest.prototype, 'send', $f8ac3caec1ed9186$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($f8ac3caec1ed9186$var$_wrapEventTarget);
            }
        }
    };
};
const $f8ac3caec1ed9186$export$59bfe9f1c76150e = (0, $51cfcbefde61ff20$export$2323046b9414659f)($f8ac3caec1ed9186$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $f8ac3caec1ed9186$export$f1a018517668e6d3 = (0, $51cfcbefde61ff20$export$afa219bf23651160)($f8ac3caec1ed9186$var$INTEGRATION_NAME, $f8ac3caec1ed9186$export$59bfe9f1c76150e);
function $f8ac3caec1ed9186$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $4e817323ced6d78c$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $16dZf.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f8ac3caec1ed9186$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $4e817323ced6d78c$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $16dZf.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $f8ac3caec1ed9186$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $jL8lq.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $16dZf.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $jL8lq.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $16dZf.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $4e817323ced6d78c$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $f8ac3caec1ed9186$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $jL8lq.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $16dZf.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $16dZf.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $jL8lq.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



var $16dZf = parcelRequire("16dZf");
// global reference to slice
const $6fa852429033a8df$var$UNKNOWN_FUNCTION = '?';
const $6fa852429033a8df$var$OPERA10_PRIORITY = 10;
const $6fa852429033a8df$var$OPERA11_PRIORITY = 20;
const $6fa852429033a8df$var$CHROME_PRIORITY = 30;
const $6fa852429033a8df$var$WINJS_PRIORITY = 40;
const $6fa852429033a8df$var$GECKO_PRIORITY = 50;
function $6fa852429033a8df$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $6fa852429033a8df$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $6fa852429033a8df$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $6fa852429033a8df$var$chromeStackParserFn = (line)=>{
    const parts = $6fa852429033a8df$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $6fa852429033a8df$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, parts[2]);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $6fa852429033a8df$export$263a749fff749872 = [
    $6fa852429033a8df$var$CHROME_PRIORITY,
    $6fa852429033a8df$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $6fa852429033a8df$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $6fa852429033a8df$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $6fa852429033a8df$var$gecko = (line)=>{
    const parts = $6fa852429033a8df$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $6fa852429033a8df$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION;
        [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(func, filename);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $6fa852429033a8df$export$cdba47a5dd2804d = [
    $6fa852429033a8df$var$GECKO_PRIORITY,
    $6fa852429033a8df$var$gecko
];
const $6fa852429033a8df$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $6fa852429033a8df$var$winjs = (line)=>{
    const parts = $6fa852429033a8df$var$winjsRegex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $6fa852429033a8df$export$179460296da408e8 = [
    $6fa852429033a8df$var$WINJS_PRIORITY,
    $6fa852429033a8df$var$winjs
];
const $6fa852429033a8df$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $6fa852429033a8df$var$opera10 = (line)=>{
    const parts = $6fa852429033a8df$var$opera10Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[3] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $6fa852429033a8df$export$f892b52c880ffc7a = [
    $6fa852429033a8df$var$OPERA10_PRIORITY,
    $6fa852429033a8df$var$opera10
];
const $6fa852429033a8df$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $6fa852429033a8df$var$opera11 = (line)=>{
    const parts = $6fa852429033a8df$var$opera11Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[5], parts[3] || parts[4] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $6fa852429033a8df$export$af11af13f09fb0dc = [
    $6fa852429033a8df$var$OPERA11_PRIORITY,
    $6fa852429033a8df$var$opera11
];
const $6fa852429033a8df$export$7197c0fe6554c079 = [
    $6fa852429033a8df$export$263a749fff749872,
    $6fa852429033a8df$export$cdba47a5dd2804d,
    $6fa852429033a8df$export$179460296da408e8
];
const $6fa852429033a8df$export$2b2b997d81bf3907 = (0, $16dZf.createStackParser)(...$6fa852429033a8df$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $6fa852429033a8df$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $6fa852429033a8df$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $e02662e4aa308398$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $e02662e4aa308398$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $e02662e4aa308398$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $e02662e4aa308398$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $e02662e4aa308398$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $e02662e4aa308398$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


var $4g0Ct = parcelRequire("4g0Ct");

var $j3a3y = parcelRequire("j3a3y");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $e21a1e6dd57da767$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $j3a3y.rejectedSyncPromise)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $j3a3y.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


var $j3a3y = parcelRequire("j3a3y");

var $8IHa9 = parcelRequire("8IHa9");
const $551fd97e865f07d3$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $551fd97e865f07d3$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $e21a1e6dd57da767$export$85a4f67f852183e6)(options.bufferSize || $551fd97e865f07d3$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $2cae643f899492f0$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $2cae643f899492f0$export$b11169581eeaf237)(type);
            if ((0, $e02662e4aa308398$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $j3a3y.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $2cae643f899492f0$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $2cae643f899492f0$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $2cae643f899492f0$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $e02662e4aa308398$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)) {
                (0, $8IHa9.DEBUG_BUILD) && (0, $4g0Ct.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $j3a3y.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $551fd97e865f07d3$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



var $j3a3y = parcelRequire("j3a3y");

var $4g0Ct = parcelRequire("4g0Ct");


let $7d25350de9c66b8e$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $7d25350de9c66b8e$export$8be2119ce08e3379() {
    if ($7d25350de9c66b8e$var$cachedFetchImpl) return $7d25350de9c66b8e$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $a87a94b8e4ff7f26$export$18cf36ed71d733e7)((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch)) return $7d25350de9c66b8e$var$cachedFetchImpl = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch.bind((0, $4e817323ced6d78c$export$56d8a8a25bd48b81));
    const document = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $7d25350de9c66b8e$var$cachedFetchImpl = fetchImpl.bind((0, $4e817323ced6d78c$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $7d25350de9c66b8e$export$d499686d2dd738c6() {
    $7d25350de9c66b8e$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9237c8bb75383bbf$export$b2311068c46d7cc8(options, nativeFetch = (0, $7d25350de9c66b8e$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $7d25350de9c66b8e$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $j3a3y.rejectedSyncPromise)(e);
        }
    }
    return (0, $551fd97e865f07d3$export$d09f50d9ab7f7b69)(options, makeRequest);
}




var $j3a3y = parcelRequire("j3a3y");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $8be23756f879b8e4$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $8be23756f879b8e4$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $8be23756f879b8e4$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $551fd97e865f07d3$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $4c87801c815e53f1$export$5ef831fccfce35e5 = [
    (0, $499a1b6c2e7bd9e9$export$cb3c5c2ceb9818ba)(),
    (0, $ceb328f2f449885f$export$7918117e9202e4fb)(),
    (0, $f8ac3caec1ed9186$export$59bfe9f1c76150e)(),
    (0, $b50dad0732e7f682$export$c079d904b326663a)(),
    (0, $9d72a78ef45a7c39$export$66acc70e8cf2b71a)(),
    (0, $732232d08e00e18c$export$ebabb00eb7f3a395)(),
    (0, $893f0ce260470ef7$export$6d39aa44cd0c7567)(),
    (0, $a609b75c449d57c1$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $4c87801c815e53f1$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$4c87801c815e53f1$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $4c87801c815e53f1$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $4c87801c815e53f1$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $16dZf.stackParserFromStackParserOptions)(options.stackParser || (0, $6fa852429033a8df$export$2b2b997d81bf3907)),
        integrations: (0, $51cfcbefde61ff20$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e)() ? (0, $9237c8bb75383bbf$export$b2311068c46d7cc8) : (0, $8be23756f879b8e4$export$5e1441cee30d5a39))
    };
    (0, $93002778f3923c52$export$5333c3f1c58d9bc1)((0, $c55795097f9daeb0$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $4c87801c815e53f1$var$startSessionTracking();
}
const $4c87801c815e53f1$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $cmFjP.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $d91612272370ed71$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.head || (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4c87801c815e53f1$export$4997ffc0176396a6(fn) {
    return (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4c87801c815e53f1$var$startSessionTracking() {
    if (typeof (0, $4e817323ced6d78c$export$56d8a8a25bd48b81).document === 'undefined') {
        (0, $817d897c5dc6d664$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $b8438.startSession)({
        ignoreDuration: true
    });
    (0, $b8438.captureSession)();
    // We want to create a session for every navigation as well
    (0, $2579aac1b9dfd189$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $b8438.startSession)({
                ignoreDuration: true
            });
            (0, $b8438.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $4c87801c815e53f1$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $b8438.getClient)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $795a7664e1a3c052$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $cb951e05ebb58c43$export$b9f95b027256052c)(opts, 'react');
    (0, $4c87801c815e53f1$export$2cd8252107eb640b)(opts);
}



var $3NuqQ = parcelRequire("3NuqQ");/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $ba7e9f49429c2354$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $289ZW = parcelRequire("289ZW");
var $4g0Ct = parcelRequire("4g0Ct");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a5e85a0c259bdb77$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ // eslint-disable-next-line deprecation/deprecation
function $a9d137194c535c9f$export$34db76d03eb96b7e(getCurrentHub) {
    // eslint-disable-next-line deprecation/deprecation
    const clientOptions = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        getCurrentHub,
        'call',
        (_)=>_(),
        'access',
        (_2)=>_2.getClient,
        'call',
        (_3)=>_3(),
        'optionalAccess',
        (_4)=>_4.getOptions,
        'call',
        (_5)=>_5()
    ]);
    const instrumenter = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        clientOptions,
        'optionalAccess',
        (_6)=>_6.instrumenter
    ]) || 'sentry';
    return instrumenter !== 'sentry';
}


/** Tracing integration for Apollo */ class $72d6e24f36ba74e2$export$3db3e396472fda8d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Apollo';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {
        useNestjs: false
    }){
        this.name = $72d6e24f36ba74e2$export$3db3e396472fda8d.id;
        this._useNest = !!options.useNestjs;
    }
    /** @inheritdoc */ loadDependency() {
        if (this._useNest) this._module = this._module || (0, $289ZW.loadModule)('@nestjs/graphql');
        else this._module = this._module || (0, $289ZW.loadModule)('apollo-server-core');
        return this._module;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('Apollo Integration is skipped because of instrumenter configuration.');
            return;
        }
        if (this._useNest) {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('Apollo-NestJS Integration was unable to require @nestjs/graphql package.');
                return;
            }
            /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, $jL8lq.fill)(pkg.GraphQLFactory.prototype, 'mergeWithSchema', function(orig) {
                return function(...args) {
                    (0, $jL8lq.fill)(this.resolversExplorerService, 'explore', function(orig) {
                        return function() {
                            const resolvers = (0, $b1E2c.arrayify)(orig.call(this));
                            const instrumentedResolvers = $72d6e24f36ba74e2$var$instrumentResolvers(resolvers, getCurrentHub);
                            return instrumentedResolvers;
                        };
                    });
                    return orig.call(this, ...args);
                };
            });
        } else {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('Apollo Integration was unable to require apollo-server-core package.');
                return;
            }
            /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, $jL8lq.fill)(pkg.ApolloServerBase.prototype, 'constructSchema', function(orig) {
                return function() {
                    if (!this.config.resolvers) {
                        if (0, $a5e85a0c259bdb77$export$16a28057038b10ef) {
                            if (this.config.schema) {
                                (0, $4g0Ct.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                (0, $4g0Ct.logger).warn();
                            } else if (this.config.modules) (0, $4g0Ct.logger).warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.');
                            (0, $4g0Ct.logger).error('Skipping tracing as no resolvers found on the `ApolloServer` instance.');
                        }
                        return orig.call(this);
                    }
                    const resolvers = (0, $b1E2c.arrayify)(this.config.resolvers);
                    this.config.resolvers = $72d6e24f36ba74e2$var$instrumentResolvers(resolvers, getCurrentHub);
                    return orig.call(this);
                };
            });
        }
    }
}
$72d6e24f36ba74e2$export$3db3e396472fda8d.__initStatic();
// eslint-disable-next-line deprecation/deprecation
function $72d6e24f36ba74e2$var$instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map((model)=>{
        Object.keys(model).forEach((resolverGroupName)=>{
            Object.keys(model[resolverGroupName]).forEach((resolverName)=>{
                if (typeof model[resolverGroupName][resolverName] !== 'function') return;
                $72d6e24f36ba74e2$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function $72d6e24f36ba74e2$var$wrapResolver(model, resolverGroupName, resolverName, // eslint-disable-next-line deprecation/deprecation
getCurrentHub) {
    (0, $jL8lq.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function(...args) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = getCurrentHub().getScope();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            // eslint-disable-next-line deprecation/deprecation
            const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                parentSpan,
                'optionalAccess',
                (_2)=>_2.startChild,
                'call',
                (_3)=>_3({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: 'graphql.resolve',
                        origin: 'auto.graphql.apollo'
                    })
            ]);
            const rv = orig.call(this, ...args);
            if ((0, $2zW56.isThenable)(rv)) return rv.then((res)=>{
                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    span,
                    'optionalAccess',
                    (_4)=>_4.end,
                    'call',
                    (_5)=>_5()
                ]);
                return res;
            });
            (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                span,
                'optionalAccess',
                (_6)=>_6.end,
                'call',
                (_7)=>_7()
            ]);
            return rv;
        };
    });
}


var $gu0hs = parcelRequire("gu0hs");
var $5UTPE = parcelRequire("5UTPE");
var $b8438 = parcelRequire("b8438");
var $h5OHf = parcelRequire("h5OHf");
var $2EZoq = parcelRequire("2EZoq");

var $ibKgU = parcelRequire("ibKgU");
var $4g0Ct = parcelRequire("4g0Ct");
var $65HJt = parcelRequire("65HJt");


var $5UTPE = parcelRequire("5UTPE");
var $jfPQV = parcelRequire("jfPQV");

var $4g0Ct = parcelRequire("4g0Ct");


var $3bpJ1 = parcelRequire("3bpJ1");
const $fe9433352f19d4b6$export$56d8a8a25bd48b81 = (0, $3bpJ1.GLOBAL_OBJ);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $a50bc2aef3fcf638$export$6f18f55521af71a1() {
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $5UTPE.getActiveTransaction)();
        if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            const { op: op, status: status } = (0, $jfPQV.spanToJSON)(activeTransaction);
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}



var $16dZf = parcelRequire("16dZf");
var $4g0Ct = parcelRequire("4g0Ct");

const $13c2ca2b7f8f393a$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $5863aef6ed758511$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0ae3ea9e7f2c4254$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $0ae3ea9e7f2c4254$export$6431553786c94949 = ()=>{
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $0ae3ea9e7f2c4254$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57e88e157c530457$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $0ae3ea9e7f2c4254$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e8d4206fcb32f41c$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $0ae3ea9e7f2c4254$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.prerendering || (0, $57e88e157c530457$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $5863aef6ed758511$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $c62bade033a6ea98$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $06ed980438256cb2$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)('layout-shift', handleEntries);
    if (po) {
        report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $b6c848c639162360$var$firstHiddenTime = -1;
const $b6c848c639162360$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.visibilityState) $b6c848c639162360$var$firstHiddenTime = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $b6c848c639162360$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $b6c848c639162360$var$firstHiddenTime = timeStamp;
    }, true);
};
const $b6c848c639162360$export$443f86b2c77012c4 = ()=>{
    if ($b6c848c639162360$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $b6c848c639162360$var$initHiddenTime();
        $b6c848c639162360$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $b6c848c639162360$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $fde0c7d375f4fcfc$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $b6c848c639162360$export$443f86b2c77012c4)();
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)('first-input', handleEntries);
    report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $588c8c9828db8996$var$interactionCountEstimate = 0;
let $588c8c9828db8996$var$minKnownInteractionId = Infinity;
let $588c8c9828db8996$var$maxKnownInteractionId = 0;
const $588c8c9828db8996$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $588c8c9828db8996$var$minKnownInteractionId = Math.min($588c8c9828db8996$var$minKnownInteractionId, e.interactionId);
            $588c8c9828db8996$var$maxKnownInteractionId = Math.max($588c8c9828db8996$var$maxKnownInteractionId, e.interactionId);
            $588c8c9828db8996$var$interactionCountEstimate = $588c8c9828db8996$var$maxKnownInteractionId ? ($588c8c9828db8996$var$maxKnownInteractionId - $588c8c9828db8996$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $588c8c9828db8996$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $588c8c9828db8996$export$8a962f2683a476d1 = ()=>{
    return $588c8c9828db8996$var$po ? $588c8c9828db8996$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $588c8c9828db8996$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $588c8c9828db8996$var$po) return;
    $588c8c9828db8996$var$po = (0, $c62bade033a6ea98$export$d1203567a167490e)('event', $588c8c9828db8996$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $ff897fbbb59b5bdf$var$getInteractionCountForNavigation = ()=>{
    return (0, $588c8c9828db8996$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $ff897fbbb59b5bdf$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $ff897fbbb59b5bdf$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $ff897fbbb59b5bdf$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $ff897fbbb59b5bdf$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $ff897fbbb59b5bdf$var$longestInteractionList[$ff897fbbb59b5bdf$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $ff897fbbb59b5bdf$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $ff897fbbb59b5bdf$var$longestInteractionList.length < $ff897fbbb59b5bdf$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $ff897fbbb59b5bdf$var$longestInteractionMap[interaction.id] = interaction;
            $ff897fbbb59b5bdf$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $ff897fbbb59b5bdf$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $ff897fbbb59b5bdf$var$longestInteractionList.splice($ff897fbbb59b5bdf$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $ff897fbbb59b5bdf$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $ff897fbbb59b5bdf$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($ff897fbbb59b5bdf$var$longestInteractionList.length - 1, Math.floor($ff897fbbb59b5bdf$var$getInteractionCountForNavigation() / 50));
    return $ff897fbbb59b5bdf$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $ff897fbbb59b5bdf$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $588c8c9828db8996$export$67d90cda6b78a2eb)();
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)('INP');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $ff897fbbb59b5bdf$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                const noMatchingEntry = !$ff897fbbb59b5bdf$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $ff897fbbb59b5bdf$var$processEntry(entry);
            }
        });
        const inp = $ff897fbbb59b5bdf$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $ff897fbbb59b5bdf$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ca1c2d1679c3e1ef$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $ca1c2d1679c3e1ef$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $b6c848c639162360$export$443f86b2c77012c4)();
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $57e88e157c530457$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $c62bade033a6ea98$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$ca1c2d1679c3e1ef$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $ca1c2d1679c3e1ef$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $d30f0c2db0bdbc5b$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $fc0e8942a061fac1$var$whenReady = (callback)=>{
    if (!(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) return;
    if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', ()=>$fc0e8942a061fac1$var$whenReady(callback), true);
    else if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', ()=>$fc0e8942a061fac1$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $fc0e8942a061fac1$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $e8d4206fcb32f41c$export$3c29b44508a0612b)('TTFB');
    const report = (0, $13c2ca2b7f8f393a$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $fc0e8942a061fac1$var$whenReady(()=>{
        const navEntry = (0, $0ae3ea9e7f2c4254$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $57e88e157c530457$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $8b02f76565f096cc$var$handlers = {};
const $8b02f76565f096cc$var$instrumented = {};
let $8b02f76565f096cc$var$_previousCls;
let $8b02f76565f096cc$var$_previousFid;
let $8b02f76565f096cc$var$_previousLcp;
let $8b02f76565f096cc$var$_previousTtfb;
let $8b02f76565f096cc$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $8b02f76565f096cc$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $8b02f76565f096cc$var$addMetricObserver('cls', callback, $8b02f76565f096cc$var$instrumentCls, $8b02f76565f096cc$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $8b02f76565f096cc$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $8b02f76565f096cc$var$addMetricObserver('lcp', callback, $8b02f76565f096cc$var$instrumentLcp, $8b02f76565f096cc$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $8b02f76565f096cc$export$699d9529c099a797(callback) {
    return $8b02f76565f096cc$var$addMetricObserver('ttfb', callback, $8b02f76565f096cc$var$instrumentTtfb, $8b02f76565f096cc$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$2707d7471c0b918f(callback) {
    return $8b02f76565f096cc$var$addMetricObserver('fid', callback, $8b02f76565f096cc$var$instrumentFid, $8b02f76565f096cc$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$da3b76aa2022cbd7(callback) {
    return $8b02f76565f096cc$var$addMetricObserver('inp', callback, $8b02f76565f096cc$var$instrumentInp, $8b02f76565f096cc$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8b02f76565f096cc$export$69816c1a049f8db6(type, callback) {
    $8b02f76565f096cc$var$addHandler(type, callback);
    if (!$8b02f76565f096cc$var$instrumented[type]) {
        $8b02f76565f096cc$var$instrumentPerformanceObserver(type);
        $8b02f76565f096cc$var$instrumented[type] = true;
    }
    return $8b02f76565f096cc$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $8b02f76565f096cc$var$triggerHandlers(type, data) {
    const typeHandlers = $8b02f76565f096cc$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $16dZf.getFunctionName)(handler)}\nError:`, e);
    }
}
function $8b02f76565f096cc$var$instrumentCls() {
    return (0, $06ed980438256cb2$export$a7873055838e5ad8)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers('cls', {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $8b02f76565f096cc$var$instrumentFid() {
    return (0, $fde0c7d375f4fcfc$export$39705a25c49af873)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers('fid', {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousFid = metric;
    });
}
function $8b02f76565f096cc$var$instrumentLcp() {
    return (0, $ca1c2d1679c3e1ef$export$947b1626ab8d5632)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers('lcp', {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousLcp = metric;
    });
}
function $8b02f76565f096cc$var$instrumentTtfb() {
    return (0, $fc0e8942a061fac1$export$33a01e6c5f2c7e33)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousTtfb = metric;
    });
}
function $8b02f76565f096cc$var$instrumentInp() {
    return (0, $ff897fbbb59b5bdf$export$7df4b36ecaed99e1)((metric)=>{
        $8b02f76565f096cc$var$triggerHandlers('inp', {
            metric: metric
        });
        $8b02f76565f096cc$var$_previousInp = metric;
    });
}
function $8b02f76565f096cc$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $8b02f76565f096cc$var$addHandler(type, callback);
    let stopListening;
    if (!$8b02f76565f096cc$var$instrumented[type]) {
        stopListening = instrumentFn();
        $8b02f76565f096cc$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $8b02f76565f096cc$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $8b02f76565f096cc$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $c62bade033a6ea98$export$d1203567a167490e)(type, (entries)=>{
        $8b02f76565f096cc$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $8b02f76565f096cc$var$addHandler(type, handler) {
    $8b02f76565f096cc$var$handlers[type] = $8b02f76565f096cc$var$handlers[type] || [];
    $8b02f76565f096cc$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $8b02f76565f096cc$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $8b02f76565f096cc$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}



/**
 * Create envelope from Span item.
 */ function $27113bf3441639bf$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn);
    const items = spans.map($27113bf3441639bf$var$createSpanItem);
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(headers, items);
}
function $27113bf3441639bf$var$createSpanItem(span) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}


var $5UTPE = parcelRequire("5UTPE");
var $b8438 = parcelRequire("b8438");
var $duCnO = parcelRequire("duCnO");
var $kJ1jU = parcelRequire("kJ1jU");
var $5UTPE = parcelRequire("5UTPE");
/**
 * Adds a measurement to the current active transaction.
 */ function $90bdaea68141640c$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $5UTPE.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


var $cKEJC = parcelRequire("cKEJC");
var $jfPQV = parcelRequire("jfPQV");

var $cvSY8 = parcelRequire("cvSY8");
var $ibKgU = parcelRequire("ibKgU");
var $4g0Ct = parcelRequire("4g0Ct");




/**
 * Checks if a given value is a valid measurement value.
 */ function $5efc8c95ea982b90$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $5efc8c95ea982b90$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $df8507bffbb2043c$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $df8507bffbb2043c$var$msToSec(time) {
    return time / 1000;
}
function $df8507bffbb2043c$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81) && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).addEventListener && (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance;
}
let $df8507bffbb2043c$var$_performanceCursor = 0;
let $df8507bffbb2043c$var$_measurements = {};
let $df8507bffbb2043c$var$_lcpEntry;
let $df8507bffbb2043c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $df8507bffbb2043c$export$7c69f0412d101b88() {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (performance && (0, $cvSY8.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const fidCallback = $df8507bffbb2043c$var$_trackFID();
        const clsCallback = $df8507bffbb2043c$var$_trackCLS();
        const lcpCallback = $df8507bffbb2043c$var$_trackLCP();
        const ttfbCallback = $df8507bffbb2043c$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $df8507bffbb2043c$export$f396d19077034ad2() {
    (0, $8b02f76565f096cc$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $5UTPE.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $df8507bffbb2043c$export$e27543e0976315e4() {
    (0, $8b02f76565f096cc$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $5UTPE.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
                const span = {
                    description: (0, $ibKgU.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $ibKgU.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    'ui.component_name': componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $df8507bffbb2043c$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (performance && (0, $cvSY8.browserPerformanceTimeOrigin)) {
        const inpCallback = $df8507bffbb2043c$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $df8507bffbb2043c$var$_trackCLS() {
    return (0, $8b02f76565f096cc$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('[Measurements] Adding CLS');
        $df8507bffbb2043c$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $df8507bffbb2043c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $df8507bffbb2043c$var$_trackLCP() {
    return (0, $8b02f76565f096cc$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('[Measurements] Adding LCP');
        $df8507bffbb2043c$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $df8507bffbb2043c$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $df8507bffbb2043c$var$_trackFID() {
    return (0, $8b02f76565f096cc$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin));
        const startTime = $df8507bffbb2043c$var$msToSec(entry.startTime);
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('[Measurements] Adding FID');
        $df8507bffbb2043c$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $df8507bffbb2043c$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $df8507bffbb2043c$var$_trackTtfb() {
    return (0, $8b02f76565f096cc$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('[Measurements] Adding TTFB');
        $df8507bffbb2043c$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
const $df8507bffbb2043c$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $df8507bffbb2043c$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $8b02f76565f096cc$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $df8507bffbb2043c$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $b8438.getClient)();
        if (!entry || !client) return;
        const interactionType = $df8507bffbb2043c$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = $df8507bffbb2043c$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $cKEJC.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $ibKgU.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== '' ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $df8507bffbb2043c$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $27113bf3441639bf$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $df8507bffbb2043c$export$5f8fa6b3467a7443(transaction) {
    const performance = $df8507bffbb2043c$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).performance.getEntries || !(0, $cvSY8.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $df8507bffbb2043c$var$msToSec((0, $cvSY8.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $jfPQV.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($df8507bffbb2043c$var$_performanceCursor).forEach((entry)=>{
        const startTime = $df8507bffbb2043c$var$msToSec(entry.startTime);
        const duration = $df8507bffbb2043c$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $df8507bffbb2043c$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $df8507bffbb2043c$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $b6c848c639162360$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('[Measurements] Adding FP');
                        $df8507bffbb2043c$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('[Measurements] Adding FCP');
                        $df8507bffbb2043c$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $df8507bffbb2043c$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $df8507bffbb2043c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $df8507bffbb2043c$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $df8507bffbb2043c$var$_addTtfbRequestTimeToMeasurements($df8507bffbb2043c$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$df8507bffbb2043c$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $df8507bffbb2043c$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $df8507bffbb2043c$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $df8507bffbb2043c$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $df8507bffbb2043c$var$_measurements['mark.fid'];
        if (fidMark && $df8507bffbb2043c$var$_measurements['fid']) {
            // create span for FID
            (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $df8507bffbb2043c$var$msToSec($df8507bffbb2043c$var$_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $df8507bffbb2043c$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $df8507bffbb2043c$var$_measurements)) delete $df8507bffbb2043c$var$_measurements.cls;
        Object.keys($df8507bffbb2043c$var$_measurements).forEach((measurementName)=>{
            (0, $90bdaea68141640c$export$7cc31b475d33a706)(measurementName, $df8507bffbb2043c$var$_measurements[measurementName].value, $df8507bffbb2043c$var$_measurements[measurementName].unit);
        });
        $df8507bffbb2043c$var$_tagMetricInfo(transaction);
    }
    $df8507bffbb2043c$var$_lcpEntry = undefined;
    $df8507bffbb2043c$var$_clsEntry = undefined;
    $df8507bffbb2043c$var$_measurements = {};
}
/** Create measure related spans */ function $df8507bffbb2043c$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $df8507bffbb2043c$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $df8507bffbb2043c$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $df8507bffbb2043c$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(start),
        endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $df8507bffbb2043c$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseEnd)
        });
        (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $df8507bffbb2043c$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $df8507bffbb2043c$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $25257edadcf16f49$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $5efc8c95ea982b90$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $df8507bffbb2043c$var$_trackNavigator(transaction) {
    const navigator = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, $5efc8c95ea982b90$export$27169ccae1b439e3)(connection.rtt)) $df8507bffbb2043c$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $5efc8c95ea982b90$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $5efc8c95ea982b90$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $df8507bffbb2043c$var$_tagMetricInfo(transaction) {
    if ($df8507bffbb2043c$var$_lcpEntry) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($df8507bffbb2043c$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, $ibKgU.htmlTreeAsString)($df8507bffbb2043c$var$_lcpEntry.element));
        if ($df8507bffbb2043c$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', $df8507bffbb2043c$var$_lcpEntry.id);
        if ($df8507bffbb2043c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', $df8507bffbb2043c$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', $df8507bffbb2043c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($df8507bffbb2043c$var$_clsEntry && $df8507bffbb2043c$var$_clsEntry.sources) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('[Measurements] Adding CLS Data');
        $df8507bffbb2043c$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $ibKgU.htmlTreeAsString)(source.node)));
    }
}
function $df8507bffbb2043c$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $df8507bffbb2043c$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $df8507bffbb2043c$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $0ae3ea9e7f2c4254$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $df8507bffbb2043c$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $duCnO.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $kJ1jU.isValidSampleRate)(sampleRate)) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}



var $b8438 = parcelRequire("b8438");
var $bPHT6 = parcelRequire("bPHT6");
var $cmFjP = parcelRequire("cmFjP");
var $duCnO = parcelRequire("duCnO");
var $h5OHf = parcelRequire("h5OHf");
var $9pnio = parcelRequire("9pnio");
var $jfPQV = parcelRequire("jfPQV");
var $fJmes = parcelRequire("fJmes");

var $dzA7g = parcelRequire("dzA7g");
var $cvSY8 = parcelRequire("cvSY8");
var $65HJt = parcelRequire("65HJt");
var $91U3U = parcelRequire("91U3U");

var $b8438 = parcelRequire("b8438");
var $bPHT6 = parcelRequire("bPHT6");
var $cmFjP = parcelRequire("cmFjP");
var $duCnO = parcelRequire("duCnO");
var $h5OHf = parcelRequire("h5OHf");
var $9pnio = parcelRequire("9pnio");
var $jfPQV = parcelRequire("jfPQV");
var $fJmes = parcelRequire("fJmes");

var $dzA7g = parcelRequire("dzA7g");
var $65HJt = parcelRequire("65HJt");
var $2zW56 = parcelRequire("2zW56");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $bb4def6c8b51e56d$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!(0, $duCnO.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $bb4def6c8b51e56d$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $b8438.getCurrentScope)();
    const client = (0, $b8438.getClient)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $bb4def6c8b51e56d$var$getFullURL(url);
    const host = fullUrl ? (0, $25257edadcf16f49$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $fJmes.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $bb4def6c8b51e56d$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $bb4def6c8b51e56d$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $jfPQV.spanToTraceHeader)(span) : (0, $65HJt.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $dzA7g.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $bPHT6.getDynamicSamplingContextFromSpan)(span) : (0, $bPHT6.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== 'undefined' && (0, $2zW56.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $2zW56.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $dzA7g.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $dzA7g.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $bb4def6c8b51e56d$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $bb4def6c8b51e56d$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $9pnio.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}




/* eslint-disable max-lines */ const $e425abf0f1e5a10f$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $e425abf0f1e5a10f$export$15bd0305d05ad07b,
    tracePropagationTargets: $e425abf0f1e5a10f$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $e425abf0f1e5a10f$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$e425abf0f1e5a10f$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $deebfb2c2f3e82fb$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $bb4def6c8b51e56d$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $e425abf0f1e5a10f$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $25257edadcf16f49$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $e425abf0f1e5a10f$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $ae6dc6125d1c3217$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $e425abf0f1e5a10f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $e425abf0f1e5a10f$var$addHTTPTimings(createdSpan);
    });
}
function $e425abf0f1e5a10f$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $e425abf0f1e5a10f$var$addHTTPTimings(span) {
    const { url: url } = (0, $jfPQV.spanToJSON)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $8b02f76565f096cc$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($e425abf0f1e5a10f$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $e425abf0f1e5a10f$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $e425abf0f1e5a10f$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $e425abf0f1e5a10f$var$getAbsoluteTime(time = 0) {
    return (((0, $cvSY8.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $e425abf0f1e5a10f$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $e425abf0f1e5a10f$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $cvSY8.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $e425abf0f1e5a10f$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $e425abf0f1e5a10f$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $91U3U.stringMatchesSomePattern)(url, tracePropagationTargets || $e425abf0f1e5a10f$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $e425abf0f1e5a10f$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $ae6dc6125d1c3217$export$55b6bb1e45c6cf59];
    if (!(0, $duCnO.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $9pnio.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $b8438.getCurrentScope)();
    const isolationScope = (0, $cmFjP.getIsolationScope)();
    const fullUrl = $e425abf0f1e5a10f$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $25257edadcf16f49$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $fJmes.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser'
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $b8438.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $jfPQV.spanToTraceHeader)(span) : (0, $65HJt.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $dzA7g.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $bPHT6.getDynamicSamplingContextFromSpan)(span) : (0, $bPHT6.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $e425abf0f1e5a10f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $e425abf0f1e5a10f$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $dzA7g.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $e425abf0f1e5a10f$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



var $cvSY8 = parcelRequire("cvSY8");
var $4g0Ct = parcelRequire("4g0Ct");


/**
 * Default function implementing pageload and navigation transactions
 */ function $fe365ce63ae91e59$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81) || !(0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location) {
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    let startingUrl = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $cvSY8.browserPerformanceTimeOrigin) ? (0, $cvSY8.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: 'pageload',
        origin: 'auto.pageload.browser',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $2579aac1b9dfd189$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).location.pathname,
                op: 'navigation',
                origin: 'auto.navigation.browser',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}



const $1a684ef8a4a48899$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $1a684ef8a4a48899$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $2EZoq.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $fe365ce63ae91e59$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $1a684ef8a4a48899$var$MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class $1a684ef8a4a48899$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = $1a684ef8a4a48899$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $gu0hs.addTracingExtensions)();
        if (0, $a5e85a0c259bdb77$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$1a684ef8a4a48899$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $df8507bffbb2043c$export$7c69f0412d101b88)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, $df8507bffbb2043c$export$f17d06681a4744a3)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, $df8507bffbb2043c$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $df8507bffbb2043c$export$e27543e0976315e4)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $a5e85a0c259bdb77$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $4g0Ct.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $a50bc2aef3fcf638$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, $e425abf0f1e5a10f$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $1a684ef8a4a48899$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $1a684ef8a4a48899$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $65HJt.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $gu0hs.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) {
                (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', ()=>{
                    if ([
                        'interactive',
                        'complete'
                    ].includes((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $df8507bffbb2043c$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = 'ui.action.click';
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $5UTPE.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                'navigation',
                'pageload'
            ].includes(currentTransaction.op)) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $fe9433352f19d4b6$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRoute.name,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: this._latestRoute.context ? $1a684ef8a4a48899$var$getSource(this._latestRoute.context) : 'url'
                }
            };
            inflightInteractionTransaction = (0, $gu0hs.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            'click'
        ].forEach((type)=>{
            if ((0, $fe9433352f19d4b6$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries: entries })=>{
            const client = (0, $b8438.getClient)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, $5UTPE.getActiveTransaction)();
            const currentScope = (0, $b8438.getCurrentScope)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if ($1a684ef8a4a48899$var$isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === 'first-input') {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < $1a684ef8a4a48899$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= $1a684ef8a4a48899$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName: routeName,
                                duration: duration,
                                parentContext: parentContext,
                                user: user,
                                activeTransaction: activeTransaction,
                                replayId: replayId,
                                startTime: startTime
                            };
                        }
                    }
                }
            });
        };
        (0, $8b02f76565f096cc$export$69816c1a049f8db6)('event', handleEntries);
        (0, $8b02f76565f096cc$export$69816c1a049f8db6)('first-input', handleEntries);
    }
}
/** Returns the value of a meta tag */ function $1a684ef8a4a48899$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $ibKgU.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
function $1a684ef8a4a48899$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function $1a684ef8a4a48899$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}

/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ function $99dc60c0d6480f52$export$d0eaf3e94be578f6(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf('=', index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(';', index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(';', eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf('%') !== -1 ? decodeURIComponent(val) : val;
            } catch (e) {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}



var $eKZKa = parcelRequire("eKZKa");

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");

var $drMc1 = parcelRequire("drMc1");

const $bfbb651c762ddc49$var$DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
const $bfbb651c762ddc49$var$DEFAULT_REQUEST_INCLUDES = [
    'cookies',
    'data',
    'headers',
    'method',
    'query_string',
    'url'
];
const $bfbb651c762ddc49$export$33c1c602a3538e5e = [
    'id',
    'username',
    'email'
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request.
 *
 * @deprecated This utility will be removed in v8.
 */ function $bfbb651c762ddc49$export$1973410ef8793cd6(transaction, req, deps) {
    if (!transaction) return;
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.metadata.source || transaction.metadata.source === 'url') {
        // Attempt to grab a parameterized route off of the request
        const [name, source] = $bfbb651c762ddc49$export$8c5ebee2e5bb9575(req, {
            path: true,
            method: true
        });
        transaction.updateName(name);
        // TODO: SEMANTIC_ATTRIBUTE_SENTRY_SOURCE is in core, align this once we merge utils & core
        // eslint-disable-next-line deprecation/deprecation
        transaction.setMetadata({
            source: source
        });
    }
    transaction.setAttribute('url', req.originalUrl || req.url);
    if (req.baseUrl) transaction.setAttribute('baseUrl', req.baseUrl);
    // TODO: We need to rewrite this to a flat format?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setData('query', $bfbb651c762ddc49$var$extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function $bfbb651c762ddc49$export$8c5ebee2e5bb9575(req, options = {}) {
    const method = req.method && req.method.toUpperCase();
    let path = '';
    let source = 'url';
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ''}${req.route && req.route.path}`;
        source = 'route';
    } else if (req.originalUrl || req.url) path = (0, $25257edadcf16f49$export$ce084c78234bd35)(req.originalUrl || req.url || '');
    let name = '';
    if (options.method && method) name += method;
    if (options.method && options.path) name += ' ';
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function $bfbb651c762ddc49$var$extractTransaction(req, type) {
    switch(type){
        case 'path':
            return $bfbb651c762ddc49$export$8c5ebee2e5bb9575(req, {
                path: true
            })[0];
        case 'handler':
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || '<anonymous>';
        case 'methodPath':
        default:
            {
                // if exist _reconstructedRoute return that path instead of route.path
                const customRoute = req._reconstructedRoute ? req._reconstructedRoute : undefined;
                return $bfbb651c762ddc49$export$8c5ebee2e5bb9575(req, {
                    path: true,
                    method: true,
                    customRoute: customRoute
                })[0];
            }
    }
}
/** JSDoc */ function $bfbb651c762ddc49$var$extractUserData(user, keys) {
    const extractedUser = {};
    const attributes = Array.isArray(keys) ? keys : $bfbb651c762ddc49$export$33c1c602a3538e5e;
    attributes.forEach((key)=>{
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function $bfbb651c762ddc49$export$b5c5d78255f11c84(req, options) {
    const { include: include = $bfbb651c762ddc49$var$DEFAULT_REQUEST_INCLUDES, deps: deps } = options || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    const headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    const method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    // Express 4 mistakenly strips off port number from req.host / req.hostname so we can't rely on them
    // See: https://github.com/expressjs/express/issues/3047#issuecomment-236653223
    // Also: https://github.com/getsentry/sentry-javascript/issues/1917
    const host = headers.host || req.hostname || req.host || '<no host>';
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    const protocol = req.protocol === 'https' || req.socket && req.socket.encrypted ? 'https' : 'http';
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    const originalUrl = req.originalUrl || req.url || '';
    // absolute url
    const absoluteUrl = originalUrl.startsWith(protocol) ? originalUrl : `${protocol}://${host}${originalUrl}`;
    include.forEach((key)=>{
        switch(key){
            case 'headers':
                requestData.headers = headers;
                // Remove the Cookie header in case cookie data should not be included in the event
                if (!include.includes('cookies')) delete requestData.headers.cookie;
                break;
            case 'method':
                requestData.method = method;
                break;
            case 'url':
                requestData.url = absoluteUrl;
                break;
            case 'cookies':
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && (0, $99dc60c0d6480f52$export$d0eaf3e94be578f6)(headers.cookie) || {};
                break;
            case 'query_string':
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = $bfbb651c762ddc49$var$extractQueryParams(req, deps);
                break;
            case 'data':
                if (method === 'GET' || method === 'HEAD') break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, $2zW56.isString)(req.body) ? req.body : JSON.stringify((0, $drMc1.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */ function $bfbb651c762ddc49$export$e560aeb323d2791d(event, req, options) {
    const include = {
        ...$bfbb651c762ddc49$var$DEFAULT_INCLUDES,
        ...options && options.include
    };
    if (include.request) {
        const extractedRequestData = Array.isArray(include.request) ? $bfbb651c762ddc49$export$b5c5d78255f11c84(req, {
            include: include.request,
            deps: options && options.deps
        }) : $bfbb651c762ddc49$export$b5c5d78255f11c84(req, {
            deps: options && options.deps
        });
        event.request = {
            ...event.request,
            ...extractedRequestData
        };
    }
    if (include.user) {
        const extractedUser = req.user && (0, $2zW56.isPlainObject)(req.user) ? $bfbb651c762ddc49$var$extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = {
            ...event.user,
            ...extractedUser
        };
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        const ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = $bfbb651c762ddc49$var$extractTransaction(req, include.transaction);
    return event;
}
function $bfbb651c762ddc49$var$extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    let originalUrl = req.originalUrl || req.url || '';
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith('/')) originalUrl = `http://dogs.are.great${originalUrl}`;
    try {
        return req.query || typeof URL !== 'undefined' && new URL(originalUrl).search.slice(1) || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
        deps && deps.url && deps.url.parse(originalUrl).query || undefined;
    } catch (e2) {
        return undefined;
    }
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ // TODO(v8): Make this function return undefined when the extraction fails.
function $bfbb651c762ddc49$export$fee0927b05379c23(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === 'string') // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch (e) {
        (0, $eKZKa.DEBUG_BUILD) && (0, $4g0Ct.logger).warn('Sentry failed extracting headers from a request object. If you see this, please file an issue.');
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function $bfbb651c762ddc49$export$49a11ed11911fd29(req) {
    const headers = $bfbb651c762ddc49$export$fee0927b05379c23(req.headers);
    return {
        method: req.method,
        url: req.url,
        headers: headers
    };
}


var $3bpJ1 = parcelRequire("3bpJ1");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");

var $h5OHf = parcelRequire("h5OHf");
var $jfPQV = parcelRequire("jfPQV");


/* eslint-disable max-lines */ /**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ class $04470ea8dc00f88f$export$6dafdd8fec05099d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Express';
    }
    /**
   * @inheritDoc
   */ /**
   * Express App instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $04470ea8dc00f88f$export$6dafdd8fec05099d.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if (!this._router) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('ExpressIntegration is missing an Express instance');
            return;
        }
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('Express Integration is skipped because of instrumenter configuration.');
            return;
        }
        $04470ea8dc00f88f$var$instrumentMiddlewares(this._router, this._methods);
        $04470ea8dc00f88f$var$instrumentRouter(this._router);
    }
}
$04470ea8dc00f88f$export$6dafdd8fec05099d.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $04470ea8dc00f88f$var$wrap(fn, method) {
    const arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                const transaction = res.__sentry_transaction;
                if (transaction) {
                    // eslint-disable-next-line deprecation/deprecation
                    const span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`,
                        origin: 'auto.middleware.express'
                    });
                    res.once('finish', ()=>{
                        span.end();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                const transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    transaction,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: 'auto.middleware.express'
                        })
                ]);
                fn.call(this, req, res, function(...args) {
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_4)=>_4.end,
                        'call',
                        (_5)=>_5()
                    ]);
                    next.call(this, ...args);
                });
            };
        case 4:
            return function(err, req, res, next) {
                const transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    transaction,
                    'optionalAccess',
                    (_6)=>_6.startChild,
                    'call',
                    (_7)=>_7({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: 'auto.middleware.express'
                        })
                ]);
                fn.call(this, err, req, res, function(...args) {
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.end,
                        'call',
                        (_9)=>_9()
                    ]);
                    next.call(this, ...args);
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $04470ea8dc00f88f$var$wrapMiddlewareArgs(args, method) {
    return args.map((arg)=>{
        if (typeof arg === 'function') return $04470ea8dc00f88f$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map((a)=>{
            if (typeof a === 'function') return $04470ea8dc00f88f$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $04470ea8dc00f88f$var$patchMiddleware(router, method) {
    const originalCallback = router[method];
    router[method] = function(...args) {
        return originalCallback.call(this, ...$04470ea8dc00f88f$var$wrapMiddlewareArgs(args, method));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $04470ea8dc00f88f$var$instrumentMiddlewares(router, methods = []) {
    methods.forEach((method)=>$04470ea8dc00f88f$var$patchMiddleware(router, method));
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function $04470ea8dc00f88f$var$instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    const isApp = 'settings' in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    const router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).debug('Cannot instrument router for URL Parameterization (did not find a valid router).');
        (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).debug('Routing instrumentation is currently only supported in Express 4.');
        return;
    }
    const routerProto = Object.getPrototypeOf(router);
    const originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = '';
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        const { layerRoutePath: layerRoutePath, isRegex: isRegex, isArray: isArray, numExtraSegments: numExtraSegments } = $04470ea8dc00f88f$var$getLayerRoutePathInfo(layer);
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        let partialRoute;
        if (layerRoutePath) partialRoute = layerRoutePath;
        else /**
       * prevent duplicate segment in _reconstructedRoute param if router match multiple routes before final path
       * example:
       * original url: /api/v1/1234
       * prevent: /api/api/v1/:userId
       * router structure
       * /api -> middleware
       * /api/v1 -> middleware
       * /1234 -> endpoint with param :userId
       * final _reconstructedRoute is /api/v1/:userId
       */ partialRoute = $04470ea8dc00f88f$export$ea5dbbfd8423c1fa(req.originalUrl, req._reconstructedRoute, layer.path) || '';
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        const finalPartialRoute = partialRoute.split('/').filter((segment)=>segment.length > 0 && (isRegex || isArray || !segment.includes('*'))).join('/');
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? '/' : ''}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        const urlLength = (0, $25257edadcf16f49$export$69dd85280a8d374c)((0, $25257edadcf16f49$export$ce084c78234bd35)(req.originalUrl || '')) + numExtraSegments;
        const routeLength = (0, $25257edadcf16f49$export$69dd85280a8d374c)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl ? (0, $25257edadcf16f49$export$ce084c78234bd35)(req.originalUrl) : req.originalUrl;
            }
            const transaction = res.__sentry_transaction;
            const attributes = transaction && (0, $jfPQV.spanToJSON)(transaction).data || {};
            if (transaction && attributes[0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] !== 'custom') {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                const finalRoute = req._reconstructedRoute || '/';
                const [name, source] = (0, $bfbb651c762ddc49$export$8c5ebee2e5bb9575)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                });
                transaction.updateName(name);
                transaction.setAttribute((0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Recreate layer.route.path from layer.regexp and layer.keys.
 * Works until express.js used package path-to-regexp@0.1.7
 * or until layer.keys contain offset attribute
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns string in layer.route.path structure 'router/:pathParam' or undefined
 */ const $04470ea8dc00f88f$export$bde9c19304d7dbd3 = (path, regexp, keys)=>{
    if (!path || !regexp || !keys || Object.keys(keys).length === 0 || (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        keys,
        'access',
        (_10)=>_10[0],
        'optionalAccess',
        (_11)=>_11.offset
    ]) === undefined || (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        keys,
        'access',
        (_12)=>_12[0],
        'optionalAccess',
        (_13)=>_13.offset
    ]) === null) return undefined;
    const orderedKeys = keys.sort((a, b)=>a.offset - b.offset);
    // add d flag for getting indices from regexp result
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- regexp comes from express.js
    const pathRegex = new RegExp(regexp, `${regexp.flags}d`);
    /**
   * use custom type cause of TS error with missing indices in RegExpExecArray
   */ const execResult = pathRegex.exec(path);
    if (!execResult || !execResult.indices) return undefined;
    /**
   * remove first match from regex cause contain whole layer.path
   */ const [, ...paramIndices] = execResult.indices;
    if (paramIndices.length !== orderedKeys.length) return undefined;
    let resultPath = path;
    let indexShift = 0;
    /**
   * iterate param matches from regexp.exec
   */ paramIndices.forEach((item, index)=>{
        /** check if offsets is define because in some cases regex d flag returns undefined */ if (item) {
            const [startOffset, endOffset] = item;
            /**
       * isolate part before param
       */ const substr1 = resultPath.substring(0, startOffset - indexShift);
            /**
       * define paramName as replacement in format :pathParam
       */ const replacement = `:${orderedKeys[index].name}`;
            /**
       * isolate part after param
       */ const substr2 = resultPath.substring(endOffset - indexShift);
            /**
       * recreate original path but with param replacement
       */ resultPath = substr1 + replacement + substr2;
            /**
       * calculate new index shift after resultPath was modified
       */ indexShift = indexShift + (endOffset - startOffset - replacement.length);
        }
    });
    return resultPath;
};
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function $04470ea8dc00f88f$var$getLayerRoutePathInfo(layer) {
    let lrp = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        layer,
        'access',
        (_14)=>_14.route,
        'optionalAccess',
        (_15)=>_15.path
    ]);
    const isRegex = (0, $2zW56.isRegExp)(lrp);
    const isArray = Array.isArray(lrp);
    if (!lrp) {
        // parse node.js major version
        // Next.js will complain if we directly use `proces.versions` here because of edge runtime.
        const [major] = (0, $3bpJ1.GLOBAL_OBJ).process.versions.node.split('.').map(Number);
        // allow call extractOriginalRoute only if node version support Regex d flag, node 16+
        if (major >= 16) /**
       * If lrp does not exist try to recreate original layer path from route regexp
       */ lrp = $04470ea8dc00f88f$export$bde9c19304d7dbd3(layer.path, layer.regexp, layer.keys);
    }
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    const numExtraSegments = isArray ? Math.max($04470ea8dc00f88f$var$getNumberOfArrayUrlSegments(lrp) - (0, $25257edadcf16f49$export$69dd85280a8d374c)(layer.path || ''), 0) : 0;
    const layerRoutePath = $04470ea8dc00f88f$var$getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function $04470ea8dc00f88f$var$getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce((accNumSegments, currentRoute)=>{
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, $25257edadcf16f49$export$69dd85280a8d374c)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function $04470ea8dc00f88f$var$getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map((r)=>r.toString()).join(',');
    return lrp && lrp.toString();
}
/**
 * remove duplicate segment contain in layerPath against reconstructedRoute,
 * and return only unique segment that can be added into reconstructedRoute
 */ function $04470ea8dc00f88f$export$ea5dbbfd8423c1fa(originalUrl, reconstructedRoute, layerPath) {
    // filter query params
    const normalizeURL = (0, $25257edadcf16f49$export$ce084c78234bd35)(originalUrl || '');
    const originalUrlSplit = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        normalizeURL,
        'optionalAccess',
        (_16)=>_16.split,
        'call',
        (_17)=>_17('/'),
        'access',
        (_18)=>_18.filter,
        'call',
        (_19)=>_19((v)=>!!v)
    ]);
    let tempCounter = 0;
    const currentOffset = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        reconstructedRoute,
        'optionalAccess',
        (_20)=>_20.split,
        'call',
        (_21)=>_21('/'),
        'access',
        (_22)=>_22.filter,
        'call',
        (_23)=>_23((v)=>!!v),
        'access',
        (_24)=>_24.length
    ]) || 0;
    const result = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
        layerPath,
        'optionalAccess',
        (_25)=>_25.split,
        'call',
        (_26)=>_26('/'),
        'access',
        (_27)=>_27.filter,
        'call',
        (_28)=>_28((segment)=>{
                if ((0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    originalUrlSplit,
                    'optionalAccess',
                    (_29)=>_29[currentOffset + tempCounter]
                ]) === segment) {
                    tempCounter += 1;
                    return true;
                }
                return false;
            }),
        'access',
        (_30)=>_30.join,
        'call',
        (_31)=>_31('/')
    ]);
    return result;
}


var $5UTPE = parcelRequire("5UTPE");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $289ZW = parcelRequire("289ZW");
var $4g0Ct = parcelRequire("4g0Ct");


/** Tracing integration for graphql package */ class $cc85be36602e051f$export$b735d011553f1049 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'GraphQL';
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $cc85be36602e051f$export$b735d011553f1049.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $289ZW.loadModule)('graphql/execution/execute.js');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('GraphQL Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('GraphQL Integration was unable to require graphql/execution package.');
            return;
        }
        (0, $jL8lq.fill)(pkg, 'execute', function(orig) {
            return function(...args) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: 'execute',
                            op: 'graphql.execute',
                            origin: 'auto.graphql.graphql'
                        })
                ]);
                // eslint-disable-next-line deprecation/deprecation
                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    scope,
                    'optionalAccess',
                    (_4)=>_4.setSpan,
                    'call',
                    (_5)=>_5(span)
                ]);
                const rv = orig.call(this, ...args);
                if ((0, $2zW56.isThenable)(rv)) return rv.then((res)=>{
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_6)=>_6.end,
                        'call',
                        (_7)=>_7()
                    ]);
                    // eslint-disable-next-line deprecation/deprecation
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        scope,
                        'optionalAccess',
                        (_8)=>_8.setSpan,
                        'call',
                        (_9)=>_9(parentSpan)
                    ]);
                    return res;
                });
                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    span,
                    'optionalAccess',
                    (_10)=>_10.end,
                    'call',
                    (_11)=>_11()
                ]);
                // eslint-disable-next-line deprecation/deprecation
                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    scope,
                    'optionalAccess',
                    (_12)=>_12.setSpan,
                    'call',
                    (_13)=>_13(parentSpan)
                ]);
                return rv;
            };
        });
    }
}
$cc85be36602e051f$export$b735d011553f1049.__initStatic();


var $duCnO = parcelRequire("duCnO");
var $2EZoq = parcelRequire("2EZoq");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $289ZW = parcelRequire("289ZW");
var $4g0Ct = parcelRequire("4g0Ct");


// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
const $b507c398886020fd$var$OPERATIONS = [
    'aggregate',
    'bulkWrite',
    'countDocuments',
    'createIndex',
    'createIndexes',
    'deleteMany',
    'deleteOne',
    'distinct',
    'drop',
    'dropIndex',
    'dropIndexes',
    'estimatedDocumentCount',
    'find',
    'findOne',
    'findOneAndDelete',
    'findOneAndReplace',
    'findOneAndUpdate',
    'indexes',
    'indexExists',
    'indexInformation',
    'initializeOrderedBulkOp',
    'insertMany',
    'insertOne',
    'isCapped',
    'mapReduce',
    'options',
    'parallelCollectionScan',
    'rename',
    'replaceOne',
    'stats',
    'updateMany',
    'updateOne'
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const $b507c398886020fd$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        'operations'
    ],
    countDocuments: [
        'query'
    ],
    createIndex: [
        'fieldOrSpec'
    ],
    createIndexes: [
        'indexSpecs'
    ],
    deleteMany: [
        'filter'
    ],
    deleteOne: [
        'filter'
    ],
    distinct: [
        'key',
        'query'
    ],
    dropIndex: [
        'indexName'
    ],
    find: [
        'query'
    ],
    findOne: [
        'query'
    ],
    findOneAndDelete: [
        'filter'
    ],
    findOneAndReplace: [
        'filter',
        'replacement'
    ],
    findOneAndUpdate: [
        'filter',
        'update'
    ],
    indexExists: [
        'indexes'
    ],
    insertMany: [
        'docs'
    ],
    insertOne: [
        'doc'
    ],
    mapReduce: [
        'map',
        'reduce'
    ],
    rename: [
        'newName'
    ],
    replaceOne: [
        'filter',
        'doc'
    ],
    updateMany: [
        'filter',
        'update'
    ],
    updateOne: [
        'filter',
        'update'
    ]
};
function $b507c398886020fd$var$isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === 'object' && maybeCursor.once && typeof maybeCursor.once === 'function';
}
/** Tracing integration for mongo package */ class $b507c398886020fd$export$968aa4360b02a334 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Mongo';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $b507c398886020fd$export$968aa4360b02a334.id;
        this._operations = Array.isArray(options.operations) ? options.operations : $b507c398886020fd$var$OPERATIONS;
        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /** @inheritdoc */ loadDependency() {
        const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
        return this._module = this._module || (0, $289ZW.loadModule)(moduleName);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('Mongo Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }
    /**
   * Patches original collection methods
   */ // eslint-disable-next-line deprecation/deprecation
    _instrumentOperations(collection, operations, getCurrentHub) {
        operations.forEach((operation)=>this._patchOperation(collection, operation, getCurrentHub));
    }
    /**
   * Patches original collection to utilize our tracing functionality
   */ // eslint-disable-next-line deprecation/deprecation
    _patchOperation(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $jL8lq.fill)(collection.prototype, operation, function(orig) {
            return function(...args) {
                const lastArg = args[args.length - 1];
                // eslint-disable-next-line deprecation/deprecation
                const hub = getCurrentHub();
                // eslint-disable-next-line deprecation/deprecation
                const scope = hub.getScope();
                // eslint-disable-next-line deprecation/deprecation
                const client = hub.getClient();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                const sendDefaultPii = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    client,
                    'optionalAccess',
                    (_2)=>_2.getOptions,
                    'call',
                    (_3)=>_3(),
                    'access',
                    (_4)=>_4.sendDefaultPii
                ]);
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== 'function' || operation === 'mapReduce' && args.length === 2) {
                    // eslint-disable-next-line deprecation/deprecation
                    const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        parentSpan,
                        'optionalAccess',
                        (_5)=>_5.startChild,
                        'call',
                        (_6)=>_6(getSpanContext(this, operation, args, sendDefaultPii))
                    ]);
                    const maybePromiseOrCursor = orig.call(this, ...args);
                    if ((0, $2zW56.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then((res)=>{
                        (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                            span,
                            'optionalAccess',
                            (_7)=>_7.end,
                            'call',
                            (_8)=>_8()
                        ]);
                        return res;
                    });
                    else if ($b507c398886020fd$var$isCursor(maybePromiseOrCursor)) {
                        const cursor = maybePromiseOrCursor;
                        try {
                            cursor.once('close', ()=>{
                                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                                    span,
                                    'optionalAccess',
                                    (_9)=>_9.end,
                                    'call',
                                    (_10)=>_10()
                                ]);
                            });
                        } catch (e) {
                            // If the cursor is already closed, `once` will throw an error. In that case, we can
                            // finish the span immediately.
                            (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                                span,
                                'optionalAccess',
                                (_11)=>_11.end,
                                'call',
                                (_12)=>_12()
                            ]);
                        }
                        return cursor;
                    } else {
                        (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                            span,
                            'optionalAccess',
                            (_13)=>_13.end,
                            'call',
                            (_14)=>_14()
                        ]);
                        return maybePromiseOrCursor;
                    }
                }
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_15)=>_15.startChild,
                    'call',
                    (_16)=>_16(getSpanContext(this, operation, args.slice(0, -1)))
                ]);
                return orig.call(this, ...args.slice(0, -1), function(err, result) {
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_17)=>_17.end,
                        'call',
                        (_18)=>_18()
                    ]);
                    lastArg(err, result);
                });
            };
        });
    }
    /**
   * Form a SpanContext based on the user input to a given operation.
   */ _getSpanContextFromOperationArguments(collection, operation, args, sendDefaultPii = false) {
        const data = {
            'db.system': 'mongodb',
            'db.name': collection.dbName,
            'db.operation': operation,
            'db.mongodb.collection': collection.collectionName
        };
        const spanContext = {
            op: 'db',
            // TODO v8: Use `${collection.collectionName}.${operation}`
            origin: 'auto.db.mongo',
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        const signature = $b507c398886020fd$var$OPERATION_SIGNATURES[operation];
        const shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe || !sendDefaultPii) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === 'mapReduce') {
                const [map, reduce] = args;
                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
            } else for(let i = 0; i < signature.length; i++)data[`db.mongodb.${signature[i]}`] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    }
}
$b507c398886020fd$export$968aa4360b02a334.__initStatic();


var $jL8lq = parcelRequire("jL8lq");
var $289ZW = parcelRequire("289ZW");
var $4g0Ct = parcelRequire("4g0Ct");


/** Tracing integration for node-mysql package */ class $f7ee3fbca33c38de$export$a2cc26ff91a3f8ad {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Mysql';
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $f7ee3fbca33c38de$export$a2cc26ff91a3f8ad.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $289ZW.loadModule)('mysql/lib/Connection.js');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('Mysql Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('Mysql Integration was unable to require `mysql` package.');
            return;
        }
        let mySqlConfig = undefined;
        try {
            pkg.prototype.connect = new Proxy(pkg.prototype.connect, {
                apply (wrappingTarget, thisArg, args) {
                    if (!mySqlConfig) mySqlConfig = thisArg.config;
                    return wrappingTarget.apply(thisArg, args);
                }
            });
        } catch (e) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('Mysql Integration was unable to instrument `mysql` config.');
        }
        function spanDataFromConfig() {
            if (!mySqlConfig) return {};
            return {
                'server.address': mySqlConfig.host,
                'server.port': mySqlConfig.port,
                'db.user': mySqlConfig.user
            };
        }
        function finishSpan(span) {
            if (!span) return;
            const data = spanDataFromConfig();
            Object.keys(data).forEach((key)=>{
                span.setAttribute(key, data[key]);
            });
            span.end();
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $jL8lq.fill)(pkg, 'createQuery', function(orig) {
            return function(options, values, callback) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: typeof options === 'string' ? options : options.sql,
                            op: 'db',
                            origin: 'auto.db.mysql',
                            data: {
                                'db.system': 'mysql'
                            }
                        })
                ]);
                if (typeof callback === 'function') return orig.call(this, options, values, function(err, result, fields) {
                    finishSpan(span);
                    callback(err, result, fields);
                });
                if (typeof values === 'function') return orig.call(this, options, function(err, result, fields) {
                    finishSpan(span);
                    values(err, result, fields);
                });
                // streaming, no callback!
                const query = orig.call(this, options, values);
                query.on('end', ()=>{
                    finishSpan(span);
                });
                return query;
            };
        });
    }
}
$f7ee3fbca33c38de$export$a2cc26ff91a3f8ad.__initStatic();


var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $289ZW = parcelRequire("289ZW");
var $4g0Ct = parcelRequire("4g0Ct");


/** Tracing integration for node-postgres package */ class $3497dd2fc8e02eea$export$806ddb599177abc4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Postgres';
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $3497dd2fc8e02eea$export$806ddb599177abc4.id;
        this._usePgNative = !!options.usePgNative;
        this._module = options.module;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $289ZW.loadModule)('pg');
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)(getCurrentHub)) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).log('Postgres Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error('Postgres Integration was unable to require `pg` package.');
            return;
        }
        const Client = this._usePgNative ? (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
            pkg,
            'access',
            (_2)=>_2.native,
            'optionalAccess',
            (_3)=>_3.Client
        ]) : pkg.Client;
        if (!Client) {
            (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, $jL8lq.fill)(Client.prototype, 'query', function(orig) {
            return function(config, values, callback) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                const data = {
                    'db.system': 'postgresql'
                };
                try {
                    if (this.database) data['db.name'] = this.database;
                    if (this.host) data['server.address'] = this.host;
                    if (this.port) data['server.port'] = this.port;
                    if (this.user) data['db.user'] = this.user;
                } catch (e) {
                // ignore
                }
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    parentSpan,
                    'optionalAccess',
                    (_4)=>_4.startChild,
                    'call',
                    (_5)=>_5({
                            description: typeof config === 'string' ? config : config.text,
                            op: 'db',
                            origin: 'auto.db.postgres',
                            data: data
                        })
                ]);
                if (typeof callback === 'function') return orig.call(this, config, values, function(err, result) {
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_6)=>_6.end,
                        'call',
                        (_7)=>_7()
                    ]);
                    callback(err, result);
                });
                if (typeof values === 'function') return orig.call(this, config, function(err, result) {
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.end,
                        'call',
                        (_9)=>_9()
                    ]);
                    values(err, result);
                });
                const rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, $2zW56.isThenable)(rv)) return rv.then((res)=>{
                    (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                        span,
                        'optionalAccess',
                        (_10)=>_10.end,
                        'call',
                        (_11)=>_11()
                    ]);
                    return res;
                });
                (0, $ba7e9f49429c2354$export$3cc482e6b02f32f7)([
                    span,
                    'optionalAccess',
                    (_12)=>_12.end,
                    'call',
                    (_13)=>_13()
                ]);
                return rv;
            };
        });
    }
}
$3497dd2fc8e02eea$export$806ddb599177abc4.__initStatic();


var $cmFjP = parcelRequire("cmFjP");
var $h5OHf = parcelRequire("h5OHf");
var $fJmes = parcelRequire("fJmes");

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");


function $55d28c9b57eb05c8$var$isValidPrismaClient(possibleClient) {
    return !!possibleClient && !!possibleClient['$use'];
}
/** Tracing integration for @prisma/client package */ class $55d28c9b57eb05c8$export$e300e6f4779d55c2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Prisma';
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $55d28c9b57eb05c8$export$e300e6f4779d55c2.id;
        // We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
        // bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
        // in setupOnce we can only ever instrument one client.
        // https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
        // In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.
        if ($55d28c9b57eb05c8$var$isValidPrismaClient(options.client) && !options.client._sentryInstrumented) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $jL8lq.addNonEnumerableProperty)(options.client, '_sentryInstrumented', true);
            const clientData = {};
            try {
                const engineConfig = options.client._engineConfig;
                if (engineConfig) {
                    const { activeProvider: activeProvider, clientVersion: clientVersion } = engineConfig;
                    if (activeProvider) clientData['db.system'] = activeProvider;
                    if (clientVersion) clientData['db.prisma.version'] = clientVersion;
                }
            } catch (e) {
            // ignore
            }
            options.client.$use((params, next)=>{
                // eslint-disable-next-line deprecation/deprecation
                if ((0, $a9d137194c535c9f$export$34db76d03eb96b7e)((0, $cmFjP.getCurrentHub))) return next(params);
                const action = params.action;
                const model = params.model;
                return (0, $fJmes.startSpan)({
                    name: model ? `${model} ${action}` : action,
                    onlyIfParent: true,
                    op: 'db.prisma',
                    attributes: {
                        [(0, $h5OHf.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.db.prisma'
                    },
                    data: {
                        ...clientData,
                        'db.operation': action
                    }
                }, ()=>next(params));
            });
        } else (0, $a5e85a0c259bdb77$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn('Unsupported Prisma client provided to PrismaIntegration. Provided client:', options.client);
    }
    /**
   * @inheritDoc
   */ setupOnce() {
    // Noop - here for backwards compatibility
    }
}
$55d28c9b57eb05c8$export$e300e6f4779d55c2.__initStatic();


var $cKEJC = parcelRequire("cKEJC");
var $9pnio = parcelRequire("9pnio");
var $gu0hs = parcelRequire("gu0hs");
var $65HJt = parcelRequire("65HJt");
var $6Tqu0 = parcelRequire("6Tqu0");
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ // eslint-disable-next-line deprecation/deprecation
const $2c54dac91da760a9$export$46d3bbd0375f5fa4 = (0, $1a684ef8a4a48899$export$46d3bbd0375f5fa4);
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ // eslint-disable-next-line deprecation/deprecation
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $2c54dac91da760a9$export$5a20b45239a3c0a6 = (0, $3NuqQ.addExtensionMethods);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `getActiveTransaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $2c54dac91da760a9$export$a7feb32fdd923295 = (0, $5UTPE.getActiveTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `extractTraceparentData` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $2c54dac91da760a9$export$8e9a29865c0a1226 = (0, $5UTPE.extractTraceparentData);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `spanStatusfromHttpCode` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ // eslint-disable-next-line deprecation/deprecation
const $2c54dac91da760a9$export$ac65c70d78fcdb55 = (0, $9pnio.spanStatusfromHttpCode);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `SpanStatusType` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $2c54dac91da760a9$export$febc5573c75cefb0 = (0, $6Tqu0.Transaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $2c54dac91da760a9$export$5f1714a13ed34c01 = (0, $cKEJC.Span);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $2c54dac91da760a9$export$bbd2089f30bd3708 = (0, $1a684ef8a4a48899$export$bbd2089f30bd3708);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `defaultRequestInstrumentationOptions` can be imported from `@sentry/browser`, or your framework SDK
 */ const $2c54dac91da760a9$export$cc17fb3c0bc95cd7 = (0, $e425abf0f1e5a10f$export$cc17fb3c0bc95cd7);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `hasTracingEnabled` can be imported from `@sentry/utils`
 */ const $2c54dac91da760a9$export$5008da00b1b6dee6 = (0, $duCnO.hasTracingEnabled);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `stripUrlQueryAndFragment` can be imported from `@sentry/utils`
 */ const $2c54dac91da760a9$export$ce084c78234bd35 = (0, $25257edadcf16f49$export$ce084c78234bd35);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `TRACEPARENT_REGEXP` can be imported from `@sentry/utils`
 */ const $2c54dac91da760a9$export$394a210812ba3012 = (0, $65HJt.TRACEPARENT_REGEXP);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $2c54dac91da760a9$export$b279e6bd7040371f = (0, $2EZoq.IdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $2c54dac91da760a9$export$864489cb3478db3e = (0, $e425abf0f1e5a10f$export$864489cb3478db3e);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $2c54dac91da760a9$export$479dbd817e392a4f = (0, $gu0hs.startIdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $2c54dac91da760a9$export$beb8e6a823e89c5d = (0, $9pnio.SpanStatus);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $2c54dac91da760a9$export$99d02219d259eb94 = {
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
   *
   * import { BrowserTracing } from '@sentry/browser';
   * new BrowserTracing()
   */ // eslint-disable-next-line deprecation/deprecation
    BrowserTracing: $2c54dac91da760a9$export$46d3bbd0375f5fa4,
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Apollo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Apollo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Apollo: (0, $72d6e24f36ba74e2$export$3db3e396472fda8d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Express` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Express({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Express: (0, $04470ea8dc00f88f$export$6dafdd8fec05099d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `GraphQL` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.GraphQL({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    GraphQL: (0, $cc85be36602e051f$export$b735d011553f1049),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mongo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mongo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mongo: (0, $b507c398886020fd$export$968aa4360b02a334),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mysql` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mysql({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mysql: (0, $f7ee3fbca33c38de$export$a2cc26ff91a3f8ad),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Postgres` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Postgres({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Postgres: (0, $3497dd2fc8e02eea$export$806ddb599177abc4),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Prisma` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Prisma({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Prisma: (0, $55d28c9b57eb05c8$export$e300e6f4779d55c2)
};
// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $3NuqQ.addExtensionMethods)();


const $d457a61013135fd1$export$1f7656c617418e15 = (environment)=>{
    // TODO(cvu): add sentry to router when useRoute is supported: https://github.com/getsentry/sentry-javascript/pull/5624
    (0, $795a7664e1a3c052$export$2cd8252107eb640b)({
        dsn: "https://e9cc13fb4bcd4bd9b55f06a7898f7159@o160250.ingest.sentry.io/6707190",
        integrations: [
            new (0, $2c54dac91da760a9$export$46d3bbd0375f5fa4)()
        ],
        attachStacktrace: true,
        environment: environment
    });
};


const $673ff3dfc4a496de$var$isString = (obj)=>typeof obj === 'string';
const $673ff3dfc4a496de$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $673ff3dfc4a496de$var$makeString = (object)=>{
    if (object == null) return '';
    return String(object);
};
const $673ff3dfc4a496de$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $673ff3dfc4a496de$var$lastOfPathSeparatorRegExp = /###/g;
const $673ff3dfc4a496de$var$cleanKey = (key)=>key && key.includes('###') ? key.replace($673ff3dfc4a496de$var$lastOfPathSeparatorRegExp, '.') : key;
const $673ff3dfc4a496de$var$canNotTraverseDeeper = (object)=>!object || $673ff3dfc4a496de$var$isString(object);
const $673ff3dfc4a496de$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$673ff3dfc4a496de$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
        const key = $673ff3dfc4a496de$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $673ff3dfc4a496de$var$cleanKey(stack[stackIndex])
    };
};
const $673ff3dfc4a496de$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $673ff3dfc4a496de$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $673ff3dfc4a496de$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $673ff3dfc4a496de$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
};
const $673ff3dfc4a496de$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (Object.prototype.hasOwnProperty.call(target, prop)) {
            if ($673ff3dfc4a496de$var$isString(target[prop]) || target[prop] instanceof String || $673ff3dfc4a496de$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $673ff3dfc4a496de$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
const $673ff3dfc4a496de$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $673ff3dfc4a496de$var$escape = (data)=>{
    if ($673ff3dfc4a496de$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
};
class $673ff3dfc4a496de$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $673ff3dfc4a496de$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache = new $673ff3dfc4a496de$var$RegExpCache(20);
const $673ff3dfc4a496de$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>!nsSeparator.includes(c) && !keySeparator.includes(c));
    if (possibleChars.length === 0) return true;
    const r = $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $673ff3dfc4a496de$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].includes(typeof next) && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $673ff3dfc4a496de$var$getCleanedCode = (code)=>code?.replace(/_/g, '-');
const $673ff3dfc4a496de$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        args = args.map((a)=>$673ff3dfc4a496de$var$isString(a) ? a.replace(/[\r\n\x00-\x1F\x7F]/g, ' ') : a);
        if ($673ff3dfc4a496de$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    once(event, listener) {
        const wrapper = (...args)=>{
            listener(...args);
            this.off(event, wrapper);
        };
        this.on(event, wrapper);
        return this;
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(event, ...args);
            });
        }
    }
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (!this.options.ns.includes(ns)) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.includes('.')) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($673ff3dfc4a496de$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.includes('.')) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$673ff3dfc4a496de$var$isString(key)) return result;
        return $673ff3dfc4a496de$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.includes('.')) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($673ff3dfc4a496de$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.includes('.')) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $673ff3dfc4a496de$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $673ff3dfc4a496de$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$673ff3dfc4a496de$var$PATH_KEY]: path } = selector($673ff3dfc4a496de$var$createProxy());
    const keySeparator = opts?.keySeparator ?? '.';
    const nsSeparator = opts?.nsSeparator ?? ':';
    const strict = opts?.enableSelector === 'strict';
    if (path.length > 1 && nsSeparator) {
        const ns = opts?.ns;
        const nsList = strict ? Array.isArray(ns) ? ns : ns ? [
            ns
        ] : null : Array.isArray(ns) ? ns : null;
        if (nsList) {
            const candidates = strict ? nsList : nsList.length > 1 ? nsList.slice(1) : [];
            if (candidates.includes(path[0])) return `${path[0]}${nsSeparator}${path.slice(1).join(keySeparator)}`;
        }
    }
    return path.join(keySeparator);
}
const $673ff3dfc4a496de$var$shouldHandleAsObject = (res)=>!$673ff3dfc4a496de$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $673ff3dfc4a496de$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('translator');
        this.checkedLoadedFor = {};
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.includes(nsSeparator);
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.includes(parts[0])) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        keys = keys.map((k)=>typeof k === 'function' ? $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : String(k));
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
        const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $673ff3dfc4a496de$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && !noObject.includes(resType) && !($673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $673ff3dfc4a496de$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, needsPluralHandling && !updateMissing ? `${key}${this.pluralResolver.getSuffix(lng, opt.count, opt)}` : key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && !suffixes.includes(`${this.options.pluralSeparator}zero`)) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $673ff3dfc4a496de$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$673ff3dfc4a496de$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $673ff3dfc4a496de$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($673ff3dfc4a496de$var$isString(keys)) keys = [
            keys
        ];
        if (Array.isArray(keys)) keys = keys.map((k)=>typeof k === 'function' ? $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, {
                ...this.options,
                ...opt
            }) : k);
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$673ff3dfc4a496de$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($673ff3dfc4a496de$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!this.checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    this.checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.startsWith(ordinalPrefix)) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$673ff3dfc4a496de$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data = {
            ...data,
            count: options.count
        };
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && option.startsWith(prefix) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || !code.includes('-')) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($673ff3dfc4a496de$var$isString(code) && code.includes('-')) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.includes(code);
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return true;
                if (!supportedLng.includes('-') && !lngOnly.includes('-')) return false;
                if (supportedLng.includes('-') && !lngOnly.includes('-') && supportedLng.slice(0, supportedLng.indexOf('-')) === lngOnly) return true;
                if (supportedLng.startsWith(lngOnly) && lngOnly.length > 1) return true;
                return false;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($673ff3dfc4a496de$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($673ff3dfc4a496de$var$isString(code) && (code.includes('-') || code.includes('_'))) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($673ff3dfc4a496de$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (!codes.includes(fc)) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $673ff3dfc4a496de$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $673ff3dfc4a496de$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $673ff3dfc4a496de$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $673ff3dfc4a496de$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $673ff3dfc4a496de$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $673ff3dfc4a496de$var$isString(key)) {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $673ff3dfc4a496de$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $673ff3dfc4a496de$var$Interpolator {
    constructor(options = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $673ff3dfc4a496de$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $673ff3dfc4a496de$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $673ff3dfc4a496de$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix ? $673ff3dfc4a496de$var$regexEscape(unescapePrefix) : '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix ? $673ff3dfc4a496de$var$regexEscape(unescapeSuffix) : '';
        this.nestingPrefix = nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (!key.includes(this.formatSeparator)) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        if (!this.escapeValue && typeof str === 'string' && /\$t\([^)]*\{[^}]*\{\{/.test(str)) this.logger.warn("nesting options string contains interpolated variables with escapeValue: false \u2014 if any of those values are attacker-controlled they can inject additional nesting options (e.g. redirect lng/ns). Sanitise untrusted input before passing it to t(), or keep escapeValue: true.");
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>val
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? this.escape(val) : val
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $673ff3dfc4a496de$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$673ff3dfc4a496de$var$isString(value) && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], $673ff3dfc4a496de$var$regexSafe(safeValue));
                if (skipOnVariables) {
                    todo.regex.lastIndex += safeValue.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (!key.includes(sep)) return key;
            const c = key.split(new RegExp(`${$673ff3dfc4a496de$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.includes(this.prefix)) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$673ff3dfc4a496de$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/s.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$673ff3dfc4a496de$var$isString(value)) return value;
            if (!$673ff3dfc4a496de$var$isString(value)) value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $673ff3dfc4a496de$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.includes('(')) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].slice(0, -1);
        if (formatName === 'currency' && !optStr.includes(':')) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && !optStr.includes(':')) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $673ff3dfc4a496de$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($673ff3dfc4a496de$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $673ff3dfc4a496de$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($673ff3dfc4a496de$var$getCleanedCode(l), o)(v);
class $673ff3dfc4a496de$var$Formatter {
    constructor(options = {}){
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $673ff3dfc4a496de$var$createCachedFormatter : $673ff3dfc4a496de$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        if (!format) return value;
        if (value == null) return value;
        const rawFormats = format.split(this.formatSeparator);
        const formats = [];
        for(let i = 0; i < rawFormats.length; i++){
            let f = rawFormats[i];
            while(f.indexOf('(') > -1 && !f.includes(')') && i + 1 < rawFormats.length)f = `${f}${this.formatSeparator}${rawFormats[++i]}`;
            formats.push(f);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $673ff3dfc4a496de$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read(lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($673ff3dfc4a496de$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($673ff3dfc4a496de$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $673ff3dfc4a496de$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        enableSelector: false,
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($673ff3dfc4a496de$var$isString(args[1])) ret.defaultValue = args[1];
            if ($673ff3dfc4a496de$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $673ff3dfc4a496de$var$transformOptions = (options)=>{
    if ($673ff3dfc4a496de$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && !options.supportedLngs.includes('cimode')) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $673ff3dfc4a496de$var$noop = ()=>{};
const $673ff3dfc4a496de$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($673ff3dfc4a496de$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (!options.ns.includes('translation')) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator
            });
            if (formatter) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if ((this.languages || this.isLanguageChangingTo) && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $673ff3dfc4a496de$var$noop) {
        let usedCallback = callback;
        const usedLng = $673ff3dfc4a496de$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (!toLoad.includes(l)) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].includes(l)) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].includes(lngInLngs)) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && !this.languages.includes(l) && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $673ff3dfc4a496de$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($673ff3dfc4a496de$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix, fixedOpts) {
        const scopeNs = fixedOpts?.scopeNs;
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            const explicitCallNs = o.ns !== undefined && o.ns !== null;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const selectorOpts = {
                ...this.options,
                ...o
            };
            if (Array.isArray(scopeNs) && !explicitCallNs) selectorOpts.ns = scopeNs;
            if (typeof o.keyPrefix === 'function') o.keyPrefix = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(o.keyPrefix, selectorOpts);
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(k, selectorOpts);
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $673ff3dfc4a496de$export$ec2cccc18ab4c2ae(key, selectorOpts);
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($673ff3dfc4a496de$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($673ff3dfc4a496de$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (!this.options.ns.includes(n)) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if ($673ff3dfc4a496de$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>!preloaded.includes(lng) && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.includes(languageUtils.getLanguagePartFromCode(lng)) || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $673ff3dfc4a496de$var$I18n(options, callback);
        instance.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $673ff3dfc4a496de$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $673ff3dfc4a496de$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $673ff3dfc4a496de$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

// inlined from the former `void-elements` dependency, so the package has
// zero runtime dependencies. `!doctype`/`!DOCTYPE` are treated as void so a
// doctype parses as a childless node instead of swallowing the document.
const $e481e183a1d88720$var$voidElements = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    '!doctype': true,
    '!DOCTYPE': true
};
const $e481e183a1d88720$var$attrRE = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $e481e183a1d88720$var$parseTag(tag) {
    const res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };
    const tagMatch = tag.match(/<\/?([^\s]+?)[/\s>]/);
    if (tagMatch) {
        res.name = tagMatch[1];
        // void-element lookup stays case sensitive on purpose: react-i18next
        // relies on `<Br>` NOT being treated as a void `<br>` (see 1df0f9d)
        if ($e481e183a1d88720$var$voidElements[tagMatch[1]] || tag.charAt(tag.length - 2) === '/') res.voidElement = true;
        // handle comment tag
        if (res.name.startsWith('!--')) {
            const endIndex = tag.indexOf('-->');
            return {
                type: 'comment',
                comment: endIndex !== -1 ? tag.slice(4, endIndex) : ''
            };
        }
    }
    const reg = new RegExp($e481e183a1d88720$var$attrRE);
    let result = null;
    for(;;){
        result = reg.exec(tag);
        if (result === null) break;
        if (!result[0].trim()) continue;
        if (result[1]) {
            const attr = result[1].trim();
            // boolean attributes carry `null` so stringify can render them bare
            // (`<input disabled/>` instead of `<input disabled=""/>`)
            let arr = [
                attr,
                null
            ];
            const eq = attr.indexOf('=');
            if (eq > -1) // split at the first `=` only, so `data-x=a=b` keeps its full value
            arr = [
                attr.slice(0, eq),
                attr.slice(eq + 1)
            ];
            res.attrs[arr[0]] = arr[1];
            reg.lastIndex--;
        } else if (result[2]) res.attrs[result[2]] = result[3].trim().substring(1, result[3].length - 1);
    }
    return res;
}
// comments are matched as a whole (so `>` inside them is fine), everything
// else tag-shaped is matched by the second alternative
const $e481e183a1d88720$var$tagRE = /<!--[\s\S]*?-->|<[a-zA-Z0-9\-!/](?:"[^"]*"|'[^']*'|[^'">])*>/g;
const $e481e183a1d88720$var$tagNameRE = /<\/?([^\s]+?)[/\s>]/;
const $e481e183a1d88720$var$whitespaceRE = /^\s*$/;
// tags whose content is raw text: nothing inside them is markup
const $e481e183a1d88720$var$rawTextRE = /^(script|style)$/i;
// placeholder for `<` of tags rejected by options.allowedTags; restored to a
// literal `<` in text/attr/comment content after parsing (U+0000 cannot appear
// in sane input, and a collision would merely render as an extra `<`)
const $e481e183a1d88720$var$sentinel = '\u0000';
// re-used obj for quick lookups of components
const $e481e183a1d88720$var$empty = Object.create(null);
function $e481e183a1d88720$var$restoreSentinels(nodes) {
    nodes.forEach(function(node) {
        if (node.type === 'text') {
            node.content = node.content.split($e481e183a1d88720$var$sentinel).join('<');
            return;
        }
        if (node.type === 'comment') {
            node.comment = node.comment.split($e481e183a1d88720$var$sentinel).join('<');
            return;
        }
        for(const key in node.attrs){
            const value = node.attrs[key];
            if (typeof value === 'string' && value.indexOf($e481e183a1d88720$var$sentinel) > -1) node.attrs[key] = value.split($e481e183a1d88720$var$sentinel).join('<');
        }
        if (node.children.length) $e481e183a1d88720$var$restoreSentinels(node.children);
    });
}
function $e481e183a1d88720$export$98e6a39c04603d36(html, options) {
    const components = options && options.components || $e481e183a1d88720$var$empty;
    const allowedTags = options && options.allowedTags;
    let restoreNeeded = false;
    if (allowedTags) {
        const isAllowed = typeof allowedTags === 'function' ? allowedTags : function(name) {
            return allowedTags.indexOf(name) > -1;
        };
        // neutralize tags whose name is not allowed, so they parse as text.
        // on a disallowed match only the leading `<` is escaped and scanning
        // resumes right after it, so a valid tag glued into the same match
        // (e.g. `<bold>` inside `<10, <20, and <bold>`) still gets recognized
        let out = '';
        let pos = 0;
        $e481e183a1d88720$var$tagRE.lastIndex = 0;
        let am;
        while(am = $e481e183a1d88720$var$tagRE.exec(html)){
            const tag = am[0];
            out += html.slice(pos, am.index);
            const nameMatch = tag.match($e481e183a1d88720$var$tagNameRE);
            if (tag.startsWith('<!--') || nameMatch && isAllowed(nameMatch[1])) {
                out += tag;
                pos = am.index + tag.length;
            } else {
                restoreNeeded = true;
                out += $e481e183a1d88720$var$sentinel;
                pos = am.index + 1;
                $e481e183a1d88720$var$tagRE.lastIndex = pos;
            }
        }
        html = out + html.slice(pos);
    }
    const result = [];
    const arr = [];
    let current;
    let level = -1;
    let inComponent = false;
    // while parsing raw-text content (script/style), tag-looking matches
    // before this index belong to the content and must be skipped
    let rawUntil = 0;
    // lazily created lowercase copy for case-insensitive raw-text close-tag search
    let htmlLower;
    // handle text at top level
    if (html.indexOf('<') !== 0) {
        const end = html.indexOf('<');
        result.push({
            type: 'text',
            content: end === -1 ? html : html.substring(0, end)
        });
    }
    // collect matches with an exec loop instead of matchAll to keep ES5 API compat
    const matches = [];
    let m;
    while(m = $e481e183a1d88720$var$tagRE.exec(html))matches.push(m);
    matches.forEach(function(match, i) {
        const tag = match[0];
        if (!tag) return;
        // comments match as a whole; their content must not trigger the
        // mismatched-bracket split below
        if (tag.startsWith('<!--')) return;
        // count brackets outside quoted attribute values, so `<` inside an
        // attribute (e.g. title="1 < 2") can't trigger a bogus split
        let lts = 0;
        let gts = 0;
        let secondLt = -1;
        let quote = null;
        for(let j = 0; j < tag.length; j++){
            const c = tag.charAt(j);
            if (quote) {
                if (c === quote) quote = null;
            } else if (c === '"' || c === "'") quote = c;
            else if (c === '<') {
                lts++;
                if (lts === 2) secondLt = j;
            } else if (c === '>') gts++;
        }
        // only split when the remainder is itself a valid tag start; otherwise
        // a fragment like `< <!-->` desyncs the string-level isComment check
        // from parseTag's name-based comment detection and crashes the walker
        const validSplit = secondLt > -1 && /[a-zA-Z0-9\-!/]/.test(tag.charAt(secondLt + 1));
        if (lts > gts && validSplit) {
            const firstPart = tag.substring(0, secondLt);
            const secondPart = tag.substring(firstPart.length);
            matches[i][0] = secondPart;
            matches[i].index += firstPart.length;
        }
    });
    matches.forEach(function(match, i) {
        const tag = match[0];
        if (!tag) return;
        const index = match.index;
        if (index < rawUntil) return;
        if (inComponent) {
            if (tag !== '</' + current.name + '>') return;
            else inComponent = false;
        }
        const isOpen = tag.charAt(1) !== '/';
        const isComment = tag.startsWith('<!--');
        const start = index + tag.length;
        const nextChar = html.charAt(start);
        const nextMatch = matches[i + 1];
        let isText;
        if (nextChar === '<' && nextMatch) {
            const nextTag = html.substring(start, nextMatch.index);
            isText = nextTag.split('<').length > nextTag.split('>').length;
        }
        let parent;
        if (isComment) {
            const comment = $e481e183a1d88720$var$parseTag(tag);
            // if we're at root, push new base node
            if (level < 0) {
                result.push(comment);
                return result;
            }
            parent = arr[level];
            parent.children.push(comment);
            const text = html.slice(start, nextMatch ? nextMatch.index : undefined);
            if (text.length > 0) parent.children.push({
                type: 'text',
                content: text
            });
            return result;
        }
        if (isOpen) {
            level++;
            current = $e481e183a1d88720$var$parseTag(tag);
            if (current.type === 'tag' && components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }
            let isRawText = false;
            if (!inComponent && !current.voidElement && $e481e183a1d88720$var$rawTextRE.test(current.name)) {
                // raw-text element: everything up to the matching close tag is one
                // text child, regardless of what it looks like
                isRawText = true;
                htmlLower || (htmlLower = html.toLowerCase());
                const closeIndex = htmlLower.indexOf('</' + current.name.toLowerCase() + '>', start);
                const contentEnd = closeIndex === -1 ? html.length : closeIndex;
                const content = html.slice(start, contentEnd);
                if (content) current.children.push({
                    type: 'text',
                    content: content
                });
                rawUntil = contentEnd;
            }
            if (!current.voidElement && !inComponent && !isRawText && nextChar && nextChar !== '<') // text content runs to the next actual tag match; stray `<`
            // characters in between are part of the text
            current.children.push({
                type: 'text',
                content: html.slice(start, nextMatch ? nextMatch.index : undefined)
            });
            // if we're at root, push new base node
            if (level === 0) result.push(current);
            parent = arr[level - 1];
            if (parent) parent.children.push(current);
            arr[level] = current;
        }
        if (!isOpen || current.voidElement) {
            if (level > -1 && (current.voidElement || current.name === tag.slice(2, -1))) {
                level--;
                // move current up a level to match the end tag
                current = level === -1 ? result : arr[level];
            }
            if (!inComponent && (nextChar !== '<' || isText) && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                // the text node runs to the next actual tag match; -1 means
                // there's no tag after it (trailing text)
                const end = nextMatch ? nextMatch.index : -1;
                let content = html.slice(start, end === -1 ? undefined : end);
                // if a node is nothing but whitespace, collapse it as the spec states:
                // https://www.w3.org/TR/html4/struct/text.html#h-9.1
                if ($e481e183a1d88720$var$whitespaceRE.test(content)) content = ' ';
                // don't add whitespace-only text nodes if they would be trailing text nodes
                // or if they would be leading whitespace-only text nodes:
                //  * end > -1 indicates this is not a trailing text node
                //  * leading node is when level is -1 and parent has length 0
                if (end > -1 && level + parent.length >= 0 || content !== ' ') parent.push({
                    type: 'text',
                    content: content
                });
            }
        }
    });
    if (restoreNeeded) $e481e183a1d88720$var$restoreSentinels(result);
    return result;
}
function $e481e183a1d88720$var$attrString(attrs) {
    const buff = [];
    for(const key in attrs)if (attrs[key] === null) // boolean attribute, render bare
    buff.push(key);
    else // escape double quotes so values parsed from single-quoted or
    // multiline attributes can't break out of the generated markup
    buff.push(key + '="' + String(attrs[key]).replace(/"/g, '&quot;') + '"');
    if (!buff.length) return '';
    return ' ' + buff.join(' ');
}
function $e481e183a1d88720$var$stringifyNode(buff, doc) {
    switch(doc.type){
        case 'text':
            return buff + doc.content;
        case 'tag':
            {
                // a doctype is void but must not self-close: `<!DOCTYPE html>` not `<!DOCTYPE html/>`
                const tagEnd = doc.voidElement && doc.name.toLowerCase() !== '!doctype' ? '/>' : '>';
                buff += '<' + doc.name + (doc.attrs ? $e481e183a1d88720$var$attrString(doc.attrs) : '') + tagEnd;
                if (doc.voidElement) return buff;
                return buff + doc.children.reduce($e481e183a1d88720$var$stringifyNode, '') + '</' + doc.name + '>';
            }
        case 'comment':
            buff += '<!--' + doc.comment + '-->';
            return buff;
    }
}
function $e481e183a1d88720$export$fac44ee5b035f737(doc) {
    return doc.reduce(function(token, rootEl) {
        return token + $e481e183a1d88720$var$stringifyNode('', rootEl);
    }, '');
}
var $e481e183a1d88720$export$2e2bcd8739ae039 = {
    parse: $e481e183a1d88720$export$98e6a39c04603d36,
    stringify: $e481e183a1d88720$export$fac44ee5b035f737
};


const $cfb6e0167e0b350d$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $cfb6e0167e0b350d$var$alreadyWarned = {};
const $cfb6e0167e0b350d$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg) && $cfb6e0167e0b350d$var$alreadyWarned[msg]) return;
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(msg)) $cfb6e0167e0b350d$var$alreadyWarned[msg] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $cfb6e0167e0b350d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $cfb6e0167e0b350d$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($cfb6e0167e0b350d$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
};
const $cfb6e0167e0b350d$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $cfb6e0167e0b350d$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($cfb6e0167e0b350d$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $cfb6e0167e0b350d$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $cfb6e0167e0b350d$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d7f2d92b0368699f$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $d7f2d92b0368699f$var$unescapeHtmlEntity = (m)=>$d7f2d92b0368699f$var$htmlEntities[m];
const $d7f2d92b0368699f$export$e8bacd2802a88316 = (text)=>text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);


let $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $d7f2d92b0368699f$export$e8bacd2802a88316,
    transDefaultProps: undefined
};
const $4f75eea5b29ffc65$export$2e2366488d12e20d = (options = {})=>{
    $4f75eea5b29ffc65$var$defaultOptions = {
        ...$4f75eea5b29ffc65$var$defaultOptions,
        ...options
    };
};
const $4f75eea5b29ffc65$export$212bb2fc580a90a8 = ()=>$4f75eea5b29ffc65$var$defaultOptions;


let $1d04edb3ddd0d89e$var$i18nInstance;
const $1d04edb3ddd0d89e$export$a039134f2fc7e0 = (instance)=>{
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
};
const $1d04edb3ddd0d89e$export$64af334f494c2f47 = ()=>$1d04edb3ddd0d89e$var$i18nInstance;



const $acffcb171536f8e9$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $acffcb171536f8e9$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $acffcb171536f8e9$var$getAsArray(children) : children;
};
const $acffcb171536f8e9$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $acw62.isValidElement));
const $acffcb171536f8e9$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $acffcb171536f8e9$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = {
        ...target.props,
        ...source.props
    };
    return newTarget;
};
const $acffcb171536f8e9$var$getValuesFromChildren = (children)=>{
    const values = {};
    if (!children) return values;
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
const $acffcb171536f8e9$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $acw62.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount <= 1) {
                const cnt = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(childChildren) ? childChildren : $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
                stringNode += `<${type}>${cnt}</${type}>`;
                return;
            }
            const content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $acffcb171536f8e9$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const knownNames = Object.keys(data);
    const allowedTags = (name)=>/^\d+$/.test(name) || keepArray.indexOf(name) > -1 || knownNames.indexOf(name) > -1;
    const ast = (0, $e481e183a1d88720$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`, {
        allowedTags: allowedTags
    });
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $acffcb171536f8e9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $acw62.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $acw62.Children).map([
            child
        ], (c)=>{
            if (c.type === (0, $acw62.Fragment) || c.props?.i18nIsDynamicList !== undefined) {
                const freshProps = {
                    key: i
                };
                if (c && c.props) Object.keys(c.props).forEach((k)=>{
                    if (k === 'children' || k === 'i18nIsDynamicList') return;
                    freshProps[k] = c.props[k];
                });
                return (0, $acw62.createElement)(c.type, freshProps, isVoid ? null : inner);
            }
            const override = {
                key: i
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children') return;
                override[k] = c.props[k];
            });
            return (0, $acw62.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        const astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        const keepTagOccurrence = {};
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const props = {
                    ...node.attrs
                };
                if (shouldUnescape) Object.keys(props).forEach((p)=>{
                    const val = props[p];
                    if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(val)) props[p] = (0, $d7f2d92b0368699f$export$e8bacd2802a88316)(val);
                });
                const child = Object.keys(props).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                const isElement = (0, $acw62.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const occurrence = keepTagOccurrence[node.name] || 0;
                            keepTagOccurrence[node.name] = occurrence + 1;
                            let matched;
                            let seen = 0;
                            for(let r = 0; r < reactNodes.length; r += 1){
                                const rn = reactNodes[r];
                                if ((0, $acw62.isValidElement)(rn) && rn.type === node.name) {
                                    if (seen === occurrence) {
                                        matched = rn;
                                        break;
                                    }
                                    seen += 1;
                                }
                            }
                            const innerScope = matched ? $acffcb171536f8e9$var$getAsArray($acffcb171536f8e9$var$getChildren(matched)) : reactNodes;
                            const inner = mapAST(innerScope, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)().unescape;
                const content = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
};
const $acffcb171536f8e9$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $acw62.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $acw62.createElement)((0, $acw62.Fragment), null, comp);
    }
    return (0, $acw62.createElement)(Componentized, {
        key: componentKey
    });
};
const $acffcb171536f8e9$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$acffcb171536f8e9$var$fixComponentProps(c, index, translation));
const $acffcb171536f8e9$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $acffcb171536f8e9$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $acffcb171536f8e9$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $acffcb171536f8e9$var$generateArrayComponents(components, translation);
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(components)) return $acffcb171536f8e9$var$generateObjectComponents(components, translation);
    (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $acffcb171536f8e9$var$isComponentsMap = (object)=>{
    if (!(0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const { transDefaultProps: transDefaultProps } = reactI18nextOptions;
    const mergedTOptions = transDefaultProps?.tOptions ? {
        ...transDefaultProps.tOptions,
        ...tOptions
    } : tOptions;
    const mergedShouldUnescape = shouldUnescape ?? transDefaultProps?.shouldUnescape;
    const mergedValues = transDefaultProps?.values ? {
        ...transDefaultProps.values,
        ...values
    } : values;
    const mergedComponents = transDefaultProps?.components ? {
        ...transDefaultProps.components,
        ...components
    } : components;
    const nodeAsString = $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || mergedTOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $673ff3dfc4a496de$export$ec2cccc18ab4c2ae)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? {
        ...mergedValues,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    else values = mergedValues;
    const valuesFromChildren = $acffcb171536f8e9$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? mergedTOptions.interpolation : {
        interpolation: {
            ...mergedTOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...mergedTOptions,
        context: context || mergedTOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $acffcb171536f8e9$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($acffcb171536f8e9$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $acffcb171536f8e9$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $acw62 = parcelRequire("acw62");




const $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


const $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
class $0636c84fe4549f1f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $0636c84fe4549f1f$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $0636c84fe4549f1f$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        console.warn('react-i18next:: getInitialProps: You will need to pass in an i18next instance by using initReactI18next');
        return {};
    }
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $e04d9533328ca578$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


class $e0c19337b294ccec$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e0c19337b294ccec$export$aa9e222d9ffc5d1b);
    }
}


const $1ddf6027fecc0115$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $1ddf6027fecc0115$var$entityPattern = new RegExp(Object.keys($1ddf6027fecc0115$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $1ddf6027fecc0115$export$5cfeaa4af6841c8f = (text)=>text.replace($1ddf6027fecc0115$var$entityPattern, (match)=>$1ddf6027fecc0115$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));


const $5f107391742a83a7$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};



var $acw62 = parcelRequire("acw62");



const $54962d9d09845ed9$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, props, ...children);
};
const $54962d9d09845ed9$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $5f107391742a83a7$export$660b2ee2d4fb4eff)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $1ddf6027fecc0115$export$5cfeaa4af6841c8f)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $54962d9d09845ed9$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $e0c19337b294ccec$export$aa9e222d9ffc5d1b)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};




function $e917e4d32765654d$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey || defaultTranslation, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $54962d9d09845ed9$export$1038df9fa5e5f35f)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, translation);
    }
}
$e917e4d32765654d$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $60cfc2270f17f8cc$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $e917e4d32765654d$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$60cfc2270f17f8cc$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';




var $acw62 = parcelRequire("acw62");
var $c8e45c4daa4b95cb$exports = {};
'use strict';

$c8e45c4daa4b95cb$exports = (parcelRequire("hkKGc"));




const $3765cebd031b52c0$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $cfb6e0167e0b350d$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    if (typeof k === 'function') return '';
    if (Array.isArray(k)) {
        const last = k[k.length - 1];
        return typeof last === 'function' ? '' : last;
    }
    return k;
};
const $3765cebd031b52c0$var$notReadySnapshot = {
    t: $3765cebd031b52c0$var$notReadyT,
    ready: false
};
const $3765cebd031b52c0$var$dummySubscribe = ()=>()=>{};
const $3765cebd031b52c0$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
    const i18nOptions = (0, $acw62.useMemo)(()=>({
            ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $cfb6e0167e0b350d$export$844ec244b1367d54)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $acw62.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $acw62.useRef)(0);
    const subscribe = (0, $acw62.useCallback)((callback)=>{
        if (!i18n) return $3765cebd031b52c0$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $acw62.useRef)();
    const getSnapshot = (0, $acw62.useCallback)(()=>{
        if (!i18n) return $3765cebd031b52c0$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix, {
            scopeNs: namespaces
        });
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $acw62.useState)(0);
    const { t: t, ready: ready } = (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $acw62.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $acw62.useRef)(null);
    const wrapperLangRef = (0, $acw62.useRef)();
    const languageKey = (inst)=>`${inst.language}|${inst.resolvedLanguage}|${inst.languages?.join(',')}`;
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $acw62.useMemo)(()=>{
        const original = finalI18n;
        const lang = original && languageKey(original);
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const effectiveT = !ready && !useSuspense ? (...args)=>{
            (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'USE_T_BEFORE_READY', 'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.');
            return t(...args);
        } : t;
        const arr = [
            effectiveT,
            i18nWrapper,
            ready
        ];
        arr.t = effectiveT;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) {
        let inDevelopment = false;
        try {
            inDevelopment = false;
        } catch (e) {}
        if (inDevelopment) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'SUSPENDED_WHILE_LOADING', 'useTranslation: suspended while translations are loading (useSuspense is true by default). Add a <Suspense> boundary above this component, or set react.useSuspense: false in the i18next init options. https://react.i18next.com/latest/usetranslation-hook');
        throw new Promise((resolve)=>{
            const onLoaded = ()=>resolve();
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        });
    }
    return ret;
};



var $acw62 = parcelRequire("acw62");


const $d9bd4545752f9667$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $868685a400877801$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n?.language
    }, ready);
};



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $acw62.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $d97c91d803f78bcc$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useSSR: You will need to pass in an i18next instance by using initReactI18next or by passing it via props or context. In monorepo setups, make sure there is only one instance of react-i18next.');
        return;
    }
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        if (!i18n.services?.resourceStore) {
            (0, $cfb6e0167e0b350d$export$5b28268982f175ba)(i18n, 'I18N_NOT_INITIALIZED', "useSSR: i18n instance was found but not initialized (services.resourceStore is missing). Make sure you call i18next.init() before using useSSR \u2014 e.g. at module level, not only in getStaticProps/getServerSideProps.");
            return;
        }
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $afd5c8e3ef499392$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $2843511fe0fbbf82$export$324d90190a8b822a = ()=>'';
const $2843511fe0fbbf82$export$2da9be4cfdb689b1 = ()=>'';
const $2843511fe0fbbf82$export$98e628dec113755e = ()=>'';
const $2843511fe0fbbf82$export$2e6c959c16ff56b8 = ()=>'';
const $2843511fe0fbbf82$export$4e35d5c922a95490 = ()=>'';
const $2843511fe0fbbf82$export$720a3b9db04b7a0f = ()=>'';


function $f6e8edbd6de2d1a8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f6e8edbd6de2d1a8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f6e8edbd6de2d1a8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f6e8edbd6de2d1a8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f6e8edbd6de2d1a8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f6e8edbd6de2d1a8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f6e8edbd6de2d1a8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f6e8edbd6de2d1a8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f6e8edbd6de2d1a8$var$_typeof(o);
}
var $f6e8edbd6de2d1a8$var$arr = [];
var $f6e8edbd6de2d1a8$var$each = $f6e8edbd6de2d1a8$var$arr.forEach;
var $f6e8edbd6de2d1a8$var$slice = $f6e8edbd6de2d1a8$var$arr.slice;
var $f6e8edbd6de2d1a8$var$UNSAFE_KEYS = [
    '__proto__',
    'constructor',
    'prototype'
];
function $f6e8edbd6de2d1a8$export$ebe90cb607ad99e(obj) {
    $f6e8edbd6de2d1a8$var$each.call($f6e8edbd6de2d1a8$var$slice.call(arguments, 1), function(source) {
        if (source) for(var _i = 0, _Object$keys = Object.keys(source); _i < _Object$keys.length; _i++){
            var prop = _Object$keys[_i];
            if ($f6e8edbd6de2d1a8$var$UNSAFE_KEYS.indexOf(prop) > -1) continue;
            if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $f6e8edbd6de2d1a8$var$isSafeUrlSegmentBase(v) {
    if (typeof v !== 'string') return false;
    if (v.length === 0 || v.length > 128) return false;
    if ($f6e8edbd6de2d1a8$var$UNSAFE_KEYS.indexOf(v) > -1) return false;
    if (v.indexOf('..') > -1) return false;
    if (v.indexOf('\\') > -1) return false;
    if (/[?#%\s@]/.test(v)) return false;
    if (/[\x00-\x1F\x7F]/.test(v)) return false;
    return true;
}
function $f6e8edbd6de2d1a8$export$d4b1d5d3c7993bfa(v) {
    if (!$f6e8edbd6de2d1a8$var$isSafeUrlSegmentBase(v)) return false;
    if (v.indexOf('/') > -1) return false;
    return true;
}
function $f6e8edbd6de2d1a8$export$d8513ff071200f5b(v) {
    return $f6e8edbd6de2d1a8$var$isSafeUrlSegmentBase(v);
}
var $f6e8edbd6de2d1a8$export$fcec0b7704220ff2 = $f6e8edbd6de2d1a8$export$d4b1d5d3c7993bfa;
var $f6e8edbd6de2d1a8$var$SAFETY_CHECK_BY_KEY = {
    lng: $f6e8edbd6de2d1a8$export$d4b1d5d3c7993bfa,
    ns: $f6e8edbd6de2d1a8$export$d8513ff071200f5b
};
function $f6e8edbd6de2d1a8$export$b5ba5937b9227ae9(v) {
    if (typeof v !== 'string') return v;
    return v.replace(/[\r\n\x00-\x1F\x7F]/g, ' ');
}
function $f6e8edbd6de2d1a8$export$fee0a5152e4c950b(u) {
    if (typeof u !== 'string' || u.length === 0) return u;
    try {
        var parsed = new URL(u);
        if (parsed.username || parsed.password) {
            parsed.username = '';
            parsed.password = '';
            return parsed.toString();
        }
        return u;
    } catch (e) {
        return u.replace(/(\/\/)[^/@\s]+@/g, '$1');
    }
}
function $f6e8edbd6de2d1a8$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $f6e8edbd6de2d1a8$var$_typeof(XMLHttpRequest)) === 'object';
}
function $f6e8edbd6de2d1a8$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $f6e8edbd6de2d1a8$export$1625492ec82002b9(maybePromise) {
    if ($f6e8edbd6de2d1a8$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}
var $f6e8edbd6de2d1a8$var$interpolationRegexp = /\{\{(.+?)\}\}/g;
function $f6e8edbd6de2d1a8$export$89e29e4ab65e70a9(str, data) {
    return str.replace($f6e8edbd6de2d1a8$var$interpolationRegexp, function(match, key) {
        var k = key.trim();
        if ($f6e8edbd6de2d1a8$var$UNSAFE_KEYS.indexOf(k) > -1) return match;
        var value = data[k];
        return value != null ? value : match;
    });
}
function $f6e8edbd6de2d1a8$export$538bd54113066b32(str, data) {
    var unsafe = false;
    var result = str.replace($f6e8edbd6de2d1a8$var$interpolationRegexp, function(match, key) {
        var k = key.trim();
        if ($f6e8edbd6de2d1a8$var$UNSAFE_KEYS.indexOf(k) > -1) return match;
        var value = data[k];
        if (value == null) return match;
        var check = $f6e8edbd6de2d1a8$var$SAFETY_CHECK_BY_KEY[k] || $f6e8edbd6de2d1a8$export$d4b1d5d3c7993bfa;
        var segments = String(value).split('+');
        var _iterator = $f6e8edbd6de2d1a8$var$_createForOfIteratorHelper(segments), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var seg = _step.value;
                if (!check(seg)) {
                    unsafe = true;
                    return match;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return segments.join('+');
    });
    return unsafe ? null : result;
}



function $cad892b69e25befc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cad892b69e25befc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cad892b69e25befc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cad892b69e25befc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cad892b69e25befc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cad892b69e25befc$var$_defineProperty(e, r, t) {
    return (r = $cad892b69e25befc$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cad892b69e25befc$var$_toPropertyKey(t) {
    var i = $cad892b69e25befc$var$_toPrimitive(t, "string");
    return "symbol" == $cad892b69e25befc$var$_typeof(i) ? i : i + "";
}
function $cad892b69e25befc$var$_toPrimitive(t, r) {
    if ("object" != $cad892b69e25befc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cad892b69e25befc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cad892b69e25befc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cad892b69e25befc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cad892b69e25befc$var$_typeof(o);
}
var $cad892b69e25befc$var$fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $cad892b69e25befc$var$fetchApi = $parcel$global.fetch;
else if (typeof window !== 'undefined' && window.fetch) $cad892b69e25befc$var$fetchApi = window.fetch;
var $cad892b69e25befc$var$XmlHttpRequestApi;
if ((0, $f6e8edbd6de2d1a8$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $cad892b69e25befc$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $cad892b69e25befc$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $cad892b69e25befc$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $cad892b69e25befc$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $cad892b69e25befc$var$ActiveXObjectApi = window.ActiveXObject;
}
if (typeof $cad892b69e25befc$var$fetchApi !== 'function') $cad892b69e25befc$var$fetchApi = undefined;

if (!$cad892b69e25befc$var$fetchApi && !$cad892b69e25befc$var$XmlHttpRequestApi && !$cad892b69e25befc$var$ActiveXObjectApi) try {
    (parcelRequire("f9rNA")).then(function(mod) {
        $cad892b69e25befc$var$fetchApi = mod.default;
    }).catch(function() {});
} catch (e) {}
var $cad892b69e25befc$var$UNSAFE_KEYS = [
    '__proto__',
    'constructor',
    'prototype'
];
var $cad892b69e25befc$var$addQueryString = function addQueryString(url, params) {
    if (params && $cad892b69e25befc$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var _i = 0, _Object$keys = Object.keys(params); _i < _Object$keys.length; _i++){
            var paramName = _Object$keys[_i];
            if ($cad892b69e25befc$var$UNSAFE_KEYS.indexOf(paramName) > -1) continue;
            queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        }
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $cad892b69e25befc$var$fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        var altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $cad892b69e25befc$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $cad892b69e25befc$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $cad892b69e25befc$var$addQueryString(url, options.queryStringParams);
    var headers = $cad892b69e25befc$var$_objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (typeof window === 'undefined' && typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && $parcel$global.process.versions && $parcel$global.process.versions.node) headers['User-Agent'] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")");
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = $cad892b69e25befc$var$_objectSpread({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, options._omitFetchOptions ? {} : reqOptions);
    var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
    try {
        $cad892b69e25befc$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $cad892b69e25befc$var$fetchIt(url, fetchOptions, callback, altFetch);
            options._omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $cad892b69e25befc$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $cad892b69e25befc$var$_typeof(payload) === 'object') payload = $cad892b69e25befc$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $cad892b69e25befc$var$addQueryString(url, options.queryStringParams);
    try {
        var x = $cad892b69e25befc$var$XmlHttpRequestApi ? new $cad892b69e25befc$var$XmlHttpRequestApi() : new $cad892b69e25befc$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var _i2 = 0, _Object$keys2 = Object.keys(h); _i2 < _Object$keys2.length; _i2++){
            var i = _Object$keys2[_i2];
            if ($cad892b69e25befc$var$UNSAFE_KEYS.indexOf(i) > -1) continue;
            x.setRequestHeader(i, h[i]);
        }
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $cad892b69e25befc$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($cad892b69e25befc$var$fetchApi && url.indexOf('file:') !== 0) return $cad892b69e25befc$var$requestWithFetch(options, url, payload, callback);
    if ((0, $f6e8edbd6de2d1a8$export$87022daa49baf612)() || typeof ActiveXObject === 'function') return $cad892b69e25befc$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $cad892b69e25befc$export$2e2bcd8739ae039 = $cad892b69e25befc$var$request;


function $3faa45b77b2a48ba$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3faa45b77b2a48ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3faa45b77b2a48ba$var$_typeof(o);
}
function $3faa45b77b2a48ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3faa45b77b2a48ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3faa45b77b2a48ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3faa45b77b2a48ba$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3faa45b77b2a48ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3faa45b77b2a48ba$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $3faa45b77b2a48ba$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $3faa45b77b2a48ba$var$_toPropertyKey(o.key), o);
    }
}
function $3faa45b77b2a48ba$var$_createClass(e, r, t) {
    return r && $3faa45b77b2a48ba$var$_defineProperties(e.prototype, r), t && $3faa45b77b2a48ba$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $3faa45b77b2a48ba$var$_defineProperty(e, r, t) {
    return (r = $3faa45b77b2a48ba$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3faa45b77b2a48ba$var$_toPropertyKey(t) {
    var i = $3faa45b77b2a48ba$var$_toPrimitive(t, "string");
    return "symbol" == $3faa45b77b2a48ba$var$_typeof(i) ? i : i + "";
}
function $3faa45b77b2a48ba$var$_toPrimitive(t, r) {
    if ("object" != $3faa45b77b2a48ba$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3faa45b77b2a48ba$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3faa45b77b2a48ba$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $3faa45b77b2a48ba$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $cad892b69e25befc$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $3faa45b77b2a48ba$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $3faa45b77b2a48ba$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    return $3faa45b77b2a48ba$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $3faa45b77b2a48ba$var$_objectSpread($3faa45b77b2a48ba$var$_objectSpread($3faa45b77b2a48ba$var$_objectSpread({}, $3faa45b77b2a48ba$var$getDefaults()), this.options || {}), options);
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) {
                    var timer = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if ($3faa45b77b2a48ba$var$_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $f6e8edbd6de2d1a8$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = (0, $f6e8edbd6de2d1a8$export$538bd54113066b32)(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    if (url == null) {
                        var safeLngs = languages.map((0, $f6e8edbd6de2d1a8$export$b5ba5937b9227ae9)).join(', ');
                        var safeNss = namespaces.map((0, $f6e8edbd6de2d1a8$export$b5ba5937b9227ae9)).join(', ');
                        return callback(new Error("i18next-http-backend: unsafe lng/ns value \u2014 refusing to build request URL for languages=[" + safeLngs + '] namespaces=[' + safeNss + ']'), false);
                    }
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                var safeUrl = (0, $f6e8edbd6de2d1a8$export$b5ba5937b9227ae9)((0, $f6e8edbd6de2d1a8$export$fee0a5152e4c950b)(url));
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + safeUrl + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + safeUrl + '; status code: ' + res.status, false);
                    if (!res && err && err.message) {
                        var errorMessage = err.message.toLowerCase();
                        var isNetworkError = [
                            'failed',
                            'fetch',
                            'network',
                            'load'
                        ].find(function(term) {
                            return errorMessage.indexOf(term) > -1;
                        });
                        if (isNetworkError) return callback('failed loading ' + safeUrl + ': ' + (0, $f6e8edbd6de2d1a8$export$b5ba5937b9227ae9)(err.message), true);
                    }
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + safeUrl + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = (0, $f6e8edbd6de2d1a8$export$538bd54113066b32)(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    if (url == null) {
                        finished += 1;
                        if (callback && finished === languages.length) callback(dataArray, resArray);
                        return;
                    }
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
}();
$3faa45b77b2a48ba$var$Backend.type = 'backend';
var $3faa45b77b2a48ba$export$2e2bcd8739ae039 = $3faa45b77b2a48ba$var$Backend;


const { slice: $60196a4650e96cb1$var$slice, forEach: $60196a4650e96cb1$var$forEach } = [];
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$forEach.call($60196a4650e96cb1$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $60196a4650e96cb1$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $60196a4650e96cb1$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $60196a4650e96cb1$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $60196a4650e96cb1$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $60196a4650e96cb1$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            let { search: search } = window.location;
            if (!window.location.search && window.location.hash?.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return language[index]?.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $60196a4650e96cb1$var$hasLocalStorageSupport = null;
const $60196a4650e96cb1$var$localStorageAvailable = ()=>{
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$60196a4650e96cb1$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $60196a4650e96cb1$var$hasSessionStorageSupport = null;
const $60196a4650e96cb1$var$sessionStorageAvailable = ()=>{
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$60196a4650e96cb1$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return language[index]?.replace('/', '');
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $60196a4650e96cb1$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $60196a4650e96cb1$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $60196a4650e96cb1$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$60196a4650e96cb1$var$canCookies) $60196a4650e96cb1$var$order.splice(1, 1);
const $60196a4650e96cb1$var$getDefaults = ()=>({
        order: $60196a4650e96cb1$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $60196a4650e96cb1$export$2e2bcd8739ae039 {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($60196a4650e96cb1$var$cookie$1);
        this.addDetector($60196a4650e96cb1$var$querystring);
        this.addDetector($60196a4650e96cb1$var$localStorage);
        this.addDetector($60196a4650e96cb1$var$sessionStorage);
        this.addDetector($60196a4650e96cb1$var$navigator$1);
        this.addDetector($60196a4650e96cb1$var$htmlTag);
        this.addDetector($60196a4650e96cb1$var$path);
        this.addDetector($60196a4650e96cb1$var$subdomain);
        this.addDetector($60196a4650e96cb1$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$60196a4650e96cb1$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
}
$60196a4650e96cb1$export$2e2bcd8739ae039.type = 'languageDetector';


(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $60196a4650e96cb1$export$2e2bcd8739ae039)).use((0, $26bfda595e5aa141$export$ae7e14d40d89f296)) // passes i18n down to react-i18next
/**
   * Needed to dynamically load bundled translation instead of manually
   * importing the translation files. This is not really a backend.
   */ .use((0, $3faa45b77b2a48ba$export$2e2bcd8739ae039)).init({
    backend: {
        loadPath: "/translations/{{lng}}/{{ns}}.json"
    },
    fallbackLng: "en-US",
    interpolation: {
        escapeValue: false
    },
    load: "currentOnly",
    react: {
        useSuspense: true
    }
});
var $dae7aefd84fd0ab6$export$2e2bcd8739ae039 = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);




var $b8438 = parcelRequire("b8438");

var $acw62 = parcelRequire("acw62");
/* eslint-disable */ /* tslint:disable */ /* auto-generated react proxies */ 
var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $6104d6d22ebd6b39$export$ddc5491c09e462d8 = (str)=>str.toLowerCase().split('-').map((segment)=>segment.charAt(0).toUpperCase() + segment.slice(1)).join('');
const $6104d6d22ebd6b39$export$6e116da553d9a4d8 = (str)=>str.replace(/([A-Z])/g, (m)=>`-${m[0].toLowerCase()}`);


const $f41c1c2eeb6ff4e3$export$a4a300577a7fb982 = (node, newProps, oldProps = {})=>{
    // some test frameworks don't render DOM elements, so we test here to make sure we are dealing with DOM first
    if (node instanceof Element) {
        // add any classes in className to the class list
        const className = $f41c1c2eeb6ff4e3$export$307b18b61172f7ed(node.classList, newProps, oldProps);
        if (className !== '') node.className = className;
        Object.keys(newProps).forEach((name)=>{
            if (name === 'children' || name === 'style' || name === 'ref' || name === 'class' || name === 'className' || name === 'forwardedRef') return;
            if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
                const eventName = name.substring(2);
                const eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);
                if (!$f41c1c2eeb6ff4e3$export$4581b16e56f4a391(eventNameLc)) $f41c1c2eeb6ff4e3$export$fe3993fb4b10b68c(node, eventNameLc, newProps[name]);
            } else {
                node[name] = newProps[name];
                const propType = typeof newProps[name];
                if (propType === 'boolean') {
                    if (newProps[name] === true) node.setAttribute((0, $6104d6d22ebd6b39$export$6e116da553d9a4d8)(name), '');
                    else node.removeAttribute((0, $6104d6d22ebd6b39$export$6e116da553d9a4d8)(name));
                } else if (propType === 'string') node.setAttribute((0, $6104d6d22ebd6b39$export$6e116da553d9a4d8)(name), newProps[name]);
            }
        });
    }
};
const $f41c1c2eeb6ff4e3$export$307b18b61172f7ed = (classList, newProps, oldProps)=>{
    const newClassProp = newProps.className || newProps.class;
    const oldClassProp = oldProps.className || oldProps.class;
    // map the classes to Maps for performance
    const currentClasses = $f41c1c2eeb6ff4e3$var$arrayToMap(classList);
    const incomingPropClasses = $f41c1c2eeb6ff4e3$var$arrayToMap(newClassProp ? newClassProp.split(' ') : []);
    const oldPropClasses = $f41c1c2eeb6ff4e3$var$arrayToMap(oldClassProp ? oldClassProp.split(' ') : []);
    const finalClassNames = [];
    // loop through each of the current classes on the component
    // to see if it should be a part of the classNames added
    currentClasses.forEach((currentClass)=>{
        if (incomingPropClasses.has(currentClass)) {
            // add it as its already included in classnames coming in from newProps
            finalClassNames.push(currentClass);
            incomingPropClasses.delete(currentClass);
        } else if (!oldPropClasses.has(currentClass)) // add it as it has NOT been removed by user
        finalClassNames.push(currentClass);
    });
    incomingPropClasses.forEach((s)=>finalClassNames.push(s));
    return finalClassNames.join(' ');
};
const $f41c1c2eeb6ff4e3$export$72c73565402906e5 = (eventNameSuffix)=>{
    switch(eventNameSuffix){
        case 'doubleclick':
            return 'dblclick';
    }
    return eventNameSuffix;
};
const $f41c1c2eeb6ff4e3$export$4581b16e56f4a391 = (eventNameSuffix)=>{
    if (typeof document === 'undefined') return true;
    else {
        const eventName = 'on' + $f41c1c2eeb6ff4e3$export$72c73565402906e5(eventNameSuffix);
        let isSupported = eventName in document;
        if (!isSupported) {
            const element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
    }
};
const $f41c1c2eeb6ff4e3$export$fe3993fb4b10b68c = (node, eventName, newEventHandler)=>{
    const eventStore = node.__events || (node.__events = {});
    const oldEventHandler = eventStore[eventName];
    // Remove old listener so they don't double up.
    if (oldEventHandler) node.removeEventListener(eventName, oldEventHandler);
    // Bind new listener.
    node.addEventListener(eventName, eventStore[eventName] = function handler(e) {
        if (newEventHandler) newEventHandler.call(this, e);
    });
};
const $f41c1c2eeb6ff4e3$var$arrayToMap = (arr)=>{
    const map = new Map();
    arr.forEach((s)=>map.set(s, s));
    return map;
};



const $995d8de1f2c32154$export$4bb192c7cacf928f = (ref, value)=>{
    if (typeof ref === 'function') ref(value);
    else if (ref != null) // Cast as a MutableRef so we can assign current
    ref.current = value;
};
const $995d8de1f2c32154$export$c9058316764c140e = (...refs)=>{
    return (value)=>{
        refs.forEach((ref)=>{
            $995d8de1f2c32154$export$4bb192c7cacf928f(ref, value);
        });
    };
};
const $995d8de1f2c32154$export$6fc32794423c3270 = (ReactComponent, displayName)=>{
    const forwardRef = (props, ref)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ReactComponent, Object.assign({}, props, {
            forwardedRef: ref
        }));
    };
    forwardRef.displayName = displayName;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(forwardRef);
};
const $995d8de1f2c32154$export$a00e2346eabbdbef = (tagName, customElement)=>{
    if (customElement !== undefined && typeof customElements !== 'undefined' && !customElements.get(tagName)) customElements.define(tagName, customElement);
};


var $8ab0037957ad6c88$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $8ab0037957ad6c88$export$927875efa13d9ac5 = (tagName, ReactComponentContext, manipulatePropsFunction, defineCustomElement)=>{
    if (defineCustomElement !== undefined) defineCustomElement();
    const displayName = (0, $6104d6d22ebd6b39$export$ddc5491c09e462d8)(tagName);
    const ReactComponent = class extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
        constructor(props){
            super(props);
            this.setComponentElRef = (element)=>{
                this.componentEl = element;
            };
        }
        componentDidMount() {
            this.componentDidUpdate(this.props);
        }
        componentDidUpdate(prevProps) {
            (0, $f41c1c2eeb6ff4e3$export$a4a300577a7fb982)(this.componentEl, this.props, prevProps);
        }
        render() {
            const _a = this.props, { children: children, forwardedRef: forwardedRef, style: style, className: className, ref: ref } = _a, cProps = $8ab0037957ad6c88$var$__rest(_a, [
                "children",
                "forwardedRef",
                "style",
                "className",
                "ref"
            ]);
            let propsToPass = Object.keys(cProps).reduce((acc, name)=>{
                const value = cProps[name];
                if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
                    const eventName = name.substring(2).toLowerCase();
                    if (typeof document !== 'undefined' && (0, $f41c1c2eeb6ff4e3$export$4581b16e56f4a391)(eventName)) acc[name] = value;
                } else {
                    // we should only render strings, booleans, and numbers as attrs in html.
                    // objects, functions, arrays etc get synced via properties on mount.
                    const type = typeof value;
                    if (type === 'string' || type === 'boolean' || type === 'number') acc[(0, $6104d6d22ebd6b39$export$6e116da553d9a4d8)(name)] = value;
                }
                return acc;
            }, {});
            if (manipulatePropsFunction) propsToPass = manipulatePropsFunction(this.props, propsToPass);
            const newProps = Object.assign(Object.assign({}, propsToPass), {
                ref: (0, $995d8de1f2c32154$export$c9058316764c140e)(forwardedRef, this.setComponentElRef),
                style: style
            });
            /**
             * We use createElement here instead of
             * React.createElement to work around a
             * bug in Vite (https://github.com/vitejs/vite/issues/6104).
             * React.createElement causes all elements to be rendered
             * as <tagname> instead of the actual Web Component.
             */ return (0, $acw62.createElement)(tagName, newProps, children);
        }
        static get displayName() {
            return displayName;
        }
    };
    // If context was passed to createReactComponent then conditionally add it to the Component Class
    if (ReactComponentContext) ReactComponent.contextType = ReactComponentContext;
    return (0, $995d8de1f2c32154$export$6fc32794423c3270)(ReactComponent, displayName);
};



var $acw62 = parcelRequire("acw62");



function $2f386ee4d98cc344$var$isMarketElement(node) {
    var _a;
    const node_ = node;
    return ((_a = node_ === null || node_ === void 0 ? void 0 : node_.tagName) === null || _a === void 0 ? void 0 : _a.includes('MARKET-')) && typeof node_.componentOnReady === 'function';
}
async function $2f386ee4d98cc344$export$e6be160dea4e140c(domNode) {
    const promises = [];
    const waitForDidLoad = (promises, elm)=>{
        if (elm != null && elm.nodeType === 1) for(let i = 0; i < elm.children.length; i++){
            const childElm = elm.children[i];
            if ($2f386ee4d98cc344$var$isMarketElement(childElm)) promises.push(childElm.componentOnReady());
            waitForDidLoad(promises, childElm);
        }
    };
    waitForDidLoad(promises, domNode);
    await Promise.all(promises).catch((e)=>console.error(e));
}


var $fb84c88c899bd36b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $fb84c88c899bd36b$var$MARKET_TAGNAME_REGEX = /(market-)(.*)/;
const $fb84c88c899bd36b$export$8f95d9dcc176da71 = (tagName, defineCustomElement)=>{
    if (defineCustomElement !== undefined) defineCustomElement();
    const displayName = (0, $6104d6d22ebd6b39$export$ddc5491c09e462d8)(tagName);
    const contextManagerTagName = tagName.replace($fb84c88c899bd36b$var$MARKET_TAGNAME_REGEX, "$1context-manager");
    const contextTagName = tagName.replace($fb84c88c899bd36b$var$MARKET_TAGNAME_REGEX, "$1context");
    const MarketContext = (0, $8ab0037957ad6c88$export$927875efa13d9ac5)(contextTagName);
    const ModalElement = (0, $8ab0037957ad6c88$export$927875efa13d9ac5)(tagName);
    // Return `MarketManagerContext` to be used used as container for Portal or
    // throw an error in case it doesn't exist
    const createOrReturnContextManager = ()=>{
        const contextManager = document.querySelector(contextManagerTagName);
        if (!contextManager) {
            const contextManager = document.createElement(contextManagerTagName);
            document.body.appendChild(contextManager);
            // @ts-expect-error
            return contextManager;
        }
        return contextManager;
    };
    const ReactComponent = (_a)=>{
        var { children: children, forwardedRef: forwardedRef, style: style, className: className, ref: ref } = _a, cProps = $fb84c88c899bd36b$var$__rest(_a, [
            "children",
            "forwardedRef",
            "style",
            "className",
            "ref"
        ]);
        const containerRef = (0, $acw62.useRef)(null);
        const contextManagerElement = createOrReturnContextManager();
        // This is a copy from react-component-lib/createOverlayComponent.tsx with proper modifications
        const propsToPass = Object.keys(cProps).reduce((acc, name)=>{
            const value = cProps[name];
            if (name.indexOf("on") === 0 && name[2] === name[2].toUpperCase()) acc[name] = value;
            else {
                // we should only render strings, booleans, and numbers as attrs in html.
                // objects, functions, arrays etc get synced via properties on mount.
                const type = typeof value;
                if (type === "string" || type === "boolean" || type === "number") acc[(0, $6104d6d22ebd6b39$export$6e116da553d9a4d8)(name)] = value;
            }
            return acc;
        }, {});
        const newProps = Object.assign(Object.assign({}, propsToPass), {
            ref: forwardedRef,
            style: style,
            className: className
        });
        (0, $acw62.useEffect)(()=>{
            const setupModal = async ()=>{
                var _a;
                await (0, $2f386ee4d98cc344$export$e6be160dea4e140c)(containerRef.current);
                await ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.open(containerRef.current.firstElementChild));
                await contextManagerElement.activate();
            };
            setupModal().catch(()=>null);
            return ()=>{
                if (contextManagerElement.childElementCount === 0) contextManagerElement.deactivate();
            };
        }, []);
        if (contextManagerElement === null) return null;
        return (0, $11492dca620dcaa5$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MarketContext, {
            ref: containerRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ModalElement, Object.assign({}, newProps), children)), contextManagerElement);
    };
    ReactComponent.displayName = displayName;
    return (0, $995d8de1f2c32154$export$6fc32794423c3270)(ReactComponent, displayName);
};




const $7d1bfdd6e8737fe3$export$6f0866326599ed67 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-accessory');
const $7d1bfdd6e8737fe3$export$6145a59a4e4eac8b = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-accordion-item');
const $7d1bfdd6e8737fe3$export$cac360922d5e9af6 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-action-card');
const $7d1bfdd6e8737fe3$export$28c2b904b2ab5c88 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-activity-indicator');
const $7d1bfdd6e8737fe3$export$809cbe1e0a7d9f9 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-activity-indicator-bar');
const $7d1bfdd6e8737fe3$export$5c6fd3bcc87b049b = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-banner');
const $7d1bfdd6e8737fe3$export$edd5eb07a68f878 = /*@__PURE__*/ (0, $fb84c88c899bd36b$export$8f95d9dcc176da71)('market-blade');
const $7d1bfdd6e8737fe3$export$862a33790ffda48f = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-button');
const $7d1bfdd6e8737fe3$export$19f8dfeebad6b5c4 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-button-dropdown');
const $7d1bfdd6e8737fe3$export$98f7e185520106d0 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-button-group');
const $7d1bfdd6e8737fe3$export$1df005bf392232de = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-checkbox');
const $7d1bfdd6e8737fe3$export$2e8eb11a7d8d825 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-choice-button');
const $7d1bfdd6e8737fe3$export$6ce1c5a1197c7e0f = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-code-display');
const $7d1bfdd6e8737fe3$export$f1fcfd478d0fa17d = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-code-input');
const $7d1bfdd6e8737fe3$export$e11c4ee477acc652 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-content-card');
const $7d1bfdd6e8737fe3$export$5c6dae3c700da9bd = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-context');
const $7d1bfdd6e8737fe3$export$671557a13be7cc96 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-context-manager');
const $7d1bfdd6e8737fe3$export$507e2a5199469119 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-date-picker');
const $7d1bfdd6e8737fe3$export$759993c595fab914 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-date-picker-date');
const $7d1bfdd6e8737fe3$export$5916b05805a96ee3 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-date-picker-input-date');
const $7d1bfdd6e8737fe3$export$efbd9f2ed7780a30 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-date-picker-menu');
const $7d1bfdd6e8737fe3$export$ae31bb92daaacf7b = /*@__PURE__*/ (0, $fb84c88c899bd36b$export$8f95d9dcc176da71)('market-dialog');
const $7d1bfdd6e8737fe3$export$2bf53bba4802f0ae = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-divider');
const $7d1bfdd6e8737fe3$export$45b2ab2714d81604 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-drag-handle');
const $7d1bfdd6e8737fe3$export$55e40bf6ba98f173 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-dropdown');
const $7d1bfdd6e8737fe3$export$53fe4b71065a03ce = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-empty-state');
const $7d1bfdd6e8737fe3$export$bf9d3c0d17a2f99e = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-field');
const $7d1bfdd6e8737fe3$export$3bb74e73144a7a1c = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-file-upload');
const $7d1bfdd6e8737fe3$export$ac4de2402813dce3 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-filter');
const $7d1bfdd6e8737fe3$export$e5dbc5e04048d721 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-filter-button');
const $7d1bfdd6e8737fe3$export$2a6919f5f2d41050 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-filter-dropdown-menu');
const $7d1bfdd6e8737fe3$export$78870e85af0e5c95 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-filter-group');
const $7d1bfdd6e8737fe3$export$a2053447cfda9df3 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-footer');
const $7d1bfdd6e8737fe3$export$95abf1952846aff4 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-header');
const $7d1bfdd6e8737fe3$export$bd6be06d24180fe5 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-input-password');
const $7d1bfdd6e8737fe3$export$2ede3c8d67d0b9d0 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-input-search');
const $7d1bfdd6e8737fe3$export$f8929a49510d767f = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-input-text');
const $7d1bfdd6e8737fe3$export$49443b5f5d98af6e = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-link');
const $7d1bfdd6e8737fe3$export$5f38cc4b3e71c577 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-list');
const $7d1bfdd6e8737fe3$export$9be6f02cefaea425 = /*@__PURE__*/ (0, $fb84c88c899bd36b$export$8f95d9dcc176da71)('market-modal-full');
const $7d1bfdd6e8737fe3$export$4fa994bc91bf3e1 = /*@__PURE__*/ (0, $fb84c88c899bd36b$export$8f95d9dcc176da71)('market-modal-partial');
const $7d1bfdd6e8737fe3$export$2d83be035d558064 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-pagination');
const $7d1bfdd6e8737fe3$export$ffeb71fc62d8c571 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-pagination-nav');
const $7d1bfdd6e8737fe3$export$924e17977e3d512f = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-pagination-page-size');
const $7d1bfdd6e8737fe3$export$2deb0c47cc93ce63 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-pill');
const $7d1bfdd6e8737fe3$export$a00ed319fc43be46 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-popover');
const $7d1bfdd6e8737fe3$export$561cbb7b502ca6ee = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-progress-tracker');
const $7d1bfdd6e8737fe3$export$e4682f92f3256842 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-progress-tracker-step');
const $7d1bfdd6e8737fe3$export$98adee31ea2d2621 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-qrcode');
const $7d1bfdd6e8737fe3$export$3f5cc96cec366be4 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-radio');
const $7d1bfdd6e8737fe3$export$14eeaa98ef1abeb2 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-row');
const $7d1bfdd6e8737fe3$export$d9270f60b07d09a = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-segment');
const $7d1bfdd6e8737fe3$export$42ee0af031e2823c = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-segmented-control');
const $7d1bfdd6e8737fe3$export$29823418345456dd = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-select');
const $7d1bfdd6e8737fe3$export$47ef55df1edd51ec = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-stepper');
const $7d1bfdd6e8737fe3$export$a351e59f4d54d834 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-tab');
const $7d1bfdd6e8737fe3$export$b4a4c53ca46e095f = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-tab-list');
const $7d1bfdd6e8737fe3$export$e8b65da8829cd4fc = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-tab-panel');
const $7d1bfdd6e8737fe3$export$8c7c5327e9abf9e9 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-table');
const $7d1bfdd6e8737fe3$export$f2c35307246bb502 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-table-area');
const $7d1bfdd6e8737fe3$export$47cffd043943b519 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-table-cell');
const $7d1bfdd6e8737fe3$export$98d982f91501addb = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-table-column');
const $7d1bfdd6e8737fe3$export$4791d97b1f79ac1a = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-table-row');
const $7d1bfdd6e8737fe3$export$dcc0675722e11d9a = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-table-v2');
const $7d1bfdd6e8737fe3$export$ad11139b8552df77 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-table-v2-cell');
const $7d1bfdd6e8737fe3$export$c0dd1175b8b645f4 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-table-v2-row');
const $7d1bfdd6e8737fe3$export$d2c429788534e7b2 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-tabs');
const $7d1bfdd6e8737fe3$export$2157929c12620208 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-tag');
const $7d1bfdd6e8737fe3$export$f6983f729ebeb4cd = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-textarea');
const $7d1bfdd6e8737fe3$export$91a0ef8451160b3b = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-tile');
const $7d1bfdd6e8737fe3$export$7976a0b446a572f = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-toast');
const $7d1bfdd6e8737fe3$export$6185df1bc788a671 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-toaster');
const $7d1bfdd6e8737fe3$export$b2dd8e9aed9c0935 = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-toggle');
const $7d1bfdd6e8737fe3$export$8f7631573f08e68b = /*@__PURE__*/ (0, $8ab0037957ad6c88$export$927875efa13d9ac5)('market-tooltip');




// DO NOT EDIT! This is copy and pasted from dashboard
// TODO(cvu): eventually import this from dashboard via bazel
// frontend/@banking/ui/addon/utils/assert.ts
// DO NOT EDIT! This is copy and pasted from dashboard
// frontend/@banking/ui/addon/utils/predicates.ts
// TODO(cvu): eventually import this from dashboard via bazel
const $e414140c55630b60$export$ec3bcb3c4c9d7237 = (value)=>typeof value === "boolean";
const $e414140c55630b60$export$26128561c93f5847 = (value)=>value != null;


function $5cdd7c46b89c41cf$export$2e2bcd8739ae039(condition, msg) {
    if (!condition) throw new Error(msg ?? "assertion failure");
}
function $5cdd7c46b89c41cf$export$a5d83b356248b8b4(val, ctor) {
    // eslint-disable-next-line
    function assert(val, ctor) {
        if (!(val instanceof ctor)) throw new TypeError(`Expected value to be an instance of ${ctor.name}.`);
    }
    assert(val, ctor);
    return val;
}
function $5cdd7c46b89c41cf$export$860d92d158d1ae0e(val) {
    $5cdd7c46b89c41cf$export$2e2bcd8739ae039((0, $e414140c55630b60$export$ec3bcb3c4c9d7237)(val), "value must be boolean");
    return val;
}
function $5cdd7c46b89c41cf$export$31407c2dd876dbd1(val) {
    $5cdd7c46b89c41cf$export$2e2bcd8739ae039((0, $e414140c55630b60$export$26128561c93f5847)(val), "value cannot be nullable");
    return val;
}


const $f52070b5f7ea08cf$export$f0f3a5c436134bc0 = (personProfile)=>{
    if (personProfile == null) throw new Error("Missing personProfile from bootstrap");
    if (personProfile.personToken === "") throw new Error("PersonProfile person token is empty from bootstrap");
    return {
        personToken: personProfile.personToken,
        name: {
            first: personProfile.name?.firstName ?? "",
            last: personProfile.name?.lastName ?? ""
        }
    };
};
const $f52070b5f7ea08cf$export$155800cbebf9d04f = (user)=>{
    const firstName = user.name.first;
    const lastName = user.name.last;
    return $f52070b5f7ea08cf$export$525011322c57ec0f(firstName, lastName);
};
const $f52070b5f7ea08cf$export$525011322c57ec0f = (firstName, lastName)=>{
    return `${firstName} ${lastName}`.trim();
};


const $214b3af3bfc0d570$export$8f5519c5909517b3 = (bootstrap)=>({
        user: (0, $f52070b5f7ea08cf$export$f0f3a5c436134bc0)(bootstrap.personProfile)
    });




var $acw62 = parcelRequire("acw62");

/**
 * react-router v7.18.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v7.18.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v7.18.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $3e8179397014bb35$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-OB3PAWPO.mjs"
});
var $3e8179397014bb35$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $3e8179397014bb35$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $3e8179397014bb35$var$__typeError("Cannot " + msg);
var $3e8179397014bb35$var$__privateGet = (obj, member, getter)=>($3e8179397014bb35$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $3e8179397014bb35$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $3e8179397014bb35$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $3e8179397014bb35$var$__privateSet = (obj, member, value, setter)=>($3e8179397014bb35$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $3e8179397014bb35$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $3e8179397014bb35$export$825a82322d91916e = /^[\\/]{2}/;
function $3e8179397014bb35$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $3e8179397014bb35$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($3e8179397014bb35$export$e19cd5f9376f8cee || {});
var $3e8179397014bb35$var$PopStateEventType = "popstate";
function $3e8179397014bb35$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $3e8179397014bb35$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $3e8179397014bb35$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $3e8179397014bb35$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $3e8179397014bb35$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $3e8179397014bb35$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $3e8179397014bb35$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $3e8179397014bb35$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to);
    }
    return $3e8179397014bb35$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $3e8179397014bb35$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $3e8179397014bb35$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $3e8179397014bb35$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $3e8179397014bb35$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $3e8179397014bb35$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $3e8179397014bb35$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $3e8179397014bb35$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $3e8179397014bb35$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $3e8179397014bb35$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $3e8179397014bb35$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $3e8179397014bb35$var$createKey(),
        mask: mask
    };
    return location;
}
function $3e8179397014bb35$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $3e8179397014bb35$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $3e8179397014bb35$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $3e8179397014bb35$var$isLocation(to) ? to : $3e8179397014bb35$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $3e8179397014bb35$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $3e8179397014bb35$var$isLocation(to) ? to : $3e8179397014bb35$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $3e8179397014bb35$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $3e8179397014bb35$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($3e8179397014bb35$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($3e8179397014bb35$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $3e8179397014bb35$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $3e8179397014bb35$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $3e8179397014bb35$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $3e8179397014bb35$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $3e8179397014bb35$var$_map;
var $3e8179397014bb35$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $3e8179397014bb35$var$__privateAdd(this, $3e8179397014bb35$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_map).has(context)) return $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_map).set(context, value);
    }
};
$3e8179397014bb35$var$_map = new WeakMap();
var $3e8179397014bb35$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $3e8179397014bb35$var$isUnsupportedLazyRouteObjectKey(key) {
    return $3e8179397014bb35$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $3e8179397014bb35$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $3e8179397014bb35$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $3e8179397014bb35$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $3e8179397014bb35$var$isIndexRoute(route) {
    return route.index === true;
}
function $3e8179397014bb35$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $3e8179397014bb35$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $3e8179397014bb35$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($3e8179397014bb35$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $3e8179397014bb35$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $3e8179397014bb35$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $3e8179397014bb35$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $3e8179397014bb35$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $3e8179397014bb35$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $3e8179397014bb35$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $3e8179397014bb35$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $3e8179397014bb35$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $3e8179397014bb35$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $3e8179397014bb35$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $3e8179397014bb35$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $3e8179397014bb35$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $3e8179397014bb35$var$flattenAndRankRoutes(routes) {
    let branches = $3e8179397014bb35$var$flattenRoutes(routes);
    $3e8179397014bb35$var$rankRouteBranches(branches);
    return branches;
}
function $3e8179397014bb35$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $3e8179397014bb35$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $3e8179397014bb35$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $3e8179397014bb35$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $3e8179397014bb35$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $3e8179397014bb35$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $3e8179397014bb35$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $3e8179397014bb35$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $3e8179397014bb35$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $3e8179397014bb35$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $3e8179397014bb35$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $3e8179397014bb35$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $3e8179397014bb35$var$paramRe = /^:[\w-]+$/;
var $3e8179397014bb35$var$dynamicSegmentValue = 3;
var $3e8179397014bb35$var$indexRouteValue = 2;
var $3e8179397014bb35$var$emptySegmentValue = 1;
var $3e8179397014bb35$var$staticSegmentValue = 10;
var $3e8179397014bb35$var$splatPenalty = -2;
var $3e8179397014bb35$var$isSplat = (s)=>s === "*";
function $3e8179397014bb35$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($3e8179397014bb35$var$isSplat)) initialScore += $3e8179397014bb35$var$splatPenalty;
    if (index) initialScore += $3e8179397014bb35$var$indexRouteValue;
    return segments.filter((s)=>!$3e8179397014bb35$var$isSplat(s)).reduce((score, segment)=>score + ($3e8179397014bb35$var$paramRe.test(segment) ? $3e8179397014bb35$var$dynamicSegmentValue : segment === "" ? $3e8179397014bb35$var$emptySegmentValue : $3e8179397014bb35$var$staticSegmentValue), initialScore);
}
function $3e8179397014bb35$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $3e8179397014bb35$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $3e8179397014bb35$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $3e8179397014bb35$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $3e8179397014bb35$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $3e8179397014bb35$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $3e8179397014bb35$var$normalizePathname($3e8179397014bb35$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $3e8179397014bb35$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $3e8179397014bb35$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $3e8179397014bb35$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $3e8179397014bb35$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $3e8179397014bb35$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $3e8179397014bb35$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $3e8179397014bb35$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $3e8179397014bb35$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $3e8179397014bb35$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $3e8179397014bb35$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $3e8179397014bb35$var$compilePath(path, caseSensitive = false, end = true) {
    $3e8179397014bb35$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $3e8179397014bb35$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $3e8179397014bb35$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $3e8179397014bb35$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $3e8179397014bb35$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $3e8179397014bb35$var$joinPaths([
        basename,
        pathname
    ]);
}
var $3e8179397014bb35$var$isAbsoluteUrl = (url)=>$3e8179397014bb35$var$ABSOLUTE_URL_REGEX.test(url);
function $3e8179397014bb35$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $3e8179397014bb35$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $3e8179397014bb35$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $3e8179397014bb35$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $3e8179397014bb35$var$normalizeSearch(search),
        hash: $3e8179397014bb35$var$normalizeHash(hash)
    };
}
function $3e8179397014bb35$var$resolvePathname(relativePath, fromPathname) {
    let segments = $3e8179397014bb35$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $3e8179397014bb35$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $3e8179397014bb35$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $3e8179397014bb35$var$getResolveToMatches(matches) {
    let pathMatches = $3e8179397014bb35$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $3e8179397014bb35$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $3e8179397014bb35$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $3e8179397014bb35$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $3e8179397014bb35$var$getInvalidPathError("?", "pathname", "search", to));
        $3e8179397014bb35$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $3e8179397014bb35$var$getInvalidPathError("#", "pathname", "hash", to));
        $3e8179397014bb35$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $3e8179397014bb35$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $3e8179397014bb35$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $3e8179397014bb35$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $3e8179397014bb35$var$joinPaths = (paths)=>$3e8179397014bb35$var$removeDoubleSlashes(paths.join("/"));
function $3e8179397014bb35$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $3e8179397014bb35$var$normalizePathname = (pathname)=>$3e8179397014bb35$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $3e8179397014bb35$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $3e8179397014bb35$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $3e8179397014bb35$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $3e8179397014bb35$export$4051a07651545597(data2, init) {
    return new $3e8179397014bb35$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $3e8179397014bb35$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $3e8179397014bb35$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $3e8179397014bb35$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $3e8179397014bb35$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $3e8179397014bb35$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $3e8179397014bb35$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $3e8179397014bb35$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $3e8179397014bb35$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $3e8179397014bb35$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $3e8179397014bb35$var$joinPaths(parts) || "/";
}
var $3e8179397014bb35$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $3e8179397014bb35$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$3e8179397014bb35$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($3e8179397014bb35$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $3e8179397014bb35$export$825a82322d91916e.test(to) ? new URL($3e8179397014bb35$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $3e8179397014bb35$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $3e8179397014bb35$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $3e8179397014bb35$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $3e8179397014bb35$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $3e8179397014bb35$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $3e8179397014bb35$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$3e8179397014bb35$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $3e8179397014bb35$var$wrapImpl(aggregated[key], original, (...args)=>$3e8179397014bb35$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$3e8179397014bb35$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$3e8179397014bb35$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $3e8179397014bb35$var$wrapImpl(aggregated.middleware, original, (...args)=>$3e8179397014bb35$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$3e8179397014bb35$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $3e8179397014bb35$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$3e8179397014bb35$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $3e8179397014bb35$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $3e8179397014bb35$export$fe53371bee54353d(to) : ".",
                ...$3e8179397014bb35$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$3e8179397014bb35$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$3e8179397014bb35$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $3e8179397014bb35$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$3e8179397014bb35$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$3e8179397014bb35$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $3e8179397014bb35$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $3e8179397014bb35$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $3e8179397014bb35$var$getReadonlyRequest(request),
            context: context != null ? $3e8179397014bb35$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $3e8179397014bb35$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $3e8179397014bb35$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $3e8179397014bb35$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $3e8179397014bb35$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $3e8179397014bb35$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $3e8179397014bb35$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $3e8179397014bb35$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $3e8179397014bb35$var$getReadonlyContext(context)
    };
}
function $3e8179397014bb35$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $3e8179397014bb35$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $3e8179397014bb35$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $3e8179397014bb35$var$getReadonlyContext(context) {
    if ($3e8179397014bb35$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $3e8179397014bb35$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $3e8179397014bb35$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $3e8179397014bb35$var$objectProtoNames;
}
// lib/router/navigation.ts
var $3e8179397014bb35$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $3e8179397014bb35$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $3e8179397014bb35$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $3e8179397014bb35$var$DEFAULT_NAVIGATION_URL;
    }
}
function $3e8179397014bb35$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $3e8179397014bb35$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $3e8179397014bb35$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$3e8179397014bb35$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$3e8179397014bb35$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$3e8179397014bb35$var$isExplicitUrl(original, originalUrl) || !$3e8179397014bb35$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $3e8179397014bb35$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $3e8179397014bb35$var$validMutationMethods = new Set($3e8179397014bb35$var$validMutationMethodsArr);
var $3e8179397014bb35$var$validRequestMethodsArr = [
    "GET",
    ...$3e8179397014bb35$var$validMutationMethodsArr
];
var $3e8179397014bb35$var$validRequestMethods = new Set($3e8179397014bb35$var$validRequestMethodsArr);
var $3e8179397014bb35$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $3e8179397014bb35$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $3e8179397014bb35$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $3e8179397014bb35$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $3e8179397014bb35$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $3e8179397014bb35$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $3e8179397014bb35$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $3e8179397014bb35$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $3e8179397014bb35$var$_routes, $3e8179397014bb35$var$_branches, $3e8179397014bb35$var$_hmrRoutes, $3e8179397014bb35$var$_hmrBranches;
var $3e8179397014bb35$var$DataRoutes = class {
    constructor(routes){
        $3e8179397014bb35$var$__privateAdd(this, $3e8179397014bb35$var$_routes);
        $3e8179397014bb35$var$__privateAdd(this, $3e8179397014bb35$var$_branches);
        $3e8179397014bb35$var$__privateAdd(this, $3e8179397014bb35$var$_hmrRoutes);
        $3e8179397014bb35$var$__privateAdd(this, $3e8179397014bb35$var$_hmrBranches);
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_routes, routes);
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_branches, $3e8179397014bb35$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrRoutes) ?? $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrBranches) ?? $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_branches);
    }
    get hasHMRRoutes() {
        return $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_routes, routes);
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_branches, $3e8179397014bb35$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_hmrRoutes, routes);
        $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_hmrBranches, $3e8179397014bb35$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrRoutes)) {
            $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_routes, $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrRoutes));
            $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_branches, $3e8179397014bb35$var$__privateGet(this, $3e8179397014bb35$var$_hmrBranches));
            $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_hmrRoutes, void 0);
            $3e8179397014bb35$var$__privateSet(this, $3e8179397014bb35$var$_hmrBranches, void 0);
        }
    }
};
$3e8179397014bb35$var$_routes = new WeakMap();
$3e8179397014bb35$var$_branches = new WeakMap();
$3e8179397014bb35$var$_hmrRoutes = new WeakMap();
$3e8179397014bb35$var$_hmrBranches = new WeakMap();
function $3e8179397014bb35$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $3e8179397014bb35$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $3e8179397014bb35$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$3e8179397014bb35$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $3e8179397014bb35$var$DataRoutes($3e8179397014bb35$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $3e8179397014bb35$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $3e8179397014bb35$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$3e8179397014bb35$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $3e8179397014bb35$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $3e8179397014bb35$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $3e8179397014bb35$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $3e8179397014bb35$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $3e8179397014bb35$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$3e8179397014bb35$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $3e8179397014bb35$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $3e8179397014bb35$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $3e8179397014bb35$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $3e8179397014bb35$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */  && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $3e8179397014bb35$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $3e8179397014bb35$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $3e8179397014bb35$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $3e8179397014bb35$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($3e8179397014bb35$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $3e8179397014bb35$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $3e8179397014bb35$export$fe53371bee54353d(opts.mask), $3e8179397014bb35$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $3e8179397014bb35$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $3e8179397014bb35$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $3e8179397014bb35$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $3e8179397014bb35$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $3e8179397014bb35$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $3e8179397014bb35$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $3e8179397014bb35$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $3e8179397014bb35$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $3e8179397014bb35$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $3e8179397014bb35$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $3e8179397014bb35$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($3e8179397014bb35$var$isErrorResult(result) && $3e8179397014bb35$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $3e8179397014bb35$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $3e8179397014bb35$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$3e8179397014bb35$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $3e8179397014bb35$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $3e8179397014bb35$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $3e8179397014bb35$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $3e8179397014bb35$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($3e8179397014bb35$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $3e8179397014bb35$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($3e8179397014bb35$var$isErrorResult(result)) {
            let boundaryMatch = $3e8179397014bb35$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $3e8179397014bb35$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $3e8179397014bb35$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $3e8179397014bb35$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $3e8179397014bb35$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$3e8179397014bb35$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $3e8179397014bb35$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $3e8179397014bb35$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $3e8179397014bb35$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$3e8179397014bb35$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $3e8179397014bb35$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $3e8179397014bb35$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $3e8179397014bb35$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $3e8179397014bb35$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $3e8179397014bb35$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $3e8179397014bb35$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $3e8179397014bb35$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $3e8179397014bb35$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $3e8179397014bb35$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $3e8179397014bb35$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $3e8179397014bb35$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($3e8179397014bb35$var$isRedirectResult(actionResult) || $3e8179397014bb35$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($3e8179397014bb35$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $3e8179397014bb35$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($3e8179397014bb35$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $3e8179397014bb35$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $3e8179397014bb35$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $3e8179397014bb35$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $3e8179397014bb35$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $3e8179397014bb35$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $3e8179397014bb35$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $3e8179397014bb35$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $3e8179397014bb35$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $3e8179397014bb35$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $3e8179397014bb35$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $3e8179397014bb35$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $3e8179397014bb35$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $3e8179397014bb35$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $3e8179397014bb35$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $3e8179397014bb35$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $3e8179397014bb35$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(void 0));
            return;
        }
        if ($3e8179397014bb35$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($3e8179397014bb35$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $3e8179397014bb35$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $3e8179397014bb35$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $3e8179397014bb35$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $3e8179397014bb35$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($3e8179397014bb35$var$isAbsoluteUrl(location)) {
                const url = $3e8179397014bb35$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $3e8179397014bb35$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $3e8179397014bb35$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($3e8179397014bb35$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $3e8179397014bb35$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $3e8179397014bb35$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $3e8179397014bb35$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$3e8179397014bb35$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($3e8179397014bb35$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $3e8179397014bb35$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $3e8179397014bb35$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $3e8179397014bb35$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $3e8179397014bb35$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $3e8179397014bb35$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $3e8179397014bb35$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $3e8179397014bb35$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $3e8179397014bb35$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $3e8179397014bb35$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $3e8179397014bb35$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $3e8179397014bb35$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $3e8179397014bb35$export$386d57f03f0b2883;
        $3e8179397014bb35$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $3e8179397014bb35$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $3e8179397014bb35$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $3e8179397014bb35$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$3e8179397014bb35$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $3e8179397014bb35$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($3e8179397014bb35$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $3e8179397014bb35$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $3e8179397014bb35$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $3e8179397014bb35$export$3336b097a6fbc59a(routes, opts) {
    $3e8179397014bb35$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $3e8179397014bb35$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$3e8179397014bb35$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $3e8179397014bb35$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $3e8179397014bb35$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $3e8179397014bb35$var$defaultNormalizePath;
        let method = request.method;
        let location = $3e8179397014bb35$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $3e8179397014bb35$export$b8d3e69d4b3eff04();
        if (!$3e8179397014bb35$var$isValidMethod(method) && method !== "HEAD") {
            let error = $3e8179397014bb35$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $3e8179397014bb35$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $3e8179397014bb35$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $3e8179397014bb35$export$f5708dca728d7177(requestContext instanceof $3e8179397014bb35$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $3e8179397014bb35$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $3e8179397014bb35$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $3e8179397014bb35$var$createDataFunctionUrl(request, location),
                    pattern: $3e8179397014bb35$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($3e8179397014bb35$export$6e80290866a84dd4(error)) return error;
                    if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $3e8179397014bb35$export$f2680fa305b734ca(error.status, error.statusText, await $3e8179397014bb35$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($3e8179397014bb35$export$e0163cfdf7bc9cfa(error)) error = $3e8179397014bb35$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $3e8179397014bb35$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $3e8179397014bb35$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $3e8179397014bb35$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $3e8179397014bb35$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $3e8179397014bb35$var$defaultNormalizePath;
        let method = request.method;
        let location = $3e8179397014bb35$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $3e8179397014bb35$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $3e8179397014bb35$export$b8d3e69d4b3eff04();
        if (!$3e8179397014bb35$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $3e8179397014bb35$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $3e8179397014bb35$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $3e8179397014bb35$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $3e8179397014bb35$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $3e8179397014bb35$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $3e8179397014bb35$export$f5708dca728d7177(requestContext instanceof $3e8179397014bb35$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $3e8179397014bb35$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $3e8179397014bb35$var$runServerMiddlewarePipeline({
                request: request,
                url: $3e8179397014bb35$var$createDataFunctionUrl(request, location),
                pattern: $3e8179397014bb35$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $3e8179397014bb35$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($3e8179397014bb35$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($3e8179397014bb35$var$dataWithResponseInitToResponse(error));
                if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $3e8179397014bb35$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($3e8179397014bb35$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $3e8179397014bb35$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $3e8179397014bb35$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($3e8179397014bb35$var$isDataStrategyResult(e) && $3e8179397014bb35$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($3e8179397014bb35$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $3e8179397014bb35$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $3e8179397014bb35$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($3e8179397014bb35$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($3e8179397014bb35$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($3e8179397014bb35$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $3e8179397014bb35$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $3e8179397014bb35$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($3e8179397014bb35$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $3e8179397014bb35$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $3e8179397014bb35$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $3e8179397014bb35$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $3e8179397014bb35$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $3e8179397014bb35$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $3e8179397014bb35$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $3e8179397014bb35$var$callDataStrategyImpl(dataStrategy || $3e8179397014bb35$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($3e8179397014bb35$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $3e8179397014bb35$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($3e8179397014bb35$export$e0163cfdf7bc9cfa(result.result)) throw $3e8179397014bb35$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $3e8179397014bb35$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $3e8179397014bb35$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $3e8179397014bb35$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $3e8179397014bb35$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $3e8179397014bb35$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $3e8179397014bb35$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $3e8179397014bb35$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $3e8179397014bb35$var$resolveTo(to ? to : ".", $3e8179397014bb35$var$getResolveToMatches(contextualMatches), $3e8179397014bb35$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $3e8179397014bb35$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $3e8179397014bb35$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $3e8179397014bb35$export$fe53371bee54353d(path);
}
function $3e8179397014bb35$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$3e8179397014bb35$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$3e8179397014bb35$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $3e8179397014bb35$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $3e8179397014bb35$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $3e8179397014bb35$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$3e8179397014bb35$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$3e8179397014bb35$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $3e8179397014bb35$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $3e8179397014bb35$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $3e8179397014bb35$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $3e8179397014bb35$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $3e8179397014bb35$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($3e8179397014bb35$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $3e8179397014bb35$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $3e8179397014bb35$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $3e8179397014bb35$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $3e8179397014bb35$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $3e8179397014bb35$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $3e8179397014bb35$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$3e8179397014bb35$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $3e8179397014bb35$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($3e8179397014bb35$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($3e8179397014bb35$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $3e8179397014bb35$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $3e8179397014bb35$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $3e8179397014bb35$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $3e8179397014bb35$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($3e8179397014bb35$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $3e8179397014bb35$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $3e8179397014bb35$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$3e8179397014bb35$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $3e8179397014bb35$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $3e8179397014bb35$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $3e8179397014bb35$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $3e8179397014bb35$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $3e8179397014bb35$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$3e8179397014bb35$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $3e8179397014bb35$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $3e8179397014bb35$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $3e8179397014bb35$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$3e8179397014bb35$var$isSameRoute(aChild, bChild))) ?? false;
}
var $3e8179397014bb35$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $3e8179397014bb35$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $3e8179397014bb35$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $3e8179397014bb35$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $3e8179397014bb35$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $3e8179397014bb35$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $3e8179397014bb35$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $3e8179397014bb35$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $3e8179397014bb35$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $3e8179397014bb35$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $3e8179397014bb35$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $3e8179397014bb35$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $3e8179397014bb35$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $3e8179397014bb35$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $3e8179397014bb35$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $3e8179397014bb35$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $3e8179397014bb35$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $3e8179397014bb35$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $3e8179397014bb35$var$isNonNullable(value) {
    return value !== void 0;
}
function $3e8179397014bb35$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $3e8179397014bb35$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($3e8179397014bb35$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $3e8179397014bb35$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $3e8179397014bb35$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $3e8179397014bb35$var$defaultDataStrategy(args);
    return $3e8179397014bb35$var$runClientMiddlewarePipeline(args, ()=>$3e8179397014bb35$var$defaultDataStrategy(args));
}
function $3e8179397014bb35$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $3e8179397014bb35$var$runMiddlewarePipeline(args, handler, processResult, $3e8179397014bb35$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $3e8179397014bb35$export$e0163cfdf7bc9cfa(result) ? $3e8179397014bb35$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $3e8179397014bb35$var$runClientMiddlewarePipeline(args, handler) {
    return $3e8179397014bb35$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($3e8179397014bb35$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $3e8179397014bb35$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $3e8179397014bb35$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $3e8179397014bb35$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $3e8179397014bb35$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $3e8179397014bb35$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $3e8179397014bb35$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $3e8179397014bb35$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $3e8179397014bb35$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $3e8179397014bb35$var$loadLazyRoute(match.route, $3e8179397014bb35$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $3e8179397014bb35$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $3e8179397014bb35$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $3e8179397014bb35$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $3e8179397014bb35$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$3e8179397014bb35$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($3e8179397014bb35$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $3e8179397014bb35$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $3e8179397014bb35$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $3e8179397014bb35$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $3e8179397014bb35$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $3e8179397014bb35$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $3e8179397014bb35$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $3e8179397014bb35$var$createDataFunctionUrl(request, path),
        pattern: $3e8179397014bb35$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $3e8179397014bb35$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $3e8179397014bb35$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $3e8179397014bb35$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $3e8179397014bb35$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $3e8179397014bb35$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $3e8179397014bb35$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $3e8179397014bb35$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $3e8179397014bb35$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $3e8179397014bb35$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $3e8179397014bb35$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($3e8179397014bb35$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $3e8179397014bb35$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $3e8179397014bb35$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $3e8179397014bb35$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($3e8179397014bb35$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $3e8179397014bb35$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $3e8179397014bb35$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$3e8179397014bb35$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $3e8179397014bb35$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $3e8179397014bb35$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $3e8179397014bb35$export$961a3ef7a4da3a39(location) {
    try {
        return $3e8179397014bb35$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $3e8179397014bb35$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($3e8179397014bb35$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $3e8179397014bb35$export$825a82322d91916e.test(normalizedLocation) ? new URL($3e8179397014bb35$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($3e8179397014bb35$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $3e8179397014bb35$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $3e8179397014bb35$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($3e8179397014bb35$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $3e8179397014bb35$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($3e8179397014bb35$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $3e8179397014bb35$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $3e8179397014bb35$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $3e8179397014bb35$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $3e8179397014bb35$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $3e8179397014bb35$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $3e8179397014bb35$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $3e8179397014bb35$export$f5708dca728d7177(!$3e8179397014bb35$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($3e8179397014bb35$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $3e8179397014bb35$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $3e8179397014bb35$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $3e8179397014bb35$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $3e8179397014bb35$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $3e8179397014bb35$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $3e8179397014bb35$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($3e8179397014bb35$var$isErrorResult(result)) {
            let boundaryMatch = $3e8179397014bb35$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($3e8179397014bb35$var$isRedirectResult(result)) $3e8179397014bb35$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $3e8179397014bb35$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $3e8179397014bb35$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $3e8179397014bb35$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $3e8179397014bb35$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $3e8179397014bb35$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $3e8179397014bb35$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $3e8179397014bb35$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $3e8179397014bb35$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $3e8179397014bb35$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $3e8179397014bb35$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($3e8179397014bb35$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $3e8179397014bb35$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(path) : path;
    return $3e8179397014bb35$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $3e8179397014bb35$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $3e8179397014bb35$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $3e8179397014bb35$var$dataWithResponseInitToErrorResponse(data2) {
    return new $3e8179397014bb35$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $3e8179397014bb35$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $3e8179397014bb35$var$isDataStrategyResult(value));
}
function $3e8179397014bb35$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $3e8179397014bb35$var$isRedirectDataStrategyResult(result) {
    return $3e8179397014bb35$export$3f1eb41d9a6a6a27(result.result) && $3e8179397014bb35$var$redirectStatusCodes.has(result.result.status);
}
function $3e8179397014bb35$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $3e8179397014bb35$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $3e8179397014bb35$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $3e8179397014bb35$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $3e8179397014bb35$export$794b2760043cf8cd(statusCode) {
    return $3e8179397014bb35$var$redirectStatusCodes.has(statusCode);
}
function $3e8179397014bb35$export$6e80290866a84dd4(result) {
    return $3e8179397014bb35$export$3f1eb41d9a6a6a27(result) && $3e8179397014bb35$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $3e8179397014bb35$var$isValidMethod(method) {
    return $3e8179397014bb35$var$validRequestMethods.has(method.toUpperCase());
}
function $3e8179397014bb35$export$cbae47800eb95bc3(method) {
    return $3e8179397014bb35$var$validMutationMethods.has(method.toUpperCase());
}
function $3e8179397014bb35$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $3e8179397014bb35$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $3e8179397014bb35$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $3e8179397014bb35$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $3e8179397014bb35$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $3e8179397014bb35$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $3e8179397014bb35$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $3e8179397014bb35$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $3e8179397014bb35$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $3e8179397014bb35$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $3e8179397014bb35$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($3e8179397014bb35$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $3e8179397014bb35$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($3e8179397014bb35$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $3e8179397014bb35$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $3e8179397014bb35$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $3e8179397014bb35$export$2eeee58951ff3c1c = $acw62.createContext(null);
$3e8179397014bb35$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $3e8179397014bb35$export$315e3ffb01f217 = $acw62.createContext(null);
$3e8179397014bb35$export$315e3ffb01f217.displayName = "DataRouterState";
var $3e8179397014bb35$export$717f757c655223f1 = $acw62.createContext(false);
function $3e8179397014bb35$var$useIsRSCRouterContext() {
    return $acw62.useContext($3e8179397014bb35$export$717f757c655223f1);
}
var $3e8179397014bb35$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$3e8179397014bb35$export$3681f408decb40d1.displayName = "ViewTransition";
var $3e8179397014bb35$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$3e8179397014bb35$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $3e8179397014bb35$var$AwaitContext = $acw62.createContext(null);
$3e8179397014bb35$var$AwaitContext.displayName = "Await";
var $3e8179397014bb35$export$2666c20e15407622 = (props)=>$acw62.createElement($3e8179397014bb35$var$AwaitContext.Provider, props);
var $3e8179397014bb35$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$3e8179397014bb35$export$3044ab7fdabeaee6.displayName = "Navigation";
var $3e8179397014bb35$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$3e8179397014bb35$export$e6a44b110a0c44d3.displayName = "Location";
var $3e8179397014bb35$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$3e8179397014bb35$export$aac280ed165a4397.displayName = "Route";
var $3e8179397014bb35$var$RouteErrorContext = $acw62.createContext(null);
$3e8179397014bb35$var$RouteErrorContext.displayName = "RouteError";
var $3e8179397014bb35$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $3e8179397014bb35$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $3e8179397014bb35$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $3e8179397014bb35$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $3e8179397014bb35$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$3e8179397014bb35$var$ERROR_DIGEST_BASE}:${$3e8179397014bb35$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $3e8179397014bb35$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$3e8179397014bb35$var$ERROR_DIGEST_BASE}:${$3e8179397014bb35$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $3e8179397014bb35$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $3e8179397014bb35$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $3e8179397014bb35$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $3e8179397014bb35$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $3e8179397014bb35$export$9c954a9d03d32f4a() {
    return $acw62.useContext($3e8179397014bb35$export$e6a44b110a0c44d3) != null;
}
function $3e8179397014bb35$export$45d76561a5302f2b() {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($3e8179397014bb35$export$e6a44b110a0c44d3).location;
}
function $3e8179397014bb35$export$1b3f31771c5d07c() {
    return $acw62.useContext($3e8179397014bb35$export$e6a44b110a0c44d3).navigationType;
}
function $3e8179397014bb35$export$6c330e8992e8a295(pattern) {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $3e8179397014bb35$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$3e8179397014bb35$export$81336c211d5ff295(pattern, $3e8179397014bb35$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $3e8179397014bb35$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $3e8179397014bb35$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $3e8179397014bb35$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    return isDataRoute ? $3e8179397014bb35$var$useNavigateStable() : $3e8179397014bb35$var$useNavigateUnstable();
}
function $3e8179397014bb35$var$useNavigateUnstable() {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let { pathname: locationPathname } = $3e8179397014bb35$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($3e8179397014bb35$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $3e8179397014bb35$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $3e8179397014bb35$var$warning(activeRef.current, $3e8179397014bb35$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $3e8179397014bb35$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $3e8179397014bb35$var$joinPaths([
            basename,
            path.pathname
        ]);
        $3e8179397014bb35$export$6c8e41f66e7aa990(typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to), navigator.createHref(path), $3e8179397014bb35$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $3e8179397014bb35$var$OutletContext = $acw62.createContext(null);
function $3e8179397014bb35$export$4138103a3ae699cc() {
    return $acw62.useContext($3e8179397014bb35$var$OutletContext);
}
function $3e8179397014bb35$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $3e8179397014bb35$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $3e8179397014bb35$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let { pathname: locationPathname } = $3e8179397014bb35$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($3e8179397014bb35$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$3e8179397014bb35$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $3e8179397014bb35$export$5d3fca4a98652595(routes, locationArg) {
    return $3e8179397014bb35$var$useRoutesImpl(routes, locationArg);
}
function $3e8179397014bb35$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($3e8179397014bb35$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $3e8179397014bb35$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $3e8179397014bb35$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $3e8179397014bb35$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $3e8179397014bb35$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $3e8179397014bb35$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($3e8179397014bb35$export$945fecf35a8ef089) {
        $3e8179397014bb35$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $3e8179397014bb35$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $3e8179397014bb35$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $3e8179397014bb35$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $3e8179397014bb35$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $3e8179397014bb35$var$DefaultErrorComponent() {
    let error = $3e8179397014bb35$export$ed527bf60f6e05f2();
    let message = $3e8179397014bb35$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($3e8179397014bb35$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\u{1F4BF} Hey developer \u{1F44B}"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $3e8179397014bb35$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$DefaultErrorComponent, null);
var $3e8179397014bb35$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $3e8179397014bb35$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$3e8179397014bb35$var$RenderErrorBoundary.contextType = $3e8179397014bb35$export$717f757c655223f1;
var $3e8179397014bb35$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $3e8179397014bb35$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $3e8179397014bb35$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $3e8179397014bb35$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $3e8179397014bb35$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $3e8179397014bb35$export$6c8e41f66e7aa990(redirect2.location, target, $3e8179397014bb35$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($3e8179397014bb35$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($3e8179397014bb35$var$isBrowser && !$3e8179397014bb35$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $3e8179397014bb35$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $3e8179397014bb35$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $3e8179397014bb35$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $3e8179397014bb35$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $3e8179397014bb35$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $3e8179397014bb35$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $3e8179397014bb35$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $3e8179397014bb35$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $3e8179397014bb35$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    $3e8179397014bb35$export$f5708dca728d7177(ctx, $3e8179397014bb35$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $3e8179397014bb35$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($3e8179397014bb35$export$315e3ffb01f217);
    $3e8179397014bb35$export$f5708dca728d7177(state, $3e8179397014bb35$var$getDataRouterConsoleError(hookName));
    return state;
}
function $3e8179397014bb35$var$useRouteContext(hookName) {
    let route = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    $3e8179397014bb35$export$f5708dca728d7177(route, $3e8179397014bb35$var$getDataRouterConsoleError(hookName));
    return route;
}
function $3e8179397014bb35$var$useCurrentRouteId(hookName) {
    let route = $3e8179397014bb35$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $3e8179397014bb35$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $3e8179397014bb35$var$useRouteId() {
    return $3e8179397014bb35$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $3e8179397014bb35$export$d0fd4b7106de2769() {
    let state = $3e8179397014bb35$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $acw62.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $3e8179397014bb35$export$600dc272ed516c15() {
    let dataRouterContext = $3e8179397014bb35$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $3e8179397014bb35$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $3e8179397014bb35$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $3e8179397014bb35$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$3e8179397014bb35$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $3e8179397014bb35$export$1448a5050d252c4d() {
    let state = $3e8179397014bb35$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $3e8179397014bb35$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $3e8179397014bb35$export$fd5d37484eab868d(routeId) {
    let state = $3e8179397014bb35$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $3e8179397014bb35$export$fdc00f3f26066d5e() {
    let state = $3e8179397014bb35$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $3e8179397014bb35$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $3e8179397014bb35$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($3e8179397014bb35$var$RouteErrorContext);
    let state = $3e8179397014bb35$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $3e8179397014bb35$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $3e8179397014bb35$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($3e8179397014bb35$var$AwaitContext);
    return value?._data;
}
function $3e8179397014bb35$export$17f53340677d5831() {
    let value = $acw62.useContext($3e8179397014bb35$var$AwaitContext);
    return value?._error;
}
var $3e8179397014bb35$var$blockerId = 0;
function $3e8179397014bb35$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $3e8179397014bb35$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $3e8179397014bb35$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $3e8179397014bb35$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $3e8179397014bb35$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$3e8179397014bb35$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $3e8179397014bb35$export$386d57f03f0b2883;
}
function $3e8179397014bb35$var$useNavigateStable() {
    let { router: router } = $3e8179397014bb35$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $3e8179397014bb35$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $3e8179397014bb35$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $3e8179397014bb35$var$warning(activeRef.current, $3e8179397014bb35$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $3e8179397014bb35$var$alreadyWarned = {};
function $3e8179397014bb35$var$warningOnce(key, cond, message) {
    if (!cond && !$3e8179397014bb35$var$alreadyWarned[key]) {
        $3e8179397014bb35$var$alreadyWarned[key] = true;
        $3e8179397014bb35$var$warning(false, message);
    }
}
function $3e8179397014bb35$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $3e8179397014bb35$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $3e8179397014bb35$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $3e8179397014bb35$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $3e8179397014bb35$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $3e8179397014bb35$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $acw62.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$3e8179397014bb35$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $acw62.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$3e8179397014bb35$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $acw62.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $3e8179397014bb35$var$alreadyWarned2 = {};
function $3e8179397014bb35$export$5b28268982f175ba(condition, message) {
    if (!condition && !$3e8179397014bb35$var$alreadyWarned2[message]) {
        $3e8179397014bb35$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $3e8179397014bb35$var$USE_OPTIMISTIC = "useOptimistic";
var $3e8179397014bb35$var$useOptimisticImpl = $acw62[$3e8179397014bb35$var$USE_OPTIMISTIC];
var $3e8179397014bb35$var$stableUseOptimisticSetter = ()=>void 0;
function $3e8179397014bb35$var$useOptimisticSafe(val) {
    if ($3e8179397014bb35$var$useOptimisticImpl) return $3e8179397014bb35$var$useOptimisticImpl(val);
    else return [
        val,
        $3e8179397014bb35$var$stableUseOptimisticSetter
    ];
}
function $3e8179397014bb35$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($3e8179397014bb35$export$945fecf35a8ef089) {
            if (route.element) $3e8179397014bb35$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($3e8179397014bb35$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $3e8179397014bb35$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($3e8179397014bb35$export$945fecf35a8ef089) {
            if (route.errorElement) $3e8179397014bb35$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $3e8179397014bb35$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $3e8179397014bb35$export$f30f7e456d254e83(routes, opts) {
    return $3e8179397014bb35$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $3e8179397014bb35$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $3e8179397014bb35$export$e2fd2c03906469db,
        mapRouteProperties: $3e8179397014bb35$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $3e8179397014bb35$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $3e8179397014bb35$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $3e8179397014bb35$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = $3e8179397014bb35$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $3e8179397014bb35$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $3e8179397014bb35$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $3e8179397014bb35$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$3e8179397014bb35$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $3e8179397014bb35$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$3e8179397014bb35$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $3e8179397014bb35$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $3e8179397014bb35$var$MemoizedDataRoutes = $acw62.memo($3e8179397014bb35$var$DataRoutes2);
function $3e8179397014bb35$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $3e8179397014bb35$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $3e8179397014bb35$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $3e8179397014bb35$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $3e8179397014bb35$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $3e8179397014bb35$export$f5708dca728d7177($3e8179397014bb35$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    $3e8179397014bb35$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let { pathname: locationPathname } = $3e8179397014bb35$export$45d76561a5302f2b();
    let navigate = $3e8179397014bb35$export$9770f232ac06a008();
    let path = $3e8179397014bb35$var$resolveTo(to, $3e8179397014bb35$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $3e8179397014bb35$export$6c8e41f66e7aa990(typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to), navigator.createHref(path), $3e8179397014bb35$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $3e8179397014bb35$export$910ae8079b2c2852(props) {
    return $3e8179397014bb35$export$a3be3530d8e40d0b(props.context);
}
function $3e8179397014bb35$export$e7b0ac011bb776c6(props) {
    $3e8179397014bb35$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $3e8179397014bb35$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $3e8179397014bb35$export$f5708dca728d7177(!$3e8179397014bb35$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $3e8179397014bb35$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $3e8179397014bb35$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $3e8179397014bb35$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $3e8179397014bb35$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $3e8179397014bb35$export$5d3fca4a98652595($3e8179397014bb35$export$16da398f5434bdec(children), location);
}
function $3e8179397014bb35$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $acw62.useContext($3e8179397014bb35$export$315e3ffb01f217);
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $3e8179397014bb35$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$ResolveAwait, null, children));
}
var $3e8179397014bb35$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $3e8179397014bb35$var$ResolveAwait({ children: children }) {
    let data2 = $3e8179397014bb35$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $3e8179397014bb35$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $3e8179397014bb35$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $3e8179397014bb35$export$f5708dca728d7177(element.type === $3e8179397014bb35$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $3e8179397014bb35$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $3e8179397014bb35$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $3e8179397014bb35$export$9b5b6d122dea0c88 = $3e8179397014bb35$export$16da398f5434bdec;
function $3e8179397014bb35$export$daf73786167a7f72(matches) {
    return $3e8179397014bb35$var$_renderMatches(matches);
}
function $3e8179397014bb35$var$useRouteComponentProps() {
    return {
        params: $3e8179397014bb35$export$99eaa27ddbbb95ef(),
        loaderData: $3e8179397014bb35$export$1448a5050d252c4d(),
        actionData: $3e8179397014bb35$export$fdc00f3f26066d5e(),
        matches: $3e8179397014bb35$export$2378eb7f5ff86053()
    };
}
function $3e8179397014bb35$export$6c4f3826290c37af({ children: children }) {
    const props = $3e8179397014bb35$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $3e8179397014bb35$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $3e8179397014bb35$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $3e8179397014bb35$var$useHydrateFallbackProps() {
    return {
        params: $3e8179397014bb35$export$99eaa27ddbbb95ef(),
        loaderData: $3e8179397014bb35$export$1448a5050d252c4d(),
        actionData: $3e8179397014bb35$export$fdc00f3f26066d5e()
    };
}
function $3e8179397014bb35$export$f8cff34f39c1932a({ children: children }) {
    const props = $3e8179397014bb35$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $3e8179397014bb35$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $3e8179397014bb35$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $3e8179397014bb35$var$useErrorBoundaryProps() {
    return {
        params: $3e8179397014bb35$export$99eaa27ddbbb95ef(),
        loaderData: $3e8179397014bb35$export$1448a5050d252c4d(),
        actionData: $3e8179397014bb35$export$fdc00f3f26066d5e(),
        error: $3e8179397014bb35$export$ed527bf60f6e05f2()
    };
}
function $3e8179397014bb35$export$e5afde5c4b6d747b({ children: children }) {
    const props = $3e8179397014bb35$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $3e8179397014bb35$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $3e8179397014bb35$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $3e8179397014bb35$var$defaultMethod = "get";
var $3e8179397014bb35$var$defaultEncType = "application/x-www-form-urlencoded";
function $3e8179397014bb35$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $3e8179397014bb35$var$isButtonElement(object) {
    return $3e8179397014bb35$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $3e8179397014bb35$var$isFormElement(object) {
    return $3e8179397014bb35$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $3e8179397014bb35$var$isInputElement(object) {
    return $3e8179397014bb35$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $3e8179397014bb35$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $3e8179397014bb35$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$3e8179397014bb35$var$isModifiedEvent(event);
}
function $3e8179397014bb35$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $3e8179397014bb35$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $3e8179397014bb35$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $3e8179397014bb35$var$_formDataSupportsSubmitter = null;
function $3e8179397014bb35$var$isFormDataSubmitterSupported() {
    if ($3e8179397014bb35$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $3e8179397014bb35$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $3e8179397014bb35$var$_formDataSupportsSubmitter = true;
    }
    return $3e8179397014bb35$var$_formDataSupportsSubmitter;
}
var $3e8179397014bb35$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $3e8179397014bb35$var$getFormEncType(encType) {
    if (encType != null && !$3e8179397014bb35$var$supportedFormEncTypes.has(encType)) {
        $3e8179397014bb35$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$3e8179397014bb35$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $3e8179397014bb35$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($3e8179397014bb35$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $3e8179397014bb35$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $3e8179397014bb35$var$defaultMethod;
        encType = $3e8179397014bb35$var$getFormEncType(target.getAttribute("enctype")) || $3e8179397014bb35$var$defaultEncType;
        formData = new FormData(target);
    } else if ($3e8179397014bb35$var$isButtonElement(target) || $3e8179397014bb35$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $3e8179397014bb35$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $3e8179397014bb35$var$defaultMethod;
        encType = $3e8179397014bb35$var$getFormEncType(target.getAttribute("formenctype")) || $3e8179397014bb35$var$getFormEncType(form.getAttribute("enctype")) || $3e8179397014bb35$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$3e8179397014bb35$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($3e8179397014bb35$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $3e8179397014bb35$var$defaultMethod;
        action = null;
        encType = $3e8179397014bb35$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $3e8179397014bb35$var$HOLE = -1;
var $3e8179397014bb35$var$NAN = -2;
var $3e8179397014bb35$var$NEGATIVE_INFINITY = -3;
var $3e8179397014bb35$var$NEGATIVE_ZERO = -4;
var $3e8179397014bb35$var$NULL = -5;
var $3e8179397014bb35$var$POSITIVE_INFINITY = -6;
var $3e8179397014bb35$var$UNDEFINED = -7;
var $3e8179397014bb35$var$TYPE_BIGINT = "B";
var $3e8179397014bb35$var$TYPE_DATE = "D";
var $3e8179397014bb35$var$TYPE_ERROR = "E";
var $3e8179397014bb35$var$TYPE_MAP = "M";
var $3e8179397014bb35$var$TYPE_NULL_OBJECT = "N";
var $3e8179397014bb35$var$TYPE_PROMISE = "P";
var $3e8179397014bb35$var$TYPE_REGEXP = "R";
var $3e8179397014bb35$var$TYPE_SET = "S";
var $3e8179397014bb35$var$TYPE_SYMBOL = "Y";
var $3e8179397014bb35$var$TYPE_URL = "U";
var $3e8179397014bb35$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $3e8179397014bb35$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $3e8179397014bb35$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $3e8179397014bb35$var$TIME_LIMIT_MS = 1;
var $3e8179397014bb35$var$getNow = ()=>Date.now();
var $3e8179397014bb35$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $3e8179397014bb35$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $3e8179397014bb35$var$UNDEFINED;
    if (input === null) return $3e8179397014bb35$var$NULL;
    if (Number.isNaN(input)) return $3e8179397014bb35$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $3e8179397014bb35$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $3e8179397014bb35$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $3e8179397014bb35$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $3e8179397014bb35$var$stringify.call(this, stack);
    return index;
}
async function $3e8179397014bb35$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $3e8179397014bb35$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $3e8179397014bb35$var$UNDEFINED;
        if (value === null) return $3e8179397014bb35$var$NULL;
        if (Number.isNaN(value)) return $3e8179397014bb35$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $3e8179397014bb35$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $3e8179397014bb35$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $3e8179397014bb35$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $3e8179397014bb35$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $3e8179397014bb35$var$TIME_LIMIT_MS) {
            await $3e8179397014bb35$var$yieldToMain();
            lastYieldTime = $3e8179397014bb35$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$3e8179397014bb35$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$3e8179397014bb35$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$3e8179397014bb35$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $3e8179397014bb35$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$3e8179397014bb35$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$3e8179397014bb35$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$3e8179397014bb35$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$3e8179397014bb35$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$3e8179397014bb35$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$3e8179397014bb35$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$3e8179397014bb35$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$3e8179397014bb35$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$3e8179397014bb35$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$3e8179397014bb35$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($3e8179397014bb35$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $3e8179397014bb35$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $3e8179397014bb35$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $3e8179397014bb35$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $3e8179397014bb35$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $3e8179397014bb35$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $3e8179397014bb35$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $3e8179397014bb35$var$hydrate.call(this, startIndex);
}
function $3e8179397014bb35$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $3e8179397014bb35$var$UNDEFINED:
                set(void 0);
                continue;
            case $3e8179397014bb35$var$NULL:
                set(null);
                continue;
            case $3e8179397014bb35$var$NAN:
                set(NaN);
                continue;
            case $3e8179397014bb35$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $3e8179397014bb35$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $3e8179397014bb35$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $3e8179397014bb35$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $3e8179397014bb35$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $3e8179397014bb35$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $3e8179397014bb35$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $3e8179397014bb35$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $3e8179397014bb35$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $3e8179397014bb35$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $3e8179397014bb35$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $3e8179397014bb35$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $3e8179397014bb35$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $3e8179397014bb35$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $3e8179397014bb35$var$globalObj && $3e8179397014bb35$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $3e8179397014bb35$var$globalObj && typeof $3e8179397014bb35$var$globalObj[errorType] === "function" ? new $3e8179397014bb35$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $3e8179397014bb35$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $3e8179397014bb35$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $3e8179397014bb35$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $3e8179397014bb35$var$Deferred2();
    const reader = readable.pipeThrough($3e8179397014bb35$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $3e8179397014bb35$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $3e8179397014bb35$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $3e8179397014bb35$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $3e8179397014bb35$var$unflatten.call(this, line)
    };
}
async function $3e8179397014bb35$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $3e8179397014bb35$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $3e8179397014bb35$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $3e8179397014bb35$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $3e8179397014bb35$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $3e8179397014bb35$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $3e8179397014bb35$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $3e8179397014bb35$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_PROMISE}${deferredId}:[["${$3e8179397014bb35$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $3e8179397014bb35$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_ERROR}${deferredId}:[["${$3e8179397014bb35$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$3e8179397014bb35$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $3e8179397014bb35$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $3e8179397014bb35$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $3e8179397014bb35$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $3e8179397014bb35$export$4cf11838cdc2a8a8(html) {
    return html.replace($3e8179397014bb35$var$ESCAPE_REGEX, (match)=>$3e8179397014bb35$var$ESCAPE_LOOKUP[match]);
}
function $3e8179397014bb35$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
// lib/dom/ssr/invariant.ts
function $3e8179397014bb35$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $3e8179397014bb35$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $3e8179397014bb35$var$SingleFetchNoResultError = class extends Error {
};
var $3e8179397014bb35$export$ae9272e641ead836 = 202;
var $3e8179397014bb35$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $3e8179397014bb35$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$3e8179397014bb35$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $3e8179397014bb35$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $3e8179397014bb35$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $3e8179397014bb35$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $3e8179397014bb35$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $3e8179397014bb35$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $3e8179397014bb35$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $3e8179397014bb35$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $3e8179397014bb35$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $3e8179397014bb35$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $3e8179397014bb35$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $3e8179397014bb35$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $3e8179397014bb35$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($3e8179397014bb35$export$3f1eb41d9a6a6a27(result.result) || $3e8179397014bb35$export$972111febbeef05b(result.result) || $3e8179397014bb35$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $3e8179397014bb35$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $3e8179397014bb35$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $3e8179397014bb35$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $3e8179397014bb35$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$3e8179397014bb35$var$createDeferred2());
    let singleFetchDfd = $3e8179397014bb35$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $3e8179397014bb35$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $3e8179397014bb35$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $3e8179397014bb35$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $3e8179397014bb35$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $3e8179397014bb35$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $3e8179397014bb35$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $3e8179397014bb35$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $3e8179397014bb35$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $3e8179397014bb35$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $3e8179397014bb35$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $3e8179397014bb35$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$3e8179397014bb35$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$3e8179397014bb35$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $3e8179397014bb35$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $3e8179397014bb35$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $3e8179397014bb35$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $3e8179397014bb35$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $3e8179397014bb35$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $3e8179397014bb35$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($3e8179397014bb35$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $3e8179397014bb35$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $3e8179397014bb35$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($3e8179397014bb35$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$3e8179397014bb35$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $3e8179397014bb35$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $3e8179397014bb35$export$4023ad4ecd4126a2(body, global) {
    return $3e8179397014bb35$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $3e8179397014bb35$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $3e8179397014bb35$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$3e8179397014bb35$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $3e8179397014bb35$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $3e8179397014bb35$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $3e8179397014bb35$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $3e8179397014bb35$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $3e8179397014bb35$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $3e8179397014bb35$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $3e8179397014bb35$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $3e8179397014bb35$var$getModuleLinkHrefs(matches, manifest);
    return $3e8179397014bb35$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $3e8179397014bb35$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $3e8179397014bb35$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $3e8179397014bb35$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($3e8179397014bb35$var$prefetchStyleLink));
}
async function $3e8179397014bb35$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$3e8179397014bb35$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$3e8179397014bb35$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$3e8179397014bb35$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($3e8179397014bb35$var$prefetchStyleLink));
}
async function $3e8179397014bb35$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $3e8179397014bb35$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $3e8179397014bb35$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $3e8179397014bb35$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $3e8179397014bb35$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $3e8179397014bb35$var$dedupeLinkDescriptors(links.flat(1).filter($3e8179397014bb35$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $3e8179397014bb35$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $3e8179397014bb35$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $3e8179397014bb35$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $3e8179397014bb35$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $3e8179397014bb35$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $3e8179397014bb35$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$3e8179397014bb35$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($3e8179397014bb35$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $3e8179397014bb35$var$_isPreloadSupported;
function $3e8179397014bb35$var$isPreloadSupported() {
    if ($3e8179397014bb35$var$_isPreloadSupported !== void 0) return $3e8179397014bb35$var$_isPreloadSupported;
    let el = document.createElement("link");
    $3e8179397014bb35$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $3e8179397014bb35$var$_isPreloadSupported;
}
function $3e8179397014bb35$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $3e8179397014bb35$var$useFrameworkContext();
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $3e8179397014bb35$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $3e8179397014bb35$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $3e8179397014bb35$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $3e8179397014bb35$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $3e8179397014bb35$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RemixRootDefaultErrorBoundary, {
            error: $3e8179397014bb35$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $3e8179397014bb35$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $3e8179397014bb35$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $3e8179397014bb35$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$3e8179397014bb35$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $3e8179397014bb35$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $3e8179397014bb35$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $3e8179397014bb35$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $3e8179397014bb35$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $3e8179397014bb35$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $3e8179397014bb35$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $3e8179397014bb35$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $3e8179397014bb35$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $3e8179397014bb35$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $3e8179397014bb35$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $3e8179397014bb35$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $3e8179397014bb35$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $3e8179397014bb35$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$3e8179397014bb35$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $3e8179397014bb35$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $3e8179397014bb35$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $3e8179397014bb35$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $3e8179397014bb35$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $3e8179397014bb35$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $3e8179397014bb35$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $3e8179397014bb35$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $3e8179397014bb35$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $3e8179397014bb35$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $3e8179397014bb35$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $3e8179397014bb35$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $3e8179397014bb35$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $3e8179397014bb35$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $3e8179397014bb35$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $3e8179397014bb35$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $3e8179397014bb35$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $3e8179397014bb35$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $3e8179397014bb35$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $3e8179397014bb35$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $3e8179397014bb35$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $3e8179397014bb35$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $3e8179397014bb35$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $3e8179397014bb35$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $3e8179397014bb35$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $3e8179397014bb35$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $3e8179397014bb35$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $3e8179397014bb35$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $3e8179397014bb35$var$nextPaths = /* @__PURE__ */ new Set();
var $3e8179397014bb35$var$discoveredPathsMaxSize = 1e3;
var $3e8179397014bb35$var$discoveredPaths = /* @__PURE__ */ new Set();
var $3e8179397014bb35$export$b5915cf27fa06b9f = 7680;
function $3e8179397014bb35$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $3e8179397014bb35$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $3e8179397014bb35$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $3e8179397014bb35$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $3e8179397014bb35$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$3e8179397014bb35$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($3e8179397014bb35$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $3e8179397014bb35$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $3e8179397014bb35$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $3e8179397014bb35$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$3e8179397014bb35$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$3e8179397014bb35$var$discoveredPaths.has(pathname)) $3e8179397014bb35$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($3e8179397014bb35$var$nextPaths.keys()).filter((path)=>{
                if ($3e8179397014bb35$var$discoveredPaths.has(path)) {
                    $3e8179397014bb35$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $3e8179397014bb35$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $3e8179397014bb35$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $3e8179397014bb35$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $3e8179397014bb35$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $3e8179397014bb35$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $3e8179397014bb35$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $3e8179397014bb35$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($3e8179397014bb35$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $3e8179397014bb35$export$b5915cf27fa06b9f) {
        $3e8179397014bb35$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($3e8179397014bb35$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($3e8179397014bb35$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($3e8179397014bb35$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$3e8179397014bb35$var$addToFifoQueue(p, $3e8179397014bb35$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $3e8179397014bb35$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $3e8179397014bb35$var$addToFifoQueue(path, queue) {
    if (queue.size >= $3e8179397014bb35$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $3e8179397014bb35$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $3e8179397014bb35$var$useDataRouterContext2() {
    let context = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    $3e8179397014bb35$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $3e8179397014bb35$var$useDataRouterStateContext() {
    let context = $acw62.useContext($3e8179397014bb35$export$315e3ffb01f217);
    $3e8179397014bb35$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $3e8179397014bb35$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$3e8179397014bb35$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $3e8179397014bb35$var$useFrameworkContext() {
    let context = $acw62.useContext($3e8179397014bb35$export$208d6a3bc3aa62bd);
    $3e8179397014bb35$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $3e8179397014bb35$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($3e8179397014bb35$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $3e8179397014bb35$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $3e8179397014bb35$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $3e8179397014bb35$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $3e8179397014bb35$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $3e8179397014bb35$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $3e8179397014bb35$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $3e8179397014bb35$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$3e8179397014bb35$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $3e8179397014bb35$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $3e8179397014bb35$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $3e8179397014bb35$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $3e8179397014bb35$var$useDataRouterStateContext();
    let matches = $3e8179397014bb35$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$3e8179397014bb35$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$3e8179397014bb35$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$3e8179397014bb35$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$3e8179397014bb35$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $3e8179397014bb35$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $3e8179397014bb35$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $3e8179397014bb35$var$useFrameworkContext();
    let { router: router } = $3e8179397014bb35$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$3e8179397014bb35$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $3e8179397014bb35$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $3e8179397014bb35$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $3e8179397014bb35$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $3e8179397014bb35$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let { future: future } = $3e8179397014bb35$var$useFrameworkContext();
    let { basename: basename } = $3e8179397014bb35$var$useDataRouterContext2();
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $3e8179397014bb35$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $3e8179397014bb35$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $3e8179397014bb35$var$useFrameworkContext();
    let { basename: basename } = $3e8179397014bb35$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $3e8179397014bb35$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$3e8179397014bb35$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$3e8179397014bb35$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $3e8179397014bb35$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$3e8179397014bb35$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $3e8179397014bb35$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $3e8179397014bb35$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $3e8179397014bb35$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $3e8179397014bb35$var$useDataRouterStateContext();
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let _matches = $3e8179397014bb35$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$3e8179397014bb35$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $3e8179397014bb35$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $3e8179397014bb35$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $3e8179397014bb35$var$isHydrated = false;
function $3e8179397014bb35$export$3be068dde909e563() {
    $3e8179397014bb35$var$isHydrated = true;
}
function $3e8179397014bb35$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $3e8179397014bb35$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $3e8179397014bb35$var$useDataRouterContext2();
    let { matches: routerMatches } = $3e8179397014bb35$var$useDataRouterStateContext();
    let isRSCRouterContext = $3e8179397014bb35$var$useIsRSCRouterContext();
    let enableFogOfWar = $3e8179397014bb35$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $3e8179397014bb35$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $3e8179397014bb35$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $3e8179397014bb35$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($3e8179397014bb35$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $3e8179397014bb35$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($3e8179397014bb35$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $3e8179397014bb35$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $3e8179397014bb35$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $3e8179397014bb35$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $3e8179397014bb35$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $3e8179397014bb35$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $3e8179397014bb35$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($3e8179397014bb35$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $3e8179397014bb35$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $3e8179397014bb35$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $3e8179397014bb35$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$ff0bf87698939488, null) : null)));
}
var $3e8179397014bb35$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($3e8179397014bb35$var$isBrowser2) window.__reactRouterVersion = "7.18.4";
} catch (e) {}
function $3e8179397014bb35$export$1f3f55432a00e06d(routes, opts) {
    return $3e8179397014bb35$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $3e8179397014bb35$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $3e8179397014bb35$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $3e8179397014bb35$export$9269a41d8c4635e,
        hydrationRouteProperties: $3e8179397014bb35$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $3e8179397014bb35$export$1ba7ed8a3a7b3765(routes, opts) {
    return $3e8179397014bb35$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $3e8179397014bb35$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $3e8179397014bb35$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $3e8179397014bb35$export$9269a41d8c4635e,
        hydrationRouteProperties: $3e8179397014bb35$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $3e8179397014bb35$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $3e8179397014bb35$var$deserializeErrors(state.errors)
    };
    return state;
}
function $3e8179397014bb35$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $3e8179397014bb35$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $3e8179397014bb35$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $3e8179397014bb35$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $3e8179397014bb35$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $3e8179397014bb35$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $3e8179397014bb35$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $3e8179397014bb35$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$3e8179397014bb35$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $3e8179397014bb35$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $3e8179397014bb35$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $3e8179397014bb35$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $3e8179397014bb35$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $3e8179397014bb35$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $3e8179397014bb35$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $3e8179397014bb35$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $3e8179397014bb35$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $3e8179397014bb35$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$3e8179397014bb35$export$a6c7ac8248d6e38a.displayName = "Link";
var $3e8179397014bb35$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $3e8179397014bb35$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($3e8179397014bb35$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3e8179397014bb35$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $3e8179397014bb35$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$3e8179397014bb35$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $3e8179397014bb35$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $3e8179397014bb35$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let submit = $3e8179397014bb35$export$47c85c6e3a081d3();
    let formAction = $3e8179397014bb35$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $3e8179397014bb35$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$3e8179397014bb35$export$a7fed597f4b8afd8.displayName = "Form";
function $3e8179397014bb35$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($3e8179397014bb35$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let matches = $3e8179397014bb35$export$2378eb7f5ff86053();
    $3e8179397014bb35$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $3e8179397014bb35$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$3e8179397014bb35$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $3e8179397014bb35$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$3e8179397014bb35$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$3e8179397014bb35$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $3e8179397014bb35$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $3e8179397014bb35$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($3e8179397014bb35$export$2eeee58951ff3c1c);
    $3e8179397014bb35$export$f5708dca728d7177(ctx, $3e8179397014bb35$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $3e8179397014bb35$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($3e8179397014bb35$export$315e3ffb01f217);
    $3e8179397014bb35$export$f5708dca728d7177(state, $3e8179397014bb35$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $3e8179397014bb35$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $3e8179397014bb35$export$9770f232ac06a008();
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let path = $3e8179397014bb35$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($3e8179397014bb35$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $3e8179397014bb35$export$fe53371bee54353d(location) === $3e8179397014bb35$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $3e8179397014bb35$export$f1a78c17382fe22a(defaultInit) {
    $3e8179397014bb35$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($3e8179397014bb35$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $3e8179397014bb35$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $3e8179397014bb35$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $3e8179397014bb35$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $3e8179397014bb35$var$fetcherId = 0;
var $3e8179397014bb35$var$getUniqueFetcherId = ()=>`__${String(++$3e8179397014bb35$var$fetcherId)}__`;
function $3e8179397014bb35$export$47c85c6e3a081d3() {
    let { router: router } = $3e8179397014bb35$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let currentRouteId = $3e8179397014bb35$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $3e8179397014bb35$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $3e8179397014bb35$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $3e8179397014bb35$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    $3e8179397014bb35$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$3e8179397014bb35$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $3e8179397014bb35$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $3e8179397014bb35$export$fe53371bee54353d(path);
}
function $3e8179397014bb35$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $3e8179397014bb35$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $3e8179397014bb35$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($3e8179397014bb35$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($3e8179397014bb35$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $3e8179397014bb35$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $3e8179397014bb35$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $3e8179397014bb35$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $3e8179397014bb35$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $3e8179397014bb35$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $3e8179397014bb35$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $3e8179397014bb35$export$fa996778a3a31087() {
    let state = $3e8179397014bb35$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $acw62.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $3e8179397014bb35$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $3e8179397014bb35$var$savedScrollPositions = {};
function $3e8179397014bb35$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $3e8179397014bb35$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $3e8179397014bb35$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $3e8179397014bb35$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $3e8179397014bb35$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($3e8179397014bb35$export$3044ab7fdabeaee6);
    let location = $3e8179397014bb35$export$45d76561a5302f2b();
    let matches = $3e8179397014bb35$export$2378eb7f5ff86053();
    let navigation = $3e8179397014bb35$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $3e8179397014bb35$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $3e8179397014bb35$var$getScrollRestorationKey(location, matches, basename, getKey);
            $3e8179397014bb35$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $3e8179397014bb35$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($3e8179397014bb35$var$savedScrollPositions));
        } catch (error) {
            $3e8179397014bb35$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $3e8179397014bb35$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $3e8179397014bb35$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($3e8179397014bb35$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$3e8179397014bb35$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $3e8179397014bb35$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $3e8179397014bb35$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $3e8179397014bb35$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $3e8179397014bb35$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $3e8179397014bb35$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $3e8179397014bb35$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($3e8179397014bb35$export$3681f408decb40d1);
    $3e8179397014bb35$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $3e8179397014bb35$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $3e8179397014bb35$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $3e8179397014bb35$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $3e8179397014bb35$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $3e8179397014bb35$export$81336c211d5ff295(path.pathname, nextPath) != null || $3e8179397014bb35$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $3e8179397014bb35$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $3e8179397014bb35$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $3e8179397014bb35$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $3e8179397014bb35$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $3e8179397014bb35$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $3e8179397014bb35$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $3e8179397014bb35$var$serializeErrors(context.errors)
        };
        let json = $3e8179397014bb35$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $acw62.createElement($3e8179397014bb35$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $3e8179397014bb35$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($3e8179397014bb35$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $3e8179397014bb35$var$getStatelessNavigator() {
    return {
        createHref: $3e8179397014bb35$var$createHref,
        encodeLocation: $3e8179397014bb35$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $3e8179397014bb35$export$69163f0b72ec60d9(routes, opts) {
    return $3e8179397014bb35$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $3e8179397014bb35$export$9269a41d8c4635e
    });
}
function $3e8179397014bb35$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $3e8179397014bb35$export$87cb1a9238dc3fba(routes, $3e8179397014bb35$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $3e8179397014bb35$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $3e8179397014bb35$var$createHref,
        encodeLocation: $3e8179397014bb35$var$encodeLocation,
        getFetcher () {
            return $3e8179397014bb35$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $3e8179397014bb35$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $3e8179397014bb35$var$createHref(to) {
    return typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to);
}
function $3e8179397014bb35$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $3e8179397014bb35$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $3e8179397014bb35$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}



var $acw62 = parcelRequire("acw62");
var $9fd38747d73cb940$exports = {};
"use strict";
Object.defineProperty($9fd38747d73cb940$exports, "__esModule", {
    value: true
});
$9fd38747d73cb940$exports.parseCookie = $9fd38747d73cb940$var$parseCookie;
$9fd38747d73cb940$exports.parse = $9fd38747d73cb940$var$parseCookie;
$9fd38747d73cb940$exports.stringifyCookie = $9fd38747d73cb940$var$stringifyCookie;
$9fd38747d73cb940$exports.stringifySetCookie = $9fd38747d73cb940$var$stringifySetCookie;
$9fd38747d73cb940$exports.serialize = $9fd38747d73cb940$var$stringifySetCookie;
$9fd38747d73cb940$exports.parseSetCookie = $9fd38747d73cb940$var$parseSetCookie;
$9fd38747d73cb940$exports.stringifySetCookie = $9fd38747d73cb940$var$stringifySetCookie;
$9fd38747d73cb940$exports.serialize = $9fd38747d73cb940$var$stringifySetCookie;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $9fd38747d73cb940$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $9fd38747d73cb940$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $9fd38747d73cb940$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $9fd38747d73cb940$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
/**
 * RegExp to match max-age-value in RFC 6265 sec 5.6.2
 */ const $9fd38747d73cb940$var$maxAgeRegExp = /^-?\d+$/;
const $9fd38747d73cb940$var$__toString = Object.prototype.toString;
const $9fd38747d73cb940$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a `Cookie` header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $9fd38747d73cb940$var$parseCookie(str, options) {
    const obj = new $9fd38747d73cb940$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $9fd38747d73cb940$var$decode;
    let index = 0;
    do {
        const eqIdx = $9fd38747d73cb940$var$eqIndex(str, index, len);
        if (eqIdx === -1) break; // No more cookie pairs.
        const endIdx = $9fd38747d73cb940$var$endIndex(str, index, len);
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = $9fd38747d73cb940$var$valueSlice(str, index, eqIdx);
        // only assign once
        if (obj[key] === undefined) obj[key] = dec($9fd38747d73cb940$var$valueSlice(str, eqIdx + 1, endIdx));
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
/**
 * Stringifies an object into an HTTP `Cookie` header.
 */ function $9fd38747d73cb940$var$stringifyCookie(cookie, options) {
    const enc = options?.encode || encodeURIComponent;
    const cookieStrings = [];
    for (const name of Object.keys(cookie)){
        const val = cookie[name];
        if (val === undefined) continue;
        if (!$9fd38747d73cb940$var$cookieNameRegExp.test(name)) throw new TypeError(`cookie name is invalid: ${name}`);
        const value = enc(val);
        if (!$9fd38747d73cb940$var$cookieValueRegExp.test(value)) throw new TypeError(`cookie val is invalid: ${val}`);
        cookieStrings.push(`${name}=${value}`);
    }
    return cookieStrings.join("; ");
}
function $9fd38747d73cb940$var$stringifySetCookie(_name, _val, _opts) {
    const cookie = typeof _name === "object" ? _name : {
        ..._opts,
        name: _name,
        value: String(_val)
    };
    const options = typeof _val === "object" ? _val : _opts;
    const enc = options?.encode || encodeURIComponent;
    if (!$9fd38747d73cb940$var$cookieNameRegExp.test(cookie.name)) throw new TypeError(`argument name is invalid: ${cookie.name}`);
    const value = cookie.value ? enc(cookie.value) : "";
    if (!$9fd38747d73cb940$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${cookie.value}`);
    let str = cookie.name + "=" + value;
    if (cookie.maxAge !== undefined) {
        if (!Number.isInteger(cookie.maxAge)) throw new TypeError(`option maxAge is invalid: ${cookie.maxAge}`);
        str += "; Max-Age=" + cookie.maxAge;
    }
    if (cookie.domain) {
        if (!$9fd38747d73cb940$var$domainValueRegExp.test(cookie.domain)) throw new TypeError(`option domain is invalid: ${cookie.domain}`);
        str += "; Domain=" + cookie.domain;
    }
    if (cookie.path) {
        if (!$9fd38747d73cb940$var$pathValueRegExp.test(cookie.path)) throw new TypeError(`option path is invalid: ${cookie.path}`);
        str += "; Path=" + cookie.path;
    }
    if (cookie.expires) {
        if (!$9fd38747d73cb940$var$isDate(cookie.expires) || !Number.isFinite(cookie.expires.valueOf())) throw new TypeError(`option expires is invalid: ${cookie.expires}`);
        str += "; Expires=" + cookie.expires.toUTCString();
    }
    if (cookie.httpOnly) str += "; HttpOnly";
    if (cookie.secure) str += "; Secure";
    if (cookie.partitioned) str += "; Partitioned";
    if (cookie.priority) {
        const priority = typeof cookie.priority === "string" ? cookie.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${cookie.priority}`);
        }
    }
    if (cookie.sameSite) {
        const sameSite = typeof cookie.sameSite === "string" ? cookie.sameSite.toLowerCase() : cookie.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${cookie.sameSite}`);
        }
    }
    return str;
}
/**
 * Deserialize a `Set-Cookie` header into an object.
 *
 * deserialize('foo=bar; httpOnly')
 *   => { name: 'foo', value: 'bar', httpOnly: true }
 */ function $9fd38747d73cb940$var$parseSetCookie(str, options) {
    const dec = options?.decode || $9fd38747d73cb940$var$decode;
    const len = str.length;
    const endIdx = $9fd38747d73cb940$var$endIndex(str, 0, len);
    const eqIdx = $9fd38747d73cb940$var$eqIndex(str, 0, endIdx);
    const setCookie = eqIdx === -1 ? {
        name: "",
        value: dec($9fd38747d73cb940$var$valueSlice(str, 0, endIdx))
    } : {
        name: $9fd38747d73cb940$var$valueSlice(str, 0, eqIdx),
        value: dec($9fd38747d73cb940$var$valueSlice(str, eqIdx + 1, endIdx))
    };
    let index = endIdx + 1;
    while(index < len){
        const endIdx = $9fd38747d73cb940$var$endIndex(str, index, len);
        const eqIdx = $9fd38747d73cb940$var$eqIndex(str, index, endIdx);
        const attr = eqIdx === -1 ? $9fd38747d73cb940$var$valueSlice(str, index, endIdx) : $9fd38747d73cb940$var$valueSlice(str, index, eqIdx);
        const val = eqIdx === -1 ? undefined : $9fd38747d73cb940$var$valueSlice(str, eqIdx + 1, endIdx);
        switch(attr.toLowerCase()){
            case "httponly":
                setCookie.httpOnly = true;
                break;
            case "secure":
                setCookie.secure = true;
                break;
            case "partitioned":
                setCookie.partitioned = true;
                break;
            case "domain":
                setCookie.domain = val;
                break;
            case "path":
                setCookie.path = val;
                break;
            case "max-age":
                if (val && $9fd38747d73cb940$var$maxAgeRegExp.test(val)) setCookie.maxAge = Number(val);
                break;
            case "expires":
                if (!val) break;
                const date = new Date(val);
                if (Number.isFinite(date.valueOf())) setCookie.expires = date;
                break;
            case "priority":
                if (!val) break;
                const priority = val.toLowerCase();
                if (priority === "low" || priority === "medium" || priority === "high") setCookie.priority = priority;
                break;
            case "samesite":
                if (!val) break;
                const sameSite = val.toLowerCase();
                if (sameSite === "lax" || sameSite === "strict" || sameSite === "none") setCookie.sameSite = sameSite;
                break;
        }
        index = endIdx + 1;
    }
    return setCookie;
}
/**
 * Find the `;` character between `min` and `len` in str.
 */ function $9fd38747d73cb940$var$endIndex(str, min, len) {
    const index = str.indexOf(";", min);
    return index === -1 ? len : index;
}
/**
 * Find the `=` character between `min` and `max` in str.
 */ function $9fd38747d73cb940$var$eqIndex(str, min, max) {
    const index = str.indexOf("=", min);
    return index < max ? index : -1;
}
/**
 * Slice out a value between startPod to max.
 */ function $9fd38747d73cb940$var$valueSlice(str, min, max) {
    let start = min;
    let end = max;
    do {
        const code = str.charCodeAt(start);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
    }while (++start < end);
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
        end--;
    }
    return str.slice(start, end);
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $9fd38747d73cb940$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $9fd38747d73cb940$var$isDate(val) {
    return $9fd38747d73cb940$var$__toString.call(val) === "[object Date]";
}


var $e4a96bcce5e8f1ac$exports = {};
"use strict";
var $e4a96bcce5e8f1ac$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $e4a96bcce5e8f1ac$var$isForbiddenKey(key) {
    return typeof key !== "string" || key in {};
}
function $e4a96bcce5e8f1ac$var$createNullObj() {
    return Object.create(null);
}
function $e4a96bcce5e8f1ac$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $e4a96bcce5e8f1ac$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($e4a96bcce5e8f1ac$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $e4a96bcce5e8f1ac$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $e4a96bcce5e8f1ac$var$defaultParseOptions, options) : $e4a96bcce5e8f1ac$var$defaultParseOptions;
    if ($e4a96bcce5e8f1ac$var$isForbiddenKey(name)) return null;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser: failed to decode cookie value. Set options.decodeValues=false to disable decoding.", e);
    }
    var cookie = $e4a96bcce5e8f1ac$var$createNullObj();
    cookie.name = name;
    cookie.value = value;
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        if ($e4a96bcce5e8f1ac$var$isForbiddenKey(key)) return;
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") {
            var n = parseInt(value, 10);
            if (!Number.isNaN(n)) cookie.maxAge = n;
        } else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else if (key) cookie[key] = value;
    });
    return cookie;
}
function $e4a96bcce5e8f1ac$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $e4a96bcce5e8f1ac$var$parse(input, options) {
    options = options ? Object.assign({}, $e4a96bcce5e8f1ac$var$defaultParseOptions, options) : $e4a96bcce5e8f1ac$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return $e4a96bcce5e8f1ac$var$createNullObj();
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case)
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($e4a96bcce5e8f1ac$var$isNonEmptyString).map(function(str) {
        return $e4a96bcce5e8f1ac$var$parseString(str, options);
    }).filter(Boolean);
    else {
        var cookies = $e4a96bcce5e8f1ac$var$createNullObj();
        return input.filter($e4a96bcce5e8f1ac$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $e4a96bcce5e8f1ac$var$parseString(str, options);
            if (cookie && !$e4a96bcce5e8f1ac$var$isForbiddenKey(cookie.name)) cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $e4a96bcce5e8f1ac$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$e4a96bcce5e8f1ac$exports = $e4a96bcce5e8f1ac$var$parse;
$e4a96bcce5e8f1ac$exports.parse = $e4a96bcce5e8f1ac$var$parse;
$e4a96bcce5e8f1ac$exports.parseString = $e4a96bcce5e8f1ac$var$parseString;
$e4a96bcce5e8f1ac$exports.splitCookiesString = $e4a96bcce5e8f1ac$var$splitCookiesString;


function $e4c31f3f81f1e687$export$7246f7e18cebe1bd({ context: context, url: url, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = (0, $3e8179397014bb35$export$5be2318464878170)(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && (0, $3e8179397014bb35$export$6ac68922d4e92125)(routeId, route.clientLoader, manifestRoute.hasLoader, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = (0, $3e8179397014bb35$export$3dd6171c30258b6f)(routes, context.staticHandlerContext, {
        branches: context.branches
    });
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$208d6a3bc3aa62bd).Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            ssr: context.ssr,
            isSpaMode: context.isSpaMode,
            routeDiscovery: context.routeDiscovery,
            nonce: nonce,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$32e57f52df4b6e34), {
        location: router.state.location
    }, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$3d80f15952491985), {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$2b0b5f24fd77a79f), {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $e4c31f3f81f1e687$export$bea31554c7dfd2ad(routes, _context) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $acw62.useRef();
        let frameworkContextRef = $acw62.useRef();
        if (routerRef.current == null) {
            frameworkContextRef.current = {
                future: {
                    v8_passThroughRequests: future?.v8_passThroughRequests === true,
                    v8_middleware: future?.v8_middleware === true,
                    v8_trailingSlashAwareDataRequests: future?.v8_trailingSlashAwareDataRequests === true
                },
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                ssr: false,
                isSpaMode: false,
                routeDiscovery: {
                    mode: "lazy",
                    manifestPath: "/__manifest"
                }
            };
            let patched = $e4c31f3f81f1e687$var$processRoutes(// @ts-expect-error `StubRouteObject` is stricter about `loader`/`action`
            // types compared to `RouteObject`
            (0, $3e8179397014bb35$export$87cb1a9238dc3fba)(routes, (r)=>r), _context !== void 0 ? _context : future?.v8_middleware ? new (0, $3e8179397014bb35$export$b8d3e69d4b3eff04)() : {}, frameworkContextRef.current.manifest, frameworkContextRef.current.routeModules);
            routerRef.current = (0, $3e8179397014bb35$export$f30f7e456d254e83)(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$208d6a3bc3aa62bd).Provider, {
            value: frameworkContextRef.current
        }, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$323e4fc2fa4753fb), {
            router: routerRef.current
        }));
    };
}
function $e4c31f3f81f1e687$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in react-router processRoutes() function");
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component ? (0, $3e8179397014bb35$export$1a5de91a5c3255e0)(route.Component) : void 0,
            HydrateFallback: route.HydrateFallback ? (0, $3e8179397014bb35$export$cd4a5850c74ba029)(route.HydrateFallback) : void 0,
            ErrorBoundary: route.ErrorBoundary ? (0, $3e8179397014bb35$export$26aea97ad016e70c)(route.ErrorBoundary) : void 0,
            action: route.action ? (args)=>route.action({
                    ...args,
                    context: context
                }) : void 0,
            loader: route.loader ? (args)=>route.loader({
                    ...args,
                    context: context
                }) : void 0,
            middleware: route.middleware ? route.middleware.map((mw)=>(...args)=>mw({
                        ...args[0],
                        context: context
                    }, args[1])) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should be stubbing loader/action/middleware,
            // not trying to re-implement the full loader/clientLoader/SSR/hydration
            // flow. That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasClientMiddleware: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            // any need for these?
            module: "build/stub-path-to-module.js",
            clientActionModule: void 0,
            clientLoaderModule: void 0,
            clientMiddlewareModule: void 0,
            hydrateFallbackModule: void 0
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: newRoute.Component || (0, $3e8179397014bb35$export$910ae8079b2c2852),
            ErrorBoundary: newRoute.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $e4c31f3f81f1e687$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $e4c31f3f81f1e687$var$encoder = /* @__PURE__ */ new TextEncoder();
var $e4c31f3f81f1e687$var$sign = async (value, secret)=>{
    let data2 = $e4c31f3f81f1e687$var$encoder.encode(value);
    let key = await $e4c31f3f81f1e687$var$createKey(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $e4c31f3f81f1e687$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $e4c31f3f81f1e687$var$encoder.encode(value);
    let key = await $e4c31f3f81f1e687$var$createKey(secret, [
        "verify"
    ]);
    try {
        let signature = $e4c31f3f81f1e687$var$byteStringToUint8Array(atob(hash));
        let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
        return valid ? value : false;
    } catch (e) {
        return false;
    }
};
var $e4c31f3f81f1e687$var$createKey = async (secret, usages)=>crypto.subtle.importKey("raw", $e4c31f3f81f1e687$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $e4c31f3f81f1e687$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $e4c31f3f81f1e687$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $e4c31f3f81f1e687$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $9fd38747d73cb940$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $e4c31f3f81f1e687$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $9fd38747d73cb940$exports.serialize)(name, value === "" ? "" : await $e4c31f3f81f1e687$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $e4c31f3f81f1e687$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $e4c31f3f81f1e687$var$encodeCookieValue(value, secrets) {
    let encoded = $e4c31f3f81f1e687$var$encodeData(value);
    if (secrets.length > 0) encoded = await $e4c31f3f81f1e687$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $e4c31f3f81f1e687$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $e4c31f3f81f1e687$var$unsign(value, secret);
            if (unsignedValue !== false) return $e4c31f3f81f1e687$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $e4c31f3f81f1e687$var$decodeData(value);
}
function $e4c31f3f81f1e687$var$encodeData(value) {
    return btoa($e4c31f3f81f1e687$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $e4c31f3f81f1e687$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($e4c31f3f81f1e687$var$myEscape(atob(value))));
    } catch (e) {
        return {};
    }
}
function $e4c31f3f81f1e687$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $e4c31f3f81f1e687$var$hex(code, 2);
            else result += "%u" + $e4c31f3f81f1e687$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $e4c31f3f81f1e687$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $e4c31f3f81f1e687$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $e4c31f3f81f1e687$var$warnOnceAboutExpiresCookie(name, expires) {
    (0, $3e8179397014bb35$export$5b28268982f175ba)(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $e4c31f3f81f1e687$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo, routeId)=>{
        let route = manifest[routeId];
        if (route) memo[routeId] = route.module;
        return memo;
    }, {});
}
// lib/server-runtime/mode.ts
var $e4c31f3f81f1e687$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($e4c31f3f81f1e687$export$e7973f87fd96e4f2 || {});
function $e4c31f3f81f1e687$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $e4c31f3f81f1e687$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $e4c31f3f81f1e687$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $e4c31f3f81f1e687$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $e4c31f3f81f1e687$var$serializeError(error, serverMode) {
    let sanitized = $e4c31f3f81f1e687$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
// lib/server-runtime/invariant.ts
function $e4c31f3f81f1e687$var$invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routeMatching.ts
function $e4c31f3f81f1e687$var$matchServerRoutes(manifest, dataRoutes, branches, pathname, basename) {
    let matches = (0, $3e8179397014bb35$export$5c7b09132f833c25)(dataRoutes, pathname, basename ?? "/", false, branches);
    if (!matches) return null;
    return matches.map((match)=>{
        let route = manifest[match.route.id];
        $e4c31f3f81f1e687$var$invariant(route, `Route with id "${match.route.id}" not found in manifest.`);
        return {
            params: match.params,
            pathname: match.pathname,
            route: route
        };
    });
}
// lib/server-runtime/data.ts
async function $e4c31f3f81f1e687$var$callRouteHandler(handler, args, future) {
    let result = await handler({
        request: future.v8_passThroughRequests ? args.request : $e4c31f3f81f1e687$var$stripRoutesParam($e4c31f3f81f1e687$var$stripIndexParam(args.request)),
        url: args.url,
        params: args.params,
        context: args.context,
        pattern: args.pattern
    });
    if ((0, $3e8179397014bb35$export$e0163cfdf7bc9cfa)(result) && result.init && result.init.status && (0, $3e8179397014bb35$export$794b2760043cf8cd)(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $e4c31f3f81f1e687$var$stripIndexParam(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $e4c31f3f81f1e687$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/dev.ts
var $e4c31f3f81f1e687$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $e4c31f3f81f1e687$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$e4c31f3f81f1e687$var$globalDevServerHooksKey] = devServerHooks;
}
function $e4c31f3f81f1e687$var$getDevServerHooks() {
    return globalThis[$e4c31f3f81f1e687$var$globalDevServerHooksKey];
}
function $e4c31f3f81f1e687$var$getBuildTimeHeader(request, headerName) {
    var e;
    return null;
}
// lib/server-runtime/routes.ts
function $e4c31f3f81f1e687$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $e4c31f3f81f1e687$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $e4c31f3f81f1e687$var$groupRoutesByParentId(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            middleware: route.module.middleware,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                let preRenderedData = $e4c31f3f81f1e687$var$getBuildTimeHeader(args.request, "X-React-Router-Prerender-Data");
                if (preRenderedData != null) {
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $e4c31f3f81f1e687$var$invariant(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await (0, $3e8179397014bb35$export$4023ad4ecd4126a2)(stream, $parcel$global);
                    let data2 = decoded.value;
                    if (data2 && (0, $3e8179397014bb35$export$60644022b8b46aaa) in data2) {
                        let result = data2[0, $3e8179397014bb35$export$60644022b8b46aaa];
                        let init = {
                            status: result.status
                        };
                        if (result.reload) throw (0, $3e8179397014bb35$export$a6cd19cd1951a23c)(result.redirect, init);
                        else if (result.replace) throw (0, $3e8179397014bb35$export$77ad94ebf1c2b9ed)(result.redirect, init);
                        else throw (0, $3e8179397014bb35$export$89e12c5b50f7529d)(result.redirect, init);
                    } else {
                        $e4c31f3f81f1e687$var$invariant(data2 && route.id in data2, "Unable to decode prerendered data");
                        let result = data2[route.id];
                        $e4c31f3f81f1e687$var$invariant("data" in result, "Unable to process prerendered data");
                        return result.data;
                    }
                }
                let val = await $e4c31f3f81f1e687$var$callRouteHandler(route.module.loader, args, future);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$e4c31f3f81f1e687$var$callRouteHandler(route.module.action, args, future) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $e4c31f3f81f1e687$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/serverHandoff.ts
function $e4c31f3f81f1e687$var$createServerHandoffString(serverHandoff) {
    return (0, $3e8179397014bb35$export$4cf11838cdc2a8a8)(JSON.stringify(serverHandoff));
}
function $e4c31f3f81f1e687$var$getDocumentHeaders(context, build) {
    return $e4c31f3f81f1e687$var$getDocumentHeadersImpl(context, (m)=>{
        let route = build.routes[m.route.id];
        $e4c31f3f81f1e687$var$invariant(route, `Route with id "${m.route.id}" not found in build`);
        return route.module.headers;
    });
}
function $e4c31f3f81f1e687$var$getDocumentHeadersImpl(context, getRouteHeadersFn, _defaultHeaders) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    const defaultHeaders = new Headers(_defaultHeaders);
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        let headersFn = getRouteHeadersFn(match);
        if (headersFn == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $e4c31f3f81f1e687$var$prependCookies(errorHeaders, headers2);
            $e4c31f3f81f1e687$var$prependCookies(actionHeaders, headers2);
            $e4c31f3f81f1e687$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(typeof headersFn === "function" ? headersFn({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : headersFn);
        if (includeErrorCookies) $e4c31f3f81f1e687$var$prependCookies(errorHeaders, headers);
        $e4c31f3f81f1e687$var$prependCookies(actionHeaders, headers);
        $e4c31f3f81f1e687$var$prependCookies(loaderHeaders, headers);
        $e4c31f3f81f1e687$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers(defaultHeaders));
}
function $e4c31f3f81f1e687$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $e4a96bcce5e8f1ac$exports.splitCookiesString)(parentSetCookieString);
        let childCookies = new Set(childHeaders.getSetCookie());
        cookies.forEach((cookie)=>{
            if (!childCookies.has(cookie)) childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/actions.ts
function $e4c31f3f81f1e687$var$throwIfPotentialCSRFAttack(request, allowedActionOrigins) {
    let originHeader = request.headers.get("origin");
    let originDomain = null;
    let originUrl = null;
    try {
        if (typeof originHeader === "string" && originHeader !== "null") {
            originUrl = new URL(originHeader);
            originDomain = originUrl.host;
        } else originDomain = originHeader;
    } catch  {
        throw new Error(`\`origin\` header is not a valid URL. Aborting the action.`);
    }
    let requestUrl = new URL(request.url);
    let originMatchesRequest = originUrl ? originUrl.origin === requestUrl.origin : originDomain === requestUrl.host;
    if (originDomain && !originMatchesRequest) {
        if (!$e4c31f3f81f1e687$var$isAllowedOrigin(originDomain, allowedActionOrigins)) throw new Error("The `request.url` origin does not match `origin` header from a forwarded action request. Aborting the action.");
    }
}
function $e4c31f3f81f1e687$var$matchWildcardDomain(domain, pattern) {
    const domainParts = domain.split(".");
    const patternParts = pattern.split(".");
    if (patternParts.length < 1) return false;
    if (domainParts.length < patternParts.length) return false;
    while(patternParts.length){
        const patternPart = patternParts.pop();
        const domainPart = domainParts.pop();
        switch(patternPart){
            case "":
                return false;
            case "*":
                if (domainPart) continue;
                else return false;
            case "**":
                if (patternParts.length > 0) return false;
                return domainPart !== void 0;
            case void 0:
            default:
                if (domainPart !== patternPart) return false;
        }
    }
    return domainParts.length === 0;
}
function $e4c31f3f81f1e687$var$isAllowedOrigin(originDomain, allowedActionOrigins = []) {
    return allowedActionOrigins.some((allowedOrigin)=>allowedOrigin && (allowedOrigin === originDomain || $e4c31f3f81f1e687$var$matchWildcardDomain(originDomain, allowedOrigin)));
}
// lib/server-runtime/urls.ts
function $e4c31f3f81f1e687$var$getNormalizedPath(request, basename, future) {
    basename = basename || "/";
    let url = new URL(request.url);
    let pathname = url.pathname;
    if (future?.v8_trailingSlashAwareDataRequests) {
        if (pathname.endsWith("/_.data")) pathname = pathname.replace(/_\.data$/, "");
        else pathname = pathname.replace(/\.data$/, "");
    } else {
        if ((0, $3e8179397014bb35$export$b69e3301ce081aa3)(pathname, basename) === "/_root.data") pathname = basename;
        else if (pathname.endsWith(".data")) pathname = pathname.replace(/\.data$/, "");
        if ((0, $3e8179397014bb35$export$b69e3301ce081aa3)(pathname, basename) !== "/" && pathname.endsWith("/")) pathname = pathname.slice(0, -1);
    }
    let searchParams = new URLSearchParams(url.search);
    searchParams.delete("_routes");
    let search = searchParams.toString();
    if (search) search = `?${search}`;
    return {
        pathname: pathname,
        search: search,
        // No hashes on the server
        hash: ""
    };
}
// lib/server-runtime/single-fetch.ts
var $e4c31f3f81f1e687$var$SERVER_NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    ...(0, $3e8179397014bb35$export$e35ccdcde387134d),
    304
]);
async function $e4c31f3f81f1e687$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        try {
            $e4c31f3f81f1e687$var$throwIfPotentialCSRFAttack(request, Array.isArray(build.allowedActionOrigins) ? build.allowedActionOrigins : []);
        } catch (e) {
            return handleQueryError(new Error("Bad Request"), 400);
        }
        let handlerRequest = build.future.v8_passThroughRequests ? request : new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            skipRevalidation: true,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(handlerRequest);
                    return handleQueryResult(innerResult);
                } catch (error) {
                    return handleQueryError(error);
                }
            } : void 0,
            normalizePath: (r)=>$e4c31f3f81f1e687$var$getNormalizedPath(r, build.basename, build.future)
        });
        return handleQueryResult(result);
    } catch (error) {
        return handleQueryError(error);
    }
    function handleQueryResult(result) {
        return (0, $3e8179397014bb35$export$3f1eb41d9a6a6a27)(result) ? result : staticContextToResponse(result);
    }
    function handleQueryError(error, status = 500) {
        handleError(error);
        return $e4c31f3f81f1e687$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: status
        });
    }
    function staticContextToResponse(context) {
        let headers = $e4c31f3f81f1e687$var$getDocumentHeaders(context, build);
        if ((0, $3e8179397014bb35$export$794b2760043cf8cd)(context.statusCode) && headers.has("Location")) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $3e8179397014bb35$export$972111febbeef05b)(err) || err.error) handleError(err);
            });
            context.errors = $e4c31f3f81f1e687$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return $e4c31f3f81f1e687$var$generateSingleFetchResponse(request, build, serverMode, {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        });
    }
}
async function $e4c31f3f81f1e687$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    let routesParam = new URL(request.url).searchParams.get("_routes");
    let loadRouteIds = routesParam ? new Set(routesParam.split(",")) : null;
    try {
        let handlerRequest = build.future.v8_passThroughRequests ? request : new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            filterMatchesToLoad: (m)=>!loadRouteIds || loadRouteIds.has(m.route.id),
            skipLoaderErrorBubbling: true,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(handlerRequest);
                    return handleQueryResult(innerResult);
                } catch (error) {
                    return handleQueryError(error);
                }
            } : void 0,
            normalizePath: (r)=>$e4c31f3f81f1e687$var$getNormalizedPath(r, build.basename, build.future)
        });
        return handleQueryResult(result);
    } catch (error) {
        return handleQueryError(error);
    }
    function handleQueryResult(result) {
        return (0, $3e8179397014bb35$export$3f1eb41d9a6a6a27)(result) ? result : staticContextToResponse(result);
    }
    function handleQueryError(error) {
        handleError(error);
        return $e4c31f3f81f1e687$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        });
    }
    function staticContextToResponse(context) {
        let headers = $e4c31f3f81f1e687$var$getDocumentHeaders(context, build);
        if ((0, $3e8179397014bb35$export$794b2760043cf8cd)(context.statusCode) && headers.has("Location")) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $3e8179397014bb35$export$972111febbeef05b)(err) || err.error) handleError(err);
            });
            context.errors = $e4c31f3f81f1e687$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = new Set(context.matches.filter((m)=>loadRouteIds ? loadRouteIds.has(m.route.id) : m.route.loader != null).map((m)=>m.route.id));
        if (context.errors) for (let [id, error] of Object.entries(context.errors))results[id] = {
            error: error
        };
        for (let [id, data2] of Object.entries(context.loaderData))if (!(id in results) && loadedMatches.has(id)) results[id] = {
            data: data2
        };
        return $e4c31f3f81f1e687$var$generateSingleFetchResponse(request, build, serverMode, {
            result: results,
            headers: headers,
            status: context.statusCode
        });
    }
}
function $e4c31f3f81f1e687$var$generateSingleFetchResponse(request, build, serverMode, { result: result, headers: headers, status: status }) {
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if ($e4c31f3f81f1e687$var$SERVER_NO_BODY_STATUS_CODES.has(status)) return new Response(null, {
        status: status,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    resultHeaders.delete("Content-Length");
    return new Response($e4c31f3f81f1e687$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
function $e4c31f3f81f1e687$var$generateSingleFetchRedirectResponse(redirectResponse, request, build, serverMode) {
    let redirect2 = $e4c31f3f81f1e687$var$getSingleFetchRedirect(redirectResponse.status, redirectResponse.headers, build.basename);
    let headers = new Headers(redirectResponse.headers);
    headers.delete("Location");
    headers.set("Content-Type", "text/x-script");
    return $e4c31f3f81f1e687$var$generateSingleFetchResponse(request, build, serverMode, {
        result: request.method === "GET" ? {
            [(0, $3e8179397014bb35$export$60644022b8b46aaa)]: redirect2
        } : redirect2,
        headers: headers,
        status: (0, $3e8179397014bb35$export$ae9272e641ead836)
    });
}
function $e4c31f3f81f1e687$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = (0, $3e8179397014bb35$export$b69e3301ce081aa3)(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $e4c31f3f81f1e687$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>{
        controller.abort(new Error("Server Timeout"));
        cleanupCallbacks();
    }, typeof streamTimeout === "number" ? streamTimeout : 4950);
    let abortControllerOnRequestAbort = ()=>{
        controller.abort(requestSignal.reason);
        cleanupCallbacks();
    };
    requestSignal.addEventListener("abort", abortControllerOnRequestAbort);
    let cleanupCallbacks = ()=>{
        clearTimeout(timeoutId);
        requestSignal.removeEventListener("abort", abortControllerOnRequestAbort);
    };
    return (0, $3e8179397014bb35$export$c564cdbbe6da493)(data2, {
        signal: controller.signal,
        onComplete: cleanupCallbacks,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $e4c31f3f81f1e687$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof (0, $3e8179397014bb35$export$f2680fa305b734ca)) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && (0, $3e8179397014bb35$export$60644022b8b46aaa) in value) return [
                    "SingleFetchRedirect",
                    value[0, $3e8179397014bb35$export$60644022b8b46aaa]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $e4c31f3f81f1e687$var$derive(build, mode) {
    let dataRoutes = $e4c31f3f81f1e687$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $e4c31f3f81f1e687$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = (0, $3e8179397014bb35$export$3336b097a6fbc59a)(dataRoutes, {
        basename: build.basename,
        instrumentations: build.entry.module.instrumentations,
        future: build.future
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        (0, $3e8179397014bb35$export$972111febbeef05b)(error) && error.error ? error.error : error);
    });
    let requestHandler = async (request, initialContext)=>{
        let params = {};
        let loadContext;
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $e4c31f3f81f1e687$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        if (build.future.v8_middleware) {
            if (initialContext && !(initialContext instanceof (0, $3e8179397014bb35$export$b8d3e69d4b3eff04))) {
                let error = new Error("Invalid `context` value provided to `handleRequest`. When middleware is enabled you must return an instance of `RouterContextProvider` from your `getLoadContext` function.");
                handleError(error);
                return $e4c31f3f81f1e687$var$returnLastResortErrorResponse(error, serverMode);
            }
            loadContext = initialContext || new (0, $3e8179397014bb35$export$b8d3e69d4b3eff04)();
        } else loadContext = initialContext || {};
        let requestUrl = new URL(request.url);
        let normalizedPathname = $e4c31f3f81f1e687$var$getNormalizedPath(request, build.basename, build.future).pathname;
        let isSpaMode = $e4c31f3f81f1e687$var$getBuildTimeHeader(request, "X-React-Router-SPA-Mode") === "yes";
        if (!build.ssr) {
            let decodedPath = decodeURI(normalizedPathname);
            if (build.basename && build.basename !== "/") {
                let strippedPath = (0, $3e8179397014bb35$export$b69e3301ce081aa3)(decodedPath, build.basename);
                if (strippedPath == null) {
                    errorHandler(new (0, $3e8179397014bb35$export$f2680fa305b734ca)(404, "Not Found", `Refusing to prerender the \`${decodedPath}\` path because it does not start with the basename \`${build.basename}\``), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                }
                decodedPath = strippedPath;
            }
            if (build.prerender.length === 0) isSpaMode = true;
            else if (!build.prerender.includes(decodedPath.replace(/\/$/, "")) && !build.prerender.includes(decodedPath.replace(/[^/]$/, "/"))) {
                if (requestUrl.pathname.endsWith(".data")) {
                    errorHandler(new (0, $3e8179397014bb35$export$f2680fa305b734ca)(404, "Not Found", `Refusing to SSR the path \`${decodedPath}\` because \`ssr:false\` is set and the path is not included in the \`prerender\` config, so in production the path will be a 404.`), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                } else isSpaMode = true;
            }
        }
        let manifestUrl = (0, $3e8179397014bb35$export$bcb79c3deff01d56)(build.routeDiscovery.manifestPath, build.basename);
        if (build.routeDiscovery.mode === "lazy" && requestUrl.pathname === manifestUrl) try {
            let res = await $e4c31f3f81f1e687$var$handleManifestRequest(build, staticHandler.dataRoutes, staticHandler._internalRouteBranches, requestUrl);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $e4c31f3f81f1e687$var$matchServerRoutes(build.routes, staticHandler.dataRoutes, staticHandler._internalRouteBranches, normalizedPathname, build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (requestUrl.pathname.endsWith(".data")) {
            response = await $e4c31f3f81f1e687$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, normalizedPathname, loadContext, handleError);
            if ((0, $3e8179397014bb35$export$6e80290866a84dd4)(response)) response = $e4c31f3f81f1e687$var$generateSingleFetchRedirectResponse(response, request, build, serverMode);
            if (build.entry.module.handleDataRequest) {
                response = await build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: matches ? matches[0].params : {},
                    request: request
                });
                if ((0, $3e8179397014bb35$export$6e80290866a84dd4)(response)) response = $e4c31f3f81f1e687$var$generateSingleFetchRedirectResponse(response, request, build, serverMode);
            }
        } else if (!isSpaMode && matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $e4c31f3f81f1e687$var$handleResourceRequest(serverMode, build, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let { pathname: pathname } = requestUrl;
            let criticalCss = void 0;
            if (build.unstable_getCriticalCss) criticalCss = await build.unstable_getCriticalCss({
                pathname: pathname
            });
            else if (mode === "development" /* Development */  && $e4c31f3f81f1e687$var$getDevServerHooks()?.getCriticalCss) criticalCss = await $e4c31f3f81f1e687$var$getDevServerHooks()?.getCriticalCss?.(pathname);
            response = await $e4c31f3f81f1e687$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
    if (build.entry.module.instrumentations) requestHandler = (0, $3e8179397014bb35$export$8f7a8e481272777)(requestHandler, build.entry.module.instrumentations.map((i)=>i.handler).filter(Boolean));
    return {
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler,
        requestHandler: requestHandler
    };
}
var $e4c31f3f81f1e687$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let serverMode;
    let staticHandler;
    let errorHandler;
    let _requestHandler;
    return async function requestHandler(request, initialContext) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $e4c31f3f81f1e687$var$derive(_build, mode);
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
            _requestHandler = derived.requestHandler;
        } else if (!serverMode || !staticHandler || !errorHandler || !_requestHandler) {
            let derived = $e4c31f3f81f1e687$var$derive(_build, mode);
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
            _requestHandler = derived.requestHandler;
        }
        return _requestHandler(request, initialContext);
    };
};
async function $e4c31f3f81f1e687$var$handleManifestRequest(build, dataRoutes, branches, url) {
    if (url.toString().length > (0, $3e8179397014bb35$export$b5915cf27fa06b9f)) return new Response(null, {
        statusText: "Bad Request",
        status: 400
    });
    if (build.assets.version !== url.searchParams.get("version")) return new Response(null, {
        status: 204,
        headers: {
            "X-Remix-Reload-Document": "true"
        }
    });
    let patches = {};
    if (url.searchParams.has("paths")) {
        let pathParam = url.searchParams.get("paths") || "";
        let paths = new Set(pathParam.split(",").filter(Boolean));
        for (let path of paths){
            if (!path.startsWith("/")) path = `/${path}`;
            let matches = $e4c31f3f81f1e687$var$matchServerRoutes(build.routes, dataRoutes, branches, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $e4c31f3f81f1e687$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, normalizedPath, loadContext, handleError) {
    let handlerUrl = new URL(request.url);
    handlerUrl.pathname = normalizedPath;
    let response = (0, $3e8179397014bb35$export$cbae47800eb95bc3)(request.method) ? await $e4c31f3f81f1e687$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $e4c31f3f81f1e687$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    return response;
}
async function $e4c31f3f81f1e687$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss) {
    try {
        if ((0, $3e8179397014bb35$export$cbae47800eb95bc3)(request.method)) try {
            $e4c31f3f81f1e687$var$throwIfPotentialCSRFAttack(request, Array.isArray(build.allowedActionOrigins) ? build.allowedActionOrigins : []);
        } catch (e) {
            handleError(e);
            return new Response("Bad Request", {
                status: 400
            });
        }
        let result = await staticHandler.query(request, {
            requestContext: loadContext,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(request);
                    if (!(0, $3e8179397014bb35$export$3f1eb41d9a6a6a27)(innerResult)) innerResult = await renderHtml(innerResult, isSpaMode);
                    return innerResult;
                } catch (error) {
                    handleError(error);
                    return new Response(null, {
                        status: 500
                    });
                }
            } : void 0,
            normalizePath: (r)=>$e4c31f3f81f1e687$var$getNormalizedPath(r, build.basename, build.future)
        });
        if (!(0, $3e8179397014bb35$export$3f1eb41d9a6a6a27)(result)) result = await renderHtml(result, isSpaMode);
        return result;
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    async function renderHtml(context, isSpaMode2) {
        let headers = $e4c31f3f81f1e687$var$getDocumentHeaders(context, build);
        if ($e4c31f3f81f1e687$var$SERVER_NO_BODY_STATUS_CODES.has(context.statusCode)) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $3e8179397014bb35$export$972111febbeef05b)(err) || err.error) handleError(err);
            });
            context.errors = $e4c31f3f81f1e687$var$sanitizeErrors(context.errors, serverMode);
        }
        let state = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: context.errors
        };
        let baseServerHandoff = {
            basename: build.basename,
            future: build.future,
            routeDiscovery: build.routeDiscovery,
            ssr: build.ssr,
            isSpaMode: isSpaMode2
        };
        let entryContext = {
            manifest: build.assets,
            branches: staticHandler._internalRouteBranches,
            routeModules: $e4c31f3f81f1e687$var$createEntryRouteModules(build.routes),
            staticHandlerContext: context,
            criticalCss: criticalCss,
            serverHandoffString: $e4c31f3f81f1e687$var$createServerHandoffString({
                ...baseServerHandoff,
                criticalCss: criticalCss
            }),
            serverHandoffStream: $e4c31f3f81f1e687$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {},
            future: build.future,
            ssr: build.ssr,
            routeDiscovery: build.routeDiscovery,
            isSpaMode: isSpaMode2,
            serializeError: (err)=>$e4c31f3f81f1e687$var$serializeError(err, serverMode)
        };
        let handleDocumentRequestFunction = build.entry.module.default;
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error) {
            handleError(error);
            let errorForSecondRender = error;
            if ((0, $3e8179397014bb35$export$3f1eb41d9a6a6a27)(error)) try {
                let data2 = await $e4c31f3f81f1e687$var$unwrapResponse(error);
                errorForSecondRender = new (0, $3e8179397014bb35$export$f2680fa305b734ca)(error.status, error.statusText, data2);
            } catch (e) {}
            context = (0, $3e8179397014bb35$export$fec11da027c70692)(staticHandler.dataRoutes, context, errorForSecondRender);
            if (context.errors) context.errors = $e4c31f3f81f1e687$var$sanitizeErrors(context.errors, serverMode);
            let state2 = {
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors
            };
            entryContext = {
                ...entryContext,
                staticHandlerContext: context,
                serverHandoffString: $e4c31f3f81f1e687$var$createServerHandoffString(baseServerHandoff),
                serverHandoffStream: $e4c31f3f81f1e687$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
                renderMeta: {}
            };
            try {
                return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
            } catch (error2) {
                handleError(error2);
                return $e4c31f3f81f1e687$var$returnLastResortErrorResponse(error2, serverMode);
            }
        }
    }
}
async function $e4c31f3f81f1e687$var$handleResourceRequest(serverMode, build, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let result = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext,
            generateMiddlewareResponse: build.future.v8_middleware ? async (queryRoute)=>{
                try {
                    let innerResult = await queryRoute(request);
                    return handleQueryRouteResult(innerResult);
                } catch (error) {
                    return handleQueryRouteError(error);
                }
            } : void 0,
            normalizePath: (r)=>$e4c31f3f81f1e687$var$getNormalizedPath(r, build.basename, build.future)
        });
        return handleQueryRouteResult(result);
    } catch (error) {
        return handleQueryRouteError(error);
    }
    function handleQueryRouteResult(result) {
        if ((0, $3e8179397014bb35$export$3f1eb41d9a6a6a27)(result)) return result;
        if (typeof result === "string") return new Response(result);
        return Response.json(result);
    }
    function handleQueryRouteError(error) {
        if ((0, $3e8179397014bb35$export$3f1eb41d9a6a6a27)(error)) return error;
        if ((0, $3e8179397014bb35$export$972111febbeef05b)(error)) {
            handleError(error);
            return $e4c31f3f81f1e687$var$errorResponseToJson(error, serverMode);
        }
        if (error instanceof Error && error.message === "Expected a response from queryRoute") {
            let newError = new Error("Expected a Response to be returned from resource route handler");
            handleError(newError);
            return $e4c31f3f81f1e687$var$returnLastResortErrorResponse(newError, serverMode);
        }
        handleError(error);
        return $e4c31f3f81f1e687$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $e4c31f3f81f1e687$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($e4c31f3f81f1e687$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText
    });
}
function $e4c31f3f81f1e687$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $e4c31f3f81f1e687$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $e4c31f3f81f1e687$var$flash(name) {
    return `__flash_${name}__`;
}
var $e4c31f3f81f1e687$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($e4c31f3f81f1e687$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $e4c31f3f81f1e687$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($e4c31f3f81f1e687$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $e4c31f3f81f1e687$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $e4c31f3f81f1e687$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $e4c31f3f81f1e687$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $e4c31f3f81f1e687$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $e4c31f3f81f1e687$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $e4c31f3f81f1e687$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $e4c31f3f81f1e687$var$warnOnceAboutSigningSessionCookie(cookie) {
    (0, $3e8179397014bb35$export$5b28268982f175ba)(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://reactrouter.com/explanation/sessions-and-cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $e4c31f3f81f1e687$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $e4c31f3f81f1e687$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $e4c31f3f81f1e687$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $e4c31f3f81f1e687$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $e4c31f3f81f1e687$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $e4c31f3f81f1e687$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $e4c31f3f81f1e687$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/href.ts
function $e4c31f3f81f1e687$export$8f51af5840e0602a(path, ...args) {
    let params = args[0];
    let result = $e4c31f3f81f1e687$var$trimTrailingSplat(path).replace(/\/:([\w-]+)(\?)?/g, // same regex as in .\router\utils.ts: compilePath().
    (_, param, questionMark)=>{
        const isRequired = questionMark === void 0;
        const value = params?.[param];
        if (isRequired && value === void 0) throw new Error(`Path '${path}' requires param '${param}' but it was not provided`);
        return value === void 0 ? "" : "/" + value;
    });
    if (path.endsWith("*")) {
        const value = params?.["*"];
        if (value !== void 0) result += "/" + value;
    }
    return result || "/";
}
function $e4c31f3f81f1e687$var$trimTrailingSplat(path) {
    let i = path.length - 1;
    let char = path[i];
    if (char !== "*" && char !== "/") return path;
    i--;
    for(; i >= 0; i--){
        if (path[i] !== "/") break;
    }
    return path.slice(0, i + 1);
}
// lib/rsc/html-stream/server.ts
var $e4c31f3f81f1e687$var$encoder2 = new TextEncoder();
var $e4c31f3f81f1e687$var$trailer = "</body></html>";
function $e4c31f3f81f1e687$var$injectRSCPayload(rscStream) {
    let decoder = new TextDecoder();
    let resolveFlightDataPromise;
    let flightDataPromise = new Promise((resolve)=>resolveFlightDataPromise = resolve);
    let startedRSC = false;
    let buffered = [];
    let timeout = null;
    function flushBufferedChunks(controller) {
        for (let chunk of buffered){
            let buf = decoder.decode(chunk, {
                stream: true
            });
            if (buf.endsWith($e4c31f3f81f1e687$var$trailer)) buf = buf.slice(0, -$e4c31f3f81f1e687$var$trailer.length);
            controller.enqueue($e4c31f3f81f1e687$var$encoder2.encode(buf));
        }
        buffered.length = 0;
        timeout = null;
    }
    return new TransformStream({
        transform (chunk, controller) {
            buffered.push(chunk);
            if (timeout) return;
            timeout = setTimeout(async ()=>{
                flushBufferedChunks(controller);
                if (!startedRSC) {
                    startedRSC = true;
                    $e4c31f3f81f1e687$var$writeRSCStream(rscStream, controller).catch((err)=>controller.error(err)).then(resolveFlightDataPromise);
                }
            }, 0);
        },
        async flush (controller) {
            await flightDataPromise;
            if (timeout) {
                clearTimeout(timeout);
                flushBufferedChunks(controller);
            }
            controller.enqueue($e4c31f3f81f1e687$var$encoder2.encode("</body></html>"));
        }
    });
}
async function $e4c31f3f81f1e687$var$writeRSCStream(rscStream, controller) {
    let decoder = new TextDecoder("utf-8", {
        fatal: true
    });
    const reader = rscStream.getReader();
    try {
        let read;
        while((read = await reader.read()) && !read.done){
            const chunk = read.value;
            try {
                $e4c31f3f81f1e687$var$writeChunk(JSON.stringify(decoder.decode(chunk, {
                    stream: true
                })), controller);
            } catch (e) {
                let base64 = JSON.stringify(btoa(String.fromCodePoint(...chunk)));
                $e4c31f3f81f1e687$var$writeChunk(`Uint8Array.from(atob(${base64}), m => m.codePointAt(0))`, controller);
            }
        }
    } finally{
        reader.releaseLock();
    }
    let remaining = decoder.decode();
    if (remaining.length) $e4c31f3f81f1e687$var$writeChunk(JSON.stringify(remaining), controller);
}
function $e4c31f3f81f1e687$var$writeChunk(chunk, controller) {
    controller.enqueue($e4c31f3f81f1e687$var$encoder2.encode(`<script>${$e4c31f3f81f1e687$var$escapeScript(`(self.__FLIGHT_DATA||=[]).push(${chunk})`)}</script>`));
}
function $e4c31f3f81f1e687$var$escapeScript(script) {
    return script.replace(/<!--/g, "<\\!--").replace(/<\/(script)/gi, "</\\$1");
}
var $e4c31f3f81f1e687$export$ea608ff93320d416 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: null,
            location: props.location
        };
        return {
            error: state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e4c31f3f81f1e687$var$RSCDefaultRootErrorBoundaryImpl, {
            error: this.state.error,
            renderAppShell: true
        });
        else return this.props.children;
    }
};
function $e4c31f3f81f1e687$var$ErrorWrapper({ renderAppShell: renderAppShell, title: title, children: children }) {
    if (!renderAppShell) return children;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("head", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("body", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children)));
}
function $e4c31f3f81f1e687$var$RSCDefaultRootErrorBoundaryImpl({ error: error, renderAppShell: renderAppShell }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $3e8179397014bb35$export$972111febbeef05b)(error)) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e4c31f3f81f1e687$var$ErrorWrapper, {
        renderAppShell: renderAppShell,
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), (0, $3e8179397014bb35$export$945fecf35a8ef089) ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e4c31f3f81f1e687$var$ErrorWrapper, {
        renderAppShell: renderAppShell,
        title: "Application Error!"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $e4c31f3f81f1e687$export$a55eecbda762d267({ hasRootLayout: hasRootLayout }) {
    let error = (0, $3e8179397014bb35$export$ed527bf60f6e05f2)();
    if (hasRootLayout === void 0) throw new Error("Missing 'hasRootLayout' prop");
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e4c31f3f81f1e687$var$RSCDefaultRootErrorBoundaryImpl, {
        renderAppShell: !hasRootLayout,
        error: error
    });
}
// lib/rsc/route-modules.ts
function $e4c31f3f81f1e687$var$createRSCRouteModules(payload) {
    const routeModules = {};
    for (const match of payload.matches)$e4c31f3f81f1e687$export$93a6ee970ac9d016(routeModules, match);
    return routeModules;
}
function $e4c31f3f81f1e687$export$93a6ee970ac9d016(routeModules, matches) {
    matches = Array.isArray(matches) ? matches : [
        matches
    ];
    for (const match of matches)routeModules[match.id] = {
        links: match.links,
        meta: match.meta,
        default: $e4c31f3f81f1e687$var$noopComponent
    };
}
var $e4c31f3f81f1e687$var$noopComponent = ()=>null;
// lib/rsc/server.ssr.tsx
var $e4c31f3f81f1e687$var$defaultManifestPath = "/__manifest";
var $e4c31f3f81f1e687$var$REACT_USE = "use";
var $e4c31f3f81f1e687$var$useImpl = $acw62[$e4c31f3f81f1e687$var$REACT_USE];
function $e4c31f3f81f1e687$var$useSafe(promise) {
    if ($e4c31f3f81f1e687$var$useImpl) return $e4c31f3f81f1e687$var$useImpl(promise);
    throw new Error("React Router v7 requires React 19+ for RSC features.");
}
async function $e4c31f3f81f1e687$export$144ccff01a5655fc({ request: request, serverResponse: serverResponse, createFromReadableStream: createFromReadableStream, renderHTML: renderHTML, hydrate: hydrate = true }) {
    const url = new URL(request.url);
    const isDataRequest = $e4c31f3f81f1e687$var$isReactServerRequest(url);
    const respondWithRSCPayload = isDataRequest || $e4c31f3f81f1e687$var$isManifestRequest(url) || request.headers.has("rsc-action-id");
    if (respondWithRSCPayload || serverResponse.headers.get("React-Router-Resource") === "true") return serverResponse;
    if (!serverResponse.body) throw new Error("Missing body in server response");
    const detectRedirectResponse = serverResponse.clone();
    let serverResponseB = null;
    if (hydrate) serverResponseB = serverResponse.clone();
    const body = serverResponse.body;
    let buffer;
    let streamControllers = [];
    const createStream = ()=>{
        if (!buffer) {
            buffer = [];
            return body.pipeThrough(new TransformStream({
                transform (chunk, controller) {
                    buffer.push(chunk);
                    controller.enqueue(chunk);
                    streamControllers.forEach((c)=>c.enqueue(chunk));
                },
                flush () {
                    streamControllers.forEach((c)=>c.close());
                    streamControllers = [];
                }
            }));
        }
        return new ReadableStream({
            start (controller) {
                buffer.forEach((chunk)=>controller.enqueue(chunk));
                streamControllers.push(controller);
            }
        });
    };
    let deepestRenderedBoundaryId = null;
    const getPayload = ()=>{
        const payloadPromise = Promise.resolve(createFromReadableStream(createStream()));
        return Object.defineProperties(payloadPromise, {
            _deepestRenderedBoundaryId: {
                get () {
                    return deepestRenderedBoundaryId;
                },
                set (boundaryId1) {
                    deepestRenderedBoundaryId = boundaryId1;
                }
            },
            formState: {
                get () {
                    return payloadPromise.then((payload)=>payload.type === "render" ? payload.formState : void 0);
                }
            }
        });
    };
    let renderRedirect;
    let renderError;
    try {
        if (!detectRedirectResponse.body) throw new Error("Failed to clone server response");
        const payload = await createFromReadableStream(detectRedirectResponse.body);
        if (serverResponse.status === (0, $3e8179397014bb35$export$ae9272e641ead836) && payload.type === "redirect") {
            if ((0, $3e8179397014bb35$export$961a3ef7a4da3a39)(payload.location)) throw new Error("Invalid redirect location");
            const headers2 = new Headers(serverResponse.headers);
            headers2.delete("Content-Encoding");
            headers2.delete("Content-Length");
            headers2.delete("Content-Type");
            headers2.delete("X-Remix-Response");
            headers2.set("Location", payload.location);
            return new Response(serverResponseB?.body || "", {
                headers: headers2,
                status: payload.status,
                statusText: serverResponse.statusText
            });
        }
        let reactHeaders = new Headers();
        let status = serverResponse.status;
        let statusText = serverResponse.statusText;
        let html = await renderHTML(getPayload, {
            onError (error) {
                if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
                    renderRedirect = (0, $3e8179397014bb35$export$30db792b333fd2ee)(error.digest);
                    if (renderRedirect) return error.digest;
                    let routeErrorResponse = (0, $3e8179397014bb35$export$2b5950305b3e7eaf)(error.digest);
                    if (routeErrorResponse) {
                        renderError = routeErrorResponse;
                        status = routeErrorResponse.status;
                        statusText = routeErrorResponse.statusText;
                        return error.digest;
                    }
                }
            },
            onHeaders (headers2) {
                for (const [key, value] of headers2)reactHeaders.append(key, value);
            }
        });
        const headers = new Headers(reactHeaders);
        for (const [key, value] of serverResponse.headers)headers.append(key, value);
        headers.set("Content-Type", "text/html; charset=utf-8");
        if (renderRedirect) {
            if ((0, $3e8179397014bb35$export$961a3ef7a4da3a39)(renderRedirect.location)) throw new Error("Invalid redirect location");
            headers.set("Location", renderRedirect.location);
            return new Response(html, {
                status: renderRedirect.status,
                headers: headers
            });
        }
        const redirectTransform = new TransformStream({
            flush (controller) {
                if (renderRedirect) {
                    if ((0, $3e8179397014bb35$export$961a3ef7a4da3a39)(renderRedirect.location)) return;
                    controller.enqueue(new TextEncoder().encode(`<meta http-equiv="refresh" content="0;url=${(0, $3e8179397014bb35$export$30330f3d5eb70e11)(renderRedirect.location)}"/>`));
                }
            }
        });
        if (!hydrate) return new Response(html.pipeThrough(redirectTransform), {
            status: status,
            statusText: statusText,
            headers: headers
        });
        if (!serverResponseB?.body) throw new Error("Failed to clone server response");
        const body2 = html.pipeThrough($e4c31f3f81f1e687$var$injectRSCPayload(serverResponseB.body)).pipeThrough(redirectTransform);
        return new Response(body2, {
            status: status,
            statusText: statusText,
            headers: headers
        });
    } catch (error) {
        if (error instanceof Response) return error;
        if (renderRedirect) {
            if ((0, $3e8179397014bb35$export$961a3ef7a4da3a39)(renderRedirect.location)) throw new Error("Invalid redirect location");
            return new Response(`Redirect: ${renderRedirect.location}`, {
                status: renderRedirect.status,
                headers: {
                    Location: renderRedirect.location
                }
            });
        }
        try {
            let normalizedError = renderError ?? error;
            let [status, statusText] = (0, $3e8179397014bb35$export$972111febbeef05b)(normalizedError) ? [
                normalizedError.status,
                normalizedError.statusText
            ] : [
                500,
                ""
            ];
            let retryRedirect;
            let reactHeaders = new Headers();
            const html = await renderHTML(()=>{
                const decoded = Promise.resolve(createFromReadableStream(createStream()));
                const payloadPromise = decoded.then((payload)=>Object.assign(payload, {
                        status: status,
                        errors: deepestRenderedBoundaryId ? {
                            [deepestRenderedBoundaryId]: normalizedError
                        } : {}
                    }));
                return Object.defineProperties(payloadPromise, {
                    _deepestRenderedBoundaryId: {
                        get () {
                            return deepestRenderedBoundaryId;
                        },
                        set (boundaryId1) {
                            deepestRenderedBoundaryId = boundaryId1;
                        }
                    },
                    formState: {
                        get () {
                            return payloadPromise.then((payload)=>payload.type === "render" ? payload.formState : void 0);
                        }
                    }
                });
            }, {
                onError (error2) {
                    if (typeof error2 === "object" && error2 && "digest" in error2 && typeof error2.digest === "string") {
                        retryRedirect = (0, $3e8179397014bb35$export$30db792b333fd2ee)(error2.digest);
                        if (retryRedirect) return error2.digest;
                        let routeErrorResponse = (0, $3e8179397014bb35$export$2b5950305b3e7eaf)(error2.digest);
                        if (routeErrorResponse) {
                            status = routeErrorResponse.status;
                            statusText = routeErrorResponse.statusText;
                            return error2.digest;
                        }
                    }
                },
                onHeaders (headers2) {
                    for (const [key, value] of headers2)reactHeaders.append(key, value);
                }
            });
            const headers = new Headers(reactHeaders);
            for (const [key, value] of serverResponse.headers)headers.append(key, value);
            headers.set("Content-Type", "text/html; charset=utf-8");
            if (retryRedirect) {
                if ((0, $3e8179397014bb35$export$961a3ef7a4da3a39)(retryRedirect.location)) throw new Error("Invalid redirect location");
                headers.set("Location", retryRedirect.location);
                return new Response(html, {
                    status: retryRedirect.status,
                    headers: headers
                });
            }
            const retryRedirectTransform = new TransformStream({
                flush (controller) {
                    if (retryRedirect) {
                        if ((0, $3e8179397014bb35$export$961a3ef7a4da3a39)(retryRedirect.location)) return;
                        controller.enqueue(new TextEncoder().encode(`<meta http-equiv="refresh" content="0;url=${(0, $3e8179397014bb35$export$30330f3d5eb70e11)(retryRedirect.location)}"/>`));
                    }
                }
            });
            if (!hydrate) return new Response(html.pipeThrough(retryRedirectTransform), {
                status: status,
                statusText: statusText,
                headers: headers
            });
            if (!serverResponseB?.body) throw new Error("Failed to clone server response");
            const body2 = html.pipeThrough($e4c31f3f81f1e687$var$injectRSCPayload(serverResponseB.body)).pipeThrough(retryRedirectTransform);
            return new Response(body2, {
                status: status,
                statusText: statusText,
                headers: headers
            });
        } catch (error2) {}
        throw error;
    }
}
function $e4c31f3f81f1e687$export$7f2da8ab5e593830({ getPayload: getPayload }) {
    const decoded = getPayload();
    const payload = $e4c31f3f81f1e687$var$useSafe(decoded);
    if (payload.type === "redirect") {
        if ((0, $3e8179397014bb35$export$961a3ef7a4da3a39)(payload.location)) throw new Error("Invalid redirect location");
        throw new Response(null, {
            status: payload.status,
            headers: {
                Location: payload.location
            }
        });
    }
    if (payload.type !== "render") return null;
    let patchedLoaderData = {
        ...payload.loaderData
    };
    for (const match of payload.matches)if ((0, $3e8179397014bb35$export$6ac68922d4e92125)(match.id, match.clientLoader, match.hasLoader, false) && (match.hydrateFallbackElement || !match.hasLoader)) delete patchedLoaderData[match.id];
    const context = {
        get _deepestRenderedBoundaryId () {
            return decoded._deepestRenderedBoundaryId ?? null;
        },
        set _deepestRenderedBoundaryId (boundaryId){
            decoded._deepestRenderedBoundaryId = boundaryId;
        },
        actionData: payload.actionData,
        actionHeaders: {},
        basename: payload.basename,
        errors: payload.errors,
        loaderData: patchedLoaderData,
        loaderHeaders: {},
        location: payload.location,
        statusCode: 200,
        matches: payload.matches.map((match)=>({
                params: match.params,
                pathname: match.pathname,
                pathnameBase: match.pathnameBase,
                route: {
                    id: match.id,
                    action: match.hasAction || !!match.clientAction,
                    handle: match.handle,
                    hasErrorBoundary: match.hasErrorBoundary,
                    loader: match.hasLoader || !!match.clientLoader,
                    index: match.index,
                    path: match.path,
                    shouldRevalidate: match.shouldRevalidate
                }
            }))
    };
    const router = (0, $3e8179397014bb35$export$3dd6171c30258b6f)(payload.matches.reduceRight((previous, match)=>{
        const route = {
            id: match.id,
            action: match.hasAction || !!match.clientAction,
            element: match.element,
            errorElement: match.errorElement,
            handle: match.handle,
            hasErrorBoundary: !!match.errorElement,
            hydrateFallbackElement: match.hydrateFallbackElement,
            index: match.index,
            loader: match.hasLoader || !!match.clientLoader,
            path: match.path,
            shouldRevalidate: match.shouldRevalidate
        };
        if (previous.length > 0) route.children = previous;
        return [
            route
        ];
    }, []), context);
    const frameworkContext = {
        future: {
            // These flags have no runtime impact so can always be false.  If we add
            // flags that drive runtime behavior they'll need to be proxied through.
            v8_middleware: false,
            v8_trailingSlashAwareDataRequests: true,
            // always on for RSC
            v8_passThroughRequests: true
        },
        isSpaMode: false,
        ssr: true,
        criticalCss: "",
        manifest: {
            routes: {},
            version: "1",
            url: "",
            entry: {
                module: "",
                imports: []
            }
        },
        routeDiscovery: payload.routeDiscovery.mode === "initial" ? {
            mode: "initial",
            manifestPath: $e4c31f3f81f1e687$var$defaultManifestPath
        } : {
            mode: "lazy",
            manifestPath: payload.routeDiscovery.manifestPath || $e4c31f3f81f1e687$var$defaultManifestPath
        },
        routeModules: $e4c31f3f81f1e687$var$createRSCRouteModules(payload)
    };
    return /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$717f757c655223f1).Provider, {
        value: true
    }, /* @__PURE__ */ $acw62.createElement($e4c31f3f81f1e687$export$ea608ff93320d416, {
        location: payload.location
    }, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$208d6a3bc3aa62bd).Provider, {
        value: frameworkContext
    }, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$3d80f15952491985), {
        context: context,
        router: router,
        hydrate: false,
        nonce: payload.nonce
    }))));
}
function $e4c31f3f81f1e687$var$isReactServerRequest(url) {
    return url.pathname.endsWith(".rsc");
}
function $e4c31f3f81f1e687$var$isManifestRequest(url) {
    return url.pathname.endsWith(".manifest");
}
// lib/dom/ssr/hydration.tsx
function $e4c31f3f81f1e687$export$6fa8d910d97963ad({ state: state, routes: routes, getRouteInfo: getRouteInfo, location: location, basename: basename, isSpaMode: isSpaMode }) {
    let hydrationData = {
        ...state,
        loaderData: {
            ...state.loaderData
        }
    };
    let initialMatches = (0, $3e8179397014bb35$export$2708184779ceb39d)(routes, location, basename);
    if (initialMatches) for (let match of initialMatches){
        let routeId = match.route.id;
        let routeInfo = getRouteInfo(routeId);
        if ((0, $3e8179397014bb35$export$6ac68922d4e92125)(routeId, routeInfo.clientLoader, routeInfo.hasLoader, isSpaMode) && (routeInfo.hasHydrateFallback || !routeInfo.hasLoader)) delete hydrationData.loaderData[routeId];
        else if (!routeInfo.hasLoader) hydrationData.loaderData[routeId] = null;
    }
    return hydrationData;
}




var $acw62 = parcelRequire("acw62");

"use client";
function $5fc20031e6d40819$export$323e4fc2fa4753fb(props) {
    return /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$323e4fc2fa4753fb), {
        flushSync: $11492dca620dcaa5$exports.flushSync,
        ...props
    });
}
var $5fc20031e6d40819$var$ssrInfo = null;
var $5fc20031e6d40819$var$router = null;
function $5fc20031e6d40819$var$initSsrInfo() {
    if (!$5fc20031e6d40819$var$ssrInfo && window.__reactRouterContext && window.__reactRouterManifest && window.__reactRouterRouteModules) {
        if (window.__reactRouterManifest.sri === true) {
            const importMap = document.querySelector("script[rr-importmap]");
            if (importMap?.textContent) try {
                window.__reactRouterManifest.sri = JSON.parse(importMap.textContent).integrity;
            } catch (err) {
                console.error("Failed to parse import map", err);
            }
        }
        $5fc20031e6d40819$var$ssrInfo = {
            context: window.__reactRouterContext,
            manifest: window.__reactRouterManifest,
            routeModules: window.__reactRouterRouteModules,
            stateDecodingPromise: void 0,
            router: void 0,
            routerInitialized: false
        };
    }
}
function $5fc20031e6d40819$var$createHydratedRouter({ getContext: getContext, instrumentations: instrumentations }) {
    $5fc20031e6d40819$var$initSsrInfo();
    if (!$5fc20031e6d40819$var$ssrInfo) throw new Error("You must be using the SSR features of React Router in order to skip passing a `router` prop to `<RouterProvider>`");
    let localSsrInfo = $5fc20031e6d40819$var$ssrInfo;
    if (!$5fc20031e6d40819$var$ssrInfo.stateDecodingPromise) {
        let stream = $5fc20031e6d40819$var$ssrInfo.context.stream;
        (0, $3e8179397014bb35$export$f5708dca728d7177)(stream, "No stream found for single fetch decoding");
        $5fc20031e6d40819$var$ssrInfo.context.stream = void 0;
        $5fc20031e6d40819$var$ssrInfo.stateDecodingPromise = (0, $3e8179397014bb35$export$4023ad4ecd4126a2)(stream, window).then((value)=>{
            $5fc20031e6d40819$var$ssrInfo.context.state = value.value;
            localSsrInfo.stateDecodingPromise.value = true;
        }).catch((e)=>{
            localSsrInfo.stateDecodingPromise.error = e;
        });
    }
    if ($5fc20031e6d40819$var$ssrInfo.stateDecodingPromise.error) throw $5fc20031e6d40819$var$ssrInfo.stateDecodingPromise.error;
    if (!$5fc20031e6d40819$var$ssrInfo.stateDecodingPromise.value) throw $5fc20031e6d40819$var$ssrInfo.stateDecodingPromise;
    let routes = (0, $3e8179397014bb35$export$af76e85f27ba0229)($5fc20031e6d40819$var$ssrInfo.manifest.routes, $5fc20031e6d40819$var$ssrInfo.routeModules, $5fc20031e6d40819$var$ssrInfo.context.state, $5fc20031e6d40819$var$ssrInfo.context.ssr, $5fc20031e6d40819$var$ssrInfo.context.isSpaMode);
    let hydrationData = void 0;
    if ($5fc20031e6d40819$var$ssrInfo.context.isSpaMode) {
        let { loaderData: loaderData } = $5fc20031e6d40819$var$ssrInfo.context.state;
        if ($5fc20031e6d40819$var$ssrInfo.manifest.routes.root?.hasLoader && loaderData && "root" in loaderData) hydrationData = {
            loaderData: {
                root: loaderData.root
            }
        };
    } else hydrationData = (0, $e4c31f3f81f1e687$export$6fa8d910d97963ad)({
        state: $5fc20031e6d40819$var$ssrInfo.context.state,
        routes: routes,
        getRouteInfo: (routeId)=>({
                clientLoader: $5fc20031e6d40819$var$ssrInfo.routeModules[routeId]?.clientLoader,
                hasLoader: $5fc20031e6d40819$var$ssrInfo.manifest.routes[routeId]?.hasLoader === true,
                hasHydrateFallback: $5fc20031e6d40819$var$ssrInfo.routeModules[routeId]?.HydrateFallback != null
            }),
        location: window.location,
        basename: window.__reactRouterContext?.basename,
        isSpaMode: $5fc20031e6d40819$var$ssrInfo.context.isSpaMode
    });
    if (window.history.state && window.history.state.masked) window.history.replaceState({
        ...window.history.state,
        masked: void 0
    }, "");
    let router2 = (0, $3e8179397014bb35$export$baddd0131ee8c05b)({
        routes: routes,
        history: (0, $3e8179397014bb35$export$719fc203c4e16dee)(),
        basename: $5fc20031e6d40819$var$ssrInfo.context.basename,
        getContext: getContext,
        hydrationData: hydrationData,
        hydrationRouteProperties: $3e8179397014bb35$export$e2fd2c03906469db,
        instrumentations: instrumentations,
        mapRouteProperties: $3e8179397014bb35$export$9269a41d8c4635e,
        future: {
            v8_passThroughRequests: $5fc20031e6d40819$var$ssrInfo.context.future.v8_passThroughRequests
        },
        dataStrategy: (0, $3e8179397014bb35$export$77d7799427e365da)(()=>router2, $5fc20031e6d40819$var$ssrInfo.manifest, $5fc20031e6d40819$var$ssrInfo.routeModules, $5fc20031e6d40819$var$ssrInfo.context.ssr, $5fc20031e6d40819$var$ssrInfo.context.basename, $5fc20031e6d40819$var$ssrInfo.context.future.v8_trailingSlashAwareDataRequests),
        patchRoutesOnNavigation: (0, $3e8179397014bb35$export$72ab377a1030deb9)(()=>router2, $5fc20031e6d40819$var$ssrInfo.manifest, $5fc20031e6d40819$var$ssrInfo.routeModules, $5fc20031e6d40819$var$ssrInfo.context.ssr, $5fc20031e6d40819$var$ssrInfo.context.routeDiscovery, $5fc20031e6d40819$var$ssrInfo.context.isSpaMode, $5fc20031e6d40819$var$ssrInfo.context.basename)
    });
    $5fc20031e6d40819$var$ssrInfo.router = router2;
    if (router2.state.initialized) {
        $5fc20031e6d40819$var$ssrInfo.routerInitialized = true;
        router2.initialize();
    }
    router2.createRoutesForHMR = /* spacer so ts-ignore does not affect the right hand of the assignment */ (0, $3e8179397014bb35$export$49d9dc160d22054c);
    window.__reactRouterDataRouter = router2;
    return router2;
}
function $5fc20031e6d40819$export$63ce90781bf4d238(props) {
    if (!$5fc20031e6d40819$var$router) $5fc20031e6d40819$var$router = $5fc20031e6d40819$var$createHydratedRouter({
        getContext: props.getContext,
        instrumentations: props.instrumentations
    });
    let [criticalCss, setCriticalCss] = $acw62.useState(void 0);
    $acw62.useEffect(()=>{}, []);
    $acw62.useEffect(()=>{
        var element;
    }, [
        criticalCss
    ]);
    let [location2, setLocation] = $acw62.useState($5fc20031e6d40819$var$router.state.location);
    $acw62.useLayoutEffect(()=>{
        if ($5fc20031e6d40819$var$ssrInfo && $5fc20031e6d40819$var$ssrInfo.router && !$5fc20031e6d40819$var$ssrInfo.routerInitialized) {
            $5fc20031e6d40819$var$ssrInfo.routerInitialized = true;
            $5fc20031e6d40819$var$ssrInfo.router.initialize();
        }
    }, []);
    $acw62.useLayoutEffect(()=>{
        if ($5fc20031e6d40819$var$ssrInfo && $5fc20031e6d40819$var$ssrInfo.router) return $5fc20031e6d40819$var$ssrInfo.router.subscribe((newState)=>{
            if (newState.location !== location2) setLocation(newState.location);
        });
    }, [
        location2
    ]);
    (0, $3e8179397014bb35$export$f5708dca728d7177)($5fc20031e6d40819$var$ssrInfo, "ssrInfo unavailable for HydratedRouter");
    (0, $3e8179397014bb35$export$5ef046b23d96090d)($5fc20031e6d40819$var$router, $5fc20031e6d40819$var$ssrInfo.manifest, $5fc20031e6d40819$var$ssrInfo.routeModules, $5fc20031e6d40819$var$ssrInfo.context.ssr, $5fc20031e6d40819$var$ssrInfo.context.routeDiscovery, $5fc20031e6d40819$var$ssrInfo.context.isSpaMode);
    return(// This fragment is important to ensure we match the <ServerRouter> JSX
    // structure so that useId values hydrate correctly
    /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$208d6a3bc3aa62bd).Provider, {
        value: {
            manifest: $5fc20031e6d40819$var$ssrInfo.manifest,
            routeModules: $5fc20031e6d40819$var$ssrInfo.routeModules,
            future: $5fc20031e6d40819$var$ssrInfo.context.future,
            criticalCss: criticalCss,
            ssr: $5fc20031e6d40819$var$ssrInfo.context.ssr,
            isSpaMode: $5fc20031e6d40819$var$ssrInfo.context.isSpaMode,
            routeDiscovery: $5fc20031e6d40819$var$ssrInfo.context.routeDiscovery
        }
    }, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$32e57f52df4b6e34), {
        location: location2
    }, /* @__PURE__ */ $acw62.createElement($5fc20031e6d40819$export$323e4fc2fa4753fb, {
        router: $5fc20031e6d40819$var$router,
        useTransitions: props.useTransitions,
        onError: props.onError
    }))), /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null)));
}
var $5fc20031e6d40819$var$defaultManifestPath = "/__manifest";
function $5fc20031e6d40819$export$e5e8f3607b669df({ createFromReadableStream: createFromReadableStream, createTemporaryReferenceSet: createTemporaryReferenceSet, encodeReply: encodeReply, fetch: fetchImplementation = fetch }) {
    const globalVar = window;
    let landedActionId = 0;
    return async (id, args)=>{
        let actionId = globalVar.__routerActionID = (globalVar.__routerActionID ?? (globalVar.__routerActionID = 0)) + 1;
        const temporaryReferences = createTemporaryReferenceSet();
        const payloadPromise = fetchImplementation(new Request(location.href, {
            body: await encodeReply(args, {
                temporaryReferences: temporaryReferences
            }),
            method: "POST",
            headers: {
                Accept: "text/x-component",
                "rsc-action-id": id
            }
        })).then((response)=>{
            if (!response.body) throw new Error("No response body");
            return createFromReadableStream(response.body, {
                temporaryReferences: temporaryReferences
            });
        });
        $acw62.startTransition(()=>// @ts-expect-error - Needs React 19 types
            Promise.resolve(payloadPromise).then(async (payload)=>{
                if (payload.type === "redirect") {
                    let location2 = $5fc20031e6d40819$var$normalizeRedirectLocation(payload.location);
                    (0, $3e8179397014bb35$export$6c8e41f66e7aa990)(payload.location, location2, new URL(window.location.href), "allow-explicit");
                    if (payload.reload || $5fc20031e6d40819$var$isExternalLocation(location2)) {
                        if ((0, $3e8179397014bb35$export$961a3ef7a4da3a39)(location2)) throw new Error("Invalid redirect location");
                        window.location.href = location2;
                        return;
                    }
                    $acw62.startTransition(()=>{
                        globalVar.__reactRouterDataRouter.navigate(location2, {
                            replace: payload.replace
                        });
                    });
                    return;
                }
                if (payload.type !== "action") throw new Error("Unexpected payload type");
                const rerender = await payload.rerender;
                if (rerender && landedActionId < actionId && globalVar.__routerActionID <= actionId) {
                    if (rerender.type === "redirect") {
                        let location2 = $5fc20031e6d40819$var$normalizeRedirectLocation(rerender.location);
                        (0, $3e8179397014bb35$export$6c8e41f66e7aa990)(rerender.location, location2, new URL(window.location.href), "allow-explicit");
                        if (rerender.reload || $5fc20031e6d40819$var$isExternalLocation(location2)) {
                            if ((0, $3e8179397014bb35$export$961a3ef7a4da3a39)(location2)) throw new Error("Invalid redirect location");
                            window.location.href = location2;
                            return;
                        }
                        $acw62.startTransition(()=>{
                            globalVar.__reactRouterDataRouter.navigate(location2, {
                                replace: rerender.replace
                            });
                        });
                        return;
                    }
                    $acw62.startTransition(()=>{
                        let lastMatch;
                        for (const match of rerender.matches){
                            globalVar.__reactRouterDataRouter.patchRoutes(lastMatch?.id ?? null, [
                                $5fc20031e6d40819$var$createRouteFromServerManifest(match)
                            ], true);
                            lastMatch = match;
                        }
                        window.__reactRouterDataRouter._internalSetStateDoNotUseOrYouWillBreakYourApp({
                            loaderData: Object.assign({}, globalVar.__reactRouterDataRouter.state.loaderData, rerender.loaderData),
                            errors: rerender.errors ? Object.assign({}, globalVar.__reactRouterDataRouter.state.errors, rerender.errors) : null
                        });
                    });
                }
            }).catch(()=>{}));
        return payloadPromise.then((payload)=>{
            if (payload.type !== "action" && payload.type !== "redirect") throw new Error("Unexpected payload type");
            return payload.actionResult;
        });
    };
}
function $5fc20031e6d40819$var$createRouterFromPayload({ fetchImplementation: fetchImplementation, createFromReadableStream: createFromReadableStream, getContext: getContext, payload: payload }) {
    const globalVar = window;
    if (globalVar.__reactRouterDataRouter && globalVar.__reactRouterRouteModules) return {
        router: globalVar.__reactRouterDataRouter,
        routeModules: globalVar.__reactRouterRouteModules
    };
    if (payload.type !== "render") throw new Error("Invalid payload type");
    globalVar.__reactRouterRouteModules = globalVar.__reactRouterRouteModules ?? {};
    (0, $e4c31f3f81f1e687$export$93a6ee970ac9d016)(globalVar.__reactRouterRouteModules, payload.matches);
    let routes = payload.matches.reduceRight((previous, match)=>{
        const route = $5fc20031e6d40819$var$createRouteFromServerManifest(match, payload);
        if (previous.length > 0) route.children = previous;
        else if (!route.index) route.children = [];
        return [
            route
        ];
    }, []);
    let applyPatchesPromise;
    globalVar.__reactRouterDataRouter = (0, $3e8179397014bb35$export$baddd0131ee8c05b)({
        routes: routes,
        getContext: getContext,
        basename: payload.basename,
        history: (0, $3e8179397014bb35$export$719fc203c4e16dee)(),
        hydrationData: (0, $e4c31f3f81f1e687$export$6fa8d910d97963ad)({
            state: {
                loaderData: payload.loaderData,
                actionData: payload.actionData,
                errors: payload.errors
            },
            routes: routes,
            getRouteInfo: (routeId)=>{
                let match = payload.matches.find((m)=>m.id === routeId);
                (0, $3e8179397014bb35$export$f5708dca728d7177)(match, "Route not found in payload");
                return {
                    clientLoader: match.clientLoader,
                    hasLoader: match.hasLoader,
                    hasHydrateFallback: match.hydrateFallbackElement != null
                };
            },
            location: payload.location,
            basename: payload.basename,
            isSpaMode: false
        }),
        async patchRoutesOnNavigation ({ path: path, signal: signal }) {
            if (payload.routeDiscovery.mode === "initial") {
                if (!applyPatchesPromise) applyPatchesPromise = (async ()=>{
                    if (!payload.patches) return;
                    let patches = await payload.patches;
                    $acw62.startTransition(()=>{
                        patches.forEach((p)=>{
                            window.__reactRouterDataRouter.patchRoutes(p.parentId ?? null, [
                                $5fc20031e6d40819$var$createRouteFromServerManifest(p)
                            ]);
                        });
                    });
                })();
                await applyPatchesPromise;
                return;
            }
            if ($5fc20031e6d40819$var$discoveredPaths.has(path)) return;
            await $5fc20031e6d40819$var$fetchAndApplyManifestPatches([
                path
            ], createFromReadableStream, fetchImplementation, signal);
        },
        // FIXME: Pass `build.ssr` into this function
        dataStrategy: $5fc20031e6d40819$var$getRSCSingleFetchDataStrategy(()=>globalVar.__reactRouterDataRouter, true, payload.basename, createFromReadableStream, fetchImplementation)
    });
    if (globalVar.__reactRouterDataRouter.state.initialized) {
        globalVar.__routerInitialized = true;
        globalVar.__reactRouterDataRouter.initialize();
    } else globalVar.__routerInitialized = false;
    let lastLoaderData = void 0;
    globalVar.__reactRouterDataRouter.subscribe(({ loaderData: loaderData, actionData: actionData })=>{
        if (lastLoaderData !== loaderData) globalVar.__routerActionID = (globalVar.__routerActionID ?? (globalVar.__routerActionID = 0)) + 1;
    });
    globalVar.__reactRouterDataRouter._updateRoutesForHMR = (routeUpdateByRouteId)=>{
        const oldRoutes = window.__reactRouterDataRouter.routes;
        const newRoutes = [];
        function walkRoutes(routes2, parentId) {
            return routes2.map((route)=>{
                const routeUpdate = routeUpdateByRouteId.get(route.id);
                if (routeUpdate) {
                    const { routeModule: routeModule, hasAction: hasAction, hasComponent: hasComponent, hasErrorBoundary: hasErrorBoundary, hasLoader: hasLoader } = routeUpdate;
                    const newRoute = $5fc20031e6d40819$var$createRouteFromServerManifest({
                        clientAction: routeModule.clientAction,
                        clientLoader: routeModule.clientLoader,
                        element: route.element,
                        errorElement: route.errorElement,
                        handle: route.handle,
                        hasAction: hasAction,
                        hasComponent: hasComponent,
                        hasErrorBoundary: hasErrorBoundary,
                        hasLoader: hasLoader,
                        hydrateFallbackElement: route.hydrateFallbackElement,
                        id: route.id,
                        index: route.index,
                        links: routeModule.links,
                        meta: routeModule.meta,
                        parentId: parentId,
                        path: route.path,
                        shouldRevalidate: routeModule.shouldRevalidate
                    });
                    if (route.children) newRoute.children = walkRoutes(route.children, route.id);
                    return newRoute;
                }
                const updatedRoute = {
                    ...route
                };
                if (route.children) updatedRoute.children = walkRoutes(route.children, route.id);
                return updatedRoute;
            });
        }
        newRoutes.push(...walkRoutes(oldRoutes, void 0));
        window.__reactRouterDataRouter._internalSetRoutes(newRoutes);
    };
    return {
        router: globalVar.__reactRouterDataRouter,
        routeModules: globalVar.__reactRouterRouteModules
    };
}
var $5fc20031e6d40819$var$renderedRoutesContext = (0, $3e8179397014bb35$export$fd42f52fd3ae1109)();
function $5fc20031e6d40819$var$getRSCSingleFetchDataStrategy(getRouter, ssr, basename, createFromReadableStream, fetchImplementation) {
    let dataStrategy = (0, $3e8179397014bb35$export$7144ac7f1a8613d3)(getRouter, (match)=>{
        let M = match;
        return {
            hasLoader: M.route.hasLoader,
            hasClientLoader: M.route.hasClientLoader,
            hasComponent: M.route.hasComponent,
            hasAction: M.route.hasAction,
            hasClientAction: M.route.hasClientAction
        };
    }, // pass map into fetchAndDecode so it can add payloads
    $5fc20031e6d40819$var$getFetchAndDecodeViaRSC(createFromReadableStream, fetchImplementation), ssr, basename, // .rsc requests are always trailing slash aware
    true, // If the route has a component but we don't have an element, we need to hit
    // the server loader flow regardless of whether the client loader calls
    // `serverLoader` or not, otherwise we'll have nothing to render.
    (match)=>{
        let M = match;
        return M.route.hasComponent && !M.route.element;
    });
    return async (args)=>args.runClientMiddleware(async ()=>{
            let context = args.context;
            context.set($5fc20031e6d40819$var$renderedRoutesContext, []);
            let results = await dataStrategy(args);
            const renderedRoutesById = /* @__PURE__ */ new Map();
            for (const route of context.get($5fc20031e6d40819$var$renderedRoutesContext)){
                if (!renderedRoutesById.has(route.id)) renderedRoutesById.set(route.id, []);
                renderedRoutesById.get(route.id).push(route);
            }
            $acw62.startTransition(()=>{
                for (const match of args.matches){
                    const renderedRoutes = renderedRoutesById.get(match.route.id);
                    if (renderedRoutes) for (const rendered of renderedRoutes)window.__reactRouterDataRouter.patchRoutes(rendered.parentId ?? null, [
                        $5fc20031e6d40819$var$createRouteFromServerManifest(rendered)
                    ], true);
                }
            });
            return results;
        });
}
function $5fc20031e6d40819$var$getFetchAndDecodeViaRSC(createFromReadableStream, fetchImplementation) {
    return async (args, basename, trailingSlashAware, targetRoutes)=>{
        let { request: request, context: context } = args;
        let url = (0, $3e8179397014bb35$export$7b977381851b2c)(request.url, basename, trailingSlashAware, "rsc");
        if (request.method === "GET") {
            url = (0, $3e8179397014bb35$export$425969b7f98e2c9c)(url);
            if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
        }
        let res = await fetchImplementation(new Request(url, await (0, $3e8179397014bb35$export$a30aa2a0fce6c468)(request)));
        if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $3e8179397014bb35$export$f2680fa305b734ca)(res.status, res.statusText, await res.text());
        (0, $3e8179397014bb35$export$f5708dca728d7177)(res.body, "No response body to decode");
        try {
            const payload = await createFromReadableStream(res.body, {
                temporaryReferences: void 0
            });
            if (payload.type === "redirect") return {
                status: res.status,
                data: {
                    redirect: {
                        redirect: payload.location,
                        reload: payload.reload,
                        replace: payload.replace,
                        revalidate: false,
                        status: payload.status
                    }
                }
            };
            if (payload.type !== "render") throw new Error("Unexpected payload type");
            context.get($5fc20031e6d40819$var$renderedRoutesContext).push(...payload.matches);
            let results = {
                routes: {}
            };
            const dataKey = (0, $3e8179397014bb35$export$cbae47800eb95bc3)(request.method) ? "actionData" : "loaderData";
            for (let [routeId, data] of Object.entries(payload[dataKey] || {}))results.routes[routeId] = {
                data: data
            };
            if (payload.errors) for (let [routeId, error] of Object.entries(payload.errors))results.routes[routeId] = {
                error: error
            };
            return {
                status: res.status,
                data: results
            };
        } catch (cause) {
            throw new Error("Unable to decode RSC response", {
                cause: cause
            });
        }
    };
}
function $5fc20031e6d40819$export$af9dbdb90aaefbae({ createFromReadableStream: createFromReadableStream, fetch: fetchImplementation = fetch, payload: payload, getContext: getContext }) {
    if (payload.type !== "render") throw new Error("Invalid payload type");
    let { routeDiscovery: routeDiscovery } = payload;
    let { router: router2, routeModules: routeModules } = $acw62.useMemo(()=>$5fc20031e6d40819$var$createRouterFromPayload({
            payload: payload,
            fetchImplementation: fetchImplementation,
            getContext: getContext,
            createFromReadableStream: createFromReadableStream
        }), [
        createFromReadableStream,
        payload,
        fetchImplementation,
        getContext
    ]);
    $acw62.useEffect(()=>{
        (0, $3e8179397014bb35$export$3be068dde909e563)();
    }, []);
    $acw62.useLayoutEffect(()=>{
        const globalVar = window;
        if (!globalVar.__routerInitialized) {
            globalVar.__routerInitialized = true;
            globalVar.__reactRouterDataRouter.initialize();
        }
    }, []);
    let [{ routes: routes, state: state }, setState] = $acw62.useState(()=>({
            routes: $5fc20031e6d40819$var$cloneRoutes(router2.routes),
            state: router2.state
        }));
    $acw62.useLayoutEffect(()=>router2.subscribe((newState)=>{
            if ($5fc20031e6d40819$var$diffRoutes(router2.routes, routes)) $acw62.startTransition(()=>{
                setState({
                    routes: $5fc20031e6d40819$var$cloneRoutes(router2.routes),
                    state: newState
                });
            });
        }), [
        router2.subscribe,
        routes,
        router2
    ]);
    const transitionEnabledRouter = $acw62.useMemo(()=>({
            ...router2,
            state: state,
            routes: routes
        }), [
        router2,
        routes,
        state
    ]);
    $acw62.useEffect(()=>{
        if (routeDiscovery.mode === "initial" || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$5fc20031e6d40819$var$discoveredPaths.has(pathname)) $5fc20031e6d40819$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let paths = Array.from($5fc20031e6d40819$var$nextPaths.keys()).filter((path)=>{
                if ($5fc20031e6d40819$var$discoveredPaths.has(path)) {
                    $5fc20031e6d40819$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (paths.length === 0) return;
            try {
                await $5fc20031e6d40819$var$fetchAndApplyManifestPatches(paths, createFromReadableStream, fetchImplementation);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $5fc20031e6d40819$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
    }, [
        routeDiscovery,
        createFromReadableStream,
        fetchImplementation
    ]);
    const frameworkContext = {
        future: {
            // These flags have no runtime impact so can always be false.  If we add
            // flags that drive runtime behavior they'll need to be proxied through.
            v8_middleware: false,
            v8_trailingSlashAwareDataRequests: true,
            // always on for RSC
            v8_passThroughRequests: true
        },
        isSpaMode: false,
        ssr: true,
        criticalCss: "",
        manifest: {
            routes: {},
            version: "1",
            url: "",
            entry: {
                module: "",
                imports: []
            }
        },
        routeDiscovery: payload.routeDiscovery.mode === "initial" ? {
            mode: "initial",
            manifestPath: $5fc20031e6d40819$var$defaultManifestPath
        } : {
            mode: "lazy",
            manifestPath: payload.routeDiscovery.manifestPath || $5fc20031e6d40819$var$defaultManifestPath
        },
        routeModules: routeModules
    };
    return /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$717f757c655223f1).Provider, {
        value: true
    }, /* @__PURE__ */ $acw62.createElement((0, $e4c31f3f81f1e687$export$ea608ff93320d416), {
        location: state.location
    }, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$208d6a3bc3aa62bd).Provider, {
        value: frameworkContext
    }, /* @__PURE__ */ $acw62.createElement((0, $3e8179397014bb35$export$323e4fc2fa4753fb), {
        router: transitionEnabledRouter,
        flushSync: $11492dca620dcaa5$exports.flushSync
    }))));
}
function $5fc20031e6d40819$var$createRouteFromServerManifest(match, payload) {
    let hasInitialData = payload && match.id in payload.loaderData;
    let initialData = payload?.loaderData[match.id];
    let hasInitialError = payload?.errors && match.id in payload.errors;
    let initialError = payload?.errors?.[match.id];
    let isHydrationRequest = match.clientLoader?.hydrate === true || !match.hasLoader || // If the route has a component but we don't have an element, we need to hit
    // the server loader flow regardless of whether the client loader calls
    // `serverLoader` or not, otherwise we'll have nothing to render.
    match.hasComponent && !match.element;
    (0, $3e8179397014bb35$export$f5708dca728d7177)(window.__reactRouterRouteModules);
    (0, $e4c31f3f81f1e687$export$93a6ee970ac9d016)(window.__reactRouterRouteModules, match);
    let dataRoute = {
        id: match.id,
        element: match.element,
        errorElement: match.errorElement,
        handle: match.handle,
        hasErrorBoundary: match.hasErrorBoundary,
        hydrateFallbackElement: match.hydrateFallbackElement,
        index: match.index,
        loader: match.clientLoader ? async (args, singleFetch)=>{
            let _isHydrationRequest = isHydrationRequest;
            isHydrationRequest = false;
            let result = await match.clientLoader({
                ...args,
                serverLoader: ()=>{
                    $5fc20031e6d40819$var$preventInvalidServerHandlerCall("loader", match.id, match.hasLoader);
                    if (_isHydrationRequest) {
                        if (hasInitialData) return initialData;
                        if (hasInitialError) throw initialError;
                    }
                    return $5fc20031e6d40819$var$callSingleFetch(singleFetch);
                }
            });
            return result;
        } : // We always make the call in this RSC world since even if we don't
        // have a `loader` we may need to get the `element` implementation
        (_, singleFetch)=>$5fc20031e6d40819$var$callSingleFetch(singleFetch),
        action: match.clientAction ? (args, singleFetch)=>match.clientAction({
                ...args,
                serverAction: async ()=>{
                    $5fc20031e6d40819$var$preventInvalidServerHandlerCall("action", match.id, match.hasLoader);
                    return await $5fc20031e6d40819$var$callSingleFetch(singleFetch);
                }
            }) : match.hasAction ? (_, singleFetch)=>$5fc20031e6d40819$var$callSingleFetch(singleFetch) : ()=>{
            throw (0, $3e8179397014bb35$export$2754e84c8e66e57d)("action", match.id);
        },
        path: match.path,
        shouldRevalidate: match.shouldRevalidate,
        // We always have a "loader" in this RSC world since even if we don't
        // have a `loader` we may need to get the `element` implementation
        hasLoader: true,
        hasClientLoader: match.clientLoader != null,
        hasAction: match.hasAction,
        hasClientAction: match.clientAction != null
    };
    if (typeof dataRoute.loader === "function") dataRoute.loader.hydrate = (0, $3e8179397014bb35$export$6ac68922d4e92125)(match.id, match.clientLoader, match.hasLoader, false);
    return dataRoute;
}
function $5fc20031e6d40819$var$callSingleFetch(singleFetch) {
    (0, $3e8179397014bb35$export$f5708dca728d7177)(typeof singleFetch === "function", "Invalid singleFetch parameter");
    return singleFetch();
}
function $5fc20031e6d40819$var$preventInvalidServerHandlerCall(type, routeId, hasHandler) {
    if (!hasHandler) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${routeId}")`;
        console.error(msg);
        throw new (0, $3e8179397014bb35$export$f2680fa305b734ca)(400, "Bad Request", new Error(msg), true);
    }
}
var $5fc20031e6d40819$var$nextPaths = /* @__PURE__ */ new Set();
var $5fc20031e6d40819$var$discoveredPathsMaxSize = 1e3;
var $5fc20031e6d40819$var$discoveredPaths = /* @__PURE__ */ new Set();
function $5fc20031e6d40819$var$getManifestUrl(paths) {
    if (paths.length === 0) return null;
    if (paths.length === 1) return new URL(`${paths[0]}.manifest`, window.location.origin);
    const globalVar = window;
    let basename = (globalVar.__reactRouterDataRouter.basename ?? "").replace(/^\/|\/$/g, "");
    let url = new URL(`${basename}/.manifest`, window.location.origin);
    url.searchParams.set("paths", paths.sort().join(","));
    return url;
}
async function $5fc20031e6d40819$var$fetchAndApplyManifestPatches(paths, createFromReadableStream, fetchImplementation, signal) {
    paths = (0, $3e8179397014bb35$export$791cac19ae57137a)(paths);
    let url = $5fc20031e6d40819$var$getManifestUrl(paths);
    if (url == null) return;
    if (url.toString().length > (0, $3e8179397014bb35$export$b5915cf27fa06b9f)) {
        $5fc20031e6d40819$var$nextPaths.clear();
        return;
    }
    let response = await fetchImplementation(new Request(url, {
        signal: signal
    }));
    if (!response.body || response.status < 200 || response.status >= 300) throw new Error("Unable to fetch new route matches from the server");
    let payload = await createFromReadableStream(response.body, {
        temporaryReferences: void 0
    });
    if (payload.type !== "manifest") throw new Error("Failed to patch routes");
    paths.forEach((p)=>$5fc20031e6d40819$var$addToFifoQueue(p, $5fc20031e6d40819$var$discoveredPaths));
    let patches = await payload.patches;
    $acw62.startTransition(()=>{
        patches.forEach((p)=>{
            window.__reactRouterDataRouter.patchRoutes(p.parentId ?? null, [
                $5fc20031e6d40819$var$createRouteFromServerManifest(p)
            ]);
        });
    });
}
function $5fc20031e6d40819$var$addToFifoQueue(path, queue) {
    if (queue.size >= $5fc20031e6d40819$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (typeof first === "string") queue.delete(first);
    }
    queue.add(path);
}
function $5fc20031e6d40819$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
function $5fc20031e6d40819$var$isExternalLocation(location2) {
    const newLocation = new URL(location2, window.location.href);
    return newLocation.origin !== window.location.origin;
}
function $5fc20031e6d40819$var$normalizeRedirectLocation(location2) {
    if ((0, $3e8179397014bb35$export$825a82322d91916e).test(location2)) {
        let path = (0, $3e8179397014bb35$export$b09f2ff0bbcb43c7)(location2);
        return path.pathname + path.search + path.hash;
    }
    return location2;
}
function $5fc20031e6d40819$var$cloneRoutes(routes) {
    if (!routes) return void 0;
    return routes.map((route)=>({
            ...route,
            children: $5fc20031e6d40819$var$cloneRoutes(route.children)
        }));
}
function $5fc20031e6d40819$var$diffRoutes(a, b) {
    if (a.length !== b.length) return true;
    return a.some((route, index)=>{
        if (route.element !== b[index].element) return true;
        if (route.errorElement !== b[index].errorElement) return true;
        if (route.hydrateFallbackElement !== b[index].hydrateFallbackElement) return true;
        if (route.hasErrorBoundary !== b[index].hasErrorBoundary) return true;
        if (route.hasLoader !== b[index].hasLoader) return true;
        if (route.hasClientLoader !== b[index].hasClientLoader) return true;
        if (route.hasAction !== b[index].hasAction) return true;
        if (route.hasClientAction !== b[index].hasClientAction) return true;
        return $5fc20031e6d40819$var$diffRoutes(route.children || [], b[index].children || []);
    });
}
// lib/rsc/html-stream/browser.ts
function $5fc20031e6d40819$export$f4bb6b48866e43b() {
    let encoder = new TextEncoder();
    let streamController = null;
    let rscStream = new ReadableStream({
        start (controller) {
            if (typeof window === "undefined") return;
            let handleChunk = (chunk)=>{
                if (typeof chunk === "string") controller.enqueue(encoder.encode(chunk));
                else controller.enqueue(chunk);
            };
            window.__FLIGHT_DATA || (window.__FLIGHT_DATA = []);
            window.__FLIGHT_DATA.forEach(handleChunk);
            window.__FLIGHT_DATA.push = (chunk)=>{
                handleChunk(chunk);
                return 0;
            };
            streamController = controller;
        }
    });
    if (typeof document !== "undefined" && document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>{
        streamController?.close();
    });
    else streamController?.close();
    return rscStream;
}






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $5e79fd8d87f78889$export$129aff4b527bc0eb = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $5e79fd8d87f78889$export$4dda1981a34a6aa4({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5e79fd8d87f78889$export$129aff4b527bc0eb.Provider, {
        value: value,
        children: children
    });
}


const $7c5a3dd94b85a123$export$72f8d6ff1467b5f4 = (Component, diConfig)=>// eslint-disable-next-line react/display-name
    (props)=>{
        const diContainer = (0, $acw62.useContext)((0, $5e79fd8d87f78889$export$129aff4b527bc0eb));
        if (diContainer == null) throw new Error("DIContainerContext not provided");
        const dependencyInjectionProps = Object.entries(diConfig).reduce((acc, [propName, dependencyName])=>{
            const dependency = diContainer[dependencyName];
            return {
                ...acc,
                [propName]: dependency
            };
        }, {});
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ...dependencyInjectionProps
        });
    };



const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $568f4ee4022ba00e$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $568f4ee4022ba00e$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;



var $b8438 = parcelRequire("b8438");
var $60313e3b9e75c852$exports = {};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(' ');
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $acw62 = parcelRequire("acw62");


function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}


function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $702e4d306615a028$var$extendStatics = function(d, b) {
    $702e4d306615a028$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $702e4d306615a028$var$extendStatics(d, b);
};
function $702e4d306615a028$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $702e4d306615a028$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $702e4d306615a028$export$18ce0697a983be9b = function() {
    $702e4d306615a028$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $702e4d306615a028$export$18ce0697a983be9b.apply(this, arguments);
};
function $702e4d306615a028$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $702e4d306615a028$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $702e4d306615a028$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $702e4d306615a028$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $702e4d306615a028$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $702e4d306615a028$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $702e4d306615a028$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $702e4d306615a028$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $702e4d306615a028$export$45d3717a4c69092e(o, m, p);
}
function $702e4d306615a028$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $702e4d306615a028$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $702e4d306615a028$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($702e4d306615a028$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $702e4d306615a028$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $702e4d306615a028$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $702e4d306615a028$export$10c90e4f7922046c(v) {
    return this instanceof $702e4d306615a028$export$10c90e4f7922046c ? (this.v = v, this) : new $702e4d306615a028$export$10c90e4f7922046c(v);
}
function $702e4d306615a028$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $702e4d306615a028$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $702e4d306615a028$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $702e4d306615a028$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $702e4d306615a028$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $702e4d306615a028$export$19a8beecd37a4c45 === "function" ? $702e4d306615a028$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $702e4d306615a028$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $702e4d306615a028$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $702e4d306615a028$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $702e4d306615a028$export$45d3717a4c69092e(result, mod, k);
    }
    $702e4d306615a028$var$__setModuleDefault(result, mod);
    return result;
}
function $702e4d306615a028$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $702e4d306615a028$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $702e4d306615a028$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $702e4d306615a028$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}






function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $702e4d306615a028$export$1216008129fb82ed)((0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(errors)), (0, $702e4d306615a028$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && 'closed' in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};


function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $cf8ce74b80455e9f$export$60959659b2c22881));


function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}





var $acw62 = parcelRequire("acw62");
function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}




function $6fb8b1c12553edae$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $7569c528cdd9d182$export$f0954fd7d5368655);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $6fb8b1c12553edae$var$defaultCompare;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $6fb8b1c12553edae$var$defaultCompare(a, b) {
    return a === b;
}


const $52d6aae768cd1bf0$export$7bc289ae93a0a81d = (context, initialState, createWorkflow)=>{
    const [_workflow] = (0, $acw62.useState)(createWorkflow(initialState, context));
    const [_state, setState] = (0, $acw62.useState)(initialState);
    const dispatch = (action)=>_workflow.emit(action);
    (0, $acw62.useEffect)(()=>{
        const subscription = new (0, $8343668acd7c4a9b$export$f55210826850c514)();
        subscription.add(_workflow.states.pipe((0, $6fb8b1c12553edae$export$779c5fb865a0172e)((previous, current)=>JSON.stringify(previous) === JSON.stringify(current))).subscribe(setState));
        var next;
        return ()=>{
            subscription.unsubscribe();
        };
    }, []);
    return [
        _state,
        dispatch,
        _workflow
    ];
};



var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};



function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}




var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();



function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]);
}



function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();



function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]);
}




function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $702e4d306615a028$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $702e4d306615a028$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $702e4d306615a028$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $702e4d306615a028$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $702e4d306615a028$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]();
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $18eb28ff53cc4943$export$ebf645db02d3e99f));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $54b99b9095e84ce4$export$cf4785e597badab3)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $702e4d306615a028$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $702e4d306615a028$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $702e4d306615a028$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}


function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}




function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}





function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}



function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)((0, $54b99b9095e84ce4$export$cf4785e597badab3)(input), scheduler);
}


function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return (0, $e3a1d71c442b5de9$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return (0, $0ce5b91768be0a6d$export$b34673931371729a)(input, scheduler);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return (0, $7ea29ae5d684fb04$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return (0, $3a22bf76b9b6de63$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return (0, $7999ea1c5b71ad25$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}



function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $8f2bbfa9b5105688$export$49c44dfc2bb21d70)(input, scheduler) : (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input);
}



function $cd8e5ea142a386bd$export$187e35932e88c15c(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.schedule);
}


function $3b29c258456d9a89$var$last(arr) {
    return arr[arr.length - 1];
}
function $3b29c258456d9a89$export$9ae19b645239a61b(args) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$29534b2f653ae592(args) {
    return (0, $cd8e5ea142a386bd$export$187e35932e88c15c)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3b29c258456d9a89$var$last(args) === 'number' ? args.pop() : defaultValue;
}



function $195e3b3043565ec4$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, scheduler);
}


/* eslint @typescript-eslint/no-explicit-any: "off" */ /**
 * NOTE(cvu): COPIED FROM @banking DASHBOARD. DO NOT EDIT
 */ 
var $8faf6f2806f38bc2$export$ccb33e29d92c9a58 = new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $8faf6f2806f38bc2$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $8faf6f2806f38bc2$var$emptyScheduled(scheduler) : $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
}
function $8faf6f2806f38bc2$var$emptyScheduled(scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

function $854df3a4a165b4ff$export$6003a5f097c73977(pred, thisArg) {
    return function(value, index) {
        return !pred.call(thisArg, value, index);
    };
}




function $98681b222841709d$export$b29f828819edca8d(source, predicate, thisArg) {
    return [
        (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(predicate, thisArg)((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source)),
        (0, $98aaadcfa91e6727$export$3dea766d36a8935f)((0, $854df3a4a165b4ff$export$6003a5f097c73977)(predicate, thisArg))((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source))
    ];
}





var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);





function $b910c27483c6e6a0$export$3dede90624df3ba9(selector) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(selector(err, $b910c27483c6e6a0$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}


var $6cabd83f99ce6113$export$78f6d1b1dbcda304 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});






function $e53e80f9042754be$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
    } : (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}




function $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b(defaultValue) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}





function $8c2c9c105ebfd25b$export$c8ea5e9f84346833(errorFactory) {
    if (errorFactory === void 0) errorFactory = $8c2c9c105ebfd25b$var$defaultErrorFactory;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function $8c2c9c105ebfd25b$var$defaultErrorFactory() {
    return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
}



function $b9a90ca4d933af63$export$43128fadae87b74a(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655), (0, $e53e80f9042754be$export$b7df5d561049483a)(1), hasDefaultValue ? (0, $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b)(defaultValue) : (0, $8c2c9c105ebfd25b$export$c8ea5e9f84346833)(function() {
            return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
        }));
    };
}



function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}







function $9cbbbba4f565a378$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $46964ba1b403cbfc$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(resultSelector)) return $46964ba1b403cbfc$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        return (0, $9cbbbba4f565a378$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}


var $95de7a7c38006759$export$5b8affa63fc6df16 = (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9);



function $949f1fd33ffd44b7$export$8f9d79d42bff1aac() {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}






function $0cd9b6b86141760f$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $0cd9b6b86141760f$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $0cd9b6b86141760f$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return on.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(args))).subscribe(onSubscriber);
}



function $4707859e785b3da6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)((0, $7569c528cdd9d182$export$f0954fd7d5368655), concurrent);
}


function $3a4e37c3b56570cb$export$b314777ae20abca9() {
    return (0, $4707859e785b3da6$export$18aef43295bbe906)(1);
}




function $82eda875fdd470db$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $3a4e37c3b56570cb$export$b314777ae20abca9)()((0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, (0, $3b29c258456d9a89$export$29534b2f653ae592)(args)));
}




function $b52129d9072c7912$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(values);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        (scheduler ? (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(values, source, scheduler) : (0, $82eda875fdd470db$export$ee1b3e54f0441b22)(values, source)).subscribe(subscriber);
    });
}








function $ada720f14bd5f844$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $3b29c258456d9a89$export$9ae19b645239a61b)(inputs);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(inputs[i]).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $7569c528cdd9d182$export$f0954fd7d5368655))) && (hasValue = null);
                }
            }, (0, $528e75db69787807$export$8793edee2d425525)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (ready) {
                var values = (0, $702e4d306615a028$export$1216008129fb82ed)([
                    value
                ], (0, $702e4d306615a028$export$8d051b38c9118094)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(values))) : values);
            }
        }));
    });
}


var $f244369e42336676$export$cc7e12c76513e857 = /*#__PURE__*/ function(Command) {
    Command["Done"] = "SECRET_KEY__DO_NOT__USE__OR_WE_WILL_ADD_MORE_UNDERSCORES/DONE";
    return Command;
}({});
const $f244369e42336676$export$26128561c93f5847 = (value)=>value != null;
const $f244369e42336676$var$isCommand = (value)=>value === "SECRET_KEY__DO_NOT__USE__OR_WE_WILL_ADD_MORE_UNDERSCORES/DONE";
// NOTE(steckel): We previously utilized `instance of Promise` for this
// use-case but that does not work well where Promise-polyfill libraries must
// seamlessly integrate.
const $f244369e42336676$var$isPromiseLike = (value)=>typeof value?.then === "function";
const $f244369e42336676$export$a7a096f65990e390 = (nextAction)=>{
    const observableAction = (()=>{
        if (nextAction instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4)) return nextAction;
        else if ($f244369e42336676$var$isPromiseLike(nextAction)) return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(nextAction);
        else if (nextAction !== null) return (0, $195e3b3043565ec4$export$ba255e9e49e00608)(nextAction);
        else return (0, $8faf6f2806f38bc2$export$6e22c362a0406a2c)();
    })();
    return observableAction.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)($f244369e42336676$export$26128561c93f5847));
};
const $f244369e42336676$var$update = (updater, seed)=>(source)=>new (0, $4f562137a990678a$export$77cea355fa80b5f4)((subscriber)=>{
            let state = seed;
            const next = (action)=>{
                try {
                    const update = updater(state, action);
                    state = update[0];
                    subscriber.next(update);
                } catch (err) {
                    subscriber.error(err);
                }
            };
            const error = (err)=>{
                subscriber.error(err);
            };
            const subscription = source.subscribe({
                next: next,
                error: error
            });
            return ()=>subscription.unsubscribe();
        });
const $f244369e42336676$var$workflow = (updater, seed)=>{
    // Public states subject. This will be exposed publically as a hot
    // observable for workflow state.
    const publicStates = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    // Public side-effect subject. This will be exposed publically as a hot
    // observable for workflow side-effects.
    const publicUpdates = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    const internalActions = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    const [commands, actions] = (0, $98681b222841709d$export$b29f828819edca8d)(internalActions, (val)=>$f244369e42336676$var$isCommand(val));
    // Handle Command.DONE
    commands.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)((command)=>command === "SECRET_KEY__DO_NOT__USE__OR_WE_WILL_ADD_MORE_UNDERSCORES/DONE"), (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>(0, $8faf6f2806f38bc2$export$6e22c362a0406a2c)())).subscribe(()=>publicStates.complete());
    // This observable receives actions and invokes the updater function
    const actionHandler = actions.pipe($f244369e42336676$var$update(updater, seed), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([state, nextActionFactory])=>[
            state,
            $f244369e42336676$export$a7a096f65990e390(nextActionFactory?.() ?? null)
        ]), // We need this observable to be hot so that the update function does not
    // receive duplicate invocations for a particular action
    (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)());
    // This observable powers our public states observable
    const states = actionHandler.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)(([state, _])=>state), // immediately send the initial state into the observable
    // (aids with updates initial value)
    (0, $b52129d9072c7912$export$a4fe86229b0e9bdd)(seed));
    // This observable powers our public updates/side-effect observable
    const updates = states.pipe(// select previous and next state
    (0, $949f1fd33ffd44b7$export$8f9d79d42bff1aac)(), (0, $ada720f14bd5f844$export$d449030e5c10edf7)(actions), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([states, action])=>[
            states,
            action
        ]), // swallow errors from upstream and end the observable gracefully
    (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>(0, $8faf6f2806f38bc2$export$6e22c362a0406a2c)()));
    // Subscribe to our internal observables to push values into our public
    // subjects
    updates.subscribe({
        next: (value)=>publicUpdates.next(value)
    });
    states.subscribe({
        next: (value)=>publicStates.next(value),
        error: (err)=>publicStates.error(err)
    });
    // This observable extracts any next actions from the result of calling the
    // updater function
    actionHandler.pipe(// swallow errors from upstream and end the observable gracefully;
    // do not continue with more actions
    (0, $b910c27483c6e6a0$export$3dede90624df3ba9)(()=>(0, $8faf6f2806f38bc2$export$6e22c362a0406a2c)()), // flat map the next actions observable upward for subscription
    (0, $95de7a7c38006759$export$5b8affa63fc6df16)(([_, actions])=>actions)).subscribe({
        // forward actions to original actions subject for processing
        next: (action)=>internalActions.next(action),
        // forward errors to original actions subject to publish error within
        // the public states observable
        error: (err)=>internalActions.error(err)
    });
    // TODO(steckel): Consider transforming states with `.pipe(distinctUntilChanged)`
    return {
        emit: (action)=>internalActions.next(action),
        states: publicStates.asObservable().pipe((0, $0cd9b6b86141760f$export$ed80d9de1d9df928)()),
        updates: publicUpdates.asObservable().pipe((0, $0cd9b6b86141760f$export$ed80d9de1d9df928)())
    };
};
var $f244369e42336676$export$2e2bcd8739ae039 = $f244369e42336676$var$workflow;









// DO NOT EDIT! This is copy and pasted from dashboard
// frontend/@banking/ui/addon/models/checking/onboarding/card-customization.ts
// TODO(cvu): eventually import this from dashboard via bazel
var $8ac095e22cd80964$export$c1bd96fb305c59e8 = /*#__PURE__*/ function(SignatureFont) {
    SignatureFont["AlexBrush"] = "Alex Brush";
    SignatureFont["Allura"] = "Allura";
    SignatureFont["AmaticSC"] = "Amatic SC";
    SignatureFont["AnnieUseYourTelescope"] = "Annie Use Your Telescope";
    SignatureFont["DancingScript"] = "Dancing Script";
    SignatureFont["GreatVibes"] = "Great Vibes";
    SignatureFont["IndieFlower"] = "Indie Flower";
    SignatureFont["Kristi"] = "Kristi";
    SignatureFont["LaBelleAurore"] = "La Belle Aurore";
    SignatureFont["MeieScript"] = "Meie Script";
    SignatureFont["MrsSaintDelafield"] = "Mrs Saint Delafield";
    SignatureFont["NanumPenScript"] = "Nanum Pen Script";
    SignatureFont["OvertheRainbow"] = "Over the Rainbow";
    SignatureFont["Qwigley"] = "Qwigley";
    SignatureFont["ReenieBeanie"] = "Reenie Beanie";
    SignatureFont["SueEllenFrancisco"] = "Sue Ellen Francisco";
    return SignatureFont;
}({});
const $8ac095e22cd80964$export$970f1491a494c331 = Object.values($8ac095e22cd80964$export$c1bd96fb305c59e8);


// DO NOT EDIT! This is copy and pasted from dashboard
// frontend/@banking/ui/addon/utils/string.ts
// TODO(cvu): eventually import this from dashboard via bazel
// Regular expression initially extracted from lodash. Treat with skepticism.
const $488d76279e935265$var$EMOJI_PATTERN = // eslint-disable-next-line no-misleading-character-class
/[\u2700-\u27BF]|(?:\uD83C[\uDDE6-\uDDFF]){2}|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u0023-\u0039]\uFE0F?\u20E3|\u3299|\u3297|\u303D|\u3030|\u24C2|\uD83C[\uDD70\uDD71]|\uD83C[\uDD7E\uDD7F]|\uD83C\uDD8E|\uD83C[\uDD91-\uDD9A]|\uD83C[\uDDE6-\uDDFF]|[\uD83C\uDE01\uDE02]|\uD83C\uDE1A|\uD83C\uDE2F|[\uD83C\uDE32-\uDE3A]|[\uD83C\uDE50\uDE51]|\u203C|\u2049|[\u25AA\u25AB]|\u25B6|\u25C0|[\u25FB-\u25FE]|\u00A9|\u00AE|\u2122|\u2139|\uD83C\uDC04|[\u2600-\u26FF]|\u2B05|\u2B06|\u2B07|\u2B1B|\u2B1C|\u2B50|\u2B55|\u231A|\u231B|\u2328|\u23CF|[\u23E9-\u23F3]|[\u23F8-\u23FA]|\uD83C\uDCCF|\u2934|\u2935|[\u2190-\u21FF]|\uFE0F|\u200D/g;
function $488d76279e935265$export$9efee81811214072(input) {
    return `${input}`.replace($488d76279e935265$var$EMOJI_PATTERN, "");
}
function $488d76279e935265$export$537947b51dead775(input) {
    return input.match($488d76279e935265$var$EMOJI_PATTERN) !== null;
}


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// DO NOT EDIT! This is copy and pasted from dashboard
// frontend/@banking/ui/addon/utils/text-renderer.ts
// TODO(cvu): eventually import this from dashboard via bazel

const $74c7b72a71b76868$var$BUSINESS_BANKING_CARD_SIGNATURE_RECT_WIDTH = 1062;
const $74c7b72a71b76868$var$BUSINESS_BANKING_CARD_SIGNATURE_RECT_HEIGHT = 354;
const $74c7b72a71b76868$var$SIGNATURE_PADDING = 4;
const $74c7b72a71b76868$export$9a1b8f2a422bb03a = {
    width: $74c7b72a71b76868$var$BUSINESS_BANKING_CARD_SIGNATURE_RECT_WIDTH,
    height: $74c7b72a71b76868$var$BUSINESS_BANKING_CARD_SIGNATURE_RECT_HEIGHT
};
function $74c7b72a71b76868$export$cb8806e8acc557d7(fontSize, fontFamily) {
    return `${fontSize}px ${fontFamily}`;
}
function $74c7b72a71b76868$export$2344b14b097df817(a, b) {
    return a.height >= b.height && a.width >= b.width;
}
function $74c7b72a71b76868$export$ec1a41cc27ddd097(context, font, text) {
    context.textAlign = "right";
    context.textBaseline = "middle";
    context.font = font;
    const { actualBoundingBoxAscent: actualBoundingBoxAscent, actualBoundingBoxDescent: actualBoundingBoxDescent, actualBoundingBoxLeft: actualBoundingBoxLeft, actualBoundingBoxRight: actualBoundingBoxRight } = context.measureText(text);
    if (actualBoundingBoxAscent == null || actualBoundingBoxDescent == null || actualBoundingBoxLeft == null || actualBoundingBoxRight == null) throw new Error("TextMetrics does not support required actualBoundingBox properties");
    const height = Math.ceil(actualBoundingBoxAscent + actualBoundingBoxDescent) + $74c7b72a71b76868$var$SIGNATURE_PADDING;
    const width = Math.ceil(actualBoundingBoxLeft + actualBoundingBoxRight) + $74c7b72a71b76868$var$SIGNATURE_PADDING;
    const x = context.canvas.width - Math.ceil(actualBoundingBoxRight) - $74c7b72a71b76868$var$SIGNATURE_PADDING / 2;
    const y = (context.canvas.height - height) / 2 + Math.ceil(actualBoundingBoxAscent) + $74c7b72a71b76868$var$SIGNATURE_PADDING / 2;
    return {
        coordinates: {
            x: x,
            y: y
        },
        rect: {
            width: width,
            height: height
        }
    };
}
function $74c7b72a71b76868$export$d6aae5c6ae5c73f6(context, fontFamily, fontSize, measureTextFn, text) {
    if (fontSize <= 0 || fontSize > Number.MAX_VALUE) throw new RangeError("Calculated font size fell outside bounds before reaching a solution.");
    if (!/\S/.test(text)) return {
        fontFamily: fontFamily,
        fontSize: fontSize,
        coordinates: {
            x: 0,
            y: 0
        }
    };
    const font = $74c7b72a71b76868$export$cb8806e8acc557d7(fontSize, fontFamily);
    const targetSize = {
        width: context.canvas.width,
        height: context.canvas.height
    };
    const actualSize = measureTextFn(context, font, text);
    const fits = $74c7b72a71b76868$export$2344b14b097df817(targetSize, actualSize.rect);
    if (fits) {
        const increasedFontSize = fontSize + 1;
        const increasedFont = $74c7b72a71b76868$export$cb8806e8acc557d7(increasedFontSize, fontFamily);
        const increasedActualSize = measureTextFn(context, increasedFont, text);
        const increasedFits = $74c7b72a71b76868$export$2344b14b097df817(targetSize, increasedActualSize.rect);
        if (increasedFits) return $74c7b72a71b76868$export$d6aae5c6ae5c73f6(context, fontFamily, fontSize + 2, measureTextFn, text);
        // if this size fits, but n + 1 doesn't, we found our match
        return {
            fontFamily: fontFamily,
            fontSize: fontSize,
            coordinates: actualSize.coordinates
        };
    }
    const decreasedFontSize = fontSize - 1;
    const decreasedFont = $74c7b72a71b76868$export$cb8806e8acc557d7(decreasedFontSize, fontFamily);
    const decreasedActualSize = measureTextFn(context, decreasedFont, text);
    const decreasedFits = $74c7b72a71b76868$export$2344b14b097df817(targetSize, decreasedActualSize.rect);
    if (decreasedFits) // if this size doesn't fit, but n - 1 does, we found our match
    return {
        fontFamily: fontFamily,
        fontSize: decreasedFontSize,
        coordinates: decreasedActualSize.coordinates
    };
    return $74c7b72a71b76868$export$d6aae5c6ae5c73f6(context, fontFamily, fontSize - 2, measureTextFn, text);
}
const $74c7b72a71b76868$export$5aa9cd1ba259435e = {
    calculateTextRenderingParams (context, fontSize, fontFamily, text) {
        return $74c7b72a71b76868$export$d6aae5c6ae5c73f6(context, fontFamily, fontSize, $74c7b72a71b76868$export$ec1a41cc27ddd097, text);
    },
    createCanvas () {
        return document.createElement("canvas");
    }
};
class $74c7b72a71b76868$export$2e2bcd8739ae039 {
    #canvas;
    #context;
    #textRenderingParams;
    #strategy;
    #text;
    constructor(estimatedfontSize, fontFamily, text, boundingBox, strategy){
        this.#canvas = strategy.createCanvas();
        this.#canvas.height = boundingBox.height;
        this.#canvas.width = boundingBox.width;
        this.#context = (0, $5cdd7c46b89c41cf$export$31407c2dd876dbd1)(this.#canvas.getContext("2d"));
        this.#strategy = strategy;
        this.#text = text;
        this.#textRenderingParams = this.#strategy.calculateTextRenderingParams(this.#context, estimatedfontSize, fontFamily, text);
    }
    get fontFamily() {
        return this.#textRenderingParams.fontFamily;
    }
    set fontFamily(newFontFamily) {
        if (this.#textRenderingParams.fontFamily !== newFontFamily) {
            const { fontSize: fontSize } = this.#textRenderingParams;
            this.#textRenderingParams = this.#strategy.calculateTextRenderingParams(this.#context, fontSize, newFontFamily, this.#text);
        }
    }
    get text() {
        return this.#text;
    }
    set text(newText) {
        if (this.#text !== newText) {
            this.#text = newText;
            const { fontFamily: fontFamily, fontSize: fontSize } = this.#textRenderingParams;
            this.#textRenderingParams = this.#strategy.calculateTextRenderingParams(this.#context, fontSize, fontFamily, this.#text);
        }
    }
    toDataURL() {
        this.render();
        return this.#canvas.toDataURL();
    }
    toBytes() {
        this.render();
        return new Promise((resolve, reject)=>{
            try {
                this.#canvas.toBlob((blob)=>resolve(blob), "image/png");
            } catch (e) {
                reject(e);
            }
        }).then((blob)=>blob ?? new Blob()).then((blob)=>blob.arrayBuffer()).then((buffer)=>new Uint8Array(buffer));
    }
    render() {
        const context = (0, $5cdd7c46b89c41cf$export$31407c2dd876dbd1)(this.#canvas.getContext("2d"));
        context.clearRect(0, 0, this.#canvas.width, this.#canvas.height);
        if (/\S/.test(this.#text)) {
            const { fontFamily: fontFamily, fontSize: fontSize, coordinates: coordinates } = this.#textRenderingParams;
            context.font = $74c7b72a71b76868$export$cb8806e8acc557d7(fontSize, fontFamily);
            context.fillText(this.#text, coordinates.x, coordinates.y);
        }
    }
}


const $d50f52fc18ffa921$export$6bcdc49eab1cd857 = 21;
const $d50f52fc18ffa921$var$MIME_TYPE = "image/png";
var $d50f52fc18ffa921$export$b58c4be94c1619ca = /*#__PURE__*/ function(CardCustomizationSignatureError) {
    CardCustomizationSignatureError["ContainsEmoji"] = "CARD_CUSTOMIZATION_SIGNATURE_ERROR_CONTAINS_EMOJI";
    CardCustomizationSignatureError["Empty"] = "CARD_CUSTOMIZATION_SIGNATURE_ERROR_EMPTY";
    CardCustomizationSignatureError["ExceededMaxLength"] = "CARD_CUSTOMIZATION_SIGNATURE_ERROR_EXCEEDED_MAX_LENGTH";
    return CardCustomizationSignatureError;
}({});
const $d50f52fc18ffa921$export$36d128238e6b60f5 = {
    cardInvitationToken: "",
    cardCustomizationToken: "",
    customSignatureInputError: [],
    done: false,
    loading: false,
    signatureFont: (0, $8ac095e22cd80964$export$c1bd96fb305c59e8).AlexBrush,
    signatureInputText: "",
    signatureText: "",
    toggleCustomSignature: false
};
const $d50f52fc18ffa921$export$e6a0daad8304de = (overrides = {})=>({
        ...$d50f52fc18ffa921$export$36d128238e6b60f5,
        ...overrides
    });
const $d50f52fc18ffa921$var$renderCardCustomization = (TextRenderer)=>(state)=>state.toggleCustomSignature ? new TextRenderer(// Note(cvu): This value was copied from dashboard so the image generated
        // in banking-web will be the same as the one generated in dashboard.
        // https://github.com/squareup/dashboard/blob/4642381a3237dd628fbe821ef1a1d4bdfbba298e/frontend/%40banking/applet-engine/addon/workflows/banking/checking/onboarding/index.ts#L866
        100, state.signatureFont, state.signatureText, (0, $74c7b72a71b76868$export$9a1b8f2a422bb03a), (0, $74c7b72a71b76868$export$5aa9cd1ba259435e)).toBytes() : Promise.resolve(undefined);
var $d50f52fc18ffa921$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["CreateCardCustomizationReceived"] = "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_RECEIVED";
    ActionType["CreateCardCustomizationRejected"] = "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_REJECTED";
    ActionType["Done"] = "CARD_CUSTOMIZATION_DONE";
    ActionType["Initialize"] = "CARD_CUSTOMIZATION_INITIALIZE";
    ActionType["UserChangeSignatureFont"] = "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_FONT";
    ActionType["UserChangeSignatureText"] = "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_TEXT";
    ActionType["UserToggleCustomizeSignature"] = "CARD_CUSTOMIZATION_USER_TOGGLE_CUSTOMIZE_SIGNATURE";
    ActionType["UserClickNextAction"] = "CARD_CUSTOMIZATION_USER_CLICK_NEXT";
    return ActionType;
}({});
const $d50f52fc18ffa921$export$2d705c8ebe551367 = (response)=>({
        type: "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_RECEIVED",
        response: response
    });
const $d50f52fc18ffa921$export$f96823155fd35b20 = (// eslint-disable-next-line
error)=>({
        type: "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_REJECTED",
        error: error
    });
const $d50f52fc18ffa921$export$8789045e6aca717c = ()=>({
        type: "CARD_CUSTOMIZATION_DONE"
    });
const $d50f52fc18ffa921$export$c81c36414a1e3192 = (cardInvitationToken, signatureText)=>({
        type: "CARD_CUSTOMIZATION_INITIALIZE",
        cardInvitationToken: cardInvitationToken,
        signatureText: signatureText
    });
const $d50f52fc18ffa921$export$817cb1cc86775b9b = (signatureFont)=>({
        type: "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_FONT",
        signatureFont: signatureFont
    });
const $d50f52fc18ffa921$export$22e3bdf54f208610 = (signatureInputText)=>({
        type: "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_TEXT",
        signatureInputText: signatureInputText
    });
const $d50f52fc18ffa921$export$69864c1ae20800a8 = ()=>({
        type: "CARD_CUSTOMIZATION_USER_CLICK_NEXT"
    });
const $d50f52fc18ffa921$export$74d52cff822ce1fe = (value)=>({
        type: "CARD_CUSTOMIZATION_USER_TOGGLE_CUSTOMIZE_SIGNATURE",
        value: value
    });
function $d50f52fc18ffa921$var$handleCreateCardCustomizationReceived(state, action) {
    const { cardCustomizationToken: cardCustomizationToken } = action.response;
    return [
        {
            ...state,
            cardCustomizationToken: cardCustomizationToken,
            loading: false
        },
        $d50f52fc18ffa921$export$8789045e6aca717c
    ];
}
function $d50f52fc18ffa921$var$handleInitialize(state, action) {
    const { cardInvitationToken: cardInvitationToken, signatureText: signatureText } = action;
    return [
        $d50f52fc18ffa921$export$e6a0daad8304de({
            cardInvitationToken: cardInvitationToken,
            signatureText: signatureText,
            signatureInputText: signatureText
        }),
        null
    ];
}
function $d50f52fc18ffa921$var$handleUserChangeSignatureText(state, action) {
    const { signatureInputText: signatureInputText } = action;
    const customSignatureInputError = [];
    if ((0, $488d76279e935265$export$537947b51dead775)(signatureInputText)) customSignatureInputError.push("CARD_CUSTOMIZATION_SIGNATURE_ERROR_CONTAINS_EMOJI");
    if (signatureInputText.length === 0) customSignatureInputError.push("CARD_CUSTOMIZATION_SIGNATURE_ERROR_EMPTY");
    if (signatureInputText.length > $d50f52fc18ffa921$export$6bcdc49eab1cd857) customSignatureInputError.push("CARD_CUSTOMIZATION_SIGNATURE_ERROR_EXCEEDED_MAX_LENGTH");
    const signatureText = (0, $488d76279e935265$export$9efee81811214072)(signatureInputText).trim().substring(0, $d50f52fc18ffa921$export$6bcdc49eab1cd857);
    return [
        {
            ...state,
            signatureText: signatureText,
            signatureInputText: signatureInputText,
            customSignatureInputError: customSignatureInputError
        },
        null
    ];
}
function $d50f52fc18ffa921$var$handleUserClickNext(context, state) {
    const { bankingWebCardService: bankingWebCardService } = context;
    const { cardInvitationToken: cardInvitationToken, customSignatureInputError: customSignatureInputError } = state;
    if (customSignatureInputError.length) return [
        state,
        null
    ];
    const work = ()=>{
        const response = $d50f52fc18ffa921$var$renderCardCustomization(context.textRenderer)(state).then((imageBytes)=>{
            const request = (0, $bc006730c79954a6$export$aed3bec368de6e1f).create({
                cardInvitationToken: cardInvitationToken,
                idempotencyKey: context.uuid(),
                imageBytes: imageBytes,
                mimeType: $d50f52fc18ffa921$var$MIME_TYPE
            });
            return bankingWebCardService.createCardCustomization(request).then($d50f52fc18ffa921$export$2d705c8ebe551367, $d50f52fc18ffa921$export$f96823155fd35b20);
        });
        return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(response);
    };
    return [
        {
            ...state,
            loading: true
        },
        work
    ];
}
function $d50f52fc18ffa921$var$handleUserToggleCustomizeSignature(state, action) {
    const { value: value } = action;
    // TODO(cvu): person name here
    return [
        {
            ...state,
            toggleCustomSignature: value
        },
        null
    ];
}
const $d50f52fc18ffa921$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_RECEIVED":
                return $d50f52fc18ffa921$var$handleCreateCardCustomizationReceived(state, action);
            case "CARD_CUSTOMIZATION_CREATE_CARD_CUSTOMIZATION_REJECTED":
                // TODO(cvu): to be implemented
                return [
                    state,
                    null
                ];
            case "CARD_CUSTOMIZATION_DONE":
                return [
                    {
                        ...state,
                        done: true
                    },
                    null
                ];
            case "CARD_CUSTOMIZATION_INITIALIZE":
                return $d50f52fc18ffa921$var$handleInitialize(state, action);
            case "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_FONT":
                return [
                    {
                        ...state,
                        signatureFont: action.signatureFont
                    },
                    null
                ];
            case "CARD_CUSTOMIZATION_USER_CHANGE_SIGNATURE_TEXT":
                return $d50f52fc18ffa921$var$handleUserChangeSignatureText(state, action);
            case "CARD_CUSTOMIZATION_USER_CLICK_NEXT":
                return $d50f52fc18ffa921$var$handleUserClickNext(context, state);
            case "CARD_CUSTOMIZATION_USER_TOGGLE_CUSTOMIZE_SIGNATURE":
                return $d50f52fc18ffa921$var$handleUserToggleCustomizeSignature(state, action);
        }
    };







/**
 * For multiple cards GA, we will be handling address validation in the client. This should ideally be
 * handled in the backend with some validate address endpoint. We are currently in a in-between state
 * with our high-level RPCs.
 *
 * We also want to be able to launch GA first and fix this later.
 *
 * TODO(cvu): Remove this file when we properly validate addresses
 */ const $074c0fa941456ba7$var$ZIP5_TO_STATE = {
    "06390": "NY",
    "83414": "WY",
    "96799": "AS",
    "96940": "PW",
    "96941": "FM",
    "96942": "FM",
    "96943": "FM",
    "96944": "FM",
    "96950": "MP",
    "96951": "MP",
    "96952": "MP",
    "96960": "MH",
    "96970": "MH"
};
const $074c0fa941456ba7$var$ZIP3_TO_STATE = {
    "005": "NY",
    "006": "PR",
    "007": "PR",
    "008": "VI",
    "009": "PR",
    "010": "MA",
    "011": "MA",
    "012": "MA",
    "013": "MA",
    "014": "MA",
    "015": "MA",
    "016": "MA",
    "017": "MA",
    "018": "MA",
    "019": "MA",
    "020": "MA",
    "021": "MA",
    "022": "MA",
    "023": "MA",
    "024": "MA",
    "025": "MA",
    "026": "MA",
    "027": "MA",
    "028": "RI",
    "029": "RI",
    "030": "NH",
    "031": "NH",
    "032": "NH",
    "033": "NH",
    "034": "NH",
    "035": "NH",
    "036": "NH",
    "037": "NH",
    "038": "NH",
    "039": "ME",
    "040": "ME",
    "041": "ME",
    "042": "ME",
    "043": "ME",
    "044": "ME",
    "045": "ME",
    "046": "ME",
    "047": "ME",
    "048": "ME",
    "049": "ME",
    "050": "VT",
    "051": "VT",
    "052": "VT",
    "053": "VT",
    "054": "VT",
    "055": "MA",
    "056": "VT",
    "057": "VT",
    "058": "VT",
    "059": "VT",
    "060": "CT",
    "061": "CT",
    "062": "CT",
    "063": "CT",
    "064": "CT",
    "065": "CT",
    "066": "CT",
    "067": "CT",
    "068": "CT",
    "069": "CT",
    "070": "NJ",
    "071": "NJ",
    "072": "NJ",
    "073": "NJ",
    "074": "NJ",
    "075": "NJ",
    "076": "NJ",
    "077": "NJ",
    "078": "NJ",
    "079": "NJ",
    "080": "NJ",
    "081": "NJ",
    "082": "NJ",
    "083": "NJ",
    "084": "NJ",
    "085": "NJ",
    "086": "NJ",
    "087": "NJ",
    "088": "NJ",
    "089": "NJ",
    "090": "AE",
    "091": "AE",
    "092": "AE",
    "093": "AE",
    "094": "AE",
    "095": "AE",
    "096": "AE",
    "097": "AE",
    "098": "AE",
    "100": "NY",
    "101": "NY",
    "102": "NY",
    "103": "NY",
    "104": "NY",
    "105": "NY",
    "106": "NY",
    "107": "NY",
    "108": "NY",
    "109": "NY",
    "110": "NY",
    "111": "NY",
    "112": "NY",
    "113": "NY",
    "114": "NY",
    "115": "NY",
    "116": "NY",
    "117": "NY",
    "118": "NY",
    "119": "NY",
    "120": "NY",
    "121": "NY",
    "122": "NY",
    "123": "NY",
    "124": "NY",
    "125": "NY",
    "126": "NY",
    "127": "NY",
    "128": "NY",
    "129": "NY",
    "130": "NY",
    "131": "NY",
    "132": "NY",
    "133": "NY",
    "134": "NY",
    "135": "NY",
    "136": "NY",
    "137": "NY",
    "138": "NY",
    "139": "NY",
    "140": "NY",
    "141": "NY",
    "142": "NY",
    "143": "NY",
    "144": "NY",
    "145": "NY",
    "146": "NY",
    "147": "NY",
    "148": "NY",
    "149": "NY",
    "150": "PA",
    "151": "PA",
    "152": "PA",
    "153": "PA",
    "154": "PA",
    "155": "PA",
    "156": "PA",
    "157": "PA",
    "158": "PA",
    "159": "PA",
    "160": "PA",
    "161": "PA",
    "162": "PA",
    "163": "PA",
    "164": "PA",
    "165": "PA",
    "166": "PA",
    "167": "PA",
    "168": "PA",
    "169": "PA",
    "170": "PA",
    "171": "PA",
    "172": "PA",
    "173": "PA",
    "174": "PA",
    "175": "PA",
    "176": "PA",
    "177": "PA",
    "178": "PA",
    "179": "PA",
    "180": "PA",
    "181": "PA",
    "182": "PA",
    "183": "PA",
    "184": "PA",
    "185": "PA",
    "186": "PA",
    "187": "PA",
    "188": "PA",
    "189": "PA",
    "190": "PA",
    "191": "PA",
    "192": "PA",
    "193": "PA",
    "194": "PA",
    "195": "PA",
    "196": "PA",
    "197": "DE",
    "198": "DE",
    "199": "DE",
    "200": "DC",
    "201": "VA",
    "202": "DC",
    "203": "DC",
    "204": "DC",
    "205": "DC",
    "206": "MD",
    "207": "MD",
    "208": "MD",
    "209": "MD",
    "210": "MD",
    "211": "MD",
    "212": "MD",
    "214": "MD",
    "215": "MD",
    "216": "MD",
    "217": "MD",
    "218": "MD",
    "219": "MD",
    "220": "VA",
    "221": "VA",
    "222": "VA",
    "223": "VA",
    "224": "VA",
    "225": "VA",
    "226": "VA",
    "227": "VA",
    "228": "VA",
    "229": "VA",
    "230": "VA",
    "231": "VA",
    "232": "VA",
    "233": "VA",
    "234": "VA",
    "235": "VA",
    "236": "VA",
    "237": "VA",
    "238": "VA",
    "239": "VA",
    "240": "VA",
    "241": "VA",
    "242": "VA",
    "243": "VA",
    "244": "VA",
    "245": "VA",
    "246": "VA",
    "247": "WV",
    "248": "WV",
    "249": "WV",
    "250": "WV",
    "251": "WV",
    "252": "WV",
    "253": "WV",
    "254": "WV",
    "255": "WV",
    "256": "WV",
    "257": "WV",
    "258": "WV",
    "259": "WV",
    "260": "WV",
    "261": "WV",
    "262": "WV",
    "263": "WV",
    "264": "WV",
    "265": "WV",
    "266": "WV",
    "267": "WV",
    "268": "WV",
    "270": "NC",
    "271": "NC",
    "272": "NC",
    "273": "NC",
    "274": "NC",
    "275": "NC",
    "276": "NC",
    "277": "NC",
    "278": "NC",
    "279": "NC",
    "280": "NC",
    "281": "NC",
    "282": "NC",
    "283": "NC",
    "284": "NC",
    "285": "NC",
    "286": "NC",
    "287": "NC",
    "288": "NC",
    "289": "NC",
    "290": "SC",
    "291": "SC",
    "292": "SC",
    "293": "SC",
    "294": "SC",
    "295": "SC",
    "296": "SC",
    "297": "SC",
    "298": "SC",
    "299": "SC",
    "300": "GA",
    "301": "GA",
    "302": "GA",
    "303": "GA",
    "304": "GA",
    "305": "GA",
    "306": "GA",
    "307": "GA",
    "308": "GA",
    "309": "GA",
    "310": "GA",
    "311": "GA",
    "312": "GA",
    "313": "GA",
    "314": "GA",
    "315": "GA",
    "316": "GA",
    "317": "GA",
    "318": "GA",
    "319": "GA",
    "320": "FL",
    "321": "FL",
    "322": "FL",
    "323": "FL",
    "324": "FL",
    "325": "FL",
    "326": "FL",
    "327": "FL",
    "328": "FL",
    "329": "FL",
    "330": "FL",
    "331": "FL",
    "332": "FL",
    "333": "FL",
    "334": "FL",
    "335": "FL",
    "336": "FL",
    "337": "FL",
    "338": "FL",
    "339": "FL",
    "340": "AA",
    "341": "FL",
    "342": "FL",
    "344": "FL",
    "346": "FL",
    "347": "FL",
    "349": "FL",
    "350": "AL",
    "351": "AL",
    "352": "AL",
    "354": "AL",
    "355": "AL",
    "356": "AL",
    "357": "AL",
    "358": "AL",
    "359": "AL",
    "360": "AL",
    "361": "AL",
    "362": "AL",
    "363": "AL",
    "364": "AL",
    "365": "AL",
    "366": "AL",
    "367": "AL",
    "368": "AL",
    "369": "AL",
    "370": "TN",
    "371": "TN",
    "372": "TN",
    "373": "TN",
    "374": "TN",
    "375": "TN",
    "376": "TN",
    "377": "TN",
    "378": "TN",
    "379": "TN",
    "380": "TN",
    "381": "TN",
    "382": "TN",
    "383": "TN",
    "384": "TN",
    "385": "TN",
    "386": "MS",
    "387": "MS",
    "388": "MS",
    "389": "MS",
    "390": "MS",
    "391": "MS",
    "392": "MS",
    "393": "MS",
    "394": "MS",
    "395": "MS",
    "396": "MS",
    "397": "MS",
    "398": "GA",
    "399": "GA",
    "400": "KY",
    "401": "KY",
    "402": "KY",
    "403": "KY",
    "404": "KY",
    "405": "KY",
    "406": "KY",
    "407": "KY",
    "408": "KY",
    "409": "KY",
    "410": "KY",
    "411": "KY",
    "412": "KY",
    "413": "KY",
    "414": "KY",
    "415": "KY",
    "416": "KY",
    "417": "KY",
    "418": "KY",
    "420": "KY",
    "421": "KY",
    "422": "KY",
    "423": "KY",
    "424": "KY",
    "425": "KY",
    "426": "KY",
    "427": "KY",
    "430": "OH",
    "431": "OH",
    "432": "OH",
    "433": "OH",
    "434": "OH",
    "435": "OH",
    "436": "OH",
    "437": "OH",
    "438": "OH",
    "439": "OH",
    "440": "OH",
    "441": "OH",
    "442": "OH",
    "443": "OH",
    "444": "OH",
    "445": "OH",
    "446": "OH",
    "447": "OH",
    "448": "OH",
    "449": "OH",
    "450": "OH",
    "451": "OH",
    "452": "OH",
    "453": "OH",
    "454": "OH",
    "455": "OH",
    "456": "OH",
    "457": "OH",
    "458": "OH",
    "459": "OH",
    "460": "IN",
    "461": "IN",
    "462": "IN",
    "463": "IN",
    "464": "IN",
    "465": "IN",
    "466": "IN",
    "467": "IN",
    "468": "IN",
    "469": "IN",
    "470": "IN",
    "471": "IN",
    "472": "IN",
    "473": "IN",
    "474": "IN",
    "475": "IN",
    "476": "IN",
    "477": "IN",
    "478": "IN",
    "479": "IN",
    "480": "MI",
    "481": "MI",
    "482": "MI",
    "483": "MI",
    "484": "MI",
    "485": "MI",
    "486": "MI",
    "487": "MI",
    "488": "MI",
    "489": "MI",
    "490": "MI",
    "491": "MI",
    "492": "MI",
    "493": "MI",
    "494": "MI",
    "495": "MI",
    "496": "MI",
    "497": "MI",
    "498": "MI",
    "499": "MI",
    "500": "IA",
    "501": "IA",
    "502": "IA",
    "503": "IA",
    "504": "IA",
    "505": "IA",
    "506": "IA",
    "507": "IA",
    "508": "IA",
    "509": "IA",
    "510": "IA",
    "511": "IA",
    "512": "IA",
    "513": "IA",
    "514": "IA",
    "515": "IA",
    "516": "IA",
    "520": "IA",
    "521": "IA",
    "522": "IA",
    "523": "IA",
    "524": "IA",
    "525": "IA",
    "526": "IA",
    "527": "IA",
    "528": "IA",
    "530": "WI",
    "531": "WI",
    "532": "WI",
    "534": "WI",
    "535": "WI",
    "537": "WI",
    "538": "WI",
    "539": "WI",
    "540": "WI",
    "541": "WI",
    "542": "WI",
    "543": "WI",
    "544": "WI",
    "545": "WI",
    "546": "WI",
    "547": "WI",
    "548": "WI",
    "549": "WI",
    "550": "MN",
    "551": "MN",
    "553": "MN",
    "554": "MN",
    "555": "MN",
    "556": "MN",
    "557": "MN",
    "558": "MN",
    "559": "MN",
    "560": "MN",
    "561": "MN",
    "562": "MN",
    "563": "MN",
    "564": "MN",
    "565": "MN",
    "566": "MN",
    "567": "MN",
    "569": "DC",
    "570": "SD",
    "571": "SD",
    "572": "SD",
    "573": "SD",
    "574": "SD",
    "575": "SD",
    "576": "SD",
    "577": "SD",
    "580": "ND",
    "581": "ND",
    "582": "ND",
    "583": "ND",
    "584": "ND",
    "585": "ND",
    "586": "ND",
    "587": "ND",
    "588": "ND",
    "590": "MT",
    "591": "MT",
    "592": "MT",
    "593": "MT",
    "594": "MT",
    "595": "MT",
    "596": "MT",
    "597": "MT",
    "598": "MT",
    "599": "MT",
    "600": "IL",
    "601": "IL",
    "602": "IL",
    "603": "IL",
    "604": "IL",
    "605": "IL",
    "606": "IL",
    "607": "IL",
    "608": "IL",
    "609": "IL",
    "610": "IL",
    "611": "IL",
    "612": "IL",
    "613": "IL",
    "614": "IL",
    "615": "IL",
    "616": "IL",
    "617": "IL",
    "618": "IL",
    "619": "IL",
    "620": "IL",
    "622": "IL",
    "623": "IL",
    "624": "IL",
    "625": "IL",
    "626": "IL",
    "627": "IL",
    "628": "IL",
    "629": "IL",
    "630": "MO",
    "631": "MO",
    "633": "MO",
    "634": "MO",
    "635": "MO",
    "636": "MO",
    "637": "MO",
    "638": "MO",
    "639": "MO",
    "640": "MO",
    "641": "MO",
    "644": "MO",
    "645": "MO",
    "646": "MO",
    "647": "MO",
    "648": "MO",
    "649": "MO",
    "650": "MO",
    "651": "MO",
    "652": "MO",
    "653": "MO",
    "654": "MO",
    "655": "MO",
    "656": "MO",
    "657": "MO",
    "658": "MO",
    "660": "KS",
    "661": "KS",
    "662": "KS",
    "664": "KS",
    "665": "KS",
    "666": "KS",
    "667": "KS",
    "668": "KS",
    "669": "KS",
    "670": "KS",
    "671": "KS",
    "672": "KS",
    "673": "KS",
    "674": "KS",
    "675": "KS",
    "676": "KS",
    "677": "KS",
    "678": "KS",
    "679": "KS",
    "680": "NE",
    "681": "NE",
    "683": "NE",
    "684": "NE",
    "685": "NE",
    "686": "NE",
    "687": "NE",
    "688": "NE",
    "689": "NE",
    "690": "NE",
    "691": "NE",
    "692": "NE",
    "693": "NE",
    "700": "LA",
    "701": "LA",
    "703": "LA",
    "704": "LA",
    "705": "LA",
    "706": "LA",
    "707": "LA",
    "708": "LA",
    "710": "LA",
    "711": "LA",
    "712": "LA",
    "713": "LA",
    "714": "LA",
    "716": "AR",
    "717": "AR",
    "718": "AR",
    "719": "AR",
    "720": "AR",
    "721": "AR",
    "722": "AR",
    "723": "AR",
    "724": "AR",
    "725": "AR",
    "726": "AR",
    "727": "AR",
    "728": "AR",
    "729": "AR",
    "730": "OK",
    "731": "OK",
    "733": "TX",
    "734": "OK",
    "735": "OK",
    "736": "OK",
    "737": "OK",
    "738": "OK",
    "739": "OK",
    "740": "OK",
    "741": "OK",
    "743": "OK",
    "744": "OK",
    "745": "OK",
    "746": "OK",
    "747": "OK",
    "748": "OK",
    "749": "OK",
    "750": "TX",
    "751": "TX",
    "752": "TX",
    "753": "TX",
    "754": "TX",
    "755": "TX",
    "756": "TX",
    "757": "TX",
    "758": "TX",
    "759": "TX",
    "760": "TX",
    "761": "TX",
    "762": "TX",
    "763": "TX",
    "764": "TX",
    "765": "TX",
    "766": "TX",
    "767": "TX",
    "768": "TX",
    "769": "TX",
    "770": "TX",
    "772": "TX",
    "773": "TX",
    "774": "TX",
    "775": "TX",
    "776": "TX",
    "777": "TX",
    "778": "TX",
    "779": "TX",
    "780": "TX",
    "781": "TX",
    "782": "TX",
    "783": "TX",
    "784": "TX",
    "785": "TX",
    "786": "TX",
    "787": "TX",
    "788": "TX",
    "789": "TX",
    "790": "TX",
    "791": "TX",
    "792": "TX",
    "793": "TX",
    "794": "TX",
    "795": "TX",
    "796": "TX",
    "797": "TX",
    "798": "TX",
    "799": "TX",
    "800": "CO",
    "801": "CO",
    "802": "CO",
    "803": "CO",
    "804": "CO",
    "805": "CO",
    "806": "CO",
    "807": "CO",
    "808": "CO",
    "809": "CO",
    "810": "CO",
    "811": "CO",
    "812": "CO",
    "813": "CO",
    "814": "CO",
    "815": "CO",
    "816": "CO",
    "820": "WY",
    "821": "WY",
    "822": "WY",
    "823": "WY",
    "824": "WY",
    "825": "WY",
    "826": "WY",
    "827": "WY",
    "828": "WY",
    "829": "WY",
    "830": "WY",
    "831": "WY",
    "832": "ID",
    "833": "ID",
    "834": "ID",
    "835": "ID",
    "836": "ID",
    "837": "ID",
    "838": "ID",
    "840": "UT",
    "841": "UT",
    "842": "UT",
    "843": "UT",
    "844": "UT",
    "845": "UT",
    "846": "UT",
    "847": "UT",
    "850": "AZ",
    "851": "AZ",
    "852": "AZ",
    "853": "AZ",
    "855": "AZ",
    "856": "AZ",
    "857": "AZ",
    "859": "AZ",
    "860": "AZ",
    "863": "AZ",
    "864": "AZ",
    "865": "AZ",
    "870": "NM",
    "871": "NM",
    "872": "NM",
    "873": "NM",
    "874": "NM",
    "875": "NM",
    "877": "NM",
    "878": "NM",
    "879": "NM",
    "880": "NM",
    "881": "NM",
    "882": "NM",
    "883": "NM",
    "884": "NM",
    "885": "TX",
    "889": "NV",
    "890": "NV",
    "891": "NV",
    "893": "NV",
    "894": "NV",
    "895": "NV",
    "897": "NV",
    "898": "NV",
    "900": "CA",
    "901": "CA",
    "902": "CA",
    "903": "CA",
    "904": "CA",
    "905": "CA",
    "906": "CA",
    "907": "CA",
    "908": "CA",
    "910": "CA",
    "911": "CA",
    "912": "CA",
    "913": "CA",
    "914": "CA",
    "915": "CA",
    "916": "CA",
    "917": "CA",
    "918": "CA",
    "919": "CA",
    "920": "CA",
    "921": "CA",
    "922": "CA",
    "923": "CA",
    "924": "CA",
    "925": "CA",
    "926": "CA",
    "927": "CA",
    "928": "CA",
    "930": "CA",
    "931": "CA",
    "932": "CA",
    "933": "CA",
    "934": "CA",
    "935": "CA",
    "936": "CA",
    "937": "CA",
    "938": "CA",
    "939": "CA",
    "940": "CA",
    "941": "CA",
    "942": "CA",
    "943": "CA",
    "944": "CA",
    "945": "CA",
    "946": "CA",
    "947": "CA",
    "948": "CA",
    "949": "CA",
    "950": "CA",
    "951": "CA",
    "952": "CA",
    "953": "CA",
    "954": "CA",
    "955": "CA",
    "956": "CA",
    "957": "CA",
    "958": "CA",
    "959": "CA",
    "960": "CA",
    "961": "CA",
    "962": "AP",
    "963": "AP",
    "964": "AP",
    "965": "AP",
    "966": "AP",
    "967": "HI",
    "968": "HI",
    "969": "GU",
    "970": "OR",
    "971": "OR",
    "972": "OR",
    "973": "OR",
    "974": "OR",
    "975": "OR",
    "976": "OR",
    "977": "OR",
    "978": "OR",
    "979": "OR",
    "980": "WA",
    "981": "WA",
    "982": "WA",
    "983": "WA",
    "984": "WA",
    "985": "WA",
    "986": "WA",
    "988": "WA",
    "989": "WA",
    "990": "WA",
    "991": "WA",
    "992": "WA",
    "993": "WA",
    "994": "WA",
    "995": "AK",
    "996": "AK",
    "997": "AK",
    "998": "AK",
    "999": "AK"
};
const $074c0fa941456ba7$export$c58b7bec74e6ca50 = (zip)=>{
    const cleanedZip = zip.trim();
    // 5 digit zip / 9 digit zip with hyphen / 9 digit zip without hyphen
    const regex = new RegExp("(^\\d{5}(-\\d{4})?$)|(^\\d{9}$)");
    return regex.test(cleanedZip) && (Boolean($074c0fa941456ba7$var$ZIP5_TO_STATE[cleanedZip.substring(0, 5)]) || Boolean($074c0fa941456ba7$var$ZIP3_TO_STATE[cleanedZip.substring(0, 3)]));
};


var $a9356ac90e965f5c$export$804a92ba667853be = /*#__PURE__*/ function(AddressError) {
    AddressError["Empty"] = "ADDRESS_ERROR_EMPTY";
    return AddressError;
}({});
var $a9356ac90e965f5c$export$74e717fd56f132db = /*#__PURE__*/ function(PostalCodeError) {
    PostalCodeError["Invalid"] = "POSTAL_CODE_ERROR_INVALID";
    return PostalCodeError;
}({});
var $a9356ac90e965f5c$export$4b2f75d0e5275120 = /*#__PURE__*/ function(AddressField) {
    AddressField["AddressLine1"] = "addressLine1";
    AddressField["AddressLine2"] = "addressLine2";
    AddressField["AdministrativeDistrictLevel1"] = "administrativeDistrictLevel1";
    AddressField["Locality"] = "locality";
    AddressField["PostalCode"] = "postalCode";
    AddressField["CountryCode"] = "countryCode";
    return AddressField;
}({});
const $a9356ac90e965f5c$export$e82aa99a68ee705d = [
    (0, $a8741251394c554f$export$5552a8f08b2b9f9e).US
];
const $a9356ac90e965f5c$export$c8bac1d5c31c83a1 = (address)=>{
    const addressLine1 = address["addressLine1"];
    const administrativeDistrictLevelOne = address["administrativeDistrictLevel1"];
    const locality = address["locality"];
    const postalCode = address["postalCode"];
    const countryCode = address["countryCode"];
    if (!$a9356ac90e965f5c$export$e82aa99a68ee705d.includes(countryCode)) throw new Error(`Country is not supported: [country=${countryCode}]`);
    const addressLine1Errors = [];
    const administrativeDistrictLevelOneErrors = [];
    const localityErrors = [];
    const postalCodeErrors = $a9356ac90e965f5c$export$815da5de8966867b(postalCode, countryCode);
    if (addressLine1 === "") addressLine1Errors.push("ADDRESS_ERROR_EMPTY");
    if (administrativeDistrictLevelOne === "") administrativeDistrictLevelOneErrors.push("ADDRESS_ERROR_EMPTY");
    if (locality === "") localityErrors.push("ADDRESS_ERROR_EMPTY");
    const valid = addressLine1Errors.length === 0 && administrativeDistrictLevelOneErrors.length === 0 && localityErrors.length === 0 && postalCodeErrors.length === 0;
    return {
        errors: {
            ["addressLine1"]: addressLine1Errors,
            ["administrativeDistrictLevel1"]: administrativeDistrictLevelOneErrors,
            ["locality"]: localityErrors,
            ["postalCode"]: $a9356ac90e965f5c$export$815da5de8966867b(postalCode, countryCode)
        },
        valid: valid
    };
};
const $a9356ac90e965f5c$export$815da5de8966867b = (postalCode, countryCode)=>{
    const postalCodeErrors = [];
    if (postalCode === "") postalCodeErrors.push("ADDRESS_ERROR_EMPTY");
    // TODO(cvu): support Canada maybe. this code will probably be obsolete when we support Canada
    switch(countryCode){
        case (0, $a8741251394c554f$export$5552a8f08b2b9f9e).US:
            if (!(0, $074c0fa941456ba7$export$c58b7bec74e6ca50)(postalCode)) postalCodeErrors.push("POSTAL_CODE_ERROR_INVALID");
            break;
        default:
            throw new Error(`Country is not supported: [country=${countryCode}]`);
    }
    return postalCodeErrors;
};


var $a4c47930ee9facdd$export$a98515d67472a41f = /*#__PURE__*/ function(Screen) {
    Screen[Screen["EnterAddress"] = 0] = "EnterAddress";
    Screen[Screen["ConfirmAddress"] = 1] = "ConfirmAddress";
    return Screen;
}({});
var $a4c47930ee9facdd$export$625913c7ca4f03a9 = /*#__PURE__*/ function(ChosenAddress) {
    ChosenAddress[ChosenAddress["SystemNormalized"] = 0] = "SystemNormalized";
    ChosenAddress[ChosenAddress["UserInput"] = 1] = "UserInput";
    return ChosenAddress;
}({});
var $a4c47930ee9facdd$export$804a92ba667853be = /*#__PURE__*/ function(AddressError) {
    AddressError["Empty"] = "ADDRESS_ERROR_EMPTY";
    return AddressError;
}({});
var $a4c47930ee9facdd$export$4b2f75d0e5275120 = /*#__PURE__*/ function(AddressField) {
    AddressField["AddressLine1"] = "addressLine1";
    AddressField["AddressLine2"] = "addressLine2";
    AddressField["AdministrativeDistrictLevel1"] = "administrativeDistrictLevel1";
    AddressField["Locality"] = "locality";
    AddressField["PostalCode"] = "postalCode";
    return AddressField;
}({});
const $a4c47930ee9facdd$export$36d128238e6b60f5 = {
    address: (0, $04e03da92c8def10$export$1d6b20d87bad724b).create({
        // TODO(cvu): Support other countries in the future
        // https://jira.sqprod.co/browse/SQCARD-2656
        countryCode: (0, $a8741251394c554f$export$5552a8f08b2b9f9e).US
    }),
    loading: false,
    // TODO(cvu): use when normalizing address is supported and set to SystemNormalized
    chosenAddress: 1,
    countryAddressData: null,
    normalizedAddress: null,
    screen: 0,
    validation: {
        errors: {
            ["addressLine1"]: [],
            ["administrativeDistrictLevel1"]: [],
            ["locality"]: [],
            ["postalCode"]: []
        },
        valid: true
    }
};
const $a4c47930ee9facdd$export$e6a0daad8304de = (overrides = {})=>({
        ...$a4c47930ee9facdd$export$36d128238e6b60f5,
        ...overrides
    });
const $a4c47930ee9facdd$export$7b943f50522d3fc4 = (countryAddressData)=>countryAddressData.admin1Values.map((admin1Value)=>admin1Value.value);
var $a4c47930ee9facdd$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["Done"] = "CARD_SHIPPING_DONE";
    ActionType["Error"] = "CARD_SHIPPING_ERROR";
    ActionType["Initialize"] = "CARD_SHIPPING_INITIALIZE";
    ActionType["GetCountryAddressDataReceived"] = "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_RECEIVED";
    ActionType["GetCountryAddressDataRejected"] = "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_REJECTED";
    ActionType["NavigateToScreen"] = "CARD_SHIPPING_NAVIGATE_TO_SCREEN";
    ActionType["UserChangeAddress"] = "CARD_SHIPPING_USER_CHANGE_ADDRESS";
    ActionType["UserChangeChosenAddress"] = "CARD_SHIPPING_USER_CHANGE_CHOSEN_ADDRESS";
    ActionType["UserClickNextButton"] = "CARD_SHIPPING_USER_CLICK_NEXT_BUTTON";
    ActionType["ValidateAddressReceived"] = "CARD_SHIPPING_VALIDATE_ADDRESS_RECEIVED";
    ActionType["ValidateAddressRejected"] = "CARD_SHIPPING_VALIDATE_ADDRESS_REJECTED";
    return ActionType;
}({});
const $a4c47930ee9facdd$export$8789045e6aca717c = ()=>({
        type: "CARD_SHIPPING_DONE"
    });
const $a4c47930ee9facdd$export$2be98aef2d1db8da = ()=>({
        type: "CARD_SHIPPING_ERROR"
    });
const $a4c47930ee9facdd$export$c81c36414a1e3192 = ()=>({
        type: "CARD_SHIPPING_INITIALIZE"
    });
const $a4c47930ee9facdd$export$4551d583fda7b1a7 = (response)=>({
        type: "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_RECEIVED",
        response: response
    });
const $a4c47930ee9facdd$export$d5e8efdb3deefa9c = ()=>({
        type: "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_REJECTED"
    });
const $a4c47930ee9facdd$export$a7b94443be12fd7b = (screen)=>({
        type: "CARD_SHIPPING_NAVIGATE_TO_SCREEN",
        screen: screen
    });
const $a4c47930ee9facdd$export$24e513df93afa94e = (chosenAddress)=>({
        type: "CARD_SHIPPING_USER_CHANGE_CHOSEN_ADDRESS",
        chosenAddress: chosenAddress
    });
const $a4c47930ee9facdd$export$426fffe680412262 = (field, value)=>({
        type: "CARD_SHIPPING_USER_CHANGE_ADDRESS",
        field: field,
        value: value
    });
const $a4c47930ee9facdd$export$848ce7d6602fe3bd = ()=>({
        type: "CARD_SHIPPING_USER_CLICK_NEXT_BUTTON"
    });
function $a4c47930ee9facdd$var$handleInitialize(context, state) {
    const { countryAddressData: countryAddressData } = state;
    if (countryAddressData == null) {
        const work = ()=>{
            const response = context.webService.getCountryAddressData((0, $fce501362cc81cfc$export$be0c7e46b391ca72).create({
                // TODO(cvu): Support other countries in the future
                // https://jira.sqprod.co/browse/SQCARD-2656
                countryCode: (0, $a8741251394c554f$export$5552a8f08b2b9f9e).US
            })).then($a4c47930ee9facdd$export$4551d583fda7b1a7, $a4c47930ee9facdd$export$d5e8efdb3deefa9c);
            return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(response);
        };
        return [
            state,
            work
        ];
    }
    return [
        state,
        null
    ];
}
function $a4c47930ee9facdd$var$handleGetCountryAddressDataReceived(state, action) {
    const countryAddressData = action.response.countryAddressData || null;
    return [
        {
            ...state,
            countryAddressData: countryAddressData
        },
        null
    ];
}
function $a4c47930ee9facdd$var$handleUserChangeAddress(state, action) {
    const { address: address } = state;
    const addressRecord = address.toJSON();
    switch(action.field){
        case "addressLine1":
            addressRecord.addressLine1 = action.value;
            break;
        case "addressLine2":
            addressRecord.addressLine2 = action.value;
            break;
        case "postalCode":
            addressRecord.postalCode = action.value;
            break;
        case "administrativeDistrictLevel1":
            addressRecord.administrativeDistrictLevel1 = action.value;
            break;
        case "locality":
            addressRecord.locality = action.value;
            break;
    }
    return [
        {
            ...state,
            address: (0, $04e03da92c8def10$export$1d6b20d87bad724b).fromObject(addressRecord)
        },
        null
    ];
}
function $a4c47930ee9facdd$var$handleUserClickNextButton(context, state) {
    const { address: address, screen: screen } = state;
    if (screen === 0) {
        const validation = (0, $a9356ac90e965f5c$export$c8bac1d5c31c83a1)(address);
        const work = ()=>{
            if (!validation.valid) return null;
            return $a4c47930ee9facdd$export$8789045e6aca717c();
        };
        return [
            {
                ...state,
                loading: validation.valid,
                validation: validation
            },
            work
        ];
    }
    return [
        state,
        $a4c47930ee9facdd$export$8789045e6aca717c
    ];
}
const $a4c47930ee9facdd$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "CARD_SHIPPING_DONE":
            case "CARD_SHIPPING_ERROR":
                return [
                    state,
                    null
                ];
            case "CARD_SHIPPING_INITIALIZE":
                return $a4c47930ee9facdd$var$handleInitialize(context, state);
            case "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_RECEIVED":
                return $a4c47930ee9facdd$var$handleGetCountryAddressDataReceived(state, action);
            case "CARD_SHIPPING_GET_COUNTRY_ADDRESS_DATA_REJECTED":
                return [
                    state,
                    null
                ];
            case "CARD_SHIPPING_NAVIGATE_TO_SCREEN":
                {
                    const { screen: screen } = action;
                    return [
                        {
                            ...state,
                            screen: screen
                        },
                        null
                    ];
                }
            case "CARD_SHIPPING_USER_CHANGE_ADDRESS":
                return $a4c47930ee9facdd$var$handleUserChangeAddress(state, action);
            case "CARD_SHIPPING_USER_CHANGE_CHOSEN_ADDRESS":
                return [
                    {
                        ...state,
                        chosenAddress: action.chosenAddress
                    },
                    null
                ];
            case "CARD_SHIPPING_USER_CLICK_NEXT_BUTTON":
                return $a4c47930ee9facdd$var$handleUserClickNextButton(context, state);
        }
    };



var $c27a3102df5220b7$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOT_DONE"] = 0] = "NOT_DONE";
    DoneState[DoneState["DONE"] = 1] = "DONE";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});
var $c27a3102df5220b7$export$a455218a85c89869 = /*#__PURE__*/ function(Field) {
    Field["FirstName"] = "firstName";
    Field["LastName"] = "lastName";
    return Field;
}({});
var $c27a3102df5220b7$export$e4493d7100331504 = /*#__PURE__*/ function(VerifyNameError) {
    VerifyNameError[VerifyNameError["VERIFY_NAME_ERROR_EMPTY"] = 0] = "VERIFY_NAME_ERROR_EMPTY";
    return VerifyNameError;
}({});
const $c27a3102df5220b7$export$36d128238e6b60f5 = {
    done: 0,
    ["firstName"]: "",
    ["lastName"]: "",
    loading: false,
    validation: {
        errors: {
            firstName: [],
            lastName: []
        },
        valid: true
    }
};
const $c27a3102df5220b7$export$e6a0daad8304de = (overrides = {})=>({
        ...$c27a3102df5220b7$export$36d128238e6b60f5,
        ...overrides
    });
const $c27a3102df5220b7$export$cd31394628980743 = (field, state)=>{
    const { validation: validation } = state;
    return {
        ...validation,
        errors: {
            ...validation.errors,
            [field]: []
        }
    };
};
const $c27a3102df5220b7$export$c8bac1d5c31c83a1 = (state)=>{
    const firstName = state["firstName"];
    const lastName = state["lastName"];
    const firstNameErrors = [];
    const lastNameErrors = [];
    if (firstName === "") firstNameErrors.push(0);
    if (lastName === "") lastNameErrors.push(0);
    const valid = firstNameErrors.length === 0 && lastNameErrors.length === 0;
    return {
        errors: {
            ["firstName"]: firstNameErrors,
            ["lastName"]: lastNameErrors
        },
        valid: valid
    };
};
var $c27a3102df5220b7$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["Done"] = "VERIFY_NAME_DONE";
    ActionType["Initialize"] = "VERIFY_NAME_INITIALIZE";
    ActionType["UpdatePersonProfileReceived"] = "VERIFY_NAME_UPDATE_PERSON_PROFILE_RECEIVED";
    ActionType["UpdatePersonProfileRejected"] = "VERIFY_NAME_UPDATE_PERSON_PROFILE_REJECTED";
    ActionType["UserChangeInputFieldValue"] = "VERIFY_NAME_USER_CHANGE_INPUT_FIELD_VALUE";
    ActionType["UserClickNext"] = "VERIFY_NAME_USER_CLICK_NEXT";
    return ActionType;
}({});
const $c27a3102df5220b7$export$8789045e6aca717c = (doneState)=>({
        type: "VERIFY_NAME_DONE",
        doneState: doneState
    });
const $c27a3102df5220b7$export$c81c36414a1e3192 = (user)=>({
        type: "VERIFY_NAME_INITIALIZE",
        user: user
    });
const $c27a3102df5220b7$export$db85caff4653ef45 = (response)=>({
        type: "VERIFY_NAME_UPDATE_PERSON_PROFILE_RECEIVED",
        response: response
    });
const $c27a3102df5220b7$export$c68fed2e072f5d53 = (error)=>({
        type: "VERIFY_NAME_UPDATE_PERSON_PROFILE_REJECTED",
        error: error
    });
const $c27a3102df5220b7$export$49d8151683dabb69 = (field, value)=>({
        type: "VERIFY_NAME_USER_CHANGE_INPUT_FIELD_VALUE",
        field: field,
        value: value
    });
const $c27a3102df5220b7$export$69864c1ae20800a8 = ()=>({
        type: "VERIFY_NAME_USER_CLICK_NEXT"
    });
function $c27a3102df5220b7$var$handleDone(state, { doneState: doneState }) {
    return [
        {
            ...state,
            done: doneState
        },
        null
    ];
}
function $c27a3102df5220b7$var$handleInitialize(context, { user: user }) {
    const { first: first = "", last: last = "" } = user.name;
    return [
        {
            ...$c27a3102df5220b7$export$36d128238e6b60f5,
            ["firstName"]: first,
            ["lastName"]: last
        },
        null
    ];
}
function $c27a3102df5220b7$var$handleUpdatePersonProfileReceived(context, state, { response: response }) {
    const profile = response.profile;
    if (profile == null) {
        context.sentry.captureException("Card issuing - Person profile missing from update response");
        return [
            {
                ...state,
                loading: false
            },
            ()=>$c27a3102df5220b7$export$8789045e6aca717c(2)
        ];
    }
    if (profile.name == null) {
        context.sentry.captureException("Card issuing - Person profile missing name");
        return [
            {
                ...state,
                loading: false
            },
            ()=>$c27a3102df5220b7$export$8789045e6aca717c(2)
        ];
    }
    const { firstName: firstName, lastName: lastName } = profile.name;
    return [
        {
            ...state,
            ["firstName"]: firstName,
            ["lastName"]: lastName,
            loading: false
        },
        ()=>$c27a3102df5220b7$export$8789045e6aca717c(1)
    ];
}
function $c27a3102df5220b7$var$handleUpdatePersonProfileRejected(context, state, { error: error }) {
    context.sentry.captureException(error);
    return [
        {
            ...state,
            loading: false
        },
        ()=>$c27a3102df5220b7$export$8789045e6aca717c(2)
    ];
}
function $c27a3102df5220b7$var$handleUserChangeInputFieldValue(state, action) {
    const { field: field, value: value } = action;
    const nextState = {
        ...state,
        [field]: value
    };
    // revalidate to remove any error highlighting
    const validation = $c27a3102df5220b7$export$cd31394628980743(field, state);
    return [
        {
            ...nextState,
            validation: validation
        },
        null
    ];
}
function $c27a3102df5220b7$var$handleUserClickNext(context, state) {
    const validation = $c27a3102df5220b7$export$c8bac1d5c31c83a1(state);
    const work = ()=>{
        if (!validation.valid) return null;
        const { firstName: firstName, lastName: lastName } = state;
        return context.personProfileService.updatePersonProfile((0, $3f95b099726a1553$export$2d30a2bab0b6db0).create({
            idempotenceKey: context.uuid(),
            profile: (0, $3f95b099726a1553$export$5120f2d0b8d4cab8).create({
                name: (0, $3f95b099726a1553$export$5120f2d0b8d4cab8).Name.create({
                    firstName: firstName,
                    lastName: lastName
                })
            })
        })).then($c27a3102df5220b7$export$db85caff4653ef45, $c27a3102df5220b7$export$c68fed2e072f5d53);
    };
    // Do not trigger loading state if validation failure.
    return [
        {
            ...state,
            loading: validation.valid,
            validation: validation
        },
        work
    ];
}
const $c27a3102df5220b7$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "VERIFY_NAME_DONE":
                return $c27a3102df5220b7$var$handleDone(state, action);
            case "VERIFY_NAME_INITIALIZE":
                return $c27a3102df5220b7$var$handleInitialize(context, action);
            case "VERIFY_NAME_UPDATE_PERSON_PROFILE_RECEIVED":
                return $c27a3102df5220b7$var$handleUpdatePersonProfileReceived(context, state, action);
            case "VERIFY_NAME_UPDATE_PERSON_PROFILE_REJECTED":
                return $c27a3102df5220b7$var$handleUpdatePersonProfileRejected(context, state, action);
            case "VERIFY_NAME_USER_CHANGE_INPUT_FIELD_VALUE":
                return $c27a3102df5220b7$var$handleUserChangeInputFieldValue(state, action);
            case "VERIFY_NAME_USER_CLICK_NEXT":
                return $c27a3102df5220b7$var$handleUserClickNext(context, state);
        }
    };


var $b2490fa107d6478d$export$a98515d67472a41f = /*#__PURE__*/ function(Screen) {
    Screen[Screen["None"] = 0] = "None";
    Screen[Screen["VerifyName"] = 1] = "VerifyName";
    Screen[Screen["Customization"] = 2] = "Customization";
    Screen[Screen["ShippingAddress"] = 3] = "ShippingAddress";
    Screen[Screen["SetPin"] = 4] = "SetPin";
    Screen[Screen["ConfirmPin"] = 5] = "ConfirmPin";
    Screen[Screen["OrderConfirmation"] = 6] = "OrderConfirmation";
    Screen[Screen["AddToDigitalWallet"] = 7] = "AddToDigitalWallet";
    Screen[Screen["Error"] = 8] = "Error";
    return Screen;
}({});
const $b2490fa107d6478d$export$49d8745ae22a51ab = [
    2,
    3,
    6
];
const $b2490fa107d6478d$export$3ef250ace880f95b = [
    8
];
const $b2490fa107d6478d$var$PIN_LENGTH = 4;
var $b2490fa107d6478d$export$99337e8421d6e839 = /*#__PURE__*/ function(CardIssuingError) {
    CardIssuingError[CardIssuingError["None"] = 0] = "None";
    CardIssuingError[CardIssuingError["Generic"] = 1] = "Generic";
    CardIssuingError[CardIssuingError["Ineligible"] = 2] = "Ineligible";
    return CardIssuingError;
}({});
const $b2490fa107d6478d$var$INITIAL_STATE = {
    balanceId: "",
    businessName: "",
    cardCustomizationState: $d50f52fc18ffa921$export$e6a0daad8304de(),
    cardInvitationToken: "",
    cardShippingState: $a4c47930ee9facdd$export$e6a0daad8304de(),
    cardToken: "",
    confirmPin: "",
    done: false,
    error: 0,
    loading: false,
    modalOpen: false,
    navigation: {
        current: 0,
        flow: []
    },
    pin: "",
    verifyNameState: $c27a3102df5220b7$export$e6a0daad8304de()
};
const $b2490fa107d6478d$export$e6a0daad8304de = (overrides = {})=>({
        ...$b2490fa107d6478d$var$INITIAL_STATE,
        ...overrides
    });
const $b2490fa107d6478d$export$477b3fce3049067a = (state)=>{
    const { current: current, flow: flow } = state.navigation;
    const currentIndex = flow.indexOf(current);
    return currentIndex === 0 || currentIndex === flow.length - 1;
};
const $b2490fa107d6478d$export$f3db0dc3a05c157d = (state)=>{
    const { current: current, flow: flow } = state.navigation;
    const currentIndex = flow.indexOf(current);
    return currentIndex !== flow.length - 1;
};
var $b2490fa107d6478d$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["ClaimCardInvitationReceived"] = "CLAIM_CARD_INVITATION_RECEIVED";
    ActionType["ClaimCardInvitationRejected"] = "CLAIM_CARD_INVITATION_REJECTED";
    ActionType["CreateCardResponseReceived"] = "CREATE_CARD_RESPONSE_RECEIVED";
    ActionType["CreateCardResponseRejected"] = "CREATE_CARD_RESPONSE_REJECTED";
    ActionType["Done"] = "DONE";
    ActionType["GetOrCreateComplianceVerificationReceived"] = "GET_OR_CREATE_COMPLIANCE_VERIFICATION_RECEIVED";
    ActionType["GetOrCreateComplianceVerificationRejected"] = "GET_OR_CREATE_COMPLIANCE_VERIFICATION_REJECTED";
    ActionType["Initialize"] = "INITIALIZE";
    ActionType["NavigateBack"] = "NAVIGATE_BACK";
    ActionType["NavigateNext"] = "NAVIGATE_NEXT";
    ActionType["NavigateToScreen"] = "NAVIGATE_TO_SCREEN";
    ActionType["OnCardShippingDone"] = "ON_CARD_SHIPPING_DONE";
    ActionType["OnVerifyNameDone"] = "ON_VERIFY_NAME_DONE";
    ActionType["SetError"] = "SET_ERROR";
    ActionType["ToggleModal"] = "TOGGLE_MODAL";
    ActionType["UserChangeConfirmPin"] = "USER_CHANGE_CONFIRM_PIN";
    ActionType["UserChangeSetPin"] = "USER_CHANGE_SET_PIN";
    ActionType["UserClickAddToDigitalWallet"] = "USER_CLICK_ADD_TO_DIGITAL_WALLET";
    ActionType["UserClickBackButton"] = "USER_CLICK_BACK_BUTTON";
    ActionType["UserClickCloseButton"] = "USER_CLICK_CLOSE_BUTTON";
    ActionType["UserClickNextButton"] = "USER_CLICK_NEXT_BUTTON";
    ActionType["UserClickSkipAddToDigitalWallet"] = "USER_CLICK_SKIP_ADD_TO_DIGITAL_WALLET";
    return ActionType;
}({});
const $b2490fa107d6478d$export$48f9bc309d916c4e = (response)=>({
        type: "CLAIM_CARD_INVITATION_RECEIVED",
        response: response
    });
const $b2490fa107d6478d$export$21eb82a138d815c3 = (error)=>({
        type: "CLAIM_CARD_INVITATION_REJECTED",
        error: error
    });
const $b2490fa107d6478d$export$57a2388bf0bd5829 = (response)=>({
        type: "CREATE_CARD_RESPONSE_RECEIVED",
        response: response
    });
const $b2490fa107d6478d$export$9d65633e27e46a5a = (error)=>({
        type: "CREATE_CARD_RESPONSE_REJECTED",
        error: error
    });
const $b2490fa107d6478d$export$d3d98dcc45b4508e = (response)=>({
        type: "GET_OR_CREATE_COMPLIANCE_VERIFICATION_RECEIVED",
        response: response
    });
const $b2490fa107d6478d$export$7ae8da9fc164fe4a = (error)=>({
        type: "GET_OR_CREATE_COMPLIANCE_VERIFICATION_REJECTED",
        error: error
    });
const $b2490fa107d6478d$export$8789045e6aca717c = ()=>({
        type: "DONE"
    });
const $b2490fa107d6478d$export$c81c36414a1e3192 = (balanceId, businessName, cardInvitationToken, user, requiresVerification)=>({
        type: "INITIALIZE",
        balanceId: balanceId,
        businessName: businessName,
        cardInvitationToken: cardInvitationToken,
        user: user,
        requiresVerification: requiresVerification
    });
const $b2490fa107d6478d$export$5305586e9456f3b2 = ()=>({
        type: "NAVIGATE_BACK"
    });
const $b2490fa107d6478d$export$48b2ba392cc5989f = ()=>({
        type: "NAVIGATE_NEXT"
    });
const $b2490fa107d6478d$export$a7b94443be12fd7b = (screen)=>({
        type: "NAVIGATE_TO_SCREEN",
        screen: screen
    });
const $b2490fa107d6478d$export$8e55300aef6a3a48 = ()=>({
        type: "ON_CARD_SHIPPING_DONE"
    });
const $b2490fa107d6478d$export$d2125e9041c4ce = ()=>({
        type: "ON_VERIFY_NAME_DONE"
    });
const $b2490fa107d6478d$export$8f12bad0f165bfad = (error)=>({
        type: "SET_ERROR",
        error: error
    });
const $b2490fa107d6478d$export$2085928ad4455e61 = (value)=>({
        type: "TOGGLE_MODAL",
        value: value
    });
const $b2490fa107d6478d$export$7fccafb1bae4775a = (confirmPin)=>({
        type: "USER_CHANGE_CONFIRM_PIN",
        confirmPin: confirmPin
    });
const $b2490fa107d6478d$export$5ad45d9849095e2d = (pin)=>({
        type: "USER_CHANGE_SET_PIN",
        pin: pin
    });
const $b2490fa107d6478d$export$ecbea34edac74891 = ()=>({
        type: "USER_CLICK_BACK_BUTTON"
    });
const $b2490fa107d6478d$export$34ed016b7ffc8a51 = ()=>({
        type: "USER_CLICK_CLOSE_BUTTON"
    });
const $b2490fa107d6478d$export$848ce7d6602fe3bd = ()=>({
        type: "USER_CLICK_NEXT_BUTTON"
    });
function $b2490fa107d6478d$var$handleCreateCardResponseReceived(context, state, action) {
    const { card: card, errors: errors } = action.response;
    if (errors.length) {
        const hasAuthChallengeError = errors.includes((0, $d272bac0a1712861$export$77c2e9a08149a1ad).CreateCardError.CREATE_CARD_ERROR_AUTHORIZATION_CHALLENGED);
        const errorType = hasAuthChallengeError ? 2 : 1;
        return [
            state,
            ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(errorType)
        ];
    }
    if (!card?.id) return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
    const work = ()=>{
        const { userCardInvitationService: userCardInvitationService } = context;
        const request = (0, $bbc3574921766dd2$export$818c5a2d30ed1bb0).create({
            cardInvitationId: state.cardInvitationToken,
            cardToken: card.id
        });
        const response = userCardInvitationService.claimCardInvitation(request).then($b2490fa107d6478d$export$48f9bc309d916c4e, $b2490fa107d6478d$export$21eb82a138d815c3);
        return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(response);
    };
    return [
        {
            ...state,
            cardToken: card.id
        },
        work
    ];
}
function $b2490fa107d6478d$var$handleClaimCardInvitationReceived(state) {
    return [
        {
            ...state,
            loading: false
        },
        $b2490fa107d6478d$export$48b2ba392cc5989f
    ];
}
function $b2490fa107d6478d$var$handleClaimCardInvitationRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(error);
    return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
}
function $b2490fa107d6478d$var$handleCreateCardResponseRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(error);
    return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
}
function $b2490fa107d6478d$var$handleDone(state) {
    return [
        {
            ...state,
            done: true
        },
        null
    ];
}
function $b2490fa107d6478d$var$handleGetOrCreateComplianceVerificationReceived(context, state, action) {
    const { result: result } = action.response;
    switch(result){
        case (0, $81287a0f87730909$export$5a81323f8347f22).ComplianceResult.COMPLIANCE_RESULT_UNKNOWN:
            return [
                state,
                ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
            ];
        case (0, $81287a0f87730909$export$5a81323f8347f22).ComplianceResult.COMPLIANCE_RESULT_FAILED:
            return [
                state,
                ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(2)
            ];
        case (0, $81287a0f87730909$export$5a81323f8347f22).ComplianceResult.COMPLIANCE_RESULT_PASSED:
            {
                const { cardCustomizationState: cardCustomizationState, cardInvitationToken: cardInvitationToken, balanceId: balanceId, cardShippingState: cardShippingState } = state;
                const shippingAddress = cardShippingState.address;
                try {
                    (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(cardCustomizationState.cardCustomizationToken.length > 0, "Card issuing - card customization token is empty");
                    (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(cardInvitationToken.length > 0, "Card issuing - card invitation token is empty");
                    (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(shippingAddress, "Card issuing - chosen address is null");
                } catch (e) {
                    context.sentry.captureException(e);
                    return [
                        {
                            ...state,
                            loading: false
                        },
                        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
                    ];
                }
                const work = ()=>{
                    const { cardManagementService: cardManagementService } = context;
                    const { businessName: businessName, verifyNameState: verifyNameState } = state;
                    const cardHolderName = (0, $f52070b5f7ea08cf$export$525011322c57ec0f)(verifyNameState[$c27a3102df5220b7$export$a455218a85c89869.FirstName], verifyNameState[$c27a3102df5220b7$export$a455218a85c89869.LastName]);
                    const request = (0, $d272bac0a1712861$export$531aee450bc3dbd4).create({
                        balanceId: balanceId,
                        cardCustomization: (0, $d272bac0a1712861$export$f27319a4138ec79f).create({
                            id: cardCustomizationState.cardCustomizationToken,
                            cardTexts: [
                                {
                                    text: businessName,
                                    type: (0, $d272bac0a1712861$export$f27319a4138ec79f).CardText.Type.CARD_TEXT_TYPE_BUSINESS_NAME
                                },
                                {
                                    text: cardHolderName,
                                    type: (0, $d272bac0a1712861$export$f27319a4138ec79f).CardText.Type.CARD_TEXT_TYPE_CARDHOLDER_NAME
                                }
                            ]
                        }),
                        idempotenceKey: context.uuid(),
                        shippingAddress: // TODO(cvu): replace when shipping is implemented
                        shippingAddress
                    });
                    const response = cardManagementService.createCard(request).then($b2490fa107d6478d$export$57a2388bf0bd5829, $b2490fa107d6478d$export$9d65633e27e46a5a);
                    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(response);
                };
                return [
                    {
                        ...state,
                        loading: true
                    },
                    work
                ];
            }
    }
}
function $b2490fa107d6478d$var$handleGetOrCreateComplianceVerificationRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(error);
    return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
}
function $b2490fa107d6478d$var$handleInitialize(context, state, action) {
    const { balanceId: balanceId, businessName: businessName, cardInvitationToken: cardInvitationToken, requiresVerification: requiresVerification, user: user } = action;
    const flow = requiresVerification ? [
        1,
        ...$b2490fa107d6478d$export$49d8745ae22a51ab
    ] : [
        ...$b2490fa107d6478d$export$49d8745ae22a51ab
    ];
    const newState = $b2490fa107d6478d$export$e6a0daad8304de();
    const work = ()=>{
        return (0, $195e3b3043565ec4$export$ba255e9e49e00608)(// Always initialize name state with user data, even when skipping name verification screen
        // This ensures that the card holder name can be set correctly when creating the card
        // whether the name verification screen is skipped or not.
        $c27a3102df5220b7$export$c81c36414a1e3192(user), $d50f52fc18ffa921$export$c81c36414a1e3192(cardInvitationToken, (0, $f52070b5f7ea08cf$export$155800cbebf9d04f)(user)), $a4c47930ee9facdd$export$c81c36414a1e3192(), $b2490fa107d6478d$export$a7b94443be12fd7b(flow[0]));
    };
    // Initialize will reset state
    return [
        {
            ...newState,
            businessName: businessName,
            cardInvitationToken: cardInvitationToken,
            balanceId: balanceId,
            navigation: {
                ...newState.navigation,
                flow: flow
            }
        },
        work
    ];
}
function $b2490fa107d6478d$var$handleNavigateBack(context, state) {
    const { navigation: navigation } = state;
    const { current: current, flow: flow } = navigation;
    const currentIndex = flow.indexOf(current);
    const prevIndex = currentIndex - 1;
    if (prevIndex > -1) {
        if (current === 3) {
            if (state.cardShippingState.screen === $a4c47930ee9facdd$export$a98515d67472a41f.ConfirmAddress) return [
                state,
                ()=>$a4c47930ee9facdd$export$a7b94443be12fd7b($a4c47930ee9facdd$export$a98515d67472a41f.EnterAddress)
            ];
        }
        return [
            state,
            ()=>$b2490fa107d6478d$export$a7b94443be12fd7b(flow[prevIndex])
        ];
    }
    context.sentry.captureException(`Tried to navigate back to screen index out of bounds`);
    return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
}
function $b2490fa107d6478d$var$handleNavigateNext(context, state) {
    const { navigation: navigation } = state;
    const { current: current, flow: flow } = navigation;
    const currentIndex = flow.indexOf(current);
    const nextIndex = currentIndex + 1;
    if (nextIndex < flow.length) return [
        state,
        ()=>$b2490fa107d6478d$export$a7b94443be12fd7b(flow[nextIndex])
    ];
    else return [
        state,
        $b2490fa107d6478d$export$8789045e6aca717c
    ];
}
function $b2490fa107d6478d$var$handleNavigateToScreen(context, state, action) {
    const { screen: screen } = action;
    const { navigation: navigation } = state;
    if (!navigation.flow.includes(screen)) {
        context.sentry.captureException(`Tried to navigate to screen, ${screen}, not in flow [${navigation.flow.toString()}]`);
        return [
            state,
            ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
        ];
    }
    return [
        {
            ...state,
            navigation: {
                ...navigation,
                current: screen
            }
        },
        null
    ];
}
function $b2490fa107d6478d$var$handleOnCardShippingDone(context, state) {
    const { cardInvitationToken: cardInvitationToken, cardShippingState: cardShippingState } = state;
    (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(cardInvitationToken.length > 0);
    const work = ()=>{
        const { bankingWebComplianceService: bankingWebComplianceService } = context;
        const request = (0, $81287a0f87730909$export$32eac23879e45813).create({
            cardInvitationToken: cardInvitationToken,
            globalAddress: cardShippingState.address
        });
        const response = bankingWebComplianceService.getOrCreateComplianceVerification(request).then($b2490fa107d6478d$export$d3d98dcc45b4508e, $b2490fa107d6478d$export$7ae8da9fc164fe4a);
        return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(response);
    };
    return [
        {
            ...state,
            loading: true
        },
        work
    ];
}
function $b2490fa107d6478d$var$handleOnVerifyNameDone(context, state) {
    const { verifyNameState: verifyNameState } = state;
    if (verifyNameState.done === $c27a3102df5220b7$export$f93c40fda808dd0c.ERROR) return [
        state,
        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
    ];
    const firstName = verifyNameState[$c27a3102df5220b7$export$a455218a85c89869.FirstName];
    const lastName = verifyNameState[$c27a3102df5220b7$export$a455218a85c89869.LastName];
    return [
        {
            ...state,
            cardCustomizationState: $d50f52fc18ffa921$export$e6a0daad8304de({
                ...state.cardCustomizationState,
                signatureText: (0, $f52070b5f7ea08cf$export$525011322c57ec0f)(firstName, lastName)
            }),
            verifyNameState: verifyNameState
        },
        $b2490fa107d6478d$export$48b2ba392cc5989f
    ];
}
function $b2490fa107d6478d$var$handleSetError(state, action) {
    const { error: error } = action;
    const navigation = {
        current: $b2490fa107d6478d$export$3ef250ace880f95b[0],
        flow: $b2490fa107d6478d$export$3ef250ace880f95b
    };
    return [
        {
            ...state,
            navigation: navigation,
            error: error
        },
        null
    ];
}
function $b2490fa107d6478d$var$handleToggleModal(state, { value: value }) {
    return [
        {
            ...state,
            modalOpen: value ?? !state.modalOpen
        },
        null
    ];
}
function $b2490fa107d6478d$var$handleUserChangeConfirmPin(state, action) {
    const { pin: pin } = state;
    const { confirmPin: confirmPin } = action;
    if (pin === confirmPin) return [
        {
            ...state,
            confirmPin: confirmPin
        },
        $b2490fa107d6478d$export$48b2ba392cc5989f
    ];
    else if (confirmPin.length < $b2490fa107d6478d$var$PIN_LENGTH) return [
        {
            ...state,
            confirmPin: confirmPin
        },
        null
    ];
    // TODO(cvu): add pin does not match validation
    return [
        {
            ...state,
            confirmPin: confirmPin
        },
        null
    ];
}
function $b2490fa107d6478d$var$handleUserChangeSetPin(state, action) {
    const { pin: pin } = action;
    // TODO(cvu): add complex pin validation
    const maybeNextAction = pin.length === $b2490fa107d6478d$var$PIN_LENGTH ? $b2490fa107d6478d$export$48b2ba392cc5989f : null;
    return [
        {
            ...state,
            pin: pin
        },
        maybeNextAction
    ];
}
function $b2490fa107d6478d$var$handleUserClickCloseButton(state) {
    const { current: current, flow: flow } = state.navigation;
    if (current === flow[flow.length - 1]) return [
        state,
        ()=>(0, $195e3b3043565ec4$export$ba255e9e49e00608)($b2490fa107d6478d$export$2085928ad4455e61(false), $b2490fa107d6478d$export$8789045e6aca717c())
    ];
    return [
        state,
        ()=>$b2490fa107d6478d$export$2085928ad4455e61(false)
    ];
}
function $b2490fa107d6478d$var$handleUserClickNextButton(context, state) {
    return [
        state,
        $b2490fa107d6478d$export$48b2ba392cc5989f
    ];
}
const $b2490fa107d6478d$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "CLAIM_CARD_INVITATION_RECEIVED":
                return $b2490fa107d6478d$var$handleClaimCardInvitationReceived(state);
            case "CLAIM_CARD_INVITATION_REJECTED":
                return $b2490fa107d6478d$var$handleClaimCardInvitationRejected(context, state, action);
            case "CREATE_CARD_RESPONSE_RECEIVED":
                return $b2490fa107d6478d$var$handleCreateCardResponseReceived(context, state, action);
            case "CREATE_CARD_RESPONSE_REJECTED":
                return $b2490fa107d6478d$var$handleCreateCardResponseRejected(context, state, action);
            case "DONE":
                return $b2490fa107d6478d$var$handleDone(state);
            case "GET_OR_CREATE_COMPLIANCE_VERIFICATION_RECEIVED":
                return $b2490fa107d6478d$var$handleGetOrCreateComplianceVerificationReceived(context, state, action);
            case "GET_OR_CREATE_COMPLIANCE_VERIFICATION_REJECTED":
                return $b2490fa107d6478d$var$handleGetOrCreateComplianceVerificationRejected(context, state, action);
            case "INITIALIZE":
                return $b2490fa107d6478d$var$handleInitialize(context, state, action);
            case "NAVIGATE_BACK":
                return $b2490fa107d6478d$var$handleNavigateBack(context, state);
            case "NAVIGATE_NEXT":
                return $b2490fa107d6478d$var$handleNavigateNext(context, state);
            case "NAVIGATE_TO_SCREEN":
                return $b2490fa107d6478d$var$handleNavigateToScreen(context, state, action);
            case "ON_CARD_SHIPPING_DONE":
                return $b2490fa107d6478d$var$handleOnCardShippingDone(context, state);
            case "ON_VERIFY_NAME_DONE":
                return $b2490fa107d6478d$var$handleOnVerifyNameDone(context, state);
            case "SET_ERROR":
                return $b2490fa107d6478d$var$handleSetError(state, action);
            case "TOGGLE_MODAL":
                return $b2490fa107d6478d$var$handleToggleModal(state, action);
            case "USER_CHANGE_CONFIRM_PIN":
                return $b2490fa107d6478d$var$handleUserChangeConfirmPin(state, action);
            case "USER_CHANGE_SET_PIN":
                return $b2490fa107d6478d$var$handleUserChangeSetPin(state, action);
            case "USER_CLICK_ADD_TO_DIGITAL_WALLET":
                // TODO(cvu): Add functionally for this action
                return [
                    state,
                    null
                ];
            case "USER_CLICK_BACK_BUTTON":
                return [
                    state,
                    $b2490fa107d6478d$export$5305586e9456f3b2
                ];
            case "USER_CLICK_CLOSE_BUTTON":
                return $b2490fa107d6478d$var$handleUserClickCloseButton(state);
            case "USER_CLICK_NEXT_BUTTON":
                return $b2490fa107d6478d$var$handleUserClickNextButton(context, state);
            case "USER_CLICK_SKIP_ADD_TO_DIGITAL_WALLET":
                // TODO(cvu): Add functionally for this action
                return [
                    state,
                    null
                ];
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.CreateCardCustomizationReceived:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.CreateCardCustomizationRejected:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.Initialize:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.UserChangeSignatureFont:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.UserChangeSignatureText:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.UserClickNextAction:
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.UserToggleCustomizeSignature:
                {
                    const [cardCustomizationState, nextAction] = $d50f52fc18ffa921$export$722fbec263ad908a({
                        bankingWebCardService: context.bankingWebCardService,
                        textRenderer: context.textRenderer,
                        uuid: context.uuid
                    })(state.cardCustomizationState, action);
                    return [
                        {
                            ...state,
                            cardCustomizationState: cardCustomizationState
                        },
                        nextAction
                    ];
                }
            case $d50f52fc18ffa921$export$e4a712fff93fb00f.Done:
                {
                    const [cardCustomizationState] = $d50f52fc18ffa921$export$722fbec263ad908a({
                        bankingWebCardService: context.bankingWebCardService,
                        textRenderer: context.textRenderer,
                        uuid: context.uuid
                    })(state.cardCustomizationState, action);
                    return [
                        {
                            ...state,
                            cardCustomizationState: cardCustomizationState
                        },
                        $b2490fa107d6478d$export$48b2ba392cc5989f
                    ];
                }
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.Error:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.Done:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.Initialize:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.GetCountryAddressDataReceived:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.GetCountryAddressDataRejected:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.NavigateToScreen:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.UserChangeChosenAddress:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.UserChangeAddress:
            case $a4c47930ee9facdd$export$e4a712fff93fb00f.UserClickNextButton:
                {
                    const [cardShippingState, nextAction] = $a4c47930ee9facdd$export$722fbec263ad908a({
                        sentry: context.sentry,
                        webService: context.webService
                    })(state.cardShippingState, action);
                    if (action.type === $a4c47930ee9facdd$export$e4a712fff93fb00f.Done) return [
                        {
                            ...state,
                            cardShippingState: cardShippingState,
                            loading: true
                        },
                        $b2490fa107d6478d$export$8e55300aef6a3a48
                    ];
                    if (action.type === $a4c47930ee9facdd$export$e4a712fff93fb00f.Error) return [
                        {
                            ...state,
                            cardShippingState: cardShippingState
                        },
                        ()=>$b2490fa107d6478d$export$8f12bad0f165bfad(1)
                    ];
                    return [
                        {
                            ...state,
                            cardShippingState: cardShippingState
                        },
                        nextAction
                    ];
                }
            case $c27a3102df5220b7$export$e4a712fff93fb00f.Done:
            case $c27a3102df5220b7$export$e4a712fff93fb00f.Initialize:
            case $c27a3102df5220b7$export$e4a712fff93fb00f.UpdatePersonProfileReceived:
            case $c27a3102df5220b7$export$e4a712fff93fb00f.UpdatePersonProfileRejected:
            case $c27a3102df5220b7$export$e4a712fff93fb00f.UserChangeInputFieldValue:
            case $c27a3102df5220b7$export$e4a712fff93fb00f.UserClickNext:
                {
                    const [verifyNameState, nextAction] = $c27a3102df5220b7$export$722fbec263ad908a({
                        personProfileService: context.personProfileService,
                        sentry: context.sentry,
                        uuid: context.uuid
                    })(state.verifyNameState, action);
                    const work = action.type === $c27a3102df5220b7$export$e4a712fff93fb00f.Done ? $b2490fa107d6478d$export$d2125e9041c4ce : nextAction;
                    return [
                        {
                            ...state,
                            verifyNameState: verifyNameState
                        },
                        work
                    ];
                }
        }
    };
const $b2490fa107d6478d$var$cardIssuing = (seed, context)=>{
    const w = (0, $f244369e42336676$export$2e2bcd8739ae039)($b2490fa107d6478d$export$722fbec263ad908a(context), seed);
    return {
        states: w.states,
        updates: w.updates,
        emit: w.emit
    };
};
var $b2490fa107d6478d$export$2e2bcd8739ae039 = $b2490fa107d6478d$var$cardIssuing;




const $01f0b782f211d659$var$foldOperators = (pipes)=>(source)=>(0, $195e3b3043565ec4$export$ba255e9e49e00608)(...pipes.map((pipe)=>source.pipe(pipe)));
// Combine multiple analytics signals into one.
const $01f0b782f211d659$var$analytics = (pipes)=>(source)=>source.pipe($01f0b782f211d659$var$foldOperators(pipes), (0, $4707859e785b3da6$export$18aef43295bbe906)());
var $01f0b782f211d659$export$2e2bcd8739ae039 = $01f0b782f211d659$var$analytics;








const $86e4772b0444d7da$var$enterLegalNamePageView = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, after], _])=>!before.modalOpen && after.modalOpen && after.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).VerifyName), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.View,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.EnterLegalName,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$enterLegalNameNextButtonClick = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, _], action])=>before.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).VerifyName && action.type === (0, $c27a3102df5220b7$export$e4a712fff93fb00f).UserClickNext), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.Click,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.EnterLegalName,
            target: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Target.Next,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$personalizeCardPageView = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, after], _])=>before.navigation.current !== (0, $b2490fa107d6478d$export$a98515d67472a41f).Customization && after.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).Customization), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.View,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.PersonalizeCard,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$personalizeCardNextButtonClick = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, _], action])=>before.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).Customization && action.type === (0, $d50f52fc18ffa921$export$e4a712fff93fb00f).UserClickNextAction), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.Click,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.PersonalizeCard,
            target: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Target.Next,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$shippingDetailsPageView = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, after], _])=>before.navigation.current !== (0, $b2490fa107d6478d$export$a98515d67472a41f).ShippingAddress && after.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).ShippingAddress), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.View,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.ShippingDetails,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$shippingDetailsNextButtonClick = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, _], action])=>before.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).ShippingAddress && action.type === (0, $a4c47930ee9facdd$export$e4a712fff93fb00f).UserClickNextButton), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.Click,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.ShippingDetails,
            target: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Target.Next,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$orderConfirmationPageView = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, after], _])=>before.navigation.current !== (0, $b2490fa107d6478d$export$a98515d67472a41f).OrderConfirmation && after.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).OrderConfirmation), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.View,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.OrderConfirmation,
            cardInvitationToken: after.cardInvitationToken
        })));
const $86e4772b0444d7da$var$orderConfirmationDoneButtonClick = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[before, _], action])=>before.navigation.current === (0, $b2490fa107d6478d$export$a98515d67472a41f).OrderConfirmation && action.type === (0, $b2490fa107d6478d$export$e4a712fff93fb00f).Done), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_before, after], _])=>(0, $4bc04b71b868732d$export$b8bcf109fec61099).CDP.event({
            action: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Action.Click,
            page: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Page.OrderConfirmation,
            target: (0, $4bc04b71b868732d$export$b8bcf109fec61099).Target.Next,
            cardInvitationToken: after.cardInvitationToken
        })));
var $86e4772b0444d7da$export$2e2bcd8739ae039 = [
    $86e4772b0444d7da$var$enterLegalNamePageView,
    $86e4772b0444d7da$var$enterLegalNameNextButtonClick,
    $86e4772b0444d7da$var$personalizeCardPageView,
    $86e4772b0444d7da$var$personalizeCardNextButtonClick,
    $86e4772b0444d7da$var$shippingDetailsPageView,
    $86e4772b0444d7da$var$shippingDetailsNextButtonClick,
    $86e4772b0444d7da$var$orderConfirmationPageView,
    $86e4772b0444d7da$var$orderConfirmationDoneButtonClick
];


(function(EventLogging) {
    (function(Action) {
        Action["Click"] = "Click";
        Action["View"] = "View";
    })(EventLogging.Action || (EventLogging.Action = {}));
    (function(Page) {
        Page["EnterLegalName"] = "Enter Legal Name";
        Page["PersonalizeCard"] = "Personalize Card";
        Page["ShippingDetails"] = "Shipping Details";
        Page["OrderConfirmation"] = "Order Confirmation";
    })(EventLogging.Page || (EventLogging.Page = {}));
    (function(Target) {
        Target["Next"] = "Next";
        Target["Done"] = "Done";
    })(EventLogging.Target || (EventLogging.Target = {}));
    (function(Feature) {
        Feature["CardOrdering"] = "Card Ordering";
    })(EventLogging.Feature || (EventLogging.Feature = {}));
    (function(CDP) {
        const eventName = (action, feature)=>`${action} ${feature}`;
        CDP.event = (args)=>{
            const feature = "Card Ordering";
            return {
                eventName: eventName(args.action, feature),
                eventProps: {
                    ...args,
                    applet: "Home",
                    feature: feature
                }
            };
        };
    })(EventLogging.CDP || (EventLogging.CDP = {}));
})($4bc04b71b868732d$export$b8bcf109fec61099 || ($4bc04b71b868732d$export$b8bcf109fec61099 = {}));
var $4bc04b71b868732d$export$2e2bcd8739ae039 = (0, $01f0b782f211d659$export$2e2bcd8739ae039)([
    ...(0, $86e4772b0444d7da$export$2e2bcd8739ae039)
]);
var $4bc04b71b868732d$export$b8bcf109fec61099;





var $df4c13d691d01291$exports = {};
var $a3b0f2fdf3961f6f$exports = {};


$df4c13d691d01291$exports["content"] = `IMiyZG_Page_content`;
$df4c13d691d01291$exports["header"] = `IMiyZG_Page_header`;
$df4c13d691d01291$exports["page"] = `IMiyZG_Page_page`;
for(let key in $a3b0f2fdf3961f6f$exports)if (key in $df4c13d691d01291$exports) $df4c13d691d01291$exports[key] += ' ' + $a3b0f2fdf3961f6f$exports[key];
else $df4c13d691d01291$exports[key] = $a3b0f2fdf3961f6f$exports[key];


function $10b264b7e14b606b$export$6955bcca4cd3539f({ header: header, loading: loading = false, className: className, children: children }) {
    const loadingIndicator = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$28c2b904b2ab5c88), {});
    return loading ? loadingIndicator : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($df4c13d691d01291$exports.page, className),
        children: [
            header && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $df4c13d691d01291$exports.header,
                children: header
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $df4c13d691d01291$exports.content,
                children: children
            })
        ]
    });
}












var $acw62 = parcelRequire("acw62");



var $e000fdea42d59506$exports = {};
/* Font Face Observer v2.3.0 - © Bram Stein. License: BSD-3-Clause */ (function() {
    function p(a, c) {
        document.addEventListener ? a.addEventListener("scroll", c, !1) : a.attachEvent("scroll", c);
    }
    function u(a) {
        document.body ? a() : document.addEventListener ? document.addEventListener("DOMContentLoaded", function b() {
            document.removeEventListener("DOMContentLoaded", b);
            a();
        }) : document.attachEvent("onreadystatechange", function g() {
            if ("interactive" == document.readyState || "complete" == document.readyState) document.detachEvent("onreadystatechange", g), a();
        });
    }
    function w(a) {
        this.g = document.createElement("div");
        this.g.setAttribute("aria-hidden", "true");
        this.g.appendChild(document.createTextNode(a));
        this.h = document.createElement("span");
        this.i = document.createElement("span");
        this.m = document.createElement("span");
        this.j = document.createElement("span");
        this.l = -1;
        this.h.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
        this.i.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
        this.j.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
        this.m.style.cssText = "display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";
        this.h.appendChild(this.m);
        this.i.appendChild(this.j);
        this.g.appendChild(this.h);
        this.g.appendChild(this.i);
    }
    function x(a, c) {
        a.g.style.cssText = "max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:" + c + ";";
    }
    function B(a) {
        var c = a.g.offsetWidth, b = c + 100;
        a.j.style.width = b + "px";
        a.i.scrollLeft = b;
        a.h.scrollLeft = a.h.scrollWidth + 100;
        return a.l !== c ? (a.l = c, !0) : !1;
    }
    function C(a, c) {
        function b() {
            var e = g;
            B(e) && null !== e.g.parentNode && c(e.l);
        }
        var g = a;
        p(a.h, b);
        p(a.i, b);
        B(a);
    }
    function D(a, c, b) {
        c = c || {};
        b = b || window;
        this.family = a;
        this.style = c.style || "normal";
        this.weight = c.weight || "normal";
        this.stretch = c.stretch || "normal";
        this.context = b;
    }
    var E = null, F = null, G = null, H = null;
    function I(a) {
        null === F && (M(a) && /Apple/.test(window.navigator.vendor) ? (a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent), F = !!a && 603 > parseInt(a[1], 10)) : F = !1);
        return F;
    }
    function M(a) {
        null === H && (H = !!a.document.fonts);
        return H;
    }
    function N(a, c) {
        var b = a.style, g = a.weight;
        if (null === G) {
            var e = document.createElement("div");
            try {
                e.style.font = "condensed 100px sans-serif";
            } catch (q) {}
            G = "" !== e.style.font;
        }
        return [
            b,
            g,
            G ? a.stretch : "",
            "100px",
            c
        ].join(" ");
    }
    D.prototype.load = function(a, c) {
        var b = this, g = a || "BESbswy", e = 0, q = c || 3E3, J = (new Date).getTime();
        return new Promise(function(K, L) {
            if (M(b.context) && !I(b.context)) {
                var O = new Promise(function(r, t) {
                    function h() {
                        (new Date).getTime() - J >= q ? t(Error("" + q + "ms timeout exceeded")) : b.context.document.fonts.load(N(b, '"' + b.family + '"'), g).then(function(n) {
                            1 <= n.length ? r() : setTimeout(h, 25);
                        }, t);
                    }
                    h();
                }), P = new Promise(function(r, t) {
                    e = setTimeout(function() {
                        t(Error("" + q + "ms timeout exceeded"));
                    }, q);
                });
                Promise.race([
                    P,
                    O
                ]).then(function() {
                    clearTimeout(e);
                    K(b);
                }, L);
            } else u(function() {
                function r() {
                    var d;
                    if (d = -1 != k && -1 != l || -1 != k && -1 != m || -1 != l && -1 != m) (d = k != l && k != m && l != m) || (null === E && (d = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent), E = !!d && (536 > parseInt(d[1], 10) || 536 === parseInt(d[1], 10) && 11 >= parseInt(d[2], 10))), d = E && (k == y && l == y && m == y || k == z && l == z && m == z || k == A && l == A && m == A)), d = !d;
                    d && (null !== f.parentNode && f.parentNode.removeChild(f), clearTimeout(e), K(b));
                }
                function t() {
                    if ((new Date).getTime() - J >= q) null !== f.parentNode && f.parentNode.removeChild(f), L(Error("" + q + "ms timeout exceeded"));
                    else {
                        var d = b.context.document.hidden;
                        if (!0 === d || void 0 === d) k = h.g.offsetWidth, l = n.g.offsetWidth, m = v.g.offsetWidth, r();
                        e = setTimeout(t, 50);
                    }
                }
                var h = new w(g), n = new w(g), v = new w(g), k = -1, l = -1, m = -1, y = -1, z = -1, A = -1, f = document.createElement("div");
                f.dir = "ltr";
                x(h, N(b, "sans-serif"));
                x(n, N(b, "serif"));
                x(v, N(b, "monospace"));
                f.appendChild(h.g);
                f.appendChild(n.g);
                f.appendChild(v.g);
                b.context.document.body.appendChild(f);
                y = h.g.offsetWidth;
                z = n.g.offsetWidth;
                A = v.g.offsetWidth;
                t();
                C(h, function(d) {
                    k = d;
                    r();
                });
                x(h, N(b, '"' + b.family + '",sans-serif'));
                C(n, function(d) {
                    l = d;
                    r();
                });
                x(n, N(b, '"' + b.family + '",serif'));
                C(v, function(d) {
                    m = d;
                    r();
                });
                x(v, N(b, '"' + b.family + '",monospace'));
            });
        });
    };
    $e000fdea42d59506$exports = D;
})();




var $acw62 = parcelRequire("acw62");


function $01b628065e650f1c$export$20c0b5ff3d7d9924({ businessName: businessName, className: className, signatureDataUri: signatureDataUri }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "335",
        height: "208",
        viewBox: "0 0 335 208",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "335",
                height: "208",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M277.5 16C273.91 16 271 18.9102 271 22.5V57.5C271 61.0899 273.91 64 277.5 64H312.5C316.09 64 319 61.0899 319 57.5V22.5C319 18.9101 316.09 16 312.5 16H277.5ZM282 25C280.895 25 280 25.8954 280 27V53C280 54.1046 280.895 55 282 55H308C309.105 55 310 54.1046 310 53V27C310 25.8954 309.105 25 308 25H282ZM289.5 33C288.672 33 288 33.6716 288 34.5V45.5C288 46.3284 288.672 47 289.5 47H300.5C301.328 47 302 46.3284 302 45.5V34.5C302 33.6716 301.328 33 300.5 33H289.5Z",
                fill: "#F1F3F5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M277.5 16C273.91 16 271 18.9102 271 22.5V57.5C271 61.0899 273.91 64 277.5 64H312.5C316.09 64 319 61.0899 319 57.5V22.5C319 18.9101 316.09 16 312.5 16H277.5ZM282 25C280.895 25 280 25.8954 280 27V53C280 54.1046 280.895 55 282 55H308C309.105 55 310 54.1046 310 53V27C310 25.8954 309.105 25 308 25H282ZM289.5 33C288.672 33 288 33.6716 288 34.5V45.5C288 46.3284 288.672 47 289.5 47H300.5C301.328 47 302 46.3284 302 45.5V34.5C302 33.6716 301.328 33 300.5 33H289.5Z",
                fill: "url(#paint0_radial_555_74899)",
                fillOpacity: "0.3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                opacity: "0.8",
                x: "34",
                y: "70",
                width: "40",
                height: "30.9489",
                fill: "url(#pattern0)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("image", {
                x: "119",
                y: "109",
                width: "200",
                xlinkHref: signatureDataUri
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                className: "paragraph-30",
                textAnchor: "end",
                x: "319",
                y: "192",
                fill: "#101314",
                children: businessName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                            xlinkHref: "#image0_555_74899",
                            transform: "scale(0.00729927 0.00943396)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                        id: "paint0_radial_555_74899",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(271 16) rotate(45) scale(67.8823)",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("image", {
                        id: "image0_555_74899",
                        width: "137",
                        height: "106",
                        xlinkHref: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    });
}


function $25a3c353e703cc79$export$35617c7a4abfbad0(props) {
    const [signatureDataUri, setSignatureDataUri] = (0, $acw62.useState)("");
    const [textRenderer, setTextRenderer] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const txtRenderer = new (0, $74c7b72a71b76868$export$2e2bcd8739ae039)(props.estimatedFontSize, props.fontFamily, props.nameOnCard, props.boundingBox, (0, $74c7b72a71b76868$export$5aa9cd1ba259435e));
        setTextRenderer(txtRenderer);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (textRenderer) {
            textRenderer.fontFamily = props.fontFamily;
            textRenderer.text = props.nameOnCard;
            setSignatureDataUri(textRenderer.toDataURL());
        }
    }, [
        textRenderer,
        props.nameOnCard,
        props.fontFamily
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01b628065e650f1c$export$20c0b5ff3d7d9924), {
        ...props,
        signatureDataUri: signatureDataUri
    });
}







var $58cb02b9641cce25$exports = {};
(function(f) {
    var g;
    $58cb02b9641cce25$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(_e) {
                    var n = t[o][1][_e];
                    return s(n ? n : _e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(process) {
                    (function(global, factory) {
                        if (typeof define === 'function' && define.amd) define('InputSim', [
                            'exports'
                        ], factory);
                        else if (typeof exports !== 'undefined') factory(exports);
                        else {
                            var mod = {
                                exports: {}
                            };
                            factory(mod.exports);
                            global.InputSim = mod.exports;
                        }
                    })(this, function(exports) {
                        /*! jshint esnext:true, undef:true, unused:true */ /** @private */ 'use strict';
                        Object.defineProperty(exports, '__esModule', {
                            value: true
                        });
                        var _createClass = function() {
                            function defineProperties(target, props) {
                                for(var i = 0; i < props.length; i++){
                                    var descriptor = props[i];
                                    descriptor.enumerable = descriptor.enumerable || false;
                                    descriptor.configurable = true;
                                    if ('value' in descriptor) descriptor.writable = true;
                                    Object.defineProperty(target, descriptor.key, descriptor);
                                }
                            }
                            return function(Constructor, protoProps, staticProps) {
                                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                                if (staticProps) defineProperties(Constructor, staticProps);
                                return Constructor;
                            };
                        }();
                        function _classCallCheck(instance, Constructor) {
                            if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                        }
                        var A = 65;
                        /** @private */ var Y = 89;
                        /** @private */ var Z = 90;
                        /** @private */ var ZERO = 48;
                        /** @private */ var NINE = 57;
                        /** @private */ var LEFT = 37;
                        /** @private */ var RIGHT = 39;
                        /** @private */ var UP = 38;
                        /** @private */ var DOWN = 40;
                        /** @private */ var BACKSPACE = 8;
                        /** @private */ var DELETE = 46;
                        /** @private */ var TAB = 9;
                        /** @private */ var ENTER = 13;
                        /**
   * @namespace KEYS
   */ var KEYS = {
                            A: A,
                            Y: Y,
                            Z: Z,
                            ZERO: ZERO,
                            NINE: NINE,
                            LEFT: LEFT,
                            RIGHT: RIGHT,
                            UP: UP,
                            DOWN: DOWN,
                            BACKSPACE: BACKSPACE,
                            DELETE: DELETE,
                            TAB: TAB,
                            ENTER: ENTER,
                            /**
     * @param {number} keyCode
     * @returns {boolean}
     */ isDigit: function isDigit(keyCode) {
                                return ZERO <= keyCode && keyCode <= NINE;
                            },
                            /**
     * Is an arrow keyCode.
     *
     * @param {number} keyCode
     * @returns {boolean}
     */ isDirectional: function isDirectional(keyCode) {
                                return keyCode === LEFT || keyCode === RIGHT || keyCode === UP || keyCode === DOWN;
                            }
                        };
                        var CTRL = 1;
                        var META = 2;
                        var ALT = 4;
                        var SHIFT = 8;
                        var cache = {};
                        /**
   * Builds a BindingSet based on the current platform.
   *
   * @param {string} platform A string name of a platform (e.g. "OSX").
   * @returns {BindingSet} keybindings appropriate for the given platform.
   */ function keyBindingsForPlatform(platform) {
                            var osx = platform === 'OSX';
                            var ctrl = osx ? META : CTRL;
                            if (!cache[platform]) cache[platform] = build(function(bind) {
                                bind(A, ctrl, 'selectAll');
                                bind(LEFT, null, 'moveLeft');
                                bind(LEFT, ALT, 'moveWordLeft');
                                bind(LEFT, SHIFT, 'moveLeftAndModifySelection');
                                bind(LEFT, ALT | SHIFT, 'moveWordLeftAndModifySelection');
                                bind(RIGHT, null, 'moveRight');
                                bind(RIGHT, ALT, 'moveWordRight');
                                bind(RIGHT, SHIFT, 'moveRightAndModifySelection');
                                bind(RIGHT, ALT | SHIFT, 'moveWordRightAndModifySelection');
                                bind(UP, null, 'moveUp');
                                bind(UP, ALT, 'moveToBeginningOfParagraph');
                                bind(UP, SHIFT, 'moveUpAndModifySelection');
                                bind(UP, ALT | SHIFT, 'moveParagraphBackwardAndModifySelection');
                                bind(DOWN, null, 'moveDown');
                                bind(DOWN, ALT, 'moveToEndOfParagraph');
                                bind(DOWN, SHIFT, 'moveDownAndModifySelection');
                                bind(DOWN, ALT | SHIFT, 'moveParagraphForwardAndModifySelection');
                                bind(BACKSPACE, null, 'deleteBackward');
                                bind(BACKSPACE, SHIFT, 'deleteBackward');
                                bind(BACKSPACE, ALT, 'deleteWordBackward');
                                bind(BACKSPACE, ALT | SHIFT, 'deleteWordBackward');
                                bind(BACKSPACE, ctrl, 'deleteBackwardToBeginningOfLine');
                                bind(BACKSPACE, ctrl | SHIFT, 'deleteBackwardToBeginningOfLine');
                                bind(DELETE, null, 'deleteForward');
                                bind(DELETE, ALT, 'deleteWordForward');
                                bind(TAB, null, 'insertTab');
                                bind(TAB, SHIFT, 'insertBackTab');
                                bind(ENTER, null, 'insertNewline');
                                bind(Z, ctrl, 'undo');
                                if (osx) {
                                    bind(LEFT, META, 'moveToBeginningOfLine');
                                    bind(LEFT, META | SHIFT, 'moveToBeginningOfLineAndModifySelection');
                                    bind(RIGHT, META, 'moveToEndOfLine');
                                    bind(RIGHT, META | SHIFT, 'moveToEndOfLineAndModifySelection');
                                    bind(UP, META, 'moveToBeginningOfDocument');
                                    bind(UP, META | SHIFT, 'moveToBeginningOfDocumentAndModifySelection');
                                    bind(DOWN, META, 'moveToEndOfDocument');
                                    bind(DOWN, META | SHIFT, 'moveToEndOfDocumentAndModifySelection');
                                    bind(BACKSPACE, CTRL, 'deleteBackwardByDecomposingPreviousCharacter');
                                    bind(BACKSPACE, CTRL | SHIFT, 'deleteBackwardByDecomposingPreviousCharacter');
                                    bind(Z, META | SHIFT, 'redo');
                                } else bind(Y, CTRL, 'redo');
                            });
                            return cache[platform];
                        }
                        function build(callback) {
                            var result = new BindingSet();
                            callback(function() {
                                return result.bind.apply(result, arguments);
                            });
                            return result;
                        }
                        /**
   * @private
   */ var BindingSet = function() {
                            function BindingSet() {
                                _classCallCheck(this, BindingSet);
                                this.bindings = {};
                            }
                            /**
     * Enum for text direction affinity.
     *
     * @const
     * @enum {number}
     * @private
     */ /**
     * @param {number} keyCode
     * @param {number} modifiers
     * @param {string} action
     */ _createClass(BindingSet, [
                                {
                                    key: 'bind',
                                    value: function bind(keyCode, modifiers, action) {
                                        if (!this.bindings[keyCode]) this.bindings[keyCode] = {};
                                        this.bindings[keyCode][modifiers || 0] = action;
                                    }
                                },
                                {
                                    key: 'actionForEvent',
                                    value: function actionForEvent(event) {
                                        var bindingsForKeyCode = this.bindings[event.keyCode];
                                        if (bindingsForKeyCode) {
                                            var modifiers = 0;
                                            if (event.altKey) modifiers |= ALT;
                                            if (event.ctrlKey) modifiers |= CTRL;
                                            if (event.metaKey) modifiers |= META;
                                            if (event.shiftKey) modifiers |= SHIFT;
                                            return bindingsForKeyCode[modifiers];
                                        }
                                    }
                                }
                            ]);
                            return BindingSet;
                        }();
                        var Affinity = {
                            UPSTREAM: 0,
                            DOWNSTREAM: 1,
                            NONE: null
                        };
                        /**
   * Tests is string passed in is a single word.
   *
   * @param {string} chr
   * @returns {boolean}
   * @private
   */ function isWordChar(chr) {
                            return chr && /^\w$/.test(chr);
                        }
                        /**
   * Checks if char to the left of {index} in {string}
   * is a break (non-char).
   *
   * @param {string} text
   * @param {number} index
   * @returns {boolean}
   * @private
   */ function hasLeftWordBreakAtIndex(text, index) {
                            if (index === 0) return true;
                            else return !isWordChar(text[index - 1]) && isWordChar(text[index]);
                        }
                        /**
   * Checks if char to the right of {index} in {string}
   * is a break (non-char).
   *
   * @param {string} text
   * @param {number} index
   * @returns {boolean}
   * @private
   */ function hasRightWordBreakAtIndex(text, index) {
                            if (index === text.length - 1) return true;
                            else return isWordChar(text[index]) && !isWordChar(text[index + 1]);
                        }
                        var Input = function() {
                            /**
      * Sets up the initial properties of the TextField and
      * sets  up the event listeners
      *
      * @param {string} value
      * @param {Object} range ({start: 0, length: 0})
      */ function Input(value, range) {
                                _classCallCheck(this, Input);
                                this._value = '';
                                this._selectedRange = {
                                    start: 0,
                                    length: 0
                                };
                                this.shouldCancelEvents = true;
                                this.selectionAffinity = Affinity.NONE;
                                if (value) this.setText(value);
                                if (range) this.setSelectedRange(range);
                                this._buildKeybindings();
                            }
                            /**
     * Clears all characters in the existing selection.
     *
     * @example
     *     // 12|34567|8
     *     clearSelection();
     *     // 12|8
     *
     */ _createClass(Input, [
                                {
                                    key: 'clearSelection',
                                    value: function clearSelection() {
                                        this.replaceSelection('');
                                    }
                                },
                                {
                                    key: 'deleteBackward',
                                    value: function deleteBackward(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        if (range.length === 0) {
                                            range.start--;
                                            range.length++;
                                            this.setSelectedRange(range);
                                        }
                                        this.clearSelection();
                                    }
                                },
                                {
                                    key: 'deleteWordBackward',
                                    value: function deleteWordBackward(event) {
                                        if (this.hasSelection()) this.deleteBackward(event);
                                        else {
                                            this._handleEvent(event);
                                            var range = this.selectedRange();
                                            var start = this._lastWordBreakBeforeIndex(range.start);
                                            range.length += range.start - start;
                                            range.start = start;
                                            this.setSelectedRange(range);
                                            this.clearSelection();
                                        }
                                    }
                                },
                                {
                                    key: 'deleteBackwardByDecomposingPreviousCharacter',
                                    value: function deleteBackwardByDecomposingPreviousCharacter(event) {
                                        this.deleteBackward(event);
                                    }
                                },
                                {
                                    key: 'deleteBackwardToBeginningOfLine',
                                    value: function deleteBackwardToBeginningOfLine(event) {
                                        if (this.hasSelection()) this.deleteBackward(event);
                                        else {
                                            this._handleEvent(event);
                                            var range = this.selectedRange();
                                            range.length = range.start;
                                            range.start = 0;
                                            this.setSelectedRange(range);
                                            this.clearSelection();
                                        }
                                    }
                                },
                                {
                                    key: 'deleteForward',
                                    value: function deleteForward(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        if (range.length === 0) {
                                            range.length++;
                                            this.setSelectedRange(range);
                                        }
                                        this.clearSelection();
                                    }
                                },
                                {
                                    key: 'deleteWordForward',
                                    value: function deleteWordForward(event) {
                                        if (this.hasSelection()) return this.deleteForward(event);
                                        else {
                                            this._handleEvent(event);
                                            var range = this.selectedRange();
                                            var end = this._nextWordBreakAfterIndex(range.start + range.length);
                                            this.setSelectedRange({
                                                start: range.start,
                                                length: end - range.start
                                            });
                                            this.clearSelection();
                                        }
                                    }
                                },
                                {
                                    key: 'handleEvent',
                                    value: function handleEvent(event) {
                                        if (typeof event === 'undefined') throw new Error('cannot handle and event that isn\'t passed');
                                        var action = this._bindings.actionForEvent(event);
                                        if (action) this[action](event);
                                        return action;
                                    }
                                },
                                {
                                    key: 'hasSelection',
                                    value: function hasSelection() {
                                        return this.selectedRange().length !== 0;
                                    }
                                },
                                {
                                    key: 'insertBackTab',
                                    value: function insertBackTab() {}
                                },
                                {
                                    key: 'insertNewline',
                                    value: function insertNewline() {}
                                },
                                {
                                    key: 'insertTab',
                                    value: function insertTab() {}
                                },
                                {
                                    key: 'insertText',
                                    value: function insertText(text) {
                                        var range;
                                        if (this.hasSelection()) this.clearSelection();
                                        this.replaceSelection(text);
                                        range = this.selectedRange();
                                        range.start += range.length;
                                        range.length = 0;
                                        this.setSelectedRange(range);
                                    }
                                },
                                {
                                    key: 'moveUp',
                                    value: function moveUp(event) {
                                        this._handleEvent(event);
                                        this.setSelectedRange({
                                            start: 0,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'moveToBeginningOfParagraph',
                                    value: function moveToBeginningOfParagraph(event) {
                                        this.moveUp(event);
                                    }
                                },
                                {
                                    key: 'moveUpAndModifySelection',
                                    value: function moveUpAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                            case Affinity.NONE:
                                                // 12<34 56|78  =>  <1234 56|78
                                                range.length += range.start;
                                                range.start = 0;
                                                break;
                                            case Affinity.DOWNSTREAM:
                                                // 12|34 56>78   =>   <12|34 5678
                                                range.length = range.start;
                                                range.start = 0;
                                                break;
                                        }
                                        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
                                    }
                                },
                                {
                                    key: 'moveParagraphBackwardAndModifySelection',
                                    value: function moveParagraphBackwardAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                            case Affinity.NONE:
                                                // 12<34 56|78  =>  <1234 56|78
                                                range.length += range.start;
                                                range.start = 0;
                                                break;
                                            case Affinity.DOWNSTREAM:
                                                // 12|34 56>78  =>  12|34 5678
                                                range.length = 0;
                                                break;
                                        }
                                        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
                                    }
                                },
                                {
                                    key: 'moveToBeginningOfDocument',
                                    value: function moveToBeginningOfDocument(event) {
                                        // Since we only support a single line this is just an alias.
                                        this.moveToBeginningOfLine(event);
                                    }
                                },
                                {
                                    key: 'moveToBeginningOfDocumentAndModifySelection',
                                    value: function moveToBeginningOfDocumentAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        range.length += range.start;
                                        range.start = 0;
                                        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
                                    }
                                },
                                {
                                    key: 'moveDown',
                                    value: function moveDown(event) {
                                        this._handleEvent(event);
                                        // 12|34 56|78  =>  1234 5678|
                                        var range = {
                                            start: this.text().length,
                                            length: 0
                                        };
                                        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
                                    }
                                },
                                {
                                    key: 'moveToEndOfParagraph',
                                    value: function moveToEndOfParagraph(event) {
                                        this.moveDown(event);
                                    }
                                },
                                {
                                    key: 'moveDownAndModifySelection',
                                    value: function moveDownAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        var end = this.text().length;
                                        if (this.selectionAffinity === Affinity.UPSTREAM) range.start += range.length;
                                        range.length = end - range.start;
                                        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
                                    }
                                },
                                {
                                    key: 'moveParagraphForwardAndModifySelection',
                                    value: function moveParagraphForwardAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.DOWNSTREAM:
                                            case Affinity.NONE:
                                                // 12|34 56>78  =>  12|34 5678>
                                                range.length = this.text().length - range.start;
                                                break;
                                            case Affinity.UPSTREAM:
                                                // 12<34 56|78  =>  12|34 5678
                                                range.start += range.length;
                                                range.length = 0;
                                                break;
                                        }
                                        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
                                    }
                                },
                                {
                                    key: 'moveToEndOfDocument',
                                    value: function moveToEndOfDocument(event) {
                                        // Since we only support a single line this is just an alias.
                                        this.moveToEndOfLine(event);
                                    }
                                },
                                {
                                    key: 'moveToEndOfDocumentAndModifySelection',
                                    value: function moveToEndOfDocumentAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        range.length = this.text().length - range.start;
                                        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
                                    }
                                },
                                {
                                    key: 'moveLeft',
                                    value: function moveLeft(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        if (range.length !== 0) range.length = 0;
                                        else range.start--;
                                        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
                                    }
                                },
                                {
                                    key: 'moveLeftAndModifySelection',
                                    value: function moveLeftAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                            case Affinity.NONE:
                                                this.selectionAffinity = Affinity.UPSTREAM;
                                                range.start--;
                                                range.length++;
                                                break;
                                            case Affinity.DOWNSTREAM:
                                                range.length--;
                                                break;
                                        }
                                        this.setSelectedRange(range);
                                    }
                                },
                                {
                                    key: 'moveWordLeft',
                                    value: function moveWordLeft(event) {
                                        this._handleEvent(event);
                                        var index = this._lastWordBreakBeforeIndex(this.selectedRange().start - 1);
                                        this.setSelectedRange({
                                            start: index,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'moveWordLeftAndModifySelection',
                                    value: function moveWordLeftAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                            case Affinity.NONE:
                                                this.selectionAffinity = Affinity.UPSTREAM;
                                                var start = this._lastWordBreakBeforeIndex(range.start - 1);
                                                range.length += range.start - start;
                                                range.start = start;
                                                break;
                                            case Affinity.DOWNSTREAM:
                                                var end = this._lastWordBreakBeforeIndex(range.start + range.length);
                                                if (end < range.start) end = range.start;
                                                range.length -= range.start + range.length - end;
                                                break;
                                        }
                                        this.setSelectedRange(range);
                                    }
                                },
                                {
                                    key: 'moveToBeginningOfLine',
                                    value: function moveToBeginningOfLine(event) {
                                        this._handleEvent(event);
                                        this.setSelectedRange({
                                            start: 0,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'moveToBeginningOfLineAndModifySelection',
                                    value: function moveToBeginningOfLineAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        range.length += range.start;
                                        range.start = 0;
                                        this.setSelectedRangeWithAffinity(range, Affinity.UPSTREAM);
                                    }
                                },
                                {
                                    key: 'moveRight',
                                    value: function moveRight(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        if (range.length !== 0) {
                                            range.start += range.length;
                                            range.length = 0;
                                        } else range.start++;
                                        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
                                    }
                                },
                                {
                                    key: 'moveRightAndModifySelection',
                                    value: function moveRightAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                                range.start++;
                                                range.length--;
                                                break;
                                            case Affinity.DOWNSTREAM:
                                            case Affinity.NONE:
                                                this.selectionAffinity = Affinity.DOWNSTREAM;
                                                range.length++;
                                                break;
                                        }
                                        this.setSelectedRange(range);
                                    }
                                },
                                {
                                    key: 'moveWordRight',
                                    value: function moveWordRight(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        var index = this._nextWordBreakAfterIndex(range.start + range.length);
                                        this.setSelectedRange({
                                            start: index,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'moveWordRightAndModifySelection',
                                    value: function moveWordRightAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        var start = range.start;
                                        var end = range.start + range.length;
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                                start = Math.min(this._nextWordBreakAfterIndex(start), end);
                                                break;
                                            case Affinity.DOWNSTREAM:
                                            case Affinity.NONE:
                                                this.selectionAffinity = Affinity.DOWNSTREAM;
                                                end = this._nextWordBreakAfterIndex(range.start + range.length);
                                                break;
                                        }
                                        this.setSelectedRange({
                                            start: start,
                                            length: end - start
                                        });
                                    }
                                },
                                {
                                    key: 'moveToEndOfLine',
                                    value: function moveToEndOfLine(event) {
                                        this._handleEvent(event);
                                        this.setSelectedRange({
                                            start: this.text().length,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'moveToEndOfLineAndModifySelection',
                                    value: function moveToEndOfLineAndModifySelection(event) {
                                        this._handleEvent(event);
                                        var range = this.selectedRange();
                                        range.length = this.text().length - range.start;
                                        this.setSelectedRangeWithAffinity(range, Affinity.DOWNSTREAM);
                                    }
                                },
                                {
                                    key: 'replaceSelection',
                                    value: function replaceSelection(replacement) {
                                        var range = this.selectedRange();
                                        var end = range.start + range.length;
                                        var text = this.text();
                                        text = text.substring(0, range.start) + replacement + text.substring(end);
                                        range.length = replacement.length;
                                        this.setText(text);
                                        this.setSelectedRangeWithAffinity(range, Affinity.NONE);
                                    }
                                },
                                {
                                    key: 'rightWordBreakIndexes',
                                    value: function rightWordBreakIndexes() {
                                        var result = [];
                                        var text = this.text();
                                        for(var i = 0, l = text.length; i < l; i++)if (hasRightWordBreakAtIndex(text, i)) result.push(i + 1);
                                        return result;
                                    }
                                },
                                {
                                    key: 'selectAll',
                                    value: function selectAll(event) {
                                        this._handleEvent(event);
                                        this.setSelectedRangeWithAffinity({
                                            start: 0,
                                            length: this.text().length
                                        }, Affinity.NONE);
                                    }
                                },
                                {
                                    key: 'text',
                                    value: function text() {
                                        return this._value;
                                    }
                                },
                                {
                                    key: 'setText',
                                    value: function setText(value) {
                                        this._value = '' + value;
                                        this.setSelectedRange({
                                            start: this._value.length,
                                            length: 0
                                        });
                                    }
                                },
                                {
                                    key: 'selectedRange',
                                    value: function selectedRange() {
                                        return this._selectedRange;
                                    }
                                },
                                {
                                    key: 'setSelectedRange',
                                    value: function setSelectedRange(range) {
                                        this.setSelectedRangeWithAffinity(range, this.selectionAffinity);
                                    }
                                },
                                {
                                    key: 'setSelectedRangeWithAffinity',
                                    value: function setSelectedRangeWithAffinity(range, affinity) {
                                        var min = 0;
                                        var max = this.text().length;
                                        var caret = {
                                            start: Math.max(min, Math.min(max, range.start)),
                                            end: Math.max(min, Math.min(max, range.start + range.length))
                                        };
                                        this._selectedRange = {
                                            start: caret.start,
                                            length: caret.end - caret.start
                                        };
                                        this.selectionAffinity = range.length === 0 ? Affinity.NONE : affinity;
                                        return this._selectedRange;
                                    }
                                },
                                {
                                    key: 'selectionAnchor',
                                    value: function selectionAnchor() {
                                        var range = this.selectedRange();
                                        switch(this.selectionAffinity){
                                            case Affinity.UPSTREAM:
                                                return range.start + range.length;
                                            case Affinity.DOWNSTREAM:
                                                return range.start;
                                            default:
                                                return Affinity.NONE;
                                        }
                                    }
                                },
                                {
                                    key: '_buildKeybindings',
                                    value: function _buildKeybindings() {
                                        var osx;
                                        if (typeof navigator !== 'undefined') osx = /^Mozilla\/[\d\.]+ \(Macintosh/.test(navigator.userAgent);
                                        else if (typeof process !== 'undefined') osx = /darwin/.test(process.platform);
                                        this._bindings = keyBindingsForPlatform(osx ? 'OSX' : 'Default');
                                    }
                                },
                                {
                                    key: '_handleEvent',
                                    value: function _handleEvent(event) {
                                        if (event && this.shouldCancelEvents) event.preventDefault();
                                    }
                                },
                                {
                                    key: '_lastWordBreakBeforeIndex',
                                    value: function _lastWordBreakBeforeIndex(index) {
                                        var indexes = this._leftWordBreakIndexes();
                                        var result = indexes[0];
                                        for(var i = 0, l = indexes.length; i < l; i++){
                                            var wordBreakIndex = indexes[i];
                                            if (index > wordBreakIndex) result = wordBreakIndex;
                                            else break;
                                        }
                                        return result;
                                    }
                                },
                                {
                                    key: '_leftWordBreakIndexes',
                                    value: function _leftWordBreakIndexes() {
                                        var result = [];
                                        var text = this.text();
                                        for(var i = 0, l = text.length; i < l; i++)if (hasLeftWordBreakAtIndex(text, i)) result.push(i);
                                        return result;
                                    }
                                },
                                {
                                    key: '_nextWordBreakAfterIndex',
                                    value: function _nextWordBreakAfterIndex(index) {
                                        var indexes = this.rightWordBreakIndexes().reverse();
                                        var result = indexes[0];
                                        for(var i = 0, l = indexes.length; i < l; i++){
                                            var wordBreakIndex = indexes[i];
                                            if (index < wordBreakIndex) result = wordBreakIndex;
                                            else break;
                                        }
                                        return result;
                                    }
                                }
                            ]);
                            return Input;
                        }();
                        exports.Input = Input;
                        exports.KEYS = KEYS;
                        exports.keyBindingsForPlatform = keyBindingsForPlatform;
                    });
                }).call(this, _dereq_('_process'));
            },
            {
                "_process": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error('setTimeout has not been defined');
                }
                function defaultClearTimeout() {
                    throw new Error('clearTimeout has not been defined');
                }
                (function() {
                    try {
                        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = 'browser';
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ''; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error('process.binding is not supported');
                };
                process.cwd = function() {
                    return '/';
                };
                process.chdir = function(dir) {
                    throw new Error('process.chdir is not supported');
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global, factory) {
                    if (typeof define === 'function' && define.amd) define('stround', [
                        'exports'
                    ], factory);
                    else if (typeof exports !== 'undefined') factory(exports);
                    else {
                        var mod = {
                            exports: {}
                        };
                        factory(mod.exports);
                        global.stround = mod.exports;
                    }
                })(this, function(exports) {
                    /* jshint sub:true, esnext:true, undef:true, unused:true */ /**
   * Enum for the available rounding modes.
   *
   * @enum {number}
   */ 'use strict';
                    Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                    var _slicedToArray = function() {
                        function sliceIterator(arr, i) {
                            var _arr = [];
                            var _n = true;
                            var _d = false;
                            var _e = undefined;
                            try {
                                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                                    _arr.push(_s.value);
                                    if (i && _arr.length === i) break;
                                }
                            } catch (err) {
                                _d = true;
                                _e = err;
                            } finally{
                                try {
                                    if (!_n && _i['return']) _i['return']();
                                } finally{
                                    if (_d) throw _e;
                                }
                            }
                            return _arr;
                        }
                        return function(arr, i) {
                            if (Array.isArray(arr)) return arr;
                            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                            else throw new TypeError('Invalid attempt to destructure non-iterable instance');
                        };
                    }();
                    exports.parse = parse;
                    exports.format = format;
                    exports.shiftParts = shiftParts;
                    exports.shift = shift;
                    exports.round = round;
                    var modes = {
                        CEILING: 0,
                        FLOOR: 1,
                        DOWN: 2,
                        UP: 3,
                        HALF_EVEN: 4,
                        HALF_DOWN: 5,
                        HALF_UP: 6
                    };
                    exports.modes = modes;
                    /**
   * @const
   * @private
   */ var NEG = '-';
                    /**
   * @const
   * @private
   */ var SEP = '.';
                    /**
   * @const
   * @private
   */ var NEG_PATTERN = '-';
                    /**
   * @const
   * @private
   */ var SEP_PATTERN = '\\.';
                    /**
   * @const
   * @private
   */ var NUMBER_PATTERN = new RegExp('^(' + NEG_PATTERN + ')?(\\d*)(?:' + SEP_PATTERN + '(\\d*))?$');
                    /**
   * Increments the given integer represented by a string by one.
   *
   * @example
   *
   *   increment('1');  // '2'
   *   increment('99'); // '100'
   *   increment('');   // '1'
   *
   * @param {string} strint
   * @return {string}
   * @private
   */ function increment(strint) {
                        var length = strint.length;
                        if (length === 0) return '1';
                        var last = parseInt(strint[length - 1], 10);
                        if (last === 9) return increment(strint.slice(0, length - 1)) + '0';
                        else return strint.slice(0, length - 1) + (last + 1);
                    }
                    /**
   * Parses the given decimal string into its component parts.
   *
   * @example
   *
   *   stround.parse('3.14');  // [false, '3', '14']
   *   stround.parse('-3.45'); // [true, '3', '45']
   *
   * @param {string} strnum
   * @return {?Array}
   */ function parse(strnum) {
                        switch(strnum){
                            case 'NaN':
                            case 'Infinity':
                            case '-Infinity':
                                return null;
                        }
                        var match = strnum.match(NUMBER_PATTERN);
                        if (!match) throw new Error('cannot round malformed number: ' + strnum);
                        return [
                            match[1] !== undefined,
                            match[2],
                            match[3] || ''
                        ];
                    }
                    /**
   * Format the given number configuration as a number string.
   *
   * @example
   *
   *   stround.format([false, '12', '34']); // '12.34'
   *   stround.format([true, '8', '']);     // '-8'
   *   stround.format([true, '', '7']);     // '-0.7'
   *
   * @param {Array} parts
   * @return {string}
   */ function format(_ref) {
                        var _ref2 = _slicedToArray(_ref, 3);
                        var negative = _ref2[0];
                        var intPart = _ref2[1];
                        var fracPart = _ref2[2];
                        if (intPart.length === 0) intPart = '0';
                        else {
                            var firstNonZeroIndex = undefined;
                            for(firstNonZeroIndex = 0; firstNonZeroIndex < intPart.length; firstNonZeroIndex++){
                                if (intPart[firstNonZeroIndex] !== '0') break;
                            }
                            if (firstNonZeroIndex !== intPart.length) intPart = intPart.slice(firstNonZeroIndex);
                        }
                        return (negative ? NEG + intPart : intPart) + (fracPart.length ? SEP + fracPart : '');
                    }
                    /**
   * Shift the exponent of the given number (in parts) by the given amount.
   *
   * @example
   *
   *   stround.shiftParts([false, '12', ''], 2);  // [false, '1200', '']
   *   stround.shiftParts([false, '12', ''], -2); // [false, '', '12']
   *
   * @param {Array} parts
   * @param {number} exponent
   * @return {Array}
   */ function shiftParts(_ref3, exponent) {
                        var _ref32 = _slicedToArray(_ref3, 3);
                        var negative = _ref32[0];
                        var intPart = _ref32[1];
                        var fracPart = _ref32[2];
                        var partToMove = undefined;
                        if (exponent > 0) {
                            partToMove = fracPart.slice(0, exponent);
                            while(partToMove.length < exponent)partToMove += '0';
                            intPart += partToMove;
                            fracPart = fracPart.slice(exponent);
                        } else if (exponent < 0) {
                            while(intPart.length < -exponent)intPart = '0' + intPart;
                            partToMove = intPart.slice(intPart.length + exponent);
                            fracPart = partToMove + fracPart;
                            intPart = intPart.slice(0, intPart.length - partToMove.length);
                        }
                        return [
                            negative,
                            intPart,
                            fracPart
                        ];
                    }
                    /**
   * Shift the exponent of the given number (as a string) by the given amount.
   *
   *   shift('12', 2);  // '1200'
   *   shift('12', -2); // '0.12'
   *
   * @param {string|number} strnum
   * @param {number} exponent
   * @return {string}
   */ function shift(strnum, exponent) {
                        if (typeof strnum === 'number') strnum = '' + strnum;
                        var parsed = parse(strnum);
                        if (parsed === null) return strnum;
                        else return format(shiftParts(parsed, exponent));
                    }
                    /**
   * Round the given number represented by a string according to the given
   * precision and mode.
   *
   * @param {string|number} strnum
   * @param {number|null|undefined=} precision
   * @param {modes=} mode
   * @return {string}
   */ function round(strnum, precision, mode) {
                        if (typeof strnum === 'number') strnum = '' + strnum;
                        if (typeof strnum !== 'string') throw new Error('expected a string or number, got: ' + strnum);
                        if (strnum.length === 0) return strnum;
                        if (precision === null || precision === undefined) precision = 0;
                        if (mode === undefined) mode = modes.HALF_EVEN;
                        var parsed = parse(strnum);
                        if (parsed === null) return strnum;
                        if (precision > 0) parsed = shiftParts(parsed, precision);
                        var _parsed = parsed;
                        var _parsed2 = _slicedToArray(_parsed, 3);
                        var negative = _parsed2[0];
                        var intPart = _parsed2[1];
                        var fracPart = _parsed2[2];
                        switch(mode){
                            case modes.CEILING:
                            case modes.FLOOR:
                            case modes.UP:
                                var foundNonZeroDigit = false;
                                for(var i = 0, _length = fracPart.length; i < _length; i++)if (fracPart[i] !== '0') {
                                    foundNonZeroDigit = true;
                                    break;
                                }
                                if (foundNonZeroDigit) {
                                    if (mode === modes.UP || negative !== (mode === modes.CEILING)) intPart = increment(intPart);
                                }
                                break;
                            case modes.HALF_EVEN:
                            case modes.HALF_DOWN:
                            case modes.HALF_UP:
                                var shouldRoundUp = false;
                                var firstFracPartDigit = parseInt(fracPart[0], 10);
                                if (firstFracPartDigit > 5) shouldRoundUp = true;
                                else if (firstFracPartDigit === 5) {
                                    if (mode === modes.HALF_UP) shouldRoundUp = true;
                                    if (!shouldRoundUp) {
                                        for(var i = 1, _length2 = fracPart.length; i < _length2; i++)if (fracPart[i] !== '0') {
                                            shouldRoundUp = true;
                                            break;
                                        }
                                    }
                                    if (!shouldRoundUp && mode === modes.HALF_EVEN) {
                                        var lastIntPartDigit = parseInt(intPart[intPart.length - 1], 10);
                                        shouldRoundUp = lastIntPartDigit % 2 !== 0;
                                    }
                                }
                                if (shouldRoundUp) intPart = increment(intPart);
                                break;
                        }
                        return format(shiftParts([
                            negative,
                            intPart,
                            ''
                        ], -precision));
                    }
                });
            },
            {}
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                var _amex_card_formatter = _dereq_('./amex_card_formatter');
                var _amex_card_formatter2 = _interopRequireDefault(_amex_card_formatter);
                var _default_card_formatter = _dereq_('./default_card_formatter');
                var _default_card_formatter2 = _interopRequireDefault(_default_card_formatter);
                var _card_utils = _dereq_('./card_utils');
                /**
 * AdaptiveCardFormatter will decide if it needs to use
 * {@link AmexCardFormatter} or {@link DefaultCardFormatter}.
 */ var AdaptiveCardFormatter = function() {
                    function AdaptiveCardFormatter() {
                        _classCallCheck(this, AdaptiveCardFormatter);
                        /** @private */ this.amexCardFormatter = new _amex_card_formatter2['default']();
                        /** @private */ this.defaultCardFormatter = new _default_card_formatter2['default']();
                        /** @private */ this.formatter = this.defaultCardFormatter;
                    }
                    /**
   * Will pick the right formatter based on the `pan` and will return the
   * formatted string.
   *
   * @param {string} pan
   * @returns {string} formatted string
   */ _createClass(AdaptiveCardFormatter, [
                        {
                            key: 'format',
                            value: function format(pan) {
                                return this._formatterForPan(pan).format(pan);
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text, error) {
                                return this.formatter.parse(text, error);
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                this.formatter = this._formatterForPan(change.proposed.text);
                                return this.formatter.isChangeValid(change, error);
                            }
                        },
                        {
                            key: '_formatterForPan',
                            value: function _formatterForPan(pan) {
                                if ((0, _card_utils.determineCardType)(pan.replace(/[^\d]+/g, '')) === _card_utils.AMEX) return this.amexCardFormatter;
                                else return this.defaultCardFormatter;
                            }
                        }
                    ]);
                    return AdaptiveCardFormatter;
                }();
                exports['default'] = AdaptiveCardFormatter;
                module1.exports = exports['default'];
            },
            {
                "./amex_card_formatter": 5,
                "./card_utils": 7,
                "./default_card_formatter": 9
            }
        ],
        5: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _default_card_formatter = _dereq_('./default_card_formatter');
                var _default_card_formatter2 = _interopRequireDefault(_default_card_formatter);
                /**
 * Amex credit card formatter.
 *
 * @extends DefaultCardFormatter
 */ var AmexCardFormatter = function(_DefaultCardFormatter) {
                    _inherits(AmexCardFormatter, _DefaultCardFormatter);
                    function AmexCardFormatter() {
                        _classCallCheck(this, AmexCardFormatter);
                        _get(Object.getPrototypeOf(AmexCardFormatter.prototype), 'constructor', this).apply(this, arguments);
                    }
                    _createClass(AmexCardFormatter, [
                        {
                            key: 'hasDelimiterAtIndex',
                            /**
     * @override
     */ value: function hasDelimiterAtIndex(index) {
                                return index === 4 || index === 11;
                            }
                        },
                        {
                            key: 'maximumLength',
                            get: function get() {
                                return 17;
                            }
                        }
                    ]);
                    return AmexCardFormatter;
                }(_default_card_formatter2['default']);
                exports['default'] = AmexCardFormatter;
                module1.exports = exports['default'];
            },
            {
                "./default_card_formatter": 9
            }
        ],
        6: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _text_field = _dereq_('./text_field');
                var _text_field2 = _interopRequireDefault(_text_field);
                var _adaptive_card_formatter = _dereq_('./adaptive_card_formatter');
                var _adaptive_card_formatter2 = _interopRequireDefault(_adaptive_card_formatter);
                var _card_utils = _dereq_('./card_utils');
                /**
 * Enum for card mask strategies.
 *
 * @readonly
 * @enum {number}
 * @private
 */ var CardMaskStrategy = {
                    None: 'None',
                    DoneEditing: 'DoneEditing'
                };
                /**
 * CardTextField add some functionality for credit card inputs
 *
 * @extends TextField
 */ var CardTextField = function(_TextField) {
                    _inherits(CardTextField, _TextField);
                    /**
   * @param {HTMLElement} element
   */ function CardTextField(element) {
                        _classCallCheck(this, CardTextField);
                        _get(Object.getPrototypeOf(CardTextField.prototype), 'constructor', this).call(this, element, new _adaptive_card_formatter2['default']());
                        this.setCardMaskStrategy(CardMaskStrategy.None);
                        /**
     * Whether we are currently masking the displayed text.
     *
     * @private
     */ this._masked = false;
                        /**
     * Whether we are currently editing.
     *
     * @private
     */ this._editing = false;
                    }
                    /**
   * Gets the card type for the current value.
   *
   * @returns {string} Returns one of 'visa', 'mastercard', 'amex' and 'discover'.
   */ _createClass(CardTextField, [
                        {
                            key: 'cardType',
                            value: function cardType() {
                                return (0, _card_utils.determineCardType)(this.value());
                            }
                        },
                        {
                            key: 'cardMaskStrategy',
                            value: function cardMaskStrategy() {
                                return this._cardMaskStrategy;
                            }
                        },
                        {
                            key: 'setCardMaskStrategy',
                            value: function setCardMaskStrategy(cardMaskStrategy) {
                                if (cardMaskStrategy !== this._cardMaskStrategy) {
                                    this._cardMaskStrategy = cardMaskStrategy;
                                    this._syncMask();
                                }
                            }
                        },
                        {
                            key: 'cardMask',
                            value: function cardMask() {
                                var text = this.text();
                                var last4 = text.slice(-4);
                                var toMask = text.slice(0, -4);
                                return toMask.replace(/\d/g, "\u2022") + last4;
                            }
                        },
                        {
                            key: 'text',
                            value: function text() {
                                if (this._masked) return this._unmaskedText;
                                else return _get(Object.getPrototypeOf(CardTextField.prototype), 'text', this).call(this);
                            }
                        },
                        {
                            key: 'setText',
                            value: function setText(text) {
                                if (this._masked) {
                                    this._unmaskedText = text;
                                    text = this.cardMask();
                                }
                                _get(Object.getPrototypeOf(CardTextField.prototype), 'setText', this).call(this, text);
                            }
                        },
                        {
                            key: 'textFieldDidEndEditing',
                            value: function textFieldDidEndEditing() {
                                this._editing = false;
                                this._syncMask();
                            }
                        },
                        {
                            key: 'textFieldDidBeginEditing',
                            value: function textFieldDidBeginEditing() {
                                this._editing = true;
                                this._syncMask();
                            }
                        },
                        {
                            key: '_enableMasking',
                            value: function _enableMasking() {
                                if (!this._masked) {
                                    this._unmaskedText = this.text();
                                    this._masked = true;
                                    this.setText(this._unmaskedText);
                                }
                            }
                        },
                        {
                            key: '_disableMasking',
                            value: function _disableMasking() {
                                if (this._masked) {
                                    this._masked = false;
                                    this.setText(this._unmaskedText);
                                    this._unmaskedText = null;
                                }
                            }
                        },
                        {
                            key: '_syncMask',
                            value: function _syncMask() {
                                if (this.cardMaskStrategy() === CardMaskStrategy.DoneEditing) {
                                    if (this._editing) this._disableMasking();
                                    else this._enableMasking();
                                }
                            }
                        }
                    ], [
                        {
                            key: 'CardMaskStrategy',
                            get: function get() {
                                return CardMaskStrategy;
                            }
                        }
                    ]);
                    return CardTextField;
                }(_text_field2['default']);
                exports['default'] = CardTextField;
                module1.exports = exports['default'];
            },
            {
                "./adaptive_card_formatter": 4,
                "./card_utils": 7,
                "./text_field": 20
            }
        ],
        7: [
            function(_dereq_, module1, exports) {
                /**
 * @TODO Make this an enum
 */ 'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                exports.determineCardType = determineCardType;
                exports.luhnCheck = luhnCheck;
                exports.validCardLength = validCardLength;
                var AMEX = 'amex';
                exports.AMEX = AMEX;
                var DISCOVER = 'discover';
                exports.DISCOVER = DISCOVER;
                var JCB = 'jcb';
                exports.JCB = JCB;
                var MASTERCARD = 'mastercard';
                exports.MASTERCARD = MASTERCARD;
                var VISA = 'visa';
                exports.VISA = VISA;
                /**
 * Pass in a credit card number and it'll return the
 * type of card it is.
 *
 * @param {string} pan
 * @returns {?string} returns the type of card based in the digits
 */ function determineCardType(pan) {
                    if (pan === null || pan === undefined) return null;
                    pan = pan.toString();
                    var firsttwo = parseInt(pan.slice(0, 2), 10);
                    var iin = parseInt(pan.slice(0, 6), 10);
                    var halfiin = parseInt(pan.slice(0, 3), 10);
                    if (pan[0] === '4') return VISA;
                    else if (pan.slice(0, 4) === '6011' || firsttwo === 65 || halfiin >= 664 && halfiin <= 649 || iin >= 622126 && iin <= 622925) return DISCOVER;
                    else if (pan.slice(0, 4) === '2131' || pan.slice(0, 4) === '1800' || firsttwo === 35) return JCB;
                    else if (firsttwo >= 51 && firsttwo <= 55) return MASTERCARD;
                    else if (firsttwo === 34 || firsttwo === 37) return AMEX;
                }
                /**
 * Pass in a credit card number and it'll return if it
 * passes the [luhn algorithm](http://en.wikipedia.org/wiki/Luhn_algorithm)
 *
 * @param {string} pan
 * @returns {boolean}
 */ function luhnCheck(pan) {
                    var sum = 0;
                    var flip = true;
                    for(var i = pan.length - 1; i >= 0; i--){
                        var digit = parseInt(pan.charAt(i), 10);
                        sum += (flip = !flip) ? Math.floor(digit * 2 / 10) + Math.floor(digit * 2 % 10) : digit;
                    }
                    return sum % 10 === 0;
                }
                /**
 * Pass in a credit card number and it'll return if it
 * is a valid length for that type. If it doesn't know the
 * type it'll return false
 *
 * @param {string} pan
 * @returns {boolean}
 */ function validCardLength(pan) {
                    switch(determineCardType(pan)){
                        case VISA:
                            return pan.length === 13 || pan.length === 16;
                        case DISCOVER:
                        case MASTERCARD:
                            return pan.length === 16;
                        case JCB:
                            return pan.length === 15 || pan.length === 16;
                        case AMEX:
                            return pan.length === 15;
                        default:
                            return false;
                    }
                }
            },
            {}
        ],
        8: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                exports['default'] = installCaret;
                function installCaret() {
                    var _document = arguments.length <= 0 || arguments[0] === undefined ? document : arguments[0];
                    var getCaret = undefined;
                    var setCaret = undefined;
                    if (!_document) throw new Error('Caret does not have access to document');
                    else if ('selectionStart' in _document.createElement('input')) {
                        getCaret = function(element) {
                            return {
                                start: element.selectionStart,
                                end: element.selectionEnd
                            };
                        };
                        setCaret = function(element, start, end) {
                            element.selectionStart = start;
                            element.selectionEnd = end;
                        };
                    } else if (_document.selection) {
                        getCaret = function(element) {
                            var selection = _document.selection;
                            var value = element.value;
                            var range = selection.createRange().duplicate();
                            range.moveEnd('character', value.length);
                            var start = range.text === '' ? value.length : value.lastIndexOf(range.text);
                            range = selection.createRange().duplicate();
                            range.moveStart('character', -value.length);
                            var end = range.text.length;
                            return {
                                start: start,
                                end: end
                            };
                        };
                        setCaret = function(element, start, end) {
                            var range = element.createTextRange();
                            range.collapse(true);
                            range.moveStart('character', start);
                            range.moveEnd('character', end - start);
                            range.select();
                        };
                    } else throw new Error('Caret unknown input selection capabilities');
                    return {
                        getCaret: getCaret,
                        setCaret: setCaret
                    };
                }
                module1.exports = exports['default'];
            },
            {}
        ],
        9: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                var _card_utils = _dereq_('./card_utils');
                /**
 * A generic credit card formatter.
 *
 * @extends DelimitedTextFormatter
 */ var DefaultCardFormatter = function(_DelimitedTextFormatter) {
                    _inherits(DefaultCardFormatter, _DelimitedTextFormatter);
                    function DefaultCardFormatter() {
                        _classCallCheck(this, DefaultCardFormatter);
                        _get(Object.getPrototypeOf(DefaultCardFormatter.prototype), 'constructor', this).call(this, ' ');
                    }
                    /**
   * @param {number} index
   * @returns {boolean}
   */ _createClass(DefaultCardFormatter, [
                        {
                            key: 'hasDelimiterAtIndex',
                            value: function hasDelimiterAtIndex(index) {
                                return index === 4 || index === 9 || index === 14;
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text, error) {
                                var value = this._valueFromText(text);
                                if (typeof error === 'function') {
                                    if (!(0, _card_utils.validCardLength)(value)) error('card-formatter.number-too-short');
                                    if (!(0, _card_utils.luhnCheck)(value)) error('card-formatter.invalid-number');
                                }
                                return _get(Object.getPrototypeOf(DefaultCardFormatter.prototype), 'parse', this).call(this, text, error);
                            }
                        },
                        {
                            key: '_valueFromText',
                            value: function _valueFromText(text) {
                                return _get(Object.getPrototypeOf(DefaultCardFormatter.prototype), '_valueFromText', this).call(this, (text || '').replace(/[^\d]/g, ''));
                            }
                        },
                        {
                            key: 'maximumLength',
                            get: function get() {
                                return 19;
                            }
                        }
                    ]);
                    return DefaultCardFormatter;
                }(_delimited_text_formatter2['default']);
                exports['default'] = DefaultCardFormatter;
                module1.exports = exports['default'];
            },
            {
                "./card_utils": 7,
                "./delimited_text_formatter": 10
            }
        ],
        10: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x2, _x3, _x4) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x2, property = _x3, receiver = _x4;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x2 = parent;
                                _x3 = property;
                                _x4 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _formatter = _dereq_('./formatter');
                var _formatter2 = _interopRequireDefault(_formatter);
                /**
 * A generic delimited formatter.
 *
 * @extends Formatter
 */ var DelimitedTextFormatter = function(_Formatter) {
                    _inherits(DelimitedTextFormatter, _Formatter);
                    /**
   * @param {string=} delimiter
   * @param {boolean=} isLazy
   * @throws {Error} delimiter must have just one character
   */ function DelimitedTextFormatter(delimiter) {
                        var isLazy = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
                        _classCallCheck(this, DelimitedTextFormatter);
                        _get(Object.getPrototypeOf(DelimitedTextFormatter.prototype), 'constructor', this).call(this);
                        if (arguments.length === 0) return;
                        if (delimiter === null || delimiter === undefined || delimiter.length !== 1) throw new Error('delimiter must have just one character');
                        this.delimiter = delimiter;
                        // If the formatter is lazy, delimiter will not be added until input has gone
                        // past the delimiter index. Useful for 'optional' extension, like zip codes.
                        // 94103  ->  type '1'  ->  94103-1
                        this.isLazy = isLazy;
                    }
                    /**
   * Determines the delimiter character at the given index.
   *
   * @param {number} index
   * @returns {?string}
   */ _createClass(DelimitedTextFormatter, [
                        {
                            key: 'delimiterAt',
                            value: function delimiterAt(index) {
                                if (!this.hasDelimiterAtIndex(index)) return null;
                                return this.delimiter;
                            }
                        },
                        {
                            key: 'isDelimiter',
                            value: function isDelimiter(chr) {
                                return chr === this.delimiter;
                            }
                        },
                        {
                            key: 'format',
                            value: function format(value) {
                                return this._textFromValue(value);
                            }
                        },
                        {
                            key: '_textFromValue',
                            value: function _textFromValue(value) {
                                if (!value) return '';
                                var result = '';
                                var delimiter = undefined;
                                var maximumLength = this.maximumLength;
                                for(var i = 0, l = value.length; i < l; i++){
                                    while(delimiter = this.delimiterAt(result.length))result += delimiter;
                                    result += value[i];
                                    if (!this.isLazy) while(delimiter = this.delimiterAt(result.length))result += delimiter;
                                }
                                if (maximumLength !== undefined && maximumLength !== null) return result.slice(0, maximumLength);
                                else return result;
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text) {
                                return this._valueFromText(text);
                            }
                        },
                        {
                            key: '_valueFromText',
                            value: function _valueFromText(text) {
                                if (!text) return '';
                                var result = '';
                                for(var i = 0, l = text.length; i < l; i++)if (!this.isDelimiter(text[i])) result += text[i];
                                return result;
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                if (!_get(Object.getPrototypeOf(DelimitedTextFormatter.prototype), 'isChangeValid', this).call(this, change, error)) return false;
                                var newText = change.proposed.text;
                                var range = change.proposed.selectedRange;
                                var hasSelection = range.length !== 0;
                                var startMovedLeft = range.start < change.current.selectedRange.start;
                                var startMovedRight = range.start > change.current.selectedRange.start;
                                var endMovedLeft = range.start + range.length < change.current.selectedRange.start + change.current.selectedRange.length;
                                var endMovedRight = range.start + range.length > change.current.selectedRange.start + change.current.selectedRange.length;
                                var startMovedOverADelimiter = startMovedLeft && this.hasDelimiterAtIndex(range.start) || startMovedRight && this.hasDelimiterAtIndex(range.start - 1);
                                var endMovedOverADelimiter = endMovedLeft && this.hasDelimiterAtIndex(range.start + range.length) || endMovedRight && this.hasDelimiterAtIndex(range.start + range.length - 1);
                                if (this.isDelimiter(change.deleted.text)) {
                                    var newCursorPosition = change.deleted.start - 1;
                                    // delete any immediately preceding delimiters
                                    while(this.isDelimiter(newText.charAt(newCursorPosition))){
                                        newText = newText.substring(0, newCursorPosition) + newText.substring(newCursorPosition + 1);
                                        newCursorPosition--;
                                    }
                                    // finally delete the real character that was intended
                                    newText = newText.substring(0, newCursorPosition) + newText.substring(newCursorPosition + 1);
                                }
                                // adjust the cursor / selection
                                if (startMovedLeft && startMovedOverADelimiter) {
                                    // move left over any immediately preceding delimiters
                                    while(this.delimiterAt(range.start - 1)){
                                        range.start--;
                                        range.length++;
                                    }
                                    // finally move left over the real intended character
                                    range.start--;
                                    range.length++;
                                }
                                if (startMovedRight) {
                                    // move right over any delimiters found on the way, including any leading delimiters
                                    for(var i = change.current.selectedRange.start; i < range.start + range.length; i++)if (this.delimiterAt(i)) {
                                        range.start++;
                                        if (range.length > 0) range.length--;
                                    }
                                    while(this.delimiterAt(range.start)){
                                        range.start++;
                                        range.length--;
                                    }
                                }
                                if (hasSelection) {
                                    // Otherwise, the logic for the range start takes care of everything.
                                    if (endMovedOverADelimiter) {
                                        if (endMovedLeft) {
                                            // move left over any immediately preceding delimiters
                                            while(this.delimiterAt(range.start + range.length - 1))range.length--;
                                            // finally move left over the real intended character
                                            range.length--;
                                        }
                                        if (endMovedRight) {
                                            // move right over any immediately following delimiters
                                            while(this.delimiterAt(range.start + range.length))range.length++;
                                            // finally move right over the real intended character
                                            range.length++;
                                        }
                                    }
                                    // trailing delimiters in the selection
                                    while(this.hasDelimiterAtIndex(range.start + range.length - 1))if (startMovedLeft || endMovedLeft) range.length--;
                                    else range.length++;
                                    while(this.hasDelimiterAtIndex(range.start))if (startMovedRight || endMovedRight) {
                                        range.start++;
                                        range.length--;
                                    } else {
                                        range.start--;
                                        range.length++;
                                    }
                                } else range.length = 0;
                                var result = true;
                                var value = this._valueFromText(newText, function() {
                                    result = false;
                                    error.apply(undefined, arguments);
                                });
                                if (result) change.proposed.text = this._textFromValue(value);
                                return result;
                            }
                        }
                    ]);
                    return DelimitedTextFormatter;
                }(_formatter2['default']);
                exports['default'] = DelimitedTextFormatter;
                module1.exports = exports['default'];
            },
            {
                "./formatter": 14
            }
        ],
        11: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                /**
 * @const
 * @private
 */ var DIGITS_PATTERN = /^\d*$/;
                /**
 * @extends DelimitedTextFormatter
 */ var EmployerIdentificationNumberFormatter = function(_DelimitedTextFormatter) {
                    _inherits(EmployerIdentificationNumberFormatter, _DelimitedTextFormatter);
                    function EmployerIdentificationNumberFormatter() {
                        _classCallCheck(this, EmployerIdentificationNumberFormatter);
                        _get(Object.getPrototypeOf(EmployerIdentificationNumberFormatter.prototype), 'constructor', this).call(this, '-');
                        this.maximumLength = 10;
                    }
                    /**
   * @param {number} index
   * @returns {boolean}
   */ _createClass(EmployerIdentificationNumberFormatter, [
                        {
                            key: 'hasDelimiterAtIndex',
                            value: function hasDelimiterAtIndex(index) {
                                return index === 2;
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                if (DIGITS_PATTERN.test(change.inserted.text)) return _get(Object.getPrototypeOf(EmployerIdentificationNumberFormatter.prototype), 'isChangeValid', this).call(this, change, error);
                                else return false;
                            }
                        }
                    ]);
                    return EmployerIdentificationNumberFormatter;
                }(_delimited_text_formatter2['default']);
                exports['default'] = EmployerIdentificationNumberFormatter;
                module1.exports = exports['default'];
            },
            {
                "./delimited_text_formatter": 10
            }
        ],
        12: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _text_field = _dereq_('./text_field');
                var _text_field2 = _interopRequireDefault(_text_field);
                var _expiry_date_formatter = _dereq_('./expiry_date_formatter');
                var _expiry_date_formatter2 = _interopRequireDefault(_expiry_date_formatter);
                /**
 * Adds a default formatter for expiration dates.
 *
 * @extends TextField
 */ var ExpiryDateField = function(_TextField) {
                    _inherits(ExpiryDateField, _TextField);
                    /**
   * @param {HTMLElement} element
   */ function ExpiryDateField(element) {
                        _classCallCheck(this, ExpiryDateField);
                        _get(Object.getPrototypeOf(ExpiryDateField.prototype), 'constructor', this).call(this, element, new _expiry_date_formatter2['default']());
                    }
                    /**
   * Called by our superclass, used to post-process the text.
   *
   * @private
   */ _createClass(ExpiryDateField, [
                        {
                            key: 'textFieldDidEndEditing',
                            value: function textFieldDidEndEditing() {
                                var value = this.value();
                                if (value) this.setText(this.formatter().format(value));
                            }
                        }
                    ]);
                    return ExpiryDateField;
                }(_text_field2['default']);
                exports['default'] = ExpiryDateField;
                module1.exports = exports['default'];
            },
            {
                "./expiry_date_formatter": 13,
                "./text_field": 20
            }
        ],
        13: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                var _utils = _dereq_('./utils');
                /**
 * Give this function a 2 digit year it'll return with 4.
 *
 * @example
 *     interpretTwoDigitYear(15);
 *     // => 2015
 *     interpretTwoDigitYear(97);
 *     // => 1997
 * @param {number} year
 * @returns {number}
 * @private
 */ function interpretTwoDigitYear(year) {
                    var thisYear = new Date().getFullYear();
                    var thisCentury = thisYear - thisYear % 100;
                    var centuries = [
                        thisCentury,
                        thisCentury - 100,
                        thisCentury + 100
                    ].sort(function(a, b) {
                        return Math.abs(thisYear - (year + a)) - Math.abs(thisYear - (year + b));
                    });
                    return year + centuries[0];
                }
                /**
 * @extends DelimitedTextFormatter
 */ var ExpiryDateFormatter = function(_DelimitedTextFormatter) {
                    _inherits(ExpiryDateFormatter, _DelimitedTextFormatter);
                    function ExpiryDateFormatter() {
                        _classCallCheck(this, ExpiryDateFormatter);
                        _get(Object.getPrototypeOf(ExpiryDateFormatter.prototype), 'constructor', this).call(this, '/');
                        this.maximumLength = 5;
                    }
                    /**
   * @param {number} index
   * @returns {boolean}
   */ _createClass(ExpiryDateFormatter, [
                        {
                            key: 'hasDelimiterAtIndex',
                            value: function hasDelimiterAtIndex(index) {
                                return index === 2;
                            }
                        },
                        {
                            key: 'format',
                            value: function format(value) {
                                if (!value) return '';
                                var month = value.month;
                                var year = value.year;
                                year = year % 100;
                                return _get(Object.getPrototypeOf(ExpiryDateFormatter.prototype), 'format', this).call(this, (0, _utils.zpad2)(month) + (0, _utils.zpad2)(year));
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text, error) {
                                var monthAndYear = text.split(this.delimiter);
                                var month = monthAndYear[0];
                                var year = monthAndYear[1];
                                if (month && month.match(/^(0?[1-9]|1\d)$/) && year && year.match(/^\d\d?$/)) {
                                    month = Number(month);
                                    year = interpretTwoDigitYear(Number(year));
                                    return {
                                        month: month,
                                        year: year
                                    };
                                } else {
                                    if (typeof error === 'function') error('expiry-date-formatter.invalid-date');
                                    return null;
                                }
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                if (!error) error = function() {};
                                var isBackspace = change.proposed.text.length < change.current.text.length;
                                var newText = change.proposed.text;
                                if (change.inserted.text === this.delimiter && change.current.text === '1') newText = '01' + this.delimiter;
                                else if (change.inserted.text.length > 0 && !/^\d$/.test(change.inserted.text)) {
                                    error('expiry-date-formatter.only-digits-allowed');
                                    return false;
                                } else {
                                    if (isBackspace) {
                                        if (change.deleted.text === this.delimiter) newText = newText[0];
                                        if (newText === '0') newText = '';
                                        if (change.inserted.text.length > 0 && !/^\d$/.test(change.inserted.text)) {
                                            error('expiry-date-formatter.only-digits-allowed');
                                            return false;
                                        }
                                    }
                                    // 4| -> 04|
                                    if (/^[2-9]$/.test(newText)) newText = '0' + newText;
                                    // 1|1|/5 -> 11|/5
                                    if (/^1[3-9].+$/.test(newText)) {
                                        error('expiry-date-formatter.invalid-month');
                                        return false;
                                    }
                                    // 15| -> 01/5|
                                    if (/^1[3-9]$/.test(newText)) newText = '01' + this.delimiter + newText.slice(-1);
                                    // Don't allow 00
                                    if (newText === '00') {
                                        error('expiry-date-formatter.invalid-month');
                                        return false;
                                    }
                                    // 11| -> 11/
                                    if (/^(0[1-9]|1[0-2])$/.test(newText)) newText += this.delimiter;
                                    var match = newText.match(/^(\d\d)(.)(\d\d?).*$/);
                                    if (match && match[2] === this.delimiter) newText = match[1] + this.delimiter + match[3];
                                }
                                change.proposed.text = newText;
                                change.proposed.selectedRange = {
                                    start: newText.length,
                                    length: 0
                                };
                                return true;
                            }
                        }
                    ]);
                    return ExpiryDateFormatter;
                }(_delimited_text_formatter2['default']);
                exports['default'] = ExpiryDateFormatter;
                module1.exports = exports['default'];
            },
            {
                "./delimited_text_formatter": 10,
                "./utils": 22
            }
        ],
        14: [
            function(_dereq_, module1, exports) {
                /**
 * Base class providing basic formatting, parsing, and change validation to be
 * customized in subclasses.
 */ 'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                var Formatter = function() {
                    function Formatter() {
                        _classCallCheck(this, Formatter);
                    }
                    _createClass(Formatter, [
                        {
                            key: 'format',
                            /**
     * @param {string} text
     * @returns {string}
     */ value: function format(text) {
                                if (text === undefined || text === null) text = '';
                                if (this.maximumLength !== undefined && this.maximumLength !== null) text = text.substring(0, this.maximumLength);
                                return text;
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text) {
                                if (text === undefined || text === null) text = '';
                                if (this.maximumLength !== undefined && this.maximumLength !== null) text = text.substring(0, this.maximumLength);
                                return text;
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change) {
                                var selectedRange = change.proposed.selectedRange;
                                var text = change.proposed.text;
                                if (this.maximumLength !== undefined && this.maximumLength !== null && text.length > this.maximumLength) {
                                    var available = this.maximumLength - (text.length - change.inserted.text.length);
                                    var newText = change.current.text.substring(0, change.current.selectedRange.start);
                                    if (available > 0) newText += change.inserted.text.substring(0, available);
                                    newText += change.current.text.substring(change.current.selectedRange.start + change.current.selectedRange.length);
                                    var truncatedLength = text.length - newText.length;
                                    change.proposed.text = newText;
                                    selectedRange.start -= truncatedLength;
                                }
                                return true;
                            }
                        }
                    ]);
                    return Formatter;
                }();
                exports['default'] = Formatter;
                module1.exports = exports['default'];
            },
            {}
        ],
        15: [
            function(_dereq_, module1, exports) {
                'use strict';
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                var _adaptive_card_formatter = _dereq_('./adaptive_card_formatter');
                var _adaptive_card_formatter2 = _interopRequireDefault(_adaptive_card_formatter);
                var _amex_card_formatter = _dereq_('./amex_card_formatter');
                var _amex_card_formatter2 = _interopRequireDefault(_amex_card_formatter);
                var _card_text_field = _dereq_('./card_text_field');
                var _card_text_field2 = _interopRequireDefault(_card_text_field);
                var _card_utils = _dereq_('./card_utils');
                var _default_card_formatter = _dereq_('./default_card_formatter');
                var _default_card_formatter2 = _interopRequireDefault(_default_card_formatter);
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                var _employer_identification_number_formatter = _dereq_('./employer_identification_number_formatter');
                var _employer_identification_number_formatter2 = _interopRequireDefault(_employer_identification_number_formatter);
                var _expiry_date_field = _dereq_('./expiry_date_field');
                var _expiry_date_field2 = _interopRequireDefault(_expiry_date_field);
                var _expiry_date_formatter = _dereq_('./expiry_date_formatter');
                var _expiry_date_formatter2 = _interopRequireDefault(_expiry_date_formatter);
                var _formatter = _dereq_('./formatter');
                var _formatter2 = _interopRequireDefault(_formatter);
                var _number_formatter = _dereq_('./number_formatter');
                var _number_formatter2 = _interopRequireDefault(_number_formatter);
                var _number_formatter_settings_formatter = _dereq_('./number_formatter_settings_formatter');
                var _number_formatter_settings_formatter2 = _interopRequireDefault(_number_formatter_settings_formatter);
                var _phone_formatter = _dereq_('./phone_formatter');
                var _phone_formatter2 = _interopRequireDefault(_phone_formatter);
                var _social_security_number_formatter = _dereq_('./social_security_number_formatter');
                var _social_security_number_formatter2 = _interopRequireDefault(_social_security_number_formatter);
                var _text_field = _dereq_('./text_field');
                var _text_field2 = _interopRequireDefault(_text_field);
                var _undo_manager = _dereq_('./undo_manager');
                var _undo_manager2 = _interopRequireDefault(_undo_manager);
                /**
 * @namespace FieldKit
 * @readonly
 */ module1.exports = {
                    AdaptiveCardFormatter: _adaptive_card_formatter2['default'],
                    AmexCardFormatter: _amex_card_formatter2['default'],
                    CardTextField: _card_text_field2['default'],
                    CardUtils: {
                        AMEX: _card_utils.AMEX,
                        DISCOVER: _card_utils.DISCOVER,
                        VISA: _card_utils.VISA,
                        MASTERCARD: _card_utils.MASTERCARD,
                        determineCardType: _card_utils.determineCardType,
                        luhnCheck: _card_utils.luhnCheck,
                        validCardLength: _card_utils.validCardLength
                    },
                    DefaultCardFormatter: _default_card_formatter2['default'],
                    DelimitedTextFormatter: _delimited_text_formatter2['default'],
                    EmployerIdentificationNumberFormatter: _employer_identification_number_formatter2['default'],
                    ExpiryDateField: _expiry_date_field2['default'],
                    ExpiryDateFormatter: _expiry_date_formatter2['default'],
                    Formatter: _formatter2['default'],
                    NumberFormatter: _number_formatter2['default'],
                    NumberFormatterSettingsFormatter: _number_formatter_settings_formatter2['default'],
                    PhoneFormatter: _phone_formatter2['default'],
                    SocialSecurityNumberFormatter: _social_security_number_formatter2['default'],
                    TextField: _text_field2['default'],
                    UndoManager: _undo_manager2['default']
                };
            },
            {
                "./adaptive_card_formatter": 4,
                "./amex_card_formatter": 5,
                "./card_text_field": 6,
                "./card_utils": 7,
                "./default_card_formatter": 9,
                "./delimited_text_formatter": 10,
                "./employer_identification_number_formatter": 11,
                "./expiry_date_field": 12,
                "./expiry_date_formatter": 13,
                "./formatter": 14,
                "./number_formatter": 16,
                "./number_formatter_settings_formatter": 17,
                "./phone_formatter": 18,
                "./social_security_number_formatter": 19,
                "./text_field": 20,
                "./undo_manager": 21
            }
        ],
        16: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _formatter = _dereq_('./formatter');
                var _formatter2 = _interopRequireDefault(_formatter);
                var _number_formatter_settings_formatter = _dereq_('./number_formatter_settings_formatter');
                var _number_formatter_settings_formatter2 = _interopRequireDefault(_number_formatter_settings_formatter);
                var _utils = _dereq_('./utils');
                var _stround = _dereq_('stround');
                // Style
                var NONE = 0;
                var CURRENCY = 1;
                var PERCENT = 2;
                var DEFAULT_LOCALE = 'en-US';
                var DEFAULT_COUNTRY = 'US';
                /**
 * @param {string} locale
 * @returns {Object} {lang: lang, country: country}
 * @private
 */ function splitLocaleComponents(locale) {
                    var match = locale.match(/^([a-z][a-z])(?:[-_]([a-z][a-z]))?$/i);
                    if (match) {
                        var lang = match[1] && match[1].toLowerCase();
                        var country = match[2] && match[2].toLowerCase();
                        return {
                            lang: lang,
                            country: country
                        };
                    }
                }
                /**
 * This simple property getter assumes that properties will never be functions
 * and so attempts to run those functions using the given args.
 *
 * @private
 */ function get(object, key) {
                    if (object) {
                        var value = object[key];
                        if (typeof value === 'function') {
                            for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                            return value.apply(undefined, args);
                        } else return value;
                    }
                }
                /**
 * @param {string} string
 * @param {string} currencySymbol
 * @return {string}
 * @private
 */ function replaceCurrencySymbol(string, currencySymbol) {
                    return string.replace(/¤/g, currencySymbol);
                }
                /**
 * @param {string} string
 * @param {string} plusSign
 * @returns {string}
 * @private
 */ function replacePlusSign(string, plusSign) {
                    return string.replace(/\+/g, plusSign);
                }
                /**
 * @param {string} string
 * @param {string} minusSign
 * @returns {string}
 * @private
 */ function replaceMinusSign(string, minusSign) {
                    return string.replace(/-/g, minusSign);
                }
                /**
 * Formats and parses numbers. There are many configuration options for how to
 * format numbers as strings, but for many users simply adjusting the
 * {@link NumberFormatter#numberStyle}, {@link NumberFormatter#locale},
 * {@link NumberFormatter#currencyCode}, and {@link NumberFormatter#countryCode}
 * values will be sufficient. NumberFormatter natively understands how to
 * format numbers, currencies, and percentages for a variety of locales.
 *
 * @example
 *
 *   // Configure a NumberFormatter to display currencies.
 *   var f = new FieldKit.NumberFormatter();
 *   f.setNumberStyle(FieldKit.NumberFormatter.Style.CURRENCY);
 *
 *   // Configure the current locale info.
 *   f.setLocale('en-US');
 *   f.setCountryCode('US');
 *   f.setCurrencyCode('USD');
 *
 *   // Showing USD in US uses abbreviated currency.
 *   f.format(6.17);  // '$6.17'
 *
 *   // Showing CAD in US uses fully-qualified currency.
 *   f.setCurrencyCode('CAD');
 *   f.format(6.17);  // 'CA$6.17'
 *
 *   // Showing CAD in CA again uses abbreviated currency.
 *   f.setLocale('en-CA');
 *   f.setCountryCode('CA');
 *   f.format(6.17);  // '$6.17'
 *
 *   // Showing CAD in CA to a French speaker uses correct formatting.
 *   f.setLocale('fr-CA');
 *   f.format(6.17);  // '6,17 $'
 *
 *   // You may customize the behavior of NumberFormatter to achieve whatever
 *   // number formatting you need using the setter methods for the various
 *   // settings, or you can use the {@link NumberFormatter#positiveFormat} and
 *   // {@link NumberFormatter#negativeFormat} shorthand templates.
 *
 *   var f = new FieldKit.NumberFormatter();
 *
 *   // Using this template string…
 *   f.setPositiveFormat('¤#0.00');
 *
 *   // …is equivalent to this:
 *   f.setPositivePrefix('¤');
 *   f.setPositiveSuffix('');
 *   f.setMinimumIntegerDigits(1);
 *   f.setMinimumFractionDigits(2);
 *   f.setMaximumFractionDigits(2);
 *
 *   // And you can determine what the template string is for however you've
 *   // configured the NumberFormatter:
 *   f.setUsesGroupingSeparator(true);
 *   f.setGroupingSize(2);
 *   f.positiveFormat(); // '¤#,#0.00'
 *
 * @extends Formatter
 */ var NumberFormatter = function(_Formatter) {
                    _inherits(NumberFormatter, _Formatter);
                    function NumberFormatter() {
                        _classCallCheck(this, NumberFormatter);
                        _get(Object.getPrototypeOf(NumberFormatter.prototype), 'constructor', this).call(this);
                        this.setNumberStyle(NONE);
                    }
                    /**
   * Defaults
   */ /** @private */ /**
   * Gets whether this formatter will parse float number values. This value does
   * not apply to formatting. To prevent formatting floats, set
   * maximumFractionDigits to 0.
   *
   * @returns {boolean}
   */ _createClass(NumberFormatter, [
                        {
                            key: 'allowsFloats',
                            value: function allowsFloats() {
                                return this._get('allowsFloats');
                            }
                        },
                        {
                            key: 'setAllowsFloats',
                            value: function setAllowsFloats(allowsFloats) {
                                this._allowsFloats = allowsFloats;
                                return this;
                            }
                        },
                        {
                            key: 'alwaysShowsDecimalSeparator',
                            value: function alwaysShowsDecimalSeparator() {
                                return this._get('alwaysShowsDecimalSeparator');
                            }
                        },
                        {
                            key: 'setAlwaysShowsDecimalSeparator',
                            value: function setAlwaysShowsDecimalSeparator(alwaysShowsDecimalSeparator) {
                                this._alwaysShowsDecimalSeparator = alwaysShowsDecimalSeparator;
                                return this;
                            }
                        },
                        {
                            key: 'countryCode',
                            value: function countryCode() {
                                return this._countryCode || DEFAULT_COUNTRY;
                            }
                        },
                        {
                            key: 'setCountryCode',
                            value: function setCountryCode(countryCode) {
                                this._countryCode = countryCode;
                                return this;
                            }
                        },
                        {
                            key: 'currencyCode',
                            value: function currencyCode() {
                                return this._get('currencyCode');
                            }
                        },
                        {
                            key: 'setCurrencyCode',
                            value: function setCurrencyCode(currencyCode) {
                                this._currencyCode = currencyCode;
                                return this;
                            }
                        },
                        {
                            key: 'currencySymbol',
                            value: function currencySymbol() {
                                if (this._shouldShowNativeCurrencySymbol()) return this._get('currencySymbol');
                                else return this._get('internationalCurrencySymbol');
                            }
                        },
                        {
                            key: 'setCurrencySymbol',
                            value: function setCurrencySymbol(currencySymbol) {
                                this._currencySymbol = currencySymbol;
                                return this;
                            }
                        },
                        {
                            key: '_shouldShowNativeCurrencySymbol',
                            value: function _shouldShowNativeCurrencySymbol() {
                                var regionDefaultCurrencyCode = this._regionDefaults().currencyCode;
                                if (typeof regionDefaultCurrencyCode === 'function') regionDefaultCurrencyCode = regionDefaultCurrencyCode();
                                return this.currencyCode() === regionDefaultCurrencyCode;
                            }
                        },
                        {
                            key: 'decimalSeparator',
                            value: function decimalSeparator() {
                                return this._get('decimalSeparator');
                            }
                        },
                        {
                            key: 'setDecimalSeparator',
                            value: function setDecimalSeparator(decimalSeparator) {
                                this._decimalSeparator = decimalSeparator;
                                return this;
                            }
                        },
                        {
                            key: 'exponent',
                            value: function exponent() {
                                return this._get('exponent');
                            }
                        },
                        {
                            key: 'setExponent',
                            value: function setExponent(exponent) {
                                this._exponent = exponent;
                                return this;
                            }
                        },
                        {
                            key: 'groupingSeparator',
                            value: function groupingSeparator() {
                                return this._get('groupingSeparator');
                            }
                        },
                        {
                            key: 'setGroupingSeparator',
                            value: function setGroupingSeparator(groupingSeparator) {
                                this._groupingSeparator = groupingSeparator;
                                return this;
                            }
                        },
                        {
                            key: 'groupingSize',
                            value: function groupingSize() {
                                return this._get('groupingSize');
                            }
                        },
                        {
                            key: 'setGroupingSize',
                            value: function setGroupingSize(groupingSize) {
                                this._groupingSize = groupingSize;
                                return this;
                            }
                        },
                        {
                            key: 'internationalCurrencySymbol',
                            value: function internationalCurrencySymbol() {
                                return this._get('internationalCurrencySymbol');
                            }
                        },
                        {
                            key: 'setInternationalCurrencySymbol',
                            value: function setInternationalCurrencySymbol(internationalCurrencySymbol) {
                                this._internationalCurrencySymbol = internationalCurrencySymbol;
                                return this;
                            }
                        },
                        {
                            key: 'isLenient',
                            value: function isLenient() {
                                return this._lenient;
                            }
                        },
                        {
                            key: 'setLenient',
                            value: function setLenient(lenient) {
                                this._lenient = lenient;
                                return this;
                            }
                        },
                        {
                            key: 'locale',
                            value: function locale() {
                                return this._locale || DEFAULT_LOCALE;
                            }
                        },
                        {
                            key: 'setLocale',
                            value: function setLocale(locale) {
                                this._locale = locale;
                                return this;
                            }
                        },
                        {
                            key: 'maximum',
                            value: function maximum() {
                                return this._maximum;
                            }
                        },
                        {
                            key: 'setMaximum',
                            value: function setMaximum(max) {
                                this._maximum = max;
                                return this;
                            }
                        },
                        {
                            key: 'minimum',
                            value: function minimum() {
                                return this._minimum;
                            }
                        },
                        {
                            key: 'setMinimum',
                            value: function setMinimum(min) {
                                this._minimum = min;
                                return this;
                            }
                        },
                        {
                            key: 'maximumFractionDigits',
                            value: function maximumFractionDigits() {
                                var result = this._get('maximumFractionDigits');
                                var minimumFractionDigits = this._minimumFractionDigits;
                                if (result !== null && result !== undefined && minimumFractionDigits !== null && minimumFractionDigits !== undefined && minimumFractionDigits > result) result = minimumFractionDigits;
                                return result;
                            }
                        },
                        {
                            key: 'setMaximumFractionDigits',
                            value: function setMaximumFractionDigits(maximumFractionDigits) {
                                this._maximumFractionDigits = maximumFractionDigits;
                                return this;
                            }
                        },
                        {
                            key: 'minimumFractionDigits',
                            value: function minimumFractionDigits() {
                                var result = this._get('minimumFractionDigits');
                                var maximumFractionDigits = this._maximumFractionDigits;
                                if (result !== null && result !== undefined && maximumFractionDigits !== null && maximumFractionDigits !== undefined && maximumFractionDigits < result) result = maximumFractionDigits;
                                return result;
                            }
                        },
                        {
                            key: 'setMinimumFractionDigits',
                            value: function setMinimumFractionDigits(minimumFractionDigits) {
                                this._minimumFractionDigits = minimumFractionDigits;
                                return this;
                            }
                        },
                        {
                            key: 'maximumIntegerDigits',
                            value: function maximumIntegerDigits() {
                                var result = this._get('maximumIntegerDigits');
                                var minimumIntegerDigits = this._minimumIntegerDigits;
                                if (result !== null && result !== undefined && minimumIntegerDigits !== null && minimumIntegerDigits !== undefined && minimumIntegerDigits > result) result = minimumIntegerDigits;
                                return result;
                            }
                        },
                        {
                            key: 'setMaximumIntegerDigits',
                            value: function setMaximumIntegerDigits(maximumIntegerDigits) {
                                this._maximumIntegerDigits = maximumIntegerDigits;
                                return this;
                            }
                        },
                        {
                            key: 'minimumIntegerDigits',
                            value: function minimumIntegerDigits() {
                                var result = this._get('minimumIntegerDigits');
                                var maximumIntegerDigits = this._maximumIntegerDigits;
                                if (result !== null && result !== undefined && maximumIntegerDigits !== null && maximumIntegerDigits !== undefined && maximumIntegerDigits < result) result = maximumIntegerDigits;
                                return result;
                            }
                        },
                        {
                            key: 'setMinimumIntegerDigits',
                            value: function setMinimumIntegerDigits(minimumIntegerDigits) {
                                this._minimumIntegerDigits = minimumIntegerDigits;
                                return this;
                            }
                        },
                        {
                            key: 'minusSign',
                            value: function minusSign() {
                                return this._get('minusSign');
                            }
                        },
                        {
                            key: 'setMinusSign',
                            value: function setMinusSign(minusSign) {
                                this._minusSign = minusSign;
                                return this;
                            }
                        },
                        {
                            key: 'negativeFormat',
                            value: function negativeFormat() {
                                return this.numberFormatFormatter().format({
                                    alwaysShowsDecimalSeparator: this.alwaysShowsDecimalSeparator(),
                                    groupingSize: this.groupingSize(),
                                    maximumFractionDigits: this.maximumFractionDigits(),
                                    minimumFractionDigits: this.minimumFractionDigits(),
                                    minimumIntegerDigits: this.minimumIntegerDigits(),
                                    prefix: this._get('negativePrefix'),
                                    suffix: this._get('negativeSuffix'),
                                    usesGroupingSeparator: this.usesGroupingSeparator()
                                });
                            }
                        },
                        {
                            key: 'setNegativeFormat',
                            value: function setNegativeFormat(negativeFormat) {
                                var settings = this.numberFormatFormatter().parse(negativeFormat);
                                this.setNegativePrefix(settings.prefix);
                                this.setNegativeSuffix(settings.suffix);
                                this.setGroupingSize(settings.groupingSize);
                                this.setMaximumFractionDigits(settings.maximumFractionDigits);
                                this.setMinimumFractionDigits(settings.minimumFractionDigits);
                                this.setMinimumIntegerDigits(settings.minimumIntegerDigits);
                                this.setUsesGroupingSeparator(settings.usesGroupingSeparator);
                            }
                        },
                        {
                            key: 'negativeInfinitySymbol',
                            value: function negativeInfinitySymbol() {
                                return this._get('negativeInfinitySymbol');
                            }
                        },
                        {
                            key: 'setNegativeInfinitySymbol',
                            value: function setNegativeInfinitySymbol(negativeInfinitySymbol) {
                                this._negativeInfinitySymbol = negativeInfinitySymbol;
                                return this;
                            }
                        },
                        {
                            key: 'negativePrefix',
                            value: function negativePrefix() {
                                return replaceCurrencySymbol(replaceMinusSign(this._get('negativePrefix'), this._get('minusSign')), this.currencySymbol());
                            }
                        },
                        {
                            key: 'setNegativePrefix',
                            value: function setNegativePrefix(prefix) {
                                this._negativePrefix = prefix;
                                return this;
                            }
                        },
                        {
                            key: 'negativeSuffix',
                            value: function negativeSuffix() {
                                return replaceCurrencySymbol(replaceMinusSign(this._get('negativeSuffix'), this._get('minusSign')), this.currencySymbol());
                            }
                        },
                        {
                            key: 'setNegativeSuffix',
                            value: function setNegativeSuffix(prefix) {
                                this._negativeSuffix = prefix;
                                return this;
                            }
                        },
                        {
                            key: 'notANumberSymbol',
                            value: function notANumberSymbol() {
                                return this._get('notANumberSymbol');
                            }
                        },
                        {
                            key: 'setNotANumberSymbol',
                            value: function setNotANumberSymbol(notANumberSymbol) {
                                this._notANumberSymbol = notANumberSymbol;
                                return this;
                            }
                        },
                        {
                            key: 'nullSymbol',
                            value: function nullSymbol() {
                                return this._get('nullSymbol');
                            }
                        },
                        {
                            key: 'setNullSymbol',
                            value: function setNullSymbol(nullSymbol) {
                                this._nullSymbol = nullSymbol;
                                return this;
                            }
                        },
                        {
                            key: 'numberFormatFormatter',
                            value: function numberFormatFormatter() {
                                if (!this._numberFormatFormatter) this._numberFormatFormatter = new _number_formatter_settings_formatter2['default']();
                                return this._numberFormatFormatter;
                            }
                        },
                        {
                            key: 'numberStyle',
                            value: function numberStyle() {
                                return this._numberStyle;
                            }
                        },
                        {
                            key: 'setNumberStyle',
                            value: function setNumberStyle(numberStyle) {
                                this._numberStyle = numberStyle;
                                switch(this._numberStyle){
                                    case NONE:
                                        this._styleDefaults = StyleDefaults.NONE;
                                        break;
                                    case PERCENT:
                                        this._styleDefaults = StyleDefaults.PERCENT;
                                        break;
                                    case CURRENCY:
                                        this._styleDefaults = StyleDefaults.CURRENCY;
                                        break;
                                    default:
                                        this._styleDefaults = null;
                                }
                                return this;
                            }
                        },
                        {
                            key: 'percentSymbol',
                            value: function percentSymbol() {
                                return this._get('percentSymbol');
                            }
                        },
                        {
                            key: 'setPercentSymbol',
                            value: function setPercentSymbol(percentSymbol) {
                                this._percentSymbol = percentSymbol;
                                return this;
                            }
                        },
                        {
                            key: 'plusSign',
                            value: function plusSign() {
                                return this._get('plusSign');
                            }
                        },
                        {
                            key: 'setPlusSign',
                            value: function setPlusSign(plusSign) {
                                this._plusSign = plusSign;
                                return this;
                            }
                        },
                        {
                            key: 'positiveFormat',
                            value: function positiveFormat() {
                                return this.numberFormatFormatter().format({
                                    alwaysShowsDecimalSeparator: this.alwaysShowsDecimalSeparator(),
                                    groupingSize: this.groupingSize(),
                                    maximumFractionDigits: this.maximumFractionDigits(),
                                    minimumFractionDigits: this.minimumFractionDigits(),
                                    minimumIntegerDigits: this.minimumIntegerDigits(),
                                    prefix: this._get('positivePrefix'),
                                    suffix: this._get('positiveSuffix'),
                                    usesGroupingSeparator: this.usesGroupingSeparator()
                                });
                            }
                        },
                        {
                            key: 'setPositiveFormat',
                            value: function setPositiveFormat(positiveFormat) {
                                var settings = this.numberFormatFormatter().parse(positiveFormat);
                                this.setPositivePrefix(settings.prefix);
                                this.setPositiveSuffix(settings.suffix);
                                this.setGroupingSize(settings.groupingSize);
                                this.setMaximumFractionDigits(settings.maximumFractionDigits);
                                this.setMinimumFractionDigits(settings.minimumFractionDigits);
                                this.setMinimumIntegerDigits(settings.minimumIntegerDigits);
                                this.setUsesGroupingSeparator(settings.usesGroupingSeparator);
                            }
                        },
                        {
                            key: 'positiveInfinitySymbol',
                            value: function positiveInfinitySymbol() {
                                return this._get('positiveInfinitySymbol');
                            }
                        },
                        {
                            key: 'setPositiveInfinitySymbol',
                            value: function setPositiveInfinitySymbol(positiveInfinitySymbol) {
                                this._positiveInfinitySymbol = positiveInfinitySymbol;
                                return this;
                            }
                        },
                        {
                            key: 'positivePrefix',
                            value: function positivePrefix() {
                                return replaceCurrencySymbol(replacePlusSign(this._get('positivePrefix'), this._get('plusSign')), this.currencySymbol());
                            }
                        },
                        {
                            key: 'setPositivePrefix',
                            value: function setPositivePrefix(prefix) {
                                this._positivePrefix = prefix;
                                return this;
                            }
                        },
                        {
                            key: 'positiveSuffix',
                            value: function positiveSuffix() {
                                return replaceCurrencySymbol(replacePlusSign(this._get('positiveSuffix'), this._get('plusSign')), this.currencySymbol());
                            }
                        },
                        {
                            key: 'setPositiveSuffix',
                            value: function setPositiveSuffix(prefix) {
                                this._positiveSuffix = prefix;
                                return this;
                            }
                        },
                        {
                            key: 'roundingMode',
                            value: function roundingMode() {
                                return this._get('roundingMode');
                            }
                        },
                        {
                            key: 'setRoundingMode',
                            value: function setRoundingMode(roundingMode) {
                                this._roundingMode = roundingMode;
                                return this;
                            }
                        },
                        {
                            key: 'usesGroupingSeparator',
                            value: function usesGroupingSeparator() {
                                return this._get('usesGroupingSeparator');
                            }
                        },
                        {
                            key: 'setUsesGroupingSeparator',
                            value: function setUsesGroupingSeparator(usesGroupingSeparator) {
                                this._usesGroupingSeparator = usesGroupingSeparator;
                                return this;
                            }
                        },
                        {
                            key: 'zeroSymbol',
                            value: function zeroSymbol() {
                                return this._get('zeroSymbol');
                            }
                        },
                        {
                            key: 'setZeroSymbol',
                            value: function setZeroSymbol(zeroSymbol) {
                                this._zeroSymbol = zeroSymbol;
                                return this;
                            }
                        },
                        {
                            key: '_get',
                            value: function _get(attr) {
                                var value = this['_' + attr];
                                if (value !== null && value !== undefined) return value;
                                var styleDefaults = this._styleDefaults;
                                var localeDefaults = this._localeDefaults();
                                var regionDefaults = this._regionDefaults();
                                value = get(styleDefaults, attr, this, localeDefaults);
                                if (value !== null && value !== undefined) return value;
                                value = get(localeDefaults, attr, this, styleDefaults);
                                if (value !== null && value !== undefined) return value;
                                value = get(regionDefaults, attr, this, styleDefaults);
                                if (value !== null && value !== undefined) return value;
                                value = get(this._currencyDefaults(), attr, this, localeDefaults);
                                if (value !== null && value !== undefined) return value;
                                return null;
                            }
                        },
                        {
                            key: 'format',
                            value: function format(number) {
                                if (number === '') return '';
                                var zeroSymbol = this.zeroSymbol();
                                if (zeroSymbol !== undefined && zeroSymbol !== null && number === 0) return zeroSymbol;
                                var nullSymbol = this.nullSymbol();
                                if (nullSymbol !== undefined && nullSymbol !== null && number === null) return nullSymbol;
                                var notANumberSymbol = this.notANumberSymbol();
                                if (notANumberSymbol !== undefined && notANumberSymbol !== null && isNaN(number)) return notANumberSymbol;
                                var positiveInfinitySymbol = this.positiveInfinitySymbol();
                                if (positiveInfinitySymbol !== undefined && positiveInfinitySymbol !== null && number === Infinity) return positiveInfinitySymbol;
                                var negativeInfinitySymbol = this.negativeInfinitySymbol();
                                if (negativeInfinitySymbol !== undefined && negativeInfinitySymbol !== null && number === -Infinity) return negativeInfinitySymbol;
                                var negative = number < 0;
                                var parts = ('' + Math.abs(number)).split('.');
                                var integerPart = parts[0];
                                var fractionPart = parts[1] || '';
                                var exponent = this.exponent();
                                if (exponent !== undefined && exponent !== null) {
                                    var shifted = (0, _stround.shiftParts)([
                                        negative,
                                        integerPart,
                                        fractionPart
                                    ], exponent);
                                    negative = shifted[0];
                                    integerPart = shifted[1];
                                    fractionPart = shifted[2];
                                    while(integerPart[0] === '0')integerPart = integerPart.slice(1);
                                }
                                // round fraction part to the maximum length
                                var maximumFractionDigits = this.maximumFractionDigits();
                                if (fractionPart.length > maximumFractionDigits) {
                                    var unrounded = integerPart + '.' + fractionPart;
                                    var rounded = this._round(negative ? '-' + unrounded : unrounded);
                                    if (rounded[0] === '-') rounded = rounded.slice(1);
                                    parts = rounded.split('.');
                                    integerPart = parts[0];
                                    fractionPart = parts[1] || '';
                                }
                                // right-pad fraction zeros up to the minimum length
                                var minimumFractionDigits = this.minimumFractionDigits();
                                while(fractionPart.length < minimumFractionDigits)fractionPart += '0';
                                // left-pad integer zeros up to the minimum length
                                var minimumIntegerDigits = this.minimumIntegerDigits();
                                while(integerPart.length < minimumIntegerDigits)integerPart = '0' + integerPart;
                                // eat any unneeded trailing zeros
                                while(fractionPart.length > minimumFractionDigits && fractionPart.slice(-1) === '0')fractionPart = fractionPart.slice(0, -1);
                                // left-truncate any integer digits over the maximum length
                                var maximumIntegerDigits = this.maximumIntegerDigits();
                                if (maximumIntegerDigits !== undefined && maximumIntegerDigits !== null && integerPart.length > maximumIntegerDigits) integerPart = integerPart.slice(-maximumIntegerDigits);
                                // add the decimal separator
                                if (fractionPart.length > 0 || this.alwaysShowsDecimalSeparator()) fractionPart = this.decimalSeparator() + fractionPart;
                                if (this.usesGroupingSeparator()) {
                                    var integerPartWithGroupingSeparators = '';
                                    var copiedCharacterCount = 0;
                                    for(var i = integerPart.length - 1; i >= 0; i--){
                                        if (copiedCharacterCount > 0 && copiedCharacterCount % this.groupingSize() === 0) integerPartWithGroupingSeparators = this.groupingSeparator() + integerPartWithGroupingSeparators;
                                        integerPartWithGroupingSeparators = integerPart[i] + integerPartWithGroupingSeparators;
                                        copiedCharacterCount++;
                                    }
                                    integerPart = integerPartWithGroupingSeparators;
                                }
                                var result = integerPart + fractionPart;
                                // surround with the appropriate prefix and suffix
                                if (negative) result = this.negativePrefix() + result + this.negativeSuffix();
                                else result = this.positivePrefix() + result + this.positiveSuffix();
                                return result;
                            }
                        },
                        {
                            key: '_round',
                            value: function _round(number) {
                                return (0, _stround.round)(number, this.maximumFractionDigits(), this.roundingMode());
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(string, error) {
                                var result = undefined;
                                var positivePrefix = this.positivePrefix();
                                var negativePrefix = this.negativePrefix();
                                var positiveSuffix = this.positiveSuffix();
                                var negativeSuffix = this.negativeSuffix();
                                if (this.isLenient()) {
                                    string = string.replace(/\s/g, '');
                                    positivePrefix = (0, _utils.trim)(positivePrefix);
                                    negativePrefix = (0, _utils.trim)(negativePrefix);
                                    positiveSuffix = (0, _utils.trim)(positiveSuffix);
                                    negativeSuffix = (0, _utils.trim)(negativeSuffix);
                                }
                                var zeroSymbol = undefined;
                                var nullSymbol = undefined;
                                var notANumberSymbol = undefined;
                                var positiveInfinitySymbol = undefined;
                                var negativeInfinitySymbol = undefined;
                                var innerString = undefined;
                                if ((zeroSymbol = this.zeroSymbol()) !== undefined && zeroSymbol !== null && string === zeroSymbol) result = 0;
                                else if ((nullSymbol = this.nullSymbol()) !== undefined && nullSymbol !== null && string === nullSymbol) result = null;
                                else if ((notANumberSymbol = this.notANumberSymbol()) !== undefined && notANumberSymbol !== null && string === notANumberSymbol) result = NaN;
                                else if ((positiveInfinitySymbol = this.positiveInfinitySymbol()) !== undefined && positiveInfinitySymbol !== null && string === positiveInfinitySymbol) result = Infinity;
                                else if ((negativeInfinitySymbol = this.negativeInfinitySymbol()) !== undefined && negativeInfinitySymbol !== null && string === negativeInfinitySymbol) result = -Infinity;
                                else {
                                    var hasNegativePrefix = (0, _utils.startsWith)(negativePrefix, string);
                                    var hasNegativeSuffix = (0, _utils.endsWith)(negativeSuffix, string);
                                    if (hasNegativePrefix && (this.isLenient() || hasNegativeSuffix)) {
                                        innerString = string.slice(negativePrefix.length);
                                        if (hasNegativeSuffix) innerString = innerString.slice(0, innerString.length - negativeSuffix.length);
                                        result = this._parseAbsoluteValue(innerString, error);
                                        if (result !== undefined && result !== null) result *= -1;
                                    } else {
                                        var hasPositivePrefix = (0, _utils.startsWith)(positivePrefix, string);
                                        var hasPositiveSuffix = (0, _utils.endsWith)(positiveSuffix, string);
                                        if (this.isLenient() || hasPositivePrefix && hasPositiveSuffix) {
                                            innerString = string;
                                            if (hasPositivePrefix) innerString = innerString.slice(positivePrefix.length);
                                            if (hasPositiveSuffix) innerString = innerString.slice(0, innerString.length - positiveSuffix.length);
                                            result = this._parseAbsoluteValue(innerString, error);
                                        } else {
                                            if (typeof error === 'function') error('number-formatter.invalid-format');
                                            return null;
                                        }
                                    }
                                }
                                if (result !== undefined && result !== null) {
                                    var minimum = this.minimum();
                                    if (minimum !== undefined && minimum !== null && result < minimum) {
                                        if (typeof error === 'function') error('number-formatter.out-of-bounds.below-minimum');
                                        return null;
                                    }
                                    var maximum = this.maximum();
                                    if (maximum !== undefined && maximum !== null && result > maximum) {
                                        if (typeof error === 'function') error('number-formatter.out-of-bounds.above-maximum');
                                        return null;
                                    }
                                }
                                return result;
                            }
                        },
                        {
                            key: '_parseAbsoluteValue',
                            value: function _parseAbsoluteValue(string, error) {
                                var number = undefined;
                                if (string.length === 0) {
                                    if (typeof error === 'function') error('number-formatter.invalid-format');
                                    return null;
                                }
                                var parts = string.split(this.decimalSeparator());
                                if (parts.length > 2) {
                                    if (typeof error === 'function') error('number-formatter.invalid-format');
                                    return null;
                                }
                                var integerPart = parts[0];
                                var fractionPart = parts[1] || '';
                                if (this.usesGroupingSeparator()) {
                                    var groupingSize = this.groupingSize();
                                    var groupParts = integerPart.split(this.groupingSeparator());
                                    if (!this.isLenient()) {
                                        if (groupParts.length > 1) {
                                            // disallow 1000,000
                                            if (groupParts[0].length > groupingSize) {
                                                if (typeof error === 'function') error('number-formatter.invalid-format.grouping-size');
                                                return null;
                                            }
                                            // disallow 1,00
                                            var groupPartsTail = groupParts.slice(1);
                                            for(var i = 0, l = groupPartsTail.length; i < l; i++)if (groupPartsTail[i].length !== groupingSize) {
                                                if (typeof error === 'function') error('number-formatter.invalid-format.grouping-size');
                                                return null;
                                            }
                                        }
                                    }
                                    // remove grouping separators
                                    integerPart = groupParts.join('');
                                }
                                if (!(0, _utils.isDigits)(integerPart) || !(0, _utils.isDigits)(fractionPart)) {
                                    if (typeof error === 'function') error('number-formatter.invalid-format');
                                    return null;
                                }
                                var exponent = this.exponent();
                                if (exponent !== undefined && exponent !== null) {
                                    var shifted = (0, _stround.shiftParts)([
                                        false,
                                        integerPart,
                                        fractionPart
                                    ], -exponent);
                                    integerPart = shifted[1];
                                    fractionPart = shifted[2];
                                }
                                number = Number(integerPart) + Number('.' + (fractionPart || '0'));
                                if (!this.allowsFloats() && number !== ~~number) {
                                    if (typeof error === 'function') error('number-formatter.floats-not-allowed');
                                    return null;
                                }
                                return number;
                            }
                        },
                        {
                            key: '_currencyDefaults',
                            value: function _currencyDefaults() {
                                var result = {};
                                (0, _utils.forEach)(CurrencyDefaults['default'], function(value, key) {
                                    result[key] = value;
                                });
                                (0, _utils.forEach)(CurrencyDefaults[this.currencyCode()], function(value, key) {
                                    result[key] = value;
                                });
                                return result;
                            }
                        },
                        {
                            key: '_regionDefaults',
                            value: function _regionDefaults() {
                                var result = {};
                                (0, _utils.forEach)(RegionDefaults['default'], function(value, key) {
                                    result[key] = value;
                                });
                                (0, _utils.forEach)(RegionDefaults[this.countryCode()], function(value, key) {
                                    result[key] = value;
                                });
                                return result;
                            }
                        },
                        {
                            key: '_localeDefaults',
                            value: function _localeDefaults() {
                                var locale = this.locale();
                                var countryCode = this.countryCode();
                                var lang = splitLocaleComponents(locale).lang;
                                var result = {};
                                var defaultFallbacks = [
                                    RegionDefaults['default'],
                                    LocaleDefaults['default'],
                                    RegionDefaults[countryCode],
                                    LocaleDefaults[lang],
                                    LocaleDefaults[locale] // fr-CA
                                ];
                                (0, _utils.forEach)(defaultFallbacks, function(defaults) {
                                    (0, _utils.forEach)(defaults, function(value, key) {
                                        result[key] = value;
                                    });
                                });
                                return result;
                            }
                        }
                    ]);
                    return NumberFormatter;
                }(_formatter2['default']);
                NumberFormatter.prototype._allowsFloats = null;
                /** @private */ NumberFormatter.prototype._alwaysShowsDecimalSeparator = null;
                /** @private */ NumberFormatter.prototype._countryCode = null;
                /** @private */ NumberFormatter.prototype._currencyCode = null;
                /** @private */ NumberFormatter.prototype._exponent = null;
                /** @private */ NumberFormatter.prototype._groupingSeparator = null;
                /** @private */ NumberFormatter.prototype._groupingSize = null;
                /** @private */ NumberFormatter.prototype._lenient = false;
                /** @private */ NumberFormatter.prototype._locale = null;
                /** @private */ NumberFormatter.prototype._internationalCurrencySymbol = null;
                /** @private */ NumberFormatter.prototype._maximumFractionDigits = null;
                /** @private */ NumberFormatter.prototype._minimumFractionDigits = null;
                /** @private */ NumberFormatter.prototype._maximumIntegerDigits = null;
                /** @private */ NumberFormatter.prototype._minimumIntegerDigits = null;
                /** @private */ NumberFormatter.prototype._maximum = null;
                /** @private */ NumberFormatter.prototype._minimum = null;
                /** @private */ NumberFormatter.prototype._notANumberSymbol = null;
                /** @private */ NumberFormatter.prototype._nullSymbol = null;
                /** @private */ NumberFormatter.prototype._numberStyle = null;
                /** @private */ NumberFormatter.prototype._roundingMode = null;
                /** @private */ NumberFormatter.prototype._usesGroupingSeparator = null;
                /** @private */ NumberFormatter.prototype._zeroSymbol = null;
                /**
 * Aliases
 */ NumberFormatter.prototype.stringFromNumber = NumberFormatter.prototype.format;
                NumberFormatter.prototype.numberFromString = NumberFormatter.prototype.parse;
                NumberFormatter.Rounding = _stround.modes;
                /**
 * @enum {number}
 * @readonly
 */ NumberFormatter.Style = {
                    NONE: NONE,
                    CURRENCY: CURRENCY,
                    PERCENT: PERCENT
                };
                /**
 * @namespace StyleDefaults
 */ var StyleDefaults = {
                    NONE: {
                        usesGroupingSeparator: false,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        minimumIntegerDigits: 0
                    },
                    PERCENT: {
                        usesGroupingSeparator: false,
                        exponent: 2,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        minimumIntegerDigits: 1,
                        positiveSuffix: function positiveSuffix(formatter) {
                            return formatter.percentSymbol();
                        },
                        negativeSuffix: function negativeSuffix(formatter) {
                            return formatter.percentSymbol();
                        }
                    },
                    CURRENCY: {
                        positivePrefix: function positivePrefix(formatter, locale) {
                            return get(locale, 'positiveCurrencyPrefix', formatter, this);
                        },
                        positiveSuffix: function positiveSuffix(formatter, locale) {
                            return get(locale, 'positiveCurrencySuffix', formatter, this);
                        },
                        negativePrefix: function negativePrefix(formatter, locale) {
                            return get(locale, 'negativeCurrencyPrefix', formatter, this);
                        },
                        negativeSuffix: function negativeSuffix(formatter, locale) {
                            return get(locale, 'negativeCurrencySuffix', formatter, this);
                        }
                    }
                };
                /**
 * Contains the default values for various number formatter settings, including
 * per-locale overrides. Some of these characters will not be used as-is and
 * instead serve as placeholders:
 *
 *   "¤"  placeholder for `currencySymbol()`.
 *   "-"  placeholder for `minusSign()`.
 *   "+"  placeholder for `plusSign()`.
 *
 * @namespace LocaleDefaults
 */ var LocaleDefaults = {
                    'default': {
                        allowsFloats: true,
                        alwaysShowsDecimalSeparator: false,
                        decimalSeparator: '.',
                        groupingSeparator: ',',
                        groupingSize: 3,
                        minusSign: '-',
                        negativeInfinitySymbol: "-\u221E",
                        negativePrefix: '-',
                        negativeSuffix: '',
                        notANumberSymbol: 'NaN',
                        nullSymbol: '',
                        percentSymbol: '%',
                        positiveInfinitySymbol: "+\u221E",
                        positivePrefix: '',
                        positiveSuffix: '',
                        plusSign: '+',
                        roundingMode: NumberFormatter.Rounding.HALF_EVEN,
                        positiveCurrencyPrefix: "\xa4",
                        positiveCurrencySuffix: '',
                        negativeCurrencyPrefix: "(\xa4",
                        negativeCurrencySuffix: ')'
                    },
                    fr: {
                        decimalSeparator: ',',
                        groupingSeparator: ' ',
                        percentSymbol: ' %',
                        positiveCurrencyPrefix: '',
                        positiveCurrencySuffix: " \xa4",
                        negativeCurrencyPrefix: '(',
                        negativeCurrencySuffix: " \xa4)"
                    },
                    ja: {
                        negativeCurrencyPrefix: "-\xa4",
                        negativeCurrencySuffix: ''
                    },
                    'en-GB': {
                        negativeCurrencyPrefix: "-\xa4",
                        negativeCurrencySuffix: ''
                    },
                    'es-ES': {
                        decimalSeparator: ',',
                        groupingSeparator: ' ',
                        percentSymbol: ' %',
                        positiveCurrencyPrefix: '',
                        positiveCurrencySuffix: " \xa4",
                        negativeCurrencyPrefix: '(',
                        negativeCurrencySuffix: " \xa4)"
                    }
                };
                /**
 * @namespace RegionDefaults
 */ var RegionDefaults = {
                    AE: {
                        currencyCode: 'AED'
                    },
                    AG: {
                        currencyCode: 'XCD'
                    },
                    AI: {
                        currencyCode: 'XCD'
                    },
                    AL: {
                        currencyCode: 'ALL'
                    },
                    AM: {
                        currencyCode: 'AMD'
                    },
                    AO: {
                        currencyCode: 'AOA'
                    },
                    AR: {
                        currencyCode: 'ARS'
                    },
                    AT: {
                        currencyCode: 'EUR'
                    },
                    AU: {
                        currencyCode: 'AUD'
                    },
                    AW: {
                        currencyCode: 'AWG'
                    },
                    AZ: {
                        currencyCode: 'AZN'
                    },
                    BA: {
                        currencyCode: 'BAM'
                    },
                    BB: {
                        currencyCode: 'BBD'
                    },
                    BD: {
                        currencyCode: 'BDT'
                    },
                    BE: {
                        currencyCode: 'EUR'
                    },
                    BF: {
                        currencyCode: 'XOF'
                    },
                    BG: {
                        currencyCode: 'BGN'
                    },
                    BH: {
                        currencyCode: 'BHD'
                    },
                    BJ: {
                        currencyCode: 'XOF'
                    },
                    BM: {
                        currencyCode: 'BMD'
                    },
                    BN: {
                        currencyCode: 'BND'
                    },
                    BO: {
                        currencyCode: 'BOB'
                    },
                    BR: {
                        currencyCode: 'BRL'
                    },
                    BS: {
                        currencyCode: 'BSD'
                    },
                    BT: {
                        currencyCode: 'BTN'
                    },
                    BW: {
                        currencyCode: 'BWP'
                    },
                    BY: {
                        currencyCode: 'BYR'
                    },
                    BZ: {
                        currencyCode: 'BZD'
                    },
                    CA: {
                        currencyCode: 'CAD'
                    },
                    CG: {
                        currencyCode: 'CDF'
                    },
                    CH: {
                        currencyCode: 'CHF'
                    },
                    CI: {
                        currencyCode: 'XOF'
                    },
                    CL: {
                        currencyCode: 'CLP'
                    },
                    CM: {
                        currencyCode: 'XAF'
                    },
                    CN: {
                        currencyCode: 'CNY'
                    },
                    CO: {
                        currencyCode: 'COP'
                    },
                    CR: {
                        currencyCode: 'CRC'
                    },
                    CV: {
                        currencyCode: 'CVE'
                    },
                    CY: {
                        currencyCode: 'EUR'
                    },
                    CZ: {
                        currencyCode: 'CZK'
                    },
                    DE: {
                        currencyCode: 'EUR'
                    },
                    DK: {
                        currencyCode: 'DKK'
                    },
                    DM: {
                        currencyCode: 'XCD'
                    },
                    DO: {
                        currencyCode: 'DOP'
                    },
                    DZ: {
                        currencyCode: 'DZD'
                    },
                    EC: {
                        currencyCode: 'USD'
                    },
                    EE: {
                        currencyCode: 'EUR'
                    },
                    EG: {
                        currencyCode: 'EGP'
                    },
                    ES: {
                        currencyCode: 'EUR'
                    },
                    ET: {
                        currencyCode: 'ETB'
                    },
                    FI: {
                        currencyCode: 'EUR'
                    },
                    FJ: {
                        currencyCode: 'FJD'
                    },
                    FM: {
                        currencyCode: 'USD'
                    },
                    FR: {
                        currencyCode: 'EUR'
                    },
                    GA: {
                        currencyCode: 'XAF'
                    },
                    GB: {
                        currencyCode: 'GBP'
                    },
                    GD: {
                        currencyCode: 'XCD'
                    },
                    GE: {
                        currencyCode: 'GEL'
                    },
                    GH: {
                        currencyCode: 'GHS'
                    },
                    GI: {
                        currencyCode: 'GIP'
                    },
                    GM: {
                        currencyCode: 'GMD'
                    },
                    GR: {
                        currencyCode: 'EUR'
                    },
                    GT: {
                        currencyCode: 'GTQ'
                    },
                    GU: {
                        currencyCode: 'USD'
                    },
                    GW: {
                        currencyCode: 'XOF'
                    },
                    GY: {
                        currencyCode: 'GYD'
                    },
                    HK: {
                        currencyCode: 'HKD'
                    },
                    HN: {
                        currencyCode: 'HNL'
                    },
                    HR: {
                        currencyCode: 'HRK'
                    },
                    HT: {
                        currencyCode: 'HTG'
                    },
                    HU: {
                        currencyCode: 'HUF'
                    },
                    ID: {
                        currencyCode: 'IDR'
                    },
                    IE: {
                        currencyCode: 'EUR'
                    },
                    IL: {
                        currencyCode: 'ILS'
                    },
                    IN: {
                        currencyCode: 'INR'
                    },
                    IS: {
                        currencyCode: 'ISK'
                    },
                    IT: {
                        currencyCode: 'EUR'
                    },
                    JM: {
                        currencyCode: 'JMD'
                    },
                    JO: {
                        currencyCode: 'JOD'
                    },
                    JP: {
                        currencyCode: 'JPY'
                    },
                    KE: {
                        currencyCode: 'KES'
                    },
                    KG: {
                        currencyCode: 'KGS'
                    },
                    KH: {
                        currencyCode: 'KHR'
                    },
                    KN: {
                        currencyCode: 'XCD'
                    },
                    KR: {
                        currencyCode: 'KRW'
                    },
                    KW: {
                        currencyCode: 'KWD'
                    },
                    KY: {
                        currencyCode: 'KYD'
                    },
                    KZ: {
                        currencyCode: 'KZT'
                    },
                    LA: {
                        currencyCode: 'LAK'
                    },
                    LB: {
                        currencyCode: 'LBP'
                    },
                    LC: {
                        currencyCode: 'XCD'
                    },
                    LI: {
                        currencyCode: 'CHF'
                    },
                    LK: {
                        currencyCode: 'LKR'
                    },
                    LR: {
                        currencyCode: 'LRD'
                    },
                    LT: {
                        currencyCode: 'LTL'
                    },
                    LU: {
                        currencyCode: 'EUR'
                    },
                    LV: {
                        currencyCode: 'EUR'
                    },
                    MA: {
                        currencyCode: 'MAD'
                    },
                    MD: {
                        currencyCode: 'MDL'
                    },
                    MG: {
                        currencyCode: 'MGA'
                    },
                    MK: {
                        currencyCode: 'MKD'
                    },
                    ML: {
                        currencyCode: 'XOF'
                    },
                    MM: {
                        currencyCode: 'MMK'
                    },
                    MN: {
                        currencyCode: 'MNT'
                    },
                    MO: {
                        currencyCode: 'MOP'
                    },
                    MP: {
                        currencyCode: 'USD'
                    },
                    MR: {
                        currencyCode: 'MRO'
                    },
                    MS: {
                        currencyCode: 'XCD'
                    },
                    MT: {
                        currencyCode: 'EUR'
                    },
                    MU: {
                        currencyCode: 'MUR'
                    },
                    MW: {
                        currencyCode: 'MWK'
                    },
                    MX: {
                        currencyCode: 'MXN'
                    },
                    MY: {
                        currencyCode: 'MYR'
                    },
                    MZ: {
                        currencyCode: 'MZN'
                    },
                    NA: {
                        currencyCode: 'NAD'
                    },
                    NE: {
                        currencyCode: 'XOF'
                    },
                    NG: {
                        currencyCode: 'NGN'
                    },
                    NI: {
                        currencyCode: 'NIO'
                    },
                    NL: {
                        currencyCode: 'EUR'
                    },
                    NO: {
                        currencyCode: 'NOK'
                    },
                    NP: {
                        currencyCode: 'NPR'
                    },
                    NZ: {
                        currencyCode: 'NZD'
                    },
                    OM: {
                        currencyCode: 'OMR'
                    },
                    PA: {
                        currencyCode: 'PAB'
                    },
                    PE: {
                        currencyCode: 'PEN'
                    },
                    PG: {
                        currencyCode: 'PGK'
                    },
                    PH: {
                        currencyCode: 'PHP'
                    },
                    PK: {
                        currencyCode: 'PKR'
                    },
                    PL: {
                        currencyCode: 'PLN'
                    },
                    PR: {
                        currencyCode: 'USD'
                    },
                    PT: {
                        currencyCode: 'EUR'
                    },
                    PW: {
                        currencyCode: 'USD'
                    },
                    PY: {
                        currencyCode: 'PYG'
                    },
                    QA: {
                        currencyCode: 'QAR'
                    },
                    RO: {
                        currencyCode: 'RON'
                    },
                    RS: {
                        currencyCode: 'RSD'
                    },
                    RU: {
                        currencyCode: 'RUB'
                    },
                    RW: {
                        currencyCode: 'RWF'
                    },
                    SA: {
                        currencyCode: 'SAR'
                    },
                    SB: {
                        currencyCode: 'SBD'
                    },
                    SC: {
                        currencyCode: 'SCR'
                    },
                    SE: {
                        currencyCode: 'SEK'
                    },
                    SG: {
                        currencyCode: 'SGD'
                    },
                    SI: {
                        currencyCode: 'EUR'
                    },
                    SK: {
                        currencyCode: 'EUR'
                    },
                    SL: {
                        currencyCode: 'SLL'
                    },
                    SN: {
                        currencyCode: 'XOF'
                    },
                    SR: {
                        currencyCode: 'SRD'
                    },
                    ST: {
                        currencyCode: 'STD'
                    },
                    SV: {
                        currencyCode: 'SVC'
                    },
                    SZ: {
                        currencyCode: 'SZL'
                    },
                    TC: {
                        currencyCode: 'USD'
                    },
                    TD: {
                        currencyCode: 'XAF'
                    },
                    TG: {
                        currencyCode: 'XOF'
                    },
                    TH: {
                        currencyCode: 'THB'
                    },
                    TJ: {
                        currencyCode: 'TJS'
                    },
                    TM: {
                        currencyCode: 'TMT'
                    },
                    TN: {
                        currencyCode: 'TND'
                    },
                    TR: {
                        currencyCode: 'TRY'
                    },
                    TT: {
                        currencyCode: 'TTD'
                    },
                    TW: {
                        currencyCode: 'TWD'
                    },
                    TZ: {
                        currencyCode: 'TZS'
                    },
                    UA: {
                        currencyCode: 'UAH'
                    },
                    UG: {
                        currencyCode: 'UGX'
                    },
                    US: {
                        currencyCode: 'USD'
                    },
                    UY: {
                        currencyCode: 'UYU'
                    },
                    UZ: {
                        currencyCode: 'UZS'
                    },
                    VC: {
                        currencyCode: 'XCD'
                    },
                    VE: {
                        currencyCode: 'VEF'
                    },
                    VG: {
                        currencyCode: 'USD'
                    },
                    VI: {
                        currencyCode: 'USD'
                    },
                    VN: {
                        currencyCode: 'VND'
                    },
                    YE: {
                        currencyCode: 'YER'
                    },
                    ZA: {
                        currencyCode: 'ZAR'
                    },
                    ZM: {
                        currencyCode: 'ZMW'
                    },
                    ZW: {
                        currencyCode: 'USD'
                    }
                };
                /**
 * @namespace CurrencyDefaults
 */ var CurrencyDefaults = {
                    'default': {
                        currencySymbol: function currencySymbol(formatter) {
                            return formatter.currencyCode();
                        },
                        internationalCurrencySymbol: function internationalCurrencySymbol(formatter) {
                            return formatter.currencyCode();
                        },
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        minimumIntegerDigits: 1,
                        usesGroupingSeparator: true
                    },
                    AED: {
                        currencySymbol: "\u062F.\u0625",
                        internationalCurrencySymbol: "\u062F.\u0625"
                    },
                    ALL: {
                        currencySymbol: 'L',
                        internationalCurrencySymbol: 'L'
                    },
                    AMD: {
                        currencySymbol: "\u0564\u0580.",
                        internationalCurrencySymbol: "\u0564\u0580."
                    },
                    AOA: {
                        currencySymbol: 'Kz',
                        internationalCurrencySymbol: 'Kz'
                    },
                    ARS: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    AUD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    AWG: {
                        currencySymbol: "\u0192",
                        internationalCurrencySymbol: "\u0192"
                    },
                    AZN: {
                        currencySymbol: "\u20BC",
                        internationalCurrencySymbol: "\u20BC"
                    },
                    BAM: {
                        currencySymbol: "\u041A\u041C",
                        internationalCurrencySymbol: "\u041A\u041C"
                    },
                    BBD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    BDT: {
                        currencySymbol: "\u09F3",
                        internationalCurrencySymbol: "\u09F3"
                    },
                    BGN: {
                        currencySymbol: "\u043B\u0432",
                        internationalCurrencySymbol: "\u043B\u0432"
                    },
                    BHD: {
                        currencySymbol: "\u0628.\u062F",
                        internationalCurrencySymbol: "\u0628.\u062F",
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3
                    },
                    BMD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    BND: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    BOB: {
                        currencySymbol: 'Bs.',
                        internationalCurrencySymbol: 'Bs.'
                    },
                    BRL: {
                        currencySymbol: 'R$',
                        internationalCurrencySymbol: 'R$'
                    },
                    BSD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    BTN: {
                        currencySymbol: 'Nu.',
                        internationalCurrencySymbol: 'Nu.'
                    },
                    BWP: {
                        currencySymbol: 'P',
                        internationalCurrencySymbol: 'P'
                    },
                    BYR: {
                        currencySymbol: 'Br',
                        internationalCurrencySymbol: 'Br'
                    },
                    BZD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    CAD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    CDF: {
                        currencySymbol: 'Fr',
                        internationalCurrencySymbol: 'Fr'
                    },
                    CHF: {
                        currencySymbol: 'Fr',
                        internationalCurrencySymbol: 'Fr'
                    },
                    CLP: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    CNY: {
                        currencySymbol: "\xa5",
                        internationalCurrencySymbol: "\xa5"
                    },
                    COP: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    CRC: {
                        currencySymbol: "\u20A1",
                        internationalCurrencySymbol: "\u20A1"
                    },
                    CVE: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    CZK: {
                        currencySymbol: "K\u010D",
                        internationalCurrencySymbol: "K\u010D"
                    },
                    DKK: {
                        currencySymbol: 'kr',
                        internationalCurrencySymbol: 'kr'
                    },
                    DOP: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    DZD: {
                        currencySymbol: "\u062F.\u062C",
                        internationalCurrencySymbol: "\u062F.\u062C"
                    },
                    EGP: {
                        currencySymbol: "E\xa3",
                        internationalCurrencySymbol: "E\xa3"
                    },
                    ETB: {
                        currencySymbol: "\u1265\u122D",
                        internationalCurrencySymbol: "\u1265\u122D"
                    },
                    EUR: {
                        currencySymbol: "\u20AC",
                        internationalCurrencySymbol: "\u20AC"
                    },
                    FJD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    GBP: {
                        currencySymbol: "\xa3",
                        internationalCurrencySymbol: "\xa3"
                    },
                    GEL: {
                        currencySymbol: "\u10DA,",
                        internationalCurrencySymbol: "\u10DA,"
                    },
                    GHS: {
                        currencySymbol: "\u20B5",
                        internationalCurrencySymbol: "\u20B5"
                    },
                    GIP: {
                        currencySymbol: "\xa3",
                        internationalCurrencySymbol: "\xa3"
                    },
                    GMD: {
                        currencySymbol: 'D',
                        internationalCurrencySymbol: 'D'
                    },
                    GTQ: {
                        currencySymbol: 'Q',
                        internationalCurrencySymbol: 'Q'
                    },
                    GYD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    HKD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    HNL: {
                        currencySymbol: 'L',
                        internationalCurrencySymbol: 'L'
                    },
                    HRK: {
                        currencySymbol: 'kn',
                        internationalCurrencySymbol: 'kn'
                    },
                    HTG: {
                        currencySymbol: 'G',
                        internationalCurrencySymbol: 'G'
                    },
                    HUF: {
                        currencySymbol: 'Ft',
                        internationalCurrencySymbol: 'Ft'
                    },
                    IDR: {
                        currencySymbol: 'Rp',
                        internationalCurrencySymbol: 'Rp'
                    },
                    ILS: {
                        currencySymbol: "\u20AA",
                        internationalCurrencySymbol: "\u20AA"
                    },
                    INR: {
                        currencySymbol: "\u20B9",
                        internationalCurrencySymbol: "\u20B9"
                    },
                    ISK: {
                        currencySymbol: 'kr',
                        internationalCurrencySymbol: 'kr'
                    },
                    JMD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    JOD: {
                        currencySymbol: "\u062F.\u0627",
                        internationalCurrencySymbol: "\u062F.\u0627",
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3
                    },
                    JPY: {
                        currencySymbol: "\xa5",
                        internationalCurrencySymbol: "\xa5",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    KES: {
                        currencySymbol: 'KSh',
                        internationalCurrencySymbol: 'KSh'
                    },
                    KGS: {
                        currencySymbol: 'som',
                        internationalCurrencySymbol: 'som'
                    },
                    KHR: {
                        currencySymbol: "\u17DB",
                        internationalCurrencySymbol: "\u17DB"
                    },
                    KRW: {
                        currencySymbol: "\u20A9",
                        internationalCurrencySymbol: "\u20A9",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    KWD: {
                        currencySymbol: "\u062F.\u0643",
                        internationalCurrencySymbol: "\u062F.\u0643",
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3
                    },
                    KYD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    KZT: {
                        currencySymbol: "\u3012",
                        internationalCurrencySymbol: "\u3012"
                    },
                    LAK: {
                        currencySymbol: "\u20AD",
                        internationalCurrencySymbol: "\u20AD"
                    },
                    LBP: {
                        currencySymbol: "\u0644.\u0644",
                        internationalCurrencySymbol: "\u0644.\u0644"
                    },
                    LKR: {
                        currencySymbol: "\u20A8",
                        internationalCurrencySymbol: "\u20A8"
                    },
                    LRD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    LTL: {
                        currencySymbol: 'Lt',
                        internationalCurrencySymbol: 'Lt'
                    },
                    MAD: {
                        currencySymbol: "\u062F.\u0645.",
                        internationalCurrencySymbol: "\u062F.\u0645."
                    },
                    MDL: {
                        currencySymbol: 'L',
                        internationalCurrencySymbol: 'L'
                    },
                    MGA: {
                        currencySymbol: 'Ar',
                        internationalCurrencySymbol: 'Ar',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    MKD: {
                        currencySymbol: "\u0434\u0435\u043D",
                        internationalCurrencySymbol: "\u0434\u0435\u043D"
                    },
                    MMK: {
                        currencySymbol: 'K',
                        internationalCurrencySymbol: 'K'
                    },
                    MNT: {
                        currencySymbol: "\u20AE",
                        internationalCurrencySymbol: "\u20AE"
                    },
                    MOP: {
                        currencySymbol: 'P',
                        internationalCurrencySymbol: 'P'
                    },
                    MRO: {
                        currencySymbol: 'UM',
                        internationalCurrencySymbol: 'UM',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    MUR: {
                        currencySymbol: "\u20A8",
                        internationalCurrencySymbol: "\u20A8"
                    },
                    MWK: {
                        currencySymbol: 'MK',
                        internationalCurrencySymbol: 'MK'
                    },
                    MXN: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    MYR: {
                        currencySymbol: 'RM',
                        internationalCurrencySymbol: 'RM'
                    },
                    MZN: {
                        currencySymbol: 'MTn',
                        internationalCurrencySymbol: 'MTn'
                    },
                    NAD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    NGN: {
                        currencySymbol: "\u20A6",
                        internationalCurrencySymbol: "\u20A6"
                    },
                    NIO: {
                        currencySymbol: 'C$',
                        internationalCurrencySymbol: 'C$'
                    },
                    NOK: {
                        currencySymbol: 'kr',
                        internationalCurrencySymbol: 'kr'
                    },
                    NPR: {
                        currencySymbol: "\u20A8",
                        internationalCurrencySymbol: "\u20A8"
                    },
                    NZD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    OMR: {
                        currencySymbol: "\u0631.\u0639.",
                        internationalCurrencySymbol: "\u0631.\u0639.",
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3
                    },
                    PAB: {
                        currencySymbol: 'B/.',
                        internationalCurrencySymbol: 'B/.'
                    },
                    PEN: {
                        currencySymbol: 'S/.',
                        internationalCurrencySymbol: 'S/.'
                    },
                    PGK: {
                        currencySymbol: 'K',
                        internationalCurrencySymbol: 'K'
                    },
                    PHP: {
                        currencySymbol: "\u20B1",
                        internationalCurrencySymbol: "\u20B1"
                    },
                    PKR: {
                        currencySymbol: "\u20A8",
                        internationalCurrencySymbol: "\u20A8"
                    },
                    PLN: {
                        currencySymbol: "z\u0142",
                        internationalCurrencySymbol: "z\u0142"
                    },
                    PYG: {
                        currencySymbol: "\u20B2",
                        internationalCurrencySymbol: "\u20B2"
                    },
                    QAR: {
                        currencySymbol: "\u0631.\u0642",
                        internationalCurrencySymbol: "\u0631.\u0642"
                    },
                    RON: {
                        currencySymbol: 'Lei',
                        internationalCurrencySymbol: 'Lei'
                    },
                    RSD: {
                        currencySymbol: "\u0420\u0421\u0414",
                        internationalCurrencySymbol: "\u0420\u0421\u0414"
                    },
                    RUB: {
                        currencySymbol: "\u20BD",
                        internationalCurrencySymbol: "\u20BD"
                    },
                    RWF: {
                        currencySymbol: 'FRw',
                        internationalCurrencySymbol: 'FRw'
                    },
                    SAR: {
                        currencySymbol: "\u0631.\u0633",
                        internationalCurrencySymbol: "\u0631.\u0633"
                    },
                    SBD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    SCR: {
                        currencySymbol: "\u20A8",
                        internationalCurrencySymbol: "\u20A8"
                    },
                    SEK: {
                        currencySymbol: 'kr',
                        internationalCurrencySymbol: 'kr'
                    },
                    SGD: {
                        currencySymbol: 'S$',
                        internationalCurrencySymbol: 'S$'
                    },
                    SLL: {
                        currencySymbol: 'Le',
                        internationalCurrencySymbol: 'Le'
                    },
                    SRD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    STD: {
                        currencySymbol: 'Db',
                        internationalCurrencySymbol: 'Db'
                    },
                    SVC: {
                        currencySymbol: "\u20A1",
                        internationalCurrencySymbol: "\u20A1"
                    },
                    SZL: {
                        currencySymbol: 'E',
                        internationalCurrencySymbol: 'E'
                    },
                    THB: {
                        currencySymbol: "\u0E3F",
                        internationalCurrencySymbol: "\u0E3F"
                    },
                    TJS: {
                        currencySymbol: "\u0405\u041C",
                        internationalCurrencySymbol: "\u0405\u041C"
                    },
                    TMT: {
                        currencySymbol: 'm',
                        internationalCurrencySymbol: 'm'
                    },
                    TND: {
                        currencySymbol: "\u062F.\u062A",
                        internationalCurrencySymbol: "\u062F.\u062A",
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3
                    },
                    TRY: {
                        currencySymbol: "\u20BA",
                        internationalCurrencySymbol: "\u20BA"
                    },
                    TTD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    TWD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    TZS: {
                        currencySymbol: 'Sh',
                        internationalCurrencySymbol: 'Sh'
                    },
                    UAH: {
                        currencySymbol: "\u20B4",
                        internationalCurrencySymbol: "\u20B4"
                    },
                    UGX: {
                        currencySymbol: 'USh',
                        internationalCurrencySymbol: 'USh'
                    },
                    USD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: 'US$'
                    },
                    UYU: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    UZS: {
                        currencySymbol: "\u043B\u0432",
                        internationalCurrencySymbol: "\u043B\u0432"
                    },
                    VEF: {
                        currencySymbol: 'Bs F',
                        internationalCurrencySymbol: 'Bs F'
                    },
                    VND: {
                        currencySymbol: "\u20AB",
                        internationalCurrencySymbol: "\u20AB",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    },
                    XAF: {
                        currencySymbol: 'Fr',
                        internationalCurrencySymbol: 'Fr'
                    },
                    XCD: {
                        currencySymbol: '$',
                        internationalCurrencySymbol: '$'
                    },
                    XOF: {
                        currencySymbol: 'Fr',
                        internationalCurrencySymbol: 'Fr'
                    },
                    YER: {
                        currencySymbol: "\uFDFC",
                        internationalCurrencySymbol: "\uFDFC"
                    },
                    ZAR: {
                        currencySymbol: 'R',
                        internationalCurrencySymbol: 'R'
                    },
                    ZMW: {
                        currencySymbol: 'ZMK',
                        internationalCurrencySymbol: 'ZMK'
                    }
                };
                exports['default'] = NumberFormatter;
                module1.exports = exports['default'];
            },
            {
                "./formatter": 14,
                "./number_formatter_settings_formatter": 17,
                "./utils": 22,
                "stround": 3
            }
        ],
        17: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                var _formatter = _dereq_('./formatter');
                var _formatter2 = _interopRequireDefault(_formatter);
                var NumberFormatterSettings = function NumberFormatterSettings() {
                    _classCallCheck(this, NumberFormatterSettings);
                    /** @type boolean */ this.alwaysShowsDecimalSeparator = false;
                    /** @type number */ this.groupingSize = 0;
                    /** @type number */ this.maximumFractionDigits = 0;
                    /** @type number */ this.minimumFractionDigits = 0;
                    /** @type number */ this.minimumIntegerDigits = 0;
                    /** @type string */ this.prefix = '';
                    /** @type string */ this.suffix = '';
                    /** @type boolean */ this.usesGroupingSeparator = false;
                } /**
 * Returns a string composed of the given character repeated `length` times.
 *
 * @param {string} character
 * @param {number} length
 * @returns {string}
 * @private
 */ ;
                function chars(character, length) {
                    return new Array(length + 1).join(character);
                }
                /**
 * @const
 * @private
 */ var DIGIT = '#';
                /**
 * @const
 * @private
 */ var PADDING = '0';
                /**
 * @const
 * @private
 */ var DECIMAL_SEPARATOR = '.';
                /**
 * @const
 * @private
 */ var GROUPING_SEPARATOR = ',';
                var NumberFormatterSettingsFormatter = function(_Formatter) {
                    _inherits(NumberFormatterSettingsFormatter, _Formatter);
                    function NumberFormatterSettingsFormatter() {
                        _classCallCheck(this, NumberFormatterSettingsFormatter);
                        _get(Object.getPrototypeOf(NumberFormatterSettingsFormatter.prototype), 'constructor', this).apply(this, arguments);
                    }
                    _createClass(NumberFormatterSettingsFormatter, [
                        {
                            key: 'format',
                            /**
     * @param {NumberFormatterSettings} settings
     * @returns {string}
     */ value: function format(settings) {
                                var result = '';
                                var minimumIntegerDigits = settings.minimumIntegerDigits;
                                if (minimumIntegerDigits !== 0) result += chars(PADDING, minimumIntegerDigits);
                                result = DIGIT + result;
                                if (settings.usesGroupingSeparator) {
                                    while(result.length <= settings.groupingSize)result = DIGIT + result;
                                    result = result.slice(0, -settings.groupingSize) + GROUPING_SEPARATOR + result.slice(-settings.groupingSize);
                                }
                                var minimumFractionDigits = settings.minimumFractionDigits;
                                var maximumFractionDigits = settings.maximumFractionDigits;
                                var hasFractionalPart = settings.alwaysShowsDecimalSeparator || minimumFractionDigits > 0 || maximumFractionDigits > 0;
                                if (hasFractionalPart) {
                                    result += DECIMAL_SEPARATOR;
                                    for(var i = 0, _length = maximumFractionDigits; i < _length; i++)result += i < minimumFractionDigits ? PADDING : DIGIT;
                                }
                                return settings.prefix + result + settings.suffix;
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(string) {
                                var result = new NumberFormatterSettings();
                                var hasPassedPrefix = false;
                                var hasStartedSuffix = false;
                                var decimalSeparatorIndex = null;
                                var groupingSeparatorIndex = null;
                                var lastIntegerDigitIndex = null;
                                for(var i = 0, length = string.length; i < length; i++){
                                    var c = string[i];
                                    switch(c){
                                        case DIGIT:
                                            if (hasStartedSuffix) return null;
                                            hasPassedPrefix = true;
                                            if (decimalSeparatorIndex !== null) result.maximumFractionDigits++;
                                            break;
                                        case PADDING:
                                            if (hasStartedSuffix) return null;
                                            hasPassedPrefix = true;
                                            if (decimalSeparatorIndex === null) result.minimumIntegerDigits++;
                                            else {
                                                result.minimumFractionDigits++;
                                                result.maximumFractionDigits++;
                                            }
                                            break;
                                        case DECIMAL_SEPARATOR:
                                            if (hasStartedSuffix) return null;
                                            hasPassedPrefix = true;
                                            decimalSeparatorIndex = i;
                                            lastIntegerDigitIndex = i - 1;
                                            break;
                                        case GROUPING_SEPARATOR:
                                            if (hasStartedSuffix) return null;
                                            hasPassedPrefix = true;
                                            groupingSeparatorIndex = i;
                                            break;
                                        default:
                                            if (hasPassedPrefix) {
                                                hasStartedSuffix = true;
                                                result.suffix += c;
                                            } else result.prefix += c;
                                    }
                                }
                                if (decimalSeparatorIndex === null) lastIntegerDigitIndex = length - 1;
                                if (decimalSeparatorIndex === length - 1) result.alwaysShowsDecimalSeparator = true;
                                if (groupingSeparatorIndex !== null) {
                                    result.groupingSize = lastIntegerDigitIndex - groupingSeparatorIndex;
                                    result.usesGroupingSeparator = true;
                                }
                                return result;
                            }
                        }
                    ]);
                    return NumberFormatterSettingsFormatter;
                }(_formatter2['default']);
                exports['default'] = NumberFormatterSettingsFormatter;
                module1.exports = exports['default'];
            },
            {
                "./formatter": 14
            }
        ],
        18: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                /**
 * @const
 * @private
 */ var NANPPhoneDelimiters = {
                    name: 'NANPPhoneDelimiters',
                    0: '(',
                    4: ')',
                    5: ' ',
                    9: '-'
                };
                /**
 * @const
 * @private
 */ var NANPPhoneDelimitersWithOne = {
                    name: 'NANPPhoneDelimitersWithOne',
                    1: ' ',
                    2: '(',
                    6: ')',
                    7: ' ',
                    11: '-'
                };
                /**
 * @const
 * @private
 */ var E164PhoneDelimitersWithOneDigit = {
                    name: 'E164PhoneDelimitersWithOneDigit',
                    2: ' ',
                    3: '(',
                    7: ')',
                    8: ' ',
                    12: '-'
                };
                /**
 * @const
 * @private
 */ var E164PhoneDelimitersWithTwoDigit = {
                    name: 'E164PhoneDelimitersWithTwoDigit',
                    3: ' ',
                    4: '(',
                    8: ')',
                    9: ' ',
                    13: '-'
                };
                /**
 * @const
 * @private
 */ var E164PhoneDelimitersWithThreeDigit = {
                    name: 'E164PhoneDelimitersWithThreeDigit',
                    4: ' ',
                    5: '(',
                    9: ')',
                    10: ' ',
                    14: '-'
                };
                /**
 * This should match any characters in the maps above.
 *
 * @const
 * @private
 */ var DELIMITER_PATTERN = /[-\(\) ]/g;
                /**
 * @const
 * @private
 */ var DEFAULT_COUNTRY_CODE = {
                    "E164": "1",
                    "country": [
                        "American Samoa",
                        "Anguilla",
                        "Antigua and Barbuda",
                        "Bahamas",
                        "Barbados",
                        "Bermuda",
                        "British Virgin Islands",
                        "Canada",
                        "Cayman Islands",
                        "Dominica",
                        "Dominican Republic",
                        "Grenada",
                        "Guam",
                        "Jamaica",
                        "Montserrat",
                        "Northern Mariana Islands",
                        "Puerto Rico",
                        "Saint Kitts and Nevis",
                        "Saint Lucia",
                        "Saint Martin",
                        "Saint Vincent and the Grenadines",
                        "Sint Maarten",
                        "Trinidad and Tobago",
                        "Turks and Caicos Islands",
                        "U.S. Virgin Islands",
                        "United States"
                    ]
                };
                /**
 * This is an internal store for the current country
 *
 * @private
 */ var currentCountryCode = DEFAULT_COUNTRY_CODE;
                /**
 * @extends DelimitedTextFormatter
 */ var PhoneFormatter = function(_DelimitedTextFormatter) {
                    _inherits(PhoneFormatter, _DelimitedTextFormatter);
                    /**
   * @throws {Error} if anything is passed in
   * @param {Array} args
   */ function PhoneFormatter() {
                        _classCallCheck(this, PhoneFormatter);
                        _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'constructor', this).call(this);
                        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (args.length !== 0) throw new Error('were you trying to set a delimiter (' + args[0] + ')?');
                    }
                    /**
   * @param {string} chr
   * @returns {boolean}
   */ _createClass(PhoneFormatter, [
                        {
                            key: 'isDelimiter',
                            value: function isDelimiter(chr) {
                                var map = this.delimiterMap;
                                for(var index in map)if (map.hasOwnProperty(index)) {
                                    if (map[index] === chr) return true;
                                }
                                return false;
                            }
                        },
                        {
                            key: 'delimiterAt',
                            value: function delimiterAt(index) {
                                return this.delimiterMap[index];
                            }
                        },
                        {
                            key: 'hasDelimiterAtIndex',
                            value: function hasDelimiterAtIndex(index) {
                                var delimiter = this.delimiterAt(index);
                                return delimiter !== undefined && delimiter !== null;
                            }
                        },
                        {
                            key: 'parse',
                            value: function parse(text, error) {
                                if (!error) error = function() {};
                                var digits = this.digitsWithoutCountryCode(text);
                                // Source: http://en.wikipedia.org/wiki/North_American_Numbering_Plan
                                //
                                // Area Code
                                if (text.length < 10) error('phone-formatter.number-too-short');
                                if (digits[0] === '0') error('phone-formatter.area-code-zero');
                                if (digits[0] === '1') error('phone-formatter.area-code-one');
                                if (digits[1] === '9') error('phone-formatter.area-code-n9n');
                                // Central Office Code
                                if (digits[3] === '1') error('phone-formatter.central-office-one');
                                if (digits.slice(4, 6) === '11') error('phone-formatter.central-office-n11');
                                return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'parse', this).call(this, text, error);
                            }
                        },
                        {
                            key: 'format',
                            value: function format(value) {
                                this.guessFormatFromText(value);
                                return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'format', this).call(this, this.removeDelimiterMapChars(value));
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                this.guessFormatFromText(change.proposed.text);
                                if (change.inserted.text.length > 1) {
                                    // handle pastes
                                    var text = change.current.text;
                                    var selectedRange = change.current.selectedRange;
                                    var toInsert = change.inserted.text;
                                    // Replace the selection with the new text, remove non-digits, then format.
                                    var formatted = this.format((text.slice(0, selectedRange.start) + toInsert + text.slice(selectedRange.start + selectedRange.length)).replace(/[^\d]/g, ''));
                                    change.proposed = {
                                        text: formatted,
                                        selectedRange: {
                                            start: formatted.length - (text.length - (selectedRange.start + selectedRange.length)),
                                            length: 0
                                        }
                                    };
                                    return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'isChangeValid', this).call(this, change, error);
                                }
                                if (/^\d*$/.test(change.inserted.text) || change.proposed.text.indexOf('+') === 0) {
                                    var formatName = this.delimiterMap.name;
                                    // First guess at the localized format
                                    if (currentCountryCode.localizedFormat) {
                                        this.delimiterMap = currentCountryCode.localizedFormat;
                                        this.maximumLength = currentCountryCode.localizedFormat.maximumLength;
                                        formatName = 'localized-' + currentCountryCode.E164;
                                    }
                                    // We need to store the change and current format guess so that if the isChangeValid
                                    // call to super changes the proposed text such that the format we thought is no longer
                                    // valid. If that does happen we actually just rerun it through with the correct format
                                    var originalProposed = change.proposed.text;
                                    var _isChangeValid = _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'isChangeValid', this).call(this, change, error);
                                    this.guessFormatFromText(change.proposed.text);
                                    // Make sure if the localizedFormat changed, respect that
                                    if (currentCountryCode.localizedFormat) {
                                        this.delimiterMap = currentCountryCode.localizedFormat;
                                        this.maximumLength = currentCountryCode.localizedFormat.maximumLength;
                                        this.delimiterMap.name = 'localized-' + currentCountryCode.E164;
                                    }
                                    if (formatName === this.delimiterMap.name) return _isChangeValid;
                                    else {
                                        var originalChange = change;
                                        originalChange.proposed.text = originalProposed;
                                        return _get(Object.getPrototypeOf(PhoneFormatter.prototype), 'isChangeValid', this).call(this, originalChange, error);
                                    }
                                } else return false;
                            }
                        },
                        {
                            key: 'guessFormatFromText',
                            value: function guessFormatFromText(text) {
                                currentCountryCode = DEFAULT_COUNTRY_CODE;
                                if (text && text[0] === '+') {
                                    if (text.length > 1) {
                                        var isValidCountryCode = function isValidCountryCode(countryCode) {
                                            var matchingCodes = COUNTRY_CODES.filter(function(country) {
                                                return country.E164 === countryCode;
                                            });
                                            return matchingCodes.length > 0;
                                        };
                                        var rawText = this.removeDelimiterMapChars(text);
                                        if (currentCountryCode = isValidCountryCode(rawText[1])) {
                                            this.delimiterMap = E164PhoneDelimitersWithOneDigit;
                                            this.maximumLength = 17;
                                        } else if (text.length > 2 && (currentCountryCode = isValidCountryCode(rawText.slice(1, 3)))) {
                                            this.delimiterMap = E164PhoneDelimitersWithTwoDigit;
                                            this.maximumLength = 18;
                                        } else {
                                            currentCountryCode = isValidCountryCode(rawText.slice(1, 4)) || DEFAULT_COUNTRY_CODE;
                                            this.delimiterMap = E164PhoneDelimitersWithThreeDigit;
                                            this.maximumLength = 19;
                                        }
                                    } else {
                                        this.delimiterMap = E164PhoneDelimitersWithThreeDigit;
                                        this.maximumLength = 19;
                                    }
                                } else if (text && text[0] === '1') {
                                    this.delimiterMap = NANPPhoneDelimitersWithOne;
                                    this.maximumLength = 16;
                                } else if (text && text[0] === ' ') {
                                    this.delimiterMap = NANPPhoneDelimiters;
                                    this.maximumLength = 15;
                                } else {
                                    this.delimiterMap = NANPPhoneDelimiters;
                                    this.maximumLength = 14;
                                }
                            }
                        },
                        {
                            key: 'digitsWithoutCountryCode',
                            value: function digitsWithoutCountryCode(text) {
                                var digits = (text || '').replace(/[^\d]/g, '');
                                var extraDigits = digits.length - 10;
                                if (extraDigits > 0) digits = digits.substr(extraDigits);
                                return digits;
                            }
                        },
                        {
                            key: 'removeDelimiterMapChars',
                            value: function removeDelimiterMapChars(text) {
                                return (text || '').replace(DELIMITER_PATTERN, '');
                            }
                        }
                    ]);
                    return PhoneFormatter;
                }(_delimited_text_formatter2['default']);
                var COUNTRY_CODES = [
                    {
                        "E164": "93",
                        "country": "Afghanistan"
                    },
                    {
                        "E164": "355",
                        "country": "Albania"
                    },
                    {
                        "E164": "213",
                        "country": "Algeria"
                    },
                    {
                        "E164": "1",
                        "country": [
                            "American Samoa",
                            "Anguilla",
                            "Antigua and Barbuda",
                            "Bahamas",
                            "Barbados",
                            "Bermuda",
                            "British Virgin Islands",
                            "Canada",
                            "Cayman Islands",
                            "Dominica",
                            "Dominican Republic",
                            "Grenada",
                            "Guam",
                            "Jamaica",
                            "Montserrat",
                            "Northern Mariana Islands",
                            "Puerto Rico",
                            "Saint Kitts and Nevis",
                            "Saint Lucia",
                            "Saint Martin",
                            "Saint Vincent and the Grenadines",
                            "Sint Maarten",
                            "Trinidad and Tobago",
                            "Turks and Caicos Islands",
                            "U.S. Virgin Islands",
                            "United States"
                        ]
                    },
                    {
                        "E164": "376",
                        "country": "Andorra"
                    },
                    {
                        "E164": "244",
                        "country": "Angola"
                    },
                    {
                        "E164": "672",
                        "country": "Antarctica"
                    },
                    {
                        "E164": "54",
                        "country": "Argentina"
                    },
                    {
                        "E164": "374",
                        "country": "Armenia"
                    },
                    {
                        "E164": "297",
                        "country": "Aruba"
                    },
                    {
                        "E164": "43",
                        "country": "Austria"
                    },
                    {
                        "E164": "994",
                        "country": "Azerbaijan"
                    },
                    {
                        "E164": "973",
                        "country": "Bahrain"
                    },
                    {
                        "E164": "880",
                        "country": "Bangladesh"
                    },
                    {
                        "E164": "375",
                        "country": "Belarus"
                    },
                    {
                        "E164": "32",
                        "country": "Belgium"
                    },
                    {
                        "E164": "501",
                        "country": "Belize"
                    },
                    {
                        "E164": "229",
                        "country": "Benin"
                    },
                    {
                        "E164": "975",
                        "country": "Bhutan"
                    },
                    {
                        "E164": "591",
                        "country": "Bolivia"
                    },
                    {
                        "E164": "387",
                        "country": "Bosnia and Herzegovina"
                    },
                    {
                        "E164": "267",
                        "country": "Botswana"
                    },
                    {
                        "E164": "55",
                        "country": "Brazil"
                    },
                    {
                        "E164": "246",
                        "country": "British Indian Ocean Territory"
                    },
                    {
                        "E164": "673",
                        "country": "Brunei"
                    },
                    {
                        "E164": "359",
                        "country": "Bulgaria"
                    },
                    {
                        "E164": "226",
                        "country": "Burkina Faso"
                    },
                    {
                        "E164": "257",
                        "country": "Burundi"
                    },
                    {
                        "E164": "855",
                        "country": "Cambodia"
                    },
                    {
                        "E164": "237",
                        "country": "Cameroon"
                    },
                    {
                        "E164": "238",
                        "country": "Cape Verde"
                    },
                    {
                        "E164": "236",
                        "country": "Central African Republic"
                    },
                    {
                        "E164": "235",
                        "country": "Chad"
                    },
                    {
                        "E164": "56",
                        "country": "Chile"
                    },
                    {
                        "E164": "86",
                        "country": "China"
                    },
                    {
                        "E164": "61",
                        "country": [
                            "Australia",
                            "Christmas Island",
                            "Cocos Islands"
                        ]
                    },
                    {
                        "E164": "57",
                        "country": "Colombia"
                    },
                    {
                        "E164": "269",
                        "country": "Comoros"
                    },
                    {
                        "E164": "682",
                        "country": "Cook Islands"
                    },
                    {
                        "E164": "506",
                        "country": "Costa Rica"
                    },
                    {
                        "E164": "385",
                        "country": "Croatia"
                    },
                    {
                        "E164": "53",
                        "country": "Cuba"
                    },
                    {
                        "E164": "599",
                        "country": [
                            "Curacao",
                            "Netherlands Antilles"
                        ]
                    },
                    {
                        "E164": "357",
                        "country": "Cyprus"
                    },
                    {
                        "E164": "420",
                        "country": "Czech Republic"
                    },
                    {
                        "E164": "243",
                        "country": "Democratic Republic of the Congo"
                    },
                    {
                        "E164": "45",
                        "country": "Denmark"
                    },
                    {
                        "E164": "253",
                        "country": "Djibouti"
                    },
                    {
                        "E164": "670",
                        "country": "East Timor"
                    },
                    {
                        "E164": "593",
                        "country": "Ecuador"
                    },
                    {
                        "E164": "20",
                        "country": "Egypt"
                    },
                    {
                        "E164": "503",
                        "country": "El Salvador"
                    },
                    {
                        "E164": "240",
                        "country": "Equatorial Guinea"
                    },
                    {
                        "E164": "291",
                        "country": "Eritrea"
                    },
                    {
                        "E164": "372",
                        "country": "Estonia"
                    },
                    {
                        "E164": "251",
                        "country": "Ethiopia"
                    },
                    {
                        "E164": "500",
                        "country": "Falkland Islands"
                    },
                    {
                        "E164": "298",
                        "country": "Faroe Islands"
                    },
                    {
                        "E164": "679",
                        "country": "Fiji"
                    },
                    {
                        "E164": "358",
                        "country": "Finland"
                    },
                    {
                        "E164": "33",
                        "country": "France"
                    },
                    {
                        "E164": "689",
                        "country": "French Polynesia"
                    },
                    {
                        "E164": "241",
                        "country": "Gabon"
                    },
                    {
                        "E164": "220",
                        "country": "Gambia"
                    },
                    {
                        "E164": "995",
                        "country": "Georgia"
                    },
                    {
                        "E164": "49",
                        "country": "Germany"
                    },
                    {
                        "E164": "233",
                        "country": "Ghana"
                    },
                    {
                        "E164": "350",
                        "country": "Gibraltar"
                    },
                    {
                        "E164": "30",
                        "country": "Greece"
                    },
                    {
                        "E164": "299",
                        "country": "Greenland"
                    },
                    {
                        "E164": "502",
                        "country": "Guatemala"
                    },
                    {
                        "E164": "44",
                        "country": [
                            "Guernsey",
                            "Isle of Man",
                            "Jersey",
                            "United Kingdom"
                        ]
                    },
                    {
                        "E164": "224",
                        "country": "Guinea"
                    },
                    {
                        "E164": "245",
                        "country": "Guinea-Bissau"
                    },
                    {
                        "E164": "592",
                        "country": "Guyana"
                    },
                    {
                        "E164": "509",
                        "country": "Haiti"
                    },
                    {
                        "E164": "504",
                        "country": "Honduras"
                    },
                    {
                        "E164": "852",
                        "country": "Hong Kong"
                    },
                    {
                        "E164": "36",
                        "country": "Hungary"
                    },
                    {
                        "E164": "354",
                        "country": "Iceland"
                    },
                    {
                        "E164": "91",
                        "country": "India"
                    },
                    {
                        "E164": "62",
                        "country": "Indonesia"
                    },
                    {
                        "E164": "98",
                        "country": "Iran"
                    },
                    {
                        "E164": "964",
                        "country": "Iraq"
                    },
                    {
                        "E164": "353",
                        "country": "Ireland"
                    },
                    {
                        "E164": "972",
                        "country": "Israel"
                    },
                    {
                        "E164": "39",
                        "country": [
                            "Italy",
                            "Vatican"
                        ]
                    },
                    {
                        "E164": "225",
                        "country": "Ivory Coast"
                    },
                    {
                        "E164": "81",
                        "country": "Japan"
                    },
                    {
                        "E164": "962",
                        "country": "Jordan"
                    },
                    {
                        "E164": "7",
                        "country": [
                            "Kazakhstan",
                            "Russia"
                        ],
                        "localizedFormat": {
                            "maximumLength": 18,
                            2: ' ',
                            3: '(',
                            7: ')',
                            8: ' ',
                            12: '-',
                            15: '-'
                        }
                    },
                    {
                        "E164": "254",
                        "country": "Kenya"
                    },
                    {
                        "E164": "686",
                        "country": "Kiribati"
                    },
                    {
                        "E164": "383",
                        "country": "Kosovo"
                    },
                    {
                        "E164": "965",
                        "country": "Kuwait"
                    },
                    {
                        "E164": "996",
                        "country": "Kyrgyzstan"
                    },
                    {
                        "E164": "856",
                        "country": "Laos"
                    },
                    {
                        "E164": "371",
                        "country": "Latvia"
                    },
                    {
                        "E164": "961",
                        "country": "Lebanon"
                    },
                    {
                        "E164": "266",
                        "country": "Lesotho"
                    },
                    {
                        "E164": "231",
                        "country": "Liberia"
                    },
                    {
                        "E164": "218",
                        "country": "Libya"
                    },
                    {
                        "E164": "423",
                        "country": "Liechtenstein"
                    },
                    {
                        "E164": "370",
                        "country": "Lithuania"
                    },
                    {
                        "E164": "352",
                        "country": "Luxembourg"
                    },
                    {
                        "E164": "853",
                        "country": "Macao"
                    },
                    {
                        "E164": "389",
                        "country": "Macedonia"
                    },
                    {
                        "E164": "261",
                        "country": "Madagascar"
                    },
                    {
                        "E164": "265",
                        "country": "Malawi"
                    },
                    {
                        "E164": "60",
                        "country": "Malaysia"
                    },
                    {
                        "E164": "960",
                        "country": "Maldives"
                    },
                    {
                        "E164": "223",
                        "country": "Mali"
                    },
                    {
                        "E164": "356",
                        "country": "Malta"
                    },
                    {
                        "E164": "692",
                        "country": "Marshall Islands"
                    },
                    {
                        "E164": "222",
                        "country": "Mauritania"
                    },
                    {
                        "E164": "230",
                        "country": "Mauritius"
                    },
                    {
                        "E164": "262",
                        "country": [
                            "Mayotte",
                            "Reunion"
                        ]
                    },
                    {
                        "E164": "52",
                        "country": "Mexico"
                    },
                    {
                        "E164": "691",
                        "country": "Micronesia"
                    },
                    {
                        "E164": "373",
                        "country": "Moldova"
                    },
                    {
                        "E164": "377",
                        "country": "Monaco"
                    },
                    {
                        "E164": "976",
                        "country": "Mongolia"
                    },
                    {
                        "E164": "382",
                        "country": "Montenegro"
                    },
                    {
                        "E164": "212",
                        "country": [
                            "Morocco",
                            "Western Sahara"
                        ]
                    },
                    {
                        "E164": "258",
                        "country": "Mozambique"
                    },
                    {
                        "E164": "95",
                        "country": "Myanmar"
                    },
                    {
                        "E164": "264",
                        "country": "Namibia"
                    },
                    {
                        "E164": "674",
                        "country": "Nauru"
                    },
                    {
                        "E164": "977",
                        "country": "Nepal"
                    },
                    {
                        "E164": "31",
                        "country": "Netherlands"
                    },
                    {
                        "E164": "687",
                        "country": "New Caledonia"
                    },
                    {
                        "E164": "64",
                        "country": "New Zealand"
                    },
                    {
                        "E164": "64",
                        "country": "Pitcairn"
                    },
                    {
                        "E164": "505",
                        "country": "Nicaragua"
                    },
                    {
                        "E164": "227",
                        "country": "Niger"
                    },
                    {
                        "E164": "234",
                        "country": "Nigeria"
                    },
                    {
                        "E164": "683",
                        "country": "Niue"
                    },
                    {
                        "E164": "850",
                        "country": "North Korea"
                    },
                    {
                        "E164": "47",
                        "country": [
                            "Norway",
                            "Svalbard and Jan Mayen"
                        ]
                    },
                    {
                        "E164": "968",
                        "country": "Oman"
                    },
                    {
                        "E164": "92",
                        "country": "Pakistan"
                    },
                    {
                        "E164": "680",
                        "country": "Palau"
                    },
                    {
                        "E164": "970",
                        "country": "Palestine"
                    },
                    {
                        "E164": "507",
                        "country": "Panama"
                    },
                    {
                        "E164": "675",
                        "country": "Papua New Guinea"
                    },
                    {
                        "E164": "595",
                        "country": "Paraguay"
                    },
                    {
                        "E164": "51",
                        "country": "Peru"
                    },
                    {
                        "E164": "63",
                        "country": "Philippines"
                    },
                    {
                        "E164": "48",
                        "country": "Poland"
                    },
                    {
                        "E164": "351",
                        "country": "Portugal"
                    },
                    {
                        "E164": "974",
                        "country": "Qatar"
                    },
                    {
                        "E164": "242",
                        "country": "Republic of the Congo"
                    },
                    {
                        "E164": "40",
                        "country": "Romania"
                    },
                    {
                        "E164": "250",
                        "country": "Rwanda"
                    },
                    {
                        "E164": "590",
                        "country": "Saint Barthelemy"
                    },
                    {
                        "E164": "290",
                        "country": "Saint Helena"
                    },
                    {
                        "E164": "508",
                        "country": "Saint Pierre and Miquelon"
                    },
                    {
                        "E164": "685",
                        "country": "Samoa"
                    },
                    {
                        "E164": "378",
                        "country": "San Marino"
                    },
                    {
                        "E164": "239",
                        "country": "Sao Tome and Principe"
                    },
                    {
                        "E164": "966",
                        "country": "Saudi Arabia"
                    },
                    {
                        "E164": "221",
                        "country": "Senegal"
                    },
                    {
                        "E164": "381",
                        "country": "Serbia"
                    },
                    {
                        "E164": "248",
                        "country": "Seychelles"
                    },
                    {
                        "E164": "232",
                        "country": "Sierra Leone"
                    },
                    {
                        "E164": "65",
                        "country": "Singapore"
                    },
                    {
                        "E164": "421",
                        "country": "Slovakia"
                    },
                    {
                        "E164": "386",
                        "country": "Slovenia"
                    },
                    {
                        "E164": "677",
                        "country": "Solomon Islands"
                    },
                    {
                        "E164": "252",
                        "country": "Somalia"
                    },
                    {
                        "E164": "27",
                        "country": "South Africa"
                    },
                    {
                        "E164": "82",
                        "country": "South Korea"
                    },
                    {
                        "E164": "211",
                        "country": "South Sudan"
                    },
                    {
                        "E164": "34",
                        "country": "Spain"
                    },
                    {
                        "E164": "94",
                        "country": "Sri Lanka"
                    },
                    {
                        "E164": "249",
                        "country": "Sudan"
                    },
                    {
                        "E164": "597",
                        "country": "Suriname"
                    },
                    {
                        "E164": "268",
                        "country": "Swaziland"
                    },
                    {
                        "E164": "46",
                        "country": "Sweden"
                    },
                    {
                        "E164": "41",
                        "country": "Switzerland"
                    },
                    {
                        "E164": "963",
                        "country": "Syria"
                    },
                    {
                        "E164": "886",
                        "country": "Taiwan"
                    },
                    {
                        "E164": "992",
                        "country": "Tajikistan"
                    },
                    {
                        "E164": "255",
                        "country": "Tanzania"
                    },
                    {
                        "E164": "66",
                        "country": "Thailand"
                    },
                    {
                        "E164": "228",
                        "country": "Togo"
                    },
                    {
                        "E164": "690",
                        "country": "Tokelau"
                    },
                    {
                        "E164": "676",
                        "country": "Tonga"
                    },
                    {
                        "E164": "216",
                        "country": "Tunisia"
                    },
                    {
                        "E164": "90",
                        "country": "Turkey"
                    },
                    {
                        "E164": "993",
                        "country": "Turkmenistan"
                    },
                    {
                        "E164": "688",
                        "country": "Tuvalu"
                    },
                    {
                        "E164": "256",
                        "country": "Uganda"
                    },
                    {
                        "E164": "380",
                        "country": "Ukraine"
                    },
                    {
                        "E164": "971",
                        "country": "United Arab Emirates"
                    },
                    {
                        "E164": "598",
                        "country": "Uruguay"
                    },
                    {
                        "E164": "998",
                        "country": "Uzbekistan"
                    },
                    {
                        "E164": "678",
                        "country": "Vanuatu"
                    },
                    {
                        "E164": "58",
                        "country": "Venezuela"
                    },
                    {
                        "E164": "84",
                        "country": "Vietnam"
                    },
                    {
                        "E164": "681",
                        "country": "Wallis and Futuna"
                    },
                    {
                        "E164": "967",
                        "country": "Yemen"
                    },
                    {
                        "E164": "260",
                        "country": "Zambia"
                    },
                    {
                        "E164": "263",
                        "country": "Zimbabwe"
                    }
                ];
                exports['default'] = PhoneFormatter;
                module1.exports = exports['default'];
            },
            {
                "./delimited_text_formatter": 10
            }
        ],
        19: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _delimited_text_formatter = _dereq_('./delimited_text_formatter');
                var _delimited_text_formatter2 = _interopRequireDefault(_delimited_text_formatter);
                /**
 * @const
 * @private
 */ var DIGITS_PATTERN = /^\d*$/;
                /**
 * @extends DelimitedTextFormatter
 */ var SocialSecurityNumberFormatter = function(_DelimitedTextFormatter) {
                    _inherits(SocialSecurityNumberFormatter, _DelimitedTextFormatter);
                    function SocialSecurityNumberFormatter() {
                        _classCallCheck(this, SocialSecurityNumberFormatter);
                        _get(Object.getPrototypeOf(SocialSecurityNumberFormatter.prototype), 'constructor', this).call(this, '-');
                        this.maximumLength = 11;
                    }
                    /**
   * @param {number} index
   * @returns {boolean}
   */ _createClass(SocialSecurityNumberFormatter, [
                        {
                            key: 'hasDelimiterAtIndex',
                            value: function hasDelimiterAtIndex(index) {
                                return index === 3 || index === 6;
                            }
                        },
                        {
                            key: 'isChangeValid',
                            value: function isChangeValid(change, error) {
                                if (DIGITS_PATTERN.test(change.inserted.text)) return _get(Object.getPrototypeOf(SocialSecurityNumberFormatter.prototype), 'isChangeValid', this).call(this, change, error);
                                else return false;
                            }
                        }
                    ]);
                    return SocialSecurityNumberFormatter;
                }(_delimited_text_formatter2['default']);
                exports['default'] = SocialSecurityNumberFormatter;
                module1.exports = exports['default'];
            },
            {
                "./delimited_text_formatter": 10
            }
        ],
        20: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _get = function get(_x, _x2, _x3) {
                    var _again = true;
                    _function: while(_again){
                        var object = _x, property = _x2, receiver = _x3;
                        _again = false;
                        if (object === null) object = Function.prototype;
                        var desc = Object.getOwnPropertyDescriptor(object, property);
                        if (desc === undefined) {
                            var parent = Object.getPrototypeOf(object);
                            if (parent === null) return undefined;
                            else {
                                _x = parent;
                                _x2 = property;
                                _x3 = receiver;
                                _again = true;
                                desc = parent = undefined;
                                continue _function;
                            }
                        } else if ('value' in desc) return desc.value;
                        else {
                            var getter = desc.get;
                            if (getter === undefined) return undefined;
                            return getter.call(receiver);
                        }
                    }
                };
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        'default': obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                }
                var _formatter = _dereq_('./formatter');
                var _formatter2 = _interopRequireDefault(_formatter);
                var _undo_manager = _dereq_('./undo_manager');
                var _undo_manager2 = _interopRequireDefault(_undo_manager);
                var _utils = _dereq_('./utils');
                var _caret = _dereq_('./caret');
                var _caret2 = _interopRequireDefault(_caret);
                /**
 * Simulates input behavior.
 *
 * @external InputSim
 * @see https://github.com/iamJoeTaylor/input-sim
 */ var _inputSim = _dereq_('input-sim');
                /**
 * TextField is the simplest input and the base for more complex
 * types to inherit.
 *
 * @extends external:InputSim.Input
 */ var _installCaret = (0, _caret2['default'])();
                var getCaret = _installCaret.getCaret;
                var setCaret = _installCaret.setCaret;
                var TextField = function(_Input) {
                    _inherits(TextField, _Input);
                    /**
   * Sets up the initial properties of the TextField and
   * sets  up the event listeners
   *
   * @param {HTMLElement} element
   * @param {Formatter} formatter
   */ function TextField(element, formatter) {
                        _classCallCheck(this, TextField);
                        _get(Object.getPrototypeOf(TextField.prototype), 'constructor', this).call(this);
                        var caret = getCaret(element);
                        if (typeof element.get === 'function') {
                            console.warn("DEPRECATION: FieldKit.TextField instances should no longer be created with a jQuery-wrapped element.");
                            element = element.get(0);
                        }
                        this.element = element;
                        this._formatter = formatter;
                        this._enabled = true;
                        this._manualCaret = {
                            start: 0,
                            end: 0
                        };
                        this._placeholder = null;
                        this._disabledPlaceholder = null;
                        this._focusedPlaceholder = null;
                        this._unfocusedPlaceholder = null;
                        this._isDirty = false;
                        this._valueOnFocus = '';
                        this._currentValue = '';
                        // Make sure textDidChange fires while the value is correct
                        this._needsKeyUpTextDidChangeTrigger = false;
                        this._blur = (0, _utils.bind)(this._blur, this);
                        this._focus = (0, _utils.bind)(this._focus, this);
                        this._click = (0, _utils.bind)(this._click, this);
                        this._paste = (0, _utils.bind)(this._paste, this);
                        this._keyUp = (0, _utils.bind)(this._keyUp, this);
                        this._keyPress = (0, _utils.bind)(this._keyPress, this);
                        this._keyDown = (0, _utils.bind)(this._keyDown, this);
                        if (element['field-kit-text-field']) throw new Error('already attached a TextField to this element');
                        else element['field-kit-text-field'] = this;
                        element.addEventListener('keydown', this._keyDown);
                        element.addEventListener('keypress', this._keyPress);
                        element.addEventListener('keyup', this._keyUp);
                        element.addEventListener('click', this._click);
                        element.addEventListener('paste', this._paste);
                        element.addEventListener('focus', this._focus);
                        element.addEventListener('blur', this._blur);
                        if (!element.getAttribute('autocapitalize')) element.setAttribute('autocapitalize', 'off');
                        var window = element.ownerDocument.defaultView;
                        /**
     * Fixes caret bug (Android) that caused the input
     * to place inserted characters in the wrong place
     * Expected: 1234 5678|  =>  1234 5678 9|
     * Bug: 1234 5678|  =>  1234 5679| 8
     *
     * @private
     */ this._needsManualCaret = window.navigator.userAgent.toLowerCase().indexOf('android') > -1;
                        this.setText(element.value);
                        this.setSelectedRange({
                            start: caret.start,
                            length: caret.end - caret.start
                        });
                    }
                    /**
   * Helps calculate the changes after an event on a FieldKit.TextField.
   *
   * @private
   */ /**
   * **** Public Events ****
   */ /**
   * Called when the user has changed the text of the field. Can be used in
   * subclasses to perform actions suitable for this event.
   *
   * @private
   */ _createClass(TextField, [
                        {
                            key: 'textDidChange',
                            value: function textDidChange() {}
                        },
                        {
                            key: 'textFieldDidEndEditing',
                            value: function textFieldDidEndEditing() {}
                        },
                        {
                            key: 'textFieldDidBeginEditing',
                            value: function textFieldDidBeginEditing() {}
                        },
                        {
                            key: '_textDidChange',
                            value: function _textDidChange() {
                                var delegate = this._delegate;
                                this.textDidChange();
                                if (delegate && typeof delegate.textDidChange === 'function') delegate.textDidChange(this);
                                // manually fire the HTML5 input event
                                this._fireEvent('input');
                            }
                        },
                        {
                            key: '_textFieldDidEndEditing',
                            value: function _textFieldDidEndEditing() {
                                var delegate = this._delegate;
                                this.textFieldDidEndEditing();
                                if (delegate && typeof delegate.textFieldDidEndEditing === 'function') delegate.textFieldDidEndEditing(this);
                                // manually fire the HTML5 change event, only when a change has been made since focus
                                if (this._isDirty && this._valueOnFocus !== this.element.value) this._fireEvent('change');
                                // reset the dirty property
                                this._isDirty = false;
                                this._valueOnFocus = '';
                            }
                        },
                        {
                            key: '_textFieldDidBeginEditing',
                            value: function _textFieldDidBeginEditing() {
                                var delegate = this._delegate;
                                this.textFieldDidBeginEditing();
                                if (delegate && typeof delegate.textFieldDidBeginEditing === 'function') delegate.textFieldDidBeginEditing(this);
                            }
                        },
                        {
                            key: 'delegate',
                            value: function delegate() {
                                return this._delegate;
                            }
                        },
                        {
                            key: 'setDelegate',
                            value: function setDelegate(delegate) {
                                this._delegate = delegate;
                            }
                        },
                        {
                            key: 'destroy',
                            value: function destroy() {
                                var element = this.element;
                                element.removeEventListener('keydown', this._keyDown);
                                element.removeEventListener('keypress', this._keyPress);
                                element.removeEventListener('keyup', this._keyUp);
                                element.removeEventListener('click', this._click);
                                element.removeEventListener('paste', this._paste);
                                element.removeEventListener('focus', this._focus);
                                element.removeEventListener('blur', this._blur);
                                delete element['field-kit-text-field'];
                            }
                        },
                        {
                            key: 'formatter',
                            value: function formatter() {
                                if (!this._formatter) {
                                    this._formatter = new _formatter2['default']();
                                    var maximumLengthString = this.element.getAttribute('maxlength');
                                    if (maximumLengthString !== undefined && maximumLengthString !== null) this._formatter.maximumLength = parseInt(maximumLengthString, 10);
                                }
                                return this._formatter;
                            }
                        },
                        {
                            key: 'setFormatter',
                            value: function setFormatter(formatter) {
                                var value = this.value();
                                this._formatter = formatter;
                                this.setValue(value);
                            }
                        },
                        {
                            key: 'hasChangesAndIsValid',
                            value: function hasChangesAndIsValid(current, proposed) {
                                var _this = this;
                                var change = new TextFieldStateChange(this);
                                var error = function error(errorType) {
                                    var delegate = _this.delegate();
                                    if (delegate) {
                                        if (typeof delegate.textFieldDidFailToValidateChange === 'function') delegate.textFieldDidFailToValidateChange(_this, change, errorType);
                                    }
                                };
                                change.current = {
                                    text: current.text,
                                    selectedRange: current.selectedRange
                                };
                                change.proposed = {
                                    text: proposed.text,
                                    selectedRange: proposed.selectedRange
                                };
                                if (change.hasChanges() && this.formatter().isChangeValid(change, error)) return change;
                                return null;
                            }
                        },
                        {
                            key: 'insertNewline',
                            value: function insertNewline() {
                                this._textFieldDidEndEditing();
                                this._didEndEditingButKeptFocus = true;
                            }
                        },
                        {
                            key: 'inspect',
                            value: function inspect() {
                                return '#<TextField text="' + this.text() + '">';
                            }
                        },
                        {
                            key: 'readSelectionFromPasteboard',
                            value: function readSelectionFromPasteboard(pasteboard) {
                                var range = undefined, text = undefined;
                                text = pasteboard.getData('Text');
                                this.replaceSelection(text);
                                range = this.selectedRange();
                                range.start += range.length;
                                range.length = 0;
                                this.setSelectedRange(range);
                            }
                        },
                        {
                            key: 'rollbackInvalidChanges',
                            value: function rollbackInvalidChanges(callback) {
                                var result = null;
                                var errorType = null;
                                var change = TextFieldStateChange.build(this, function() {
                                    return result = callback();
                                });
                                var error = function error(type) {
                                    errorType = type;
                                };
                                if (change.hasChanges()) {
                                    var formatter = this.formatter();
                                    if (formatter && typeof formatter.isChangeValid === 'function') {
                                        if (!this._isDirty) {
                                            this._valueOnFocus = change.current.text || '';
                                            this._isDirty = true;
                                        }
                                        if (formatter.isChangeValid(change, error)) {
                                            change.recomputeDiff();
                                            this.setText(change.proposed.text);
                                            this.setSelectedRange(change.proposed.selectedRange);
                                        } else {
                                            var delegate = this.delegate();
                                            if (delegate) {
                                                if (typeof delegate.textFieldDidFailToValidateChange === 'function') delegate.textFieldDidFailToValidateChange(this, change, errorType);
                                            }
                                            this.setText(change.current.text);
                                            this.setSelectedRange(change.current.selectedRange);
                                            return result;
                                        }
                                    }
                                    if (change.inserted.text.length || change.deleted.text.length) {
                                        this.undoManager().proxyFor(this)._applyChangeFromUndoManager(change);
                                        this._textDidChange();
                                    }
                                }
                                return result;
                            }
                        },
                        {
                            key: 'value',
                            value: function value() {
                                var _this2 = this;
                                var text = this.text();
                                var delegate = this.delegate();
                                var formatter = this.formatter();
                                if (!formatter) return text;
                                return formatter.parse(text, function(errorType) {
                                    if (delegate) {
                                        if (typeof delegate.textFieldDidFailToParseString === 'function') delegate.textFieldDidFailToParseString(_this2, text, errorType);
                                    }
                                });
                            }
                        },
                        {
                            key: 'setValue',
                            value: function setValue(value) {
                                if (this._formatter) value = this._formatter.format(value);
                                this.setText('' + value);
                            }
                        },
                        {
                            key: 'text',
                            value: function text() {
                                return this.element.value;
                            }
                        },
                        {
                            key: 'setText',
                            value: function setText(text) {
                                this.element.value = text;
                                this._currentValue = text;
                            }
                        },
                        {
                            key: 'selectedRange',
                            value: function selectedRange() {
                                var caret = this._needsManualCaret ? this._manualCaret : getCaret(this.element);
                                return {
                                    start: caret.start,
                                    length: caret.end - caret.start
                                };
                            }
                        },
                        {
                            key: 'setSelectedRangeWithAffinity',
                            value: function setSelectedRangeWithAffinity(range, affinity) {
                                var newRange = _get(Object.getPrototypeOf(TextField.prototype), 'setSelectedRangeWithAffinity', this).call(this, range, affinity);
                                var caret = {
                                    start: newRange.start,
                                    end: newRange.start + newRange.length
                                };
                                this._manualCaret = caret;
                                setCaret(this.element, caret.start, caret.end);
                                this.selectionAffinity = range.length === 0 ? null : affinity;
                            }
                        },
                        {
                            key: 'allowsUndo',
                            value: function allowsUndo() {
                                return this._allowsUndo;
                            }
                        },
                        {
                            key: 'setAllowsUndo',
                            value: function setAllowsUndo(allowsUndo) {
                                this._allowsUndo = allowsUndo;
                            }
                        },
                        {
                            key: 'redo',
                            value: function redo(event) {
                                if (this.undoManager().canRedo()) this.undoManager().redo();
                                event.preventDefault();
                            }
                        },
                        {
                            key: 'undo',
                            value: function undo(event) {
                                if (this.undoManager().canUndo()) this.undoManager().undo();
                                event.preventDefault();
                            }
                        },
                        {
                            key: 'undoManager',
                            value: function undoManager() {
                                return this._undoManager || (this._undoManager = new _undo_manager2['default']());
                            }
                        },
                        {
                            key: 'becomeFirstResponder',
                            value: function becomeFirstResponder() {
                                var _this3 = this;
                                this.element.focus();
                                this.rollbackInvalidChanges(function() {
                                    _this3.element.select();
                                    _this3._syncPlaceholder();
                                });
                            }
                        },
                        {
                            key: 'hasFocus',
                            value: function hasFocus() {
                                return this.element.ownerDocument.activeElement === this.element;
                            }
                        },
                        {
                            key: 'isEnabled',
                            value: function isEnabled() {
                                return this._enabled;
                            }
                        },
                        {
                            key: 'setEnabled',
                            value: function setEnabled(enabled) {
                                this._enabled = enabled;
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: 'resignFirstResponder',
                            value: function resignFirstResponder(event) {
                                if (event !== undefined && event !== null) event.preventDefault();
                                this.element.blur();
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: 'disabledPlaceholder',
                            value: function disabledPlaceholder() {
                                return this._disabledPlaceholder;
                            }
                        },
                        {
                            key: 'setDisabledPlaceholder',
                            value: function setDisabledPlaceholder(disabledPlaceholder) {
                                this._disabledPlaceholder = disabledPlaceholder;
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: 'focusedPlaceholder',
                            value: function focusedPlaceholder() {
                                return this._focusedPlaceholder;
                            }
                        },
                        {
                            key: 'setFocusedPlaceholder',
                            value: function setFocusedPlaceholder(focusedPlaceholder) {
                                this._focusedPlaceholder = focusedPlaceholder;
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: 'placeholder',
                            value: function placeholder() {
                                return this._placeholder;
                            }
                        },
                        {
                            key: 'setPlaceholder',
                            value: function setPlaceholder(placeholder) {
                                this._placeholder = placeholder;
                                this.element.setAttribute('placeholder', this._placeholder);
                            }
                        },
                        {
                            key: 'unfocusedPlaceholder',
                            value: function unfocusedPlaceholder() {
                                return this._unfocusedPlaceholder;
                            }
                        },
                        {
                            key: 'setUnfocusedPlaceholder',
                            value: function setUnfocusedPlaceholder(unfocusedPlaceholder) {
                                this._unfocusedPlaceholder = unfocusedPlaceholder;
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: '_applyChangeFromUndoManager',
                            value: function _applyChangeFromUndoManager(change) {
                                this.undoManager().proxyFor(this)._applyChangeFromUndoManager(change);
                                if (this.undoManager().isUndoing()) {
                                    this.setText(change.current.text);
                                    this.setSelectedRange(change.current.selectedRange);
                                } else {
                                    this.setText(change.proposed.text);
                                    this.setSelectedRange(change.proposed.selectedRange);
                                }
                                this._textDidChange();
                            }
                        },
                        {
                            key: '_click',
                            value: function _click() {
                                this._manualCaret = getCaret(this.element);
                                this._selectedRange = {
                                    start: this._manualCaret.start,
                                    length: this._manualCaret.end - this._manualCaret.start
                                };
                                this.selectionAffinity = null;
                            }
                        },
                        {
                            key: '_fireEvent',
                            value: function _fireEvent(eventType) {
                                var document1 = this.element.ownerDocument;
                                var window = document1.defaultView;
                                if (typeof window.CustomEvent === 'function') this.element.dispatchEvent(new window.CustomEvent(eventType, {}));
                                else {
                                    var _event = document1.createEvent('Event');
                                    _event.initEvent(eventType, false, false);
                                    this.element.dispatchEvent(_event);
                                }
                            }
                        },
                        {
                            key: '_focus',
                            value: function _focus() {
                                this._textFieldDidBeginEditing();
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: '_blur',
                            value: function _blur() {
                                this._textFieldDidEndEditing();
                                this._syncPlaceholder();
                            }
                        },
                        {
                            key: '_keyDown',
                            value: function _keyDown(event) {
                                var _this4 = this;
                                if (this._didEndEditingButKeptFocus) {
                                    this._textFieldDidBeginEditing();
                                    this._didEndEditingButKeptFocus = false;
                                }
                                var action = this._bindings.actionForEvent(event);
                                if (action) switch(action){
                                    case 'undo':
                                    case 'redo':
                                        this[action](event);
                                        break;
                                    default:
                                        this.rollbackInvalidChanges(function() {
                                            return _this4[action](event);
                                        });
                                        break;
                                }
                            }
                        },
                        {
                            key: '_keyPress',
                            value: function _keyPress(event) {
                                var _this5 = this;
                                var keyCode = event.keyCode;
                                if (!event.metaKey && !event.ctrlKey && keyCode !== _inputSim.KEYS.ENTER && keyCode !== _inputSim.KEYS.TAB && keyCode !== _inputSim.KEYS.BACKSPACE) {
                                    if (event.charCode !== 0) (function() {
                                        var newText = String.fromCharCode(event.charCode || event.keyCode);
                                        _this5._processChange({
                                            currentText: _this5.text(),
                                            proposedText: (0, _utils.replaceStringSelection)(newText, _this5.text(), _this5.selectedRange()),
                                            onSuccess: function onSuccess(change, changeTriggeredFormatting) {
                                                if (!changeTriggeredFormatting && event instanceof KeyboardEvent) {
                                                    // HACK(JoeTaylor) Use Browser's native input when using the formatter
                                                    // would not make a difference https://code.google.com/p/chromium/issues/detail?id=32865
                                                    if (!_this5._isDirty) {
                                                        _this5._valueOnFocus = change.current.text || '';
                                                        _this5._isDirty = true;
                                                    }
                                                    _this5.undoManager().proxyFor(_this5)._applyChangeFromUndoManager(change);
                                                    _this5._manualCaret = {
                                                        start: change.proposed.selectedRange.start,
                                                        end: change.proposed.selectedRange.start + change.proposed.selectedRange.length
                                                    };
                                                    _this5._needsKeyUpTextDidChangeTrigger = true;
                                                } else {
                                                    event.preventDefault();
                                                    _this5.rollbackInvalidChanges(function() {
                                                        return _this5.insertText(newText);
                                                    });
                                                }
                                                _this5._currentValue = change.proposed.text;
                                            },
                                            onFail: function onFail() {
                                                event.preventDefault();
                                                _this5.rollbackInvalidChanges(function() {
                                                    return _this5.insertText(newText);
                                                });
                                            }
                                        });
                                    })();
                                    else event.preventDefault();
                                }
                            }
                        },
                        {
                            key: '_keyUp',
                            value: function _keyUp(event) {
                                var _this6 = this;
                                if (this._needsKeyUpTextDidChangeTrigger) {
                                    this._textDidChange();
                                    this._needsKeyUpTextDidChangeTrigger = false;
                                }
                                var keyCode = event.keyCode;
                                // NOTE: Certain Androids on Chrome always return 229
                                // https://code.google.com/p/chromium/issues/detail?id=118639
                                if (keyCode === 229) (function() {
                                    // Text has already been changed at this point, so we check the previous text
                                    // to determine whether we need to undo the change.
                                    var previousText = _this6._currentValue || '';
                                    _this6._processChange({
                                        currentText: previousText,
                                        proposedText: _this6.text(),
                                        onSuccess: function onSuccess(change, changeTriggeredFormatting) {
                                            if (changeTriggeredFormatting) {
                                                var newText = change.proposed.text;
                                                _this6.setSelectedRange(change.proposed.selectedRange);
                                                _this6.setText(newText);
                                            }
                                            if (!_this6._isDirty) {
                                                _this6._valueOnFocus = change.current.text || '';
                                                _this6._isDirty = true;
                                            }
                                            _this6.undoManager().proxyFor(_this6)._applyChangeFromUndoManager(change);
                                            _this6._textDidChange();
                                            _this6._currentValue = change.proposed.text;
                                        },
                                        onFail: function onFail() {
                                            // Need to rollback the letter input in the Keyup event because it is not valid,
                                            // so we set text to the previous state (as collected from the UndoManager).
                                            _this6.setText(previousText);
                                        }
                                    });
                                })();
                                else this.rollbackInvalidChanges(function() {
                                    if (event.keyCode === _inputSim.KEYS.TAB) _this6.selectAll(event);
                                });
                            }
                        },
                        {
                            key: '_processChange',
                            value: function _processChange(_ref) {
                                var currentText = _ref.currentText;
                                var proposedText = _ref.proposedText;
                                var onSuccess = _ref.onSuccess;
                                var _ref$onFail = _ref.onFail;
                                var onFail = _ref$onFail === undefined ? function() {} : _ref$onFail;
                                var current = {
                                    text: currentText,
                                    selectedRange: this.selectedRange()
                                };
                                var proposed = {
                                    text: proposedText,
                                    selectedRange: {
                                        start: current.selectedRange.start + 1,
                                        length: 0
                                    }
                                };
                                var change = this.hasChangesAndIsValid(current, proposed);
                                var changeTriggeredFormatting = change && (change.proposed.text !== proposed.text || change.proposed.selectedRange.start !== proposed.selectedRange.start || change.proposed.selectedRange.length !== proposed.selectedRange.length);
                                if (change) onSuccess(change, changeTriggeredFormatting);
                                else onFail();
                            }
                        },
                        {
                            key: '_paste',
                            value: function _paste(event) {
                                var _this7 = this;
                                event.preventDefault();
                                this.rollbackInvalidChanges(function() {
                                    _this7.readSelectionFromPasteboard(event.clipboardData);
                                });
                            }
                        },
                        {
                            key: '_syncPlaceholder',
                            value: function _syncPlaceholder() {
                                if (!this._enabled) {
                                    var disabledPlaceholder = this._disabledPlaceholder;
                                    if (disabledPlaceholder !== undefined && disabledPlaceholder !== null) this.setPlaceholder(disabledPlaceholder);
                                } else if (this.hasFocus()) {
                                    var focusedPlaceholder = this._focusedPlaceholder;
                                    if (focusedPlaceholder !== undefined && focusedPlaceholder !== null) this.setPlaceholder(focusedPlaceholder);
                                } else {
                                    var unfocusedPlaceholder = this._unfocusedPlaceholder;
                                    if (unfocusedPlaceholder !== undefined && unfocusedPlaceholder !== null) this.setPlaceholder(unfocusedPlaceholder);
                                }
                            }
                        }
                    ]);
                    return TextField;
                }(_inputSim.Input);
                var TextFieldStateChange = function() {
                    /**
   * @param {TextField} field
   */ function TextFieldStateChange(field) {
                        _classCallCheck(this, TextFieldStateChange);
                        this.field = field;
                    }
                    /**
   * Builds a new {TextFieldStateChange} that will allow you to
   * compute differences, and see the current vs proposed changes.
   *
   * @param {TextField} field
   * @param {Function} callback called when you want changes to the field
   *    take place. Current will be calculated before this callback.
   *    Proposed will be calculated after this callback.
   *
   * @returns {Object} change object with current and proposed properties
   */ /**
   * Determines whether this field has changes.
   *
   * @returns {boolean} true if either the current text doesn't match the proposed text
   *    or the current selection range doesn't match the proposed selection range
   */ _createClass(TextFieldStateChange, [
                        {
                            key: 'hasChanges',
                            value: function hasChanges() {
                                this.recomputeDiff();
                                return this.current.text !== this.proposed.text || this.current.selectedRange.start !== this.proposed.selectedRange.start || this.current.selectedRange.length !== this.proposed.selectedRange.length;
                            }
                        },
                        {
                            key: 'recomputeDiff',
                            value: function recomputeDiff() {
                                if (this.proposed.text !== this.current.text) {
                                    var ctext = this.current.text;
                                    var ptext = this.proposed.text;
                                    var sharedPrefixLength = 0;
                                    var sharedSuffixLength = 0;
                                    var minTextLength = Math.min(ctext.length, ptext.length);
                                    var i = undefined;
                                    for(i = 0; i < minTextLength; i++){
                                        if (ptext[i] === ctext[i]) sharedPrefixLength = i + 1;
                                        else break;
                                    }
                                    for(i = 0; i < minTextLength - sharedPrefixLength; i++){
                                        if (ptext[ptext.length - 1 - i] === ctext[ctext.length - 1 - i]) sharedSuffixLength = i + 1;
                                        else break;
                                    }
                                    var inserted = {
                                        start: sharedPrefixLength,
                                        end: ptext.length - sharedSuffixLength
                                    };
                                    var deleted = {
                                        start: sharedPrefixLength,
                                        end: ctext.length - sharedSuffixLength
                                    };
                                    inserted.text = ptext.substring(inserted.start, inserted.end);
                                    deleted.text = ctext.substring(deleted.start, deleted.end);
                                    this.inserted = inserted;
                                    this.deleted = deleted;
                                } else {
                                    this.inserted = {
                                        start: this.proposed.selectedRange.start,
                                        end: this.proposed.selectedRange.start + this.proposed.selectedRange.length,
                                        text: ''
                                    };
                                    this.deleted = {
                                        start: this.current.selectedRange.start,
                                        end: this.current.selectedRange.start + this.current.selectedRange.length,
                                        text: ''
                                    };
                                }
                            }
                        }
                    ]);
                    return TextFieldStateChange;
                }();
                TextFieldStateChange.build = function(field, callback) {
                    var change = new this(field);
                    change.current = {
                        text: field.text(),
                        selectedRange: field.selectedRange()
                    };
                    callback();
                    change.proposed = {
                        text: field.text(),
                        selectedRange: field.selectedRange()
                    };
                    change.recomputeDiff();
                    return change;
                };
                exports['default'] = TextField;
                module1.exports = exports['default'];
            },
            {
                "./caret": 8,
                "./formatter": 14,
                "./undo_manager": 21,
                "./utils": 22,
                "input-sim": 1
            }
        ],
        21: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ('value' in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
                }
                var _utils = _dereq_('./utils');
                /**
 * UndoManager is a general-purpose recorder of operations for undo and redo.
 *
 * Registering an undo action is done by specifying the changed object, along
 * with a method to invoke to revert its state and the arguments for that
 * method. When performing undo an UndoManager saves the operations reverted so
 * that you can redo the undos.
 */ var UndoManager = function() {
                    function UndoManager() {
                        _classCallCheck(this, UndoManager);
                        /** @private */ this._undos = [];
                        /** @private */ this._redos = [];
                        /** @private */ this._isUndoing = false;
                        /** @private */ this._isRedoing = false;
                    }
                    /**
   * Determines whether there are any undo actions on the stack.
   *
   * @returns {boolean}
   */ _createClass(UndoManager, [
                        {
                            key: 'canUndo',
                            value: function canUndo() {
                                return this._undos.length !== 0;
                            }
                        },
                        {
                            key: 'canRedo',
                            value: function canRedo() {
                                return this._redos.length !== 0;
                            }
                        },
                        {
                            key: 'isUndoing',
                            value: function isUndoing() {
                                return this._isUndoing;
                            }
                        },
                        {
                            key: 'isRedoing',
                            value: function isRedoing() {
                                return this._isRedoing;
                            }
                        },
                        {
                            key: 'registerUndo',
                            value: function registerUndo(target, selector) {
                                for(var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                                if (this._isUndoing) this._appendRedo.apply(this, [
                                    target,
                                    selector
                                ].concat(args));
                                else {
                                    if (!this._isRedoing) this._redos.length = 0;
                                    this._appendUndo.apply(this, [
                                        target,
                                        selector
                                    ].concat(args));
                                }
                            }
                        },
                        {
                            key: '_appendUndo',
                            value: function _appendUndo(target, selector) {
                                for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
                                this._undos.push({
                                    target: target,
                                    selector: selector,
                                    args: args
                                });
                            }
                        },
                        {
                            key: '_appendRedo',
                            value: function _appendRedo(target, selector) {
                                for(var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
                                this._redos.push({
                                    target: target,
                                    selector: selector,
                                    args: args
                                });
                            }
                        },
                        {
                            key: 'undo',
                            value: function undo() {
                                if (!this.canUndo()) throw new Error('there are no registered undos');
                                var data = this._undos.pop();
                                var target = data.target;
                                var selector = data.selector;
                                var args = data.args;
                                this._isUndoing = true;
                                target[selector].apply(target, args);
                                this._isUndoing = false;
                            }
                        },
                        {
                            key: 'redo',
                            value: function redo() {
                                if (!this.canRedo()) throw new Error('there are no registered redos');
                                var data = this._redos.pop();
                                var target = data.target;
                                var selector = data.selector;
                                var args = data.args;
                                this._isRedoing = true;
                                target[selector].apply(target, args);
                                this._isRedoing = false;
                            }
                        },
                        {
                            key: 'proxyFor',
                            value: function proxyFor(target) {
                                var proxy = {};
                                var self = this;
                                function proxyMethod(selector) {
                                    return function() {
                                        for(var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                                        self.registerUndo.apply(self, [
                                            target,
                                            selector
                                        ].concat(args));
                                    };
                                }
                                (0, _utils.getAllPropertyNames)(target).forEach(function(selector) {
                                    // don't trigger anything that has a getter
                                    if ((0, _utils.hasGetter)(target, selector)) return;
                                    // don't try to proxy properties that aren't functions
                                    if (typeof target[selector] !== 'function') return;
                                    // set up a proxy function to register an undo
                                    proxy[selector] = proxyMethod(selector);
                                });
                                return proxy;
                            }
                        }
                    ]);
                    return UndoManager;
                }();
                exports['default'] = UndoManager;
                module1.exports = exports['default'];
            },
            {
                "./utils": 22
            }
        ],
        22: [
            function(_dereq_, module1, exports) {
                /**
 * @const
 * @private
 */ 'use strict';
                Object.defineProperty(exports, '__esModule', {
                    value: true
                });
                exports.isDigits = isDigits;
                exports.startsWith = startsWith;
                exports.endsWith = endsWith;
                exports.zpad = zpad;
                exports.zpad2 = zpad2;
                exports.bind = bind;
                exports.replaceStringSelection = replaceStringSelection;
                exports.forEach = forEach;
                exports.hasGetter = hasGetter;
                exports.getAllPropertyNames = getAllPropertyNames;
                function _toConsumableArray(arr) {
                    if (Array.isArray(arr)) {
                        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                        return arr2;
                    } else return Array.from(arr);
                }
                var DIGITS_PATTERN = /^\d*$/;
                /**
 * @const
 * @private
 */ var SURROUNDING_SPACE_PATTERN = /(^\s+|\s+$)/;
                /**
 * @param {string} string
 * @returns {boolean}
 */ function isDigits(string) {
                    return DIGITS_PATTERN.test(string);
                }
                /**
 * @param {string} prefix
 * @param {string} string
 * @returns {boolean}
 */ function startsWith(prefix, string) {
                    return string.slice(0, prefix.length) === prefix;
                }
                /**
 * @param {string} suffix
 * @param {string} string
 * @returns {boolean}
 */ function endsWith(suffix, string) {
                    return string.slice(string.length - suffix.length) === suffix;
                }
                /**
 * @param {string} string
 * @returns {string}
 */ var trim = typeof ''.trim === 'function' ? function(string) {
                    return string.trim();
                } : function(string) {
                    return string.replace(SURROUNDING_SPACE_PATTERN, '');
                };
                exports.trim = trim;
                /**
 * Will pad n with `0` up until length.
 *
 * @example
 *     zpad(16, '1234');
 *     // => 0000000000001234
 *
 * @param {number} length
 * @param {(string|number)} n
 * @returns {string}
 */ function zpad(length, n) {
                    var result = '' + n;
                    while(result.length < length)result = '0' + result;
                    return result;
                }
                /**
 * Will pad n with `0` up until length is 2.
 *
 * @example
 *     zpad2('2');
 *     // => 02
 *
 * @param {(string|number)} n
 * @returns {string}
 */ function zpad2(n) {
                    return zpad(2, n);
                }
                /**
 * PhantomJS 1.9 does not have Function.bind.
 *
 * @param {Function} fn
 * @param {*} context
 * @returns {*}
 */ function bind(fn, context) {
                    return fn.bind(context);
                }
                if (!Function.prototype.bind) Function.prototype.bind = function(context) {
                    for(var _len = arguments.length, prependedArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)prependedArgs[_key - 1] = arguments[_key];
                    var self = this;
                    return function() {
                        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                        return self.apply(context, prependedArgs.concat(args));
                    };
                };
                /**
 * Replaces the characters within the selection with given text.
 *
 * @example
 *     // 12|34567|8
 *     replaceStringSelection('12345678', '00', { start: 2, length: 5 });
 *     // 12|00|8
 *
 * @param   {string} replacement
 * @param   {string} text
 * @param   {object} {start: number, length: number}
 * @returns {string}
 */ function replaceStringSelection(replacement, text, range) {
                    var end = range.start + range.length;
                    return text.substring(0, range.start) + replacement + text.substring(end);
                }
                var hasOwnProp = Object.prototype.hasOwnProperty;
                /**
 * @param {*} iterable
 * @param {Function} iterator
 */ function forEach(iterable, iterator) {
                    if (iterable && typeof iterable.forEach === 'function') iterable.forEach(iterator);
                    else if (({}).toString.call(iterable) === '[object Array]') for(var i = 0, l = iterable.length; i < l; i++)iterator.call(null, iterable[i], i, iterable);
                    else {
                        for(var key in iterable)if (hasOwnProp.call(iterable, key)) iterator.call(null, iterable[key], key, iterable);
                    }
                }
                var getOwnPropertyNames = function() {
                    var getOwnPropertyNames = Object.getOwnPropertyNames;
                    try {
                        Object.getOwnPropertyNames({}, 'sq');
                    } catch (e) {
                        // IE 8
                        getOwnPropertyNames = function(object) {
                            var result = [];
                            for(var key in object)if (hasOwnProp.call(object, key)) result.push(key);
                            return result;
                        };
                    }
                    return getOwnPropertyNames;
                }();
                var getPrototypeOf = Object.getPrototypeOf || function(object) {
                    return object.__proto__;
                };
                /**
 * @param {Object} object
 * @param {string} property
 * @returns {boolean}
 */ function hasGetter(object, property) {
                    // Skip if getOwnPropertyDescriptor throws (IE8)
                    try {
                        Object.getOwnPropertyDescriptor({}, 'sq');
                    } catch (e) {
                        return false;
                    }
                    var descriptor = undefined;
                    if (object && object.constructor && object.constructor.prototype) descriptor = Object.getOwnPropertyDescriptor(object.constructor.prototype, property);
                    if (!descriptor) descriptor = Object.getOwnPropertyDescriptor(object, property);
                    if (descriptor && descriptor.get) return true;
                    else return false;
                }
                /**
 * @param {Object} object
 * @returns {?string[]}
 */ function getAllPropertyNames(object) {
                    if (object === null || object === undefined) return [];
                    var result = getOwnPropertyNames(object);
                    var prototype = object.constructor && object.constructor.prototype;
                    while(prototype){
                        result.push.apply(result, _toConsumableArray(getOwnPropertyNames(prototype)));
                        prototype = getPrototypeOf(prototype);
                    }
                    return result;
                }
            },
            {}
        ]
    }, {}, [
        15
    ])(15);
});


function $5e640a0c964f3ee4$export$d5fa24fd308c2940({ value: value, children: children, disabled: disabled = false, formatter: formatter = new (0, $58cb02b9641cce25$exports.Formatter)(), maxlength: maxlength, placeholder: placeholder, readonly: readonly = false, type: type = "string", onTextChange: // eslint-disable-next-line @typescript-eslint/no-empty-function
onTextChange = ()=>{} }) {
    /**
   * Add field kit text field when MarketInputText has loaded. This is determined by
   * onMarketInputDidLoad. This was the most consistent way to ensure that the HTML
   * input was loaded.
   *
   * Other attempts included adding a ref and useEffect and adding
   * the field kit text field. In theory, it would have been called after first render
   * but HTML input in MarketInputText was occasionally returning `undefined` when
   * calling `getInputElement`
   */ const addFieldKit = (input)=>{
        if (value) input.value = formatter.format(value);
        const textField = new (0, $58cb02b9641cce25$exports.TextField)(input, formatter);
        /**
     * Forgo using the onMarketInputValueChange to handle text change and use
     * text field textDidChange
     */ const textDidChange = (field)=>onTextChange(field.value());
        textField.setDelegate({
            textDidChange: textDidChange
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$f8929a49510d767f), {
        "data-testid": "formatted-input-text",
        value: value && formatter ? formatter.format(value) : "",
        // NOTE(cvu): this is a hack because disabled="false" prevents the input field from being editable
        // TODO(cvu): Change once issue is fixed. Ticket: https://github.com/squareup/market/issues/4880
        disabled: disabled,
        maxlength: maxlength,
        readonly: readonly,
        placeholder: placeholder,
        onMarketInputDidLoad: (event)=>addFieldKit(event.detail.input),
        type: type,
        children: children
    });
}


function $c713dbee3e06984a$export$be4b7f1b3e13aead({ className: className, disabled: disabled = false, error: error, formatter: formatter, helper: helper, label: label, maxlength: maxlength, name: name, placeholder: placeholder, readonly: readonly = false, value: value, onTextChange: onTextChange }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$bf9d3c0d17a2f99e), {
        "data-testid": name,
        className: className,
        name: name,
        invalid: Boolean(error),
        // NOTE(cvu): this is a hack because disabled="false" prevents the input field from being editable
        // TODO(cvu): Change once issue is fixed. Ticket: https://github.com/squareup/market/issues/4880
        disabled: disabled,
        readonly: readonly,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e640a0c964f3ee4$export$d5fa24fd308c2940), {
                value: value,
                placeholder: placeholder,
                maxlength: maxlength,
                formatter: formatter,
                onTextChange: onTextChange,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    htmlFor: label,
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                "data-testid": "error",
                slot: "error",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                slot: "helper",
                style: {
                    marginBottom: 0
                },
                children: helper
            })
        ]
    });
}


var $19fc8f7d0d9a2516$export$ded0429a17534e2e;
var $19fc8f7d0d9a2516$export$ad966e170037b8a8;
var $19fc8f7d0d9a2516$export$34e0f9847d4c02dd;
var $19fc8f7d0d9a2516$export$f10e6b4aaa94c253;
var $19fc8f7d0d9a2516$export$dc6dff4b377d0f20;
var $19fc8f7d0d9a2516$export$775b4cc0f1f2bbce;
var $19fc8f7d0d9a2516$export$a9dcf7b529f2769a;
$19fc8f7d0d9a2516$export$ded0429a17534e2e = `_0sPYBa_CardCustomization_cardPreview`;
$19fc8f7d0d9a2516$export$ad966e170037b8a8 = `_0sPYBa_CardCustomization_cardPreviewContainer`;
$19fc8f7d0d9a2516$export$34e0f9847d4c02dd = `_0sPYBa_CardCustomization_container`;
$19fc8f7d0d9a2516$export$f10e6b4aaa94c253 = `_0sPYBa_CardCustomization_loadingIndicator`;
$19fc8f7d0d9a2516$export$dc6dff4b377d0f20 = `_0sPYBa_CardCustomization_pill`;
$19fc8f7d0d9a2516$export$775b4cc0f1f2bbce = `_0sPYBa_CardCustomization_signatureContent`;
$19fc8f7d0d9a2516$export$a9dcf7b529f2769a = `_0sPYBa_CardCustomization_signaturePreview`;


var $211b47b09eb34e54$export$48c2d0f2f545ac27;
var $211b47b09eb34e54$export$746c1c87f3ad3d31;
var $211b47b09eb34e54$export$8aade8ce2b5d7e87;
var $211b47b09eb34e54$export$e97739ba196b52a5;
var $211b47b09eb34e54$export$e57dd03da898490e;
$211b47b09eb34e54$export$48c2d0f2f545ac27 = `UHnzMG_CardPreview_preview`;
$211b47b09eb34e54$export$746c1c87f3ad3d31 = `UHnzMG_CardPreview_previewBack`;
$211b47b09eb34e54$export$8aade8ce2b5d7e87 = `UHnzMG_CardPreview_previewContainer`;
$211b47b09eb34e54$export$e97739ba196b52a5 = `UHnzMG_CardPreview_previewContainerRotate`;
$211b47b09eb34e54$export$e57dd03da898490e = `UHnzMG_CardPreview_previewFront`;







var $acw62 = parcelRequire("acw62");
// This value is copied from market
const $fb48b27410e45132$var$CORE_HORIZONTAL_REGULAR_THRESHOLD = 600;
function $fb48b27410e45132$export$f715c0e61b2c1a36() {
    const [windowDimensions, setWindowDimensions] = (0, $acw62.useState)({
        width: undefined,
        height: undefined,
        isMobile: false
    });
    (0, $acw62.useEffect)(()=>{
        function updateWindowDimensions() {
            setWindowDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
                isMobile: window.innerWidth < $fb48b27410e45132$var$CORE_HORIZONTAL_REGULAR_THRESHOLD
            });
        }
        window.addEventListener("resize", updateWindowDimensions);
        updateWindowDimensions();
        return ()=>window.removeEventListener("resize", updateWindowDimensions);
    }, []);
    return windowDimensions;
}
const $fb48b27410e45132$export$ada05d935211d77e = /*#__PURE__*/ (0, $acw62.createContext)({
    width: undefined,
    height: undefined,
    isMobile: false
});
function $fb48b27410e45132$export$e6e3537859e84918({ children: children }) {
    const windowDimensions = $fb48b27410e45132$export$f715c0e61b2c1a36();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fb48b27410e45132$export$ada05d935211d77e.Provider, {
        value: windowDimensions,
        children: children
    });
}


var $f0367ad0a0e81232$export$2ba01fb71ed41cb6;
var $f0367ad0a0e81232$export$38e42c68cf43b5d4;
$f0367ad0a0e81232$export$2ba01fb71ed41cb6 = `KDRO4a_Screen_button`;
$f0367ad0a0e81232$export$38e42c68cf43b5d4 = `KDRO4a_Screen_header`;


function $77a799ee7a5a2b82$export$a98515d67472a41f({ buttons: buttons = [], content: content, title: title }) {
    const windowDimensions = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    const mobileViewport = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("header-30", $f0367ad0a0e81232$export$38e42c68cf43b5d4),
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                "data-testid": "main",
                children: content
            }),
            buttons?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$a2053447cfda9df3), {
                "data-testid": "footer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$98f7e185520106d0), {
                    alignment: "stack",
                    "data-testid": "button-group",
                    children: [
                        ...buttons
                    ]
                })
            }) : null
        ]
    });
    const desktopViewport = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
            "data-testid": "main",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("header-30", $f0367ad0a0e81232$export$38e42c68cf43b5d4),
                    children: title
                }),
                content,
                buttons?.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$98f7e185520106d0), {
                    alignment: "left",
                    className: $f0367ad0a0e81232$export$2ba01fb71ed41cb6,
                    "data-testid": "button-group",
                    children: [
                        ...buttons
                    ]
                }) : null
            ]
        })
    });
    return windowDimensions.isMobile ? mobileViewport : desktopViewport;
}


const $76f6a20479f97bf3$var$SIGNATURE_FONT_SIZE = 32;
function $76f6a20479f97bf3$export$4eecc657670f7f54({ businessName: businessName, customizeSignatureActive: customizeSignatureActive, customSignatureInputError: customSignatureInputError, customSignatureInputHelper: customSignatureInputHelper, fontFamilies: fontFamilies, loading: loading, signatureInputText: signatureInputText, signatureText: signatureText, selectedFontFamily: selectedFontFamily, onCustomizeSignatureToggle: onCustomizeSignatureToggle, onNextClick: onNextClick, onSignatureFontChange: onSignatureFontChange, onSignatureTextChange: onSignatureTextChange }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "cardCustomization"
    });
    const [fontsLoaded, setFontsLoaded] = (0, $acw62.useState)(false);
    const [loadedFontFamilies, setLoadedFontFamilies] = (0, $acw62.useState)([]);
    const loadSignatureFont = async (font)=>{
        try {
            const observer = new (0, (/*@__PURE__*/$parcel$interopDefault($e000fdea42d59506$exports)))(font);
            await observer.load();
            return font;
        } catch  {
            return null;
        }
    };
    (0, $acw62.useEffect)(()=>{
        setFontsLoaded(false);
        Promise.all(fontFamilies.map(loadSignatureFont)).then((fonts)=>{
            const loadedFonts = fonts.filter((0, $e414140c55630b60$export$26128561c93f5847));
            setLoadedFontFamilies(loadedFonts);
            setFontsLoaded(true);
        });
    }, [
        fontFamilies
    ]);
    const onFontSelectionChange = (event)=>{
        const font = event.detail.value;
        onSignatureFontChange(font);
    };
    const cardSignatureList = fontsLoaded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $19fc8f7d0d9a2516$export$775b4cc0f1f2bbce),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                error: customSignatureInputError,
                helper: customSignatureInputHelper,
                name: t("customSignatureTextLabel"),
                label: t("customSignatureTextLabel"),
                value: signatureInputText,
                onTextChange: onSignatureTextChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$5f38cc4b3e71c577), {
                interactive: true,
                value: selectedFontFamily,
                children: loadedFontFamilies.map((fontFamily)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$14eeaa98ef1abeb2), {
                        value: fontFamily,
                        onMarketRowSelected: onFontSelectionChange,
                        "data-testid": "font-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                slot: "label",
                                style: {
                                    fontFamily: fontFamily
                                },
                                className: (0, $19fc8f7d0d9a2516$export$a9dcf7b529f2769a),
                                children: signatureText
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$3f5cc96cec366be4), {
                                slot: "control"
                            })
                        ]
                    }, fontFamily))
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$28c2b904b2ab5c88), {
        className: (0, $19fc8f7d0d9a2516$export$f10e6b4aaa94c253)
    });
    const buttons = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
            rank: "primary",
            isLoading: loading,
            onClick: onNextClick,
            children: t("nextButtonText")
        }, t("nextButtonText"))
    ];
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $19fc8f7d0d9a2516$export$34e0f9847d4c02dd),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $19fc8f7d0d9a2516$export$ad966e170037b8a8),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $19fc8f7d0d9a2516$export$ded0429a17534e2e),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25a3c353e703cc79$export$35617c7a4abfbad0), {
                        className: (0, $211b47b09eb34e54$export$48c2d0f2f545ac27),
                        businessName: businessName,
                        boundingBox: (0, $74c7b72a71b76868$export$9a1b8f2a422bb03a),
                        estimatedFontSize: $76f6a20479f97bf3$var$SIGNATURE_FONT_SIZE,
                        fontFamily: selectedFontFamily,
                        nameOnCard: customizeSignatureActive ? signatureText : ""
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$14eeaa98ef1abeb2), {
                    selected: customizeSignatureActive,
                    onMarketRowSelected: ()=>onCustomizeSignatureToggle(true),
                    onMarketRowDeselected: ()=>onCustomizeSignatureToggle(false),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            slot: "label",
                            children: [
                                t("createCustomSignatureText"),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$2deb0c47cc93ce63), {
                                    size: "small",
                                    className: (0, $19fc8f7d0d9a2516$export$dc6dff4b377d0f20),
                                    children: t("optionalPillText")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$1df005bf392232de), {
                            slot: "control"
                        })
                    ]
                })
            }),
            customizeSignatureActive ? cardSignatureList : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77a799ee7a5a2b82$export$a98515d67472a41f), {
        buttons: buttons,
        content: content,
        title: t("title")
    });
}






/**
 * NOTE(cvu): To try to not bake a specific translations library into in the card customization workflow
 * and not require CardCustomizationComponent to not import or reference the workflow, an intermediary
 * place was needed to map the error states to translation strings. ConnectedCardCustomization was the best
 * place for it. But for the sake of allowing me to test these functions easier, I have moved these functions
 * into a separate file.
 */ 
const $d3c3b5d7e6f92cf0$export$e0eaa81363ef94db = (t)=>(customSignatureInputError, signatureInputText)=>{
        if (customSignatureInputError.length === 0) return "";
        switch(customSignatureInputError[0]){
            case (0, $d50f52fc18ffa921$export$b58c4be94c1619ca).ContainsEmoji:
                return t("customSignatureError.containsEmoji");
            case (0, $d50f52fc18ffa921$export$b58c4be94c1619ca).Empty:
                return t("customSignatureError.empty");
            case (0, $d50f52fc18ffa921$export$b58c4be94c1619ca).ExceededMaxLength:
                return t("customSignatureError.exceedsMaxLength", {
                    replace: {
                        overLimitAmount: signatureInputText.length - (0, $d50f52fc18ffa921$export$6bcdc49eab1cd857)
                    }
                });
        }
    };
const $d3c3b5d7e6f92cf0$export$a942d43ed793e30d = (t)=>(signatureText)=>{
        return t("customSignatureHelper", {
            replace: {
                charactersLeft: (0, $d50f52fc18ffa921$export$6bcdc49eab1cd857) - signatureText.length
            }
        });
    };
const $d3c3b5d7e6f92cf0$export$44fc99b272868206 = (t)=>(signatureText)=>signatureText || t("emptySignaturePlaceholder");


function $7079a22d48a3517c$export$10055180eae25861({ state: state, dispatch: dispatch }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "cardCustomization"
    });
    const mapToProps = ({ state: state, dispatch: dispatch })=>({
            businessName: state.businessName,
            loading: state.cardCustomizationState.loading,
            customizeSignatureActive: state.cardCustomizationState.toggleCustomSignature,
            customSignatureInputError: (0, $d3c3b5d7e6f92cf0$export$e0eaa81363ef94db)(t)(state.cardCustomizationState.customSignatureInputError, state.cardCustomizationState.signatureInputText),
            customSignatureInputHelper: (0, $d3c3b5d7e6f92cf0$export$a942d43ed793e30d)(t)(state.cardCustomizationState.signatureText),
            signatureInputText: state.cardCustomizationState.signatureInputText,
            signatureText: (0, $d3c3b5d7e6f92cf0$export$44fc99b272868206)(t)(state.cardCustomizationState.signatureInputText),
            selectedFontFamily: state.cardCustomizationState.signatureFont,
            fontFamilies: (0, $8ac095e22cd80964$export$970f1491a494c331),
            onCustomizeSignatureToggle: (value)=>dispatch((0, $d50f52fc18ffa921$export$74d52cff822ce1fe)(value)),
            onNextClick: ()=>dispatch((0, $d50f52fc18ffa921$export$69864c1ae20800a8)()),
            onSignatureFontChange: (signatureFont)=>dispatch((0, $d50f52fc18ffa921$export$817cb1cc86775b9b)(signatureFont)),
            onSignatureTextChange: (signatureInputText)=>dispatch((0, $d50f52fc18ffa921$export$22e3bdf54f208610)(signatureInputText))
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76f6a20479f97bf3$export$4eecc657670f7f54), {
        ...mapToProps({
            state: state,
            dispatch: dispatch
        })
    });
}












const $ca1292c5dc2fbd33$export$e41c4cad2141beb = (callback)=>(event)=>{
        callback(event.detail.value);
    };
const $ca1292c5dc2fbd33$export$7e6c12e5558cec76 = (callback)=>(event)=>{
        callback?.(event.detail);
    };
const $ca1292c5dc2fbd33$export$f61b557f7731a103 = (callback)=>(event)=>{
        callback(event.detail.code);
    };
const $ca1292c5dc2fbd33$export$3a4e95f5f650d5aa = (callback)=>(_event)=>{
        callback?.();
    };


function $3517bb91938c0291$export$d55b50a564d0b931({ value: value, name: name, label: label, listRows: listRows, className: className, disabled: disabled = false, error: error, readonly: readonly = false, onSelectChange: onSelectChange }) {
    const onMarketSelectValueDidChange = (0, $ca1292c5dc2fbd33$export$7e6c12e5558cec76)(onSelectChange);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$bf9d3c0d17a2f99e), {
        className: className,
        name: name,
        invalid: Boolean(error),
        // TODO(cvu): this is a dumb hack because disabled="false" prevents the input field from being editable
        // TODO(cvu): file a bug with the market team
        disabled: disabled,
        readonly: readonly,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$29823418345456dd), {
            onMarketSelectValueDidChange: onMarketSelectValueDidChange,
            value: value,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    children: label
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$5f38cc4b3e71c577), {
                    slot: "list",
                    children: listRows
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                    slot: "error",
                    children: error
                })
            ]
        })
    });
}



/**
 * NOTE(cvu): COPIED FROM @banking DASHBOARD. DO NOT EDIT
 */ 
class $0d407af57388fa01$export$2e2bcd8739ae039 extends (0, $58cb02b9641cce25$exports.DelimitedTextFormatter) {
    constructor(){
        super("-", /* isLazy = */ true);
        this.maximumLength = 10;
    }
    hasDelimiterAtIndex(index) {
        return index === 5;
    }
    format(str) {
        if (/\d{5}-\d{4}/.test(str)) return super.format(str.replace(/-/, ""));
        return super.format(str);
    }
    isChangeValid(change, error) {
        if (/^\d*$/.test(change.inserted.text)) return super.isChangeValid(change, error);
        else return false;
    }
}


function $7da9a08062adf300$export$73974d1f547d9d48({ administrativeDistrictLevelOneList: administrativeDistrictLevelOneList, addressLineOne: addressLineOne, addressLineOneError: addressLineOneError, addressLineTwo: addressLineTwo, locality: locality, localityError: localityError, administrativeDistrictLevelOne: administrativeDistrictLevelOne, administrativeDistrictLevelOneError: administrativeDistrictLevelOneError, postalCode: postalCode, postalCodeError: postalCodeError, onAddressLineOneChange: onAddressLineOneChange, onAddressLineTwoChange: onAddressLineTwoChange, onLocalityChange: onLocalityChange, onAdministrativeDistrictLevelOneChange: onAdministrativeDistrictLevelOneChange, onPostalCodeChange: onPostalCodeChange }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("components", {
        keyPrefix: "address"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "market-grid-container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                name: "addressLineOne",
                label: t("label.addressLine1"),
                className: "market-grid-item-full",
                value: addressLineOne,
                error: addressLineOneError,
                onTextChange: onAddressLineOneChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                name: "addressLineTwo",
                label: t("label.addressLine2"),
                className: "market-grid-item-full",
                value: addressLineTwo,
                onTextChange: onAddressLineTwoChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                name: "locality",
                label: t("label.locality"),
                className: "market-grid-item-full",
                value: locality,
                error: localityError,
                onTextChange: onLocalityChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3517bb91938c0291$export$d55b50a564d0b931), {
                name: "administrativeDistrictLevelOne",
                label: t("label.administrativeDistrictLevel1"),
                listRows: administrativeDistrictLevelOneList.map((district)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$14eeaa98ef1abeb2), {
                        value: district,
                        children: district
                    }, district)),
                className: "market-grid-item-medium",
                value: administrativeDistrictLevelOne,
                error: administrativeDistrictLevelOneError,
                onSelectChange: onAdministrativeDistrictLevelOneChange
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                name: "postalCode",
                label: t("label.postalCode"),
                className: "market-grid-item-medium",
                formatter: new (0, $0d407af57388fa01$export$2e2bcd8739ae039)(),
                value: postalCode,
                error: postalCodeError,
                onTextChange: onPostalCodeChange
            })
        ]
    });
}



function $6b060c5e2a8b2d89$export$4b61e541da9ec969({ administrativeDistrictLevelOneList: administrativeDistrictLevelOneList, addressLineOne: addressLineOne, addressLineOneError: addressLineOneError, addressLineTwo: addressLineTwo, loading: loading, locality: locality, localityError: localityError, administrativeDistrictLevelOne: administrativeDistrictLevelOne, administrativeDistrictLevelOneError: administrativeDistrictLevelOneError, postalCode: postalCode, postalCodeError: postalCodeError, onAddressLineOneChange: onAddressLineOneChange, onAddressLineTwoChange: onAddressLineTwoChange, onLocalityChange: onLocalityChange, onAdministrativeDistrictLevelOneChange: onAdministrativeDistrictLevelOneChange, onPostalCodeChange: onPostalCodeChange, onNextClick: onNextClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "shippingAddress"
    });
    const buttons = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
            rank: "primary",
            isLoading: loading,
            onClick: onNextClick,
            children: t("buttonContinueTitle")
        }, t("buttonContinueTitle"))
    ];
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7da9a08062adf300$export$73974d1f547d9d48), {
            administrativeDistrictLevelOneList: administrativeDistrictLevelOneList,
            addressLineOne: addressLineOne,
            addressLineOneError: addressLineOneError,
            addressLineTwo: addressLineTwo,
            locality: locality,
            localityError: localityError,
            administrativeDistrictLevelOne: administrativeDistrictLevelOne,
            administrativeDistrictLevelOneError: administrativeDistrictLevelOneError,
            postalCode: postalCode,
            postalCodeError: postalCodeError,
            onAddressLineOneChange: onAddressLineOneChange,
            onAddressLineTwoChange: onAddressLineTwoChange,
            onLocalityChange: onLocalityChange,
            onAdministrativeDistrictLevelOneChange: onAdministrativeDistrictLevelOneChange,
            onPostalCodeChange: onPostalCodeChange
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77a799ee7a5a2b82$export$a98515d67472a41f), {
        buttons: buttons,
        content: content,
        title: t("title")
    });
}





const $95fea94033a7ccce$export$375b49718dbd9ced = (t)=>(field, validationRecord)=>{
        if (validationRecord.valid) return "";
        switch(validationRecord.errors[field][0]){
            case (0, $a4c47930ee9facdd$export$804a92ba667853be).Empty:
                return t(`shippingAddress.errors.emptyField`, {
                    ns: "card-issuing",
                    replace: {
                        field: t(`address.label.${field}`, {
                            ns: "components"
                        })
                    }
                });
            case (0, $a9356ac90e965f5c$export$74e717fd56f132db).Invalid:
                return t(`shippingAddress.errors.invalidPostalCode`, {
                    ns: "card-issuing",
                    replace: {
                        field: t(`address.label.${field}`, {
                            ns: "components"
                        })
                    }
                });
        }
    };
function $95fea94033a7ccce$export$e6c073bff812bf4e({ state: state, dispatch: dispatch }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const getErrorStringFunc = $95fea94033a7ccce$export$375b49718dbd9ced(t);
    const mapToProps = ({ state: state, dispatch: dispatch })=>({
            administrativeDistrictLevelOneList: state.cardShippingState.countryAddressData ? (0, $a4c47930ee9facdd$export$7b943f50522d3fc4)(state.cardShippingState.countryAddressData) : [],
            addressLineOne: state.cardShippingState.address.addressLine1,
            addressLineOneError: getErrorStringFunc((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).AddressLine1, state.cardShippingState.validation),
            addressLineTwo: state.cardShippingState.address.addressLine2,
            loading: state.cardShippingState.loading || state.loading,
            locality: state.cardShippingState.address.locality,
            localityError: getErrorStringFunc((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).Locality, state.cardShippingState.validation),
            administrativeDistrictLevelOne: state.cardShippingState.address.administrativeDistrictLevel1,
            administrativeDistrictLevelOneError: getErrorStringFunc((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).AdministrativeDistrictLevel1, state.cardShippingState.validation),
            postalCode: state.cardShippingState.address.postalCode,
            postalCodeError: getErrorStringFunc((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).PostalCode, state.cardShippingState.validation),
            onAddressLineOneChange: (value)=>dispatch((0, $a4c47930ee9facdd$export$426fffe680412262)((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).AddressLine1, value)),
            onAddressLineTwoChange: (value)=>dispatch((0, $a4c47930ee9facdd$export$426fffe680412262)((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).AddressLine2, value)),
            onLocalityChange: (value)=>dispatch((0, $a4c47930ee9facdd$export$426fffe680412262)((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).Locality, value)),
            onAdministrativeDistrictLevelOneChange: ({ value: value })=>{
                // Value can string or array of any value. Asserting to ensure the value is a string
                (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(typeof value === "string", "Market select value is not a string");
                dispatch((0, $a4c47930ee9facdd$export$426fffe680412262)((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).AdministrativeDistrictLevel1, value));
            },
            onPostalCodeChange: (value)=>dispatch((0, $a4c47930ee9facdd$export$426fffe680412262)((0, $a4c47930ee9facdd$export$4b2f75d0e5275120).PostalCode, value)),
            onNextClick: ()=>dispatch((0, $a4c47930ee9facdd$export$848ce7d6602fe3bd)())
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b060c5e2a8b2d89$export$4b61e541da9ec969), {
        ...mapToProps({
            state: state,
            dispatch: dispatch
        })
    });
}







var $2fa5cd385f265c4c$export$2ba01fb71ed41cb6;
var $2fa5cd385f265c4c$export$34e0f9847d4c02dd;
var $2fa5cd385f265c4c$export$6d59db4903f20f7d;
var $2fa5cd385f265c4c$export$38e42c68cf43b5d4;
var $2fa5cd385f265c4c$export$79b7ea2066c6e4f9;
var $2fa5cd385f265c4c$export$c96745152eb2740f;
$2fa5cd385f265c4c$export$2ba01fb71ed41cb6 = `GdpZFa_CardOrderedConfirmation_button`;
$2fa5cd385f265c4c$export$34e0f9847d4c02dd = `GdpZFa_CardOrderedConfirmation_container`;
$2fa5cd385f265c4c$export$6d59db4903f20f7d = `GdpZFa_CardOrderedConfirmation_description`;
$2fa5cd385f265c4c$export$38e42c68cf43b5d4 = `GdpZFa_CardOrderedConfirmation_header`;
$2fa5cd385f265c4c$export$79b7ea2066c6e4f9 = `GdpZFa_CardOrderedConfirmation_subtext`;
$2fa5cd385f265c4c$export$c96745152eb2740f = `GdpZFa_CardOrderedConfirmation_subtitle`;


// TODO(cvu): pass card customization into this svg via prop

function $0a88d3f9b6a1b5a9$export$b5be2bc9038e471b() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "364",
        height: "245",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                xmlns: "http://www.w3.org/2000/svg",
                id: "c",
                clipRule: "evenodd",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "244",
                    height: "244",
                    x: "54.5",
                    y: ".5",
                    fill: "#fff",
                    fillOpacity: ".01",
                    rx: "122"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "244",
                height: "244",
                x: "54.5",
                y: ".5",
                fill: "#000",
                fillOpacity: ".04",
                rx: "122"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "244",
                height: "244",
                x: "54.5",
                y: ".5",
                fill: "url(#a)",
                fillOpacity: ".2",
                rx: "122"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "#006AFF",
                strokeLinecap: "round",
                strokeWidth: "3.17",
                d: "M115.713 107.915H10.864M115.713 107.915H10.864M141.988 107.915h-18.726"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#c)",
                filter: "url(#b)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "200",
                        height: "124.198",
                        x: "142.5",
                        y: "60.5",
                        fill: "#fff",
                        rx: "4.665"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#F1F3F5",
                        fillRule: "evenodd",
                        d: "M308.166 70.053a3.881 3.881 0 0 0-3.881 3.88v20.9a3.881 3.881 0 0 0 3.881 3.88h20.899a3.88 3.88 0 0 0 3.881-3.88v-20.9a3.88 3.88 0 0 0-3.881-3.88h-20.899Zm2.687 5.374c-.659 0-1.194.534-1.194 1.194v15.525c0 .66.535 1.194 1.194 1.194h15.525c.66 0 1.194-.535 1.194-1.194V76.62c0-.66-.534-1.194-1.194-1.194h-15.525Zm4.479 4.777a.896.896 0 0 0-.896.896v6.568c0 .495.401.896.896.896h6.568a.896.896 0 0 0 .896-.896V81.1a.896.896 0 0 0-.896-.895h-6.568Z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "url(#d)",
                        fillOpacity: ".3",
                        fillRule: "evenodd",
                        d: "M308.166 70.053a3.881 3.881 0 0 0-3.881 3.88v20.9a3.881 3.881 0 0 0 3.881 3.88h20.899a3.88 3.88 0 0 0 3.881-3.88v-20.9a3.88 3.88 0 0 0-3.881-3.88h-20.899Zm2.687 5.374c-.659 0-1.194.534-1.194 1.194v15.525c0 .66.535 1.194 1.194 1.194h15.525c.66 0 1.194-.535 1.194-1.194V76.62c0-.66-.534-1.194-1.194-1.194h-15.525Zm4.479 4.777a.896.896 0 0 0-.896.896v6.568c0 .495.401.896.896.896h6.568a.896.896 0 0 0 .896-.896V81.1a.896.896 0 0 0-.896-.895h-6.568Z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "url(#e)",
                        d: "M162.802 102.297h23.884v18.48h-23.884z",
                        opacity: ".8"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#101314",
                        d: "M252.603 175.199v-6.219h.841v6.219h-.841Zm-2.016-5.923v-.764h4.873v.764h-4.873Zm7.317 6.019c-.452 0-.85-.109-1.194-.325a2.224 2.224 0 0 1-.784-.908 3.017 3.017 0 0 1-.277-1.309c0-.515.093-.974.277-1.375.185-.408.446-.73.784-.965a1.997 1.997 0 0 1 1.175-.354c.49 0 .901.109 1.232.325.331.217.58.506.745.87.172.356.258.757.258 1.203v.43h-4.079v-.64h3.583l-.287.048c-.006-.471-.14-.847-.401-1.127-.261-.281-.612-.421-1.051-.421-.299 0-.557.077-.774.229a1.377 1.377 0 0 0-.497.65c-.114.287-.172.637-.172 1.051l-.009.096c0 .388.067.719.2.993.134.268.312.475.535.621.23.14.475.21.736.21.318 0 .58-.063.783-.191.211-.133.376-.321.497-.563h.803a2.1 2.1 0 0 1-.793 1.07c-.37.254-.8.382-1.29.382Zm3.303-.096v-6.993H262v6.993h-.793Zm3.789.096c-.357 0-.675-.064-.955-.191a1.634 1.634 0 0 1-.66-.545 1.7 1.7 0 0 1-.286-.841h.774c.051.262.165.478.343.65.185.166.446.248.784.248.337 0 .611-.073.822-.219a.688.688 0 0 0 .315-.593c0-.248-.083-.43-.249-.544-.159-.121-.372-.204-.64-.249l-.707-.124a2.003 2.003 0 0 1-.678-.248 1.394 1.394 0 0 1-.487-.478 1.36 1.36 0 0 1-.172-.697c0-.281.076-.526.229-.736.159-.21.373-.373.64-.487.274-.121.58-.182.917-.182.491 0 .898.121 1.223.363.331.236.532.58.602 1.032h-.745a.859.859 0 0 0-.373-.535 1.243 1.243 0 0 0-.716-.2c-.3 0-.548.063-.745.191a.607.607 0 0 0-.287.535c0 .439.322.716.965.831l.659.114c.376.064.691.204.946.421.255.21.382.532.382.965 0 .293-.08.554-.239.783a1.634 1.634 0 0 1-.669.545 2.426 2.426 0 0 1-.993.191Zm5.056 0c-.484 0-.898-.112-1.241-.335a2.23 2.23 0 0 1-.793-.936 3.23 3.23 0 0 1-.268-1.347c0-.382.051-.732.153-1.051.102-.318.251-.592.449-.821.204-.236.446-.418.726-.545.287-.134.611-.201.974-.201.485 0 .899.115 1.242.344.344.223.606.532.784.927.185.388.277.838.277 1.347 0 .382-.051.732-.153 1.051a2.353 2.353 0 0 1-.459.831 2.137 2.137 0 0 1-.726.545c-.28.127-.601.191-.965.191Zm0-.717c.3 0 .561-.073.784-.22.223-.146.398-.359.525-.64.128-.286.191-.633.191-1.041 0-.611-.14-1.08-.42-1.404-.274-.332-.634-.497-1.08-.497a1.42 1.42 0 0 0-.783.22 1.456 1.456 0 0 0-.525.649c-.128.28-.191.624-.191 1.032 0 .611.136 1.083.41 1.414.281.325.644.487 1.089.487Zm3.396.621v-5.044h.716v.793h.077c.127-.249.315-.459.564-.631.254-.172.579-.258.974-.258.573 0 .997.172 1.271.516.28.338.42.806.42 1.405v3.219h-.793v-3.143c0-.471-.099-.802-.296-.994-.198-.191-.462-.286-.793-.286-.433 0-.768.143-1.003.43-.229.28-.344.646-.344 1.098v2.895h-.793Zm10.746.096c-.573 0-1.079-.14-1.519-.421a2.916 2.916 0 0 1-1.041-1.184c-.248-.516-.373-1.128-.373-1.835 0-.528.07-1.003.211-1.423.146-.427.35-.79.611-1.089.261-.3.57-.529.927-.688a2.92 2.92 0 0 1 1.184-.239c.51 0 .946.086 1.309.258.37.172.666.411.889.717.223.305.369.659.439 1.06h-.86c-.102-.414-.302-.729-.602-.946-.293-.216-.684-.325-1.175-.325-.293 0-.57.061-.831.182a1.917 1.917 0 0 0-.669.535 2.624 2.624 0 0 0-.439.841 3.532 3.532 0 0 0-.162 1.117c0 .555.092 1.032.277 1.433.184.402.436.711.754.927.319.21.675.315 1.07.315.484 0 .873-.114 1.166-.343.293-.23.516-.545.669-.946h.831a2.757 2.757 0 0 1-.917 1.49c-.459.376-1.042.564-1.749.564Zm5.824 0c-.484 0-.898-.112-1.242-.335a2.237 2.237 0 0 1-.793-.936 3.245 3.245 0 0 1-.267-1.347c0-.382.051-.732.153-1.051.102-.318.251-.592.449-.821.204-.236.446-.418.726-.545a2.27 2.27 0 0 1 .974-.201c.484 0 .898.115 1.242.344.344.223.605.532.784.927.184.388.277.838.277 1.347 0 .382-.051.732-.153 1.051a2.353 2.353 0 0 1-.459.831 2.137 2.137 0 0 1-.726.545c-.28.127-.602.191-.965.191Zm0-.717c.3 0 .561-.073.784-.22.223-.146.398-.359.525-.64.127-.286.191-.633.191-1.041 0-.611-.14-1.08-.42-1.404-.274-.332-.634-.497-1.08-.497-.293 0-.554.073-.783.22a1.464 1.464 0 0 0-.526.649c-.127.28-.191.624-.191 1.032 0 .611.137 1.083.411 1.414.28.325.643.487 1.089.487Zm3.396.621v-5.044h.716v.793h.077a1.71 1.71 0 0 1 .563-.631c.255-.172.58-.258.975-.258.573 0 .997.172 1.27.516.281.338.421.806.421 1.405v3.219h-.793v-3.143c0-.471-.099-.802-.296-.994-.198-.191-.462-.286-.793-.286-.433 0-.768.143-1.003.43-.23.28-.344.646-.344 1.098v2.895h-.793Zm7.037 0c-.433 0-.761-.143-.984-.43-.223-.286-.334-.672-.334-1.156v-4.643h.793v4.643c0 .293.06.513.181.66.128.14.303.21.526.21h.64v.716h-.822Zm-2.216-4.375v-.669h3.038v.669h-3.038Zm4.07 4.375v-5.044h.717v.879h.076c.07-.28.229-.497.478-.65.254-.153.554-.229.898-.229h.477v.716h-.582c-.363 0-.666.134-.908.402-.242.267-.363.633-.363 1.098v2.828h-.793Zm4.873.096c-.478 0-.86-.137-1.147-.411-.28-.28-.42-.634-.42-1.061 0-.471.159-.831.477-1.079.325-.255.749-.401 1.271-.44l1.357-.095v-.583a.897.897 0 0 0-.124-.478.79.79 0 0 0-.363-.305 1.45 1.45 0 0 0-.583-.105c-.274 0-.507.063-.698.191a.884.884 0 0 0-.382.554h-.802c.044-.287.153-.535.324-.745a1.65 1.65 0 0 1 .66-.497c.274-.121.573-.182.898-.182.395 0 .729.058 1.003.172.28.115.493.287.64.516.146.223.22.5.22.831v3.621h-.717v-.821h-.076a1.501 1.501 0 0 1-.593.678 1.813 1.813 0 0 1-.945.239Zm.181-.688c.261 0 .494-.064.698-.191.203-.128.363-.306.477-.535.121-.229.182-.494.182-.793v-.277l-1.194.086c-.37.025-.644.118-.822.277a.778.778 0 0 0-.258.611c0 .236.08.433.239.593.159.152.385.229.678.229Zm5.526.688c-.471 0-.879-.115-1.223-.344a2.272 2.272 0 0 1-.783-.936 3.162 3.162 0 0 1-.277-1.338c0-.497.092-.943.277-1.337.185-.395.446-.707.783-.937.344-.229.752-.344 1.223-.344.567 0 1.032.137 1.395.411.363.274.583.656.659 1.147h-.793a1.142 1.142 0 0 0-.439-.612c-.204-.153-.478-.229-.822-.229-.28 0-.535.079-.764.239a1.529 1.529 0 0 0-.526.659c-.127.28-.191.615-.191 1.003 0 .58.14 1.041.421 1.385.28.344.633.516 1.06.516.338 0 .608-.083.812-.248a1.53 1.53 0 0 0 .459-.612h.793c-.089.332-.23.615-.421.851a1.834 1.834 0 0 1-.697.544 2.32 2.32 0 0 1-.946.182Zm4.845-.096c-.433 0-.761-.143-.984-.43-.223-.286-.334-.672-.334-1.156v-4.643h.792v4.643c0 .293.061.513.182.66.127.14.303.21.525.21h.641v.716h-.822Zm-2.217-4.375v-.669h3.039v.669h-3.039Zm6.087 4.471c-.484 0-.898-.112-1.242-.335a2.23 2.23 0 0 1-.793-.936 3.23 3.23 0 0 1-.268-1.347c0-.382.051-.732.153-1.051.102-.318.252-.592.449-.821.204-.236.446-.418.726-.545.287-.134.612-.201.975-.201.484 0 .898.115 1.242.344.344.223.605.532.783.927.185.388.277.838.277 1.347 0 .382-.051.732-.153 1.051a2.367 2.367 0 0 1-.458.831c-.198.229-.44.411-.726.545a2.318 2.318 0 0 1-.965.191Zm0-.717c.299 0 .56-.073.783-.22.223-.146.398-.359.525-.64.128-.286.192-.633.192-1.041 0-.611-.141-1.08-.421-1.404-.274-.332-.634-.497-1.079-.497a1.42 1.42 0 0 0-.784.22 1.456 1.456 0 0 0-.525.649c-.128.28-.191.624-.191 1.032 0 .611.137 1.083.41 1.414.281.325.644.487 1.09.487Zm3.395.621v-5.044h.717v.879h.076c.07-.28.229-.497.478-.65.254-.153.554-.229.898-.229h.477v.716h-.582c-.363 0-.666.134-.908.402-.242.267-.363.633-.363 1.098v2.828h-.793Zm5.198.096c-.357 0-.676-.064-.956-.191a1.631 1.631 0 0 1-.659-.545 1.701 1.701 0 0 1-.287-.841h.774c.051.262.166.478.344.65.185.166.446.248.784.248.337 0 .611-.073.821-.219a.688.688 0 0 0 .315-.593c0-.248-.082-.43-.248-.544-.159-.121-.373-.204-.64-.249l-.707-.124a1.995 1.995 0 0 1-.678-.248 1.397 1.397 0 0 1-.488-.478 1.37 1.37 0 0 1-.172-.697c0-.281.077-.526.23-.736a1.54 1.54 0 0 1 .64-.487c.274-.121.579-.182.917-.182.49 0 .898.121 1.223.363.331.236.532.58.602 1.032h-.745a.863.863 0 0 0-.373-.535 1.246 1.246 0 0 0-.717-.2c-.299 0-.547.063-.745.191a.606.606 0 0 0-.286.535c0 .439.321.716.965.831l.659.114c.376.064.691.204.946.421.254.21.382.532.382.965 0 .293-.08.554-.239.783a1.634 1.634 0 0 1-.669.545 2.433 2.433 0 0 1-.993.191Z"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        stroke: "#000",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "5",
                        strokeOpacity: ".9",
                        strokeWidth: "1.194",
                        d: "m228.081 130.83-.262 28.505m5.411-17.66c.266 4.51-4.625 6.204-8.292 7.883v.089c5.762 1.327 12.856 3.008 17.021 7.518m-2.855-11.36c-2.161-.718-5.225 6.254-2.465 6.421 2.007.084 2.203-3.808 2.661-5.441-1.145 2.236.775 9.764 4.068 1.414-2.332 2.19 3.566 11.224 5.495-8.079-.529 5.618-1.031 9.165 1.227 11.501 1.923 2.003 4.882 1.073 5.45-1.315 1.894-7.963.584-18.025-.985-17.894-1.572.132-2.62 9.015-.855 16.142.559 2.257 2.007 4.506 4.684 4.923 3.011.501 2.676-2.503 3.513-4.34.251 1.085.251 2.42 1.589 2.587 1.504.25 1.923-2.003 2.927-2.003.418 0 .837.835 1.255.919.67.25.753-.084 1.421-.334 4.014-1.251 3.623-.013 7.805-.013m-31.64-3.157c2.927-.501 5.855-.752 8.866-.835m28.785-8.155c1.593-3.073-4.672-2.649-5.841-.318-2.655 5.299 7.647 9.431 8.921 13.881 1.912 6.675-9.983 6.887-13.699 4.344-2.336-1.696-.425-2.755 1.698-3.39m17.58.123c1.364.164 6.852.305 8.028-3.278 1.162-3.544-6.914-2.447-9.468-1.399-.829.341-2.627 1.133-2.575 2.468.108 2.754 7.528 2.622 11.413 1.62 3.886-1.002 4.796-1.95 5.25-2.937-.984.164-1.06 2.222-.303 2.88.985.823 1.364-.494 1.969-1.235.151.659.303 1.235.606 1.81.757-.576 1.136-2.057 2.197-1.974.909 0 .808 1.049 1.717 1.131.833.082 1.637-2.244 4.648-2.112-1.703-.327-4.91 1.764-2.749 2.483 2.291.587 2.669-1.913 2.972-2.901.304-1.069 1.364-8.052.151-8.875-.908-.576-1.06 1.153-1.136 1.893-.227 2.304.531 6.489 2.046 8.217 1.514 1.809 5.377 2.468 6.666-.33.985-2.222-1.743-3.538-2.046-1.069-.606 4.689 4.571 3.047 6.194 1.601 2.751-2.45 2.259-17.435.458-17.541-1.635-.097-5.008 19.109 7.366 20.676m-45.677-3.952c-1.066 3.282.685 10.351 2.578 12.079 0 0 .131-5.357-2.128-8.264m15.229-7.395c.075-.082.075-.247.075-.412m-61.264-1.464c.075-.082.075-.246.075-.412"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "200.583",
                        height: "124.781",
                        x: "142.208",
                        y: "60.209",
                        stroke: "url(#f)",
                        strokeOpacity: ".05",
                        strokeWidth: ".583",
                        rx: "4.956"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "#006AFF",
                strokeLinecap: "round",
                strokeWidth: "3.17",
                d: "M6.962 130.54h2.669M18.64 130.54h11.427M40.535 130.54h89.522M6.962 130.54h2.669M18.64 130.54h11.427M40.535 130.54h89.522M69.73 152.437h7.778M28.128 152.437h33.323M85.787 152.437h90.251"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                filter: "url(#g)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "244",
                    height: "244",
                    x: "54.5",
                    y: ".5",
                    fill: "#fff",
                    fillOpacity: ".01",
                    rx: "122"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "a",
                        x1: "176.5",
                        x2: "176.5",
                        y1: ".5",
                        y2: "244.5",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopOpacity: ".05"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "f",
                        x1: "242.5",
                        x2: "242.5",
                        y1: "60.5",
                        y2: "184.698",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopOpacity: ".05"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopOpacity: ".14"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                        id: "b",
                        width: "227.166",
                        height: "172.365",
                        x: "128.917",
                        y: "57.916",
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_2547_130233"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {
                                dy: "2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "effect1_dropShadow_2547_130233",
                                result: "effect2_dropShadow_2547_130233"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {
                                dy: "8"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "4"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "effect2_dropShadow_2547_130233",
                                result: "effect3_dropShadow_2547_130233"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {
                                dy: "18"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "5.5"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "effect3_dropShadow_2547_130233",
                                result: "effect4_dropShadow_2547_130233"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {
                                dy: "32"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "6.5"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "effect4_dropShadow_2547_130233",
                                result: "effect5_dropShadow_2547_130233"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect5_dropShadow_2547_130233",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                        id: "g",
                        width: "256",
                        height: "244",
                        x: "42.5",
                        y: ".5",
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feOffset", {
                                dx: "-12"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "6.5"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feComposite", {
                                in2: "hardAlpha",
                                k2: "-1",
                                k3: "1",
                                operator: "arithmetic"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_2547_130233"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                        id: "d",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientTransform: "rotate(45 67.581 402.33) scale(40.533)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fff",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pattern", {
                        id: "e",
                        width: "1",
                        height: "1",
                        patternContentUnits: "objectBoundingBox",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                            xlinkHref: "#h",
                            transform: "scale(.0073 .00943)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("image", {
                        xlinkHref: "data:image/png;base64,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",
                        id: "h",
                        width: "137",
                        height: "106"
                    })
                ]
            })
        ]
    });
}



function $fbe5020f1b3e8361$export$35d0ea5f90a48237({ estimateArrivalDate: estimateArrivalDate, onDoneClick: onDoneClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "cardConfirmation"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: (0, $2fa5cd385f265c4c$export$34e0f9847d4c02dd),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: (0, $2fa5cd385f265c4c$export$38e42c68cf43b5d4),
                children: t("title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a88d3f9b6a1b5a9$export$b5be2bc9038e471b), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $2fa5cd385f265c4c$export$6d59db4903f20f7d),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: (0, $2fa5cd385f265c4c$export$c96745152eb2740f),
                        children: t("subtitle")
                    }),
                    estimateArrivalDate.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $2fa5cd385f265c4c$export$79b7ea2066c6e4f9), "paragraph-20"),
                        children: t("estimateArrivalText", {
                            replace: {
                                estimateArrivalDate: estimateArrivalDate
                            }
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                className: (0, $2fa5cd385f265c4c$export$2ba01fb71ed41cb6),
                rank: "primary",
                onClick: onDoneClick,
                children: t("doneButtonText")
            })
        ]
    });
}


function $9faa4f23fc8da724$export$69dff73d12ee9b83({ dispatch: dispatch }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbe5020f1b3e8361$export$35d0ea5f90a48237), {
        cardCustomization: "",
        estimateArrivalDate: "",
        onDoneClick: ()=>dispatch((0, $b2490fa107d6478d$export$848ce7d6602fe3bd)())
    });
}










var $ea9696031b0ed501$exports = {};

$parcel$export($ea9696031b0ed501$exports, "description", () => $ea9696031b0ed501$export$6d59db4903f20f7d, (v) => $ea9696031b0ed501$export$6d59db4903f20f7d = v);
$parcel$export($ea9696031b0ed501$exports, "inputFields", () => $ea9696031b0ed501$export$2daf5cbeed728edf, (v) => $ea9696031b0ed501$export$2daf5cbeed728edf = v);
var $ea9696031b0ed501$export$6d59db4903f20f7d;
var $ea9696031b0ed501$export$2daf5cbeed728edf;
$ea9696031b0ed501$export$6d59db4903f20f7d = `HvIZVq_VerifyName_description`;
$ea9696031b0ed501$export$2daf5cbeed728edf = `HvIZVq_VerifyName_inputFields`;



function $ed393ea70cbc6d28$export$f9233de0a874ce72({ firstName: firstName, firstNameError: firstNameError, lastName: lastName, lastNameError: lastNameError, loading: loading, onFirstNameChange: onFirstNameChange, onLastNameChange: onLastNameChange, onNextClick: onNextClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "verifyName"
    });
    const button = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
            rank: "primary",
            isLoading: loading,
            onClick: onNextClick,
            children: t("buttonText")
        }, t("buttonText"))
    ];
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ea9696031b0ed501$exports))).description, "paragraph-30"),
                children: t("description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ea9696031b0ed501$exports))).inputFields,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                        name: "firsName",
                        label: t("firstName.label"),
                        className: "market-grid-item-full",
                        value: firstName,
                        error: firstNameError,
                        onTextChange: onFirstNameChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                        name: "lastName",
                        label: t("lastName.label"),
                        className: "market-grid-item-full",
                        value: lastName,
                        error: lastNameError,
                        onTextChange: onLastNameChange
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77a799ee7a5a2b82$export$a98515d67472a41f), {
        buttons: button,
        content: content,
        title: t("title")
    });
}


const $95484e46f870a5c7$export$375b49718dbd9ced = (t)=>(field, validationRecord)=>{
        if (validationRecord.valid) return "";
        switch(validationRecord.errors[field][0]){
            case (0, $c27a3102df5220b7$export$e4493d7100331504).VERIFY_NAME_ERROR_EMPTY:
                return t(`${field}.error.empty`);
        }
    };
function $95484e46f870a5c7$export$83868f3de121e0f3({ state: state, dispatch: dispatch }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "verifyName"
    });
    const getErrorStringFunc = $95484e46f870a5c7$export$375b49718dbd9ced(t);
    const mapToProps = ({ state: state, dispatch: dispatch })=>({
            firstName: state.verifyNameState[(0, $c27a3102df5220b7$export$a455218a85c89869).FirstName],
            firstNameError: getErrorStringFunc((0, $c27a3102df5220b7$export$a455218a85c89869).FirstName, state.verifyNameState.validation),
            lastName: state.verifyNameState[(0, $c27a3102df5220b7$export$a455218a85c89869).LastName],
            lastNameError: getErrorStringFunc((0, $c27a3102df5220b7$export$a455218a85c89869).LastName, state.verifyNameState.validation),
            loading: state.verifyNameState.loading,
            onFirstNameChange: (value)=>dispatch((0, $c27a3102df5220b7$export$49d8151683dabb69)((0, $c27a3102df5220b7$export$a455218a85c89869).FirstName, value)),
            onLastNameChange: (value)=>dispatch((0, $c27a3102df5220b7$export$49d8151683dabb69)((0, $c27a3102df5220b7$export$a455218a85c89869).LastName, value)),
            onNextClick: ()=>dispatch((0, $c27a3102df5220b7$export$69864c1ae20800a8)())
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed393ea70cbc6d28$export$f9233de0a874ce72), {
        ...mapToProps({
            state: state,
            dispatch: dispatch
        })
    });
}



parcelRequire("acw62");
const $336d8037eb9512f1$var$SvgActionX = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            d: "M1.71 13.71 7 8.41l5.29 5.3 1.42-1.42L8.41 7l5.3-5.29L12.29.29 7 5.59 1.71.29.29 1.71 5.59 7l-5.3 5.29z"
        })
    });
var $336d8037eb9512f1$export$2e2bcd8739ae039 = $336d8037eb9512f1$var$SvgActionX;



parcelRequire("acw62");
const $6c454853b38ed92b$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M.293 7.293a1 1 0 0 0 0 1.414l7 7 1.414-1.414L3.414 9H15V7H3.414l5.293-5.293L7.293.293z",
            clipRule: "evenodd"
        })
    });
var $6c454853b38ed92b$export$2e2bcd8739ae039 = $6c454853b38ed92b$var$SvgArrowLeft;





/**
 * Market considers modals (full and partial), dialog and blade as DialogElements.
 */ 

var $acw62 = parcelRequire("acw62");
const $c552822fec5ee486$export$db7975a4146cc3db = (Component)=>{
    // TODO(cvu): decide if we should disable this for the whole project later
    // eslint-disable-next-line react/display-name
    return ({ active: active, onActiveChange: onActiveChange, children: children })=>{
        const [_active, setActive] = (0, $acw62.useState)(false);
        (0, $acw62.useEffect)(()=>{
            setActive(active ?? false);
        }, [
            active
        ]);
        (0, $acw62.useEffect)(()=>{
            if (onActiveChange) onActiveChange(_active);
        }, [
            _active
        ]);
        const onMarketDialogDismissed = ()=>{
            setActive(false);
        };
        return _active ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            onMarketDialogDismissed: onMarketDialogDismissed,
            children: children
        }) : null;
    };
};


const $c5c53dc05f5ac83c$export$da81b8c087817043 = (0, $c552822fec5ee486$export$db7975a4146cc3db)((0, $7d1bfdd6e8737fe3$export$9be6f02cefaea425));


var $524129e4974f2735$export$a7db06668cad9adb;
var $524129e4974f2735$export$140756403827ba10;
$524129e4974f2735$export$a7db06668cad9adb = `uFNLba_CardIssuingModal_content`;
$524129e4974f2735$export$140756403827ba10 = `uFNLba_CardIssuingModal_navIcon`;


function $e787d7fbfea89ae1$export$433accab5d13d26f({ active: active, isNavButtonVisible: isNavButtonVisible, children: children, IconSVGComponent: IconSVGComponent, onActiveChange: onActiveChange, onNavButtonClick: onNavButtonClick }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c5c53dc05f5ac83c$export$da81b8c087817043), {
        active: active,
        onActiveChange: onActiveChange,
        children: [
            isNavButtonVisible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                    rank: "secondary",
                    slot: "navigation",
                    onClick: onNavButtonClick,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(IconSVGComponent, {
                        slot: "icon",
                        className: (0, $524129e4974f2735$export$140756403827ba10)
                    })
                })
            }) : null,
            children
        ]
    });
}





parcelRequire("acw62");
const $cb30999c39860334$var$SvgAlertX = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M0 9a9 9 0 1 1 18.001.001A9 9 0 0 1 0 9m2 0c0 3.86 3.14 7 7 7s7-3.14 7-7-3.14-7-7-7-7 3.14-7 7m7-1.41 2.29-2.3 1.42 1.42L10.41 9l2.3 2.29-1.42 1.42L9 10.42l-2.29 2.29-1.42-1.42L7.59 9l-2.3-2.29 1.42-1.42z",
            clipRule: "evenodd"
        })
    });
var $cb30999c39860334$export$2e2bcd8739ae039 = $cb30999c39860334$var$SvgAlertX;



var $2fc14e6bd3984098$exports = {};

$parcel$export($2fc14e6bd3984098$exports, "button", () => $2fc14e6bd3984098$export$2ba01fb71ed41cb6, (v) => $2fc14e6bd3984098$export$2ba01fb71ed41cb6 = v);
$parcel$export($2fc14e6bd3984098$exports, "container", () => $2fc14e6bd3984098$export$34e0f9847d4c02dd, (v) => $2fc14e6bd3984098$export$34e0f9847d4c02dd = v);
$parcel$export($2fc14e6bd3984098$exports, "description", () => $2fc14e6bd3984098$export$6d59db4903f20f7d, (v) => $2fc14e6bd3984098$export$6d59db4903f20f7d = v);
$parcel$export($2fc14e6bd3984098$exports, "grey", () => $2fc14e6bd3984098$export$e4c89085febbc618, (v) => $2fc14e6bd3984098$export$e4c89085febbc618 = v);
$parcel$export($2fc14e6bd3984098$exports, "icon", () => $2fc14e6bd3984098$export$1ca1ec8b29a4ce27, (v) => $2fc14e6bd3984098$export$1ca1ec8b29a4ce27 = v);
$parcel$export($2fc14e6bd3984098$exports, "title", () => $2fc14e6bd3984098$export$fb184b623420d9be, (v) => $2fc14e6bd3984098$export$fb184b623420d9be = v);
var $2fc14e6bd3984098$export$2ba01fb71ed41cb6;
var $2fc14e6bd3984098$export$34e0f9847d4c02dd;
var $2fc14e6bd3984098$export$6d59db4903f20f7d;
var $2fc14e6bd3984098$export$e4c89085febbc618;
var $2fc14e6bd3984098$export$1ca1ec8b29a4ce27;
var $2fc14e6bd3984098$export$fb184b623420d9be;
$2fc14e6bd3984098$export$2ba01fb71ed41cb6 = `yw5C6G_Alert_button`;
$2fc14e6bd3984098$export$34e0f9847d4c02dd = `yw5C6G_Alert_container`;
$2fc14e6bd3984098$export$6d59db4903f20f7d = `yw5C6G_Alert_description`;
$2fc14e6bd3984098$export$e4c89085febbc618 = `yw5C6G_Alert_grey`;
$2fc14e6bd3984098$export$1ca1ec8b29a4ce27 = `yw5C6G_Alert_icon`;
$2fc14e6bd3984098$export$fb184b623420d9be = `yw5C6G_Alert_title`;



var $06f269f6a0cbba3c$export$2ddc1882e756bb44 = /*#__PURE__*/ function(AlertColor) {
    AlertColor["Grey"] = "grey";
    return AlertColor;
}({});
var $06f269f6a0cbba3c$export$4a143c8822a09fb4 = /*#__PURE__*/ function(AlertIcon) {
    AlertIcon["X"] = "X";
    return AlertIcon;
}({});
function $06f269f6a0cbba3c$export$caec2af78bcc877f({ buttonText: buttonText, color: color, description: description, icon: icon, title: title, onButtonClick: onButtonClick }) {
    const getIcon = (icon, color)=>{
        switch(icon){
            case "X":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb30999c39860334$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports))).icon, (0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports)))[color])
                });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports))).container,
        children: [
            getIcon(icon, color),
            title?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports))).title,
                children: title
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            description?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports))).description,
                children: description
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            buttonText?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                rank: "primary",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2fc14e6bd3984098$exports))).button,
                onClick: onButtonClick,
                children: buttonText
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
        ]
    });
}



function $51ac4cb382475bb7$export$ea52035eac03daf0({ onButtonClick: onButtonClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("site", {
        keyPrefix: "error.flow"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06f269f6a0cbba3c$export$caec2af78bcc877f), {
        buttonText: t("buttonText"),
        color: (0, $06f269f6a0cbba3c$export$2ddc1882e756bb44).Grey,
        description: t("description"),
        icon: (0, $06f269f6a0cbba3c$export$4a143c8822a09fb4).X,
        title: t("title"),
        onButtonClick: onButtonClick
    });
}





function $1b1a454b8bd0f7d6$export$c781be0ae6db134e({ onButtonClick: onButtonClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-issuing", {
        keyPrefix: "error.ineligibility"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06f269f6a0cbba3c$export$caec2af78bcc877f), {
        buttonText: t("buttonText"),
        color: (0, $06f269f6a0cbba3c$export$2ddc1882e756bb44).Grey,
        description: t("description"),
        icon: (0, $06f269f6a0cbba3c$export$4a143c8822a09fb4).X,
        onButtonClick: onButtonClick
    });
}


function $bd61bc2ba06a0509$export$cee179dbf81603ea({ state: state, dispatch: dispatch }) {
    const getNavIcon = (state)=>(0, $b2490fa107d6478d$export$477b3fce3049067a)(state) ? (0, $336d8037eb9512f1$export$2e2bcd8739ae039) : (0, $6c454853b38ed92b$export$2e2bcd8739ae039);
    const getChildren = (state)=>{
        const { current: current } = state.navigation;
        switch(current){
            case (0, $b2490fa107d6478d$export$a98515d67472a41f).VerifyName:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95484e46f870a5c7$export$83868f3de121e0f3), {
                    state: state,
                    dispatch: dispatch
                });
            case (0, $b2490fa107d6478d$export$a98515d67472a41f).Customization:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7079a22d48a3517c$export$10055180eae25861), {
                    state: state,
                    dispatch: dispatch
                });
            case (0, $b2490fa107d6478d$export$a98515d67472a41f).ShippingAddress:
                switch(state.cardShippingState.screen){
                    case (0, $a4c47930ee9facdd$export$a98515d67472a41f).EnterAddress:
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95fea94033a7ccce$export$e6c073bff812bf4e), {
                            state: state,
                            dispatch: dispatch
                        });
                }
                break;
            case (0, $b2490fa107d6478d$export$a98515d67472a41f).OrderConfirmation:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9faa4f23fc8da724$export$69dff73d12ee9b83), {
                    state: state,
                    dispatch: dispatch
                });
            case (0, $b2490fa107d6478d$export$a98515d67472a41f).Error:
                switch(state.error){
                    case (0, $b2490fa107d6478d$export$99337e8421d6e839).Ineligible:
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b1a454b8bd0f7d6$export$c781be0ae6db134e), {
                            onButtonClick: ()=>dispatch((0, $b2490fa107d6478d$export$2085928ad4455e61)(false))
                        });
                    case (0, $b2490fa107d6478d$export$99337e8421d6e839).Generic:
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ac4cb382475bb7$export$ea52035eac03daf0), {
                            onButtonClick: ()=>dispatch((0, $b2490fa107d6478d$export$2085928ad4455e61)(false))
                        });
                }
        }
    };
    const mapToProps = ({ state: state, dispatch: dispatch })=>{
        return {
            active: state.modalOpen,
            children: getChildren(state),
            IconSVGComponent: getNavIcon(state),
            isNavButtonVisible: (0, $b2490fa107d6478d$export$f3db0dc3a05c157d)(state),
            onActiveChange: (value)=>dispatch((0, $b2490fa107d6478d$export$2085928ad4455e61)(value)),
            onNavButtonClick: (0, $b2490fa107d6478d$export$477b3fce3049067a)(state) ? ()=>dispatch((0, $b2490fa107d6478d$export$34ed016b7ffc8a51)()) : ()=>dispatch((0, $b2490fa107d6478d$export$ecbea34edac74891)())
        };
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e787d7fbfea89ae1$export$433accab5d13d26f), {
        ...mapToProps({
            state: state,
            dispatch: dispatch
        })
    });
}




var $acw62 = parcelRequire("acw62");

var $jPIgV = parcelRequire("jPIgV");
parcelRequire("5o0ob");
var $4BZ7p = parcelRequire("4BZ7p");
var $i34zz = parcelRequire("i34zz");
var $fvmH2 = parcelRequire("fvmH2");

var $l73hA = parcelRequire("l73hA");

var $4ya6m = parcelRequire("4ya6m");
parcelRequire("5o0ob");
var $7tMaX = parcelRequire("7tMaX");
var $i34zz = parcelRequire("i34zz");
var $lll06 = parcelRequire("lll06");

var $l73hA = parcelRequire("l73hA");

var $4ya6m = parcelRequire("4ya6m");
class $7c707cd517dbc514$export$bdb31e4c69f480ca {
    constructor(){
        (0, $7tMaX.cookies).set((0, $4ya6m.CookieNames).enabled, 'allowed');
        if ((0, $7tMaX.cookies).get((0, $4ya6m.CookieNames).enabled) === 'allowed') {
            (0, $7tMaX.cookies).remove((0, $4ya6m.CookieNames).enabled);
            this.store = (0, $7tMaX.cookies);
        } else this.store = (0, $lll06.ls);
    }
    get(key) {
        return this.store.get(key);
    }
    set(key, val) {
        this.store.set(key, val);
    }
    remove(key) {
        this.store.remove(key);
    }
    getEntityType() {
        const entityFromStore = this.store.get((0, $4ya6m.StoreNames).userEntityType);
        const entityFromLegacyStore = this.store.get((0, $4ya6m.LegacyStoreNames).userEntityType);
        let entityType;
        if ((0, $i34zz.isEntity)(entityFromStore)) entityType = entityFromStore;
        else if ((0, $i34zz.isEntity)(entityFromLegacyStore)) entityType = entityFromLegacyStore;
        else entityType = (0, $4ya6m.EntityTypes).anonVisitor;
        return entityType;
    }
    getEntityId() {
        const avt = (0, $l73hA.getAndSetAvtSafe)();
        const idFromStore = this.store.get((0, $4ya6m.StoreNames).userEntityId);
        const idFromLegacyStore = this.store.get((0, $4ya6m.LegacyStoreNames).userEntityId);
        let id;
        if ((0, $i34zz.isEntityId)(idFromStore)) id = idFromStore;
        else if ((0, $i34zz.isEntityId)(idFromLegacyStore)) id = idFromLegacyStore;
        else id = avt;
        return id;
    }
    getEntityTraits() {
        const traitsFromLegacyStore = (0, $lll06.ls).get((0, $4ya6m.LegacyLSNames).userEntityTraits);
        const traitsFromStore = (0, $lll06.ls).get((0, $4ya6m.LSNames).userEntityTraits);
        const legacyTraits = (0, $i34zz.isTraits)(traitsFromLegacyStore) ? traitsFromLegacyStore : {};
        const newerTraits = (0, $i34zz.isTraits)(traitsFromStore) ? traitsFromStore : {};
        // new store should overwrite legacy store
        const traits = Object.assign(Object.assign({}, legacyTraits), newerTraits);
        return traits;
    }
    setEntityId(passedId, type) {
        // persist id in new store keys
        this.store.set((0, $4ya6m.StoreNames).userEntityId, passedId);
        // persist id in legacy store keys
        this.store.set((0, $4ya6m.LegacyStoreNames).userEntityId, passedId);
        if (type === (0, $4ya6m.EntityTypes).anonVisitor && (0, $i34zz.isUUID)(passedId)) this.store.set((0, $4ya6m.LegacyStoreNames).anonId, passedId);
    }
    setEntity(passedEntity) {
        this.store.set((0, $4ya6m.StoreNames).userEntityType, passedEntity);
        this.store.set((0, $4ya6m.LegacyStoreNames).userEntityType, passedEntity);
    }
    setEntityTraits(traits) {
        // only set new keys in localStorage
        // old traits shouldn't be used by application logic
        (0, $lll06.ls).set((0, $4ya6m.LSNames).userEntityTraits, traits);
    }
}


/**
 * The only reason we're not using a private property is because of the size
 * that would add to the bundle when compiled. It really doesn't matter, though,
 * if this is shared between instances of `User` because it's just a wrapper
 * around cookies and localStorage.
 */ let $fd3bbd181df177da$var$store;
class $fd3bbd181df177da$export$1f44aaf2ec115b54 {
    // set default entity, id, and traits
    constructor(){
        // Reinitializing in the constructor is easier
        // to write tests with a fresh store instance.
        // This makes no difference to the functionality
        // of the persistentStore in actual use
        $fd3bbd181df177da$var$store = new (0, $7c707cd517dbc514$export$bdb31e4c69f480ca)();
        // try to find entityType and id from storage
        const id = $fd3bbd181df177da$var$store.getEntityId();
        const entityType = $fd3bbd181df177da$var$store.getEntityType();
        const traits = $fd3bbd181df177da$var$store.getEntityTraits();
        this._identify(id, entityType, traits);
    }
    _setEntityId(passedId) {
        (0, $4BZ7p.assignReadOnly)(this, 'entityId', passedId);
        $fd3bbd181df177da$var$store.setEntityId(passedId, this.entityType);
    }
    _setEntityType(passedEntity) {
        (0, $4BZ7p.assignReadOnly)(this, 'entityType', passedEntity);
        $fd3bbd181df177da$var$store.setEntity(passedEntity);
    }
    _setEntityTraits(passedTraits) {
        const newTraits = Object.assign(Object.assign({}, this.entityTraits), passedTraits);
        (0, $4BZ7p.assignReadOnly)(this, 'entityTraits', newTraits);
        $fd3bbd181df177da$var$store.setEntityTraits(newTraits);
    }
    // note that we won't implement entity
    // hierarchy for now, as that is a P3
    _identify(id, type, traits) {
        if ((0, $l73hA.entityIdAndTypeMatch)(id, type)) {
            // entity needs to be set before id as setId require to know entity
            this._setEntityType(type);
            if (type === (0, $4ya6m.EntityTypes).anonVisitor) // _savt is always the source of truth for anonymous_visitor
            this._setEntityId((0, $l73hA.getAndSetAvtSafe)(id));
            else this._setEntityId(id);
        // if entity and type are mismatched and identify
        // was not previously called (hence entity and id
        // being falsey), default to anonymous and AVT. Rely
        // on a new identify call in application logic to fix.
        } else if (!this.entityType || !this.entityId) {
            this._setEntityType((0, $4ya6m.EntityTypes).anonVisitor);
            this._setEntityId((0, $l73hA.getAndSetAvtSafe)());
        }
        // even if user identity is a mismatch,
        // we should still set traits
        if (!traits) return;
        if ((0, $i34zz.isTraits)(traits)) this._setEntityTraits(traits);
        else (0, $fvmH2.warn)("The third argument traits is not of type 'object'. Traits were not set.");
    }
}


function $740c4c84f29b8527$export$2e841e6398be3d56(callback) {
    let unloaded = false; // prevents double firing if both are supported
    window.addEventListener('pagehide', ()=>{
        if (unloaded) return;
        unloaded = true;
        callback('hidden');
    });
    document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'hidden') {
            if (unloaded) return;
            unloaded = true;
            callback('hidden');
        } else {
            unloaded = false;
            callback('visible');
        }
    });
}



var $WS9F7 = parcelRequire("WS9F7");

var $33Dov = parcelRequire("33Dov");
function $f3da5185d7000480$export$2e2bcd8739ae039(payloadStr, apiKey) {
    const key = apiKey.replaceAll('-', '');
    const hash = (0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(payloadStr, key);
    return `v1:${(0, (/*@__PURE__*/$parcel$interopDefault($33Dov))).stringify(hash)}`;
}


parcelRequire("5o0ob");
var $fvmH2 = parcelRequire("fvmH2");
var $3EKNW = parcelRequire("3EKNW");
parcelRequire("5o0ob");
var $fvmH2 = parcelRequire("fvmH2");
var $i34zz = parcelRequire("i34zz");
var $lll06 = parcelRequire("lll06");
const $629312d497386cff$export$45b7810513497e4d = 1;
const $629312d497386cff$export$50df8a7fb6541d03 = 3;
const $629312d497386cff$export$7bd623b29ec8e1eb = 3000;
var $629312d497386cff$export$9e20319ccc45b52a;
(function(LsKeysV1) {
    LsKeysV1["items"] = "persisted-queue:v1:items";
    LsKeysV1["seen"] = "persisted-queue:v1:seen";
    LsKeysV1["lockKey"] = "persisted-queue:v1:lock";
})($629312d497386cff$export$9e20319ccc45b52a || ($629312d497386cff$export$9e20319ccc45b52a = {}));
function $629312d497386cff$export$d7542945cc215dfe(buffer) {
    // const size = encodeURI(JSON.stringify(buffer)).split(/%..|./).length - 1;
    const size = encodeURI(JSON.stringify(buffer)).length - 1;
    return size / 1024;
}
function $629312d497386cff$export$abebcb2d74fab1a8() {
    const items = (0, $lll06.ls).get($629312d497386cff$export$9e20319ccc45b52a.items);
    return (0, $i34zz.isArray)(items) ? items : [];
}
function $629312d497386cff$export$97cf1c62313c79c4(items) {
    const existing = $629312d497386cff$export$abebcb2d74fab1a8();
    const all = [
        ...items,
        ...existing
    ];
    (0, $lll06.ls).set($629312d497386cff$export$9e20319ccc45b52a.items, JSON.stringify(all));
}
function $629312d497386cff$export$781d5e5499c99070() {
    const stored = (0, $lll06.ls).get($629312d497386cff$export$9e20319ccc45b52a.seen);
    return (0, $i34zz.isObject)(stored) ? stored : {};
}
function $629312d497386cff$export$c6af13f8f71f6b84(memory) {
    const stored = $629312d497386cff$export$781d5e5499c99070();
    (0, $lll06.ls).set($629312d497386cff$export$9e20319ccc45b52a.seen, JSON.stringify(Object.assign(Object.assign({}, stored), memory)));
}
function $629312d497386cff$export$712ea50be43a7858(events) {
    const result = [];
    let index = 0;
    const sentAt = new Date().toISOString();
    events.forEach((event)=>{
        const eventWithSentAt = Object.assign(Object.assign({}, event), {
            sentAt: sentAt
        });
        const size = (result[index] ? $629312d497386cff$export$d7542945cc215dfe(result[index]) : 0) + $629312d497386cff$export$d7542945cc215dfe(eventWithSentAt);
        if (size >= 1000) index++;
        if (result[index]) result[index].push(eventWithSentAt);
        else result[index] = [
            eventWithSentAt
        ];
    });
    return result;
}
function $629312d497386cff$export$cd7f480d6b8286c3(key) {
    (0, $lll06.ls).remove(key);
}
function $629312d497386cff$var$expired(lockExpirationTime) {
    return Date.now() >= lockExpirationTime;
}
function $629312d497386cff$export$1b347e5c2ee97123(onUnlock, attempt = 0) {
    const lockTimeout = 50;
    const rawLock = (0, $lll06.ls).get($629312d497386cff$export$9e20319ccc45b52a.lockKey);
    const lock = rawLock ? rawLock : null;
    const allowed = lock === null || $629312d497386cff$var$expired(lock);
    if (allowed) {
        (0, $lll06.ls).set($629312d497386cff$export$9e20319ccc45b52a.lockKey, JSON.stringify(Date.now() + lockTimeout));
        onUnlock();
        (0, $lll06.ls).remove($629312d497386cff$export$9e20319ccc45b52a.lockKey);
        return;
    }
    if (!allowed && attempt < 3) setTimeout(()=>{
        $629312d497386cff$export$1b347e5c2ee97123(onUnlock, attempt + 1);
    }, lockTimeout);
    else (0, $fvmH2.error)('Unable to retrieve lock');
}


var $8724debf7a85666b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $8724debf7a85666b$export$1a39c19cecd1c26 {
    constructor({ url: url, batchSize: batchSize = (0, $629312d497386cff$export$45b7810513497e4d), timeout: timeout = (0, $629312d497386cff$export$7bd623b29ec8e1eb), logEventsToConsole: logEventsToConsole = false, maxRetryAttempts: maxRetryAttempts = (0, $629312d497386cff$export$50df8a7fb6541d03) }){
        this.maxRetryAttempts = maxRetryAttempts;
        this.url = url;
        this.logEventsToConsole = logEventsToConsole;
        this.pageUnloaded = false;
        this.batchSize = batchSize;
        this.timeout = timeout;
        this.queue = [];
        this.eventsAttempts = {};
        // recover pending events and events attempt data from localstorage
        (0, $629312d497386cff$export$1b347e5c2ee97123)(()=>{
            let saved = [];
            let lastSeen = {};
            try {
                saved = (0, $629312d497386cff$export$abebcb2d74fab1a8)();
                lastSeen = (0, $629312d497386cff$export$781d5e5499c99070)();
                (0, $629312d497386cff$export$cd7f480d6b8286c3)((0, $629312d497386cff$export$9e20319ccc45b52a).items);
                (0, $629312d497386cff$export$cd7f480d6b8286c3)((0, $629312d497386cff$export$9e20319ccc45b52a).seen);
                this.queue = [
                    ...saved,
                    ...this.queue
                ];
                this.eventsAttempts = Object.assign(Object.assign({}, lastSeen), this.eventsAttempts);
            } catch (err) {
                (0, $fvmH2.error)(err);
            }
        });
        // add onPageLeave event listener, to flush queue
        // onPageLeave will trigger on: tab away, close tab, switch to other app (mobile)
        (0, $740c4c84f29b8527$export$2e841e6398be3d56)((visibilityState)=>{
            if (visibilityState === 'hidden') {
                this.pageUnloaded = true;
                // keepalive requests have a limit of 64kb requst size
                // https://javascript.info/fetch-api#:~:text=We%20can't%20send%20megabytes,for%20keepalive%20requests%20is%2064KB.
                if (this.length > 0) this.flushUpTo64kb();
            } else this.pageUnloaded = false;
        });
        window.addEventListener('pagehide', ()=>{
            // we deliberately want to use the less powerful 'pagehide' API to only persist on events
            // where the cdp.js instance gets destroyed upon closing tab or page refresh, and not on tab away.
            if (this.length > 0) {
                const items = [
                    ...this.queue
                ];
                (0, $629312d497386cff$export$1b347e5c2ee97123)(()=>{
                    (0, $629312d497386cff$export$97cf1c62313c79c4)(items);
                    (0, $629312d497386cff$export$c6af13f8f71f6b84)(this.eventsAttempts);
                });
            }
        });
    }
    scheduleFlush() {
        if (this.schedule) return;
        this.schedule = setTimeout(()=>{
            this.schedule = undefined;
            this.flush();
        }, this.timeout);
    }
    push(...events) {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            const filteredEvents = events.filter((event)=>{
                const attempts = this.updateRetryAttempt(event);
                return attempts <= this.maxRetryAttempts && !this.includes(event);
            });
            this.queue.push(...filteredEvents);
            this.queue = this.queue.sort((a, b)=>this.getRetryAttempt(a) - this.getRetryAttempt(b));
            const batchSizeLimitReached = this.length >= this.batchSize;
            yield batchSizeLimitReached || this.pageUnloaded ? this.flush() : this.scheduleFlush();
        });
    }
    getRetryAttempt(event) {
        var _a;
        return (_a = this.eventsAttempts[event.messageId]) !== null && _a !== void 0 ? _a : 0;
    }
    updateRetryAttempt(event) {
        this.eventsAttempts[event.messageId] = this.getRetryAttempt(event) + 1;
        return this.getRetryAttempt(event);
    }
    includes(event) {
        return this.queue.includes(event) || Boolean(this.queue.some((i)=>i.messageId === event.messageId));
    }
    get length() {
        return this.queue.length;
    }
    backToQueue(batch) {
        batch.forEach((event)=>{
            // eslint-disable-next-line no-param-reassign
            event.sentAt = null;
        });
        this.push(...batch);
    }
    sendBatch(batch) {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            if (batch.length === 0) return;
            const payloadStr = JSON.stringify({
                batch: batch
            });
            const apiKey = batch[0].apiKey;
            const requestSignature = (0, $f3da5185d7000480$export$2e2bcd8739ae039)(payloadStr, apiKey);
            const authKey = window.btoa(`${apiKey}:`);
            yield fetch(this.url, {
                keepalive: this.pageUnloaded,
                headers: {
                    'Content-Type': 'application/json',
                    'X-CDP-Batch-ID': requestSignature,
                    authorization: `Basic ${authKey}`
                },
                method: 'post',
                body: payloadStr
            }).then((resp)=>{
                // we don't want to retry if we get i.e 401 which indicates an invalid signature
                if (resp.status === 429 || resp.status >= 500) this.backToQueue(batch);
                else if (resp.status < 400 && this.logEventsToConsole) batch.forEach((event)=>{
                    (0, $fvmH2.logEvent)(event);
                    if (event.apiMethod === 'track') (0, $3EKNW.warnAboutExcessiveColumns)(event.eventName, event.properties);
                });
            }).catch((e)=>{
                (0, $fvmH2.warn)(e);
                this.backToQueue(batch);
            });
        });
    }
    flushUpTo64kb() {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            const batchedEvents = [];
            let currPayloadSize = 0;
            const sentAt = new Date().toISOString();
            while(this.queue.length > 0){
                const eventWithSentAt = Object.assign(Object.assign({}, this.queue[0]), {
                    sentAt: sentAt
                });
                const currEventSize = (0, $629312d497386cff$export$d7542945cc215dfe)(eventWithSentAt);
                // set limit to 45 to give room for the rest of the request i.e headers
                if (currPayloadSize + currEventSize > 45) break;
                this.queue.shift();
                batchedEvents.push(eventWithSentAt);
                currPayloadSize += currEventSize;
            }
            yield this.sendBatch(batchedEvents);
        });
    }
    flush() {
        return $8724debf7a85666b$var$__awaiter(this, void 0, void 0, function*() {
            if (this.queue.length > 0) {
                const events = this.queue;
                this.queue = [];
                yield Promise.all((0, $629312d497386cff$export$712ea50be43a7858)(events).map((batchedEvents)=>this.sendBatch(batchedEvents)));
            }
        });
    }
}



var $aEqFn = parcelRequire("aEqFn");

var $l73hA = parcelRequire("l73hA");
var $9b8221f76ec3a444$exports = {};
$parcel$export($9b8221f76ec3a444$exports, "makeContextObj", () => $787adfe79aa608a3$export$6c5004d5490ddf9e);
parcelRequire("5o0ob");
var $7tMaX = parcelRequire("7tMaX");

var $jPIgV = parcelRequire("jPIgV");

var $4ya6m = parcelRequire("4ya6m");
function $0a3ea60d32b203ad$export$2afae91a33db1d52() {
    const queryParams = $0a3ea60d32b203ad$var$getQuery();
    return Object.assign(Object.assign({}, $0a3ea60d32b203ad$var$getTrackCookieData()), {
        utmCampaign: queryParams.utm_campaign,
        utmContent: queryParams.utm_content,
        utmMedium: queryParams.utm_medium,
        utmSource: queryParams.utm_source,
        utmTerm: queryParams.utm_term,
        trackCookieBase64: $0a3ea60d32b203ad$var$getTrackCookiesBase64()
    });
}
function $0a3ea60d32b203ad$var$getQuery() {
    if (window.location.search.length === 0) return {};
    const obj = {};
    const query = window.location.search.slice(1);
    const pairs = query.split('&');
    for (const pair of pairs){
        const [key, value] = pair.split('=');
        const decodedKey = decodeURIComponent(key);
        const decodedVal = decodeURIComponent(value);
        obj[decodedKey] = decodedVal;
    }
    return obj;
}
function $0a3ea60d32b203ad$var$getTrackCookieData() {
    const trackCookieArray = $0a3ea60d32b203ad$var$getTrackCookieDataArray();
    const trackCookieObject = {};
    if (trackCookieArray.length > 0) trackCookieArray.forEach((keyValStr)=>{
        const paramKey = keyValStr.split(/[=_-]/)[0];
        if (paramKey in (0, $jPIgV.cookiePrefixMap)) {
            // parse and set marketing param data
            const readableParamName = (0, $jPIgV.cookiePrefixMap)[paramKey];
            readableParamName.forEach((param)=>{
                trackCookieObject[param] = keyValStr;
            });
        } else // parse and set gclid related data
        if (keyValStr.includes('gclid=')) {
            const kvs = keyValStr.split('|');
            kvs.forEach((kv)=>{
                const [key, val] = kv.split('=').slice(0, 2);
                if (key && val && (0, $jPIgV.gclidKeySet).has(key)) trackCookieObject[key] = val;
            });
        }
    });
    return trackCookieObject;
}
function $0a3ea60d32b203ad$var$getTrackCookieDataArray() {
    const trackCookieVal = $0a3ea60d32b203ad$var$getTrackCookiesBase64();
    if (trackCookieVal) try {
        return window.JSON.parse(window.atob(trackCookieVal));
    } catch (_a) {
        return [];
    }
    return [];
}
// gets decoded 'track_cookie' which is an array
// This cookie is a list of marketing fields to collect.
// Where this cookie is set: https://github.com/squareup/xms/blob/main/app/controllers/marketing_tracking_controller.rb#L11C5-L29
// Business context for this cookie: https://docs.google.com/document/d/1PMNf8K9aV7EmaVFXMTzzJQmBFqeKEhuW5rqxj-h6R_Q/edit
function $0a3ea60d32b203ad$var$getTrackCookiesBase64() {
    const value = (0, $7tMaX.cookies).get((0, $4ya6m.CookieNames).trackCookie);
    if (value) try {
        return decodeURIComponent(value.split('--')[0]);
    } catch (_a) {
        return '';
    }
    return '';
}


// These helper functions are pulled
// from Segment's open source code
function $44e59744a5cbd3d4$export$4a68843152603124(search) {
    const canon = $44e59744a5cbd3d4$export$6885068ab384f932();
    if (canon) return canon.includes('?') ? canon : canon + (search !== null && search !== void 0 ? search : '');
    const url = window.location.href;
    const i = url.indexOf('#');
    return i === -1 ? url : url.slice(0, i);
}
function $44e59744a5cbd3d4$export$5e8a4ad862d86f90() {
    const canon = $44e59744a5cbd3d4$export$6885068ab384f932();
    if (!canon) return window.location.pathname;
    const parts = canon.split('.');
    const lastPartOfString = String(parts.at(-1));
    const i = lastPartOfString.indexOf('/');
    return lastPartOfString.slice(i);
}
function $44e59744a5cbd3d4$export$6885068ab384f932() {
    const tags = document.getElementsByTagName('link');
    for(let i = 0, tag; tag = tags[i]; i++){
        if (tag.getAttribute('rel') === 'canonical') return tag.getAttribute('href');
    }
    return null;
}



var $jPIgV = parcelRequire("jPIgV");

var $4ya6m = parcelRequire("4ya6m");
parcelRequire("5o0ob");
var $7tMaX = parcelRequire("7tMaX");
const $cd2f0f4c1dae1055$export$71998e95cfdeda6f = (()=>{
    const names = [];
    [
        (0, $4ya6m.StoreNames),
        (0, $4ya6m.CookieNames),
        (0, $4ya6m.LegacyStoreNames)
    ].forEach((obj)=>{
        for(const cookieKey in obj){
            const cookieName = obj[cookieKey];
            names.push(cookieName);
        }
    });
    return names;
})();
function $cd2f0f4c1dae1055$export$70ac24b0f6c7dc9c() {
    return Object.fromEntries(Object.entries((0, $7tMaX.cookies).get()).filter(([key])=>key === '_ga'));
}



// These helper functions are pulled
// from Segment's open source code
function $16c4560839fd69fc$export$b255f37afd2ff5f6() {
    const referrer = document.referrer;
    // try catch ensures that the string is a valid URL
    try {
        const refUrl = new URL(referrer);
        return {
            referrer: referrer,
            referrerHost: refUrl.host,
            referrerPath: refUrl.pathname,
            referrerSearch: refUrl.search
        };
    } catch (_a) {
        return {
            referrer: referrer
        };
    }
}




var $86Wyx = parcelRequire("86Wyx");
let $787adfe79aa608a3$var$metrics = null;
function $787adfe79aa608a3$export$6c5004d5490ddf9e() {
    if ($787adfe79aa608a3$var$metrics === null) $787adfe79aa608a3$var$metrics = (0, (/*@__PURE__*/$parcel$interopDefault($86Wyx)))(window.navigator.userAgent);
    return {
        browser: {
            name: $787adfe79aa608a3$var$metrics.browser.name,
            version: $787adfe79aa608a3$var$metrics.browser.version,
            height: window.innerHeight,
            width: window.innerWidth
        },
        campaign: (0, $0a3ea60d32b203ad$export$2afae91a33db1d52)(),
        cookies: (0, $cd2f0f4c1dae1055$export$70ac24b0f6c7dc9c)(),
        library: {
            name: (0, $jPIgV.LIBRARY_NAME),
            version: (0, $jPIgV.LIBRARY_VERSION)
        },
        locale: {
            countryCode: window.navigator.language.split('-')[1],
            language: window.navigator.language
        },
        os: {
            name: $787adfe79aa608a3$var$metrics.os.name,
            version: $787adfe79aa608a3$var$metrics.os.version
        },
        page: Object.assign({
            path: (0, $44e59744a5cbd3d4$export$5e8a4ad862d86f90)(),
            referrer: document.referrer,
            search: location.search,
            title: document.title,
            url: (0, $44e59744a5cbd3d4$export$4a68843152603124)(location.search),
            realPath: window.location.pathname,
            realUrl: window.location.href
        }, this.options.page),
        referrer: (0, $16c4560839fd69fc$export$b255f37afd2ff5f6)(),
        subject: this.makeContextSubject(),
        traits: this.user.entityTraits,
        userAgent: window.navigator.userAgent
    };
}




var $hNQFu = parcelRequire("hNQFu");
$parcel$exportWildcard($9b8221f76ec3a444$exports, $hNQFu);


var $hNQFu = parcelRequire("hNQFu");
parcelRequire("5o0ob");
var $i34zz = parcelRequire("i34zz");

var $i34zz = parcelRequire("i34zz");
function $f796209a1a234b00$var$isEmpty(arg) {
    return (0, $i34zz.isUndefined)(arg) || (0, $i34zz.isNull)(arg) || (0, $i34zz.isString)(arg) && arg.length === 0 || (0, $i34zz.isArray)(arg) && arg.length === 0 || (0, $i34zz.isObject)(arg) && Object.keys(arg).length === 0;
}
function $f796209a1a234b00$var$getKeys(o) {
    return Object.keys(o);
}
function $f796209a1a234b00$var$recursiveClean(obj) {
    // If 'obj' is an array, check its elements for objects to clean up.
    if ((0, $i34zz.isArray)(obj)) {
        obj.forEach($f796209a1a234b00$var$recursiveClean);
        // Remove empty objects from the array
        for(let i = 0; i < obj.length; i++)if ($f796209a1a234b00$var$isEmpty(obj[i])) obj.splice(i, 1);
    } else if ((0, $i34zz.isObject)(obj)) $f796209a1a234b00$var$getKeys(obj).forEach((key)=>{
        if ($f796209a1a234b00$var$isEmpty(obj[key])) // eslint-disable-next-line no-param-reassign
        delete obj[key];
        else {
            $f796209a1a234b00$var$recursiveClean(obj[key]);
            // eslint-disable-next-line no-param-reassign
            if ($f796209a1a234b00$var$isEmpty(obj[key])) delete obj[key];
        }
    });
}
function $f796209a1a234b00$export$2e2bcd8739ae039(obj) {
    $f796209a1a234b00$var$recursiveClean(obj);
    return obj;
}


/* eslint-disable @typescript-eslint/no-explicit-any,no-param-reassign */ // This is based on https://github.com/voodoocreation/ts-deepmerge/blob/master/src/index.ts but embedded directly
// for more control and smaller install footprint.

var $i34zz = parcelRequire("i34zz");
function $bad08ba8e8d78b41$var$merge(...objects) {
    return objects.reduce((result, current)=>{
        if (Array.isArray(current)) throw new TypeError('Arguments provided to ts-deepmerge must be objects, not arrays.');
        Object.keys(current).forEach((key)=>{
            if ([
                '__proto__',
                'constructor',
                'prototype'
            ].includes(key)) return;
            if (Array.isArray(result[key]) && Array.isArray(current[key])) result[key] = $bad08ba8e8d78b41$var$merge.options.mergeArrays ? Array.from(new Set(result[key].concat(current[key]))) : current[key];
            else if ((0, $i34zz.isObject)(result[key]) && (0, $i34zz.isObject)(current[key])) result[key] = $bad08ba8e8d78b41$var$merge(result[key], current[key]);
            else result[key] = current[key];
        });
        return result;
    }, {});
}
const $bad08ba8e8d78b41$var$defaultOptions = {
    mergeArrays: true
};
$bad08ba8e8d78b41$var$merge.options = $bad08ba8e8d78b41$var$defaultOptions;
$bad08ba8e8d78b41$var$merge.withOptions = (options, ...objects)=>{
    $bad08ba8e8d78b41$var$merge.options = Object.assign({
        mergeArrays: true
    }, options);
    const result = $bad08ba8e8d78b41$var$merge(...objects);
    $bad08ba8e8d78b41$var$merge.options = $bad08ba8e8d78b41$var$defaultOptions;
    return result;
};
var $bad08ba8e8d78b41$export$2e2bcd8739ae039 /* eslint-enable @typescript-eslint/no-explicit-any,no-param-reassign */  = $bad08ba8e8d78b41$var$merge;



var $4ya6m = parcelRequire("4ya6m");
/**
 * Takes properties from second object and assigns them to first if not found in the first.
 * Mutates first object, returns nothing
 */ function $76eec1bf4cde68f4$export$d4cd6183e892663c(obj1, obj2) {
    const keys = Object.keys(obj2);
    for (const key of keys)if (obj1[key] === undefined) // eslint-disable-next-line no-param-reassign
    obj1[key] = obj2[key];
}


class $5f721bab78e7c1d2$export$2e2bcd8739ae039 {
    constructor(queue, user, apiKey){
        this.queue = queue;
        this.user = user;
        this.apiKey = apiKey;
        this.properties = {};
        this.options = {};
        this.integrations = {};
        // these functions need reference to this context
        this.entityMatch = (0, $hNQFu.entityMatch).bind(this);
        this.makeContextObj = (0, $787adfe79aa608a3$export$6c5004d5490ddf9e).bind(this);
        this.makeContextSubject = (0, $hNQFu.makeContextSubject).bind(this);
        this.getProp = (0, $hNQFu.getProp).bind(this);
    }
    call(msg, options) {
        var _a, _b;
        if ((0, $i34zz.isTrack)(msg) || (0, $i34zz.isPage)(msg)) this.properties = (_a = msg.properties) !== null && _a !== void 0 ? _a : {};
        this.integrations = (_b = options === null || options === void 0 ? void 0 : options.integrations) !== null && _b !== void 0 ? _b : {};
        this.options = options !== null && options !== void 0 ? options : {};
        this.queue.push((0, $f796209a1a234b00$export$2e2bcd8739ae039)(this.makePayload(msg, options === null || options === void 0 ? void 0 : options.overrides)));
    }
    /**
     * Payload Documentation
     * {@link  https://zeroheight.com/55c402603/v/latest/p/61d3c0-data-api-reference/b/37f1b1}
     */ makePayload(msg, overrides) {
        const context = this.makeContextObj();
        if ((0, $i34zz.isIdentify)(msg)) // if identify, remove traits from context object
        delete context.traits;
        // if page, copy context.page to properties
        if ((0, $i34zz.isPage)(msg)) {
            /* eslint-disable no-param-reassign */ if (!(0, $i34zz.isObject)(msg.properties)) msg.properties = {};
            msg.properties.name = msg.name;
            msg.properties.category = msg.category;
            /* eslint-enable no-param-reassign */ (0, $76eec1bf4cde68f4$export$d4cd6183e892663c)(msg.properties, context.page);
        }
        const payload = Object.assign(Object.assign({}, msg), {
            anonymousId: (0, $l73hA.getAndSetAvtSafe)(),
            apiKey: this.apiKey,
            entityType: this.user.entityType,
            entityId: this.user.entityType === (0, $4ya6m.EntityTypes).anonVisitor ? '' // CDP does not expect an entity ID if type is anonVisitor
             : this.user.entityId,
            context: context,
            integrations: this.integrations,
            messageId: (0, $aEqFn.default)(),
            originalTimestamp: new Date().toISOString(),
            sentAt: null,
            timestamp: new Date().toISOString()
        });
        return (0, $bad08ba8e8d78b41$export$2e2bcd8739ae039)(payload, overrides !== null && overrides !== void 0 ? overrides : {});
    }
}


class $4530a0811e382d39$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire(event, properties, options) {
        this.call({
            properties: properties,
            eventName: event,
            apiMethod: 'track'
        }, options);
    }
}



class $e029523b7e4ed9b6$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire(traits, options) {
        this.call({
            traits: traits,
            apiMethod: 'identify'
        }, options);
    }
}



class $3d1b628e06db0d94$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire(category, page, properties, options) {
        this.call({
            properties: properties,
            apiMethod: 'page',
            name: page,
            category: category
        }, options);
    }
}



class $240633c0466106e8$export$2e2bcd8739ae039 extends (0, $5f721bab78e7c1d2$export$2e2bcd8739ae039) {
    fire(groupId, traits, options) {
        this.call({
            groupId: groupId,
            traits: traits,
            apiMethod: 'group'
        }, options);
    }
}



var $4ya6m = parcelRequire("4ya6m");
parcelRequire("5o0ob");
var $4BZ7p = parcelRequire("4BZ7p");
var $i34zz = parcelRequire("i34zz");
var $fvmH2 = parcelRequire("fvmH2");
var $hLZet = parcelRequire("hLZet");
var $cCZXV = parcelRequire("cCZXV");

var $i34zz = parcelRequire("i34zz");

var $l73hA = parcelRequire("l73hA");
class $39aefecf4ce2d04e$export$f15b3b9a7d41d3aa {
    constructor({ apiKey: apiKey, environment: environment, batchSize: batchSize, maxRetryAttempts: maxRetryAttempts, timeout: timeout, logEventsToConsole: logEventsToConsole = (0, $4ya6m.LogEventsToConsole).default, useSameOrigin: useSameOrigin = false }){
        (0, $4BZ7p.assignReadOnly)(this, 'key', apiKey);
        (0, $4BZ7p.assignReadOnly)(this, 'version', (0, $jPIgV.LIBRARY_VERSION));
        (0, $4BZ7p.assignReadOnly)(this, 'name', (0, $jPIgV.LIBRARY_NAME));
        (0, $4BZ7p.assignReadOnly)(this, 'user', new (0, $fd3bbd181df177da$export$1f44aaf2ec115b54)());
        let url = null;
        switch(environment){
            case (0, $4ya6m.Environments).production:
                url = "https://api.squareup.com/v1/cdp/batch" /* CDP_URL.production */ ;
                (0, $4BZ7p.assignReadOnly)(this, 'environment', (0, $4ya6m.Environments).production);
                break;
            case (0, $4ya6m.Environments).localDev:
                url = "http://localhost:3000/v1/cdp/batch" /* CDP_URL.development */ ;
                (0, $4BZ7p.assignReadOnly)(this, 'environment', (0, $4ya6m.Environments).development);
                break;
            default:
                url = "https://api.squarestagingexternal.com/v1/cdp/batch" /* CDP_URL.stage */ ;
                (0, $4BZ7p.assignReadOnly)(this, 'environment', (0, $4ya6m.Environments).stage);
                break;
        }
        if (useSameOrigin) (0, $4BZ7p.assignReadOnly)(this, 'url', `${window.location.origin}/v1/cdp/batch`);
        else (0, $4BZ7p.assignReadOnly)(this, 'url', url);
        (0, $4BZ7p.assignReadOnly)(this, 'queue', new (0, $8724debf7a85666b$export$1a39c19cecd1c26)({
            url: this.url,
            batchSize: batchSize,
            maxRetryAttempts: maxRetryAttempts,
            timeout: timeout
        }));
        this.setConfig('logEventsToConsole', logEventsToConsole);
    }
    setConfig(setting, value) {
        if (setting === undefined || value === undefined) (0, $fvmH2.throwError)(`No value passed for "${setting}"`);
        switch(setting){
            case 'maxRetryAttempts':
            case 'batchSize':
            case 'timeout':
                if (!Number.isNaN(Number(value))) {
                    this.queue[setting] = Number(value);
                    return;
                }
                break;
            case 'logEventsToConsole':
                if (Object.values((0, $4ya6m.LogEventsToConsole)).includes(value)) {
                    this.queue[setting] = (0, $fvmH2.shouldLogEventsToConsole)(value, this.environment);
                    return;
                }
                break;
            default:
                (0, $fvmH2.throwError)(`"${setting}" is not a valid setting`);
        }
        (0, $fvmH2.throwError)(`Invalid value passed for "${setting}"`);
    }
    getConfig(setting) {
        switch(setting){
            case 'maxRetryAttempts':
            case 'batchSize':
            case 'timeout':
                return this.queue[setting];
            case 'name':
            case 'version':
            case 'environment':
                return this[setting];
            case 'logEventsToConsole':
                return this.queue.logEventsToConsole;
            default:
        }
        return undefined;
    }
    /**
     * Backwards compatible track function.
     * Use the trackV2 method if writing new API calls.
     */ track(eventName, properties, options, callbackFn) {
        // check that event name is a valid non-empty string
        if (!(0, $i34zz.isString)(eventName) || !eventName.trim()) (0, $fvmH2.throwError)('"eventName" argument is required.');
        // Argument reshuffling code copied from data-api.js
        /* eslint-disable no-param-reassign */ if ((0, $i34zz.isFunction)(options)) {
            callbackFn = options;
            options = undefined;
        }
        if ((0, $i34zz.isFunction)(properties)) {
            callbackFn = properties;
            options = undefined;
            properties = {};
        }
        /* eslint-enable no-param-reassign */ if (properties && !(0, $i34zz.isRecord)(properties)) (0, $fvmH2.warn)('Argument "properties" is not an object. Use the trackV2 method which has consistent method arguments.');
        this.trackV2({
            eventName: eventName,
            eventProps: (0, $i34zz.isRecord)(properties) ? properties : {},
            options: options !== null && options !== void 0 ? options : {}
        });
        (0, $hLZet.timeout)(callbackFn);
        return this;
    }
    /**
     * Type safe track function
     */ trackV2(trackArgs) {
        const { eventName: eventName, eventProps: eventProps, options: options } = trackArgs;
        new (0, $4530a0811e382d39$export$2e2bcd8739ae039)(this.queue, this.user, this.key).fire(eventName, eventProps !== null && eventProps !== void 0 ? eventProps : {}, options !== null && options !== void 0 ? options : {});
    }
    /**
     * Backwards compatible identify function.
     * Use the identifyV2 method if writing new API calls.
     */ identify(// no validation for entity Id or Type as this will default
    // to anonymous with AVT if values here are incorrect
    entityId, entityType, traits, options, callbackFn) {
        // Argument reshuffling code copied from data-api.js
        /* eslint-disable no-param-reassign */ if ((0, $i34zz.isFunction)(options)) {
            callbackFn = options;
            options = null;
        }
        if ((0, $i34zz.isFunction)(traits)) {
            callbackFn = traits;
            options = null;
            traits = null;
        }
        /* eslint-enable no-param-reassign */ if (traits && !(0, $i34zz.isTraits)(traits)) (0, $fvmH2.warn)('Argument "traits" is not an object. Use the identifyV2 method which has consistent method arguments.');
        this.identifyV2({
            entityId: entityId,
            entityType: entityType,
            traits: (0, $i34zz.isTraits)(traits) ? traits : {},
            options: options !== null && options !== void 0 ? options : {}
        });
        (0, $hLZet.timeout)(callbackFn);
        return this;
    }
    /**
     * Type safe track function
     */ identifyV2(identifyArgs) {
        const { entityId: entityId, entityType: entityType, traits: traits, options: options } = identifyArgs;
        this.user._identify(entityId, entityType, traits);
        new (0, $e029523b7e4ed9b6$export$2e2bcd8739ae039)(this.queue, this.user, this.key).fire(this.user.entityTraits, options !== null && options !== void 0 ? options : {});
    }
    /**
     * Backwards compatible page function.
     * Use the pageV2 method if writing new API calls.
     */ page(pageCategory, pageName, properties, options, callbackFn) {
        // Argument reshuffling code copied from data-api.js
        /* eslint-disable no-param-reassign */ if ((0, $i34zz.isFunction)(options)) {
            callbackFn = options;
            options = null;
        }
        if ((0, $i34zz.isFunction)(properties)) {
            callbackFn = properties;
            options = properties = null;
        }
        if ((0, $i34zz.isFunction)(pageName)) {
            callbackFn = pageName;
            options = properties = pageName = undefined;
        }
        if ((0, $i34zz.isObject)(pageCategory)) {
            options = pageName;
            properties = pageCategory;
            pageName = pageCategory = undefined;
        }
        if ((0, $i34zz.isObject)(pageName)) {
            options = properties;
            properties = pageName;
            pageName = undefined;
        }
        if ((0, $i34zz.isString)(pageCategory) && !(0, $i34zz.isString)(pageName)) {
            pageName = pageCategory;
            pageCategory = undefined;
        }
        /* eslint-enable no-param-reassign */ if (pageCategory && !(0, $i34zz.isString)(pageCategory)) (0, $fvmH2.warn)('Argument "pageCategory" is not a string. Use the pageV2 method which has consistent method arguments.');
        if (pageName && !(0, $i34zz.isString)(pageName)) (0, $fvmH2.warn)('Argument "pageName" is not a string. Use the pageV2 method which has consistent method arguments.');
        if (properties && !(0, $i34zz.isRecord)(properties)) (0, $fvmH2.warn)('Argument "properties" is not an object. Use the pageV2 method which has consistent method arguments.');
        if (options && !(0, $i34zz.isRecord)(options)) (0, $fvmH2.warn)('Argument "options" is not an object. Use the pageV2 method which has consistent method arguments.');
        this.pageV2({
            pageCategory: (0, $i34zz.isString)(pageCategory) ? pageCategory : undefined,
            pageName: (0, $i34zz.isString)(pageName) ? pageName : undefined,
            eventProps: (0, $i34zz.isRecord)(properties) ? properties : undefined,
            options: (0, $i34zz.isRecord)(options) ? options : undefined
        });
        (0, $hLZet.timeout)(callbackFn);
        return this;
    }
    /**
     * Type safe page function
     */ pageV2(pageArgs) {
        const { pageCategory: pageCategory, pageName: pageName, eventProps: eventProps, options: options } = pageArgs;
        new (0, $3d1b628e06db0d94$export$2e2bcd8739ae039)(this.queue, this.user, this.key).fire(pageCategory, pageName, eventProps !== null && eventProps !== void 0 ? eventProps : {}, options !== null && options !== void 0 ? options : {});
    }
    /**
     * Unsupported group function. Reach out to #martech
     * if you intend to use this function.
     */ group(groupId, traits, options) {
        this.groupV2({
            groupId: groupId,
            traits: traits,
            options: options
        });
        return this;
    }
    groupV2(groupArgs) {
        const { groupId: groupId, traits: traits, options: options } = groupArgs;
        new (0, $240633c0466106e8$export$2e2bcd8739ae039)(this.queue, this.user, this.key).fire(groupId, traits, options !== null && options !== void 0 ? options : {});
    }
    trackViewFeature(properties) {
        (0, $cCZXV.trackViewFeature)(this, properties);
    }
    trackClickFeature(properties) {
        (0, $cCZXV.trackClickFeature)(this, properties);
    }
    trackClickLink(properties) {
        (0, $cCZXV.trackClickLink)(this, properties);
    }
    trackError(properties) {
        (0, $cCZXV.trackError)(this, properties);
    }
}
var $39aefecf4ce2d04e$export$2e2bcd8739ae039 = $39aefecf4ce2d04e$export$f15b3b9a7d41d3aa;


var $4ya6m = parcelRequire("4ya6m");

const $d0d964ae431b09d8$var$API_KEY_STAGING = "832421b1-5d5b-4b01-bfd5-caa9fb405c7d";
const $d0d964ae431b09d8$var$API_KEY_PRODUCTION = "0ad09861-154b-4304-b1e1-84b23026a89e";
const $d0d964ae431b09d8$var$getApiKey = (environment)=>{
    switch(environment){
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Development:
            return "TEST_API_KEY";
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Staging:
            return $d0d964ae431b09d8$var$API_KEY_STAGING;
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Production:
            return $d0d964ae431b09d8$var$API_KEY_PRODUCTION;
        default:
            throw new Error("Unsupported environment for CDP");
    }
};
const $d0d964ae431b09d8$var$getEnvironment = (environment)=>{
    switch(environment){
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Development:
            return (0, $4ya6m.Environments).localDev;
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Staging:
            return (0, $4ya6m.Environments).stage;
        case (0, $078609d239e2b7c3$export$7dc6752a22ab011a).Production:
            return (0, $4ya6m.Environments).production;
        default:
            throw new Error("Unsupported environment for CDP");
    }
};
const $d0d964ae431b09d8$export$ba9fd443d3b686ce = (environment)=>new (0, $39aefecf4ce2d04e$export$f15b3b9a7d41d3aa)({
        apiKey: $d0d964ae431b09d8$var$getApiKey(environment),
        environment: $d0d964ae431b09d8$var$getEnvironment(environment)
    });
const $d0d964ae431b09d8$export$d66a1788a2497e64 = (personToken)=>({
        entityType: (0, $4ya6m.EntityTypes).person,
        entityId: personToken
    });


const $e4f881c141a2f86c$var$CdpContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
function $e4f881c141a2f86c$export$a2c75276dce92780({ environment: environment, personToken: personToken, children: children }) {
    const [cdp, setCdp] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        const cdp = (0, $d0d964ae431b09d8$export$ba9fd443d3b686ce)(environment);
        cdp.identifyV2((0, $d0d964ae431b09d8$export$d66a1788a2497e64)(personToken));
        setCdp(cdp);
    }, []);
    return cdp ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e4f881c141a2f86c$var$CdpContext.Provider, {
        value: cdp,
        children: children
    }) : null;
}
const $e4f881c141a2f86c$export$b2b9e07b4a5e09bc = ()=>{
    const cdp = (0, $acw62.useContext)($e4f881c141a2f86c$var$CdpContext);
    if (!cdp) throw new Error("Trying to use CDP hook but CDP instance has been be created");
    return cdp;
};




var $acw62 = parcelRequire("acw62");
const $6a9ee46bb299cc77$var$UserContext = /*#__PURE__*/ (0, $acw62.createContext)([
    undefined,
    ()=>undefined
]);
function $6a9ee46bb299cc77$export$88f24fd8fcfab6ca({ initialUser: initialUser, children: children }) {
    // TODO(cvu): Handle responsibility of re-fetching person data into UserContext
    // Tech debt ticket: https://jira.sqprod.co/browse/SQCARD-2840
    const [user, setUser] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (initialUser) {
            if (user) throw new Error("User already set. Please use `setUser` from context to update User");
            setUser(initialUser);
        }
    }, [
        initialUser
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6a9ee46bb299cc77$var$UserContext.Provider, {
        value: [
            user,
            setUser
        ],
        children: children
    });
}
const $6a9ee46bb299cc77$export$23bbbc4533528f03 = ()=>(0, $acw62.useContext)($6a9ee46bb299cc77$var$UserContext);






var $615d179a8c27ee51$export$4f67169e154cee8f;
$615d179a8c27ee51$export$4f67169e154cee8f = `C6iQuq_ActionCardListItem_mobileAction`;


var $f3a85f73b7c64a2a$export$8654921a6a5908fc;
var $f3a85f73b7c64a2a$export$7466047bb510a932;
var $f3a85f73b7c64a2a$export$120ff0929b202a6d;
var $f3a85f73b7c64a2a$export$7c29df341f8f08e0;
$f3a85f73b7c64a2a$export$8654921a6a5908fc = `QapKMW_CardList_cardImage`;
$f3a85f73b7c64a2a$export$7466047bb510a932 = `QapKMW_CardList_cardImageContainer`;
$f3a85f73b7c64a2a$export$120ff0929b202a6d = `QapKMW_CardList_row`;
$f3a85f73b7c64a2a$export$7c29df341f8f08e0 = `QapKMW_CardList_rowContainer`;





parcelRequire("acw62");
const $55dd9b3900c1b5df$var$SvgUnclaimedCard = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 100 63",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: 99,
                height: 62,
                x: 0.5,
                y: 0.5,
                fill: "#000",
                fillOpacity: 0.03,
                rx: 3.5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#fff",
                d: "M51 38.5v-6h6v-2h-6v-6h-2v6h-6v2h6v6z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: 99,
                height: 62,
                x: 0.5,
                y: 0.5,
                stroke: "url(#unclaimed-card_svg__a)",
                strokeDasharray: "8 3",
                rx: 3.5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                    id: "unclaimed-card_svg__a",
                    x1: 50,
                    x2: 50,
                    y1: 1,
                    y2: 62,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            stopOpacity: 0.05
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: 1,
                            stopOpacity: 0.14
                        })
                    ]
                })
            })
        ]
    });
var $55dd9b3900c1b5df$export$2e2bcd8739ae039 = $55dd9b3900c1b5df$var$SvgUnclaimedCard;


const $c132a48b6eaf5d4b$export$4d2ca89a51f2af83 = (cardListItemProps)=>{
    return "buttonText" in cardListItemProps;
};
function $c132a48b6eaf5d4b$export$50fc1233c883cd6d({ buttonText: buttonText, cardImage: cardImage, subtext: subtext, title: title, onItemClick: onItemClick }) {
    const windowDimensions = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$14eeaa98ef1abeb2), {
        class: $f3a85f73b7c64a2a$export$120ff0929b202a6d,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                slot: "leading-accessory",
                className: $f3a85f73b7c64a2a$export$7466047bb510a932,
                children: cardImage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01b628065e650f1c$export$20c0b5ff3d7d9924), {
                    className: $f3a85f73b7c64a2a$export$8654921a6a5908fc,
                    businessName: cardImage.businessName,
                    signatureDataUri: cardImage?.signatureUri
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55dd9b3900c1b5df$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                slot: "label",
                children: title
            }),
            windowDimensions.isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $615d179a8c27ee51$export$4f67169e154cee8f),
                slot: "subtext",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: subtext
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        onClick: onItemClick,
                        children: buttonText
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        slot: "subtext",
                        children: subtext
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                        slot: "control",
                        rank: "primary",
                        onClick: onItemClick,
                        children: buttonText
                    })
                ]
            })
        ]
    });
}








function $20057657b35eb547$export$9156e7ca4e0589e5({ cardImage: cardImage, subtext: subtext, title: title, onItemClick: onItemClick }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$14eeaa98ef1abeb2), {
        class: $f3a85f73b7c64a2a$export$120ff0929b202a6d,
        interactive: true,
        transient: true,
        variant: "drill",
        onClick: onItemClick,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                slot: "leading-accessory",
                className: $f3a85f73b7c64a2a$export$7466047bb510a932,
                children: cardImage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01b628065e650f1c$export$20c0b5ff3d7d9924), {
                    className: $f3a85f73b7c64a2a$export$8654921a6a5908fc,
                    businessName: cardImage.businessName,
                    signatureDataUri: cardImage?.signatureUri
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55dd9b3900c1b5df$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                slot: "label",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                slot: "subtext",
                children: subtext
            })
        ]
    });
}


function $95a30c6e0ec76fc2$export$bb29c16f5612603e({ cardListItems: cardListItems }) {
    const getCardListItemComponent = (props)=>{
        return (0, $c132a48b6eaf5d4b$export$4d2ca89a51f2af83)(props) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c132a48b6eaf5d4b$export$50fc1233c883cd6d), {
            ...props
        }, props.cardToken) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20057657b35eb547$export$9156e7ca4e0589e5), {
            ...props
        }, props.cardToken);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $f3a85f73b7c64a2a$export$7c29df341f8f08e0),
        children: cardListItems.map((card)=>getCardListItemComponent(card))
    });
}


var $22e7bf8618bb78d1$export$5736b3a32ef5fe55;
var $22e7bf8618bb78d1$export$252465da46a2ae40;
var $22e7bf8618bb78d1$export$38e42c68cf43b5d4;
var $22e7bf8618bb78d1$export$1ca1ec8b29a4ce27;
var $22e7bf8618bb78d1$export$acf4eaf431084f78;
var $22e7bf8618bb78d1$export$523fb3936f49e028;
$22e7bf8618bb78d1$export$5736b3a32ef5fe55 = `-pzsaG_CardHome_desktopCardLists`;
$22e7bf8618bb78d1$export$252465da46a2ae40 = `-pzsaG_CardHome_emptyState`;
$22e7bf8618bb78d1$export$38e42c68cf43b5d4 = `-pzsaG_CardHome_header`;
$22e7bf8618bb78d1$export$1ca1ec8b29a4ce27 = `-pzsaG_CardHome_icon`;
$22e7bf8618bb78d1$export$acf4eaf431084f78 = `-pzsaG_CardHome_iconContainer`;
$22e7bf8618bb78d1$export$523fb3936f49e028 = `-pzsaG_CardHome_page`;


/**
 * This version of this util file uses the models defined in bb-debit. This will replace the current util
 * once have completely migrated to bb-debit
 */ 

/**
 * This version of this util file uses the models defined in bb-debit. This will replace the current util
 * once have completely migrated to bb-debit
 */ const $12d982416c644898$export$dbbc3f17800c9c64 = (customization)=>{
    const { imageBytes: imageBytes, mimeType: mimeType } = customization;
    if (imageBytes == null || mimeType == null) return "";
    if (imageBytes.length === 0 || mimeType.length === 0) return "";
    const imageString = $12d982416c644898$export$31da71098e0122bc(imageBytes);
    return `data:${mimeType};base64,${imageString}`;
};
const $12d982416c644898$export$31da71098e0122bc = (bytes)=>{
    const bin = bytes.reduce((arr, byte)=>{
        arr.push(String.fromCharCode(byte));
        return arr;
    }, []).join("");
    return btoa(bin);
};



const $1f03a6bc7d91b109$export$af0ed80290d14473 = (card)=>card.fulfillment?.cardCustomization?.cardTexts?.find((cardText)=>cardText.type === (0, $d272bac0a1712861$export$f27319a4138ec79f).CardText.Type.CARD_TEXT_TYPE_BUSINESS_NAME)?.text ?? "";
const $1f03a6bc7d91b109$export$f0d76c98e43e3f03 = (card)=>card.fulfillment?.cardCustomization?.cardTexts?.find((cardText)=>cardText.type === (0, $d272bac0a1712861$export$f27319a4138ec79f).CardText.Type.CARD_TEXT_TYPE_CARDHOLDER_NAME)?.text ?? "";
const $1f03a6bc7d91b109$export$461358cf94db3eb1 = (cardCustomization)=>{
    if (cardCustomization) return (0, $12d982416c644898$export$dbbc3f17800c9c64)(cardCustomization);
    return "";
};
const $1f03a6bc7d91b109$export$7f1de93407df59b0 = (card)=>{
    return card.securityCode || "";
};
const $1f03a6bc7d91b109$export$1bbc5be1c1af00a7 = (card)=>{
    const expiration = card.expirationData?.expiration;
    if (!expiration) return "";
    const formatter = new (0, $58cb02b9641cce25$exports.ExpiryDateFormatter)();
    return formatter.format({
        month: expiration.monthOfYear,
        year: expiration.year
    });
};
const $1f03a6bc7d91b109$export$eb37d3dae2bf604a = (card)=>{
    return card.fullPan || "";
};
const $1f03a6bc7d91b109$export$8e48b4074de9a9df = (card)=>card?.status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_ACTIVATABLE;
const $1f03a6bc7d91b109$export$8a4b2f4654e557c3 = (0, $32d23a4e2afcf5bf$export$90f2e2c209b42f72).create({
    paths: [
        "id",
        "status",
        "card_brand",
        "fulfillment",
        "last_four",
        "full_pan",
        "security_code",
        "can_digital_spend",
        "balance_id",
        "relationship",
        "expiration_data"
    ]
});



const $3263116ab73aeb84$export$3d0307c837ed757 = (t)=>(cards, customizationMap, activationCallback)=>cards.map((card)=>$3263116ab73aeb84$var$createActivatableCardListItem(card, customizationMap.get(card.id) ?? null, t, activationCallback));
function $3263116ab73aeb84$var$createActivatableCardListItem(card, customization, t, activationCallback) {
    const cardImage = $3263116ab73aeb84$export$58d4d1c2211d37f3(card, customization ?? undefined);
    return {
        buttonText: t("cardList.existingCard.activateCard.buttonText"),
        cardImage: cardImage,
        cardToken: card.id,
        subtext: t("cardList.existingCard.lastFourPanText", {
            replace: {
                lastFourPan: card.lastFour
            }
        }),
        title: cardImage.businessName,
        onItemClick: ()=>activationCallback(card)
    };
}
const $3263116ab73aeb84$export$7b36776e8ade4f1a = (navigate, t)=>(cards, customizationMap)=>cards.map((card)=>{
            const customization = customizationMap.get(card.id) ?? null;
            return $3263116ab73aeb84$var$createCardListItem(card, customization, navigate, t);
        });
function $3263116ab73aeb84$var$createCardListItem(card, customization, navigate, t) {
    const cardImage = $3263116ab73aeb84$export$58d4d1c2211d37f3(card, customization ?? undefined);
    return {
        cardImage: cardImage,
        cardToken: card.id,
        subtext: t("cardList.existingCard.lastFourPanText", {
            replace: {
                lastFourPan: card.lastFour
            }
        }),
        title: cardImage.businessName,
        onItemClick: ()=>navigate(`/card/${card.id}/settings`)
    };
}
const $3263116ab73aeb84$export$58d4d1c2211d37f3 = (card, customization)=>({
        businessName: (0, $1f03a6bc7d91b109$export$af0ed80290d14473)(card),
        signatureUri: (0, $1f03a6bc7d91b109$export$461358cf94db3eb1)(customization)
    });
const $3263116ab73aeb84$export$e6312e49a41c0ec6 = (cards)=>cards.reduce(([accActivatableCards, accClaimedCards], card)=>{
        if (card.status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_ACTIVATABLE) accActivatableCards.push(card);
        else accClaimedCards.push(card);
        return [
            accActivatableCards,
            accClaimedCards
        ];
    }, [
        [],
        []
    ]);



parcelRequire("acw62");
const $3fe9fa928f0c0d60$var$SvgAlertNoEntry = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            d: "M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m7 9c0 1.57-.53 3.02-1.4 4.18L4.82 3.4C5.98 2.53 7.43 2 9 2c3.86 0 7 3.14 7 7M2 9c0-1.57.53-3.02 1.4-4.18l9.78 9.78C12.02 15.47 10.57 16 9 16c-3.86 0-7-3.14-7-7"
        })
    });
var $3fe9fa928f0c0d60$export$2e2bcd8739ae039 = $3fe9fa928f0c0d60$var$SvgAlertNoEntry;




async function $a5705b90962ee2ab$var$fetchCardsAndInvitations(cardManagementService, bankingWebService, externalBizbankService, t, navigate) {
    // Fetch all Cards and OpenCardInvitations
    const [cardsResponse, invitationsResponse] = await Promise.all([
        cardManagementService.listCards((0, $d272bac0a1712861$export$1f9ff0d796a08011).create()),
        bankingWebService.listOpenCardInvitations((0, $2a6a68ea1459b895$export$498c8f0ad968f111).create())
    ]);
    const cards = [
        ...cardsResponse.cards ?? []
    ];
    // Fetch the CardCustomization, which contains the Signature, for each Card
    // Put the CardCustomizations in a Map for easy access when rendering the cards
    const customizationEntries = await Promise.all(cards.map(async (card)=>{
        const token = card.fulfillment?.cardCustomization?.id;
        if (!token) return [
            card.id,
            null
        ];
        const res = await externalBizbankService.getCardCustomization((0, $3f73c216104868a6$export$1a963d2655841b69).create({
            customizationToken: token
        }));
        return [
            card.id,
            res.cardCustomization ?? null
        ];
    }));
    const customizationMap = new Map(customizationEntries);
    // Separate ActivatableCards from ClaimedCards
    // Create lists of ActionCardListItemProps and CardListItemProps for display
    const [activatableCards, claimedCards] = (0, $3263116ab73aeb84$export$e6312e49a41c0ec6)(cards);
    const activatableCardsListItems = (0, $3263116ab73aeb84$export$3d0307c837ed757)(t)(activatableCards, customizationMap, (card)=>navigate(`/activate-card/${card.id}`));
    const cardsListItems = (0, $3263116ab73aeb84$export$7b36776e8ade4f1a)(navigate, t)(claimedCards, customizationMap);
    return {
        activatableCardsListItems: activatableCardsListItems,
        cardsListItems: cardsListItems,
        cardInvitations: [
            ...invitationsResponse.openCardInvitations ?? []
        ]
    };
}
function $a5705b90962ee2ab$export$1f8c1c7183c9c5f7({ bankingWebCardService: bankingWebCardService, bankingWebComplianceService: bankingWebComplianceService, bankingWebService: bankingWebService, cardManagementService: cardManagementService, externalBizbankService: externalBizbankService, personProfileService: personProfileService, userCardInvitationService: userCardInvitationService, webService: webService }) {
    const cdp = (0, $e4f881c141a2f86c$export$b2b9e07b4a5e09bc)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("common");
    const [user, setUser] = (0, $6a9ee46bb299cc77$export$23bbbc4533528f03)();
    const navigate = (0, $3e8179397014bb35$export$9770f232ac06a008)();
    const { isMobile: isMobile } = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [cardInvitations, setCardInvitations] = (0, $acw62.useState)([]);
    const [activatableCardsListItems, setActivatableCardsListItems] = (0, $acw62.useState)([]);
    const [cardsListItems, setCardsListItems] = (0, $acw62.useState)([]);
    const [cardIssuingState, cardIssuingDispatch, cardIssuingWorkflow] = (0, $52d6aae768cd1bf0$export$7bc289ae93a0a81d)({
        bankingWebCardService: bankingWebCardService,
        bankingWebComplianceService: bankingWebComplianceService,
        cardManagementService: cardManagementService,
        personProfileService: personProfileService,
        sentry: {
            captureException: $b8438.captureException
        },
        textRenderer: (0, $74c7b72a71b76868$export$2e2bcd8739ae039),
        userCardInvitationService: userCardInvitationService,
        uuid: $3fa3ae484854b431$export$2e2bcd8739ae039,
        webService: webService
    }, $b2490fa107d6478d$export$e6a0daad8304de(), $b2490fa107d6478d$export$2e2bcd8739ae039);
    (0, $acw62.useEffect)(()=>{
        // Initialize the workflow
        cardIssuingWorkflow.states.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(({ done: done })=>done)).subscribe((state)=>{
            personProfileService.getPersonProfile((0, $3f95b099726a1553$export$2ad677b174787c25).create())// TODO(cvu): Figure out how to move the responsibility of re-fetching person data into UserContext
            // Going to leave this for now. Tech debt ticket: https://jira.sqprod.co/browse/SQCARD-2840
            .then((response)=>{
                const profile = response.profile;
                (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(profile, "Profile does not exist in GetPersonProfileResponse");
                setUser((0, $f52070b5f7ea08cf$export$f0f3a5c436134bc0)(profile));
                navigate(`/card/${state.cardToken}/settings`);
            });
        });
        // Initialize analytics
        (0, $4bc04b71b868732d$export$2e2bcd8739ae039)(cardIssuingWorkflow.updates).subscribe((params)=>{
            cdp.trackV2(params);
        });
        // Fetch all Cards and Invitations
        const getCards = async ()=>{
            const { activatableCardsListItems: activatableCardsListItems, cardsListItems: cardsListItems, cardInvitations: cardInvitations } = await $a5705b90962ee2ab$var$fetchCardsAndInvitations(cardManagementService, bankingWebService, externalBizbankService, t, navigate);
            setActivatableCardsListItems(activatableCardsListItems);
            setCardsListItems(cardsListItems);
            setCardInvitations(cardInvitations);
            setLoading(false);
        };
        getCards();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (loading) return;
        // Open ordering flow if the person only has one invitation and no cards.
        if (cardInvitations.length === 1 && activatableCardsListItems.length === 0 && cardsListItems.length === 0) {
            cardIssuingDispatch($b2490fa107d6478d$export$c81c36414a1e3192(cardInvitations[0].balanceId, cardInvitations[0].name, cardInvitations[0].cardInvitationToken, user || {
                personToken: "",
                name: {
                    first: "",
                    last: ""
                }
            }, true));
            cardIssuingDispatch($b2490fa107d6478d$export$2085928ad4455e61(true));
        }
    }, [
        loading
    ]);
    const cardInvitationListItems = cardInvitations.map((cardInvitation)=>({
            buttonText: t("cardList.newCard.orderCard.buttonText"),
            cardToken: cardInvitation.cardInvitationToken,
            subtext: t("cardList.newCard.subtext"),
            title: cardInvitation.name,
            onItemClick: ()=>{
                cardIssuingDispatch($b2490fa107d6478d$export$c81c36414a1e3192(cardInvitation.balanceId, cardInvitation.name, cardInvitation.cardInvitationToken, user || {
                    personToken: "",
                    name: {
                        first: "",
                        last: ""
                    }
                }, cardsListItems.length === 0));
                cardIssuingDispatch($b2490fa107d6478d$export$2085928ad4455e61(true));
            }
        }));
    const allListItems = [
        ...cardInvitationListItems,
        ...activatableCardsListItems,
        ...cardsListItems
    ];
    const hasListItems = allListItems.length > 0;
    // Render content based on the state of the Card lists
    const renderContent = ()=>{
        if (!hasListItems) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: $22e7bf8618bb78d1$export$252465da46a2ae40,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: $22e7bf8618bb78d1$export$acf4eaf431084f78,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3fe9fa928f0c0d60$export$2e2bcd8739ae039), {
                        className: $22e7bf8618bb78d1$export$1ca1ec8b29a4ce27
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: t("cardHome.emptyState")
                })
            ]
        });
        else if (isMobile) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a30c6e0ec76fc2$export$bb29c16f5612603e), {
            cardListItems: allListItems
        });
        else {
            const actionableItems = [
                ...cardInvitationListItems,
                ...activatableCardsListItems
            ];
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $22e7bf8618bb78d1$export$5736b3a32ef5fe55,
                children: [
                    actionableItems.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a30c6e0ec76fc2$export$bb29c16f5612603e), {
                        cardListItems: actionableItems
                    }),
                    cardsListItems.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a30c6e0ec76fc2$export$bb29c16f5612603e), {
                        cardListItems: cardsListItems
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $10b264b7e14b606b$export$6955bcca4cd3539f), {
                loading: loading,
                className: $22e7bf8618bb78d1$export$523fb3936f49e028,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("header-30", $22e7bf8618bb78d1$export$38e42c68cf43b5d4),
                        children: t("cardHome.list.header")
                    }),
                    renderContent(),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e8179397014bb35$export$910ae8079b2c2852), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd61bc2ba06a0509$export$cee179dbf81603ea), {
                state: cardIssuingState,
                dispatch: cardIssuingDispatch
            })
        ]
    });
}



const $88be25437d5209b9$export$13f025e534889db5 = (0, $7c5a3dd94b85a123$export$72f8d6ff1467b5f4)((0, $a5705b90962ee2ab$export$1f8c1c7183c9c5f7), {
    bankingWebCardService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).BANKING_WEB_CARD_SERVICE,
    bankingWebComplianceService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).BANKING_WEB_COMPLIANCE_SERVICE,
    bankingWebService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).BANKING_WEB_SERVICE,
    cardManagementService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).CARD_MANAGEMENT_SERVICE,
    externalBizbankService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).EXTERNAL_BIZBANK_SERVICE,
    personProfileService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).PERSON_PROFILE_SERVICE,
    userCardInvitationService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).USER_CARD_INVITATION_SERVICE,
    webService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).WEB_SERVICE
});







var $b8438 = parcelRequire("b8438");

var $acw62 = parcelRequire("acw62");










var $6f7a3101dc7a9683$export$8d6d009d1f06226e;
var $6f7a3101dc7a9683$export$3914d6a81335784f;
var $6f7a3101dc7a9683$export$38e42c68cf43b5d4;
var $6f7a3101dc7a9683$export$15c60d712917cee6;
$6f7a3101dc7a9683$export$8d6d009d1f06226e = `Y5a8AW_PageHeader_backButton`;
$6f7a3101dc7a9683$export$3914d6a81335784f = `Y5a8AW_PageHeader_backButtonIcon`;
$6f7a3101dc7a9683$export$38e42c68cf43b5d4 = `Y5a8AW_PageHeader_header`;
$6f7a3101dc7a9683$export$15c60d712917cee6 = `Y5a8AW_PageHeader_headerTitle`;


function $0cb7d9ae27028ab3$export$53f1cd6809577fc5({ breadcrumb: breadcrumb, title: title }) {
    const windowDimensions = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    // FIXME(cvu): replace with whatever svg solution we figure out later
    const backArrowSvg = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 8H1M1 8L8 1M1 8L8 15",
            stroke: "black",
            strokeOpacity: "0.9",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $6f7a3101dc7a9683$export$38e42c68cf43b5d4),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e8179397014bb35$export$a6c7ac8248d6e38a), {
                ...breadcrumb.link,
                children: windowDimensions.isMobile ? // For some reason adding classnames makes market button styles go weird if icon only button
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                    rank: "secondary",
                    slot: "navigation",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $6f7a3101dc7a9683$export$3914d6a81335784f),
                        slot: "icon",
                        children: backArrowSvg
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                    className: (0, $6f7a3101dc7a9683$export$8d6d009d1f06226e),
                    rank: "secondary",
                    slot: "navigation",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $6f7a3101dc7a9683$export$3914d6a81335784f),
                            slot: "icon",
                            children: backArrowSvg
                        }),
                        breadcrumb.title
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("heading-20", (0, $6f7a3101dc7a9683$export$15c60d712917cee6)),
                children: title
            })
        ]
    });
}







var $f85882ff218eecf6$export$4d6040b341c06f0d = /*#__PURE__*/ function(CardSettingError) {
    CardSettingError[CardSettingError["None"] = 0] = "None";
    CardSettingError[CardSettingError["Generic"] = 1] = "Generic";
    return CardSettingError;
}({});
const $f85882ff218eecf6$export$36d128238e6b60f5 = {
    card: null,
    cardCustomization: null,
    error: 0,
    loading: true,
    showCardDetails: false,
    toggleLoading: {
        lockCard: false,
        showCardDetails: false
    }
};
const $f85882ff218eecf6$export$e6a0daad8304de = (overrides = {})=>({
        ...$f85882ff218eecf6$export$36d128238e6b60f5,
        ...overrides
    });
var $f85882ff218eecf6$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["Initialize"] = "INITIALIZE";
    ActionType["GetCardCustomizationReceived"] = "GET_CARD_CUSTOMIZATION_RECEIVED";
    ActionType["GetCardCustomizationRejected"] = "GET_CARD_CUSTOMIZATION_REJECTED";
    ActionType["LockCardReceived"] = "LOCK_CARD_RECEIVED";
    ActionType["LockCardRejected"] = "LOCK_CARD_REJECTED";
    ActionType["RetrieveCardReceived"] = "RETRIEVE_CARD_RECEIVED";
    ActionType["RetrieveCardRejected"] = "RETRIEVE_CARD_REJECTED";
    ActionType["UnlockCardReceived"] = "UNLOCK_CARD_RECEIVED";
    ActionType["UnlockCardRejected"] = "UNLOCK_CARD_REJECTED";
    ActionType["UserClickActivateCard"] = "USER_CLICK_ACTIVATE_CARD";
    ActionType["UserClickResetPin"] = "USER_CLICK_RESET_PIN";
    ActionType["UserToggleCardDetails"] = "USER_TOGGLE_CARD_DETAILS";
    ActionType["UserToggleLockCard"] = "USER_TOGGLE_LOCK_CARD";
    return ActionType;
}({});
const $f85882ff218eecf6$export$c81c36414a1e3192 = (cardToken)=>({
        type: "INITIALIZE",
        cardToken: cardToken
    });
const $f85882ff218eecf6$export$e4cfa67b45b8795 = (response)=>({
        type: "GET_CARD_CUSTOMIZATION_RECEIVED",
        response: response
    });
const $f85882ff218eecf6$export$bc7f28f58cbf0d00 = (error)=>({
        type: "GET_CARD_CUSTOMIZATION_REJECTED",
        error: error
    });
const $f85882ff218eecf6$export$1bbe87ab8acfab84 = (response)=>({
        type: "LOCK_CARD_RECEIVED",
        response: response
    });
const $f85882ff218eecf6$export$8e3fd900d5c185c6 = (error)=>({
        type: "LOCK_CARD_REJECTED",
        error: error
    });
const $f85882ff218eecf6$export$212307bd3d2bba11 = (response)=>({
        type: "RETRIEVE_CARD_RECEIVED",
        response: response
    });
const $f85882ff218eecf6$export$d0acd6b8d53632a7 = (error)=>({
        type: "RETRIEVE_CARD_REJECTED",
        error: error
    });
const $f85882ff218eecf6$export$5664b27f394d381d = (response)=>({
        type: "UNLOCK_CARD_RECEIVED",
        response: response
    });
const $f85882ff218eecf6$export$29aa61d5efabae5c = (error)=>({
        type: "UNLOCK_CARD_REJECTED",
        error: error
    });
const $f85882ff218eecf6$export$4b6cffd9a01ae17 = ()=>({
        type: "USER_CLICK_ACTIVATE_CARD"
    });
const $f85882ff218eecf6$export$95b3c069ab4a2752 = ()=>({
        type: "USER_CLICK_RESET_PIN"
    });
const $f85882ff218eecf6$export$f74d2d3c457dc478 = (value)=>({
        type: "USER_TOGGLE_CARD_DETAILS",
        value: value
    });
const $f85882ff218eecf6$export$d395068d63fb6384 = (value)=>({
        type: "USER_TOGGLE_LOCK_CARD",
        value: value
    });
function $f85882ff218eecf6$var$handleInitialize(context, action) {
    const { cardToken: cardToken } = action;
    const work = ()=>context.cardManagementService.retrieveCard((0, $d272bac0a1712861$export$8f1da4e33ad24fb3).create({
            cardToken: cardToken,
            fieldMask: (0, $1f03a6bc7d91b109$export$8a4b2f4654e557c3)
        })).then($f85882ff218eecf6$export$212307bd3d2bba11, $f85882ff218eecf6$export$d0acd6b8d53632a7);
    return [
        $f85882ff218eecf6$export$36d128238e6b60f5,
        work
    ];
}
function $f85882ff218eecf6$var$handleGetCardCustomizationReceived(context, state, action) {
    const cardCustomization = action.response.cardCustomization ?? (0, $3f73c216104868a6$export$4eecc657670f7f54).create();
    return [
        {
            ...state,
            cardCustomization: cardCustomization,
            loading: false
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleGetCardCustomizationRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(`Card settings: Fetching card customization failed ${error}`);
    return [
        {
            ...state,
            error: 1,
            loading: false
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleLockCardReceived(context, state, action) {
    const { errors: errors } = action.response;
    if (errors.length > 0) {
        context.sentry.captureException("Card settings [LockCardReceivedAction]: Failed to lock card");
        return [
            {
                ...state,
                error: 1,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: false
                }
            },
            null
        ];
    }
    const cardToken = state.card?.id;
    if (cardToken == null) {
        context.sentry.captureException("Card settings [LockCardReceivedAction]: Missing card token");
        return [
            {
                ...state,
                error: 1,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: false
                }
            },
            null
        ];
    }
    const work = ()=>context.cardManagementService.retrieveCard((0, $d272bac0a1712861$export$8f1da4e33ad24fb3).create({
            cardToken: cardToken,
            fieldMask: (0, $1f03a6bc7d91b109$export$8a4b2f4654e557c3)
        })).then($f85882ff218eecf6$export$212307bd3d2bba11, $f85882ff218eecf6$export$d0acd6b8d53632a7);
    return [
        state,
        work
    ];
}
function $f85882ff218eecf6$var$handleLockCardRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(`Card settings [LockCardRejectedAction]: Failed to lock card ${error}`);
    return [
        {
            ...state,
            error: 1,
            toggleLoading: {
                ...state.toggleLoading,
                lockCard: false
            }
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleRetrieveCardReceived(context, state, action) {
    const { card: card } = action.response;
    if (card == null) {
        context.sentry.captureException("Card settings: Missing card");
        return [
            {
                ...state,
                error: 1,
                loading: false,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: false
                }
            },
            null
        ];
    }
    const customizationToken = card?.fulfillment?.cardCustomization?.id;
    if (!customizationToken) return [
        state,
        null
    ];
    const work = ()=>context.externalBizbankService.getCardCustomization((0, $3f73c216104868a6$export$1a963d2655841b69).create({
            customizationToken: customizationToken
        })).then($f85882ff218eecf6$export$e4cfa67b45b8795, $f85882ff218eecf6$export$bc7f28f58cbf0d00);
    return [
        {
            ...state,
            card: card,
            loading: false,
            toggleLoading: {
                ...state.toggleLoading,
                lockCard: false
            }
        },
        work
    ];
}
function $f85882ff218eecf6$var$handleRetrieveCardRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(`Card settings: Fetching card failed ${error}`);
    return [
        {
            ...state,
            error: 1,
            loading: false,
            toggleLoading: {
                ...state.toggleLoading,
                lockCard: false
            }
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleUnlockCardReceived(context, state, action) {
    const { errors: errors } = action.response;
    if (errors.length > 0) {
        context.sentry.captureException("Card settings [UnlockCardReceivedAction]: Failed to unlock card");
        return [
            {
                ...state,
                error: 1,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: false
                }
            },
            null
        ];
    }
    const cardToken = state.card?.id;
    if (cardToken == null) {
        context.sentry.captureException("Card settings [UnlockCardReceivedAction]: Missing card token");
        return [
            {
                ...state,
                error: 1,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: false
                }
            },
            null
        ];
    }
    const work = ()=>context.cardManagementService.retrieveCard((0, $d272bac0a1712861$export$8f1da4e33ad24fb3).create({
            cardToken: cardToken,
            fieldMask: (0, $1f03a6bc7d91b109$export$8a4b2f4654e557c3)
        })).then($f85882ff218eecf6$export$212307bd3d2bba11, $f85882ff218eecf6$export$d0acd6b8d53632a7);
    return [
        state,
        work
    ];
}
function $f85882ff218eecf6$var$handleUnlockCardRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(`Card settings [UnlockCardRejectedAction]: Failed to unlock card ${error}`);
    return [
        {
            ...state,
            error: 1,
            loading: false
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleUserToggleCardDetails(state, action) {
    const { value: value } = action;
    return [
        {
            ...state,
            showCardDetails: value
        },
        null
    ];
}
function $f85882ff218eecf6$var$handleUserToggleLockCard(context, state, action) {
    const { value: value } = action;
    const cardToken = state.card?.id;
    if (cardToken == null) {
        context.sentry.captureException("Card setting [UserToggleLockCardAction]: Missing card token");
        return [
            {
                ...state,
                error: 1
            },
            null
        ];
    }
    if (value) {
        const work = ()=>context.cardManagementService.lockCard((0, $d272bac0a1712861$export$ea294dc182de2c2c).create({
                cardToken: cardToken
            })).then($f85882ff218eecf6$export$1bbe87ab8acfab84, $f85882ff218eecf6$export$8e3fd900d5c185c6);
        return [
            {
                ...state,
                toggleLoading: {
                    ...state.toggleLoading,
                    lockCard: true
                }
            },
            work
        ];
    }
    const work = ()=>context.cardManagementService.unlockCard((0, $d272bac0a1712861$export$708d55e385ca855d).create({
            cardToken: cardToken
        })).then($f85882ff218eecf6$export$5664b27f394d381d, $f85882ff218eecf6$export$29aa61d5efabae5c);
    return [
        {
            ...state,
            toggleLoading: {
                ...state.toggleLoading,
                lockCard: true
            }
        },
        work
    ];
}
/**
 * Noop is purely to have the action be called and the side effect will
 * outside the workflow.
 */ function $f85882ff218eecf6$var$noop(state) {
    return [
        state,
        null
    ];
}
const $f85882ff218eecf6$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "INITIALIZE":
                return $f85882ff218eecf6$var$handleInitialize(context, action);
            case "GET_CARD_CUSTOMIZATION_RECEIVED":
                return $f85882ff218eecf6$var$handleGetCardCustomizationReceived(context, state, action);
            case "GET_CARD_CUSTOMIZATION_REJECTED":
                return $f85882ff218eecf6$var$handleGetCardCustomizationRejected(context, state, action);
            case "LOCK_CARD_RECEIVED":
                return $f85882ff218eecf6$var$handleLockCardReceived(context, state, action);
            case "LOCK_CARD_REJECTED":
                return $f85882ff218eecf6$var$handleLockCardRejected(context, state, action);
            case "RETRIEVE_CARD_RECEIVED":
                return $f85882ff218eecf6$var$handleRetrieveCardReceived(context, state, action);
            case "RETRIEVE_CARD_REJECTED":
                return $f85882ff218eecf6$var$handleRetrieveCardRejected(context, state, action);
            case "UNLOCK_CARD_RECEIVED":
                return $f85882ff218eecf6$var$handleUnlockCardReceived(context, state, action);
            case "UNLOCK_CARD_REJECTED":
                return $f85882ff218eecf6$var$handleUnlockCardRejected(context, state, action);
            case "USER_CLICK_ACTIVATE_CARD":
                return $f85882ff218eecf6$var$noop(state);
            case "USER_CLICK_RESET_PIN":
                return $f85882ff218eecf6$var$noop(state);
            case "USER_TOGGLE_CARD_DETAILS":
                return $f85882ff218eecf6$var$handleUserToggleCardDetails(state, action);
            case "USER_TOGGLE_LOCK_CARD":
                return $f85882ff218eecf6$var$handleUserToggleLockCard(context, state, action);
        }
    };
const $f85882ff218eecf6$var$cardSettings = (seed, context)=>{
    const w = (0, $f244369e42336676$export$2e2bcd8739ae039)($f85882ff218eecf6$export$722fbec263ad908a(context), seed);
    return {
        states: w.states,
        updates: w.updates,
        emit: w.emit
    };
};
var $f85882ff218eecf6$export$2e2bcd8739ae039 = $f85882ff218eecf6$var$cardSettings;
















function $81bb7444e996fcbd$export$79391ed63190e48d({ cardholder: cardholder, className: className, cvc: cvc, expirationDate: expirationDate, fullPan: fullPan }) {
    // Add space after every four digits. This only works for Visa and Mastercard
    const formatFullPan = fullPan.replace(/(.{4})/g, "$1 ");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "335",
        height: "208",
        viewBox: "0 0 335 208",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "335",
                height: "208",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                y: "20",
                width: "335",
                height: "32",
                fill: "url(#paint0_linear_555_74960)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                className: "paragraph-30",
                textAnchor: "start",
                x: "19",
                y: "141",
                fill: "#101314",
                children: formatFullPan
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
                className: "paragraph-30",
                textAnchor: "start",
                x: "19",
                y: "165",
                fill: "#101314",
                children: [
                    "EXP ",
                    expirationDate
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("text", {
                className: "paragraph-30",
                textAnchor: "start",
                x: "108",
                y: "165",
                fill: "#101314",
                children: [
                    "CVC ",
                    cvc
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                className: "paragraph-30",
                textAnchor: "start",
                x: "19",
                y: "189",
                fill: "#101314",
                children: cardholder
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "272",
                cy: "171",
                r: "17",
                fill: "url(#paint1_linear_555_74960)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "294",
                cy: "171",
                r: "17",
                fill: "url(#paint2_linear_555_74960)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M283 183.962C286.671 180.844 289 176.194 289 171C289 165.806 286.671 161.156 283 158.038C279.329 161.156 277 165.806 277 171C277 176.194 279.329 180.844 283 183.962Z",
                fill: "#737373"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "paint0_linear_555_74960",
                        x1: "-0.500023",
                        y1: "202.5",
                        x2: "333",
                        y2: "-131",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: "#A2AAAD"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0.635359",
                                stopColor: "#C2C7CA"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A4ABAE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "paint1_linear_555_74960",
                        x1: "255",
                        y1: "188",
                        x2: "289",
                        y2: "154",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: "#6D6E71"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0.491713",
                                stopColor: "#5A5B5D"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#77787B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "paint2_linear_555_74960",
                        x1: "277",
                        y1: "188",
                        x2: "311",
                        y2: "154",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                stopColor: "#C7C8CA"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0.502762",
                                stopColor: "#B1B3B6"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C7C8CA"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



function $d559914ba3bc587b$export$115f017852a4bb7c({ businessName: businessName, cardholder: cardholder, cvc: cvc, expirationDate: expirationDate, fullPan: fullPan, showCardDetails: showCardDetails = false, signatureDataUri: signatureDataUri }) {
    const previewContainerClassName = showCardDetails ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($211b47b09eb34e54$export$8aade8ce2b5d7e87, $211b47b09eb34e54$export$e97739ba196b52a5) : $211b47b09eb34e54$export$8aade8ce2b5d7e87;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: previewContainerClassName,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01b628065e650f1c$export$20c0b5ff3d7d9924), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($211b47b09eb34e54$export$48c2d0f2f545ac27, $211b47b09eb34e54$export$e57dd03da898490e),
                businessName: businessName,
                signatureDataUri: signatureDataUri
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81bb7444e996fcbd$export$79391ed63190e48d), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))($211b47b09eb34e54$export$48c2d0f2f545ac27, $211b47b09eb34e54$export$746c1c87f3ad3d31),
                cardholder: cardholder,
                cvc: cvc,
                expirationDate: expirationDate,
                fullPan: fullPan
            })
        ]
    });
}


var $bd48c8ef11defcf4$exports = {};

$parcel$export($bd48c8ef11defcf4$exports, "container", () => $bd48c8ef11defcf4$export$34e0f9847d4c02dd, (v) => $bd48c8ef11defcf4$export$34e0f9847d4c02dd = v);
$parcel$export($bd48c8ef11defcf4$exports, "listContainer", () => $bd48c8ef11defcf4$export$1b9b24bdbcc25a11, (v) => $bd48c8ef11defcf4$export$1b9b24bdbcc25a11 = v);
$parcel$export($bd48c8ef11defcf4$exports, "preview", () => $bd48c8ef11defcf4$export$48c2d0f2f545ac27, (v) => $bd48c8ef11defcf4$export$48c2d0f2f545ac27 = v);
$parcel$export($bd48c8ef11defcf4$exports, "previewContainer", () => $bd48c8ef11defcf4$export$8aade8ce2b5d7e87, (v) => $bd48c8ef11defcf4$export$8aade8ce2b5d7e87 = v);
$parcel$export($bd48c8ef11defcf4$exports, "previewContainerWithSecondary", () => $bd48c8ef11defcf4$export$8eeea050e4b2a94c, (v) => $bd48c8ef11defcf4$export$8eeea050e4b2a94c = v);
var $bd48c8ef11defcf4$export$34e0f9847d4c02dd;
var $bd48c8ef11defcf4$export$1b9b24bdbcc25a11;
var $bd48c8ef11defcf4$export$48c2d0f2f545ac27;
var $bd48c8ef11defcf4$export$8aade8ce2b5d7e87;
var $bd48c8ef11defcf4$export$8eeea050e4b2a94c;
$bd48c8ef11defcf4$export$34e0f9847d4c02dd = `WTltza_PreviewContentCard_container`;
$bd48c8ef11defcf4$export$1b9b24bdbcc25a11 = `WTltza_PreviewContentCard_listContainer`;
$bd48c8ef11defcf4$export$48c2d0f2f545ac27 = `WTltza_PreviewContentCard_preview`;
$bd48c8ef11defcf4$export$8aade8ce2b5d7e87 = `WTltza_PreviewContentCard_previewContainer`;
$bd48c8ef11defcf4$export$8eeea050e4b2a94c = `WTltza_PreviewContentCard_previewContainerWithSecondary`;


function $034af6c0eb5c10e4$export$7ffad9c53e8a82d9({ card: card, cardCustomization: cardCustomization, children: children, showCardDetails: showCardDetails = false, previewSecondaryContent: previewSecondaryContent }) {
    const previewContainerClassName = previewSecondaryContent == null ? (0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).previewContainer : (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).previewContainer, (0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).previewContainerWithSecondary);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: previewContainerClassName,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).preview,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d559914ba3bc587b$export$115f017852a4bb7c), {
                            cardholder: (0, $1f03a6bc7d91b109$export$f0d76c98e43e3f03)(card),
                            cvc: (0, $1f03a6bc7d91b109$export$7f1de93407df59b0)(card),
                            expirationDate: (0, $1f03a6bc7d91b109$export$1bbc5be1c1af00a7)(card),
                            fullPan: (0, $1f03a6bc7d91b109$export$eb37d3dae2bf604a)(card),
                            businessName: (0, $1f03a6bc7d91b109$export$af0ed80290d14473)(card),
                            showCardDetails: showCardDetails,
                            signatureDataUri: (0, $1f03a6bc7d91b109$export$461358cf94db3eb1)(cardCustomization)
                        }),
                        previewSecondaryContent
                    ]
                })
            }),
            children ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bd48c8ef11defcf4$exports))).listContainer,
                children: children
            }) : null
        ]
    });
}




var $e710467a0b08d0a7$export$8837f4fc672e936d;
$e710467a0b08d0a7$export$8837f4fc672e936d = `ccjoFG_List_list`;




var $e90df8fac1d740f0$exports = {};

$parcel$export($e90df8fac1d740f0$exports, "activityIndicator", () => $e90df8fac1d740f0$export$1d20b5855c758fab, (v) => $e90df8fac1d740f0$export$1d20b5855c758fab = v);
$parcel$export($e90df8fac1d740f0$exports, "icon", () => $e90df8fac1d740f0$export$1ca1ec8b29a4ce27, (v) => $e90df8fac1d740f0$export$1ca1ec8b29a4ce27 = v);
$parcel$export($e90df8fac1d740f0$exports, "iconContainer", () => $e90df8fac1d740f0$export$acf4eaf431084f78, (v) => $e90df8fac1d740f0$export$acf4eaf431084f78 = v);
var $e90df8fac1d740f0$export$1d20b5855c758fab;
var $e90df8fac1d740f0$export$1ca1ec8b29a4ce27;
var $e90df8fac1d740f0$export$acf4eaf431084f78;
$e90df8fac1d740f0$export$1d20b5855c758fab = `_0qYKCG_ListItem_activityIndicator`;
$e90df8fac1d740f0$export$1ca1ec8b29a4ce27 = `_0qYKCG_ListItem_icon`;
$e90df8fac1d740f0$export$acf4eaf431084f78 = `_0qYKCG_ListItem_iconContainer`;


var $67b4545ba4ea2391$export$18f8036a6dc5f3a5 = /*#__PURE__*/ function(ListControl) {
    ListControl["TOGGLE"] = "TOGGLE";
    return ListControl;
}({});
function $67b4545ba4ea2391$export$a7b06bfba60a8a78({ Icon: Icon, text: text, subtext: subtext, control: control, hidden: hidden = false, loading: loading = false, value: value = false, action: action }) {
    const ToggleComponent = ()=>{
        if (control === "TOGGLE") return loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$28c2b904b2ab5c88), {
            slot: "trailing-accessory",
            size: "small",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($e90df8fac1d740f0$exports))).activityIndicator
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$b2dd8e9aed9c0935), {
            slot: "control"
        });
        return null;
    };
    return hidden ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$14eeaa98ef1abeb2), {
        onClick: action,
        variant: control ? "regular" : "drill",
        selected: value,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                slot: "leading-accessory",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e90df8fac1d740f0$exports))).iconContainer,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($e90df8fac1d740f0$exports))).icon
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                slot: "label",
                children: text
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ToggleComponent, {}),
            subtext && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                slot: "subtext",
                children: subtext
            })
        ]
    }, text);
}


function $155fca31ba7836a3$export$54c2e3dc7acea9f5({ items: items }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$5f38cc4b3e71c577), {
        className: (0, $e710467a0b08d0a7$export$8837f4fc672e936d),
        transient: true,
        name: "card-settings-list",
        children: items.map(({ Icon: Icon, text: text, subtext: subtext, control: control, hidden: hidden, loading: loading, value: value, action: action })=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67b4545ba4ea2391$export$a7b06bfba60a8a78), {
                Icon: Icon,
                text: text,
                subtext: subtext,
                control: control,
                hidden: hidden,
                loading: loading,
                value: value,
                action: action
            }, text);
        })
    });
}




var $9ea98b0e574b2c69$export$9261782d08389607;
$9ea98b0e574b2c69$export$9261782d08389607 = `zfQBuG_ContentCard_contentCard`;


function $9572a2cf9fb2ccf8$export$f631859cab12b342({ className: className, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $9ea98b0e574b2c69$export$9261782d08389607), className),
        children: children
    });
}



var $e3e42df70a20556d$exports = {};

$parcel$export($e3e42df70a20556d$exports, "button", () => $e3e42df70a20556d$export$2ba01fb71ed41cb6, (v) => $e3e42df70a20556d$export$2ba01fb71ed41cb6 = v);
$parcel$export($e3e42df70a20556d$exports, "container", () => $e3e42df70a20556d$export$34e0f9847d4c02dd, (v) => $e3e42df70a20556d$export$34e0f9847d4c02dd = v);
$parcel$export($e3e42df70a20556d$exports, "disclaimer", () => $e3e42df70a20556d$export$daa7d8bf68093807, (v) => $e3e42df70a20556d$export$daa7d8bf68093807 = v);
$parcel$export($e3e42df70a20556d$exports, "divider", () => $e3e42df70a20556d$export$e8c9778bf415dd08, (v) => $e3e42df70a20556d$export$e8c9778bf415dd08 = v);
$parcel$export($e3e42df70a20556d$exports, "helpHeader", () => $e3e42df70a20556d$export$fbf96866ee135169, (v) => $e3e42df70a20556d$export$fbf96866ee135169 = v);
var $e3e42df70a20556d$export$2ba01fb71ed41cb6;
var $e3e42df70a20556d$export$34e0f9847d4c02dd;
var $e3e42df70a20556d$export$daa7d8bf68093807;
var $e3e42df70a20556d$export$e8c9778bf415dd08;
var $e3e42df70a20556d$export$fbf96866ee135169;
$e3e42df70a20556d$export$2ba01fb71ed41cb6 = `dY9jpq_CardManagement_button`;
$e3e42df70a20556d$export$34e0f9847d4c02dd = `dY9jpq_CardManagement_container`;
$e3e42df70a20556d$export$daa7d8bf68093807 = `dY9jpq_CardManagement_disclaimer`;
$e3e42df70a20556d$export$e8c9778bf415dd08 = `dY9jpq_CardManagement_divider`;
$e3e42df70a20556d$export$fbf96866ee135169 = `dY9jpq_CardManagement_helpHeader`;



function $65a7b64dd007d7b7$export$7aa52cf130c2f005({ card: card, cardCustomization: cardCustomization, cardSettings: cardSettings, helpSettings: helpSettings, showCardDetails: showCardDetails, onActivateCardClick: onActivateCardClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-settings");
    const previewSecondaryContent = (0, $1f03a6bc7d91b109$export$8e48b4074de9a9df)(card) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
        rank: "primary",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e3e42df70a20556d$exports))).button,
        onClick: onActivateCardClick,
        children: t("button.activateCard")
    }) : undefined;
    const showCardSettings = cardSettings.length > 0 && cardSettings.some((setting)=>!setting.hidden);
    const isUsSeller = card?.fulfillment?.address?.countryCode === (0, $a8741251394c554f$export$5552a8f08b2b9f9e).US;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e3e42df70a20556d$exports))).container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $034af6c0eb5c10e4$export$7ffad9c53e8a82d9), {
                card: card,
                cardCustomization: cardCustomization,
                previewSecondaryContent: previewSecondaryContent,
                showCardDetails: showCardDetails,
                children: showCardSettings ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $155fca31ba7836a3$export$54c2e3dc7acea9f5), {
                    items: cardSettings
                }) : null
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$2bf53bba4802f0ae), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e3e42df70a20556d$exports))).divider
            }),
            helpSettings.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9572a2cf9fb2ccf8$export$f631859cab12b342), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($e3e42df70a20556d$exports))).helpHeader,
                        children: t("section.help.title")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $155fca31ba7836a3$export$54c2e3dc7acea9f5), {
                        items: helpSettings
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
            isUsSeller && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e3e42df70a20556d$exports))).disclaimer,
                children: t("section.settings.disclaimer")
            })
        ]
    });
}


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $1f14c967a58ea158$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
function $1f14c967a58ea158$var$Ae(e, t) {
    return function() {
        return e.apply(t, arguments);
    };
}
const { toString: $1f14c967a58ea158$var$Ke } = Object.prototype, { getPrototypeOf: $1f14c967a58ea158$var$ie } = Object, $1f14c967a58ea158$var$V = ((e)=>(t)=>{
        const n = $1f14c967a58ea158$var$Ke.call(t);
        return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
    })(/* @__PURE__ */ Object.create(null)), $1f14c967a58ea158$var$_ = (e)=>(e = e.toLowerCase(), (t)=>$1f14c967a58ea158$var$V(t) === e), $1f14c967a58ea158$var$z = (e)=>(t)=>typeof t === e, { isArray: $1f14c967a58ea158$var$D } = Array, $1f14c967a58ea158$var$L = $1f14c967a58ea158$var$z("undefined");
function $1f14c967a58ea158$var$Ge(e) {
    return e !== null && !$1f14c967a58ea158$var$L(e) && e.constructor !== null && !$1f14c967a58ea158$var$L(e.constructor) && $1f14c967a58ea158$var$b(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const $1f14c967a58ea158$var$Te = $1f14c967a58ea158$var$_("ArrayBuffer");
function $1f14c967a58ea158$var$We(e) {
    let t;
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && $1f14c967a58ea158$var$Te(e.buffer), t;
}
const $1f14c967a58ea158$var$Ye = $1f14c967a58ea158$var$z("string"), $1f14c967a58ea158$var$b = $1f14c967a58ea158$var$z("function"), $1f14c967a58ea158$var$Ne = $1f14c967a58ea158$var$z("number"), $1f14c967a58ea158$var$$ = (e)=>e !== null && typeof e == "object", $1f14c967a58ea158$var$Xe = (e)=>e === !0 || e === !1, $1f14c967a58ea158$var$H = (e)=>{
    if ($1f14c967a58ea158$var$V(e) !== "object") return !1;
    const t = $1f14c967a58ea158$var$ie(e);
    return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, $1f14c967a58ea158$var$Qe = $1f14c967a58ea158$var$_("Date"), $1f14c967a58ea158$var$Ze = $1f14c967a58ea158$var$_("File"), $1f14c967a58ea158$var$et = $1f14c967a58ea158$var$_("Blob"), $1f14c967a58ea158$var$tt = $1f14c967a58ea158$var$_("FileList"), $1f14c967a58ea158$var$nt = (e)=>$1f14c967a58ea158$var$$(e) && $1f14c967a58ea158$var$b(e.pipe), $1f14c967a58ea158$var$rt = (e)=>{
    let t;
    return e && (typeof FormData == "function" && e instanceof FormData || $1f14c967a58ea158$var$b(e.append) && ((t = $1f14c967a58ea158$var$V(e)) === "formdata" || // detect form-data instance
    t === "object" && $1f14c967a58ea158$var$b(e.toString) && e.toString() === "[object FormData]"));
}, $1f14c967a58ea158$var$st = $1f14c967a58ea158$var$_("URLSearchParams"), $1f14c967a58ea158$var$ot = (e)=>e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function $1f14c967a58ea158$var$B(e, t, { allOwnKeys: n = !1 } = {}) {
    if (e === null || typeof e > "u") return;
    let r, s;
    if (typeof e != "object" && (e = [
        e
    ]), $1f14c967a58ea158$var$D(e)) for(r = 0, s = e.length; r < s; r++)t.call(null, e[r], r, e);
    else {
        const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
        let u;
        for(r = 0; r < o; r++)u = i[r], t.call(null, e[u], u, e);
    }
}
function $1f14c967a58ea158$var$_e(e, t) {
    t = t.toLowerCase();
    const n = Object.keys(e);
    let r = n.length, s;
    for(; r-- > 0;)if (s = n[r], t === s.toLowerCase()) return s;
    return null;
}
const $1f14c967a58ea158$var$Ce = (()=>typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : $parcel$global)(), $1f14c967a58ea158$var$Fe = (e)=>!$1f14c967a58ea158$var$L(e) && e !== $1f14c967a58ea158$var$Ce;
function $1f14c967a58ea158$var$ee() {
    const { caseless: e } = $1f14c967a58ea158$var$Fe(this) && this || {}, t = {}, n = (r, s)=>{
        const i = e && $1f14c967a58ea158$var$_e(t, s) || s;
        $1f14c967a58ea158$var$H(t[i]) && $1f14c967a58ea158$var$H(r) ? t[i] = $1f14c967a58ea158$var$ee(t[i], r) : $1f14c967a58ea158$var$H(r) ? t[i] = $1f14c967a58ea158$var$ee({}, r) : $1f14c967a58ea158$var$D(r) ? t[i] = r.slice() : t[i] = r;
    };
    for(let r = 0, s = arguments.length; r < s; r++)arguments[r] && $1f14c967a58ea158$var$B(arguments[r], n);
    return t;
}
const $1f14c967a58ea158$var$it = (e, t, n, { allOwnKeys: r } = {})=>($1f14c967a58ea158$var$B(t, (s, i)=>{
        n && $1f14c967a58ea158$var$b(s) ? e[i] = $1f14c967a58ea158$var$Ae(s, n) : e[i] = s;
    }, {
        allOwnKeys: r
    }), e), $1f14c967a58ea158$var$at = (e)=>(e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), $1f14c967a58ea158$var$ct = (e, t, n, r)=>{
    e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
        value: t.prototype
    }), n && Object.assign(e.prototype, n);
}, $1f14c967a58ea158$var$ut = (e, t, n, r)=>{
    let s, i, o;
    const u = {};
    if (t = t || {}, e == null) return t;
    do {
        for(s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0;)o = s[i], (!r || r(o, e, t)) && !u[o] && (t[o] = e[o], u[o] = !0);
        e = n !== !1 && $1f14c967a58ea158$var$ie(e);
    }while (e && (!n || n(e, t)) && e !== Object.prototype);
    return t;
}, $1f14c967a58ea158$var$lt = (e, t, n)=>{
    e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
    const r = e.indexOf(t, n);
    return r !== -1 && r === n;
}, $1f14c967a58ea158$var$ft = (e)=>{
    if (!e) return null;
    if ($1f14c967a58ea158$var$D(e)) return e;
    let t = e.length;
    if (!$1f14c967a58ea158$var$Ne(t)) return null;
    const n = new Array(t);
    for(; t-- > 0;)n[t] = e[t];
    return n;
}, $1f14c967a58ea158$var$dt = ((e)=>(t)=>e && t instanceof e)(typeof Uint8Array < "u" && $1f14c967a58ea158$var$ie(Uint8Array)), $1f14c967a58ea158$var$pt = (e, t)=>{
    const r = (e && e[Symbol.iterator]).call(e);
    let s;
    for(; (s = r.next()) && !s.done;){
        const i = s.value;
        t.call(e, i[0], i[1]);
    }
}, $1f14c967a58ea158$var$ht = (e, t)=>{
    let n;
    const r = [];
    for(; (n = e.exec(t)) !== null;)r.push(n);
    return r;
}, $1f14c967a58ea158$var$mt = $1f14c967a58ea158$var$_("HTMLFormElement"), $1f14c967a58ea158$var$yt = (e)=>e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(n, r, s) {
        return r.toUpperCase() + s;
    }), $1f14c967a58ea158$var$de = (({ hasOwnProperty: e })=>(t, n)=>e.call(t, n))(Object.prototype), $1f14c967a58ea158$var$Et = $1f14c967a58ea158$var$_("RegExp"), $1f14c967a58ea158$var$Pe = (e, t)=>{
    const n = Object.getOwnPropertyDescriptors(e), r = {};
    $1f14c967a58ea158$var$B(n, (s, i)=>{
        let o;
        (o = t(s, i, e)) !== !1 && (r[i] = o || s);
    }), Object.defineProperties(e, r);
}, $1f14c967a58ea158$var$gt = (e)=>{
    $1f14c967a58ea158$var$Pe(e, (t, n)=>{
        if ($1f14c967a58ea158$var$b(e) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(n) !== -1) return !1;
        const r = e[n];
        if ($1f14c967a58ea158$var$b(r)) {
            if (t.enumerable = !1, "writable" in t) {
                t.writable = !1;
                return;
            }
            t.set || (t.set = ()=>{
                throw Error("Can not rewrite read-only method '" + n + "'");
            });
        }
    });
}, $1f14c967a58ea158$var$wt = (e, t)=>{
    const n = {}, r = (s)=>{
        s.forEach((i)=>{
            n[i] = !0;
        });
    };
    return $1f14c967a58ea158$var$D(e) ? r(e) : r(String(e).split(t)), n;
}, $1f14c967a58ea158$var$Rt = ()=>{}, $1f14c967a58ea158$var$Ot = (e, t)=>(e = +e, Number.isFinite(e) ? e : t), $1f14c967a58ea158$var$Y = "abcdefghijklmnopqrstuvwxyz", $1f14c967a58ea158$var$pe = "0123456789", $1f14c967a58ea158$var$xe = {
    DIGIT: $1f14c967a58ea158$var$pe,
    ALPHA: $1f14c967a58ea158$var$Y,
    ALPHA_DIGIT: $1f14c967a58ea158$var$Y + $1f14c967a58ea158$var$Y.toUpperCase() + $1f14c967a58ea158$var$pe
}, $1f14c967a58ea158$var$St = (e = 16, t = $1f14c967a58ea158$var$xe.ALPHA_DIGIT)=>{
    let n = "";
    const { length: r } = t;
    for(; e--;)n += t[Math.random() * r | 0];
    return n;
};
function $1f14c967a58ea158$var$bt(e) {
    return !!(e && $1f14c967a58ea158$var$b(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const $1f14c967a58ea158$var$At = (e)=>{
    const t = new Array(10), n = (r, s)=>{
        if ($1f14c967a58ea158$var$$(r)) {
            if (t.indexOf(r) >= 0) return;
            if (!("toJSON" in r)) {
                t[s] = r;
                const i = $1f14c967a58ea158$var$D(r) ? [] : {};
                return $1f14c967a58ea158$var$B(r, (o, u)=>{
                    const f = n(o, s + 1);
                    !$1f14c967a58ea158$var$L(f) && (i[u] = f);
                }), t[s] = void 0, i;
            }
        }
        return r;
    };
    return n(e, 0);
}, $1f14c967a58ea158$var$Tt = $1f14c967a58ea158$var$_("AsyncFunction"), $1f14c967a58ea158$var$Nt = (e)=>e && ($1f14c967a58ea158$var$$(e) || $1f14c967a58ea158$var$b(e)) && $1f14c967a58ea158$var$b(e.then) && $1f14c967a58ea158$var$b(e.catch), $1f14c967a58ea158$var$a = {
    isArray: $1f14c967a58ea158$var$D,
    isArrayBuffer: $1f14c967a58ea158$var$Te,
    isBuffer: $1f14c967a58ea158$var$Ge,
    isFormData: $1f14c967a58ea158$var$rt,
    isArrayBufferView: $1f14c967a58ea158$var$We,
    isString: $1f14c967a58ea158$var$Ye,
    isNumber: $1f14c967a58ea158$var$Ne,
    isBoolean: $1f14c967a58ea158$var$Xe,
    isObject: $1f14c967a58ea158$var$$,
    isPlainObject: $1f14c967a58ea158$var$H,
    isUndefined: $1f14c967a58ea158$var$L,
    isDate: $1f14c967a58ea158$var$Qe,
    isFile: $1f14c967a58ea158$var$Ze,
    isBlob: $1f14c967a58ea158$var$et,
    isRegExp: $1f14c967a58ea158$var$Et,
    isFunction: $1f14c967a58ea158$var$b,
    isStream: $1f14c967a58ea158$var$nt,
    isURLSearchParams: $1f14c967a58ea158$var$st,
    isTypedArray: $1f14c967a58ea158$var$dt,
    isFileList: $1f14c967a58ea158$var$tt,
    forEach: $1f14c967a58ea158$var$B,
    merge: $1f14c967a58ea158$var$ee,
    extend: $1f14c967a58ea158$var$it,
    trim: $1f14c967a58ea158$var$ot,
    stripBOM: $1f14c967a58ea158$var$at,
    inherits: $1f14c967a58ea158$var$ct,
    toFlatObject: $1f14c967a58ea158$var$ut,
    kindOf: $1f14c967a58ea158$var$V,
    kindOfTest: $1f14c967a58ea158$var$_,
    endsWith: $1f14c967a58ea158$var$lt,
    toArray: $1f14c967a58ea158$var$ft,
    forEachEntry: $1f14c967a58ea158$var$pt,
    matchAll: $1f14c967a58ea158$var$ht,
    isHTMLForm: $1f14c967a58ea158$var$mt,
    hasOwnProperty: $1f14c967a58ea158$var$de,
    hasOwnProp: $1f14c967a58ea158$var$de,
    // an alias to avoid ESLint no-prototype-builtins detection
    reduceDescriptors: $1f14c967a58ea158$var$Pe,
    freezeMethods: $1f14c967a58ea158$var$gt,
    toObjectSet: $1f14c967a58ea158$var$wt,
    toCamelCase: $1f14c967a58ea158$var$yt,
    noop: $1f14c967a58ea158$var$Rt,
    toFiniteNumber: $1f14c967a58ea158$var$Ot,
    findKey: $1f14c967a58ea158$var$_e,
    global: $1f14c967a58ea158$var$Ce,
    isContextDefined: $1f14c967a58ea158$var$Fe,
    ALPHABET: $1f14c967a58ea158$var$xe,
    generateString: $1f14c967a58ea158$var$St,
    isSpecCompliantForm: $1f14c967a58ea158$var$bt,
    toJSONObject: $1f14c967a58ea158$var$At,
    isAsyncFn: $1f14c967a58ea158$var$Tt,
    isThenable: $1f14c967a58ea158$var$Nt
};
function $1f14c967a58ea158$var$m(e, t, n, r, s) {
    Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s);
}
$1f14c967a58ea158$var$a.inherits($1f14c967a58ea158$var$m, Error, {
    toJSON: function() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: $1f14c967a58ea158$var$a.toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $1f14c967a58ea158$var$De = $1f14c967a58ea158$var$m.prototype, $1f14c967a58ea158$var$Ue = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((e)=>{
    $1f14c967a58ea158$var$Ue[e] = {
        value: e
    };
});
Object.defineProperties($1f14c967a58ea158$var$m, $1f14c967a58ea158$var$Ue);
Object.defineProperty($1f14c967a58ea158$var$De, "isAxiosError", {
    value: !0
});
$1f14c967a58ea158$var$m.from = (e, t, n, r, s, i)=>{
    const o = Object.create($1f14c967a58ea158$var$De);
    return $1f14c967a58ea158$var$a.toFlatObject(e, o, function(f) {
        return f !== Error.prototype;
    }, (u)=>u !== "isAxiosError"), $1f14c967a58ea158$var$m.call(o, e.message, t, n, r, s), o.cause = e, o.name = e.name, i && Object.assign(o, i), o;
};
const $1f14c967a58ea158$var$_t = null;
function $1f14c967a58ea158$var$te(e) {
    return $1f14c967a58ea158$var$a.isPlainObject(e) || $1f14c967a58ea158$var$a.isArray(e);
}
function $1f14c967a58ea158$var$Le(e) {
    return $1f14c967a58ea158$var$a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function $1f14c967a58ea158$var$he(e, t, n) {
    return e ? e.concat(t).map(function(s, i) {
        return s = $1f14c967a58ea158$var$Le(s), !n && i ? "[" + s + "]" : s;
    }).join(n ? "." : "") : t;
}
function $1f14c967a58ea158$var$Ct(e) {
    return $1f14c967a58ea158$var$a.isArray(e) && !e.some($1f14c967a58ea158$var$te);
}
const $1f14c967a58ea158$var$Ft = $1f14c967a58ea158$var$a.toFlatObject($1f14c967a58ea158$var$a, {}, null, function(t) {
    return /^is[A-Z]/.test(t);
});
function $1f14c967a58ea158$var$K(e, t, n) {
    if (!$1f14c967a58ea158$var$a.isObject(e)) throw new TypeError("target must be an object");
    t = t || new FormData(), n = $1f14c967a58ea158$var$a.toFlatObject(n, {
        metaTokens: !0,
        dots: !1,
        indexes: !1
    }, !1, function(h, R) {
        return !$1f14c967a58ea158$var$a.isUndefined(R[h]);
    });
    const r = n.metaTokens, s = n.visitor || c, i = n.dots, o = n.indexes, f = (n.Blob || typeof Blob < "u" && Blob) && $1f14c967a58ea158$var$a.isSpecCompliantForm(t);
    if (!$1f14c967a58ea158$var$a.isFunction(s)) throw new TypeError("visitor must be a function");
    function d(l) {
        if (l === null) return "";
        if ($1f14c967a58ea158$var$a.isDate(l)) return l.toISOString();
        if (!f && $1f14c967a58ea158$var$a.isBlob(l)) throw new $1f14c967a58ea158$var$m("Blob is not supported. Use a Buffer instead.");
        return $1f14c967a58ea158$var$a.isArrayBuffer(l) || $1f14c967a58ea158$var$a.isTypedArray(l) ? f && typeof Blob == "function" ? new Blob([
            l
        ]) : $1f14c967a58ea158$require$Buffer.from(l) : l;
    }
    function c(l, h, R) {
        let A = l;
        if (l && !R && typeof l == "object") {
            if ($1f14c967a58ea158$var$a.endsWith(h, "{}")) h = r ? h : h.slice(0, -2), l = JSON.stringify(l);
            else if ($1f14c967a58ea158$var$a.isArray(l) && $1f14c967a58ea158$var$Ct(l) || ($1f14c967a58ea158$var$a.isFileList(l) || $1f14c967a58ea158$var$a.endsWith(h, "[]")) && (A = $1f14c967a58ea158$var$a.toArray(l))) return h = $1f14c967a58ea158$var$Le(h), A.forEach(function(S, O) {
                !($1f14c967a58ea158$var$a.isUndefined(S) || S === null) && t.append(// eslint-disable-next-line no-nested-ternary
                o === !0 ? $1f14c967a58ea158$var$he([
                    h
                ], O, i) : o === null ? h : h + "[]", d(S));
            }), !1;
        }
        return $1f14c967a58ea158$var$te(l) ? !0 : (t.append($1f14c967a58ea158$var$he(R, h, i), d(l)), !1);
    }
    const p = [], y = Object.assign($1f14c967a58ea158$var$Ft, {
        defaultVisitor: c,
        convertValue: d,
        isVisitable: $1f14c967a58ea158$var$te
    });
    function w(l, h) {
        if (!$1f14c967a58ea158$var$a.isUndefined(l)) {
            if (p.indexOf(l) !== -1) throw Error("Circular reference detected in " + h.join("."));
            p.push(l), $1f14c967a58ea158$var$a.forEach(l, function(A, E) {
                (!($1f14c967a58ea158$var$a.isUndefined(A) || A === null) && s.call(t, A, $1f14c967a58ea158$var$a.isString(E) ? E.trim() : E, h, y)) === !0 && w(A, h ? h.concat(E) : [
                    E
                ]);
            }), p.pop();
        }
    }
    if (!$1f14c967a58ea158$var$a.isObject(e)) throw new TypeError("data must be an object");
    return w(e), t;
}
function $1f14c967a58ea158$var$me(e) {
    const t = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
        return t[r];
    });
}
function $1f14c967a58ea158$var$ae(e, t) {
    this._pairs = [], e && $1f14c967a58ea158$var$K(e, this, t);
}
const $1f14c967a58ea158$var$Be = $1f14c967a58ea158$var$ae.prototype;
$1f14c967a58ea158$var$Be.append = function(t, n) {
    this._pairs.push([
        t,
        n
    ]);
};
$1f14c967a58ea158$var$Be.toString = function(t) {
    const n = t ? function(r) {
        return t.call(this, r, $1f14c967a58ea158$var$me);
    } : $1f14c967a58ea158$var$me;
    return this._pairs.map(function(s) {
        return n(s[0]) + "=" + n(s[1]);
    }, "").join("&");
};
function $1f14c967a58ea158$var$Pt(e) {
    return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $1f14c967a58ea158$var$Ie(e, t, n) {
    if (!t) return e;
    const r = n && n.encode || $1f14c967a58ea158$var$Pt, s = n && n.serialize;
    let i;
    if (s ? i = s(t, n) : i = $1f14c967a58ea158$var$a.isURLSearchParams(t) ? t.toString() : new $1f14c967a58ea158$var$ae(t, n).toString(r), i) {
        const o = e.indexOf("#");
        o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
    }
    return e;
}
class $1f14c967a58ea158$var$xt {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(t, n, r) {
        return this.handlers.push({
            fulfilled: t,
            rejected: n,
            synchronous: r ? r.synchronous : !1,
            runWhen: r ? r.runWhen : null
        }), this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(t) {
        this.handlers[t] && (this.handlers[t] = null);
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        this.handlers && (this.handlers = []);
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(t) {
        $1f14c967a58ea158$var$a.forEach(this.handlers, function(r) {
            r !== null && t(r);
        });
    }
}
const $1f14c967a58ea158$var$ye = $1f14c967a58ea158$var$xt, $1f14c967a58ea158$var$ke = {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
}, $1f14c967a58ea158$var$Dt = typeof URLSearchParams < "u" ? URLSearchParams : $1f14c967a58ea158$var$ae, $1f14c967a58ea158$var$Ut = typeof FormData < "u" ? FormData : null, $1f14c967a58ea158$var$Lt = typeof Blob < "u" ? Blob : null, $1f14c967a58ea158$var$Bt = (()=>{
    let e;
    return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), $1f14c967a58ea158$var$It = (()=>typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), $1f14c967a58ea158$var$N = {
    isBrowser: !0,
    classes: {
        URLSearchParams: $1f14c967a58ea158$var$Dt,
        FormData: $1f14c967a58ea158$var$Ut,
        Blob: $1f14c967a58ea158$var$Lt
    },
    isStandardBrowserEnv: $1f14c967a58ea158$var$Bt,
    isStandardBrowserWebWorkerEnv: $1f14c967a58ea158$var$It,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};
function $1f14c967a58ea158$var$kt(e, t) {
    return $1f14c967a58ea158$var$K(e, new $1f14c967a58ea158$var$N.classes.URLSearchParams(), Object.assign({
        visitor: function(n, r, s, i) {
            return $1f14c967a58ea158$var$N.isNode && $1f14c967a58ea158$var$a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
        }
    }, t));
}
function $1f14c967a58ea158$var$vt(e) {
    return $1f14c967a58ea158$var$a.matchAll(/\w+|\[(\w*)]/g, e).map((t)=>t[0] === "[]" ? "" : t[1] || t[0]);
}
function $1f14c967a58ea158$var$jt(e) {
    const t = {}, n = Object.keys(e);
    let r;
    const s = n.length;
    let i;
    for(r = 0; r < s; r++)i = n[r], t[i] = e[i];
    return t;
}
function $1f14c967a58ea158$var$ve(e) {
    function t(n, r, s, i) {
        let o = n[i++];
        const u = Number.isFinite(+o), f = i >= n.length;
        return o = !o && $1f14c967a58ea158$var$a.isArray(s) ? s.length : o, f ? ($1f14c967a58ea158$var$a.hasOwnProp(s, o) ? s[o] = [
            s[o],
            r
        ] : s[o] = r, !u) : ((!s[o] || !$1f14c967a58ea158$var$a.isObject(s[o])) && (s[o] = []), t(n, r, s[o], i) && $1f14c967a58ea158$var$a.isArray(s[o]) && (s[o] = $1f14c967a58ea158$var$jt(s[o])), !u);
    }
    if ($1f14c967a58ea158$var$a.isFormData(e) && $1f14c967a58ea158$var$a.isFunction(e.entries)) {
        const n = {};
        return $1f14c967a58ea158$var$a.forEachEntry(e, (r, s)=>{
            t($1f14c967a58ea158$var$vt(r), s, n, 0);
        }), n;
    }
    return null;
}
function $1f14c967a58ea158$var$Ht(e, t, n) {
    if ($1f14c967a58ea158$var$a.isString(e)) try {
        return (t || JSON.parse)(e), $1f14c967a58ea158$var$a.trim(e);
    } catch (r) {
        if (r.name !== "SyntaxError") throw r;
    }
    return (n || JSON.stringify)(e);
}
const $1f14c967a58ea158$var$ce = {
    transitional: $1f14c967a58ea158$var$ke,
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function(t, n) {
            const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, i = $1f14c967a58ea158$var$a.isObject(t);
            if (i && $1f14c967a58ea158$var$a.isHTMLForm(t) && (t = new FormData(t)), $1f14c967a58ea158$var$a.isFormData(t)) return s && s ? JSON.stringify($1f14c967a58ea158$var$ve(t)) : t;
            if ($1f14c967a58ea158$var$a.isArrayBuffer(t) || $1f14c967a58ea158$var$a.isBuffer(t) || $1f14c967a58ea158$var$a.isStream(t) || $1f14c967a58ea158$var$a.isFile(t) || $1f14c967a58ea158$var$a.isBlob(t)) return t;
            if ($1f14c967a58ea158$var$a.isArrayBufferView(t)) return t.buffer;
            if ($1f14c967a58ea158$var$a.isURLSearchParams(t)) return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
            let u;
            if (i) {
                if (r.indexOf("application/x-www-form-urlencoded") > -1) return $1f14c967a58ea158$var$kt(t, this.formSerializer).toString();
                if ((u = $1f14c967a58ea158$var$a.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
                    const f = this.env && this.env.FormData;
                    return $1f14c967a58ea158$var$K(u ? {
                        "files[]": t
                    } : t, f && new f(), this.formSerializer);
                }
            }
            return i || s ? (n.setContentType("application/json", !1), $1f14c967a58ea158$var$Ht(t)) : t;
        }
    ],
    transformResponse: [
        function(t) {
            const n = this.transitional || $1f14c967a58ea158$var$ce.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
            if (t && $1f14c967a58ea158$var$a.isString(t) && (r && !this.responseType || s)) {
                const o = !(n && n.silentJSONParsing) && s;
                try {
                    return JSON.parse(t);
                } catch (u) {
                    if (o) throw u.name === "SyntaxError" ? $1f14c967a58ea158$var$m.from(u, $1f14c967a58ea158$var$m.ERR_BAD_RESPONSE, this, null, this.response) : u;
                }
            }
            return t;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: $1f14c967a58ea158$var$N.classes.FormData,
        Blob: $1f14c967a58ea158$var$N.classes.Blob
    },
    validateStatus: function(t) {
        return t >= 200 && t < 300;
    },
    headers: {
        common: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": void 0
        }
    }
};
$1f14c967a58ea158$var$a.forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (e)=>{
    $1f14c967a58ea158$var$ce.headers[e] = {};
});
const $1f14c967a58ea158$var$ue = $1f14c967a58ea158$var$ce, $1f14c967a58ea158$var$Mt = $1f14c967a58ea158$var$a.toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]), $1f14c967a58ea158$var$qt = (e)=>{
    const t = {};
    let n, r, s;
    return e && e.split(`
`).forEach(function(o) {
        s = o.indexOf(":"), n = o.substring(0, s).trim().toLowerCase(), r = o.substring(s + 1).trim(), !(!n || t[n] && $1f14c967a58ea158$var$Mt[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [
            r
        ] : t[n] = t[n] ? t[n] + ", " + r : r);
    }), t;
}, $1f14c967a58ea158$var$Ee = Symbol("internals");
function $1f14c967a58ea158$var$U(e) {
    return e && String(e).trim().toLowerCase();
}
function $1f14c967a58ea158$var$M(e) {
    return e === !1 || e == null ? e : $1f14c967a58ea158$var$a.isArray(e) ? e.map($1f14c967a58ea158$var$M) : String(e);
}
function $1f14c967a58ea158$var$Jt(e) {
    const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let r;
    for(; r = n.exec(e);)t[r[1]] = r[2];
    return t;
}
const $1f14c967a58ea158$var$Vt = (e)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function $1f14c967a58ea158$var$X(e, t, n, r, s) {
    if ($1f14c967a58ea158$var$a.isFunction(r)) return r.call(this, t, n);
    if (s && (t = n), !!$1f14c967a58ea158$var$a.isString(t)) {
        if ($1f14c967a58ea158$var$a.isString(r)) return t.indexOf(r) !== -1;
        if ($1f14c967a58ea158$var$a.isRegExp(r)) return r.test(t);
    }
}
function $1f14c967a58ea158$var$zt(e) {
    return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r)=>n.toUpperCase() + r);
}
function $1f14c967a58ea158$var$$t(e, t) {
    const n = $1f14c967a58ea158$var$a.toCamelCase(" " + t);
    [
        "get",
        "set",
        "has"
    ].forEach((r)=>{
        Object.defineProperty(e, r + n, {
            value: function(s, i, o) {
                return this[r].call(this, t, s, i, o);
            },
            configurable: !0
        });
    });
}
class $1f14c967a58ea158$var$G {
    constructor(t){
        t && this.set(t);
    }
    set(t, n, r) {
        const s = this;
        function i(u, f, d) {
            const c = $1f14c967a58ea158$var$U(f);
            if (!c) throw new Error("header name must be a non-empty string");
            const p = $1f14c967a58ea158$var$a.findKey(s, c);
            (!p || s[p] === void 0 || d === !0 || d === void 0 && s[p] !== !1) && (s[p || f] = $1f14c967a58ea158$var$M(u));
        }
        const o = (u, f)=>$1f14c967a58ea158$var$a.forEach(u, (d, c)=>i(d, c, f));
        return $1f14c967a58ea158$var$a.isPlainObject(t) || t instanceof this.constructor ? o(t, n) : $1f14c967a58ea158$var$a.isString(t) && (t = t.trim()) && !$1f14c967a58ea158$var$Vt(t) ? o($1f14c967a58ea158$var$qt(t), n) : t != null && i(n, t, r), this;
    }
    get(t, n) {
        if (t = $1f14c967a58ea158$var$U(t), t) {
            const r = $1f14c967a58ea158$var$a.findKey(this, t);
            if (r) {
                const s = this[r];
                if (!n) return s;
                if (n === !0) return $1f14c967a58ea158$var$Jt(s);
                if ($1f14c967a58ea158$var$a.isFunction(n)) return n.call(this, s, r);
                if ($1f14c967a58ea158$var$a.isRegExp(n)) return n.exec(s);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(t, n) {
        if (t = $1f14c967a58ea158$var$U(t), t) {
            const r = $1f14c967a58ea158$var$a.findKey(this, t);
            return !!(r && this[r] !== void 0 && (!n || $1f14c967a58ea158$var$X(this, this[r], r, n)));
        }
        return !1;
    }
    delete(t, n) {
        const r = this;
        let s = !1;
        function i(o) {
            if (o = $1f14c967a58ea158$var$U(o), o) {
                const u = $1f14c967a58ea158$var$a.findKey(r, o);
                u && (!n || $1f14c967a58ea158$var$X(r, r[u], u, n)) && (delete r[u], s = !0);
            }
        }
        return $1f14c967a58ea158$var$a.isArray(t) ? t.forEach(i) : i(t), s;
    }
    clear(t) {
        const n = Object.keys(this);
        let r = n.length, s = !1;
        for(; r--;){
            const i = n[r];
            (!t || $1f14c967a58ea158$var$X(this, this[i], i, t, !0)) && (delete this[i], s = !0);
        }
        return s;
    }
    normalize(t) {
        const n = this, r = {};
        return $1f14c967a58ea158$var$a.forEach(this, (s, i)=>{
            const o = $1f14c967a58ea158$var$a.findKey(r, i);
            if (o) {
                n[o] = $1f14c967a58ea158$var$M(s), delete n[i];
                return;
            }
            const u = t ? $1f14c967a58ea158$var$zt(i) : String(i).trim();
            u !== i && delete n[i], n[u] = $1f14c967a58ea158$var$M(s), r[u] = !0;
        }), this;
    }
    concat(...t) {
        return this.constructor.concat(this, ...t);
    }
    toJSON(t) {
        const n = /* @__PURE__ */ Object.create(null);
        return $1f14c967a58ea158$var$a.forEach(this, (r, s)=>{
            r != null && r !== !1 && (n[s] = t && $1f14c967a58ea158$var$a.isArray(r) ? r.join(", ") : r);
        }), n;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([t, n])=>t + ": " + n).join(`
`);
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(t) {
        return t instanceof this ? t : new this(t);
    }
    static concat(t, ...n) {
        const r = new this(t);
        return n.forEach((s)=>r.set(s)), r;
    }
    static accessor(t) {
        const r = (this[$1f14c967a58ea158$var$Ee] = this[$1f14c967a58ea158$var$Ee] = {
            accessors: {}
        }).accessors, s = this.prototype;
        function i(o) {
            const u = $1f14c967a58ea158$var$U(o);
            r[u] || ($1f14c967a58ea158$var$$t(s, o), r[u] = !0);
        }
        return $1f14c967a58ea158$var$a.isArray(t) ? t.forEach(i) : i(t), this;
    }
}
$1f14c967a58ea158$var$G.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
$1f14c967a58ea158$var$a.reduceDescriptors($1f14c967a58ea158$var$G.prototype, ({ value: e }, t)=>{
    let n = t[0].toUpperCase() + t.slice(1);
    return {
        get: ()=>e,
        set (r) {
            this[n] = r;
        }
    };
});
$1f14c967a58ea158$var$a.freezeMethods($1f14c967a58ea158$var$G);
const $1f14c967a58ea158$var$C = $1f14c967a58ea158$var$G;
function $1f14c967a58ea158$var$Q(e, t) {
    const n = this || $1f14c967a58ea158$var$ue, r = t || n, s = $1f14c967a58ea158$var$C.from(r.headers);
    let i = r.data;
    return $1f14c967a58ea158$var$a.forEach(e, function(u) {
        i = u.call(n, i, s.normalize(), t ? t.status : void 0);
    }), s.normalize(), i;
}
function $1f14c967a58ea158$var$je(e) {
    return !!(e && e.__CANCEL__);
}
function $1f14c967a58ea158$var$I(e, t, n) {
    $1f14c967a58ea158$var$m.call(this, e ?? "canceled", $1f14c967a58ea158$var$m.ERR_CANCELED, t, n), this.name = "CanceledError";
}
$1f14c967a58ea158$var$a.inherits($1f14c967a58ea158$var$I, $1f14c967a58ea158$var$m, {
    __CANCEL__: !0
});
function $1f14c967a58ea158$var$Kt(e, t, n) {
    const r = n.config.validateStatus;
    !n.status || !r || r(n.status) ? e(n) : t(new $1f14c967a58ea158$var$m("Request failed with status code " + n.status, [
        $1f14c967a58ea158$var$m.ERR_BAD_REQUEST,
        $1f14c967a58ea158$var$m.ERR_BAD_RESPONSE
    ][Math.floor(n.status / 100) - 4], n.config, n.request, n));
}
const $1f14c967a58ea158$var$Gt = $1f14c967a58ea158$var$N.isStandardBrowserEnv ? // Standard browser envs support document.cookie
function() {
    return {
        write: function(n, r, s, i, o, u) {
            const f = [];
            f.push(n + "=" + encodeURIComponent(r)), $1f14c967a58ea158$var$a.isNumber(s) && f.push("expires=" + new Date(s).toGMTString()), $1f14c967a58ea158$var$a.isString(i) && f.push("path=" + i), $1f14c967a58ea158$var$a.isString(o) && f.push("domain=" + o), u === !0 && f.push("secure"), document.cookie = f.join("; ");
        },
        read: function(n) {
            const r = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
            return r ? decodeURIComponent(r[3]) : null;
        },
        remove: function(n) {
            this.write(n, "", Date.now() - 864e5);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function() {
    return {
        write: function() {},
        read: function() {
            return null;
        },
        remove: function() {}
    };
}();
function $1f14c967a58ea158$var$Wt(e) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function $1f14c967a58ea158$var$Yt(e, t) {
    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function $1f14c967a58ea158$var$He(e, t) {
    return e && !$1f14c967a58ea158$var$Wt(t) ? $1f14c967a58ea158$var$Yt(e, t) : t;
}
const $1f14c967a58ea158$var$Xt = $1f14c967a58ea158$var$N.isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function s(i) {
        let o = i;
        return t && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
            href: n.href,
            protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
            host: n.host,
            search: n.search ? n.search.replace(/^\?/, "") : "",
            hash: n.hash ? n.hash.replace(/^#/, "") : "",
            hostname: n.hostname,
            port: n.port,
            pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
    }
    return r = s(window.location.href), function(o) {
        const u = $1f14c967a58ea158$var$a.isString(o) ? s(o) : o;
        return u.protocol === r.protocol && u.host === r.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function() {
    return function() {
        return !0;
    };
}();
function $1f14c967a58ea158$var$Qt(e) {
    const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return t && t[1] || "";
}
function $1f14c967a58ea158$var$Zt(e, t) {
    e = e || 10;
    const n = new Array(e), r = new Array(e);
    let s = 0, i = 0, o;
    return t = t !== void 0 ? t : 1e3, function(f) {
        const d = Date.now(), c = r[i];
        o || (o = d), n[s] = f, r[s] = d;
        let p = i, y = 0;
        for(; p !== s;)y += n[p++], p = p % e;
        if (s = (s + 1) % e, s === i && (i = (i + 1) % e), d - o < t) return;
        const w = c && d - c;
        return w ? Math.round(y * 1e3 / w) : void 0;
    };
}
function $1f14c967a58ea158$var$ge(e, t) {
    let n = 0;
    const r = $1f14c967a58ea158$var$Zt(50, 250);
    return (s)=>{
        const i = s.loaded, o = s.lengthComputable ? s.total : void 0, u = i - n, f = r(u), d = i <= o;
        n = i;
        const c = {
            loaded: i,
            total: o,
            progress: o ? i / o : void 0,
            bytes: u,
            rate: f || void 0,
            estimated: f && o && d ? (o - i) / f : void 0,
            event: s
        };
        c[t ? "download" : "upload"] = !0, e(c);
    };
}
const $1f14c967a58ea158$var$en = typeof XMLHttpRequest < "u", $1f14c967a58ea158$var$tn = $1f14c967a58ea158$var$en && function(e) {
    return new Promise(function(n, r) {
        let s = e.data;
        const i = $1f14c967a58ea158$var$C.from(e.headers).normalize(), o = e.responseType;
        let u;
        function f() {
            e.cancelToken && e.cancelToken.unsubscribe(u), e.signal && e.signal.removeEventListener("abort", u);
        }
        let d;
        $1f14c967a58ea158$var$a.isFormData(s) && ($1f14c967a58ea158$var$N.isStandardBrowserEnv || $1f14c967a58ea158$var$N.isStandardBrowserWebWorkerEnv ? i.setContentType(!1) : i.getContentType(/^\s*multipart\/form-data/) ? $1f14c967a58ea158$var$a.isString(d = i.getContentType()) && i.setContentType(d.replace(/^\s*(multipart\/form-data);+/, "$1")) : i.setContentType("multipart/form-data"));
        let c = new XMLHttpRequest();
        if (e.auth) {
            const l = e.auth.username || "", h = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
            i.set("Authorization", "Basic " + btoa(l + ":" + h));
        }
        const p = $1f14c967a58ea158$var$He(e.baseURL, e.url);
        c.open(e.method.toUpperCase(), $1f14c967a58ea158$var$Ie(p, e.params, e.paramsSerializer), !0), c.timeout = e.timeout;
        function y() {
            if (!c) return;
            const l = $1f14c967a58ea158$var$C.from("getAllResponseHeaders" in c && c.getAllResponseHeaders()), R = {
                data: !o || o === "text" || o === "json" ? c.responseText : c.response,
                status: c.status,
                statusText: c.statusText,
                headers: l,
                config: e,
                request: c
            };
            $1f14c967a58ea158$var$Kt(function(E) {
                n(E), f();
            }, function(E) {
                r(E), f();
            }, R), c = null;
        }
        if ("onloadend" in c ? c.onloadend = y : c.onreadystatechange = function() {
            !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(y);
        }, c.onabort = function() {
            c && (r(new $1f14c967a58ea158$var$m("Request aborted", $1f14c967a58ea158$var$m.ECONNABORTED, e, c)), c = null);
        }, c.onerror = function() {
            r(new $1f14c967a58ea158$var$m("Network Error", $1f14c967a58ea158$var$m.ERR_NETWORK, e, c)), c = null;
        }, c.ontimeout = function() {
            let h = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
            const R = e.transitional || $1f14c967a58ea158$var$ke;
            e.timeoutErrorMessage && (h = e.timeoutErrorMessage), r(new $1f14c967a58ea158$var$m(h, R.clarifyTimeoutError ? $1f14c967a58ea158$var$m.ETIMEDOUT : $1f14c967a58ea158$var$m.ECONNABORTED, e, c)), c = null;
        }, $1f14c967a58ea158$var$N.isStandardBrowserEnv) {
            const l = $1f14c967a58ea158$var$Xt(p) && e.xsrfCookieName && $1f14c967a58ea158$var$Gt.read(e.xsrfCookieName);
            l && i.set(e.xsrfHeaderName, l);
        }
        s === void 0 && i.setContentType(null), "setRequestHeader" in c && $1f14c967a58ea158$var$a.forEach(i.toJSON(), function(h, R) {
            c.setRequestHeader(R, h);
        }), $1f14c967a58ea158$var$a.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), o && o !== "json" && (c.responseType = e.responseType), typeof e.onDownloadProgress == "function" && c.addEventListener("progress", $1f14c967a58ea158$var$ge(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", $1f14c967a58ea158$var$ge(e.onUploadProgress)), (e.cancelToken || e.signal) && (u = (l)=>{
            c && (r(!l || l.type ? new $1f14c967a58ea158$var$I(null, e, c) : l), c.abort(), c = null);
        }, e.cancelToken && e.cancelToken.subscribe(u), e.signal && (e.signal.aborted ? u() : e.signal.addEventListener("abort", u)));
        const w = $1f14c967a58ea158$var$Qt(p);
        if (w && $1f14c967a58ea158$var$N.protocols.indexOf(w) === -1) {
            r(new $1f14c967a58ea158$var$m("Unsupported protocol " + w + ":", $1f14c967a58ea158$var$m.ERR_BAD_REQUEST, e));
            return;
        }
        c.send(s || null);
    });
}, $1f14c967a58ea158$var$ne = {
    http: $1f14c967a58ea158$var$_t,
    xhr: $1f14c967a58ea158$var$tn
};
$1f14c967a58ea158$var$a.forEach($1f14c967a58ea158$var$ne, (e, t)=>{
    if (e) {
        try {
            Object.defineProperty(e, "name", {
                value: t
            });
        } catch  {}
        Object.defineProperty(e, "adapterName", {
            value: t
        });
    }
});
const $1f14c967a58ea158$var$we = (e)=>`- ${e}`, $1f14c967a58ea158$var$nn = (e)=>$1f14c967a58ea158$var$a.isFunction(e) || e === null || e === !1, $1f14c967a58ea158$var$Me = {
    getAdapter: (e)=>{
        e = $1f14c967a58ea158$var$a.isArray(e) ? e : [
            e
        ];
        const { length: t } = e;
        let n, r;
        const s = {};
        for(let i = 0; i < t; i++){
            n = e[i];
            let o;
            if (r = n, !$1f14c967a58ea158$var$nn(n) && (r = $1f14c967a58ea158$var$ne[(o = String(n)).toLowerCase()], r === void 0)) throw new $1f14c967a58ea158$var$m(`Unknown adapter '${o}'`);
            if (r) break;
            s[o || "#" + i] = r;
        }
        if (!r) {
            const i = Object.entries(s).map(([u, f])=>`adapter ${u} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build"));
            let o = t ? i.length > 1 ? `since :
` + i.map($1f14c967a58ea158$var$we).join(`
`) : " " + $1f14c967a58ea158$var$we(i[0]) : "as no adapter specified";
            throw new $1f14c967a58ea158$var$m("There is no suitable adapter to dispatch the request " + o, "ERR_NOT_SUPPORT");
        }
        return r;
    },
    adapters: $1f14c967a58ea158$var$ne
};
function $1f14c967a58ea158$var$Z(e) {
    if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new $1f14c967a58ea158$var$I(null, e);
}
function $1f14c967a58ea158$var$Re(e) {
    return $1f14c967a58ea158$var$Z(e), e.headers = $1f14c967a58ea158$var$C.from(e.headers), e.data = $1f14c967a58ea158$var$Q.call(e, e.transformRequest), [
        "post",
        "put",
        "patch"
    ].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), $1f14c967a58ea158$var$Me.getAdapter(e.adapter || $1f14c967a58ea158$var$ue.adapter)(e).then(function(r) {
        return $1f14c967a58ea158$var$Z(e), r.data = $1f14c967a58ea158$var$Q.call(e, e.transformResponse, r), r.headers = $1f14c967a58ea158$var$C.from(r.headers), r;
    }, function(r) {
        return $1f14c967a58ea158$var$je(r) || ($1f14c967a58ea158$var$Z(e), r && r.response && (r.response.data = $1f14c967a58ea158$var$Q.call(e, e.transformResponse, r.response), r.response.headers = $1f14c967a58ea158$var$C.from(r.response.headers))), Promise.reject(r);
    });
}
const $1f14c967a58ea158$var$Oe = (e)=>e instanceof $1f14c967a58ea158$var$C ? e.toJSON() : e;
function $1f14c967a58ea158$var$x(e, t) {
    t = t || {};
    const n = {};
    function r(d, c, p) {
        return $1f14c967a58ea158$var$a.isPlainObject(d) && $1f14c967a58ea158$var$a.isPlainObject(c) ? $1f14c967a58ea158$var$a.merge.call({
            caseless: p
        }, d, c) : $1f14c967a58ea158$var$a.isPlainObject(c) ? $1f14c967a58ea158$var$a.merge({}, c) : $1f14c967a58ea158$var$a.isArray(c) ? c.slice() : c;
    }
    function s(d, c, p) {
        if ($1f14c967a58ea158$var$a.isUndefined(c)) {
            if (!$1f14c967a58ea158$var$a.isUndefined(d)) return r(void 0, d, p);
        } else return r(d, c, p);
    }
    function i(d, c) {
        if (!$1f14c967a58ea158$var$a.isUndefined(c)) return r(void 0, c);
    }
    function o(d, c) {
        if ($1f14c967a58ea158$var$a.isUndefined(c)) {
            if (!$1f14c967a58ea158$var$a.isUndefined(d)) return r(void 0, d);
        } else return r(void 0, c);
    }
    function u(d, c, p) {
        if (p in t) return r(d, c);
        if (p in e) return r(void 0, d);
    }
    const f = {
        url: i,
        method: i,
        data: i,
        baseURL: o,
        transformRequest: o,
        transformResponse: o,
        paramsSerializer: o,
        timeout: o,
        timeoutMessage: o,
        withCredentials: o,
        adapter: o,
        responseType: o,
        xsrfCookieName: o,
        xsrfHeaderName: o,
        onUploadProgress: o,
        onDownloadProgress: o,
        decompress: o,
        maxContentLength: o,
        maxBodyLength: o,
        beforeRedirect: o,
        transport: o,
        httpAgent: o,
        httpsAgent: o,
        cancelToken: o,
        socketPath: o,
        responseEncoding: o,
        validateStatus: u,
        headers: (d, c)=>s($1f14c967a58ea158$var$Oe(d), $1f14c967a58ea158$var$Oe(c), !0)
    };
    return $1f14c967a58ea158$var$a.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
        const p = f[c] || s, y = p(e[c], t[c], c);
        $1f14c967a58ea158$var$a.isUndefined(y) && p !== u || (n[c] = y);
    }), n;
}
const $1f14c967a58ea158$var$qe = "1.6.0", $1f14c967a58ea158$var$le = {};
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((e, t)=>{
    $1f14c967a58ea158$var$le[e] = function(r) {
        return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
    };
});
const $1f14c967a58ea158$var$Se = {};
$1f14c967a58ea158$var$le.transitional = function(t, n, r) {
    function s(i, o) {
        return "[Axios v" + $1f14c967a58ea158$var$qe + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
    }
    return (i, o, u)=>{
        if (t === !1) throw new $1f14c967a58ea158$var$m(s(o, " has been removed" + (n ? " in " + n : "")), $1f14c967a58ea158$var$m.ERR_DEPRECATED);
        return n && !$1f14c967a58ea158$var$Se[o] && ($1f14c967a58ea158$var$Se[o] = !0, console.warn(s(o, " has been deprecated since v" + n + " and will be removed in the near future"))), t ? t(i, o, u) : !0;
    };
};
function $1f14c967a58ea158$var$rn(e, t, n) {
    if (typeof e != "object") throw new $1f14c967a58ea158$var$m("options must be an object", $1f14c967a58ea158$var$m.ERR_BAD_OPTION_VALUE);
    const r = Object.keys(e);
    let s = r.length;
    for(; s-- > 0;){
        const i = r[s], o = t[i];
        if (o) {
            const u = e[i], f = u === void 0 || o(u, i, e);
            if (f !== !0) throw new $1f14c967a58ea158$var$m("option " + i + " must be " + f, $1f14c967a58ea158$var$m.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (n !== !0) throw new $1f14c967a58ea158$var$m("Unknown option " + i, $1f14c967a58ea158$var$m.ERR_BAD_OPTION);
    }
}
const $1f14c967a58ea158$var$re = {
    assertOptions: $1f14c967a58ea158$var$rn,
    validators: $1f14c967a58ea158$var$le
}, $1f14c967a58ea158$var$F = $1f14c967a58ea158$var$re.validators;
class $1f14c967a58ea158$var$J {
    constructor(t){
        this.defaults = t, this.interceptors = {
            request: new $1f14c967a58ea158$var$ye(),
            response: new $1f14c967a58ea158$var$ye()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(t, n) {
        typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = $1f14c967a58ea158$var$x(this.defaults, n);
        const { transitional: r, paramsSerializer: s, headers: i } = n;
        r !== void 0 && $1f14c967a58ea158$var$re.assertOptions(r, {
            silentJSONParsing: $1f14c967a58ea158$var$F.transitional($1f14c967a58ea158$var$F.boolean),
            forcedJSONParsing: $1f14c967a58ea158$var$F.transitional($1f14c967a58ea158$var$F.boolean),
            clarifyTimeoutError: $1f14c967a58ea158$var$F.transitional($1f14c967a58ea158$var$F.boolean)
        }, !1), s != null && ($1f14c967a58ea158$var$a.isFunction(s) ? n.paramsSerializer = {
            serialize: s
        } : $1f14c967a58ea158$var$re.assertOptions(s, {
            encode: $1f14c967a58ea158$var$F.function,
            serialize: $1f14c967a58ea158$var$F.function
        }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
        let o = i && $1f14c967a58ea158$var$a.merge(i.common, i[n.method]);
        i && $1f14c967a58ea158$var$a.forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (l)=>{
            delete i[l];
        }), n.headers = $1f14c967a58ea158$var$C.concat(o, i);
        const u = [];
        let f = !0;
        this.interceptors.request.forEach(function(h) {
            typeof h.runWhen == "function" && h.runWhen(n) === !1 || (f = f && h.synchronous, u.unshift(h.fulfilled, h.rejected));
        });
        const d = [];
        this.interceptors.response.forEach(function(h) {
            d.push(h.fulfilled, h.rejected);
        });
        let c, p = 0, y;
        if (!f) {
            const l = [
                $1f14c967a58ea158$var$Re.bind(this),
                void 0
            ];
            for(l.unshift.apply(l, u), l.push.apply(l, d), y = l.length, c = Promise.resolve(n); p < y;)c = c.then(l[p++], l[p++]);
            return c;
        }
        y = u.length;
        let w = n;
        for(p = 0; p < y;){
            const l = u[p++], h = u[p++];
            try {
                w = l(w);
            } catch (R) {
                h.call(this, R);
                break;
            }
        }
        try {
            c = $1f14c967a58ea158$var$Re.call(this, w);
        } catch (l) {
            return Promise.reject(l);
        }
        for(p = 0, y = d.length; p < y;)c = c.then(d[p++], d[p++]);
        return c;
    }
    getUri(t) {
        t = $1f14c967a58ea158$var$x(this.defaults, t);
        const n = $1f14c967a58ea158$var$He(t.baseURL, t.url);
        return $1f14c967a58ea158$var$Ie(n, t.params, t.paramsSerializer);
    }
}
$1f14c967a58ea158$var$a.forEach([
    "delete",
    "get",
    "head",
    "options"
], function(t) {
    $1f14c967a58ea158$var$J.prototype[t] = function(n, r) {
        return this.request($1f14c967a58ea158$var$x(r || {}, {
            method: t,
            url: n,
            data: (r || {}).data
        }));
    };
});
$1f14c967a58ea158$var$a.forEach([
    "post",
    "put",
    "patch"
], function(t) {
    function n(r) {
        return function(i, o, u) {
            return this.request($1f14c967a58ea158$var$x(u || {}, {
                method: t,
                headers: r ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: i,
                data: o
            }));
        };
    }
    $1f14c967a58ea158$var$J.prototype[t] = n(), $1f14c967a58ea158$var$J.prototype[t + "Form"] = n(!0);
});
const $1f14c967a58ea158$var$q = $1f14c967a58ea158$var$J;
class $1f14c967a58ea158$var$fe {
    constructor(t){
        if (typeof t != "function") throw new TypeError("executor must be a function.");
        let n;
        this.promise = new Promise(function(i) {
            n = i;
        });
        const r = this;
        this.promise.then((s)=>{
            if (!r._listeners) return;
            let i = r._listeners.length;
            for(; i-- > 0;)r._listeners[i](s);
            r._listeners = null;
        }), this.promise.then = (s)=>{
            let i;
            const o = new Promise((u)=>{
                r.subscribe(u), i = u;
            }).then(s);
            return o.cancel = function() {
                r.unsubscribe(i);
            }, o;
        }, t(function(i, o, u) {
            r.reason || (r.reason = new $1f14c967a58ea158$var$I(i, o, u), n(r.reason));
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(t) {
        if (this.reason) {
            t(this.reason);
            return;
        }
        this._listeners ? this._listeners.push(t) : this._listeners = [
            t
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(t) {
        if (!this._listeners) return;
        const n = this._listeners.indexOf(t);
        n !== -1 && this._listeners.splice(n, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let t;
        return {
            token: new $1f14c967a58ea158$var$fe(function(s) {
                t = s;
            }),
            cancel: t
        };
    }
}
const $1f14c967a58ea158$var$sn = $1f14c967a58ea158$var$fe;
function $1f14c967a58ea158$var$on(e) {
    return function(n) {
        return e.apply(null, n);
    };
}
function $1f14c967a58ea158$var$an(e) {
    return $1f14c967a58ea158$var$a.isObject(e) && e.isAxiosError === !0;
}
const $1f14c967a58ea158$var$se = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($1f14c967a58ea158$var$se).forEach(([e, t])=>{
    $1f14c967a58ea158$var$se[t] = e;
});
const $1f14c967a58ea158$var$cn = $1f14c967a58ea158$var$se;
function $1f14c967a58ea158$var$Je(e) {
    const t = new $1f14c967a58ea158$var$q(e), n = $1f14c967a58ea158$var$Ae($1f14c967a58ea158$var$q.prototype.request, t);
    return $1f14c967a58ea158$var$a.extend(n, $1f14c967a58ea158$var$q.prototype, t, {
        allOwnKeys: !0
    }), $1f14c967a58ea158$var$a.extend(n, t, null, {
        allOwnKeys: !0
    }), n.create = function(s) {
        return $1f14c967a58ea158$var$Je($1f14c967a58ea158$var$x(e, s));
    }, n;
}
const $1f14c967a58ea158$var$g = $1f14c967a58ea158$var$Je($1f14c967a58ea158$var$ue);
$1f14c967a58ea158$var$g.Axios = $1f14c967a58ea158$var$q;
$1f14c967a58ea158$var$g.CanceledError = $1f14c967a58ea158$var$I;
$1f14c967a58ea158$var$g.CancelToken = $1f14c967a58ea158$var$sn;
$1f14c967a58ea158$var$g.isCancel = $1f14c967a58ea158$var$je;
$1f14c967a58ea158$var$g.VERSION = $1f14c967a58ea158$var$qe;
$1f14c967a58ea158$var$g.toFormData = $1f14c967a58ea158$var$K;
$1f14c967a58ea158$var$g.AxiosError = $1f14c967a58ea158$var$m;
$1f14c967a58ea158$var$g.Cancel = $1f14c967a58ea158$var$g.CanceledError;
$1f14c967a58ea158$var$g.all = function(t) {
    return Promise.all(t);
};
$1f14c967a58ea158$var$g.spread = $1f14c967a58ea158$var$on;
$1f14c967a58ea158$var$g.isAxiosError = $1f14c967a58ea158$var$an;
$1f14c967a58ea158$var$g.mergeConfig = $1f14c967a58ea158$var$x;
$1f14c967a58ea158$var$g.AxiosHeaders = $1f14c967a58ea158$var$C;
$1f14c967a58ea158$var$g.formToJSON = (e)=>$1f14c967a58ea158$var$ve($1f14c967a58ea158$var$a.isHTMLForm(e) ? new FormData(e) : e);
$1f14c967a58ea158$var$g.getAdapter = $1f14c967a58ea158$var$Me.getAdapter;
$1f14c967a58ea158$var$g.HttpStatusCode = $1f14c967a58ea158$var$cn;
$1f14c967a58ea158$var$g.default = $1f14c967a58ea158$var$g;
const $1f14c967a58ea158$var$un = $1f14c967a58ea158$var$g;
var $1f14c967a58ea158$export$45c69700ee30a78c = /* @__PURE__ */ ((e)=>(e.BOOLEAN = "BOOLEAN", e.INTEGER = "INTEGER", e.DOUBLE = "DOUBLE", e.STRING = "STRING", e.JSON = "JSON", e))($1f14c967a58ea158$export$45c69700ee30a78c || {}), $1f14c967a58ea158$export$96e9906d6d93a972 = /* @__PURE__ */ ((e)=>(e.UNKNOWN = "UNKNOWN", e.SUCCESS = "SUCCESS", e.SDK_ERROR = "SDK_ERROR", e.INVALID_REQUEST = "INVALID_REQUEST", e.NOT_FOUND = "NOT_FOUND", e.WRONG_TYPE = "WRONG_TYPE", e.SERVICE_NOT_READY = "SERVICE_NOT_READY", e))($1f14c967a58ea158$export$96e9906d6d93a972 || {}), $1f14c967a58ea158$export$f435f793048e7a0f = /* @__PURE__ */ ((e)=>(e.UNIT = "UNIT", e.MERCHANT = "MERCHANT", e.DEVICE_ID = "DEVICE_ID", e.ANONYMOUS_VISITOR = "ANONYMOUS_VISITOR", e.PERSON = "PERSON", e))($1f14c967a58ea158$export$f435f793048e7a0f || {}), $1f14c967a58ea158$export$b6032183171af19f = /* @__PURE__ */ ((e)=>(e.NOT_SUPPLIED = "NOT_SUPPLIED", e.PIE = "PIE", e.CAPITAL = "CAPITAL", e.SQUARE_CONSOLE = "SQUARE_CONSOLE", e.TIDAL = "TIDAL", e.SHOP = "SHOP", e))($1f14c967a58ea158$export$b6032183171af19f || {});
const $1f14c967a58ea158$var$fn = "application/json", $1f14c967a58ea158$var$dn = "https://squareupsandbox.com", $1f14c967a58ea158$var$pn = "/1.0/features/get-flags", $1f14c967a58ea158$var$hn = "/1.0/features/get-flags-sandbox", $1f14c967a58ea158$var$ze = $1f14c967a58ea158$export$b6032183171af19f.PIE;
function $1f14c967a58ea158$var$mn(e = "") {
    const t = e.endsWith("/") ? e.slice(0, -1) : e, n = e.includes($1f14c967a58ea158$var$dn) ? $1f14c967a58ea158$var$hn : $1f14c967a58ea158$var$pn;
    return `${t}${n}`;
}
/*! js-cookie v3.0.5 | MIT */ function $1f14c967a58ea158$var$j(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = arguments[t];
        for(var r in n)e[r] = n[r];
    }
    return e;
}
var $1f14c967a58ea158$var$yn = {
    read: function(e) {
        return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(e) {
        return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $1f14c967a58ea158$var$oe(e, t) {
    function n(s, i, o) {
        if (!(typeof document > "u")) {
            o = $1f14c967a58ea158$var$j({}, t, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), s = encodeURIComponent(s).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var u = "";
            for(var f in o)o[f] && (u += "; " + f, o[f] !== !0 && (u += "=" + o[f].split(";")[0]));
            return document.cookie = s + "=" + e.write(i, s) + u;
        }
    }
    function r(s) {
        if (!(typeof document > "u" || arguments.length && !s)) {
            for(var i = document.cookie ? document.cookie.split("; ") : [], o = {}, u = 0; u < i.length; u++){
                var f = i[u].split("="), d = f.slice(1).join("=");
                try {
                    var c = decodeURIComponent(f[0]);
                    if (o[c] = e.read(d, c), s === c) break;
                } catch  {}
            }
            return s ? o[s] : o;
        }
    }
    return Object.create({
        set: n,
        get: r,
        remove: function(s, i) {
            n(s, "", $1f14c967a58ea158$var$j({}, i, {
                expires: -1
            }));
        },
        withAttributes: function(s) {
            return $1f14c967a58ea158$var$oe(this.converter, $1f14c967a58ea158$var$j({}, this.attributes, s));
        },
        withConverter: function(s) {
            return $1f14c967a58ea158$var$oe($1f14c967a58ea158$var$j({}, this.converter, s), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(t)
        },
        converter: {
            value: Object.freeze(e)
        }
    });
}
var $1f14c967a58ea158$var$En = $1f14c967a58ea158$var$oe($1f14c967a58ea158$var$yn, {
    path: "/"
});
async function $1f14c967a58ea158$export$d5815430bcc75df0({ flagRequests: e, userToken: t, origin: n, headers: r, withCredentials: s, project: i = $1f14c967a58ea158$var$ze, userAttributes: o }) {
    const u = {
        project: i,
        flag_requests: e,
        user_token: t,
        user_attributes: o ? {
            user_attributes: o
        } : void 0
    }, f = $1f14c967a58ea158$var$mn(n), { data: d } = await $1f14c967a58ea158$var$un.post(f, u, {
        withCredentials: s,
        headers: {
            Accept: $1f14c967a58ea158$var$fn,
            ...$1f14c967a58ea158$var$wn(),
            ...r
        }
    });
    if (d.status !== $1f14c967a58ea158$export$96e9906d6d93a972.SUCCESS) throw new Error(`Request to retrieve feature flags failed with status ${d.status}`);
    return d.flag_responses ?? [];
}
function $1f14c967a58ea158$var$wn() {
    const e = $1f14c967a58ea158$var$En.get("_js_csrf");
    return e !== void 0 ? {
        "x-csrf-token": e
    } : null;
}
function $1f14c967a58ea158$var$Rn(e) {
    return e.flag_type === $1f14c967a58ea158$export$45c69700ee30a78c.BOOLEAN && typeof e.flag_name == "string";
}
function $1f14c967a58ea158$var$On(e) {
    return e.flag_type === $1f14c967a58ea158$export$45c69700ee30a78c.DOUBLE && typeof e.flag_name == "string";
}
function $1f14c967a58ea158$var$Sn(e) {
    return e.flag_type === $1f14c967a58ea158$export$45c69700ee30a78c.INTEGER && typeof e.flag_name == "string";
}
function $1f14c967a58ea158$var$bn(e) {
    return e.flag_type === $1f14c967a58ea158$export$45c69700ee30a78c.JSON && typeof e.flag_name == "string";
}
function $1f14c967a58ea158$var$An(e) {
    return e.flag_type === $1f14c967a58ea158$export$45c69700ee30a78c.STRING && typeof e.flag_name == "string";
}
function $1f14c967a58ea158$export$bd729e45c45d1b14(e, t) {
    if (e.status === $1f14c967a58ea158$export$96e9906d6d93a972.SUCCESS) {
        if ($1f14c967a58ea158$var$Rn(e)) return e.bool_value;
        if ($1f14c967a58ea158$var$Sn(e)) return e.int_value;
        if ($1f14c967a58ea158$var$On(e)) return e.double_value;
        if ($1f14c967a58ea158$var$An(e)) return e.string_value;
        if ($1f14c967a58ea158$var$bn(e)) {
            if (!e.string_value) return;
            try {
                return JSON.parse(e.string_value);
            } catch  {
                typeof t == "function" && t({
                    flagKey: e.flag_name,
                    stringifiedValue: e.string_value
                });
                return;
            }
        }
    }
}
function $1f14c967a58ea158$var$Tn(e) {
    const t = /* @__PURE__ */ new Map();
    for (const n of Object.values(e)){
        const r = {
            value: void 0,
            config: n
        };
        t.set(n.key, r);
    }
    return t;
}
function $1f14c967a58ea158$var$Nn(e) {
    const { key: t, flagType: n } = e;
    return {
        flag_name: t,
        flag_type: n
    };
}
function $1f14c967a58ea158$var$_n({ flagConfig: e, flagResponse: t, onIncorrectFlagType: n, onMalformedJsonFlagValue: r }) {
    return t.status === $1f14c967a58ea158$export$96e9906d6d93a972.WRONG_TYPE ? (typeof n == "function" && n({
        flagKey: e.key,
        expectedType: e.flagType
    }), e.defaultValue) : $1f14c967a58ea158$export$bd729e45c45d1b14(t, r);
}
function $1f14c967a58ea158$var$be(e, t) {
    if (typeof t == "function") for (const [n, { config: r, value: s }] of e)s === void 0 && t({
        flagKey: n,
        flagType: r.flagType
    });
}
function $1f14c967a58ea158$export$4c027c4176fa384({ project: e = $1f14c967a58ea158$var$ze, flagConfigs: t, origin: n, headers: r, withCredentials: s, userAttributes: i, userToken: o, offlineMode: u, onIncorrectFlagType: f, onMalformedJsonFlagValue: d, onMissingFlagValue: c, onUnexpectedFlagValue: p }) {
    const y = $1f14c967a58ea158$var$Tn(t);
    let w = !1, l = !1;
    function h(E) {
        var S;
        if (w = !0, l) throw new Error("Bootstrapping flags after `loadFlags` has been invoked is not supported. Instantiate a different client instance if both bootstrapped and client-loaded feature flags are required.");
        for(const O in E){
            const P = ((S = t[O]) == null ? void 0 : S.key) ?? "", v = y.get(P);
            if (v === void 0) {
                typeof p == "function" && p({
                    flagKey: O,
                    value: E[O]
                });
                continue;
            }
            y.set(P, {
                config: v.config,
                value: E[O]
            });
        }
        $1f14c967a58ea158$var$be(y, c);
    }
    async function R() {
        if (l = !0, w) throw new Error("Loading flags after `boostrapFlags` has been invoked is not supported. Instantiate a different client instance if both bootstrapped and client-loaded feature flags are required.");
        if (o === void 0) throw new TypeError("Clients require a `userToken` to retrieve flags from the Feature Relay service via `loadFlags`. Be sure to invoke `createFeatureRelayClient` with a valid `userToken` instance.");
        if (u) return;
        const E = Object.values(t).map($1f14c967a58ea158$var$Nn), S = await $1f14c967a58ea158$export$d5815430bcc75df0({
            project: e,
            flagRequests: E,
            origin: n,
            headers: r,
            withCredentials: s,
            userAttributes: i,
            userToken: o
        });
        for (const O of S){
            const P = y.get(O.flag_name);
            if (!P) {
                typeof p == "function" && p({
                    dataType: O.flag_type,
                    flagKey: O.flag_name,
                    value: $1f14c967a58ea158$export$bd729e45c45d1b14(O)
                });
                continue;
            }
            const v = $1f14c967a58ea158$var$_n({
                flagConfig: P.config,
                flagResponse: O,
                onIncorrectFlagType: f,
                onMalformedJsonFlagValue: d
            });
            y.set(P.config.key, {
                ...P,
                value: v
            });
        }
        $1f14c967a58ea158$var$be(y, c);
    }
    function A(E) {
        const S = y.get(E.key);
        if (!S) throw new Error(`Attempted to read a flag (${E.key}) that has not been configured. Make sure you're using the correct client instance, or that you've included this flag when instantiating the client.`);
        if (!w && !l) throw new Error("You have not yet fetched values for your flags. Retrieve flag values with the `loadFlags` method, or bootstrap values with the `bootstrapFlags` method.");
        const O = E.getMock();
        return O.isSet ? O.value : u ? E.defaultValue : S.value ?? E.defaultValue;
    }
    return {
        bootstrapFlags: h,
        getFlagValue: A,
        loadFlags: R
    };
}
function $1f14c967a58ea158$var$Cn(e) {
    let t = {
        isSet: !1,
        value: void 0
    };
    return {
        ...e,
        getMock () {
            return t;
        },
        setMockValue (n) {
            if (t.isSet) {
                const r = "A mock value has been re-set with out being cleared. This may be an indication of state leaking between tests. Clear mock values with `.clearMockValue()` before re-setting.";
                throw new Error(r);
            }
            t = {
                value: n,
                isSet: !0
            };
        },
        clearMockValue () {
            t = {
                value: void 0,
                isSet: !1
            };
        }
    };
}
function $1f14c967a58ea158$var$k({ key: e, defaultValue: t, flagType: n }) {
    if (e.length === 0) throw new Error("Feature flag configuration instances require non-empty key");
    return $1f14c967a58ea158$var$Cn({
        key: e,
        defaultValue: t,
        flagType: n
    });
}
function $1f14c967a58ea158$export$b36941f86f577b21({ key: e, defaultValue: t }) {
    return $1f14c967a58ea158$var$k({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.BOOLEAN
    });
}
function $1f14c967a58ea158$export$4fa9630feb8c5be5({ key: e, defaultValue: t }) {
    if (!Number.isInteger(t)) throw new TypeError(`You supplied a non-integer default value to the ${e} flag.To create a flag with support for decimal values, use createDoubleFlag.`);
    return $1f14c967a58ea158$var$k({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.INTEGER
    });
}
function $1f14c967a58ea158$export$cca336e59540c09c({ key: e, defaultValue: t }) {
    return $1f14c967a58ea158$var$k({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.DOUBLE
    });
}
function $1f14c967a58ea158$export$2fc7b3a447bc1bcb({ key: e, defaultValue: t }) {
    return $1f14c967a58ea158$var$k({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.STRING
    });
}
function $1f14c967a58ea158$export$ef7cd1fbde911956({ key: e, defaultValue: t }) {
    return $1f14c967a58ea158$var$k({
        key: e,
        defaultValue: t,
        flagType: $1f14c967a58ea158$export$45c69700ee30a78c.JSON
    });
}


const $3ffd6dbaf72645e1$export$33fb1db36da5c5ad = {
    canToggleLockCard: (0, $1f14c967a58ea158$export$b36941f86f577b21)({
        key: "banking-microsite-toggle-card-lock",
        defaultValue: true
    }),
    canUpdatePin: (0, $1f14c967a58ea158$export$b36941f86f577b21)({
        key: "banking-web-enable-update-pin",
        defaultValue: true
    })
};




parcelRequire("acw62");
const $3de42ffd7affe746$var$SvgActionEye = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 14",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M.09 6.58C1.97 2.52 5.77 0 10 0s8.03 2.52 9.91 6.58c.12.26.12.57 0 .84C18.03 11.48 14.23 14 10 14S1.97 11.48.09 7.42c-.12-.26-.12-.57 0-.84M2.11 7c1.61 3.1 4.6 5 7.89 5s6.28-1.9 7.89-5c-1.61-3.1-4.6-5-7.89-5S3.72 3.9 2.11 7M6 7c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4m2 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2",
            clipRule: "evenodd"
        })
    });
var $3de42ffd7affe746$export$2e2bcd8739ae039 = $3de42ffd7affe746$var$SvgActionEye;



parcelRequire("acw62");
const $20c5e8324d8e54d7$var$SvgActionLockOff = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M9 9h7c1.66 0 3 1.34 3 3v7c0 1.66-1.34 3-3 3H8c-1.66 0-3-1.34-3-3v-7c0-1.3.84-2.4 2-2.82V7c0-2.76 2.24-5 5-5 1.38 0 2.63.56 3.53 1.47l-1.41 1.41C13.58 4.34 12.83 4 12 4c-1.65 0-3 1.35-3 3zm7 11c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1zm-2.5-4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
            clipRule: "evenodd"
        })
    });
var $20c5e8324d8e54d7$export$2e2bcd8739ae039 = $20c5e8324d8e54d7$var$SvgActionLockOff;



parcelRequire("acw62");
const $68c25860e8f03803$var$SvgActionLockOn = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M17 7v2.18c1.16.42 2 1.52 2 2.82v7c0 1.66-1.34 3-3 3H8c-1.66 0-3-1.34-3-3v-7c0-1.3.84-2.4 2-2.82V7c0-2.76 2.24-5 5-5s5 2.24 5 5m-2 0c0-1.65-1.35-3-3-3S9 5.35 9 7v2h6zm1 13c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1zm-2.5-4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
            clipRule: "evenodd"
        })
    });
var $68c25860e8f03803$export$2e2bcd8739ae039 = $68c25860e8f03803$var$SvgActionLockOn;



parcelRequire("acw62");
const $098aefa0dee8a062$var$SvgActionMessage = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 19 19",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M1 8.999C1 4.029 5.03 0 10 0s9 4.03 9 8.999c0 .574-.06 1.129-.16 1.661a9.02 9.02 0 0 1-4.295 6.102h-.002a8.95 8.95 0 0 1-8.847.131L4.2 17.36.48 18.52l1.16-3.72.467-1.494A8.9 8.9 0 0 1 1 8.999M10 2a7 7 0 0 0-7 6.999c0 1.343.384 2.592 1.043 3.658l.24.388-.758 2.43.08-.024 2.349-.733.387.238a6.946 6.946 0 0 0 7.19.082 7.02 7.02 0 0 0 3.344-4.746C16.955 9.865 17 9.434 17 9A7 7 0 0 0 10 2",
            clipRule: "evenodd"
        })
    });
var $098aefa0dee8a062$export$2e2bcd8739ae039 = $098aefa0dee8a062$var$SvgActionMessage;



parcelRequire("acw62");
const $5107a4283e5093ff$var$SvgArrowDualRotatingArrows = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 22,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            d: "M1.77 16.01c.04-.04.07-.09.11-.13l1.31-1.31A5.9 5.9 0 0 1 2 11c0-3.31 2.69-6 6-6h1.59L8.3 6.29 9.71 7.7l3-3a.996.996 0 0 0 0-1.41l-3-3L8.3 1.7 9.59 3H8c-4.41 0-8 3.59-8 8 0 1.85.62 3.6 1.77 5.01M14 11c0 3.31-2.69 6-6 6H6.41l1.29-1.29-1.41-1.41-3 3a.996.996 0 0 0 0 1.41l3 3L7.7 20.3 6.41 19H8c4.41 0 8-3.59 8-8 0-1.85-.62-3.6-1.77-5.01-.04.04-.07.09-.11.13l-1.31 1.31A5.9 5.9 0 0 1 14 11"
        })
    });
var $5107a4283e5093ff$export$2e2bcd8739ae039 = $5107a4283e5093ff$var$SvgArrowDualRotatingArrows;



parcelRequire("acw62");
const $cac23a2dd1647340$var$SvgAlertQuestionMarkCircle = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7m0-2a1.25 1.25 0 1 0 0-2.5A1.25 1.25 0 0 0 9 14M6 6.75C6 5.23 7.35 4 9 4s3 1.23 3 2.75c0 1.11-.66 1.77-1.19 2.29-.53.53-.81.83-.81 1.46H8c0-1.48.8-2.28 1.388-2.868L9.4 7.62c.44-.43.6-.61.6-.87C10 6.34 9.54 6 9 6s-1 .34-1 .75z",
            clipRule: "evenodd"
        })
    });
var $cac23a2dd1647340$export$2e2bcd8739ae039 = $cac23a2dd1647340$var$SvgAlertQuestionMarkCircle;



parcelRequire("acw62");
const $92250f559716e808$var$SvgFinanceCardSwipe = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 14",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            d: "M17 0H3C1.34 0 0 1.34 0 3v8c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3m1 11c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V6h16zM2 4V3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v1z"
        })
    });
var $92250f559716e808$export$2e2bcd8739ae039 = $92250f559716e808$var$SvgFinanceCardSwipe;




/**
 * This file is used to define the card management items and their actions.
 *
 * This file may change when the actions are implemented
 */ /**
 * These are the status in which the card is activated and the majority of settings
 * are accessible to the user.
 */ const $b4caa49c14bbb322$var$ACTIVE_CARD_STATES = [
    (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_ACTIVE,
    (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_LOCKED
];
const $b4caa49c14bbb322$export$602235b7817de594 = (status)=>{
    if (status == null) return false;
    return $b4caa49c14bbb322$var$ACTIVE_CARD_STATES.includes(status);
};
const $b4caa49c14bbb322$export$2fcbf09f7363273b = (t)=>(state, dispatch)=>({
            Icon: (0, $3de42ffd7affe746$export$2e2bcd8739ae039),
            text: t("section.settings.actions.showCardDetails"),
            control: (0, $67b4545ba4ea2391$export$18f8036a6dc5f3a5).TOGGLE,
            hidden: state.card?.status !== (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_ACTIVE,
            value: state.showCardDetails,
            action: ()=>dispatch((0, $f85882ff218eecf6$export$f74d2d3c457dc478)(!state.showCardDetails))
        });
const $b4caa49c14bbb322$export$130c3b3bd8381d24 = (t, getFlagValue)=>(state, dispatch)=>{
        const status = state.card?.status;
        return {
            Icon: status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_LOCKED ? (0, $20c5e8324d8e54d7$export$2e2bcd8739ae039) : (0, $68c25860e8f03803$export$2e2bcd8739ae039),
            text: status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_LOCKED ? t("section.settings.actions.toggleLockCard.unlock") : t("section.settings.actions.toggleLockCard.lock"),
            control: (0, $67b4545ba4ea2391$export$18f8036a6dc5f3a5).TOGGLE,
            hidden: getFlagValue((0, $3ffd6dbaf72645e1$export$33fb1db36da5c5ad).canToggleLockCard) === false || !$b4caa49c14bbb322$export$602235b7817de594(status),
            loading: state.toggleLoading.lockCard,
            value: status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_LOCKED,
            action: ()=>dispatch((0, $f85882ff218eecf6$export$d395068d63fb6384)(!(status === (0, $d272bac0a1712861$export$490c7ce941281ba8).CARD_STATUS_LOCKED)))
        };
    };
const $b4caa49c14bbb322$export$5a00c9fa00a5082b = (t, getFlagValue)=>(state, dispatch)=>({
            Icon: (0, $5107a4283e5093ff$export$2e2bcd8739ae039),
            text: t("section.settings.actions.resetPin"),
            hidden: getFlagValue((0, $3ffd6dbaf72645e1$export$33fb1db36da5c5ad).canUpdatePin) === false || !$b4caa49c14bbb322$export$602235b7817de594(state.card?.status),
            action: ()=>dispatch((0, $f85882ff218eecf6$export$95b3c069ab4a2752)())
        });
const $b4caa49c14bbb322$export$86fc0ee5ddebf360 = (t, getFlagValue)=>(state, dispatch)=>[
            $b4caa49c14bbb322$export$2fcbf09f7363273b(t)(state, dispatch),
            $b4caa49c14bbb322$export$130c3b3bd8381d24(t, getFlagValue)(state, dispatch),
            $b4caa49c14bbb322$export$5a00c9fa00a5082b(t, getFlagValue)(state, dispatch)
        ];
const $b4caa49c14bbb322$export$5699e2a53bd86cbe = (t)=>[
        {
            Icon: (0, $92250f559716e808$export$2e2bcd8739ae039),
            text: t("section.help.actions.cardHelp"),
            action: ()=>{
                // TODO(cvu): implement card management actions
                console.log("card help");
            }
        },
        {
            Icon: (0, $cac23a2dd1647340$export$2e2bcd8739ae039),
            text: t("section.help.actions.supportArticles"),
            action: ()=>{
                // TODO(cvu): implement card management actions
                console.log("support articles");
            }
        },
        {
            Icon: (0, $098aefa0dee8a062$export$2e2bcd8739ae039),
            text: t("section.help.actions.contactUs"),
            action: ()=>{
                // TODO(cvu): implement card management actions
                console.log("contact us");
            }
        }
    ];



var $acw62 = parcelRequire("acw62");



const $68b24b260ef7a1f3$export$132644df149d36c1 = (flagConfigs, userToken)=>({
        project: (0, $1f14c967a58ea158$export$b6032183171af19f).PIE,
        flagConfigs: flagConfigs,
        origin: (0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039).origin,
        withCredentials: true,
        offlineMode: false,
        userToken: userToken
    });
var $68b24b260ef7a1f3$export$2e2bcd8739ae039 = $68b24b260ef7a1f3$export$132644df149d36c1;


function $ea440760c63f6861$export$43f174d627cf7c49(flagConfigs, userToken) {
    const [client, setClient] = (0, $acw62.useState)();
    const [flagsLoaded, setFlagsLoaded] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const client = (0, $1f14c967a58ea158$export$4c027c4176fa384)((0, $68b24b260ef7a1f3$export$2e2bcd8739ae039)(flagConfigs, userToken));
        setClient(client);
    }, []);
    (0, $acw62.useEffect)(()=>{
        // NOTE(cvu): Load flags can throw an error. I am going to let it throw for now.
        client?.loadFlags().then(()=>{
            setFlagsLoaded(true);
        });
    }, [
        client
    ]);
    const getFlagValue = (flag)=>{
        if (!flagsLoaded) throw new Error("Flags have not been loaded, please call 'loadFlags' before fetching flag");
        return client?.getFlagValue(flag);
    };
    return {
        flagsLoaded: flagsLoaded,
        getFlagValue: getFlagValue
    };
}




function $cc584424654c833c$export$e314053f2db92863({ state: state, dispatch: dispatch }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-settings");
    const launchDarklyClient = (0, $ea440760c63f6861$export$43f174d627cf7c49)((0, $3ffd6dbaf72645e1$export$33fb1db36da5c5ad), {
        token: "anonymousUser",
        type: (0, $1f14c967a58ea158$export$f435f793048e7a0f).ANONYMOUS_VISITOR
    });
    return launchDarklyClient.flagsLoaded && launchDarklyClient.getFlagValue ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $65a7b64dd007d7b7$export$7aa52cf130c2f005), {
        card: state.card || (0, $d272bac0a1712861$export$60332b2344f7fe41).create(),
        cardCustomization: state.cardCustomization || undefined,
        cardSettings: (0, $b4caa49c14bbb322$export$86fc0ee5ddebf360)(t, launchDarklyClient.getFlagValue)(state, dispatch),
        helpSettings: [],
        showCardDetails: state.showCardDetails,
        onActivateCardClick: ()=>dispatch((0, $f85882ff218eecf6$export$4b6cffd9a01ae17)())
    }) : null;
}





const $46e9f01d04e1602b$var$openCardActivationModal = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([_, action])=>action.type === (0, $f85882ff218eecf6$export$e4a712fff93fb00f).UserClickActivateCard), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(()=>({
            to: "activate-card",
            state: {
                cardActivation: {
                    done: false
                }
            }
        })));
const $46e9f01d04e1602b$var$openResetPinModal = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([_, action])=>action.type === (0, $f85882ff218eecf6$export$e4a712fff93fb00f).UserClickResetPin), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(()=>({
            to: "reset-pin"
        })));
const $46e9f01d04e1602b$var$navigation = (source)=>(0, $195e3b3043565ec4$export$ba255e9e49e00608)(...[
        $46e9f01d04e1602b$var$openCardActivationModal,
        $46e9f01d04e1602b$var$openResetPinModal
    ].map((transition)=>source.pipe(transition))).pipe((0, $4707859e785b3da6$export$18aef43295bbe906)());
var $46e9f01d04e1602b$export$2e2bcd8739ae039 = $46e9f01d04e1602b$var$navigation;


function $f754305549e0f040$export$2239573305b2aa49({ cardManagementService: cardManagementService, externalBizbankService: externalBizbankService }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-settings");
    const { cardToken: cardToken } = (0, $3e8179397014bb35$export$99eaa27ddbbb95ef)();
    const location = (0, $3e8179397014bb35$export$45d76561a5302f2b)();
    const navigate = (0, $3e8179397014bb35$export$9770f232ac06a008)();
    const [cardSettingsState, cardSettingsDispatch, cardSettingsWorkflow] = (0, $52d6aae768cd1bf0$export$7bc289ae93a0a81d)({
        cardManagementService: cardManagementService,
        externalBizbankService: externalBizbankService,
        sentry: {
            captureException: $b8438.captureException
        }
    }, $f85882ff218eecf6$export$e6a0daad8304de(), $f85882ff218eecf6$export$2e2bcd8739ae039);
    (0, $acw62.useEffect)(()=>{
        const subscriptions = new (0, $8343668acd7c4a9b$export$f55210826850c514)();
        subscriptions.add(cardSettingsWorkflow.updates.pipe((0, $46e9f01d04e1602b$export$2e2bcd8739ae039)).subscribe((nav)=>navigate(nav.to, nav.options)));
        return ()=>{
            subscriptions.unsubscribe();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (cardToken != null) cardSettingsDispatch($f85882ff218eecf6$export$c81c36414a1e3192(cardToken));
    }, [
        cardToken
    ]);
    (0, $acw62.useEffect)(()=>{
        // refetch the card data if card activation is completed
        if (location.state?.cardActivation?.done && cardToken != null) cardSettingsDispatch($f85882ff218eecf6$export$c81c36414a1e3192(cardToken));
    }, [
        location
    ]);
    const breadcrumb = {
        title: t("routes.overview", {
            ns: "site"
        }),
        link: {
            to: "/"
        }
    };
    const headerElement = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0cb7d9ae27028ab3$export$53f1cd6809577fc5), {
        breadcrumb: breadcrumb,
        title: cardSettingsState.card ? (0, $1f03a6bc7d91b109$export$af0ed80290d14473)(cardSettingsState.card) : ""
    });
    return cardSettingsState.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$28c2b904b2ab5c88), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $10b264b7e14b606b$export$6955bcca4cd3539f), {
        header: headerElement,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc584424654c833c$export$e314053f2db92863), {
                state: cardSettingsState,
                dispatch: cardSettingsDispatch
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e8179397014bb35$export$910ae8079b2c2852), {})
        ]
    });
}


const $ffa5c35d73b6afd6$export$fdf04d45b6511766 = (0, $7c5a3dd94b85a123$export$72f8d6ff1467b5f4)((0, $f754305549e0f040$export$2239573305b2aa49), {
    cardManagementService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).CARD_MANAGEMENT_SERVICE,
    externalBizbankService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).EXTERNAL_BIZBANK_SERVICE
});






var $acw62 = parcelRequire("acw62");










var $a81baa7b3cd02573$export$484fa93d7befe621;
var $a81baa7b3cd02573$export$acf4eaf431084f78;
var $a81baa7b3cd02573$export$70a5d6cdc959e89c;
$a81baa7b3cd02573$export$484fa93d7befe621 = `qaDDfW_CardStatus_cardDetailsButton`;
$a81baa7b3cd02573$export$acf4eaf431084f78 = `qaDDfW_CardStatus_iconContainer`;
$a81baa7b3cd02573$export$70a5d6cdc959e89c = `qaDDfW_CardStatus_statusTrackerContainer`;




var $c7723983a8e93402$exports = {};

$parcel$export($c7723983a8e93402$exports, "icon", () => $c7723983a8e93402$export$1ca1ec8b29a4ce27, (v) => $c7723983a8e93402$export$1ca1ec8b29a4ce27 = v);
$parcel$export($c7723983a8e93402$exports, "iconContainer", () => $c7723983a8e93402$export$acf4eaf431084f78, (v) => $c7723983a8e93402$export$acf4eaf431084f78 = v);
$parcel$export($c7723983a8e93402$exports, "iconCurrent", () => $c7723983a8e93402$export$6a5f1703c8ba8b15, (v) => $c7723983a8e93402$export$6a5f1703c8ba8b15 = v);
$parcel$export($c7723983a8e93402$exports, "iconEmphasis", () => $c7723983a8e93402$export$9935ad3322fea53, (v) => $c7723983a8e93402$export$9935ad3322fea53 = v);
$parcel$export($c7723983a8e93402$exports, "label", () => $c7723983a8e93402$export$1237798dc640739a, (v) => $c7723983a8e93402$export$1237798dc640739a = v);
$parcel$export($c7723983a8e93402$exports, "labelCompleted", () => $c7723983a8e93402$export$9ac6f9b4edc3f60a, (v) => $c7723983a8e93402$export$9ac6f9b4edc3f60a = v);
$parcel$export($c7723983a8e93402$exports, "labelContainer", () => $c7723983a8e93402$export$a1b12bea82a67f51, (v) => $c7723983a8e93402$export$a1b12bea82a67f51 = v);
$parcel$export($c7723983a8e93402$exports, "progressBar", () => $c7723983a8e93402$export$9d1298853f0e77f7, (v) => $c7723983a8e93402$export$9d1298853f0e77f7 = v);
$parcel$export($c7723983a8e93402$exports, "progressBarCompleted", () => $c7723983a8e93402$export$dafac656802d4b04, (v) => $c7723983a8e93402$export$dafac656802d4b04 = v);
$parcel$export($c7723983a8e93402$exports, "progressContainer", () => $c7723983a8e93402$export$2612087cf48ded35, (v) => $c7723983a8e93402$export$2612087cf48ded35 = v);
$parcel$export($c7723983a8e93402$exports, "progressSegment", () => $c7723983a8e93402$export$2f1a7971962a5dcd, (v) => $c7723983a8e93402$export$2f1a7971962a5dcd = v);
var $c7723983a8e93402$export$1ca1ec8b29a4ce27;
var $c7723983a8e93402$export$acf4eaf431084f78;
var $c7723983a8e93402$export$6a5f1703c8ba8b15;
var $c7723983a8e93402$export$9935ad3322fea53;
var $c7723983a8e93402$export$1237798dc640739a;
var $c7723983a8e93402$export$9ac6f9b4edc3f60a;
var $c7723983a8e93402$export$a1b12bea82a67f51;
var $c7723983a8e93402$export$9d1298853f0e77f7;
var $c7723983a8e93402$export$dafac656802d4b04;
var $c7723983a8e93402$export$2612087cf48ded35;
var $c7723983a8e93402$export$2f1a7971962a5dcd;
$c7723983a8e93402$export$1ca1ec8b29a4ce27 = `kIK7lG_StatusTracker_icon`;
$c7723983a8e93402$export$acf4eaf431084f78 = `kIK7lG_StatusTracker_iconContainer`;
$c7723983a8e93402$export$6a5f1703c8ba8b15 = `kIK7lG_StatusTracker_iconCurrent`;
$c7723983a8e93402$export$9935ad3322fea53 = `kIK7lG_StatusTracker_iconEmphasis`;
$c7723983a8e93402$export$1237798dc640739a = `kIK7lG_StatusTracker_label`;
$c7723983a8e93402$export$9ac6f9b4edc3f60a = `kIK7lG_StatusTracker_labelCompleted`;
$c7723983a8e93402$export$a1b12bea82a67f51 = `kIK7lG_StatusTracker_labelContainer`;
$c7723983a8e93402$export$9d1298853f0e77f7 = `kIK7lG_StatusTracker_progressBar`;
$c7723983a8e93402$export$dafac656802d4b04 = `kIK7lG_StatusTracker_progressBarCompleted`;
$c7723983a8e93402$export$2612087cf48ded35 = `kIK7lG_StatusTracker_progressContainer`;
$c7723983a8e93402$export$2f1a7971962a5dcd = `kIK7lG_StatusTracker_progressSegment`;


function $cd1f284c3beac8a4$export$4232ddc329592180({ currentStepIndex: currentStepIndex, steps: steps }) {
    const generateIconProgressSegments = (index, currentStepIndex)=>{
        const progressBarStyles = currentStepIndex >= index ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).progressBar, (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).progressBarCompleted) : (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).progressBar;
        const iconStyles = currentStepIndex >= index ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).icon, (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).iconCurrent) : (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).icon;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).progressSegment,
            children: [
                index !== 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: progressBarStyles
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).iconContainer,
                    children: [
                        index === currentStepIndex ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).iconEmphasis
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: iconStyles
                        })
                    ]
                })
            ]
        }, index);
    };
    const getLabelStyles = (index, currentStepIndex)=>currentStepIndex >= index ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("semibold-20", (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).label, (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).labelCompleted) : (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("semibold-20", (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).label);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).progressContainer,
                children: steps.map((step, index)=>generateIconProgressSegments(index, currentStepIndex))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c7723983a8e93402$exports))).labelContainer,
                children: steps.map((step, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: getLabelStyles(index, currentStepIndex),
                        children: step
                    }, index))
            })
        ]
    });
}





var $bd8ab4d7b3f60bfa$export$f9f3bb5fa67216a9 = /*#__PURE__*/ function(StepIndex) {
    StepIndex[StepIndex["Printing"] = 0] = "Printing";
    StepIndex[StepIndex["Shipping"] = 1] = "Shipping";
    StepIndex[StepIndex["Activatable"] = 2] = "Activatable";
    return StepIndex;
}({});
const $bd8ab4d7b3f60bfa$export$e6c736e769e1d104 = (t)=>(estimatedDeliveryDate)=>[
            {
                title: t("stepPrinting.title"),
                description: t("stepPrinting.description", {
                    replace: {
                        estimatedDeliveryDate: estimatedDeliveryDate
                    }
                }),
                trackerLabels: {
                    trackerLabelCurrent: t("stepPrinting.stepText"),
                    trackerLabelCompleted: t("stepPrinting.completedStepText")
                }
            },
            {
                title: t("stepOnTheWay.title"),
                description: t("stepOnTheWay.description", {
                    replace: {
                        estimatedDeliveryDate: estimatedDeliveryDate
                    }
                }),
                trackerLabels: {
                    trackerLabelCurrent: t("stepOnTheWay.stepText")
                }
            },
            {
                title: t("stepActivate.title"),
                description: t("stepActivate.description"),
                trackerLabels: {
                    trackerLabelCurrent: t("stepActivate.stepText")
                }
            }
        ];
const $bd8ab4d7b3f60bfa$export$47fdefecd3e5b7fc = (steps, currentStepIndex)=>steps.map((step, index)=>{
        if (currentStepIndex === index) return step.trackerLabels.trackerLabelCurrent;
        // Default to current step label if completed label does not exist
        return step.trackerLabels.trackerLabelCompleted || step.trackerLabels.trackerLabelCurrent;
    });
const $bd8ab4d7b3f60bfa$export$6da507a69b4a760 = (fulfillmentShippingStatus)=>{
    // NOTE(cvu): Staging does not have ShippingStatus. This is here temporarily
    // so staging doesn't break.
    // TODO(cvu): Remove this when we have shipping status
    if (!fulfillmentShippingStatus) return 0;
    const shippingStatus = (0, $d272bac0a1712861$export$b2a48b6a70d75edb).FulfillmentStatus;
    if (fulfillmentShippingStatus === shippingStatus.FULFILLMENT_STATUS_PROCESSING) return 0;
    if (fulfillmentShippingStatus === shippingStatus.FULFILLMENT_STATUS_SHIPPED) return 1;
    // TODO(cvu): add condition of after end number of dates have passed or some activatable state check condition
    if (fulfillmentShippingStatus === shippingStatus.FULFILLMENT_STATUS_DELIVERED) return 2;
    throw new Error("Unknown card fulfillment shipping status");
};
const $bd8ab4d7b3f60bfa$export$875e999ecf0156c7 = (t)=>(card)=>{
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(card, "Card is undefined/null");
        const { expirationData: expirationData, fulfillment: fulfillment, fullPan: fullPan, securityCode: securityCode } = card;
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(fullPan, "Missing full pan");
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(expirationData, "Missing expiration data");
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(securityCode, "Missing security code");
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(fulfillment, "Missing fulfillment");
        const { address: address, status: status } = fulfillment;
        (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(address, "Missing address");
        const trackerStepIndex = $bd8ab4d7b3f60bfa$export$6da507a69b4a760(status);
        // TODO(cvu): calculate this somewhere
        const estimatedDeliveryDate = "ESTIMATE_DATE";
        const steps = $bd8ab4d7b3f60bfa$export$e6c736e769e1d104(t)(estimatedDeliveryDate);
        const step = steps[trackerStepIndex];
        return {
            cardPreview: {
                businessName: (0, $1f03a6bc7d91b109$export$af0ed80290d14473)(card),
                cardholder: (0, $1f03a6bc7d91b109$export$f0d76c98e43e3f03)(card),
                cvc: (0, $1f03a6bc7d91b109$export$7f1de93407df59b0)(card),
                expirationDate: (0, $1f03a6bc7d91b109$export$1bbc5be1c1af00a7)(card),
                fullPan: (0, $1f03a6bc7d91b109$export$eb37d3dae2bf604a)(card),
                signatureDataUri: (0, $1f03a6bc7d91b109$export$461358cf94db3eb1)()
            },
            address: address,
            description: step.description,
            title: step.title,
            trackerLabels: $bd8ab4d7b3f60bfa$export$47fdefecd3e5b7fc(steps, trackerStepIndex),
            trackerStepIndex: trackerStepIndex
        };
    };


const $098dac6bfd59e01c$export$9ab766ce7f4c1f3c = (address)=>{
    const { addressLine1: addressLine1, addressLine2: addressLine2, locality: locality, administrativeDistrictLevel1: administrativeDistrictLevel1, postalCode: postalCode } = address;
    const lineOne = addressLine2 ? `${addressLine1}, ${addressLine2}` : addressLine1;
    const lineTwo = `${locality}, ${administrativeDistrictLevel1} ${postalCode}`;
    return [
        lineOne,
        lineTwo
    ];
};




parcelRequire("acw62");
const $6d4efe3506892de5$var$SvgActionEyeSlash = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 18",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#7B61FF",
                fillRule: "evenodd",
                d: "M14.548 14.96h.002l2.75 2.75 1.41-1.41-2.4-2.4c1.5-1.12 2.75-2.63 3.6-4.47.12-.27.12-.58 0-.84C18.03 4.52 14.23 2 10 2c-1.61 0-3.15.37-4.55 1.04L2.71.29 1.294 1.706l10.724 10.725.002-.001.99.99h-.002zM9.49 7.07l2.44 2.44c.04-.16.07-.33.07-.51 0-1.1-.9-2-2-2-.18 0-.35.03-.51.07m3.94 3.95 1.43 1.43A9.6 9.6 0 0 0 17.89 9c-1.61-3.1-4.6-5-7.89-5-1.05 0-2.06.21-3.01.58l.99.99C8.57 5.22 9.26 5 10 5c2.21 0 4 1.79 4 4 0 .74-.21 1.43-.57 2.02",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#7B61FF",
                d: "M9.751 12.992 6.008 9.25a4 4 0 0 0 3.743 3.743"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#7B61FF",
                d: "M3.617 6.858A9.6 9.6 0 0 0 2.11 9c1.61 3.1 4.6 5 7.89 5q.366 0 .725-.033l1.739 1.738c-.795.193-1.62.295-2.464.295-4.23 0-8.03-2.52-9.91-6.58-.12-.26-.12-.57 0-.84A11.8 11.8 0 0 1 2.2 5.441z"
            })
        ]
    });
var $6d4efe3506892de5$export$2e2bcd8739ae039 = $6d4efe3506892de5$var$SvgActionEyeSlash;




var $b8438 = parcelRequire("b8438");
function $62342eb4086d381f$export$490c7ce941281ba8({ cardManagementService: cardManagementService, externalBizbankService: externalBizbankService }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-status");
    const { cardToken: cardToken } = (0, $3e8179397014bb35$export$99eaa27ddbbb95ef)();
    const windowDimensions = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    const [card, setCard] = (0, $acw62.useState)((0, $d272bac0a1712861$export$60332b2344f7fe41).create());
    const [cardCustomization, setCardCustomization] = (0, $acw62.useState)(null);
    const [cardStatusState, setCardStatusState] = (0, $acw62.useState)(null);
    const [showCardDetails, setShowCardDetails] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!cardToken) return;
        try {
            (async ()=>{
                const retrieveCardResponse = await cardManagementService.retrieveCard((0, $d272bac0a1712861$export$8f1da4e33ad24fb3).create({
                    cardToken: cardToken,
                    fieldMask: (0, $1f03a6bc7d91b109$export$8a4b2f4654e557c3)
                }));
                const card = retrieveCardResponse.card;
                setCardStatusState((0, $bd8ab4d7b3f60bfa$export$875e999ecf0156c7)(t)(card));
                if (card) {
                    setCard(card);
                    const customizationToken = card.fulfillment?.cardCustomization?.id;
                    if (customizationToken) {
                        const res = await externalBizbankService.getCardCustomization((0, $3f73c216104868a6$export$1a963d2655841b69).create({
                            customizationToken: customizationToken
                        }));
                        setCardCustomization(res.cardCustomization ?? null);
                    }
                }
            })();
        } catch (error) {
            (0, $b8438.captureException)(error, {
                contexts: {
                    info: {
                        message: "Fetching Card or CardCustomization failed.",
                        cardToken: cardToken
                    }
                }
            });
        }
    }, [
        cardToken
    ]);
    const breadcrumb = {
        title: t("routes.overview", {
            ns: "site"
        }),
        link: {
            to: "/"
        }
    };
    const headerElement = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0cb7d9ae27028ab3$export$53f1cd6809577fc5), {
        breadcrumb: breadcrumb,
        title: (0, $1f03a6bc7d91b109$export$af0ed80290d14473)(card)
    });
    const getTrackerContents = (isMobile, cardStatusState)=>{
        if (cardStatusState === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        const onShowCardDetailsClick = ()=>{
            setShowCardDetails(!showCardDetails);
        };
        const showDetailsButton = (showCardDetails)=>{
            if (showCardDetails) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                className: (0, $a81baa7b3cd02573$export$484fa93d7befe621),
                onClick: onShowCardDetailsClick,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        slot: "icon",
                        className: (0, $a81baa7b3cd02573$export$acf4eaf431084f78),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d4efe3506892de5$export$2e2bcd8739ae039), {})
                    }),
                    t("hideCardNumberButtonText")
                ]
            });
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                className: (0, $a81baa7b3cd02573$export$484fa93d7befe621),
                onClick: onShowCardDetailsClick,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        slot: "icon",
                        className: (0, $a81baa7b3cd02573$export$acf4eaf431084f78),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3de42ffd7affe746$export$2e2bcd8739ae039), {})
                    }),
                    t("showCardNumberButtonText")
                ]
            });
        };
        const [formattedLine1, formattedLine2] = (0, $098dac6bfd59e01c$export$9ab766ce7f4c1f3c)(cardStatusState.address);
        const { title: title, description: description, trackerLabels: trackerLabels, trackerStepIndex: trackerStepIndex, cardPreview: cardPreview } = cardStatusState;
        const contents = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $a81baa7b3cd02573$export$70a5d6cdc959e89c),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    children: title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "semibold-30",
                    children: description
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: formattedLine1
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: formattedLine2
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd1f284c3beac8a4$export$4232ddc329592180), {
                    steps: trackerLabels,
                    currentStepIndex: trackerStepIndex
                })
            ]
        });
        if (isMobile) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d559914ba3bc587b$export$115f017852a4bb7c), {
                    ...cardPreview,
                    showCardDetails: showCardDetails
                }),
                showDetailsButton(showCardDetails),
                contents
            ]
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $034af6c0eb5c10e4$export$7ffad9c53e8a82d9), {
            card: card,
            cardCustomization: cardCustomization || undefined,
            previewSecondaryContent: showDetailsButton(showCardDetails),
            showCardDetails: showCardDetails,
            children: contents
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10b264b7e14b606b$export$6955bcca4cd3539f), {
        header: headerElement,
        children: getTrackerContents(windowDimensions.isMobile, cardStatusState)
    });
}


const $b9b8f95d28dd1cc4$export$cc5a44eb2bffd45a = (0, $7c5a3dd94b85a123$export$72f8d6ff1467b5f4)((0, $62342eb4086d381f$export$490c7ce941281ba8), {
    cardManagementService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).CARD_MANAGEMENT_SERVICE,
    externalBizbankService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).EXTERNAL_BIZBANK_SERVICE
});





var $b8438 = parcelRequire("b8438");

var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $72623ab6bcb0a33b$exports = {};
'use strict';
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;



var $acw62 = parcelRequire("acw62");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $480634a75d8ae79a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


const $da278c11bbb20b21$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function $da278c11bbb20b21$export$a87138b73900f5b(version) {
    const major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
const $da278c11bbb20b21$export$6ef4c0367e27f2d5 = 'unknown';
const $da278c11bbb20b21$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
function $da278c11bbb20b21$var$setCause(error, cause) {
    const seenErrors = new WeakMap();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.set(error, true);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $da278c11bbb20b21$export$e926676385687eaf extends $acw62.Component {
    constructor(props){
        super(props);
        $da278c11bbb20b21$export$e926676385687eaf.prototype.__init.call(this);
        this.state = $da278c11bbb20b21$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $b8438.getClient)();
        if (client && client.on && props.showDialog) {
            this._openFallbackReportDialog = false;
            client.on('afterSendEvent', (event)=>{
                if (!event.type && event.event_id === this._lastEventId) // eslint-disable-next-line deprecation/deprecation
                (0, $4c87801c815e53f1$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, { componentStack: componentStack }) {
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $b8438.withScope)((scope)=>{
            // If on React version >= 17, create stack trace from componentStack param and links
            // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
            // Linking errors requires the `LinkedErrors` integration be enabled.
            // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
            //
            // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
            // with non-error objects. This is why we need to check if the error is an error-like object.
            // See: https://github.com/getsentry/sentry-javascript/issues/6167
            if ($da278c11bbb20b21$export$a87138b73900f5b($acw62.version) && (0, $2zW56.isError)(error)) {
                const errorBoundaryError = new Error(error.message);
                errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
                errorBoundaryError.stack = componentStack;
                // Using the `LinkedErrors` integration to link the errors together.
                $da278c11bbb20b21$var$setCause(error, errorBoundaryError);
            }
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const eventId = (0, $b8438.captureException)(error, {
                captureContext: {
                    contexts: {
                        react: {
                            componentStack: componentStack
                        }
                    }
                },
                // If users provide a fallback component we can assume they are handling the error.
                // Therefore, we set the mechanism depending on the presence of the fallback prop.
                mechanism: {
                    handled: !!this.props.fallback
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $4c87801c815e53f1$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset } = this.props;
            const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($da278c11bbb20b21$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === 'function') element = fallback({
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($acw62.isValidElement(element)) return element;
            if (fallback) (0, $480634a75d8ae79a$export$16a28057038b10ef) && (0, $4g0Ct.logger).warn('fallback did not produce a valid ReactElement');
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === 'function') return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $da278c11bbb20b21$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $da278c11bbb20b21$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$acw62.createElement($da278c11bbb20b21$export$e926676385687eaf, {
            ...errorBoundaryOptions,
            __self: this,
            __source: {
                fileName: $da278c11bbb20b21$var$_jsxFileName,
                lineNumber: 240
            }
        }, $acw62.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: $da278c11bbb20b21$var$_jsxFileName,
                lineNumber: 241
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(Wrapped, WrappedComponent);
    return Wrapped;
}






var $78e63bfb11f97634$export$5ea928c9faf85bd3;
$78e63bfb11f97634$export$5ea928c9faf85bd3 = `-K8hva_Error_alert`;


function $577020a59df1a3ff$export$edf27be85e5f6da0() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("site", {
        keyPrefix: "error.page"
    });
    const navigate = (0, $3e8179397014bb35$export$9770f232ac06a008)();
    const onButtonClick = ()=>{
        // refresh page
        navigate(0);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: $78e63bfb11f97634$export$5ea928c9faf85bd3,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06f269f6a0cbba3c$export$caec2af78bcc877f), {
            buttonText: t("buttonText"),
            color: (0, $06f269f6a0cbba3c$export$2ddc1882e756bb44).Grey,
            description: t("description"),
            icon: (0, $06f269f6a0cbba3c$export$4a143c8822a09fb4).X,
            title: t("title"),
            onButtonClick: onButtonClick
        })
    });
}





parcelRequire("acw62");
const $07558121fd9459b9$var$SvgSquareLogo = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#000",
                fillOpacity: 0.9,
                d: "M19.989 0H4.011A4.01 4.01 0 0 0 0 4.01v15.978A4.01 4.01 0 0 0 4.011 24h15.978A4.01 4.01 0 0 0 24 19.988V4.01A4.01 4.01 0 0 0 19.989 0m-.353 18.371a1.266 1.266 0 0 1-1.265 1.266H5.631a1.266 1.266 0 0 1-1.265-1.266V5.63a1.265 1.265 0 0 1 1.265-1.266h12.74a1.266 1.266 0 0 1 1.265 1.266z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#000",
                fillOpacity: 0.9,
                d: "M9.45 15.256a.727.727 0 0 1-.726-.729V9.441a.726.726 0 0 1 .726-.73h5.1a.727.727 0 0 1 .726.73v5.086a.725.725 0 0 1-.726.729z"
            })
        ]
    });
var $07558121fd9459b9$export$2e2bcd8739ae039 = $07558121fd9459b9$var$SvgSquareLogo;



parcelRequire("acw62");
const $807caacbf22c63a9$var$SvgQuestionMark = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#000",
            fillOpacity: 0.9,
            fillRule: "evenodd",
            d: "M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7m0-2a1.25 1.25 0 1 0 0-2.5A1.25 1.25 0 0 0 9 14M6 6.75C6 5.23 7.35 4 9 4s3 1.23 3 2.75c0 1.11-.66 1.77-1.19 2.29-.53.53-.81.83-.81 1.46H8c0-1.48.8-2.28 1.388-2.868L9.4 7.62c.44-.43.6-.61.6-.87C10 6.34 9.54 6 9 6s-1 .34-1 .75z",
            clipRule: "evenodd"
        })
    });
var $807caacbf22c63a9$export$2e2bcd8739ae039 = $807caacbf22c63a9$var$SvgQuestionMark;






var $c0ba15911c7a95e9$export$d0f464870998e995;
$c0ba15911c7a95e9$export$d0f464870998e995 = `vZph2q_AccountDropdown_accountName`;


function $86cb485473df5872$export$f82a7981da43931a({ accountName: accountName, options: options }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$55e40bf6ba98f173), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: "semibold-20",
                slot: "trigger",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: $c0ba15911c7a95e9$export$d0f464870998e995,
                    children: accountName
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$a00ed319fc43be46), {
                slot: "popover",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$5f38cc4b3e71c577), {
                    transient: true,
                    children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$14eeaa98ef1abeb2), {
                            size: "small",
                            onClick: option.callback,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                slot: "label",
                                children: option.name
                            })
                        }, option.name))
                })
            })
        ]
    });
}


var $8fda1502fcc70b61$exports = {};

$8fda1502fcc70b61$exports["container"] = `KsVgLq_AppNavBar_container`;
$8fda1502fcc70b61$exports["help"] = `KsVgLq_AppNavBar_help`;
$8fda1502fcc70b61$exports["icon"] = `KsVgLq_AppNavBar_icon`;
$8fda1502fcc70b61$exports["navContent"] = `KsVgLq_AppNavBar_navContent`;
$8fda1502fcc70b61$exports["navTopOffset"] = `KsVgLq_AppNavBar_navTopOffset`;
$8fda1502fcc70b61$exports["right"] = `KsVgLq_AppNavBar_right`;
for(let key in $a3b0f2fdf3961f6f$exports)if (key in $8fda1502fcc70b61$exports) $8fda1502fcc70b61$exports[key] += ' ' + $a3b0f2fdf3961f6f$exports[key];
else $8fda1502fcc70b61$exports[key] = $a3b0f2fdf3961f6f$exports[key];


function $f9e218b81ec54d12$export$ad89b3f114c71ca({ user: user }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("site");
    const accountDropdownOptions = [
        {
            name: t("navigation.accountDropdownOptions.personalSettings"),
            callback: ()=>{
                window.location.href = `${0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039}help`;
            }
        },
        {
            name: t("navigation.accountDropdownOptions.signOut"),
            callback: ()=>{
                window.location.href = `${0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039}logout`;
            }
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: $8fda1502fcc70b61$exports.navTopOffset,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $8fda1502fcc70b61$exports.container,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: $8fda1502fcc70b61$exports.navContent,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "semibold-20",
                            children: t("title")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07558121fd9459b9$export$2e2bcd8739ae039), {
                            className: $8fda1502fcc70b61$exports.icon
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: $8fda1502fcc70b61$exports.right,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    className: $8fda1502fcc70b61$exports.help,
                                    href: `${(0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039)}help`,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $807caacbf22c63a9$export$2e2bcd8739ae039), {
                                        className: $8fda1502fcc70b61$exports.icon
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $86cb485473df5872$export$f82a7981da43931a), {
                                    accountName: (0, $f52070b5f7ea08cf$export$155800cbebf9d04f)(user),
                                    options: accountDropdownOptions
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}




function $becdf5d7bd69726e$export$be92b6f5f03c0fe9() {
    const [user] = (0, $6a9ee46bb299cc77$export$23bbbc4533528f03)();
    const windowDimensions = (0, $fb48b27410e45132$export$f715c0e61b2c1a36)();
    const navBar = windowDimensions.isMobile ? null : user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e218b81ec54d12$export$ad89b3f114c71ca), {
        user: user
    }) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            navBar,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da278c11bbb20b21$export$e926676385687eaf), {
                fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $577020a59df1a3ff$export$edf27be85e5f6da0), {}),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e8179397014bb35$export$910ae8079b2c2852), {})
            })
        ]
    });
}






const $eb322dd52f4d040c$export$fcd084e6273b1578 = (Component, propsToParam)=>// eslint-disable-next-line react/display-name
    (props)=>{
        const params = (0, $3e8179397014bb35$export$99eaa27ddbbb95ef)();
        const paramsMappedToProps = Object.entries(propsToParam).reduce((acc, [propName, paramName])=>{
            const paramString = paramName;
            const value = params[paramString];
            if (value == null) throw new Error(`param '${paramString}' does not exist`);
            return {
                ...acc,
                [propName]: value
            };
        }, {});
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ...paramsMappedToProps
        });
    };




var $b8438 = parcelRequire("b8438");

var $acw62 = parcelRequire("acw62");











/**
 * Set pin workflow to set/reset pin.
 */ const $41708348d2f204d8$var$PIN_LENGTH = 4;
var $41708348d2f204d8$export$a98515d67472a41f = /*#__PURE__*/ function(Screen) {
    Screen["SetPin"] = "SCREEN_SET_PIN";
    Screen["ConfirmPin"] = "SCREEN_CONFIRM_PIN";
    return Screen;
}({});
var $41708348d2f204d8$export$edf27be85e5f6da0 = /*#__PURE__*/ function(Error) {
    Error["WeakPin"] = "ERROR_WEAK_PIN";
    Error["InvalidPinMatch"] = "ERROR_INVALID_PIN_MATCH";
    Error["GenericError"] = "ERROR_GENERIC";
    return Error;
}({});
var $41708348d2f204d8$export$54d4c18dc78a26d4 = /*#__PURE__*/ function(ValueError) {
    ValueError["InvalidLength"] = "VALUE_ERROR_INVALID_LENGTH";
    return ValueError;
}({});
const $41708348d2f204d8$export$36d128238e6b60f5 = {
    cardToken: "",
    confirmPin: "",
    confirmPinError: [],
    error: [],
    loading: false,
    pin: "",
    pinError: []
};
const $41708348d2f204d8$export$e6a0daad8304de = (overrides = {})=>({
        ...$41708348d2f204d8$export$36d128238e6b60f5,
        ...overrides
    });
var $41708348d2f204d8$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["Done"] = "SET_PIN_DONE";
    ActionType["Initialize"] = "SET_PIN_INITIALIZE";
    ActionType["SetPin"] = "SET_PIN_SET_PIN";
    ActionType["SetPinReceived"] = "SET_PIN_RECEIVED";
    ActionType["SetPinRejected"] = "SET_PIN_REJECTED";
    ActionType["UserChangeConfirmPin"] = "SET_PIN_USER_CHANGE_CONFIRM_PIN";
    ActionType["UserChangePin"] = "SET_PIN_USER_CHANGE_PIN";
    return ActionType;
}({});
const $41708348d2f204d8$export$8789045e6aca717c = ()=>({
        type: "SET_PIN_DONE"
    });
const $41708348d2f204d8$export$c81c36414a1e3192 = (cardToken)=>({
        type: "SET_PIN_INITIALIZE",
        cardToken: cardToken
    });
const $41708348d2f204d8$export$b128ee3182fea17d = ()=>({
        type: "SET_PIN_SET_PIN"
    });
const $41708348d2f204d8$export$18ce6532235c33d5 = (response)=>({
        type: "SET_PIN_RECEIVED",
        response: response
    });
const $41708348d2f204d8$export$b482c06046986f66 = (error)=>({
        type: "SET_PIN_REJECTED",
        error: error
    });
const $41708348d2f204d8$export$7fccafb1bae4775a = (confirmPin)=>({
        type: "SET_PIN_USER_CHANGE_CONFIRM_PIN",
        confirmPin: confirmPin
    });
const $41708348d2f204d8$export$6e1c9a50e77df720 = (pin)=>({
        type: "SET_PIN_USER_CHANGE_PIN",
        pin: pin
    });
function $41708348d2f204d8$var$handleSetPin(context, state) {
    const { cardToken: cardToken, pin: pin, confirmPin: confirmPin } = state;
    const pinError = [];
    const confirmPinError = [];
    const error = [];
    if (pin.length !== $41708348d2f204d8$var$PIN_LENGTH) pinError.push("VALUE_ERROR_INVALID_LENGTH");
    if (confirmPin.length !== $41708348d2f204d8$var$PIN_LENGTH) confirmPinError.push("VALUE_ERROR_INVALID_LENGTH");
    if (pin.length === $41708348d2f204d8$var$PIN_LENGTH && confirmPin.length === $41708348d2f204d8$var$PIN_LENGTH && pin !== confirmPin) error.push("ERROR_INVALID_PIN_MATCH");
    const hasError = confirmPinError.length || error.length || pinError.length;
    const work = ()=>{
        if (hasError) return null;
        return context.setPin((0, $d272bac0a1712861$export$6129867d2a9d1edf).create({
            cardToken: cardToken,
            pin: pin
        })).then($41708348d2f204d8$export$18ce6532235c33d5, $41708348d2f204d8$export$b482c06046986f66);
    };
    return [
        {
            ...state,
            confirmPinError: confirmPinError,
            error: error,
            loading: !hasError,
            pinError: pinError
        },
        work
    ];
}
function $41708348d2f204d8$var$handleSetPinReceived(_context, state, action) {
    const { errors: errors } = action.response;
    if (errors.length === 0) return [
        {
            ...state,
            loading: false
        },
        $41708348d2f204d8$export$8789045e6aca717c
    ];
    // Client will handle one error at a time, the first one.
    switch(errors[0]){
        case (0, $d272bac0a1712861$export$7aecf5bab678a854).SetPinError.SET_PIN_ERROR_INVALID_CARD_TOKEN:
            return [
                {
                    ...state,
                    confirmPinError: [
                        "VALUE_ERROR_INVALID_LENGTH"
                    ],
                    pinError: [
                        "VALUE_ERROR_INVALID_LENGTH"
                    ],
                    loading: false
                },
                null
            ];
        case (0, $d272bac0a1712861$export$7aecf5bab678a854).SetPinError.SET_PIN_ERROR_WEAK_PIN:
            return [
                {
                    ...state,
                    error: [
                        ...state.error,
                        "ERROR_WEAK_PIN"
                    ],
                    loading: false
                },
                null
            ];
        case (0, $d272bac0a1712861$export$7aecf5bab678a854).SetPinError.SET_PIN_ERROR_UNAUTHORIZED:
        case (0, $d272bac0a1712861$export$7aecf5bab678a854).SetPinError.SET_PIN_ERROR_DO_NOT_USE:
            return [
                {
                    ...state,
                    error: [
                        ...state.error,
                        "ERROR_GENERIC"
                    ],
                    loading: false
                },
                null
            ];
    }
}
function $41708348d2f204d8$var$handleSetPinRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(`SetPin error - ${error}`);
    return [
        {
            ...state,
            error: [
                ...state.error,
                "ERROR_GENERIC"
            ],
            loading: false
        },
        null
    ];
}
function $41708348d2f204d8$var$handleUserChangeConfirmPin(state, action) {
    const { confirmPin: confirmPin } = action;
    return [
        {
            ...state,
            confirmPin: confirmPin,
            confirmPinError: []
        },
        null
    ];
}
function $41708348d2f204d8$var$handleUserChangePin(state, action) {
    const { pin: pin } = action;
    return [
        {
            ...state,
            pin: pin,
            pinError: []
        },
        null
    ];
}
const $41708348d2f204d8$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "SET_PIN_DONE":
                // noop action to watch for done
                return [
                    state,
                    null
                ];
            case "SET_PIN_INITIALIZE":
                return [
                    {
                        ...$41708348d2f204d8$export$36d128238e6b60f5,
                        cardToken: action.cardToken
                    },
                    null
                ];
            case "SET_PIN_SET_PIN":
                return $41708348d2f204d8$var$handleSetPin(context, state);
            case "SET_PIN_RECEIVED":
                return $41708348d2f204d8$var$handleSetPinReceived(context, state, action);
            case "SET_PIN_REJECTED":
                return $41708348d2f204d8$var$handleSetPinRejected(context, state, action);
            case "SET_PIN_USER_CHANGE_CONFIRM_PIN":
                return $41708348d2f204d8$var$handleUserChangeConfirmPin(state, action);
            case "SET_PIN_USER_CHANGE_PIN":
                return $41708348d2f204d8$var$handleUserChangePin(state, action);
        }
    };
const $41708348d2f204d8$var$setPin = (seed, context)=>{
    const w = (0, $f244369e42336676$export$2e2bcd8739ae039)($41708348d2f204d8$export$722fbec263ad908a(context), seed);
    return {
        states: w.states,
        updates: w.updates,
        emit: w.emit
    };
};
var $41708348d2f204d8$export$2e2bcd8739ae039 = $41708348d2f204d8$var$setPin;





var $91a4cf0fed9238a4$export$6b43b4121596bf23 = /*#__PURE__*/ function(CardDetailsInputError) {
    CardDetailsInputError["Empty"] = "CARD_DETAIL_INPUT_ERROR_EMPTY";
    return CardDetailsInputError;
}({});
var $91a4cf0fed9238a4$export$8e65f9a47a3365d = /*#__PURE__*/ function(CardDetailsError) {
    CardDetailsError["InvalidCvcExpiryDate"] = "CARD_DETAILS_ERROR_INVALID_CVC_EXPIRY_DATE";
    return CardDetailsError;
}({});
var $91a4cf0fed9238a4$export$73ffda178c022f15 = /*#__PURE__*/ function(CardActivationError) {
    CardActivationError[CardActivationError["None"] = 0] = "None";
    CardActivationError[CardActivationError["Generic"] = 1] = "Generic";
    return CardActivationError;
}({});
var $91a4cf0fed9238a4$export$a98515d67472a41f = /*#__PURE__*/ function(Screen) {
    Screen[Screen["Details"] = 0] = "Details";
    Screen[Screen["Pin"] = 1] = "Pin";
    Screen[Screen["Success"] = 2] = "Success";
    Screen[Screen["Error"] = 3] = "Error";
    return Screen;
}({});
const $91a4cf0fed9238a4$export$36d128238e6b60f5 = {
    cardDetailsValidationErrors: {
        cvc: [],
        expiryDate: [],
        cardDetails: []
    },
    cardToken: "",
    cvcValue: "",
    done: false,
    error: 0,
    expiryDateValue: null,
    isLoading: false,
    modalOpen: false,
    screen: 0,
    setPinState: $41708348d2f204d8$export$e6a0daad8304de()
};
const $91a4cf0fed9238a4$export$e6a0daad8304de = (overrides = {})=>({
        ...$91a4cf0fed9238a4$export$36d128238e6b60f5,
        ...overrides
    });
var $91a4cf0fed9238a4$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["ActivateCardReceived"] = "ACTIVATE_CARD_RECEIVED";
    ActionType["ActivateCardRejected"] = "ACTIVATE_CARD_REJECTED";
    ActionType["Done"] = "Done";
    ActionType["Initialize"] = "INITIALIZE";
    ActionType["NavigateToScreen"] = "NAVIGATE_TO_SCREEN";
    ActionType["SetError"] = "SET_ERROR";
    ActionType["ToggleLoading"] = "TOGGLE_LOADING";
    ActionType["ToggleModal"] = "TOGGLE_MODAL";
    ActionType["UserChangeCvc"] = "USER_CHANGE_CVC";
    ActionType["UserChangeExpiryDate"] = "USER_CHANGE_EXPIRY_DATE";
    ActionType["UserClickNext"] = "USER_CLICK_NEXT";
    return ActionType;
}({});
const $91a4cf0fed9238a4$export$5c8fbc33f44710ab = (response)=>({
        type: "ACTIVATE_CARD_RECEIVED",
        response: response
    });
const $91a4cf0fed9238a4$export$ddaa186bd434f499 = (error)=>({
        type: "ACTIVATE_CARD_REJECTED",
        error: error
    });
const $91a4cf0fed9238a4$export$8789045e6aca717c = ()=>({
        type: "Done"
    });
const $91a4cf0fed9238a4$export$a7b94443be12fd7b = (screen)=>({
        type: "NAVIGATE_TO_SCREEN",
        screen: screen
    });
const $91a4cf0fed9238a4$export$c81c36414a1e3192 = (cardToken)=>({
        type: "INITIALIZE",
        cardToken: cardToken
    });
const $91a4cf0fed9238a4$export$8f12bad0f165bfad = (error)=>({
        type: "SET_ERROR",
        error: error
    });
const $91a4cf0fed9238a4$export$e125175ee6544919 = (value)=>({
        type: "TOGGLE_LOADING",
        value: value
    });
const $91a4cf0fed9238a4$export$2085928ad4455e61 = (value)=>({
        type: "TOGGLE_MODAL",
        value: value
    });
const $91a4cf0fed9238a4$export$6e6290200ceb68b4 = (value)=>({
        type: "USER_CHANGE_CVC",
        value: value
    });
const $91a4cf0fed9238a4$export$b758c0ba8238b576 = (value)=>({
        type: "USER_CHANGE_EXPIRY_DATE",
        value: value
    });
const $91a4cf0fed9238a4$export$69864c1ae20800a8 = ()=>({
        type: "USER_CLICK_NEXT"
    });
// Update
// =============================================================================
function $91a4cf0fed9238a4$var$handleActivateCardReceived(context, state, action) {
    const { error: error } = action.response;
    if (error === (0, $d272bac0a1712861$export$7dde42e884f2d048).ActivateCardError.ACTIVATE_CARD_ERROR_INVALID_CVV_OR_EXPIRATION) {
        const { cardDetailsValidationErrors: cardDetailsValidationErrors } = state;
        return [
            {
                ...state,
                cardDetailsValidationErrors: {
                    ...cardDetailsValidationErrors,
                    cardDetails: [
                        ...cardDetailsValidationErrors.cardDetails,
                        "CARD_DETAILS_ERROR_INVALID_CVC_EXPIRY_DATE"
                    ]
                },
                isLoading: false
            },
            null
        ];
    }
    return context.canUpdatePin ? [
        {
            ...state,
            screen: 1,
            isLoading: false
        },
        ()=>$41708348d2f204d8$export$c81c36414a1e3192(state.cardToken)
    ] : [
        {
            ...state,
            screen: 2,
            isLoading: false
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleActivateCardRejected(context, state, action) {
    const { error: error } = action;
    context.sentry.captureException(error);
    return [
        state,
        ()=>$91a4cf0fed9238a4$export$8f12bad0f165bfad(1)
    ];
}
function $91a4cf0fed9238a4$var$handleInitialize(context, state, action) {
    const { cardToken: cardToken } = action;
    if (cardToken.length === 0) {
        context.sentry.captureException("Card activation: card token is empty string");
        return [
            {
                ...$91a4cf0fed9238a4$export$36d128238e6b60f5,
                modalOpen: true
            },
            ()=>$91a4cf0fed9238a4$export$8f12bad0f165bfad(1)
        ];
    }
    return [
        {
            ...$91a4cf0fed9238a4$export$36d128238e6b60f5,
            cardToken: cardToken,
            modalOpen: true
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleNavigateToScreen(state, action) {
    const { screen: screen } = action;
    return [
        {
            ...state,
            screen: screen
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleSetError(state, action) {
    const { error: error } = action;
    return [
        {
            ...state,
            error: error,
            screen: 3
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleToggleLoading(state, action) {
    const { value: value } = action;
    return [
        {
            ...state,
            isLoading: value
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleToggleModal(context, state, action) {
    const { value: value } = action;
    const nextAction = state.screen === 2 ? $91a4cf0fed9238a4$export$8789045e6aca717c : null;
    return [
        {
            ...state,
            modalOpen: value
        },
        nextAction
    ];
}
function $91a4cf0fed9238a4$var$handleUserChangeCvc(state, action) {
    const { value: value } = action;
    const cardDetailsValidationErrors = {
        ...state.cardDetailsValidationErrors,
        cardDetails: [],
        cvc: []
    };
    return [
        {
            ...state,
            cvcValue: value,
            cardDetailsValidationErrors: cardDetailsValidationErrors
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleUserChangeExpiryDate(state, action) {
    const { value: value } = action;
    const cardDetailsValidationErrors = {
        ...state.cardDetailsValidationErrors,
        cardDetails: [],
        expiryDate: []
    };
    return [
        {
            ...state,
            expiryDateValue: value,
            cardDetailsValidationErrors: cardDetailsValidationErrors
        },
        null
    ];
}
function $91a4cf0fed9238a4$var$handleUserClickNext(context, state) {
    const { screen: screen, cvcValue: cvcValue, expiryDateValue: expiryDateValue } = state;
    switch(screen){
        case 0:
            {
                const expiryDateErrors = expiryDateValue === null ? [
                    "CARD_DETAIL_INPUT_ERROR_EMPTY"
                ] : [];
                const cvcErrors = cvcValue.length === 0 ? [
                    "CARD_DETAIL_INPUT_ERROR_EMPTY"
                ] : [];
                if (expiryDateErrors.length || cvcErrors.length) return [
                    {
                        ...state,
                        cardDetailsValidationErrors: {
                            ...state.cardDetailsValidationErrors,
                            cvc: cvcErrors,
                            expiryDate: expiryDateErrors
                        }
                    },
                    null
                ];
                const { cardToken: cardToken } = state;
                (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(expiryDateValue, "expiryDateValue is null");
                const work = ()=>context.cardManagementService.activateCard((0, $d272bac0a1712861$export$7e4385b3b341704b).create({
                        cardToken: cardToken,
                        cvv: cvcValue,
                        expiration: (0, $63d33be972ac5a3a$export$b707805e12671f51).create({
                            monthOfYear: expiryDateValue.month,
                            year: expiryDateValue.year
                        })
                    })).then($91a4cf0fed9238a4$export$5c8fbc33f44710ab, $91a4cf0fed9238a4$export$ddaa186bd434f499);
                return [
                    {
                        ...state,
                        isLoading: true
                    },
                    work
                ];
            }
        case 1:
            return [
                {
                    ...state,
                    screen: 2
                },
                null
            ];
        case 2:
            return [
                state,
                $91a4cf0fed9238a4$export$8789045e6aca717c
            ];
        case 3:
            return [
                state,
                null
            ];
    }
}
const $91a4cf0fed9238a4$export$722fbec263ad908a = (context)=>(state, action)=>{
        switch(action.type){
            case "ACTIVATE_CARD_RECEIVED":
                return $91a4cf0fed9238a4$var$handleActivateCardReceived(context, state, action);
            case "ACTIVATE_CARD_REJECTED":
                return $91a4cf0fed9238a4$var$handleActivateCardRejected(context, state, action);
            case "Done":
                return [
                    {
                        ...state,
                        done: true,
                        modalOpen: false
                    },
                    null
                ];
            case "INITIALIZE":
                return $91a4cf0fed9238a4$var$handleInitialize(context, state, action);
            case "NAVIGATE_TO_SCREEN":
                return $91a4cf0fed9238a4$var$handleNavigateToScreen(state, action);
            case "SET_ERROR":
                return $91a4cf0fed9238a4$var$handleSetError(state, action);
            case "TOGGLE_LOADING":
                return $91a4cf0fed9238a4$var$handleToggleLoading(state, action);
            case "TOGGLE_MODAL":
                return $91a4cf0fed9238a4$var$handleToggleModal(context, state, action);
            case "USER_CHANGE_CVC":
                return $91a4cf0fed9238a4$var$handleUserChangeCvc(state, action);
            case "USER_CHANGE_EXPIRY_DATE":
                return $91a4cf0fed9238a4$var$handleUserChangeExpiryDate(state, action);
            case "USER_CLICK_NEXT":
                return $91a4cf0fed9238a4$var$handleUserClickNext(context, state);
            case $41708348d2f204d8$export$e4a712fff93fb00f.Done:
            case $41708348d2f204d8$export$e4a712fff93fb00f.Initialize:
            case $41708348d2f204d8$export$e4a712fff93fb00f.SetPin:
            case $41708348d2f204d8$export$e4a712fff93fb00f.SetPinReceived:
            case $41708348d2f204d8$export$e4a712fff93fb00f.SetPinRejected:
            case $41708348d2f204d8$export$e4a712fff93fb00f.UserChangeConfirmPin:
            case $41708348d2f204d8$export$e4a712fff93fb00f.UserChangePin:
                {
                    const update = $41708348d2f204d8$export$722fbec263ad908a({
                        sentry: context.sentry,
                        setPin: context.setPin,
                        uuid: context.uuid
                    });
                    const [nextState, nextActions] = update(state.setPinState, action);
                    return [
                        {
                            ...state,
                            setPinState: nextState
                        },
                        action.type === $41708348d2f204d8$export$e4a712fff93fb00f.Done ? $91a4cf0fed9238a4$export$69864c1ae20800a8 : nextActions
                    ];
                }
        }
    };
const $91a4cf0fed9238a4$var$debitCardActivation = (seed, context)=>{
    const w = (0, $f244369e42336676$export$2e2bcd8739ae039)($91a4cf0fed9238a4$export$722fbec263ad908a(context), seed);
    return {
        states: w.states,
        updates: w.updates,
        emit: w.emit
    };
};
var $91a4cf0fed9238a4$export$2e2bcd8739ae039 = $91a4cf0fed9238a4$var$debitCardActivation;












var $9ba2892e041037f1$export$2ba01fb71ed41cb6;
var $9ba2892e041037f1$export$2daf5cbeed728edf;
var $9ba2892e041037f1$export$d3baea09c0a68887;
var $9ba2892e041037f1$export$f22da7240b7add18;
$9ba2892e041037f1$export$2ba01fb71ed41cb6 = `FTqktG_CardActivationEnterDetails_button`;
$9ba2892e041037f1$export$2daf5cbeed728edf = `FTqktG_CardActivationEnterDetails_inputFields`;
$9ba2892e041037f1$export$d3baea09c0a68887 = `FTqktG_CardActivationEnterDetails_inputFieldsContainer`;
$9ba2892e041037f1$export$f22da7240b7add18 = `FTqktG_CardActivationEnterDetails_main`;


function $272930093305839e$export$f2c5c7ab1f242baa({ cardDetailsError: cardDetailsError, cvc: cvc, cvcError: cvcError, expiryDate: expiryDate, expiryDateError: expiryDateError, loading: loading = false, onCvcChange: onCvcChange, onExpiryDateChange: onExpiryDateChange, onNextClick: onNextClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-activation", {
        keyPrefix: "enterDetails"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$95abf1952846aff4), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: t("title")
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: $9ba2892e041037f1$export$f22da7240b7add18,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "paragraph-30",
                        children: t("description")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d1bfdd6e8737fe3$export$bf9d3c0d17a2f99e), {
                        className: $9ba2892e041037f1$export$d3baea09c0a68887,
                        invalid: cardDetailsError.length > 0,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: $9ba2892e041037f1$export$2daf5cbeed728edf,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                                        error: expiryDateError,
                                        formatter: new (0, $58cb02b9641cce25$exports.ExpiryDateFormatter)(),
                                        label: t("inputLabelExpiryDate"),
                                        name: t("inputLabelExpiryDate"),
                                        value: expiryDate || undefined,
                                        onTextChange: onExpiryDateChange
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                                        error: cvcError,
                                        label: t("inputLabelCVC"),
                                        maxlength: 4,
                                        name: t("inputLabelCVC"),
                                        value: cvc,
                                        onTextChange: onCvcChange
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                slot: "error",
                                children: cardDetailsError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                        className: $9ba2892e041037f1$export$2ba01fb71ed41cb6,
                        rank: "primary",
                        isLoading: loading,
                        onClick: onNextClick,
                        children: t("buttonText")
                    })
                ]
            })
        ]
    });
}


const $5defc9b8dec84daf$var$getCardDetailsErrorText = (t)=>(errors)=>{
        for(let i = 0; i < errors.length; i++){
            const error = errors[i];
            switch(error){
                case (0, $91a4cf0fed9238a4$export$8e65f9a47a3365d).InvalidCvcExpiryDate:
                    return t("errors.cardDetailsDoesNotMatch");
            }
        }
        return "";
    };
const $5defc9b8dec84daf$var$getCvcErrorText = (t)=>(errors)=>{
        for(let i = 0; i < errors.length; i++){
            const error = errors[i];
            switch(error){
                case (0, $91a4cf0fed9238a4$export$6b43b4121596bf23).Empty:
                    return t("errors.cvcEmpty");
            }
        }
        return "";
    };
const $5defc9b8dec84daf$var$getExpiryDateErrorText = (t)=>(errors)=>{
        for(let i = 0; i < errors.length; i++){
            const error = errors[i];
            switch(error){
                case (0, $91a4cf0fed9238a4$export$6b43b4121596bf23).Empty:
                    return t("errors.expiryDateEmpty");
            }
        }
        return "";
    };
const $5defc9b8dec84daf$export$14cd645e3e4b4681 = (t)=>(errors)=>{
        const cvcError = $5defc9b8dec84daf$var$getCvcErrorText(t)(errors.cvc);
        const expiryDateError = $5defc9b8dec84daf$var$getExpiryDateErrorText(t)(errors.expiryDate);
        return {
            // Prioritize input error over screen error
            cardDetailsError: cvcError === "" && expiryDateError === "" ? $5defc9b8dec84daf$var$getCardDetailsErrorText(t)(errors.cardDetails) : "",
            cvcError: cvcError,
            expiryDateError: expiryDateError
        };
    };
function $5defc9b8dec84daf$export$5d4f271475ebc706({ state: state, dispatch: dispatch }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-activation", {
        keyPrefix: "enterDetails"
    });
    const { cardDetailsError: cardDetailsError, cvcError: cvcError, expiryDateError: expiryDateError } = $5defc9b8dec84daf$export$14cd645e3e4b4681(t)(state.cardDetailsValidationErrors);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $272930093305839e$export$f2c5c7ab1f242baa), {
        cardDetailsError: cardDetailsError,
        cvc: state.cvcValue,
        cvcError: cvcError,
        expiryDate: state.expiryDateValue,
        expiryDateError: expiryDateError,
        loading: state.isLoading,
        onCvcChange: (value)=>dispatch((0, $91a4cf0fed9238a4$export$6e6290200ceb68b4)(value)),
        onExpiryDateChange: (value)=>dispatch((0, $91a4cf0fed9238a4$export$b758c0ba8238b576)(value)),
        onNextClick: ()=>dispatch((0, $91a4cf0fed9238a4$export$69864c1ae20800a8)())
    });
}






parcelRequire("acw62");
const $0a5ae922de365778$var$SvgConfirmation = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 88,
        height: 88,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: 88,
                height: 88,
                fill: "#006AFF",
                fillOpacity: 0.1,
                rx: 44
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#006AFF",
                fillRule: "evenodd",
                d: "M26 44c0-9.94 8.06-18 18-18s18 8.06 18 18-8.06 18-18 18-18-8.06-18-18m4 0c0 7.72 6.28 14 14 14s14-6.28 14-14-6.28-14-14-14-14 6.28-14 14m7.42-2.4L42 46.18l8.62-8.58 2.82 2.82-10 10c-.4.38-.9.58-1.42.58s-1.02-.18-1.42-.58l-6-6z",
                clipRule: "evenodd"
            })
        ]
    });
var $0a5ae922de365778$export$2e2bcd8739ae039 = $0a5ae922de365778$var$SvgConfirmation;


var $700ab6bfc2f3c54a$export$2ba01fb71ed41cb6;
var $700ab6bfc2f3c54a$export$34e0f9847d4c02dd;
var $700ab6bfc2f3c54a$export$6d59db4903f20f7d;
var $700ab6bfc2f3c54a$export$46e4a324ac90507f;
$700ab6bfc2f3c54a$export$2ba01fb71ed41cb6 = `LPNBGa_CardActivationConfirmation_button`;
$700ab6bfc2f3c54a$export$34e0f9847d4c02dd = `LPNBGa_CardActivationConfirmation_container`;
$700ab6bfc2f3c54a$export$6d59db4903f20f7d = `LPNBGa_CardActivationConfirmation_description`;
$700ab6bfc2f3c54a$export$46e4a324ac90507f = `LPNBGa_CardActivationConfirmation_heading`;



function $6b654f6b05c2e118$export$2ed00321646e1191({ onDoneClick: onDoneClick }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("card-activation", {
        keyPrefix: "confirmation"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $700ab6bfc2f3c54a$export$34e0f9847d4c02dd),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a5ae922de365778$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("heading-30", (0, $700ab6bfc2f3c54a$export$46e4a324ac90507f)),
                children: t("title")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("paragraph-30", (0, $700ab6bfc2f3c54a$export$6d59db4903f20f7d)),
                children: t("description")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                className: (0, $700ab6bfc2f3c54a$export$2ba01fb71ed41cb6),
                rank: "primary",
                onClick: onDoneClick,
                children: t("buttonText")
            })
        ]
    });
}





function $a8e20f7a92ec925f$export$6181f13aeb5b530f({ children: children, onClose: onClose }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$4fa994bc91bf3e1), {
        onMarketDialogDismissed: (0, $ca1292c5dc2fbd33$export$3a4e95f5f650d5aa)(onClose),
        children: children
    });
}







var $64ecc05438fc4dba$export$2ba01fb71ed41cb6;
var $64ecc05438fc4dba$export$6d59db4903f20f7d;
var $64ecc05438fc4dba$export$a3bc9b8ed74fc;
var $64ecc05438fc4dba$export$6210fa4921d2a466;
var $64ecc05438fc4dba$export$7b388ca536128c6d;
var $64ecc05438fc4dba$export$f22da7240b7add18;
var $64ecc05438fc4dba$export$9f616b728e5a5e80;
$64ecc05438fc4dba$export$2ba01fb71ed41cb6 = `_14oPQW_SetPin_button`;
$64ecc05438fc4dba$export$6d59db4903f20f7d = `_14oPQW_SetPin_description`;
$64ecc05438fc4dba$export$a3bc9b8ed74fc = `_14oPQW_SetPin_error`;
$64ecc05438fc4dba$export$6210fa4921d2a466 = `_14oPQW_SetPin_form`;
$64ecc05438fc4dba$export$7b388ca536128c6d = `_14oPQW_SetPin_inputs`;
$64ecc05438fc4dba$export$f22da7240b7add18 = `_14oPQW_SetPin_main`;
$64ecc05438fc4dba$export$9f616b728e5a5e80 = `_14oPQW_SetPin_market-button`;



parcelRequire("acw62");
const $3180af4f14c2cd8a$var$SvgAlertExclaimationCircle = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "#7B61FF",
            fillRule: "evenodd",
            d: "M12 21c4.96 0 9-4.04 9-9s-4.04-9-9-9-9 4.04-9 9 4.04 9 9 9m0-16c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0 12a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M11 7h2v6.5h-2z",
            clipRule: "evenodd"
        })
    });
var $3180af4f14c2cd8a$export$2e2bcd8739ae039 = $3180af4f14c2cd8a$var$SvgAlertExclaimationCircle;


var $ebc0db443cea3b36$export$eec9628ef2c503b1 = /*#__PURE__*/ function(SetPinType) {
    SetPinType["CREATE"] = "CREATE_PIN";
    SetPinType["RESET"] = "RESET_PIN";
    return SetPinType;
}({});
var $ebc0db443cea3b36$export$742f06b032aee827 = /*#__PURE__*/ function(SetPinError) {
    SetPinError["WeakPin"] = "ERROR_WEAK_PIN";
    SetPinError["InvalidPinMatch"] = "ERROR_INVALID_PIN_MATCH";
    SetPinError["GenericError"] = "ERROR_GENERIC";
    return SetPinError;
}({});
var $ebc0db443cea3b36$export$54d4c18dc78a26d4 = /*#__PURE__*/ function(ValueError) {
    ValueError["InvalidLength"] = "VALUE_ERROR_INVALID_LENGTH";
    return ValueError;
}({});
function $ebc0db443cea3b36$export$16fd8f17ceae9f7e({ confirmPin: confirmPin, confirmPinError: confirmPinError, loading: loading = false, pin: pin, pinError: pinError, setPinError: setPinError, showNav: showNav = false, type: type, onConfirmPinChange: onConfirmPinChange, onPinChange: onPinChange, onNavClick: onNavClick, onSubmit: onSubmit }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("pin");
    const getHeader = (type)=>{
        switch(type){
            case "CREATE_PIN":
                return t("title.create");
            case "RESET_PIN":
                return t("title.reset");
        }
    };
    const getButton = (type)=>{
        switch(type){
            case "CREATE_PIN":
                return t("submit.continue");
            case "RESET_PIN":
                return t("submit.save");
        }
    };
    const getConfirmPinError = (error)=>{
        switch(error){
            case "VALUE_ERROR_INVALID_LENGTH":
                return t("error.validInput");
            case undefined:
                return undefined;
            default:
                throw new Error("Unsupported error type");
        }
    };
    const getPinError = (error)=>{
        switch(error){
            case "VALUE_ERROR_INVALID_LENGTH":
                return t("error.validInput");
            case undefined:
                return undefined;
            default:
                throw new Error("Unsupported error type");
        }
    };
    const getSetPinError = (error)=>{
        switch(error){
            case "ERROR_GENERIC":
                return t("error.generic");
            case "ERROR_INVALID_PIN_MATCH":
                return t("error.notMatch");
            case "ERROR_WEAK_PIN":
                return t("error.weak");
            case undefined:
                return undefined;
            default:
                throw new Error("Unsupported error type");
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$95abf1952846aff4), {
                showNavigation: showNav,
                onMarketHeaderNavigate: onNavClick,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: getHeader(type)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: $64ecc05438fc4dba$export$f22da7240b7add18,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "paragraph-30",
                        children: t("description")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        "data-testid": "form-pin",
                        className: $64ecc05438fc4dba$export$6210fa4921d2a466,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                                error: getPinError(pinError),
                                label: t("inputLabel.pin"),
                                name: t("inputLabel.pin"),
                                type: "number",
                                value: pin,
                                onTextChange: onPinChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c713dbee3e06984a$export$be4b7f1b3e13aead), {
                                error: getConfirmPinError(confirmPinError),
                                label: t("inputLabel.confirmPin"),
                                name: t("inputLabel.confirmPin"),
                                type: "number",
                                value: confirmPin,
                                onTextChange: onConfirmPinChange
                            })
                        ]
                    }),
                    setPinError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: $64ecc05438fc4dba$export$a3bc9b8ed74fc,
                        "data-testid": "error-message",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3180af4f14c2cd8a$export$2e2bcd8739ae039), {}),
                            getSetPinError(setPinError)
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$862a33790ffda48f), {
                        className: $64ecc05438fc4dba$export$2ba01fb71ed41cb6,
                        rank: "primary",
                        isLoading: loading,
                        onClick: onSubmit,
                        children: getButton(type)
                    })
                ]
            })
        ]
    });
}





function $45b78035b1c1170e$export$1f17c7406440bd8e({ state: state, dispatch: dispatch, showNav: showNav, type: type, onNavClick: onNavClick }) {
    /**
   * These error seem very similar but the errors in workflow and the component
   * may diverge. We do not want to couple presentational and functionality
   */ const mapValueError = (error)=>{
        switch(error){
            case (0, $41708348d2f204d8$export$54d4c18dc78a26d4).InvalidLength:
                return (0, $ebc0db443cea3b36$export$54d4c18dc78a26d4).InvalidLength;
        }
    };
    const mapSetPinError = (error)=>{
        switch(error){
            case (0, $41708348d2f204d8$export$edf27be85e5f6da0).GenericError:
                return (0, $ebc0db443cea3b36$export$742f06b032aee827).GenericError;
            case (0, $41708348d2f204d8$export$edf27be85e5f6da0).InvalidPinMatch:
                return (0, $ebc0db443cea3b36$export$742f06b032aee827).InvalidPinMatch;
            case (0, $41708348d2f204d8$export$edf27be85e5f6da0).WeakPin:
                return (0, $ebc0db443cea3b36$export$742f06b032aee827).WeakPin;
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc0db443cea3b36$export$16fd8f17ceae9f7e), {
        type: type,
        confirmPin: state.confirmPin,
        confirmPinError: state.confirmPinError.length ? mapValueError(state.confirmPinError[0]) : undefined,
        loading: state.loading,
        pin: state.pin,
        pinError: state.pinError.length ? mapValueError(state.pinError[0]) : undefined,
        setPinError: state.error.length ? mapSetPinError(state.error[0]) : undefined,
        showNav: showNav,
        onConfirmPinChange: (confirmPin)=>dispatch((0, $41708348d2f204d8$export$7fccafb1bae4775a)(confirmPin)),
        onPinChange: (pin)=>dispatch((0, $41708348d2f204d8$export$6e1c9a50e77df720)(pin)),
        onNavClick: onNavClick,
        onSubmit: ()=>dispatch((0, $41708348d2f204d8$export$b128ee3182fea17d)())
    });
}


function $d4b4a79186728168$export$e4086be69ab38865({ state: state, dispatch: dispatch }) {
    const getChildren = (state)=>{
        switch(state.screen){
            case (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Details:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5defc9b8dec84daf$export$5d4f271475ebc706), {
                    state: state,
                    dispatch: dispatch
                });
            case (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Pin:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45b78035b1c1170e$export$1f17c7406440bd8e), {
                    state: state.setPinState,
                    dispatch: dispatch,
                    showNav: true,
                    type: (0, $ebc0db443cea3b36$export$eec9628ef2c503b1).CREATE,
                    onNavClick: ()=>dispatch((0, $91a4cf0fed9238a4$export$2085928ad4455e61)(false))
                });
            case (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Success:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b654f6b05c2e118$export$2ed00321646e1191), {
                    onDoneClick: ()=>dispatch((0, $91a4cf0fed9238a4$export$69864c1ae20800a8)())
                });
            case (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Error:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51ac4cb382475bb7$export$ea52035eac03daf0), {
                    onButtonClick: ()=>dispatch((0, $91a4cf0fed9238a4$export$2085928ad4455e61)(false))
                });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a8e20f7a92ec925f$export$6181f13aeb5b530f), {
        active: state.modalOpen,
        onClose: ()=>dispatch((0, $91a4cf0fed9238a4$export$2085928ad4455e61)(false)),
        children: getChildren(state)
    });
}





const $66549f7d84306a62$var$redirectAfterClose = (updates)=>updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([[_, state], action])=>action.type === (0, $91a4cf0fed9238a4$export$e4a712fff93fb00f).Done || action.type === (0, $91a4cf0fed9238a4$export$e4a712fff93fb00f).ToggleModal && state.modalOpen === false), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([[_, state], _action])=>{
        const done = state.screen === (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Success || state.done;
        // redirects to card settings if card is activated successfully
        // otherwise redirect back to parent route
        const to = done ? `/card/${state.cardToken}/settings` : "../.";
        const locationState = done ? {
            cardActivation: {
                // Handle case where user closes modal on success screen
                done: state.screen === (0, $91a4cf0fed9238a4$export$a98515d67472a41f).Success || state.done
            }
        } : undefined;
        return {
            to: to,
            options: {
                replace: true,
                state: locationState
            }
        };
    }));
const $66549f7d84306a62$var$navigation = (source)=>(0, $195e3b3043565ec4$export$ba255e9e49e00608)(...[
        $66549f7d84306a62$var$redirectAfterClose
    ].map((transition)=>source.pipe(transition))).pipe((0, $4707859e785b3da6$export$18aef43295bbe906)());
var $66549f7d84306a62$export$2e2bcd8739ae039 = $66549f7d84306a62$var$navigation;


function $6c405fcdac0fc35b$export$d5dbd6e4860c3b3c({ cardManagementService: cardManagementService, cardToken: cardToken }) {
    const launchDarklyClient = (0, $ea440760c63f6861$export$43f174d627cf7c49)((0, $3ffd6dbaf72645e1$export$33fb1db36da5c5ad), {
        token: "anonymousUser",
        type: (0, $1f14c967a58ea158$export$f435f793048e7a0f).ANONYMOUS_VISITOR
    });
    const loadingIndicator = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$28c2b904b2ab5c88), {});
    return launchDarklyClient.flagsLoaded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6c405fcdac0fc35b$export$cc77469cad146b51, {
        canUpdatePin: launchDarklyClient.getFlagValue((0, $3ffd6dbaf72645e1$export$33fb1db36da5c5ad).canUpdatePin)?.valueOf() ?? false,
        cardManagementService: cardManagementService,
        cardToken: cardToken
    }) : loadingIndicator;
}
function $6c405fcdac0fc35b$export$cc77469cad146b51({ canUpdatePin: canUpdatePin, cardManagementService: cardManagementService, cardToken: cardToken }) {
    const navigate = (0, $3e8179397014bb35$export$9770f232ac06a008)();
    const [state, dispatch, workflow] = (0, $52d6aae768cd1bf0$export$7bc289ae93a0a81d)({
        cardManagementService: cardManagementService,
        canUpdatePin: canUpdatePin,
        sentry: {
            captureException: $b8438.captureException
        },
        setPin: cardManagementService.setPin.bind(cardManagementService),
        uuid: $3fa3ae484854b431$export$2e2bcd8739ae039
    }, $91a4cf0fed9238a4$export$e6a0daad8304de(), $91a4cf0fed9238a4$export$2e2bcd8739ae039);
    (0, $acw62.useEffect)(()=>{
        const subscriptions = new (0, $8343668acd7c4a9b$export$f55210826850c514)();
        subscriptions.add(workflow.updates.pipe((0, $66549f7d84306a62$export$2e2bcd8739ae039)).subscribe((nav)=>navigate(nav.to, nav.options)));
        dispatch($91a4cf0fed9238a4$export$c81c36414a1e3192(cardToken));
        return ()=>{
            subscriptions.unsubscribe();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4b4a79186728168$export$e4086be69ab38865), {
        state: state,
        dispatch: dispatch
    });
}


const $d75344a988d25c32$var$InjectedWorkflowContainedCardActivationModal = (0, $7c5a3dd94b85a123$export$72f8d6ff1467b5f4)((0, $6c405fcdac0fc35b$export$d5dbd6e4860c3b3c), {
    cardManagementService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).CARD_MANAGEMENT_SERVICE
});
const $d75344a988d25c32$export$9e7f6294aedab850 = (0, $eb322dd52f4d040c$export$fcd084e6273b1578)($d75344a988d25c32$var$InjectedWorkflowContainedCardActivationModal, {
    cardToken: "cardToken"
});







var $acw62 = parcelRequire("acw62");



var $b8438 = parcelRequire("b8438");






function $70708f7aebe7b790$export$6e2f6812128e86b8({ cardManagementService: cardManagementService, cardToken: cardToken, type: type }) {
    // NOTE(cvu): hardcoding navigation back only for set/reset pin.
    const navigate = (0, $3e8179397014bb35$export$9770f232ac06a008)();
    const onNavClick = ()=>navigate("../.");
    const [state, dispatch, workflow] = (0, $52d6aae768cd1bf0$export$7bc289ae93a0a81d)({
        sentry: {
            captureException: $b8438.captureException
        },
        setPin: cardManagementService.setPin.bind(cardManagementService),
        uuid: $3fa3ae484854b431$export$2e2bcd8739ae039
    }, $41708348d2f204d8$export$e6a0daad8304de(), $41708348d2f204d8$export$2e2bcd8739ae039);
    (0, $acw62.useEffect)(()=>{
        const subscriptions = new (0, $8343668acd7c4a9b$export$f55210826850c514)();
        subscriptions.add(workflow.updates.pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([_, action])=>action.type === $41708348d2f204d8$export$e4a712fff93fb00f.Done)).subscribe(()=>onNavClick()));
        dispatch($41708348d2f204d8$export$c81c36414a1e3192(cardToken));
        return ()=>{
            subscriptions.unsubscribe();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$4fa994bc91bf3e1), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45b78035b1c1170e$export$1f17c7406440bd8e), {
            state: state,
            dispatch: dispatch,
            showNav: true,
            type: type,
            onNavClick: onNavClick
        })
    });
}


const $056f39cb2284108a$var$InjectedWorkflowContainedSetPinModal = (0, $7c5a3dd94b85a123$export$72f8d6ff1467b5f4)((0, $70708f7aebe7b790$export$6e2f6812128e86b8), {
    cardManagementService: (0, $701d006d22a68e04$export$9faacf97a1a86e9d).CARD_MANAGEMENT_SERVICE
});
const $056f39cb2284108a$export$e69d35ecf5312a84 = (0, $eb322dd52f4d040c$export$fcd084e6273b1578)($056f39cb2284108a$var$InjectedWorkflowContainedSetPinModal, {
    cardToken: "cardToken"
});



/**
 * PageRouter is used to handle which page and elements render at certain routes.
 */ const $b3c1eeb19c22229f$var$router = (0, $3e8179397014bb35$export$1f3f55432a00e06d)([
    {
        path: "",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $becdf5d7bd69726e$export$be92b6f5f03c0fe9), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88be25437d5209b9$export$13f025e534889db5), {}),
                children: [
                    {
                        path: "/activate-card/:cardToken",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d75344a988d25c32$export$9e7f6294aedab850), {})
                    }
                ]
            },
            {
                path: "/card/:cardToken/settings",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffa5c35d73b6afd6$export$fdf04d45b6511766), {}),
                children: [
                    {
                        path: "/card/:cardToken/settings/activate-card",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d75344a988d25c32$export$9e7f6294aedab850), {})
                    },
                    {
                        path: "/card/:cardToken/settings/reset-pin",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $056f39cb2284108a$export$e69d35ecf5312a84), {
                            type: (0, $ebc0db443cea3b36$export$eec9628ef2c503b1).RESET
                        })
                    }
                ]
            },
            {
                path: "/card/:cardToken/status",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b9b8f95d28dd1cc4$export$cc5a44eb2bffd45a), {})
            }
        ]
    }
]);
var $b3c1eeb19c22229f$export$2e2bcd8739ae039 = $b3c1eeb19c22229f$var$router;







function $cd93687958c8007e$export$86fbec116b87613f({ bootstrap: bootstrap, diContainer: diContainer }) {
    // TODO(cvu): figure out what the actual title should be
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)("site");
    const title = t("title");
    (0, $acw62.useEffect)(()=>{
        document.title = title;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e79fd8d87f78889$export$4dda1981a34a6aa4), {
        value: diContainer,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb48b27410e45132$export$e6e3537859e84918), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a9ee46bb299cc77$export$88f24fd8fcfab6ca), {
                initialUser: bootstrap.user,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4f881c141a2f86c$export$a2c75276dce92780), {
                    environment: (0, $078609d239e2b7c3$export$57570b1603cf6adb)(),
                    personToken: bootstrap.user.personToken,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5fc20031e6d40819$export$323e4fc2fa4753fb), {
                        router: (0, $b3c1eeb19c22229f$export$2e2bcd8739ae039)
                    })
                })
            })
        })
    });
}


function $3c39250b670ce798$export$f6a06b563a614935({ diContainer: diContainer }) {
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [authenticated, setAuthenticated] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        const webService = diContainer.WEB_SERVICE;
        webService.getBootstrap((0, $fce501362cc81cfc$export$fed1fc70f4110737).create()).then((response)=>{
            if (response.unauthenticated) window.location.replace(new URL(`/login?return_to=${window.location.href}`, (0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039)));
            else {
                const { authenticated: authenticated } = response;
                (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(authenticated, "Missing authenticated from bootstrap");
                const { authorized: authorized, unauthorized: unauthorized } = authenticated;
                if (authorized) setAuthenticated(response.authenticated);
                else {
                    (0, $5cdd7c46b89c41cf$export$2e2bcd8739ae039)(unauthorized, "Missing authorization values");
                    window.location.replace(new URL(`/launchpad`, (0, $6a4edd14a7aeb8ed$export$2e2bcd8739ae039)));
                }
            }
        }, (0, $b8438.captureException));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (authenticated != null) setLoading(false);
    }, [
        authenticated
    ]);
    // TODO(cvu): make better loading
    const loadingIndicator = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d1bfdd6e8737fe3$export$28c2b904b2ab5c88), {});
    return loading ? loadingIndicator : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Suspense), {
        fallback: loadingIndicator,
        children: authenticated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {
            bootstrap: (0, $214b3af3bfc0d570$export$8f5519c5909517b3)(authenticated),
            diContainer: diContainer
        }) : null
    });
}


(async function() {
    (0, $eIG6O.defineCustomElements)(window);
    document.body.className = (0, $27bb0e5b34358db8$export$32180ef41b15b513);
    (0, $d457a61013135fd1$export$1f7656c617418e15)((0, $078609d239e2b7c3$export$57570b1603cf6adb)());
    // TODO(cvu): decide if this simple dependency container is sufficient or should we use package like rsdi
    const diContainer = await (0, $701d006d22a68e04$export$e9bcd07a423f60d8)();
    const container = document.getElementById("app");
    if (container == null) throw new Error("application failed to mount due to missing HTMLElement with 'app' id");
    (0, $7e96a608cb33bf79$export$882461b6382ed46c)(container).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c39250b670ce798$export$f6a06b563a614935), {
        diContainer: diContainer
    }));
})();


//# sourceMappingURL=banking_web.e085a512.js.map
